/* eslint-disable */

var A =
  "undefined" != typeof globalThis
    ? globalThis
    : "undefined" != typeof window
      ? window
      : "undefined" != typeof global
        ? global
        : "undefined" != typeof self
          ? self
          : {};
function e(A) {
  return A && A.__esModule && Object.prototype.hasOwnProperty.call(A, "default") ? A.default : A;
}
var t,
  i,
  n,
  o = { exports: {} };
(i = A),
  (n = function () {
    var A = function () {},
      e = "undefined",
      t =
        typeof window !== e &&
        typeof window.navigator !== e &&
        /Trident\/|MSIE /.test(window.navigator.userAgent),
      i = ["trace", "debug", "info", "warn", "error"],
      n = {},
      o = null;
    function r(A, e) {
      var t = A[e];
      if ("function" == typeof t.bind) return t.bind(A);
      try {
        return Function.prototype.bind.call(t, A);
      } catch (e) {
        return function () {
          return Function.prototype.apply.apply(t, [A, arguments]);
        };
      }
    }
    function s() {
      console.log &&
        (console.log.apply
          ? console.log.apply(console, arguments)
          : Function.prototype.apply.apply(console.log, [console, arguments])),
        console.trace && console.trace();
    }
    function a() {
      for (var t = this.getLevel(), n = 0; n < i.length; n++) {
        var o = i[n];
        this[o] = n < t ? A : this.methodFactory(o, t, this.name);
      }
      if (((this.log = this.debug), typeof console === e && t < this.levels.SILENT))
        return "No console available for logging";
    }
    function g(A) {
      return function () {
        typeof console !== e && (a.call(this), this[A].apply(this, arguments));
      };
    }
    function c(i, n, o) {
      return (
        (function (i) {
          return (
            "debug" === i && (i = "log"),
            typeof console !== e &&
              ("trace" === i && t
                ? s
                : void 0 !== console[i]
                  ? r(console, i)
                  : void 0 !== console.log
                    ? r(console, "log")
                    : A)
          );
        })(i) || g.apply(this, arguments)
      );
    }
    function I(A, t) {
      var r,
        s,
        g,
        I = this,
        l = "loglevel";
      function d() {
        var A;
        if (typeof window !== e && l) {
          try {
            A = window.localStorage[l];
          } catch (A) {}
          if (typeof A === e)
            try {
              var t = window.document.cookie,
                i = encodeURIComponent(l),
                n = t.indexOf(i + "=");
              -1 !== n && (A = /^([^;]+)/.exec(t.slice(n + i.length + 1))[1]);
            } catch (A) {}
          return void 0 === I.levels[A] && (A = void 0), A;
        }
      }
      function u(A) {
        var e = A;
        if (
          ("string" == typeof e &&
            void 0 !== I.levels[e.toUpperCase()] &&
            (e = I.levels[e.toUpperCase()]),
          "number" == typeof e && e >= 0 && e <= I.levels.SILENT)
        )
          return e;
        throw new TypeError("log.setLevel() called with invalid level: " + A);
      }
      "string" == typeof A ? (l += ":" + A) : "symbol" == typeof A && (l = void 0),
        (I.name = A),
        (I.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }),
        (I.methodFactory = t || c),
        (I.getLevel = function () {
          return null != g ? g : null != s ? s : r;
        }),
        (I.setLevel = function (A, t) {
          return (
            (g = u(A)),
            !1 !== t &&
              (function (A) {
                var t = (i[A] || "silent").toUpperCase();
                if (typeof window !== e && l) {
                  try {
                    return void (window.localStorage[l] = t);
                  } catch (A) {}
                  try {
                    window.document.cookie = encodeURIComponent(l) + "=" + t + ";";
                  } catch (A) {}
                }
              })(g),
            a.call(I)
          );
        }),
        (I.setDefaultLevel = function (A) {
          (s = u(A)), d() || I.setLevel(A, !1);
        }),
        (I.resetLevel = function () {
          (g = null),
            (function () {
              if (typeof window !== e && l) {
                try {
                  window.localStorage.removeItem(l);
                } catch (A) {}
                try {
                  window.document.cookie =
                    encodeURIComponent(l) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                } catch (A) {}
              }
            })(),
            a.call(I);
        }),
        (I.enableAll = function (A) {
          I.setLevel(I.levels.TRACE, A);
        }),
        (I.disableAll = function (A) {
          I.setLevel(I.levels.SILENT, A);
        }),
        (I.rebuild = function () {
          if ((o !== I && (r = u(o.getLevel())), a.call(I), o === I))
            for (var A in n) n[A].rebuild();
        }),
        (r = u(o ? o.getLevel() : "WARN"));
      var C = d();
      null != C && (g = u(C)), a.call(I);
    }
    (o = new I()).getLogger = function (A) {
      if (("symbol" != typeof A && "string" != typeof A) || "" === A)
        throw new TypeError("You must supply a name when creating a logger.");
      var e = n[A];
      return e || (e = n[A] = new I(A, o.methodFactory)), e;
    };
    var l = typeof window !== e ? window.log : void 0;
    return (
      (o.noConflict = function () {
        return typeof window !== e && window.log === o && (window.log = l), o;
      }),
      (o.getLoggers = function () {
        return n;
      }),
      (o.default = o),
      o
    );
  }),
  (t = o).exports ? (t.exports = n()) : (i.log = n());
var r = o.exports;
const s = {
    TRACE: r.levels.TRACE,
    DEBUG: r.levels.DEBUG,
    INFO: r.levels.INFO,
    WARN: r.levels.WARN,
    ERROR: r.levels.ERROR,
    SILENT: r.levels.SILENT
  },
  a = s.INFO,
  g = "generic";
let c = {},
  I = a;
const l = {};
function d(A) {
  return ("string" == typeof A && s[A.toUpperCase()]) || a;
}
function u(A) {
  if (A instanceof Object) (c = A), (I = d(c.default || "info"));
  else
    try {
      (I = A), r.setLevel(A);
    } catch (e) {
      throw new Error(
        `setLogLevel called with invalid level ${A}. Falling back to log level INFO.`
      );
    }
}
function C(A) {
  return [s.TRACE, s.DEBUG].indexOf(I) >= 0 ? JSON.stringify(A) : "";
}
class B {
  constructor({ name: A, logLevelLogger: e }) {
    (this.logLevelLogger = e), (this.name = A), (this.dateObject = new Date());
  }
  trace(A) {
    const e = this.dateObject;
    e.setTime(Date.now()),
      this.logLevelLogger.trace(`${e.toISOString()} - [${this.name}] TRACE ${A}`);
  }
  debug(A) {
    const e = this.dateObject;
    e.setTime(Date.now()),
      this.logLevelLogger.debug(`${e.toISOString()} - [${this.name}] DEBUG ${A}`);
  }
  info(A) {
    const e = this.dateObject;
    e.setTime(Date.now()),
      this.logLevelLogger.info(`${e.toISOString()} - [${this.name}] INFO ${A}`);
  }
  warn(A) {
    const e = this.dateObject;
    e.setTime(Date.now()),
      this.logLevelLogger.warn(`${e.toISOString()} - [${this.name}] WARN ${A}`);
  }
  error(A) {
    const e = this.dateObject;
    e.setTime(Date.now()),
      this.logLevelLogger.error(`${e.toISOString()} - [${this.name}] ERROR ${A}`);
  }
  debugIf(A) {
    if (this.logLevelLogger.getLevel() <= r.levels.DEBUG) {
      const e = this.dateObject;
      e.setTime(Date.now()),
        this.logLevelLogger.debug(`${e.toISOString()} - [${this.name}] ${A()}`);
    }
  }
}
function Q(A, e) {
  const t = e ?? g;
  t in l || (l[t] = {});
  const i = l[t];
  if (A in i) return i[A];
  const n = `${A}${null == e ? "" : `:${e}`}`,
    o = r.getLogger(n),
    s = A in c ? d(c[A]) : I;
  o.setLevel(s);
  const a = new B({ name: n, logLevelLogger: o });
  return (i[A] = a), a;
}
var E = { exports: {} };
!(function (A) {
  !(function () {
    var e,
      t = {
        polyfill: function () {
          if (!("KeyboardEvent" in window) || "key" in KeyboardEvent.prototype) return !1;
          var A = {
            get: function (A) {
              var e = t.keys[this.which || this.keyCode];
              return Array.isArray(e) && (e = e[+this.shiftKey]), e;
            }
          };
          return Object.defineProperty(KeyboardEvent.prototype, "key", A), A;
        },
        keys: {
          3: "Cancel",
          6: "Help",
          8: "Backspace",
          9: "Tab",
          12: "Clear",
          13: "Enter",
          16: "Shift",
          17: "Control",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Escape",
          28: "Convert",
          29: "NonConvert",
          30: "Accept",
          31: "ModeChange",
          32: " ",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "ArrowLeft",
          38: "ArrowUp",
          39: "ArrowRight",
          40: "ArrowDown",
          41: "Select",
          42: "Print",
          43: "Execute",
          44: "PrintScreen",
          45: "Insert",
          46: "Delete",
          48: ["0", ")"],
          49: ["1", "!"],
          50: ["2", "@"],
          51: ["3", "#"],
          52: ["4", "$"],
          53: ["5", "%"],
          54: ["6", "^"],
          55: ["7", "&"],
          56: ["8", "*"],
          57: ["9", "("],
          91: "OS",
          93: "ContextMenu",
          144: "NumLock",
          145: "ScrollLock",
          181: "VolumeMute",
          182: "VolumeDown",
          183: "VolumeUp",
          186: [";", ":"],
          187: ["=", "+"],
          188: [",", "<"],
          189: ["-", "_"],
          190: [".", ">"],
          191: ["/", "?"],
          192: ["`", "~"],
          219: ["[", "{"],
          220: ["\\", "|"],
          221: ["]", "}"],
          222: ["'", '"'],
          224: "Meta",
          225: "AltGraph",
          246: "Attn",
          247: "CrSel",
          248: "ExSel",
          249: "EraseEof",
          250: "Play",
          251: "ZoomOut"
        }
      };
    for (e = 1; e < 25; e++) t.keys[111 + e] = "F" + e;
    var i = "";
    for (e = 65; e < 91; e++)
      (i = String.fromCharCode(e)), (t.keys[e] = [i.toLowerCase(), i.toUpperCase()]);
    A.exports = t;
  })();
})(E),
  (function () {
    function A(A) {
      A && (A.setTargetAtTime || (A.setTargetAtTime = A.setTargetValueAtTime));
    }
    window.hasOwnProperty("webkitAudioContext") &&
      !window.hasOwnProperty("AudioContext") &&
      ((window.AudioContext = webkitAudioContext),
      AudioContext.prototype.hasOwnProperty("createGain") ||
        (AudioContext.prototype.createGain = AudioContext.prototype.createGainNode),
      AudioContext.prototype.hasOwnProperty("createDelay") ||
        (AudioContext.prototype.createDelay = AudioContext.prototype.createDelayNode),
      AudioContext.prototype.hasOwnProperty("createScriptProcessor") ||
        (AudioContext.prototype.createScriptProcessor =
          AudioContext.prototype.createJavaScriptNode),
      AudioContext.prototype.hasOwnProperty("createPeriodicWave") ||
        (AudioContext.prototype.createPeriodicWave = AudioContext.prototype.createWaveTable),
      (AudioContext.prototype.internal_createGain = AudioContext.prototype.createGain),
      (AudioContext.prototype.createGain = function () {
        var e = this.internal_createGain();
        return A(e.gain), e;
      }),
      (AudioContext.prototype.internal_createDelay = AudioContext.prototype.createDelay),
      (AudioContext.prototype.createDelay = function (e) {
        var t = e ? this.internal_createDelay(e) : this.internal_createDelay();
        return A(t.delayTime), t;
      }),
      (AudioContext.prototype.internal_createBufferSource =
        AudioContext.prototype.createBufferSource),
      (AudioContext.prototype.createBufferSource = function () {
        var e = this.internal_createBufferSource();
        return (
          e.start
            ? ((e.internal_start = e.start),
              (e.start = function (A, t, i) {
                void 0 !== i ? e.internal_start(A || 0, t, i) : e.internal_start(A || 0, t || 0);
              }))
            : (e.start = function (A, e, t) {
                e || t ? this.noteGrainOn(A || 0, e, t) : this.noteOn(A || 0);
              }),
          e.stop
            ? ((e.internal_stop = e.stop),
              (e.stop = function (A) {
                e.internal_stop(A || 0);
              }))
            : (e.stop = function (A) {
                this.noteOff(A || 0);
              }),
          A(e.playbackRate),
          e
        );
      }),
      (AudioContext.prototype.internal_createDynamicsCompressor =
        AudioContext.prototype.createDynamicsCompressor),
      (AudioContext.prototype.createDynamicsCompressor = function () {
        var e = this.internal_createDynamicsCompressor();
        return A(e.threshold), A(e.knee), A(e.ratio), A(e.reduction), A(e.attack), A(e.release), e;
      }),
      (AudioContext.prototype.internal_createBiquadFilter =
        AudioContext.prototype.createBiquadFilter),
      (AudioContext.prototype.createBiquadFilter = function () {
        var e = this.internal_createBiquadFilter();
        return A(e.frequency), A(e.detune), A(e.Q), A(e.gain), e;
      }),
      AudioContext.prototype.hasOwnProperty("createOscillator") &&
        ((AudioContext.prototype.internal_createOscillator =
          AudioContext.prototype.createOscillator),
        (AudioContext.prototype.createOscillator = function () {
          var e = this.internal_createOscillator();
          return (
            e.start
              ? ((e.internal_start = e.start),
                (e.start = function (A) {
                  e.internal_start(A || 0);
                }))
              : (e.start = function (A) {
                  this.noteOn(A || 0);
                }),
            e.stop
              ? ((e.internal_stop = e.stop),
                (e.stop = function (A) {
                  e.internal_stop(A || 0);
                }))
              : (e.stop = function (A) {
                  this.noteOff(A || 0);
                }),
            e.setPeriodicWave || (e.setPeriodicWave = e.setWaveTable),
            A(e.frequency),
            A(e.detune),
            e
          );
        }))),
      window.hasOwnProperty("webkitOfflineAudioContext") &&
        !window.hasOwnProperty("OfflineAudioContext") &&
        (window.OfflineAudioContext = webkitOfflineAudioContext);
  })();
const h = {
  major: "1",
  minor: "9",
  patch: "100",
  revision: "952",
  extended: "4ab1897487118844fc235eec12d4a5eb96deb56b",
  version: "1.9.100+build.952",
  package: "1.9.100-952",
  copyright: "© 2019-2025, Nice Srl. All rights reserved"
};
var p = function (A) {
    return A && A.Math == Math && A;
  },
  f =
    p("object" == typeof globalThis && globalThis) ||
    p("object" == typeof window && window) ||
    p("object" == typeof self && self) ||
    p("object" == typeof A && A) ||
    (function () {
      return this;
    })() ||
    Function("return this")(),
  m = {},
  y = function (A) {
    try {
      return !!A();
    } catch (A) {
      return !0;
    }
  },
  D = !y(function () {
    return (
      7 !=
      Object.defineProperty({}, 1, {
        get: function () {
          return 7;
        }
      })[1]
    );
  }),
  w = !y(function () {
    var A = function () {}.bind();
    return "function" != typeof A || A.hasOwnProperty("prototype");
  }),
  F = w,
  b = Function.prototype.call,
  U = F
    ? b.bind(b)
    : function () {
        return b.apply(b, arguments);
      },
  S = {},
  R = {}.propertyIsEnumerable,
  v = Object.getOwnPropertyDescriptor,
  x = v && !R.call({ 1: 2 }, 1);
S.f = x
  ? function (A) {
      var e = v(this, A);
      return !!e && e.enumerable;
    }
  : R;
var M,
  O,
  k = function (A, e) {
    return { enumerable: !(1 & A), configurable: !(2 & A), writable: !(4 & A), value: e };
  },
  N = w,
  K = Function.prototype,
  L = K.bind,
  T = K.call,
  P = N && L.bind(T, T),
  G = N
    ? function (A) {
        return A && P(A);
      }
    : function (A) {
        return (
          A &&
          function () {
            return T.apply(A, arguments);
          }
        );
      },
  H = G,
  Y = H({}.toString),
  q = H("".slice),
  J = function (A) {
    return q(Y(A), 8, -1);
  },
  j = G,
  W = y,
  V = J,
  _ = f.Object,
  X = j("".split),
  z = W(function () {
    return !_("z").propertyIsEnumerable(0);
  })
    ? function (A) {
        return "String" == V(A) ? X(A, "") : _(A);
      }
    : _,
  Z = f.TypeError,
  $ = function (A) {
    if (null == A) throw Z("Can't call method on " + A);
    return A;
  },
  AA = z,
  eA = $,
  tA = function (A) {
    return AA(eA(A));
  },
  iA = function (A) {
    return "function" == typeof A;
  },
  nA = iA,
  oA = function (A) {
    return "object" == typeof A ? null !== A : nA(A);
  },
  rA = f,
  sA = iA,
  aA = function (A, e) {
    return arguments.length < 2 ? ((t = rA[A]), sA(t) ? t : void 0) : rA[A] && rA[A][e];
    var t;
  },
  gA = G({}.isPrototypeOf),
  cA = f,
  IA = aA("navigator", "userAgent") || "",
  lA = cA.process,
  dA = cA.Deno,
  uA = (lA && lA.versions) || (dA && dA.version),
  CA = uA && uA.v8;
CA && (O = (M = CA.split("."))[0] > 0 && M[0] < 4 ? 1 : +(M[0] + M[1])),
  !O &&
    IA &&
    (!(M = IA.match(/Edge\/(\d+)/)) || M[1] >= 74) &&
    (M = IA.match(/Chrome\/(\d+)/)) &&
    (O = +M[1]);
var BA = O,
  QA = y,
  EA =
    !!Object.getOwnPropertySymbols &&
    !QA(function () {
      var A = Symbol();
      return !String(A) || !(Object(A) instanceof Symbol) || (!Symbol.sham && BA && BA < 41);
    }),
  hA = EA && !Symbol.sham && "symbol" == typeof Symbol.iterator,
  pA = aA,
  fA = iA,
  mA = gA,
  yA = hA,
  DA = f.Object,
  wA = yA
    ? function (A) {
        return "symbol" == typeof A;
      }
    : function (A) {
        var e = pA("Symbol");
        return fA(e) && mA(e.prototype, DA(A));
      },
  FA = f.String,
  bA = iA,
  UA = function (A) {
    try {
      return FA(A);
    } catch (A) {
      return "Object";
    }
  },
  SA = f.TypeError,
  RA = function (A) {
    if (bA(A)) return A;
    throw SA(UA(A) + " is not a function");
  },
  vA = U,
  xA = iA,
  MA = oA,
  OA = f.TypeError,
  kA = { exports: {} },
  NA = f,
  KA = Object.defineProperty,
  LA = function (A, e) {
    try {
      KA(NA, A, { value: e, configurable: !0, writable: !0 });
    } catch (t) {
      NA[A] = e;
    }
    return e;
  },
  TA = LA,
  PA = "__core-js_shared__",
  GA = f[PA] || TA(PA, {}),
  HA = GA;
(kA.exports = function (A, e) {
  return HA[A] || (HA[A] = void 0 !== e ? e : {});
})("versions", []).push({
  version: "3.20.3",
  mode: "global",
  copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.20.3/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var YA = $,
  qA = f.Object,
  JA = function (A) {
    return qA(YA(A));
  },
  jA = G({}.hasOwnProperty),
  WA =
    Object.hasOwn ||
    function (A, e) {
      return jA(JA(A), e);
    },
  VA = G,
  _A = 0,
  XA = Math.random(),
  zA = VA((1).toString),
  ZA = function (A) {
    return "Symbol(" + (void 0 === A ? "" : A) + ")_" + zA(++_A + XA, 36);
  },
  $A = f,
  Ae = kA.exports,
  ee = WA,
  te = ZA,
  ie = EA,
  ne = hA,
  oe = Ae("wks"),
  re = $A.Symbol,
  se = re && re.for,
  ae = ne ? re : (re && re.withoutSetter) || te,
  ge = function (A) {
    if (!ee(oe, A) || (!ie && "string" != typeof oe[A])) {
      var e = "Symbol." + A;
      ie && ee(re, A) ? (oe[A] = re[A]) : (oe[A] = ne && se ? se(e) : ae(e));
    }
    return oe[A];
  },
  ce = U,
  Ie = oA,
  le = wA,
  de = function (A, e) {
    var t = A[e];
    return null == t ? void 0 : RA(t);
  },
  ue = function (A, e) {
    var t, i;
    if ("string" === e && xA((t = A.toString)) && !MA((i = vA(t, A)))) return i;
    if (xA((t = A.valueOf)) && !MA((i = vA(t, A)))) return i;
    if ("string" !== e && xA((t = A.toString)) && !MA((i = vA(t, A)))) return i;
    throw OA("Can't convert object to primitive value");
  },
  Ce = ge,
  Be = f.TypeError,
  Qe = Ce("toPrimitive"),
  Ee = function (A, e) {
    if (!Ie(A) || le(A)) return A;
    var t,
      i = de(A, Qe);
    if (i) {
      if ((void 0 === e && (e = "default"), (t = ce(i, A, e)), !Ie(t) || le(t))) return t;
      throw Be("Can't convert object to primitive value");
    }
    return void 0 === e && (e = "number"), ue(A, e);
  },
  he = wA,
  pe = function (A) {
    var e = Ee(A, "string");
    return he(e) ? e : e + "";
  },
  fe = oA,
  me = f.document,
  ye = fe(me) && fe(me.createElement),
  De = function (A) {
    return ye ? me.createElement(A) : {};
  },
  we =
    !D &&
    !y(function () {
      return (
        7 !=
        Object.defineProperty(De("div"), "a", {
          get: function () {
            return 7;
          }
        }).a
      );
    }),
  Fe = D,
  be = U,
  Ue = S,
  Se = k,
  Re = tA,
  ve = pe,
  xe = WA,
  Me = we,
  Oe = Object.getOwnPropertyDescriptor;
m.f = Fe
  ? Oe
  : function (A, e) {
      if (((A = Re(A)), (e = ve(e)), Me))
        try {
          return Oe(A, e);
        } catch (A) {}
      if (xe(A, e)) return Se(!be(Ue.f, A, e), A[e]);
    };
var ke = {},
  Ne =
    D &&
    y(function () {
      return (
        42 !=
        Object.defineProperty(function () {}, "prototype", { value: 42, writable: !1 }).prototype
      );
    }),
  Ke = f,
  Le = oA,
  Te = Ke.String,
  Pe = Ke.TypeError,
  Ge = function (A) {
    if (Le(A)) return A;
    throw Pe(Te(A) + " is not an object");
  },
  He = D,
  Ye = we,
  qe = Ne,
  Je = Ge,
  je = pe,
  We = f.TypeError,
  Ve = Object.defineProperty,
  _e = Object.getOwnPropertyDescriptor,
  Xe = "enumerable",
  ze = "configurable",
  Ze = "writable";
ke.f = He
  ? qe
    ? function (A, e, t) {
        if (
          (Je(A),
          (e = je(e)),
          Je(t),
          "function" == typeof A && "prototype" === e && "value" in t && Ze in t && !t[Ze])
        ) {
          var i = _e(A, e);
          i &&
            i[Ze] &&
            ((A[e] = t.value),
            (t = {
              configurable: ze in t ? t[ze] : i[ze],
              enumerable: Xe in t ? t[Xe] : i[Xe],
              writable: !1
            }));
        }
        return Ve(A, e, t);
      }
    : Ve
  : function (A, e, t) {
      if ((Je(A), (e = je(e)), Je(t), Ye))
        try {
          return Ve(A, e, t);
        } catch (A) {}
      if ("get" in t || "set" in t) throw We("Accessors not supported");
      return "value" in t && (A[e] = t.value), A;
    };
var $e = ke,
  At = k,
  et = D
    ? function (A, e, t) {
        return $e.f(A, e, At(1, t));
      }
    : function (A, e, t) {
        return (A[e] = t), A;
      },
  tt = { exports: {} },
  it = iA,
  nt = GA,
  ot = G(Function.toString);
it(nt.inspectSource) ||
  (nt.inspectSource = function (A) {
    return ot(A);
  });
var rt,
  st,
  at,
  gt = nt.inspectSource,
  ct = iA,
  It = gt,
  lt = f.WeakMap,
  dt = ct(lt) && /native code/.test(It(lt)),
  ut = kA.exports,
  Ct = ZA,
  Bt = ut("keys"),
  Qt = {},
  Et = dt,
  ht = f,
  pt = G,
  ft = oA,
  mt = et,
  yt = WA,
  Dt = GA,
  wt = function (A) {
    return Bt[A] || (Bt[A] = Ct(A));
  },
  Ft = Qt,
  bt = "Object already initialized",
  Ut = ht.TypeError,
  St = ht.WeakMap;
if (Et || Dt.state) {
  var Rt = Dt.state || (Dt.state = new St()),
    vt = pt(Rt.get),
    xt = pt(Rt.has),
    Mt = pt(Rt.set);
  (rt = function (A, e) {
    if (xt(Rt, A)) throw new Ut(bt);
    return (e.facade = A), Mt(Rt, A, e), e;
  }),
    (st = function (A) {
      return vt(Rt, A) || {};
    }),
    (at = function (A) {
      return xt(Rt, A);
    });
} else {
  var Ot = wt("state");
  (Ft[Ot] = !0),
    (rt = function (A, e) {
      if (yt(A, Ot)) throw new Ut(bt);
      return (e.facade = A), mt(A, Ot, e), e;
    }),
    (st = function (A) {
      return yt(A, Ot) ? A[Ot] : {};
    }),
    (at = function (A) {
      return yt(A, Ot);
    });
}
var kt = {
    set: rt,
    get: st,
    has: at,
    enforce: function (A) {
      return at(A) ? st(A) : rt(A, {});
    },
    getterFor: function (A) {
      return function (e) {
        var t;
        if (!ft(e) || (t = st(e)).type !== A) throw Ut("Incompatible receiver, " + A + " required");
        return t;
      };
    }
  },
  Nt = D,
  Kt = WA,
  Lt = Function.prototype,
  Tt = Nt && Object.getOwnPropertyDescriptor,
  Pt = Kt(Lt, "name"),
  Gt = Pt && "something" === function () {}.name,
  Ht = Pt && (!Nt || (Nt && Tt(Lt, "name").configurable)),
  Yt = f,
  qt = iA,
  Jt = WA,
  jt = et,
  Wt = LA,
  Vt = gt,
  _t = { EXISTS: Pt, PROPER: Gt, CONFIGURABLE: Ht }.CONFIGURABLE,
  Xt = kt.get,
  zt = kt.enforce,
  Zt = String(String).split("String");
(tt.exports = function (A, e, t, i) {
  var n,
    o = !!i && !!i.unsafe,
    r = !!i && !!i.enumerable,
    s = !!i && !!i.noTargetGet,
    a = i && void 0 !== i.name ? i.name : e;
  qt(t) &&
    ("Symbol(" === String(a).slice(0, 7) &&
      (a = "[" + String(a).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"),
    (!Jt(t, "name") || (_t && t.name !== a)) && jt(t, "name", a),
    (n = zt(t)).source || (n.source = Zt.join("string" == typeof a ? a : ""))),
    A !== Yt
      ? (o ? !s && A[e] && (r = !0) : delete A[e], r ? (A[e] = t) : jt(A, e, t))
      : r
        ? (A[e] = t)
        : Wt(e, t);
})(Function.prototype, "toString", function () {
  return (qt(this) && Xt(this).source) || Vt(this);
});
var $t = {},
  Ai = Math.ceil,
  ei = Math.floor,
  ti = function (A) {
    var e = +A;
    return e != e || 0 === e ? 0 : (e > 0 ? ei : Ai)(e);
  },
  ii = ti,
  ni = Math.max,
  oi = Math.min,
  ri = ti,
  si = Math.min,
  ai = function (A) {
    return A > 0 ? si(ri(A), 9007199254740991) : 0;
  },
  gi = tA,
  ci = function (A, e) {
    var t = ii(A);
    return t < 0 ? ni(t + e, 0) : oi(t, e);
  },
  Ii = function (A) {
    return ai(A.length);
  },
  li = function (A) {
    return function (e, t, i) {
      var n,
        o = gi(e),
        r = Ii(o),
        s = ci(i, r);
      if (A && t != t) {
        for (; r > s; ) if ((n = o[s++]) != n) return !0;
      } else for (; r > s; s++) if ((A || s in o) && o[s] === t) return A || s || 0;
      return !A && -1;
    };
  },
  di = { includes: li(!0), indexOf: li(!1) },
  ui = WA,
  Ci = tA,
  Bi = di.indexOf,
  Qi = Qt,
  Ei = G([].push),
  hi = function (A, e) {
    var t,
      i = Ci(A),
      n = 0,
      o = [];
    for (t in i) !ui(Qi, t) && ui(i, t) && Ei(o, t);
    for (; e.length > n; ) ui(i, (t = e[n++])) && (~Bi(o, t) || Ei(o, t));
    return o;
  },
  pi = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ].concat("length", "prototype");
$t.f =
  Object.getOwnPropertyNames ||
  function (A) {
    return hi(A, pi);
  };
var fi = {};
fi.f = Object.getOwnPropertySymbols;
var mi = aA,
  yi = $t,
  Di = fi,
  wi = Ge,
  Fi = G([].concat),
  bi =
    mi("Reflect", "ownKeys") ||
    function (A) {
      var e = yi.f(wi(A)),
        t = Di.f;
      return t ? Fi(e, t(A)) : e;
    },
  Ui = WA,
  Si = bi,
  Ri = m,
  vi = ke,
  xi = y,
  Mi = iA,
  Oi = /#|\.prototype\./,
  ki = function (A, e) {
    var t = Ki[Ni(A)];
    return t == Ti || (t != Li && (Mi(e) ? xi(e) : !!e));
  },
  Ni = (ki.normalize = function (A) {
    return String(A).replace(Oi, ".").toLowerCase();
  }),
  Ki = (ki.data = {}),
  Li = (ki.NATIVE = "N"),
  Ti = (ki.POLYFILL = "P"),
  Pi = ki,
  Gi = f,
  Hi = m.f,
  Yi = et,
  qi = tt.exports,
  Ji = LA,
  ji = function (A, e, t) {
    for (var i = Si(e), n = vi.f, o = Ri.f, r = 0; r < i.length; r++) {
      var s = i[r];
      Ui(A, s) || (t && Ui(t, s)) || n(A, s, o(e, s));
    }
  },
  Wi = Pi,
  Vi = gA,
  _i = f.TypeError,
  Xi = f,
  zi = iA,
  Zi = Xi.String,
  $i = Xi.TypeError,
  An = G,
  en = Ge,
  tn = function (A) {
    if ("object" == typeof A || zi(A)) return A;
    throw $i("Can't set " + Zi(A) + " as a prototype");
  },
  nn =
    Object.setPrototypeOf ||
    ("__proto__" in {}
      ? (function () {
          var A,
            e = !1,
            t = {};
          try {
            (A = An(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(t, []),
              (e = t instanceof Array);
          } catch (A) {}
          return function (t, i) {
            return en(t), tn(i), e ? A(t, i) : (t.__proto__ = i), t;
          };
        })()
      : void 0),
  on = iA,
  rn = oA,
  sn = nn,
  an = {};
an[ge("toStringTag")] = "z";
var gn = f,
  cn = "[object z]" === String(an),
  In = iA,
  ln = J,
  dn = ge("toStringTag"),
  un = gn.Object,
  Cn =
    "Arguments" ==
    ln(
      (function () {
        return arguments;
      })()
    ),
  Bn = cn
    ? ln
    : function (A) {
        var e, t, i;
        return void 0 === A
          ? "Undefined"
          : null === A
            ? "Null"
            : "string" ==
                typeof (t = (function (A, e) {
                  try {
                    return A[e];
                  } catch (A) {}
                })((e = un(A)), dn))
              ? t
              : Cn
                ? ln(e)
                : "Object" == (i = ln(e)) && In(e.callee)
                  ? "Arguments"
                  : i;
      },
  Qn = Bn,
  En = f.String,
  hn = function (A) {
    if ("Symbol" === Qn(A)) throw TypeError("Cannot convert a Symbol value to a string");
    return En(A);
  },
  pn = G("".replace),
  fn = String(Error("zxcasd").stack),
  mn = /\n\s*at [^:]*:[^\n]*/,
  yn = mn.test(fn),
  Dn = function (A, e) {
    var t,
      i,
      n,
      o,
      r,
      s = A.target,
      a = A.global,
      g = A.stat;
    if ((t = a ? Gi : g ? Gi[s] || Ji(s, {}) : (Gi[s] || {}).prototype))
      for (i in e) {
        if (
          ((o = e[i]),
          (n = A.noTargetGet ? (r = Hi(t, i)) && r.value : t[i]),
          !Wi(a ? i : s + (g ? "." : "#") + i, A.forced) && void 0 !== n)
        ) {
          if (typeof o == typeof n) continue;
          ji(o, n);
        }
        (A.sham || (n && n.sham)) && Yi(o, "sham", !0), qi(t, i, o, A);
      }
  },
  wn = aA,
  Fn = k,
  bn = ke.f,
  Un = WA,
  Sn = function (A, e) {
    if (Vi(e, A)) return A;
    throw _i("Incorrect invocation");
  },
  Rn = function (A, e, t) {
    var i, n;
    return (
      sn &&
        on((i = e.constructor)) &&
        i !== t &&
        rn((n = i.prototype)) &&
        n !== t.prototype &&
        sn(A, n),
      A
    );
  },
  vn = function (A, e) {
    return void 0 === A ? (arguments.length < 2 ? "" : e) : hn(A);
  },
  xn = {
    IndexSizeError: { s: "INDEX_SIZE_ERR", c: 1, m: 1 },
    DOMStringSizeError: { s: "DOMSTRING_SIZE_ERR", c: 2, m: 0 },
    HierarchyRequestError: { s: "HIERARCHY_REQUEST_ERR", c: 3, m: 1 },
    WrongDocumentError: { s: "WRONG_DOCUMENT_ERR", c: 4, m: 1 },
    InvalidCharacterError: { s: "INVALID_CHARACTER_ERR", c: 5, m: 1 },
    NoDataAllowedError: { s: "NO_DATA_ALLOWED_ERR", c: 6, m: 0 },
    NoModificationAllowedError: { s: "NO_MODIFICATION_ALLOWED_ERR", c: 7, m: 1 },
    NotFoundError: { s: "NOT_FOUND_ERR", c: 8, m: 1 },
    NotSupportedError: { s: "NOT_SUPPORTED_ERR", c: 9, m: 1 },
    InUseAttributeError: { s: "INUSE_ATTRIBUTE_ERR", c: 10, m: 1 },
    InvalidStateError: { s: "INVALID_STATE_ERR", c: 11, m: 1 },
    SyntaxError: { s: "SYNTAX_ERR", c: 12, m: 1 },
    InvalidModificationError: { s: "INVALID_MODIFICATION_ERR", c: 13, m: 1 },
    NamespaceError: { s: "NAMESPACE_ERR", c: 14, m: 1 },
    InvalidAccessError: { s: "INVALID_ACCESS_ERR", c: 15, m: 1 },
    ValidationError: { s: "VALIDATION_ERR", c: 16, m: 0 },
    TypeMismatchError: { s: "TYPE_MISMATCH_ERR", c: 17, m: 1 },
    SecurityError: { s: "SECURITY_ERR", c: 18, m: 1 },
    NetworkError: { s: "NETWORK_ERR", c: 19, m: 1 },
    AbortError: { s: "ABORT_ERR", c: 20, m: 1 },
    URLMismatchError: { s: "URL_MISMATCH_ERR", c: 21, m: 1 },
    QuotaExceededError: { s: "QUOTA_EXCEEDED_ERR", c: 22, m: 1 },
    TimeoutError: { s: "TIMEOUT_ERR", c: 23, m: 1 },
    InvalidNodeTypeError: { s: "INVALID_NODE_TYPE_ERR", c: 24, m: 1 },
    DataCloneError: { s: "DATA_CLONE_ERR", c: 25, m: 1 }
  },
  Mn = function (A, e) {
    if (yn && "string" == typeof A) for (; e--; ) A = pn(A, mn, "");
    return A;
  },
  On = "DOMException",
  kn = wn("Error"),
  Nn = wn(On),
  Kn = function () {
    Sn(this, Ln);
    var A = arguments.length,
      e = vn(A < 1 ? void 0 : arguments[0]),
      t = vn(A < 2 ? void 0 : arguments[1], "Error"),
      i = new Nn(e, t),
      n = kn(e);
    return (n.name = On), bn(i, "stack", Fn(1, Mn(n.stack, 1))), Rn(i, this, Kn), i;
  },
  Ln = (Kn.prototype = Nn.prototype),
  Tn = "stack" in kn(On),
  Pn = "stack" in new Nn(1, 2),
  Gn = Tn && !Pn;
Dn({ global: !0, forced: Gn }, { DOMException: Gn ? Kn : Nn });
var Hn = wn(On),
  Yn = Hn.prototype;
if (Yn.constructor !== Hn)
  for (var qn in (bn(Yn, "constructor", Fn(1, Hn)), xn))
    if (Un(xn, qn)) {
      var Jn = xn[qn],
        jn = Jn.s;
      Un(Hn, jn) || bn(Hn, jn, Fn(6, Jn.c));
    }
let Wn = Q("utils");
function Vn(A) {
  let e,
    t = [];
  for (e = 0; e < A.length; e += 32768)
    t.push(String.fromCharCode.apply(null, A.subarray(e, e + 32768)));
  return t.join("");
}
function _n(A) {
  return Array.from(A, (A) => `0${A.toString(16)}`.slice(-2)).join("");
}
function Xn(A) {
  return "function" == typeof A;
}
function zn(A) {
  return !Ao(A) && "object" == typeof A && !Array.isArray(A);
}
function Zn(A) {
  return !Ao(A) && "number" == typeof A;
}
function $n(A) {
  let e,
    t,
    i = [],
    n = 0;
  for (t = 0; t < A.length; t++)
    (e = A.charCodeAt(t)),
      e < 128
        ? (i[n++] = e)
        : e < 2048
          ? ((i[n++] = (e >> 6) | 192), (i[n++] = (63 & e) | 128))
          : 55296 == (64512 & e) && t + 1 < A.length && 56320 == (64512 & A.charCodeAt(t + 1))
            ? ((e = 65536 + ((1023 & e) << 10) + (1023 & A.charCodeAt(++t))),
              (i[n++] = (e >> 18) | 240),
              (i[n++] = ((e >> 12) & 63) | 128),
              (i[n++] = ((e >> 6) & 63) | 128),
              (i[n++] = (63 & e) | 128))
            : ((i[n++] = (e >> 12) | 224),
              (i[n++] = ((e >> 6) & 63) | 128),
              (i[n++] = (63 & e) | 128));
  return new Uint8Array(i);
}
function Ao(A) {
  return null == A;
}
function eo() {}
function to(A, e) {
  return A.major > e.major || (A.major === e.major && A.minor >= e.minor);
}
function io(A) {
  const e = Array.prototype.slice.call(arguments, 1);
  return A.replace(/{(\d+)}/g, (A, t) => (void 0 !== e[t] ? e[t] : A));
}
function no(A, e) {
  return A.split("?", 1)[0].split("#", 1)[0].replace(/^http/, "ws").replace(/\/+$/, "") + e;
}
function oo(A, e, t) {
  return Number.isFinite(A) && A >= e && A <= t;
}
function ro(A) {
  let e;
  return (
    A instanceof Blob
      ? (e = A.size)
      : A instanceof ArrayBuffer
        ? (e = A.byteLength)
        : (function (A) {
            return "string" == typeof A || A instanceof String;
          })(A) && (e = $n(A).byteLength),
    e
  );
}
function so(A) {
  const e = A.ownerDocument;
  if (!e) return Wn.warn(`Element ${A.id} is not owned by any document`), 1;
  return (e.defaultView || e.parentWindow).devicePixelRatio;
}
function ao(A, e) {
  const t = A,
    i = { once: !0 };
  let n,
    o = !0;
  function r() {
    o ? (o = !1) : e(t.devicePixelRatio),
      (n = t.matchMedia(`(resolution: ${t.devicePixelRatio}dppx)`)),
      n.addEventListener("change", r, i);
  }
  return (
    r(),
    function () {
      n.removeEventListener("change", r, i);
    }
  );
}
const go =
  Object.hasOwn ||
  function (A, e) {
    return Object.prototype.hasOwnProperty.call(A, e);
  };
const co = (A, e, t) =>
    new Promise((i, n) =>
      A()
        .then(i)
        .catch((o) => {
          return t > 0
            ? ((r = e), new Promise((A) => setTimeout(A, r)))
                .then(co.bind(null, A, e, t - 1))
                .then(i)
                .catch(n)
            : n(o);
          var r;
        })
    ),
  Io = {
    Connection: {
      ALREADY_OPEN: 1,
      INVALID_CONFIG: 2,
      INITIALIZATION_FAILED: 3,
      REJECTED: 4,
      MAIN_CHANNEL_ALREADY_OPEN: 5,
      GENERIC_ERROR: 6,
      INTERNAL_SERVER_ERROR: 7,
      AUTHENTICATION_FAILED: 8,
      PROTOCOL_ERROR: 9,
      INVALID_SESSION_ID: 10,
      INVALID_CONNECTION_ID: 11,
      CONNECTION_LIMIT_REACHED: 12,
      SERVER_UNREACHABLE: 13,
      GATEWAY_BUSY: 14,
      UNSUPPORTED_CREDENTIAL: 15,
      TRANSPORT_ERROR: 16
    },
    Channel: { ALREADY_OPEN: 1, INITIALIZATION_FAILED: 2, REJECTED: 3 },
    CustomChannel: { TRANSPORT_ERROR: 1 },
    Resolution: { INVALID_ARGUMENT: 1, NO_CHANNEL: 2, NOT_IMPLEMENTED: 3 },
    DisplayConfig: { INVALID_ARGUMENT: 1, UNSUPPORTED_OPERATION: 2, NO_CHANNEL: 3 },
    Screenshot: { NO_CHANNEL: 1, GENERIC_ERROR: 2 },
    FileStorage: {
      CANCELLED: 1,
      ABORTED: 2,
      INVALID_ARGUMENT: 3,
      NOT_IMPLEMENTED: 4,
      ERROR: 5,
      ALREADY_EXIST: 6,
      NOT_FOUND: 7
    },
    ClosingReason: {
      TRANSPORT_ERROR: 1,
      NO_ERROR: 2,
      GENERIC_ERROR: 3,
      INTERNAL_SERVER_ERROR: 4,
      PROTOCOL_ERROR: 5,
      AUTHORIZATION_DENIED: 6,
      AUTHORIZATION_REVOKED: 7,
      ACCESS_REJECTED: 8,
      IDLE_TIMEOUT_EXPIRED: 9,
      DISCONNECT_BY_OWNER: 10,
      DISCONNECT_BY_USER: 11,
      EVICTED: 12,
      EXTERNAL_PROTOCOL_CONNECTION_EVICTED: 13,
      DISCONNECTION_REQUESTED: 14
    },
    MultiMonitor: {
      NO_DISPLAY_CHANNEL: 1,
      MAX_DISPLAY_NUMBER_REACHED: 2,
      INVALID_ARGUMENT: 3,
      DISPLAY_NOT_OPENED_BY_SERVER: 4,
      REQUEST_TIMEOUT: 5,
      GENERIC_ERROR: 6,
      NO_ERROR: 7
    },
    Audio: { SETTING_AUDIO_FAILED: 1, CHANNEL_NOT_AVAILABLE: 2, INVALID_ARGUMENT: 3 },
    Webcam: { SETTING_WEBCAM_FAILED: 1, CHANNEL_NOT_AVAILABLE: 2, INVALID_ARGUMENT: 3 },
    Authentication: {
      INVALID_MESSAGE: 1,
      UNKNOWN_AUTH_MODE: 2,
      SESSION_NOT_AVAILABLE: 3,
      NO_SESSIONS: 4,
      WRONG_CREDENTIALS: 5,
      SASL_CHALLENGE: 6,
      SASL_AUTH_MECHANISM: 7,
      FAILED_COMMUNICATION: 8,
      AUTHENTICATION_REJECTED: 9,
      GENERIC_ERROR: 10,
      WRONG_CREDENTIALS_FORMAT: 11,
      WRONG_CREDENTIALS_TYPE: 12,
      UNREQUESTED_CREDENTIALS: 13,
      MISSING_CREDENTIAL: 14
    },
    TimezoneRedirection: { INVALID_ARGUMENT: 1, NO_CHANNEL: 2, USER_CANNOT_CHANGE: 3 }
  },
  lo = 262144,
  uo = 52428800,
  Co = {
    READING_HEADER_AND_BODY: 1,
    READING_BINARY_PAYLOAD: 2,
    properties: {
      1: { name: "READING_HEADER_AND_BODY", value: 1 },
      2: { name: "READING_BINARY_PAYLOAD", value: 2 }
    }
  },
  Bo = new RegExp("^http", "i");
function Qo(A) {
  (this.log = Q("wstransport")),
    Bo.test(A.uri) && (A.uri = no(A.uri, "/ws")),
    (this.config = A),
    this.log.debug(`Opening WebSocket connection with uri '${A.uri}'`);
  let e = new URL(A.uri);
  if (Xn(A.httpExtraSearchParams)) {
    let t = A.httpExtraSearchParams("GET", e, null);
    t instanceof URLSearchParams
      ? t.forEach((A, t) => {
          e.searchParams.set(t, A);
        })
      : this.log.warn("httpExtraSearchParams callback returned invalid type " + typeof t);
  }
  (this.websocket = new WebSocket(e, "dcv")),
    (this.websocket.binaryType = "arraybuffer"),
    (this.reader = {
      state: Co.READING_HEADER_AND_BODY,
      getStateName: () => Co.properties[this.reader.state].name,
      reset: () => {
        (this.reader.body = null), (this.reader.binaryPayload = null);
      }
    }),
    (this.websocket.onopen = Eo.bind(this)),
    (this.websocket.onclose = ho.bind(this)),
    (this.websocket.onerror = po.bind(this)),
    (this.websocket.onmessage = fo.bind(this));
}
function Eo() {
  this.log.debug("WebSocket onopen"), Xn(this.config.onOpen) && this.config.onOpen();
}
function ho(A) {
  const e = {
    1e3: "Normal closure, meaning that the purpose for which the connection was established has been fulfilled",
    1001: 'An endpoint is "going away", such as a server going down or a browser having navigated away from a page',
    1002: "An endpoint is terminating the connection due to a protocol error",
    1003: "An endpoint is terminating the connection because it has received a type of data it cannot accept (e.g., an endpoint that understands only text data MAY send this if it receives a binary message)",
    1004: "Reserved. The specific meaning might be defined in the future",
    1005: "No status code was actually present",
    1006: "The connection was closed abnormally, e.g., without sending or receiving a close control frame",
    1007: "An endpoint is terminating the connection because it has received data within a message that was not consistent with the type of the message (e.g., non-UTF-8 [https://tools.ietf.org/html/rfc3629] data within a text message)",
    1008: 'An endpoint is terminating the connection because it has received a message that "violates its policy". This reason is given either if there is no other suitable reason, or if there is a need to hide specific details about the policy',
    1009: "An endpoint is terminating the connection because it has received a message that is too big for it to process",
    1010: `An endpoint (client) is terminating the connection because it has expected the server to negotiate one or more extension, but the server didn't return them in the response message of the WebSocket handshake. <br />Specifically, the extensions that are needed are: ${A.reason}`,
    1011: "A server is terminating the connection because it encountered an unexpected condition that prevented it from fulfilling the request",
    1015: "The connection was closed due to a failure to perform a TLS handshake (e.g., the server certificate can't be verified)"
  };
  if ((this.log.debug(`WebSocket onclose. Code: ${A.code}`), Xn(this.config.onClose))) {
    let t, i;
    (t = A.code in e ? e[A.code] : `Unknown reason (ws code ${A.code})`),
      (i = 1e3 === A.code ? Io.ClosingReason.NO_ERROR : Io.ClosingReason.TRANSPORT_ERROR),
      this.config.onClose({ code: i, message: t });
  }
}
function po() {
  this.websocket.readyState !== WebSocket.CLOSED
    ? Xn(this.config.onError)
      ? (this.log.debug("WebSocket error"), this.config.onError())
      : this.log.error("WebSocket error")
    : this.log.debug("Discarding error on closed websocket");
}
function fo(A) {
  if (
    this.websocket.readyState === WebSocket.CLOSING ||
    this.websocket.readyState === WebSocket.CLOSED
  )
    return void this.log.debug("Discarding message on closed websocket");
  let e;
  function t() {
    const e = this.reader.body,
      t = this.reader.binaryPayload;
    this.log.debugIf(() => {
      let A = `Received message: [${e ? e.byteLength : 0}`;
      return t && (A += `, ${t.byteLength}`), (A += "]"), A;
    }),
      Xn(this.config.onMessageReceived) && this.config.onMessageReceived(e, t, A.data.byteLength);
  }
  function i(A) {
    this.log.error(`Protocol error: ${A}`),
      this.websocket.close(),
      Xn(this.config.onError) && this.config.onError();
  }
  switch (
    (this.log.debugIf(
      () =>
        `Received WebSocket message (length: ${A.data.byteLength}, state: ${this.reader.getStateName()})`
    ),
    this.reader.state)
  ) {
    case Co.READING_HEADER_AND_BODY:
      if (
        (this.reader.reset(),
        (e = new DataView(A.data)),
        (this.reader.bodySize = e.getUint32(0, !0)),
        (this.reader.binaryPayloadSize = e.getUint32(4, !0)),
        this.reader.bodySize > lo)
      ) {
        i.call(
          this,
          `Incoming message exceeded the maximum allowed size: ${this.reader.bodySize} > ${lo}`
        );
        break;
      }
      if (this.reader.binaryPayloadSize > uo) {
        i.call(
          this,
          `Incoming message payload exceeded the maximum allowed size: ${this.reader.binaryPayloadSize} > ${uo}`
        );
        break;
      }
      0 !== this.reader.bodySize &&
        (this.reader.body = new Uint8Array(A.data, 8, this.reader.bodySize)),
        0 !== this.reader.binaryPayloadSize
          ? (this.reader.state = Co.READING_BINARY_PAYLOAD)
          : t.call(this);
      break;
    case Co.READING_BINARY_PAYLOAD:
      A.data.byteLength === this.reader.binaryPayloadSize
        ? (this.reader.binaryPayload = A.data)
        : (this.reader.binaryPayload = A.data.slice(0, this.reader.binaryPayloadSize)),
        (this.reader.state = Co.READING_HEADER_AND_BODY),
        t.call(this);
      break;
    default:
      i.call(this, "Unexpected reader state");
  }
}
(Qo.prototype.removeEventListeners = function () {
  (this.websocket.onopen = null),
    (this.websocket.onclose = null),
    (this.websocket.onerror = null),
    (this.websocket.onmessage = null),
    (this.websocket = null);
}),
  (Qo.prototype.trySendMessage = function (A, e) {
    let t,
      i,
      n,
      o = A ? A.byteLength : 0,
      r = e ? e.byteLength : 0;
    if (o > lo) throw new Error(`Outgoing message exceeded the maximum allowed size: ${o} > ${lo}`);
    if (r > uo)
      throw new Error(`Outgoing message payload exceeded the maximum allowed size: ${r} > ${uo}`);
    if (
      ((t = (o + 7) & -8),
      (i = new Uint8Array(8 + t)),
      (n = new DataView(i.buffer)),
      n.setUint32(0, o, !0),
      n.setUint32(4, r, !0),
      A && i.set(new Uint8Array(A), 8),
      this.websocket.readyState !== WebSocket.OPEN)
    )
      throw new DOMException("WebSocket is not in an OPEN state.", DOMException.INVALID_STATE_ERR);
    this.websocket.send(i.buffer),
      e && this.websocket.send(e),
      this.log.debugIf(() => `Sent message: ${o} (${t}) bin: ${r}`);
  }),
  (Qo.prototype.sendMessage = function (A, e) {
    try {
      this.trySendMessage(A, e);
    } catch (A) {
      this.log.error(`Error sending message: ${A.message}`);
    }
  }),
  (Qo.prototype.close = function (A) {
    this.log.debug("Closing WebSocket"),
      this.websocket.close(1e3),
      A &&
        (this.config.onClose({
          code: Io.ClosingReason.TRANSPORT_ERROR,
          message: "Transport error."
        }),
        this.removeEventListeners());
  }),
  (Qo.prototype.getBufferedAmount = function () {
    return (
      this.log.debug("Getting WebSocket buffered amount not yet transmitted to the network"),
      this.websocket.bufferedAmount
    );
  }),
  (Qo.prototype.setConnectionId = function (A) {
    this.log = Q("transport", A);
  });
let mo,
  yo = function () {
    (mo = Q("message")), (yo = () => {});
  };
function Do(A, e) {
  let t = null,
    i = null;
  yo();
  try {
    (t = new A(e)), (i = A.encode(t).finish());
  } catch (A) {
    return mo.warn(`Error occurred encoding message: ${A}`), null;
  }
  return mo.trace(`encoded message (size: ${i.byteLength}): `), i;
}
function wo(A, e) {
  const t = A.decode(e);
  return yo(), t;
}
var Fo = { exports: {} };
/*!
 * protobuf.js v7.3.0 (c) 2016, daniel wirtz
 * compiled tue, 14 may 2024 10:51:51 utc
 * licensed under the bsd-3-clause license
 * see: https://github.com/dcodeio/protobuf.js for details
 */ !(function (e) {
  var t, i, n, o;
  (i = {
    1: [
      function (A, e, t) {
        e.exports = function (e) {
          try {
            var t = A(e);
            if (t && (t.length || Object.keys(t).length)) return t;
          } catch (e) {}
          return null;
        };
      },
      {}
    ],
    2: [
      function (A, e, t) {
        e.exports = function (A, e) {
          for (var t = Array(arguments.length - 1), i = 0, n = 2, o = !0; n < arguments.length; )
            t[i++] = arguments[n++];
          return new Promise(function (n, r) {
            t[i] = function (A) {
              if (o)
                if (((o = !1), A)) r(A);
                else {
                  for (var e = Array(arguments.length - 1), t = 0; t < e.length; )
                    e[t++] = arguments[t];
                  n.apply(null, e);
                }
            };
            try {
              A.apply(e || null, t);
            } catch (A) {
              o && ((o = !1), r(A));
            }
          });
        };
      },
      {}
    ],
    3: [
      function (A, e, i) {
        i.length = function (A) {
          var e = A.length;
          if (!e) return 0;
          for (var t = 0; 1 < --e % 4 && "=" == (A[0 | e] || ""); ) ++t;
          return Math.ceil(3 * A.length) / 4 - t;
        };
        for (var n = Array(64), o = Array(123), r = 0; r < 64; )
          o[(n[r] = r < 26 ? r + 65 : r < 52 ? r + 71 : r < 62 ? r - 4 : (r - 59) | 43)] = r++;
        i.encode = function (A, e, t) {
          for (var i, o = null, r = [], s = 0, a = 0; e < t; ) {
            var g = A[e++];
            switch (a) {
              case 0:
                (r[s++] = n[g >> 2]), (i = (3 & g) << 4), (a = 1);
                break;
              case 1:
                (r[s++] = n[i | (g >> 4)]), (i = (15 & g) << 2), (a = 2);
                break;
              case 2:
                (r[s++] = n[i | (g >> 6)]), (r[s++] = n[63 & g]), (a = 0);
            }
            8191 < s && ((o = o || []).push(String.fromCharCode.apply(String, r)), (s = 0));
          }
          return (
            a && ((r[s++] = n[i]), (r[s++] = 61), 1 === a && (r[s++] = 61)),
            o
              ? (s && o.push(String.fromCharCode.apply(String, r.slice(0, s))), o.join(""))
              : String.fromCharCode.apply(String, r.slice(0, s))
          );
        };
        var s = "invalid encoding";
        (i.decode = function (A, e, i) {
          for (var n, r = i, a = 0, g = 0; g < A.length; ) {
            var c = A.charCodeAt(g++);
            if (61 == c && 1 < a) break;
            if ((c = o[c]) === t) throw Error(s);
            switch (a) {
              case 0:
                (n = c), (a = 1);
                break;
              case 1:
                (e[i++] = (n << 2) | ((48 & c) >> 4)), (n = c), (a = 2);
                break;
              case 2:
                (e[i++] = ((15 & n) << 4) | ((60 & c) >> 2)), (n = c), (a = 3);
                break;
              case 3:
                (e[i++] = ((3 & n) << 6) | c), (a = 0);
            }
          }
          if (1 === a) throw Error(s);
          return i - r;
        }),
          (i.test = function (A) {
            return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(A);
          });
      },
      {}
    ],
    4: [
      function (A, e, i) {
        function n() {
          this.t = {};
        }
        ((e.exports = n).prototype.on = function (A, e, t) {
          return (this.t[A] || (this.t[A] = [])).push({ fn: e, ctx: t || this }), this;
        }),
          (n.prototype.off = function (A, e) {
            if (A === t) this.t = {};
            else if (e === t) this.t[A] = [];
            else
              for (var i = this.t[A], n = 0; n < i.length; ) i[n].fn === e ? i.splice(n, 1) : ++n;
            return this;
          }),
          (n.prototype.emit = function (A) {
            var e = this.t[A];
            if (e) {
              for (var t = [], i = 1; i < arguments.length; ) t.push(arguments[i++]);
              for (i = 0; i < e.length; ) e[i].fn.apply(e[i++].ctx, t);
            }
            return this;
          });
      },
      {}
    ],
    5: [
      function (A, e, t) {
        function i(A) {
          function e(A, e, t, i) {
            var n = e < 0 ? 1 : 0;
            A(
              0 === (e = n ? -e : e)
                ? 0 < 1 / e
                  ? 0
                  : 2147483648
                : isNaN(e)
                  ? 2143289344
                  : 34028234663852886e22 < e
                    ? ((n << 31) | 2139095040) >>> 0
                    : e < 11754943508222875e-54
                      ? ((n << 31) | Math.round(e / 1401298464324817e-60)) >>> 0
                      : ((n << 31) |
                          ((127 + (A = Math.floor(Math.log(e) / Math.LN2))) << 23) |
                          (8388607 & Math.round(e * Math.pow(2, -A) * 8388608))) >>>
                        0,
              t,
              i
            );
          }
          function t(A, e, t) {
            return (
              (e = 2 * ((A = A(e, t)) >> 31) + 1),
              (t = (A >>> 23) & 255),
              (A &= 8388607),
              255 == t
                ? A
                  ? NaN
                  : (1 / 0) * e
                : 0 == t
                  ? 1401298464324817e-60 * e * A
                  : e * Math.pow(2, t - 150) * (8388608 + A)
            );
          }
          function i(A, e, t) {
            (I[0] = A), (e[t] = l[0]), (e[t + 1] = l[1]), (e[t + 2] = l[2]), (e[t + 3] = l[3]);
          }
          function a(A, e, t) {
            (I[0] = A), (e[t] = l[3]), (e[t + 1] = l[2]), (e[t + 2] = l[1]), (e[t + 3] = l[0]);
          }
          function g(A, e) {
            return (l[0] = A[e]), (l[1] = A[e + 1]), (l[2] = A[e + 2]), (l[3] = A[e + 3]), I[0];
          }
          function c(A, e) {
            return (l[3] = A[e]), (l[2] = A[e + 1]), (l[1] = A[e + 2]), (l[0] = A[e + 3]), I[0];
          }
          var I, l, d, u, C;
          function B(A, e, t, i, n, o) {
            var r,
              s = i < 0 ? 1 : 0;
            0 === (i = s ? -i : i)
              ? (A(0, n, o + e), A(0 < 1 / i ? 0 : 2147483648, n, o + t))
              : isNaN(i)
                ? (A(0, n, o + e), A(2146959360, n, o + t))
                : 17976931348623157e292 < i
                  ? (A(0, n, o + e), A(((s << 31) | 2146435072) >>> 0, n, o + t))
                  : i < 22250738585072014e-324
                    ? (A((r = i / 5e-324) >>> 0, n, o + e),
                      A(((s << 31) | (r / 4294967296)) >>> 0, n, o + t))
                    : (A(
                        (4503599627370496 *
                          (r =
                            i *
                            Math.pow(
                              2,
                              -(i = 1024 === (i = Math.floor(Math.log(i) / Math.LN2)) ? 1023 : i)
                            ))) >>>
                          0,
                        n,
                        o + e
                      ),
                      A(
                        ((s << 31) | ((i + 1023) << 20) | ((1048576 * r) & 1048575)) >>> 0,
                        n,
                        o + t
                      ));
          }
          function Q(A, e, t, i, n) {
            return (
              (e = A(i, n + e)),
              (i = 2 * ((A = A(i, n + t)) >> 31) + 1),
              (t = 4294967296 * (1048575 & A) + e),
              2047 == (n = (A >>> 20) & 2047)
                ? t
                  ? NaN
                  : (1 / 0) * i
                : 0 == n
                  ? 5e-324 * i * t
                  : i * Math.pow(2, n - 1075) * (t + 4503599627370496)
            );
          }
          function E(A, e, t) {
            (d[0] = A),
              (e[t] = u[0]),
              (e[t + 1] = u[1]),
              (e[t + 2] = u[2]),
              (e[t + 3] = u[3]),
              (e[t + 4] = u[4]),
              (e[t + 5] = u[5]),
              (e[t + 6] = u[6]),
              (e[t + 7] = u[7]);
          }
          function h(A, e, t) {
            (d[0] = A),
              (e[t] = u[7]),
              (e[t + 1] = u[6]),
              (e[t + 2] = u[5]),
              (e[t + 3] = u[4]),
              (e[t + 4] = u[3]),
              (e[t + 5] = u[2]),
              (e[t + 6] = u[1]),
              (e[t + 7] = u[0]);
          }
          function p(A, e) {
            return (
              (u[0] = A[e]),
              (u[1] = A[e + 1]),
              (u[2] = A[e + 2]),
              (u[3] = A[e + 3]),
              (u[4] = A[e + 4]),
              (u[5] = A[e + 5]),
              (u[6] = A[e + 6]),
              (u[7] = A[e + 7]),
              d[0]
            );
          }
          function f(A, e) {
            return (
              (u[7] = A[e]),
              (u[6] = A[e + 1]),
              (u[5] = A[e + 2]),
              (u[4] = A[e + 3]),
              (u[3] = A[e + 4]),
              (u[2] = A[e + 5]),
              (u[1] = A[e + 6]),
              (u[0] = A[e + 7]),
              d[0]
            );
          }
          return (
            "undefined" != typeof Float32Array
              ? ((I = new Float32Array([-0])),
                (C = 128 === (l = new Uint8Array(I.buffer))[3]),
                (A.writeFloatLE = C ? i : a),
                (A.writeFloatBE = C ? a : i),
                (A.readFloatLE = C ? g : c),
                (A.readFloatBE = C ? c : g))
              : ((A.writeFloatLE = e.bind(null, n)),
                (A.writeFloatBE = e.bind(null, o)),
                (A.readFloatLE = t.bind(null, r)),
                (A.readFloatBE = t.bind(null, s))),
            "undefined" != typeof Float64Array
              ? ((d = new Float64Array([-0])),
                (C = 128 === (u = new Uint8Array(d.buffer))[7]),
                (A.writeDoubleLE = C ? E : h),
                (A.writeDoubleBE = C ? h : E),
                (A.readDoubleLE = C ? p : f),
                (A.readDoubleBE = C ? f : p))
              : ((A.writeDoubleLE = B.bind(null, n, 0, 4)),
                (A.writeDoubleBE = B.bind(null, o, 4, 0)),
                (A.readDoubleLE = Q.bind(null, r, 0, 4)),
                (A.readDoubleBE = Q.bind(null, s, 4, 0))),
            A
          );
        }
        function n(A, e, t) {
          (e[t] = 255 & A),
            (e[t + 1] = (A >>> 8) & 255),
            (e[t + 2] = (A >>> 16) & 255),
            (e[t + 3] = A >>> 24);
        }
        function o(A, e, t) {
          (e[t] = A >>> 24),
            (e[t + 1] = (A >>> 16) & 255),
            (e[t + 2] = (A >>> 8) & 255),
            (e[t + 3] = 255 & A);
        }
        function r(A, e) {
          return (A[e] | (A[e + 1] << 8) | (A[e + 2] << 16) | (A[e + 3] << 24)) >>> 0;
        }
        function s(A, e) {
          return ((A[e] << 24) | (A[e + 1] << 16) | (A[e + 2] << 8) | A[e + 3]) >>> 0;
        }
        e.exports = i(i);
      },
      {}
    ],
    6: [
      function (A, e, t) {
        e.exports = function (A, e, t) {
          var i = t || 8192,
            n = i >>> 1,
            o = null,
            r = i;
          return function (t) {
            return t < 1 || n < t
              ? A(t)
              : (i < r + t && ((o = A(i)), (r = 0)),
                (t = e.call(o, r, (r += t))),
                7 & r && (r = 1 + (7 | r)),
                t);
          };
        };
      },
      {}
    ],
    7: [
      function (A, e, t) {
        (t.length = function (A) {
          for (var e, t = 0, i = 0; i < A.length; ++i)
            (e = A.charCodeAt(i)) < 128
              ? (t += 1)
              : e < 2048
                ? (t += 2)
                : 55296 == (64512 & e) && 56320 == (64512 & A.charCodeAt(i + 1))
                  ? (++i, (t += 4))
                  : (t += 3);
          return t;
        }),
          (t.read = function (A, e, t) {
            if (t - e < 1) return "";
            for (var i, n = null, o = [], r = 0; e < t; )
              (i = A[e++]) < 128
                ? (o[r++] = i)
                : 191 < i && i < 224
                  ? (o[r++] = ((31 & i) << 6) | (63 & A[e++]))
                  : 239 < i && i < 365
                    ? ((i =
                        (((7 & i) << 18) |
                          ((63 & A[e++]) << 12) |
                          ((63 & A[e++]) << 6) |
                          (63 & A[e++])) -
                        65536),
                      (o[r++] = 55296 + (i >> 10)),
                      (o[r++] = 56320 + (1023 & i)))
                    : (o[r++] = ((15 & i) << 12) | ((63 & A[e++]) << 6) | (63 & A[e++])),
                8191 < r && ((n = n || []).push(String.fromCharCode.apply(String, o)), (r = 0));
            return n
              ? (r && n.push(String.fromCharCode.apply(String, o.slice(0, r))), n.join(""))
              : String.fromCharCode.apply(String, o.slice(0, r));
          }),
          (t.write = function (A, e, t) {
            for (var i, n, o = t, r = 0; r < A.length; ++r)
              (i = A.charCodeAt(r)) < 128
                ? (e[t++] = i)
                : (i < 2048
                    ? (e[t++] = (i >> 6) | 192)
                    : (55296 == (64512 & i) && 56320 == (64512 & (n = A.charCodeAt(r + 1)))
                        ? (++r,
                          (e[t++] = ((i = 65536 + ((1023 & i) << 10) + (1023 & n)) >> 18) | 240),
                          (e[t++] = ((i >> 12) & 63) | 128))
                        : (e[t++] = (i >> 12) | 224),
                      (e[t++] = ((i >> 6) & 63) | 128)),
                  (e[t++] = (63 & i) | 128));
            return t - o;
          });
      },
      {}
    ],
    8: [
      function (A, e, t) {
        var i = t;
        function n() {
          i.util.n(), i.Writer.n(i.BufferWriter), i.Reader.n(i.BufferReader);
        }
        (i.build = "minimal"),
          (i.Writer = A(16)),
          (i.BufferWriter = A(17)),
          (i.Reader = A(9)),
          (i.BufferReader = A(10)),
          (i.util = A(15)),
          (i.rpc = A(12)),
          (i.roots = A(11)),
          (i.configure = n),
          n();
      },
      { 10: 10, 11: 11, 12: 12, 15: 15, 16: 16, 17: 17, 9: 9 }
    ],
    9: [
      function (A, e, t) {
        e.exports = a;
        var i,
          n = A(15),
          o = n.LongBits,
          r = n.utf8;
        function s(A, e) {
          return RangeError("index out of range: " + A.pos + " + " + (e || 1) + " > " + A.len);
        }
        function a(A) {
          (this.buf = A), (this.pos = 0), (this.len = A.length);
        }
        function g() {
          return n.Buffer
            ? function (A) {
                return (a.create = function (A) {
                  return n.Buffer.isBuffer(A) ? new i(A) : I(A);
                })(A);
              }
            : I;
        }
        var c,
          I =
            "undefined" != typeof Uint8Array
              ? function (A) {
                  if (A instanceof Uint8Array || Array.isArray(A)) return new a(A);
                  throw Error("illegal buffer");
                }
              : function (A) {
                  if (Array.isArray(A)) return new a(A);
                  throw Error("illegal buffer");
                };
        function l() {
          var A = new o(0, 0),
            e = 0;
          if (!(4 < this.len - this.pos)) {
            for (; e < 3; ++e) {
              if (this.pos >= this.len) throw s(this);
              if (
                ((A.lo = (A.lo | ((127 & this.buf[this.pos]) << (7 * e))) >>> 0),
                this.buf[this.pos++] < 128)
              )
                return A;
            }
            return (A.lo = (A.lo | ((127 & this.buf[this.pos++]) << (7 * e))) >>> 0), A;
          }
          for (; e < 4; ++e)
            if (
              ((A.lo = (A.lo | ((127 & this.buf[this.pos]) << (7 * e))) >>> 0),
              this.buf[this.pos++] < 128)
            )
              return A;
          if (
            ((A.lo = (A.lo | ((127 & this.buf[this.pos]) << 28)) >>> 0),
            (A.hi = (A.hi | ((127 & this.buf[this.pos]) >> 4)) >>> 0),
            this.buf[this.pos++] < 128)
          )
            return A;
          if (((e = 0), 4 < this.len - this.pos)) {
            for (; e < 5; ++e)
              if (
                ((A.hi = (A.hi | ((127 & this.buf[this.pos]) << (7 * e + 3))) >>> 0),
                this.buf[this.pos++] < 128)
              )
                return A;
          } else
            for (; e < 5; ++e) {
              if (this.pos >= this.len) throw s(this);
              if (
                ((A.hi = (A.hi | ((127 & this.buf[this.pos]) << (7 * e + 3))) >>> 0),
                this.buf[this.pos++] < 128)
              )
                return A;
            }
          throw Error("invalid varint encoding");
        }
        function d(A, e) {
          return (A[e - 4] | (A[e - 3] << 8) | (A[e - 2] << 16) | (A[e - 1] << 24)) >>> 0;
        }
        function u() {
          if (this.pos + 8 > this.len) throw s(this, 8);
          return new o(d(this.buf, (this.pos += 4)), d(this.buf, (this.pos += 4)));
        }
        (a.create = g()),
          (a.prototype.i = n.Array.prototype.subarray || n.Array.prototype.slice),
          (a.prototype.uint32 =
            ((c = 4294967295),
            function () {
              if (
                ((c = (127 & this.buf[this.pos]) >>> 0),
                this.buf[this.pos++] < 128 ||
                  ((c = (c | ((127 & this.buf[this.pos]) << 7)) >>> 0),
                  this.buf[this.pos++] < 128 ||
                    ((c = (c | ((127 & this.buf[this.pos]) << 14)) >>> 0),
                    this.buf[this.pos++] < 128 ||
                      ((c = (c | ((127 & this.buf[this.pos]) << 21)) >>> 0),
                      this.buf[this.pos++] < 128 ||
                        ((c = (c | ((15 & this.buf[this.pos]) << 28)) >>> 0),
                        this.buf[this.pos++] < 128 || !((this.pos += 5) > this.len))))))
              )
                return c;
              throw ((this.pos = this.len), s(this, 10));
            })),
          (a.prototype.int32 = function () {
            return 0 | this.uint32();
          }),
          (a.prototype.sint32 = function () {
            var A = this.uint32();
            return (A >>> 1) ^ -(1 & A);
          }),
          (a.prototype.bool = function () {
            return 0 !== this.uint32();
          }),
          (a.prototype.fixed32 = function () {
            if (this.pos + 4 > this.len) throw s(this, 4);
            return d(this.buf, (this.pos += 4));
          }),
          (a.prototype.sfixed32 = function () {
            if (this.pos + 4 > this.len) throw s(this, 4);
            return 0 | d(this.buf, (this.pos += 4));
          }),
          (a.prototype.float = function () {
            if (this.pos + 4 > this.len) throw s(this, 4);
            var A = n.float.readFloatLE(this.buf, this.pos);
            return (this.pos += 4), A;
          }),
          (a.prototype.double = function () {
            if (this.pos + 8 > this.len) throw s(this, 4);
            var A = n.float.readDoubleLE(this.buf, this.pos);
            return (this.pos += 8), A;
          }),
          (a.prototype.bytes = function () {
            var A = this.uint32(),
              e = this.pos,
              t = this.pos + A;
            if (t > this.len) throw s(this, A);
            return (
              (this.pos += A),
              Array.isArray(this.buf)
                ? this.buf.slice(e, t)
                : e === t
                  ? (A = n.Buffer)
                    ? A.alloc(0)
                    : new this.buf.constructor(0)
                  : this.i.call(this.buf, e, t)
            );
          }),
          (a.prototype.string = function () {
            var A = this.bytes();
            return r.read(A, 0, A.length);
          }),
          (a.prototype.skip = function (A) {
            if ("number" == typeof A) {
              if (this.pos + A > this.len) throw s(this, A);
              this.pos += A;
            } else
              do {
                if (this.pos >= this.len) throw s(this);
              } while (128 & this.buf[this.pos++]);
            return this;
          }),
          (a.prototype.skipType = function (A) {
            switch (A) {
              case 0:
                this.skip();
                break;
              case 1:
                this.skip(8);
                break;
              case 2:
                this.skip(this.uint32());
                break;
              case 3:
                for (; 4 != (A = 7 & this.uint32()); ) this.skipType(A);
                break;
              case 5:
                this.skip(4);
                break;
              default:
                throw Error("invalid wire type " + A + " at offset " + this.pos);
            }
            return this;
          }),
          (a.n = function (A) {
            (i = A), (a.create = g()), i.n();
            var e = n.Long ? "toLong" : "toNumber";
            n.merge(a.prototype, {
              int64: function () {
                return l.call(this)[e](!1);
              },
              uint64: function () {
                return l.call(this)[e](!0);
              },
              sint64: function () {
                return l.call(this).zzDecode()[e](!1);
              },
              fixed64: function () {
                return u.call(this)[e](!0);
              },
              sfixed64: function () {
                return u.call(this)[e](!1);
              }
            });
          });
      },
      { 15: 15 }
    ],
    10: [
      function (A, e, t) {
        e.exports = o;
        var i = A(9),
          n = (((o.prototype = Object.create(i.prototype)).constructor = o), A(15));
        function o(A) {
          i.call(this, A);
        }
        (o.n = function () {
          n.Buffer && (o.prototype.i = n.Buffer.prototype.slice);
        }),
          (o.prototype.string = function () {
            var A = this.uint32();
            return this.buf.utf8Slice
              ? this.buf.utf8Slice(this.pos, (this.pos = Math.min(this.pos + A, this.len)))
              : this.buf.toString("utf-8", this.pos, (this.pos = Math.min(this.pos + A, this.len)));
          }),
          o.n();
      },
      { 15: 15, 9: 9 }
    ],
    11: [
      function (A, e, t) {
        e.exports = {};
      },
      {}
    ],
    12: [
      function (A, e, t) {
        t.Service = A(13);
      },
      { 13: 13 }
    ],
    13: [
      function (A, e, i) {
        e.exports = o;
        var n = A(15);
        function o(A, e, t) {
          if ("function" != typeof A) throw TypeError("rpcImpl must be a function");
          n.EventEmitter.call(this),
            (this.rpcImpl = A),
            (this.requestDelimited = !!e),
            (this.responseDelimited = !!t);
        }
        (((o.prototype = Object.create(n.EventEmitter.prototype)).constructor =
          o).prototype.rpcCall = function A(e, i, o, r, s) {
          if (!r) throw TypeError("request must be specified");
          var a = this;
          if (!s) return n.asPromise(A, a, e, i, o, r);
          if (!a.rpcImpl)
            return (
              setTimeout(function () {
                s(Error("already ended"));
              }, 0),
              t
            );
          try {
            return a.rpcImpl(
              e,
              i[a.requestDelimited ? "encodeDelimited" : "encode"](r).finish(),
              function (A, i) {
                if (A) return a.emit("error", A, e), s(A);
                if (null === i) return a.end(!0), t;
                if (!(i instanceof o))
                  try {
                    i = o[a.responseDelimited ? "decodeDelimited" : "decode"](i);
                  } catch (A) {
                    return a.emit("error", A, e), s(A);
                  }
                return a.emit("data", i, e), s(null, i);
              }
            );
          } catch (A) {
            return (
              a.emit("error", A, e),
              setTimeout(function () {
                s(A);
              }, 0),
              t
            );
          }
        }),
          (o.prototype.end = function (A) {
            return (
              this.rpcImpl &&
                (A || this.rpcImpl(null, null, null),
                (this.rpcImpl = null),
                this.emit("end").off()),
              this
            );
          });
      },
      { 15: 15 }
    ],
    14: [
      function (A, e, t) {
        e.exports = n;
        var i = A(15);
        function n(A, e) {
          (this.lo = A >>> 0), (this.hi = e >>> 0);
        }
        var o = (n.zero = new n(0, 0)),
          r =
            ((o.toNumber = function () {
              return 0;
            }),
            (o.zzEncode = o.zzDecode =
              function () {
                return this;
              }),
            (o.length = function () {
              return 1;
            }),
            (n.zeroHash = "\0\0\0\0\0\0\0\0"),
            (n.fromNumber = function (A) {
              var e, t;
              return 0 === A
                ? o
                : ((t = (A = (e = A < 0) ? -A : A) >>> 0),
                  (A = ((A - t) / 4294967296) >>> 0),
                  e &&
                    ((A = ~A >>> 0),
                    (t = ~t >>> 0),
                    4294967295 < ++t && ((t = 0), 4294967295 < ++A && (A = 0))),
                  new n(t, A));
            }),
            (n.from = function (A) {
              if ("number" == typeof A) return n.fromNumber(A);
              if (i.isString(A)) {
                if (!i.Long) return n.fromNumber(parseInt(A, 10));
                A = i.Long.fromString(A);
              }
              return A.low || A.high ? new n(A.low >>> 0, A.high >>> 0) : o;
            }),
            (n.prototype.toNumber = function (A) {
              var e;
              return !A && this.hi >>> 31
                ? ((A = (1 + ~this.lo) >>> 0),
                  (e = ~this.hi >>> 0),
                  -(A + 4294967296 * (e = A ? e : (e + 1) >>> 0)))
                : this.lo + 4294967296 * this.hi;
            }),
            (n.prototype.toLong = function (A) {
              return i.Long
                ? new i.Long(0 | this.lo, 0 | this.hi, !!A)
                : { low: 0 | this.lo, high: 0 | this.hi, unsigned: !!A };
            }),
            String.prototype.charCodeAt);
        (n.fromHash = function (A) {
          return "\0\0\0\0\0\0\0\0" === A
            ? o
            : new n(
                (r.call(A, 0) |
                  (r.call(A, 1) << 8) |
                  (r.call(A, 2) << 16) |
                  (r.call(A, 3) << 24)) >>>
                  0,
                (r.call(A, 4) |
                  (r.call(A, 5) << 8) |
                  (r.call(A, 6) << 16) |
                  (r.call(A, 7) << 24)) >>>
                  0
              );
        }),
          (n.prototype.toHash = function () {
            return String.fromCharCode(
              255 & this.lo,
              (this.lo >>> 8) & 255,
              (this.lo >>> 16) & 255,
              this.lo >>> 24,
              255 & this.hi,
              (this.hi >>> 8) & 255,
              (this.hi >>> 16) & 255,
              this.hi >>> 24
            );
          }),
          (n.prototype.zzEncode = function () {
            var A = this.hi >> 31;
            return (
              (this.hi = (((this.hi << 1) | (this.lo >>> 31)) ^ A) >>> 0),
              (this.lo = ((this.lo << 1) ^ A) >>> 0),
              this
            );
          }),
          (n.prototype.zzDecode = function () {
            var A = -(1 & this.lo);
            return (
              (this.lo = (((this.lo >>> 1) | (this.hi << 31)) ^ A) >>> 0),
              (this.hi = ((this.hi >>> 1) ^ A) >>> 0),
              this
            );
          }),
          (n.prototype.length = function () {
            var A = this.lo,
              e = ((this.lo >>> 28) | (this.hi << 4)) >>> 0,
              t = this.hi >>> 24;
            return 0 == t
              ? 0 == e
                ? A < 16384
                  ? A < 128
                    ? 1
                    : 2
                  : A < 2097152
                    ? 3
                    : 4
                : e < 16384
                  ? e < 128
                    ? 5
                    : 6
                  : e < 2097152
                    ? 7
                    : 8
              : t < 128
                ? 9
                : 10;
          });
      },
      { 15: 15 }
    ],
    15: [
      function (e, i, n) {
        var o = n;
        function r(A, e, i) {
          for (var n = Object.keys(e), o = 0; o < n.length; ++o)
            (A[n[o]] !== t && i) || (A[n[o]] = e[n[o]]);
          return A;
        }
        function s(A) {
          function e(A, t) {
            if (!(this instanceof e)) return new e(A, t);
            Object.defineProperty(this, "message", {
              get: function () {
                return A;
              }
            }),
              Error.captureStackTrace
                ? Error.captureStackTrace(this, e)
                : Object.defineProperty(this, "stack", { value: Error().stack || "" }),
              t && r(this, t);
          }
          return (
            (e.prototype = Object.create(Error.prototype, {
              constructor: { value: e, writable: !0, enumerable: !1, configurable: !0 },
              name: {
                get: function () {
                  return A;
                },
                set: t,
                enumerable: !1,
                configurable: !0
              },
              toString: {
                value: function () {
                  return this.name + ": " + this.message;
                },
                writable: !0,
                enumerable: !1,
                configurable: !0
              }
            })),
            e
          );
        }
        (o.asPromise = e(2)),
          (o.base64 = e(3)),
          (o.EventEmitter = e(4)),
          (o.float = e(5)),
          (o.inquire = e(1)),
          (o.utf8 = e(7)),
          (o.pool = e(6)),
          (o.LongBits = e(14)),
          (o.isNode = !!(
            void 0 !== A &&
            A &&
            A.process &&
            A.process.versions &&
            A.process.versions.node
          )),
          (o.global =
            (o.isNode && A) ||
            ("undefined" != typeof window && window) ||
            ("undefined" != typeof self && self) ||
            this),
          (o.emptyArray = Object.freeze ? Object.freeze([]) : []),
          (o.emptyObject = Object.freeze ? Object.freeze({}) : {}),
          (o.isInteger =
            Number.isInteger ||
            function (A) {
              return "number" == typeof A && isFinite(A) && Math.floor(A) === A;
            }),
          (o.isString = function (A) {
            return "string" == typeof A || A instanceof String;
          }),
          (o.isObject = function (A) {
            return A && "object" == typeof A;
          }),
          (o.isset = o.isSet =
            function (A, e) {
              var t = A[e];
              return (
                null != t &&
                A.hasOwnProperty(e) &&
                ("object" != typeof t || 0 < (Array.isArray(t) ? t : Object.keys(t)).length)
              );
            }),
          (o.Buffer = (function () {
            try {
              var A = o.inquire("buffer").Buffer;
              return A.prototype.utf8Write ? A : null;
            } catch (A) {
              return null;
            }
          })()),
          (o.r = null),
          (o.u = null),
          (o.newBuffer = function (A) {
            return "number" == typeof A
              ? o.Buffer
                ? o.u(A)
                : new o.Array(A)
              : o.Buffer
                ? o.r(A)
                : "undefined" == typeof Uint8Array
                  ? A
                  : new Uint8Array(A);
          }),
          (o.Array = "undefined" != typeof Uint8Array ? Uint8Array : Array),
          (o.Long =
            (o.global.dcodeIO && o.global.dcodeIO.Long) || o.global.Long || o.inquire("long")),
          (o.key2Re = /^true|false|0|1$/),
          (o.key32Re = /^-?(?:0|[1-9][0-9]*)$/),
          (o.key64Re = /^(?:[\\x00-\\xff]{8}|-?(?:0|[1-9][0-9]*))$/),
          (o.longToHash = function (A) {
            return A ? o.LongBits.from(A).toHash() : o.LongBits.zeroHash;
          }),
          (o.longFromHash = function (A, e) {
            return (
              (A = o.LongBits.fromHash(A)),
              o.Long ? o.Long.fromBits(A.lo, A.hi, e) : A.toNumber(!!e)
            );
          }),
          (o.merge = r),
          (o.lcFirst = function (A) {
            return (A[0] || "").toLowerCase() + A.substring(1);
          }),
          (o.newError = s),
          (o.ProtocolError = s("ProtocolError")),
          (o.oneOfGetter = function (A) {
            for (var e = {}, i = 0; i < A.length; ++i) e[A[i]] = 1;
            return function () {
              for (var A = Object.keys(this), i = A.length - 1; -1 < i; --i)
                if (1 === e[A[i]] && this[A[i]] !== t && null !== this[A[i]]) return A[i];
            };
          }),
          (o.oneOfSetter = function (A) {
            return function (e) {
              for (var t = 0; t < A.length; ++t) A[t] !== e && delete this[A[t]];
            };
          }),
          (o.toJSONOptions = { longs: String, enums: String, bytes: String, json: !0 }),
          (o.n = function () {
            var A = o.Buffer;
            A
              ? ((o.r =
                  (A.from !== Uint8Array.from && A.from) ||
                  function (e, t) {
                    return new A(e, t);
                  }),
                (o.u =
                  A.allocUnsafe ||
                  function (e) {
                    return new A(e);
                  }))
              : (o.r = o.u = null);
          });
      },
      { 1: 1, 14: 14, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7 }
    ],
    16: [
      function (A, e, i) {
        e.exports = l;
        var n,
          o = A(15),
          r = o.LongBits,
          s = o.base64,
          a = o.utf8;
        function g(A, e, i) {
          (this.fn = A), (this.len = e), (this.next = t), (this.val = i);
        }
        function c() {}
        function I(A) {
          (this.head = A.head), (this.tail = A.tail), (this.len = A.len), (this.next = A.states);
        }
        function l() {
          (this.len = 0),
            (this.head = new g(c, 0, 0)),
            (this.tail = this.head),
            (this.states = null);
        }
        function d() {
          return o.Buffer
            ? function () {
                return (l.create = function () {
                  return new n();
                })();
              }
            : function () {
                return new l();
              };
        }
        function u(A, e, t) {
          e[t] = 255 & A;
        }
        function C(A, e) {
          (this.len = A), (this.next = t), (this.val = e);
        }
        function B(A, e, t) {
          for (; A.hi; )
            (e[t++] = (127 & A.lo) | 128),
              (A.lo = ((A.lo >>> 7) | (A.hi << 25)) >>> 0),
              (A.hi >>>= 7);
          for (; 127 < A.lo; ) (e[t++] = (127 & A.lo) | 128), (A.lo = A.lo >>> 7);
          e[t++] = A.lo;
        }
        function Q(A, e, t) {
          (e[t] = 255 & A),
            (e[t + 1] = (A >>> 8) & 255),
            (e[t + 2] = (A >>> 16) & 255),
            (e[t + 3] = A >>> 24);
        }
        (l.create = d()),
          (l.alloc = function (A) {
            return new o.Array(A);
          }),
          o.Array !== Array && (l.alloc = o.pool(l.alloc, o.Array.prototype.subarray)),
          (l.prototype.e = function (A, e, t) {
            return (this.tail = this.tail.next = new g(A, e, t)), (this.len += e), this;
          }),
          ((C.prototype = Object.create(g.prototype)).fn = function (A, e, t) {
            for (; 127 < A; ) (e[t++] = (127 & A) | 128), (A >>>= 7);
            e[t] = A;
          }),
          (l.prototype.uint32 = function (A) {
            return (
              (this.len += (this.tail = this.tail.next =
                new C(
                  (A >>>= 0) < 128 ? 1 : A < 16384 ? 2 : A < 2097152 ? 3 : A < 268435456 ? 4 : 5,
                  A
                )).len),
              this
            );
          }),
          (l.prototype.int32 = function (A) {
            return A < 0 ? this.e(B, 10, r.fromNumber(A)) : this.uint32(A);
          }),
          (l.prototype.sint32 = function (A) {
            return this.uint32(((A << 1) ^ (A >> 31)) >>> 0);
          }),
          (l.prototype.int64 = l.prototype.uint64 =
            function (A) {
              return (A = r.from(A)), this.e(B, A.length(), A);
            }),
          (l.prototype.sint64 = function (A) {
            return (A = r.from(A).zzEncode()), this.e(B, A.length(), A);
          }),
          (l.prototype.bool = function (A) {
            return this.e(u, 1, A ? 1 : 0);
          }),
          (l.prototype.sfixed32 = l.prototype.fixed32 =
            function (A) {
              return this.e(Q, 4, A >>> 0);
            }),
          (l.prototype.sfixed64 = l.prototype.fixed64 =
            function (A) {
              return (A = r.from(A)), this.e(Q, 4, A.lo).e(Q, 4, A.hi);
            }),
          (l.prototype.float = function (A) {
            return this.e(o.float.writeFloatLE, 4, A);
          }),
          (l.prototype.double = function (A) {
            return this.e(o.float.writeDoubleLE, 8, A);
          });
        var E = o.Array.prototype.set
          ? function (A, e, t) {
              e.set(A, t);
            }
          : function (A, e, t) {
              for (var i = 0; i < A.length; ++i) e[t + i] = A[i];
            };
        (l.prototype.bytes = function (A) {
          var e,
            t = A.length >>> 0;
          return t
            ? (o.isString(A) && ((e = l.alloc((t = s.length(A)))), s.decode(A, e, 0), (A = e)),
              this.uint32(t).e(E, t, A))
            : this.e(u, 1, 0);
        }),
          (l.prototype.string = function (A) {
            var e = a.length(A);
            return e ? this.uint32(e).e(a.write, e, A) : this.e(u, 1, 0);
          }),
          (l.prototype.fork = function () {
            return (
              (this.states = new I(this)),
              (this.head = this.tail = new g(c, 0, 0)),
              (this.len = 0),
              this
            );
          }),
          (l.prototype.reset = function () {
            return (
              this.states
                ? ((this.head = this.states.head),
                  (this.tail = this.states.tail),
                  (this.len = this.states.len),
                  (this.states = this.states.next))
                : ((this.head = this.tail = new g(c, 0, 0)), (this.len = 0)),
              this
            );
          }),
          (l.prototype.ldelim = function () {
            var A = this.head,
              e = this.tail,
              t = this.len;
            return (
              this.reset().uint32(t),
              t && ((this.tail.next = A.next), (this.tail = e), (this.len += t)),
              this
            );
          }),
          (l.prototype.finish = function () {
            for (var A = this.head.next, e = this.constructor.alloc(this.len), t = 0; A; )
              A.fn(A.val, e, t), (t += A.len), (A = A.next);
            return e;
          }),
          (l.n = function (A) {
            (n = A), (l.create = d()), n.n();
          });
      },
      { 15: 15 }
    ],
    17: [
      function (A, e, t) {
        e.exports = o;
        var i = A(16),
          n = (((o.prototype = Object.create(i.prototype)).constructor = o), A(15));
        function o() {
          i.call(this);
        }
        function r(A, e, t) {
          A.length < 40 ? n.utf8.write(A, e, t) : e.utf8Write ? e.utf8Write(A, t) : e.write(A, t);
        }
        (o.n = function () {
          (o.alloc = n.u),
            (o.writeBytesBuffer =
              n.Buffer &&
              n.Buffer.prototype instanceof Uint8Array &&
              "set" === n.Buffer.prototype.set.name
                ? function (A, e, t) {
                    e.set(A, t);
                  }
                : function (A, e, t) {
                    if (A.copy) A.copy(e, t, 0, A.length);
                    else for (var i = 0; i < A.length; ) e[t++] = A[i++];
                  });
        }),
          (o.prototype.bytes = function (A) {
            var e = (A = n.isString(A) ? n.r(A, "base64") : A).length >>> 0;
            return this.uint32(e), e && this.e(o.writeBytesBuffer, e, A), this;
          }),
          (o.prototype.string = function (A) {
            var e = n.Buffer.byteLength(A);
            return this.uint32(e), e && this.e(r, e, A), this;
          }),
          o.n();
      },
      { 15: 15, 16: 16 }
    ]
  }),
    (n = {}),
    ((o = (function A(e) {
      var t = n[e];
      return t || i[e][0].call((t = n[e] = { exports: {} }), A, t, t.exports), t.exports;
    })(8)).util.global.protobuf = o),
    e && e.exports && (e.exports = o);
})(Fo);
const bo = Fo.exports.Reader,
  Uo = Fo.exports.Writer,
  So = Fo.exports.util,
  Ro = Fo.exports.roots["dcv.setup"] || (Fo.exports.roots["dcv.setup"] = {}),
  vo = (Ro.dcv = (() => {
    const A = {};
    return (
      (A.setup = (function () {
        const A = {};
        return (
          (A.SoftwareInfo = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.name = ""),
              (A.prototype.version = null),
              (A.prototype.os = ""),
              (A.prototype.arch = ""),
              (A.prototype.hostname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.name &&
                    Object.hasOwnProperty.call(A, "name") &&
                    e.uint32(10).string(A.name),
                  null != A.version &&
                    Object.hasOwnProperty.call(A, "version") &&
                    Ro.dcv.setup.SoftwareInfo.VersionNumber.encode(
                      A.version,
                      e.uint32(18).fork()
                    ).ldelim(),
                  null != A.os && Object.hasOwnProperty.call(A, "os") && e.uint32(26).string(A.os),
                  null != A.arch &&
                    Object.hasOwnProperty.call(A, "arch") &&
                    e.uint32(34).string(A.arch),
                  null != A.hostname &&
                    Object.hasOwnProperty.call(A, "hostname") &&
                    e.uint32(42).string(A.hostname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.SoftwareInfo();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.name = A.string();
                      break;
                    case 2:
                      i.version = Ro.dcv.setup.SoftwareInfo.VersionNumber.decode(A, A.uint32());
                      break;
                    case 3:
                      i.os = A.string();
                      break;
                    case 4:
                      i.arch = A.string();
                      break;
                    case 5:
                      i.hostname = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.name && A.hasOwnProperty("name") && !So.isString(A.name))
                  return "name: string expected";
                if (null != A.version && A.hasOwnProperty("version")) {
                  let e = Ro.dcv.setup.SoftwareInfo.VersionNumber.verify(A.version);
                  if (e) return "version." + e;
                }
                return null != A.os && A.hasOwnProperty("os") && !So.isString(A.os)
                  ? "os: string expected"
                  : null != A.arch && A.hasOwnProperty("arch") && !So.isString(A.arch)
                    ? "arch: string expected"
                    : null != A.hostname && A.hasOwnProperty("hostname") && !So.isString(A.hostname)
                      ? "hostname: string expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.SoftwareInfo) return A;
                let e = new Ro.dcv.setup.SoftwareInfo();
                if ((null != A.name && (e.name = String(A.name)), null != A.version)) {
                  if ("object" != typeof A.version)
                    throw TypeError(".dcv.setup.SoftwareInfo.version: object expected");
                  e.version = Ro.dcv.setup.SoftwareInfo.VersionNumber.fromObject(A.version);
                }
                return (
                  null != A.os && (e.os = String(A.os)),
                  null != A.arch && (e.arch = String(A.arch)),
                  null != A.hostname && (e.hostname = String(A.hostname)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.name = ""),
                    (t.version = null),
                    (t.os = ""),
                    (t.arch = ""),
                    (t.hostname = "")),
                  null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                  null != A.version &&
                    A.hasOwnProperty("version") &&
                    (t.version = Ro.dcv.setup.SoftwareInfo.VersionNumber.toObject(A.version, e)),
                  null != A.os && A.hasOwnProperty("os") && (t.os = A.os),
                  null != A.arch && A.hasOwnProperty("arch") && (t.arch = A.arch),
                  null != A.hostname && A.hasOwnProperty("hostname") && (t.hostname = A.hostname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.setup.SoftwareInfo";
              }),
              (A.VersionNumber = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.major = 0),
                  (A.prototype.minor = 0),
                  (A.prototype.revision = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Uo.create()),
                      null != A.major &&
                        Object.hasOwnProperty.call(A, "major") &&
                        e.uint32(8).uint32(A.major),
                      null != A.minor &&
                        Object.hasOwnProperty.call(A, "minor") &&
                        e.uint32(16).uint32(A.minor),
                      null != A.revision &&
                        Object.hasOwnProperty.call(A, "revision") &&
                        e.uint32(24).uint32(A.revision),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof bo || (A = bo.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Ro.dcv.setup.SoftwareInfo.VersionNumber();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.major = A.uint32();
                          break;
                        case 2:
                          i.minor = A.uint32();
                          break;
                        case 3:
                          i.revision = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.major && A.hasOwnProperty("major") && !So.isInteger(A.major)
                        ? "major: integer expected"
                        : null != A.minor && A.hasOwnProperty("minor") && !So.isInteger(A.minor)
                          ? "minor: integer expected"
                          : null != A.revision &&
                              A.hasOwnProperty("revision") &&
                              !So.isInteger(A.revision)
                            ? "revision: integer expected"
                            : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Ro.dcv.setup.SoftwareInfo.VersionNumber) return A;
                    let e = new Ro.dcv.setup.SoftwareInfo.VersionNumber();
                    return (
                      null != A.major && (e.major = A.major >>> 0),
                      null != A.minor && (e.minor = A.minor >>> 0),
                      null != A.revision && (e.revision = A.revision >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.major = 0), (t.minor = 0), (t.revision = 0)),
                      null != A.major && A.hasOwnProperty("major") && (t.major = A.major),
                      null != A.minor && A.hasOwnProperty("minor") && (t.minor = A.minor),
                      null != A.revision &&
                        A.hasOwnProperty("revision") &&
                        (t.revision = A.revision),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.setup.SoftwareInfo.VersionNumber"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.ProtocolVersionNumber = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.major = 0),
              (A.prototype.minor = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.major &&
                    Object.hasOwnProperty.call(A, "major") &&
                    e.uint32(8).uint32(A.major),
                  null != A.minor &&
                    Object.hasOwnProperty.call(A, "minor") &&
                    e.uint32(16).uint32(A.minor),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ProtocolVersionNumber();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.major = A.uint32();
                      break;
                    case 2:
                      i.minor = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.major && A.hasOwnProperty("major") && !So.isInteger(A.major)
                    ? "major: integer expected"
                    : null != A.minor && A.hasOwnProperty("minor") && !So.isInteger(A.minor)
                      ? "minor: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ProtocolVersionNumber) return A;
                let e = new Ro.dcv.setup.ProtocolVersionNumber();
                return (
                  null != A.major && (e.major = A.major >>> 0),
                  null != A.minor && (e.minor = A.minor >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.major = 0), (t.minor = 0)),
                  null != A.major && A.hasOwnProperty("major") && (t.major = A.major),
                  null != A.minor && A.hasOwnProperty("minor") && (t.minor = A.minor),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.setup.ProtocolVersionNumber"
                );
              }),
              A
            );
          })()),
          (A.ConnectionConfirm = (function () {
            function A(A) {
              if (((this.endpointFeatures = []), (this.intermediateFeatures = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.connectionId = 0),
              (A.prototype.serverInfo = null),
              (A.prototype.protocolVersion = null),
              (A.prototype.endpointFeatures = So.emptyArray),
              (A.prototype.intermediateFeatures = So.emptyArray),
              (A.prototype.maxFlowStats = 0),
              (A.prototype.extensionData = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Uo.create()),
                  null != A.connectionId &&
                    Object.hasOwnProperty.call(A, "connectionId") &&
                    e.uint32(8).uint32(A.connectionId),
                  null != A.serverInfo &&
                    Object.hasOwnProperty.call(A, "serverInfo") &&
                    Ro.dcv.setup.SoftwareInfo.encode(A.serverInfo, e.uint32(162).fork()).ldelim(),
                  null != A.protocolVersion &&
                    Object.hasOwnProperty.call(A, "protocolVersion") &&
                    Ro.dcv.setup.ProtocolVersionNumber.encode(
                      A.protocolVersion,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.endpointFeatures && A.endpointFeatures.length)
                ) {
                  e.uint32(322).fork();
                  for (let t = 0; t < A.endpointFeatures.length; ++t)
                    e.uint32(A.endpointFeatures[t]);
                  e.ldelim();
                }
                if (null != A.intermediateFeatures && A.intermediateFeatures.length) {
                  e.uint32(330).fork();
                  for (let t = 0; t < A.intermediateFeatures.length; ++t)
                    e.uint32(A.intermediateFeatures[t]);
                  e.ldelim();
                }
                return (
                  null != A.maxFlowStats &&
                    Object.hasOwnProperty.call(A, "maxFlowStats") &&
                    e.uint32(336).uint32(A.maxFlowStats),
                  null != A.extensionData &&
                    Object.hasOwnProperty.call(A, "extensionData") &&
                    e.uint32(402).string(A.extensionData),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ConnectionConfirm();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.connectionId = A.uint32();
                      break;
                    case 20:
                      i.serverInfo = Ro.dcv.setup.SoftwareInfo.decode(A, A.uint32());
                      break;
                    case 30:
                      i.protocolVersion = Ro.dcv.setup.ProtocolVersionNumber.decode(A, A.uint32());
                      break;
                    case 40:
                      if (
                        ((i.endpointFeatures && i.endpointFeatures.length) ||
                          (i.endpointFeatures = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.endpointFeatures.push(A.uint32());
                      } else i.endpointFeatures.push(A.uint32());
                      break;
                    case 41:
                      if (
                        ((i.intermediateFeatures && i.intermediateFeatures.length) ||
                          (i.intermediateFeatures = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.intermediateFeatures.push(A.uint32());
                      } else i.intermediateFeatures.push(A.uint32());
                      break;
                    case 42:
                      i.maxFlowStats = A.uint32();
                      break;
                    case 50:
                      i.extensionData = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.connectionId &&
                  A.hasOwnProperty("connectionId") &&
                  !So.isInteger(A.connectionId)
                )
                  return "connectionId: integer expected";
                if (null != A.serverInfo && A.hasOwnProperty("serverInfo")) {
                  let e = Ro.dcv.setup.SoftwareInfo.verify(A.serverInfo);
                  if (e) return "serverInfo." + e;
                }
                if (null != A.protocolVersion && A.hasOwnProperty("protocolVersion")) {
                  let e = Ro.dcv.setup.ProtocolVersionNumber.verify(A.protocolVersion);
                  if (e) return "protocolVersion." + e;
                }
                if (null != A.endpointFeatures && A.hasOwnProperty("endpointFeatures")) {
                  if (!Array.isArray(A.endpointFeatures)) return "endpointFeatures: array expected";
                  for (let e = 0; e < A.endpointFeatures.length; ++e)
                    if (!So.isInteger(A.endpointFeatures[e]))
                      return "endpointFeatures: integer[] expected";
                }
                if (null != A.intermediateFeatures && A.hasOwnProperty("intermediateFeatures")) {
                  if (!Array.isArray(A.intermediateFeatures))
                    return "intermediateFeatures: array expected";
                  for (let e = 0; e < A.intermediateFeatures.length; ++e)
                    if (!So.isInteger(A.intermediateFeatures[e]))
                      return "intermediateFeatures: integer[] expected";
                }
                return null != A.maxFlowStats &&
                  A.hasOwnProperty("maxFlowStats") &&
                  !So.isInteger(A.maxFlowStats)
                  ? "maxFlowStats: integer expected"
                  : null != A.extensionData &&
                      A.hasOwnProperty("extensionData") &&
                      !So.isString(A.extensionData)
                    ? "extensionData: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ConnectionConfirm) return A;
                let e = new Ro.dcv.setup.ConnectionConfirm();
                if (
                  (null != A.connectionId && (e.connectionId = A.connectionId >>> 0),
                  null != A.serverInfo)
                ) {
                  if ("object" != typeof A.serverInfo)
                    throw TypeError(".dcv.setup.ConnectionConfirm.serverInfo: object expected");
                  e.serverInfo = Ro.dcv.setup.SoftwareInfo.fromObject(A.serverInfo);
                }
                if (null != A.protocolVersion) {
                  if ("object" != typeof A.protocolVersion)
                    throw TypeError(
                      ".dcv.setup.ConnectionConfirm.protocolVersion: object expected"
                    );
                  e.protocolVersion = Ro.dcv.setup.ProtocolVersionNumber.fromObject(
                    A.protocolVersion
                  );
                }
                if (A.endpointFeatures) {
                  if (!Array.isArray(A.endpointFeatures))
                    throw TypeError(
                      ".dcv.setup.ConnectionConfirm.endpointFeatures: array expected"
                    );
                  e.endpointFeatures = [];
                  for (let t = 0; t < A.endpointFeatures.length; ++t)
                    e.endpointFeatures[t] = A.endpointFeatures[t] >>> 0;
                }
                if (A.intermediateFeatures) {
                  if (!Array.isArray(A.intermediateFeatures))
                    throw TypeError(
                      ".dcv.setup.ConnectionConfirm.intermediateFeatures: array expected"
                    );
                  e.intermediateFeatures = [];
                  for (let t = 0; t < A.intermediateFeatures.length; ++t)
                    e.intermediateFeatures[t] = A.intermediateFeatures[t] >>> 0;
                }
                return (
                  null != A.maxFlowStats && (e.maxFlowStats = A.maxFlowStats >>> 0),
                  null != A.extensionData && (e.extensionData = String(A.extensionData)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) &&
                    ((t.endpointFeatures = []), (t.intermediateFeatures = [])),
                  e.defaults &&
                    ((t.connectionId = 0),
                    (t.serverInfo = null),
                    (t.protocolVersion = null),
                    (t.maxFlowStats = 0),
                    (t.extensionData = "")),
                  null != A.connectionId &&
                    A.hasOwnProperty("connectionId") &&
                    (t.connectionId = A.connectionId),
                  null != A.serverInfo &&
                    A.hasOwnProperty("serverInfo") &&
                    (t.serverInfo = Ro.dcv.setup.SoftwareInfo.toObject(A.serverInfo, e)),
                  null != A.protocolVersion &&
                    A.hasOwnProperty("protocolVersion") &&
                    (t.protocolVersion = Ro.dcv.setup.ProtocolVersionNumber.toObject(
                      A.protocolVersion,
                      e
                    )),
                  A.endpointFeatures && A.endpointFeatures.length)
                ) {
                  t.endpointFeatures = [];
                  for (let e = 0; e < A.endpointFeatures.length; ++e)
                    t.endpointFeatures[e] = A.endpointFeatures[e];
                }
                if (A.intermediateFeatures && A.intermediateFeatures.length) {
                  t.intermediateFeatures = [];
                  for (let e = 0; e < A.intermediateFeatures.length; ++e)
                    t.intermediateFeatures[e] = A.intermediateFeatures[e];
                }
                return (
                  null != A.maxFlowStats &&
                    A.hasOwnProperty("maxFlowStats") &&
                    (t.maxFlowStats = A.maxFlowStats),
                  null != A.extensionData &&
                    A.hasOwnProperty("extensionData") &&
                    (t.extensionData = A.extensionData),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.setup.ConnectionConfirm"
                );
              }),
              A
            );
          })()),
          (A.ChannelConnectionConfirm = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.channelConnectionId = 0),
              (A.prototype.protocolVersion = null),
              (A.prototype.encryption = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.channelConnectionId &&
                    Object.hasOwnProperty.call(A, "channelConnectionId") &&
                    e.uint32(8).uint32(A.channelConnectionId),
                  null != A.protocolVersion &&
                    Object.hasOwnProperty.call(A, "protocolVersion") &&
                    Ro.dcv.setup.ProtocolVersionNumber.encode(
                      A.protocolVersion,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.encryption &&
                    Object.hasOwnProperty.call(A, "encryption") &&
                    e.uint32(240).bool(A.encryption),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ChannelConnectionConfirm();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.channelConnectionId = A.uint32();
                      break;
                    case 20:
                      i.protocolVersion = Ro.dcv.setup.ProtocolVersionNumber.decode(A, A.uint32());
                      break;
                    case 30:
                      i.encryption = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.channelConnectionId &&
                  A.hasOwnProperty("channelConnectionId") &&
                  !So.isInteger(A.channelConnectionId)
                )
                  return "channelConnectionId: integer expected";
                if (null != A.protocolVersion && A.hasOwnProperty("protocolVersion")) {
                  let e = Ro.dcv.setup.ProtocolVersionNumber.verify(A.protocolVersion);
                  if (e) return "protocolVersion." + e;
                }
                return null != A.encryption &&
                  A.hasOwnProperty("encryption") &&
                  "boolean" != typeof A.encryption
                  ? "encryption: boolean expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ChannelConnectionConfirm) return A;
                let e = new Ro.dcv.setup.ChannelConnectionConfirm();
                if (
                  (null != A.channelConnectionId &&
                    (e.channelConnectionId = A.channelConnectionId >>> 0),
                  null != A.protocolVersion)
                ) {
                  if ("object" != typeof A.protocolVersion)
                    throw TypeError(
                      ".dcv.setup.ChannelConnectionConfirm.protocolVersion: object expected"
                    );
                  e.protocolVersion = Ro.dcv.setup.ProtocolVersionNumber.fromObject(
                    A.protocolVersion
                  );
                }
                return null != A.encryption && (e.encryption = Boolean(A.encryption)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.channelConnectionId = 0), (t.protocolVersion = null), (t.encryption = !1)),
                  null != A.channelConnectionId &&
                    A.hasOwnProperty("channelConnectionId") &&
                    (t.channelConnectionId = A.channelConnectionId),
                  null != A.protocolVersion &&
                    A.hasOwnProperty("protocolVersion") &&
                    (t.protocolVersion = Ro.dcv.setup.ProtocolVersionNumber.toObject(
                      A.protocolVersion,
                      e
                    )),
                  null != A.encryption &&
                    A.hasOwnProperty("encryption") &&
                    (t.encryption = A.encryption),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.setup.ChannelConnectionConfirm"
                );
              }),
              A
            );
          })()),
          (A.ConnectionAbort = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.reason = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.reason &&
                    Object.hasOwnProperty.call(A, "reason") &&
                    e.uint32(8).int32(A.reason),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ConnectionAbort();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.reason = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.reason && A.hasOwnProperty("reason"))
                  switch (A.reason) {
                    default:
                      return "reason: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 10:
                    case 11:
                    case 20:
                    case 30:
                    case 31:
                    case 40:
                    case 50:
                    case 60:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ConnectionAbort) return A;
                let e = new Ro.dcv.setup.ConnectionAbort();
                switch (A.reason) {
                  default:
                    if ("number" == typeof A.reason) {
                      e.reason = A.reason;
                      break;
                    }
                    break;
                  case "GENERIC_ERROR":
                  case 0:
                    e.reason = 0;
                    break;
                  case "INTERNAL_SERVER_ERROR":
                  case 1:
                    e.reason = 1;
                    break;
                  case "PROTOCOL_ERROR":
                  case 2:
                    e.reason = 2;
                    break;
                  case "INVALID_SESSION_ID":
                  case 10:
                    e.reason = 10;
                    break;
                  case "INVALID_CONNECTION_ID":
                  case 11:
                    e.reason = 11;
                    break;
                  case "AUTHENTICATION_FAILED":
                  case 20:
                    e.reason = 20;
                    break;
                  case "CONNECTION_LIMIT_REACHED":
                  case 30:
                    e.reason = 30;
                    break;
                  case "GATEWAY_BUSY":
                  case 31:
                    e.reason = 31;
                    break;
                  case "SERVER_UNREACHABLE":
                  case 40:
                    e.reason = 40;
                    break;
                  case "UNSUPPORTED_CREDENTIAL":
                  case 50:
                    e.reason = 50;
                    break;
                  case "UNSUPERVISED_USER_CONNECTION":
                  case 60:
                    e.reason = 60;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.reason = e.enums === String ? "GENERIC_ERROR" : 0),
                  null != A.reason &&
                    A.hasOwnProperty("reason") &&
                    (t.reason =
                      e.enums === String
                        ? void 0 === Ro.dcv.setup.ConnectionAbort.AbortingReason[A.reason]
                          ? A.reason
                          : Ro.dcv.setup.ConnectionAbort.AbortingReason[A.reason]
                        : A.reason),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.setup.ConnectionAbort"
                );
              }),
              (A.AbortingReason = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "GENERIC_ERROR")] = 0),
                  (e[(A[1] = "INTERNAL_SERVER_ERROR")] = 1),
                  (e[(A[2] = "PROTOCOL_ERROR")] = 2),
                  (e[(A[10] = "INVALID_SESSION_ID")] = 10),
                  (e[(A[11] = "INVALID_CONNECTION_ID")] = 11),
                  (e[(A[20] = "AUTHENTICATION_FAILED")] = 20),
                  (e[(A[30] = "CONNECTION_LIMIT_REACHED")] = 30),
                  (e[(A[31] = "GATEWAY_BUSY")] = 31),
                  (e[(A[40] = "SERVER_UNREACHABLE")] = 40),
                  (e[(A[50] = "UNSUPPORTED_CREDENTIAL")] = 50),
                  (e[(A[60] = "UNSUPERVISED_USER_CONNECTION")] = 60),
                  e
                );
              })()),
              A
            );
          })()),
          (A.ConnectionRequest = (function () {
            function A(A) {
              if (((this.endpointFeatures = []), (this.intermediateFeatures = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.sessionId = ""),
              (A.prototype.authenticationToken = ""),
              (A.prototype.clientInfo = null),
              (A.prototype.maxProtocolVersion = null),
              (A.prototype.extensionData = ""),
              (A.prototype.endpointFeatures = So.emptyArray),
              (A.prototype.intermediateFeatures = So.emptyArray),
              (A.prototype.intermediateCounter = So.Long ? So.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Uo.create()),
                  null != A.sessionId &&
                    Object.hasOwnProperty.call(A, "sessionId") &&
                    e.uint32(10).string(A.sessionId),
                  null != A.authenticationToken &&
                    Object.hasOwnProperty.call(A, "authenticationToken") &&
                    e.uint32(82).string(A.authenticationToken),
                  null != A.clientInfo &&
                    Object.hasOwnProperty.call(A, "clientInfo") &&
                    Ro.dcv.setup.SoftwareInfo.encode(A.clientInfo, e.uint32(162).fork()).ldelim(),
                  null != A.maxProtocolVersion &&
                    Object.hasOwnProperty.call(A, "maxProtocolVersion") &&
                    Ro.dcv.setup.ProtocolVersionNumber.encode(
                      A.maxProtocolVersion,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.extensionData &&
                    Object.hasOwnProperty.call(A, "extensionData") &&
                    e.uint32(322).string(A.extensionData),
                  null != A.endpointFeatures && A.endpointFeatures.length)
                ) {
                  e.uint32(402).fork();
                  for (let t = 0; t < A.endpointFeatures.length; ++t)
                    e.uint32(A.endpointFeatures[t]);
                  e.ldelim();
                }
                if (null != A.intermediateFeatures && A.intermediateFeatures.length) {
                  e.uint32(410).fork();
                  for (let t = 0; t < A.intermediateFeatures.length; ++t)
                    e.uint32(A.intermediateFeatures[t]);
                  e.ldelim();
                }
                return (
                  null != A.intermediateCounter &&
                    Object.hasOwnProperty.call(A, "intermediateCounter") &&
                    e.uint32(480).uint64(A.intermediateCounter),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ConnectionRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.sessionId = A.string();
                      break;
                    case 10:
                      i.authenticationToken = A.string();
                      break;
                    case 20:
                      i.clientInfo = Ro.dcv.setup.SoftwareInfo.decode(A, A.uint32());
                      break;
                    case 30:
                      i.maxProtocolVersion = Ro.dcv.setup.ProtocolVersionNumber.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 40:
                      i.extensionData = A.string();
                      break;
                    case 50:
                      if (
                        ((i.endpointFeatures && i.endpointFeatures.length) ||
                          (i.endpointFeatures = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.endpointFeatures.push(A.uint32());
                      } else i.endpointFeatures.push(A.uint32());
                      break;
                    case 51:
                      if (
                        ((i.intermediateFeatures && i.intermediateFeatures.length) ||
                          (i.intermediateFeatures = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.intermediateFeatures.push(A.uint32());
                      } else i.intermediateFeatures.push(A.uint32());
                      break;
                    case 60:
                      i.intermediateCounter = A.uint64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.sessionId &&
                  A.hasOwnProperty("sessionId") &&
                  !So.isString(A.sessionId)
                )
                  return "sessionId: string expected";
                if (
                  null != A.authenticationToken &&
                  A.hasOwnProperty("authenticationToken") &&
                  !So.isString(A.authenticationToken)
                )
                  return "authenticationToken: string expected";
                if (null != A.clientInfo && A.hasOwnProperty("clientInfo")) {
                  let e = Ro.dcv.setup.SoftwareInfo.verify(A.clientInfo);
                  if (e) return "clientInfo." + e;
                }
                if (null != A.maxProtocolVersion && A.hasOwnProperty("maxProtocolVersion")) {
                  let e = Ro.dcv.setup.ProtocolVersionNumber.verify(A.maxProtocolVersion);
                  if (e) return "maxProtocolVersion." + e;
                }
                if (
                  null != A.extensionData &&
                  A.hasOwnProperty("extensionData") &&
                  !So.isString(A.extensionData)
                )
                  return "extensionData: string expected";
                if (null != A.endpointFeatures && A.hasOwnProperty("endpointFeatures")) {
                  if (!Array.isArray(A.endpointFeatures)) return "endpointFeatures: array expected";
                  for (let e = 0; e < A.endpointFeatures.length; ++e)
                    if (!So.isInteger(A.endpointFeatures[e]))
                      return "endpointFeatures: integer[] expected";
                }
                if (null != A.intermediateFeatures && A.hasOwnProperty("intermediateFeatures")) {
                  if (!Array.isArray(A.intermediateFeatures))
                    return "intermediateFeatures: array expected";
                  for (let e = 0; e < A.intermediateFeatures.length; ++e)
                    if (!So.isInteger(A.intermediateFeatures[e]))
                      return "intermediateFeatures: integer[] expected";
                }
                return null != A.intermediateCounter &&
                  A.hasOwnProperty("intermediateCounter") &&
                  !(
                    So.isInteger(A.intermediateCounter) ||
                    (A.intermediateCounter &&
                      So.isInteger(A.intermediateCounter.low) &&
                      So.isInteger(A.intermediateCounter.high))
                  )
                  ? "intermediateCounter: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ConnectionRequest) return A;
                let e = new Ro.dcv.setup.ConnectionRequest();
                if (
                  (null != A.sessionId && (e.sessionId = String(A.sessionId)),
                  null != A.authenticationToken &&
                    (e.authenticationToken = String(A.authenticationToken)),
                  null != A.clientInfo)
                ) {
                  if ("object" != typeof A.clientInfo)
                    throw TypeError(".dcv.setup.ConnectionRequest.clientInfo: object expected");
                  e.clientInfo = Ro.dcv.setup.SoftwareInfo.fromObject(A.clientInfo);
                }
                if (null != A.maxProtocolVersion) {
                  if ("object" != typeof A.maxProtocolVersion)
                    throw TypeError(
                      ".dcv.setup.ConnectionRequest.maxProtocolVersion: object expected"
                    );
                  e.maxProtocolVersion = Ro.dcv.setup.ProtocolVersionNumber.fromObject(
                    A.maxProtocolVersion
                  );
                }
                if (
                  (null != A.extensionData && (e.extensionData = String(A.extensionData)),
                  A.endpointFeatures)
                ) {
                  if (!Array.isArray(A.endpointFeatures))
                    throw TypeError(
                      ".dcv.setup.ConnectionRequest.endpointFeatures: array expected"
                    );
                  e.endpointFeatures = [];
                  for (let t = 0; t < A.endpointFeatures.length; ++t)
                    e.endpointFeatures[t] = A.endpointFeatures[t] >>> 0;
                }
                if (A.intermediateFeatures) {
                  if (!Array.isArray(A.intermediateFeatures))
                    throw TypeError(
                      ".dcv.setup.ConnectionRequest.intermediateFeatures: array expected"
                    );
                  e.intermediateFeatures = [];
                  for (let t = 0; t < A.intermediateFeatures.length; ++t)
                    e.intermediateFeatures[t] = A.intermediateFeatures[t] >>> 0;
                }
                return (
                  null != A.intermediateCounter &&
                    (So.Long
                      ? ((e.intermediateCounter = So.Long.fromValue(
                          A.intermediateCounter
                        )).unsigned = !0)
                      : "string" == typeof A.intermediateCounter
                        ? (e.intermediateCounter = parseInt(A.intermediateCounter, 10))
                        : "number" == typeof A.intermediateCounter
                          ? (e.intermediateCounter = A.intermediateCounter)
                          : "object" == typeof A.intermediateCounter &&
                            (e.intermediateCounter = new So.LongBits(
                              A.intermediateCounter.low >>> 0,
                              A.intermediateCounter.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) &&
                    ((t.endpointFeatures = []), (t.intermediateFeatures = [])),
                  e.defaults)
                )
                  if (
                    ((t.sessionId = ""),
                    (t.authenticationToken = ""),
                    (t.clientInfo = null),
                    (t.maxProtocolVersion = null),
                    (t.extensionData = ""),
                    So.Long)
                  ) {
                    let A = new So.Long(0, 0, !0);
                    t.intermediateCounter =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.intermediateCounter = e.longs === String ? "0" : 0;
                if (
                  (null != A.sessionId &&
                    A.hasOwnProperty("sessionId") &&
                    (t.sessionId = A.sessionId),
                  null != A.authenticationToken &&
                    A.hasOwnProperty("authenticationToken") &&
                    (t.authenticationToken = A.authenticationToken),
                  null != A.clientInfo &&
                    A.hasOwnProperty("clientInfo") &&
                    (t.clientInfo = Ro.dcv.setup.SoftwareInfo.toObject(A.clientInfo, e)),
                  null != A.maxProtocolVersion &&
                    A.hasOwnProperty("maxProtocolVersion") &&
                    (t.maxProtocolVersion = Ro.dcv.setup.ProtocolVersionNumber.toObject(
                      A.maxProtocolVersion,
                      e
                    )),
                  null != A.extensionData &&
                    A.hasOwnProperty("extensionData") &&
                    (t.extensionData = A.extensionData),
                  A.endpointFeatures && A.endpointFeatures.length)
                ) {
                  t.endpointFeatures = [];
                  for (let e = 0; e < A.endpointFeatures.length; ++e)
                    t.endpointFeatures[e] = A.endpointFeatures[e];
                }
                if (A.intermediateFeatures && A.intermediateFeatures.length) {
                  t.intermediateFeatures = [];
                  for (let e = 0; e < A.intermediateFeatures.length; ++e)
                    t.intermediateFeatures[e] = A.intermediateFeatures[e];
                }
                return (
                  null != A.intermediateCounter &&
                    A.hasOwnProperty("intermediateCounter") &&
                    ("number" == typeof A.intermediateCounter
                      ? (t.intermediateCounter =
                          e.longs === String
                            ? String(A.intermediateCounter)
                            : A.intermediateCounter)
                      : (t.intermediateCounter =
                          e.longs === String
                            ? So.Long.prototype.toString.call(A.intermediateCounter)
                            : e.longs === Number
                              ? new So.LongBits(
                                  A.intermediateCounter.low >>> 0,
                                  A.intermediateCounter.high >>> 0
                                ).toNumber(!0)
                              : A.intermediateCounter)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.setup.ConnectionRequest"
                );
              }),
              A
            );
          })()),
          (A.ChannelConnectionRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.sessionId = ""),
              (A.prototype.connectionId = 0),
              (A.prototype.channelName = ""),
              (A.prototype.channelNamespace = ""),
              (A.prototype.authenticationToken = ""),
              (A.prototype.maxProtocolVersion = null),
              (A.prototype.requestedEncryptionMode = 0),
              (A.prototype.extensionData = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.sessionId &&
                    Object.hasOwnProperty.call(A, "sessionId") &&
                    e.uint32(10).string(A.sessionId),
                  null != A.connectionId &&
                    Object.hasOwnProperty.call(A, "connectionId") &&
                    e.uint32(16).uint32(A.connectionId),
                  null != A.channelName &&
                    Object.hasOwnProperty.call(A, "channelName") &&
                    e.uint32(26).string(A.channelName),
                  null != A.channelNamespace &&
                    Object.hasOwnProperty.call(A, "channelNamespace") &&
                    e.uint32(34).string(A.channelNamespace),
                  null != A.authenticationToken &&
                    Object.hasOwnProperty.call(A, "authenticationToken") &&
                    e.uint32(82).string(A.authenticationToken),
                  null != A.maxProtocolVersion &&
                    Object.hasOwnProperty.call(A, "maxProtocolVersion") &&
                    Ro.dcv.setup.ProtocolVersionNumber.encode(
                      A.maxProtocolVersion,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.requestedEncryptionMode &&
                    Object.hasOwnProperty.call(A, "requestedEncryptionMode") &&
                    e.uint32(240).int32(A.requestedEncryptionMode),
                  null != A.extensionData &&
                    Object.hasOwnProperty.call(A, "extensionData") &&
                    e.uint32(322).string(A.extensionData),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ChannelConnectionRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.sessionId = A.string();
                      break;
                    case 2:
                      i.connectionId = A.uint32();
                      break;
                    case 3:
                      i.channelName = A.string();
                      break;
                    case 4:
                      i.channelNamespace = A.string();
                      break;
                    case 10:
                      i.authenticationToken = A.string();
                      break;
                    case 20:
                      i.maxProtocolVersion = Ro.dcv.setup.ProtocolVersionNumber.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 30:
                      i.requestedEncryptionMode = A.int32();
                      break;
                    case 40:
                      i.extensionData = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.sessionId &&
                  A.hasOwnProperty("sessionId") &&
                  !So.isString(A.sessionId)
                )
                  return "sessionId: string expected";
                if (
                  null != A.connectionId &&
                  A.hasOwnProperty("connectionId") &&
                  !So.isInteger(A.connectionId)
                )
                  return "connectionId: integer expected";
                if (
                  null != A.channelName &&
                  A.hasOwnProperty("channelName") &&
                  !So.isString(A.channelName)
                )
                  return "channelName: string expected";
                if (
                  null != A.channelNamespace &&
                  A.hasOwnProperty("channelNamespace") &&
                  !So.isString(A.channelNamespace)
                )
                  return "channelNamespace: string expected";
                if (
                  null != A.authenticationToken &&
                  A.hasOwnProperty("authenticationToken") &&
                  !So.isString(A.authenticationToken)
                )
                  return "authenticationToken: string expected";
                if (null != A.maxProtocolVersion && A.hasOwnProperty("maxProtocolVersion")) {
                  let e = Ro.dcv.setup.ProtocolVersionNumber.verify(A.maxProtocolVersion);
                  if (e) return "maxProtocolVersion." + e;
                }
                if (
                  null != A.requestedEncryptionMode &&
                  A.hasOwnProperty("requestedEncryptionMode")
                )
                  switch (A.requestedEncryptionMode) {
                    default:
                      return "requestedEncryptionMode: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                return null != A.extensionData &&
                  A.hasOwnProperty("extensionData") &&
                  !So.isString(A.extensionData)
                  ? "extensionData: string expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ChannelConnectionRequest) return A;
                let e = new Ro.dcv.setup.ChannelConnectionRequest();
                if (
                  (null != A.sessionId && (e.sessionId = String(A.sessionId)),
                  null != A.connectionId && (e.connectionId = A.connectionId >>> 0),
                  null != A.channelName && (e.channelName = String(A.channelName)),
                  null != A.channelNamespace && (e.channelNamespace = String(A.channelNamespace)),
                  null != A.authenticationToken &&
                    (e.authenticationToken = String(A.authenticationToken)),
                  null != A.maxProtocolVersion)
                ) {
                  if ("object" != typeof A.maxProtocolVersion)
                    throw TypeError(
                      ".dcv.setup.ChannelConnectionRequest.maxProtocolVersion: object expected"
                    );
                  e.maxProtocolVersion = Ro.dcv.setup.ProtocolVersionNumber.fromObject(
                    A.maxProtocolVersion
                  );
                }
                switch (A.requestedEncryptionMode) {
                  default:
                    if ("number" == typeof A.requestedEncryptionMode) {
                      e.requestedEncryptionMode = A.requestedEncryptionMode;
                      break;
                    }
                    break;
                  case "SERVER_DECIDES":
                  case 0:
                    e.requestedEncryptionMode = 0;
                    break;
                  case "ALWAYS_ON":
                  case 1:
                    e.requestedEncryptionMode = 1;
                    break;
                  case "PREFER_ON":
                  case 2:
                    e.requestedEncryptionMode = 2;
                    break;
                  case "PREFER_OFF":
                  case 3:
                    e.requestedEncryptionMode = 3;
                }
                return null != A.extensionData && (e.extensionData = String(A.extensionData)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.sessionId = ""),
                    (t.connectionId = 0),
                    (t.channelName = ""),
                    (t.channelNamespace = ""),
                    (t.authenticationToken = ""),
                    (t.maxProtocolVersion = null),
                    (t.requestedEncryptionMode = e.enums === String ? "SERVER_DECIDES" : 0),
                    (t.extensionData = "")),
                  null != A.sessionId &&
                    A.hasOwnProperty("sessionId") &&
                    (t.sessionId = A.sessionId),
                  null != A.connectionId &&
                    A.hasOwnProperty("connectionId") &&
                    (t.connectionId = A.connectionId),
                  null != A.channelName &&
                    A.hasOwnProperty("channelName") &&
                    (t.channelName = A.channelName),
                  null != A.channelNamespace &&
                    A.hasOwnProperty("channelNamespace") &&
                    (t.channelNamespace = A.channelNamespace),
                  null != A.authenticationToken &&
                    A.hasOwnProperty("authenticationToken") &&
                    (t.authenticationToken = A.authenticationToken),
                  null != A.maxProtocolVersion &&
                    A.hasOwnProperty("maxProtocolVersion") &&
                    (t.maxProtocolVersion = Ro.dcv.setup.ProtocolVersionNumber.toObject(
                      A.maxProtocolVersion,
                      e
                    )),
                  null != A.requestedEncryptionMode &&
                    A.hasOwnProperty("requestedEncryptionMode") &&
                    (t.requestedEncryptionMode =
                      e.enums === String
                        ? void 0 ===
                          Ro.dcv.setup.ChannelConnectionRequest.EncryptionMode[
                            A.requestedEncryptionMode
                          ]
                          ? A.requestedEncryptionMode
                          : Ro.dcv.setup.ChannelConnectionRequest.EncryptionMode[
                              A.requestedEncryptionMode
                            ]
                        : A.requestedEncryptionMode),
                  null != A.extensionData &&
                    A.hasOwnProperty("extensionData") &&
                    (t.extensionData = A.extensionData),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.setup.ChannelConnectionRequest"
                );
              }),
              (A.EncryptionMode = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "SERVER_DECIDES")] = 0),
                  (e[(A[1] = "ALWAYS_ON")] = 1),
                  (e[(A[2] = "PREFER_ON")] = 2),
                  (e[(A[3] = "PREFER_OFF")] = 3),
                  e
                );
              })()),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.connectionRequest = null),
              (A.prototype.channelConnectionRequest = null),
              Object.defineProperty(A.prototype, "msg", {
                get: So.oneOfGetter((e = ["connectionRequest", "channelConnectionRequest"])),
                set: So.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.connectionRequest &&
                    Object.hasOwnProperty.call(A, "connectionRequest") &&
                    Ro.dcv.setup.ConnectionRequest.encode(
                      A.connectionRequest,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.channelConnectionRequest &&
                    Object.hasOwnProperty.call(A, "channelConnectionRequest") &&
                    Ro.dcv.setup.ChannelConnectionRequest.encode(
                      A.channelConnectionRequest,
                      e.uint32(90).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.connectionRequest = Ro.dcv.setup.ConnectionRequest.decode(A, A.uint32());
                      break;
                    case 11:
                      i.channelConnectionRequest = Ro.dcv.setup.ChannelConnectionRequest.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.connectionRequest && A.hasOwnProperty("connectionRequest")) {
                  e.msg = 1;
                  {
                    let e = Ro.dcv.setup.ConnectionRequest.verify(A.connectionRequest);
                    if (e) return "connectionRequest." + e;
                  }
                }
                if (
                  null != A.channelConnectionRequest &&
                  A.hasOwnProperty("channelConnectionRequest")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ro.dcv.setup.ChannelConnectionRequest.verify(
                      A.channelConnectionRequest
                    );
                    if (e) return "channelConnectionRequest." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ClientMessage) return A;
                let e = new Ro.dcv.setup.ClientMessage();
                if (null != A.connectionRequest) {
                  if ("object" != typeof A.connectionRequest)
                    throw TypeError(".dcv.setup.ClientMessage.connectionRequest: object expected");
                  e.connectionRequest = Ro.dcv.setup.ConnectionRequest.fromObject(
                    A.connectionRequest
                  );
                }
                if (null != A.channelConnectionRequest) {
                  if ("object" != typeof A.channelConnectionRequest)
                    throw TypeError(
                      ".dcv.setup.ClientMessage.channelConnectionRequest: object expected"
                    );
                  e.channelConnectionRequest = Ro.dcv.setup.ChannelConnectionRequest.fromObject(
                    A.channelConnectionRequest
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.connectionRequest &&
                    A.hasOwnProperty("connectionRequest") &&
                    ((t.connectionRequest = Ro.dcv.setup.ConnectionRequest.toObject(
                      A.connectionRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "connectionRequest")),
                  null != A.channelConnectionRequest &&
                    A.hasOwnProperty("channelConnectionRequest") &&
                    ((t.channelConnectionRequest = Ro.dcv.setup.ChannelConnectionRequest.toObject(
                      A.channelConnectionRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "channelConnectionRequest")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.setup.ClientMessage";
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.connectionConfirm = null),
              (A.prototype.channelConnectionConfirm = null),
              (A.prototype.connectionAbort = null),
              Object.defineProperty(A.prototype, "msg", {
                get: So.oneOfGetter(
                  (e = ["connectionConfirm", "channelConnectionConfirm", "connectionAbort"])
                ),
                set: So.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Uo.create()),
                  null != A.connectionConfirm &&
                    Object.hasOwnProperty.call(A, "connectionConfirm") &&
                    Ro.dcv.setup.ConnectionConfirm.encode(
                      A.connectionConfirm,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.channelConnectionConfirm &&
                    Object.hasOwnProperty.call(A, "channelConnectionConfirm") &&
                    Ro.dcv.setup.ChannelConnectionConfirm.encode(
                      A.channelConnectionConfirm,
                      e.uint32(90).fork()
                    ).ldelim(),
                  null != A.connectionAbort &&
                    Object.hasOwnProperty.call(A, "connectionAbort") &&
                    Ro.dcv.setup.ConnectionAbort.encode(
                      A.connectionAbort,
                      e.uint32(162).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof bo || (A = bo.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ro.dcv.setup.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.connectionConfirm = Ro.dcv.setup.ConnectionConfirm.decode(A, A.uint32());
                      break;
                    case 11:
                      i.channelConnectionConfirm = Ro.dcv.setup.ChannelConnectionConfirm.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 20:
                      i.connectionAbort = Ro.dcv.setup.ConnectionAbort.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof bo || (A = new bo(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.connectionConfirm && A.hasOwnProperty("connectionConfirm")) {
                  e.msg = 1;
                  {
                    let e = Ro.dcv.setup.ConnectionConfirm.verify(A.connectionConfirm);
                    if (e) return "connectionConfirm." + e;
                  }
                }
                if (
                  null != A.channelConnectionConfirm &&
                  A.hasOwnProperty("channelConnectionConfirm")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ro.dcv.setup.ChannelConnectionConfirm.verify(
                      A.channelConnectionConfirm
                    );
                    if (e) return "channelConnectionConfirm." + e;
                  }
                }
                if (null != A.connectionAbort && A.hasOwnProperty("connectionAbort")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ro.dcv.setup.ConnectionAbort.verify(A.connectionAbort);
                    if (e) return "connectionAbort." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ro.dcv.setup.ServerMessage) return A;
                let e = new Ro.dcv.setup.ServerMessage();
                if (null != A.connectionConfirm) {
                  if ("object" != typeof A.connectionConfirm)
                    throw TypeError(".dcv.setup.ServerMessage.connectionConfirm: object expected");
                  e.connectionConfirm = Ro.dcv.setup.ConnectionConfirm.fromObject(
                    A.connectionConfirm
                  );
                }
                if (null != A.channelConnectionConfirm) {
                  if ("object" != typeof A.channelConnectionConfirm)
                    throw TypeError(
                      ".dcv.setup.ServerMessage.channelConnectionConfirm: object expected"
                    );
                  e.channelConnectionConfirm = Ro.dcv.setup.ChannelConnectionConfirm.fromObject(
                    A.channelConnectionConfirm
                  );
                }
                if (null != A.connectionAbort) {
                  if ("object" != typeof A.connectionAbort)
                    throw TypeError(".dcv.setup.ServerMessage.connectionAbort: object expected");
                  e.connectionAbort = Ro.dcv.setup.ConnectionAbort.fromObject(A.connectionAbort);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.connectionConfirm &&
                    A.hasOwnProperty("connectionConfirm") &&
                    ((t.connectionConfirm = Ro.dcv.setup.ConnectionConfirm.toObject(
                      A.connectionConfirm,
                      e
                    )),
                    e.oneofs && (t.msg = "connectionConfirm")),
                  null != A.channelConnectionConfirm &&
                    A.hasOwnProperty("channelConnectionConfirm") &&
                    ((t.channelConnectionConfirm = Ro.dcv.setup.ChannelConnectionConfirm.toObject(
                      A.channelConnectionConfirm,
                      e
                    )),
                    e.oneofs && (t.msg = "channelConnectionConfirm")),
                  null != A.connectionAbort &&
                    A.hasOwnProperty("connectionAbort") &&
                    ((t.connectionAbort = Ro.dcv.setup.ConnectionAbort.toObject(
                      A.connectionAbort,
                      e
                    )),
                    e.oneofs && (t.msg = "connectionAbort")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.setup.ServerMessage";
              }),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  xo = [
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255, 255,
    255, 255, 255, 255, 255, 62, 255, 255, 255, 63, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 255,
    255, 255, 0, 255, 255, 255, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
    19, 20, 21, 22, 23, 24, 25, 255, 255, 255, 255, 255, 255, 26, 27, 28, 29, 30, 31, 32, 33, 34,
    35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51
  ];
function Mo(A) {
  return 1 << A;
}
function Oo(A) {
  if (A >= xo.length) throw new Error("Unable to parse base64 string.");
  const e = xo[A];
  if (255 === e) throw new Error("Unable to parse base64 string.");
  return e;
}
function ko(A) {
  const e = A.length % 4;
  let t = A;
  0 !== e && (t += 3 === e ? "=" : 2 === e ? "==" : "===");
  const i = t.indexOf("=");
  if (-1 !== i && i < t.length - 2) throw new Error("Unable to parse base64 string.");
  let n;
  n = t.endsWith("==") ? 2 : t.endsWith("=") ? 1 : 0;
  const o = t.length,
    r = new Uint8Array((o / 4) * 3);
  let s;
  for (let A = 0, e = 0; A < o; A += 4, e += 3)
    (s =
      (Oo(t.charCodeAt(A)) << 18) |
      (Oo(t.charCodeAt(A + 1)) << 12) |
      (Oo(t.charCodeAt(A + 2)) << 6) |
      Oo(t.charCodeAt(A + 3))),
      (r[e] = s >> 16),
      (r[e + 1] = (s >> 8) & 255),
      (r[e + 2] = 255 & s);
  return r.subarray(0, r.length - n);
}
const No = [
    {
      name: "high444",
      atoms: "AfQAHv/hABtn9AAekZaAoD2moMBAyAAAAwAIAAADAeR4sXUBAAVozgIRkg==",
      packets: [
        "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",
        "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",
        "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",
        "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"
      ]
    },
    {
      name: "high",
      atoms: "AWQAHv/hABpnZAAerLQFAe01BgIGQAAAAwBAAAAPI8WLqAEABmjOAhxAwA==",
      packets: [
        "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",
        "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",
        "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",
        "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"
      ]
    },
    {
      name: "main",
      atoms: "AU1AHv/hABlnTUAe2gKA9pqDAQMgAAADACAAAAeR4sXUAQAFaM8CHIA=",
      packets: [
        "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",
        "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",
        "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",
        "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"
      ]
    },
    {
      name: "baseline",
      atoms: "AULAHv/hABlnQsAe2gKA9pqDAQMgAAADACAAAAeR4sXUAQAFaM4CHIA=",
      packets: [
        "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",
        "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",
        "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",
        "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"
      ]
    }
  ].map((A) => ({ name: A.name, atoms: ko(A.atoms), packets: A.packets.map((A) => ko(A)) })),
  Ko = No.reduce((A, e) => ({ ...A, [e.atoms[1]]: e.name }), {}),
  Lo = 18 === new Uint8Array(new Uint32Array([305419896]).buffer)[0],
  To = [0, 4096, 4718592, 71319568, 3137, 0, 0, 1048576],
  Po = Mo(1),
  Go = Mo(5),
  Ho = Mo(6),
  Yo = Mo(7),
  qo = Mo(8),
  Jo = Mo(9),
  jo = Po | Go | Ho | Yo | qo | Jo,
  Wo = Lo
    ? function (A, e, t) {
        (A[e] = 255 & t), (A[e + 1] = (t >>> 8) & 255);
      }
    : function (A, e, t) {
        (A[e] = (t >>> 8) & 255), (A[e + 1] = 255 & t);
      },
  Vo = Lo
    ? function (A, e, t) {
        (A[e] = 255 & t),
          (A[e + 1] = (t >>> 8) & 255),
          (A[e + 2] = (t >>> 16) & 255),
          (A[e + 3] = (t >>> 24) & 255);
      }
    : function (A, e, t) {
        (A[e] = (t >>> 24) & 255),
          (A[e + 1] = (t >>> 16) & 255),
          (A[e + 2] = (t >>> 8) & 255),
          (A[e + 3] = 255 & t);
      };
class _o {
  constructor(A) {
    (this.buf = A),
      (this.pos = 0),
      (this.end = null !== A ? A.byteLength : null),
      (this.bitsLeft = 8);
  }
  toRbsp() {
    return this.buf.subarray(0, this.pos);
  }
  isByteAligned() {
    return 8 === this.bitsLeft;
  }
  eof() {
    return null !== this.end && this.pos >= this.end;
  }
  skip() {
    this.bitsLeft--, 0 === this.bitsLeft && (this.pos++, (this.bitsLeft = 8));
  }
  skipU(A) {
    for (let e = 0; e < A; e++) this.skip();
  }
  read() {
    let A = 0;
    return (
      this.bitsLeft--,
      this.eof() || (A = (this.buf[this.pos] >>> this.bitsLeft) & 1),
      0 === this.bitsLeft && (this.pos++, (this.bitsLeft = 8)),
      A
    );
  }
  readU(A) {
    let e = 0;
    for (let t = 0; t < A; t++) e |= this.read() << (A - t - 1);
    return e;
  }
  readU8() {
    return 8 !== this.bitsLeft || this.eof() ? this.readU(8) : this.buf[this.pos++];
  }
  readUE() {
    let A = 0,
      e = 0;
    for (; 0 === this.read() && e < 32 && !this.eof(); ) e++;
    return (A = this.readU(e)), (A += (1 << e) - 1), A;
  }
  readSE() {
    const A = this.readUE();
    return 1 & A ? (A + 1) / 2 : -A / 2;
  }
  write(A) {
    this.bitsLeft--,
      this.eof() ||
        (null !== this.buf &&
          ((this.buf[this.pos] &= ~(1 << this.bitsLeft)),
          (this.buf[this.pos] |= (1 & A) << this.bitsLeft))),
      0 === this.bitsLeft && (this.pos++, (this.bitsLeft = 8));
  }
  writeU(A, e) {
    for (let t = 0; t < A; t++) this.write((e >>> (A - t - 1)) & 1);
  }
  writeU8(A) {
    if (8 === this.bitsLeft && !this.eof())
      return null !== this.buf && (this.buf[this.pos] = A), void this.pos++;
    this.writeU(8, A);
  }
  writeUE(A) {
    if (0 === A) this.write(1);
    else {
      const e = (A + 1) & 4294967295,
        t = 32 - Math.clz32(1 | e);
      this.writeU(2 * t - 1, e);
    }
  }
  writeSE(A) {
    const e = A <= 0 ? 2 * -A : 2 * A - 1;
    this.writeUE(e);
  }
  readHrd() {
    const A = {},
      e = this.readUE() + 1;
    (A.bitrateScale = this.readU(4)),
      (A.cpbSizeScale = this.readU(4)),
      (A.bitrateValueMinus1 = new Int32Array(e)),
      (A.cpbSizeValueMinus1 = new Int32Array(e)),
      (A.cbrFlag = new Int32Array(e));
    for (let t = 0; t < e; t++)
      (A.bitrateValueMinus1[t] = this.readUE()),
        (A.cpbSizeValueMinus1[t] = this.readUE()),
        (A.cbrFlag[t] = this.read());
    return (
      (A.initialCpbRemovalDelayLengthMinus1 = this.readU(5)),
      (A.cpbRemovalDelayLengthMinus1 = this.readU(5)),
      (A.dpbOutputDelayLengthMinus1 = this.readU(5)),
      (A.timeOffsetLength = this.readU(5)),
      A
    );
  }
  readVui() {
    const A = {};
    return (
      (A.aspectRatioInfoPresentFlag = this.read()),
      0 !== A.aspectRatioInfoPresentFlag &&
        ((A.aspectRatioIdc = this.readU8()),
        255 === A.aspectRatioIdc &&
          ((A.sarWidth = this.readU(16)), (A.sarHeight = this.readU(16)))),
      (A.overscanInfoPresentFlag = this.read()),
      0 !== A.overscanInfoPresentFlag && (A.overscanAppropriateFlag = this.read()),
      (A.videoSignalTypePresentFlag = this.read()),
      0 !== A.videoSignalTypePresentFlag &&
        ((A.videoFormat = this.readU(3)),
        (A.videoFullRangeFlag = this.read()),
        (A.colourDescriptionPresentFlag = this.read()),
        0 !== A.colourDescriptionPresentFlag &&
          ((A.colourPrimaries = this.readU8()),
          (A.transferCharacteristics = this.readU8()),
          (A.matrixCoefficients = this.readU8()))),
      (A.chromaLocInfoPresentFlag = this.read()),
      0 !== A.chromaLocInfoPresentFlag &&
        ((A.chromaSampleLocTypeTopField = this.readUE()),
        (A.chromaSampleLocTypeBottomField = this.readUE())),
      (A.timingInfoPresentFlag = this.read()),
      0 !== A.timingInfoPresentFlag &&
        ((A.numUnitsInTick = this.readU(32)),
        (A.timeScale = this.readU(32)),
        (A.fixedFrameRateFlag = this.read())),
      0 !== this.read() && (A.hrdNal = this.readHrd()),
      0 !== this.read() && (A.hrdVcl = this.readHrd()),
      (A.hrdNal || A.hrdVcl) && (A.lowDelayHrdFlag = this.read()),
      (A.picStructPresentFlag = this.read()),
      (A.bitstreamRestrictionFlag = this.read()),
      0 !== A.bitstreamRestrictionFlag &&
        ((A.motionVectorsOverPicBoundariesFlag = this.read()),
        (A.maxBytesPerPicDenom = this.readUE()),
        (A.maxBitsPerMbDenom = this.readUE()),
        (A.log2MaxMvLengthHorizontal = this.readUE()),
        (A.log2MaxMvLengthVertical = this.readUE()),
        (A.numReorderFrames = this.readUE()),
        (A.maxDecFrameBuffering = this.readUE())),
      A
    );
  }
  readScalingList(A) {
    let e = {},
      t = 8,
      i = 8;
    (e.matrix = new Int32Array(A)), (e.useDefaultMatrix = 0);
    for (let A = 0; A < e.matrix.length; A++) {
      if (0 !== i) {
        (i = (t + this.readSE() + 256) % 256), (e.useDefaultMatrix = 0 === A && 0 === i);
      }
      (e.matrix[A] = 0 === i ? t : i), (t = e.matrix[A]);
    }
    return e;
  }
  readSps() {
    const A = {};
    if (
      ((A.profileIdc = this.readU8()),
      (A.constraintSetFlags = this.readU(6)),
      this.skipU(2),
      (A.levelIdc = this.readU8()),
      (A.seqParameterSetId = this.readUE()),
      (A.chromaFormatIdc = 1),
      (To[A.profileIdc >>> 5] >>> (31 & A.profileIdc)) & 1 &&
        ((A.chromaFormatIdc = this.readUE()),
        3 === A.chromaFormatIdc && (A.residualColourTransformFlag = this.read()),
        (A.bitDepthLumaMinus8 = this.readUE()),
        (A.bitDepthChromaMinus8 = this.readUE()),
        (A.qpprimeYZeroTransformBypassFlag = this.read()),
        (A.seqScalingMatrixPresentFlag = this.read()),
        0 !== A.seqScalingMatrixPresentFlag))
    ) {
      const e = 3 !== A.chromaFormatIdc ? 8 : 12;
      (A.scalingList = new Array(e)), (A.seqScalingListPresentFlag = new Int32Array(e));
      for (let t = 0; t < e; t++)
        (A.seqScalingListPresentFlag[t] = this.read()),
          0 !== A.seqScalingListPresentFlag[t] &&
            (A.scalingList[t] = t < 6 ? this.readScalingList(16) : this.readScalingList(64));
    }
    if (
      ((A.log2MaxFrameNumMinus4 = this.readUE()),
      (A.picOrderCntType = this.readUE()),
      0 === A.picOrderCntType)
    )
      A.log2MaxPicOrderCntLsbMinus4 = this.readUE();
    else if (1 === A.picOrderCntType) {
      (A.deltaPicOrderAlwaysZeroFlag = this.read()),
        (A.offsetForNonRefPic = this.readSE()),
        (A.offsetForTopToBottomField = this.readSE());
      const e = this.readUE();
      A.offsetForRefFrame = new Int32Array(e);
      for (let t = 0; t < e; t++) A.offsetForRefFrame[t] = this.readSE();
    }
    return (
      (A.numRefFrames = this.readUE()),
      (A.gapsInFrameNumValueAllowedFlag = this.read()),
      (A.picWidthInMbsMinus1 = this.readUE()),
      (A.picHeightInMapUnitsMinus1 = this.readUE()),
      (A.frameMbsOnlyFlag = this.read()),
      0 === A.frameMbsOnlyFlag && (A.mbAdaptiveFrameFieldFlag = this.read()),
      (A.direct8x8InferenceFlag = this.read()),
      (A.frameCroppingFlag = this.read()),
      0 !== A.frameCroppingFlag &&
        ((A.frameCropLeftOffset = this.readUE()),
        (A.frameCropRightOffset = this.readUE()),
        (A.frameCropTopOffset = this.readUE()),
        (A.frameCropBottomOffset = this.readUE())),
      0 !== this.read() && (A.vui = this.readVui()),
      A
    );
  }
  writeHrd(A) {
    const e = A.bitrateValueMinus1.length;
    this.writeUE(e - 1), this.writeU(4, A.bitrateScale), this.writeU(4, A.cpbSizeScale);
    for (let t = 0; t < e; t++)
      this.writeUE(A.bitrateValueMinus1[t]),
        this.writeUE(A.cpbSizeValueMinus1[t]),
        this.write(A.cbrFlag[t]);
    this.writeU(5, A.initialCpbRemovalDelayLengthMinus1),
      this.writeU(5, A.cpbRemovalDelayLengthMinus1),
      this.writeU(5, A.dpbOutputDelayLengthMinus1),
      this.writeU(5, A.timeOffsetLength);
  }
  writeVui(A) {
    this.write(A.aspectRatioInfoPresentFlag),
      0 !== A.aspectRatioInfoPresentFlag &&
        (this.writeU8(A.aspectRatioIdc),
        255 === A.aspectRatioIdc && (this.writeU(16, A.sarWidth), this.writeU(16, A.sarHeight))),
      this.write(A.overscanInfoPresentFlag),
      0 !== A.overscanInfoPresentFlag && this.write(A.overscanAppropriateFlag),
      this.write(A.videoSignalTypePresentFlag),
      0 !== A.videoSignalTypePresentFlag &&
        (this.writeU(3, A.videoFormat),
        this.write(A.videoFullRangeFlag),
        this.write(A.colourDescriptionPresentFlag),
        0 !== A.colourDescriptionPresentFlag &&
          (this.writeU8(A.colourPrimaries),
          this.writeU8(A.transferCharacteristics),
          this.writeU8(A.matrixCoefficients))),
      this.write(A.chromaLocInfoPresentFlag),
      0 !== A.chromaLocInfoPresentFlag &&
        (this.writeUE(A.chromaSampleLocTypeTopField),
        this.writeUE(A.chromaSampleLocTypeBottomField)),
      this.write(A.timingInfoPresentFlag),
      0 !== A.timingInfoPresentFlag &&
        (this.writeU(32, A.numUnitsInTick),
        this.writeU(32, A.timeScale),
        this.write(A.fixedFrameRateFlag)),
      this.write(A.hrdNal ? 1 : 0),
      A.hrdNal && this.writeHrd(A.hrdNal),
      this.write(A.vclNal ? 1 : 0),
      A.vclNal && this.writeHrd(A.vclNal),
      (A.hrdNal || A.vclNal) && this.write(A.lowDelayHrdFlag),
      this.write(A.picStructPresentFlag),
      this.write(A.bitstreamRestrictionFlag),
      0 !== A.bitstreamRestrictionFlag &&
        (this.write(A.motionVectorsOverPicBoundariesFlag),
        this.writeUE(A.maxBytesPerPicDenom),
        this.writeUE(A.maxBitsPerMbDenom),
        this.writeUE(A.log2MaxMvLengthHorizontal),
        this.writeUE(A.log2MaxMvLengthVertical),
        this.writeUE(A.numReorderFrames),
        this.writeUE(A.maxDecFrameBuffering));
  }
  writeScalingList(A) {
    let e = 8,
      t = 8;
    for (let i = 0; i < A.matrix.length; i++)
      0 !== t &&
        ((t = A.matrix[i]), 0 !== A.useDefaultMatrix && (t = 0), this.writeSE((t - e) % 256)),
        (e = A.matrix[i]);
  }
  writeSps(A) {
    if (
      (this.writeU8(A.profileIdc),
      this.writeU(6, A.constraintSetFlags),
      this.writeU(2, 0),
      this.writeU8(A.levelIdc),
      this.writeUE(A.seqParameterSetId),
      (To[A.profileIdc >>> 5] >>> (31 & A.profileIdc)) & 1 &&
        (this.writeUE(A.chromaFormatIdc),
        3 === A.chromaFormatIdc && this.write(A.residualColourTransformFlag),
        this.writeUE(A.bitDepthLumaMinus8),
        this.writeUE(A.bitDepthChromaMinus8),
        this.write(A.qpprimeYZeroTransformBypassFlag),
        this.write(A.seqScalingMatrixPresentFlag),
        0 !== A.seqScalingMatrixPresentFlag))
    ) {
      const e = 3 !== A.chromaFormatIdc ? 8 : 12;
      for (let t = 0; t < e; t++)
        this.write(A.seqScalingListPresentFlag[t]),
          0 !== A.seqScalingListPresentFlag[t] && this.writeScalingList(A.scalingList[t]);
    }
    if (
      (this.writeUE(A.log2MaxFrameNumMinus4),
      this.writeUE(A.picOrderCntType),
      0 === A.picOrderCntType)
    )
      this.writeUE(A.log2MaxPicOrderCntLsbMinus4);
    else if (1 === A.picOrderCntType) {
      this.write(A.deltaPicOrderAlwaysZeroFlag),
        this.writeSE(A.offsetForNonRefPic),
        this.writeSE(A.offsetForTopToBottomField);
      const e = A.offsetForRefFrame.length;
      this.writeUE(e);
      for (let t = 0; t < e; t++) this.writeSE(A.offsetForRefFrame[t]);
    }
    for (
      this.writeUE(A.numRefFrames),
        this.write(A.gapsInFrameNumValueAllowedFlag),
        this.writeUE(A.picWidthInMbsMinus1),
        this.writeUE(A.picHeightInMapUnitsMinus1),
        this.write(A.frameMbsOnlyFlag),
        0 === A.frameMbsOnlyFlag && this.write(A.mbAdaptiveFrameFieldFlag),
        this.write(A.direct8x8InferenceFlag),
        this.write(A.frameCroppingFlag),
        0 !== A.frameCroppingFlag &&
          (this.writeUE(A.frameCropLeftOffset),
          this.writeUE(A.frameCropRightOffset),
          this.writeUE(A.frameCropTopOffset),
          this.writeUE(A.frameCropBottomOffset)),
        this.write(A.vui ? 1 : 0),
        A.vui && this.writeVui(A.vui),
        this.writeU(1, 1);
      !this.isByteAligned();

    )
      this.writeU(1, 0);
  }
  fitToSps(A) {
    this.writeSps(A),
      (this.buf = new Uint8Array(this.pos)),
      (this.pos = 0),
      (this.end = this.buf.byteLength),
      (this.bitsLeft = 8);
  }
}
class Xo {
  constructor(A) {
    (this.data = new Uint8Array(A)), (this.pos = 0), (this.capacity = this.data.byteLength);
  }
  reset() {
    this.pos = 0;
  }
  push(A) {
    this.pos += A;
  }
  trimFrom(A) {
    (this.data = this.data.subarray(A)), (this.capacity -= A);
  }
  searchStart() {
    const A = this.data,
      e = A.subarray(0, this.capacity - 3);
    for (let t = e.indexOf(0); -1 !== t; t = e.indexOf(0, t + 1))
      if (0 === A[t + 1] && 1 === A[t + 2]) return t + 3;
    return this.capacity;
  }
  searchEnd() {
    const A = this.data,
      e = A.subarray(0, this.capacity - 2);
    for (let t = e.indexOf(0); -1 !== t; t = e.indexOf(0, t + 1))
      if (0 === A[t + 1] && A[t + 2] <= 1) return t;
    return this.capacity;
  }
}
class zo {
  constructor(A) {
    (this.pos = 0), (this.data = null), (this.type = 0), (this.log = A);
  }
  clone() {
    const A = new zo(this.log);
    return (A.pos = this.pos), (A.data = this.data), (A.type = this.type), A;
  }
  static fromHeaderAndRbsp(A, e) {
    let t,
      i = 1,
      n = 0,
      o = A.header,
      r = A.rbsp,
      s = new Uint8Array(1 + ((3 * r.byteLength + 1) >>> 1)),
      a = new zo(e);
    for (s[0] = o, t = 0; t < r.byteLength; )
      2 !== n || 252 & r[t]
        ? ((s[i++] = r[t]), 0 === r[t] ? n++ : (n = 0), t++)
        : ((s[i++] = 3), (n = 0));
    return (a.pos = 0), (a.type = Mo(31 & o)), (a.data = s.subarray(0, i)), a;
  }
  toHeaderAndRbsp() {
    let A,
      e = 0,
      t = 0,
      i = this.data.byteLength,
      n = i - 1,
      o = new Uint8Array(n),
      r = this.data[0];
    for (A = 1; A < i; A++) {
      if (2 === t) {
        if (this.data[A] < 3) return null;
        if (3 === this.data[A]) {
          if (A < n && this.data[A + 1] > 3) return null;
          if (A === n) break;
          A++, (t = 0);
        }
      }
      (o[e++] = this.data[A]), 0 === this.data[A] ? t++ : (t = 0);
    }
    return { header: r, rbsp: o.subarray(0, e) };
  }
  find(A, e) {
    let t,
      i,
      n,
      o,
      r = e.pos;
    return (
      A.trimFrom(A.searchStart()),
      0 !== A.capacity &&
        ((t = A.data[0]),
        (this.type = Mo(31 & t)),
        this.type & jo
          ? ((i = this.type & (Yo | qo) ? 0 : 4),
            e.push(i),
            (o = A.searchEnd()),
            e.data.set(A.data.subarray(0, o), e.pos),
            (e.pos += o),
            A.trimFrom(o),
            (n = e.pos - r),
            i > 0 && Vo(e.data, r, n - i),
            (this.pos = r),
            (this.data = e.data.subarray(r, r + n)),
            !0)
          : (A.trimFrom(A.searchEnd()), !0))
    );
  }
  patch(A) {
    let e,
      t,
      i,
      n,
      o = this.toHeaderAndRbsp(),
      r = 1;
    if (this.type !== Yo) return this.log.error("Not a Sequence Parameter Set (SPS)"), null;
    if (null === o) return this.log.error("Failed to parse Sequence Parameter Set (SPS)"), null;
    if (
      ((e = o.rbsp),
      (t = new _o(e)),
      (i = t.readSps()),
      this.log.debug(`Detected h264 profile: '${$o(i.profileIdc) || "unknown"}'`),
      A.indexOf("subsamp_444") > -1)
    )
      r = 3;
    else if (-1 === A.indexOf("subsamp_420"))
      return this.log.error("Failed to infer sampling from capabities"), null;
    return i.chromaFormatIdc !== r
      ? (this.log.error(
          `chromaFormatIdc (${i.chromaFormatIdc}) is not equal to inferred format (${r})`
        ),
        null)
      : (i.vui ||
          (this.log.debug("No Video Usability Information (VUI) specified. Adding default"),
          (i.vui = {
            aspectRatioInfoPresentFlag: 0,
            overscanInfoPresentFlag: 0,
            videoSignalTypePresentFlag: 0,
            chromaLocInfoPresentFlag: 0,
            timingInfoPresentFlag: 0,
            picStructPresentFlag: 0,
            bitstreamRestrictionFlag: 0
          })),
        0 === i.vui.bitstreamRestrictionFlag
          ? (this.log.debug("No bitstream restriction flag specified. Adding default"),
            (i.vui.bitstreamRestrictionFlag = 1),
            (i.vui.motionVectorsOverPicBoundariesFlag = 0),
            (i.vui.maxBytesPerPicDenom = 0),
            (i.vui.maxBitsPerMbDenom = 0),
            (i.vui.log2MaxMvLengthHorizontal = 0),
            (i.vui.log2MaxMvLengthVertical = 0),
            (i.vui.numReorderFrames = 0),
            (i.vui.maxDecFrameBuffering = i.numRefFrames))
          : (0 !== i.vui.numReorderFrames &&
              (this.log.debug(`Overriding numReorderFrames (${i.vui.numReorderFrames}) with 0`),
              (i.vui.numReorderFrames = 0)),
            i.vui.maxDecFrameBuffering !== i.numRefFrames &&
              (this.log.debug(
                `Overriding maxDecFrameBuffering (${i.vui.maxDecFrameBuffering}) with ${i.numRefFrames}`
              ),
              (i.vui.maxDecFrameBuffering = i.numRefFrames))),
        (i.vui.videoSignalTypePresentFlag = 1),
        (i.vui.videoFormat = 5),
        (i.vui.videoFullRangeFlag = A.indexOf("colorrange_full") > -1 ? 1 : 0),
        (i.vui.colourDescriptionPresentFlag = 1),
        A.indexOf("colorspace_yuv_rec601") > -1
          ? ((i.vui.transferCharacteristics = 6),
            (i.vui.colourPrimaries = 6),
            (i.vui.matrixCoefficients = 6))
          : A.indexOf("colorspace_yuv_rec709") > -1
            ? ((i.vui.transferCharacteristics = 1),
              (i.vui.colourPrimaries = 1),
              (i.vui.matrixCoefficients = 1))
            : ((i.vui.transferCharacteristics = 2),
              (i.vui.colourPrimaries = 2),
              (i.vui.matrixCoefficients = 2)),
        (n = new _o(null)),
        n.fitToSps(i),
        n.writeSps(i),
        (o.rbsp = n.toRbsp()),
        zo.fromHeaderAndRbsp(o, this.log));
  }
}
class Zo {
  constructor(A) {
    (this.avcc = null), (this.log = A || Q("h264parser"));
  }
  parse(A) {
    const e = new Xo(A);
    let t = null,
      i = null,
      n = null,
      o = null,
      r = !1,
      s = 0;
    null === this.avcc || this.avcc.capacity < 128 + e.capacity
      ? (this.avcc = new Xo(128 + e.capacity))
      : this.avcc.reset();
    let a = new zo(this.log);
    for (; a.find(e, this.avcc); ) {
      switch (a.type) {
        case Yo:
          (t = a.clone()), (r = !0);
          break;
        case qo:
          (i = a.clone()), (r = !0);
          break;
        case Ho:
        case Jo:
          break;
        case Po:
        case Go:
          (n = n || a.clone()), (o = a.clone());
          break;
        default:
          this.log.warn(`Skipping unsupported unit ${a.type}`);
          continue;
      }
      if ((s++, s >= 128)) {
        this.log.warn("Frame will be truncated. Not enough processing space");
        break;
      }
    }
    if (null === n) return null;
    const g = this.avcc.data.subarray(n.pos, o.pos + o.data.byteLength);
    return [r ? [t, i] : null, n.type === Go, g];
  }
}
function $o(A) {
  return Ko[A];
}
function Ar(A) {
  return 244 === A ? 100 : 0;
}
var er = { exports: {} };
const tr = e(
    (er.exports = (function (A) {
      var e = {};
      function t(i) {
        if (e[i]) return e[i].exports;
        var n = (e[i] = { i: i, l: !1, exports: {} });
        return A[i].call(n.exports, n, n.exports, t), (n.l = !0), n.exports;
      }
      return (
        (t.m = A),
        (t.c = e),
        (t.d = function (A, e, i) {
          t.o(A, e) || Object.defineProperty(A, e, { enumerable: !0, get: i });
        }),
        (t.r = function (A) {
          "undefined" != typeof Symbol &&
            Symbol.toStringTag &&
            Object.defineProperty(A, Symbol.toStringTag, { value: "Module" }),
            Object.defineProperty(A, "__esModule", { value: !0 });
        }),
        (t.t = function (A, e) {
          if ((1 & e && (A = t(A)), 8 & e)) return A;
          if (4 & e && "object" == typeof A && A && A.__esModule) return A;
          var i = Object.create(null);
          if (
            (t.r(i),
            Object.defineProperty(i, "default", { enumerable: !0, value: A }),
            2 & e && "string" != typeof A)
          )
            for (var n in A)
              t.d(
                i,
                n,
                function (e) {
                  return A[e];
                }.bind(null, n)
              );
          return i;
        }),
        (t.n = function (A) {
          var e =
            A && A.__esModule
              ? function () {
                  return A.default;
                }
              : function () {
                  return A;
                };
          return t.d(e, "a", e), e;
        }),
        (t.o = function (A, e) {
          return Object.prototype.hasOwnProperty.call(A, e);
        }),
        (t.p = ""),
        t((t.s = 90))
      );
    })({
      17: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i = t(18),
          n = (function () {
            function A() {}
            return (
              (A.getFirstMatch = function (A, e) {
                var t = e.match(A);
                return (t && t.length > 0 && t[1]) || "";
              }),
              (A.getSecondMatch = function (A, e) {
                var t = e.match(A);
                return (t && t.length > 1 && t[2]) || "";
              }),
              (A.matchAndReturnConst = function (A, e, t) {
                if (A.test(e)) return t;
              }),
              (A.getWindowsVersionName = function (A) {
                switch (A) {
                  case "NT":
                    return "NT";
                  case "XP":
                  case "NT 5.1":
                    return "XP";
                  case "NT 5.0":
                    return "2000";
                  case "NT 5.2":
                    return "2003";
                  case "NT 6.0":
                    return "Vista";
                  case "NT 6.1":
                    return "7";
                  case "NT 6.2":
                    return "8";
                  case "NT 6.3":
                    return "8.1";
                  case "NT 10.0":
                    return "10";
                  default:
                    return;
                }
              }),
              (A.getMacOSVersionName = function (A) {
                var e = A.split(".")
                  .splice(0, 2)
                  .map(function (A) {
                    return parseInt(A, 10) || 0;
                  });
                if ((e.push(0), 10 === e[0]))
                  switch (e[1]) {
                    case 5:
                      return "Leopard";
                    case 6:
                      return "Snow Leopard";
                    case 7:
                      return "Lion";
                    case 8:
                      return "Mountain Lion";
                    case 9:
                      return "Mavericks";
                    case 10:
                      return "Yosemite";
                    case 11:
                      return "El Capitan";
                    case 12:
                      return "Sierra";
                    case 13:
                      return "High Sierra";
                    case 14:
                      return "Mojave";
                    case 15:
                      return "Catalina";
                    default:
                      return;
                  }
              }),
              (A.getAndroidVersionName = function (A) {
                var e = A.split(".")
                  .splice(0, 2)
                  .map(function (A) {
                    return parseInt(A, 10) || 0;
                  });
                if ((e.push(0), !(1 === e[0] && e[1] < 5)))
                  return 1 === e[0] && e[1] < 6
                    ? "Cupcake"
                    : 1 === e[0] && e[1] >= 6
                      ? "Donut"
                      : 2 === e[0] && e[1] < 2
                        ? "Eclair"
                        : 2 === e[0] && 2 === e[1]
                          ? "Froyo"
                          : 2 === e[0] && e[1] > 2
                            ? "Gingerbread"
                            : 3 === e[0]
                              ? "Honeycomb"
                              : 4 === e[0] && e[1] < 1
                                ? "Ice Cream Sandwich"
                                : 4 === e[0] && e[1] < 4
                                  ? "Jelly Bean"
                                  : 4 === e[0] && e[1] >= 4
                                    ? "KitKat"
                                    : 5 === e[0]
                                      ? "Lollipop"
                                      : 6 === e[0]
                                        ? "Marshmallow"
                                        : 7 === e[0]
                                          ? "Nougat"
                                          : 8 === e[0]
                                            ? "Oreo"
                                            : 9 === e[0]
                                              ? "Pie"
                                              : void 0;
              }),
              (A.getVersionPrecision = function (A) {
                return A.split(".").length;
              }),
              (A.compareVersions = function (e, t, i) {
                void 0 === i && (i = !1);
                var n = A.getVersionPrecision(e),
                  o = A.getVersionPrecision(t),
                  r = Math.max(n, o),
                  s = 0,
                  a = A.map([e, t], function (e) {
                    var t = r - A.getVersionPrecision(e),
                      i = e + new Array(t + 1).join(".0");
                    return A.map(i.split("."), function (A) {
                      return new Array(20 - A.length).join("0") + A;
                    }).reverse();
                  });
                for (i && (s = r - Math.min(n, o)), r -= 1; r >= s; ) {
                  if (a[0][r] > a[1][r]) return 1;
                  if (a[0][r] === a[1][r]) {
                    if (r === s) return 0;
                    r -= 1;
                  } else if (a[0][r] < a[1][r]) return -1;
                }
              }),
              (A.map = function (A, e) {
                var t,
                  i = [];
                if (Array.prototype.map) return Array.prototype.map.call(A, e);
                for (t = 0; t < A.length; t += 1) i.push(e(A[t]));
                return i;
              }),
              (A.find = function (A, e) {
                var t, i;
                if (Array.prototype.find) return Array.prototype.find.call(A, e);
                for (t = 0, i = A.length; t < i; t += 1) {
                  var n = A[t];
                  if (e(n, t)) return n;
                }
              }),
              (A.assign = function (A) {
                for (
                  var e, t, i = A, n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1;
                  r < n;
                  r++
                )
                  o[r - 1] = arguments[r];
                if (Object.assign) return Object.assign.apply(Object, [A].concat(o));
                var s = function () {
                  var A = o[e];
                  "object" == typeof A &&
                    null !== A &&
                    Object.keys(A).forEach(function (e) {
                      i[e] = A[e];
                    });
                };
                for (e = 0, t = o.length; e < t; e += 1) s();
                return A;
              }),
              (A.getBrowserAlias = function (A) {
                return i.BROWSER_ALIASES_MAP[A];
              }),
              (A.getBrowserTypeByAlias = function (A) {
                return i.BROWSER_MAP[A] || "";
              }),
              A
            );
          })();
        (e.default = n), (A.exports = e.default);
      },
      18: function (A, e, t) {
        (e.__esModule = !0),
          (e.ENGINE_MAP =
            e.OS_MAP =
            e.PLATFORMS_MAP =
            e.BROWSER_MAP =
            e.BROWSER_ALIASES_MAP =
              void 0),
          (e.BROWSER_ALIASES_MAP = {
            "Amazon Silk": "amazon_silk",
            "Android Browser": "android",
            Bada: "bada",
            BlackBerry: "blackberry",
            Chrome: "chrome",
            Chromium: "chromium",
            Electron: "electron",
            Epiphany: "epiphany",
            Firefox: "firefox",
            Focus: "focus",
            Generic: "generic",
            "Google Search": "google_search",
            Googlebot: "googlebot",
            "Internet Explorer": "ie",
            "K-Meleon": "k_meleon",
            Maxthon: "maxthon",
            "Microsoft Edge": "edge",
            "MZ Browser": "mz",
            "NAVER Whale Browser": "naver",
            Opera: "opera",
            "Opera Coast": "opera_coast",
            PhantomJS: "phantomjs",
            Puffin: "puffin",
            QupZilla: "qupzilla",
            QQ: "qq",
            QQLite: "qqlite",
            Safari: "safari",
            Sailfish: "sailfish",
            "Samsung Internet for Android": "samsung_internet",
            SeaMonkey: "seamonkey",
            Sleipnir: "sleipnir",
            Swing: "swing",
            Tizen: "tizen",
            "UC Browser": "uc",
            Vivaldi: "vivaldi",
            "WebOS Browser": "webos",
            WeChat: "wechat",
            "Yandex Browser": "yandex",
            Roku: "roku"
          }),
          (e.BROWSER_MAP = {
            amazon_silk: "Amazon Silk",
            android: "Android Browser",
            bada: "Bada",
            blackberry: "BlackBerry",
            chrome: "Chrome",
            chromium: "Chromium",
            electron: "Electron",
            epiphany: "Epiphany",
            firefox: "Firefox",
            focus: "Focus",
            generic: "Generic",
            googlebot: "Googlebot",
            google_search: "Google Search",
            ie: "Internet Explorer",
            k_meleon: "K-Meleon",
            maxthon: "Maxthon",
            edge: "Microsoft Edge",
            mz: "MZ Browser",
            naver: "NAVER Whale Browser",
            opera: "Opera",
            opera_coast: "Opera Coast",
            phantomjs: "PhantomJS",
            puffin: "Puffin",
            qupzilla: "QupZilla",
            qq: "QQ Browser",
            qqlite: "QQ Browser Lite",
            safari: "Safari",
            sailfish: "Sailfish",
            samsung_internet: "Samsung Internet for Android",
            seamonkey: "SeaMonkey",
            sleipnir: "Sleipnir",
            swing: "Swing",
            tizen: "Tizen",
            uc: "UC Browser",
            vivaldi: "Vivaldi",
            webos: "WebOS Browser",
            wechat: "WeChat",
            yandex: "Yandex Browser"
          }),
          (e.PLATFORMS_MAP = { tablet: "tablet", mobile: "mobile", desktop: "desktop", tv: "tv" }),
          (e.OS_MAP = {
            WindowsPhone: "Windows Phone",
            Windows: "Windows",
            MacOS: "macOS",
            iOS: "iOS",
            Android: "Android",
            WebOS: "WebOS",
            BlackBerry: "BlackBerry",
            Bada: "Bada",
            Tizen: "Tizen",
            Linux: "Linux",
            ChromeOS: "Chrome OS",
            PlayStation4: "PlayStation 4",
            Roku: "Roku"
          }),
          (e.ENGINE_MAP = {
            EdgeHTML: "EdgeHTML",
            Blink: "Blink",
            Trident: "Trident",
            Presto: "Presto",
            Gecko: "Gecko",
            WebKit: "WebKit"
          });
      },
      90: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i,
          n = (i = t(91)) && i.__esModule ? i : { default: i },
          o = t(18);
        function r(A, e) {
          for (var t = 0; t < e.length; t++) {
            var i = e[t];
            (i.enumerable = i.enumerable || !1),
              (i.configurable = !0),
              "value" in i && (i.writable = !0),
              Object.defineProperty(A, i.key, i);
          }
        }
        var s = (function () {
          function A() {}
          var e, t, i;
          return (
            (A.getParser = function (A, e) {
              if ((void 0 === e && (e = !1), "string" != typeof A))
                throw new Error("UserAgent should be a string");
              return new n.default(A, e);
            }),
            (A.parse = function (A) {
              return new n.default(A).getResult();
            }),
            (e = A),
            (i = [
              {
                key: "BROWSER_MAP",
                get: function () {
                  return o.BROWSER_MAP;
                }
              },
              {
                key: "ENGINE_MAP",
                get: function () {
                  return o.ENGINE_MAP;
                }
              },
              {
                key: "OS_MAP",
                get: function () {
                  return o.OS_MAP;
                }
              },
              {
                key: "PLATFORMS_MAP",
                get: function () {
                  return o.PLATFORMS_MAP;
                }
              }
            ]),
            (t = null) && r(e.prototype, t),
            i && r(e, i),
            A
          );
        })();
        (e.default = s), (A.exports = e.default);
      },
      91: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i = a(t(92)),
          n = a(t(93)),
          o = a(t(94)),
          r = a(t(95)),
          s = a(t(17));
        function a(A) {
          return A && A.__esModule ? A : { default: A };
        }
        var g = (function () {
          function A(A, e) {
            if ((void 0 === e && (e = !1), null == A || "" === A))
              throw new Error("UserAgent parameter can't be empty");
            (this._ua = A), (this.parsedResult = {}), !0 !== e && this.parse();
          }
          var e = A.prototype;
          return (
            (e.getUA = function () {
              return this._ua;
            }),
            (e.test = function (A) {
              return A.test(this._ua);
            }),
            (e.parseBrowser = function () {
              var A = this;
              this.parsedResult.browser = {};
              var e = s.default.find(i.default, function (e) {
                if ("function" == typeof e.test) return e.test(A);
                if (e.test instanceof Array)
                  return e.test.some(function (e) {
                    return A.test(e);
                  });
                throw new Error("Browser's test function is not valid");
              });
              return (
                e && (this.parsedResult.browser = e.describe(this.getUA())),
                this.parsedResult.browser
              );
            }),
            (e.getBrowser = function () {
              return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
            }),
            (e.getBrowserName = function (A) {
              return A
                ? String(this.getBrowser().name).toLowerCase() || ""
                : this.getBrowser().name || "";
            }),
            (e.getBrowserVersion = function () {
              return this.getBrowser().version;
            }),
            (e.getOS = function () {
              return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
            }),
            (e.parseOS = function () {
              var A = this;
              this.parsedResult.os = {};
              var e = s.default.find(n.default, function (e) {
                if ("function" == typeof e.test) return e.test(A);
                if (e.test instanceof Array)
                  return e.test.some(function (e) {
                    return A.test(e);
                  });
                throw new Error("Browser's test function is not valid");
              });
              return e && (this.parsedResult.os = e.describe(this.getUA())), this.parsedResult.os;
            }),
            (e.getOSName = function (A) {
              var e = this.getOS().name;
              return A ? String(e).toLowerCase() || "" : e || "";
            }),
            (e.getOSVersion = function () {
              return this.getOS().version;
            }),
            (e.getPlatform = function () {
              return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
            }),
            (e.getPlatformType = function (A) {
              void 0 === A && (A = !1);
              var e = this.getPlatform().type;
              return A ? String(e).toLowerCase() || "" : e || "";
            }),
            (e.parsePlatform = function () {
              var A = this;
              this.parsedResult.platform = {};
              var e = s.default.find(o.default, function (e) {
                if ("function" == typeof e.test) return e.test(A);
                if (e.test instanceof Array)
                  return e.test.some(function (e) {
                    return A.test(e);
                  });
                throw new Error("Browser's test function is not valid");
              });
              return (
                e && (this.parsedResult.platform = e.describe(this.getUA())),
                this.parsedResult.platform
              );
            }),
            (e.getEngine = function () {
              return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
            }),
            (e.getEngineName = function (A) {
              return A
                ? String(this.getEngine().name).toLowerCase() || ""
                : this.getEngine().name || "";
            }),
            (e.parseEngine = function () {
              var A = this;
              this.parsedResult.engine = {};
              var e = s.default.find(r.default, function (e) {
                if ("function" == typeof e.test) return e.test(A);
                if (e.test instanceof Array)
                  return e.test.some(function (e) {
                    return A.test(e);
                  });
                throw new Error("Browser's test function is not valid");
              });
              return (
                e && (this.parsedResult.engine = e.describe(this.getUA())), this.parsedResult.engine
              );
            }),
            (e.parse = function () {
              return (
                this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this
              );
            }),
            (e.getResult = function () {
              return s.default.assign({}, this.parsedResult);
            }),
            (e.satisfies = function (A) {
              var e = this,
                t = {},
                i = 0,
                n = {},
                o = 0;
              if (
                (Object.keys(A).forEach(function (e) {
                  var r = A[e];
                  "string" == typeof r
                    ? ((n[e] = r), (o += 1))
                    : "object" == typeof r && ((t[e] = r), (i += 1));
                }),
                i > 0)
              ) {
                var r = Object.keys(t),
                  a = s.default.find(r, function (A) {
                    return e.isOS(A);
                  });
                if (a) {
                  var g = this.satisfies(t[a]);
                  if (void 0 !== g) return g;
                }
                var c = s.default.find(r, function (A) {
                  return e.isPlatform(A);
                });
                if (c) {
                  var I = this.satisfies(t[c]);
                  if (void 0 !== I) return I;
                }
              }
              if (o > 0) {
                var l = Object.keys(n),
                  d = s.default.find(l, function (A) {
                    return e.isBrowser(A, !0);
                  });
                if (void 0 !== d) return this.compareVersion(n[d]);
              }
            }),
            (e.isBrowser = function (A, e) {
              void 0 === e && (e = !1);
              var t = this.getBrowserName().toLowerCase(),
                i = A.toLowerCase(),
                n = s.default.getBrowserTypeByAlias(i);
              return e && n && (i = n.toLowerCase()), i === t;
            }),
            (e.compareVersion = function (A) {
              var e = [0],
                t = A,
                i = !1,
                n = this.getBrowserVersion();
              if ("string" == typeof n)
                return (
                  ">" === A[0] || "<" === A[0]
                    ? ((t = A.substr(1)),
                      "=" === A[1] ? ((i = !0), (t = A.substr(2))) : (e = []),
                      ">" === A[0] ? e.push(1) : e.push(-1))
                    : "=" === A[0]
                      ? (t = A.substr(1))
                      : "~" === A[0] && ((i = !0), (t = A.substr(1))),
                  e.indexOf(s.default.compareVersions(n, t, i)) > -1
                );
            }),
            (e.isOS = function (A) {
              return this.getOSName(!0) === String(A).toLowerCase();
            }),
            (e.isPlatform = function (A) {
              return this.getPlatformType(!0) === String(A).toLowerCase();
            }),
            (e.isEngine = function (A) {
              return this.getEngineName(!0) === String(A).toLowerCase();
            }),
            (e.is = function (A, e) {
              return (
                void 0 === e && (e = !1), this.isBrowser(A, e) || this.isOS(A) || this.isPlatform(A)
              );
            }),
            (e.some = function (A) {
              var e = this;
              return (
                void 0 === A && (A = []),
                A.some(function (A) {
                  return e.is(A);
                })
              );
            }),
            A
          );
        })();
        (e.default = g), (A.exports = e.default);
      },
      92: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i,
          n = (i = t(17)) && i.__esModule ? i : { default: i },
          o = /version\/(\d+(\.?_?\d+)+)/i,
          r = [
            {
              test: [/googlebot/i],
              describe: function (A) {
                var e = { name: "Googlebot" },
                  t =
                    n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/opera/i],
              describe: function (A) {
                var e = { name: "Opera" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/opr\/|opios/i],
              describe: function (A) {
                var e = { name: "Opera" },
                  t =
                    n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/SamsungBrowser/i],
              describe: function (A) {
                var e = { name: "Samsung Internet for Android" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/Whale/i],
              describe: function (A) {
                var e = { name: "NAVER Whale Browser" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/MZBrowser/i],
              describe: function (A) {
                var e = { name: "MZ Browser" },
                  t =
                    n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/focus/i],
              describe: function (A) {
                var e = { name: "Focus" },
                  t =
                    n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/swing/i],
              describe: function (A) {
                var e = { name: "Swing" },
                  t =
                    n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/coast/i],
              describe: function (A) {
                var e = { name: "Opera Coast" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/opt\/\d+(?:.?_?\d+)+/i],
              describe: function (A) {
                var e = { name: "Opera Touch" },
                  t =
                    n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/yabrowser/i],
              describe: function (A) {
                var e = { name: "Yandex Browser" },
                  t =
                    n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/ucbrowser/i],
              describe: function (A) {
                var e = { name: "UC Browser" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/Maxthon|mxios/i],
              describe: function (A) {
                var e = { name: "Maxthon" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/epiphany/i],
              describe: function (A) {
                var e = { name: "Epiphany" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/puffin/i],
              describe: function (A) {
                var e = { name: "Puffin" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/sleipnir/i],
              describe: function (A) {
                var e = { name: "Sleipnir" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/k-meleon/i],
              describe: function (A) {
                var e = { name: "K-Meleon" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/micromessenger/i],
              describe: function (A) {
                var e = { name: "WeChat" },
                  t =
                    n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/qqbrowser/i],
              describe: function (A) {
                var e = { name: /qqbrowserlite/i.test(A) ? "QQ Browser Lite" : "QQ Browser" },
                  t =
                    n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/msie|trident/i],
              describe: function (A) {
                var e = { name: "Internet Explorer" },
                  t = n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/\sedg\//i],
              describe: function (A) {
                var e = { name: "Microsoft Edge" },
                  t = n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/edg([ea]|ios)/i],
              describe: function (A) {
                var e = { name: "Microsoft Edge" },
                  t = n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/vivaldi/i],
              describe: function (A) {
                var e = { name: "Vivaldi" },
                  t = n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/seamonkey/i],
              describe: function (A) {
                var e = { name: "SeaMonkey" },
                  t = n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/sailfish/i],
              describe: function (A) {
                var e = { name: "Sailfish" },
                  t = n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/silk/i],
              describe: function (A) {
                var e = { name: "Amazon Silk" },
                  t = n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/phantom/i],
              describe: function (A) {
                var e = { name: "PhantomJS" },
                  t = n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/slimerjs/i],
              describe: function (A) {
                var e = { name: "SlimerJS" },
                  t = n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
              describe: function (A) {
                var e = { name: "BlackBerry" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/(web|hpw)[o0]s/i],
              describe: function (A) {
                var e = { name: "WebOS Browser" },
                  t =
                    n.default.getFirstMatch(o, A) ||
                    n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/bada/i],
              describe: function (A) {
                var e = { name: "Bada" },
                  t = n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/tizen/i],
              describe: function (A) {
                var e = { name: "Tizen" },
                  t =
                    n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/qupzilla/i],
              describe: function (A) {
                var e = { name: "QupZilla" },
                  t =
                    n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/firefox|iceweasel|fxios/i],
              describe: function (A) {
                var e = { name: "Firefox" },
                  t = n.default.getFirstMatch(
                    /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,
                    A
                  );
                return t && (e.version = t), e;
              }
            },
            {
              test: [/electron/i],
              describe: function (A) {
                var e = { name: "Electron" },
                  t = n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/MiuiBrowser/i],
              describe: function (A) {
                var e = { name: "Miui" },
                  t = n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/chromium/i],
              describe: function (A) {
                var e = { name: "Chromium" },
                  t =
                    n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, A) ||
                    n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/chrome|crios|crmo/i],
              describe: function (A) {
                var e = { name: "Chrome" },
                  t = n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/GSA/i],
              describe: function (A) {
                var e = { name: "Google Search" },
                  t = n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: function (A) {
                var e = !A.test(/like android/i),
                  t = A.test(/android/i);
                return e && t;
              },
              describe: function (A) {
                var e = { name: "Android Browser" },
                  t = n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/playstation 4/i],
              describe: function (A) {
                var e = { name: "PlayStation 4" },
                  t = n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/safari|applewebkit/i],
              describe: function (A) {
                var e = { name: "Safari" },
                  t = n.default.getFirstMatch(o, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/.*/i],
              describe: function (A) {
                var e = -1 !== A.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                return {
                  name: n.default.getFirstMatch(e, A),
                  version: n.default.getSecondMatch(e, A)
                };
              }
            }
          ];
        (e.default = r), (A.exports = e.default);
      },
      93: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i,
          n = (i = t(17)) && i.__esModule ? i : { default: i },
          o = t(18),
          r = [
            {
              test: [/Roku\/DVP/],
              describe: function (A) {
                var e = n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, A);
                return { name: o.OS_MAP.Roku, version: e };
              }
            },
            {
              test: [/windows phone/i],
              describe: function (A) {
                var e = n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, A);
                return { name: o.OS_MAP.WindowsPhone, version: e };
              }
            },
            {
              test: [/windows /i],
              describe: function (A) {
                var e = n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, A),
                  t = n.default.getWindowsVersionName(e);
                return { name: o.OS_MAP.Windows, version: e, versionName: t };
              }
            },
            {
              test: [/Macintosh(.*?) FxiOS(.*?)\//],
              describe: function (A) {
                var e = { name: o.OS_MAP.iOS },
                  t = n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/macintosh/i],
              describe: function (A) {
                var e = n.default
                    .getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, A)
                    .replace(/[_\s]/g, "."),
                  t = n.default.getMacOSVersionName(e),
                  i = { name: o.OS_MAP.MacOS, version: e };
                return t && (i.versionName = t), i;
              }
            },
            {
              test: [/(ipod|iphone|ipad)/i],
              describe: function (A) {
                var e = n.default
                  .getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, A)
                  .replace(/[_\s]/g, ".");
                return { name: o.OS_MAP.iOS, version: e };
              }
            },
            {
              test: function (A) {
                var e = !A.test(/like android/i),
                  t = A.test(/android/i);
                return e && t;
              },
              describe: function (A) {
                var e = n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, A),
                  t = n.default.getAndroidVersionName(e),
                  i = { name: o.OS_MAP.Android, version: e };
                return t && (i.versionName = t), i;
              }
            },
            {
              test: [/(web|hpw)[o0]s/i],
              describe: function (A) {
                var e = n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, A),
                  t = { name: o.OS_MAP.WebOS };
                return e && e.length && (t.version = e), t;
              }
            },
            {
              test: [/blackberry|\bbb\d+/i, /rim\stablet/i],
              describe: function (A) {
                var e =
                  n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, A) ||
                  n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, A) ||
                  n.default.getFirstMatch(/\bbb(\d+)/i, A);
                return { name: o.OS_MAP.BlackBerry, version: e };
              }
            },
            {
              test: [/bada/i],
              describe: function (A) {
                var e = n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, A);
                return { name: o.OS_MAP.Bada, version: e };
              }
            },
            {
              test: [/tizen/i],
              describe: function (A) {
                var e = n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, A);
                return { name: o.OS_MAP.Tizen, version: e };
              }
            },
            {
              test: [/linux/i],
              describe: function () {
                return { name: o.OS_MAP.Linux };
              }
            },
            {
              test: [/CrOS/],
              describe: function () {
                return { name: o.OS_MAP.ChromeOS };
              }
            },
            {
              test: [/PlayStation 4/],
              describe: function (A) {
                var e = n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, A);
                return { name: o.OS_MAP.PlayStation4, version: e };
              }
            }
          ];
        (e.default = r), (A.exports = e.default);
      },
      94: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i,
          n = (i = t(17)) && i.__esModule ? i : { default: i },
          o = t(18),
          r = [
            {
              test: [/googlebot/i],
              describe: function () {
                return { type: "bot", vendor: "Google" };
              }
            },
            {
              test: [/huawei/i],
              describe: function (A) {
                var e = n.default.getFirstMatch(/(can-l01)/i, A) && "Nova",
                  t = { type: o.PLATFORMS_MAP.mobile, vendor: "Huawei" };
                return e && (t.model = e), t;
              }
            },
            {
              test: [/nexus\s*(?:7|8|9|10).*/i],
              describe: function () {
                return { type: o.PLATFORMS_MAP.tablet, vendor: "Nexus" };
              }
            },
            {
              test: [/ipad/i],
              describe: function () {
                return { type: o.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
              }
            },
            {
              test: [/Macintosh(.*?) FxiOS(.*?)\//],
              describe: function () {
                return { type: o.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
              }
            },
            {
              test: [/kftt build/i],
              describe: function () {
                return {
                  type: o.PLATFORMS_MAP.tablet,
                  vendor: "Amazon",
                  model: "Kindle Fire HD 7"
                };
              }
            },
            {
              test: [/silk/i],
              describe: function () {
                return { type: o.PLATFORMS_MAP.tablet, vendor: "Amazon" };
              }
            },
            {
              test: [/tablet(?! pc)/i],
              describe: function () {
                return { type: o.PLATFORMS_MAP.tablet };
              }
            },
            {
              test: function (A) {
                var e = A.test(/ipod|iphone/i),
                  t = A.test(/like (ipod|iphone)/i);
                return e && !t;
              },
              describe: function (A) {
                var e = n.default.getFirstMatch(/(ipod|iphone)/i, A);
                return { type: o.PLATFORMS_MAP.mobile, vendor: "Apple", model: e };
              }
            },
            {
              test: [/nexus\s*[0-6].*/i, /galaxy nexus/i],
              describe: function () {
                return { type: o.PLATFORMS_MAP.mobile, vendor: "Nexus" };
              }
            },
            {
              test: [/[^-]mobi/i],
              describe: function () {
                return { type: o.PLATFORMS_MAP.mobile };
              }
            },
            {
              test: function (A) {
                return "blackberry" === A.getBrowserName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.mobile, vendor: "BlackBerry" };
              }
            },
            {
              test: function (A) {
                return "bada" === A.getBrowserName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.mobile };
              }
            },
            {
              test: function (A) {
                return "windows phone" === A.getBrowserName();
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.mobile, vendor: "Microsoft" };
              }
            },
            {
              test: function (A) {
                var e = Number(String(A.getOSVersion()).split(".")[0]);
                return "android" === A.getOSName(!0) && e >= 3;
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.tablet };
              }
            },
            {
              test: function (A) {
                return "android" === A.getOSName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.mobile };
              }
            },
            {
              test: function (A) {
                return "macos" === A.getOSName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.desktop, vendor: "Apple" };
              }
            },
            {
              test: function (A) {
                return "windows" === A.getOSName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.desktop };
              }
            },
            {
              test: function (A) {
                return "linux" === A.getOSName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.desktop };
              }
            },
            {
              test: function (A) {
                return "playstation 4" === A.getOSName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.tv };
              }
            },
            {
              test: function (A) {
                return "roku" === A.getOSName(!0);
              },
              describe: function () {
                return { type: o.PLATFORMS_MAP.tv };
              }
            }
          ];
        (e.default = r), (A.exports = e.default);
      },
      95: function (A, e, t) {
        (e.__esModule = !0), (e.default = void 0);
        var i,
          n = (i = t(17)) && i.__esModule ? i : { default: i },
          o = t(18),
          r = [
            {
              test: function (A) {
                return "microsoft edge" === A.getBrowserName(!0);
              },
              describe: function (A) {
                if (/\sedg\//i.test(A)) return { name: o.ENGINE_MAP.Blink };
                var e = n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, A);
                return { name: o.ENGINE_MAP.EdgeHTML, version: e };
              }
            },
            {
              test: [/trident/i],
              describe: function (A) {
                var e = { name: o.ENGINE_MAP.Trident },
                  t = n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: function (A) {
                return A.test(/presto/i);
              },
              describe: function (A) {
                var e = { name: o.ENGINE_MAP.Presto },
                  t = n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: function (A) {
                var e = A.test(/gecko/i),
                  t = A.test(/like gecko/i);
                return e && !t;
              },
              describe: function (A) {
                var e = { name: o.ENGINE_MAP.Gecko },
                  t = n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            },
            {
              test: [/(apple)?webkit\/537\.36/i],
              describe: function () {
                return { name: o.ENGINE_MAP.Blink };
              }
            },
            {
              test: [/(apple)?webkit/i],
              describe: function (A) {
                var e = { name: o.ENGINE_MAP.WebKit },
                  t = n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, A);
                return t && (e.version = t), e;
              }
            }
          ];
        (e.default = r), (A.exports = e.default);
      }
    }))
  ).getParser(window.navigator.userAgent),
  ir = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0,
  nr = tr.getOSName(!0),
  or = new RegExp("AFTGAZLTC;"),
  rr = window.navigator.userAgent.match(or),
  sr = null !== rr && rr.length > 0;
let ar = !1;
function gr() {
  return !!tr.satisfies({ edge: ">70" });
}
function cr() {
  return !!tr.satisfies({ macos: { safari: ">=13" } }) && ir;
}
function Ir() {
  return tr;
}
function lr() {
  return tr.isBrowser("chrome", !0);
}
function dr() {
  return tr.isBrowser("firefox", !0);
}
function ur() {
  return tr.isBrowser("safari", !0);
}
function Cr() {
  return "desktop" === tr.getPlatformType(!0) && !cr();
}
function Br() {
  return "windows" === nr;
}
function Qr() {
  return "macos" === nr;
}
function Er() {
  return "chrome os" === nr;
}
function hr() {
  return "ios" === nr;
}
function pr() {
  return "Blink" === tr.getEngineName();
}
function fr() {
  return sr;
}
function mr() {
  return ar;
}
navigator?.userAgentData?.getHighEntropyValues(["platformVersion"]).then((A) => {
  if ("Windows" === navigator.userAgentData.platform) {
    parseInt(A.platformVersion.split(".")[0], 10) >= 13 && (ar = !0);
  }
});
var yr = Object.freeze({
  __proto__: null,
  isTablet: function () {
    return !("tablet" !== tr.getPlatformType(!0) && !cr());
  },
  isiPadDesktopMode: cr,
  getParsed: Ir,
  isEdgeChromium: gr,
  isChrome: lr,
  isFirefox: dr,
  isSafari: ur,
  isMobile: function () {
    return "mobile" === tr.getPlatformType(!0);
  },
  isDesktop: Cr,
  isWindows: Br,
  isMacOS: Qr,
  isChromeOS: Er,
  isiOS: hr,
  isChromiumBasedBrowser: pr,
  getBrowserVersion: function () {
    return tr.getBrowserVersion();
  },
  isWorkSpacesThinClient: fr,
  osName: nr,
  isWindows11orLater: mr
});
const Dr = fr() ? 1500 : 250;
function wr(A, e, t, i) {
  return new Promise((n, o) => {
    let r = [],
      s = 0,
      a = null;
    const g = new window.VideoDecoder({
      output: (A) => {
        null !== a && (clearTimeout(a), (a = null));
        const e = A.format;
        if ((A.close(), s === i.length - 1)) {
          const A = c();
          A ? o(A) : n(e);
        } else
          g.decode(i[s++]),
            (a = setTimeout(() => {
              o(c("[codec] frame not decoded in time"));
            }, Dr));
      },
      error: (A) => {
        o(c(`[codec] ${A}`));
      }
    });
    try {
      const n = { codec: A, description: e, optimizeForLatency: !0 };
      (n.hardwareAcceleration = t ? "prefer-hardware" : "prefer-software"),
        g.configure(n),
        g.decode(i[s++]),
        (a = setTimeout(() => {
          o(c("[codec] frame not decoded in time"));
        }, Dr));
    } catch (A) {
      o(c(`[control] ${A}`));
    }
    function c(A) {
      a && clearTimeout(a), A && r.push(A);
      try {
        "closed" !== g.state && g.close();
      } catch (A) {
        r.push(`[control] ${A}`);
      }
      return r.join("\n");
    }
  });
}
function Fr() {
  return Promise.all(
    No.map(async (A) => {
      const e = A.atoms,
        t = `avc1.${_n(e.subarray(1, 4))}`,
        i = A.packets,
        n = e[1];
      let o = !0;
      const r = [];
      for (let A = 0; A < i.length; A++)
        r.push(
          new window.EncodedVideoChunk({
            timestamp: A,
            data: i[A],
            type: 0 === A ? "key" : "delta"
          })
        );
      try {
        return { idc: n, preferHardware: o, format: await wr(t, e, o, r) };
      } catch (A) {
        o = !1;
      }
      try {
        return { idc: n, preferHardware: o, format: await wr(t, e, o, r) };
      } catch (A) {
        return { idc: n, error: A };
      }
    })
  );
}
const br = Fo.exports.Reader,
  Ur = Fo.exports.Writer,
  Sr = Fo.exports.util,
  Rr = Fo.exports.roots["dcv.display"] || (Fo.exports.roots["dcv.display"] = {}),
  vr = (Rr.dcv = (() => {
    const A = {};
    return (
      (A.display = (function () {
        const A = {};
        return (
          (A.Rect = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.width = 0),
              (A.prototype.height = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(8).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(16).uint32(A.y),
                  null != A.width &&
                    Object.hasOwnProperty.call(A, "width") &&
                    e.uint32(24).uint32(A.width),
                  null != A.height &&
                    Object.hasOwnProperty.call(A, "height") &&
                    e.uint32(32).uint32(A.height),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Rect();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.x = A.uint32();
                      break;
                    case 2:
                      i.y = A.uint32();
                      break;
                    case 3:
                      i.width = A.uint32();
                      break;
                    case 4:
                      i.height = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.x && A.hasOwnProperty("x") && !Sr.isInteger(A.x)
                    ? "x: integer expected"
                    : null != A.y && A.hasOwnProperty("y") && !Sr.isInteger(A.y)
                      ? "y: integer expected"
                      : null != A.width && A.hasOwnProperty("width") && !Sr.isInteger(A.width)
                        ? "width: integer expected"
                        : null != A.height && A.hasOwnProperty("height") && !Sr.isInteger(A.height)
                          ? "height: integer expected"
                          : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Rect) return A;
                let e = new Rr.dcv.display.Rect();
                return (
                  null != A.x && (e.x = A.x >>> 0),
                  null != A.y && (e.y = A.y >>> 0),
                  null != A.width && (e.width = A.width >>> 0),
                  null != A.height && (e.height = A.height >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.x = 0), (t.y = 0), (t.width = 0), (t.height = 0)),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                  null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Rect";
              }),
              A
            );
          })()),
          (A.RectSize = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.width = 0),
              (A.prototype.height = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.width &&
                    Object.hasOwnProperty.call(A, "width") &&
                    e.uint32(8).uint32(A.width),
                  null != A.height &&
                    Object.hasOwnProperty.call(A, "height") &&
                    e.uint32(16).uint32(A.height),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.RectSize();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.width = A.uint32();
                      break;
                    case 2:
                      i.height = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.width && A.hasOwnProperty("width") && !Sr.isInteger(A.width)
                    ? "width: integer expected"
                    : null != A.height && A.hasOwnProperty("height") && !Sr.isInteger(A.height)
                      ? "height: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.RectSize) return A;
                let e = new Rr.dcv.display.RectSize();
                return (
                  null != A.width && (e.width = A.width >>> 0),
                  null != A.height && (e.height = A.height >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.width = 0), (t.height = 0)),
                  null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                  null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.RectSize";
              }),
              A
            );
          })()),
          (A.Point = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(8).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(16).uint32(A.y),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Point();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.x = A.uint32();
                      break;
                    case 2:
                      i.y = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.x && A.hasOwnProperty("x") && !Sr.isInteger(A.x)
                    ? "x: integer expected"
                    : null != A.y && A.hasOwnProperty("y") && !Sr.isInteger(A.y)
                      ? "y: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Point) return A;
                let e = new Rr.dcv.display.Point();
                return null != A.x && (e.x = A.x >>> 0), null != A.y && (e.y = A.y >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.x = 0), (t.y = 0)),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Point";
              }),
              A
            );
          })()),
          (A.HandshakeStart = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.negotiationId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.negotiationId &&
                    Object.hasOwnProperty.call(A, "negotiationId") &&
                    e.uint32(8).uint64(A.negotiationId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.HandshakeStart();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.negotiationId = A.uint64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.negotiationId &&
                      A.hasOwnProperty("negotiationId") &&
                      !(
                        Sr.isInteger(A.negotiationId) ||
                        (A.negotiationId &&
                          Sr.isInteger(A.negotiationId.low) &&
                          Sr.isInteger(A.negotiationId.high))
                      )
                    ? "negotiationId: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.HandshakeStart) return A;
                let e = new Rr.dcv.display.HandshakeStart();
                return (
                  null != A.negotiationId &&
                    (Sr.Long
                      ? ((e.negotiationId = Sr.Long.fromValue(A.negotiationId)).unsigned = !0)
                      : "string" == typeof A.negotiationId
                        ? (e.negotiationId = parseInt(A.negotiationId, 10))
                        : "number" == typeof A.negotiationId
                          ? (e.negotiationId = A.negotiationId)
                          : "object" == typeof A.negotiationId &&
                            (e.negotiationId = new Sr.LongBits(
                              A.negotiationId.low >>> 0,
                              A.negotiationId.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.negotiationId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.negotiationId = e.longs === String ? "0" : 0;
                return (
                  null != A.negotiationId &&
                    A.hasOwnProperty("negotiationId") &&
                    ("number" == typeof A.negotiationId
                      ? (t.negotiationId =
                          e.longs === String ? String(A.negotiationId) : A.negotiationId)
                      : (t.negotiationId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.negotiationId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.negotiationId.low >>> 0,
                                  A.negotiationId.high >>> 0
                                ).toNumber(!0)
                              : A.negotiationId)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.HandshakeStart"
                );
              }),
              A
            );
          })()),
          (A.ClientCodecs = (function () {
            function A(A) {
              if (((this.codecs = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.negotiationId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.codecs = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Ur.create()),
                  null != A.negotiationId &&
                    Object.hasOwnProperty.call(A, "negotiationId") &&
                    e.uint32(8).uint64(A.negotiationId),
                  null != A.codecs && A.codecs.length)
                )
                  for (let t = 0; t < A.codecs.length; ++t)
                    Rr.dcv.display.ClientCodecs.Codec.encode(
                      A.codecs[t],
                      e.uint32(18).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.ClientCodecs();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.negotiationId = A.uint64();
                      break;
                    case 2:
                      (i.codecs && i.codecs.length) || (i.codecs = []),
                        i.codecs.push(Rr.dcv.display.ClientCodecs.Codec.decode(A, A.uint32()));
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.negotiationId &&
                  A.hasOwnProperty("negotiationId") &&
                  !(
                    Sr.isInteger(A.negotiationId) ||
                    (A.negotiationId &&
                      Sr.isInteger(A.negotiationId.low) &&
                      Sr.isInteger(A.negotiationId.high))
                  )
                )
                  return "negotiationId: integer|Long expected";
                if (null != A.codecs && A.hasOwnProperty("codecs")) {
                  if (!Array.isArray(A.codecs)) return "codecs: array expected";
                  for (let e = 0; e < A.codecs.length; ++e) {
                    let t = Rr.dcv.display.ClientCodecs.Codec.verify(A.codecs[e]);
                    if (t) return "codecs." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.ClientCodecs) return A;
                let e = new Rr.dcv.display.ClientCodecs();
                if (
                  (null != A.negotiationId &&
                    (Sr.Long
                      ? ((e.negotiationId = Sr.Long.fromValue(A.negotiationId)).unsigned = !0)
                      : "string" == typeof A.negotiationId
                        ? (e.negotiationId = parseInt(A.negotiationId, 10))
                        : "number" == typeof A.negotiationId
                          ? (e.negotiationId = A.negotiationId)
                          : "object" == typeof A.negotiationId &&
                            (e.negotiationId = new Sr.LongBits(
                              A.negotiationId.low >>> 0,
                              A.negotiationId.high >>> 0
                            ).toNumber(!0))),
                  A.codecs)
                ) {
                  if (!Array.isArray(A.codecs))
                    throw TypeError(".dcv.display.ClientCodecs.codecs: array expected");
                  e.codecs = [];
                  for (let t = 0; t < A.codecs.length; ++t) {
                    if ("object" != typeof A.codecs[t])
                      throw TypeError(".dcv.display.ClientCodecs.codecs: object expected");
                    e.codecs[t] = Rr.dcv.display.ClientCodecs.Codec.fromObject(A.codecs[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.codecs = []), e.defaults))
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.negotiationId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.negotiationId = e.longs === String ? "0" : 0;
                if (
                  (null != A.negotiationId &&
                    A.hasOwnProperty("negotiationId") &&
                    ("number" == typeof A.negotiationId
                      ? (t.negotiationId =
                          e.longs === String ? String(A.negotiationId) : A.negotiationId)
                      : (t.negotiationId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.negotiationId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.negotiationId.low >>> 0,
                                  A.negotiationId.high >>> 0
                                ).toNumber(!0)
                              : A.negotiationId)),
                  A.codecs && A.codecs.length)
                ) {
                  t.codecs = [];
                  for (let i = 0; i < A.codecs.length; ++i)
                    t.codecs[i] = Rr.dcv.display.ClientCodecs.Codec.toObject(A.codecs[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.ClientCodecs";
              }),
              (A.Codec = (function () {
                function A(A) {
                  if (((this.capabilities = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.capabilities = Sr.emptyArray),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ur.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.capabilities && A.capabilities.length)
                    )
                      for (let t = 0; t < A.capabilities.length; ++t)
                        e.uint32(82).string(A.capabilities[t]);
                    return e;
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof br || (A = br.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Rr.dcv.display.ClientCodecs.Codec();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 10:
                          (i.capabilities && i.capabilities.length) || (i.capabilities = []),
                            i.capabilities.push(A.string());
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !Sr.isString(A.name))
                      return "name: string expected";
                    if (null != A.capabilities && A.hasOwnProperty("capabilities")) {
                      if (!Array.isArray(A.capabilities)) return "capabilities: array expected";
                      for (let e = 0; e < A.capabilities.length; ++e)
                        if (!Sr.isString(A.capabilities[e]))
                          return "capabilities: string[] expected";
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Rr.dcv.display.ClientCodecs.Codec) return A;
                    let e = new Rr.dcv.display.ClientCodecs.Codec();
                    if ((null != A.name && (e.name = String(A.name)), A.capabilities)) {
                      if (!Array.isArray(A.capabilities))
                        throw TypeError(
                          ".dcv.display.ClientCodecs.Codec.capabilities: array expected"
                        );
                      e.capabilities = [];
                      for (let t = 0; t < A.capabilities.length; ++t)
                        e.capabilities[t] = String(A.capabilities[t]);
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && (t.capabilities = []),
                      e.defaults && (t.name = ""),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      A.capabilities && A.capabilities.length)
                    ) {
                      t.capabilities = [];
                      for (let e = 0; e < A.capabilities.length; ++e)
                        t.capabilities[e] = A.capabilities[e];
                    }
                    return t;
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.display.ClientCodecs.Codec"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.ServerCodecs = (function () {
            function A(A) {
              if (((this.codecs = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.codecs = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ur.create()), null != A.codecs && A.codecs.length))
                  for (let t = 0; t < A.codecs.length; ++t)
                    Rr.dcv.display.ServerCodecs.Codec.encode(
                      A.codecs[t],
                      e.uint32(10).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.ServerCodecs();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    (i.codecs && i.codecs.length) || (i.codecs = []),
                      i.codecs.push(Rr.dcv.display.ServerCodecs.Codec.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.codecs && A.hasOwnProperty("codecs")) {
                  if (!Array.isArray(A.codecs)) return "codecs: array expected";
                  for (let e = 0; e < A.codecs.length; ++e) {
                    let t = Rr.dcv.display.ServerCodecs.Codec.verify(A.codecs[e]);
                    if (t) return "codecs." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.ServerCodecs) return A;
                let e = new Rr.dcv.display.ServerCodecs();
                if (A.codecs) {
                  if (!Array.isArray(A.codecs))
                    throw TypeError(".dcv.display.ServerCodecs.codecs: array expected");
                  e.codecs = [];
                  for (let t = 0; t < A.codecs.length; ++t) {
                    if ("object" != typeof A.codecs[t])
                      throw TypeError(".dcv.display.ServerCodecs.codecs: object expected");
                    e.codecs[t] = Rr.dcv.display.ServerCodecs.Codec.fromObject(A.codecs[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.codecs = []), A.codecs && A.codecs.length)) {
                  t.codecs = [];
                  for (let i = 0; i < A.codecs.length; ++i)
                    t.codecs[i] = Rr.dcv.display.ServerCodecs.Codec.toObject(A.codecs[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.ServerCodecs";
              }),
              (A.Codec = (function () {
                function A(A) {
                  if (((this.capabilities = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.capabilities = Sr.emptyArray),
                  (A.prototype.id = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ur.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.capabilities && A.capabilities.length)
                    )
                      for (let t = 0; t < A.capabilities.length; ++t)
                        e.uint32(82).string(A.capabilities[t]);
                    return (
                      null != A.id &&
                        Object.hasOwnProperty.call(A, "id") &&
                        e.uint32(160).uint32(A.id),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof br || (A = br.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Rr.dcv.display.ServerCodecs.Codec();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 10:
                          (i.capabilities && i.capabilities.length) || (i.capabilities = []),
                            i.capabilities.push(A.string());
                          break;
                        case 20:
                          i.id = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !Sr.isString(A.name))
                      return "name: string expected";
                    if (null != A.capabilities && A.hasOwnProperty("capabilities")) {
                      if (!Array.isArray(A.capabilities)) return "capabilities: array expected";
                      for (let e = 0; e < A.capabilities.length; ++e)
                        if (!Sr.isString(A.capabilities[e]))
                          return "capabilities: string[] expected";
                    }
                    return null != A.id && A.hasOwnProperty("id") && !Sr.isInteger(A.id)
                      ? "id: integer expected"
                      : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Rr.dcv.display.ServerCodecs.Codec) return A;
                    let e = new Rr.dcv.display.ServerCodecs.Codec();
                    if ((null != A.name && (e.name = String(A.name)), A.capabilities)) {
                      if (!Array.isArray(A.capabilities))
                        throw TypeError(
                          ".dcv.display.ServerCodecs.Codec.capabilities: array expected"
                        );
                      e.capabilities = [];
                      for (let t = 0; t < A.capabilities.length; ++t)
                        e.capabilities[t] = String(A.capabilities[t]);
                    }
                    return null != A.id && (e.id = A.id >>> 0), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && (t.capabilities = []),
                      e.defaults && ((t.name = ""), (t.id = 0)),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      A.capabilities && A.capabilities.length)
                    ) {
                      t.capabilities = [];
                      for (let e = 0; e < A.capabilities.length; ++e)
                        t.capabilities[e] = A.capabilities[e];
                    }
                    return null != A.id && A.hasOwnProperty("id") && (t.id = A.id), t;
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.display.ServerCodecs.Codec"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.Ready = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.negotiationId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.negotiationId &&
                    Object.hasOwnProperty.call(A, "negotiationId") &&
                    e.uint32(8).uint64(A.negotiationId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Ready();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.negotiationId = A.uint64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.negotiationId &&
                      A.hasOwnProperty("negotiationId") &&
                      !(
                        Sr.isInteger(A.negotiationId) ||
                        (A.negotiationId &&
                          Sr.isInteger(A.negotiationId.low) &&
                          Sr.isInteger(A.negotiationId.high))
                      )
                    ? "negotiationId: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Ready) return A;
                let e = new Rr.dcv.display.Ready();
                return (
                  null != A.negotiationId &&
                    (Sr.Long
                      ? ((e.negotiationId = Sr.Long.fromValue(A.negotiationId)).unsigned = !0)
                      : "string" == typeof A.negotiationId
                        ? (e.negotiationId = parseInt(A.negotiationId, 10))
                        : "number" == typeof A.negotiationId
                          ? (e.negotiationId = A.negotiationId)
                          : "object" == typeof A.negotiationId &&
                            (e.negotiationId = new Sr.LongBits(
                              A.negotiationId.low >>> 0,
                              A.negotiationId.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.negotiationId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.negotiationId = e.longs === String ? "0" : 0;
                return (
                  null != A.negotiationId &&
                    A.hasOwnProperty("negotiationId") &&
                    ("number" == typeof A.negotiationId
                      ? (t.negotiationId =
                          e.longs === String ? String(A.negotiationId) : A.negotiationId)
                      : (t.negotiationId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.negotiationId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.negotiationId.low >>> 0,
                                  A.negotiationId.high >>> 0
                                ).toNumber(!0)
                              : A.negotiationId)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Ready";
              }),
              A
            );
          })()),
          (A.DisplayHead = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.name = ""),
              (A.prototype.rect = null),
              (A.prototype.primary = !1),
              (A.prototype.dpi = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.name &&
                    Object.hasOwnProperty.call(A, "name") &&
                    e.uint32(18).string(A.name),
                  null != A.rect &&
                    Object.hasOwnProperty.call(A, "rect") &&
                    Rr.dcv.display.Rect.encode(A.rect, e.uint32(82).fork()).ldelim(),
                  null != A.primary &&
                    Object.hasOwnProperty.call(A, "primary") &&
                    e.uint32(88).bool(A.primary),
                  null != A.dpi &&
                    Object.hasOwnProperty.call(A, "dpi") &&
                    e.uint32(96).uint32(A.dpi),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.DisplayHead();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 2:
                      i.name = A.string();
                      break;
                    case 10:
                      i.rect = Rr.dcv.display.Rect.decode(A, A.uint32());
                      break;
                    case 11:
                      i.primary = A.bool();
                      break;
                    case 12:
                      i.dpi = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.name && A.hasOwnProperty("name") && !Sr.isString(A.name))
                  return "name: string expected";
                if (null != A.rect && A.hasOwnProperty("rect")) {
                  let e = Rr.dcv.display.Rect.verify(A.rect);
                  if (e) return "rect." + e;
                }
                return null != A.primary &&
                  A.hasOwnProperty("primary") &&
                  "boolean" != typeof A.primary
                  ? "primary: boolean expected"
                  : null != A.dpi && A.hasOwnProperty("dpi") && !Sr.isInteger(A.dpi)
                    ? "dpi: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.DisplayHead) return A;
                let e = new Rr.dcv.display.DisplayHead();
                if ((null != A.name && (e.name = String(A.name)), null != A.rect)) {
                  if ("object" != typeof A.rect)
                    throw TypeError(".dcv.display.DisplayHead.rect: object expected");
                  e.rect = Rr.dcv.display.Rect.fromObject(A.rect);
                }
                return (
                  null != A.primary && (e.primary = Boolean(A.primary)),
                  null != A.dpi && (e.dpi = A.dpi >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.name = ""), (t.rect = null), (t.primary = !1), (t.dpi = 0)),
                  null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                  null != A.rect &&
                    A.hasOwnProperty("rect") &&
                    (t.rect = Rr.dcv.display.Rect.toObject(A.rect, e)),
                  null != A.primary && A.hasOwnProperty("primary") && (t.primary = A.primary),
                  null != A.dpi && A.hasOwnProperty("dpi") && (t.dpi = A.dpi),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.DisplayHead";
              }),
              A
            );
          })()),
          (A.DisplayLayout = (function () {
            function A(A) {
              if (((this.displayHeads = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.displayHeads = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ur.create()), null != A.displayHeads && A.displayHeads.length))
                  for (let t = 0; t < A.displayHeads.length; ++t)
                    Rr.dcv.display.DisplayHead.encode(
                      A.displayHeads[t],
                      e.uint32(82).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.DisplayLayout();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10)
                    (i.displayHeads && i.displayHeads.length) || (i.displayHeads = []),
                      i.displayHeads.push(Rr.dcv.display.DisplayHead.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.displayHeads && A.hasOwnProperty("displayHeads")) {
                  if (!Array.isArray(A.displayHeads)) return "displayHeads: array expected";
                  for (let e = 0; e < A.displayHeads.length; ++e) {
                    let t = Rr.dcv.display.DisplayHead.verify(A.displayHeads[e]);
                    if (t) return "displayHeads." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.DisplayLayout) return A;
                let e = new Rr.dcv.display.DisplayLayout();
                if (A.displayHeads) {
                  if (!Array.isArray(A.displayHeads))
                    throw TypeError(".dcv.display.DisplayLayout.displayHeads: array expected");
                  e.displayHeads = [];
                  for (let t = 0; t < A.displayHeads.length; ++t) {
                    if ("object" != typeof A.displayHeads[t])
                      throw TypeError(".dcv.display.DisplayLayout.displayHeads: object expected");
                    e.displayHeads[t] = Rr.dcv.display.DisplayHead.fromObject(A.displayHeads[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.displayHeads = []),
                  A.displayHeads && A.displayHeads.length)
                ) {
                  t.displayHeads = [];
                  for (let i = 0; i < A.displayHeads.length; ++i)
                    t.displayHeads[i] = Rr.dcv.display.DisplayHead.toObject(A.displayHeads[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.DisplayLayout"
                );
              }),
              A
            );
          })()),
          (A.DisplayLayoutRequest = (function () {
            function A(A) {
              if (((this.displayHeads = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.displayHeads = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ur.create()), null != A.displayHeads && A.displayHeads.length))
                  for (let t = 0; t < A.displayHeads.length; ++t)
                    Rr.dcv.display.DisplayHead.encode(
                      A.displayHeads[t],
                      e.uint32(82).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.DisplayLayoutRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10)
                    (i.displayHeads && i.displayHeads.length) || (i.displayHeads = []),
                      i.displayHeads.push(Rr.dcv.display.DisplayHead.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.displayHeads && A.hasOwnProperty("displayHeads")) {
                  if (!Array.isArray(A.displayHeads)) return "displayHeads: array expected";
                  for (let e = 0; e < A.displayHeads.length; ++e) {
                    let t = Rr.dcv.display.DisplayHead.verify(A.displayHeads[e]);
                    if (t) return "displayHeads." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.DisplayLayoutRequest) return A;
                let e = new Rr.dcv.display.DisplayLayoutRequest();
                if (A.displayHeads) {
                  if (!Array.isArray(A.displayHeads))
                    throw TypeError(
                      ".dcv.display.DisplayLayoutRequest.displayHeads: array expected"
                    );
                  e.displayHeads = [];
                  for (let t = 0; t < A.displayHeads.length; ++t) {
                    if ("object" != typeof A.displayHeads[t])
                      throw TypeError(
                        ".dcv.display.DisplayLayoutRequest.displayHeads: object expected"
                      );
                    e.displayHeads[t] = Rr.dcv.display.DisplayHead.fromObject(A.displayHeads[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.displayHeads = []),
                  A.displayHeads && A.displayHeads.length)
                ) {
                  t.displayHeads = [];
                  for (let i = 0; i < A.displayHeads.length; ++i)
                    t.displayHeads[i] = Rr.dcv.display.DisplayHead.toObject(A.displayHeads[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.display.DisplayLayoutRequest"
                );
              }),
              A
            );
          })()),
          (A.StreamStart = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.streamId = 0),
              (A.prototype.codecId = 0),
              (A.prototype.layer = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.streamId &&
                    Object.hasOwnProperty.call(A, "streamId") &&
                    e.uint32(8).uint32(A.streamId),
                  null != A.codecId &&
                    Object.hasOwnProperty.call(A, "codecId") &&
                    e.uint32(80).uint32(A.codecId),
                  null != A.layer &&
                    Object.hasOwnProperty.call(A, "layer") &&
                    e.uint32(160).int32(A.layer),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.StreamStart();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.streamId = A.uint32();
                      break;
                    case 10:
                      i.codecId = A.uint32();
                      break;
                    case 20:
                      i.layer = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.streamId && A.hasOwnProperty("streamId") && !Sr.isInteger(A.streamId))
                  return "streamId: integer expected";
                if (null != A.codecId && A.hasOwnProperty("codecId") && !Sr.isInteger(A.codecId))
                  return "codecId: integer expected";
                if (null != A.layer && A.hasOwnProperty("layer"))
                  switch (A.layer) {
                    default:
                      return "layer: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.StreamStart) return A;
                let e = new Rr.dcv.display.StreamStart();
                switch (
                  (null != A.streamId && (e.streamId = A.streamId >>> 0),
                  null != A.codecId && (e.codecId = A.codecId >>> 0),
                  A.layer)
                ) {
                  default:
                    if ("number" == typeof A.layer) {
                      e.layer = A.layer;
                      break;
                    }
                    break;
                  case "FRAME":
                  case 0:
                    e.layer = 0;
                    break;
                  case "TILES":
                  case 1:
                    e.layer = 1;
                    break;
                  case "QUALITY_UPDATE":
                  case 2:
                    e.layer = 2;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.streamId = 0),
                    (t.codecId = 0),
                    (t.layer = e.enums === String ? "FRAME" : 0)),
                  null != A.streamId && A.hasOwnProperty("streamId") && (t.streamId = A.streamId),
                  null != A.codecId && A.hasOwnProperty("codecId") && (t.codecId = A.codecId),
                  null != A.layer &&
                    A.hasOwnProperty("layer") &&
                    (t.layer =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.StreamStart.Layer[A.layer]
                          ? A.layer
                          : Rr.dcv.display.StreamStart.Layer[A.layer]
                        : A.layer),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.StreamStart";
              }),
              (A.Layer = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "FRAME")] = 0),
                  (e[(A[1] = "TILES")] = 1),
                  (e[(A[2] = "QUALITY_UPDATE")] = 2),
                  e
                );
              })()),
              A
            );
          })()),
          (A.StreamEnd = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.streamId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.streamId &&
                    Object.hasOwnProperty.call(A, "streamId") &&
                    e.uint32(8).uint32(A.streamId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.StreamEnd();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.streamId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.streamId && A.hasOwnProperty("streamId") && !Sr.isInteger(A.streamId)
                    ? "streamId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.StreamEnd) return A;
                let e = new Rr.dcv.display.StreamEnd();
                return null != A.streamId && (e.streamId = A.streamId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.streamId = 0),
                  null != A.streamId && A.hasOwnProperty("streamId") && (t.streamId = A.streamId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.StreamEnd";
              }),
              A
            );
          })()),
          (A.SPSInfo = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.seqParameterSetId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.seqParameterSetId &&
                    Object.hasOwnProperty.call(A, "seqParameterSetId") &&
                    e.uint32(8).uint32(A.seqParameterSetId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.SPSInfo();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.seqParameterSetId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.seqParameterSetId &&
                      A.hasOwnProperty("seqParameterSetId") &&
                      !Sr.isInteger(A.seqParameterSetId)
                    ? "seqParameterSetId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.SPSInfo) return A;
                let e = new Rr.dcv.display.SPSInfo();
                return (
                  null != A.seqParameterSetId && (e.seqParameterSetId = A.seqParameterSetId >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.seqParameterSetId = 0),
                  null != A.seqParameterSetId &&
                    A.hasOwnProperty("seqParameterSetId") &&
                    (t.seqParameterSetId = A.seqParameterSetId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.SPSInfo";
              }),
              A
            );
          })()),
          (A.PPSInfo = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.seqParameterSetId = 0),
              (A.prototype.picParameterSetId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.seqParameterSetId &&
                    Object.hasOwnProperty.call(A, "seqParameterSetId") &&
                    e.uint32(8).uint32(A.seqParameterSetId),
                  null != A.picParameterSetId &&
                    Object.hasOwnProperty.call(A, "picParameterSetId") &&
                    e.uint32(16).uint32(A.picParameterSetId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.PPSInfo();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.seqParameterSetId = A.uint32();
                      break;
                    case 2:
                      i.picParameterSetId = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.seqParameterSetId &&
                      A.hasOwnProperty("seqParameterSetId") &&
                      !Sr.isInteger(A.seqParameterSetId)
                    ? "seqParameterSetId: integer expected"
                    : null != A.picParameterSetId &&
                        A.hasOwnProperty("picParameterSetId") &&
                        !Sr.isInteger(A.picParameterSetId)
                      ? "picParameterSetId: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.PPSInfo) return A;
                let e = new Rr.dcv.display.PPSInfo();
                return (
                  null != A.seqParameterSetId && (e.seqParameterSetId = A.seqParameterSetId >>> 0),
                  null != A.picParameterSetId && (e.picParameterSetId = A.picParameterSetId >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.seqParameterSetId = 0), (t.picParameterSetId = 0)),
                  null != A.seqParameterSetId &&
                    A.hasOwnProperty("seqParameterSetId") &&
                    (t.seqParameterSetId = A.seqParameterSetId),
                  null != A.picParameterSetId &&
                    A.hasOwnProperty("picParameterSetId") &&
                    (t.picParameterSetId = A.picParameterSetId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.PPSInfo";
              }),
              A
            );
          })()),
          (A.SliceHeader = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.firstMbInSlice = 0),
              (A.prototype.sliceType = 0),
              (A.prototype.picParameterSetId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.firstMbInSlice &&
                    Object.hasOwnProperty.call(A, "firstMbInSlice") &&
                    e.uint32(8).uint32(A.firstMbInSlice),
                  null != A.sliceType &&
                    Object.hasOwnProperty.call(A, "sliceType") &&
                    e.uint32(16).int32(A.sliceType),
                  null != A.picParameterSetId &&
                    Object.hasOwnProperty.call(A, "picParameterSetId") &&
                    e.uint32(24).uint32(A.picParameterSetId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.SliceHeader();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.firstMbInSlice = A.uint32();
                      break;
                    case 2:
                      i.sliceType = A.int32();
                      break;
                    case 3:
                      i.picParameterSetId = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.firstMbInSlice &&
                  A.hasOwnProperty("firstMbInSlice") &&
                  !Sr.isInteger(A.firstMbInSlice)
                )
                  return "firstMbInSlice: integer expected";
                if (null != A.sliceType && A.hasOwnProperty("sliceType"))
                  switch (A.sliceType) {
                    default:
                      return "sliceType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                  }
                return null != A.picParameterSetId &&
                  A.hasOwnProperty("picParameterSetId") &&
                  !Sr.isInteger(A.picParameterSetId)
                  ? "picParameterSetId: integer expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.SliceHeader) return A;
                let e = new Rr.dcv.display.SliceHeader();
                switch (
                  (null != A.firstMbInSlice && (e.firstMbInSlice = A.firstMbInSlice >>> 0),
                  A.sliceType)
                ) {
                  default:
                    if ("number" == typeof A.sliceType) {
                      e.sliceType = A.sliceType;
                      break;
                    }
                    break;
                  case "CODED_SLICE_TYPE_P":
                  case 0:
                    e.sliceType = 0;
                    break;
                  case "CODED_SLICE_TYPE_B":
                  case 1:
                    e.sliceType = 1;
                    break;
                  case "CODED_SLICE_TYPE_I":
                  case 2:
                    e.sliceType = 2;
                    break;
                  case "CODED_SLICE_TYPE_SP":
                  case 3:
                    e.sliceType = 3;
                    break;
                  case "CODED_SLICE_TYPE_SI":
                  case 4:
                    e.sliceType = 4;
                    break;
                  case "CODED_SLICE_TYPE_P_ONLY":
                  case 5:
                    e.sliceType = 5;
                    break;
                  case "CODED_SLICE_TYPE_B_ONLY":
                  case 6:
                    e.sliceType = 6;
                    break;
                  case "CODED_SLICE_TYPE_I_ONLY":
                  case 7:
                    e.sliceType = 7;
                    break;
                  case "CODED_SLICE_TYPE_SP_ONLY":
                  case 8:
                    e.sliceType = 8;
                    break;
                  case "CODED_SLICE_TYPE_SI_ONLY":
                  case 9:
                    e.sliceType = 9;
                }
                return (
                  null != A.picParameterSetId && (e.picParameterSetId = A.picParameterSetId >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.firstMbInSlice = 0),
                    (t.sliceType = e.enums === String ? "CODED_SLICE_TYPE_P" : 0),
                    (t.picParameterSetId = 0)),
                  null != A.firstMbInSlice &&
                    A.hasOwnProperty("firstMbInSlice") &&
                    (t.firstMbInSlice = A.firstMbInSlice),
                  null != A.sliceType &&
                    A.hasOwnProperty("sliceType") &&
                    (t.sliceType =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.SliceHeader.CodedSliceType[A.sliceType]
                          ? A.sliceType
                          : Rr.dcv.display.SliceHeader.CodedSliceType[A.sliceType]
                        : A.sliceType),
                  null != A.picParameterSetId &&
                    A.hasOwnProperty("picParameterSetId") &&
                    (t.picParameterSetId = A.picParameterSetId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.SliceHeader";
              }),
              (A.CodedSliceType = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "CODED_SLICE_TYPE_P")] = 0),
                  (e[(A[1] = "CODED_SLICE_TYPE_B")] = 1),
                  (e[(A[2] = "CODED_SLICE_TYPE_I")] = 2),
                  (e[(A[3] = "CODED_SLICE_TYPE_SP")] = 3),
                  (e[(A[4] = "CODED_SLICE_TYPE_SI")] = 4),
                  (e[(A[5] = "CODED_SLICE_TYPE_P_ONLY")] = 5),
                  (e[(A[6] = "CODED_SLICE_TYPE_B_ONLY")] = 6),
                  (e[(A[7] = "CODED_SLICE_TYPE_I_ONLY")] = 7),
                  (e[(A[8] = "CODED_SLICE_TYPE_SP_ONLY")] = 8),
                  (e[(A[9] = "CODED_SLICE_TYPE_SI_ONLY")] = 9),
                  e
                );
              })()),
              A
            );
          })()),
          (A.NalUnit = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.offset = 0),
              (A.prototype.size = 0),
              (A.prototype.type = 0),
              (A.prototype.recoveryPayload = Sr.newBuffer([])),
              (A.prototype.spsInfo = null),
              (A.prototype.ppsInfo = null),
              (A.prototype.sliceHeader = null),
              Object.defineProperty(A.prototype, "content", {
                get: Sr.oneOfGetter((e = ["spsInfo", "ppsInfo", "sliceHeader"])),
                set: Sr.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.offset &&
                    Object.hasOwnProperty.call(A, "offset") &&
                    e.uint32(8).uint32(A.offset),
                  null != A.size &&
                    Object.hasOwnProperty.call(A, "size") &&
                    e.uint32(16).uint32(A.size),
                  null != A.type &&
                    Object.hasOwnProperty.call(A, "type") &&
                    e.uint32(80).int32(A.type),
                  null != A.recoveryPayload &&
                    Object.hasOwnProperty.call(A, "recoveryPayload") &&
                    e.uint32(162).bytes(A.recoveryPayload),
                  null != A.spsInfo &&
                    Object.hasOwnProperty.call(A, "spsInfo") &&
                    Rr.dcv.display.SPSInfo.encode(A.spsInfo, e.uint32(242).fork()).ldelim(),
                  null != A.ppsInfo &&
                    Object.hasOwnProperty.call(A, "ppsInfo") &&
                    Rr.dcv.display.PPSInfo.encode(A.ppsInfo, e.uint32(322).fork()).ldelim(),
                  null != A.sliceHeader &&
                    Object.hasOwnProperty.call(A, "sliceHeader") &&
                    Rr.dcv.display.SliceHeader.encode(A.sliceHeader, e.uint32(402).fork()).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.NalUnit();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.offset = A.uint32();
                      break;
                    case 2:
                      i.size = A.uint32();
                      break;
                    case 10:
                      i.type = A.int32();
                      break;
                    case 20:
                      i.recoveryPayload = A.bytes();
                      break;
                    case 30:
                      i.spsInfo = Rr.dcv.display.SPSInfo.decode(A, A.uint32());
                      break;
                    case 40:
                      i.ppsInfo = Rr.dcv.display.PPSInfo.decode(A, A.uint32());
                      break;
                    case 50:
                      i.sliceHeader = Rr.dcv.display.SliceHeader.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.offset && A.hasOwnProperty("offset") && !Sr.isInteger(A.offset))
                  return "offset: integer expected";
                if (null != A.size && A.hasOwnProperty("size") && !Sr.isInteger(A.size))
                  return "size: integer expected";
                if (null != A.type && A.hasOwnProperty("type"))
                  switch (A.type) {
                    default:
                      return "type: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 14:
                    case 15:
                    case 16:
                    case 19:
                    case 20:
                  }
                if (
                  null != A.recoveryPayload &&
                  A.hasOwnProperty("recoveryPayload") &&
                  !(
                    (A.recoveryPayload && "number" == typeof A.recoveryPayload.length) ||
                    Sr.isString(A.recoveryPayload)
                  )
                )
                  return "recoveryPayload: buffer expected";
                if (null != A.spsInfo && A.hasOwnProperty("spsInfo")) {
                  e.content = 1;
                  {
                    let e = Rr.dcv.display.SPSInfo.verify(A.spsInfo);
                    if (e) return "spsInfo." + e;
                  }
                }
                if (null != A.ppsInfo && A.hasOwnProperty("ppsInfo")) {
                  if (1 === e.content) return "content: multiple values";
                  e.content = 1;
                  {
                    let e = Rr.dcv.display.PPSInfo.verify(A.ppsInfo);
                    if (e) return "ppsInfo." + e;
                  }
                }
                if (null != A.sliceHeader && A.hasOwnProperty("sliceHeader")) {
                  if (1 === e.content) return "content: multiple values";
                  e.content = 1;
                  {
                    let e = Rr.dcv.display.SliceHeader.verify(A.sliceHeader);
                    if (e) return "sliceHeader." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.NalUnit) return A;
                let e = new Rr.dcv.display.NalUnit();
                switch (
                  (null != A.offset && (e.offset = A.offset >>> 0),
                  null != A.size && (e.size = A.size >>> 0),
                  A.type)
                ) {
                  default:
                    if ("number" == typeof A.type) {
                      e.type = A.type;
                      break;
                    }
                    break;
                  case "UNSPECIFIED":
                  case 0:
                    e.type = 0;
                    break;
                  case "CODED_SLICE_NON_IDR":
                  case 1:
                    e.type = 1;
                    break;
                  case "CODED_SLICE_DATA_PARTITION_A":
                  case 2:
                    e.type = 2;
                    break;
                  case "CODED_SLICE_DATA_PARTITION_B":
                  case 3:
                    e.type = 3;
                    break;
                  case "CODED_SLICE_DATA_PARTITION_C":
                  case 4:
                    e.type = 4;
                    break;
                  case "CODED_SLICE_IDR":
                  case 5:
                    e.type = 5;
                    break;
                  case "SEI":
                  case 6:
                    e.type = 6;
                    break;
                  case "SPS":
                  case 7:
                    e.type = 7;
                    break;
                  case "PPS":
                  case 8:
                    e.type = 8;
                    break;
                  case "AUD":
                  case 9:
                    e.type = 9;
                    break;
                  case "END_OF_SEQUENCE":
                  case 10:
                    e.type = 10;
                    break;
                  case "END_OF_STREAM":
                  case 11:
                    e.type = 11;
                    break;
                  case "FILLER":
                  case 12:
                    e.type = 12;
                    break;
                  case "SPS_EXT":
                  case 13:
                    e.type = 13;
                    break;
                  case "PREFIX_NAL":
                  case 14:
                    e.type = 14;
                    break;
                  case "SUBSET_SPS":
                  case 15:
                    e.type = 15;
                    break;
                  case "DPS":
                  case 16:
                    e.type = 16;
                    break;
                  case "CODED_SLICE_AUX":
                  case 19:
                    e.type = 19;
                    break;
                  case "CODED_SLICE_SVC_EXTENSION":
                  case 20:
                    e.type = 20;
                }
                if (
                  (null != A.recoveryPayload &&
                    ("string" == typeof A.recoveryPayload
                      ? Sr.base64.decode(
                          A.recoveryPayload,
                          (e.recoveryPayload = Sr.newBuffer(Sr.base64.length(A.recoveryPayload))),
                          0
                        )
                      : A.recoveryPayload.length >= 0 && (e.recoveryPayload = A.recoveryPayload)),
                  null != A.spsInfo)
                ) {
                  if ("object" != typeof A.spsInfo)
                    throw TypeError(".dcv.display.NalUnit.spsInfo: object expected");
                  e.spsInfo = Rr.dcv.display.SPSInfo.fromObject(A.spsInfo);
                }
                if (null != A.ppsInfo) {
                  if ("object" != typeof A.ppsInfo)
                    throw TypeError(".dcv.display.NalUnit.ppsInfo: object expected");
                  e.ppsInfo = Rr.dcv.display.PPSInfo.fromObject(A.ppsInfo);
                }
                if (null != A.sliceHeader) {
                  if ("object" != typeof A.sliceHeader)
                    throw TypeError(".dcv.display.NalUnit.sliceHeader: object expected");
                  e.sliceHeader = Rr.dcv.display.SliceHeader.fromObject(A.sliceHeader);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.offset = 0),
                    (t.size = 0),
                    (t.type = e.enums === String ? "UNSPECIFIED" : 0),
                    e.bytes === String
                      ? (t.recoveryPayload = "")
                      : ((t.recoveryPayload = []),
                        e.bytes !== Array &&
                          (t.recoveryPayload = Sr.newBuffer(t.recoveryPayload)))),
                  null != A.offset && A.hasOwnProperty("offset") && (t.offset = A.offset),
                  null != A.size && A.hasOwnProperty("size") && (t.size = A.size),
                  null != A.type &&
                    A.hasOwnProperty("type") &&
                    (t.type =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.NalUnit.NalUnitType[A.type]
                          ? A.type
                          : Rr.dcv.display.NalUnit.NalUnitType[A.type]
                        : A.type),
                  null != A.recoveryPayload &&
                    A.hasOwnProperty("recoveryPayload") &&
                    (t.recoveryPayload =
                      e.bytes === String
                        ? Sr.base64.encode(A.recoveryPayload, 0, A.recoveryPayload.length)
                        : e.bytes === Array
                          ? Array.prototype.slice.call(A.recoveryPayload)
                          : A.recoveryPayload),
                  null != A.spsInfo &&
                    A.hasOwnProperty("spsInfo") &&
                    ((t.spsInfo = Rr.dcv.display.SPSInfo.toObject(A.spsInfo, e)),
                    e.oneofs && (t.content = "spsInfo")),
                  null != A.ppsInfo &&
                    A.hasOwnProperty("ppsInfo") &&
                    ((t.ppsInfo = Rr.dcv.display.PPSInfo.toObject(A.ppsInfo, e)),
                    e.oneofs && (t.content = "ppsInfo")),
                  null != A.sliceHeader &&
                    A.hasOwnProperty("sliceHeader") &&
                    ((t.sliceHeader = Rr.dcv.display.SliceHeader.toObject(A.sliceHeader, e)),
                    e.oneofs && (t.content = "sliceHeader")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.NalUnit";
              }),
              (A.NalUnitType = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "UNSPECIFIED")] = 0),
                  (e[(A[1] = "CODED_SLICE_NON_IDR")] = 1),
                  (e[(A[2] = "CODED_SLICE_DATA_PARTITION_A")] = 2),
                  (e[(A[3] = "CODED_SLICE_DATA_PARTITION_B")] = 3),
                  (e[(A[4] = "CODED_SLICE_DATA_PARTITION_C")] = 4),
                  (e[(A[5] = "CODED_SLICE_IDR")] = 5),
                  (e[(A[6] = "SEI")] = 6),
                  (e[(A[7] = "SPS")] = 7),
                  (e[(A[8] = "PPS")] = 8),
                  (e[(A[9] = "AUD")] = 9),
                  (e[(A[10] = "END_OF_SEQUENCE")] = 10),
                  (e[(A[11] = "END_OF_STREAM")] = 11),
                  (e[(A[12] = "FILLER")] = 12),
                  (e[(A[13] = "SPS_EXT")] = 13),
                  (e[(A[14] = "PREFIX_NAL")] = 14),
                  (e[(A[15] = "SUBSET_SPS")] = 15),
                  (e[(A[16] = "DPS")] = 16),
                  (e[(A[19] = "CODED_SLICE_AUX")] = 19),
                  (e[(A[20] = "CODED_SLICE_SVC_EXTENSION")] = 20),
                  e
                );
              })()),
              A
            );
          })()),
          (A.TileUnit = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.offset = 0),
              (A.prototype.size = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.offset &&
                    Object.hasOwnProperty.call(A, "offset") &&
                    e.uint32(8).uint32(A.offset),
                  null != A.size &&
                    Object.hasOwnProperty.call(A, "size") &&
                    e.uint32(16).uint32(A.size),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.TileUnit();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.offset = A.uint32();
                      break;
                    case 2:
                      i.size = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.offset && A.hasOwnProperty("offset") && !Sr.isInteger(A.offset)
                    ? "offset: integer expected"
                    : null != A.size && A.hasOwnProperty("size") && !Sr.isInteger(A.size)
                      ? "size: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.TileUnit) return A;
                let e = new Rr.dcv.display.TileUnit();
                return (
                  null != A.offset && (e.offset = A.offset >>> 0),
                  null != A.size && (e.size = A.size >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.offset = 0), (t.size = 0)),
                  null != A.offset && A.hasOwnProperty("offset") && (t.offset = A.offset),
                  null != A.size && A.hasOwnProperty("size") && (t.size = A.size),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.TileUnit";
              }),
              A
            );
          })()),
          (A.TileUpdate = (function () {
            function A(A) {
              if (((this.clipRegion = []), (this.nalUnits = []), (this.tileUnits = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.frameIndex = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.codecFrameId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.originLayer = 0),
              (A.prototype.streamId = 0),
              (A.prototype.sendTimestamp = Sr.Long ? Sr.Long.fromBits(0, 0, !1) : 0),
              (A.prototype.videoRecovery = !1),
              (A.prototype.grabTimestamp = Sr.Long ? Sr.Long.fromBits(0, 0, !1) : 0),
              (A.prototype.rect = null),
              (A.prototype.clipRegion = Sr.emptyArray),
              (A.prototype.nalUnits = Sr.emptyArray),
              (A.prototype.tileUnits = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Ur.create()),
                  null != A.frameIndex &&
                    Object.hasOwnProperty.call(A, "frameIndex") &&
                    e.uint32(8).uint64(A.frameIndex),
                  null != A.codecFrameId &&
                    Object.hasOwnProperty.call(A, "codecFrameId") &&
                    e.uint32(16).uint64(A.codecFrameId),
                  null != A.originLayer &&
                    Object.hasOwnProperty.call(A, "originLayer") &&
                    e.uint32(24).int32(A.originLayer),
                  null != A.streamId &&
                    Object.hasOwnProperty.call(A, "streamId") &&
                    e.uint32(80).uint32(A.streamId),
                  null != A.sendTimestamp &&
                    Object.hasOwnProperty.call(A, "sendTimestamp") &&
                    e.uint32(88).int64(A.sendTimestamp),
                  null != A.videoRecovery &&
                    Object.hasOwnProperty.call(A, "videoRecovery") &&
                    e.uint32(96).bool(A.videoRecovery),
                  null != A.grabTimestamp &&
                    Object.hasOwnProperty.call(A, "grabTimestamp") &&
                    e.uint32(104).int64(A.grabTimestamp),
                  null != A.rect &&
                    Object.hasOwnProperty.call(A, "rect") &&
                    Rr.dcv.display.Rect.encode(A.rect, e.uint32(162).fork()).ldelim(),
                  null != A.clipRegion && A.clipRegion.length)
                )
                  for (let t = 0; t < A.clipRegion.length; ++t)
                    Rr.dcv.display.Rect.encode(A.clipRegion[t], e.uint32(242).fork()).ldelim();
                if (null != A.nalUnits && A.nalUnits.length)
                  for (let t = 0; t < A.nalUnits.length; ++t)
                    Rr.dcv.display.NalUnit.encode(A.nalUnits[t], e.uint32(322).fork()).ldelim();
                if (null != A.tileUnits && A.tileUnits.length)
                  for (let t = 0; t < A.tileUnits.length; ++t)
                    Rr.dcv.display.TileUnit.encode(A.tileUnits[t], e.uint32(402).fork()).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.TileUpdate();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.frameIndex = A.uint64();
                      break;
                    case 2:
                      i.codecFrameId = A.uint64();
                      break;
                    case 3:
                      i.originLayer = A.int32();
                      break;
                    case 10:
                      i.streamId = A.uint32();
                      break;
                    case 11:
                      i.sendTimestamp = A.int64();
                      break;
                    case 12:
                      i.videoRecovery = A.bool();
                      break;
                    case 13:
                      i.grabTimestamp = A.int64();
                      break;
                    case 20:
                      i.rect = Rr.dcv.display.Rect.decode(A, A.uint32());
                      break;
                    case 30:
                      (i.clipRegion && i.clipRegion.length) || (i.clipRegion = []),
                        i.clipRegion.push(Rr.dcv.display.Rect.decode(A, A.uint32()));
                      break;
                    case 40:
                      (i.nalUnits && i.nalUnits.length) || (i.nalUnits = []),
                        i.nalUnits.push(Rr.dcv.display.NalUnit.decode(A, A.uint32()));
                      break;
                    case 50:
                      (i.tileUnits && i.tileUnits.length) || (i.tileUnits = []),
                        i.tileUnits.push(Rr.dcv.display.TileUnit.decode(A, A.uint32()));
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.frameIndex &&
                  A.hasOwnProperty("frameIndex") &&
                  !(
                    Sr.isInteger(A.frameIndex) ||
                    (A.frameIndex &&
                      Sr.isInteger(A.frameIndex.low) &&
                      Sr.isInteger(A.frameIndex.high))
                  )
                )
                  return "frameIndex: integer|Long expected";
                if (
                  null != A.codecFrameId &&
                  A.hasOwnProperty("codecFrameId") &&
                  !(
                    Sr.isInteger(A.codecFrameId) ||
                    (A.codecFrameId &&
                      Sr.isInteger(A.codecFrameId.low) &&
                      Sr.isInteger(A.codecFrameId.high))
                  )
                )
                  return "codecFrameId: integer|Long expected";
                if (null != A.originLayer && A.hasOwnProperty("originLayer"))
                  switch (A.originLayer) {
                    default:
                      return "originLayer: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                if (null != A.streamId && A.hasOwnProperty("streamId") && !Sr.isInteger(A.streamId))
                  return "streamId: integer expected";
                if (
                  null != A.sendTimestamp &&
                  A.hasOwnProperty("sendTimestamp") &&
                  !(
                    Sr.isInteger(A.sendTimestamp) ||
                    (A.sendTimestamp &&
                      Sr.isInteger(A.sendTimestamp.low) &&
                      Sr.isInteger(A.sendTimestamp.high))
                  )
                )
                  return "sendTimestamp: integer|Long expected";
                if (
                  null != A.videoRecovery &&
                  A.hasOwnProperty("videoRecovery") &&
                  "boolean" != typeof A.videoRecovery
                )
                  return "videoRecovery: boolean expected";
                if (
                  null != A.grabTimestamp &&
                  A.hasOwnProperty("grabTimestamp") &&
                  !(
                    Sr.isInteger(A.grabTimestamp) ||
                    (A.grabTimestamp &&
                      Sr.isInteger(A.grabTimestamp.low) &&
                      Sr.isInteger(A.grabTimestamp.high))
                  )
                )
                  return "grabTimestamp: integer|Long expected";
                if (null != A.rect && A.hasOwnProperty("rect")) {
                  let e = Rr.dcv.display.Rect.verify(A.rect);
                  if (e) return "rect." + e;
                }
                if (null != A.clipRegion && A.hasOwnProperty("clipRegion")) {
                  if (!Array.isArray(A.clipRegion)) return "clipRegion: array expected";
                  for (let e = 0; e < A.clipRegion.length; ++e) {
                    let t = Rr.dcv.display.Rect.verify(A.clipRegion[e]);
                    if (t) return "clipRegion." + t;
                  }
                }
                if (null != A.nalUnits && A.hasOwnProperty("nalUnits")) {
                  if (!Array.isArray(A.nalUnits)) return "nalUnits: array expected";
                  for (let e = 0; e < A.nalUnits.length; ++e) {
                    let t = Rr.dcv.display.NalUnit.verify(A.nalUnits[e]);
                    if (t) return "nalUnits." + t;
                  }
                }
                if (null != A.tileUnits && A.hasOwnProperty("tileUnits")) {
                  if (!Array.isArray(A.tileUnits)) return "tileUnits: array expected";
                  for (let e = 0; e < A.tileUnits.length; ++e) {
                    let t = Rr.dcv.display.TileUnit.verify(A.tileUnits[e]);
                    if (t) return "tileUnits." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.TileUpdate) return A;
                let e = new Rr.dcv.display.TileUpdate();
                switch (
                  (null != A.frameIndex &&
                    (Sr.Long
                      ? ((e.frameIndex = Sr.Long.fromValue(A.frameIndex)).unsigned = !0)
                      : "string" == typeof A.frameIndex
                        ? (e.frameIndex = parseInt(A.frameIndex, 10))
                        : "number" == typeof A.frameIndex
                          ? (e.frameIndex = A.frameIndex)
                          : "object" == typeof A.frameIndex &&
                            (e.frameIndex = new Sr.LongBits(
                              A.frameIndex.low >>> 0,
                              A.frameIndex.high >>> 0
                            ).toNumber(!0))),
                  null != A.codecFrameId &&
                    (Sr.Long
                      ? ((e.codecFrameId = Sr.Long.fromValue(A.codecFrameId)).unsigned = !0)
                      : "string" == typeof A.codecFrameId
                        ? (e.codecFrameId = parseInt(A.codecFrameId, 10))
                        : "number" == typeof A.codecFrameId
                          ? (e.codecFrameId = A.codecFrameId)
                          : "object" == typeof A.codecFrameId &&
                            (e.codecFrameId = new Sr.LongBits(
                              A.codecFrameId.low >>> 0,
                              A.codecFrameId.high >>> 0
                            ).toNumber(!0))),
                  A.originLayer)
                ) {
                  default:
                    if ("number" == typeof A.originLayer) {
                      e.originLayer = A.originLayer;
                      break;
                    }
                    break;
                  case "UNKNOWN":
                  case 0:
                    e.originLayer = 0;
                    break;
                  case "FRAME":
                  case 1:
                    e.originLayer = 1;
                    break;
                  case "TILES":
                  case 2:
                    e.originLayer = 2;
                    break;
                  case "QUALITY_UPDATE":
                  case 3:
                    e.originLayer = 3;
                }
                if (
                  (null != A.streamId && (e.streamId = A.streamId >>> 0),
                  null != A.sendTimestamp &&
                    (Sr.Long
                      ? ((e.sendTimestamp = Sr.Long.fromValue(A.sendTimestamp)).unsigned = !1)
                      : "string" == typeof A.sendTimestamp
                        ? (e.sendTimestamp = parseInt(A.sendTimestamp, 10))
                        : "number" == typeof A.sendTimestamp
                          ? (e.sendTimestamp = A.sendTimestamp)
                          : "object" == typeof A.sendTimestamp &&
                            (e.sendTimestamp = new Sr.LongBits(
                              A.sendTimestamp.low >>> 0,
                              A.sendTimestamp.high >>> 0
                            ).toNumber())),
                  null != A.videoRecovery && (e.videoRecovery = Boolean(A.videoRecovery)),
                  null != A.grabTimestamp &&
                    (Sr.Long
                      ? ((e.grabTimestamp = Sr.Long.fromValue(A.grabTimestamp)).unsigned = !1)
                      : "string" == typeof A.grabTimestamp
                        ? (e.grabTimestamp = parseInt(A.grabTimestamp, 10))
                        : "number" == typeof A.grabTimestamp
                          ? (e.grabTimestamp = A.grabTimestamp)
                          : "object" == typeof A.grabTimestamp &&
                            (e.grabTimestamp = new Sr.LongBits(
                              A.grabTimestamp.low >>> 0,
                              A.grabTimestamp.high >>> 0
                            ).toNumber())),
                  null != A.rect)
                ) {
                  if ("object" != typeof A.rect)
                    throw TypeError(".dcv.display.TileUpdate.rect: object expected");
                  e.rect = Rr.dcv.display.Rect.fromObject(A.rect);
                }
                if (A.clipRegion) {
                  if (!Array.isArray(A.clipRegion))
                    throw TypeError(".dcv.display.TileUpdate.clipRegion: array expected");
                  e.clipRegion = [];
                  for (let t = 0; t < A.clipRegion.length; ++t) {
                    if ("object" != typeof A.clipRegion[t])
                      throw TypeError(".dcv.display.TileUpdate.clipRegion: object expected");
                    e.clipRegion[t] = Rr.dcv.display.Rect.fromObject(A.clipRegion[t]);
                  }
                }
                if (A.nalUnits) {
                  if (!Array.isArray(A.nalUnits))
                    throw TypeError(".dcv.display.TileUpdate.nalUnits: array expected");
                  e.nalUnits = [];
                  for (let t = 0; t < A.nalUnits.length; ++t) {
                    if ("object" != typeof A.nalUnits[t])
                      throw TypeError(".dcv.display.TileUpdate.nalUnits: object expected");
                    e.nalUnits[t] = Rr.dcv.display.NalUnit.fromObject(A.nalUnits[t]);
                  }
                }
                if (A.tileUnits) {
                  if (!Array.isArray(A.tileUnits))
                    throw TypeError(".dcv.display.TileUpdate.tileUnits: array expected");
                  e.tileUnits = [];
                  for (let t = 0; t < A.tileUnits.length; ++t) {
                    if ("object" != typeof A.tileUnits[t])
                      throw TypeError(".dcv.display.TileUpdate.tileUnits: object expected");
                    e.tileUnits[t] = Rr.dcv.display.TileUnit.fromObject(A.tileUnits[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) &&
                    ((t.clipRegion = []), (t.nalUnits = []), (t.tileUnits = [])),
                  e.defaults)
                ) {
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.frameIndex =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.frameIndex = e.longs === String ? "0" : 0;
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.codecFrameId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.codecFrameId = e.longs === String ? "0" : 0;
                  if (
                    ((t.originLayer = e.enums === String ? "UNKNOWN" : 0),
                    (t.streamId = 0),
                    Sr.Long)
                  ) {
                    let A = new Sr.Long(0, 0, !1);
                    t.sendTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.sendTimestamp = e.longs === String ? "0" : 0;
                  if (((t.videoRecovery = !1), Sr.Long)) {
                    let A = new Sr.Long(0, 0, !1);
                    t.grabTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.grabTimestamp = e.longs === String ? "0" : 0;
                  t.rect = null;
                }
                if (
                  (null != A.frameIndex &&
                    A.hasOwnProperty("frameIndex") &&
                    ("number" == typeof A.frameIndex
                      ? (t.frameIndex = e.longs === String ? String(A.frameIndex) : A.frameIndex)
                      : (t.frameIndex =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.frameIndex)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0)
                              : A.frameIndex)),
                  null != A.codecFrameId &&
                    A.hasOwnProperty("codecFrameId") &&
                    ("number" == typeof A.codecFrameId
                      ? (t.codecFrameId =
                          e.longs === String ? String(A.codecFrameId) : A.codecFrameId)
                      : (t.codecFrameId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.codecFrameId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.codecFrameId.low >>> 0,
                                  A.codecFrameId.high >>> 0
                                ).toNumber(!0)
                              : A.codecFrameId)),
                  null != A.originLayer &&
                    A.hasOwnProperty("originLayer") &&
                    (t.originLayer =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.TileUpdate.Layer[A.originLayer]
                          ? A.originLayer
                          : Rr.dcv.display.TileUpdate.Layer[A.originLayer]
                        : A.originLayer),
                  null != A.streamId && A.hasOwnProperty("streamId") && (t.streamId = A.streamId),
                  null != A.sendTimestamp &&
                    A.hasOwnProperty("sendTimestamp") &&
                    ("number" == typeof A.sendTimestamp
                      ? (t.sendTimestamp =
                          e.longs === String ? String(A.sendTimestamp) : A.sendTimestamp)
                      : (t.sendTimestamp =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.sendTimestamp)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.sendTimestamp.low >>> 0,
                                  A.sendTimestamp.high >>> 0
                                ).toNumber()
                              : A.sendTimestamp)),
                  null != A.videoRecovery &&
                    A.hasOwnProperty("videoRecovery") &&
                    (t.videoRecovery = A.videoRecovery),
                  null != A.grabTimestamp &&
                    A.hasOwnProperty("grabTimestamp") &&
                    ("number" == typeof A.grabTimestamp
                      ? (t.grabTimestamp =
                          e.longs === String ? String(A.grabTimestamp) : A.grabTimestamp)
                      : (t.grabTimestamp =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.grabTimestamp)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.grabTimestamp.low >>> 0,
                                  A.grabTimestamp.high >>> 0
                                ).toNumber()
                              : A.grabTimestamp)),
                  null != A.rect &&
                    A.hasOwnProperty("rect") &&
                    (t.rect = Rr.dcv.display.Rect.toObject(A.rect, e)),
                  A.clipRegion && A.clipRegion.length)
                ) {
                  t.clipRegion = [];
                  for (let i = 0; i < A.clipRegion.length; ++i)
                    t.clipRegion[i] = Rr.dcv.display.Rect.toObject(A.clipRegion[i], e);
                }
                if (A.nalUnits && A.nalUnits.length) {
                  t.nalUnits = [];
                  for (let i = 0; i < A.nalUnits.length; ++i)
                    t.nalUnits[i] = Rr.dcv.display.NalUnit.toObject(A.nalUnits[i], e);
                }
                if (A.tileUnits && A.tileUnits.length) {
                  t.tileUnits = [];
                  for (let i = 0; i < A.tileUnits.length; ++i)
                    t.tileUnits[i] = Rr.dcv.display.TileUnit.toObject(A.tileUnits[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.TileUpdate";
              }),
              (A.Layer = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "UNKNOWN")] = 0),
                  (e[(A[1] = "FRAME")] = 1),
                  (e[(A[2] = "TILES")] = 2),
                  (e[(A[3] = "QUALITY_UPDATE")] = 3),
                  e
                );
              })()),
              A
            );
          })()),
          (A.TileMove = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.frameIndex = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.sourceRect = null),
              (A.prototype.destinationPoint = null),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.frameIndex &&
                    Object.hasOwnProperty.call(A, "frameIndex") &&
                    e.uint32(8).uint64(A.frameIndex),
                  null != A.sourceRect &&
                    Object.hasOwnProperty.call(A, "sourceRect") &&
                    Rr.dcv.display.Rect.encode(A.sourceRect, e.uint32(82).fork()).ldelim(),
                  null != A.destinationPoint &&
                    Object.hasOwnProperty.call(A, "destinationPoint") &&
                    Rr.dcv.display.Point.encode(A.destinationPoint, e.uint32(162).fork()).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.TileMove();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.frameIndex = A.uint64();
                      break;
                    case 10:
                      i.sourceRect = Rr.dcv.display.Rect.decode(A, A.uint32());
                      break;
                    case 20:
                      i.destinationPoint = Rr.dcv.display.Point.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.frameIndex &&
                  A.hasOwnProperty("frameIndex") &&
                  !(
                    Sr.isInteger(A.frameIndex) ||
                    (A.frameIndex &&
                      Sr.isInteger(A.frameIndex.low) &&
                      Sr.isInteger(A.frameIndex.high))
                  )
                )
                  return "frameIndex: integer|Long expected";
                if (null != A.sourceRect && A.hasOwnProperty("sourceRect")) {
                  let e = Rr.dcv.display.Rect.verify(A.sourceRect);
                  if (e) return "sourceRect." + e;
                }
                if (null != A.destinationPoint && A.hasOwnProperty("destinationPoint")) {
                  let e = Rr.dcv.display.Point.verify(A.destinationPoint);
                  if (e) return "destinationPoint." + e;
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.TileMove) return A;
                let e = new Rr.dcv.display.TileMove();
                if (
                  (null != A.frameIndex &&
                    (Sr.Long
                      ? ((e.frameIndex = Sr.Long.fromValue(A.frameIndex)).unsigned = !0)
                      : "string" == typeof A.frameIndex
                        ? (e.frameIndex = parseInt(A.frameIndex, 10))
                        : "number" == typeof A.frameIndex
                          ? (e.frameIndex = A.frameIndex)
                          : "object" == typeof A.frameIndex &&
                            (e.frameIndex = new Sr.LongBits(
                              A.frameIndex.low >>> 0,
                              A.frameIndex.high >>> 0
                            ).toNumber(!0))),
                  null != A.sourceRect)
                ) {
                  if ("object" != typeof A.sourceRect)
                    throw TypeError(".dcv.display.TileMove.sourceRect: object expected");
                  e.sourceRect = Rr.dcv.display.Rect.fromObject(A.sourceRect);
                }
                if (null != A.destinationPoint) {
                  if ("object" != typeof A.destinationPoint)
                    throw TypeError(".dcv.display.TileMove.destinationPoint: object expected");
                  e.destinationPoint = Rr.dcv.display.Point.fromObject(A.destinationPoint);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.frameIndex =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.frameIndex = e.longs === String ? "0" : 0;
                  (t.sourceRect = null), (t.destinationPoint = null);
                }
                return (
                  null != A.frameIndex &&
                    A.hasOwnProperty("frameIndex") &&
                    ("number" == typeof A.frameIndex
                      ? (t.frameIndex = e.longs === String ? String(A.frameIndex) : A.frameIndex)
                      : (t.frameIndex =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.frameIndex)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0)
                              : A.frameIndex)),
                  null != A.sourceRect &&
                    A.hasOwnProperty("sourceRect") &&
                    (t.sourceRect = Rr.dcv.display.Rect.toObject(A.sourceRect, e)),
                  null != A.destinationPoint &&
                    A.hasOwnProperty("destinationPoint") &&
                    (t.destinationPoint = Rr.dcv.display.Point.toObject(A.destinationPoint, e)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.TileMove";
              }),
              A
            );
          })()),
          (A.Swap = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.frameIndex = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.sendTimestamp = Sr.Long ? Sr.Long.fromBits(0, 0, !1) : 0),
              (A.prototype.grabTimestamp = Sr.Long ? Sr.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.frameIndex &&
                    Object.hasOwnProperty.call(A, "frameIndex") &&
                    e.uint32(8).uint64(A.frameIndex),
                  null != A.sendTimestamp &&
                    Object.hasOwnProperty.call(A, "sendTimestamp") &&
                    e.uint32(80).int64(A.sendTimestamp),
                  null != A.grabTimestamp &&
                    Object.hasOwnProperty.call(A, "grabTimestamp") &&
                    e.uint32(88).int64(A.grabTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Swap();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.frameIndex = A.uint64();
                      break;
                    case 10:
                      i.sendTimestamp = A.int64();
                      break;
                    case 11:
                      i.grabTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.frameIndex &&
                      A.hasOwnProperty("frameIndex") &&
                      !(
                        Sr.isInteger(A.frameIndex) ||
                        (A.frameIndex &&
                          Sr.isInteger(A.frameIndex.low) &&
                          Sr.isInteger(A.frameIndex.high))
                      )
                    ? "frameIndex: integer|Long expected"
                    : null != A.sendTimestamp &&
                        A.hasOwnProperty("sendTimestamp") &&
                        !(
                          Sr.isInteger(A.sendTimestamp) ||
                          (A.sendTimestamp &&
                            Sr.isInteger(A.sendTimestamp.low) &&
                            Sr.isInteger(A.sendTimestamp.high))
                        )
                      ? "sendTimestamp: integer|Long expected"
                      : null != A.grabTimestamp &&
                          A.hasOwnProperty("grabTimestamp") &&
                          !(
                            Sr.isInteger(A.grabTimestamp) ||
                            (A.grabTimestamp &&
                              Sr.isInteger(A.grabTimestamp.low) &&
                              Sr.isInteger(A.grabTimestamp.high))
                          )
                        ? "grabTimestamp: integer|Long expected"
                        : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Swap) return A;
                let e = new Rr.dcv.display.Swap();
                return (
                  null != A.frameIndex &&
                    (Sr.Long
                      ? ((e.frameIndex = Sr.Long.fromValue(A.frameIndex)).unsigned = !0)
                      : "string" == typeof A.frameIndex
                        ? (e.frameIndex = parseInt(A.frameIndex, 10))
                        : "number" == typeof A.frameIndex
                          ? (e.frameIndex = A.frameIndex)
                          : "object" == typeof A.frameIndex &&
                            (e.frameIndex = new Sr.LongBits(
                              A.frameIndex.low >>> 0,
                              A.frameIndex.high >>> 0
                            ).toNumber(!0))),
                  null != A.sendTimestamp &&
                    (Sr.Long
                      ? ((e.sendTimestamp = Sr.Long.fromValue(A.sendTimestamp)).unsigned = !1)
                      : "string" == typeof A.sendTimestamp
                        ? (e.sendTimestamp = parseInt(A.sendTimestamp, 10))
                        : "number" == typeof A.sendTimestamp
                          ? (e.sendTimestamp = A.sendTimestamp)
                          : "object" == typeof A.sendTimestamp &&
                            (e.sendTimestamp = new Sr.LongBits(
                              A.sendTimestamp.low >>> 0,
                              A.sendTimestamp.high >>> 0
                            ).toNumber())),
                  null != A.grabTimestamp &&
                    (Sr.Long
                      ? ((e.grabTimestamp = Sr.Long.fromValue(A.grabTimestamp)).unsigned = !1)
                      : "string" == typeof A.grabTimestamp
                        ? (e.grabTimestamp = parseInt(A.grabTimestamp, 10))
                        : "number" == typeof A.grabTimestamp
                          ? (e.grabTimestamp = A.grabTimestamp)
                          : "object" == typeof A.grabTimestamp &&
                            (e.grabTimestamp = new Sr.LongBits(
                              A.grabTimestamp.low >>> 0,
                              A.grabTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.frameIndex =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.frameIndex = e.longs === String ? "0" : 0;
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !1);
                    t.sendTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.sendTimestamp = e.longs === String ? "0" : 0;
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !1);
                    t.grabTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.grabTimestamp = e.longs === String ? "0" : 0;
                }
                return (
                  null != A.frameIndex &&
                    A.hasOwnProperty("frameIndex") &&
                    ("number" == typeof A.frameIndex
                      ? (t.frameIndex = e.longs === String ? String(A.frameIndex) : A.frameIndex)
                      : (t.frameIndex =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.frameIndex)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0)
                              : A.frameIndex)),
                  null != A.sendTimestamp &&
                    A.hasOwnProperty("sendTimestamp") &&
                    ("number" == typeof A.sendTimestamp
                      ? (t.sendTimestamp =
                          e.longs === String ? String(A.sendTimestamp) : A.sendTimestamp)
                      : (t.sendTimestamp =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.sendTimestamp)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.sendTimestamp.low >>> 0,
                                  A.sendTimestamp.high >>> 0
                                ).toNumber()
                              : A.sendTimestamp)),
                  null != A.grabTimestamp &&
                    A.hasOwnProperty("grabTimestamp") &&
                    ("number" == typeof A.grabTimestamp
                      ? (t.grabTimestamp =
                          e.longs === String ? String(A.grabTimestamp) : A.grabTimestamp)
                      : (t.grabTimestamp =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.grabTimestamp)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.grabTimestamp.low >>> 0,
                                  A.grabTimestamp.high >>> 0
                                ).toNumber()
                              : A.grabTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Swap";
              }),
              A
            );
          })()),
          (A.Ack = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.index = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.processingTime = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.index &&
                    Object.hasOwnProperty.call(A, "index") &&
                    e.uint32(8).uint64(A.index),
                  null != A.processingTime &&
                    Object.hasOwnProperty.call(A, "processingTime") &&
                    e.uint32(80).uint32(A.processingTime),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Ack();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.index = A.uint64();
                      break;
                    case 10:
                      i.processingTime = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.index &&
                      A.hasOwnProperty("index") &&
                      !(
                        Sr.isInteger(A.index) ||
                        (A.index && Sr.isInteger(A.index.low) && Sr.isInteger(A.index.high))
                      )
                    ? "index: integer|Long expected"
                    : null != A.processingTime &&
                        A.hasOwnProperty("processingTime") &&
                        !Sr.isInteger(A.processingTime)
                      ? "processingTime: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Ack) return A;
                let e = new Rr.dcv.display.Ack();
                return (
                  null != A.index &&
                    (Sr.Long
                      ? ((e.index = Sr.Long.fromValue(A.index)).unsigned = !0)
                      : "string" == typeof A.index
                        ? (e.index = parseInt(A.index, 10))
                        : "number" == typeof A.index
                          ? (e.index = A.index)
                          : "object" == typeof A.index &&
                            (e.index = new Sr.LongBits(
                              A.index.low >>> 0,
                              A.index.high >>> 0
                            ).toNumber(!0))),
                  null != A.processingTime && (e.processingTime = A.processingTime >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.index =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.index = e.longs === String ? "0" : 0;
                  t.processingTime = 0;
                }
                return (
                  null != A.index &&
                    A.hasOwnProperty("index") &&
                    ("number" == typeof A.index
                      ? (t.index = e.longs === String ? String(A.index) : A.index)
                      : (t.index =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.index)
                            : e.longs === Number
                              ? new Sr.LongBits(A.index.low >>> 0, A.index.high >>> 0).toNumber(!0)
                              : A.index)),
                  null != A.processingTime &&
                    A.hasOwnProperty("processingTime") &&
                    (t.processingTime = A.processingTime),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Ack";
              }),
              A
            );
          })()),
          (A.TileAck = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.codecFrameId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.streamId = 0),
              (A.prototype.negative = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.codecFrameId &&
                    Object.hasOwnProperty.call(A, "codecFrameId") &&
                    e.uint32(8).uint64(A.codecFrameId),
                  null != A.streamId &&
                    Object.hasOwnProperty.call(A, "streamId") &&
                    e.uint32(80).uint32(A.streamId),
                  null != A.negative &&
                    Object.hasOwnProperty.call(A, "negative") &&
                    e.uint32(160).bool(A.negative),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.TileAck();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.codecFrameId = A.uint64();
                      break;
                    case 10:
                      i.streamId = A.uint32();
                      break;
                    case 20:
                      i.negative = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.codecFrameId &&
                      A.hasOwnProperty("codecFrameId") &&
                      !(
                        Sr.isInteger(A.codecFrameId) ||
                        (A.codecFrameId &&
                          Sr.isInteger(A.codecFrameId.low) &&
                          Sr.isInteger(A.codecFrameId.high))
                      )
                    ? "codecFrameId: integer|Long expected"
                    : null != A.streamId &&
                        A.hasOwnProperty("streamId") &&
                        !Sr.isInteger(A.streamId)
                      ? "streamId: integer expected"
                      : null != A.negative &&
                          A.hasOwnProperty("negative") &&
                          "boolean" != typeof A.negative
                        ? "negative: boolean expected"
                        : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.TileAck) return A;
                let e = new Rr.dcv.display.TileAck();
                return (
                  null != A.codecFrameId &&
                    (Sr.Long
                      ? ((e.codecFrameId = Sr.Long.fromValue(A.codecFrameId)).unsigned = !0)
                      : "string" == typeof A.codecFrameId
                        ? (e.codecFrameId = parseInt(A.codecFrameId, 10))
                        : "number" == typeof A.codecFrameId
                          ? (e.codecFrameId = A.codecFrameId)
                          : "object" == typeof A.codecFrameId &&
                            (e.codecFrameId = new Sr.LongBits(
                              A.codecFrameId.low >>> 0,
                              A.codecFrameId.high >>> 0
                            ).toNumber(!0))),
                  null != A.streamId && (e.streamId = A.streamId >>> 0),
                  null != A.negative && (e.negative = Boolean(A.negative)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !0);
                    t.codecFrameId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.codecFrameId = e.longs === String ? "0" : 0;
                  (t.streamId = 0), (t.negative = !1);
                }
                return (
                  null != A.codecFrameId &&
                    A.hasOwnProperty("codecFrameId") &&
                    ("number" == typeof A.codecFrameId
                      ? (t.codecFrameId =
                          e.longs === String ? String(A.codecFrameId) : A.codecFrameId)
                      : (t.codecFrameId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.codecFrameId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.codecFrameId.low >>> 0,
                                  A.codecFrameId.high >>> 0
                                ).toNumber(!0)
                              : A.codecFrameId)),
                  null != A.streamId && A.hasOwnProperty("streamId") && (t.streamId = A.streamId),
                  null != A.negative && A.hasOwnProperty("negative") && (t.negative = A.negative),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.TileAck";
              }),
              A
            );
          })()),
          (A.Settings = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.minQuality = 0),
              (A.prototype.maxQuality = 0),
              (A.prototype.enableQu = 0),
              (A.prototype.maxDisplayWidth = 0),
              (A.prototype.maxDisplayHeight = 0),
              (A.prototype.maxDisplayNumber = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.minQuality &&
                    Object.hasOwnProperty.call(A, "minQuality") &&
                    e.uint32(8).uint32(A.minQuality),
                  null != A.maxQuality &&
                    Object.hasOwnProperty.call(A, "maxQuality") &&
                    e.uint32(16).uint32(A.maxQuality),
                  null != A.enableQu &&
                    Object.hasOwnProperty.call(A, "enableQu") &&
                    e.uint32(24).uint32(A.enableQu),
                  null != A.maxDisplayWidth &&
                    Object.hasOwnProperty.call(A, "maxDisplayWidth") &&
                    e.uint32(80).uint32(A.maxDisplayWidth),
                  null != A.maxDisplayHeight &&
                    Object.hasOwnProperty.call(A, "maxDisplayHeight") &&
                    e.uint32(88).uint32(A.maxDisplayHeight),
                  null != A.maxDisplayNumber &&
                    Object.hasOwnProperty.call(A, "maxDisplayNumber") &&
                    e.uint32(96).uint32(A.maxDisplayNumber),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Settings();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.minQuality = A.uint32();
                      break;
                    case 2:
                      i.maxQuality = A.uint32();
                      break;
                    case 3:
                      i.enableQu = A.uint32();
                      break;
                    case 10:
                      i.maxDisplayWidth = A.uint32();
                      break;
                    case 11:
                      i.maxDisplayHeight = A.uint32();
                      break;
                    case 12:
                      i.maxDisplayNumber = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.minQuality &&
                      A.hasOwnProperty("minQuality") &&
                      !Sr.isInteger(A.minQuality)
                    ? "minQuality: integer expected"
                    : null != A.maxQuality &&
                        A.hasOwnProperty("maxQuality") &&
                        !Sr.isInteger(A.maxQuality)
                      ? "maxQuality: integer expected"
                      : null != A.enableQu &&
                          A.hasOwnProperty("enableQu") &&
                          !Sr.isInteger(A.enableQu)
                        ? "enableQu: integer expected"
                        : null != A.maxDisplayWidth &&
                            A.hasOwnProperty("maxDisplayWidth") &&
                            !Sr.isInteger(A.maxDisplayWidth)
                          ? "maxDisplayWidth: integer expected"
                          : null != A.maxDisplayHeight &&
                              A.hasOwnProperty("maxDisplayHeight") &&
                              !Sr.isInteger(A.maxDisplayHeight)
                            ? "maxDisplayHeight: integer expected"
                            : null != A.maxDisplayNumber &&
                                A.hasOwnProperty("maxDisplayNumber") &&
                                !Sr.isInteger(A.maxDisplayNumber)
                              ? "maxDisplayNumber: integer expected"
                              : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Settings) return A;
                let e = new Rr.dcv.display.Settings();
                return (
                  null != A.minQuality && (e.minQuality = A.minQuality >>> 0),
                  null != A.maxQuality && (e.maxQuality = A.maxQuality >>> 0),
                  null != A.enableQu && (e.enableQu = A.enableQu >>> 0),
                  null != A.maxDisplayWidth && (e.maxDisplayWidth = A.maxDisplayWidth >>> 0),
                  null != A.maxDisplayHeight && (e.maxDisplayHeight = A.maxDisplayHeight >>> 0),
                  null != A.maxDisplayNumber && (e.maxDisplayNumber = A.maxDisplayNumber >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.minQuality = 0),
                    (t.maxQuality = 0),
                    (t.enableQu = 0),
                    (t.maxDisplayWidth = 0),
                    (t.maxDisplayHeight = 0),
                    (t.maxDisplayNumber = 0)),
                  null != A.minQuality &&
                    A.hasOwnProperty("minQuality") &&
                    (t.minQuality = A.minQuality),
                  null != A.maxQuality &&
                    A.hasOwnProperty("maxQuality") &&
                    (t.maxQuality = A.maxQuality),
                  null != A.enableQu && A.hasOwnProperty("enableQu") && (t.enableQu = A.enableQu),
                  null != A.maxDisplayWidth &&
                    A.hasOwnProperty("maxDisplayWidth") &&
                    (t.maxDisplayWidth = A.maxDisplayWidth),
                  null != A.maxDisplayHeight &&
                    A.hasOwnProperty("maxDisplayHeight") &&
                    (t.maxDisplayHeight = A.maxDisplayHeight),
                  null != A.maxDisplayNumber &&
                    A.hasOwnProperty("maxDisplayNumber") &&
                    (t.maxDisplayNumber = A.maxDisplayNumber),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Settings";
              }),
              A
            );
          })()),
          (A.Ping = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pingTimestamp = Sr.Long ? Sr.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.pingTimestamp &&
                    Object.hasOwnProperty.call(A, "pingTimestamp") &&
                    e.uint32(8).int64(A.pingTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Ping();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.pingTimestamp = A.int64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pingTimestamp &&
                      A.hasOwnProperty("pingTimestamp") &&
                      !(
                        Sr.isInteger(A.pingTimestamp) ||
                        (A.pingTimestamp &&
                          Sr.isInteger(A.pingTimestamp.low) &&
                          Sr.isInteger(A.pingTimestamp.high))
                      )
                    ? "pingTimestamp: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Ping) return A;
                let e = new Rr.dcv.display.Ping();
                return (
                  null != A.pingTimestamp &&
                    (Sr.Long
                      ? ((e.pingTimestamp = Sr.Long.fromValue(A.pingTimestamp)).unsigned = !1)
                      : "string" == typeof A.pingTimestamp
                        ? (e.pingTimestamp = parseInt(A.pingTimestamp, 10))
                        : "number" == typeof A.pingTimestamp
                          ? (e.pingTimestamp = A.pingTimestamp)
                          : "object" == typeof A.pingTimestamp &&
                            (e.pingTimestamp = new Sr.LongBits(
                              A.pingTimestamp.low >>> 0,
                              A.pingTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !1);
                    t.pingTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pingTimestamp = e.longs === String ? "0" : 0;
                return (
                  null != A.pingTimestamp &&
                    A.hasOwnProperty("pingTimestamp") &&
                    ("number" == typeof A.pingTimestamp
                      ? (t.pingTimestamp =
                          e.longs === String ? String(A.pingTimestamp) : A.pingTimestamp)
                      : (t.pingTimestamp =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.pingTimestamp)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.pingTimestamp.low >>> 0,
                                  A.pingTimestamp.high >>> 0
                                ).toNumber()
                              : A.pingTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Ping";
              }),
              A
            );
          })()),
          (A.Pong = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pingTimestamp = Sr.Long ? Sr.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.pingTimestamp &&
                    Object.hasOwnProperty.call(A, "pingTimestamp") &&
                    e.uint32(8).int64(A.pingTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Pong();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.pingTimestamp = A.int64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pingTimestamp &&
                      A.hasOwnProperty("pingTimestamp") &&
                      !(
                        Sr.isInteger(A.pingTimestamp) ||
                        (A.pingTimestamp &&
                          Sr.isInteger(A.pingTimestamp.low) &&
                          Sr.isInteger(A.pingTimestamp.high))
                      )
                    ? "pingTimestamp: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Pong) return A;
                let e = new Rr.dcv.display.Pong();
                return (
                  null != A.pingTimestamp &&
                    (Sr.Long
                      ? ((e.pingTimestamp = Sr.Long.fromValue(A.pingTimestamp)).unsigned = !1)
                      : "string" == typeof A.pingTimestamp
                        ? (e.pingTimestamp = parseInt(A.pingTimestamp, 10))
                        : "number" == typeof A.pingTimestamp
                          ? (e.pingTimestamp = A.pingTimestamp)
                          : "object" == typeof A.pingTimestamp &&
                            (e.pingTimestamp = new Sr.LongBits(
                              A.pingTimestamp.low >>> 0,
                              A.pingTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (Sr.Long) {
                    let A = new Sr.Long(0, 0, !1);
                    t.pingTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pingTimestamp = e.longs === String ? "0" : 0;
                return (
                  null != A.pingTimestamp &&
                    A.hasOwnProperty("pingTimestamp") &&
                    ("number" == typeof A.pingTimestamp
                      ? (t.pingTimestamp =
                          e.longs === String ? String(A.pingTimestamp) : A.pingTimestamp)
                      : (t.pingTimestamp =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.pingTimestamp)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.pingTimestamp.low >>> 0,
                                  A.pingTimestamp.high >>> 0
                                ).toNumber()
                              : A.pingTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Pong";
              }),
              A
            );
          })()),
          (A.Pause = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.headName = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.headName &&
                    Object.hasOwnProperty.call(A, "headName") &&
                    e.uint32(10).string(A.headName),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Pause();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.headName = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.headName && A.hasOwnProperty("headName") && !Sr.isString(A.headName)
                    ? "headName: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Pause) return A;
                let e = new Rr.dcv.display.Pause();
                return null != A.headName && (e.headName = String(A.headName)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.headName = ""),
                  null != A.headName && A.hasOwnProperty("headName") && (t.headName = A.headName),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Pause";
              }),
              A
            );
          })()),
          (A.Resume = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.headName = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.headName &&
                    Object.hasOwnProperty.call(A, "headName") &&
                    e.uint32(10).string(A.headName),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.Resume();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.headName = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.headName && A.hasOwnProperty("headName") && !Sr.isString(A.headName)
                    ? "headName: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.Resume) return A;
                let e = new Rr.dcv.display.Resume();
                return null != A.headName && (e.headName = String(A.headName)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.headName = ""),
                  null != A.headName && A.hasOwnProperty("headName") && (t.headName = A.headName),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.Resume";
              }),
              A
            );
          })()),
          (A.DisplayLayoutCapabilities = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.supportClientResize = !1),
              (A.prototype.supportClientDpi = !1),
              (A.prototype.maxLayoutArea = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.maxHeads = 0),
              (A.prototype.maxHeadResolution = null),
              (A.prototype.minHeadResolution = null),
              (A.prototype.webClientMaxHeadResolution = null),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.supportClientResize &&
                    Object.hasOwnProperty.call(A, "supportClientResize") &&
                    e.uint32(8).bool(A.supportClientResize),
                  null != A.supportClientDpi &&
                    Object.hasOwnProperty.call(A, "supportClientDpi") &&
                    e.uint32(16).bool(A.supportClientDpi),
                  null != A.maxLayoutArea &&
                    Object.hasOwnProperty.call(A, "maxLayoutArea") &&
                    e.uint32(80).uint64(A.maxLayoutArea),
                  null != A.maxHeads &&
                    Object.hasOwnProperty.call(A, "maxHeads") &&
                    e.uint32(160).uint32(A.maxHeads),
                  null != A.maxHeadResolution &&
                    Object.hasOwnProperty.call(A, "maxHeadResolution") &&
                    Rr.dcv.display.RectSize.encode(
                      A.maxHeadResolution,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.minHeadResolution &&
                    Object.hasOwnProperty.call(A, "minHeadResolution") &&
                    Rr.dcv.display.RectSize.encode(
                      A.minHeadResolution,
                      e.uint32(250).fork()
                    ).ldelim(),
                  null != A.webClientMaxHeadResolution &&
                    Object.hasOwnProperty.call(A, "webClientMaxHeadResolution") &&
                    Rr.dcv.display.RectSize.encode(
                      A.webClientMaxHeadResolution,
                      e.uint32(258).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.DisplayLayoutCapabilities();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.supportClientResize = A.bool();
                      break;
                    case 2:
                      i.supportClientDpi = A.bool();
                      break;
                    case 10:
                      i.maxLayoutArea = A.uint64();
                      break;
                    case 20:
                      i.maxHeads = A.uint32();
                      break;
                    case 30:
                      i.maxHeadResolution = Rr.dcv.display.RectSize.decode(A, A.uint32());
                      break;
                    case 31:
                      i.minHeadResolution = Rr.dcv.display.RectSize.decode(A, A.uint32());
                      break;
                    case 32:
                      i.webClientMaxHeadResolution = Rr.dcv.display.RectSize.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.supportClientResize &&
                  A.hasOwnProperty("supportClientResize") &&
                  "boolean" != typeof A.supportClientResize
                )
                  return "supportClientResize: boolean expected";
                if (
                  null != A.supportClientDpi &&
                  A.hasOwnProperty("supportClientDpi") &&
                  "boolean" != typeof A.supportClientDpi
                )
                  return "supportClientDpi: boolean expected";
                if (
                  null != A.maxLayoutArea &&
                  A.hasOwnProperty("maxLayoutArea") &&
                  !(
                    Sr.isInteger(A.maxLayoutArea) ||
                    (A.maxLayoutArea &&
                      Sr.isInteger(A.maxLayoutArea.low) &&
                      Sr.isInteger(A.maxLayoutArea.high))
                  )
                )
                  return "maxLayoutArea: integer|Long expected";
                if (null != A.maxHeads && A.hasOwnProperty("maxHeads") && !Sr.isInteger(A.maxHeads))
                  return "maxHeads: integer expected";
                if (null != A.maxHeadResolution && A.hasOwnProperty("maxHeadResolution")) {
                  let e = Rr.dcv.display.RectSize.verify(A.maxHeadResolution);
                  if (e) return "maxHeadResolution." + e;
                }
                if (null != A.minHeadResolution && A.hasOwnProperty("minHeadResolution")) {
                  let e = Rr.dcv.display.RectSize.verify(A.minHeadResolution);
                  if (e) return "minHeadResolution." + e;
                }
                if (
                  null != A.webClientMaxHeadResolution &&
                  A.hasOwnProperty("webClientMaxHeadResolution")
                ) {
                  let e = Rr.dcv.display.RectSize.verify(A.webClientMaxHeadResolution);
                  if (e) return "webClientMaxHeadResolution." + e;
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.DisplayLayoutCapabilities) return A;
                let e = new Rr.dcv.display.DisplayLayoutCapabilities();
                if (
                  (null != A.supportClientResize &&
                    (e.supportClientResize = Boolean(A.supportClientResize)),
                  null != A.supportClientDpi && (e.supportClientDpi = Boolean(A.supportClientDpi)),
                  null != A.maxLayoutArea &&
                    (Sr.Long
                      ? ((e.maxLayoutArea = Sr.Long.fromValue(A.maxLayoutArea)).unsigned = !0)
                      : "string" == typeof A.maxLayoutArea
                        ? (e.maxLayoutArea = parseInt(A.maxLayoutArea, 10))
                        : "number" == typeof A.maxLayoutArea
                          ? (e.maxLayoutArea = A.maxLayoutArea)
                          : "object" == typeof A.maxLayoutArea &&
                            (e.maxLayoutArea = new Sr.LongBits(
                              A.maxLayoutArea.low >>> 0,
                              A.maxLayoutArea.high >>> 0
                            ).toNumber(!0))),
                  null != A.maxHeads && (e.maxHeads = A.maxHeads >>> 0),
                  null != A.maxHeadResolution)
                ) {
                  if ("object" != typeof A.maxHeadResolution)
                    throw TypeError(
                      ".dcv.display.DisplayLayoutCapabilities.maxHeadResolution: object expected"
                    );
                  e.maxHeadResolution = Rr.dcv.display.RectSize.fromObject(A.maxHeadResolution);
                }
                if (null != A.minHeadResolution) {
                  if ("object" != typeof A.minHeadResolution)
                    throw TypeError(
                      ".dcv.display.DisplayLayoutCapabilities.minHeadResolution: object expected"
                    );
                  e.minHeadResolution = Rr.dcv.display.RectSize.fromObject(A.minHeadResolution);
                }
                if (null != A.webClientMaxHeadResolution) {
                  if ("object" != typeof A.webClientMaxHeadResolution)
                    throw TypeError(
                      ".dcv.display.DisplayLayoutCapabilities.webClientMaxHeadResolution: object expected"
                    );
                  e.webClientMaxHeadResolution = Rr.dcv.display.RectSize.fromObject(
                    A.webClientMaxHeadResolution
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (((t.supportClientResize = !1), (t.supportClientDpi = !1), Sr.Long)) {
                    let A = new Sr.Long(0, 0, !0);
                    t.maxLayoutArea =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.maxLayoutArea = e.longs === String ? "0" : 0;
                  (t.maxHeads = 0),
                    (t.maxHeadResolution = null),
                    (t.minHeadResolution = null),
                    (t.webClientMaxHeadResolution = null);
                }
                return (
                  null != A.supportClientResize &&
                    A.hasOwnProperty("supportClientResize") &&
                    (t.supportClientResize = A.supportClientResize),
                  null != A.supportClientDpi &&
                    A.hasOwnProperty("supportClientDpi") &&
                    (t.supportClientDpi = A.supportClientDpi),
                  null != A.maxLayoutArea &&
                    A.hasOwnProperty("maxLayoutArea") &&
                    ("number" == typeof A.maxLayoutArea
                      ? (t.maxLayoutArea =
                          e.longs === String ? String(A.maxLayoutArea) : A.maxLayoutArea)
                      : (t.maxLayoutArea =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.maxLayoutArea)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.maxLayoutArea.low >>> 0,
                                  A.maxLayoutArea.high >>> 0
                                ).toNumber(!0)
                              : A.maxLayoutArea)),
                  null != A.maxHeads && A.hasOwnProperty("maxHeads") && (t.maxHeads = A.maxHeads),
                  null != A.maxHeadResolution &&
                    A.hasOwnProperty("maxHeadResolution") &&
                    (t.maxHeadResolution = Rr.dcv.display.RectSize.toObject(
                      A.maxHeadResolution,
                      e
                    )),
                  null != A.minHeadResolution &&
                    A.hasOwnProperty("minHeadResolution") &&
                    (t.minHeadResolution = Rr.dcv.display.RectSize.toObject(
                      A.minHeadResolution,
                      e
                    )),
                  null != A.webClientMaxHeadResolution &&
                    A.hasOwnProperty("webClientMaxHeadResolution") &&
                    (t.webClientMaxHeadResolution = Rr.dcv.display.RectSize.toObject(
                      A.webClientMaxHeadResolution,
                      e
                    )),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.display.DisplayLayoutCapabilities"
                );
              }),
              A
            );
          })()),
          (A.Status = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "NOT_AVAILABLE")] = 0),
              (e[(A[1] = "AVAILABLE")] = 1),
              (e[(A[2] = "ACTIVE")] = 2),
              (e[(A[3] = "BUSY")] = 3),
              e
            );
          })()),
          (A.DisplayService = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "WINDOW_TRACKING")] = 0), (e[(A[1] = "SCREENSHOT")] = 1), e;
          })()),
          (A.StatusUpdate = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.displayService = 0),
              (A.prototype.displayStatus = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.displayService &&
                    Object.hasOwnProperty.call(A, "displayService") &&
                    e.uint32(8).int32(A.displayService),
                  null != A.displayStatus &&
                    Object.hasOwnProperty.call(A, "displayStatus") &&
                    e.uint32(16).int32(A.displayStatus),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.StatusUpdate();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.displayService = A.int32();
                      break;
                    case 2:
                      i.displayStatus = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.displayService && A.hasOwnProperty("displayService"))
                  switch (A.displayService) {
                    default:
                      return "displayService: enum value expected";
                    case 0:
                    case 1:
                  }
                if (null != A.displayStatus && A.hasOwnProperty("displayStatus"))
                  switch (A.displayStatus) {
                    default:
                      return "displayStatus: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.StatusUpdate) return A;
                let e = new Rr.dcv.display.StatusUpdate();
                switch (A.displayService) {
                  default:
                    if ("number" == typeof A.displayService) {
                      e.displayService = A.displayService;
                      break;
                    }
                    break;
                  case "WINDOW_TRACKING":
                  case 0:
                    e.displayService = 0;
                    break;
                  case "SCREENSHOT":
                  case 1:
                    e.displayService = 1;
                }
                switch (A.displayStatus) {
                  default:
                    if ("number" == typeof A.displayStatus) {
                      e.displayStatus = A.displayStatus;
                      break;
                    }
                    break;
                  case "NOT_AVAILABLE":
                  case 0:
                    e.displayStatus = 0;
                    break;
                  case "AVAILABLE":
                  case 1:
                    e.displayStatus = 1;
                    break;
                  case "ACTIVE":
                  case 2:
                    e.displayStatus = 2;
                    break;
                  case "BUSY":
                  case 3:
                    e.displayStatus = 3;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.displayService = e.enums === String ? "WINDOW_TRACKING" : 0),
                    (t.displayStatus = e.enums === String ? "NOT_AVAILABLE" : 0)),
                  null != A.displayService &&
                    A.hasOwnProperty("displayService") &&
                    (t.displayService =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.DisplayService[A.displayService]
                          ? A.displayService
                          : Rr.dcv.display.DisplayService[A.displayService]
                        : A.displayService),
                  null != A.displayStatus &&
                    A.hasOwnProperty("displayStatus") &&
                    (t.displayStatus =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.Status[A.displayStatus]
                          ? A.displayStatus
                          : Rr.dcv.display.Status[A.displayStatus]
                        : A.displayStatus),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.StatusUpdate";
              }),
              A
            );
          })()),
          (A.StartService = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.service = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.service &&
                    Object.hasOwnProperty.call(A, "service") &&
                    e.uint32(8).int32(A.service),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.StartService();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.service = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.service && A.hasOwnProperty("service"))
                  switch (A.service) {
                    default:
                      return "service: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.StartService) return A;
                let e = new Rr.dcv.display.StartService();
                switch (A.service) {
                  default:
                    if ("number" == typeof A.service) {
                      e.service = A.service;
                      break;
                    }
                    break;
                  case "WINDOW_TRACKING":
                  case 0:
                    e.service = 0;
                    break;
                  case "SCREENSHOT":
                  case 1:
                    e.service = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.service = e.enums === String ? "WINDOW_TRACKING" : 0),
                  null != A.service &&
                    A.hasOwnProperty("service") &&
                    (t.service =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.DisplayService[A.service]
                          ? A.service
                          : Rr.dcv.display.DisplayService[A.service]
                        : A.service),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.StartService";
              }),
              A
            );
          })()),
          (A.StopService = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.service = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.service &&
                    Object.hasOwnProperty.call(A, "service") &&
                    e.uint32(8).int32(A.service),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.StopService();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.service = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.service && A.hasOwnProperty("service"))
                  switch (A.service) {
                    default:
                      return "service: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.StopService) return A;
                let e = new Rr.dcv.display.StopService();
                switch (A.service) {
                  default:
                    if ("number" == typeof A.service) {
                      e.service = A.service;
                      break;
                    }
                    break;
                  case "WINDOW_TRACKING":
                  case 0:
                    e.service = 0;
                    break;
                  case "SCREENSHOT":
                  case 1:
                    e.service = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.service = e.enums === String ? "WINDOW_TRACKING" : 0),
                  null != A.service &&
                    A.hasOwnProperty("service") &&
                    (t.service =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.DisplayService[A.service]
                          ? A.service
                          : Rr.dcv.display.DisplayService[A.service]
                        : A.service),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.StopService";
              }),
              A
            );
          })()),
          (A.WindowDataRectangle = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.width = 0),
              (A.prototype.height = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(8).int32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(16).int32(A.y),
                  null != A.width &&
                    Object.hasOwnProperty.call(A, "width") &&
                    e.uint32(24).uint32(A.width),
                  null != A.height &&
                    Object.hasOwnProperty.call(A, "height") &&
                    e.uint32(32).uint32(A.height),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.WindowDataRectangle();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.x = A.int32();
                      break;
                    case 2:
                      i.y = A.int32();
                      break;
                    case 3:
                      i.width = A.uint32();
                      break;
                    case 4:
                      i.height = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.x && A.hasOwnProperty("x") && !Sr.isInteger(A.x)
                    ? "x: integer expected"
                    : null != A.y && A.hasOwnProperty("y") && !Sr.isInteger(A.y)
                      ? "y: integer expected"
                      : null != A.width && A.hasOwnProperty("width") && !Sr.isInteger(A.width)
                        ? "width: integer expected"
                        : null != A.height && A.hasOwnProperty("height") && !Sr.isInteger(A.height)
                          ? "height: integer expected"
                          : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.WindowDataRectangle) return A;
                let e = new Rr.dcv.display.WindowDataRectangle();
                return (
                  null != A.x && (e.x = 0 | A.x),
                  null != A.y && (e.y = 0 | A.y),
                  null != A.width && (e.width = A.width >>> 0),
                  null != A.height && (e.height = A.height >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.x = 0), (t.y = 0), (t.width = 0), (t.height = 0)),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                  null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.display.WindowDataRectangle"
                );
              }),
              A
            );
          })()),
          (A.WindowRestorePosition = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.windowState = 0),
              (A.prototype.minPositionX = 0),
              (A.prototype.minPositionY = 0),
              (A.prototype.maxPositionX = 0),
              (A.prototype.maxPositionY = 0),
              (A.prototype.normalPositionRect = null),
              (A.prototype.restoreToMaximized = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.windowState &&
                    Object.hasOwnProperty.call(A, "windowState") &&
                    e.uint32(8).int32(A.windowState),
                  null != A.minPositionX &&
                    Object.hasOwnProperty.call(A, "minPositionX") &&
                    e.uint32(16).int32(A.minPositionX),
                  null != A.minPositionY &&
                    Object.hasOwnProperty.call(A, "minPositionY") &&
                    e.uint32(24).int32(A.minPositionY),
                  null != A.maxPositionX &&
                    Object.hasOwnProperty.call(A, "maxPositionX") &&
                    e.uint32(32).int32(A.maxPositionX),
                  null != A.maxPositionY &&
                    Object.hasOwnProperty.call(A, "maxPositionY") &&
                    e.uint32(40).int32(A.maxPositionY),
                  null != A.normalPositionRect &&
                    Object.hasOwnProperty.call(A, "normalPositionRect") &&
                    Rr.dcv.display.WindowDataRectangle.encode(
                      A.normalPositionRect,
                      e.uint32(50).fork()
                    ).ldelim(),
                  null != A.restoreToMaximized &&
                    Object.hasOwnProperty.call(A, "restoreToMaximized") &&
                    e.uint32(56).bool(A.restoreToMaximized),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.WindowRestorePosition();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.windowState = A.int32();
                      break;
                    case 2:
                      i.minPositionX = A.int32();
                      break;
                    case 3:
                      i.minPositionY = A.int32();
                      break;
                    case 4:
                      i.maxPositionX = A.int32();
                      break;
                    case 5:
                      i.maxPositionY = A.int32();
                      break;
                    case 6:
                      i.normalPositionRect = Rr.dcv.display.WindowDataRectangle.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 7:
                      i.restoreToMaximized = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.windowState && A.hasOwnProperty("windowState"))
                  switch (A.windowState) {
                    default:
                      return "windowState: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                if (
                  null != A.minPositionX &&
                  A.hasOwnProperty("minPositionX") &&
                  !Sr.isInteger(A.minPositionX)
                )
                  return "minPositionX: integer expected";
                if (
                  null != A.minPositionY &&
                  A.hasOwnProperty("minPositionY") &&
                  !Sr.isInteger(A.minPositionY)
                )
                  return "minPositionY: integer expected";
                if (
                  null != A.maxPositionX &&
                  A.hasOwnProperty("maxPositionX") &&
                  !Sr.isInteger(A.maxPositionX)
                )
                  return "maxPositionX: integer expected";
                if (
                  null != A.maxPositionY &&
                  A.hasOwnProperty("maxPositionY") &&
                  !Sr.isInteger(A.maxPositionY)
                )
                  return "maxPositionY: integer expected";
                if (null != A.normalPositionRect && A.hasOwnProperty("normalPositionRect")) {
                  let e = Rr.dcv.display.WindowDataRectangle.verify(A.normalPositionRect);
                  if (e) return "normalPositionRect." + e;
                }
                return null != A.restoreToMaximized &&
                  A.hasOwnProperty("restoreToMaximized") &&
                  "boolean" != typeof A.restoreToMaximized
                  ? "restoreToMaximized: boolean expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.WindowRestorePosition) return A;
                let e = new Rr.dcv.display.WindowRestorePosition();
                switch (A.windowState) {
                  default:
                    if ("number" == typeof A.windowState) {
                      e.windowState = A.windowState;
                      break;
                    }
                    break;
                  case "WINDOWDATA_RESTORESTATE_STANDARD":
                  case 0:
                    e.windowState = 0;
                    break;
                  case "WINDOWDATA_RESTORESTATE_MINIMIZED":
                  case 1:
                    e.windowState = 1;
                    break;
                  case "WINDOWDATA_RESTORESTATE_MAXIMIZED":
                  case 2:
                    e.windowState = 2;
                }
                if (
                  (null != A.minPositionX && (e.minPositionX = 0 | A.minPositionX),
                  null != A.minPositionY && (e.minPositionY = 0 | A.minPositionY),
                  null != A.maxPositionX && (e.maxPositionX = 0 | A.maxPositionX),
                  null != A.maxPositionY && (e.maxPositionY = 0 | A.maxPositionY),
                  null != A.normalPositionRect)
                ) {
                  if ("object" != typeof A.normalPositionRect)
                    throw TypeError(
                      ".dcv.display.WindowRestorePosition.normalPositionRect: object expected"
                    );
                  e.normalPositionRect = Rr.dcv.display.WindowDataRectangle.fromObject(
                    A.normalPositionRect
                  );
                }
                return (
                  null != A.restoreToMaximized &&
                    (e.restoreToMaximized = Boolean(A.restoreToMaximized)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.windowState = e.enums === String ? "WINDOWDATA_RESTORESTATE_STANDARD" : 0),
                    (t.minPositionX = 0),
                    (t.minPositionY = 0),
                    (t.maxPositionX = 0),
                    (t.maxPositionY = 0),
                    (t.normalPositionRect = null),
                    (t.restoreToMaximized = !1)),
                  null != A.windowState &&
                    A.hasOwnProperty("windowState") &&
                    (t.windowState =
                      e.enums === String
                        ? void 0 ===
                          Rr.dcv.display.WindowRestorePosition.WindowRestoreState[A.windowState]
                          ? A.windowState
                          : Rr.dcv.display.WindowRestorePosition.WindowRestoreState[A.windowState]
                        : A.windowState),
                  null != A.minPositionX &&
                    A.hasOwnProperty("minPositionX") &&
                    (t.minPositionX = A.minPositionX),
                  null != A.minPositionY &&
                    A.hasOwnProperty("minPositionY") &&
                    (t.minPositionY = A.minPositionY),
                  null != A.maxPositionX &&
                    A.hasOwnProperty("maxPositionX") &&
                    (t.maxPositionX = A.maxPositionX),
                  null != A.maxPositionY &&
                    A.hasOwnProperty("maxPositionY") &&
                    (t.maxPositionY = A.maxPositionY),
                  null != A.normalPositionRect &&
                    A.hasOwnProperty("normalPositionRect") &&
                    (t.normalPositionRect = Rr.dcv.display.WindowDataRectangle.toObject(
                      A.normalPositionRect,
                      e
                    )),
                  null != A.restoreToMaximized &&
                    A.hasOwnProperty("restoreToMaximized") &&
                    (t.restoreToMaximized = A.restoreToMaximized),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.display.WindowRestorePosition"
                );
              }),
              (A.WindowRestoreState = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "WINDOWDATA_RESTORESTATE_STANDARD")] = 0),
                  (e[(A[1] = "WINDOWDATA_RESTORESTATE_MINIMIZED")] = 1),
                  (e[(A[2] = "WINDOWDATA_RESTORESTATE_MAXIMIZED")] = 2),
                  e
                );
              })()),
              A
            );
          })()),
          (A.WindowSizeLimits = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.minWidth = 0),
              (A.prototype.minHeight = 0),
              (A.prototype.maxWidth = 0),
              (A.prototype.maxHeight = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.minWidth &&
                    Object.hasOwnProperty.call(A, "minWidth") &&
                    e.uint32(8).uint32(A.minWidth),
                  null != A.minHeight &&
                    Object.hasOwnProperty.call(A, "minHeight") &&
                    e.uint32(16).uint32(A.minHeight),
                  null != A.maxWidth &&
                    Object.hasOwnProperty.call(A, "maxWidth") &&
                    e.uint32(24).uint32(A.maxWidth),
                  null != A.maxHeight &&
                    Object.hasOwnProperty.call(A, "maxHeight") &&
                    e.uint32(32).uint32(A.maxHeight),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.WindowSizeLimits();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.minWidth = A.uint32();
                      break;
                    case 2:
                      i.minHeight = A.uint32();
                      break;
                    case 3:
                      i.maxWidth = A.uint32();
                      break;
                    case 4:
                      i.maxHeight = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.minWidth && A.hasOwnProperty("minWidth") && !Sr.isInteger(A.minWidth)
                    ? "minWidth: integer expected"
                    : null != A.minHeight &&
                        A.hasOwnProperty("minHeight") &&
                        !Sr.isInteger(A.minHeight)
                      ? "minHeight: integer expected"
                      : null != A.maxWidth &&
                          A.hasOwnProperty("maxWidth") &&
                          !Sr.isInteger(A.maxWidth)
                        ? "maxWidth: integer expected"
                        : null != A.maxHeight &&
                            A.hasOwnProperty("maxHeight") &&
                            !Sr.isInteger(A.maxHeight)
                          ? "maxHeight: integer expected"
                          : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.WindowSizeLimits) return A;
                let e = new Rr.dcv.display.WindowSizeLimits();
                return (
                  null != A.minWidth && (e.minWidth = A.minWidth >>> 0),
                  null != A.minHeight && (e.minHeight = A.minHeight >>> 0),
                  null != A.maxWidth && (e.maxWidth = A.maxWidth >>> 0),
                  null != A.maxHeight && (e.maxHeight = A.maxHeight >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.minWidth = 0), (t.minHeight = 0), (t.maxWidth = 0), (t.maxHeight = 0)),
                  null != A.minWidth && A.hasOwnProperty("minWidth") && (t.minWidth = A.minWidth),
                  null != A.minHeight &&
                    A.hasOwnProperty("minHeight") &&
                    (t.minHeight = A.minHeight),
                  null != A.maxWidth && A.hasOwnProperty("maxWidth") && (t.maxWidth = A.maxWidth),
                  null != A.maxHeight &&
                    A.hasOwnProperty("maxHeight") &&
                    (t.maxHeight = A.maxHeight),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.WindowSizeLimits"
                );
              }),
              A
            );
          })()),
          (A.PayloadImage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.payloadOffset = 0),
              (A.prototype.payloadLength = 0),
              (A.prototype.width = 0),
              (A.prototype.height = 0),
              (A.prototype.format = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.payloadOffset &&
                    Object.hasOwnProperty.call(A, "payloadOffset") &&
                    e.uint32(8).uint32(A.payloadOffset),
                  null != A.payloadLength &&
                    Object.hasOwnProperty.call(A, "payloadLength") &&
                    e.uint32(16).uint32(A.payloadLength),
                  null != A.width &&
                    Object.hasOwnProperty.call(A, "width") &&
                    e.uint32(24).uint32(A.width),
                  null != A.height &&
                    Object.hasOwnProperty.call(A, "height") &&
                    e.uint32(32).uint32(A.height),
                  null != A.format &&
                    Object.hasOwnProperty.call(A, "format") &&
                    e.uint32(40).int32(A.format),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.PayloadImage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.payloadOffset = A.uint32();
                      break;
                    case 2:
                      i.payloadLength = A.uint32();
                      break;
                    case 3:
                      i.width = A.uint32();
                      break;
                    case 4:
                      i.height = A.uint32();
                      break;
                    case 5:
                      i.format = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.payloadOffset &&
                  A.hasOwnProperty("payloadOffset") &&
                  !Sr.isInteger(A.payloadOffset)
                )
                  return "payloadOffset: integer expected";
                if (
                  null != A.payloadLength &&
                  A.hasOwnProperty("payloadLength") &&
                  !Sr.isInteger(A.payloadLength)
                )
                  return "payloadLength: integer expected";
                if (null != A.width && A.hasOwnProperty("width") && !Sr.isInteger(A.width))
                  return "width: integer expected";
                if (null != A.height && A.hasOwnProperty("height") && !Sr.isInteger(A.height))
                  return "height: integer expected";
                if (null != A.format && A.hasOwnProperty("format"))
                  switch (A.format) {
                    default:
                      return "format: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.PayloadImage) return A;
                let e = new Rr.dcv.display.PayloadImage();
                switch (
                  (null != A.payloadOffset && (e.payloadOffset = A.payloadOffset >>> 0),
                  null != A.payloadLength && (e.payloadLength = A.payloadLength >>> 0),
                  null != A.width && (e.width = A.width >>> 0),
                  null != A.height && (e.height = A.height >>> 0),
                  A.format)
                ) {
                  default:
                    if ("number" == typeof A.format) {
                      e.format = A.format;
                      break;
                    }
                    break;
                  case "PAYLOAD_IMAGE_FORMAT_RAW_ARGB32":
                  case 0:
                    e.format = 0;
                    break;
                  case "PAYLOAD_IMAGE_FORMAT_JPEG":
                  case 1:
                    e.format = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.payloadOffset = 0),
                    (t.payloadLength = 0),
                    (t.width = 0),
                    (t.height = 0),
                    (t.format = e.enums === String ? "PAYLOAD_IMAGE_FORMAT_RAW_ARGB32" : 0)),
                  null != A.payloadOffset &&
                    A.hasOwnProperty("payloadOffset") &&
                    (t.payloadOffset = A.payloadOffset),
                  null != A.payloadLength &&
                    A.hasOwnProperty("payloadLength") &&
                    (t.payloadLength = A.payloadLength),
                  null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                  null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                  null != A.format &&
                    A.hasOwnProperty("format") &&
                    (t.format =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.PayloadImage.PayloadImageFormat[A.format]
                          ? A.format
                          : Rr.dcv.display.PayloadImage.PayloadImageFormat[A.format]
                        : A.format),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.PayloadImage";
              }),
              (A.PayloadImageFormat = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "PAYLOAD_IMAGE_FORMAT_RAW_ARGB32")] = 0),
                  (e[(A[1] = "PAYLOAD_IMAGE_FORMAT_JPEG")] = 1),
                  e
                );
              })()),
              A
            );
          })()),
          (A.SeamlessCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.command = 0),
              (A.prototype.windowId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.windowRect = null),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.command &&
                    Object.hasOwnProperty.call(A, "command") &&
                    e.uint32(8).int32(A.command),
                  null != A.windowId &&
                    Object.hasOwnProperty.call(A, "windowId") &&
                    e.uint32(16).uint64(A.windowId),
                  null != A.windowRect &&
                    Object.hasOwnProperty.call(A, "windowRect") &&
                    Rr.dcv.display.WindowDataRectangle.encode(
                      A.windowRect,
                      e.uint32(26).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.SeamlessCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.command = A.int32();
                      break;
                    case 2:
                      i.windowId = A.uint64();
                      break;
                    case 3:
                      i.windowRect = Rr.dcv.display.WindowDataRectangle.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.command && A.hasOwnProperty("command"))
                  switch (A.command) {
                    default:
                      return "command: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                  }
                if (
                  null != A.windowId &&
                  A.hasOwnProperty("windowId") &&
                  !(
                    Sr.isInteger(A.windowId) ||
                    (A.windowId && Sr.isInteger(A.windowId.low) && Sr.isInteger(A.windowId.high))
                  )
                )
                  return "windowId: integer|Long expected";
                if (null != A.windowRect && A.hasOwnProperty("windowRect")) {
                  let e = Rr.dcv.display.WindowDataRectangle.verify(A.windowRect);
                  if (e) return "windowRect." + e;
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.SeamlessCommand) return A;
                let e = new Rr.dcv.display.SeamlessCommand();
                switch (A.command) {
                  default:
                    if ("number" == typeof A.command) {
                      e.command = A.command;
                      break;
                    }
                    break;
                  case "WINDOW_SETFOREGROUND":
                  case 0:
                    e.command = 0;
                    break;
                  case "WINDOW_RESTORE":
                  case 1:
                    e.command = 1;
                    break;
                  case "WINDOW_CLOSE":
                  case 2:
                    e.command = 2;
                    break;
                  case "WINDOW_LEAVEAPP":
                  case 3:
                    e.command = 3;
                    break;
                  case "WINDOW_MINIMIZE":
                  case 4:
                    e.command = 4;
                    break;
                  case "WINDOW_RECT":
                  case 5:
                    e.command = 5;
                    break;
                  case "WINDOW_MAXIMIZE":
                  case 6:
                    e.command = 6;
                    break;
                  case "WINDOW_SEND_PREVIEW":
                  case 7:
                    e.command = 7;
                }
                if (
                  (null != A.windowId &&
                    (Sr.Long
                      ? ((e.windowId = Sr.Long.fromValue(A.windowId)).unsigned = !0)
                      : "string" == typeof A.windowId
                        ? (e.windowId = parseInt(A.windowId, 10))
                        : "number" == typeof A.windowId
                          ? (e.windowId = A.windowId)
                          : "object" == typeof A.windowId &&
                            (e.windowId = new Sr.LongBits(
                              A.windowId.low >>> 0,
                              A.windowId.high >>> 0
                            ).toNumber(!0))),
                  null != A.windowRect)
                ) {
                  if ("object" != typeof A.windowRect)
                    throw TypeError(".dcv.display.SeamlessCommand.windowRect: object expected");
                  e.windowRect = Rr.dcv.display.WindowDataRectangle.fromObject(A.windowRect);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (((t.command = e.enums === String ? "WINDOW_SETFOREGROUND" : 0), Sr.Long)) {
                    let A = new Sr.Long(0, 0, !0);
                    t.windowId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.windowId = e.longs === String ? "0" : 0;
                  t.windowRect = null;
                }
                return (
                  null != A.command &&
                    A.hasOwnProperty("command") &&
                    (t.command =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.SeamlessCommand.Command[A.command]
                          ? A.command
                          : Rr.dcv.display.SeamlessCommand.Command[A.command]
                        : A.command),
                  null != A.windowId &&
                    A.hasOwnProperty("windowId") &&
                    ("number" == typeof A.windowId
                      ? (t.windowId = e.longs === String ? String(A.windowId) : A.windowId)
                      : (t.windowId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.windowId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.windowId.low >>> 0,
                                  A.windowId.high >>> 0
                                ).toNumber(!0)
                              : A.windowId)),
                  null != A.windowRect &&
                    A.hasOwnProperty("windowRect") &&
                    (t.windowRect = Rr.dcv.display.WindowDataRectangle.toObject(A.windowRect, e)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.SeamlessCommand"
                );
              }),
              (A.Command = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "WINDOW_SETFOREGROUND")] = 0),
                  (e[(A[1] = "WINDOW_RESTORE")] = 1),
                  (e[(A[2] = "WINDOW_CLOSE")] = 2),
                  (e[(A[3] = "WINDOW_LEAVEAPP")] = 3),
                  (e[(A[4] = "WINDOW_MINIMIZE")] = 4),
                  (e[(A[5] = "WINDOW_RECT")] = 5),
                  (e[(A[6] = "WINDOW_MAXIMIZE")] = 6),
                  (e[(A[7] = "WINDOW_SEND_PREVIEW")] = 7),
                  e
                );
              })()),
              A
            );
          })()),
          (A.WorkareaLayoutRequest = (function () {
            function A(A) {
              if (((this.rects = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.rects = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ur.create()), null != A.rects && A.rects.length))
                  for (let t = 0; t < A.rects.length; ++t)
                    Rr.dcv.display.Rect.encode(A.rects[t], e.uint32(82).fork()).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.WorkareaLayoutRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10)
                    (i.rects && i.rects.length) || (i.rects = []),
                      i.rects.push(Rr.dcv.display.Rect.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.rects && A.hasOwnProperty("rects")) {
                  if (!Array.isArray(A.rects)) return "rects: array expected";
                  for (let e = 0; e < A.rects.length; ++e) {
                    let t = Rr.dcv.display.Rect.verify(A.rects[e]);
                    if (t) return "rects." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.WorkareaLayoutRequest) return A;
                let e = new Rr.dcv.display.WorkareaLayoutRequest();
                if (A.rects) {
                  if (!Array.isArray(A.rects))
                    throw TypeError(".dcv.display.WorkareaLayoutRequest.rects: array expected");
                  e.rects = [];
                  for (let t = 0; t < A.rects.length; ++t) {
                    if ("object" != typeof A.rects[t])
                      throw TypeError(".dcv.display.WorkareaLayoutRequest.rects: object expected");
                    e.rects[t] = Rr.dcv.display.Rect.fromObject(A.rects[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.rects = []), A.rects && A.rects.length)) {
                  t.rects = [];
                  for (let i = 0; i < A.rects.length; ++i)
                    t.rects[i] = Rr.dcv.display.Rect.toObject(A.rects[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.display.WorkareaLayoutRequest"
                );
              }),
              A
            );
          })()),
          (A.SeamlessData = (function () {
            function A(A) {
              if (((this.windows = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.windows = Sr.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ur.create()), null != A.windows && A.windows.length))
                  for (let t = 0; t < A.windows.length; ++t)
                    Rr.dcv.display.SeamlessData.WindowData.encode(
                      A.windows[t],
                      e.uint32(18).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.SeamlessData();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 2)
                    (i.windows && i.windows.length) || (i.windows = []),
                      i.windows.push(Rr.dcv.display.SeamlessData.WindowData.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.windows && A.hasOwnProperty("windows")) {
                  if (!Array.isArray(A.windows)) return "windows: array expected";
                  for (let e = 0; e < A.windows.length; ++e) {
                    let t = Rr.dcv.display.SeamlessData.WindowData.verify(A.windows[e]);
                    if (t) return "windows." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.SeamlessData) return A;
                let e = new Rr.dcv.display.SeamlessData();
                if (A.windows) {
                  if (!Array.isArray(A.windows))
                    throw TypeError(".dcv.display.SeamlessData.windows: array expected");
                  e.windows = [];
                  for (let t = 0; t < A.windows.length; ++t) {
                    if ("object" != typeof A.windows[t])
                      throw TypeError(".dcv.display.SeamlessData.windows: object expected");
                    e.windows[t] = Rr.dcv.display.SeamlessData.WindowData.fromObject(A.windows[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.windows = []), A.windows && A.windows.length)) {
                  t.windows = [];
                  for (let i = 0; i < A.windows.length; ++i)
                    t.windows[i] = Rr.dcv.display.SeamlessData.WindowData.toObject(A.windows[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.SeamlessData";
              }),
              (A.WindowState = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "WINDOWDATA_STATE_ERROR")] = 0),
                  (e[(A[1] = "WINDOWDATA_STATE_STANDARD")] = 1),
                  (e[(A[2] = "WINDOWDATA_STATE_MINIMIZED")] = 2),
                  (e[(A[3] = "WINDOWDATA_STATE_MAXIMIZED")] = 3),
                  (e[(A[4] = "WINDOWDATA_STATE_HIDDEN")] = 4),
                  (e[(A[13] = "WINDOWDATA_STATE_DESTROYED")] = 13),
                  e
                );
              })()),
              (A.WindowDataUpdate = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "WINDOWDATA_UPDATE_NONE")] = 0),
                  (e[(A[1] = "WINDOWDATA_UPDATE_DESTROYED")] = 1),
                  (e[(A[2] = "WINDOWDATA_UPDATE_PROCESS_INFO")] = 2),
                  (e[(A[4] = "WINDOWDATA_UPDATE_STATE_INFO")] = 4),
                  (e[(A[8] = "WINDOWDATA_UPDATE_TITLE")] = 8),
                  (e[(A[16] = "WINDOWDATA_UPDATE_ICON")] = 16),
                  (e[(A[32] = "WINDOWDATA_UPDATE_PREVIEW")] = 32),
                  (e[(A[64] = "WINDOWDATA_UPDATE_CREATED")] = 64),
                  (e[(A[128] = "WINDOWDATA_UPDATE_LOCATION_SIZE")] = 128),
                  (e[(A[256] = "WINDOWDATA_UPDATE_SIZE_LIMITS")] = 256),
                  (e[(A[512] = "WINDOWDATA_UPDATE_RESTORE_POSITION")] = 512),
                  (e[(A[1024] = "WINDOWDATA_UPDATE_CLIP_AREA")] = 1024),
                  e
                );
              })()),
              (A.WindowDataAttributes = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "WINDOWDATA_ATTRIBUTE_NONE")] = 0),
                  (e[(A[1] = "WINDOWDATA_ATTRIBUTE_TASKBAR_VISIBLE")] = 1),
                  (e[(A[2] = "WINDOWDATA_ATTRIBUTE_ALWAYSONTOP")] = 2),
                  (e[(A[4] = "WINDOWDATA_ATTRIBUTE_HUNGAPP")] = 4),
                  (e[(A[8] = "WINDOWDATA_ATTRIBUTE_FOREGROUND")] = 8),
                  (e[(A[16] = "WINDOWDATA_ATTRIBUTE_RESIZABLE")] = 16),
                  (e[(A[32] = "WINDOWDATA_ATTRIBUTE_MINIMIZABLE")] = 32),
                  (e[(A[64] = "WINDOWDATA_ATTRIBUTE_MAXIMIZABLE")] = 64),
                  e
                );
              })()),
              (A.WindowDataClipAreaType = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "WINDOWDATA_CLIPAREATYPE_FULL")] = 0),
                  (e[(A[1] = "WINDOWDATA_CLIPAREATYPE_RECT")] = 1),
                  (e[(A[2] = "WINDOWDATA_CLIPAREATYPE_SHAPE")] = 2),
                  e
                );
              })()),
              (A.WindowData = (function () {
                function A(A) {
                  if (((this.clipareaRectList = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.id = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.windowRect = null),
                  (A.prototype.state = 0),
                  (A.prototype.update = 0),
                  (A.prototype.attributes = 0),
                  (A.prototype.windowSizeLimits = null),
                  (A.prototype.ownerId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.windowRestorePosition = null),
                  (A.prototype.zOrder = 0),
                  (A.prototype.clipAreaType = 0),
                  (A.prototype.clipareaBoundingBox = null),
                  (A.prototype.clipareaRectList = Sr.emptyArray),
                  (A.prototype.processId = 0),
                  (A.prototype.processName = ""),
                  (A.prototype.title = ""),
                  (A.prototype.iconLarge = null),
                  (A.prototype.iconSmall = null),
                  (A.prototype.previewImage = null),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ur.create()),
                      null != A.id &&
                        Object.hasOwnProperty.call(A, "id") &&
                        e.uint32(8).uint64(A.id),
                      null != A.windowRect &&
                        Object.hasOwnProperty.call(A, "windowRect") &&
                        Rr.dcv.display.WindowDataRectangle.encode(
                          A.windowRect,
                          e.uint32(18).fork()
                        ).ldelim(),
                      null != A.state &&
                        Object.hasOwnProperty.call(A, "state") &&
                        e.uint32(24).int32(A.state),
                      null != A.update &&
                        Object.hasOwnProperty.call(A, "update") &&
                        e.uint32(32).int32(A.update),
                      null != A.attributes &&
                        Object.hasOwnProperty.call(A, "attributes") &&
                        e.uint32(40).uint32(A.attributes),
                      null != A.windowSizeLimits &&
                        Object.hasOwnProperty.call(A, "windowSizeLimits") &&
                        Rr.dcv.display.WindowSizeLimits.encode(
                          A.windowSizeLimits,
                          e.uint32(50).fork()
                        ).ldelim(),
                      null != A.ownerId &&
                        Object.hasOwnProperty.call(A, "ownerId") &&
                        e.uint32(56).uint64(A.ownerId),
                      null != A.windowRestorePosition &&
                        Object.hasOwnProperty.call(A, "windowRestorePosition") &&
                        Rr.dcv.display.WindowRestorePosition.encode(
                          A.windowRestorePosition,
                          e.uint32(66).fork()
                        ).ldelim(),
                      null != A.zOrder &&
                        Object.hasOwnProperty.call(A, "zOrder") &&
                        e.uint32(72).uint32(A.zOrder),
                      null != A.clipAreaType &&
                        Object.hasOwnProperty.call(A, "clipAreaType") &&
                        e.uint32(80).int32(A.clipAreaType),
                      null != A.clipareaBoundingBox &&
                        Object.hasOwnProperty.call(A, "clipareaBoundingBox") &&
                        Rr.dcv.display.WindowDataRectangle.encode(
                          A.clipareaBoundingBox,
                          e.uint32(90).fork()
                        ).ldelim(),
                      null != A.clipareaRectList && A.clipareaRectList.length)
                    )
                      for (let t = 0; t < A.clipareaRectList.length; ++t)
                        Rr.dcv.display.WindowDataRectangle.encode(
                          A.clipareaRectList[t],
                          e.uint32(98).fork()
                        ).ldelim();
                    return (
                      null != A.processId &&
                        Object.hasOwnProperty.call(A, "processId") &&
                        e.uint32(160).uint32(A.processId),
                      null != A.processName &&
                        Object.hasOwnProperty.call(A, "processName") &&
                        e.uint32(170).string(A.processName),
                      null != A.title &&
                        Object.hasOwnProperty.call(A, "title") &&
                        e.uint32(242).string(A.title),
                      null != A.iconLarge &&
                        Object.hasOwnProperty.call(A, "iconLarge") &&
                        Rr.dcv.display.PayloadImage.encode(
                          A.iconLarge,
                          e.uint32(322).fork()
                        ).ldelim(),
                      null != A.iconSmall &&
                        Object.hasOwnProperty.call(A, "iconSmall") &&
                        Rr.dcv.display.PayloadImage.encode(
                          A.iconSmall,
                          e.uint32(330).fork()
                        ).ldelim(),
                      null != A.previewImage &&
                        Object.hasOwnProperty.call(A, "previewImage") &&
                        Rr.dcv.display.PayloadImage.encode(
                          A.previewImage,
                          e.uint32(402).fork()
                        ).ldelim(),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof br || (A = br.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Rr.dcv.display.SeamlessData.WindowData();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.id = A.uint64();
                          break;
                        case 2:
                          i.windowRect = Rr.dcv.display.WindowDataRectangle.decode(A, A.uint32());
                          break;
                        case 3:
                          i.state = A.int32();
                          break;
                        case 4:
                          i.update = A.int32();
                          break;
                        case 5:
                          i.attributes = A.uint32();
                          break;
                        case 6:
                          i.windowSizeLimits = Rr.dcv.display.WindowSizeLimits.decode(
                            A,
                            A.uint32()
                          );
                          break;
                        case 7:
                          i.ownerId = A.uint64();
                          break;
                        case 8:
                          i.windowRestorePosition = Rr.dcv.display.WindowRestorePosition.decode(
                            A,
                            A.uint32()
                          );
                          break;
                        case 9:
                          i.zOrder = A.uint32();
                          break;
                        case 10:
                          i.clipAreaType = A.int32();
                          break;
                        case 11:
                          i.clipareaBoundingBox = Rr.dcv.display.WindowDataRectangle.decode(
                            A,
                            A.uint32()
                          );
                          break;
                        case 12:
                          (i.clipareaRectList && i.clipareaRectList.length) ||
                            (i.clipareaRectList = []),
                            i.clipareaRectList.push(
                              Rr.dcv.display.WindowDataRectangle.decode(A, A.uint32())
                            );
                          break;
                        case 20:
                          i.processId = A.uint32();
                          break;
                        case 21:
                          i.processName = A.string();
                          break;
                        case 30:
                          i.title = A.string();
                          break;
                        case 40:
                          i.iconLarge = Rr.dcv.display.PayloadImage.decode(A, A.uint32());
                          break;
                        case 41:
                          i.iconSmall = Rr.dcv.display.PayloadImage.decode(A, A.uint32());
                          break;
                        case 50:
                          i.previewImage = Rr.dcv.display.PayloadImage.decode(A, A.uint32());
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (
                      null != A.id &&
                      A.hasOwnProperty("id") &&
                      !(
                        Sr.isInteger(A.id) ||
                        (A.id && Sr.isInteger(A.id.low) && Sr.isInteger(A.id.high))
                      )
                    )
                      return "id: integer|Long expected";
                    if (null != A.windowRect && A.hasOwnProperty("windowRect")) {
                      let e = Rr.dcv.display.WindowDataRectangle.verify(A.windowRect);
                      if (e) return "windowRect." + e;
                    }
                    if (null != A.state && A.hasOwnProperty("state"))
                      switch (A.state) {
                        default:
                          return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 13:
                      }
                    if (null != A.update && A.hasOwnProperty("update"))
                      switch (A.update) {
                        default:
                          return "update: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                        case 8:
                        case 16:
                        case 32:
                        case 64:
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                      }
                    if (
                      null != A.attributes &&
                      A.hasOwnProperty("attributes") &&
                      !Sr.isInteger(A.attributes)
                    )
                      return "attributes: integer expected";
                    if (null != A.windowSizeLimits && A.hasOwnProperty("windowSizeLimits")) {
                      let e = Rr.dcv.display.WindowSizeLimits.verify(A.windowSizeLimits);
                      if (e) return "windowSizeLimits." + e;
                    }
                    if (
                      null != A.ownerId &&
                      A.hasOwnProperty("ownerId") &&
                      !(
                        Sr.isInteger(A.ownerId) ||
                        (A.ownerId && Sr.isInteger(A.ownerId.low) && Sr.isInteger(A.ownerId.high))
                      )
                    )
                      return "ownerId: integer|Long expected";
                    if (
                      null != A.windowRestorePosition &&
                      A.hasOwnProperty("windowRestorePosition")
                    ) {
                      let e = Rr.dcv.display.WindowRestorePosition.verify(A.windowRestorePosition);
                      if (e) return "windowRestorePosition." + e;
                    }
                    if (null != A.zOrder && A.hasOwnProperty("zOrder") && !Sr.isInteger(A.zOrder))
                      return "zOrder: integer expected";
                    if (null != A.clipAreaType && A.hasOwnProperty("clipAreaType"))
                      switch (A.clipAreaType) {
                        default:
                          return "clipAreaType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                      }
                    if (null != A.clipareaBoundingBox && A.hasOwnProperty("clipareaBoundingBox")) {
                      let e = Rr.dcv.display.WindowDataRectangle.verify(A.clipareaBoundingBox);
                      if (e) return "clipareaBoundingBox." + e;
                    }
                    if (null != A.clipareaRectList && A.hasOwnProperty("clipareaRectList")) {
                      if (!Array.isArray(A.clipareaRectList))
                        return "clipareaRectList: array expected";
                      for (let e = 0; e < A.clipareaRectList.length; ++e) {
                        let t = Rr.dcv.display.WindowDataRectangle.verify(A.clipareaRectList[e]);
                        if (t) return "clipareaRectList." + t;
                      }
                    }
                    if (
                      null != A.processId &&
                      A.hasOwnProperty("processId") &&
                      !Sr.isInteger(A.processId)
                    )
                      return "processId: integer expected";
                    if (
                      null != A.processName &&
                      A.hasOwnProperty("processName") &&
                      !Sr.isString(A.processName)
                    )
                      return "processName: string expected";
                    if (null != A.title && A.hasOwnProperty("title") && !Sr.isString(A.title))
                      return "title: string expected";
                    if (null != A.iconLarge && A.hasOwnProperty("iconLarge")) {
                      let e = Rr.dcv.display.PayloadImage.verify(A.iconLarge);
                      if (e) return "iconLarge." + e;
                    }
                    if (null != A.iconSmall && A.hasOwnProperty("iconSmall")) {
                      let e = Rr.dcv.display.PayloadImage.verify(A.iconSmall);
                      if (e) return "iconSmall." + e;
                    }
                    if (null != A.previewImage && A.hasOwnProperty("previewImage")) {
                      let e = Rr.dcv.display.PayloadImage.verify(A.previewImage);
                      if (e) return "previewImage." + e;
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Rr.dcv.display.SeamlessData.WindowData) return A;
                    let e = new Rr.dcv.display.SeamlessData.WindowData();
                    if (
                      (null != A.id &&
                        (Sr.Long
                          ? ((e.id = Sr.Long.fromValue(A.id)).unsigned = !0)
                          : "string" == typeof A.id
                            ? (e.id = parseInt(A.id, 10))
                            : "number" == typeof A.id
                              ? (e.id = A.id)
                              : "object" == typeof A.id &&
                                (e.id = new Sr.LongBits(A.id.low >>> 0, A.id.high >>> 0).toNumber(
                                  !0
                                ))),
                      null != A.windowRect)
                    ) {
                      if ("object" != typeof A.windowRect)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.windowRect: object expected"
                        );
                      e.windowRect = Rr.dcv.display.WindowDataRectangle.fromObject(A.windowRect);
                    }
                    switch (A.state) {
                      default:
                        if ("number" == typeof A.state) {
                          e.state = A.state;
                          break;
                        }
                        break;
                      case "WINDOWDATA_STATE_ERROR":
                      case 0:
                        e.state = 0;
                        break;
                      case "WINDOWDATA_STATE_STANDARD":
                      case 1:
                        e.state = 1;
                        break;
                      case "WINDOWDATA_STATE_MINIMIZED":
                      case 2:
                        e.state = 2;
                        break;
                      case "WINDOWDATA_STATE_MAXIMIZED":
                      case 3:
                        e.state = 3;
                        break;
                      case "WINDOWDATA_STATE_HIDDEN":
                      case 4:
                        e.state = 4;
                        break;
                      case "WINDOWDATA_STATE_DESTROYED":
                      case 13:
                        e.state = 13;
                    }
                    switch (A.update) {
                      default:
                        if ("number" == typeof A.update) {
                          e.update = A.update;
                          break;
                        }
                        break;
                      case "WINDOWDATA_UPDATE_NONE":
                      case 0:
                        e.update = 0;
                        break;
                      case "WINDOWDATA_UPDATE_DESTROYED":
                      case 1:
                        e.update = 1;
                        break;
                      case "WINDOWDATA_UPDATE_PROCESS_INFO":
                      case 2:
                        e.update = 2;
                        break;
                      case "WINDOWDATA_UPDATE_STATE_INFO":
                      case 4:
                        e.update = 4;
                        break;
                      case "WINDOWDATA_UPDATE_TITLE":
                      case 8:
                        e.update = 8;
                        break;
                      case "WINDOWDATA_UPDATE_ICON":
                      case 16:
                        e.update = 16;
                        break;
                      case "WINDOWDATA_UPDATE_PREVIEW":
                      case 32:
                        e.update = 32;
                        break;
                      case "WINDOWDATA_UPDATE_CREATED":
                      case 64:
                        e.update = 64;
                        break;
                      case "WINDOWDATA_UPDATE_LOCATION_SIZE":
                      case 128:
                        e.update = 128;
                        break;
                      case "WINDOWDATA_UPDATE_SIZE_LIMITS":
                      case 256:
                        e.update = 256;
                        break;
                      case "WINDOWDATA_UPDATE_RESTORE_POSITION":
                      case 512:
                        e.update = 512;
                        break;
                      case "WINDOWDATA_UPDATE_CLIP_AREA":
                      case 1024:
                        e.update = 1024;
                    }
                    if (
                      (null != A.attributes && (e.attributes = A.attributes >>> 0),
                      null != A.windowSizeLimits)
                    ) {
                      if ("object" != typeof A.windowSizeLimits)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.windowSizeLimits: object expected"
                        );
                      e.windowSizeLimits = Rr.dcv.display.WindowSizeLimits.fromObject(
                        A.windowSizeLimits
                      );
                    }
                    if (
                      (null != A.ownerId &&
                        (Sr.Long
                          ? ((e.ownerId = Sr.Long.fromValue(A.ownerId)).unsigned = !0)
                          : "string" == typeof A.ownerId
                            ? (e.ownerId = parseInt(A.ownerId, 10))
                            : "number" == typeof A.ownerId
                              ? (e.ownerId = A.ownerId)
                              : "object" == typeof A.ownerId &&
                                (e.ownerId = new Sr.LongBits(
                                  A.ownerId.low >>> 0,
                                  A.ownerId.high >>> 0
                                ).toNumber(!0))),
                      null != A.windowRestorePosition)
                    ) {
                      if ("object" != typeof A.windowRestorePosition)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.windowRestorePosition: object expected"
                        );
                      e.windowRestorePosition = Rr.dcv.display.WindowRestorePosition.fromObject(
                        A.windowRestorePosition
                      );
                    }
                    switch ((null != A.zOrder && (e.zOrder = A.zOrder >>> 0), A.clipAreaType)) {
                      default:
                        if ("number" == typeof A.clipAreaType) {
                          e.clipAreaType = A.clipAreaType;
                          break;
                        }
                        break;
                      case "WINDOWDATA_CLIPAREATYPE_FULL":
                      case 0:
                        e.clipAreaType = 0;
                        break;
                      case "WINDOWDATA_CLIPAREATYPE_RECT":
                      case 1:
                        e.clipAreaType = 1;
                        break;
                      case "WINDOWDATA_CLIPAREATYPE_SHAPE":
                      case 2:
                        e.clipAreaType = 2;
                    }
                    if (null != A.clipareaBoundingBox) {
                      if ("object" != typeof A.clipareaBoundingBox)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.clipareaBoundingBox: object expected"
                        );
                      e.clipareaBoundingBox = Rr.dcv.display.WindowDataRectangle.fromObject(
                        A.clipareaBoundingBox
                      );
                    }
                    if (A.clipareaRectList) {
                      if (!Array.isArray(A.clipareaRectList))
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.clipareaRectList: array expected"
                        );
                      e.clipareaRectList = [];
                      for (let t = 0; t < A.clipareaRectList.length; ++t) {
                        if ("object" != typeof A.clipareaRectList[t])
                          throw TypeError(
                            ".dcv.display.SeamlessData.WindowData.clipareaRectList: object expected"
                          );
                        e.clipareaRectList[t] = Rr.dcv.display.WindowDataRectangle.fromObject(
                          A.clipareaRectList[t]
                        );
                      }
                    }
                    if (
                      (null != A.processId && (e.processId = A.processId >>> 0),
                      null != A.processName && (e.processName = String(A.processName)),
                      null != A.title && (e.title = String(A.title)),
                      null != A.iconLarge)
                    ) {
                      if ("object" != typeof A.iconLarge)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.iconLarge: object expected"
                        );
                      e.iconLarge = Rr.dcv.display.PayloadImage.fromObject(A.iconLarge);
                    }
                    if (null != A.iconSmall) {
                      if ("object" != typeof A.iconSmall)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.iconSmall: object expected"
                        );
                      e.iconSmall = Rr.dcv.display.PayloadImage.fromObject(A.iconSmall);
                    }
                    if (null != A.previewImage) {
                      if ("object" != typeof A.previewImage)
                        throw TypeError(
                          ".dcv.display.SeamlessData.WindowData.previewImage: object expected"
                        );
                      e.previewImage = Rr.dcv.display.PayloadImage.fromObject(A.previewImage);
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (((e.arrays || e.defaults) && (t.clipareaRectList = []), e.defaults)) {
                      if (Sr.Long) {
                        let A = new Sr.Long(0, 0, !0);
                        t.id =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.id = e.longs === String ? "0" : 0;
                      if (
                        ((t.windowRect = null),
                        (t.state = e.enums === String ? "WINDOWDATA_STATE_ERROR" : 0),
                        (t.update = e.enums === String ? "WINDOWDATA_UPDATE_NONE" : 0),
                        (t.attributes = 0),
                        (t.windowSizeLimits = null),
                        Sr.Long)
                      ) {
                        let A = new Sr.Long(0, 0, !0);
                        t.ownerId =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.ownerId = e.longs === String ? "0" : 0;
                      (t.windowRestorePosition = null),
                        (t.zOrder = 0),
                        (t.clipAreaType = e.enums === String ? "WINDOWDATA_CLIPAREATYPE_FULL" : 0),
                        (t.clipareaBoundingBox = null),
                        (t.processId = 0),
                        (t.processName = ""),
                        (t.title = ""),
                        (t.iconLarge = null),
                        (t.iconSmall = null),
                        (t.previewImage = null);
                    }
                    if (
                      (null != A.id &&
                        A.hasOwnProperty("id") &&
                        ("number" == typeof A.id
                          ? (t.id = e.longs === String ? String(A.id) : A.id)
                          : (t.id =
                              e.longs === String
                                ? Sr.Long.prototype.toString.call(A.id)
                                : e.longs === Number
                                  ? new Sr.LongBits(A.id.low >>> 0, A.id.high >>> 0).toNumber(!0)
                                  : A.id)),
                      null != A.windowRect &&
                        A.hasOwnProperty("windowRect") &&
                        (t.windowRect = Rr.dcv.display.WindowDataRectangle.toObject(
                          A.windowRect,
                          e
                        )),
                      null != A.state &&
                        A.hasOwnProperty("state") &&
                        (t.state =
                          e.enums === String
                            ? void 0 === Rr.dcv.display.SeamlessData.WindowState[A.state]
                              ? A.state
                              : Rr.dcv.display.SeamlessData.WindowState[A.state]
                            : A.state),
                      null != A.update &&
                        A.hasOwnProperty("update") &&
                        (t.update =
                          e.enums === String
                            ? void 0 === Rr.dcv.display.SeamlessData.WindowDataUpdate[A.update]
                              ? A.update
                              : Rr.dcv.display.SeamlessData.WindowDataUpdate[A.update]
                            : A.update),
                      null != A.attributes &&
                        A.hasOwnProperty("attributes") &&
                        (t.attributes = A.attributes),
                      null != A.windowSizeLimits &&
                        A.hasOwnProperty("windowSizeLimits") &&
                        (t.windowSizeLimits = Rr.dcv.display.WindowSizeLimits.toObject(
                          A.windowSizeLimits,
                          e
                        )),
                      null != A.ownerId &&
                        A.hasOwnProperty("ownerId") &&
                        ("number" == typeof A.ownerId
                          ? (t.ownerId = e.longs === String ? String(A.ownerId) : A.ownerId)
                          : (t.ownerId =
                              e.longs === String
                                ? Sr.Long.prototype.toString.call(A.ownerId)
                                : e.longs === Number
                                  ? new Sr.LongBits(
                                      A.ownerId.low >>> 0,
                                      A.ownerId.high >>> 0
                                    ).toNumber(!0)
                                  : A.ownerId)),
                      null != A.windowRestorePosition &&
                        A.hasOwnProperty("windowRestorePosition") &&
                        (t.windowRestorePosition = Rr.dcv.display.WindowRestorePosition.toObject(
                          A.windowRestorePosition,
                          e
                        )),
                      null != A.zOrder && A.hasOwnProperty("zOrder") && (t.zOrder = A.zOrder),
                      null != A.clipAreaType &&
                        A.hasOwnProperty("clipAreaType") &&
                        (t.clipAreaType =
                          e.enums === String
                            ? void 0 ===
                              Rr.dcv.display.SeamlessData.WindowDataClipAreaType[A.clipAreaType]
                              ? A.clipAreaType
                              : Rr.dcv.display.SeamlessData.WindowDataClipAreaType[A.clipAreaType]
                            : A.clipAreaType),
                      null != A.clipareaBoundingBox &&
                        A.hasOwnProperty("clipareaBoundingBox") &&
                        (t.clipareaBoundingBox = Rr.dcv.display.WindowDataRectangle.toObject(
                          A.clipareaBoundingBox,
                          e
                        )),
                      A.clipareaRectList && A.clipareaRectList.length)
                    ) {
                      t.clipareaRectList = [];
                      for (let i = 0; i < A.clipareaRectList.length; ++i)
                        t.clipareaRectList[i] = Rr.dcv.display.WindowDataRectangle.toObject(
                          A.clipareaRectList[i],
                          e
                        );
                    }
                    return (
                      null != A.processId &&
                        A.hasOwnProperty("processId") &&
                        (t.processId = A.processId),
                      null != A.processName &&
                        A.hasOwnProperty("processName") &&
                        (t.processName = A.processName),
                      null != A.title && A.hasOwnProperty("title") && (t.title = A.title),
                      null != A.iconLarge &&
                        A.hasOwnProperty("iconLarge") &&
                        (t.iconLarge = Rr.dcv.display.PayloadImage.toObject(A.iconLarge, e)),
                      null != A.iconSmall &&
                        A.hasOwnProperty("iconSmall") &&
                        (t.iconSmall = Rr.dcv.display.PayloadImage.toObject(A.iconSmall, e)),
                      null != A.previewImage &&
                        A.hasOwnProperty("previewImage") &&
                        (t.previewImage = Rr.dcv.display.PayloadImage.toObject(A.previewImage, e)),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.display.SeamlessData.WindowData"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.SeamlessServerCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.command = 0),
              (A.prototype.serverInitiated = !1),
              (A.prototype.windowId = Sr.Long ? Sr.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.command &&
                    Object.hasOwnProperty.call(A, "command") &&
                    e.uint32(8).int32(A.command),
                  null != A.serverInitiated &&
                    Object.hasOwnProperty.call(A, "serverInitiated") &&
                    e.uint32(16).bool(A.serverInitiated),
                  null != A.windowId &&
                    Object.hasOwnProperty.call(A, "windowId") &&
                    e.uint32(24).uint64(A.windowId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.SeamlessServerCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.command = A.int32();
                      break;
                    case 2:
                      i.serverInitiated = A.bool();
                      break;
                    case 3:
                      i.windowId = A.uint64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.command && A.hasOwnProperty("command"))
                  switch (A.command) {
                    default:
                      return "command: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 11:
                    case 12:
                    case 13:
                    case 20:
                  }
                return null != A.serverInitiated &&
                  A.hasOwnProperty("serverInitiated") &&
                  "boolean" != typeof A.serverInitiated
                  ? "serverInitiated: boolean expected"
                  : null != A.windowId &&
                      A.hasOwnProperty("windowId") &&
                      !(
                        Sr.isInteger(A.windowId) ||
                        (A.windowId &&
                          Sr.isInteger(A.windowId.low) &&
                          Sr.isInteger(A.windowId.high))
                      )
                    ? "windowId: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.SeamlessServerCommand) return A;
                let e = new Rr.dcv.display.SeamlessServerCommand();
                switch (A.command) {
                  default:
                    if ("number" == typeof A.command) {
                      e.command = A.command;
                      break;
                    }
                    break;
                  case "SERVER_WINDOW_MENU_MOVE":
                  case 0:
                    e.command = 0;
                    break;
                  case "SERVER_WINDOW_MENU_SIZE":
                  case 1:
                    e.command = 1;
                    break;
                  case "SERVER_WINDOW_DRAG_MOVE":
                  case 2:
                    e.command = 2;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_TOP_LEFT":
                  case 3:
                    e.command = 3;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_TOP_CENTER":
                  case 4:
                    e.command = 4;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_TOP_RIGHT":
                  case 5:
                    e.command = 5;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_RIGHT_CENTER":
                  case 6:
                    e.command = 6;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_BOTTOM_RIGHT":
                  case 7:
                    e.command = 7;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_BOTTOM_CENTER":
                  case 8:
                    e.command = 8;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_BOTTOM_LEFT":
                  case 9:
                    e.command = 9;
                    break;
                  case "SERVER_WINDOW_DRAG_SIZE_LEFT_CENTER":
                  case 10:
                    e.command = 10;
                    break;
                  case "SERVER_WINDOW_MINIMIZE":
                  case 11:
                    e.command = 11;
                    break;
                  case "SERVER_WINDOW_MAXIMIZE":
                  case 12:
                    e.command = 12;
                    break;
                  case "SERVER_WINDOW_RESTORE":
                  case 13:
                    e.command = 13;
                    break;
                  case "SERVER_WINDOW_FLASH":
                  case 20:
                    e.command = 20;
                }
                return (
                  null != A.serverInitiated && (e.serverInitiated = Boolean(A.serverInitiated)),
                  null != A.windowId &&
                    (Sr.Long
                      ? ((e.windowId = Sr.Long.fromValue(A.windowId)).unsigned = !0)
                      : "string" == typeof A.windowId
                        ? (e.windowId = parseInt(A.windowId, 10))
                        : "number" == typeof A.windowId
                          ? (e.windowId = A.windowId)
                          : "object" == typeof A.windowId &&
                            (e.windowId = new Sr.LongBits(
                              A.windowId.low >>> 0,
                              A.windowId.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (
                    ((t.command = e.enums === String ? "SERVER_WINDOW_MENU_MOVE" : 0),
                    (t.serverInitiated = !1),
                    Sr.Long)
                  ) {
                    let A = new Sr.Long(0, 0, !0);
                    t.windowId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.windowId = e.longs === String ? "0" : 0;
                return (
                  null != A.command &&
                    A.hasOwnProperty("command") &&
                    (t.command =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.SeamlessServerCommand.Command[A.command]
                          ? A.command
                          : Rr.dcv.display.SeamlessServerCommand.Command[A.command]
                        : A.command),
                  null != A.serverInitiated &&
                    A.hasOwnProperty("serverInitiated") &&
                    (t.serverInitiated = A.serverInitiated),
                  null != A.windowId &&
                    A.hasOwnProperty("windowId") &&
                    ("number" == typeof A.windowId
                      ? (t.windowId = e.longs === String ? String(A.windowId) : A.windowId)
                      : (t.windowId =
                          e.longs === String
                            ? Sr.Long.prototype.toString.call(A.windowId)
                            : e.longs === Number
                              ? new Sr.LongBits(
                                  A.windowId.low >>> 0,
                                  A.windowId.high >>> 0
                                ).toNumber(!0)
                              : A.windowId)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.display.SeamlessServerCommand"
                );
              }),
              (A.Command = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "SERVER_WINDOW_MENU_MOVE")] = 0),
                  (e[(A[1] = "SERVER_WINDOW_MENU_SIZE")] = 1),
                  (e[(A[2] = "SERVER_WINDOW_DRAG_MOVE")] = 2),
                  (e[(A[3] = "SERVER_WINDOW_DRAG_SIZE_TOP_LEFT")] = 3),
                  (e[(A[4] = "SERVER_WINDOW_DRAG_SIZE_TOP_CENTER")] = 4),
                  (e[(A[5] = "SERVER_WINDOW_DRAG_SIZE_TOP_RIGHT")] = 5),
                  (e[(A[6] = "SERVER_WINDOW_DRAG_SIZE_RIGHT_CENTER")] = 6),
                  (e[(A[7] = "SERVER_WINDOW_DRAG_SIZE_BOTTOM_RIGHT")] = 7),
                  (e[(A[8] = "SERVER_WINDOW_DRAG_SIZE_BOTTOM_CENTER")] = 8),
                  (e[(A[9] = "SERVER_WINDOW_DRAG_SIZE_BOTTOM_LEFT")] = 9),
                  (e[(A[10] = "SERVER_WINDOW_DRAG_SIZE_LEFT_CENTER")] = 10),
                  (e[(A[11] = "SERVER_WINDOW_MINIMIZE")] = 11),
                  (e[(A[12] = "SERVER_WINDOW_MAXIMIZE")] = 12),
                  (e[(A[13] = "SERVER_WINDOW_RESTORE")] = 13),
                  (e[(A[20] = "SERVER_WINDOW_FLASH")] = 20),
                  e
                );
              })()),
              A
            );
          })()),
          (A.ScreenshotRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.format = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.format &&
                    Object.hasOwnProperty.call(A, "format") &&
                    e.uint32(8).int32(A.format),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.ScreenshotRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.format = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.format && A.hasOwnProperty("format"))
                  switch (A.format) {
                    default:
                      return "format: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.ScreenshotRequest) return A;
                let e = new Rr.dcv.display.ScreenshotRequest();
                switch (A.format) {
                  default:
                    if ("number" == typeof A.format) {
                      e.format = A.format;
                      break;
                    }
                    break;
                  case "PNG":
                  case 0:
                    e.format = 0;
                    break;
                  case "JPEG":
                  case 1:
                    e.format = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.format = e.enums === String ? "PNG" : 0),
                  null != A.format &&
                    A.hasOwnProperty("format") &&
                    (t.format =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.ScreenshotRequest.FormatType[A.format]
                          ? A.format
                          : Rr.dcv.display.ScreenshotRequest.FormatType[A.format]
                        : A.format),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.ScreenshotRequest"
                );
              }),
              (A.FormatType = (function () {
                const A = {},
                  e = Object.create(A);
                return (e[(A[0] = "PNG")] = 0), (e[(A[1] = "JPEG")] = 1), e;
              })()),
              A
            );
          })()),
          (A.ScreenshotResult = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.status = 0),
              (A.prototype.width = 0),
              (A.prototype.height = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.status &&
                    Object.hasOwnProperty.call(A, "status") &&
                    e.uint32(8).int32(A.status),
                  null != A.width &&
                    Object.hasOwnProperty.call(A, "width") &&
                    e.uint32(16).uint32(A.width),
                  null != A.height &&
                    Object.hasOwnProperty.call(A, "height") &&
                    e.uint32(24).uint32(A.height),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.ScreenshotResult();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.status = A.int32();
                      break;
                    case 2:
                      i.width = A.uint32();
                      break;
                    case 3:
                      i.height = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.status && A.hasOwnProperty("status"))
                  switch (A.status) {
                    default:
                      return "status: enum value expected";
                    case 0:
                    case 1:
                  }
                return null != A.width && A.hasOwnProperty("width") && !Sr.isInteger(A.width)
                  ? "width: integer expected"
                  : null != A.height && A.hasOwnProperty("height") && !Sr.isInteger(A.height)
                    ? "height: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.ScreenshotResult) return A;
                let e = new Rr.dcv.display.ScreenshotResult();
                switch (A.status) {
                  default:
                    if ("number" == typeof A.status) {
                      e.status = A.status;
                      break;
                    }
                    break;
                  case "OK":
                  case 0:
                    e.status = 0;
                    break;
                  case "ERROR_GENERIC":
                  case 1:
                    e.status = 1;
                }
                return (
                  null != A.width && (e.width = A.width >>> 0),
                  null != A.height && (e.height = A.height >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.status = e.enums === String ? "OK" : 0), (t.width = 0), (t.height = 0)),
                  null != A.status &&
                    A.hasOwnProperty("status") &&
                    (t.status =
                      e.enums === String
                        ? void 0 === Rr.dcv.display.ScreenshotResult.StatusCode[A.status]
                          ? A.status
                          : Rr.dcv.display.ScreenshotResult.StatusCode[A.status]
                        : A.status),
                  null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                  null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.ScreenshotResult"
                );
              }),
              (A.StatusCode = (function () {
                const A = {},
                  e = Object.create(A);
                return (e[(A[0] = "OK")] = 0), (e[(A[1] = "ERROR_GENERIC")] = 1), e;
              })()),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.clientCodecs = null),
              (A.prototype.displayLayoutRequest = null),
              (A.prototype.screenshotRequest = null),
              (A.prototype.ready = null),
              (A.prototype.ack = null),
              (A.prototype.tileAck = null),
              (A.prototype.settings = null),
              (A.prototype.pong = null),
              (A.prototype.pause = null),
              (A.prototype.resume = null),
              (A.prototype.seamlessCommand = null),
              (A.prototype.workareaLayoutRequest = null),
              (A.prototype.startService = null),
              (A.prototype.stopService = null),
              Object.defineProperty(A.prototype, "msg", {
                get: Sr.oneOfGetter(
                  (e = [
                    "clientCodecs",
                    "displayLayoutRequest",
                    "screenshotRequest",
                    "ready",
                    "ack",
                    "tileAck",
                    "settings",
                    "pong",
                    "pause",
                    "resume",
                    "seamlessCommand",
                    "workareaLayoutRequest",
                    "startService",
                    "stopService"
                  ])
                ),
                set: Sr.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.clientCodecs &&
                    Object.hasOwnProperty.call(A, "clientCodecs") &&
                    Rr.dcv.display.ClientCodecs.encode(
                      A.clientCodecs,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.displayLayoutRequest &&
                    Object.hasOwnProperty.call(A, "displayLayoutRequest") &&
                    Rr.dcv.display.DisplayLayoutRequest.encode(
                      A.displayLayoutRequest,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.screenshotRequest &&
                    Object.hasOwnProperty.call(A, "screenshotRequest") &&
                    Rr.dcv.display.ScreenshotRequest.encode(
                      A.screenshotRequest,
                      e.uint32(170).fork()
                    ).ldelim(),
                  null != A.ready &&
                    Object.hasOwnProperty.call(A, "ready") &&
                    Rr.dcv.display.Ready.encode(A.ready, e.uint32(242).fork()).ldelim(),
                  null != A.ack &&
                    Object.hasOwnProperty.call(A, "ack") &&
                    Rr.dcv.display.Ack.encode(A.ack, e.uint32(322).fork()).ldelim(),
                  null != A.tileAck &&
                    Object.hasOwnProperty.call(A, "tileAck") &&
                    Rr.dcv.display.TileAck.encode(A.tileAck, e.uint32(330).fork()).ldelim(),
                  null != A.settings &&
                    Object.hasOwnProperty.call(A, "settings") &&
                    Rr.dcv.display.Settings.encode(A.settings, e.uint32(402).fork()).ldelim(),
                  null != A.pong &&
                    Object.hasOwnProperty.call(A, "pong") &&
                    Rr.dcv.display.Pong.encode(A.pong, e.uint32(482).fork()).ldelim(),
                  null != A.pause &&
                    Object.hasOwnProperty.call(A, "pause") &&
                    Rr.dcv.display.Pause.encode(A.pause, e.uint32(562).fork()).ldelim(),
                  null != A.resume &&
                    Object.hasOwnProperty.call(A, "resume") &&
                    Rr.dcv.display.Resume.encode(A.resume, e.uint32(570).fork()).ldelim(),
                  null != A.seamlessCommand &&
                    Object.hasOwnProperty.call(A, "seamlessCommand") &&
                    Rr.dcv.display.SeamlessCommand.encode(
                      A.seamlessCommand,
                      e.uint32(642).fork()
                    ).ldelim(),
                  null != A.workareaLayoutRequest &&
                    Object.hasOwnProperty.call(A, "workareaLayoutRequest") &&
                    Rr.dcv.display.WorkareaLayoutRequest.encode(
                      A.workareaLayoutRequest,
                      e.uint32(650).fork()
                    ).ldelim(),
                  null != A.startService &&
                    Object.hasOwnProperty.call(A, "startService") &&
                    Rr.dcv.display.StartService.encode(
                      A.startService,
                      e.uint32(722).fork()
                    ).ldelim(),
                  null != A.stopService &&
                    Object.hasOwnProperty.call(A, "stopService") &&
                    Rr.dcv.display.StopService.encode(A.stopService, e.uint32(730).fork()).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.clientCodecs = Rr.dcv.display.ClientCodecs.decode(A, A.uint32());
                      break;
                    case 20:
                      i.displayLayoutRequest = Rr.dcv.display.DisplayLayoutRequest.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 21:
                      i.screenshotRequest = Rr.dcv.display.ScreenshotRequest.decode(A, A.uint32());
                      break;
                    case 30:
                      i.ready = Rr.dcv.display.Ready.decode(A, A.uint32());
                      break;
                    case 40:
                      i.ack = Rr.dcv.display.Ack.decode(A, A.uint32());
                      break;
                    case 41:
                      i.tileAck = Rr.dcv.display.TileAck.decode(A, A.uint32());
                      break;
                    case 50:
                      i.settings = Rr.dcv.display.Settings.decode(A, A.uint32());
                      break;
                    case 60:
                      i.pong = Rr.dcv.display.Pong.decode(A, A.uint32());
                      break;
                    case 70:
                      i.pause = Rr.dcv.display.Pause.decode(A, A.uint32());
                      break;
                    case 71:
                      i.resume = Rr.dcv.display.Resume.decode(A, A.uint32());
                      break;
                    case 80:
                      i.seamlessCommand = Rr.dcv.display.SeamlessCommand.decode(A, A.uint32());
                      break;
                    case 81:
                      i.workareaLayoutRequest = Rr.dcv.display.WorkareaLayoutRequest.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 90:
                      i.startService = Rr.dcv.display.StartService.decode(A, A.uint32());
                      break;
                    case 91:
                      i.stopService = Rr.dcv.display.StopService.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.clientCodecs && A.hasOwnProperty("clientCodecs")) {
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.ClientCodecs.verify(A.clientCodecs);
                    if (e) return "clientCodecs." + e;
                  }
                }
                if (null != A.displayLayoutRequest && A.hasOwnProperty("displayLayoutRequest")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.DisplayLayoutRequest.verify(A.displayLayoutRequest);
                    if (e) return "displayLayoutRequest." + e;
                  }
                }
                if (null != A.screenshotRequest && A.hasOwnProperty("screenshotRequest")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.ScreenshotRequest.verify(A.screenshotRequest);
                    if (e) return "screenshotRequest." + e;
                  }
                }
                if (null != A.ready && A.hasOwnProperty("ready")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Ready.verify(A.ready);
                    if (e) return "ready." + e;
                  }
                }
                if (null != A.ack && A.hasOwnProperty("ack")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Ack.verify(A.ack);
                    if (e) return "ack." + e;
                  }
                }
                if (null != A.tileAck && A.hasOwnProperty("tileAck")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.TileAck.verify(A.tileAck);
                    if (e) return "tileAck." + e;
                  }
                }
                if (null != A.settings && A.hasOwnProperty("settings")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Settings.verify(A.settings);
                    if (e) return "settings." + e;
                  }
                }
                if (null != A.pong && A.hasOwnProperty("pong")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Pong.verify(A.pong);
                    if (e) return "pong." + e;
                  }
                }
                if (null != A.pause && A.hasOwnProperty("pause")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Pause.verify(A.pause);
                    if (e) return "pause." + e;
                  }
                }
                if (null != A.resume && A.hasOwnProperty("resume")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Resume.verify(A.resume);
                    if (e) return "resume." + e;
                  }
                }
                if (null != A.seamlessCommand && A.hasOwnProperty("seamlessCommand")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.SeamlessCommand.verify(A.seamlessCommand);
                    if (e) return "seamlessCommand." + e;
                  }
                }
                if (null != A.workareaLayoutRequest && A.hasOwnProperty("workareaLayoutRequest")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.WorkareaLayoutRequest.verify(A.workareaLayoutRequest);
                    if (e) return "workareaLayoutRequest." + e;
                  }
                }
                if (null != A.startService && A.hasOwnProperty("startService")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.StartService.verify(A.startService);
                    if (e) return "startService." + e;
                  }
                }
                if (null != A.stopService && A.hasOwnProperty("stopService")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.StopService.verify(A.stopService);
                    if (e) return "stopService." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.ClientMessage) return A;
                let e = new Rr.dcv.display.ClientMessage();
                if (null != A.clientCodecs) {
                  if ("object" != typeof A.clientCodecs)
                    throw TypeError(".dcv.display.ClientMessage.clientCodecs: object expected");
                  e.clientCodecs = Rr.dcv.display.ClientCodecs.fromObject(A.clientCodecs);
                }
                if (null != A.displayLayoutRequest) {
                  if ("object" != typeof A.displayLayoutRequest)
                    throw TypeError(
                      ".dcv.display.ClientMessage.displayLayoutRequest: object expected"
                    );
                  e.displayLayoutRequest = Rr.dcv.display.DisplayLayoutRequest.fromObject(
                    A.displayLayoutRequest
                  );
                }
                if (null != A.screenshotRequest) {
                  if ("object" != typeof A.screenshotRequest)
                    throw TypeError(
                      ".dcv.display.ClientMessage.screenshotRequest: object expected"
                    );
                  e.screenshotRequest = Rr.dcv.display.ScreenshotRequest.fromObject(
                    A.screenshotRequest
                  );
                }
                if (null != A.ready) {
                  if ("object" != typeof A.ready)
                    throw TypeError(".dcv.display.ClientMessage.ready: object expected");
                  e.ready = Rr.dcv.display.Ready.fromObject(A.ready);
                }
                if (null != A.ack) {
                  if ("object" != typeof A.ack)
                    throw TypeError(".dcv.display.ClientMessage.ack: object expected");
                  e.ack = Rr.dcv.display.Ack.fromObject(A.ack);
                }
                if (null != A.tileAck) {
                  if ("object" != typeof A.tileAck)
                    throw TypeError(".dcv.display.ClientMessage.tileAck: object expected");
                  e.tileAck = Rr.dcv.display.TileAck.fromObject(A.tileAck);
                }
                if (null != A.settings) {
                  if ("object" != typeof A.settings)
                    throw TypeError(".dcv.display.ClientMessage.settings: object expected");
                  e.settings = Rr.dcv.display.Settings.fromObject(A.settings);
                }
                if (null != A.pong) {
                  if ("object" != typeof A.pong)
                    throw TypeError(".dcv.display.ClientMessage.pong: object expected");
                  e.pong = Rr.dcv.display.Pong.fromObject(A.pong);
                }
                if (null != A.pause) {
                  if ("object" != typeof A.pause)
                    throw TypeError(".dcv.display.ClientMessage.pause: object expected");
                  e.pause = Rr.dcv.display.Pause.fromObject(A.pause);
                }
                if (null != A.resume) {
                  if ("object" != typeof A.resume)
                    throw TypeError(".dcv.display.ClientMessage.resume: object expected");
                  e.resume = Rr.dcv.display.Resume.fromObject(A.resume);
                }
                if (null != A.seamlessCommand) {
                  if ("object" != typeof A.seamlessCommand)
                    throw TypeError(".dcv.display.ClientMessage.seamlessCommand: object expected");
                  e.seamlessCommand = Rr.dcv.display.SeamlessCommand.fromObject(A.seamlessCommand);
                }
                if (null != A.workareaLayoutRequest) {
                  if ("object" != typeof A.workareaLayoutRequest)
                    throw TypeError(
                      ".dcv.display.ClientMessage.workareaLayoutRequest: object expected"
                    );
                  e.workareaLayoutRequest = Rr.dcv.display.WorkareaLayoutRequest.fromObject(
                    A.workareaLayoutRequest
                  );
                }
                if (null != A.startService) {
                  if ("object" != typeof A.startService)
                    throw TypeError(".dcv.display.ClientMessage.startService: object expected");
                  e.startService = Rr.dcv.display.StartService.fromObject(A.startService);
                }
                if (null != A.stopService) {
                  if ("object" != typeof A.stopService)
                    throw TypeError(".dcv.display.ClientMessage.stopService: object expected");
                  e.stopService = Rr.dcv.display.StopService.fromObject(A.stopService);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.clientCodecs &&
                    A.hasOwnProperty("clientCodecs") &&
                    ((t.clientCodecs = Rr.dcv.display.ClientCodecs.toObject(A.clientCodecs, e)),
                    e.oneofs && (t.msg = "clientCodecs")),
                  null != A.displayLayoutRequest &&
                    A.hasOwnProperty("displayLayoutRequest") &&
                    ((t.displayLayoutRequest = Rr.dcv.display.DisplayLayoutRequest.toObject(
                      A.displayLayoutRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "displayLayoutRequest")),
                  null != A.screenshotRequest &&
                    A.hasOwnProperty("screenshotRequest") &&
                    ((t.screenshotRequest = Rr.dcv.display.ScreenshotRequest.toObject(
                      A.screenshotRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "screenshotRequest")),
                  null != A.ready &&
                    A.hasOwnProperty("ready") &&
                    ((t.ready = Rr.dcv.display.Ready.toObject(A.ready, e)),
                    e.oneofs && (t.msg = "ready")),
                  null != A.ack &&
                    A.hasOwnProperty("ack") &&
                    ((t.ack = Rr.dcv.display.Ack.toObject(A.ack, e)), e.oneofs && (t.msg = "ack")),
                  null != A.tileAck &&
                    A.hasOwnProperty("tileAck") &&
                    ((t.tileAck = Rr.dcv.display.TileAck.toObject(A.tileAck, e)),
                    e.oneofs && (t.msg = "tileAck")),
                  null != A.settings &&
                    A.hasOwnProperty("settings") &&
                    ((t.settings = Rr.dcv.display.Settings.toObject(A.settings, e)),
                    e.oneofs && (t.msg = "settings")),
                  null != A.pong &&
                    A.hasOwnProperty("pong") &&
                    ((t.pong = Rr.dcv.display.Pong.toObject(A.pong, e)),
                    e.oneofs && (t.msg = "pong")),
                  null != A.pause &&
                    A.hasOwnProperty("pause") &&
                    ((t.pause = Rr.dcv.display.Pause.toObject(A.pause, e)),
                    e.oneofs && (t.msg = "pause")),
                  null != A.resume &&
                    A.hasOwnProperty("resume") &&
                    ((t.resume = Rr.dcv.display.Resume.toObject(A.resume, e)),
                    e.oneofs && (t.msg = "resume")),
                  null != A.seamlessCommand &&
                    A.hasOwnProperty("seamlessCommand") &&
                    ((t.seamlessCommand = Rr.dcv.display.SeamlessCommand.toObject(
                      A.seamlessCommand,
                      e
                    )),
                    e.oneofs && (t.msg = "seamlessCommand")),
                  null != A.workareaLayoutRequest &&
                    A.hasOwnProperty("workareaLayoutRequest") &&
                    ((t.workareaLayoutRequest = Rr.dcv.display.WorkareaLayoutRequest.toObject(
                      A.workareaLayoutRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "workareaLayoutRequest")),
                  null != A.startService &&
                    A.hasOwnProperty("startService") &&
                    ((t.startService = Rr.dcv.display.StartService.toObject(A.startService, e)),
                    e.oneofs && (t.msg = "startService")),
                  null != A.stopService &&
                    A.hasOwnProperty("stopService") &&
                    ((t.stopService = Rr.dcv.display.StopService.toObject(A.stopService, e)),
                    e.oneofs && (t.msg = "stopService")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.ClientMessage"
                );
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.handshakeStart = null),
              (A.prototype.serverCodecs = null),
              (A.prototype.displayLayout = null),
              (A.prototype.displayLayoutCapabilities = null),
              (A.prototype.screenshotResult = null),
              (A.prototype.streamStart = null),
              (A.prototype.streamEnd = null),
              (A.prototype.tileUpdate = null),
              (A.prototype.tileMove = null),
              (A.prototype.swap = null),
              (A.prototype.ping = null),
              (A.prototype.statusUpdate = null),
              (A.prototype.seamlessData = null),
              (A.prototype.seamlessServerCommand = null),
              Object.defineProperty(A.prototype, "msg", {
                get: Sr.oneOfGetter(
                  (e = [
                    "handshakeStart",
                    "serverCodecs",
                    "displayLayout",
                    "displayLayoutCapabilities",
                    "screenshotResult",
                    "streamStart",
                    "streamEnd",
                    "tileUpdate",
                    "tileMove",
                    "swap",
                    "ping",
                    "statusUpdate",
                    "seamlessData",
                    "seamlessServerCommand"
                  ])
                ),
                set: Sr.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ur.create()),
                  null != A.handshakeStart &&
                    Object.hasOwnProperty.call(A, "handshakeStart") &&
                    Rr.dcv.display.HandshakeStart.encode(
                      A.handshakeStart,
                      e.uint32(10).fork()
                    ).ldelim(),
                  null != A.serverCodecs &&
                    Object.hasOwnProperty.call(A, "serverCodecs") &&
                    Rr.dcv.display.ServerCodecs.encode(
                      A.serverCodecs,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.displayLayout &&
                    Object.hasOwnProperty.call(A, "displayLayout") &&
                    Rr.dcv.display.DisplayLayout.encode(
                      A.displayLayout,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.displayLayoutCapabilities &&
                    Object.hasOwnProperty.call(A, "displayLayoutCapabilities") &&
                    Rr.dcv.display.DisplayLayoutCapabilities.encode(
                      A.displayLayoutCapabilities,
                      e.uint32(170).fork()
                    ).ldelim(),
                  null != A.screenshotResult &&
                    Object.hasOwnProperty.call(A, "screenshotResult") &&
                    Rr.dcv.display.ScreenshotResult.encode(
                      A.screenshotResult,
                      e.uint32(178).fork()
                    ).ldelim(),
                  null != A.streamStart &&
                    Object.hasOwnProperty.call(A, "streamStart") &&
                    Rr.dcv.display.StreamStart.encode(A.streamStart, e.uint32(242).fork()).ldelim(),
                  null != A.streamEnd &&
                    Object.hasOwnProperty.call(A, "streamEnd") &&
                    Rr.dcv.display.StreamEnd.encode(A.streamEnd, e.uint32(250).fork()).ldelim(),
                  null != A.tileUpdate &&
                    Object.hasOwnProperty.call(A, "tileUpdate") &&
                    Rr.dcv.display.TileUpdate.encode(A.tileUpdate, e.uint32(322).fork()).ldelim(),
                  null != A.tileMove &&
                    Object.hasOwnProperty.call(A, "tileMove") &&
                    Rr.dcv.display.TileMove.encode(A.tileMove, e.uint32(330).fork()).ldelim(),
                  null != A.swap &&
                    Object.hasOwnProperty.call(A, "swap") &&
                    Rr.dcv.display.Swap.encode(A.swap, e.uint32(402).fork()).ldelim(),
                  null != A.ping &&
                    Object.hasOwnProperty.call(A, "ping") &&
                    Rr.dcv.display.Ping.encode(A.ping, e.uint32(482).fork()).ldelim(),
                  null != A.statusUpdate &&
                    Object.hasOwnProperty.call(A, "statusUpdate") &&
                    Rr.dcv.display.StatusUpdate.encode(
                      A.statusUpdate,
                      e.uint32(562).fork()
                    ).ldelim(),
                  null != A.seamlessData &&
                    Object.hasOwnProperty.call(A, "seamlessData") &&
                    Rr.dcv.display.SeamlessData.encode(
                      A.seamlessData,
                      e.uint32(642).fork()
                    ).ldelim(),
                  null != A.seamlessServerCommand &&
                    Object.hasOwnProperty.call(A, "seamlessServerCommand") &&
                    Rr.dcv.display.SeamlessServerCommand.encode(
                      A.seamlessServerCommand,
                      e.uint32(650).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof br || (A = br.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Rr.dcv.display.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.handshakeStart = Rr.dcv.display.HandshakeStart.decode(A, A.uint32());
                      break;
                    case 10:
                      i.serverCodecs = Rr.dcv.display.ServerCodecs.decode(A, A.uint32());
                      break;
                    case 20:
                      i.displayLayout = Rr.dcv.display.DisplayLayout.decode(A, A.uint32());
                      break;
                    case 21:
                      i.displayLayoutCapabilities = Rr.dcv.display.DisplayLayoutCapabilities.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 22:
                      i.screenshotResult = Rr.dcv.display.ScreenshotResult.decode(A, A.uint32());
                      break;
                    case 30:
                      i.streamStart = Rr.dcv.display.StreamStart.decode(A, A.uint32());
                      break;
                    case 31:
                      i.streamEnd = Rr.dcv.display.StreamEnd.decode(A, A.uint32());
                      break;
                    case 40:
                      i.tileUpdate = Rr.dcv.display.TileUpdate.decode(A, A.uint32());
                      break;
                    case 41:
                      i.tileMove = Rr.dcv.display.TileMove.decode(A, A.uint32());
                      break;
                    case 50:
                      i.swap = Rr.dcv.display.Swap.decode(A, A.uint32());
                      break;
                    case 60:
                      i.ping = Rr.dcv.display.Ping.decode(A, A.uint32());
                      break;
                    case 70:
                      i.statusUpdate = Rr.dcv.display.StatusUpdate.decode(A, A.uint32());
                      break;
                    case 80:
                      i.seamlessData = Rr.dcv.display.SeamlessData.decode(A, A.uint32());
                      break;
                    case 81:
                      i.seamlessServerCommand = Rr.dcv.display.SeamlessServerCommand.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof br || (A = new br(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.handshakeStart && A.hasOwnProperty("handshakeStart")) {
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.HandshakeStart.verify(A.handshakeStart);
                    if (e) return "handshakeStart." + e;
                  }
                }
                if (null != A.serverCodecs && A.hasOwnProperty("serverCodecs")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.ServerCodecs.verify(A.serverCodecs);
                    if (e) return "serverCodecs." + e;
                  }
                }
                if (null != A.displayLayout && A.hasOwnProperty("displayLayout")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.DisplayLayout.verify(A.displayLayout);
                    if (e) return "displayLayout." + e;
                  }
                }
                if (
                  null != A.displayLayoutCapabilities &&
                  A.hasOwnProperty("displayLayoutCapabilities")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.DisplayLayoutCapabilities.verify(
                      A.displayLayoutCapabilities
                    );
                    if (e) return "displayLayoutCapabilities." + e;
                  }
                }
                if (null != A.screenshotResult && A.hasOwnProperty("screenshotResult")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.ScreenshotResult.verify(A.screenshotResult);
                    if (e) return "screenshotResult." + e;
                  }
                }
                if (null != A.streamStart && A.hasOwnProperty("streamStart")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.StreamStart.verify(A.streamStart);
                    if (e) return "streamStart." + e;
                  }
                }
                if (null != A.streamEnd && A.hasOwnProperty("streamEnd")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.StreamEnd.verify(A.streamEnd);
                    if (e) return "streamEnd." + e;
                  }
                }
                if (null != A.tileUpdate && A.hasOwnProperty("tileUpdate")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.TileUpdate.verify(A.tileUpdate);
                    if (e) return "tileUpdate." + e;
                  }
                }
                if (null != A.tileMove && A.hasOwnProperty("tileMove")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.TileMove.verify(A.tileMove);
                    if (e) return "tileMove." + e;
                  }
                }
                if (null != A.swap && A.hasOwnProperty("swap")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Swap.verify(A.swap);
                    if (e) return "swap." + e;
                  }
                }
                if (null != A.ping && A.hasOwnProperty("ping")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.Ping.verify(A.ping);
                    if (e) return "ping." + e;
                  }
                }
                if (null != A.statusUpdate && A.hasOwnProperty("statusUpdate")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.StatusUpdate.verify(A.statusUpdate);
                    if (e) return "statusUpdate." + e;
                  }
                }
                if (null != A.seamlessData && A.hasOwnProperty("seamlessData")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.SeamlessData.verify(A.seamlessData);
                    if (e) return "seamlessData." + e;
                  }
                }
                if (null != A.seamlessServerCommand && A.hasOwnProperty("seamlessServerCommand")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Rr.dcv.display.SeamlessServerCommand.verify(A.seamlessServerCommand);
                    if (e) return "seamlessServerCommand." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Rr.dcv.display.ServerMessage) return A;
                let e = new Rr.dcv.display.ServerMessage();
                if (null != A.handshakeStart) {
                  if ("object" != typeof A.handshakeStart)
                    throw TypeError(".dcv.display.ServerMessage.handshakeStart: object expected");
                  e.handshakeStart = Rr.dcv.display.HandshakeStart.fromObject(A.handshakeStart);
                }
                if (null != A.serverCodecs) {
                  if ("object" != typeof A.serverCodecs)
                    throw TypeError(".dcv.display.ServerMessage.serverCodecs: object expected");
                  e.serverCodecs = Rr.dcv.display.ServerCodecs.fromObject(A.serverCodecs);
                }
                if (null != A.displayLayout) {
                  if ("object" != typeof A.displayLayout)
                    throw TypeError(".dcv.display.ServerMessage.displayLayout: object expected");
                  e.displayLayout = Rr.dcv.display.DisplayLayout.fromObject(A.displayLayout);
                }
                if (null != A.displayLayoutCapabilities) {
                  if ("object" != typeof A.displayLayoutCapabilities)
                    throw TypeError(
                      ".dcv.display.ServerMessage.displayLayoutCapabilities: object expected"
                    );
                  e.displayLayoutCapabilities = Rr.dcv.display.DisplayLayoutCapabilities.fromObject(
                    A.displayLayoutCapabilities
                  );
                }
                if (null != A.screenshotResult) {
                  if ("object" != typeof A.screenshotResult)
                    throw TypeError(".dcv.display.ServerMessage.screenshotResult: object expected");
                  e.screenshotResult = Rr.dcv.display.ScreenshotResult.fromObject(
                    A.screenshotResult
                  );
                }
                if (null != A.streamStart) {
                  if ("object" != typeof A.streamStart)
                    throw TypeError(".dcv.display.ServerMessage.streamStart: object expected");
                  e.streamStart = Rr.dcv.display.StreamStart.fromObject(A.streamStart);
                }
                if (null != A.streamEnd) {
                  if ("object" != typeof A.streamEnd)
                    throw TypeError(".dcv.display.ServerMessage.streamEnd: object expected");
                  e.streamEnd = Rr.dcv.display.StreamEnd.fromObject(A.streamEnd);
                }
                if (null != A.tileUpdate) {
                  if ("object" != typeof A.tileUpdate)
                    throw TypeError(".dcv.display.ServerMessage.tileUpdate: object expected");
                  e.tileUpdate = Rr.dcv.display.TileUpdate.fromObject(A.tileUpdate);
                }
                if (null != A.tileMove) {
                  if ("object" != typeof A.tileMove)
                    throw TypeError(".dcv.display.ServerMessage.tileMove: object expected");
                  e.tileMove = Rr.dcv.display.TileMove.fromObject(A.tileMove);
                }
                if (null != A.swap) {
                  if ("object" != typeof A.swap)
                    throw TypeError(".dcv.display.ServerMessage.swap: object expected");
                  e.swap = Rr.dcv.display.Swap.fromObject(A.swap);
                }
                if (null != A.ping) {
                  if ("object" != typeof A.ping)
                    throw TypeError(".dcv.display.ServerMessage.ping: object expected");
                  e.ping = Rr.dcv.display.Ping.fromObject(A.ping);
                }
                if (null != A.statusUpdate) {
                  if ("object" != typeof A.statusUpdate)
                    throw TypeError(".dcv.display.ServerMessage.statusUpdate: object expected");
                  e.statusUpdate = Rr.dcv.display.StatusUpdate.fromObject(A.statusUpdate);
                }
                if (null != A.seamlessData) {
                  if ("object" != typeof A.seamlessData)
                    throw TypeError(".dcv.display.ServerMessage.seamlessData: object expected");
                  e.seamlessData = Rr.dcv.display.SeamlessData.fromObject(A.seamlessData);
                }
                if (null != A.seamlessServerCommand) {
                  if ("object" != typeof A.seamlessServerCommand)
                    throw TypeError(
                      ".dcv.display.ServerMessage.seamlessServerCommand: object expected"
                    );
                  e.seamlessServerCommand = Rr.dcv.display.SeamlessServerCommand.fromObject(
                    A.seamlessServerCommand
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.handshakeStart &&
                    A.hasOwnProperty("handshakeStart") &&
                    ((t.handshakeStart = Rr.dcv.display.HandshakeStart.toObject(
                      A.handshakeStart,
                      e
                    )),
                    e.oneofs && (t.msg = "handshakeStart")),
                  null != A.serverCodecs &&
                    A.hasOwnProperty("serverCodecs") &&
                    ((t.serverCodecs = Rr.dcv.display.ServerCodecs.toObject(A.serverCodecs, e)),
                    e.oneofs && (t.msg = "serverCodecs")),
                  null != A.displayLayout &&
                    A.hasOwnProperty("displayLayout") &&
                    ((t.displayLayout = Rr.dcv.display.DisplayLayout.toObject(A.displayLayout, e)),
                    e.oneofs && (t.msg = "displayLayout")),
                  null != A.displayLayoutCapabilities &&
                    A.hasOwnProperty("displayLayoutCapabilities") &&
                    ((t.displayLayoutCapabilities =
                      Rr.dcv.display.DisplayLayoutCapabilities.toObject(
                        A.displayLayoutCapabilities,
                        e
                      )),
                    e.oneofs && (t.msg = "displayLayoutCapabilities")),
                  null != A.screenshotResult &&
                    A.hasOwnProperty("screenshotResult") &&
                    ((t.screenshotResult = Rr.dcv.display.ScreenshotResult.toObject(
                      A.screenshotResult,
                      e
                    )),
                    e.oneofs && (t.msg = "screenshotResult")),
                  null != A.streamStart &&
                    A.hasOwnProperty("streamStart") &&
                    ((t.streamStart = Rr.dcv.display.StreamStart.toObject(A.streamStart, e)),
                    e.oneofs && (t.msg = "streamStart")),
                  null != A.streamEnd &&
                    A.hasOwnProperty("streamEnd") &&
                    ((t.streamEnd = Rr.dcv.display.StreamEnd.toObject(A.streamEnd, e)),
                    e.oneofs && (t.msg = "streamEnd")),
                  null != A.tileUpdate &&
                    A.hasOwnProperty("tileUpdate") &&
                    ((t.tileUpdate = Rr.dcv.display.TileUpdate.toObject(A.tileUpdate, e)),
                    e.oneofs && (t.msg = "tileUpdate")),
                  null != A.tileMove &&
                    A.hasOwnProperty("tileMove") &&
                    ((t.tileMove = Rr.dcv.display.TileMove.toObject(A.tileMove, e)),
                    e.oneofs && (t.msg = "tileMove")),
                  null != A.swap &&
                    A.hasOwnProperty("swap") &&
                    ((t.swap = Rr.dcv.display.Swap.toObject(A.swap, e)),
                    e.oneofs && (t.msg = "swap")),
                  null != A.ping &&
                    A.hasOwnProperty("ping") &&
                    ((t.ping = Rr.dcv.display.Ping.toObject(A.ping, e)),
                    e.oneofs && (t.msg = "ping")),
                  null != A.statusUpdate &&
                    A.hasOwnProperty("statusUpdate") &&
                    ((t.statusUpdate = Rr.dcv.display.StatusUpdate.toObject(A.statusUpdate, e)),
                    e.oneofs && (t.msg = "statusUpdate")),
                  null != A.seamlessData &&
                    A.hasOwnProperty("seamlessData") &&
                    ((t.seamlessData = Rr.dcv.display.SeamlessData.toObject(A.seamlessData, e)),
                    e.oneofs && (t.msg = "seamlessData")),
                  null != A.seamlessServerCommand &&
                    A.hasOwnProperty("seamlessServerCommand") &&
                    ((t.seamlessServerCommand = Rr.dcv.display.SeamlessServerCommand.toObject(
                      A.seamlessServerCommand,
                      e
                    )),
                    e.oneofs && (t.msg = "seamlessServerCommand")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.display.ServerMessage"
                );
              }),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })());
function xr(A) {
  this.log = Q("Renderer", A);
}
(xr.YUV = 0),
  (xr.JPEG = 1),
  (xr.LZ4 = 2),
  (xr.CLIPMAP = 0),
  (xr.TILELIST = 1),
  (xr.PASSTHROUGH = 2),
  (xr.RGB = 0),
  (xr.NV12 = 1),
  (xr.I420 = 2),
  (xr.FRAME = 3),
  (xr.I444 = 4);
const Mr = [
  new Float32Array([
    1.16438353, 1.79274106, -0.97294509, 0, 1.16438353, -0.21324861, -0.53290933, 0.30148268,
    1.16438353, 2.11240172, -1.13340223, 0
  ]),
  new Float32Array([
    1, 1.57480001, -0.78740001, 0, 1, -0.18732427, -0.46812427, 0.32772428, 1, 1.8556, -0.9278, 0
  ]),
  new Float32Array([
    1.16438353, 1.59602678, -0.87420219, 0, 1.16438353, -0.39176229, -0.81296766, 0.53166783,
    1.16438353, 2.01723218, -1.08563077, 0
  ]),
  new Float32Array([
    1, 1.40199995, -0.70099998, 0, 1, -0.3441363, -0.7141363, 0.5291363, 1, 1.77199996, -0.88599998,
    0
  ])
];
function Or(A, e, t) {
  (this.log = Q("GpuTimer", t)),
    (this.bufferSize = e),
    (this.queryBuffer = []),
    (this.gl = A),
    (this.ext = null),
    (this.queryIndex = 0),
    (this.lastQuery = null),
    A instanceof WebGL2RenderingContext
      ? ((this.ext = this.gl.getExtension("EXT_disjoint_timer_query_webgl2")),
        this.ext
          ? ((this.getQueryParameter = this.gl.getQueryParameter.bind(this.gl)),
            (this.createQuery = this.gl.createQuery.bind(this.gl)),
            (this.deleteQuery = this.gl.deleteQuery.bind(this.gl)),
            (this.beginQuery = this.gl.beginQuery.bind(this.gl)),
            (this.endQuery = this.gl.endQuery.bind(this.gl)),
            (this.QUERY_RESULT_AVAILABLE = this.gl.QUERY_RESULT_AVAILABLE),
            (this.QUERY_RESULT = this.gl.QUERY_RESULT),
            this.log.info("Initialized gpu timer for webgl2"))
          : this.log.warn("Failed to initialize gpu timer extension for webgl2"))
      : A instanceof WebGLRenderingContext &&
        ((this.ext = this.gl.getExtension("EXT_disjoint_timer_query")),
        this.ext
          ? ((this.getQueryParameter = this.ext.getQueryObjectEXT.bind(this.ext)),
            (this.createQuery = this.ext.createQueryEXT.bind(this.ext)),
            (this.deleteQuery = this.ext.deleteQueryEXT.bind(this.ext)),
            (this.beginQuery = this.ext.beginQueryEXT.bind(this.ext)),
            (this.endQuery = this.ext.endQueryEXT.bind(this.ext)),
            (this.QUERY_RESULT_AVAILABLE = this.ext.QUERY_RESULT_AVAILABLE_EXT),
            (this.QUERY_RESULT = this.ext.QUERY_RESULT_EXT),
            this.log.info("Initialized gpu timer for webgl1"))
          : this.log.warn("Failed to initialize gpu timer extension for webgl1"));
}
(xr.prototype.addRenderingLayer = function (A, e) {
  this.log.error(`abstract 'addRenderingLayer' method not implemented by ${this.constructor.name}`);
}),
  (xr.prototype.removeRenderingLayer = function (A) {
    this.log.error(
      `abstract 'removeRenderingLayer' method not implemented by ${this.constructor.name}`
    );
  }),
  (xr.prototype.render = function (A) {
    this.log.error(`abstract 'render' method not implemented by ${this.constructor.name}`);
  }),
  (xr.prototype.size = function (A, e) {
    this.log.error(`abstract 'size' method not implemented by ${this.constructor.name}`);
  }),
  (xr.prototype.release = function () {
    this.log.error(`abstract 'release' method not implemented by ${this.constructor.name}`);
  }),
  (xr.prototype.enableHighPixelDensity = function (A) {
    this.log.error(
      `abstract 'enableHighPixelDensity' method not implemented by ${this.constructor.name}`
    );
  }),
  (xr.prototype.getLayerTypeIndex = function (A) {
    const e = vr.display;
    switch (A) {
      case e.StreamStart.Layer.FRAME:
        return 0;
      case e.StreamStart.Layer.TILES:
        return 1;
      case e.StreamStart.Layer.QUALITY_UPDATE:
        return 2;
      default:
        return -1;
    }
  }),
  (xr.prototype.getYuvWeights = function (A) {
    const e = (A.isBt601 ? 2 : 0) | (A.isFullRange ? 1 : 0);
    return Mr[e];
  }),
  (xr.prototype.getRenderingTypeIndex = function (A) {
    return A === xr.YUV || A === xr.JPEG || A === xr.LZ4
      ? A
      : (this.log.warn(`Unknown rendering type ${A}`), -1);
  }),
  (Or.prototype.start = function (A) {
    let e,
      t,
      i,
      n = this.gl,
      o = this.ext,
      r = this.queryBuffer,
      s = this.bufferSize,
      a = this.queryIndex,
      g = {};
    this.ext
      ? (r.length >= s
          ? (a >= s && (a = 0),
            (e = n.getParameter(o.GPU_DISJOINT_EXT)),
            e
              ? (this.log.warn("Flushing buffers since GPU disjoint"),
                r.forEach((A) => {
                  this.deleteQuery(A.query);
                }),
                (this.queryBuffer = []),
                (this.queryIndex = 0),
                (r = this.queryBuffer),
                (g.query = this.createQuery()),
                r.push(g))
              : ((t = this.getQueryParameter(r[a].query, this.QUERY_RESULT_AVAILABLE)),
                t
                  ? ((i = this.getQueryParameter(r[a].query, this.QUERY_RESULT)),
                    this.log.debug(
                      `Label: ${r[a].label}, GPU: ${(i / 1e6).toFixed(6)}, CPU:${(r[a].endTime - r[a].startTime).toFixed(6)}`
                    ))
                  : this.log.warn(`Query result not available for label: ${r[a].label}`),
                (g = r[a]),
                a++,
                (this.queryIndex = a)))
          : ((g.query = this.createQuery()), r.push(g)),
        this.beginQuery(o.TIME_ELAPSED_EXT, g.query),
        (g.startTime = performance.now()),
        (g.label = A),
        (this.lastQuery = g))
      : this.log.warn("Failed to initialize timer, skipping");
  }),
  (Or.prototype.stop = function () {
    this.ext &&
      (this.endQuery(this.ext.TIME_ELAPSED_EXT), (this.lastQuery.endTime = performance.now()));
  }),
  (Or.prototype.dispose = function () {
    this.queryBuffer.forEach((A) => {
      this.deleteQuery(A.query);
    }),
      (this.gl = null),
      (this.ext = null),
      (this.queryBuffer = null),
      (this.lastQuery = null),
      this.log.info("Disposed gpu timer");
  });
const kr = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "a",
  "b",
  "c",
  "d",
  "e",
  "f",
  "g",
  "h",
  "i",
  "j",
  "k",
  "l",
  "m",
  "n",
  "o",
  "p",
  "q",
  "r",
  "s",
  "t",
  "u",
  "v",
  "w",
  "x",
  "y",
  "z",
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "+",
  "/"
];
class Nr {
  constructor(A) {
    (this.entries = []),
      (this.objectId = 0),
      (this.objectMap = new WeakMap()),
      (this.width = 0),
      (this.height = 0),
      (this.gzipCompress = "CompressionStream" in window),
      (this.inlineStringThreshold = this.gzipCompress ? 64 : -1),
      this.entries.push({
        params: [
          "context.create",
          Object.prototype.toString
            .call(A)
            .replace("]", "")
            .split(" ")
            .pop()
            .toLowerCase()
            .replace("renderingcontext", ""),
          A.getContextAttributes()
        ]
      });
    let e = this;
    for (let t in A)
      if (t) {
        let i = A[t];
        if ("function" == typeof i) {
          const n = i;
          A[t] = (...i) => {
            const o = A.drawingBufferWidth,
              r = A.drawingBufferHeight;
            (o === this.width && r === this.height) ||
              (this.entries.push({ params: ["context.resize", o, r] }),
              (this.width = o),
              (this.height = r));
            let s = e.createEntry(t, i),
              a = Reflect.apply(n, A, i);
            return e.saveEntry(s, a), a;
          };
        }
      }
    window.addEventListener(
      "keydown",
      (A) => {
        if ("s" === A.key && A.ctrlKey && A.altKey) {
          let A = new Blob([JSON.stringify(this.entries, null, 2)]),
            e = document.createElement("a");
          (e.href = URL.createObjectURL(A)),
            "download" in e && (e.download = `trace.${Date.now()}.json`),
            (e.target = "_blank"),
            e.click(),
            window.URL.revokeObjectURL(e.href);
        }
      },
      !1
    );
  }
  async compress(A, e, t) {
    let i, n;
    if (this.gzipCompress) {
      const e = new window.CompressionStream("gzip"),
        t = e.writable.getWriter();
      t.write(A), t.close();
      const o = e.readable.getReader(),
        r = 18 + 5 * ((A.byteLength + 32767) >> 15) + A.byteLength;
      let s = !1;
      for (i = new Uint8Array(r), n = 0; !s; ) {
        const { value: A, done: e } = await o.read();
        e ? (s = !0) : (i.set(A, n), (n += A.byteLength));
      }
    } else (e.raw = !0), (i = new Uint8Array(A)), (n = i.byteLength);
    e[t] = (function (A, e) {
      let t,
        i = new Uint8Array(A.buffer, 0, e),
        n = "",
        o = e;
      for (t = 2; t < o; t += 3)
        (n += kr[i[t - 2] >> 2]),
          (n += kr[((3 & i[t - 2]) << 4) | (i[t - 1] >> 4)]),
          (n += kr[((15 & i[t - 1]) << 2) | (i[t] >> 6)]),
          (n += kr[63 & i[t]]);
      return (
        t === o + 1 && ((n += kr[i[t - 2] >> 2]), (n += kr[(3 & i[t - 2]) << 4]), (n += "==")),
        t === o &&
          ((n += kr[i[t - 2] >> 2]),
          (n += kr[((3 & i[t - 2]) << 4) | (i[t - 1] >> 4)]),
          (n += kr[(15 & i[t - 1]) << 2]),
          (n += "=")),
        n
      );
    })(i, n);
  }
  async compressString(A, e, t) {
    let i = new TextEncoder();
    return this.compress(i.encode(A), e, t);
  }
  createEntry(A, e) {
    let t = [A],
      i = { params: t };
    return (
      e.forEach((A) => {
        if (
          null === A ||
          "number" == typeof A ||
          ("string" == typeof A && A.length <= this.inlineStringThreshold) ||
          "boolean" == typeof A
        )
          return void t.push(A);
        if ("string" == typeof A && A.length > this.inlineStringThreshold) {
          let e = {};
          return t.push(e), void this.compressString(A, e, "string");
        }
        const e = Object.prototype.toString.call(A);
        if (e.includes("WebGL")) t.push({ id: this.objectMap.get(A) });
        else {
          if (
            A instanceof Uint8Array ||
            A instanceof Uint16Array ||
            A instanceof Uint32Array ||
            A instanceof Float32Array ||
            A instanceof ArrayBuffer
          ) {
            let i = {};
            return (
              t.push(i),
              void this.compress(
                A,
                i,
                e
                  .replace("[", "")
                  .replace("]", "")
                  .split(" ")
                  .pop()
                  .toLowerCase()
                  .replace("array", "")
              )
            );
          }
          t.push({ unsupported: e });
        }
      }),
      A.startsWith("delete") && this.objectMap.delete(e[0]),
      i
    );
  }
  saveEntry(A, e) {
    if (void 0 !== e)
      if (null === e || "number" == typeof e || "string" == typeof e || "boolean" == typeof e)
        A.ret = e;
      else {
        const t = Object.prototype.toString.call(e);
        t.includes("WebGL")
          ? ((A.ret = { id: this.objectId }), this.objectMap.set(e, this.objectId++))
          : (A.ret = { unsupported: t });
      }
    this.entries.push(A);
  }
}
var Kr =
    "#define RENDER_METHOD_CLIPMAP 0\n#define RENDER_METHOD_TILELIST 1\n#define RENDER_METHOD_PASSTHROUGH 2\n#define PIXEL_FORMAT_RGB 0\n#define PIXEL_FORMAT_NV12 1\n#define PIXEL_FORMAT_I420 2\n#define PIXEL_FORMAT_FRAME 3\n#define FRAME_TYPE_RGB 0\n#define FRAME_TYPE_I420 1\n#define FRAME_TYPE_I444 2\n#define FRAME_TYPE_BGRX 3\n#define RENDER_METHOD {0}\n#define PIXEL_FORMAT {1}\n#define FRAME_TYPE {2}\n#define in attribute\n#define out varying\nprecision highp float;\n#define GLSLIFY 1\nin vec2 position;out vec2 uv;\n#if RENDER_METHOD != RENDER_METHOD_PASSTHROUGH\nconst vec2 scale=vec2({3},{4});\n#endif\n#if (RENDER_METHOD == RENDER_METHOD_TILELIST) || (PIXEL_FORMAT == PIXEL_FORMAT_FRAME && (FRAME_TYPE == FRAME_TYPE_RGB || FRAME_TYPE == FRAME_TYPE_BGRX))\nuniform vec4 rectScaleAndOffset;\n#endif\nvoid main(){{\n#if RENDER_METHOD != RENDER_METHOD_PASSTHROUGH\ngl_Position=vec4(position.x*scale.x-1.0,position.y*scale.y+1.0,0.0,1.0);\n#else\ngl_Position=vec4(position.x,position.y,0.0,1.0);\n#endif\n#if RENDER_METHOD == RENDER_METHOD_PASSTHROUGH\nuv=position*0.5+0.5;\n#elif (RENDER_METHOD == RENDER_METHOD_TILELIST) || (PIXEL_FORMAT == PIXEL_FORMAT_FRAME && (FRAME_TYPE == FRAME_TYPE_RGB || FRAME_TYPE == FRAME_TYPE_BGRX))\nuv=position*rectScaleAndOffset.xy+rectScaleAndOffset.zw;\n#else\nuv=position;\n#endif\n}}",
  Lr =
    "precision highp float;\n#define GLSLIFY 1\n#define in varying\n#define color gl_FragColor\n#define PIXEL_FORMAT_RGB 0\n#define PIXEL_FORMAT_NV12 1\n#define PIXEL_FORMAT_I420 2\n#define PIXEL_FORMAT_FRAME 3\n#define FRAME_TYPE_RGB 0\n#define FRAME_TYPE_I420 1\n#define FRAME_TYPE_I444 2\n#define FRAME_TYPE_BGRX 3\n#define PIXEL_FORMAT {0}\n#define FRAME_TYPE {1}\nin vec2 uv;uniform sampler2D tile;uniform vec3 rv;uniform vec4 gv;uniform vec3 bv;\n#if PIXEL_FORMAT == PIXEL_FORMAT_I420\nconst vec4 size=vec4({2},{3},{4},{5});const vec3 additional=vec3({6},{7},{8});float yAt(vec2 coords){{return texture2D(tile,coords*size.xy).r;}}float uvAt(vec2 coords){{return texture2D(tile,coords*size.xy+size.zw).r;}}\n#elif (PIXEL_FORMAT == PIXEL_FORMAT_NV12) || ((PIXEL_FORMAT == PIXEL_FORMAT_FRAME) && !(FRAME_TYPE == FRAME_TYPE_RGB || FRAME_TYPE == FRAME_TYPE_BGRX))\nuniform vec4 texScaleAndOffsetLocation;uniform vec3 additional;float yAt(vec2 coords){{return texture2D(tile,coords*texScaleAndOffsetLocation.xy).r;}}float uvAt(vec2 coords){{return texture2D(tile,coords*texScaleAndOffsetLocation.xy+texScaleAndOffsetLocation.zw).r;}}\n#endif\nvoid main(){{\n#if PIXEL_FORMAT == PIXEL_FORMAT_RGB\ncolor=texture2D(tile,uv);\n#elif PIXEL_FORMAT == PIXEL_FORMAT_FRAME\n#if FRAME_TYPE == FRAME_TYPE_RGB\ncolor=texture2D(tile,uv);\n#elif FRAME_TYPE == FRAME_TYPE_BGRX\ncolor=texture2D(tile,uv).bgra;\n#else\nvec4 yuvw=vec4(1.0);yuvw.x=yAt(uv);\n#if FRAME_TYPE == FRAME_TYPE_I444\nyuvw.y=yAt(uv+vec2(0.0,additional.x));yuvw.z=yAt(uv+vec2(0.0,2.0*additional.x));\n#else\nvec2 coords=floor(uv);float row=floor(0.25*coords.y+0.125);float remainder=-4.0*row+coords.y;row=floor(row+additional.x);float column=remainder<2.0 ? floor(0.5*coords.x+0.25): floor(additional.y+floor(0.5*coords.x+0.25));yuvw.y=uvAt(vec2(column,row));yuvw.z=uvAt(vec2(column,floor(additional.z+row)));\n#endif\ncolor=vec4(dot(yuvw.xzw,rv),dot(yuvw,gv),dot(yuvw.xyw,bv),1.0);\n#endif\n#else\nvec4 yuvw=vec4(1.0);yuvw.x=yAt(uv);vec2 coords=floor(uv);\n#if PIXEL_FORMAT == PIXEL_FORMAT_I420\nfloat row=floor(0.25*coords.y+0.125);float remainder=-4.0*row+coords.y;row=floor(row+additional.x);float column=remainder<2.0 ? floor(0.5*coords.x+0.25): floor(additional.y+floor(0.5*coords.x+0.25));yuvw.y=uvAt(vec2(column,row));yuvw.z=uvAt(vec2(column,floor(additional.z+row)));\n#else\nfloat row=floor(0.5*coords.y+0.25);row=floor(row+additional.x);float column=floor(2.0*floor(0.5*coords.x+0.25)+0.5);yuvw.y=uvAt(vec2(column,row));yuvw.z=uvAt(vec2(floor(column+1.5),row));\n#endif\ncolor=vec4(dot(yuvw.xzw,rv),dot(yuvw,gv),dot(yuvw.xyw,bv),1.0);\n#endif\n}}";
function Tr(A, e, t, i, n) {
  let o,
    r,
    s,
    a,
    g,
    c,
    I,
    l,
    d,
    u = A;
  return (
    (o = u.createShader(u.VERTEX_SHADER)),
    u.shaderSource(o, e),
    u.compileShader(o),
    u.getShaderParameter(o, u.COMPILE_STATUS) ||
      n.error(`Vertex shader failed to compile: ${u.getShaderInfoLog(o)}`),
    (r = u.createShader(u.FRAGMENT_SHADER)),
    u.shaderSource(r, t),
    u.compileShader(r),
    u.getShaderParameter(r, u.COMPILE_STATUS) ||
      n.error(`Fragment shader failed to compile: ${u.getShaderInfoLog(r)}`),
    (s = u.createProgram()),
    u.attachShader(s, o),
    u.attachShader(s, r),
    u.bindAttribLocation(s, 0, "position"),
    u.linkProgram(s),
    u.getProgramParameter(s, u.LINK_STATUS) ||
      n.error(`Program failed to compile: ${u.getProgramInfoLog(s)}`),
    u.deleteShader(o),
    u.deleteShader(r),
    u.useProgram(s),
    u.uniform1i(u.getUniformLocation(s, "tile"), i),
    (a = u.getUniformLocation(s, "rv")),
    (g = u.getUniformLocation(s, "gv")),
    (c = u.getUniformLocation(s, "bv")),
    (I = u.getUniformLocation(s, "rectScaleAndOffset")),
    (l = u.getUniformLocation(s, "additional")),
    (d = u.getUniformLocation(s, "texScaleAndOffsetLocation")),
    u.useProgram(null),
    {
      program_name: s,
      uniforms_name: {
        rvLocation: a,
        gvLocation: g,
        bvLocation: c,
        rectScaleAndOffsetLocation: I,
        additionalLocation: l,
        texScaleAndOffsetLocation: d
      }
    }
  );
}
function Pr(A, e, t, i, n, o) {
  let r,
    s = A;
  return (
    (r = s.createTexture()),
    s.bindTexture(s.TEXTURE_2D, r),
    s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MAG_FILTER, s.NEAREST),
    s.texParameteri(s.TEXTURE_2D, s.TEXTURE_MIN_FILTER, s.NEAREST),
    s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_S, s.CLAMP_TO_EDGE),
    s.texParameteri(s.TEXTURE_2D, s.TEXTURE_WRAP_T, s.CLAMP_TO_EDGE),
    e && t && s.texImage2D(s.TEXTURE_2D, 0, i, e, t, 0, n, o, null),
    s.bindTexture(s.TEXTURE_2D, null),
    r
  );
}
function Gr(A, e) {
  const t = A;
  for (let A = 0; A < e.programs.length; A++) t.deleteProgram(e.programs[A].name);
  t.deleteBuffer(e.vbo_name),
    t.deleteTexture(e.texture_name),
    (e.vertices = null),
    (e.parameters = null);
}
function Hr(A, e) {
  const t = A;
  t.deleteFramebuffer(e.fbo),
    t.deleteTexture(e.texture),
    t.deleteProgram(e.program),
    t.deleteBuffer(e.vbo);
}
function Yr(A, e, t, i) {
  xr.call(this, i),
    (this.log = Q("WebGL1Renderer", i)),
    t.enableGraphicsDebugLayer && (this.gdb = new Nr(e)),
    (this.highPixelDensityEnabled = t.enableHighPixelDensity),
    (this.canvas = A),
    (this.canvas.width = 0),
    (this.canvas.height = 0),
    (this.dpr = 1),
    (this.clientHiDpiScaling = t.clientHiDpiScaling),
    (this.vertices = new Float32Array(12)),
    (this.openglLayerObject = []),
    (this.gl = e),
    this.gl.pixelStorei(this.gl.UNPACK_ALIGNMENT, 1),
    t.enableGpuTimer && (this.timer = new Or(this.gl, 10, i)),
    (this.offscreenRendering = {}),
    this.gl.clearColor(0.043, 0.184, 0.251, 1),
    this.gl.enableVertexAttribArray(0),
    this.log.info("Initialized Webgl1Renderer");
}
(Yr.prototype = Object.create(xr.prototype)),
  (Yr.prototype.constructor = Yr),
  (Yr.prototype.webGL = "WebGL1"),
  (Yr.prototype.addRenderingLayer = function (A, e) {
    let t,
      i,
      n = e.decoder;
    (t = this.getLayerTypeIndex(A)),
      -1 !== t
        ? ((i = this.getRenderingTypeIndex(n)),
          -1 !== i
            ? (this.openglLayerObject[t] &&
                (this.log.warn(`Already initialized rendering layer for stream: ${A}`),
                this.removeRenderingLayer(A)),
              (e.width = this.width),
              (e.height = this.height),
              (e.w16 = this.w16),
              (e.h16 = this.h16),
              (e.renderingIndex = i),
              (this.openglLayerObject[t] = (function (A, e, t) {
                let i,
                  n,
                  o,
                  r = A,
                  s = {},
                  a = e.w16,
                  g = e.h16,
                  c = e.pixelFormat,
                  I = e.renderMethod,
                  l = e.renderingIndex,
                  d = (1 / a).toFixed(10),
                  u = (1 / (1.5 * g)).toFixed(10),
                  C = (0.5 * d).toFixed(10),
                  B = (0.5 * u).toFixed(10),
                  Q = (g + 0.5).toFixed(10),
                  E = (0.5 + a / 2).toFixed(10),
                  h = (0.5 + g / 4).toFixed(10);
                (o = (function (A, e) {
                  let t,
                    i = A;
                  return (
                    (t = i.createBuffer()),
                    i.bindBuffer(i.ARRAY_BUFFER, t),
                    i.bufferData(i.ARRAY_BUFFER, 32, e),
                    i.bindBuffer(i.ARRAY_BUFFER, null),
                    { vbo_name: t }
                  );
                })(r, r.STREAM_DRAW)),
                  (s.vbo_name = o.vbo_name),
                  (s.parameters = e),
                  (s.pixelFormat = c),
                  l === xr.YUV
                    ? ((s.vertices = new Float32Array(12)),
                      c === xr.FRAME
                        ? (s.texture_name = Pr(r))
                        : (s.texture_name = Pr(
                            r,
                            e.w16,
                            (3 * e.h16) / 2,
                            r.LUMINANCE,
                            r.LUMINANCE,
                            r.UNSIGNED_BYTE
                          )))
                    : ((s.vertices = new Float32Array(8)), (s.texture_name = Pr(r))),
                  (i = c === xr.FRAME ? 4 : 1),
                  (s.programs = []);
                for (let A = 0; A < i; A++)
                  (n = Tr(
                    r,
                    io(Kr, I, c, A, (2 / e.width).toFixed(10), (-2 / e.height).toFixed(10)),
                    io(Lr, c, A, d, u, C, B, Q, E, h),
                    0,
                    t
                  )),
                    s.programs.push({ name: n.program_name, uniforms: n.uniforms_name });
                return s;
              })(this.gl, e, this.log)),
              this.log.info(`Initialized rendering layer ${n}`))
            : this.log.warn(`Unknown rendering type: ${n}`))
        : this.log.warn(`Unknown layer type: ${A}`);
  }),
  (Yr.prototype.removeRenderingLayer = function (A) {
    let e, t, i;
    (e = this.getLayerTypeIndex(A)),
      -1 !== e
        ? ((i = this.openglLayerObject[e]),
          i
            ? ((t = i.parameters.decoder),
              Gr(this.gl, i),
              (this.openglLayerObject[A] = null),
              this.log.info(`Removed rendering layer for stream: ${t}`))
            : this.log.warn(`Already removed rendering layer for stream: ${A}`))
        : this.log.warn(`Unknown layer type: ${A}`);
  }),
  (Yr.prototype.render = function (A) {
    let e,
      t,
      i,
      n,
      o,
      r,
      s,
      a,
      g,
      c,
      I,
      l,
      d = this.gl,
      u = this.w16,
      C = this.h16,
      B = this.offscreenRendering,
      Q = 0,
      E = A.buffer.data;
    if (((t = this.getLayerTypeIndex(A.layerType)), -1 !== t)) {
      if (this.openglLayerObject[t]) {
        if (
          ((e = this.openglLayerObject[t]),
          (a = e.vertices),
          (l = e.parameters.renderingIndex),
          e.pixelFormat === xr.FRAME && (A.isRgb ? dr() && (Q = 3) : (Q = A.isI420 ? 1 : 2)),
          this.timer && this.timer.start(l),
          d.bindFramebuffer(d.FRAMEBUFFER, B.fbo),
          d.useProgram(e.programs[Q].name),
          d.bindBuffer(d.ARRAY_BUFFER, e.vbo_name),
          d.bindTexture(d.TEXTURE_2D, e.texture_name),
          d.vertexAttribPointer(0, 2, d.FLOAT, !1, 0, 0),
          !A.isRgb)
        ) {
          const t = this.getYuvWeights(A);
          d.uniform3fv(e.programs[Q].uniforms.rvLocation, t.subarray(0, 3)),
            d.uniform4fv(e.programs[Q].uniforms.gvLocation, t.subarray(4, 8)),
            d.uniform3fv(e.programs[Q].uniforms.bvLocation, t.subarray(8, 11));
        }
        if (l === xr.YUV) {
          if (e.pixelFormat === xr.FRAME)
            if (A.isRgb)
              (i = A.rect || { x: 0, y: 0, width: A.width, height: A.height }),
                (g = e.programs[Q].uniforms.rectScaleAndOffsetLocation),
                d.uniform4f(g, 1 / i.width, 1 / i.height, -i.x / i.width, -i.y / i.height),
                dr()
                  ? d.texImage2D(
                      d.TEXTURE_2D,
                      0,
                      d.RGBA,
                      A.width,
                      A.height,
                      0,
                      d.RGBA,
                      d.UNSIGNED_BYTE,
                      E
                    )
                  : d.texImage2D(d.TEXTURE_2D, 0, d.RGBA, d.RGBA, d.UNSIGNED_BYTE, E);
            else if (A.isI420) {
              const t = 1 / A.width,
                n = 1 / (A.height + A.height / 2),
                o = 0.5 * t,
                r = 0.5 * n;
              (i = A.rect || { x: 0, y: 0, width: A.width, height: A.height }),
                (I = e.programs[Q].uniforms.additionalLocation),
                (c = e.programs[Q].uniforms.texScaleAndOffsetLocation),
                d.uniform4f(c, t, n, o, r),
                d.uniform3f(I, A.height + 0.5, 0.5 + A.width / 2, 0.5 + A.height / 4),
                d.texImage2D(
                  d.TEXTURE_2D,
                  0,
                  d.LUMINANCE,
                  A.width,
                  A.height + A.height / 2,
                  0,
                  d.LUMINANCE,
                  d.UNSIGNED_BYTE,
                  E
                );
            } else
              (i = A.rect || { x: 0, y: 0, width: A.width, height: A.height }),
                (I = e.programs[Q].uniforms.additionalLocation),
                (c = e.programs[Q].uniforms.texScaleAndOffsetLocation),
                d.uniform4f(c, 1 / A.width, 1 / (3 * A.height), 0, 0),
                d.uniform3f(I, A.height, 0, 0),
                d.texImage2D(
                  d.TEXTURE_2D,
                  0,
                  d.LUMINANCE,
                  A.width,
                  3 * A.height,
                  0,
                  d.LUMINANCE,
                  d.UNSIGNED_BYTE,
                  E
                );
          else
            (i = A.rect || { x: 0, y: 0, width: u, height: C }),
              d.texSubImage2D(d.TEXTURE_2D, 0, 0, 0, u, C + C / 2, d.LUMINANCE, d.UNSIGNED_BYTE, E);
          for (
            n = A.clip || [i],
              a.length < 12 * n.length && ((a = new Float32Array(12 * n.length)), (e.vertices = a)),
              o = 0,
              r = 0;
            o < n.length;
            o++
          )
            (s = n[o]),
              (a[r++] = s.x),
              (a[r++] = s.y),
              (a[r++] = s.x),
              (a[r++] = s.y + s.height),
              (a[r++] = s.x + s.width),
              (a[r++] = s.y),
              (a[r++] = s.x),
              (a[r++] = s.y + s.height),
              (a[r++] = s.x + s.width),
              (a[r++] = s.y),
              (a[r++] = s.x + s.width),
              (a[r++] = s.y + s.height);
          d.bufferData(d.ARRAY_BUFFER, a.slice(0, 12 * n.length), d.STREAM_DRAW),
            d.drawArrays(d.TRIANGLES, 0, 6 * n.length);
        } else
          (g = e.programs[Q].uniforms.rectScaleAndOffsetLocation),
            (i = A.rect),
            l !== xr.LZ4 || A.isRgb
              ? l === xr.JPEG
                ? (d.uniform4f(g, 1 / i.width, 1 / i.height, -i.x / i.width, -i.y / i.height),
                  d.texImage2D(d.TEXTURE_2D, 0, d.RGB, d.RGB, d.UNSIGNED_BYTE, E))
                : (d.uniform4f(g, 1 / i.width, 1 / i.height, -i.x / i.width, -i.y / i.height),
                  d.texImage2D(
                    d.TEXTURE_2D,
                    0,
                    d.RGB,
                    i.width,
                    i.height,
                    0,
                    d.RGB,
                    d.UNSIGNED_BYTE,
                    E
                  ))
              : ((c = e.programs[Q].uniforms.texScaleAndOffsetLocation),
                (I = e.programs[Q].uniforms.additionalLocation),
                d.texImage2D(
                  d.TEXTURE_2D,
                  0,
                  d.LUMINANCE,
                  i.width,
                  i.height + i.height / 2,
                  0,
                  d.LUMINANCE,
                  d.UNSIGNED_BYTE,
                  E
                ),
                d.uniform4f(
                  c,
                  1 / i.width,
                  1 / (1.5 * i.height),
                  0.5 / i.width,
                  0.5 / (1.5 * i.height)
                ),
                d.uniform4f(g, 1, 1, -i.x, -i.y),
                d.uniform3f(I, i.height + 0.5, 0, 0)),
            (a[0] = i.x),
            (a[1] = i.y),
            (a[2] = i.x + i.width),
            (a[3] = i.y),
            (a[4] = i.x),
            (a[5] = i.y + i.height),
            (a[6] = i.x + i.width),
            (a[7] = i.y + i.height),
            d.bufferSubData(d.ARRAY_BUFFER, 0, a),
            d.drawArrays(d.TRIANGLE_STRIP, 0, 4);
        this.highPixelDensityEnabled ||
          1 === this.dpr ||
          d.viewport(0, 0, this.canvas.width, this.canvas.height),
          d.bindFramebuffer(d.FRAMEBUFFER, null),
          d.useProgram(B.program),
          d.bindBuffer(d.ARRAY_BUFFER, B.vbo),
          d.vertexAttribPointer(0, 2, d.FLOAT, !1, 0, 0),
          d.drawArrays(d.TRIANGLES, 0, 3),
          this.timer && this.timer.stop(),
          this.highPixelDensityEnabled ||
            1 === this.dpr ||
            d.viewport(0, 0, this.width, this.height);
      } else this.log.warn(`Missing rendering layer for type: ${A.layerType}`);
      A.buffer && (A.buffer.release(), (A.buffer = null));
    } else this.log.warn(`Unknown layer type: ${A.layerType}`);
  }),
  (Yr.prototype.updateCanvasSize = function (A, e) {
    let t,
      i = this.canvas;
    return (
      this.highPixelDensityEnabled
        ? ((t = so(i)),
          (i.style.width = A / t + "px"),
          (i.style.height = e / t + "px"),
          (i.width = A),
          (i.height = e))
        : ((t = window.devicePixelRatio || 1),
          (this.clientHiDpiScaling && t % 2 == 0) || (t = 1),
          (i.width = t * A),
          (i.height = t * e),
          (i.style.width = `${A}px`),
          (i.style.height = `${e}px`)),
      t
    );
  }),
  (Yr.prototype.enableHighPixelDensity = function (A) {
    (this.highPixelDensityEnabled = A), (this.dpr = this.updateCanvasSize(this.width, this.height));
  }),
  (Yr.prototype.size = function (A, e) {
    if (this.width !== A || this.height !== e) {
      let t = this.gl,
        i = this.updateCanvasSize(A, e);
      (this.dpr = i),
        (this.width = A),
        (this.height = e),
        (this.w16 = (this.width + 16 - 1) & -16),
        (this.h16 = (this.height + 16 - 1) & -16),
        Hr(this.gl, this.offscreenRendering),
        (this.offscreenRendering = (function (A, e, t, i) {
          let n,
            o,
            r,
            s,
            a,
            g = A;
          return (
            (n = g.createFramebuffer()),
            g.bindFramebuffer(g.FRAMEBUFFER, n),
            (o = g.createTexture()),
            g.activeTexture(g.TEXTURE0 + 1),
            g.bindTexture(g.TEXTURE_2D, o),
            g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.NEAREST),
            g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.NEAREST),
            g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_S, g.CLAMP_TO_EDGE),
            g.texParameteri(g.TEXTURE_2D, g.TEXTURE_WRAP_T, g.CLAMP_TO_EDGE),
            g.texImage2D(g.TEXTURE_2D, 0, g.RGBA, e, t, 0, g.RGBA, g.UNSIGNED_BYTE, null),
            g.activeTexture(g.TEXTURE0),
            g.framebufferTexture2D(g.FRAMEBUFFER, g.COLOR_ATTACHMENT0, g.TEXTURE_2D, o, 0),
            g.checkFramebufferStatus(g.FRAMEBUFFER) || i.error("Framebuffer is not complete"),
            g.clear(g.COLOR_BUFFER_BIT),
            g.bindTexture(g.TEXTURE_2D, null),
            g.bindFramebuffer(g.FRAMEBUFFER, null),
            (s = new Float32Array([-1, -1, 3, -1, -1, 3])),
            (r = g.createBuffer()),
            g.bindBuffer(g.ARRAY_BUFFER, r),
            g.bufferData(g.ARRAY_BUFFER, s, g.STATIC_DRAW),
            g.bindBuffer(g.ARRAY_BUFFER, null),
            (a = Tr(
              g,
              io(Kr, xr.PASSTHROUGH, xr.RGB, 0, 1, 1),
              io(Lr, xr.RGB, 0, 1, 1, 0, 0, 0, 0, 0),
              1,
              i
            )),
            { fbo: n, texture: o, vbo: r, program: a.program_name }
          );
        })(this.gl, this.width, this.height, this.log)),
        t.viewport(0, 0, this.width, this.height),
        this.log.info("Resized viewport"),
        this.log.debug(`Selected dpr: ${i}`);
    }
  }),
  (Yr.prototype.release = function () {
    const A = this;
    this.gl
      ? (this.openglLayerObject.forEach((e, t) => {
          e && Gr(A.gl, e);
        }),
        Hr(this.gl, this.offscreenRendering),
        this.timer && this.timer.dispose(),
        (this.offscreenRendering = null),
        (this.openglLayerObject = null),
        (this.canvas = null),
        (this.gl = null),
        (this.vertices = null),
        this.log.info("Released renderer resources"))
      : this.log.warn("OpenGL context not defined, skip release");
  });
var qr =
    "#version 300 es\n#define GLSLIFY 1\nlayout(location=0)in mediump uint id;out vec2 uv;void main(){vec2 pos=-1.0+vec2((id&1u)<<2u,(id&2u)<<1u);gl_Position=vec4(pos,0.0,1.0);uv=0.5*pos+0.5;}",
  Jr =
    "#version 300 es\n#define GLSLIFY 1\nin highp vec2 uv;uniform lowp sampler2D tile;out lowp vec4 color;void main(){color=texture(tile,uv);}";
const jr = 4096,
  Wr = 65535,
  Vr = 1,
  _r = 2,
  Xr = 4,
  zr = 8,
  Zr = 16,
  $r = 32,
  As = { RGB: 0, I420: 1, I444: 2, NV12: 3, BGRX: 4 },
  es = (A) => Math.min(A >> 1, As.BGRX);
function ts(A, e, t, i, n, o) {
  const r = A.createShader(A.VERTEX_SHADER);
  null !== i ? A.shaderSource(r, io(e, i, n, o)) : A.shaderSource(r, e), A.compileShader(r);
  const s = A.createShader(A.FRAGMENT_SHADER);
  return (
    null !== i ? A.shaderSource(s, io(t, i, n)) : A.shaderSource(s, t), A.compileShader(s), [r, s]
  );
}
function is(A, e) {
  const t = A.createProgram();
  return A.attachShader(t, e[0]), A.attachShader(t, e[1]), A.linkProgram(t), [t, e];
}
function ns(A, e, t, i) {
  const n = e[0],
    o = e[1],
    r = A.getProgramParameter(n, A.LINK_STATUS);
  if (
    (r ||
      (i.error(`Program failed to compile: ${A.getProgramInfoLog(n)}`),
      A.getShaderParameter(o[0], A.COMPILE_STATUS) ||
        i.error(`Vertex shader failed to compile: ${A.getShaderInfoLog(o[0])}`),
      A.getShaderParameter(o[1], A.COMPILE_STATUS) ||
        i.error(`Fragment shader failed to compile: ${A.getShaderInfoLog(o[1])}`)),
    A.deleteShader(o[0]),
    A.deleteShader(o[1]),
    r && (A.useProgram(n), A.uniform1i(A.getUniformLocation(n, "tile"), 0), null !== t))
  ) {
    const e = es(t);
    A.uniformBlockBinding(n, A.getUniformBlockIndex(n, "viewConstants"), 0),
      e !== As.RGB &&
        e !== As.BGRX &&
        A.uniformBlockBinding(n, A.getUniformBlockIndex(n, "frameConstants"), 1);
  }
  return n;
}
function os(A, e) {
  e.rbo && A.deleteTexture(e.rbo), e.fbo && A.deleteFramebuffer(e.fbo);
}
const rs = function (A, e) {
  const t = A.length;
  let i = 0;
  for (let n = 0; n < t; n++) {
    const t = A[n],
      o = t.x,
      r = t.y,
      s = o + t.width,
      a = r + t.height;
    (e[i] = o),
      (e[i + 1] = r),
      (i += 4),
      (e[i] = o),
      (e[i + 1] = a),
      (i += 4),
      (e[i] = s),
      (e[i + 1] = r),
      (i += 4),
      (e[i] = o),
      (e[i + 1] = a),
      (i += 4),
      (e[i] = s),
      (e[i + 1] = r),
      (i += 4),
      (e[i] = s),
      (e[i + 1] = a),
      (i += 4);
  }
};
function ss(A, e) {
  return (
    A.renderMethod === xr.CLIPMAP
      ? rs(A.vertices, e)
      : (function (A, e) {
          const t = A.length;
          let i = 0,
            n = 0;
          for (let o = 0; o < t; o++) {
            const t = A[o],
              r = t.x,
              s = t.width,
              a = t.height,
              g = r | (t.y << 16),
              c = s | (a << 16);
            for (let A = 0; A < 6; A++) (e[i] = g), (e[i + 1] = c), (e[i + 2] = n), (i += 4);
            n += (s * a) >> 2;
          }
        })(A.vertices, e),
    !0
  );
}
function as(A, e) {
  return A.renderMethod === xr.CLIPMAP
    ? (rs(A.vertices, e), !0)
    : (function (A, e) {
        const t = A.length;
        let i = 0,
          n = 0;
        for (let o = 0; o < t; o++) {
          const t = A[o],
            r = t.x,
            s = t.y,
            a = t.width,
            g = t.height;
          if ((31 & r) | (31 & s)) return !1;
          const c = (n - 1) & 16777215,
            I = 65535 & c,
            l =
              ((((a + 31) & -32) - a) >> 1) |
              (((((g + 31) & -32) - g) >> 1) << 4) |
              ((c >> 16) << 8),
            d = (r >> 5) | ((s >> 5) << 8),
            u = (((a + 31) >> 5) - 1) | ((((g + 31) >> 5) - 1) << 8);
          for (let A = 0; A < 6; A++)
            (e[i] = d), (e[i + 1] = u), (e[i + 2] = I), (e[i + 3] = l), (i += 4);
          n += (a * g) >> 2;
        }
        return !0;
      })(A.vertices, e);
}
function gs(A, e, t, i) {
  xr.call(this, i),
    (this.log = Q("WebGL2Renderer", i)),
    t.enableGraphicsDebugLayer && (this.gdb = new Nr(e)),
    (this.drawIndex = 0),
    (this.highPixelDensityEnabled = t.enableHighPixelDensity),
    (this.canvas = A),
    (this.canvas.width = 0),
    (this.canvas.height = 0),
    (this.clientHiDpiScaling = t.clientHiDpiScaling),
    (this.tileGroupRenderingEnabled = t.enableTileGroupRendering),
    (this.currentProgram = null),
    (this.currentConstants = [null, null, null, null, null]),
    (this.currentViewport = [null, null]),
    (this.textureAtlas = 0),
    (this.textureCache = {}),
    (this.gl = e),
    this.createRenderPipeline(!1),
    this.createVertexData(Wr);
  const n = is(e, ts(e, qr, Jr));
  (this.blitProgram = ns(e, n, null, this.log)), e.useProgram(null);
  const [o, r] = (function (A) {
    const e = new Uint16Array([0, 1, 2]),
      t = A.createBuffer();
    A.bindBuffer(A.ARRAY_BUFFER, t),
      A.bufferData(A.ARRAY_BUFFER, e, A.STATIC_DRAW),
      A.bindBuffer(A.ARRAY_BUFFER, null);
    const i = A.createVertexArray();
    return (
      A.bindVertexArray(i),
      A.enableVertexAttribArray(0),
      A.bindBuffer(A.ARRAY_BUFFER, t),
      A.vertexAttribIPointer(0, 1, A.UNSIGNED_SHORT, 0, 0),
      A.bindVertexArray(null),
      A.bindBuffer(A.ARRAY_BUFFER, null),
      [i, t]
    );
  })(e);
  (this.blitVao = o),
    (this.blitBuffer = r),
    (this.viewData = new Float32Array(4)),
    (this.frameData = new ArrayBuffer(64)),
    (this.yuvWeights = new Float32Array(this.frameData, 0, 12)),
    (this.imageSize = new Int32Array(this.frameData, 48, 4)),
    (this.viewConstants = e.createBuffer()),
    e.bindBufferBase(e.UNIFORM_BUFFER, 0, this.viewConstants),
    e.bufferData(e.UNIFORM_BUFFER, this.viewData.byteLength, e.DYNAMIC_DRAW),
    (this.frameConstants = e.createBuffer()),
    e.bindBufferBase(e.UNIFORM_BUFFER, 1, this.frameConstants),
    e.bufferData(e.UNIFORM_BUFFER, this.frameData.byteLength, e.DYNAMIC_DRAW),
    e.bindBuffer(e.UNIFORM_BUFFER, null),
    e.pixelStorei(e.UNPACK_ALIGNMENT, 1),
    t.enableGpuTimer && (this.timer = new Or(e, 10, i)),
    (this.offscreenRendering = {}),
    this.log.info(
      `Initialized Webgl2Renderer, tile group rendering enabled: ${this.tileGroupRenderingEnabled}`
    );
}
function cs(A, e, t, i) {
  xr.call(this, i),
    (this.log = Q("Context2DRenderer", i)),
    (this.highPixelDensityEnabled = t.enableHighPixelDensity),
    (this.canvas = A),
    (this.width = A.width),
    (this.height = A.height),
    (this.layerObject = []),
    (this.ctx = e),
    this.log.info("Initialized Context2DRenderer");
}
function Is(A, e) {
  return "webgl2" === A && gs.getSupportsTileGroupRendering(e);
}
function ls(A) {
  return "webgl2" === A;
}
(gs.getSupportsTileGroupRendering = function (A) {
  return null !== A && A.getParameter(A.MAX_TEXTURE_SIZE) >= jr;
}),
  (gs.prototype = Object.create(xr.prototype)),
  (gs.prototype.constructor = gs),
  (gs.prototype.webGL = "WebGL2"),
  (gs.prototype.setDisplayWindow = function (A) {}),
  (gs.prototype.addRenderingLayer = function (A, e) {}),
  (gs.prototype.removeRenderingLayer = function (A) {}),
  (gs.prototype.createRenderPipeline = function (A) {
    const e = this.gl,
      t = [];
    for (let i = 0; i < 10; i++)
      t.push(
        ts(
          e,
          "#version 300 es\n#define GLSLIFY 1\n#ifndef RENDER_METHOD\n#define RENDER_METHOD ({0} & 1)\n#endif\n#ifndef PIXEL_FORMAT\n#define PIXEL_FORMAT ({0} >> 1)\n#endif\n#ifndef USE_TEXTURE_ATLAS\n#define USE_TEXTURE_ATLAS {1}\n#endif\n#ifndef ANY_BLOCK\n#define ANY_BLOCK {2}\n#endif\n#define RENDER_METHOD_TILELIST 0\n#define RENDER_METHOD_CLIPMAP 1\n#define PIXEL_FORMAT_RGB 0\n#define PIXEL_FORMAT_I420 1\n#define PIXEL_FORMAT_I444 2\n#define PIXEL_FORMAT_NV12 3\n#define PIXEL_FORMAT_BGRX 4\n#if ANY_BLOCK\nlayout(location=0)in uvec4 position;\n#else\nlayout(location=0)in mediump uvec4 position;\n#endif\nlayout(std140)uniform viewConstants{vec4 scale;};out vec2 uv;\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nconst uvec4 PIXEL_SIZE[]=uvec4[](uvec4(3,0,0,0),uvec4(1,0,1,1),uvec4(1,0,1,0),uvec4(1,0,2,1),uvec4(4,0,0,0));flat out uvec4 decoder_tex_size;void output_tex_size(uvec2 tile_size,uint offset){uvec2 strides=(tile_size.xx*PIXEL_SIZE[PIXEL_FORMAT].xz)>>PIXEL_SIZE[PIXEL_FORMAT].yw;uvec2 offsets=(tile_size.yy*strides)>>PIXEL_SIZE[PIXEL_FORMAT].yw;\n#if PIXEL_FORMAT == PIXEL_FORMAT_RGB || PIXEL_FORMAT == PIXEL_FORMAT_I444\nuint base_offset=offset*12u;\n#elif PIXEL_FORMAT == PIXEL_FORMAT_BGRX\nuint base_offset=offset*16u;\n#else\nuint base_offset=offset*6u;\n#endif\ndecoder_tex_size=uvec4(tile_size.x,offsets.x,offsets.x+offsets.y,base_offset);}\n#endif\nmediump uvec2 extents(mediump uvec2 s){uint id=uint(gl_VertexID)&0xFFFFu;uint vid=id*0xAAABu;vid=(vid>>17u)&0xFFFFFFFEu;vid=id-3u*vid;mediump uvec2 sm=uvec2(vid==2u||vid>3u,vid&1u);return(1u+~sm)&s;}void output_pos_uv(vec2 pos,mediump uvec2 e){gl_Position=vec4(pos*scale.xy+vec2(-1.0,1.0),0.0,1.0);uv=vec2(e);}void main(){\n#if RENDER_METHOD == RENDER_METHOD_CLIPMAP\nvec2 pos=vec2(position.xy);gl_Position=vec4(pos*scale.xy+vec2(-1.0,1.0),0.0,1.0);uv=pos;\n#elif ANY_BLOCK\nconst uint mask=0xFFFFu;const uint shift=16u;mediump uvec2 p=uvec2(position.x&mask,position.x>>shift);mediump uvec2 s=uvec2(position.y&mask,position.y>>shift);mediump uvec2 e=extents(s);vec2 pos=vec2(p+e);output_pos_uv(pos,e);\n#if USE_TEXTURE_ATLAS\noutput_tex_size(s,position.z);\n#endif\n#else\nconst mediump uint block_size=32u;const mediump uint mask=0xFFu;const mediump uint shift=8u;mediump uvec2 p=uvec2(position.x&mask,position.x>>shift);mediump uvec2 s=uvec2(position.y&mask,position.y>>shift);s=block_size*s+block_size;mediump uvec2 e=extents(s);vec2 pos=vec2(block_size*p+e);output_pos_uv(pos,e);\n#if USE_TEXTURE_ATLAS\nmediump uvec2 grid_off=uvec2(position.w&0xFu,(position.w>>4u)&0xFu);uvec2 tile_size=s-2u*grid_off;uint offset_lo=position.z;uint residuals=position.w;uint base_offset=offset_lo|((residuals>>8u)<<16u);base_offset=(base_offset+1u)&0xFFFFFFu;output_tex_size(tile_size,base_offset);\n#endif\n#endif\n}",
          "#version 300 es\n#ifndef RENDER_METHOD\n#define RENDER_METHOD ({0} & 1)\n#endif\n#ifndef PIXEL_FORMAT\n#define PIXEL_FORMAT ({0} >> 1)\n#endif\n#ifndef USE_TEXTURE_ATLAS\n#define USE_TEXTURE_ATLAS {1}\n#endif\n#define RENDER_METHOD_TILELIST 0\n#define RENDER_METHOD_CLIPMAP 1\n#define PIXEL_FORMAT_RGB 0\n#define PIXEL_FORMAT_I420 1\n#define PIXEL_FORMAT_I444 2\n#define PIXEL_FORMAT_NV12 3\n#define PIXEL_FORMAT_BGRX 4\nprecision highp float;\n#define GLSLIFY 1\nin vec2 uv;\n#if PIXEL_FORMAT == PIXEL_FORMAT_RGB\n#define sampler_t lowp\n#else\n#define sampler_t highp\n#endif\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nuniform highp usampler2D tile;flat in highp uvec4 decoder_tex_size;highp uint get_index(highp uvec2 pos){return pos.y*decoder_tex_size.x+pos.x;}sampler_t float pull_sample(highp uint index){index+=decoder_tex_size.w;highp uint texel_index=index>>2u;highp uint texel_bank=index&3u;highp uint atlas_x=texel_index&0xFFFu;highp uint atlas_y=texel_index>>12u;highp uint texel=texelFetch(tile,ivec2(atlas_x,atlas_y),0).r;texel=(texel>>(texel_bank<<3u))&0xFFu;highp float result=float(texel)*(1.0/255.0);return result;}\n#else\nuniform sampler_t sampler2D tile;\n#endif\n#if PIXEL_FORMAT == PIXEL_FORMAT_RGB\nlowp vec4 fetch_rgba(ivec2 coords){\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nhighp uvec2 pos=uvec2(coords);highp uint index=3u*get_index(pos);return vec4(pull_sample(index),pull_sample(index+1u),pull_sample(index+2u),1.0);\n#else\nreturn texelFetch(tile,coords,0);\n#endif\n}\n#elif PIXEL_FORMAT == PIXEL_FORMAT_BGRX\nlowp vec4 fetch_bgrx(ivec2 coords){\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nhighp uvec2 pos=uvec2(coords);highp uint index=4u*get_index(pos);return vec4(pull_sample(index+2u),pull_sample(index+1u),pull_sample(index),1.0);\n#else\nreturn texelFetch(tile,coords,0).bgra;\n#endif\n}\n#else\nlayout(std140)uniform frameConstants{vec4 rv;vec4 gv;vec4 bv;ivec4 image_size;};float fetch_y(ivec2 coords){\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nhighp uvec2 pos=uvec2(coords);highp uint index=get_index(pos);return pull_sample(index);\n#else\nreturn texelFetch(tile,coords,0).r;\n#endif\n}vec2 fetch_uv_i444(ivec2 coords){\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nhighp uvec2 pos=uvec2(coords);highp uint index=get_index(pos);return vec2(pull_sample(decoder_tex_size.y+index),pull_sample(decoder_tex_size.z+index));\n#else\nreturn vec2(texelFetch(tile,coords+ivec2(0,image_size.x),0).r,texelFetch(tile,coords+ivec2(0,image_size.y),0).r);\n#endif\n}vec2 fetch_uv_i420(ivec2 coords){\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nhighp uvec2 pos=uvec2(coords);highp uvec2 half_pos=pos>>1u;highp uint half_stride=decoder_tex_size.x>>1u;highp uint chroma_index=half_pos.y*half_stride+half_pos.x;return vec2(pull_sample(decoder_tex_size.y+chroma_index),pull_sample(decoder_tex_size.z+chroma_index));\n#else\nint row=coords.y>>2;int remainder=coords.y-4*row;int half_x=coords.x>>1;int column=remainder<2 ? half_x : image_size.y+half_x;return vec2(texelFetch(tile,ivec2(column,image_size.x+row),0).r,texelFetch(tile,ivec2(column,image_size.z+row),0).r);\n#endif\n}vec2 fetch_uv_nv12(ivec2 coords){\n#if USE_TEXTURE_ATLAS && RENDER_METHOD == RENDER_METHOD_TILELIST\nhighp uvec2 pos=uvec2(coords);highp uint offset=(pos.x&~1u)+decoder_tex_size.y;highp uint chroma_index=(pos.y>>1u)*decoder_tex_size.x+offset;return vec2(pull_sample(chroma_index),pull_sample(chroma_index+1u));\n#else\nint row=(coords.y>>1)+image_size.x;int column=coords.x&~1;return vec2(texelFetch(tile,ivec2(column,row),0).r,texelFetch(tile,ivec2(column+1,row),0).r);\n#endif\n}lowp vec4 yuv_to_rgb(vec4 yuvw){return vec4(dot(yuvw.xzw,rv.xyz),dot(yuvw,gv),dot(yuvw.xyw,bv.xyz),1.0);}\n#endif\nout lowp vec4 color;void main(){ivec2 coords=ivec2(uv);\n#if PIXEL_FORMAT == PIXEL_FORMAT_RGB\ncolor=fetch_rgba(coords);\n#elif PIXEL_FORMAT == PIXEL_FORMAT_BGRX\ncolor=fetch_bgrx(coords);\n#else\nvec4 yuvw=vec4(fetch_y(coords),\n#if PIXEL_FORMAT == PIXEL_FORMAT_I420\nfetch_uv_i420(coords),\n#elif PIXEL_FORMAT == PIXEL_FORMAT_I444\nfetch_uv_i444(coords),\n#else\nfetch_uv_nv12(coords),\n#endif\n1.0);color=yuv_to_rgb(yuvw);\n#endif\n}",
          i,
          this.tileGroupRenderingEnabled ? 1 : 0,
          A ? 1 : 0
        )
      );
    const i = t.map((A) => is(e, A));
    this.programs = [];
    for (let A = 0; A < 10; A++) this.programs.push(ns(e, i[A], A, this.log));
    (this.fillGeometry = A ? ss : as), (this.anyBlock = A);
  }),
  (gs.prototype.createVertexData = function (A) {
    const e = this.gl,
      [t, i] = (function (A, e, t) {
        const i = e ? 4 : 2,
          n = A.createBuffer();
        A.bindBuffer(A.ARRAY_BUFFER, n),
          A.bufferData(A.ARRAY_BUFFER, 4 * t * i, A.STREAM_DRAW),
          A.bindBuffer(A.ARRAY_BUFFER, null);
        const o = A.createVertexArray();
        return (
          A.bindVertexArray(o),
          A.enableVertexAttribArray(0),
          A.bindBuffer(A.ARRAY_BUFFER, n),
          A.vertexAttribIPointer(0, 4, e ? A.UNSIGNED_INT : A.UNSIGNED_SHORT, 0, 0),
          A.bindVertexArray(null),
          A.bindBuffer(A.ARRAY_BUFFER, null),
          [o, n]
        );
      })(e, this.anyBlock, A);
    (this.vao_name = t),
      (this.vbo_name = i),
      this.anyBlock
        ? (this.vertices = new Uint32Array(4 * A))
        : (this.vertices = new Uint16Array(4 * A)),
      (this.maxNumVertices = A);
  }),
  (gs.prototype.destroyVertexData = function () {
    const A = this.gl;
    A.deleteVertexArray(this.vao_name), A.deleteBuffer(this.vbo_name), (this.vertices = null);
  }),
  (gs.prototype.destroyRenderPipeline = function () {
    const A = this.gl;
    this.programs.forEach((e) => A.deleteProgram(e)),
      (this.programs = null),
      (this.fillGeometry = null);
  }),
  (gs.prototype.setProgram = function (A) {
    if (A !== this.currentProgram) {
      this.gl.useProgram(A), (this.currentProgram = A);
    }
  }),
  (gs.prototype.setFrameConstants = function (A) {
    for (let e = 0; e < 3; e++) A[e] = A[e] || this.currentConstants[e];
    if (!A.every((A, e) => A === this.currentConstants[e])) {
      const e = this.gl;
      this.yuvWeights.set(this.getYuvWeights({ isBt601: A[3], isFullRange: A[4] }), 0),
        (this.imageSize[0] = A[0]),
        (this.imageSize[1] = A[1]),
        (this.imageSize[2] = A[2]),
        e.bindBuffer(e.UNIFORM_BUFFER, this.frameConstants),
        e.bufferSubData(e.UNIFORM_BUFFER, 0, this.frameData),
        e.bindBuffer(e.UNIFORM_BUFFER, null),
        (this.currentConstants = A);
    }
  }),
  (gs.prototype.setViewport = function (A, e) {
    if (A !== this.currentViewport[0] || e !== this.currentViewport[1]) {
      this.gl.viewport(0, 0, A, e), (this.currentViewport[0] = A), (this.currentViewport[1] = e);
    }
  }),
  (gs.prototype.updateAtlas = function (A) {
    const e = this.gl,
      t = this.textureAtlas;
    0 !== t && e.deleteTexture(t);
    const i = e.createTexture();
    if (
      (e.bindTexture(e.TEXTURE_2D, i),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE),
      e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE),
      dr())
    ) {
      const t = new Uint32Array(jr * A);
      e.texImage2D(e.TEXTURE_2D, 0, e.R32UI, jr, A, 0, e.RED_INTEGER, e.UNSIGNED_INT, t);
    } else e.texStorage2D(e.TEXTURE_2D, 1, e.R32UI, jr, A);
    return (this.textureAtlas = i), !0;
  }),
  (gs.prototype.updateTexture = function (A) {
    const e = this.gl;
    let t = A;
    if (this.tileGroupRenderingEnabled && t.renderMethod === xr.TILELIST) {
      const A = t.texData.data,
        i = t.texData.length,
        n = 16384,
        o = (i / n) | 0;
      if (i < n) return void this.log.warn("Not enough data to upload");
      if (o * n !== i) return void this.log.warn("Data not padded to row size");
      this.updateAtlas(o);
      const r = new Uint32Array(A.buffer);
      e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, jr, o, e.RED_INTEGER, e.UNSIGNED_INT, r);
    } else if (t.tex) e.bindTexture(e.TEXTURE_2D, t.tex);
    else {
      const A = t.texData.data,
        i = t.texSize,
        n = t.texFormat,
        o = t.texStatic,
        r = i.width,
        s = this.w16;
      let a, g, c, I;
      n & (Vr | _r)
        ? ((a = i.height + (i.height >> 1)), (I = this.h16 + (this.h16 >> 1)))
        : n & Xr
          ? ((a = 3 * i.height), (I = 3 * this.h16))
          : ((a = i.height), (I = this.h16)),
        n & (Vr | _r | Xr)
          ? ((g = e.RED), (c = e.R8))
          : n & Zr
            ? ((g = e.RGBA), (c = e.RGBA))
            : n & $r
              ? ((g = e.RGBA), (c = e.RGBA8))
              : ((g = e.RGB), (c = e.RGB8));
      const l = o ? [r, a, n] : [s, I, n];
      let d;
      if (l in this.textureCache) (d = this.textureCache[l]), e.bindTexture(e.TEXTURE_2D, d);
      else {
        if (
          ((d = e.createTexture()),
          e.bindTexture(e.TEXTURE_2D, d),
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, e.NEAREST),
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, e.NEAREST),
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE),
          e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE),
          !(n & Zr))
        )
          if (dr()) {
            let A = 1;
            g !== e.RED && (A = g === e.RGBA ? 4 : 3);
            const t = new Uint8Array(A * l[0] * l[1]);
            e.texImage2D(e.TEXTURE_2D, 0, c, l[0], l[1], 0, g, e.UNSIGNED_BYTE, t);
          } else e.texStorage2D(e.TEXTURE_2D, 1, c, l[0], l[1]);
        this.textureCache[l] = d;
      }
      n & Zr
        ? e.texImage2D(e.TEXTURE_2D, 0, c, g, e.UNSIGNED_BYTE, A)
        : e.texSubImage2D(e.TEXTURE_2D, 0, 0, 0, r, a, g, e.UNSIGNED_BYTE, A),
        (t.tex = d);
    }
  }),
  (gs.prototype.createCommand = function (A) {
    let e,
      t = { texData: A.buffer, texStatic: !1 };
    return (
      A.renderMethod === xr.TILELIST
        ? A.pixelFormat === xr.RGB
          ? (t.program = 0)
          : A.pixelFormat === xr.NV12
            ? (t.program = 6)
            : A.pixelFormat === xr.I420
              ? (t.program = 2)
              : (t.program = 4)
        : A.isRgb
          ? dr()
            ? (t.program = 9)
            : (t.program = 1)
          : A.pixelFormat !== xr.FRAME || A.isI420
            ? (t.program = 3)
            : (t.program = 5),
      A.renderMethod === xr.TILELIST
        ? this.tileGroupRenderingEnabled ||
          ((t.texSize = A.rect),
          A.pixelFormat === xr.RGB
            ? (t.texFormat = zr)
            : A.pixelFormat === xr.NV12
              ? (t.texFormat = Vr)
              : A.pixelFormat === xr.I420
                ? (t.texFormat = _r)
                : (t.texFormat = Xr),
          (e = t.texSize))
        : A.isRgb
          ? (dr() ? ((t.texStatic = !0), (t.texFormat = $r)) : (t.texFormat = Zr),
            (t.texSize = { x: 0, y: 0, width: A.width, height: A.height }),
            (e = A.rect || t.texSize))
          : A.pixelFormat !== xr.FRAME
            ? ((t.texStatic = !0),
              (t.texSize = { x: 0, y: 0, width: this.w16, height: this.h16 }),
              (t.texFormat = _r),
              (e = A.rect || t.texSize))
            : ((t.texStatic = !0),
              (t.texSize = { x: 0, y: 0, width: A.width, height: A.height }),
              (t.texFormat = A.isI420 ? _r : Xr),
              (e = A.rect || t.texSize)),
      (t.renderMethod = A.renderMethod),
      A.renderMethod === xr.CLIPMAP
        ? (t.vertices = A.clip || [e])
        : (t.vertices = this.tileGroupRenderingEnabled ? A.clip : [e]),
      (t.numVertices = 6 * t.vertices.length),
      (t.isRgb = A.isRgb),
      A.isRgb ||
        ((t.constants = [null, null, null, A.isBt601, A.isFullRange]),
        A.renderMethod === xr.TILELIST
          ? this.tileGroupRenderingEnabled ||
            (A.pixelFormat === xr.NV12
              ? (t.constants[0] = A.rect.height)
              : A.pixelFormat === xr.I420
                ? ((t.constants[0] = A.rect.height),
                  (t.constants[1] = A.rect.width >> 1),
                  (t.constants[2] = A.rect.height + (A.rect.height >> 2)))
                : ((t.constants[0] = A.rect.height), (t.constants[1] = A.rect.height << 1)))
          : A.pixelFormat === xr.FRAME
            ? ((t.constants[0] = A.height),
              A.isI420
                ? ((t.constants[1] = A.width >> 1), (t.constants[2] = A.height + (A.height >> 2)))
                : (t.constants[1] = A.height << 1))
            : A.pixelFormat === xr.I420 &&
              ((t.constants[0] = this.h16),
              (t.constants[1] = this.w16 >> 1),
              (t.constants[2] = this.h16 + (this.h16 >> 2)))),
      t
    );
  }),
  (gs.prototype.renderCommand = function (A) {
    const e = this.gl;
    this.updateTexture(A),
      A.isRgb || this.setFrameConstants(A.constants),
      this.setProgram(this.programs[A.program]),
      e.drawArrays(e.TRIANGLES, 0, A.numVertices);
  }),
  (gs.prototype.updateCanvasSize = function (A, e) {
    let t,
      i = this.canvas;
    return (
      this.highPixelDensityEnabled
        ? ((t = so(i)),
          (i.style.width = A / t + "px"),
          (i.style.height = e / t + "px"),
          (i.width = A),
          (i.height = e))
        : ((t = window.devicePixelRatio || 1),
          (this.clientHiDpiScaling && t % 2 == 0) || (t = 1),
          (i.width = t * A),
          (i.height = t * e),
          (i.style.width = `${A}px`),
          (i.style.height = `${e}px`)),
      t
    );
  }),
  (gs.prototype.enableHighPixelDensity = function (A) {
    (this.highPixelDensityEnabled = A), this.updateCanvasSize(this.width, this.height);
  }),
  (gs.prototype.submitLayout = function () {
    const A = this.gl,
      e = this.width,
      t = this.height,
      i = this.updateCanvasSize(e, t);
    this.log.info("Resized viewport"),
      this.log.debug(`Selected dpr: ${i}`),
      os(A, this.offscreenRendering),
      Object.keys(this.textureCache).forEach((e) => A.deleteTexture(this.textureCache[e])),
      (this.textureCache = {}),
      (this.w16 = (e + 15) & -16),
      (this.h16 = (t + 15) & -16),
      (this.offscreenRendering = (function (A, e, t, i) {
        const n = A.createFramebuffer();
        A.bindFramebuffer(A.FRAMEBUFFER, n);
        const o = A.createTexture();
        return (
          A.bindTexture(A.TEXTURE_2D, o),
          A.texParameteri(A.TEXTURE_2D, A.TEXTURE_MAG_FILTER, A.NEAREST),
          A.texParameteri(A.TEXTURE_2D, A.TEXTURE_MIN_FILTER, A.NEAREST),
          A.texParameteri(A.TEXTURE_2D, A.TEXTURE_WRAP_S, A.CLAMP_TO_EDGE),
          A.texParameteri(A.TEXTURE_2D, A.TEXTURE_WRAP_T, A.CLAMP_TO_EDGE),
          A.texStorage2D(A.TEXTURE_2D, 1, A.RGBA8, e, t),
          A.framebufferTexture2D(A.FRAMEBUFFER, A.COLOR_ATTACHMENT0, A.TEXTURE_2D, o, 0),
          A.checkFramebufferStatus(A.FRAMEBUFFER) || i.error("Framebuffer is not complete"),
          A.clear(A.COLOR_BUFFER_BIT),
          A.bindTexture(A.TEXTURE_2D, null),
          A.bindFramebuffer(A.FRAMEBUFFER, null),
          { fbo: n, rbo: o }
        );
      })(A, e, t, this.log)),
      (this.viewData[0] = 2 / e),
      (this.viewData[1] = -2 / t),
      A.bindBuffer(A.UNIFORM_BUFFER, this.viewConstants),
      A.bufferSubData(A.UNIFORM_BUFFER, 0, this.viewData),
      A.bindBuffer(A.UNIFORM_BUFFER, null);
  }),
  (gs.prototype.draw = function (A) {
    this.timer && this.timer.start(this.drawIndex++), null === A && this.submitLayout();
    const e = this.offscreenRendering,
      t = this.gl;
    if (null !== A) {
      let i = this.createCommand(A);
      t.bindFramebuffer(t.FRAMEBUFFER, e.fbo),
        this.setViewport(this.width, this.height),
        i.numVertices > this.maxNumVertices &&
          (this.destroyVertexData(), this.createVertexData(i.numVertices)),
        this.fillGeometry(i, this.vertices) ||
          (this.log.warn("Reconfiguring pipeline"),
          this.destroyVertexData(),
          this.destroyRenderPipeline(),
          this.createRenderPipeline(!0),
          this.createVertexData(this.maxNumVertices),
          this.fillGeometry(i, this.vertices)),
        t.bindBuffer(t.ARRAY_BUFFER, this.vbo_name),
        t.bufferSubData(t.ARRAY_BUFFER, 0, this.vertices, 0, 4 * i.numVertices),
        t.bindBuffer(t.ARRAY_BUFFER, null),
        t.bindVertexArray(this.vao_name),
        this.renderCommand(i),
        t.bindVertexArray(null),
        A.buffer && (A.buffer.release(), (A.buffer = null));
    }
    t.bindFramebuffer(t.FRAMEBUFFER, null),
      this.setViewport(this.canvas.width, this.canvas.height),
      t.clear(t.COLOR_BUFFER_BIT),
      this.setProgram(this.blitProgram),
      t.bindTexture(t.TEXTURE_2D, e.rbo),
      t.bindVertexArray(this.blitVao),
      t.drawArrays(t.TRIANGLES, 0, 3),
      t.bindVertexArray(null),
      t.bindTexture(t.TEXTURE_2D, null),
      this.setProgram(null),
      this.timer && this.timer.stop();
  }),
  (gs.prototype.render = function (A) {
    this.draw(A);
  }),
  (gs.prototype.size = function (A, e) {
    (this.width === A && this.height === e) ||
      ((this.width = A), (this.height = e), this.draw(null));
  }),
  (gs.prototype.release = function () {
    const A = this.gl;
    A
      ? (os(A, this.offscreenRendering),
        (this.offscreenRendering = null),
        this.destroyVertexData(),
        this.destroyRenderPipeline(),
        A.deleteBuffer(this.frameConstants),
        A.deleteBuffer(this.viewConstants),
        (this.frameData = null),
        (this.viewData = null),
        Object.keys(this.textureCache).forEach((e) => A.deleteTexture(this.textureCache[e])),
        (this.textureCache = null),
        0 !== this.textureAtlas && (A.deleteTexture(this.textureAtlas), (this.textureAtlas = 0)),
        A.deleteProgram(this.blitProgram),
        (this.blitProgram = null),
        A.deleteVertexArray(this.blitVao),
        (this.blitVao = null),
        A.deleteBuffer(this.blitBuffer),
        (this.blitBuffer = null),
        this.timer && this.timer.dispose(),
        (this.canvas = null),
        (this.gl = null),
        this.log.info("Released renderer resources"))
      : this.log.warn("OpenGL context not defined, skip release");
  }),
  (cs.prototype = Object.create(xr.prototype)),
  (cs.prototype.constructor = cs),
  (cs.prototype.addRenderingLayer = function (A, e) {
    let t,
      i,
      n = {},
      o = e.decoder;
    if (((t = this.getLayerTypeIndex(A)), -1 !== t))
      if (((i = this.getRenderingTypeIndex(o)), -1 !== i)) {
        if (
          (this.layerObject[t] &&
            (this.log.warn(`Already initialized rendering layer for stream: ${A}`),
            this.removeRenderingLayer(A)),
          i === xr.LZ4)
        )
          (n.render = (A) => {
            const e = A.rect,
              t = this.ctx.createImageData(e.width, e.height);
            t.data.set(A.buffer.data), this.ctx.putImageData(t, e.x, e.y);
          }),
            this.log.info(`Initialized LZ4 rendering layer ${A}`);
        else {
          if (i !== xr.JPEG) return void this.log.warn(`Unknown ${o} rendering layer ${A}`);
          (n.render = (A) => {
            const e = A.rect;
            this.ctx.drawImage(A.buffer.data, e.x, e.y);
          }),
            this.log.info(`Initialized JPEG rendering layer ${A}`);
        }
        this.layerObject[t] = n;
      } else this.log.warn(`Unknown rendering type: ${o}`);
    else this.log.warn(`Unknown layer type: ${A}`);
  }),
  (cs.prototype.removeRenderingLayer = function (A) {
    let e;
    (e = this.getLayerTypeIndex(A)),
      -1 !== e
        ? this.layerObject[e]
          ? (delete this.layerObject[e].render,
            (this.layerObject[e] = null),
            this.log.info(`Removed rendering layer ${A}`))
          : this.log.warn(`Already removed rendering layer for stream: ${A}`)
        : this.log.warn(`Unknown layer type: ${A}`);
  }),
  (cs.prototype.render = function (A) {
    let e;
    (e = this.getLayerTypeIndex(A.layerType)),
      -1 === e
        ? this.log.warn(`Unknown layer type: ${A.layerType}`)
        : this.layerObject[e]
          ? this.layerObject[e].render(A)
          : this.log.warn(`Missing rendering layer for type: ${A.layerType}`),
      A.buffer && (A.buffer.release(), (A.buffer = null));
  }),
  (cs.prototype.updateCanvasSize = function (A, e) {
    let t = this.canvas,
      i = this.highPixelDensityEnabled ? so(t) : 1;
    (t.style.width = A / i + "px"), (t.style.height = e / i + "px"), (t.width = A), (t.height = e);
  }),
  (cs.prototype.enableHighPixelDensity = function (A) {
    (this.highPixelDensityEnabled = A), this.updateCanvasSize(this.width, this.height);
  }),
  (cs.prototype.size = function (A, e) {
    (this.canvas.width === A && this.canvas.height === e) ||
      (this.updateCanvasSize(A, e),
      (this.width = A),
      (this.height = e),
      this.ctx.clearRect(0, 0, this.width, this.height),
      this.log.info("Resized renderer"));
  }),
  (cs.prototype.release = function () {
    this.layerObject.forEach((A, e) => {
      A && delete A.render;
    }),
      (this.layerObject = null),
      (this.canvas = null),
      (this.ctx = null);
  });
const ds = [
    "click",
    "keydown",
    "keyup",
    "keypress",
    "mousedown",
    "mouseup",
    "touchstart",
    "touchend"
  ],
  us = "Wired headset";
let Cs,
  Bs = null,
  Qs = null,
  Es = !0,
  hs = !0,
  ps = !0,
  fs = !0,
  ms = !0,
  ys = !0,
  Ds = !0,
  ws = !0,
  Fs = null,
  bs = !0;
function Us() {
  Qs &&
    "suspended" === Qs.state &&
    Qs.resume()
      .then(() => {
        Bs.info("AudioContext has been resumed"), Ss();
      })
      .catch(() => {
        Bs.info("Audio could not be resumed from suspended state");
      }),
    Qs && "running" === Qs.state && Ss(),
    Bs.debug(`resumeAudioOutFromUserAction called, final result: ${Qs.state}`);
}
function Ss() {
  ds.forEach((A) => {
    document.removeEventListener(A, Us);
  });
}
function Rs(A, e) {
  let t, i, n, o;
  return (
    (t = window.document.createElement("canvas")),
    t
      ? ((i = t.getContext(A, e)),
        null === i
          ? null
          : ((n = dr() ? null : i.getExtension("WEBGL_debug_renderer_info")),
            (o =
              null !== n ? i.getParameter(n.UNMASKED_RENDERER_WEBGL) : i.getParameter(i.RENDERER)),
            Qr() && "webgl" !== A && !Ao(o) && o.toLowerCase().includes("swiftshader")
              ? (Bs.debug(`Unsupported WebGL device: '${A}', renderer: '${o}'`), null)
              : (Bs.info(`Found WebGL device: '${A}', renderer: '${o}'`),
                {
                  name: A,
                  tileGroupRenderingSupported: Is(A, i),
                  webImageRenderingSupported: ls(A)
                })))
      : null
  );
}
function vs() {
  return hs;
}
function xs() {
  return ps;
}
function Ms() {
  return fs;
}
function Os() {
  return ys;
}
function ks() {
  return Es;
}
function Ns() {
  return (
    void 0 === Cs &&
      (Cs = (function () {
        const A = ["webgl2", "webgl", "experimental-webgl", "moz-webgl", "webkit-3d"],
          e = { preserveDrawingBuffer: !1, antialias: !1, depth: !1, stencil: !1 };
        if (!Xn(window.WebGL2RenderingContext) && !Xn(window.WebGLRenderingContext)) return null;
        for (let t = 0; t < A.length; t++) {
          const i = Rs(A[t], e);
          if (null !== i) return i;
        }
        return null;
      })()),
    Cs
  );
}
function Ks() {
  return xs
    ? navigator.mediaDevices.enumerateDevices()
    : Promise.reject("Cannot enumerate connected devices");
}
function Ls(A) {
  return Ks().then((e) => {
    let t = null;
    return (
      (t = A
        ? e.filter((e) => "audioinput" === e.kind && e.deviceId === A)
        : e.filter((A) => "audioinput" === A.kind)),
      0 === t.length ? Promise.reject("No audio input devices found") : Promise.resolve(t[0])
    );
  });
}
function Ts() {
  return Qs;
}
function Ps() {
  Qs || ((Qs = new AudioContext()), Bs.info(`AudioContext created with state ${Qs.state}`)),
    ds.forEach((A) => {
      document.addEventListener(A, Us);
    });
}
void 0 === navigator.mediaDevices && (navigator.mediaDevices = {}),
  void 0 === navigator.mediaDevices.enumerateDevices && (ps = !1),
  void 0 === navigator.mediaDevices.ondevicechange && (fs = !1),
  void 0 === navigator.permissions && (ys = !1),
  void 0 === window.MediaRecorder && (ms = !1),
  (void 0 !== window.MediaStreamTrack && "getCapabilities" in window.MediaStreamTrack.prototype) ||
    (ws = !1),
  "ImageCapture" in window || (Ds = !1),
  void 0 === navigator.mediaDevices.getUserMedia &&
    (navigator.mediaDevices.getUserMedia = function (A) {
      const e = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      return e
        ? new Promise((t, i) => {
            e.call(navigator, A, t, i);
          })
        : ((hs = !1), Promise.reject(new Error("The webcam system is not supported.")));
    }),
  void 0 !== window.MediaStream &&
    (function () {
      "getVideoTracks" in window.MediaStream.prototype ||
        (window.MediaStream.prototype.getVideoTracks = function () {
          const A = [];
          return this.getTracks
            ? (this.getTracks.forEach((e) => {
                -1 !== e.kind.toString().indexOf("video") && A.push(e);
              }),
              A)
            : [];
        });
      "getAudioTracks" in window.MediaStream.prototype ||
        (window.MediaStream.prototype.getAudioTracks = function () {
          const A = [];
          return this.getTracks
            ? (this.getTracks.forEach((e) => {
                -1 !== e.kind.toString().indexOf("audio") && A.push(e);
              }),
              A)
            : [];
        });
    })(),
  void 0 === window.AudioContext && (Es = !1),
  void 0 === window.ImageDecoder && (bs = !1);
const Gs = {};
let Hs = 1;
const Ys = Q("connectionmanager");
function qs(A) {
  return Gs[A];
}
function Js(A) {
  A in Gs && (Ys.info(`Removed connection ${A} from connections`), delete Gs[A]),
    Object.keys(Gs).length ||
      (Qs &&
        (Qs.close()
          .then(() => {
            Bs.info("Closed audio context");
          })
          .catch(() => {
            Bs.info("Impossible to close audio context");
          }),
        (Qs = null)));
}
function js(A) {
  return Ao(Gs[A]) ? null : Gs[A].channelManager;
}
function Ws(A) {
  return Ao(Gs[A]) ? null : Gs[A].featureManager;
}
function Vs(A) {
  return Ao(Gs[A]) ? null : Gs[A].statsManager;
}
const _s = vo.setup,
  Xs = (A) => wo(_s.ServerMessage, A);
class zs {
  constructor(A, e, t, i, n, o) {
    (this.log = Q("channel")),
      (this.sessionId = e),
      (this.authToken = t),
      (this.maxClientProtocolVersion = n),
      (this.extensionData = i),
      (this.callbacks = o),
      (this.credentials = null),
      (this.closingState = !1),
      (this.transport = new Qo({
        uri: A,
        onOpen: Zs.bind(this),
        onClose: $s.bind(this),
        onError: Aa.bind(this),
        onMessageReceived: ta.bind(this),
        httpExtraSearchParams: o.httpExtraSearchParams,
        httpExtraHeaders: o.httpExtraHeaders
      }));
  }
  close(A) {
    const e = this.channelName ? this.channelName : "mainchannel";
    this.closingState
      ? this.log.warn(`Transport close already requested for channel ${e}`)
      : (this.log.info(`Requesting transport close for channel ${e}`),
        (this.closingState = !0),
        A
          ? this.notifyCloseEvent({
              code: Io.ClosingReason.TRANSPORT_ERROR,
              message: "Transport error."
            })
          : this.notifyCloseEvent({ code: Io.ClosingReason.NO_ERROR, message: "Normal closure." }),
        this.transport.close(A));
  }
  run(A, e) {}
  onOpen() {}
  onClose() {}
  onError() {}
  connect(A, e) {
    var t;
    (this.onSetupMessageReceived = (A, t) => {
      const i = e(Xs(A));
      i
        ? ((this.protocolVersion = i.protocolVersion),
          (this.serverInfo = i.serverInfo),
          (this.onSetupMessageReceived = null),
          (this.authToken = null),
          (this.closingState = !1),
          (this.setupCompleted = !0),
          Xn(this.callbacks.onSetupCompleted) && this.callbacks.onSetupCompleted(this),
          this.run(A, t))
        : this.close();
    }),
      this.transport.sendMessage(((t = A), Do(_s.ClientMessage, t)));
  }
  getBufferedAmount() {
    return this.transport.getBufferedAmount();
  }
  notifyCloseEvent(A) {
    const e = this.channelName ? this.channelName : "mainchannel";
    this.log.info(`Closing channel ${e} (${this.clientConnectionId}) (${A.message}) ...`),
      Xn(this.onClose) && this.onClose(A),
      !this.setupCompleted &&
        Xn(this.callbacks.onSetupFailed) &&
        this.callbacks.onSetupFailed(this.connectionError),
      Xn(this.callbacks.onClose) && this.callbacks.onClose(A);
  }
}
function Zs() {
  Xn(this.onOpen) && this.onOpen(), Xn(this.callbacks.onOpen) && this.callbacks.onOpen();
}
function $s(A) {
  const e = this.channelName ? this.channelName : "mainchannel";
  this.closingState
    ? this.log.info(`Transport close notification for closed channel ${e}`)
    : ((this.closingState = !0),
      this.log.info(`Transport close notification for channel ${e}`),
      this.notifyCloseEvent(A));
}
function Aa() {
  Xn(this.onError) && this.onError(),
    !this.setupCompleted &&
      Xn(this.callbacks.onSetupFailed) &&
      this.callbacks.onSetupFailed(this.connectionError),
    Xn(this.callbacks.onError) && this.callbacks.onError();
}
const ea = {
  [_s.ConnectionAbort.AbortingReason.GENERIC_ERROR]: {
    code: Io.Connection.GENERIC_ERROR,
    message: "Generic error"
  },
  [_s.ConnectionAbort.AbortingReason.INTERNAL_SERVER_ERROR]: {
    code: Io.Connection.INTERNAL_SERVER_ERROR,
    message: "Internal server error"
  },
  [_s.ConnectionAbort.AbortingReason.AUTHENTICATION_FAILED]: {
    code: Io.Connection.AUTHENTICATION_FAILED,
    message: "Authentication failed"
  },
  [_s.ConnectionAbort.AbortingReason.PROTOCOL_ERROR]: {
    code: Io.Connection.PROTOCOL_ERROR,
    message: "Protocol error"
  },
  [_s.ConnectionAbort.AbortingReason.INVALID_SESSION_ID]: {
    code: Io.Connection.INVALID_SESSION_ID,
    message: "Invalid session ID"
  },
  [_s.ConnectionAbort.AbortingReason.INVALID_CONNECTION_ID]: {
    code: Io.Connection.INVALID_CONNECTION_ID,
    message: "Invalid connection ID"
  },
  [_s.ConnectionAbort.AbortingReason.CONNECTION_LIMIT_REACHED]: {
    code: Io.Connection.CONNECTION_LIMIT_REACHED,
    message: "Connection limit reached"
  },
  [_s.ConnectionAbort.AbortingReason.GATEWAY_BUSY]: {
    code: Io.Connection.GATEWAY_BUSY,
    message: "The gateway is busy"
  },
  [_s.ConnectionAbort.AbortingReason.SERVER_UNREACHABLE]: {
    code: Io.Connection.SERVER_UNREACHABLE,
    message: "Server unreachable"
  },
  [_s.ConnectionAbort.AbortingReason.UNSUPPORTED_CREDENTIAL]: {
    code: Io.Connection.UNSUPPORTED_CREDENTIAL,
    message: "Unsupported credential"
  }
};
function ta(A, e, t) {
  if (Xn(this.onSetupMessageReceived)) {
    const t = Xs(A);
    if ((this.log.debug(`Received setup message ${t.msg}`), "connectionAbort" === t.msg))
      return (
        t.connectionAbort.reason in ea
          ? (this.connectionError = ea[t.connectionAbort.reason])
          : (this.connectionError = {
              code: Io.Connection.GENERIC_ERROR,
              message: `Connection aborted for unknown reason (${t.connectionAbort.reason})`
            }),
        void this.log.warn(
          `Connection of channel was aborted: ${this.connectionError.message} (${this.connectionError.code})`
        )
      );
    this.onSetupMessageReceived(A, e);
  } else
    Xn(this.onMessageReceived) &&
      (Vs(this.clientConnectionId).addBytesReceived(t), this.onMessageReceived(A, e));
}
const ia = Fo.exports.Reader,
  na = Fo.exports.Writer,
  oa = Fo.exports.util,
  ra = Fo.exports.roots["dcv.main"] || (Fo.exports.roots["dcv.main"] = {}),
  sa = (ra.dcv = (() => {
    const A = {};
    return (
      (A.main = (function () {
        const A = {};
        return (
          (A.FeatureSetting = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "ALWAYS_OFF")] = 0),
              (e[(A[1] = "ALWAYS_ON")] = 1),
              (e[(A[2] = "CLIENT_DECIDES")] = 2),
              e
            );
          })()),
          (A.ChannelNotification = (function () {
            function A(A) {
              if (((this.channels = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.channels = oa.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = na.create()), null != A.channels && A.channels.length))
                  for (let t = 0; t < A.channels.length; ++t)
                    ra.dcv.main.ChannelNotification.ChannelInfo.encode(
                      A.channels[t],
                      e.uint32(18).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ChannelNotification();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 2)
                    (i.channels && i.channels.length) || (i.channels = []),
                      i.channels.push(
                        ra.dcv.main.ChannelNotification.ChannelInfo.decode(A, A.uint32())
                      );
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.channels && A.hasOwnProperty("channels")) {
                  if (!Array.isArray(A.channels)) return "channels: array expected";
                  for (let e = 0; e < A.channels.length; ++e) {
                    let t = ra.dcv.main.ChannelNotification.ChannelInfo.verify(A.channels[e]);
                    if (t) return "channels." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ChannelNotification) return A;
                let e = new ra.dcv.main.ChannelNotification();
                if (A.channels) {
                  if (!Array.isArray(A.channels))
                    throw TypeError(".dcv.main.ChannelNotification.channels: array expected");
                  e.channels = [];
                  for (let t = 0; t < A.channels.length; ++t) {
                    if ("object" != typeof A.channels[t])
                      throw TypeError(".dcv.main.ChannelNotification.channels: object expected");
                    e.channels[t] = ra.dcv.main.ChannelNotification.ChannelInfo.fromObject(
                      A.channels[t]
                    );
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.channels = []), A.channels && A.channels.length)
                ) {
                  t.channels = [];
                  for (let i = 0; i < A.channels.length; ++i)
                    t.channels[i] = ra.dcv.main.ChannelNotification.ChannelInfo.toObject(
                      A.channels[i],
                      e
                    );
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ChannelNotification"
                );
              }),
              (A.ChannelInfo = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.authenticationToken = ""),
                  (A.prototype.namespace = ""),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = na.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.authenticationToken &&
                        Object.hasOwnProperty.call(A, "authenticationToken") &&
                        e.uint32(18).string(A.authenticationToken),
                      null != A.namespace &&
                        Object.hasOwnProperty.call(A, "namespace") &&
                        e.uint32(26).string(A.namespace),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof ia || (A = ia.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new ra.dcv.main.ChannelNotification.ChannelInfo();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 2:
                          i.authenticationToken = A.string();
                          break;
                        case 3:
                          i.namespace = A.string();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.name && A.hasOwnProperty("name") && !oa.isString(A.name)
                        ? "name: string expected"
                        : null != A.authenticationToken &&
                            A.hasOwnProperty("authenticationToken") &&
                            !oa.isString(A.authenticationToken)
                          ? "authenticationToken: string expected"
                          : null != A.namespace &&
                              A.hasOwnProperty("namespace") &&
                              !oa.isString(A.namespace)
                            ? "namespace: string expected"
                            : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof ra.dcv.main.ChannelNotification.ChannelInfo) return A;
                    let e = new ra.dcv.main.ChannelNotification.ChannelInfo();
                    return (
                      null != A.name && (e.name = String(A.name)),
                      null != A.authenticationToken &&
                        (e.authenticationToken = String(A.authenticationToken)),
                      null != A.namespace && (e.namespace = String(A.namespace)),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults &&
                        ((t.name = ""), (t.authenticationToken = ""), (t.namespace = "")),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      null != A.authenticationToken &&
                        A.hasOwnProperty("authenticationToken") &&
                        (t.authenticationToken = A.authenticationToken),
                      null != A.namespace &&
                        A.hasOwnProperty("namespace") &&
                        (t.namespace = A.namespace),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.main.ChannelNotification.ChannelInfo"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.ConnectionClose = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.reason = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.reason &&
                    Object.hasOwnProperty.call(A, "reason") &&
                    e.uint32(8).int32(A.reason),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ConnectionClose();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.reason = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.reason && A.hasOwnProperty("reason"))
                  switch (A.reason) {
                    default:
                      return "reason: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 20:
                    case 21:
                    case 30:
                    case 40:
                    case 41:
                    case 42:
                    case 50:
                    case 51:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ConnectionClose) return A;
                let e = new ra.dcv.main.ConnectionClose();
                switch (A.reason) {
                  default:
                    if ("number" == typeof A.reason) {
                      e.reason = A.reason;
                      break;
                    }
                    break;
                  case "NO_ERROR":
                  case 0:
                    e.reason = 0;
                    break;
                  case "GENERIC_ERROR":
                  case 1:
                    e.reason = 1;
                    break;
                  case "INTERNAL_SERVER_ERROR":
                  case 2:
                    e.reason = 2;
                    break;
                  case "PROTOCOL_ERROR":
                  case 3:
                    e.reason = 3;
                    break;
                  case "AUTHORIZATION_DENIED":
                  case 20:
                    e.reason = 20;
                    break;
                  case "AUTHORIZATION_REVOKED":
                  case 21:
                    e.reason = 21;
                    break;
                  case "ACCESS_REJECTED":
                  case 30:
                    e.reason = 30;
                    break;
                  case "IDLE_TIMEOUT_EXPIRED":
                  case 40:
                    e.reason = 40;
                    break;
                  case "EVICTED":
                  case 41:
                    e.reason = 41;
                    break;
                  case "EXTERNAL_PROTOCOL_CONNECTION_EVICTED":
                  case 42:
                    e.reason = 42;
                    break;
                  case "DISCONNECT_BY_OWNER":
                  case 50:
                    e.reason = 50;
                    break;
                  case "DISCONNECT_BY_USER":
                  case 51:
                    e.reason = 51;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.reason = e.enums === String ? "NO_ERROR" : 0),
                  null != A.reason &&
                    A.hasOwnProperty("reason") &&
                    (t.reason =
                      e.enums === String
                        ? void 0 === ra.dcv.main.ConnectionClose.ClosingReason[A.reason]
                          ? A.reason
                          : ra.dcv.main.ConnectionClose.ClosingReason[A.reason]
                        : A.reason),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ConnectionClose";
              }),
              (A.ClosingReason = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "NO_ERROR")] = 0),
                  (e[(A[1] = "GENERIC_ERROR")] = 1),
                  (e[(A[2] = "INTERNAL_SERVER_ERROR")] = 2),
                  (e[(A[3] = "PROTOCOL_ERROR")] = 3),
                  (e[(A[20] = "AUTHORIZATION_DENIED")] = 20),
                  (e[(A[21] = "AUTHORIZATION_REVOKED")] = 21),
                  (e[(A[30] = "ACCESS_REJECTED")] = 30),
                  (e[(A[40] = "IDLE_TIMEOUT_EXPIRED")] = 40),
                  (e[(A[41] = "EVICTED")] = 41),
                  (e[(A[42] = "EXTERNAL_PROTOCOL_CONNECTION_EVICTED")] = 42),
                  (e[(A[50] = "DISCONNECT_BY_OWNER")] = 50),
                  (e[(A[51] = "DISCONNECT_BY_USER")] = 51),
                  e
                );
              })()),
              A
            );
          })()),
          (A.ResourceNotification = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.domain = ""),
              (A.prototype.resourceId = ""),
              (A.prototype.authenticationToken = ""),
              (A.prototype.port = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.domain &&
                    Object.hasOwnProperty.call(A, "domain") &&
                    e.uint32(10).string(A.domain),
                  null != A.resourceId &&
                    Object.hasOwnProperty.call(A, "resourceId") &&
                    e.uint32(18).string(A.resourceId),
                  null != A.authenticationToken &&
                    Object.hasOwnProperty.call(A, "authenticationToken") &&
                    e.uint32(26).string(A.authenticationToken),
                  null != A.port &&
                    Object.hasOwnProperty.call(A, "port") &&
                    e.uint32(32).uint32(A.port),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ResourceNotification();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.domain = A.string();
                      break;
                    case 2:
                      i.resourceId = A.string();
                      break;
                    case 3:
                      i.authenticationToken = A.string();
                      break;
                    case 4:
                      i.port = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.domain && A.hasOwnProperty("domain") && !oa.isString(A.domain)
                    ? "domain: string expected"
                    : null != A.resourceId &&
                        A.hasOwnProperty("resourceId") &&
                        !oa.isString(A.resourceId)
                      ? "resourceId: string expected"
                      : null != A.authenticationToken &&
                          A.hasOwnProperty("authenticationToken") &&
                          !oa.isString(A.authenticationToken)
                        ? "authenticationToken: string expected"
                        : null != A.port && A.hasOwnProperty("port") && !oa.isInteger(A.port)
                          ? "port: integer expected"
                          : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ResourceNotification) return A;
                let e = new ra.dcv.main.ResourceNotification();
                return (
                  null != A.domain && (e.domain = String(A.domain)),
                  null != A.resourceId && (e.resourceId = String(A.resourceId)),
                  null != A.authenticationToken &&
                    (e.authenticationToken = String(A.authenticationToken)),
                  null != A.port && (e.port = A.port >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.domain = ""),
                    (t.resourceId = ""),
                    (t.authenticationToken = ""),
                    (t.port = 0)),
                  null != A.domain && A.hasOwnProperty("domain") && (t.domain = A.domain),
                  null != A.resourceId &&
                    A.hasOwnProperty("resourceId") &&
                    (t.resourceId = A.resourceId),
                  null != A.authenticationToken &&
                    A.hasOwnProperty("authenticationToken") &&
                    (t.authenticationToken = A.authenticationToken),
                  null != A.port && A.hasOwnProperty("port") && (t.port = A.port),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ResourceNotification"
                );
              }),
              A
            );
          })()),
          (A.Ping = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pingTimestamp = oa.Long ? oa.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.pingTimestamp &&
                    Object.hasOwnProperty.call(A, "pingTimestamp") &&
                    e.uint32(8).int64(A.pingTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.Ping();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.pingTimestamp = A.int64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pingTimestamp &&
                      A.hasOwnProperty("pingTimestamp") &&
                      !(
                        oa.isInteger(A.pingTimestamp) ||
                        (A.pingTimestamp &&
                          oa.isInteger(A.pingTimestamp.low) &&
                          oa.isInteger(A.pingTimestamp.high))
                      )
                    ? "pingTimestamp: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.Ping) return A;
                let e = new ra.dcv.main.Ping();
                return (
                  null != A.pingTimestamp &&
                    (oa.Long
                      ? ((e.pingTimestamp = oa.Long.fromValue(A.pingTimestamp)).unsigned = !1)
                      : "string" == typeof A.pingTimestamp
                        ? (e.pingTimestamp = parseInt(A.pingTimestamp, 10))
                        : "number" == typeof A.pingTimestamp
                          ? (e.pingTimestamp = A.pingTimestamp)
                          : "object" == typeof A.pingTimestamp &&
                            (e.pingTimestamp = new oa.LongBits(
                              A.pingTimestamp.low >>> 0,
                              A.pingTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (oa.Long) {
                    let A = new oa.Long(0, 0, !1);
                    t.pingTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pingTimestamp = e.longs === String ? "0" : 0;
                return (
                  null != A.pingTimestamp &&
                    A.hasOwnProperty("pingTimestamp") &&
                    ("number" == typeof A.pingTimestamp
                      ? (t.pingTimestamp =
                          e.longs === String ? String(A.pingTimestamp) : A.pingTimestamp)
                      : (t.pingTimestamp =
                          e.longs === String
                            ? oa.Long.prototype.toString.call(A.pingTimestamp)
                            : e.longs === Number
                              ? new oa.LongBits(
                                  A.pingTimestamp.low >>> 0,
                                  A.pingTimestamp.high >>> 0
                                ).toNumber()
                              : A.pingTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.Ping";
              }),
              A
            );
          })()),
          (A.Pong = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pingTimestamp = oa.Long ? oa.Long.fromBits(0, 0, !1) : 0),
              (A.prototype.pongTimestamp = oa.Long ? oa.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.pingTimestamp &&
                    Object.hasOwnProperty.call(A, "pingTimestamp") &&
                    e.uint32(8).int64(A.pingTimestamp),
                  null != A.pongTimestamp &&
                    Object.hasOwnProperty.call(A, "pongTimestamp") &&
                    e.uint32(16).int64(A.pongTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.Pong();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.pingTimestamp = A.int64();
                      break;
                    case 2:
                      i.pongTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pingTimestamp &&
                      A.hasOwnProperty("pingTimestamp") &&
                      !(
                        oa.isInteger(A.pingTimestamp) ||
                        (A.pingTimestamp &&
                          oa.isInteger(A.pingTimestamp.low) &&
                          oa.isInteger(A.pingTimestamp.high))
                      )
                    ? "pingTimestamp: integer|Long expected"
                    : null != A.pongTimestamp &&
                        A.hasOwnProperty("pongTimestamp") &&
                        !(
                          oa.isInteger(A.pongTimestamp) ||
                          (A.pongTimestamp &&
                            oa.isInteger(A.pongTimestamp.low) &&
                            oa.isInteger(A.pongTimestamp.high))
                        )
                      ? "pongTimestamp: integer|Long expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.Pong) return A;
                let e = new ra.dcv.main.Pong();
                return (
                  null != A.pingTimestamp &&
                    (oa.Long
                      ? ((e.pingTimestamp = oa.Long.fromValue(A.pingTimestamp)).unsigned = !1)
                      : "string" == typeof A.pingTimestamp
                        ? (e.pingTimestamp = parseInt(A.pingTimestamp, 10))
                        : "number" == typeof A.pingTimestamp
                          ? (e.pingTimestamp = A.pingTimestamp)
                          : "object" == typeof A.pingTimestamp &&
                            (e.pingTimestamp = new oa.LongBits(
                              A.pingTimestamp.low >>> 0,
                              A.pingTimestamp.high >>> 0
                            ).toNumber())),
                  null != A.pongTimestamp &&
                    (oa.Long
                      ? ((e.pongTimestamp = oa.Long.fromValue(A.pongTimestamp)).unsigned = !1)
                      : "string" == typeof A.pongTimestamp
                        ? (e.pongTimestamp = parseInt(A.pongTimestamp, 10))
                        : "number" == typeof A.pongTimestamp
                          ? (e.pongTimestamp = A.pongTimestamp)
                          : "object" == typeof A.pongTimestamp &&
                            (e.pongTimestamp = new oa.LongBits(
                              A.pongTimestamp.low >>> 0,
                              A.pongTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (oa.Long) {
                    let A = new oa.Long(0, 0, !1);
                    t.pingTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pingTimestamp = e.longs === String ? "0" : 0;
                  if (oa.Long) {
                    let A = new oa.Long(0, 0, !1);
                    t.pongTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pongTimestamp = e.longs === String ? "0" : 0;
                }
                return (
                  null != A.pingTimestamp &&
                    A.hasOwnProperty("pingTimestamp") &&
                    ("number" == typeof A.pingTimestamp
                      ? (t.pingTimestamp =
                          e.longs === String ? String(A.pingTimestamp) : A.pingTimestamp)
                      : (t.pingTimestamp =
                          e.longs === String
                            ? oa.Long.prototype.toString.call(A.pingTimestamp)
                            : e.longs === Number
                              ? new oa.LongBits(
                                  A.pingTimestamp.low >>> 0,
                                  A.pingTimestamp.high >>> 0
                                ).toNumber()
                              : A.pingTimestamp)),
                  null != A.pongTimestamp &&
                    A.hasOwnProperty("pongTimestamp") &&
                    ("number" == typeof A.pongTimestamp
                      ? (t.pongTimestamp =
                          e.longs === String ? String(A.pongTimestamp) : A.pongTimestamp)
                      : (t.pongTimestamp =
                          e.longs === String
                            ? oa.Long.prototype.toString.call(A.pongTimestamp)
                            : e.longs === Number
                              ? new oa.LongBits(
                                  A.pongTimestamp.low >>> 0,
                                  A.pongTimestamp.high >>> 0
                                ).toNumber()
                              : A.pongTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.Pong";
              }),
              A
            );
          })()),
          (A.Pang = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pongTimestamp = oa.Long ? oa.Long.fromBits(0, 0, !1) : 0),
              (A.prototype.pangTimestamp = oa.Long ? oa.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.pongTimestamp &&
                    Object.hasOwnProperty.call(A, "pongTimestamp") &&
                    e.uint32(8).int64(A.pongTimestamp),
                  null != A.pangTimestamp &&
                    Object.hasOwnProperty.call(A, "pangTimestamp") &&
                    e.uint32(16).int64(A.pangTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.Pang();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.pongTimestamp = A.int64();
                      break;
                    case 2:
                      i.pangTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pongTimestamp &&
                      A.hasOwnProperty("pongTimestamp") &&
                      !(
                        oa.isInteger(A.pongTimestamp) ||
                        (A.pongTimestamp &&
                          oa.isInteger(A.pongTimestamp.low) &&
                          oa.isInteger(A.pongTimestamp.high))
                      )
                    ? "pongTimestamp: integer|Long expected"
                    : null != A.pangTimestamp &&
                        A.hasOwnProperty("pangTimestamp") &&
                        !(
                          oa.isInteger(A.pangTimestamp) ||
                          (A.pangTimestamp &&
                            oa.isInteger(A.pangTimestamp.low) &&
                            oa.isInteger(A.pangTimestamp.high))
                        )
                      ? "pangTimestamp: integer|Long expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.Pang) return A;
                let e = new ra.dcv.main.Pang();
                return (
                  null != A.pongTimestamp &&
                    (oa.Long
                      ? ((e.pongTimestamp = oa.Long.fromValue(A.pongTimestamp)).unsigned = !1)
                      : "string" == typeof A.pongTimestamp
                        ? (e.pongTimestamp = parseInt(A.pongTimestamp, 10))
                        : "number" == typeof A.pongTimestamp
                          ? (e.pongTimestamp = A.pongTimestamp)
                          : "object" == typeof A.pongTimestamp &&
                            (e.pongTimestamp = new oa.LongBits(
                              A.pongTimestamp.low >>> 0,
                              A.pongTimestamp.high >>> 0
                            ).toNumber())),
                  null != A.pangTimestamp &&
                    (oa.Long
                      ? ((e.pangTimestamp = oa.Long.fromValue(A.pangTimestamp)).unsigned = !1)
                      : "string" == typeof A.pangTimestamp
                        ? (e.pangTimestamp = parseInt(A.pangTimestamp, 10))
                        : "number" == typeof A.pangTimestamp
                          ? (e.pangTimestamp = A.pangTimestamp)
                          : "object" == typeof A.pangTimestamp &&
                            (e.pangTimestamp = new oa.LongBits(
                              A.pangTimestamp.low >>> 0,
                              A.pangTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (oa.Long) {
                    let A = new oa.Long(0, 0, !1);
                    t.pongTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pongTimestamp = e.longs === String ? "0" : 0;
                  if (oa.Long) {
                    let A = new oa.Long(0, 0, !1);
                    t.pangTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.pangTimestamp = e.longs === String ? "0" : 0;
                }
                return (
                  null != A.pongTimestamp &&
                    A.hasOwnProperty("pongTimestamp") &&
                    ("number" == typeof A.pongTimestamp
                      ? (t.pongTimestamp =
                          e.longs === String ? String(A.pongTimestamp) : A.pongTimestamp)
                      : (t.pongTimestamp =
                          e.longs === String
                            ? oa.Long.prototype.toString.call(A.pongTimestamp)
                            : e.longs === Number
                              ? new oa.LongBits(
                                  A.pongTimestamp.low >>> 0,
                                  A.pongTimestamp.high >>> 0
                                ).toNumber()
                              : A.pongTimestamp)),
                  null != A.pangTimestamp &&
                    A.hasOwnProperty("pangTimestamp") &&
                    ("number" == typeof A.pangTimestamp
                      ? (t.pangTimestamp =
                          e.longs === String ? String(A.pangTimestamp) : A.pangTimestamp)
                      : (t.pangTimestamp =
                          e.longs === String
                            ? oa.Long.prototype.toString.call(A.pangTimestamp)
                            : e.longs === Number
                              ? new oa.LongBits(
                                  A.pangTimestamp.low >>> 0,
                                  A.pangTimestamp.high >>> 0
                                ).toNumber()
                              : A.pangTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.Pang";
              }),
              A
            );
          })()),
          (A.QualityIndicatorNotification = (function () {
            function A(A) {
              if (((this.indicators = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.indicators = oa.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = na.create()), null != A.indicators && A.indicators.length))
                  for (let t = 0; t < A.indicators.length; ++t)
                    ra.dcv.main.QualityIndicatorNotification.Indicator.encode(
                      A.indicators[t],
                      e.uint32(10).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.QualityIndicatorNotification();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    (i.indicators && i.indicators.length) || (i.indicators = []),
                      i.indicators.push(
                        ra.dcv.main.QualityIndicatorNotification.Indicator.decode(A, A.uint32())
                      );
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.indicators && A.hasOwnProperty("indicators")) {
                  if (!Array.isArray(A.indicators)) return "indicators: array expected";
                  for (let e = 0; e < A.indicators.length; ++e) {
                    let t = ra.dcv.main.QualityIndicatorNotification.Indicator.verify(
                      A.indicators[e]
                    );
                    if (t) return "indicators." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.QualityIndicatorNotification) return A;
                let e = new ra.dcv.main.QualityIndicatorNotification();
                if (A.indicators) {
                  if (!Array.isArray(A.indicators))
                    throw TypeError(
                      ".dcv.main.QualityIndicatorNotification.indicators: array expected"
                    );
                  e.indicators = [];
                  for (let t = 0; t < A.indicators.length; ++t) {
                    if ("object" != typeof A.indicators[t])
                      throw TypeError(
                        ".dcv.main.QualityIndicatorNotification.indicators: object expected"
                      );
                    e.indicators[t] = ra.dcv.main.QualityIndicatorNotification.Indicator.fromObject(
                      A.indicators[t]
                    );
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.indicators = []),
                  A.indicators && A.indicators.length)
                ) {
                  t.indicators = [];
                  for (let i = 0; i < A.indicators.length; ++i)
                    t.indicators[i] = ra.dcv.main.QualityIndicatorNotification.Indicator.toObject(
                      A.indicators[i],
                      e
                    );
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.QualityIndicatorNotification"
                );
              }),
              (A.Status = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "NORMAL")] = 0),
                  (e[(A[1] = "WARNING")] = 1),
                  (e[(A[2] = "CRITICAL")] = 2),
                  e
                );
              })()),
              (A.Indicator = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.status = 0),
                  (A.prototype.changed = !1),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = na.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.status &&
                        Object.hasOwnProperty.call(A, "status") &&
                        e.uint32(16).int32(A.status),
                      null != A.changed &&
                        Object.hasOwnProperty.call(A, "changed") &&
                        e.uint32(24).bool(A.changed),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof ia || (A = ia.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new ra.dcv.main.QualityIndicatorNotification.Indicator();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 2:
                          i.status = A.int32();
                          break;
                        case 3:
                          i.changed = A.bool();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !oa.isString(A.name))
                      return "name: string expected";
                    if (null != A.status && A.hasOwnProperty("status"))
                      switch (A.status) {
                        default:
                          return "status: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                      }
                    return null != A.changed &&
                      A.hasOwnProperty("changed") &&
                      "boolean" != typeof A.changed
                      ? "changed: boolean expected"
                      : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof ra.dcv.main.QualityIndicatorNotification.Indicator) return A;
                    let e = new ra.dcv.main.QualityIndicatorNotification.Indicator();
                    switch ((null != A.name && (e.name = String(A.name)), A.status)) {
                      default:
                        if ("number" == typeof A.status) {
                          e.status = A.status;
                          break;
                        }
                        break;
                      case "NORMAL":
                      case 0:
                        e.status = 0;
                        break;
                      case "WARNING":
                      case 1:
                        e.status = 1;
                        break;
                      case "CRITICAL":
                      case 2:
                        e.status = 2;
                    }
                    return null != A.changed && (e.changed = Boolean(A.changed)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults &&
                        ((t.name = ""),
                        (t.status = e.enums === String ? "NORMAL" : 0),
                        (t.changed = !1)),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      null != A.status &&
                        A.hasOwnProperty("status") &&
                        (t.status =
                          e.enums === String
                            ? void 0 === ra.dcv.main.QualityIndicatorNotification.Status[A.status]
                              ? A.status
                              : ra.dcv.main.QualityIndicatorNotification.Status[A.status]
                            : A.status),
                      null != A.changed && A.hasOwnProperty("changed") && (t.changed = A.changed),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.main.QualityIndicatorNotification.Indicator"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.LicenseUpdatesNotification = (function () {
            function A(A) {
              if (((this.updates = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.updates = oa.emptyArray),
              (A.prototype.licensingMode = 0),
              (A.prototype.documentationUrl = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = na.create()), null != A.updates && A.updates.length))
                  for (let t = 0; t < A.updates.length; ++t)
                    ra.dcv.main.LicenseUpdatesNotification.Update.encode(
                      A.updates[t],
                      e.uint32(10).fork()
                    ).ldelim();
                return (
                  null != A.licensingMode &&
                    Object.hasOwnProperty.call(A, "licensingMode") &&
                    e.uint32(16).int32(A.licensingMode),
                  null != A.documentationUrl &&
                    Object.hasOwnProperty.call(A, "documentationUrl") &&
                    e.uint32(82).string(A.documentationUrl),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.LicenseUpdatesNotification();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      (i.updates && i.updates.length) || (i.updates = []),
                        i.updates.push(
                          ra.dcv.main.LicenseUpdatesNotification.Update.decode(A, A.uint32())
                        );
                      break;
                    case 2:
                      i.licensingMode = A.int32();
                      break;
                    case 10:
                      i.documentationUrl = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.updates && A.hasOwnProperty("updates")) {
                  if (!Array.isArray(A.updates)) return "updates: array expected";
                  for (let e = 0; e < A.updates.length; ++e) {
                    let t = ra.dcv.main.LicenseUpdatesNotification.Update.verify(A.updates[e]);
                    if (t) return "updates." + t;
                  }
                }
                if (null != A.licensingMode && A.hasOwnProperty("licensingMode"))
                  switch (A.licensingMode) {
                    default:
                      return "licensingMode: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                return null != A.documentationUrl &&
                  A.hasOwnProperty("documentationUrl") &&
                  !oa.isString(A.documentationUrl)
                  ? "documentationUrl: string expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.LicenseUpdatesNotification) return A;
                let e = new ra.dcv.main.LicenseUpdatesNotification();
                if (A.updates) {
                  if (!Array.isArray(A.updates))
                    throw TypeError(".dcv.main.LicenseUpdatesNotification.updates: array expected");
                  e.updates = [];
                  for (let t = 0; t < A.updates.length; ++t) {
                    if ("object" != typeof A.updates[t])
                      throw TypeError(
                        ".dcv.main.LicenseUpdatesNotification.updates: object expected"
                      );
                    e.updates[t] = ra.dcv.main.LicenseUpdatesNotification.Update.fromObject(
                      A.updates[t]
                    );
                  }
                }
                switch (A.licensingMode) {
                  default:
                    if ("number" == typeof A.licensingMode) {
                      e.licensingMode = A.licensingMode;
                      break;
                    }
                    break;
                  case "NONE_MODE":
                  case 0:
                    e.licensingMode = 0;
                    break;
                  case "RLM_MODE":
                  case 1:
                    e.licensingMode = 1;
                    break;
                  case "DEMO_MODE":
                  case 2:
                    e.licensingMode = 2;
                    break;
                  case "EC2_MODE":
                  case 3:
                    e.licensingMode = 3;
                }
                return (
                  null != A.documentationUrl && (e.documentationUrl = String(A.documentationUrl)), e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.updates = []),
                  e.defaults &&
                    ((t.licensingMode = e.enums === String ? "NONE_MODE" : 0),
                    (t.documentationUrl = "")),
                  A.updates && A.updates.length)
                ) {
                  t.updates = [];
                  for (let i = 0; i < A.updates.length; ++i)
                    t.updates[i] = ra.dcv.main.LicenseUpdatesNotification.Update.toObject(
                      A.updates[i],
                      e
                    );
                }
                return (
                  null != A.licensingMode &&
                    A.hasOwnProperty("licensingMode") &&
                    (t.licensingMode =
                      e.enums === String
                        ? void 0 ===
                          ra.dcv.main.LicenseUpdatesNotification.LicensingMode[A.licensingMode]
                          ? A.licensingMode
                          : ra.dcv.main.LicenseUpdatesNotification.LicensingMode[A.licensingMode]
                        : A.licensingMode),
                  null != A.documentationUrl &&
                    A.hasOwnProperty("documentationUrl") &&
                    (t.documentationUrl = A.documentationUrl),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.LicenseUpdatesNotification"
                );
              }),
              (A.LicensingMode = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "NONE_MODE")] = 0),
                  (e[(A[1] = "RLM_MODE")] = 1),
                  (e[(A[2] = "DEMO_MODE")] = 2),
                  (e[(A[3] = "EC2_MODE")] = 3),
                  e
                );
              })()),
              (A.Status = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "LICENSED")] = 0),
                  (e[(A[1] = "UNLICENSED")] = 1),
                  (e[(A[2] = "INVALID")] = 2),
                  e
                );
              })()),
              (A.Type = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "NONE")] = 0),
                  (e[(A[1] = "BETA")] = 1),
                  (e[(A[2] = "EVAL")] = 2),
                  (e[(A[4] = "DEMO")] = 4),
                  e
                );
              })()),
              (A.Update = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.status = 0),
                  (A.prototype.product = ""),
                  (A.prototype.message = ""),
                  (A.prototype.type = 0),
                  (A.prototype.leftDays = oa.Long ? oa.Long.fromBits(0, 0, !1) : 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = na.create()),
                      null != A.status &&
                        Object.hasOwnProperty.call(A, "status") &&
                        e.uint32(80).int32(A.status),
                      null != A.product &&
                        Object.hasOwnProperty.call(A, "product") &&
                        e.uint32(162).string(A.product),
                      null != A.message &&
                        Object.hasOwnProperty.call(A, "message") &&
                        e.uint32(242).string(A.message),
                      null != A.type &&
                        Object.hasOwnProperty.call(A, "type") &&
                        e.uint32(320).int32(A.type),
                      null != A.leftDays &&
                        Object.hasOwnProperty.call(A, "leftDays") &&
                        e.uint32(400).int64(A.leftDays),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof ia || (A = ia.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new ra.dcv.main.LicenseUpdatesNotification.Update();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 10:
                          i.status = A.int32();
                          break;
                        case 20:
                          i.product = A.string();
                          break;
                        case 30:
                          i.message = A.string();
                          break;
                        case 40:
                          i.type = A.int32();
                          break;
                        case 50:
                          i.leftDays = A.int64();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.status && A.hasOwnProperty("status"))
                      switch (A.status) {
                        default:
                          return "status: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                      }
                    if (null != A.product && A.hasOwnProperty("product") && !oa.isString(A.product))
                      return "product: string expected";
                    if (null != A.message && A.hasOwnProperty("message") && !oa.isString(A.message))
                      return "message: string expected";
                    if (null != A.type && A.hasOwnProperty("type"))
                      switch (A.type) {
                        default:
                          return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 4:
                      }
                    return null != A.leftDays &&
                      A.hasOwnProperty("leftDays") &&
                      !(
                        oa.isInteger(A.leftDays) ||
                        (A.leftDays &&
                          oa.isInteger(A.leftDays.low) &&
                          oa.isInteger(A.leftDays.high))
                      )
                      ? "leftDays: integer|Long expected"
                      : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof ra.dcv.main.LicenseUpdatesNotification.Update) return A;
                    let e = new ra.dcv.main.LicenseUpdatesNotification.Update();
                    switch (A.status) {
                      default:
                        if ("number" == typeof A.status) {
                          e.status = A.status;
                          break;
                        }
                        break;
                      case "LICENSED":
                      case 0:
                        e.status = 0;
                        break;
                      case "UNLICENSED":
                      case 1:
                        e.status = 1;
                        break;
                      case "INVALID":
                      case 2:
                        e.status = 2;
                    }
                    switch (
                      (null != A.product && (e.product = String(A.product)),
                      null != A.message && (e.message = String(A.message)),
                      A.type)
                    ) {
                      default:
                        if ("number" == typeof A.type) {
                          e.type = A.type;
                          break;
                        }
                        break;
                      case "NONE":
                      case 0:
                        e.type = 0;
                        break;
                      case "BETA":
                      case 1:
                        e.type = 1;
                        break;
                      case "EVAL":
                      case 2:
                        e.type = 2;
                        break;
                      case "DEMO":
                      case 4:
                        e.type = 4;
                    }
                    return (
                      null != A.leftDays &&
                        (oa.Long
                          ? ((e.leftDays = oa.Long.fromValue(A.leftDays)).unsigned = !1)
                          : "string" == typeof A.leftDays
                            ? (e.leftDays = parseInt(A.leftDays, 10))
                            : "number" == typeof A.leftDays
                              ? (e.leftDays = A.leftDays)
                              : "object" == typeof A.leftDays &&
                                (e.leftDays = new oa.LongBits(
                                  A.leftDays.low >>> 0,
                                  A.leftDays.high >>> 0
                                ).toNumber())),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults)
                      if (
                        ((t.status = e.enums === String ? "LICENSED" : 0),
                        (t.product = ""),
                        (t.message = ""),
                        (t.type = e.enums === String ? "NONE" : 0),
                        oa.Long)
                      ) {
                        let A = new oa.Long(0, 0, !1);
                        t.leftDays =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.leftDays = e.longs === String ? "0" : 0;
                    return (
                      null != A.status &&
                        A.hasOwnProperty("status") &&
                        (t.status =
                          e.enums === String
                            ? void 0 === ra.dcv.main.LicenseUpdatesNotification.Status[A.status]
                              ? A.status
                              : ra.dcv.main.LicenseUpdatesNotification.Status[A.status]
                            : A.status),
                      null != A.product && A.hasOwnProperty("product") && (t.product = A.product),
                      null != A.message && A.hasOwnProperty("message") && (t.message = A.message),
                      null != A.type &&
                        A.hasOwnProperty("type") &&
                        (t.type =
                          e.enums === String
                            ? void 0 === ra.dcv.main.LicenseUpdatesNotification.Type[A.type]
                              ? A.type
                              : ra.dcv.main.LicenseUpdatesNotification.Type[A.type]
                            : A.type),
                      null != A.leftDays &&
                        A.hasOwnProperty("leftDays") &&
                        ("number" == typeof A.leftDays
                          ? (t.leftDays = e.longs === String ? String(A.leftDays) : A.leftDays)
                          : (t.leftDays =
                              e.longs === String
                                ? oa.Long.prototype.toString.call(A.leftDays)
                                : e.longs === Number
                                  ? new oa.LongBits(
                                      A.leftDays.low >>> 0,
                                      A.leftDays.high >>> 0
                                    ).toNumber()
                                  : A.leftDays)),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.main.LicenseUpdatesNotification.Update"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.IdleWarningNotification = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.disconnectionTime = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.disconnectionTime &&
                    Object.hasOwnProperty.call(A, "disconnectionTime") &&
                    e.uint32(10).string(A.disconnectionTime),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.IdleWarningNotification();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.disconnectionTime = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.disconnectionTime &&
                      A.hasOwnProperty("disconnectionTime") &&
                      !oa.isString(A.disconnectionTime)
                    ? "disconnectionTime: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.IdleWarningNotification) return A;
                let e = new ra.dcv.main.IdleWarningNotification();
                return (
                  null != A.disconnectionTime &&
                    (e.disconnectionTime = String(A.disconnectionTime)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.disconnectionTime = ""),
                  null != A.disconnectionTime &&
                    A.hasOwnProperty("disconnectionTime") &&
                    (t.disconnectionTime = A.disconnectionTime),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.IdleWarningNotification"
                );
              }),
              A
            );
          })()),
          (A.ResetIdleTimeout = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return e || (e = na.create()), e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ResetIdleTimeout();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A ? "object expected" : null;
              }),
              (A.fromObject = function (A) {
                return A instanceof ra.dcv.main.ResetIdleTimeout
                  ? A
                  : new ra.dcv.main.ResetIdleTimeout();
              }),
              (A.toObject = function () {
                return {};
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ResetIdleTimeout"
                );
              }),
              A
            );
          })()),
          (A.ClientInformation = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.clientMode = 0),
              (A.prototype.ianaTimezoneCode = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.clientMode &&
                    Object.hasOwnProperty.call(A, "clientMode") &&
                    e.uint32(80).int32(A.clientMode),
                  null != A.ianaTimezoneCode &&
                    Object.hasOwnProperty.call(A, "ianaTimezoneCode") &&
                    e.uint32(162).string(A.ianaTimezoneCode),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ClientInformation();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.clientMode = A.int32();
                      break;
                    case 20:
                      i.ianaTimezoneCode = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.clientMode && A.hasOwnProperty("clientMode"))
                  switch (A.clientMode) {
                    default:
                      return "clientMode: enum value expected";
                    case 0:
                    case 1:
                  }
                return null != A.ianaTimezoneCode &&
                  A.hasOwnProperty("ianaTimezoneCode") &&
                  !oa.isString(A.ianaTimezoneCode)
                  ? "ianaTimezoneCode: string expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ClientInformation) return A;
                let e = new ra.dcv.main.ClientInformation();
                switch (A.clientMode) {
                  default:
                    if ("number" == typeof A.clientMode) {
                      e.clientMode = A.clientMode;
                      break;
                    }
                    break;
                  case "CLASSIC":
                  case 0:
                    e.clientMode = 0;
                    break;
                  case "SEAMLESS_WINDOWS":
                  case 1:
                    e.clientMode = 1;
                }
                return (
                  null != A.ianaTimezoneCode && (e.ianaTimezoneCode = String(A.ianaTimezoneCode)), e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.clientMode = e.enums === String ? "CLASSIC" : 0),
                    (t.ianaTimezoneCode = "")),
                  null != A.clientMode &&
                    A.hasOwnProperty("clientMode") &&
                    (t.clientMode =
                      e.enums === String
                        ? void 0 === ra.dcv.main.ClientInformation.ClientMode[A.clientMode]
                          ? A.clientMode
                          : ra.dcv.main.ClientInformation.ClientMode[A.clientMode]
                        : A.clientMode),
                  null != A.ianaTimezoneCode &&
                    A.hasOwnProperty("ianaTimezoneCode") &&
                    (t.ianaTimezoneCode = A.ianaTimezoneCode),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ClientInformation"
                );
              }),
              (A.ClientMode = (function () {
                const A = {},
                  e = Object.create(A);
                return (e[(A[0] = "CLASSIC")] = 0), (e[(A[1] = "SEAMLESS_WINDOWS")] = 1), e;
              })()),
              A
            );
          })()),
          (A.FlowStats = (function () {
            function A(A) {
              if (((this.reports = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.reports = oa.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = na.create()), null != A.reports && A.reports.length))
                  for (let t = 0; t < A.reports.length; ++t)
                    ra.dcv.main.FlowStats.Report.encode(A.reports[t], e.uint32(82).fork()).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.FlowStats();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10)
                    (i.reports && i.reports.length) || (i.reports = []),
                      i.reports.push(ra.dcv.main.FlowStats.Report.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.reports && A.hasOwnProperty("reports")) {
                  if (!Array.isArray(A.reports)) return "reports: array expected";
                  for (let e = 0; e < A.reports.length; ++e) {
                    let t = ra.dcv.main.FlowStats.Report.verify(A.reports[e]);
                    if (t) return "reports." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.FlowStats) return A;
                let e = new ra.dcv.main.FlowStats();
                if (A.reports) {
                  if (!Array.isArray(A.reports))
                    throw TypeError(".dcv.main.FlowStats.reports: array expected");
                  e.reports = [];
                  for (let t = 0; t < A.reports.length; ++t) {
                    if ("object" != typeof A.reports[t])
                      throw TypeError(".dcv.main.FlowStats.reports: object expected");
                    e.reports[t] = ra.dcv.main.FlowStats.Report.fromObject(A.reports[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.reports = []), A.reports && A.reports.length)) {
                  t.reports = [];
                  for (let i = 0; i < A.reports.length; ++i)
                    t.reports[i] = ra.dcv.main.FlowStats.Report.toObject(A.reports[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.FlowStats";
              }),
              (A.Report = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.receivedTimestampUsec = oa.Long ? oa.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.sentTimestampUsec = oa.Long ? oa.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.packetSize = 0),
                  (A.prototype.packetsReceived = oa.Long ? oa.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.packetsLost = oa.Long ? oa.Long.fromBits(0, 0, !0) : 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = na.create()),
                      null != A.receivedTimestampUsec &&
                        Object.hasOwnProperty.call(A, "receivedTimestampUsec") &&
                        e.uint32(8).uint64(A.receivedTimestampUsec),
                      null != A.sentTimestampUsec &&
                        Object.hasOwnProperty.call(A, "sentTimestampUsec") &&
                        e.uint32(16).uint64(A.sentTimestampUsec),
                      null != A.packetSize &&
                        Object.hasOwnProperty.call(A, "packetSize") &&
                        e.uint32(24).uint32(A.packetSize),
                      null != A.packetsReceived &&
                        Object.hasOwnProperty.call(A, "packetsReceived") &&
                        e.uint32(32).uint64(A.packetsReceived),
                      null != A.packetsLost &&
                        Object.hasOwnProperty.call(A, "packetsLost") &&
                        e.uint32(40).uint64(A.packetsLost),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof ia || (A = ia.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new ra.dcv.main.FlowStats.Report();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.receivedTimestampUsec = A.uint64();
                          break;
                        case 2:
                          i.sentTimestampUsec = A.uint64();
                          break;
                        case 3:
                          i.packetSize = A.uint32();
                          break;
                        case 4:
                          i.packetsReceived = A.uint64();
                          break;
                        case 5:
                          i.packetsLost = A.uint64();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.receivedTimestampUsec &&
                          A.hasOwnProperty("receivedTimestampUsec") &&
                          !(
                            oa.isInteger(A.receivedTimestampUsec) ||
                            (A.receivedTimestampUsec &&
                              oa.isInteger(A.receivedTimestampUsec.low) &&
                              oa.isInteger(A.receivedTimestampUsec.high))
                          )
                        ? "receivedTimestampUsec: integer|Long expected"
                        : null != A.sentTimestampUsec &&
                            A.hasOwnProperty("sentTimestampUsec") &&
                            !(
                              oa.isInteger(A.sentTimestampUsec) ||
                              (A.sentTimestampUsec &&
                                oa.isInteger(A.sentTimestampUsec.low) &&
                                oa.isInteger(A.sentTimestampUsec.high))
                            )
                          ? "sentTimestampUsec: integer|Long expected"
                          : null != A.packetSize &&
                              A.hasOwnProperty("packetSize") &&
                              !oa.isInteger(A.packetSize)
                            ? "packetSize: integer expected"
                            : null != A.packetsReceived &&
                                A.hasOwnProperty("packetsReceived") &&
                                !(
                                  oa.isInteger(A.packetsReceived) ||
                                  (A.packetsReceived &&
                                    oa.isInteger(A.packetsReceived.low) &&
                                    oa.isInteger(A.packetsReceived.high))
                                )
                              ? "packetsReceived: integer|Long expected"
                              : null != A.packetsLost &&
                                  A.hasOwnProperty("packetsLost") &&
                                  !(
                                    oa.isInteger(A.packetsLost) ||
                                    (A.packetsLost &&
                                      oa.isInteger(A.packetsLost.low) &&
                                      oa.isInteger(A.packetsLost.high))
                                  )
                                ? "packetsLost: integer|Long expected"
                                : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof ra.dcv.main.FlowStats.Report) return A;
                    let e = new ra.dcv.main.FlowStats.Report();
                    return (
                      null != A.receivedTimestampUsec &&
                        (oa.Long
                          ? ((e.receivedTimestampUsec = oa.Long.fromValue(
                              A.receivedTimestampUsec
                            )).unsigned = !0)
                          : "string" == typeof A.receivedTimestampUsec
                            ? (e.receivedTimestampUsec = parseInt(A.receivedTimestampUsec, 10))
                            : "number" == typeof A.receivedTimestampUsec
                              ? (e.receivedTimestampUsec = A.receivedTimestampUsec)
                              : "object" == typeof A.receivedTimestampUsec &&
                                (e.receivedTimestampUsec = new oa.LongBits(
                                  A.receivedTimestampUsec.low >>> 0,
                                  A.receivedTimestampUsec.high >>> 0
                                ).toNumber(!0))),
                      null != A.sentTimestampUsec &&
                        (oa.Long
                          ? ((e.sentTimestampUsec = oa.Long.fromValue(
                              A.sentTimestampUsec
                            )).unsigned = !0)
                          : "string" == typeof A.sentTimestampUsec
                            ? (e.sentTimestampUsec = parseInt(A.sentTimestampUsec, 10))
                            : "number" == typeof A.sentTimestampUsec
                              ? (e.sentTimestampUsec = A.sentTimestampUsec)
                              : "object" == typeof A.sentTimestampUsec &&
                                (e.sentTimestampUsec = new oa.LongBits(
                                  A.sentTimestampUsec.low >>> 0,
                                  A.sentTimestampUsec.high >>> 0
                                ).toNumber(!0))),
                      null != A.packetSize && (e.packetSize = A.packetSize >>> 0),
                      null != A.packetsReceived &&
                        (oa.Long
                          ? ((e.packetsReceived = oa.Long.fromValue(A.packetsReceived)).unsigned =
                              !0)
                          : "string" == typeof A.packetsReceived
                            ? (e.packetsReceived = parseInt(A.packetsReceived, 10))
                            : "number" == typeof A.packetsReceived
                              ? (e.packetsReceived = A.packetsReceived)
                              : "object" == typeof A.packetsReceived &&
                                (e.packetsReceived = new oa.LongBits(
                                  A.packetsReceived.low >>> 0,
                                  A.packetsReceived.high >>> 0
                                ).toNumber(!0))),
                      null != A.packetsLost &&
                        (oa.Long
                          ? ((e.packetsLost = oa.Long.fromValue(A.packetsLost)).unsigned = !0)
                          : "string" == typeof A.packetsLost
                            ? (e.packetsLost = parseInt(A.packetsLost, 10))
                            : "number" == typeof A.packetsLost
                              ? (e.packetsLost = A.packetsLost)
                              : "object" == typeof A.packetsLost &&
                                (e.packetsLost = new oa.LongBits(
                                  A.packetsLost.low >>> 0,
                                  A.packetsLost.high >>> 0
                                ).toNumber(!0))),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults) {
                      if (oa.Long) {
                        let A = new oa.Long(0, 0, !0);
                        t.receivedTimestampUsec =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.receivedTimestampUsec = e.longs === String ? "0" : 0;
                      if (oa.Long) {
                        let A = new oa.Long(0, 0, !0);
                        t.sentTimestampUsec =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.sentTimestampUsec = e.longs === String ? "0" : 0;
                      if (((t.packetSize = 0), oa.Long)) {
                        let A = new oa.Long(0, 0, !0);
                        t.packetsReceived =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.packetsReceived = e.longs === String ? "0" : 0;
                      if (oa.Long) {
                        let A = new oa.Long(0, 0, !0);
                        t.packetsLost =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.packetsLost = e.longs === String ? "0" : 0;
                    }
                    return (
                      null != A.receivedTimestampUsec &&
                        A.hasOwnProperty("receivedTimestampUsec") &&
                        ("number" == typeof A.receivedTimestampUsec
                          ? (t.receivedTimestampUsec =
                              e.longs === String
                                ? String(A.receivedTimestampUsec)
                                : A.receivedTimestampUsec)
                          : (t.receivedTimestampUsec =
                              e.longs === String
                                ? oa.Long.prototype.toString.call(A.receivedTimestampUsec)
                                : e.longs === Number
                                  ? new oa.LongBits(
                                      A.receivedTimestampUsec.low >>> 0,
                                      A.receivedTimestampUsec.high >>> 0
                                    ).toNumber(!0)
                                  : A.receivedTimestampUsec)),
                      null != A.sentTimestampUsec &&
                        A.hasOwnProperty("sentTimestampUsec") &&
                        ("number" == typeof A.sentTimestampUsec
                          ? (t.sentTimestampUsec =
                              e.longs === String
                                ? String(A.sentTimestampUsec)
                                : A.sentTimestampUsec)
                          : (t.sentTimestampUsec =
                              e.longs === String
                                ? oa.Long.prototype.toString.call(A.sentTimestampUsec)
                                : e.longs === Number
                                  ? new oa.LongBits(
                                      A.sentTimestampUsec.low >>> 0,
                                      A.sentTimestampUsec.high >>> 0
                                    ).toNumber(!0)
                                  : A.sentTimestampUsec)),
                      null != A.packetSize &&
                        A.hasOwnProperty("packetSize") &&
                        (t.packetSize = A.packetSize),
                      null != A.packetsReceived &&
                        A.hasOwnProperty("packetsReceived") &&
                        ("number" == typeof A.packetsReceived
                          ? (t.packetsReceived =
                              e.longs === String ? String(A.packetsReceived) : A.packetsReceived)
                          : (t.packetsReceived =
                              e.longs === String
                                ? oa.Long.prototype.toString.call(A.packetsReceived)
                                : e.longs === Number
                                  ? new oa.LongBits(
                                      A.packetsReceived.low >>> 0,
                                      A.packetsReceived.high >>> 0
                                    ).toNumber(!0)
                                  : A.packetsReceived)),
                      null != A.packetsLost &&
                        A.hasOwnProperty("packetsLost") &&
                        ("number" == typeof A.packetsLost
                          ? (t.packetsLost =
                              e.longs === String ? String(A.packetsLost) : A.packetsLost)
                          : (t.packetsLost =
                              e.longs === String
                                ? oa.Long.prototype.toString.call(A.packetsLost)
                                : e.longs === Number
                                  ? new oa.LongBits(
                                      A.packetsLost.low >>> 0,
                                      A.packetsLost.high >>> 0
                                    ).toNumber(!0)
                                  : A.packetsLost)),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.FlowStats.Report"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.CollaboratorList = (function () {
            function A(A) {
              if (((this.collaboratorsInfo = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.collaboratorsInfo = oa.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = na.create()),
                  null != A.collaboratorsInfo && A.collaboratorsInfo.length)
                )
                  for (let t = 0; t < A.collaboratorsInfo.length; ++t)
                    ra.dcv.main.CollaboratorList.CollaboratorInfo.encode(
                      A.collaboratorsInfo[t],
                      e.uint32(10).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.CollaboratorList();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    (i.collaboratorsInfo && i.collaboratorsInfo.length) ||
                      (i.collaboratorsInfo = []),
                      i.collaboratorsInfo.push(
                        ra.dcv.main.CollaboratorList.CollaboratorInfo.decode(A, A.uint32())
                      );
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.collaboratorsInfo && A.hasOwnProperty("collaboratorsInfo")) {
                  if (!Array.isArray(A.collaboratorsInfo))
                    return "collaboratorsInfo: array expected";
                  for (let e = 0; e < A.collaboratorsInfo.length; ++e) {
                    let t = ra.dcv.main.CollaboratorList.CollaboratorInfo.verify(
                      A.collaboratorsInfo[e]
                    );
                    if (t) return "collaboratorsInfo." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.CollaboratorList) return A;
                let e = new ra.dcv.main.CollaboratorList();
                if (A.collaboratorsInfo) {
                  if (!Array.isArray(A.collaboratorsInfo))
                    throw TypeError(".dcv.main.CollaboratorList.collaboratorsInfo: array expected");
                  e.collaboratorsInfo = [];
                  for (let t = 0; t < A.collaboratorsInfo.length; ++t) {
                    if ("object" != typeof A.collaboratorsInfo[t])
                      throw TypeError(
                        ".dcv.main.CollaboratorList.collaboratorsInfo: object expected"
                      );
                    e.collaboratorsInfo[t] =
                      ra.dcv.main.CollaboratorList.CollaboratorInfo.fromObject(
                        A.collaboratorsInfo[t]
                      );
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.collaboratorsInfo = []),
                  A.collaboratorsInfo && A.collaboratorsInfo.length)
                ) {
                  t.collaboratorsInfo = [];
                  for (let i = 0; i < A.collaboratorsInfo.length; ++i)
                    t.collaboratorsInfo[i] = ra.dcv.main.CollaboratorList.CollaboratorInfo.toObject(
                      A.collaboratorsInfo[i],
                      e
                    );
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.CollaboratorList"
                );
              }),
              (A.CollaboratorInfo = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.username = ""),
                  (A.prototype.owner = !1),
                  (A.prototype.connectionId = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = na.create()),
                      null != A.username &&
                        Object.hasOwnProperty.call(A, "username") &&
                        e.uint32(10).string(A.username),
                      null != A.owner &&
                        Object.hasOwnProperty.call(A, "owner") &&
                        e.uint32(16).bool(A.owner),
                      null != A.connectionId &&
                        Object.hasOwnProperty.call(A, "connectionId") &&
                        e.uint32(24).uint32(A.connectionId),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof ia || (A = ia.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new ra.dcv.main.CollaboratorList.CollaboratorInfo();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.username = A.string();
                          break;
                        case 2:
                          i.owner = A.bool();
                          break;
                        case 3:
                          i.connectionId = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.username &&
                          A.hasOwnProperty("username") &&
                          !oa.isString(A.username)
                        ? "username: string expected"
                        : null != A.owner &&
                            A.hasOwnProperty("owner") &&
                            "boolean" != typeof A.owner
                          ? "owner: boolean expected"
                          : null != A.connectionId &&
                              A.hasOwnProperty("connectionId") &&
                              !oa.isInteger(A.connectionId)
                            ? "connectionId: integer expected"
                            : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof ra.dcv.main.CollaboratorList.CollaboratorInfo) return A;
                    let e = new ra.dcv.main.CollaboratorList.CollaboratorInfo();
                    return (
                      null != A.username && (e.username = String(A.username)),
                      null != A.owner && (e.owner = Boolean(A.owner)),
                      null != A.connectionId && (e.connectionId = A.connectionId >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.username = ""), (t.owner = !1), (t.connectionId = 0)),
                      null != A.username &&
                        A.hasOwnProperty("username") &&
                        (t.username = A.username),
                      null != A.owner && A.hasOwnProperty("owner") && (t.owner = A.owner),
                      null != A.connectionId &&
                        A.hasOwnProperty("connectionId") &&
                        (t.connectionId = A.connectionId),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.main.CollaboratorList.CollaboratorInfo"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.DisconnectCollaborator = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.connectionId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.connectionId &&
                    Object.hasOwnProperty.call(A, "connectionId") &&
                    e.uint32(8).uint32(A.connectionId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.DisconnectCollaborator();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.connectionId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.connectionId &&
                      A.hasOwnProperty("connectionId") &&
                      !oa.isInteger(A.connectionId)
                    ? "connectionId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.DisconnectCollaborator) return A;
                let e = new ra.dcv.main.DisconnectCollaborator();
                return null != A.connectionId && (e.connectionId = A.connectionId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.connectionId = 0),
                  null != A.connectionId &&
                    A.hasOwnProperty("connectionId") &&
                    (t.connectionId = A.connectionId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.DisconnectCollaborator"
                );
              }),
              A
            );
          })()),
          (A.TimezoneRedirectionSetting = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.enabled = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.enabled &&
                    Object.hasOwnProperty.call(A, "enabled") &&
                    e.uint32(8).int32(A.enabled),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.TimezoneRedirectionSetting();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.enabled = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.enabled && A.hasOwnProperty("enabled"))
                  switch (A.enabled) {
                    default:
                      return "enabled: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.TimezoneRedirectionSetting) return A;
                let e = new ra.dcv.main.TimezoneRedirectionSetting();
                switch (A.enabled) {
                  default:
                    if ("number" == typeof A.enabled) {
                      e.enabled = A.enabled;
                      break;
                    }
                    break;
                  case "ALWAYS_OFF":
                  case 0:
                    e.enabled = 0;
                    break;
                  case "ALWAYS_ON":
                  case 1:
                    e.enabled = 1;
                    break;
                  case "CLIENT_DECIDES":
                  case 2:
                    e.enabled = 2;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.enabled = e.enums === String ? "ALWAYS_OFF" : 0),
                  null != A.enabled &&
                    A.hasOwnProperty("enabled") &&
                    (t.enabled =
                      e.enums === String
                        ? void 0 === ra.dcv.main.FeatureSetting[A.enabled]
                          ? A.enabled
                          : ra.dcv.main.FeatureSetting[A.enabled]
                        : A.enabled),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.TimezoneRedirectionSetting"
                );
              }),
              A
            );
          })()),
          (A.TimezoneRedirectionStatus = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.status = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.status &&
                    Object.hasOwnProperty.call(A, "status") &&
                    e.uint32(8).int32(A.status),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.TimezoneRedirectionStatus();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.status = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.status && A.hasOwnProperty("status"))
                  switch (A.status) {
                    default:
                      return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.TimezoneRedirectionStatus) return A;
                let e = new ra.dcv.main.TimezoneRedirectionStatus();
                switch (A.status) {
                  default:
                    if ("number" == typeof A.status) {
                      e.status = A.status;
                      break;
                    }
                    break;
                  case "SUCCESS":
                  case 0:
                    e.status = 0;
                    break;
                  case "PERMISSION_ERROR":
                  case 1:
                    e.status = 1;
                    break;
                  case "GENERIC_ERROR":
                  case 2:
                    e.status = 2;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.status = e.enums === String ? "SUCCESS" : 0),
                  null != A.status &&
                    A.hasOwnProperty("status") &&
                    (t.status =
                      e.enums === String
                        ? void 0 === ra.dcv.main.TimezoneRedirectionStatus.Status[A.status]
                          ? A.status
                          : ra.dcv.main.TimezoneRedirectionStatus.Status[A.status]
                        : A.status),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.TimezoneRedirectionStatus"
                );
              }),
              (A.Status = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "SUCCESS")] = 0),
                  (e[(A[1] = "PERMISSION_ERROR")] = 1),
                  (e[(A[2] = "GENERIC_ERROR")] = 2),
                  e
                );
              })()),
              A
            );
          })()),
          (A.ExtensionsClientPermission = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.enabled = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.enabled &&
                    Object.hasOwnProperty.call(A, "enabled") &&
                    e.uint32(8).bool(A.enabled),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ExtensionsClientPermission();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.enabled = A.bool();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.enabled &&
                      A.hasOwnProperty("enabled") &&
                      "boolean" != typeof A.enabled
                    ? "enabled: boolean expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ExtensionsClientPermission) return A;
                let e = new ra.dcv.main.ExtensionsClientPermission();
                return null != A.enabled && (e.enabled = Boolean(A.enabled)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.enabled = !1),
                  null != A.enabled && A.hasOwnProperty("enabled") && (t.enabled = A.enabled),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.main.ExtensionsClientPermission"
                );
              }),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.pong = null),
              (A.prototype.clientInformation = null),
              (A.prototype.resetIdleTimeout = null),
              (A.prototype.flowStatisticsReport = null),
              (A.prototype.disconnectCollaborator = null),
              Object.defineProperty(A.prototype, "msg", {
                get: oa.oneOfGetter(
                  (e = [
                    "pong",
                    "clientInformation",
                    "resetIdleTimeout",
                    "flowStatisticsReport",
                    "disconnectCollaborator"
                  ])
                ),
                set: oa.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.pong &&
                    Object.hasOwnProperty.call(A, "pong") &&
                    ra.dcv.main.Pong.encode(A.pong, e.uint32(90).fork()).ldelim(),
                  null != A.clientInformation &&
                    Object.hasOwnProperty.call(A, "clientInformation") &&
                    ra.dcv.main.ClientInformation.encode(
                      A.clientInformation,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.resetIdleTimeout &&
                    Object.hasOwnProperty.call(A, "resetIdleTimeout") &&
                    ra.dcv.main.ResetIdleTimeout.encode(
                      A.resetIdleTimeout,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.flowStatisticsReport &&
                    Object.hasOwnProperty.call(A, "flowStatisticsReport") &&
                    ra.dcv.main.FlowStats.encode(
                      A.flowStatisticsReport,
                      e.uint32(322).fork()
                    ).ldelim(),
                  null != A.disconnectCollaborator &&
                    Object.hasOwnProperty.call(A, "disconnectCollaborator") &&
                    ra.dcv.main.DisconnectCollaborator.encode(
                      A.disconnectCollaborator,
                      e.uint32(402).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 11:
                      i.pong = ra.dcv.main.Pong.decode(A, A.uint32());
                      break;
                    case 20:
                      i.clientInformation = ra.dcv.main.ClientInformation.decode(A, A.uint32());
                      break;
                    case 30:
                      i.resetIdleTimeout = ra.dcv.main.ResetIdleTimeout.decode(A, A.uint32());
                      break;
                    case 40:
                      i.flowStatisticsReport = ra.dcv.main.FlowStats.decode(A, A.uint32());
                      break;
                    case 50:
                      i.disconnectCollaborator = ra.dcv.main.DisconnectCollaborator.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.pong && A.hasOwnProperty("pong")) {
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.Pong.verify(A.pong);
                    if (e) return "pong." + e;
                  }
                }
                if (null != A.clientInformation && A.hasOwnProperty("clientInformation")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.ClientInformation.verify(A.clientInformation);
                    if (e) return "clientInformation." + e;
                  }
                }
                if (null != A.resetIdleTimeout && A.hasOwnProperty("resetIdleTimeout")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.ResetIdleTimeout.verify(A.resetIdleTimeout);
                    if (e) return "resetIdleTimeout." + e;
                  }
                }
                if (null != A.flowStatisticsReport && A.hasOwnProperty("flowStatisticsReport")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.FlowStats.verify(A.flowStatisticsReport);
                    if (e) return "flowStatisticsReport." + e;
                  }
                }
                if (
                  null != A.disconnectCollaborator &&
                  A.hasOwnProperty("disconnectCollaborator")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.DisconnectCollaborator.verify(A.disconnectCollaborator);
                    if (e) return "disconnectCollaborator." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ClientMessage) return A;
                let e = new ra.dcv.main.ClientMessage();
                if (null != A.pong) {
                  if ("object" != typeof A.pong)
                    throw TypeError(".dcv.main.ClientMessage.pong: object expected");
                  e.pong = ra.dcv.main.Pong.fromObject(A.pong);
                }
                if (null != A.clientInformation) {
                  if ("object" != typeof A.clientInformation)
                    throw TypeError(".dcv.main.ClientMessage.clientInformation: object expected");
                  e.clientInformation = ra.dcv.main.ClientInformation.fromObject(
                    A.clientInformation
                  );
                }
                if (null != A.resetIdleTimeout) {
                  if ("object" != typeof A.resetIdleTimeout)
                    throw TypeError(".dcv.main.ClientMessage.resetIdleTimeout: object expected");
                  e.resetIdleTimeout = ra.dcv.main.ResetIdleTimeout.fromObject(A.resetIdleTimeout);
                }
                if (null != A.flowStatisticsReport) {
                  if ("object" != typeof A.flowStatisticsReport)
                    throw TypeError(
                      ".dcv.main.ClientMessage.flowStatisticsReport: object expected"
                    );
                  e.flowStatisticsReport = ra.dcv.main.FlowStats.fromObject(A.flowStatisticsReport);
                }
                if (null != A.disconnectCollaborator) {
                  if ("object" != typeof A.disconnectCollaborator)
                    throw TypeError(
                      ".dcv.main.ClientMessage.disconnectCollaborator: object expected"
                    );
                  e.disconnectCollaborator = ra.dcv.main.DisconnectCollaborator.fromObject(
                    A.disconnectCollaborator
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.pong &&
                    A.hasOwnProperty("pong") &&
                    ((t.pong = ra.dcv.main.Pong.toObject(A.pong, e)), e.oneofs && (t.msg = "pong")),
                  null != A.clientInformation &&
                    A.hasOwnProperty("clientInformation") &&
                    ((t.clientInformation = ra.dcv.main.ClientInformation.toObject(
                      A.clientInformation,
                      e
                    )),
                    e.oneofs && (t.msg = "clientInformation")),
                  null != A.resetIdleTimeout &&
                    A.hasOwnProperty("resetIdleTimeout") &&
                    ((t.resetIdleTimeout = ra.dcv.main.ResetIdleTimeout.toObject(
                      A.resetIdleTimeout,
                      e
                    )),
                    e.oneofs && (t.msg = "resetIdleTimeout")),
                  null != A.flowStatisticsReport &&
                    A.hasOwnProperty("flowStatisticsReport") &&
                    ((t.flowStatisticsReport = ra.dcv.main.FlowStats.toObject(
                      A.flowStatisticsReport,
                      e
                    )),
                    e.oneofs && (t.msg = "flowStatisticsReport")),
                  null != A.disconnectCollaborator &&
                    A.hasOwnProperty("disconnectCollaborator") &&
                    ((t.disconnectCollaborator = ra.dcv.main.DisconnectCollaborator.toObject(
                      A.disconnectCollaborator,
                      e
                    )),
                    e.oneofs && (t.msg = "disconnectCollaborator")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ClientMessage";
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.channelNotification = null),
              (A.prototype.resourceNotification = null),
              (A.prototype.ping = null),
              (A.prototype.pang = null),
              (A.prototype.connectionClose = null),
              (A.prototype.qualityIndicatorNotification = null),
              (A.prototype.licenseUpdatesNotification = null),
              (A.prototype.idleWarningNotification = null),
              (A.prototype.collaboratorList = null),
              (A.prototype.timezoneRedirectionSetting = null),
              (A.prototype.timezoneRedirectionStatus = null),
              (A.prototype.extensionsClientPermission = null),
              Object.defineProperty(A.prototype, "msg", {
                get: oa.oneOfGetter(
                  (e = [
                    "channelNotification",
                    "resourceNotification",
                    "ping",
                    "pang",
                    "connectionClose",
                    "qualityIndicatorNotification",
                    "licenseUpdatesNotification",
                    "idleWarningNotification",
                    "collaboratorList",
                    "timezoneRedirectionSetting",
                    "timezoneRedirectionStatus",
                    "extensionsClientPermission"
                  ])
                ),
                set: oa.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = na.create()),
                  null != A.channelNotification &&
                    Object.hasOwnProperty.call(A, "channelNotification") &&
                    ra.dcv.main.ChannelNotification.encode(
                      A.channelNotification,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.resourceNotification &&
                    Object.hasOwnProperty.call(A, "resourceNotification") &&
                    ra.dcv.main.ResourceNotification.encode(
                      A.resourceNotification,
                      e.uint32(90).fork()
                    ).ldelim(),
                  null != A.ping &&
                    Object.hasOwnProperty.call(A, "ping") &&
                    ra.dcv.main.Ping.encode(A.ping, e.uint32(98).fork()).ldelim(),
                  null != A.pang &&
                    Object.hasOwnProperty.call(A, "pang") &&
                    ra.dcv.main.Pang.encode(A.pang, e.uint32(106).fork()).ldelim(),
                  null != A.connectionClose &&
                    Object.hasOwnProperty.call(A, "connectionClose") &&
                    ra.dcv.main.ConnectionClose.encode(
                      A.connectionClose,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.qualityIndicatorNotification &&
                    Object.hasOwnProperty.call(A, "qualityIndicatorNotification") &&
                    ra.dcv.main.QualityIndicatorNotification.encode(
                      A.qualityIndicatorNotification,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.licenseUpdatesNotification &&
                    Object.hasOwnProperty.call(A, "licenseUpdatesNotification") &&
                    ra.dcv.main.LicenseUpdatesNotification.encode(
                      A.licenseUpdatesNotification,
                      e.uint32(322).fork()
                    ).ldelim(),
                  null != A.idleWarningNotification &&
                    Object.hasOwnProperty.call(A, "idleWarningNotification") &&
                    ra.dcv.main.IdleWarningNotification.encode(
                      A.idleWarningNotification,
                      e.uint32(402).fork()
                    ).ldelim(),
                  null != A.collaboratorList &&
                    Object.hasOwnProperty.call(A, "collaboratorList") &&
                    ra.dcv.main.CollaboratorList.encode(
                      A.collaboratorList,
                      e.uint32(482).fork()
                    ).ldelim(),
                  null != A.timezoneRedirectionSetting &&
                    Object.hasOwnProperty.call(A, "timezoneRedirectionSetting") &&
                    ra.dcv.main.TimezoneRedirectionSetting.encode(
                      A.timezoneRedirectionSetting,
                      e.uint32(562).fork()
                    ).ldelim(),
                  null != A.timezoneRedirectionStatus &&
                    Object.hasOwnProperty.call(A, "timezoneRedirectionStatus") &&
                    ra.dcv.main.TimezoneRedirectionStatus.encode(
                      A.timezoneRedirectionStatus,
                      e.uint32(570).fork()
                    ).ldelim(),
                  null != A.extensionsClientPermission &&
                    Object.hasOwnProperty.call(A, "extensionsClientPermission") &&
                    ra.dcv.main.ExtensionsClientPermission.encode(
                      A.extensionsClientPermission,
                      e.uint32(642).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ia || (A = ia.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new ra.dcv.main.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.channelNotification = ra.dcv.main.ChannelNotification.decode(A, A.uint32());
                      break;
                    case 11:
                      i.resourceNotification = ra.dcv.main.ResourceNotification.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 12:
                      i.ping = ra.dcv.main.Ping.decode(A, A.uint32());
                      break;
                    case 13:
                      i.pang = ra.dcv.main.Pang.decode(A, A.uint32());
                      break;
                    case 20:
                      i.connectionClose = ra.dcv.main.ConnectionClose.decode(A, A.uint32());
                      break;
                    case 30:
                      i.qualityIndicatorNotification =
                        ra.dcv.main.QualityIndicatorNotification.decode(A, A.uint32());
                      break;
                    case 40:
                      i.licenseUpdatesNotification = ra.dcv.main.LicenseUpdatesNotification.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 50:
                      i.idleWarningNotification = ra.dcv.main.IdleWarningNotification.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 60:
                      i.collaboratorList = ra.dcv.main.CollaboratorList.decode(A, A.uint32());
                      break;
                    case 70:
                      i.timezoneRedirectionSetting = ra.dcv.main.TimezoneRedirectionSetting.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 71:
                      i.timezoneRedirectionStatus = ra.dcv.main.TimezoneRedirectionStatus.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 80:
                      i.extensionsClientPermission = ra.dcv.main.ExtensionsClientPermission.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ia || (A = new ia(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.channelNotification && A.hasOwnProperty("channelNotification")) {
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.ChannelNotification.verify(A.channelNotification);
                    if (e) return "channelNotification." + e;
                  }
                }
                if (null != A.resourceNotification && A.hasOwnProperty("resourceNotification")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.ResourceNotification.verify(A.resourceNotification);
                    if (e) return "resourceNotification." + e;
                  }
                }
                if (null != A.ping && A.hasOwnProperty("ping")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.Ping.verify(A.ping);
                    if (e) return "ping." + e;
                  }
                }
                if (null != A.pang && A.hasOwnProperty("pang")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.Pang.verify(A.pang);
                    if (e) return "pang." + e;
                  }
                }
                if (null != A.connectionClose && A.hasOwnProperty("connectionClose")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.ConnectionClose.verify(A.connectionClose);
                    if (e) return "connectionClose." + e;
                  }
                }
                if (
                  null != A.qualityIndicatorNotification &&
                  A.hasOwnProperty("qualityIndicatorNotification")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.QualityIndicatorNotification.verify(
                      A.qualityIndicatorNotification
                    );
                    if (e) return "qualityIndicatorNotification." + e;
                  }
                }
                if (
                  null != A.licenseUpdatesNotification &&
                  A.hasOwnProperty("licenseUpdatesNotification")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.LicenseUpdatesNotification.verify(
                      A.licenseUpdatesNotification
                    );
                    if (e) return "licenseUpdatesNotification." + e;
                  }
                }
                if (
                  null != A.idleWarningNotification &&
                  A.hasOwnProperty("idleWarningNotification")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.IdleWarningNotification.verify(A.idleWarningNotification);
                    if (e) return "idleWarningNotification." + e;
                  }
                }
                if (null != A.collaboratorList && A.hasOwnProperty("collaboratorList")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.CollaboratorList.verify(A.collaboratorList);
                    if (e) return "collaboratorList." + e;
                  }
                }
                if (
                  null != A.timezoneRedirectionSetting &&
                  A.hasOwnProperty("timezoneRedirectionSetting")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.TimezoneRedirectionSetting.verify(
                      A.timezoneRedirectionSetting
                    );
                    if (e) return "timezoneRedirectionSetting." + e;
                  }
                }
                if (
                  null != A.timezoneRedirectionStatus &&
                  A.hasOwnProperty("timezoneRedirectionStatus")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.TimezoneRedirectionStatus.verify(
                      A.timezoneRedirectionStatus
                    );
                    if (e) return "timezoneRedirectionStatus." + e;
                  }
                }
                if (
                  null != A.extensionsClientPermission &&
                  A.hasOwnProperty("extensionsClientPermission")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = ra.dcv.main.ExtensionsClientPermission.verify(
                      A.extensionsClientPermission
                    );
                    if (e) return "extensionsClientPermission." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof ra.dcv.main.ServerMessage) return A;
                let e = new ra.dcv.main.ServerMessage();
                if (null != A.channelNotification) {
                  if ("object" != typeof A.channelNotification)
                    throw TypeError(".dcv.main.ServerMessage.channelNotification: object expected");
                  e.channelNotification = ra.dcv.main.ChannelNotification.fromObject(
                    A.channelNotification
                  );
                }
                if (null != A.resourceNotification) {
                  if ("object" != typeof A.resourceNotification)
                    throw TypeError(
                      ".dcv.main.ServerMessage.resourceNotification: object expected"
                    );
                  e.resourceNotification = ra.dcv.main.ResourceNotification.fromObject(
                    A.resourceNotification
                  );
                }
                if (null != A.ping) {
                  if ("object" != typeof A.ping)
                    throw TypeError(".dcv.main.ServerMessage.ping: object expected");
                  e.ping = ra.dcv.main.Ping.fromObject(A.ping);
                }
                if (null != A.pang) {
                  if ("object" != typeof A.pang)
                    throw TypeError(".dcv.main.ServerMessage.pang: object expected");
                  e.pang = ra.dcv.main.Pang.fromObject(A.pang);
                }
                if (null != A.connectionClose) {
                  if ("object" != typeof A.connectionClose)
                    throw TypeError(".dcv.main.ServerMessage.connectionClose: object expected");
                  e.connectionClose = ra.dcv.main.ConnectionClose.fromObject(A.connectionClose);
                }
                if (null != A.qualityIndicatorNotification) {
                  if ("object" != typeof A.qualityIndicatorNotification)
                    throw TypeError(
                      ".dcv.main.ServerMessage.qualityIndicatorNotification: object expected"
                    );
                  e.qualityIndicatorNotification =
                    ra.dcv.main.QualityIndicatorNotification.fromObject(
                      A.qualityIndicatorNotification
                    );
                }
                if (null != A.licenseUpdatesNotification) {
                  if ("object" != typeof A.licenseUpdatesNotification)
                    throw TypeError(
                      ".dcv.main.ServerMessage.licenseUpdatesNotification: object expected"
                    );
                  e.licenseUpdatesNotification = ra.dcv.main.LicenseUpdatesNotification.fromObject(
                    A.licenseUpdatesNotification
                  );
                }
                if (null != A.idleWarningNotification) {
                  if ("object" != typeof A.idleWarningNotification)
                    throw TypeError(
                      ".dcv.main.ServerMessage.idleWarningNotification: object expected"
                    );
                  e.idleWarningNotification = ra.dcv.main.IdleWarningNotification.fromObject(
                    A.idleWarningNotification
                  );
                }
                if (null != A.collaboratorList) {
                  if ("object" != typeof A.collaboratorList)
                    throw TypeError(".dcv.main.ServerMessage.collaboratorList: object expected");
                  e.collaboratorList = ra.dcv.main.CollaboratorList.fromObject(A.collaboratorList);
                }
                if (null != A.timezoneRedirectionSetting) {
                  if ("object" != typeof A.timezoneRedirectionSetting)
                    throw TypeError(
                      ".dcv.main.ServerMessage.timezoneRedirectionSetting: object expected"
                    );
                  e.timezoneRedirectionSetting = ra.dcv.main.TimezoneRedirectionSetting.fromObject(
                    A.timezoneRedirectionSetting
                  );
                }
                if (null != A.timezoneRedirectionStatus) {
                  if ("object" != typeof A.timezoneRedirectionStatus)
                    throw TypeError(
                      ".dcv.main.ServerMessage.timezoneRedirectionStatus: object expected"
                    );
                  e.timezoneRedirectionStatus = ra.dcv.main.TimezoneRedirectionStatus.fromObject(
                    A.timezoneRedirectionStatus
                  );
                }
                if (null != A.extensionsClientPermission) {
                  if ("object" != typeof A.extensionsClientPermission)
                    throw TypeError(
                      ".dcv.main.ServerMessage.extensionsClientPermission: object expected"
                    );
                  e.extensionsClientPermission = ra.dcv.main.ExtensionsClientPermission.fromObject(
                    A.extensionsClientPermission
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.channelNotification &&
                    A.hasOwnProperty("channelNotification") &&
                    ((t.channelNotification = ra.dcv.main.ChannelNotification.toObject(
                      A.channelNotification,
                      e
                    )),
                    e.oneofs && (t.msg = "channelNotification")),
                  null != A.resourceNotification &&
                    A.hasOwnProperty("resourceNotification") &&
                    ((t.resourceNotification = ra.dcv.main.ResourceNotification.toObject(
                      A.resourceNotification,
                      e
                    )),
                    e.oneofs && (t.msg = "resourceNotification")),
                  null != A.ping &&
                    A.hasOwnProperty("ping") &&
                    ((t.ping = ra.dcv.main.Ping.toObject(A.ping, e)), e.oneofs && (t.msg = "ping")),
                  null != A.pang &&
                    A.hasOwnProperty("pang") &&
                    ((t.pang = ra.dcv.main.Pang.toObject(A.pang, e)), e.oneofs && (t.msg = "pang")),
                  null != A.connectionClose &&
                    A.hasOwnProperty("connectionClose") &&
                    ((t.connectionClose = ra.dcv.main.ConnectionClose.toObject(
                      A.connectionClose,
                      e
                    )),
                    e.oneofs && (t.msg = "connectionClose")),
                  null != A.qualityIndicatorNotification &&
                    A.hasOwnProperty("qualityIndicatorNotification") &&
                    ((t.qualityIndicatorNotification =
                      ra.dcv.main.QualityIndicatorNotification.toObject(
                        A.qualityIndicatorNotification,
                        e
                      )),
                    e.oneofs && (t.msg = "qualityIndicatorNotification")),
                  null != A.licenseUpdatesNotification &&
                    A.hasOwnProperty("licenseUpdatesNotification") &&
                    ((t.licenseUpdatesNotification =
                      ra.dcv.main.LicenseUpdatesNotification.toObject(
                        A.licenseUpdatesNotification,
                        e
                      )),
                    e.oneofs && (t.msg = "licenseUpdatesNotification")),
                  null != A.idleWarningNotification &&
                    A.hasOwnProperty("idleWarningNotification") &&
                    ((t.idleWarningNotification = ra.dcv.main.IdleWarningNotification.toObject(
                      A.idleWarningNotification,
                      e
                    )),
                    e.oneofs && (t.msg = "idleWarningNotification")),
                  null != A.collaboratorList &&
                    A.hasOwnProperty("collaboratorList") &&
                    ((t.collaboratorList = ra.dcv.main.CollaboratorList.toObject(
                      A.collaboratorList,
                      e
                    )),
                    e.oneofs && (t.msg = "collaboratorList")),
                  null != A.timezoneRedirectionSetting &&
                    A.hasOwnProperty("timezoneRedirectionSetting") &&
                    ((t.timezoneRedirectionSetting =
                      ra.dcv.main.TimezoneRedirectionSetting.toObject(
                        A.timezoneRedirectionSetting,
                        e
                      )),
                    e.oneofs && (t.msg = "timezoneRedirectionSetting")),
                  null != A.timezoneRedirectionStatus &&
                    A.hasOwnProperty("timezoneRedirectionStatus") &&
                    ((t.timezoneRedirectionStatus = ra.dcv.main.TimezoneRedirectionStatus.toObject(
                      A.timezoneRedirectionStatus,
                      e
                    )),
                    e.oneofs && (t.msg = "timezoneRedirectionStatus")),
                  null != A.extensionsClientPermission &&
                    A.hasOwnProperty("extensionsClientPermission") &&
                    ((t.extensionsClientPermission =
                      ra.dcv.main.ExtensionsClientPermission.toObject(
                        A.extensionsClientPermission,
                        e
                      )),
                    e.oneofs && (t.msg = "extensionsClientPermission")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.main.ServerMessage";
              }),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  aa = "::",
  ga = "dcv",
  ca = {
    AUDIO: "audio",
    CLIPBOARD: "clipboard",
    DISPLAY: "display",
    INPUT: "input",
    FILESTORAGE: "filestorage",
    SMARTCARD: "smartcard",
    USB: "usb",
    REDIRECTION: "redirection"
  },
  Ia = {
    AUDIO: `${ga}${aa}${ca.AUDIO}`,
    CLIPBOARD: `${ga}${aa}${ca.CLIPBOARD}`,
    DISPLAY: `${ga}${aa}${ca.DISPLAY}`,
    INPUT: `${ga}${aa}${ca.INPUT}`,
    FILESTORAGE: `${ga}${aa}${ca.FILESTORAGE}`,
    SMARTCARD: `${ga}${aa}${ca.SMARTCARD}`,
    USB: `${ga}${aa}${ca.USB}`,
    REDIRECTION: `${ga}${aa}${ca.REDIRECTION}`
  },
  la = { WEBRTC_REDIRECTION: `com.amazon.dcv.web.redir${aa}webrtc-signaling` },
  da = "opus",
  ua = ["generic", "voice"],
  Ca = { ALWAYS_OFF: 0, ALWAYS_ON: 1, CLIENT_DECIDES: 2 },
  Ba = { SUCCESS: 0, PERMISSION_ERROR: 1, GENERIC_ERROR: 2 },
  Qa = { ONLINE: "online", WARNING: "warning", CRITICAL: "critical", DISCONNECTED: "disconnected" };
class Ea {
  constructor(A) {
    (this.log = Q("networkMonitor")),
      (this.onNetworkQualityChange = A),
      (this.networkOffline = ha.bind(this)),
      ma.call(this),
      this.log.info("Created Network Monitoring for connection");
  }
  dataReceived() {
    navigator.onLine &&
      (this.networkMonitorMachine.currentState !== Qa.ONLINE &&
        this.networkMonitorMachine.onEvent("data_received", this),
      pa.call(this));
  }
  channelClosed() {
    this.networkMonitorMachine.onEvent("channel_disconnected", this);
  }
  startMonitoring() {
    this.log.info("Started Network Monitoring."),
      window.addEventListener("offline", this.networkOffline),
      this.networkMonitorMachine.onEvent("channel_open", this);
  }
  handleTransition() {
    let A = this.networkMonitorMachine.currentState;
    if (A && A !== Qa.DISCONNECTED)
      if (Xn(this.onNetworkQualityChange)) {
        let e = { quality: Object.keys(Qa).find((e) => Qa[e] === A) };
        this.onNetworkQualityChange(e);
      } else this.log.info(`No network quality update callback. Network Quality: ${A}`);
    else fa.call(this);
  }
}
function ha() {
  this.log.info("Window detected offline."),
    this.networkMonitorMachine.onEvent("navigator_offline", this);
}
function pa() {
  clearTimeout(this.dataTimeoutId),
    (this.dataTimeoutId = setTimeout(
      () => {
        this.log.warn("Timeout reached while waiting for data on the channel."),
          this.networkMonitorMachine.onEvent("data_timedout", this);
      },
      8750,
      this
    ));
}
function fa() {
  this.log.info("Stopping network monitoring."),
    window.removeEventListener("offline", this.networkOffline);
}
function ma() {
  this.networkMonitorMachine = (function (A) {
    const e = {
      currentState: A.initState,
      onEvent(t, i) {
        const n = A[this.currentState].transitions[t];
        n
          ? ((e.currentState = n.state), n.action(i))
          : i && i.log && i.log.error("No transition available.");
      }
    };
    return e;
  })({
    initState: "disconnected",
    disconnected: {
      transitions: {
        channel_open: {
          state: "online",
          action(A) {
            A.handleTransition();
          }
        }
      }
    },
    online: {
      transitions: {
        data_timedout: {
          state: "warning",
          action(A) {
            A.handleTransition();
          }
        },
        navigator_offline: {
          state: "critical",
          action(A) {
            A.handleTransition();
          }
        },
        channel_disconnected: {
          state: "disconnected",
          action(A) {
            A.handleTransition();
          }
        }
      }
    },
    warning: {
      transitions: {
        data_received: {
          state: "online",
          action(A) {
            A.handleTransition();
          }
        },
        navigator_offline: {
          state: "critical",
          action(A) {
            A.handleTransition();
          }
        },
        channel_disconnected: {
          state: "disconnected",
          action(A) {
            A.handleTransition();
          }
        }
      }
    },
    critical: {
      transitions: {
        data_received: {
          state: "online",
          action(A) {
            A.handleTransition();
          }
        },
        channel_disconnected: {
          state: "disconnected",
          action(A) {
            A.handleTransition();
          }
        }
      }
    }
  });
}
const ya = { major: 1, minor: 7 },
  Da = sa.main,
  wa = (A) => Do(Da.ClientMessage, A);
class Fa extends zs {
  constructor(A, e, t, i) {
    super(A.url, A.sessionId, e, t, ya, i),
      (this.log = Q("mainchannel")),
      (this.timezoneRedirection = {
        enabled: Ca.ALWAYS_OFF,
        status: null,
        updateIntervalID: null,
        cachedTimezone: "",
        clientEnabled: !1
      }),
      (this.closingReason = { code: Io.ClosingReason.TRANSPORT_ERROR, message: "" }),
      (this.networkMonitor = new Ea(this.callbacks.onNetworkQualityChange));
  }
  run() {
    (this.log = Q("mainchannel", this.clientConnectionId)),
      this.transport.setConnectionId(this.clientConnectionId),
      (this.onMessageReceived = (A, e) => {
        this.networkMonitor.dataReceived();
        let t = ((A) => wo(Da.ServerMessage, A))(A);
        switch (t.msg) {
          case "channelNotification":
            ba.call(this, t);
            break;
          case "resourceNotification":
            Ua.call(this, t);
            break;
          case "connectionClose":
            Ka.call(this, t);
            break;
          case "ping":
            this.setPingTimeout(), Ta.call(this, t);
            break;
          case "pang":
            La.call(this, t);
            break;
          case "qualityIndicatorNotification":
            Pa.call(this, t);
            break;
          case "licenseUpdatesNotification":
            Sa.call(this, t);
            break;
          case "idleWarningNotification":
            va.call(this, t);
            break;
          case "collaboratorList":
            Ra.call(this, t);
            break;
          case "timezoneRedirectionSetting":
            Oa.call(this, t);
            break;
          case "timezoneRedirectionStatus":
            ka.call(this, t);
            break;
          default:
            this.log.warn(`Unexpected message:${JSON.stringify(t)}`);
        }
      });
  }
  onOpen() {
    this.log.info("Main Channel opened");
    const A = {
      sessionId: this.sessionId,
      authenticationToken: this.authToken,
      clientInfo: {
        name: `dcv web client/${navigator.userAgent}`,
        version: { major: h.major, minor: h.minor, revision: h.patch },
        os: window.navigator.platform,
        arch: "web"
      },
      maxProtocolVersion: this.maxClientProtocolVersion
    };
    this.extensionData && (A.extensionData = this.extensionData),
      this.networkMonitor.startMonitoring(),
      this.connect({ connectionRequest: A }, (A) => {
        let e;
        if ("connectionConfirm" !== A.msg)
          return this.log.error("Unexpected connection response"), null;
        (this.serverConnectionId = A.connectionConfirm.connectionId),
          (this.serverExtensionData = A.connectionConfirm.extensionData),
          this.log.debug(
            `Server extension data is${this.serverExtensionData ? " not " : " "}empty`
          ),
          (e = A.connectionConfirm.serverInfo),
          this.log.info(`Main channel established (connection id ${this.connectionId})`),
          this.log.info(
            `Server ${e.name} on ${e.hostname} (${e.version.major}.${e.version.minor}.${e.version.revision} ${e.os}, ${e.arch})`
          ),
          this.log.info(`Setup completed for main channel. ConnectionId: ${this.connectionId}`);
        const t = A.connectionConfirm.protocolVersion;
        if (
          to(t, { major: 1, minor: 3 }) &&
          (function (A, e) {
            return A.major < e.major || (A.major === e.major && A.minor <= e.minor);
          })(t, { major: 1, minor: 6 })
        ) {
          const A = new Intl.DateTimeFormat().resolvedOptions().timeZone;
          Ga.call(this, A);
        }
        return {
          serverConnectionId: this.serverConnectionId,
          protocolVersion: A.connectionConfirm.protocolVersion,
          serverInfo: e
        };
      });
  }
  onClose(A) {
    this.networkMonitor.channelClosed(),
      this.closingReason.code === Io.ClosingReason.TRANSPORT_ERROR && (this.closingReason = A),
      Ao(this.serverConnectionId)
        ? this.log.info(
            `Main channel was closed before the connection was fully established (no connection id available): ${this.closingReason.message}`
          )
        : this.log.info(
            `Main channel ${this.serverConnectionId} closed: ${this.closingReason.message}`
          ),
      Xn(this.callbacks.onMainChannelClose) &&
        this.callbacks.onMainChannelClose(this.closingReason),
      this.isTimezoneRedirectionEnabled() &&
        clearInterval(this.timezoneRedirection.updateIntervalID),
      clearTimeout(this.pingTimeoutId);
  }
  onError() {
    this.log.info(`Error on main channel (${this.serverConnectionId})`);
  }
  setPingTimeout() {
    clearTimeout(this.pingTimeoutId),
      (this.pingTimeoutId = setTimeout(
        (A) => {
          this.log.info(
            "Timeout reached while waiting for PING from server, closing the main channel"
          ),
            (A.pingTimeoutExpired = !0),
            A.close(!0);
        },
        35e3,
        this
      ));
  }
  pingTimeoutHasExpired() {
    return this.pingTimeoutExpired;
  }
  disconnectCollaborator(A) {
    to(this.protocolVersion, { major: 1, minor: 5 }) &&
      this.transport.sendMessage(wa({ disconnectCollaborator: { connectionId: A } }));
  }
  isTimezoneRedirectionAvailable() {
    return (
      to(this.protocolVersion, { major: 1, minor: 7 }) &&
      this.timezoneRedirection.enabled !== Ca.ALWAYS_OFF
    );
  }
  isTimezoneRedirectionEnabled() {
    return !Ao(this.timezoneRedirection.updateIntervalID);
  }
  enableTimezoneRedirection(A) {
    (this.timezoneRedirection.clientEnabled = A),
      A
        ? (Ma.call(this),
          (this.timezoneRedirection.updateIntervalID = setInterval(Ma.bind(this), 1e4)))
        : (clearInterval(this.timezoneRedirection.updateIntervalID),
          (this.timezoneRedirection.updateIntervalID = null),
          (this.timezoneRedirection.cachedTimezone = ""),
          Ga.call(this, ""));
  }
}
function ba(A) {
  for (let e = 0; e < A.channelNotification.channels.length; e++) {
    let t = A.channelNotification.channels[e],
      i = null;
    to(this.protocolVersion, { major: 1, minor: 6 }) && ((i = t.namespace), Ao(i))
      ? this.log.warn(`Namespace not specified for channel: ${t.name}`)
      : (this.log.info(`Received channel notification: ${i ? i + aa : ""}${t.name}`),
        Xn(this.callbacks.onChannelNotification) &&
          this.callbacks.onChannelNotification(i, t.name, t.authenticationToken));
  }
}
function Ua(A) {
  const e = A.resourceNotification;
  this.log.debug(`received resource notification: ${e.domain}(id: ${e.resourceId})`),
    Xn(this.callbacks.onResourceNotification) &&
      this.callbacks.onResourceNotification(
        this.serverConnectionId,
        e.domain,
        e.resourceId,
        e.authenticationToken
      );
}
function Sa(A) {
  let e,
    t,
    i,
    n,
    o,
    r = !1;
  if (Xn(this.callbacks.onLicenseNotification)) {
    (t = []), (n = 0);
    for (let o = 0; o < A.licenseUpdatesNotification.updates.length; o++) {
      switch (((e = A.licenseUpdatesNotification.updates[o]), e.status)) {
        case Da.LicenseUpdatesNotification.Status.LICENSED:
          i = "Licensed";
          break;
        case Da.LicenseUpdatesNotification.Status.UNLICENSED:
          (i = "Unlicensed"), n++;
          break;
        case Da.LicenseUpdatesNotification.Status.INVALID:
        default:
          (i = "Invalid"), n++;
      }
      0 !== e.type && (r = e.type & Da.LicenseUpdatesNotification.Type.DEMO),
        t.push({
          product: e.product,
          status: i,
          message: e.message,
          leftDays: e.leftDays,
          isDemo: r
        });
    }
    switch (A.licenseUpdatesNotification.licensingMode) {
      case Da.LicenseUpdatesNotification.LicensingMode.RLM_MODE:
        o = "rlm";
        break;
      case Da.LicenseUpdatesNotification.LicensingMode.DEMO_MODE:
        o = "demo";
        break;
      case Da.LicenseUpdatesNotification.LicensingMode.EC2_MODE:
        o = "ec2";
        break;
      case Da.LicenseUpdatesNotification.LicensingMode.NONE_MODE:
      default:
        o = "none";
    }
    this.callbacks.onLicenseNotification({
      licenses: t,
      numUnlicensed: n,
      licensingMode: o,
      documentationUrl: A.licenseUpdatesNotification.documentationUrl
    });
  }
}
function Ra(A) {
  const e = A.collaboratorList.collaboratorsInfo;
  Xn(this.callbacks.onCollaboratorListReceived) && this.callbacks.onCollaboratorListReceived(e);
}
function va(A) {
  Xn(this.callbacks.onIdleWarningNotification) &&
    this.callbacks.onIdleWarningNotification(A.idleWarningNotification.disconnectionTime);
}
function xa(A) {
  if (!A) return null;
  const e = Da.TimezoneRedirectionStatus.Status;
  switch (A) {
    case e.SUCCESS:
      return Ba.SUCCESS;
    case e.PERMISSION_ERROR:
      return Ba.PERMISSION_ERROR;
    case e.GENERIC_ERROR:
      return Ba.GENERIC_ERROR;
    default:
      return null;
  }
}
function Ma() {
  const A = new Intl.DateTimeFormat().resolvedOptions().timeZone;
  this.timezoneRedirection.cachedTimezone !== A &&
    ((this.timezoneRedirection.cachedTimezone = A), Ga.call(this, A));
}
function Oa(A) {
  this.log.info(
    `Server sent timezone redirection setting. Enabled = ${A.timezoneRedirectionSetting.enabled}`
  );
  let e,
    t = Ws(this.clientConnectionId),
    i = this.timezoneRedirection;
  (i.enabled = A.timezoneRedirectionSetting.enabled),
    (e = i.enabled),
    e === Ca.ALWAYS_ON || (e === Ca.CLIENT_DECIDES && this.clientEnabled)
      ? i.updateIntervalID ||
        (Ma.call(this), (i.updateIntervalID = setInterval(Ma.bind(this), 1e4)))
      : i.updateIntervalID &&
        (clearInterval(i.updateIntervalID),
        (i.updateIntervalID = null),
        (this.timezoneRedirection.cachedTimezone = ""),
        Ga.call(this, "")),
    t.update("timezone-redirection", {
      setting: e,
      status: xa(i.status),
      enabled: e !== Ca.ALWAYS_OFF
    });
}
function ka(A) {
  this.log.info(
    `Server sent timezone redirection status. Status = ${A.timezoneRedirectionStatus.status}`
  );
  const e = Ws(this.clientConnectionId),
    t = this.timezoneRedirection;
  t.status = A.timezoneRedirectionStatus.status;
  const i = t.enabled;
  e.update("timezone-redirection", {
    setting: i,
    status: xa(t.status),
    enabled: i !== Ca.ALWAYS_OFF
  });
}
const Na = {
  [Da.ConnectionClose.ClosingReason.NO_ERROR]: {
    code: Io.ClosingReason.NO_ERROR,
    message: "No error."
  },
  [Da.ConnectionClose.ClosingReason.GENERIC_ERROR]: {
    code: Io.ClosingReason.GENERIC_ERROR,
    message: "Generic error."
  },
  [Da.ConnectionClose.ClosingReason.INTERNAL_SERVER_ERROR]: {
    code: Io.ClosingReason.INTERNAL_SERVER_ERROR,
    message: "Internal server error."
  },
  [Da.ConnectionClose.ClosingReason.PROTOCOL_ERROR]: {
    code: Io.ClosingReason.PROTOCOL_ERROR,
    message: "Protocol error."
  },
  [Da.ConnectionClose.ClosingReason.AUTHORIZATION_DENIED]: {
    code: Io.ClosingReason.AUTHORIZATION_DENIED,
    message: "Authorization was denied."
  },
  [Da.ConnectionClose.ClosingReason.AUTHORIZATION_REVOKED]: {
    code: Io.ClosingReason.AUTHORIZATION_REVOKED,
    message: "Authorization was revoked."
  },
  [Da.ConnectionClose.ClosingReason.ACCESS_REJECTED]: {
    code: Io.ClosingReason.ACCESS_REJECTED,
    message: "Access was rejected by the owner."
  },
  [Da.ConnectionClose.ClosingReason.IDLE_TIMEOUT_EXPIRED]: {
    code: Io.ClosingReason.IDLE_TIMEOUT_EXPIRED,
    message: "The connection has been marked as idle."
  },
  [Da.ConnectionClose.ClosingReason.EVICTED]: {
    code: Io.ClosingReason.EVICTED,
    message: "The connection has been evicted."
  },
  [Da.ConnectionClose.ClosingReason.EXTERNAL_PROTOCOL_CONNECTION_EVICTED]: {
    code: Io.ClosingReason.EXTERNAL_PROTOCOL_CONNECTION_EVICTED,
    message: "The external protocol connection has been evicted."
  },
  [Da.ConnectionClose.ClosingReason.DISCONNECT_BY_OWNER]: {
    code: Io.ClosingReason.DISCONNECT_BY_OWNER,
    message: "Connection was disconnected by the session owner."
  },
  [Da.ConnectionClose.ClosingReason.DISCONNECT_BY_USER]: {
    code: Io.ClosingReason.DISCONNECT_BY_USER,
    message: "Connection was disconnected by the user from another client."
  }
};
function Ka(A) {
  this.log.info(`Received close message from server with reason ${A.connectionClose.reason}`),
    A.connectionClose.reason in Na
      ? (this.closingReason = Na[A.connectionClose.reason])
      : (this.closingReason = {
          code: Io.ClosingReason.GENERIC_ERROR,
          message: `unknown (${A.connectionClose.reason})`
        }),
    this.close();
}
function La(A) {
  const e = { sendtime: A.pang.pongTimestamp, recvtime: Date.now() };
  Vs(this.clientConnectionId).addLatencySample(e);
}
function Ta(A) {
  this.transport.sendMessage(
    wa({ pong: { pingTimestamp: A.ping.pingTimestamp, pongTimestamp: Date.now() } })
  );
}
function Pa(A) {
  const e = A.qualityIndicatorNotification;
  this.log.debug(`quality indicator: ${C(e)}`),
    Xn(this.callbacks.onQualityIndicatorNotification) &&
      this.callbacks.onQualityIndicatorNotification(e);
}
function Ga(A) {
  this.log.debug(`Timezone of client: ${A}`),
    this.transport.sendMessage(wa({ clientInformation: { ianaTimezoneCode: A } }));
}
const Ha = vo.setup;
class Ya {
  constructor(A, e) {
    (this.namespace = A), (this.name = e);
  }
  toString() {
    return `${Ao(this.namespace) ? "" : this.namespace + aa}${this.name}`;
  }
  getNamespace() {
    return this.namespace;
  }
  getName() {
    return this.name;
  }
}
class qa extends zs {
  constructor(A, e, t, i, n, o, r, s) {
    super(A.url, A.sessionId, n, o, r, s),
      (this.channelName = i),
      (this.clientConnectionId = e),
      (this.serverConnectionId = t),
      (this.log = Q(this.channelName, e)),
      this.log.info(`Opening data channel ${this.channelName}`),
      this.transport.setConnectionId(this.clientConnectionId);
  }
  onOpen() {
    this.log.info(`Data channel ${this.channelName} opened`);
    const A = {
      sessionId: this.sessionId,
      connectionId: this.serverConnectionId,
      authenticationToken: this.authToken,
      channelName: this.channelName.getName(),
      maxProtocolVersion: this.maxClientProtocolVersion,
      requestedEncryptionMode: Ha.ChannelConnectionRequest.EncryptionMode.ALWAYS_ON
    };
    this.channelName.getNamespace() && (A.channelNamespace = this.channelName.getNamespace()),
      this.extensionData && (A.extensionData = this.extensionData),
      this.connect({ channelConnectionRequest: A }, (A) =>
        "channelConnectionConfirm" !== A.msg
          ? (this.log.error("Unexpected connection response"), null)
          : ((this.channelConnectionId = A.channelConnectionConfirm.channelConnectionId),
            this.log.info(
              `Setup completed for channel ${this.channelName}. ConnectionId: ${this.clientConnectionId}. ServerConnectionId: ${this.serverConnectionId}. ChannelConnectionId: ${this.channelConnectionId}`
            ),
            {
              channelConnectionId: this.channelConnectionId,
              protocolVersion: A.channelConnectionConfirm.protocolVersion
            })
      );
  }
  onClose(A) {
    this.log.info(
      `Data channel ${this.channelName} (${this.clientConnectionId}) closed (${A.message})`
    ),
      js(this.clientConnectionId).removeDataChannel(this.channelName, this);
  }
  onError() {
    this.log.error(`Error on data channel ${this.channelName} (${this.clientConnectionId})`);
  }
  setRequestedSettings(A) {}
}
const Ja = { major: 1, minor: 0 };
class ja extends qa {
  constructor(A, e, t, i, n, o, r) {
    super(A, e, t, i, n, o, Ja, r), (this.log = Q("customchannel", e));
  }
  run() {
    this.log.info("Starting custom protocol"),
      (this.onMessageReceived = (A, e) => {
        this.callbacks.onMessageReceived.call(this, e);
      });
  }
  onClose(A) {
    this.log.info(`Custom channel ${this.channelName} closed (${JSON.stringify(A)})`),
      js(this.clientConnectionId).removeCustomChannel(this.channelName, this);
  }
  onError() {
    this.log.error(`Error on custom channel ${this.channelName}`);
  }
  sendMessage(A) {
    const e = this;
    return new Promise((t, i) => {
      try {
        e.transport.trySendMessage(null, A), t();
      } catch (A) {
        this.log.error(`Error sending custom channel message: ${A.message}`),
          i({ code: Io.CustomChannel.TRANSPORT_ERROR, message: A.message });
      }
    });
  }
}
const Wa = Fo.exports.Reader,
  Va = Fo.exports.Writer,
  _a = Fo.exports.util,
  Xa = Fo.exports.roots["dcv.input"] || (Fo.exports.roots["dcv.input"] = {}),
  za = (Xa.dcv = (() => {
    const A = {};
    return (
      (A.input = (function () {
        const A = {};
        return (
          (A.CursorImagePixelFormat = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "NONE")] = 0), (e[(A[1] = "RAW_ARGB_DATA")] = 1), e;
          })()),
          (A.Capabilities = (function () {
            function A(A) {
              if (
                ((this.supportedPointerModes = []), (this.supportedCursorImagePixelFormats = []), A)
              )
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.supportedPointerModes = _a.emptyArray),
              (A.prototype.supportedCursorImagePixelFormats = _a.emptyArray),
              (A.prototype.supportUnreliable = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.supportedPointerModes && A.supportedPointerModes.length)
                ) {
                  e.uint32(10).fork();
                  for (let t = 0; t < A.supportedPointerModes.length; ++t)
                    e.int32(A.supportedPointerModes[t]);
                  e.ldelim();
                }
                if (
                  null != A.supportedCursorImagePixelFormats &&
                  A.supportedCursorImagePixelFormats.length
                ) {
                  e.uint32(82).fork();
                  for (let t = 0; t < A.supportedCursorImagePixelFormats.length; ++t)
                    e.int32(A.supportedCursorImagePixelFormats[t]);
                  e.ldelim();
                }
                return (
                  null != A.supportUnreliable &&
                    Object.hasOwnProperty.call(A, "supportUnreliable") &&
                    e.uint32(160).bool(A.supportUnreliable),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.Capabilities();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      if (
                        ((i.supportedPointerModes && i.supportedPointerModes.length) ||
                          (i.supportedPointerModes = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.supportedPointerModes.push(A.int32());
                      } else i.supportedPointerModes.push(A.int32());
                      break;
                    case 10:
                      if (
                        ((i.supportedCursorImagePixelFormats &&
                          i.supportedCursorImagePixelFormats.length) ||
                          (i.supportedCursorImagePixelFormats = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.supportedCursorImagePixelFormats.push(A.int32());
                      } else i.supportedCursorImagePixelFormats.push(A.int32());
                      break;
                    case 20:
                      i.supportUnreliable = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.supportedPointerModes && A.hasOwnProperty("supportedPointerModes")) {
                  if (!Array.isArray(A.supportedPointerModes))
                    return "supportedPointerModes: array expected";
                  for (let e = 0; e < A.supportedPointerModes.length; ++e)
                    switch (A.supportedPointerModes[e]) {
                      default:
                        return "supportedPointerModes: enum value[] expected";
                      case 0:
                      case 1:
                    }
                }
                if (
                  null != A.supportedCursorImagePixelFormats &&
                  A.hasOwnProperty("supportedCursorImagePixelFormats")
                ) {
                  if (!Array.isArray(A.supportedCursorImagePixelFormats))
                    return "supportedCursorImagePixelFormats: array expected";
                  for (let e = 0; e < A.supportedCursorImagePixelFormats.length; ++e)
                    switch (A.supportedCursorImagePixelFormats[e]) {
                      default:
                        return "supportedCursorImagePixelFormats: enum value[] expected";
                      case 0:
                      case 1:
                    }
                }
                return null != A.supportUnreliable &&
                  A.hasOwnProperty("supportUnreliable") &&
                  "boolean" != typeof A.supportUnreliable
                  ? "supportUnreliable: boolean expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.Capabilities) return A;
                let e = new Xa.dcv.input.Capabilities();
                if (A.supportedPointerModes) {
                  if (!Array.isArray(A.supportedPointerModes))
                    throw TypeError(
                      ".dcv.input.Capabilities.supportedPointerModes: array expected"
                    );
                  e.supportedPointerModes = [];
                  for (let t = 0; t < A.supportedPointerModes.length; ++t)
                    switch (A.supportedPointerModes[t]) {
                      default:
                        if ("number" == typeof A.supportedPointerModes[t]) {
                          e.supportedPointerModes[t] = A.supportedPointerModes[t];
                          break;
                        }
                      case "CLIENT":
                      case 0:
                        e.supportedPointerModes[t] = 0;
                        break;
                      case "SERVER":
                      case 1:
                        e.supportedPointerModes[t] = 1;
                    }
                }
                if (A.supportedCursorImagePixelFormats) {
                  if (!Array.isArray(A.supportedCursorImagePixelFormats))
                    throw TypeError(
                      ".dcv.input.Capabilities.supportedCursorImagePixelFormats: array expected"
                    );
                  e.supportedCursorImagePixelFormats = [];
                  for (let t = 0; t < A.supportedCursorImagePixelFormats.length; ++t)
                    switch (A.supportedCursorImagePixelFormats[t]) {
                      default:
                        if ("number" == typeof A.supportedCursorImagePixelFormats[t]) {
                          e.supportedCursorImagePixelFormats[t] =
                            A.supportedCursorImagePixelFormats[t];
                          break;
                        }
                      case "NONE":
                      case 0:
                        e.supportedCursorImagePixelFormats[t] = 0;
                        break;
                      case "RAW_ARGB_DATA":
                      case 1:
                        e.supportedCursorImagePixelFormats[t] = 1;
                    }
                }
                return (
                  null != A.supportUnreliable &&
                    (e.supportUnreliable = Boolean(A.supportUnreliable)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) &&
                    ((t.supportedPointerModes = []), (t.supportedCursorImagePixelFormats = [])),
                  e.defaults && (t.supportUnreliable = !1),
                  A.supportedPointerModes && A.supportedPointerModes.length)
                ) {
                  t.supportedPointerModes = [];
                  for (let i = 0; i < A.supportedPointerModes.length; ++i)
                    t.supportedPointerModes[i] =
                      e.enums === String
                        ? void 0 ===
                          Xa.dcv.input.Capabilities.PointerMode[A.supportedPointerModes[i]]
                          ? A.supportedPointerModes[i]
                          : Xa.dcv.input.Capabilities.PointerMode[A.supportedPointerModes[i]]
                        : A.supportedPointerModes[i];
                }
                if (
                  A.supportedCursorImagePixelFormats &&
                  A.supportedCursorImagePixelFormats.length
                ) {
                  t.supportedCursorImagePixelFormats = [];
                  for (let i = 0; i < A.supportedCursorImagePixelFormats.length; ++i)
                    t.supportedCursorImagePixelFormats[i] =
                      e.enums === String
                        ? void 0 ===
                          Xa.dcv.input.CursorImagePixelFormat[A.supportedCursorImagePixelFormats[i]]
                          ? A.supportedCursorImagePixelFormats[i]
                          : Xa.dcv.input.CursorImagePixelFormat[
                              A.supportedCursorImagePixelFormats[i]
                            ]
                        : A.supportedCursorImagePixelFormats[i];
                }
                return (
                  null != A.supportUnreliable &&
                    A.hasOwnProperty("supportUnreliable") &&
                    (t.supportUnreliable = A.supportUnreliable),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.Capabilities";
              }),
              (A.PointerMode = (function () {
                const A = {},
                  e = Object.create(A);
                return (e[(A[0] = "CLIENT")] = 0), (e[(A[1] = "SERVER")] = 1), e;
              })()),
              A
            );
          })()),
          (A.PointerMotionAck = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.sequenceNum = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.sequenceNum &&
                    Object.hasOwnProperty.call(A, "sequenceNum") &&
                    e.uint32(8).uint64(A.sequenceNum),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerMotionAck();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.sequenceNum = A.uint64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.sequenceNum &&
                      A.hasOwnProperty("sequenceNum") &&
                      !(
                        _a.isInteger(A.sequenceNum) ||
                        (A.sequenceNum &&
                          _a.isInteger(A.sequenceNum.low) &&
                          _a.isInteger(A.sequenceNum.high))
                      )
                    ? "sequenceNum: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerMotionAck) return A;
                let e = new Xa.dcv.input.PointerMotionAck();
                return (
                  null != A.sequenceNum &&
                    (_a.Long
                      ? ((e.sequenceNum = _a.Long.fromValue(A.sequenceNum)).unsigned = !0)
                      : "string" == typeof A.sequenceNum
                        ? (e.sequenceNum = parseInt(A.sequenceNum, 10))
                        : "number" == typeof A.sequenceNum
                          ? (e.sequenceNum = A.sequenceNum)
                          : "object" == typeof A.sequenceNum &&
                            (e.sequenceNum = new _a.LongBits(
                              A.sequenceNum.low >>> 0,
                              A.sequenceNum.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (_a.Long) {
                    let A = new _a.Long(0, 0, !0);
                    t.sequenceNum =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.sequenceNum = e.longs === String ? "0" : 0;
                return (
                  null != A.sequenceNum &&
                    A.hasOwnProperty("sequenceNum") &&
                    ("number" == typeof A.sequenceNum
                      ? (t.sequenceNum = e.longs === String ? String(A.sequenceNum) : A.sequenceNum)
                      : (t.sequenceNum =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.sequenceNum)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.sequenceNum.low >>> 0,
                                  A.sequenceNum.high >>> 0
                                ).toNumber(!0)
                              : A.sequenceNum)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.PointerMotionAck"
                );
              }),
              A
            );
          })()),
          (A.PointerPosition = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(8).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(16).uint32(A.y),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerPosition();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.x = A.uint32();
                      break;
                    case 2:
                      i.y = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.x && A.hasOwnProperty("x") && !_a.isInteger(A.x)
                    ? "x: integer expected"
                    : null != A.y && A.hasOwnProperty("y") && !_a.isInteger(A.y)
                      ? "y: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerPosition) return A;
                let e = new Xa.dcv.input.PointerPosition();
                return null != A.x && (e.x = A.x >>> 0), null != A.y && (e.y = A.y >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.x = 0), (t.y = 0)),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.PointerPosition"
                );
              }),
              A
            );
          })()),
          (A.PointerCursors = (function () {
            function A(A) {
              if (((this.cursorImages = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.currentCursorId = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.hidden = !1),
              (A.prototype.cursorImages = _a.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.currentCursorId &&
                    Object.hasOwnProperty.call(A, "currentCursorId") &&
                    e.uint32(8).uint64(A.currentCursorId),
                  null != A.hidden &&
                    Object.hasOwnProperty.call(A, "hidden") &&
                    e.uint32(16).bool(A.hidden),
                  null != A.cursorImages && A.cursorImages.length)
                )
                  for (let t = 0; t < A.cursorImages.length; ++t)
                    Xa.dcv.input.PointerCursors.CursorImage.encode(
                      A.cursorImages[t],
                      e.uint32(82).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerCursors();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.currentCursorId = A.uint64();
                      break;
                    case 2:
                      i.hidden = A.bool();
                      break;
                    case 10:
                      (i.cursorImages && i.cursorImages.length) || (i.cursorImages = []),
                        i.cursorImages.push(
                          Xa.dcv.input.PointerCursors.CursorImage.decode(A, A.uint32())
                        );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.currentCursorId &&
                  A.hasOwnProperty("currentCursorId") &&
                  !(
                    _a.isInteger(A.currentCursorId) ||
                    (A.currentCursorId &&
                      _a.isInteger(A.currentCursorId.low) &&
                      _a.isInteger(A.currentCursorId.high))
                  )
                )
                  return "currentCursorId: integer|Long expected";
                if (null != A.hidden && A.hasOwnProperty("hidden") && "boolean" != typeof A.hidden)
                  return "hidden: boolean expected";
                if (null != A.cursorImages && A.hasOwnProperty("cursorImages")) {
                  if (!Array.isArray(A.cursorImages)) return "cursorImages: array expected";
                  for (let e = 0; e < A.cursorImages.length; ++e) {
                    let t = Xa.dcv.input.PointerCursors.CursorImage.verify(A.cursorImages[e]);
                    if (t) return "cursorImages." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerCursors) return A;
                let e = new Xa.dcv.input.PointerCursors();
                if (
                  (null != A.currentCursorId &&
                    (_a.Long
                      ? ((e.currentCursorId = _a.Long.fromValue(A.currentCursorId)).unsigned = !0)
                      : "string" == typeof A.currentCursorId
                        ? (e.currentCursorId = parseInt(A.currentCursorId, 10))
                        : "number" == typeof A.currentCursorId
                          ? (e.currentCursorId = A.currentCursorId)
                          : "object" == typeof A.currentCursorId &&
                            (e.currentCursorId = new _a.LongBits(
                              A.currentCursorId.low >>> 0,
                              A.currentCursorId.high >>> 0
                            ).toNumber(!0))),
                  null != A.hidden && (e.hidden = Boolean(A.hidden)),
                  A.cursorImages)
                ) {
                  if (!Array.isArray(A.cursorImages))
                    throw TypeError(".dcv.input.PointerCursors.cursorImages: array expected");
                  e.cursorImages = [];
                  for (let t = 0; t < A.cursorImages.length; ++t) {
                    if ("object" != typeof A.cursorImages[t])
                      throw TypeError(".dcv.input.PointerCursors.cursorImages: object expected");
                    e.cursorImages[t] = Xa.dcv.input.PointerCursors.CursorImage.fromObject(
                      A.cursorImages[t]
                    );
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.cursorImages = []), e.defaults)) {
                  if (_a.Long) {
                    let A = new _a.Long(0, 0, !0);
                    t.currentCursorId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.currentCursorId = e.longs === String ? "0" : 0;
                  t.hidden = !1;
                }
                if (
                  (null != A.currentCursorId &&
                    A.hasOwnProperty("currentCursorId") &&
                    ("number" == typeof A.currentCursorId
                      ? (t.currentCursorId =
                          e.longs === String ? String(A.currentCursorId) : A.currentCursorId)
                      : (t.currentCursorId =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.currentCursorId)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.currentCursorId.low >>> 0,
                                  A.currentCursorId.high >>> 0
                                ).toNumber(!0)
                              : A.currentCursorId)),
                  null != A.hidden && A.hasOwnProperty("hidden") && (t.hidden = A.hidden),
                  A.cursorImages && A.cursorImages.length)
                ) {
                  t.cursorImages = [];
                  for (let i = 0; i < A.cursorImages.length; ++i)
                    t.cursorImages[i] = Xa.dcv.input.PointerCursors.CursorImage.toObject(
                      A.cursorImages[i],
                      e
                    );
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.PointerCursors";
              }),
              (A.CursorImage = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.id = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.width = 0),
                  (A.prototype.height = 0),
                  (A.prototype.hotspotX = 0),
                  (A.prototype.hotspotY = 0),
                  (A.prototype.pixelFormat = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Va.create()),
                      null != A.id &&
                        Object.hasOwnProperty.call(A, "id") &&
                        e.uint32(8).uint64(A.id),
                      null != A.width &&
                        Object.hasOwnProperty.call(A, "width") &&
                        e.uint32(80).uint32(A.width),
                      null != A.height &&
                        Object.hasOwnProperty.call(A, "height") &&
                        e.uint32(88).uint32(A.height),
                      null != A.hotspotX &&
                        Object.hasOwnProperty.call(A, "hotspotX") &&
                        e.uint32(160).uint32(A.hotspotX),
                      null != A.hotspotY &&
                        Object.hasOwnProperty.call(A, "hotspotY") &&
                        e.uint32(168).uint32(A.hotspotY),
                      null != A.pixelFormat &&
                        Object.hasOwnProperty.call(A, "pixelFormat") &&
                        e.uint32(240).int32(A.pixelFormat),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Wa || (A = Wa.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Xa.dcv.input.PointerCursors.CursorImage();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.id = A.uint64();
                          break;
                        case 10:
                          i.width = A.uint32();
                          break;
                        case 11:
                          i.height = A.uint32();
                          break;
                        case 20:
                          i.hotspotX = A.uint32();
                          break;
                        case 21:
                          i.hotspotY = A.uint32();
                          break;
                        case 30:
                          i.pixelFormat = A.int32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (
                      null != A.id &&
                      A.hasOwnProperty("id") &&
                      !(
                        _a.isInteger(A.id) ||
                        (A.id && _a.isInteger(A.id.low) && _a.isInteger(A.id.high))
                      )
                    )
                      return "id: integer|Long expected";
                    if (null != A.width && A.hasOwnProperty("width") && !_a.isInteger(A.width))
                      return "width: integer expected";
                    if (null != A.height && A.hasOwnProperty("height") && !_a.isInteger(A.height))
                      return "height: integer expected";
                    if (
                      null != A.hotspotX &&
                      A.hasOwnProperty("hotspotX") &&
                      !_a.isInteger(A.hotspotX)
                    )
                      return "hotspotX: integer expected";
                    if (
                      null != A.hotspotY &&
                      A.hasOwnProperty("hotspotY") &&
                      !_a.isInteger(A.hotspotY)
                    )
                      return "hotspotY: integer expected";
                    if (null != A.pixelFormat && A.hasOwnProperty("pixelFormat"))
                      switch (A.pixelFormat) {
                        default:
                          return "pixelFormat: enum value expected";
                        case 0:
                        case 1:
                      }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Xa.dcv.input.PointerCursors.CursorImage) return A;
                    let e = new Xa.dcv.input.PointerCursors.CursorImage();
                    switch (
                      (null != A.id &&
                        (_a.Long
                          ? ((e.id = _a.Long.fromValue(A.id)).unsigned = !0)
                          : "string" == typeof A.id
                            ? (e.id = parseInt(A.id, 10))
                            : "number" == typeof A.id
                              ? (e.id = A.id)
                              : "object" == typeof A.id &&
                                (e.id = new _a.LongBits(A.id.low >>> 0, A.id.high >>> 0).toNumber(
                                  !0
                                ))),
                      null != A.width && (e.width = A.width >>> 0),
                      null != A.height && (e.height = A.height >>> 0),
                      null != A.hotspotX && (e.hotspotX = A.hotspotX >>> 0),
                      null != A.hotspotY && (e.hotspotY = A.hotspotY >>> 0),
                      A.pixelFormat)
                    ) {
                      default:
                        if ("number" == typeof A.pixelFormat) {
                          e.pixelFormat = A.pixelFormat;
                          break;
                        }
                        break;
                      case "NONE":
                      case 0:
                        e.pixelFormat = 0;
                        break;
                      case "RAW_ARGB_DATA":
                      case 1:
                        e.pixelFormat = 1;
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults) {
                      if (_a.Long) {
                        let A = new _a.Long(0, 0, !0);
                        t.id =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.id = e.longs === String ? "0" : 0;
                      (t.width = 0),
                        (t.height = 0),
                        (t.hotspotX = 0),
                        (t.hotspotY = 0),
                        (t.pixelFormat = e.enums === String ? "NONE" : 0);
                    }
                    return (
                      null != A.id &&
                        A.hasOwnProperty("id") &&
                        ("number" == typeof A.id
                          ? (t.id = e.longs === String ? String(A.id) : A.id)
                          : (t.id =
                              e.longs === String
                                ? _a.Long.prototype.toString.call(A.id)
                                : e.longs === Number
                                  ? new _a.LongBits(A.id.low >>> 0, A.id.high >>> 0).toNumber(!0)
                                  : A.id)),
                      null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                      null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                      null != A.hotspotX &&
                        A.hasOwnProperty("hotspotX") &&
                        (t.hotspotX = A.hotspotX),
                      null != A.hotspotY &&
                        A.hasOwnProperty("hotspotY") &&
                        (t.hotspotY = A.hotspotY),
                      null != A.pixelFormat &&
                        A.hasOwnProperty("pixelFormat") &&
                        (t.pixelFormat =
                          e.enums === String
                            ? void 0 === Xa.dcv.input.CursorImagePixelFormat[A.pixelFormat]
                              ? A.pixelFormat
                              : Xa.dcv.input.CursorImagePixelFormat[A.pixelFormat]
                            : A.pixelFormat),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.input.PointerCursors.CursorImage"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.PointerInvalidateCursors = (function () {
            function A(A) {
              if (((this.ids = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.ids = _a.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Va.create()), null != A.ids && A.ids.length)) {
                  e.uint32(10).fork();
                  for (let t = 0; t < A.ids.length; ++t) e.uint64(A.ids[t]);
                  e.ldelim();
                }
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerInvalidateCursors();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    if (((i.ids && i.ids.length) || (i.ids = []), 2 == (7 & e))) {
                      let e = A.uint32() + A.pos;
                      for (; A.pos < e; ) i.ids.push(A.uint64());
                    } else i.ids.push(A.uint64());
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.ids && A.hasOwnProperty("ids")) {
                  if (!Array.isArray(A.ids)) return "ids: array expected";
                  for (let e = 0; e < A.ids.length; ++e)
                    if (
                      !(
                        _a.isInteger(A.ids[e]) ||
                        (A.ids[e] && _a.isInteger(A.ids[e].low) && _a.isInteger(A.ids[e].high))
                      )
                    )
                      return "ids: integer|Long[] expected";
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerInvalidateCursors) return A;
                let e = new Xa.dcv.input.PointerInvalidateCursors();
                if (A.ids) {
                  if (!Array.isArray(A.ids))
                    throw TypeError(".dcv.input.PointerInvalidateCursors.ids: array expected");
                  e.ids = [];
                  for (let t = 0; t < A.ids.length; ++t)
                    _a.Long
                      ? ((e.ids[t] = _a.Long.fromValue(A.ids[t])).unsigned = !0)
                      : "string" == typeof A.ids[t]
                        ? (e.ids[t] = parseInt(A.ids[t], 10))
                        : "number" == typeof A.ids[t]
                          ? (e.ids[t] = A.ids[t])
                          : "object" == typeof A.ids[t] &&
                            (e.ids[t] = new _a.LongBits(
                              A.ids[t].low >>> 0,
                              A.ids[t].high >>> 0
                            ).toNumber(!0));
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.ids = []), A.ids && A.ids.length)) {
                  t.ids = [];
                  for (let i = 0; i < A.ids.length; ++i)
                    "number" == typeof A.ids[i]
                      ? (t.ids[i] = e.longs === String ? String(A.ids[i]) : A.ids[i])
                      : (t.ids[i] =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.ids[i])
                            : e.longs === Number
                              ? new _a.LongBits(A.ids[i].low >>> 0, A.ids[i].high >>> 0).toNumber(
                                  !0
                                )
                              : A.ids[i]);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.PointerInvalidateCursors"
                );
              }),
              A
            );
          })()),
          (A.PointerInvalidateCursorCache = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return e || (e = Va.create()), e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerInvalidateCursorCache();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A ? "object expected" : null;
              }),
              (A.fromObject = function (A) {
                return A instanceof Xa.dcv.input.PointerInvalidateCursorCache
                  ? A
                  : new Xa.dcv.input.PointerInvalidateCursorCache();
              }),
              (A.toObject = function () {
                return {};
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.PointerInvalidateCursorCache"
                );
              }),
              A
            );
          })()),
          (A.StylusButtonsMapping = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "WIN32")] = 0), (e[(A[1] = "RAW")] = 1), e;
          })()),
          (A.Preferences = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.preferredCursorImagePixelFormat = 0),
              (A.prototype.preferredStylusButtonsMapping = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.preferredCursorImagePixelFormat &&
                    Object.hasOwnProperty.call(A, "preferredCursorImagePixelFormat") &&
                    e.uint32(8).int32(A.preferredCursorImagePixelFormat),
                  null != A.preferredStylusButtonsMapping &&
                    Object.hasOwnProperty.call(A, "preferredStylusButtonsMapping") &&
                    e.uint32(80).int32(A.preferredStylusButtonsMapping),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.Preferences();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.preferredCursorImagePixelFormat = A.int32();
                      break;
                    case 10:
                      i.preferredStylusButtonsMapping = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.preferredCursorImagePixelFormat &&
                  A.hasOwnProperty("preferredCursorImagePixelFormat")
                )
                  switch (A.preferredCursorImagePixelFormat) {
                    default:
                      return "preferredCursorImagePixelFormat: enum value expected";
                    case 0:
                    case 1:
                  }
                if (
                  null != A.preferredStylusButtonsMapping &&
                  A.hasOwnProperty("preferredStylusButtonsMapping")
                )
                  switch (A.preferredStylusButtonsMapping) {
                    default:
                      return "preferredStylusButtonsMapping: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.Preferences) return A;
                let e = new Xa.dcv.input.Preferences();
                switch (A.preferredCursorImagePixelFormat) {
                  default:
                    if ("number" == typeof A.preferredCursorImagePixelFormat) {
                      e.preferredCursorImagePixelFormat = A.preferredCursorImagePixelFormat;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.preferredCursorImagePixelFormat = 0;
                    break;
                  case "RAW_ARGB_DATA":
                  case 1:
                    e.preferredCursorImagePixelFormat = 1;
                }
                switch (A.preferredStylusButtonsMapping) {
                  default:
                    if ("number" == typeof A.preferredStylusButtonsMapping) {
                      e.preferredStylusButtonsMapping = A.preferredStylusButtonsMapping;
                      break;
                    }
                    break;
                  case "WIN32":
                  case 0:
                    e.preferredStylusButtonsMapping = 0;
                    break;
                  case "RAW":
                  case 1:
                    e.preferredStylusButtonsMapping = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.preferredCursorImagePixelFormat = e.enums === String ? "NONE" : 0),
                    (t.preferredStylusButtonsMapping = e.enums === String ? "WIN32" : 0)),
                  null != A.preferredCursorImagePixelFormat &&
                    A.hasOwnProperty("preferredCursorImagePixelFormat") &&
                    (t.preferredCursorImagePixelFormat =
                      e.enums === String
                        ? void 0 ===
                          Xa.dcv.input.CursorImagePixelFormat[A.preferredCursorImagePixelFormat]
                          ? A.preferredCursorImagePixelFormat
                          : Xa.dcv.input.CursorImagePixelFormat[A.preferredCursorImagePixelFormat]
                        : A.preferredCursorImagePixelFormat),
                  null != A.preferredStylusButtonsMapping &&
                    A.hasOwnProperty("preferredStylusButtonsMapping") &&
                    (t.preferredStylusButtonsMapping =
                      e.enums === String
                        ? void 0 ===
                          Xa.dcv.input.StylusButtonsMapping[A.preferredStylusButtonsMapping]
                          ? A.preferredStylusButtonsMapping
                          : Xa.dcv.input.StylusButtonsMapping[A.preferredStylusButtonsMapping]
                        : A.preferredStylusButtonsMapping),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.Preferences";
              }),
              A
            );
          })()),
          (A.PointerMotionEvent = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.requestAck = !1),
              (A.prototype.sequenceNum = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.lastButtonSequenceNum = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(8).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(16).uint32(A.y),
                  null != A.requestAck &&
                    Object.hasOwnProperty.call(A, "requestAck") &&
                    e.uint32(80).bool(A.requestAck),
                  null != A.sequenceNum &&
                    Object.hasOwnProperty.call(A, "sequenceNum") &&
                    e.uint32(160).uint64(A.sequenceNum),
                  null != A.lastButtonSequenceNum &&
                    Object.hasOwnProperty.call(A, "lastButtonSequenceNum") &&
                    e.uint32(240).uint64(A.lastButtonSequenceNum),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerMotionEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.x = A.uint32();
                      break;
                    case 2:
                      i.y = A.uint32();
                      break;
                    case 10:
                      i.requestAck = A.bool();
                      break;
                    case 20:
                      i.sequenceNum = A.uint64();
                      break;
                    case 30:
                      i.lastButtonSequenceNum = A.uint64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.x && A.hasOwnProperty("x") && !_a.isInteger(A.x)
                    ? "x: integer expected"
                    : null != A.y && A.hasOwnProperty("y") && !_a.isInteger(A.y)
                      ? "y: integer expected"
                      : null != A.requestAck &&
                          A.hasOwnProperty("requestAck") &&
                          "boolean" != typeof A.requestAck
                        ? "requestAck: boolean expected"
                        : null != A.sequenceNum &&
                            A.hasOwnProperty("sequenceNum") &&
                            !(
                              _a.isInteger(A.sequenceNum) ||
                              (A.sequenceNum &&
                                _a.isInteger(A.sequenceNum.low) &&
                                _a.isInteger(A.sequenceNum.high))
                            )
                          ? "sequenceNum: integer|Long expected"
                          : null != A.lastButtonSequenceNum &&
                              A.hasOwnProperty("lastButtonSequenceNum") &&
                              !(
                                _a.isInteger(A.lastButtonSequenceNum) ||
                                (A.lastButtonSequenceNum &&
                                  _a.isInteger(A.lastButtonSequenceNum.low) &&
                                  _a.isInteger(A.lastButtonSequenceNum.high))
                              )
                            ? "lastButtonSequenceNum: integer|Long expected"
                            : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerMotionEvent) return A;
                let e = new Xa.dcv.input.PointerMotionEvent();
                return (
                  null != A.x && (e.x = A.x >>> 0),
                  null != A.y && (e.y = A.y >>> 0),
                  null != A.requestAck && (e.requestAck = Boolean(A.requestAck)),
                  null != A.sequenceNum &&
                    (_a.Long
                      ? ((e.sequenceNum = _a.Long.fromValue(A.sequenceNum)).unsigned = !0)
                      : "string" == typeof A.sequenceNum
                        ? (e.sequenceNum = parseInt(A.sequenceNum, 10))
                        : "number" == typeof A.sequenceNum
                          ? (e.sequenceNum = A.sequenceNum)
                          : "object" == typeof A.sequenceNum &&
                            (e.sequenceNum = new _a.LongBits(
                              A.sequenceNum.low >>> 0,
                              A.sequenceNum.high >>> 0
                            ).toNumber(!0))),
                  null != A.lastButtonSequenceNum &&
                    (_a.Long
                      ? ((e.lastButtonSequenceNum = _a.Long.fromValue(
                          A.lastButtonSequenceNum
                        )).unsigned = !0)
                      : "string" == typeof A.lastButtonSequenceNum
                        ? (e.lastButtonSequenceNum = parseInt(A.lastButtonSequenceNum, 10))
                        : "number" == typeof A.lastButtonSequenceNum
                          ? (e.lastButtonSequenceNum = A.lastButtonSequenceNum)
                          : "object" == typeof A.lastButtonSequenceNum &&
                            (e.lastButtonSequenceNum = new _a.LongBits(
                              A.lastButtonSequenceNum.low >>> 0,
                              A.lastButtonSequenceNum.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (((t.x = 0), (t.y = 0), (t.requestAck = !1), _a.Long)) {
                    let A = new _a.Long(0, 0, !0);
                    t.sequenceNum =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.sequenceNum = e.longs === String ? "0" : 0;
                  if (_a.Long) {
                    let A = new _a.Long(0, 0, !0);
                    t.lastButtonSequenceNum =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.lastButtonSequenceNum = e.longs === String ? "0" : 0;
                }
                return (
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.requestAck &&
                    A.hasOwnProperty("requestAck") &&
                    (t.requestAck = A.requestAck),
                  null != A.sequenceNum &&
                    A.hasOwnProperty("sequenceNum") &&
                    ("number" == typeof A.sequenceNum
                      ? (t.sequenceNum = e.longs === String ? String(A.sequenceNum) : A.sequenceNum)
                      : (t.sequenceNum =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.sequenceNum)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.sequenceNum.low >>> 0,
                                  A.sequenceNum.high >>> 0
                                ).toNumber(!0)
                              : A.sequenceNum)),
                  null != A.lastButtonSequenceNum &&
                    A.hasOwnProperty("lastButtonSequenceNum") &&
                    ("number" == typeof A.lastButtonSequenceNum
                      ? (t.lastButtonSequenceNum =
                          e.longs === String
                            ? String(A.lastButtonSequenceNum)
                            : A.lastButtonSequenceNum)
                      : (t.lastButtonSequenceNum =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.lastButtonSequenceNum)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.lastButtonSequenceNum.low >>> 0,
                                  A.lastButtonSequenceNum.high >>> 0
                                ).toNumber(!0)
                              : A.lastButtonSequenceNum)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.PointerMotionEvent"
                );
              }),
              A
            );
          })()),
          (A.PointerRelativeMotionEvent = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.dx = 0),
              (A.prototype.dy = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.dx && Object.hasOwnProperty.call(A, "dx") && e.uint32(8).int32(A.dx),
                  null != A.dy && Object.hasOwnProperty.call(A, "dy") && e.uint32(16).int32(A.dy),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerRelativeMotionEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.dx = A.int32();
                      break;
                    case 2:
                      i.dy = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.dx && A.hasOwnProperty("dx") && !_a.isInteger(A.dx)
                    ? "dx: integer expected"
                    : null != A.dy && A.hasOwnProperty("dy") && !_a.isInteger(A.dy)
                      ? "dy: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerRelativeMotionEvent) return A;
                let e = new Xa.dcv.input.PointerRelativeMotionEvent();
                return null != A.dx && (e.dx = 0 | A.dx), null != A.dy && (e.dy = 0 | A.dy), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.dx = 0), (t.dy = 0)),
                  null != A.dx && A.hasOwnProperty("dx") && (t.dx = A.dx),
                  null != A.dy && A.hasOwnProperty("dy") && (t.dy = A.dy),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.PointerRelativeMotionEvent"
                );
              }),
              A
            );
          })()),
          (A.PointerRequireCursorImages = (function () {
            function A(A) {
              if (((this.ids = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.ids = _a.emptyArray),
              (A.prototype.requiredPixelFormat = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Va.create()), null != A.ids && A.ids.length)) {
                  e.uint32(10).fork();
                  for (let t = 0; t < A.ids.length; ++t) e.uint64(A.ids[t]);
                  e.ldelim();
                }
                return (
                  null != A.requiredPixelFormat &&
                    Object.hasOwnProperty.call(A, "requiredPixelFormat") &&
                    e.uint32(80).int32(A.requiredPixelFormat),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerRequireCursorImages();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      if (((i.ids && i.ids.length) || (i.ids = []), 2 == (7 & e))) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.ids.push(A.uint64());
                      } else i.ids.push(A.uint64());
                      break;
                    case 10:
                      i.requiredPixelFormat = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.ids && A.hasOwnProperty("ids")) {
                  if (!Array.isArray(A.ids)) return "ids: array expected";
                  for (let e = 0; e < A.ids.length; ++e)
                    if (
                      !(
                        _a.isInteger(A.ids[e]) ||
                        (A.ids[e] && _a.isInteger(A.ids[e].low) && _a.isInteger(A.ids[e].high))
                      )
                    )
                      return "ids: integer|Long[] expected";
                }
                if (null != A.requiredPixelFormat && A.hasOwnProperty("requiredPixelFormat"))
                  switch (A.requiredPixelFormat) {
                    default:
                      return "requiredPixelFormat: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerRequireCursorImages) return A;
                let e = new Xa.dcv.input.PointerRequireCursorImages();
                if (A.ids) {
                  if (!Array.isArray(A.ids))
                    throw TypeError(".dcv.input.PointerRequireCursorImages.ids: array expected");
                  e.ids = [];
                  for (let t = 0; t < A.ids.length; ++t)
                    _a.Long
                      ? ((e.ids[t] = _a.Long.fromValue(A.ids[t])).unsigned = !0)
                      : "string" == typeof A.ids[t]
                        ? (e.ids[t] = parseInt(A.ids[t], 10))
                        : "number" == typeof A.ids[t]
                          ? (e.ids[t] = A.ids[t])
                          : "object" == typeof A.ids[t] &&
                            (e.ids[t] = new _a.LongBits(
                              A.ids[t].low >>> 0,
                              A.ids[t].high >>> 0
                            ).toNumber(!0));
                }
                switch (A.requiredPixelFormat) {
                  default:
                    if ("number" == typeof A.requiredPixelFormat) {
                      e.requiredPixelFormat = A.requiredPixelFormat;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.requiredPixelFormat = 0;
                    break;
                  case "RAW_ARGB_DATA":
                  case 1:
                    e.requiredPixelFormat = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.ids = []),
                  e.defaults && (t.requiredPixelFormat = e.enums === String ? "NONE" : 0),
                  A.ids && A.ids.length)
                ) {
                  t.ids = [];
                  for (let i = 0; i < A.ids.length; ++i)
                    "number" == typeof A.ids[i]
                      ? (t.ids[i] = e.longs === String ? String(A.ids[i]) : A.ids[i])
                      : (t.ids[i] =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.ids[i])
                            : e.longs === Number
                              ? new _a.LongBits(A.ids[i].low >>> 0, A.ids[i].high >>> 0).toNumber(
                                  !0
                                )
                              : A.ids[i]);
                }
                return (
                  null != A.requiredPixelFormat &&
                    A.hasOwnProperty("requiredPixelFormat") &&
                    (t.requiredPixelFormat =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.CursorImagePixelFormat[A.requiredPixelFormat]
                          ? A.requiredPixelFormat
                          : Xa.dcv.input.CursorImagePixelFormat[A.requiredPixelFormat]
                        : A.requiredPixelFormat),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.PointerRequireCursorImages"
                );
              }),
              A
            );
          })()),
          (A.PointerButtonPressEvent = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.button = 0),
              (A.prototype.updatePosition = !1),
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.sequenceNum = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.button &&
                    Object.hasOwnProperty.call(A, "button") &&
                    e.uint32(8).uint32(A.button),
                  null != A.updatePosition &&
                    Object.hasOwnProperty.call(A, "updatePosition") &&
                    e.uint32(16).bool(A.updatePosition),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(24).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(32).uint32(A.y),
                  null != A.sequenceNum &&
                    Object.hasOwnProperty.call(A, "sequenceNum") &&
                    e.uint32(40).uint64(A.sequenceNum),
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerButtonPressEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.button = A.uint32();
                      break;
                    case 2:
                      i.updatePosition = A.bool();
                      break;
                    case 3:
                      i.x = A.uint32();
                      break;
                    case 4:
                      i.y = A.uint32();
                      break;
                    case 5:
                      i.sequenceNum = A.uint64();
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.button && A.hasOwnProperty("button") && !_a.isInteger(A.button)
                    ? "button: integer expected"
                    : null != A.updatePosition &&
                        A.hasOwnProperty("updatePosition") &&
                        "boolean" != typeof A.updatePosition
                      ? "updatePosition: boolean expected"
                      : null != A.x && A.hasOwnProperty("x") && !_a.isInteger(A.x)
                        ? "x: integer expected"
                        : null != A.y && A.hasOwnProperty("y") && !_a.isInteger(A.y)
                          ? "y: integer expected"
                          : null != A.sequenceNum &&
                              A.hasOwnProperty("sequenceNum") &&
                              !(
                                _a.isInteger(A.sequenceNum) ||
                                (A.sequenceNum &&
                                  _a.isInteger(A.sequenceNum.low) &&
                                  _a.isInteger(A.sequenceNum.high))
                              )
                            ? "sequenceNum: integer|Long expected"
                            : null != A.estimatedTimestamp &&
                                A.hasOwnProperty("estimatedTimestamp") &&
                                !(
                                  _a.isInteger(A.estimatedTimestamp) ||
                                  (A.estimatedTimestamp &&
                                    _a.isInteger(A.estimatedTimestamp.low) &&
                                    _a.isInteger(A.estimatedTimestamp.high))
                                )
                              ? "estimatedTimestamp: integer|Long expected"
                              : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerButtonPressEvent) return A;
                let e = new Xa.dcv.input.PointerButtonPressEvent();
                return (
                  null != A.button && (e.button = A.button >>> 0),
                  null != A.updatePosition && (e.updatePosition = Boolean(A.updatePosition)),
                  null != A.x && (e.x = A.x >>> 0),
                  null != A.y && (e.y = A.y >>> 0),
                  null != A.sequenceNum &&
                    (_a.Long
                      ? ((e.sequenceNum = _a.Long.fromValue(A.sequenceNum)).unsigned = !0)
                      : "string" == typeof A.sequenceNum
                        ? (e.sequenceNum = parseInt(A.sequenceNum, 10))
                        : "number" == typeof A.sequenceNum
                          ? (e.sequenceNum = A.sequenceNum)
                          : "object" == typeof A.sequenceNum &&
                            (e.sequenceNum = new _a.LongBits(
                              A.sequenceNum.low >>> 0,
                              A.sequenceNum.high >>> 0
                            ).toNumber(!0))),
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (((t.button = 0), (t.updatePosition = !1), (t.x = 0), (t.y = 0), _a.Long)) {
                    let A = new _a.Long(0, 0, !0);
                    t.sequenceNum =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.sequenceNum = e.longs === String ? "0" : 0;
                  if (_a.Long) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                }
                return (
                  null != A.button && A.hasOwnProperty("button") && (t.button = A.button),
                  null != A.updatePosition &&
                    A.hasOwnProperty("updatePosition") &&
                    (t.updatePosition = A.updatePosition),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.sequenceNum &&
                    A.hasOwnProperty("sequenceNum") &&
                    ("number" == typeof A.sequenceNum
                      ? (t.sequenceNum = e.longs === String ? String(A.sequenceNum) : A.sequenceNum)
                      : (t.sequenceNum =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.sequenceNum)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.sequenceNum.low >>> 0,
                                  A.sequenceNum.high >>> 0
                                ).toNumber(!0)
                              : A.sequenceNum)),
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.PointerButtonPressEvent"
                );
              }),
              A
            );
          })()),
          (A.PointerButtonReleaseEvent = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.button = 0),
              (A.prototype.updatePosition = !1),
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.sequenceNum = _a.Long ? _a.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.button &&
                    Object.hasOwnProperty.call(A, "button") &&
                    e.uint32(8).uint32(A.button),
                  null != A.updatePosition &&
                    Object.hasOwnProperty.call(A, "updatePosition") &&
                    e.uint32(16).bool(A.updatePosition),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(24).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(32).uint32(A.y),
                  null != A.sequenceNum &&
                    Object.hasOwnProperty.call(A, "sequenceNum") &&
                    e.uint32(40).uint64(A.sequenceNum),
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerButtonReleaseEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.button = A.uint32();
                      break;
                    case 2:
                      i.updatePosition = A.bool();
                      break;
                    case 3:
                      i.x = A.uint32();
                      break;
                    case 4:
                      i.y = A.uint32();
                      break;
                    case 5:
                      i.sequenceNum = A.uint64();
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.button && A.hasOwnProperty("button") && !_a.isInteger(A.button)
                    ? "button: integer expected"
                    : null != A.updatePosition &&
                        A.hasOwnProperty("updatePosition") &&
                        "boolean" != typeof A.updatePosition
                      ? "updatePosition: boolean expected"
                      : null != A.x && A.hasOwnProperty("x") && !_a.isInteger(A.x)
                        ? "x: integer expected"
                        : null != A.y && A.hasOwnProperty("y") && !_a.isInteger(A.y)
                          ? "y: integer expected"
                          : null != A.sequenceNum &&
                              A.hasOwnProperty("sequenceNum") &&
                              !(
                                _a.isInteger(A.sequenceNum) ||
                                (A.sequenceNum &&
                                  _a.isInteger(A.sequenceNum.low) &&
                                  _a.isInteger(A.sequenceNum.high))
                              )
                            ? "sequenceNum: integer|Long expected"
                            : null != A.estimatedTimestamp &&
                                A.hasOwnProperty("estimatedTimestamp") &&
                                !(
                                  _a.isInteger(A.estimatedTimestamp) ||
                                  (A.estimatedTimestamp &&
                                    _a.isInteger(A.estimatedTimestamp.low) &&
                                    _a.isInteger(A.estimatedTimestamp.high))
                                )
                              ? "estimatedTimestamp: integer|Long expected"
                              : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerButtonReleaseEvent) return A;
                let e = new Xa.dcv.input.PointerButtonReleaseEvent();
                return (
                  null != A.button && (e.button = A.button >>> 0),
                  null != A.updatePosition && (e.updatePosition = Boolean(A.updatePosition)),
                  null != A.x && (e.x = A.x >>> 0),
                  null != A.y && (e.y = A.y >>> 0),
                  null != A.sequenceNum &&
                    (_a.Long
                      ? ((e.sequenceNum = _a.Long.fromValue(A.sequenceNum)).unsigned = !0)
                      : "string" == typeof A.sequenceNum
                        ? (e.sequenceNum = parseInt(A.sequenceNum, 10))
                        : "number" == typeof A.sequenceNum
                          ? (e.sequenceNum = A.sequenceNum)
                          : "object" == typeof A.sequenceNum &&
                            (e.sequenceNum = new _a.LongBits(
                              A.sequenceNum.low >>> 0,
                              A.sequenceNum.high >>> 0
                            ).toNumber(!0))),
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (((t.button = 0), (t.updatePosition = !1), (t.x = 0), (t.y = 0), _a.Long)) {
                    let A = new _a.Long(0, 0, !0);
                    t.sequenceNum =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.sequenceNum = e.longs === String ? "0" : 0;
                  if (_a.Long) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                }
                return (
                  null != A.button && A.hasOwnProperty("button") && (t.button = A.button),
                  null != A.updatePosition &&
                    A.hasOwnProperty("updatePosition") &&
                    (t.updatePosition = A.updatePosition),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.sequenceNum &&
                    A.hasOwnProperty("sequenceNum") &&
                    ("number" == typeof A.sequenceNum
                      ? (t.sequenceNum = e.longs === String ? String(A.sequenceNum) : A.sequenceNum)
                      : (t.sequenceNum =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.sequenceNum)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.sequenceNum.low >>> 0,
                                  A.sequenceNum.high >>> 0
                                ).toNumber(!0)
                              : A.sequenceNum)),
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.PointerButtonReleaseEvent"
                );
              }),
              A
            );
          })()),
          (A.PointerAxisEvent = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.axis = 0),
              (A.prototype.value = 0),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.axis &&
                    Object.hasOwnProperty.call(A, "axis") &&
                    e.uint32(8).int32(A.axis),
                  null != A.value &&
                    Object.hasOwnProperty.call(A, "value") &&
                    e.uint32(16).int32(A.value),
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.PointerAxisEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.axis = A.int32();
                      break;
                    case 2:
                      i.value = A.int32();
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.axis && A.hasOwnProperty("axis"))
                  switch (A.axis) {
                    default:
                      return "axis: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null != A.value && A.hasOwnProperty("value") && !_a.isInteger(A.value)
                  ? "value: integer expected"
                  : null != A.estimatedTimestamp &&
                      A.hasOwnProperty("estimatedTimestamp") &&
                      !(
                        _a.isInteger(A.estimatedTimestamp) ||
                        (A.estimatedTimestamp &&
                          _a.isInteger(A.estimatedTimestamp.low) &&
                          _a.isInteger(A.estimatedTimestamp.high))
                      )
                    ? "estimatedTimestamp: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.PointerAxisEvent) return A;
                let e = new Xa.dcv.input.PointerAxisEvent();
                switch (A.axis) {
                  default:
                    if ("number" == typeof A.axis) {
                      e.axis = A.axis;
                      break;
                    }
                    break;
                  case "X_AXIS":
                  case 0:
                    e.axis = 0;
                    break;
                  case "Y_AXIS":
                  case 1:
                    e.axis = 1;
                    break;
                  case "Z_AXIS":
                  case 2:
                    e.axis = 2;
                }
                return (
                  null != A.value && (e.value = 0 | A.value),
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (((t.axis = e.enums === String ? "X_AXIS" : 0), (t.value = 0), _a.Long)) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                return (
                  null != A.axis &&
                    A.hasOwnProperty("axis") &&
                    (t.axis =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.PointerAxisEvent.Axis[A.axis]
                          ? A.axis
                          : Xa.dcv.input.PointerAxisEvent.Axis[A.axis]
                        : A.axis),
                  null != A.value && A.hasOwnProperty("value") && (t.value = A.value),
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.PointerAxisEvent"
                );
              }),
              (A.Axis = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "X_AXIS")] = 0),
                  (e[(A[1] = "Y_AXIS")] = 1),
                  (e[(A[2] = "Z_AXIS")] = 2),
                  e
                );
              })()),
              A
            );
          })()),
          (A.KeyboardLocation = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "STANDARD")] = 0),
              (e[(A[1] = "LEFT")] = 1),
              (e[(A[2] = "RIGHT")] = 2),
              (e[(A[3] = "NUMPAD")] = 3),
              e
            );
          })()),
          (A.LockKey = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "LOCK_NONE")] = 0),
              (e[(A[1] = "CAPS_LOCK")] = 1),
              (e[(A[2] = "NUM_LOCK")] = 2),
              (e[(A[3] = "SCROLL_LOCK")] = 3),
              e
            );
          })()),
          (A.LockState = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.key = 0),
              (A.prototype.active = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.key && Object.hasOwnProperty.call(A, "key") && e.uint32(8).int32(A.key),
                  null != A.active &&
                    Object.hasOwnProperty.call(A, "active") &&
                    e.uint32(16).bool(A.active),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.LockState();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.key = A.int32();
                      break;
                    case 2:
                      i.active = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.key && A.hasOwnProperty("key"))
                  switch (A.key) {
                    default:
                      return "key: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                return null != A.active &&
                  A.hasOwnProperty("active") &&
                  "boolean" != typeof A.active
                  ? "active: boolean expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.LockState) return A;
                let e = new Xa.dcv.input.LockState();
                switch (A.key) {
                  default:
                    if ("number" == typeof A.key) {
                      e.key = A.key;
                      break;
                    }
                    break;
                  case "LOCK_NONE":
                  case 0:
                    e.key = 0;
                    break;
                  case "CAPS_LOCK":
                  case 1:
                    e.key = 1;
                    break;
                  case "NUM_LOCK":
                  case 2:
                    e.key = 2;
                    break;
                  case "SCROLL_LOCK":
                  case 3:
                    e.key = 3;
                }
                return null != A.active && (e.active = Boolean(A.active)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.key = e.enums === String ? "LOCK_NONE" : 0), (t.active = !1)),
                  null != A.key &&
                    A.hasOwnProperty("key") &&
                    (t.key =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.LockKey[A.key]
                          ? A.key
                          : Xa.dcv.input.LockKey[A.key]
                        : A.key),
                  null != A.active && A.hasOwnProperty("active") && (t.active = A.active),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.LockState";
              }),
              A
            );
          })()),
          (A.KeyDownEvent = (function () {
            function A(A) {
              if (((this.locks = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.character = ""),
              (A.prototype.location = 0),
              (A.prototype.locks = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.character &&
                    Object.hasOwnProperty.call(A, "character") &&
                    e.uint32(10).string(A.character),
                  null != A.location &&
                    Object.hasOwnProperty.call(A, "location") &&
                    e.uint32(16).int32(A.location),
                  null != A.locks && A.locks.length)
                )
                  for (let t = 0; t < A.locks.length; ++t)
                    Xa.dcv.input.LockState.encode(A.locks[t], e.uint32(26).fork()).ldelim();
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.KeyDownEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.character = A.string();
                      break;
                    case 2:
                      i.location = A.int32();
                      break;
                    case 3:
                      (i.locks && i.locks.length) || (i.locks = []),
                        i.locks.push(Xa.dcv.input.LockState.decode(A, A.uint32()));
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.character &&
                  A.hasOwnProperty("character") &&
                  !_a.isString(A.character)
                )
                  return "character: string expected";
                if (null != A.location && A.hasOwnProperty("location"))
                  switch (A.location) {
                    default:
                      return "location: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                if (null != A.locks && A.hasOwnProperty("locks")) {
                  if (!Array.isArray(A.locks)) return "locks: array expected";
                  for (let e = 0; e < A.locks.length; ++e) {
                    let t = Xa.dcv.input.LockState.verify(A.locks[e]);
                    if (t) return "locks." + t;
                  }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.KeyDownEvent) return A;
                let e = new Xa.dcv.input.KeyDownEvent();
                switch ((null != A.character && (e.character = String(A.character)), A.location)) {
                  default:
                    if ("number" == typeof A.location) {
                      e.location = A.location;
                      break;
                    }
                    break;
                  case "STANDARD":
                  case 0:
                    e.location = 0;
                    break;
                  case "LEFT":
                  case 1:
                    e.location = 1;
                    break;
                  case "RIGHT":
                  case 2:
                    e.location = 2;
                    break;
                  case "NUMPAD":
                  case 3:
                    e.location = 3;
                }
                if (A.locks) {
                  if (!Array.isArray(A.locks))
                    throw TypeError(".dcv.input.KeyDownEvent.locks: array expected");
                  e.locks = [];
                  for (let t = 0; t < A.locks.length; ++t) {
                    if ("object" != typeof A.locks[t])
                      throw TypeError(".dcv.input.KeyDownEvent.locks: object expected");
                    e.locks[t] = Xa.dcv.input.LockState.fromObject(A.locks[t]);
                  }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.locks = []), e.defaults))
                  if (
                    ((t.character = ""),
                    (t.location = e.enums === String ? "STANDARD" : 0),
                    _a.Long)
                  ) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.character &&
                    A.hasOwnProperty("character") &&
                    (t.character = A.character),
                  null != A.location &&
                    A.hasOwnProperty("location") &&
                    (t.location =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.KeyboardLocation[A.location]
                          ? A.location
                          : Xa.dcv.input.KeyboardLocation[A.location]
                        : A.location),
                  A.locks && A.locks.length)
                ) {
                  t.locks = [];
                  for (let i = 0; i < A.locks.length; ++i)
                    t.locks[i] = Xa.dcv.input.LockState.toObject(A.locks[i], e);
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.KeyDownEvent";
              }),
              A
            );
          })()),
          (A.KeyUpEvent = (function () {
            function A(A) {
              if (((this.locks = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.character = ""),
              (A.prototype.location = 0),
              (A.prototype.locks = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.character &&
                    Object.hasOwnProperty.call(A, "character") &&
                    e.uint32(10).string(A.character),
                  null != A.location &&
                    Object.hasOwnProperty.call(A, "location") &&
                    e.uint32(16).int32(A.location),
                  null != A.locks && A.locks.length)
                )
                  for (let t = 0; t < A.locks.length; ++t)
                    Xa.dcv.input.LockState.encode(A.locks[t], e.uint32(26).fork()).ldelim();
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.KeyUpEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.character = A.string();
                      break;
                    case 2:
                      i.location = A.int32();
                      break;
                    case 3:
                      (i.locks && i.locks.length) || (i.locks = []),
                        i.locks.push(Xa.dcv.input.LockState.decode(A, A.uint32()));
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.character &&
                  A.hasOwnProperty("character") &&
                  !_a.isString(A.character)
                )
                  return "character: string expected";
                if (null != A.location && A.hasOwnProperty("location"))
                  switch (A.location) {
                    default:
                      return "location: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                if (null != A.locks && A.hasOwnProperty("locks")) {
                  if (!Array.isArray(A.locks)) return "locks: array expected";
                  for (let e = 0; e < A.locks.length; ++e) {
                    let t = Xa.dcv.input.LockState.verify(A.locks[e]);
                    if (t) return "locks." + t;
                  }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.KeyUpEvent) return A;
                let e = new Xa.dcv.input.KeyUpEvent();
                switch ((null != A.character && (e.character = String(A.character)), A.location)) {
                  default:
                    if ("number" == typeof A.location) {
                      e.location = A.location;
                      break;
                    }
                    break;
                  case "STANDARD":
                  case 0:
                    e.location = 0;
                    break;
                  case "LEFT":
                  case 1:
                    e.location = 1;
                    break;
                  case "RIGHT":
                  case 2:
                    e.location = 2;
                    break;
                  case "NUMPAD":
                  case 3:
                    e.location = 3;
                }
                if (A.locks) {
                  if (!Array.isArray(A.locks))
                    throw TypeError(".dcv.input.KeyUpEvent.locks: array expected");
                  e.locks = [];
                  for (let t = 0; t < A.locks.length; ++t) {
                    if ("object" != typeof A.locks[t])
                      throw TypeError(".dcv.input.KeyUpEvent.locks: object expected");
                    e.locks[t] = Xa.dcv.input.LockState.fromObject(A.locks[t]);
                  }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.locks = []), e.defaults))
                  if (
                    ((t.character = ""),
                    (t.location = e.enums === String ? "STANDARD" : 0),
                    _a.Long)
                  ) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.character &&
                    A.hasOwnProperty("character") &&
                    (t.character = A.character),
                  null != A.location &&
                    A.hasOwnProperty("location") &&
                    (t.location =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.KeyboardLocation[A.location]
                          ? A.location
                          : Xa.dcv.input.KeyboardLocation[A.location]
                        : A.location),
                  A.locks && A.locks.length)
                ) {
                  t.locks = [];
                  for (let i = 0; i < A.locks.length; ++i)
                    t.locks[i] = Xa.dcv.input.LockState.toObject(A.locks[i], e);
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.KeyUpEvent";
              }),
              A
            );
          })()),
          (A.SpecialKeyDownEvent = (function () {
            function A(A) {
              if (((this.locks = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.name = ""),
              (A.prototype.location = 0),
              (A.prototype.locks = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.name &&
                    Object.hasOwnProperty.call(A, "name") &&
                    e.uint32(10).string(A.name),
                  null != A.location &&
                    Object.hasOwnProperty.call(A, "location") &&
                    e.uint32(16).int32(A.location),
                  null != A.locks && A.locks.length)
                )
                  for (let t = 0; t < A.locks.length; ++t)
                    Xa.dcv.input.LockState.encode(A.locks[t], e.uint32(26).fork()).ldelim();
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.SpecialKeyDownEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.name = A.string();
                      break;
                    case 2:
                      i.location = A.int32();
                      break;
                    case 3:
                      (i.locks && i.locks.length) || (i.locks = []),
                        i.locks.push(Xa.dcv.input.LockState.decode(A, A.uint32()));
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.name && A.hasOwnProperty("name") && !_a.isString(A.name))
                  return "name: string expected";
                if (null != A.location && A.hasOwnProperty("location"))
                  switch (A.location) {
                    default:
                      return "location: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                if (null != A.locks && A.hasOwnProperty("locks")) {
                  if (!Array.isArray(A.locks)) return "locks: array expected";
                  for (let e = 0; e < A.locks.length; ++e) {
                    let t = Xa.dcv.input.LockState.verify(A.locks[e]);
                    if (t) return "locks." + t;
                  }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.SpecialKeyDownEvent) return A;
                let e = new Xa.dcv.input.SpecialKeyDownEvent();
                switch ((null != A.name && (e.name = String(A.name)), A.location)) {
                  default:
                    if ("number" == typeof A.location) {
                      e.location = A.location;
                      break;
                    }
                    break;
                  case "STANDARD":
                  case 0:
                    e.location = 0;
                    break;
                  case "LEFT":
                  case 1:
                    e.location = 1;
                    break;
                  case "RIGHT":
                  case 2:
                    e.location = 2;
                    break;
                  case "NUMPAD":
                  case 3:
                    e.location = 3;
                }
                if (A.locks) {
                  if (!Array.isArray(A.locks))
                    throw TypeError(".dcv.input.SpecialKeyDownEvent.locks: array expected");
                  e.locks = [];
                  for (let t = 0; t < A.locks.length; ++t) {
                    if ("object" != typeof A.locks[t])
                      throw TypeError(".dcv.input.SpecialKeyDownEvent.locks: object expected");
                    e.locks[t] = Xa.dcv.input.LockState.fromObject(A.locks[t]);
                  }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.locks = []), e.defaults))
                  if (
                    ((t.name = ""), (t.location = e.enums === String ? "STANDARD" : 0), _a.Long)
                  ) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                  null != A.location &&
                    A.hasOwnProperty("location") &&
                    (t.location =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.KeyboardLocation[A.location]
                          ? A.location
                          : Xa.dcv.input.KeyboardLocation[A.location]
                        : A.location),
                  A.locks && A.locks.length)
                ) {
                  t.locks = [];
                  for (let i = 0; i < A.locks.length; ++i)
                    t.locks[i] = Xa.dcv.input.LockState.toObject(A.locks[i], e);
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.SpecialKeyDownEvent"
                );
              }),
              A
            );
          })()),
          (A.SpecialKeyUpEvent = (function () {
            function A(A) {
              if (((this.locks = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.name = ""),
              (A.prototype.location = 0),
              (A.prototype.locks = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.name &&
                    Object.hasOwnProperty.call(A, "name") &&
                    e.uint32(10).string(A.name),
                  null != A.location &&
                    Object.hasOwnProperty.call(A, "location") &&
                    e.uint32(16).int32(A.location),
                  null != A.locks && A.locks.length)
                )
                  for (let t = 0; t < A.locks.length; ++t)
                    Xa.dcv.input.LockState.encode(A.locks[t], e.uint32(26).fork()).ldelim();
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.SpecialKeyUpEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.name = A.string();
                      break;
                    case 2:
                      i.location = A.int32();
                      break;
                    case 3:
                      (i.locks && i.locks.length) || (i.locks = []),
                        i.locks.push(Xa.dcv.input.LockState.decode(A, A.uint32()));
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.name && A.hasOwnProperty("name") && !_a.isString(A.name))
                  return "name: string expected";
                if (null != A.location && A.hasOwnProperty("location"))
                  switch (A.location) {
                    default:
                      return "location: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                if (null != A.locks && A.hasOwnProperty("locks")) {
                  if (!Array.isArray(A.locks)) return "locks: array expected";
                  for (let e = 0; e < A.locks.length; ++e) {
                    let t = Xa.dcv.input.LockState.verify(A.locks[e]);
                    if (t) return "locks." + t;
                  }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.SpecialKeyUpEvent) return A;
                let e = new Xa.dcv.input.SpecialKeyUpEvent();
                switch ((null != A.name && (e.name = String(A.name)), A.location)) {
                  default:
                    if ("number" == typeof A.location) {
                      e.location = A.location;
                      break;
                    }
                    break;
                  case "STANDARD":
                  case 0:
                    e.location = 0;
                    break;
                  case "LEFT":
                  case 1:
                    e.location = 1;
                    break;
                  case "RIGHT":
                  case 2:
                    e.location = 2;
                    break;
                  case "NUMPAD":
                  case 3:
                    e.location = 3;
                }
                if (A.locks) {
                  if (!Array.isArray(A.locks))
                    throw TypeError(".dcv.input.SpecialKeyUpEvent.locks: array expected");
                  e.locks = [];
                  for (let t = 0; t < A.locks.length; ++t) {
                    if ("object" != typeof A.locks[t])
                      throw TypeError(".dcv.input.SpecialKeyUpEvent.locks: object expected");
                    e.locks[t] = Xa.dcv.input.LockState.fromObject(A.locks[t]);
                  }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.locks = []), e.defaults))
                  if (
                    ((t.name = ""), (t.location = e.enums === String ? "STANDARD" : 0), _a.Long)
                  ) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                  null != A.location &&
                    A.hasOwnProperty("location") &&
                    (t.location =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.KeyboardLocation[A.location]
                          ? A.location
                          : Xa.dcv.input.KeyboardLocation[A.location]
                        : A.location),
                  A.locks && A.locks.length)
                ) {
                  t.locks = [];
                  for (let i = 0; i < A.locks.length; ++i)
                    t.locks[i] = Xa.dcv.input.LockState.toObject(A.locks[i], e);
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.SpecialKeyUpEvent"
                );
              }),
              A
            );
          })()),
          (A.TouchStatus = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "MOTION")] = 0), (e[(A[1] = "DOWN")] = 1), (e[(A[2] = "UP")] = 2), e;
          })()),
          (A.SingleTouch = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.id = 0),
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.status = 0),
              (A.prototype.top = 0),
              (A.prototype.bottom = 0),
              (A.prototype.left = 0),
              (A.prototype.right = 0),
              (A.prototype.hasPressure = !1),
              (A.prototype.pressure = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.id && Object.hasOwnProperty.call(A, "id") && e.uint32(8).uint32(A.id),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(80).uint32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(88).uint32(A.y),
                  null != A.status &&
                    Object.hasOwnProperty.call(A, "status") &&
                    e.uint32(160).int32(A.status),
                  null != A.top &&
                    Object.hasOwnProperty.call(A, "top") &&
                    e.uint32(240).int32(A.top),
                  null != A.bottom &&
                    Object.hasOwnProperty.call(A, "bottom") &&
                    e.uint32(248).int32(A.bottom),
                  null != A.left &&
                    Object.hasOwnProperty.call(A, "left") &&
                    e.uint32(256).int32(A.left),
                  null != A.right &&
                    Object.hasOwnProperty.call(A, "right") &&
                    e.uint32(264).int32(A.right),
                  null != A.hasPressure &&
                    Object.hasOwnProperty.call(A, "hasPressure") &&
                    e.uint32(320).bool(A.hasPressure),
                  null != A.pressure &&
                    Object.hasOwnProperty.call(A, "pressure") &&
                    e.uint32(329).double(A.pressure),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.SingleTouch();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.id = A.uint32();
                      break;
                    case 10:
                      i.x = A.uint32();
                      break;
                    case 11:
                      i.y = A.uint32();
                      break;
                    case 20:
                      i.status = A.int32();
                      break;
                    case 30:
                      i.top = A.int32();
                      break;
                    case 31:
                      i.bottom = A.int32();
                      break;
                    case 32:
                      i.left = A.int32();
                      break;
                    case 33:
                      i.right = A.int32();
                      break;
                    case 40:
                      i.hasPressure = A.bool();
                      break;
                    case 41:
                      i.pressure = A.double();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.id && A.hasOwnProperty("id") && !_a.isInteger(A.id))
                  return "id: integer expected";
                if (null != A.x && A.hasOwnProperty("x") && !_a.isInteger(A.x))
                  return "x: integer expected";
                if (null != A.y && A.hasOwnProperty("y") && !_a.isInteger(A.y))
                  return "y: integer expected";
                if (null != A.status && A.hasOwnProperty("status"))
                  switch (A.status) {
                    default:
                      return "status: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null != A.top && A.hasOwnProperty("top") && !_a.isInteger(A.top)
                  ? "top: integer expected"
                  : null != A.bottom && A.hasOwnProperty("bottom") && !_a.isInteger(A.bottom)
                    ? "bottom: integer expected"
                    : null != A.left && A.hasOwnProperty("left") && !_a.isInteger(A.left)
                      ? "left: integer expected"
                      : null != A.right && A.hasOwnProperty("right") && !_a.isInteger(A.right)
                        ? "right: integer expected"
                        : null != A.hasPressure &&
                            A.hasOwnProperty("hasPressure") &&
                            "boolean" != typeof A.hasPressure
                          ? "hasPressure: boolean expected"
                          : null != A.pressure &&
                              A.hasOwnProperty("pressure") &&
                              "number" != typeof A.pressure
                            ? "pressure: number expected"
                            : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.SingleTouch) return A;
                let e = new Xa.dcv.input.SingleTouch();
                switch (
                  (null != A.id && (e.id = A.id >>> 0),
                  null != A.x && (e.x = A.x >>> 0),
                  null != A.y && (e.y = A.y >>> 0),
                  A.status)
                ) {
                  default:
                    if ("number" == typeof A.status) {
                      e.status = A.status;
                      break;
                    }
                    break;
                  case "MOTION":
                  case 0:
                    e.status = 0;
                    break;
                  case "DOWN":
                  case 1:
                    e.status = 1;
                    break;
                  case "UP":
                  case 2:
                    e.status = 2;
                }
                return (
                  null != A.top && (e.top = 0 | A.top),
                  null != A.bottom && (e.bottom = 0 | A.bottom),
                  null != A.left && (e.left = 0 | A.left),
                  null != A.right && (e.right = 0 | A.right),
                  null != A.hasPressure && (e.hasPressure = Boolean(A.hasPressure)),
                  null != A.pressure && (e.pressure = Number(A.pressure)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.id = 0),
                    (t.x = 0),
                    (t.y = 0),
                    (t.status = e.enums === String ? "MOTION" : 0),
                    (t.top = 0),
                    (t.bottom = 0),
                    (t.left = 0),
                    (t.right = 0),
                    (t.hasPressure = !1),
                    (t.pressure = 0)),
                  null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.status &&
                    A.hasOwnProperty("status") &&
                    (t.status =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.TouchStatus[A.status]
                          ? A.status
                          : Xa.dcv.input.TouchStatus[A.status]
                        : A.status),
                  null != A.top && A.hasOwnProperty("top") && (t.top = A.top),
                  null != A.bottom && A.hasOwnProperty("bottom") && (t.bottom = A.bottom),
                  null != A.left && A.hasOwnProperty("left") && (t.left = A.left),
                  null != A.right && A.hasOwnProperty("right") && (t.right = A.right),
                  null != A.hasPressure &&
                    A.hasOwnProperty("hasPressure") &&
                    (t.hasPressure = A.hasPressure),
                  null != A.pressure &&
                    A.hasOwnProperty("pressure") &&
                    (t.pressure =
                      e.json && !isFinite(A.pressure) ? String(A.pressure) : A.pressure),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.SingleTouch";
              }),
              A
            );
          })()),
          (A.TouchEvent = (function () {
            function A(A) {
              if (((this.touches = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.groupId = 0),
              (A.prototype.touches = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.groupId &&
                    Object.hasOwnProperty.call(A, "groupId") &&
                    e.uint32(8).uint32(A.groupId),
                  null != A.touches && A.touches.length)
                )
                  for (let t = 0; t < A.touches.length; ++t)
                    Xa.dcv.input.SingleTouch.encode(A.touches[t], e.uint32(18).fork()).ldelim();
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.TouchEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.groupId = A.uint32();
                      break;
                    case 2:
                      (i.touches && i.touches.length) || (i.touches = []),
                        i.touches.push(Xa.dcv.input.SingleTouch.decode(A, A.uint32()));
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.groupId && A.hasOwnProperty("groupId") && !_a.isInteger(A.groupId))
                  return "groupId: integer expected";
                if (null != A.touches && A.hasOwnProperty("touches")) {
                  if (!Array.isArray(A.touches)) return "touches: array expected";
                  for (let e = 0; e < A.touches.length; ++e) {
                    let t = Xa.dcv.input.SingleTouch.verify(A.touches[e]);
                    if (t) return "touches." + t;
                  }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.TouchEvent) return A;
                let e = new Xa.dcv.input.TouchEvent();
                if ((null != A.groupId && (e.groupId = A.groupId >>> 0), A.touches)) {
                  if (!Array.isArray(A.touches))
                    throw TypeError(".dcv.input.TouchEvent.touches: array expected");
                  e.touches = [];
                  for (let t = 0; t < A.touches.length; ++t) {
                    if ("object" != typeof A.touches[t])
                      throw TypeError(".dcv.input.TouchEvent.touches: object expected");
                    e.touches[t] = Xa.dcv.input.SingleTouch.fromObject(A.touches[t]);
                  }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.touches = []), e.defaults))
                  if (((t.groupId = 0), _a.Long)) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.groupId && A.hasOwnProperty("groupId") && (t.groupId = A.groupId),
                  A.touches && A.touches.length)
                ) {
                  t.touches = [];
                  for (let i = 0; i < A.touches.length; ++i)
                    t.touches[i] = Xa.dcv.input.SingleTouch.toObject(A.touches[i], e);
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.TouchEvent";
              }),
              A
            );
          })()),
          (A.StylusButton = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "STYLUS_BUTTON_1")] = 0),
              (e[(A[1] = "STYLUS_BUTTON_2")] = 1),
              (e[(A[2] = "STYLUS_BUTTON_3")] = 2),
              (e[(A[3] = "STYLUS_BUTTON_4")] = 3),
              e
            );
          })()),
          (A.StylusEvent = (function () {
            function A(A) {
              if (((this.stylusButtons = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pointerId = 0),
              (A.prototype.x = 0),
              (A.prototype.y = 0),
              (A.prototype.inverted = !1),
              (A.prototype.inAir = !1),
              (A.prototype.hasPressure = !1),
              (A.prototype.pressure = 0),
              (A.prototype.hasRotation = !1),
              (A.prototype.rotation = 0),
              (A.prototype.hasTiltX = !1),
              (A.prototype.tiltX = 0),
              (A.prototype.hasTiltY = !1),
              (A.prototype.tiltY = 0),
              (A.prototype.stylusButtons = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.pointerId &&
                    Object.hasOwnProperty.call(A, "pointerId") &&
                    e.uint32(8).uint32(A.pointerId),
                  null != A.x && Object.hasOwnProperty.call(A, "x") && e.uint32(80).int32(A.x),
                  null != A.y && Object.hasOwnProperty.call(A, "y") && e.uint32(88).int32(A.y),
                  null != A.inverted &&
                    Object.hasOwnProperty.call(A, "inverted") &&
                    e.uint32(400).bool(A.inverted),
                  null != A.inAir &&
                    Object.hasOwnProperty.call(A, "inAir") &&
                    e.uint32(480).bool(A.inAir),
                  null != A.hasPressure &&
                    Object.hasOwnProperty.call(A, "hasPressure") &&
                    e.uint32(560).bool(A.hasPressure),
                  null != A.pressure &&
                    Object.hasOwnProperty.call(A, "pressure") &&
                    e.uint32(569).double(A.pressure),
                  null != A.hasRotation &&
                    Object.hasOwnProperty.call(A, "hasRotation") &&
                    e.uint32(640).bool(A.hasRotation),
                  null != A.rotation &&
                    Object.hasOwnProperty.call(A, "rotation") &&
                    e.uint32(648).uint32(A.rotation),
                  null != A.hasTiltX &&
                    Object.hasOwnProperty.call(A, "hasTiltX") &&
                    e.uint32(720).bool(A.hasTiltX),
                  null != A.tiltX &&
                    Object.hasOwnProperty.call(A, "tiltX") &&
                    e.uint32(728).int32(A.tiltX),
                  null != A.hasTiltY &&
                    Object.hasOwnProperty.call(A, "hasTiltY") &&
                    e.uint32(800).bool(A.hasTiltY),
                  null != A.tiltY &&
                    Object.hasOwnProperty.call(A, "tiltY") &&
                    e.uint32(808).int32(A.tiltY),
                  null != A.stylusButtons && A.stylusButtons.length)
                ) {
                  e.uint32(882).fork();
                  for (let t = 0; t < A.stylusButtons.length; ++t) e.int32(A.stylusButtons[t]);
                  e.ldelim();
                }
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(960).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.StylusEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.pointerId = A.uint32();
                      break;
                    case 10:
                      i.x = A.int32();
                      break;
                    case 11:
                      i.y = A.int32();
                      break;
                    case 50:
                      i.inverted = A.bool();
                      break;
                    case 60:
                      i.inAir = A.bool();
                      break;
                    case 70:
                      i.hasPressure = A.bool();
                      break;
                    case 71:
                      i.pressure = A.double();
                      break;
                    case 80:
                      i.hasRotation = A.bool();
                      break;
                    case 81:
                      i.rotation = A.uint32();
                      break;
                    case 90:
                      i.hasTiltX = A.bool();
                      break;
                    case 91:
                      i.tiltX = A.int32();
                      break;
                    case 100:
                      i.hasTiltY = A.bool();
                      break;
                    case 101:
                      i.tiltY = A.int32();
                      break;
                    case 110:
                      if (
                        ((i.stylusButtons && i.stylusButtons.length) || (i.stylusButtons = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.stylusButtons.push(A.int32());
                      } else i.stylusButtons.push(A.int32());
                      break;
                    case 120:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.pointerId &&
                  A.hasOwnProperty("pointerId") &&
                  !_a.isInteger(A.pointerId)
                )
                  return "pointerId: integer expected";
                if (null != A.x && A.hasOwnProperty("x") && !_a.isInteger(A.x))
                  return "x: integer expected";
                if (null != A.y && A.hasOwnProperty("y") && !_a.isInteger(A.y))
                  return "y: integer expected";
                if (
                  null != A.inverted &&
                  A.hasOwnProperty("inverted") &&
                  "boolean" != typeof A.inverted
                )
                  return "inverted: boolean expected";
                if (null != A.inAir && A.hasOwnProperty("inAir") && "boolean" != typeof A.inAir)
                  return "inAir: boolean expected";
                if (
                  null != A.hasPressure &&
                  A.hasOwnProperty("hasPressure") &&
                  "boolean" != typeof A.hasPressure
                )
                  return "hasPressure: boolean expected";
                if (
                  null != A.pressure &&
                  A.hasOwnProperty("pressure") &&
                  "number" != typeof A.pressure
                )
                  return "pressure: number expected";
                if (
                  null != A.hasRotation &&
                  A.hasOwnProperty("hasRotation") &&
                  "boolean" != typeof A.hasRotation
                )
                  return "hasRotation: boolean expected";
                if (null != A.rotation && A.hasOwnProperty("rotation") && !_a.isInteger(A.rotation))
                  return "rotation: integer expected";
                if (
                  null != A.hasTiltX &&
                  A.hasOwnProperty("hasTiltX") &&
                  "boolean" != typeof A.hasTiltX
                )
                  return "hasTiltX: boolean expected";
                if (null != A.tiltX && A.hasOwnProperty("tiltX") && !_a.isInteger(A.tiltX))
                  return "tiltX: integer expected";
                if (
                  null != A.hasTiltY &&
                  A.hasOwnProperty("hasTiltY") &&
                  "boolean" != typeof A.hasTiltY
                )
                  return "hasTiltY: boolean expected";
                if (null != A.tiltY && A.hasOwnProperty("tiltY") && !_a.isInteger(A.tiltY))
                  return "tiltY: integer expected";
                if (null != A.stylusButtons && A.hasOwnProperty("stylusButtons")) {
                  if (!Array.isArray(A.stylusButtons)) return "stylusButtons: array expected";
                  for (let e = 0; e < A.stylusButtons.length; ++e)
                    switch (A.stylusButtons[e]) {
                      default:
                        return "stylusButtons: enum value[] expected";
                      case 0:
                      case 1:
                      case 2:
                      case 3:
                    }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.StylusEvent) return A;
                let e = new Xa.dcv.input.StylusEvent();
                if (
                  (null != A.pointerId && (e.pointerId = A.pointerId >>> 0),
                  null != A.x && (e.x = 0 | A.x),
                  null != A.y && (e.y = 0 | A.y),
                  null != A.inverted && (e.inverted = Boolean(A.inverted)),
                  null != A.inAir && (e.inAir = Boolean(A.inAir)),
                  null != A.hasPressure && (e.hasPressure = Boolean(A.hasPressure)),
                  null != A.pressure && (e.pressure = Number(A.pressure)),
                  null != A.hasRotation && (e.hasRotation = Boolean(A.hasRotation)),
                  null != A.rotation && (e.rotation = A.rotation >>> 0),
                  null != A.hasTiltX && (e.hasTiltX = Boolean(A.hasTiltX)),
                  null != A.tiltX && (e.tiltX = 0 | A.tiltX),
                  null != A.hasTiltY && (e.hasTiltY = Boolean(A.hasTiltY)),
                  null != A.tiltY && (e.tiltY = 0 | A.tiltY),
                  A.stylusButtons)
                ) {
                  if (!Array.isArray(A.stylusButtons))
                    throw TypeError(".dcv.input.StylusEvent.stylusButtons: array expected");
                  e.stylusButtons = [];
                  for (let t = 0; t < A.stylusButtons.length; ++t)
                    switch (A.stylusButtons[t]) {
                      default:
                        if ("number" == typeof A.stylusButtons[t]) {
                          e.stylusButtons[t] = A.stylusButtons[t];
                          break;
                        }
                      case "STYLUS_BUTTON_1":
                      case 0:
                        e.stylusButtons[t] = 0;
                        break;
                      case "STYLUS_BUTTON_2":
                      case 1:
                        e.stylusButtons[t] = 1;
                        break;
                      case "STYLUS_BUTTON_3":
                      case 2:
                        e.stylusButtons[t] = 2;
                        break;
                      case "STYLUS_BUTTON_4":
                      case 3:
                        e.stylusButtons[t] = 3;
                    }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.stylusButtons = []), e.defaults))
                  if (
                    ((t.pointerId = 0),
                    (t.x = 0),
                    (t.y = 0),
                    (t.inverted = !1),
                    (t.inAir = !1),
                    (t.hasPressure = !1),
                    (t.pressure = 0),
                    (t.hasRotation = !1),
                    (t.rotation = 0),
                    (t.hasTiltX = !1),
                    (t.tiltX = 0),
                    (t.hasTiltY = !1),
                    (t.tiltY = 0),
                    _a.Long)
                  ) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.pointerId &&
                    A.hasOwnProperty("pointerId") &&
                    (t.pointerId = A.pointerId),
                  null != A.x && A.hasOwnProperty("x") && (t.x = A.x),
                  null != A.y && A.hasOwnProperty("y") && (t.y = A.y),
                  null != A.inverted && A.hasOwnProperty("inverted") && (t.inverted = A.inverted),
                  null != A.inAir && A.hasOwnProperty("inAir") && (t.inAir = A.inAir),
                  null != A.hasPressure &&
                    A.hasOwnProperty("hasPressure") &&
                    (t.hasPressure = A.hasPressure),
                  null != A.pressure &&
                    A.hasOwnProperty("pressure") &&
                    (t.pressure =
                      e.json && !isFinite(A.pressure) ? String(A.pressure) : A.pressure),
                  null != A.hasRotation &&
                    A.hasOwnProperty("hasRotation") &&
                    (t.hasRotation = A.hasRotation),
                  null != A.rotation && A.hasOwnProperty("rotation") && (t.rotation = A.rotation),
                  null != A.hasTiltX && A.hasOwnProperty("hasTiltX") && (t.hasTiltX = A.hasTiltX),
                  null != A.tiltX && A.hasOwnProperty("tiltX") && (t.tiltX = A.tiltX),
                  null != A.hasTiltY && A.hasOwnProperty("hasTiltY") && (t.hasTiltY = A.hasTiltY),
                  null != A.tiltY && A.hasOwnProperty("tiltY") && (t.tiltY = A.tiltY),
                  A.stylusButtons && A.stylusButtons.length)
                ) {
                  t.stylusButtons = [];
                  for (let i = 0; i < A.stylusButtons.length; ++i)
                    t.stylusButtons[i] =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.StylusButton[A.stylusButtons[i]]
                          ? A.stylusButtons[i]
                          : Xa.dcv.input.StylusButton[A.stylusButtons[i]]
                        : A.stylusButtons[i];
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.StylusEvent";
              }),
              A
            );
          })()),
          (A.GamepadType = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "GAMEPAD_TYPE_NONE")] = 0),
              (e[(A[1] = "GAMEPAD_TYPE_X360")] = 1),
              (e[(A[2] = "GAMEPAD_TYPE_DS4")] = 2),
              e
            );
          })()),
          (A.GamepadConnectionRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.deviceId = 0),
              (A.prototype.deviceType = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.deviceId &&
                    Object.hasOwnProperty.call(A, "deviceId") &&
                    e.uint32(8).uint32(A.deviceId),
                  null != A.deviceType &&
                    Object.hasOwnProperty.call(A, "deviceType") &&
                    e.uint32(16).int32(A.deviceType),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadConnectionRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.deviceId = A.uint32();
                      break;
                    case 2:
                      i.deviceType = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.deviceId && A.hasOwnProperty("deviceId") && !_a.isInteger(A.deviceId))
                  return "deviceId: integer expected";
                if (null != A.deviceType && A.hasOwnProperty("deviceType"))
                  switch (A.deviceType) {
                    default:
                      return "deviceType: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadConnectionRequest) return A;
                let e = new Xa.dcv.input.GamepadConnectionRequest();
                switch ((null != A.deviceId && (e.deviceId = A.deviceId >>> 0), A.deviceType)) {
                  default:
                    if ("number" == typeof A.deviceType) {
                      e.deviceType = A.deviceType;
                      break;
                    }
                    break;
                  case "GAMEPAD_TYPE_NONE":
                  case 0:
                    e.deviceType = 0;
                    break;
                  case "GAMEPAD_TYPE_X360":
                  case 1:
                    e.deviceType = 1;
                    break;
                  case "GAMEPAD_TYPE_DS4":
                  case 2:
                    e.deviceType = 2;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.deviceId = 0),
                    (t.deviceType = e.enums === String ? "GAMEPAD_TYPE_NONE" : 0)),
                  null != A.deviceId && A.hasOwnProperty("deviceId") && (t.deviceId = A.deviceId),
                  null != A.deviceType &&
                    A.hasOwnProperty("deviceType") &&
                    (t.deviceType =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.GamepadType[A.deviceType]
                          ? A.deviceType
                          : Xa.dcv.input.GamepadType[A.deviceType]
                        : A.deviceType),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.GamepadConnectionRequest"
                );
              }),
              A
            );
          })()),
          (A.GamepadConnectionResponse = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.deviceId = 0),
              (A.prototype.result = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.deviceId &&
                    Object.hasOwnProperty.call(A, "deviceId") &&
                    e.uint32(8).uint32(A.deviceId),
                  null != A.result &&
                    Object.hasOwnProperty.call(A, "result") &&
                    e.uint32(80).int32(A.result),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadConnectionResponse();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.deviceId = A.uint32();
                      break;
                    case 10:
                      i.result = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.deviceId && A.hasOwnProperty("deviceId") && !_a.isInteger(A.deviceId))
                  return "deviceId: integer expected";
                if (null != A.result && A.hasOwnProperty("result"))
                  switch (A.result) {
                    default:
                      return "result: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadConnectionResponse) return A;
                let e = new Xa.dcv.input.GamepadConnectionResponse();
                switch ((null != A.deviceId && (e.deviceId = A.deviceId >>> 0), A.result)) {
                  default:
                    if ("number" == typeof A.result) {
                      e.result = A.result;
                      break;
                    }
                    break;
                  case "GAMEPAD_CONNECTION_RESPONSE_UNSET":
                  case 0:
                    e.result = 0;
                    break;
                  case "GAMEPAD_CONNECTION_RESPONSE_SUCCESS":
                  case 1:
                    e.result = 1;
                    break;
                  case "GAMEPAD_CONNECTION_RESPONSE_ALREADY_CONNECTED":
                  case 2:
                    e.result = 2;
                    break;
                  case "GAMEPAD_CONNECTION_RESPONSE_TYPE_NOT_SUPPORTED":
                  case 3:
                    e.result = 3;
                    break;
                  case "GAMEPAD_CONNECTION_RESPONSE_CONNECTION_FAILED":
                  case 4:
                    e.result = 4;
                    break;
                  case "GAMEPAD_CONNECTION_RESPONSE_MAX_GAMEPADS_CONNECTED":
                  case 5:
                    e.result = 5;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.deviceId = 0),
                    (t.result = e.enums === String ? "GAMEPAD_CONNECTION_RESPONSE_UNSET" : 0)),
                  null != A.deviceId && A.hasOwnProperty("deviceId") && (t.deviceId = A.deviceId),
                  null != A.result &&
                    A.hasOwnProperty("result") &&
                    (t.result =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.GamepadConnectionResponse.Result[A.result]
                          ? A.result
                          : Xa.dcv.input.GamepadConnectionResponse.Result[A.result]
                        : A.result),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.GamepadConnectionResponse"
                );
              }),
              (A.Result = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "GAMEPAD_CONNECTION_RESPONSE_UNSET")] = 0),
                  (e[(A[1] = "GAMEPAD_CONNECTION_RESPONSE_SUCCESS")] = 1),
                  (e[(A[2] = "GAMEPAD_CONNECTION_RESPONSE_ALREADY_CONNECTED")] = 2),
                  (e[(A[3] = "GAMEPAD_CONNECTION_RESPONSE_TYPE_NOT_SUPPORTED")] = 3),
                  (e[(A[4] = "GAMEPAD_CONNECTION_RESPONSE_CONNECTION_FAILED")] = 4),
                  (e[(A[5] = "GAMEPAD_CONNECTION_RESPONSE_MAX_GAMEPADS_CONNECTED")] = 5),
                  e
                );
              })()),
              A
            );
          })()),
          (A.GamepadDisconnectionRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.deviceId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.deviceId &&
                    Object.hasOwnProperty.call(A, "deviceId") &&
                    e.uint32(8).uint32(A.deviceId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadDisconnectionRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.deviceId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.deviceId && A.hasOwnProperty("deviceId") && !_a.isInteger(A.deviceId)
                    ? "deviceId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadDisconnectionRequest) return A;
                let e = new Xa.dcv.input.GamepadDisconnectionRequest();
                return null != A.deviceId && (e.deviceId = A.deviceId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.deviceId = 0),
                  null != A.deviceId && A.hasOwnProperty("deviceId") && (t.deviceId = A.deviceId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.GamepadDisconnectionRequest"
                );
              }),
              A
            );
          })()),
          (A.GamepadDisconnected = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.deviceId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.deviceId &&
                    Object.hasOwnProperty.call(A, "deviceId") &&
                    e.uint32(8).uint32(A.deviceId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadDisconnected();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.deviceId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.deviceId && A.hasOwnProperty("deviceId") && !_a.isInteger(A.deviceId)
                    ? "deviceId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadDisconnected) return A;
                let e = new Xa.dcv.input.GamepadDisconnected();
                return null != A.deviceId && (e.deviceId = A.deviceId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.deviceId = 0),
                  null != A.deviceId && A.hasOwnProperty("deviceId") && (t.deviceId = A.deviceId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.GamepadDisconnected"
                );
              }),
              A
            );
          })()),
          (A.GamepadButton = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.buttonId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.buttonId &&
                    Object.hasOwnProperty.call(A, "buttonId") &&
                    e.uint32(8).uint32(A.buttonId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadButton();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.buttonId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.buttonId && A.hasOwnProperty("buttonId") && !_a.isInteger(A.buttonId)
                    ? "buttonId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadButton) return A;
                let e = new Xa.dcv.input.GamepadButton();
                return null != A.buttonId && (e.buttonId = A.buttonId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.buttonId = 0),
                  null != A.buttonId && A.hasOwnProperty("buttonId") && (t.buttonId = A.buttonId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.GamepadButton";
              }),
              A
            );
          })()),
          (A.GamepadAxis = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.axisId = 0),
              (A.prototype.value = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.axisId &&
                    Object.hasOwnProperty.call(A, "axisId") &&
                    e.uint32(8).uint32(A.axisId),
                  null != A.value &&
                    Object.hasOwnProperty.call(A, "value") &&
                    e.uint32(17).double(A.value),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadAxis();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.axisId = A.uint32();
                      break;
                    case 2:
                      i.value = A.double();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.axisId && A.hasOwnProperty("axisId") && !_a.isInteger(A.axisId)
                    ? "axisId: integer expected"
                    : null != A.value && A.hasOwnProperty("value") && "number" != typeof A.value
                      ? "value: number expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadAxis) return A;
                let e = new Xa.dcv.input.GamepadAxis();
                return (
                  null != A.axisId && (e.axisId = A.axisId >>> 0),
                  null != A.value && (e.value = Number(A.value)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.axisId = 0), (t.value = 0)),
                  null != A.axisId && A.hasOwnProperty("axisId") && (t.axisId = A.axisId),
                  null != A.value &&
                    A.hasOwnProperty("value") &&
                    (t.value = e.json && !isFinite(A.value) ? String(A.value) : A.value),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.GamepadAxis";
              }),
              A
            );
          })()),
          (A.GamepadEvent = (function () {
            function A(A) {
              if (((this.buttonsPressed = []), (this.axesMoved = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.deviceId = 0),
              (A.prototype.buttonsPressed = _a.emptyArray),
              (A.prototype.axesMoved = _a.emptyArray),
              (A.prototype.estimatedTimestamp = _a.Long ? _a.Long.fromBits(0, 0, !1) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.deviceId &&
                    Object.hasOwnProperty.call(A, "deviceId") &&
                    e.uint32(8).uint32(A.deviceId),
                  null != A.buttonsPressed && A.buttonsPressed.length)
                )
                  for (let t = 0; t < A.buttonsPressed.length; ++t)
                    Xa.dcv.input.GamepadButton.encode(
                      A.buttonsPressed[t],
                      e.uint32(18).fork()
                    ).ldelim();
                if (null != A.axesMoved && A.axesMoved.length)
                  for (let t = 0; t < A.axesMoved.length; ++t)
                    Xa.dcv.input.GamepadAxis.encode(A.axesMoved[t], e.uint32(26).fork()).ldelim();
                return (
                  null != A.estimatedTimestamp &&
                    Object.hasOwnProperty.call(A, "estimatedTimestamp") &&
                    e.uint32(80).int64(A.estimatedTimestamp),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.deviceId = A.uint32();
                      break;
                    case 2:
                      (i.buttonsPressed && i.buttonsPressed.length) || (i.buttonsPressed = []),
                        i.buttonsPressed.push(Xa.dcv.input.GamepadButton.decode(A, A.uint32()));
                      break;
                    case 3:
                      (i.axesMoved && i.axesMoved.length) || (i.axesMoved = []),
                        i.axesMoved.push(Xa.dcv.input.GamepadAxis.decode(A, A.uint32()));
                      break;
                    case 10:
                      i.estimatedTimestamp = A.int64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.deviceId && A.hasOwnProperty("deviceId") && !_a.isInteger(A.deviceId))
                  return "deviceId: integer expected";
                if (null != A.buttonsPressed && A.hasOwnProperty("buttonsPressed")) {
                  if (!Array.isArray(A.buttonsPressed)) return "buttonsPressed: array expected";
                  for (let e = 0; e < A.buttonsPressed.length; ++e) {
                    let t = Xa.dcv.input.GamepadButton.verify(A.buttonsPressed[e]);
                    if (t) return "buttonsPressed." + t;
                  }
                }
                if (null != A.axesMoved && A.hasOwnProperty("axesMoved")) {
                  if (!Array.isArray(A.axesMoved)) return "axesMoved: array expected";
                  for (let e = 0; e < A.axesMoved.length; ++e) {
                    let t = Xa.dcv.input.GamepadAxis.verify(A.axesMoved[e]);
                    if (t) return "axesMoved." + t;
                  }
                }
                return null != A.estimatedTimestamp &&
                  A.hasOwnProperty("estimatedTimestamp") &&
                  !(
                    _a.isInteger(A.estimatedTimestamp) ||
                    (A.estimatedTimestamp &&
                      _a.isInteger(A.estimatedTimestamp.low) &&
                      _a.isInteger(A.estimatedTimestamp.high))
                  )
                  ? "estimatedTimestamp: integer|Long expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadEvent) return A;
                let e = new Xa.dcv.input.GamepadEvent();
                if ((null != A.deviceId && (e.deviceId = A.deviceId >>> 0), A.buttonsPressed)) {
                  if (!Array.isArray(A.buttonsPressed))
                    throw TypeError(".dcv.input.GamepadEvent.buttonsPressed: array expected");
                  e.buttonsPressed = [];
                  for (let t = 0; t < A.buttonsPressed.length; ++t) {
                    if ("object" != typeof A.buttonsPressed[t])
                      throw TypeError(".dcv.input.GamepadEvent.buttonsPressed: object expected");
                    e.buttonsPressed[t] = Xa.dcv.input.GamepadButton.fromObject(
                      A.buttonsPressed[t]
                    );
                  }
                }
                if (A.axesMoved) {
                  if (!Array.isArray(A.axesMoved))
                    throw TypeError(".dcv.input.GamepadEvent.axesMoved: array expected");
                  e.axesMoved = [];
                  for (let t = 0; t < A.axesMoved.length; ++t) {
                    if ("object" != typeof A.axesMoved[t])
                      throw TypeError(".dcv.input.GamepadEvent.axesMoved: object expected");
                    e.axesMoved[t] = Xa.dcv.input.GamepadAxis.fromObject(A.axesMoved[t]);
                  }
                }
                return (
                  null != A.estimatedTimestamp &&
                    (_a.Long
                      ? ((e.estimatedTimestamp = _a.Long.fromValue(A.estimatedTimestamp)).unsigned =
                          !1)
                      : "string" == typeof A.estimatedTimestamp
                        ? (e.estimatedTimestamp = parseInt(A.estimatedTimestamp, 10))
                        : "number" == typeof A.estimatedTimestamp
                          ? (e.estimatedTimestamp = A.estimatedTimestamp)
                          : "object" == typeof A.estimatedTimestamp &&
                            (e.estimatedTimestamp = new _a.LongBits(
                              A.estimatedTimestamp.low >>> 0,
                              A.estimatedTimestamp.high >>> 0
                            ).toNumber())),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && ((t.buttonsPressed = []), (t.axesMoved = [])),
                  e.defaults)
                )
                  if (((t.deviceId = 0), _a.Long)) {
                    let A = new _a.Long(0, 0, !1);
                    t.estimatedTimestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.estimatedTimestamp = e.longs === String ? "0" : 0;
                if (
                  (null != A.deviceId && A.hasOwnProperty("deviceId") && (t.deviceId = A.deviceId),
                  A.buttonsPressed && A.buttonsPressed.length)
                ) {
                  t.buttonsPressed = [];
                  for (let i = 0; i < A.buttonsPressed.length; ++i)
                    t.buttonsPressed[i] = Xa.dcv.input.GamepadButton.toObject(
                      A.buttonsPressed[i],
                      e
                    );
                }
                if (A.axesMoved && A.axesMoved.length) {
                  t.axesMoved = [];
                  for (let i = 0; i < A.axesMoved.length; ++i)
                    t.axesMoved[i] = Xa.dcv.input.GamepadAxis.toObject(A.axesMoved[i], e);
                }
                return (
                  null != A.estimatedTimestamp &&
                    A.hasOwnProperty("estimatedTimestamp") &&
                    ("number" == typeof A.estimatedTimestamp
                      ? (t.estimatedTimestamp =
                          e.longs === String ? String(A.estimatedTimestamp) : A.estimatedTimestamp)
                      : (t.estimatedTimestamp =
                          e.longs === String
                            ? _a.Long.prototype.toString.call(A.estimatedTimestamp)
                            : e.longs === Number
                              ? new _a.LongBits(
                                  A.estimatedTimestamp.low >>> 0,
                                  A.estimatedTimestamp.high >>> 0
                                ).toNumber()
                              : A.estimatedTimestamp)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.GamepadEvent";
              }),
              A
            );
          })()),
          (A.MotorVibration = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.motorId = 0),
              (A.prototype.intensity = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.motorId &&
                    Object.hasOwnProperty.call(A, "motorId") &&
                    e.uint32(8).uint32(A.motorId),
                  null != A.intensity &&
                    Object.hasOwnProperty.call(A, "intensity") &&
                    e.uint32(17).double(A.intensity),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.MotorVibration();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.motorId = A.uint32();
                      break;
                    case 2:
                      i.intensity = A.double();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.motorId && A.hasOwnProperty("motorId") && !_a.isInteger(A.motorId)
                    ? "motorId: integer expected"
                    : null != A.intensity &&
                        A.hasOwnProperty("intensity") &&
                        "number" != typeof A.intensity
                      ? "intensity: number expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.MotorVibration) return A;
                let e = new Xa.dcv.input.MotorVibration();
                return (
                  null != A.motorId && (e.motorId = A.motorId >>> 0),
                  null != A.intensity && (e.intensity = Number(A.intensity)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.motorId = 0), (t.intensity = 0)),
                  null != A.motorId && A.hasOwnProperty("motorId") && (t.motorId = A.motorId),
                  null != A.intensity &&
                    A.hasOwnProperty("intensity") &&
                    (t.intensity =
                      e.json && !isFinite(A.intensity) ? String(A.intensity) : A.intensity),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.MotorVibration";
              }),
              A
            );
          })()),
          (A.GamepadVibration = (function () {
            function A(A) {
              if (((this.motors = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.deviceId = 0),
              (A.prototype.motors = _a.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Va.create()),
                  null != A.deviceId &&
                    Object.hasOwnProperty.call(A, "deviceId") &&
                    e.uint32(8).uint32(A.deviceId),
                  null != A.motors && A.motors.length)
                )
                  for (let t = 0; t < A.motors.length; ++t)
                    Xa.dcv.input.MotorVibration.encode(A.motors[t], e.uint32(18).fork()).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.GamepadVibration();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.deviceId = A.uint32();
                      break;
                    case 2:
                      (i.motors && i.motors.length) || (i.motors = []),
                        i.motors.push(Xa.dcv.input.MotorVibration.decode(A, A.uint32()));
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.deviceId && A.hasOwnProperty("deviceId") && !_a.isInteger(A.deviceId))
                  return "deviceId: integer expected";
                if (null != A.motors && A.hasOwnProperty("motors")) {
                  if (!Array.isArray(A.motors)) return "motors: array expected";
                  for (let e = 0; e < A.motors.length; ++e) {
                    let t = Xa.dcv.input.MotorVibration.verify(A.motors[e]);
                    if (t) return "motors." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.GamepadVibration) return A;
                let e = new Xa.dcv.input.GamepadVibration();
                if ((null != A.deviceId && (e.deviceId = A.deviceId >>> 0), A.motors)) {
                  if (!Array.isArray(A.motors))
                    throw TypeError(".dcv.input.GamepadVibration.motors: array expected");
                  e.motors = [];
                  for (let t = 0; t < A.motors.length; ++t) {
                    if ("object" != typeof A.motors[t])
                      throw TypeError(".dcv.input.GamepadVibration.motors: object expected");
                    e.motors[t] = Xa.dcv.input.MotorVibration.fromObject(A.motors[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.motors = []),
                  e.defaults && (t.deviceId = 0),
                  null != A.deviceId && A.hasOwnProperty("deviceId") && (t.deviceId = A.deviceId),
                  A.motors && A.motors.length)
                ) {
                  t.motors = [];
                  for (let i = 0; i < A.motors.length; ++i)
                    t.motors[i] = Xa.dcv.input.MotorVibration.toObject(A.motors[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.GamepadVibration"
                );
              }),
              A
            );
          })()),
          (A.WebauthnRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.id = ""),
              (A.prototype.request = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.id && Object.hasOwnProperty.call(A, "id") && e.uint32(10).string(A.id),
                  null != A.request &&
                    Object.hasOwnProperty.call(A, "request") &&
                    e.uint32(18).string(A.request),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.WebauthnRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.id = A.string();
                      break;
                    case 2:
                      i.request = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.id && A.hasOwnProperty("id") && !_a.isString(A.id)
                    ? "id: string expected"
                    : null != A.request && A.hasOwnProperty("request") && !_a.isString(A.request)
                      ? "request: string expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.WebauthnRequest) return A;
                let e = new Xa.dcv.input.WebauthnRequest();
                return (
                  null != A.id && (e.id = String(A.id)),
                  null != A.request && (e.request = String(A.request)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.id = ""), (t.request = "")),
                  null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                  null != A.request && A.hasOwnProperty("request") && (t.request = A.request),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.WebauthnRequest"
                );
              }),
              A
            );
          })()),
          (A.WebauthnResponse = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.id = ""),
              (A.prototype.response = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.id && Object.hasOwnProperty.call(A, "id") && e.uint32(10).string(A.id),
                  null != A.response &&
                    Object.hasOwnProperty.call(A, "response") &&
                    e.uint32(18).string(A.response),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.WebauthnResponse();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.id = A.string();
                      break;
                    case 2:
                      i.response = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.id && A.hasOwnProperty("id") && !_a.isString(A.id)
                    ? "id: string expected"
                    : null != A.response && A.hasOwnProperty("response") && !_a.isString(A.response)
                      ? "response: string expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.WebauthnResponse) return A;
                let e = new Xa.dcv.input.WebauthnResponse();
                return (
                  null != A.id && (e.id = String(A.id)),
                  null != A.response && (e.response = String(A.response)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.id = ""), (t.response = "")),
                  null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                  null != A.response && A.hasOwnProperty("response") && (t.response = A.response),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.WebauthnResponse"
                );
              }),
              A
            );
          })()),
          (A.WebauthnClientCapability = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.version = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.version &&
                    Object.hasOwnProperty.call(A, "version") &&
                    e.uint32(8).uint32(A.version),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.WebauthnClientCapability();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.version = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.version && A.hasOwnProperty("version") && !_a.isInteger(A.version)
                    ? "version: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.WebauthnClientCapability) return A;
                let e = new Xa.dcv.input.WebauthnClientCapability();
                return null != A.version && (e.version = A.version >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.version = 0),
                  null != A.version && A.hasOwnProperty("version") && (t.version = A.version),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.WebauthnClientCapability"
                );
              }),
              A
            );
          })()),
          (A.WebauthnCancelRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.id = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.id && Object.hasOwnProperty.call(A, "id") && e.uint32(10).string(A.id),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.WebauthnCancelRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.id = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.id && A.hasOwnProperty("id") && !_a.isString(A.id)
                    ? "id: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.WebauthnCancelRequest) return A;
                let e = new Xa.dcv.input.WebauthnCancelRequest();
                return null != A.id && (e.id = String(A.id)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.id = ""),
                  null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.input.WebauthnCancelRequest"
                );
              }),
              A
            );
          })()),
          (A.Status = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "NOT_AVAILABLE")] = 0),
              (e[(A[1] = "AVAILABLE")] = 1),
              (e[(A[2] = "ACTIVE")] = 2),
              (e[(A[3] = "BUSY")] = 3),
              e
            );
          })()),
          (A.InputService = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "KEYBOARD")] = 0),
              (e[(A[1] = "MOUSE")] = 1),
              (e[(A[2] = "TOUCH")] = 2),
              (e[(A[3] = "POINTER")] = 3),
              (e[(A[4] = "STYLUS")] = 4),
              (e[(A[5] = "GAMEPAD")] = 5),
              (e[(A[10] = "SAS")] = 10),
              (e[(A[20] = "WEBAUTHN")] = 20),
              e
            );
          })()),
          (A.StatusUpdate = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.inputService = 0),
              (A.prototype.inputStatus = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.inputService &&
                    Object.hasOwnProperty.call(A, "inputService") &&
                    e.uint32(8).int32(A.inputService),
                  null != A.inputStatus &&
                    Object.hasOwnProperty.call(A, "inputStatus") &&
                    e.uint32(16).int32(A.inputStatus),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.StatusUpdate();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.inputService = A.int32();
                      break;
                    case 2:
                      i.inputStatus = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.inputService && A.hasOwnProperty("inputService"))
                  switch (A.inputService) {
                    default:
                      return "inputService: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 10:
                    case 20:
                  }
                if (null != A.inputStatus && A.hasOwnProperty("inputStatus"))
                  switch (A.inputStatus) {
                    default:
                      return "inputStatus: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.StatusUpdate) return A;
                let e = new Xa.dcv.input.StatusUpdate();
                switch (A.inputService) {
                  default:
                    if ("number" == typeof A.inputService) {
                      e.inputService = A.inputService;
                      break;
                    }
                    break;
                  case "KEYBOARD":
                  case 0:
                    e.inputService = 0;
                    break;
                  case "MOUSE":
                  case 1:
                    e.inputService = 1;
                    break;
                  case "TOUCH":
                  case 2:
                    e.inputService = 2;
                    break;
                  case "POINTER":
                  case 3:
                    e.inputService = 3;
                    break;
                  case "STYLUS":
                  case 4:
                    e.inputService = 4;
                    break;
                  case "GAMEPAD":
                  case 5:
                    e.inputService = 5;
                    break;
                  case "SAS":
                  case 10:
                    e.inputService = 10;
                    break;
                  case "WEBAUTHN":
                  case 20:
                    e.inputService = 20;
                }
                switch (A.inputStatus) {
                  default:
                    if ("number" == typeof A.inputStatus) {
                      e.inputStatus = A.inputStatus;
                      break;
                    }
                    break;
                  case "NOT_AVAILABLE":
                  case 0:
                    e.inputStatus = 0;
                    break;
                  case "AVAILABLE":
                  case 1:
                    e.inputStatus = 1;
                    break;
                  case "ACTIVE":
                  case 2:
                    e.inputStatus = 2;
                    break;
                  case "BUSY":
                  case 3:
                    e.inputStatus = 3;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.inputService = e.enums === String ? "KEYBOARD" : 0),
                    (t.inputStatus = e.enums === String ? "NOT_AVAILABLE" : 0)),
                  null != A.inputService &&
                    A.hasOwnProperty("inputService") &&
                    (t.inputService =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.InputService[A.inputService]
                          ? A.inputService
                          : Xa.dcv.input.InputService[A.inputService]
                        : A.inputService),
                  null != A.inputStatus &&
                    A.hasOwnProperty("inputStatus") &&
                    (t.inputStatus =
                      e.enums === String
                        ? void 0 === Xa.dcv.input.Status[A.inputStatus]
                          ? A.inputStatus
                          : Xa.dcv.input.Status[A.inputStatus]
                        : A.inputStatus),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.StatusUpdate";
              }),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.preferences = null),
              (A.prototype.pointerMotionEvent = null),
              (A.prototype.pointerRelativeMotionEvent = null),
              (A.prototype.pointerRequireCursorImages = null),
              (A.prototype.pointerButtonPressEvent = null),
              (A.prototype.pointerButtonReleaseEvent = null),
              (A.prototype.pointerAxisEvent = null),
              (A.prototype.keyDownEvent = null),
              (A.prototype.keyUpEvent = null),
              (A.prototype.specialKeyDownEvent = null),
              (A.prototype.specialKeyUpEvent = null),
              (A.prototype.touchEvent = null),
              (A.prototype.stylusEvent = null),
              (A.prototype.gamepadEvent = null),
              (A.prototype.gamepadConnectionRequest = null),
              (A.prototype.gamepadDisconnectionRequest = null),
              (A.prototype.webauthnResponse = null),
              (A.prototype.webauthnClientCapability = null),
              Object.defineProperty(A.prototype, "msg", {
                get: _a.oneOfGetter(
                  (e = [
                    "preferences",
                    "pointerMotionEvent",
                    "pointerRelativeMotionEvent",
                    "pointerRequireCursorImages",
                    "pointerButtonPressEvent",
                    "pointerButtonReleaseEvent",
                    "pointerAxisEvent",
                    "keyDownEvent",
                    "keyUpEvent",
                    "specialKeyDownEvent",
                    "specialKeyUpEvent",
                    "touchEvent",
                    "stylusEvent",
                    "gamepadEvent",
                    "gamepadConnectionRequest",
                    "gamepadDisconnectionRequest",
                    "webauthnResponse",
                    "webauthnClientCapability"
                  ])
                ),
                set: _a.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.preferences &&
                    Object.hasOwnProperty.call(A, "preferences") &&
                    Xa.dcv.input.Preferences.encode(A.preferences, e.uint32(82).fork()).ldelim(),
                  null != A.pointerMotionEvent &&
                    Object.hasOwnProperty.call(A, "pointerMotionEvent") &&
                    Xa.dcv.input.PointerMotionEvent.encode(
                      A.pointerMotionEvent,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.pointerRelativeMotionEvent &&
                    Object.hasOwnProperty.call(A, "pointerRelativeMotionEvent") &&
                    Xa.dcv.input.PointerRelativeMotionEvent.encode(
                      A.pointerRelativeMotionEvent,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.pointerRequireCursorImages &&
                    Object.hasOwnProperty.call(A, "pointerRequireCursorImages") &&
                    Xa.dcv.input.PointerRequireCursorImages.encode(
                      A.pointerRequireCursorImages,
                      e.uint32(322).fork()
                    ).ldelim(),
                  null != A.pointerButtonPressEvent &&
                    Object.hasOwnProperty.call(A, "pointerButtonPressEvent") &&
                    Xa.dcv.input.PointerButtonPressEvent.encode(
                      A.pointerButtonPressEvent,
                      e.uint32(402).fork()
                    ).ldelim(),
                  null != A.pointerButtonReleaseEvent &&
                    Object.hasOwnProperty.call(A, "pointerButtonReleaseEvent") &&
                    Xa.dcv.input.PointerButtonReleaseEvent.encode(
                      A.pointerButtonReleaseEvent,
                      e.uint32(410).fork()
                    ).ldelim(),
                  null != A.pointerAxisEvent &&
                    Object.hasOwnProperty.call(A, "pointerAxisEvent") &&
                    Xa.dcv.input.PointerAxisEvent.encode(
                      A.pointerAxisEvent,
                      e.uint32(482).fork()
                    ).ldelim(),
                  null != A.keyDownEvent &&
                    Object.hasOwnProperty.call(A, "keyDownEvent") &&
                    Xa.dcv.input.KeyDownEvent.encode(A.keyDownEvent, e.uint32(802).fork()).ldelim(),
                  null != A.keyUpEvent &&
                    Object.hasOwnProperty.call(A, "keyUpEvent") &&
                    Xa.dcv.input.KeyUpEvent.encode(A.keyUpEvent, e.uint32(810).fork()).ldelim(),
                  null != A.specialKeyDownEvent &&
                    Object.hasOwnProperty.call(A, "specialKeyDownEvent") &&
                    Xa.dcv.input.SpecialKeyDownEvent.encode(
                      A.specialKeyDownEvent,
                      e.uint32(818).fork()
                    ).ldelim(),
                  null != A.specialKeyUpEvent &&
                    Object.hasOwnProperty.call(A, "specialKeyUpEvent") &&
                    Xa.dcv.input.SpecialKeyUpEvent.encode(
                      A.specialKeyUpEvent,
                      e.uint32(826).fork()
                    ).ldelim(),
                  null != A.touchEvent &&
                    Object.hasOwnProperty.call(A, "touchEvent") &&
                    Xa.dcv.input.TouchEvent.encode(A.touchEvent, e.uint32(882).fork()).ldelim(),
                  null != A.stylusEvent &&
                    Object.hasOwnProperty.call(A, "stylusEvent") &&
                    Xa.dcv.input.StylusEvent.encode(A.stylusEvent, e.uint32(962).fork()).ldelim(),
                  null != A.gamepadEvent &&
                    Object.hasOwnProperty.call(A, "gamepadEvent") &&
                    Xa.dcv.input.GamepadEvent.encode(
                      A.gamepadEvent,
                      e.uint32(1122).fork()
                    ).ldelim(),
                  null != A.gamepadConnectionRequest &&
                    Object.hasOwnProperty.call(A, "gamepadConnectionRequest") &&
                    Xa.dcv.input.GamepadConnectionRequest.encode(
                      A.gamepadConnectionRequest,
                      e.uint32(1130).fork()
                    ).ldelim(),
                  null != A.gamepadDisconnectionRequest &&
                    Object.hasOwnProperty.call(A, "gamepadDisconnectionRequest") &&
                    Xa.dcv.input.GamepadDisconnectionRequest.encode(
                      A.gamepadDisconnectionRequest,
                      e.uint32(1138).fork()
                    ).ldelim(),
                  null != A.webauthnResponse &&
                    Object.hasOwnProperty.call(A, "webauthnResponse") &&
                    Xa.dcv.input.WebauthnResponse.encode(
                      A.webauthnResponse,
                      e.uint32(1202).fork()
                    ).ldelim(),
                  null != A.webauthnClientCapability &&
                    Object.hasOwnProperty.call(A, "webauthnClientCapability") &&
                    Xa.dcv.input.WebauthnClientCapability.encode(
                      A.webauthnClientCapability,
                      e.uint32(1210).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.preferences = Xa.dcv.input.Preferences.decode(A, A.uint32());
                      break;
                    case 20:
                      i.pointerMotionEvent = Xa.dcv.input.PointerMotionEvent.decode(A, A.uint32());
                      break;
                    case 30:
                      i.pointerRelativeMotionEvent = Xa.dcv.input.PointerRelativeMotionEvent.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 40:
                      i.pointerRequireCursorImages = Xa.dcv.input.PointerRequireCursorImages.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 50:
                      i.pointerButtonPressEvent = Xa.dcv.input.PointerButtonPressEvent.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 51:
                      i.pointerButtonReleaseEvent = Xa.dcv.input.PointerButtonReleaseEvent.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 60:
                      i.pointerAxisEvent = Xa.dcv.input.PointerAxisEvent.decode(A, A.uint32());
                      break;
                    case 100:
                      i.keyDownEvent = Xa.dcv.input.KeyDownEvent.decode(A, A.uint32());
                      break;
                    case 101:
                      i.keyUpEvent = Xa.dcv.input.KeyUpEvent.decode(A, A.uint32());
                      break;
                    case 102:
                      i.specialKeyDownEvent = Xa.dcv.input.SpecialKeyDownEvent.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 103:
                      i.specialKeyUpEvent = Xa.dcv.input.SpecialKeyUpEvent.decode(A, A.uint32());
                      break;
                    case 110:
                      i.touchEvent = Xa.dcv.input.TouchEvent.decode(A, A.uint32());
                      break;
                    case 120:
                      i.stylusEvent = Xa.dcv.input.StylusEvent.decode(A, A.uint32());
                      break;
                    case 140:
                      i.gamepadEvent = Xa.dcv.input.GamepadEvent.decode(A, A.uint32());
                      break;
                    case 141:
                      i.gamepadConnectionRequest = Xa.dcv.input.GamepadConnectionRequest.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 142:
                      i.gamepadDisconnectionRequest =
                        Xa.dcv.input.GamepadDisconnectionRequest.decode(A, A.uint32());
                      break;
                    case 150:
                      i.webauthnResponse = Xa.dcv.input.WebauthnResponse.decode(A, A.uint32());
                      break;
                    case 151:
                      i.webauthnClientCapability = Xa.dcv.input.WebauthnClientCapability.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.preferences && A.hasOwnProperty("preferences")) {
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.Preferences.verify(A.preferences);
                    if (e) return "preferences." + e;
                  }
                }
                if (null != A.pointerMotionEvent && A.hasOwnProperty("pointerMotionEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerMotionEvent.verify(A.pointerMotionEvent);
                    if (e) return "pointerMotionEvent." + e;
                  }
                }
                if (
                  null != A.pointerRelativeMotionEvent &&
                  A.hasOwnProperty("pointerRelativeMotionEvent")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerRelativeMotionEvent.verify(
                      A.pointerRelativeMotionEvent
                    );
                    if (e) return "pointerRelativeMotionEvent." + e;
                  }
                }
                if (
                  null != A.pointerRequireCursorImages &&
                  A.hasOwnProperty("pointerRequireCursorImages")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerRequireCursorImages.verify(
                      A.pointerRequireCursorImages
                    );
                    if (e) return "pointerRequireCursorImages." + e;
                  }
                }
                if (
                  null != A.pointerButtonPressEvent &&
                  A.hasOwnProperty("pointerButtonPressEvent")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerButtonPressEvent.verify(A.pointerButtonPressEvent);
                    if (e) return "pointerButtonPressEvent." + e;
                  }
                }
                if (
                  null != A.pointerButtonReleaseEvent &&
                  A.hasOwnProperty("pointerButtonReleaseEvent")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerButtonReleaseEvent.verify(
                      A.pointerButtonReleaseEvent
                    );
                    if (e) return "pointerButtonReleaseEvent." + e;
                  }
                }
                if (null != A.pointerAxisEvent && A.hasOwnProperty("pointerAxisEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerAxisEvent.verify(A.pointerAxisEvent);
                    if (e) return "pointerAxisEvent." + e;
                  }
                }
                if (null != A.keyDownEvent && A.hasOwnProperty("keyDownEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.KeyDownEvent.verify(A.keyDownEvent);
                    if (e) return "keyDownEvent." + e;
                  }
                }
                if (null != A.keyUpEvent && A.hasOwnProperty("keyUpEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.KeyUpEvent.verify(A.keyUpEvent);
                    if (e) return "keyUpEvent." + e;
                  }
                }
                if (null != A.specialKeyDownEvent && A.hasOwnProperty("specialKeyDownEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.SpecialKeyDownEvent.verify(A.specialKeyDownEvent);
                    if (e) return "specialKeyDownEvent." + e;
                  }
                }
                if (null != A.specialKeyUpEvent && A.hasOwnProperty("specialKeyUpEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.SpecialKeyUpEvent.verify(A.specialKeyUpEvent);
                    if (e) return "specialKeyUpEvent." + e;
                  }
                }
                if (null != A.touchEvent && A.hasOwnProperty("touchEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.TouchEvent.verify(A.touchEvent);
                    if (e) return "touchEvent." + e;
                  }
                }
                if (null != A.stylusEvent && A.hasOwnProperty("stylusEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.StylusEvent.verify(A.stylusEvent);
                    if (e) return "stylusEvent." + e;
                  }
                }
                if (null != A.gamepadEvent && A.hasOwnProperty("gamepadEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.GamepadEvent.verify(A.gamepadEvent);
                    if (e) return "gamepadEvent." + e;
                  }
                }
                if (
                  null != A.gamepadConnectionRequest &&
                  A.hasOwnProperty("gamepadConnectionRequest")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.GamepadConnectionRequest.verify(
                      A.gamepadConnectionRequest
                    );
                    if (e) return "gamepadConnectionRequest." + e;
                  }
                }
                if (
                  null != A.gamepadDisconnectionRequest &&
                  A.hasOwnProperty("gamepadDisconnectionRequest")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.GamepadDisconnectionRequest.verify(
                      A.gamepadDisconnectionRequest
                    );
                    if (e) return "gamepadDisconnectionRequest." + e;
                  }
                }
                if (null != A.webauthnResponse && A.hasOwnProperty("webauthnResponse")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.WebauthnResponse.verify(A.webauthnResponse);
                    if (e) return "webauthnResponse." + e;
                  }
                }
                if (
                  null != A.webauthnClientCapability &&
                  A.hasOwnProperty("webauthnClientCapability")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.WebauthnClientCapability.verify(
                      A.webauthnClientCapability
                    );
                    if (e) return "webauthnClientCapability." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.ClientMessage) return A;
                let e = new Xa.dcv.input.ClientMessage();
                if (null != A.preferences) {
                  if ("object" != typeof A.preferences)
                    throw TypeError(".dcv.input.ClientMessage.preferences: object expected");
                  e.preferences = Xa.dcv.input.Preferences.fromObject(A.preferences);
                }
                if (null != A.pointerMotionEvent) {
                  if ("object" != typeof A.pointerMotionEvent)
                    throw TypeError(".dcv.input.ClientMessage.pointerMotionEvent: object expected");
                  e.pointerMotionEvent = Xa.dcv.input.PointerMotionEvent.fromObject(
                    A.pointerMotionEvent
                  );
                }
                if (null != A.pointerRelativeMotionEvent) {
                  if ("object" != typeof A.pointerRelativeMotionEvent)
                    throw TypeError(
                      ".dcv.input.ClientMessage.pointerRelativeMotionEvent: object expected"
                    );
                  e.pointerRelativeMotionEvent = Xa.dcv.input.PointerRelativeMotionEvent.fromObject(
                    A.pointerRelativeMotionEvent
                  );
                }
                if (null != A.pointerRequireCursorImages) {
                  if ("object" != typeof A.pointerRequireCursorImages)
                    throw TypeError(
                      ".dcv.input.ClientMessage.pointerRequireCursorImages: object expected"
                    );
                  e.pointerRequireCursorImages = Xa.dcv.input.PointerRequireCursorImages.fromObject(
                    A.pointerRequireCursorImages
                  );
                }
                if (null != A.pointerButtonPressEvent) {
                  if ("object" != typeof A.pointerButtonPressEvent)
                    throw TypeError(
                      ".dcv.input.ClientMessage.pointerButtonPressEvent: object expected"
                    );
                  e.pointerButtonPressEvent = Xa.dcv.input.PointerButtonPressEvent.fromObject(
                    A.pointerButtonPressEvent
                  );
                }
                if (null != A.pointerButtonReleaseEvent) {
                  if ("object" != typeof A.pointerButtonReleaseEvent)
                    throw TypeError(
                      ".dcv.input.ClientMessage.pointerButtonReleaseEvent: object expected"
                    );
                  e.pointerButtonReleaseEvent = Xa.dcv.input.PointerButtonReleaseEvent.fromObject(
                    A.pointerButtonReleaseEvent
                  );
                }
                if (null != A.pointerAxisEvent) {
                  if ("object" != typeof A.pointerAxisEvent)
                    throw TypeError(".dcv.input.ClientMessage.pointerAxisEvent: object expected");
                  e.pointerAxisEvent = Xa.dcv.input.PointerAxisEvent.fromObject(A.pointerAxisEvent);
                }
                if (null != A.keyDownEvent) {
                  if ("object" != typeof A.keyDownEvent)
                    throw TypeError(".dcv.input.ClientMessage.keyDownEvent: object expected");
                  e.keyDownEvent = Xa.dcv.input.KeyDownEvent.fromObject(A.keyDownEvent);
                }
                if (null != A.keyUpEvent) {
                  if ("object" != typeof A.keyUpEvent)
                    throw TypeError(".dcv.input.ClientMessage.keyUpEvent: object expected");
                  e.keyUpEvent = Xa.dcv.input.KeyUpEvent.fromObject(A.keyUpEvent);
                }
                if (null != A.specialKeyDownEvent) {
                  if ("object" != typeof A.specialKeyDownEvent)
                    throw TypeError(
                      ".dcv.input.ClientMessage.specialKeyDownEvent: object expected"
                    );
                  e.specialKeyDownEvent = Xa.dcv.input.SpecialKeyDownEvent.fromObject(
                    A.specialKeyDownEvent
                  );
                }
                if (null != A.specialKeyUpEvent) {
                  if ("object" != typeof A.specialKeyUpEvent)
                    throw TypeError(".dcv.input.ClientMessage.specialKeyUpEvent: object expected");
                  e.specialKeyUpEvent = Xa.dcv.input.SpecialKeyUpEvent.fromObject(
                    A.specialKeyUpEvent
                  );
                }
                if (null != A.touchEvent) {
                  if ("object" != typeof A.touchEvent)
                    throw TypeError(".dcv.input.ClientMessage.touchEvent: object expected");
                  e.touchEvent = Xa.dcv.input.TouchEvent.fromObject(A.touchEvent);
                }
                if (null != A.stylusEvent) {
                  if ("object" != typeof A.stylusEvent)
                    throw TypeError(".dcv.input.ClientMessage.stylusEvent: object expected");
                  e.stylusEvent = Xa.dcv.input.StylusEvent.fromObject(A.stylusEvent);
                }
                if (null != A.gamepadEvent) {
                  if ("object" != typeof A.gamepadEvent)
                    throw TypeError(".dcv.input.ClientMessage.gamepadEvent: object expected");
                  e.gamepadEvent = Xa.dcv.input.GamepadEvent.fromObject(A.gamepadEvent);
                }
                if (null != A.gamepadConnectionRequest) {
                  if ("object" != typeof A.gamepadConnectionRequest)
                    throw TypeError(
                      ".dcv.input.ClientMessage.gamepadConnectionRequest: object expected"
                    );
                  e.gamepadConnectionRequest = Xa.dcv.input.GamepadConnectionRequest.fromObject(
                    A.gamepadConnectionRequest
                  );
                }
                if (null != A.gamepadDisconnectionRequest) {
                  if ("object" != typeof A.gamepadDisconnectionRequest)
                    throw TypeError(
                      ".dcv.input.ClientMessage.gamepadDisconnectionRequest: object expected"
                    );
                  e.gamepadDisconnectionRequest =
                    Xa.dcv.input.GamepadDisconnectionRequest.fromObject(
                      A.gamepadDisconnectionRequest
                    );
                }
                if (null != A.webauthnResponse) {
                  if ("object" != typeof A.webauthnResponse)
                    throw TypeError(".dcv.input.ClientMessage.webauthnResponse: object expected");
                  e.webauthnResponse = Xa.dcv.input.WebauthnResponse.fromObject(A.webauthnResponse);
                }
                if (null != A.webauthnClientCapability) {
                  if ("object" != typeof A.webauthnClientCapability)
                    throw TypeError(
                      ".dcv.input.ClientMessage.webauthnClientCapability: object expected"
                    );
                  e.webauthnClientCapability = Xa.dcv.input.WebauthnClientCapability.fromObject(
                    A.webauthnClientCapability
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.preferences &&
                    A.hasOwnProperty("preferences") &&
                    ((t.preferences = Xa.dcv.input.Preferences.toObject(A.preferences, e)),
                    e.oneofs && (t.msg = "preferences")),
                  null != A.pointerMotionEvent &&
                    A.hasOwnProperty("pointerMotionEvent") &&
                    ((t.pointerMotionEvent = Xa.dcv.input.PointerMotionEvent.toObject(
                      A.pointerMotionEvent,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerMotionEvent")),
                  null != A.pointerRelativeMotionEvent &&
                    A.hasOwnProperty("pointerRelativeMotionEvent") &&
                    ((t.pointerRelativeMotionEvent =
                      Xa.dcv.input.PointerRelativeMotionEvent.toObject(
                        A.pointerRelativeMotionEvent,
                        e
                      )),
                    e.oneofs && (t.msg = "pointerRelativeMotionEvent")),
                  null != A.pointerRequireCursorImages &&
                    A.hasOwnProperty("pointerRequireCursorImages") &&
                    ((t.pointerRequireCursorImages =
                      Xa.dcv.input.PointerRequireCursorImages.toObject(
                        A.pointerRequireCursorImages,
                        e
                      )),
                    e.oneofs && (t.msg = "pointerRequireCursorImages")),
                  null != A.pointerButtonPressEvent &&
                    A.hasOwnProperty("pointerButtonPressEvent") &&
                    ((t.pointerButtonPressEvent = Xa.dcv.input.PointerButtonPressEvent.toObject(
                      A.pointerButtonPressEvent,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerButtonPressEvent")),
                  null != A.pointerButtonReleaseEvent &&
                    A.hasOwnProperty("pointerButtonReleaseEvent") &&
                    ((t.pointerButtonReleaseEvent = Xa.dcv.input.PointerButtonReleaseEvent.toObject(
                      A.pointerButtonReleaseEvent,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerButtonReleaseEvent")),
                  null != A.pointerAxisEvent &&
                    A.hasOwnProperty("pointerAxisEvent") &&
                    ((t.pointerAxisEvent = Xa.dcv.input.PointerAxisEvent.toObject(
                      A.pointerAxisEvent,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerAxisEvent")),
                  null != A.keyDownEvent &&
                    A.hasOwnProperty("keyDownEvent") &&
                    ((t.keyDownEvent = Xa.dcv.input.KeyDownEvent.toObject(A.keyDownEvent, e)),
                    e.oneofs && (t.msg = "keyDownEvent")),
                  null != A.keyUpEvent &&
                    A.hasOwnProperty("keyUpEvent") &&
                    ((t.keyUpEvent = Xa.dcv.input.KeyUpEvent.toObject(A.keyUpEvent, e)),
                    e.oneofs && (t.msg = "keyUpEvent")),
                  null != A.specialKeyDownEvent &&
                    A.hasOwnProperty("specialKeyDownEvent") &&
                    ((t.specialKeyDownEvent = Xa.dcv.input.SpecialKeyDownEvent.toObject(
                      A.specialKeyDownEvent,
                      e
                    )),
                    e.oneofs && (t.msg = "specialKeyDownEvent")),
                  null != A.specialKeyUpEvent &&
                    A.hasOwnProperty("specialKeyUpEvent") &&
                    ((t.specialKeyUpEvent = Xa.dcv.input.SpecialKeyUpEvent.toObject(
                      A.specialKeyUpEvent,
                      e
                    )),
                    e.oneofs && (t.msg = "specialKeyUpEvent")),
                  null != A.touchEvent &&
                    A.hasOwnProperty("touchEvent") &&
                    ((t.touchEvent = Xa.dcv.input.TouchEvent.toObject(A.touchEvent, e)),
                    e.oneofs && (t.msg = "touchEvent")),
                  null != A.stylusEvent &&
                    A.hasOwnProperty("stylusEvent") &&
                    ((t.stylusEvent = Xa.dcv.input.StylusEvent.toObject(A.stylusEvent, e)),
                    e.oneofs && (t.msg = "stylusEvent")),
                  null != A.gamepadEvent &&
                    A.hasOwnProperty("gamepadEvent") &&
                    ((t.gamepadEvent = Xa.dcv.input.GamepadEvent.toObject(A.gamepadEvent, e)),
                    e.oneofs && (t.msg = "gamepadEvent")),
                  null != A.gamepadConnectionRequest &&
                    A.hasOwnProperty("gamepadConnectionRequest") &&
                    ((t.gamepadConnectionRequest = Xa.dcv.input.GamepadConnectionRequest.toObject(
                      A.gamepadConnectionRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "gamepadConnectionRequest")),
                  null != A.gamepadDisconnectionRequest &&
                    A.hasOwnProperty("gamepadDisconnectionRequest") &&
                    ((t.gamepadDisconnectionRequest =
                      Xa.dcv.input.GamepadDisconnectionRequest.toObject(
                        A.gamepadDisconnectionRequest,
                        e
                      )),
                    e.oneofs && (t.msg = "gamepadDisconnectionRequest")),
                  null != A.webauthnResponse &&
                    A.hasOwnProperty("webauthnResponse") &&
                    ((t.webauthnResponse = Xa.dcv.input.WebauthnResponse.toObject(
                      A.webauthnResponse,
                      e
                    )),
                    e.oneofs && (t.msg = "webauthnResponse")),
                  null != A.webauthnClientCapability &&
                    A.hasOwnProperty("webauthnClientCapability") &&
                    ((t.webauthnClientCapability = Xa.dcv.input.WebauthnClientCapability.toObject(
                      A.webauthnClientCapability,
                      e
                    )),
                    e.oneofs && (t.msg = "webauthnClientCapability")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.ClientMessage";
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.capabilities = null),
              (A.prototype.pointerMotionAck = null),
              (A.prototype.pointerPosition = null),
              (A.prototype.pointerCursors = null),
              (A.prototype.pointerInvalidateCursors = null),
              (A.prototype.pointerInvalidateCursorCache = null),
              (A.prototype.statusUpdate = null),
              (A.prototype.gamepadConnectionResponse = null),
              (A.prototype.gamepadDisconnected = null),
              (A.prototype.gamepadVibration = null),
              (A.prototype.webauthnRequest = null),
              (A.prototype.webauthnCancelRequest = null),
              Object.defineProperty(A.prototype, "msg", {
                get: _a.oneOfGetter(
                  (e = [
                    "capabilities",
                    "pointerMotionAck",
                    "pointerPosition",
                    "pointerCursors",
                    "pointerInvalidateCursors",
                    "pointerInvalidateCursorCache",
                    "statusUpdate",
                    "gamepadConnectionResponse",
                    "gamepadDisconnected",
                    "gamepadVibration",
                    "webauthnRequest",
                    "webauthnCancelRequest"
                  ])
                ),
                set: _a.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Va.create()),
                  null != A.capabilities &&
                    Object.hasOwnProperty.call(A, "capabilities") &&
                    Xa.dcv.input.Capabilities.encode(A.capabilities, e.uint32(82).fork()).ldelim(),
                  null != A.pointerMotionAck &&
                    Object.hasOwnProperty.call(A, "pointerMotionAck") &&
                    Xa.dcv.input.PointerMotionAck.encode(
                      A.pointerMotionAck,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.pointerPosition &&
                    Object.hasOwnProperty.call(A, "pointerPosition") &&
                    Xa.dcv.input.PointerPosition.encode(
                      A.pointerPosition,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.pointerCursors &&
                    Object.hasOwnProperty.call(A, "pointerCursors") &&
                    Xa.dcv.input.PointerCursors.encode(
                      A.pointerCursors,
                      e.uint32(322).fork()
                    ).ldelim(),
                  null != A.pointerInvalidateCursors &&
                    Object.hasOwnProperty.call(A, "pointerInvalidateCursors") &&
                    Xa.dcv.input.PointerInvalidateCursors.encode(
                      A.pointerInvalidateCursors,
                      e.uint32(330).fork()
                    ).ldelim(),
                  null != A.pointerInvalidateCursorCache &&
                    Object.hasOwnProperty.call(A, "pointerInvalidateCursorCache") &&
                    Xa.dcv.input.PointerInvalidateCursorCache.encode(
                      A.pointerInvalidateCursorCache,
                      e.uint32(338).fork()
                    ).ldelim(),
                  null != A.statusUpdate &&
                    Object.hasOwnProperty.call(A, "statusUpdate") &&
                    Xa.dcv.input.StatusUpdate.encode(A.statusUpdate, e.uint32(402).fork()).ldelim(),
                  null != A.gamepadConnectionResponse &&
                    Object.hasOwnProperty.call(A, "gamepadConnectionResponse") &&
                    Xa.dcv.input.GamepadConnectionResponse.encode(
                      A.gamepadConnectionResponse,
                      e.uint32(482).fork()
                    ).ldelim(),
                  null != A.gamepadDisconnected &&
                    Object.hasOwnProperty.call(A, "gamepadDisconnected") &&
                    Xa.dcv.input.GamepadDisconnected.encode(
                      A.gamepadDisconnected,
                      e.uint32(490).fork()
                    ).ldelim(),
                  null != A.gamepadVibration &&
                    Object.hasOwnProperty.call(A, "gamepadVibration") &&
                    Xa.dcv.input.GamepadVibration.encode(
                      A.gamepadVibration,
                      e.uint32(498).fork()
                    ).ldelim(),
                  null != A.webauthnRequest &&
                    Object.hasOwnProperty.call(A, "webauthnRequest") &&
                    Xa.dcv.input.WebauthnRequest.encode(
                      A.webauthnRequest,
                      e.uint32(562).fork()
                    ).ldelim(),
                  null != A.webauthnCancelRequest &&
                    Object.hasOwnProperty.call(A, "webauthnCancelRequest") &&
                    Xa.dcv.input.WebauthnCancelRequest.encode(
                      A.webauthnCancelRequest,
                      e.uint32(570).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Wa || (A = Wa.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Xa.dcv.input.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.capabilities = Xa.dcv.input.Capabilities.decode(A, A.uint32());
                      break;
                    case 20:
                      i.pointerMotionAck = Xa.dcv.input.PointerMotionAck.decode(A, A.uint32());
                      break;
                    case 30:
                      i.pointerPosition = Xa.dcv.input.PointerPosition.decode(A, A.uint32());
                      break;
                    case 40:
                      i.pointerCursors = Xa.dcv.input.PointerCursors.decode(A, A.uint32());
                      break;
                    case 41:
                      i.pointerInvalidateCursors = Xa.dcv.input.PointerInvalidateCursors.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 42:
                      i.pointerInvalidateCursorCache =
                        Xa.dcv.input.PointerInvalidateCursorCache.decode(A, A.uint32());
                      break;
                    case 50:
                      i.statusUpdate = Xa.dcv.input.StatusUpdate.decode(A, A.uint32());
                      break;
                    case 60:
                      i.gamepadConnectionResponse = Xa.dcv.input.GamepadConnectionResponse.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 61:
                      i.gamepadDisconnected = Xa.dcv.input.GamepadDisconnected.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 62:
                      i.gamepadVibration = Xa.dcv.input.GamepadVibration.decode(A, A.uint32());
                      break;
                    case 70:
                      i.webauthnRequest = Xa.dcv.input.WebauthnRequest.decode(A, A.uint32());
                      break;
                    case 71:
                      i.webauthnCancelRequest = Xa.dcv.input.WebauthnCancelRequest.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Wa || (A = new Wa(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.capabilities && A.hasOwnProperty("capabilities")) {
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.Capabilities.verify(A.capabilities);
                    if (e) return "capabilities." + e;
                  }
                }
                if (null != A.pointerMotionAck && A.hasOwnProperty("pointerMotionAck")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerMotionAck.verify(A.pointerMotionAck);
                    if (e) return "pointerMotionAck." + e;
                  }
                }
                if (null != A.pointerPosition && A.hasOwnProperty("pointerPosition")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerPosition.verify(A.pointerPosition);
                    if (e) return "pointerPosition." + e;
                  }
                }
                if (null != A.pointerCursors && A.hasOwnProperty("pointerCursors")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerCursors.verify(A.pointerCursors);
                    if (e) return "pointerCursors." + e;
                  }
                }
                if (
                  null != A.pointerInvalidateCursors &&
                  A.hasOwnProperty("pointerInvalidateCursors")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerInvalidateCursors.verify(
                      A.pointerInvalidateCursors
                    );
                    if (e) return "pointerInvalidateCursors." + e;
                  }
                }
                if (
                  null != A.pointerInvalidateCursorCache &&
                  A.hasOwnProperty("pointerInvalidateCursorCache")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.PointerInvalidateCursorCache.verify(
                      A.pointerInvalidateCursorCache
                    );
                    if (e) return "pointerInvalidateCursorCache." + e;
                  }
                }
                if (null != A.statusUpdate && A.hasOwnProperty("statusUpdate")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.StatusUpdate.verify(A.statusUpdate);
                    if (e) return "statusUpdate." + e;
                  }
                }
                if (
                  null != A.gamepadConnectionResponse &&
                  A.hasOwnProperty("gamepadConnectionResponse")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.GamepadConnectionResponse.verify(
                      A.gamepadConnectionResponse
                    );
                    if (e) return "gamepadConnectionResponse." + e;
                  }
                }
                if (null != A.gamepadDisconnected && A.hasOwnProperty("gamepadDisconnected")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.GamepadDisconnected.verify(A.gamepadDisconnected);
                    if (e) return "gamepadDisconnected." + e;
                  }
                }
                if (null != A.gamepadVibration && A.hasOwnProperty("gamepadVibration")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.GamepadVibration.verify(A.gamepadVibration);
                    if (e) return "gamepadVibration." + e;
                  }
                }
                if (null != A.webauthnRequest && A.hasOwnProperty("webauthnRequest")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.WebauthnRequest.verify(A.webauthnRequest);
                    if (e) return "webauthnRequest." + e;
                  }
                }
                if (null != A.webauthnCancelRequest && A.hasOwnProperty("webauthnCancelRequest")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Xa.dcv.input.WebauthnCancelRequest.verify(A.webauthnCancelRequest);
                    if (e) return "webauthnCancelRequest." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Xa.dcv.input.ServerMessage) return A;
                let e = new Xa.dcv.input.ServerMessage();
                if (null != A.capabilities) {
                  if ("object" != typeof A.capabilities)
                    throw TypeError(".dcv.input.ServerMessage.capabilities: object expected");
                  e.capabilities = Xa.dcv.input.Capabilities.fromObject(A.capabilities);
                }
                if (null != A.pointerMotionAck) {
                  if ("object" != typeof A.pointerMotionAck)
                    throw TypeError(".dcv.input.ServerMessage.pointerMotionAck: object expected");
                  e.pointerMotionAck = Xa.dcv.input.PointerMotionAck.fromObject(A.pointerMotionAck);
                }
                if (null != A.pointerPosition) {
                  if ("object" != typeof A.pointerPosition)
                    throw TypeError(".dcv.input.ServerMessage.pointerPosition: object expected");
                  e.pointerPosition = Xa.dcv.input.PointerPosition.fromObject(A.pointerPosition);
                }
                if (null != A.pointerCursors) {
                  if ("object" != typeof A.pointerCursors)
                    throw TypeError(".dcv.input.ServerMessage.pointerCursors: object expected");
                  e.pointerCursors = Xa.dcv.input.PointerCursors.fromObject(A.pointerCursors);
                }
                if (null != A.pointerInvalidateCursors) {
                  if ("object" != typeof A.pointerInvalidateCursors)
                    throw TypeError(
                      ".dcv.input.ServerMessage.pointerInvalidateCursors: object expected"
                    );
                  e.pointerInvalidateCursors = Xa.dcv.input.PointerInvalidateCursors.fromObject(
                    A.pointerInvalidateCursors
                  );
                }
                if (null != A.pointerInvalidateCursorCache) {
                  if ("object" != typeof A.pointerInvalidateCursorCache)
                    throw TypeError(
                      ".dcv.input.ServerMessage.pointerInvalidateCursorCache: object expected"
                    );
                  e.pointerInvalidateCursorCache =
                    Xa.dcv.input.PointerInvalidateCursorCache.fromObject(
                      A.pointerInvalidateCursorCache
                    );
                }
                if (null != A.statusUpdate) {
                  if ("object" != typeof A.statusUpdate)
                    throw TypeError(".dcv.input.ServerMessage.statusUpdate: object expected");
                  e.statusUpdate = Xa.dcv.input.StatusUpdate.fromObject(A.statusUpdate);
                }
                if (null != A.gamepadConnectionResponse) {
                  if ("object" != typeof A.gamepadConnectionResponse)
                    throw TypeError(
                      ".dcv.input.ServerMessage.gamepadConnectionResponse: object expected"
                    );
                  e.gamepadConnectionResponse = Xa.dcv.input.GamepadConnectionResponse.fromObject(
                    A.gamepadConnectionResponse
                  );
                }
                if (null != A.gamepadDisconnected) {
                  if ("object" != typeof A.gamepadDisconnected)
                    throw TypeError(
                      ".dcv.input.ServerMessage.gamepadDisconnected: object expected"
                    );
                  e.gamepadDisconnected = Xa.dcv.input.GamepadDisconnected.fromObject(
                    A.gamepadDisconnected
                  );
                }
                if (null != A.gamepadVibration) {
                  if ("object" != typeof A.gamepadVibration)
                    throw TypeError(".dcv.input.ServerMessage.gamepadVibration: object expected");
                  e.gamepadVibration = Xa.dcv.input.GamepadVibration.fromObject(A.gamepadVibration);
                }
                if (null != A.webauthnRequest) {
                  if ("object" != typeof A.webauthnRequest)
                    throw TypeError(".dcv.input.ServerMessage.webauthnRequest: object expected");
                  e.webauthnRequest = Xa.dcv.input.WebauthnRequest.fromObject(A.webauthnRequest);
                }
                if (null != A.webauthnCancelRequest) {
                  if ("object" != typeof A.webauthnCancelRequest)
                    throw TypeError(
                      ".dcv.input.ServerMessage.webauthnCancelRequest: object expected"
                    );
                  e.webauthnCancelRequest = Xa.dcv.input.WebauthnCancelRequest.fromObject(
                    A.webauthnCancelRequest
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.capabilities &&
                    A.hasOwnProperty("capabilities") &&
                    ((t.capabilities = Xa.dcv.input.Capabilities.toObject(A.capabilities, e)),
                    e.oneofs && (t.msg = "capabilities")),
                  null != A.pointerMotionAck &&
                    A.hasOwnProperty("pointerMotionAck") &&
                    ((t.pointerMotionAck = Xa.dcv.input.PointerMotionAck.toObject(
                      A.pointerMotionAck,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerMotionAck")),
                  null != A.pointerPosition &&
                    A.hasOwnProperty("pointerPosition") &&
                    ((t.pointerPosition = Xa.dcv.input.PointerPosition.toObject(
                      A.pointerPosition,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerPosition")),
                  null != A.pointerCursors &&
                    A.hasOwnProperty("pointerCursors") &&
                    ((t.pointerCursors = Xa.dcv.input.PointerCursors.toObject(A.pointerCursors, e)),
                    e.oneofs && (t.msg = "pointerCursors")),
                  null != A.pointerInvalidateCursors &&
                    A.hasOwnProperty("pointerInvalidateCursors") &&
                    ((t.pointerInvalidateCursors = Xa.dcv.input.PointerInvalidateCursors.toObject(
                      A.pointerInvalidateCursors,
                      e
                    )),
                    e.oneofs && (t.msg = "pointerInvalidateCursors")),
                  null != A.pointerInvalidateCursorCache &&
                    A.hasOwnProperty("pointerInvalidateCursorCache") &&
                    ((t.pointerInvalidateCursorCache =
                      Xa.dcv.input.PointerInvalidateCursorCache.toObject(
                        A.pointerInvalidateCursorCache,
                        e
                      )),
                    e.oneofs && (t.msg = "pointerInvalidateCursorCache")),
                  null != A.statusUpdate &&
                    A.hasOwnProperty("statusUpdate") &&
                    ((t.statusUpdate = Xa.dcv.input.StatusUpdate.toObject(A.statusUpdate, e)),
                    e.oneofs && (t.msg = "statusUpdate")),
                  null != A.gamepadConnectionResponse &&
                    A.hasOwnProperty("gamepadConnectionResponse") &&
                    ((t.gamepadConnectionResponse = Xa.dcv.input.GamepadConnectionResponse.toObject(
                      A.gamepadConnectionResponse,
                      e
                    )),
                    e.oneofs && (t.msg = "gamepadConnectionResponse")),
                  null != A.gamepadDisconnected &&
                    A.hasOwnProperty("gamepadDisconnected") &&
                    ((t.gamepadDisconnected = Xa.dcv.input.GamepadDisconnected.toObject(
                      A.gamepadDisconnected,
                      e
                    )),
                    e.oneofs && (t.msg = "gamepadDisconnected")),
                  null != A.gamepadVibration &&
                    A.hasOwnProperty("gamepadVibration") &&
                    ((t.gamepadVibration = Xa.dcv.input.GamepadVibration.toObject(
                      A.gamepadVibration,
                      e
                    )),
                    e.oneofs && (t.msg = "gamepadVibration")),
                  null != A.webauthnRequest &&
                    A.hasOwnProperty("webauthnRequest") &&
                    ((t.webauthnRequest = Xa.dcv.input.WebauthnRequest.toObject(
                      A.webauthnRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "webauthnRequest")),
                  null != A.webauthnCancelRequest &&
                    A.hasOwnProperty("webauthnCancelRequest") &&
                    ((t.webauthnCancelRequest = Xa.dcv.input.WebauthnCancelRequest.toObject(
                      A.webauthnCancelRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "webauthnCancelRequest")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.input.ServerMessage";
              }),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  Za = { noButtons: 0, tip: 1, barrel: 2, eraser: 32 },
  $a = 16,
  Ag = 120,
  eg = 40,
  tg = 800,
  ig = 20,
  ng = "Dead",
  og = [12593, 12643],
  rg = { windows: ["OS"] },
  sg = [
    { key: "Control", location: KeyboardEvent.DOM_KEY_LOCATION_LEFT },
    { key: "Control", location: KeyboardEvent.DOM_KEY_LOCATION_RIGHT },
    { key: "Alt", location: KeyboardEvent.DOM_KEY_LOCATION_LEFT },
    { key: "Alt", location: KeyboardEvent.DOM_KEY_LOCATION_RIGHT },
    { key: "AltGraph", location: KeyboardEvent.DOM_KEY_LOCATION_STANDARD },
    { key: "Meta", location: KeyboardEvent.DOM_KEY_LOCATION_LEFT },
    { key: "Meta", location: KeyboardEvent.DOM_KEY_LOCATION_RIGHT },
    { key: "OS", location: KeyboardEvent.DOM_KEY_LOCATION_LEFT },
    { key: "OS", location: KeyboardEvent.DOM_KEY_LOCATION_RIGHT },
    { key: "Shift", location: KeyboardEvent.DOM_KEY_LOCATION_LEFT },
    { key: "Shift", location: KeyboardEvent.DOM_KEY_LOCATION_RIGHT }
  ],
  ag = za.input,
  gg = new lg(),
  cg = Object.freeze({
    NOT_COMPOSING: "NOT_COMPOSING",
    COMPOSING: "COMPOSING",
    COMPOSED: "COMPOSED"
  });
function Ig(A) {
  (this.log = Q("input", A)),
    (this.clientConnectionId = A),
    (this.lastTouchEnded = {}),
    (this.relativeMouseMode = { enabled: !1, serverAvailable: !1, displayIsSingleMonitor: !1 }),
    (this.touchCallbacks = { move: null, start: null, end: null }),
    (this.macKeyboardQuirks = {
      commandToControl: !1,
      optionToAlt: !1,
      controlOptionToControlAlt: !1,
      commandIsPressed: !1
    }),
    (this.winKeyboardQuirks = { leftAltNoGraph: !1 }),
    (this.pressedKeys = []),
    (this.shortcuts = []),
    (this.hiddenCursor = !1),
    (this.mouseOut = !1),
    (this.ignoreTouch = !1),
    (this.sendLocksSync = !0),
    (this.currentGroupId = 0),
    (this.wheelLatestEventTime = 0),
    (this.previousMouseButtonsState = 0),
    (this.wheelStats = { deltaMode: new Set(), deltaY: new Set(), wheelDeltaY: new Set() }),
    (this.onPointerLockChange = Cc.bind(this)),
    (this.onPointerLockError = Bc.bind(this));
  const e = qs(A);
  e
    ? ((this.IMEModeBehavior = e.getIMEModeBehavior()),
      (this.currentIMEMode = e.getCurrentIMEMode()))
    : (this.log.warn("Could not gather current IME mode and behavior while initializing input"),
      (this.IMEModeBehavior = "auto"),
      (this.currentIMEMode = !Qr())),
    this.resetDeadKeyFlags();
}
function lg(A) {
  (this.key = ""),
    (this.location = 0),
    (this.code = ""),
    (this.set = function (A, e, t) {
      (this.key = A),
        (this.location = e),
        "string" == typeof t && t.length > 2 && (this.code = t),
        "AltGraph" === this.key && (this.location = KeyboardEvent.DOM_KEY_LOCATION_STANDARD);
    }),
    (this.shortcutKey = ""),
    (this.shortcutLocation = 0),
    (this.setShortcut = function (A, e) {
      (this.shortcutKey = A), (this.shortcutLocation = e);
    }),
    (this.activeMacCommandModifier = A);
}
function dg(A) {
  A.preventDefault();
}
function ug(A) {
  return A.key.codePointAt(1);
}
function Cg(A) {
  const e = js(A).getDataChannel(Ia.DISPLAY);
  return e ? Math.floor(1e3 * e.getDisplayManager().currentServerTime()) : 0;
}
function Bg(A, e, t, i, n) {
  let o,
    r,
    s = {};
  if (
    (ug(t)
      ? ((o = i ? "specialKeyDownEvent" : "specialKeyUpEvent"), (r = "name"))
      : ((o = i ? "keyDownEvent" : "keyUpEvent"), (r = "character")),
    (s[o] = { location: t.location, estimatedTimestamp: Cg(e) }),
    (s[o][r] = t.key),
    !Ao(n))
  ) {
    s[o].locks = [];
    for (let A = 0; A < n.length; A++) {
      const e = {};
      switch (((e.active = n[A].active), n[A].key)) {
        case "CapsLock":
          e.key = ag.LockKey.CAPS_LOCK;
          break;
        case "NumLock":
          e.key = ag.LockKey.NUM_LOCK;
          break;
        case "ScrollLock":
          e.key = ag.LockKey.SCROLL_LOCK;
          break;
        default:
          this.log.debug(`Unrecognized lock key ${n[A].key}`);
      }
      s[o].locks.push(e);
    }
  }
  A.sendInputMessage(s);
}
function Qg(A, e) {
  let t, i;
  return (
    (t = `kc${e}`),
    (i = A),
    ("Unidentified" !== A && "Attn" !== A) ||
      (i =
        {
          kc240: "Alphanumeric",
          kc241: "Katakana",
          kc242: "Hiragana",
          kc243: "Hankaku",
          kc244: "Zenkaku",
          kc245: "Romaji",
          kc246: "KanaMode"
        }[t] || A),
    {
      Left: "ArrowLeft",
      Right: "ArrowRight",
      Up: "ArrowUp",
      Down: "ArrowDown",
      Del: "Delete",
      Esc: "Escape",
      Win: "OS",
      Spacebar: " ",
      Add: "+",
      Subtract: "-",
      Multiply: "*",
      Divide: "/",
      Decimal: ".",
      Scroll: "ScrollLock",
      Nonconvert: "NonConvert"
    }[A] ||
      { Meta: "OS" }[A] ||
      i
  );
}
function Eg(A) {
  const e = js(A).getDataChannel(Ia.CLIPBOARD);
  e && e.getRemoteClipboard().hasDataToSync(A);
}
function hg(A, e) {
  for (let t = 0; t < A.length; t++)
    if (A[t].key.toUpperCase() === e.key.toUpperCase() && A[t].location === e.location) return !0;
  return !1;
}
function pg(A, e) {
  "Romaji" !== e.key &&
    "KanaMode" !== e.key &&
    "Hankaku" !== e.key &&
    "Zenkaku" !== e.key &&
    (hg(A, e) || A.push(e));
}
function fg(A) {
  let e = null;
  return (
    (this.pressedKeys = this.pressedKeys.filter(
      (t) =>
        !(t.key === A.key || (t.code.length > 2 && t.code === A.code)) ||
        t.location !== A.location ||
        ((e = t), !1)
    )),
    e
      ? (e.shortcutLocation && (e.location = e.shortcutLocation),
        e.shortcutKey && (e.key = e.shortcutKey),
        e)
      : ug(A)
        ? A
        : null
  );
}
function mg() {
  return this.pressedKeys.filter(
    (A) =>
      !A.activeMacCommandModifier ||
      (Bg.call(this, this.channel, this.clientConnectionId, A, !1), !1)
  );
}
function yg(A, e) {
  const t = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  (!e || (e && !t[e.key])) &&
    Object.keys(t).forEach((e) => {
      const i = new lg(this.macKeyboardQuirks.commandIsPressed),
        n = new lg(this.macKeyboardQuirks.commandIsPressed);
      i.set(e, KeyboardEvent.DOM_KEY_LOCATION_LEFT),
        n.set(e, KeyboardEvent.DOM_KEY_LOCATION_RIGHT),
        !A[t[e]] ||
          hg(this.pressedKeys, i) ||
          hg(this.pressedKeys, n) ||
          this.log.info(`Modifier ${e} state is out of sync (right state is pressed)`),
        A[t[e]] ||
          (hg(this.pressedKeys, i) &&
            (this.log.info(`Left modifier ${e} state is out of sync (right state is released)`),
            Bg.call(this, this.channel, this.clientConnectionId, i, !1),
            fg.call(this, i)),
          hg(this.pressedKeys, n) &&
            (this.log.info(`Right modifier ${e} state is out of sync (right state is released)`),
            Bg.call(this, this.channel, this.clientConnectionId, n, !1),
            fg.call(this, n)));
    });
}
function Dg(A) {
  return A.code.startsWith("Key") || A.code.startsWith("Digit");
}
function wg(A, e) {
  (A.key = A.code.replace(/Key/, "").replace(/Digit/, "")), e || (A.key = A.key.toLowerCase());
}
function Fg(A, e) {
  Qr() &&
    (function (A) {
      return A.codePointAt(0) >= og[0] && A.codePointAt(0) <= og[1] && 1 === A.length;
    })(A.key) &&
    wg(A, e);
}
function bg(A) {
  const e = ["CapsLock", "NumLock", "ScrollLock"],
    t = [];
  return this.sendLocksSync || e.includes(A.key)
    ? (e.forEach((e) => {
        t.push({ key: e, active: A.getModifierState(e) });
      }),
      (this.sendLocksSync = !1),
      t)
    : null;
}
function Ug(A, e) {
  let t = e;
  if (!t) {
    const e = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
    if (!e) return;
    t = e.getDisplayManager().getInputDiv(A);
  }
  t &&
    t.childNodes &&
    t.childNodes.forEach((A) => {
      t.removeChild(A);
    });
}
function Sg(A) {
  const e = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  let t, i;
  if (
    e &&
    ((t = e.getDisplayManager().getInputDiv(A)),
    t && t.childNodes && ((i = t.childNodes[0]), i && i.textContent))
  ) {
    for (let A = 0; A < i.textContent.length; A++) {
      let e = new lg(this.macKeyboardQuirks.commandIsPressed);
      e.set(i.textContent.charAt(A), 0),
        Bg.call(this, this.channel, this.clientConnectionId, e, !0),
        Bg.call(this, this.channel, this.clientConnectionId, e, !1);
    }
    Ug.call(this, A, t);
  }
}
function Rg(A) {
  if (!Qr()) return !1;
  if ("auto" !== this.IMEModeBehavior) return !1;
  if ("keydown" === A.type && A.key === ng && this.currentIMEMode) {
    const A = qs(this.clientConnectionId);
    return Ao(A)
      ? (this.log.warn(`Invalid connection object for connection ${this.clientConnectionId}`), !1)
      : (this.log.debug("Setting IME Mode to false after receiving a dead key event"),
        A.setCurrentIMEMode(!1),
        !0);
  }
  if (
    "keyup" === A.type &&
    A.isComposing &&
    A.key !== ng &&
    this.deadKeyStatus === cg.NOT_COMPOSING
  ) {
    const A = qs(this.clientConnectionId);
    return Ao(A)
      ? (this.log.warn(`Invalid connection object for connection ${this.clientConnectionId}`), !1)
      : (this.log.debug(
          "Setting IME Mode to true after receiving composing keydown when no Deadkey keydown was received"
        ),
        A.setCurrentIMEMode(!0),
        !0);
  }
  return !1;
}
function vg(A, e) {
  let t = new lg(this.macKeyboardQuirks.commandIsPressed),
    i = !1,
    n = new lg(this.macKeyboardQuirks.commandIsPressed),
    o = !1;
  if ((t.set(Qg(A.key, A.keyCode), A.location, A.code), "Unidentified" !== t.key)) {
    if (
      ("" === t.key && "Digit0" === A.code && A.shiftKey && (t.key = "0"),
      "\\" === t.key && ("IntlRo" === A.code || (Ao(A.code) && 226 === A.keyCode))
        ? (t.key = "IntlRo")
        : !Qr() || ("￥" !== t.key && "¥" !== t.key) || "IntlYen" !== A.code || (t.key = "IntlYen"),
      this.relativeMouseMode.enabled && A.ctrlKey && A.shiftKey && "F8" === t.key)
    ) {
      if (document.pointerLockElement)
        document.exitPointerLock(), this.log.info("Mouse SERVER (relative) mode disabled");
      else {
        const A = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
        A && A.getDisplayManager().requestPointerLock(),
          this.log.info("Mouse SERVER (relative) mode enabled");
      }
      dg(A);
    } else if (
      (Fg(t, A.shiftKey || A.getModifierState("CapsLock")),
      ("HangulMode" !== t.key && "HanjaMode" !== t.key) ||
        (t.location = KeyboardEvent.DOM_KEY_LOCATION_STANDARD),
      (!Qr() ||
        this.currentIMEMode ||
        (this.deadKeyStatus === cg.NOT_COMPOSING && !A.isComposing) ||
        (("Tab" !== t.code && "Enter" !== t.code) || dg(A),
        "Backspace" !== t.code || ur() || (this.deadKeyCompEndedOnBackspace = !0),
        (this.ignoredOptionDeadKey && !lr()) ||
          ("Tab" !== t.code &&
            "Enter" !== t.code &&
            "Backspace" !== t.code &&
            "Delete" !== t.code))) &&
        (Qr() &&
          this.ignoredOptionDeadKey &&
          this.macKeyboardQuirks.optionToAlt &&
          this.deadKeyStatus !== cg.NOT_COMPOSING &&
          (Dg(t)
            ? wg(t)
            : !ur() ||
                ("Enter" !== t.code &&
                  "Tab" !== t.code &&
                  "Delete" !== t.code &&
                  "Backspace" !== t.code)
              ? "Space" === t.code && (t.key = " ")
              : (t.key = t.code)),
        Qr() && A.repeat && (this.repeating = !0),
        (!Br() || this.deadKeyStatus !== cg.COMPOSING || "Enter" !== t.key) &&
          (!(Qr() || Br() || Er()) ||
            (this.currentIMEMode && Qr()) ||
            !(
              t.key === ng ||
              (Er() && this.deadKeyStatus === cg.COMPOSING) ||
              (this.deadKeyStatus !== cg.NOT_COMPOSING &&
                !(t.key.length > 2 || t.key.match(/^F[0-9,n]$/m)))
            ) ||
            (this.macKeyboardQuirks.controlOptionToControlAlt && A.altKey && A.ctrlKey) ||
            (A.altKey &&
              (this.macKeyboardQuirks.optionToAlt
                ? (this.ignoredOptionDeadKey = !0)
                : (n.set("Control", KeyboardEvent.DOM_KEY_LOCATION_LEFT),
                  Bg.call(this, this.channel, this.clientConnectionId, n, !0),
                  Bg.call(this, this.channel, this.clientConnectionId, n, !1))),
            this.deadKeyStatus === cg.NOT_COMPOSING && (this.deadKeyStatus = cg.COMPOSING),
            this.ignoredOptionDeadKey))))
    ) {
      if (
        (Rg.call(this, A),
        (this.winKeyboardQuirks.leftAltNoGraph &&
          A.getModifierState("AltGraph") &&
          hg(this.pressedKeys, gg)) ||
          yg.call(this, A, t),
        (o =
          this.macKeyboardQuirks.optionToAlt ||
          this.macKeyboardQuirks.controlOptionToControlAlt ||
          this.winKeyboardQuirks.leftAltNoGraph),
        o || pg(this.pressedKeys, t),
        Eg(this.clientConnectionId),
        !(xg.call(this, t) || (rg[nr] && -1 !== rg[nr].indexOf(t.key))))
      ) {
        let e = !1;
        (e =
          this.macKeyboardQuirks.optionToAlt || this.macKeyboardQuirks.controlOptionToControlAlt
            ? "Alt" !== t.key && A.altKey && Dg(t) && !A.metaKey && (!ug(t) || t.key === ng)
            : "Alt" !== t.key && Qr() && A.altKey && !A.ctrlKey && !A.metaKey && !ug(t)),
          e &&
            (this.macKeyboardQuirks.optionToAlt ||
            (this.macKeyboardQuirks.controlOptionToControlAlt && A.ctrlKey)
              ? wg(t)
              : (n.set("Control", KeyboardEvent.DOM_KEY_LOCATION_LEFT),
                Bg.call(this, this.channel, this.clientConnectionId, n, !0),
                (i = !0))),
          this.winKeyboardQuirks.leftAltNoGraph &&
            "Alt" !== t.key &&
            hg(this.pressedKeys, gg) &&
            Dg(t) &&
            !A.metaKey &&
            !ug(t) &&
            wg(t),
          ("Meta" === t.key || "OS" === t.key) && Qr() && this.macKeyboardQuirks.commandToControl
            ? (n.set("Control", t.location),
              Bg.call(this, this.channel, this.clientConnectionId, n, !0))
            : Bg.call(this, this.channel, this.clientConnectionId, t, !0, bg.call(this, A)),
          i && Bg.call(this, this.channel, this.clientConnectionId, n, !1),
          Qr() &&
            "CapsLock" === t.key &&
            (Bg.call(this, this.channel, this.clientConnectionId, t, !1, bg.call(this, A)),
            fg.call(this, t)),
          ("Meta" !== t.key && "OS" !== t.key) ||
            !Qr() ||
            (this.macKeyboardQuirks.commandIsPressed = !0);
      }
      o && pg(this.pressedKeys, t), hr() || dg(A);
    }
  } else this.log.warn("Unidentified key");
}
function xg(A) {
  let e, t, i, n, o, r;
  for (let s = 0; s < this.shortcuts.length; s++)
    if (
      ((i = this.shortcuts[s]),
      i.sequence.length === this.pressedKeys.length &&
        (null === A.key ||
          A.key.toUpperCase() === i.sequence[i.sequence.length - 1].key.toUpperCase()))
    ) {
      for (o = !0, e = 0; e < i.sequence.length; e++)
        if (!hg(this.pressedKeys, i.sequence[e])) {
          o = !1;
          break;
        }
      if (o) {
        for (
          this.log.debug(`Triggered shortcut: ${C(i)}`), e = 0, t = 0;
          e < i.sequence.length &&
          i.sequence[e].key === i.output[e].key &&
          i.sequence[e].location === i.output[e].location;
          e++, t++
        );
        for (; e < i.sequence.length; e++)
          (n = i.sequence[e]),
            fg.call(this, n),
            Bg.call(this, this.channel, this.clientConnectionId, n, !1);
        for (; t < i.output.length; t++)
          (n = i.output[t]),
            (r = new lg(this.macKeyboardQuirks.commandIsPressed)),
            r.set(i.sequence[t].key, i.sequence[t].location),
            r.setShortcut(n.key, n.location),
            pg(this.pressedKeys, r),
            Bg.call(this, this.channel, this.clientConnectionId, n, !0);
        return !0;
      }
    }
  return !1;
}
function Mg(A, e) {
  let t,
    i = new lg(this.macKeyboardQuirks.commandIsPressed),
    n = new lg(this.macKeyboardQuirks.commandIsPressed),
    o = new lg(this.macKeyboardQuirks.commandIsPressed),
    r = !1;
  if (
    (i.set(Qg(A.key, A.keyCode), A.location, A.code),
    n.set("AltGraph", KeyboardEvent.DOM_KEY_LOCATION_STANDARD),
    "" === i.key && "Digit0" === A.code && A.shiftKey && (i.key = "0"),
    "\\" === i.key && ("IntlRo" === A.code || (Ao(A.code) && 226 === A.keyCode))
      ? (i.key = "IntlRo")
      : !Qr() || ("￥" !== i.key && "¥" !== i.key) || "IntlYen" !== A.code || (i.key = "IntlYen"),
    Qr() && ("Eisu" === A.code || "Lang2" === A.code))
  )
    return (
      this.log.debug("Mapping Eisu key to Alphanumeric"),
      (i.key = "Alphanumeric"),
      Bg.call(this, this.channel, this.clientConnectionId, i, !0),
      void dg(A)
    );
  if (
    (!Qr() ||
      ("Kana" !== A.code && "Lang1" !== A.code && "KanaMode" !== A.code) ||
      (this.log.debug("Mapping Kana key to KanaMode"), (i.key = "KanaMode")),
    "Unidentified" !== i.key)
  )
    if (this.relativeMouseMode.enabled && A.ctrlKey && A.shiftKey && "F8" === i.key) dg(A);
    else {
      if (
        (Fg(i, A.shiftKey || A.getModifierState("CapsLock")),
        ("HangulMode" !== i.key && "HanjaMode" !== i.key) ||
          (i.location = KeyboardEvent.DOM_KEY_LOCATION_STANDARD),
        "Alt" !== i.key &&
          Qr() &&
          A.altKey &&
          !A.ctrlKey &&
          !A.metaKey &&
          !ug(i) &&
          this.macKeyboardQuirks.optionToAlt &&
          ((this.macKeyboardQuirks.controlOptionToControlAlt && !Dg(i)) || wg(i)),
        this.winKeyboardQuirks.leftAltNoGraph &&
          ("Alt" === i.key ||
            !(A.getModifierState("AltGraph") || (hg(this.pressedKeys, gg) && A.ctrlKey)) ||
            hg(this.pressedKeys, i) ||
            !Dg(i) ||
            A.metaKey ||
            ug(i) ||
            wg(i)),
        ("Meta" === i.key || "OS" === i.key) &&
          Qr() &&
          this.macKeyboardQuirks.commandToControl &&
          (o.set("Control", i.location), (r = !0)),
        Qr())
      ) {
        if (this.deadKeyStatus === cg.COMPOSED && !A.isComposing)
          if (((this.deadKeyStatus = cg.NOT_COMPOSING), this.ignoredOptionDeadKey))
            Ug.call(this, e), (this.ignoredOptionDeadKey = !1), "Space" === i.code && (i.key = " ");
          else
            switch ((Sg.call(this, e), i.code)) {
              case "Tab":
                return void dg(A);
              case "Backspace":
                return;
              case "Enter":
              case "Delete":
                return void (
                  (dr() || ur()) &&
                  (Bg.call(this, this.channel, this.clientConnectionId, i, !0, bg.call(this, A)),
                  Bg.call(this, this.channel, this.clientConnectionId, i, !1, bg.call(this, A)))
                );
            }
        if (
          !(
            this.deadKeyStatus === cg.NOT_COMPOSING ||
            ug(i) ||
            ((this.macKeyboardQuirks.optionToAlt ||
              this.macKeyboardQuirks.controlOptionToControlAlt) &&
              A.altKey)
          )
        )
          return;
        Rg.call(this, A);
      } else if (Br()) {
        if (this.deadKeyStatus === cg.COMPOSED)
          return (
            "Enter" === i.key &&
              dr() &&
              (Bg.call(this, this.channel, this.clientConnectionId, i, !0, bg.call(this, A)),
              Bg.call(this, this.channel, this.clientConnectionId, i, !1, bg.call(this, A))),
            void (this.deadKeyStatus = cg.NOT_COMPOSING)
          );
        if ((this.deadKeyStatus !== cg.NOT_COMPOSING && !ug(i)) || i.key === ng) return;
      } else if (
        Er() &&
        this.deadKeyStatus === cg.COMPOSING &&
        "Control" !== i.key &&
        "Alt" !== i.key &&
        "AltGraph" !== i.key &&
        "Shift" !== i.key &&
        "Meta" !== i.key &&
        "Dead" !== i.key
      )
        return void (this.deadKeyStatus = cg.NOT_COMPOSING);
      (this.winKeyboardQuirks.leftAltNoGraph &&
        A.getModifierState("AltGraph") &&
        hg(this.pressedKeys, gg)) ||
        yg.call(this, A, i),
        (function (A) {
          return (
            "AltGraph" === A.key ||
            "AltRight" === A.code ||
            ("Alt" === A.key && A.location === KeyboardEvent.DOM_KEY_LOCATION_RIGHT)
          );
        })(i) &&
          hg(this.pressedKeys, n) &&
          (i = n),
        (t = fg.call(this, i)),
        Eg(this.clientConnectionId),
        (rg[nr] && -1 !== rg[nr].indexOf(i.key)) ||
          (Qr() &&
            "CapsLock" === i.key &&
            Bg.call(this, this.channel, this.clientConnectionId, i, !0, bg.call(this, A)),
          r
            ? Bg.call(this, this.channel, this.clientConnectionId, o, !1)
            : t && Bg.call(this, this.channel, this.clientConnectionId, t, !1, bg.call(this, A))),
        ("Meta" !== i.key && "OS" !== i.key) ||
          !Qr() ||
          ((this.pressedKeys = mg.call(this)), (this.macKeyboardQuirks.commandIsPressed = !1)),
        hr() || dg(A);
    }
  else this.log.warn("Unidentified key");
}
function Og(A) {
  const e = new lg(this.macKeyboardQuirks.commandIsPressed);
  e.set(Qg(A.key, A.keyCode), A.location, A.code),
    this.deadKeyStatus !== cg.NOT_COMPOSING &&
      (Br() || Er()) &&
      ("Unidentified" !== e.key
        ? (yg.call(this, A, e),
          (rg[nr] && -1 !== rg[nr].indexOf(e.key)) ||
            (Bg.call(this, this.channel, this.clientConnectionId, e, !0, bg.call(this, A)),
            Bg.call(this, this.channel, this.clientConnectionId, e, !1)),
          this.deadKeyStatus === cg.COMPOSING && (this.deadKeyStatus = cg.COMPOSED),
          dg(A))
        : this.log.warn("Unidentified key"));
}
function kg(A, e) {
  Qr()
    ? this.deadKeyStatus !== cg.NOT_COMPOSING
      ? (this.ignoredOptionDeadKey
          ? this.log.debug(
              "Detected Option + dead key composition but Option is set to behave like Alt, ignored"
            )
          : ur() ||
            (this.deadKeyCompEndedOnBackspace
              ? (this.deadKeyCompEndedOnBackspace = !1)
              : Sg.call(this, e)),
        (this.deadKeyStatus = cg.COMPOSED))
      : this.log.warn("Received composition end but not in a composition")
    : this.log.debug("Received compositionEnd event when not supposed to");
}
function Ng(A, e) {
  Qr()
    ? this.repeating && (Ug.call(this, e), (this.repeating = !1))
    : this.log.debug("Received input event when not supposed to");
}
function Kg(A, e, t) {
  const i = js(A).getDataChannel(Ia.DISPLAY);
  if (i) {
    const A = i.getDisplayManager();
    if (null === A.getScaleRatio(t)) {
      if ("offsetX" in e && "offsetY" in e && (e.isTrusted || (!dr() && !Qr())))
        return A.translateCoordinates(e.offsetX, e.offsetY, t);
      const i = e.target.getBoundingClientRect(),
        n = e.pageX - i.x,
        o = e.pageY - i.y,
        r = e.target.offsetWidth / i.width;
      return A.translateCoordinates(n * r, o * r, t);
    }
    return A.translateCoordinates(e.clientX, e.clientY, t);
  }
  return { x: 0, y: 0 };
}
function Lg(A) {
  return Ao(A.force) ? { force: 0, is_valid: !1 } : { force: A.force, is_valid: !0 };
}
function Tg(A) {
  const e = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  "none" === A
    ? e.getDisplayManager().setCursorStyle("none")
    : A
      ? e.getDisplayManager().setCursorStyle(`url(${A.url}) ${A.hotspotX} ${A.hotspotY}, auto`)
      : e.getDisplayManager().setCursorStyle("auto");
}
function Pg() {
  const A = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  this.hiddenCursor &&
    A &&
    ((this.hiddenCursor = !1),
    Tg.call(this, this.currentCursorStyle || "auto"),
    A.getDisplayManager().setVirtualCursor({ visible: !1 }));
}
function Gg(A, e, t, i) {
  let n,
    o,
    r,
    s,
    a,
    g = 0;
  document.pointerLockElement ||
    ((n = Kg(i, A, e)),
    (o = (function (A) {
      const e = [];
      return (
        A.buttons & Za.eraser
          ? (e.push(ag.StylusButton.STYLUS_BUTTON_1), e.push(ag.StylusButton.STYLUS_BUTTON_2))
          : A.buttons & Za.tip && e.push(ag.StylusButton.STYLUS_BUTTON_1),
        A.buttons & Za.barrel && e.push(ag.StylusButton.STYLUS_BUTTON_3),
        e
      );
    })(A)),
    (s = o.length > 0),
    (r = o.indexOf(ag.StylusButton.STYLUS_BUTTON_2) >= 0),
    (a = !Ao(A.twist)),
    a && (g = A.twist),
    t.sendInputMessage({
      stylusEvent: {
        pointerId: A.pointerId,
        x: n.x,
        y: n.y,
        inverted: r,
        inAir: !s,
        hasPressure: !0,
        pressure: A.pressure,
        hasRotation: a,
        rotation: a ? g : 0,
        hasTiltX: !0,
        tiltX: A.tiltX,
        hasTiltY: !0,
        tiltY: A.tiltY,
        stylusButtons: o,
        estimatedTimestamp: Cg(i)
      }
    })),
    dg(A);
}
function Hg(A) {
  dg(A);
}
function Yg(A) {
  dg(A);
}
function qg(A, e) {
  switch (A.pointerType) {
    case "pen":
      if (this.channel.isStylusSupportedByServer()) {
        (this.ignoreTouch = !0), Gg(A, e, this.channel, this.clientConnectionId);
        break;
      }
    case "touch":
    case "mouse":
      break;
    default:
      this.log.debug(`pointerType ${A.pointerType} is not supported`);
  }
}
function Jg(A, e) {
  switch (A.pointerType) {
    case "pen":
      if (this.channel.isStylusSupportedByServer()) {
        Gg(A, e, this.channel, this.clientConnectionId);
        break;
      }
    case "touch":
    case "mouse":
      break;
    default:
      this.log.debug(`pointerType ${A.pointerType} is not supported`);
  }
}
function jg(A, e) {
  switch (A.pointerType) {
    case "pen":
      if (this.channel.isStylusSupportedByServer()) {
        (this.ignoreTouch = !1), Gg(A, e, this.channel, this.clientConnectionId);
        break;
      }
    case "touch":
    case "mouse":
      break;
    default:
      this.log.debug(`pointerType ${A.pointerType} is not supported`);
  }
}
function Wg(A, e) {
  if (document.pointerLockElement)
    this.channel.sendInputMessage({
      pointerRelativeMotionEvent: { dx: A.movementX, dy: A.movementY }
    });
  else {
    const t = Kg(this.clientConnectionId, A, e);
    Pg.call(this), this.channel.sendInputMessage({ pointerMotionEvent: { x: t.x, y: t.y } });
  }
  (this.mouseOut = !1), dg(A);
}
function Vg(A) {
  return [1, 3, 2, 4, 5, 6, 7, 8][A];
}
function _g(A) {
  let e = null;
  for (let t = 0; t < 8; t++)
    if ((this.previousMouseButtonsState ^ A.buttons) & (1 << t)) {
      e = Vg(t);
      break;
    }
  return null === e && (e = A.button + 1), (this.previousMouseButtonsState = A.buttons), e;
}
function Xg(A, e) {
  let t,
    i,
    n = _g.call(this, A);
  if (fr() && 1 === A.buttons && !this.resyncOnNextMouseMove) {
    i = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
    const A = i?.getDisplayManager(),
      t = A?.getCurrentDisplays();
    if (t && 2 === t.length) {
      const i = t.findIndex((A) => A.id !== e),
        n = t[i].id,
        o = (A) => {
          zg.call(this, A, n), (this.resyncOnNextMouseMove = !1);
        };
      A.getInputDiv(n).addEventListener("mousemove", o.bind(this), { once: !0 }),
        (this.resyncOnNextMouseMove = !0);
    }
  }
  yg.call(this, A),
    Eg(this.clientConnectionId),
    document.pointerLockElement ||
      ((t = Kg(this.clientConnectionId, A, e)),
      Pg.call(this),
      (i = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY)),
      i && i.getDisplayManager().captureMouse(),
      this.channel.sendInputMessage({ pointerMotionEvent: { x: t.x, y: t.y } })),
    this.channel.sendInputMessage({
      pointerButtonPressEvent: { button: n, estimatedTimestamp: Cg(this.clientConnectionId) }
    }),
    dg(A);
}
function zg(A, e) {
  let t = Kg(this.clientConnectionId, A, e);
  Pg.call(this);
  let i = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  i?.getDisplayManager().captureMouse(),
    this.channel.sendInputMessage({ pointerMotionEvent: { x: t.x, y: t.y } });
  for (let e = 0; e < 8; e++)
    if ((this.previousMouseButtonsState ^ A.buttons) & (1 << e)) {
      const t = Vg(e);
      A.buttons & (1 << e) ||
        this.channel.sendInputMessage({
          pointerButtonReleaseEvent: { button: t, estimatedTimestamp: Cg(this.clientConnectionId) }
        });
    }
  for (let e = 0; e < 8; e++)
    if ((this.previousMouseButtonsState ^ A.buttons) & (1 << e)) {
      const t = Vg(e);
      A.buttons & (1 << e) &&
        this.channel.sendInputMessage({
          pointerButtonPressEvent: { button: t, estimatedTimestamp: Cg(this.clientConnectionId) }
        });
    }
  this.previousMouseButtonsState = A.buttons;
}
function Zg(A, e) {
  zg.call(this, A, e);
}
function $g(A, e) {
  const t = e.displayInputDiv.getBoundingClientRect(),
    i = new DOMRect(
      e.window.screenX + t.left,
      e.window.screenY + e.window.outerHeight - e.window.innerHeight + t.top,
      t.width,
      t.height
    );
  if (A.screenX < i.left || A.screenX > i.right || A.screenY < i.top || A.screenY > i.bottom)
    return;
  const n = e.window.innerHeight === e.window.screen.height,
    o = e.window.screen.availHeight === e.window.outerHeight,
    r = !Br() || n || (!dr() && o) ? 0 : 8,
    s = i.left - t.left,
    a = i.top - t.top,
    g = new MouseEvent(A.type, {
      screenX: A.screenX,
      screenY: A.screenY,
      clientX: A.screenX - r - s,
      clientY: A.screenY + r - a,
      ctrlKey: A.ctrlKey,
      shiftKey: A.shiftKey,
      altKey: A.altKey,
      metaKey: A.metaKey,
      button: A.button,
      buttons: A.buttons
    });
  e.displayInputDiv.dispatchEvent(g);
}
function Ac(A, e) {
  const t = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  if (!t) return;
  const i = t.getDisplayManager(),
    n = i?.getCurrentDisplays();
  if (n && 1 === this.previousMouseButtonsState && 2 === n.length) {
    const A = n.findIndex((A) => A.id === e),
      t = 0 === A ? 1 : 0,
      i = n[A],
      o = (A) => {
        $g.call(this, A, n[t]);
      };
    i.window.addEventListener("mousemove", o),
      i.window.addEventListener("mouseup", o, { once: !0 }),
      i.window.addEventListener("mouseup", () => i.window.removeEventListener("mousemove", o), {
        once: !0
      }),
      i.displayInputDiv.addEventListener(
        "mouseenter",
        () => i.window.removeEventListener("mousemove", o),
        { once: !0 }
      );
  }
  const o = Kg(this.clientConnectionId, A, e);
  o.isHotCorner &&
    this.channel.sendInputMessage({ pointerMotionEvent: { x: o.cornerX, y: o.cornerY } }),
    (this.mouseOut = !0);
}
function ec(A, e) {
  const t = _g.call(this, A),
    i = Kg(this.clientConnectionId, A, e),
    n = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  if ((yg.call(this, A), Eg(this.clientConnectionId), !document.pointerLockElement)) {
    if ((Pg.call(this), !n || !n.getDisplayManager().isMouseCaptured())) return;
    this.channel.sendInputMessage({ pointerMotionEvent: { x: i.x, y: i.y } });
  }
  this.channel.sendInputMessage({
    pointerButtonReleaseEvent: { button: t, estimatedTimestamp: Cg(this.clientConnectionId) }
  }),
    !document.pointerLockElement && n && n.getDisplayManager().releaseMouse(),
    dg(A);
}
function tc(A, e) {
  let t,
    i = 1;
  switch (e) {
    case 1:
      i = eg;
      break;
    case 2:
      i = tg;
  }
  return (
    (t = i * A),
    Math.abs(t) < Ag &&
      ((t = Math.sign(t) * Ag),
      this.log.debug(`Value for scroll delta was ${i * A}, using ${t} instead`)),
    Math.round(t)
  );
}
function ic(A, e) {
  this.channel.sendInputMessage({
    pointerAxisEvent: { axis: A, value: e, estimatedTimestamp: Cg(this.clientConnectionId) }
  });
}
function nc(A) {
  let e,
    t = performance.now();
  Pg.call(this),
    this.wheelStats.deltaMode.add(A.deltaMode),
    this.wheelStats.deltaY.add(A.deltaY),
    this.wheelStats.wheelDeltaY.add(A.wheelDeltaY),
    (e =
      Qr() || hr()
        ? (function (A) {
            const e = { deltaX: 0, deltaY: 0, deltaZ: 0, deltaMode: 0 };
            "deltaX" in A && 0 !== A.deltaX && (e.deltaX = Math.sign(A.deltaX) * Ag);
            "deltaY" in A && 0 !== A.deltaY && (e.deltaY = Math.sign(A.deltaY) * Ag);
            "deltaZ" in A && 0 !== A.deltaZ && (e.deltaZ = Math.sign(A.deltaZ) * Ag);
            return e;
          })(A)
        : A),
    t - this.wheelLatestEventTime >= $a &&
      ((this.wheelLatestEventTime = t),
      0 !== e.deltaX &&
        ic.call(this, ag.PointerAxisEvent.Axis.X_AXIS, tc.call(this, e.deltaX, e.deltaMode)),
      0 !== e.deltaY &&
        ic.call(this, ag.PointerAxisEvent.Axis.Y_AXIS, tc.call(this, e.deltaY, e.deltaMode)),
      0 !== e.deltaZ &&
        ic.call(this, ag.PointerAxisEvent.Axis.Z_AXIS, tc.call(this, e.deltaZ, e.deltaMode))),
    dg(A);
}
function oc(A, e) {
  this.ignoreTouch || this.touchCallbacks.move(A, e), dg(A);
}
function rc(A, e) {
  this.ignoreTouch || this.touchCallbacks.start(A, e);
  const t = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  t && t.getDisplayManager().focusDisplayDiv(e), dg(A);
}
function sc(A, e) {
  this.ignoreTouch || this.touchCallbacks.end(A, e), dg(A);
}
function ac(A, e) {
  let t,
    i,
    n,
    o = [];
  for (t = 0; t < A.targetTouches.length; t++)
    (i = Kg(this.clientConnectionId, A.targetTouches[t], e)),
      (n = Lg(A.targetTouches[t])),
      (o[t] = {
        id: A.targetTouches[t].identifier + 1,
        x: i.x,
        y: i.y,
        top: i.y,
        bottom: i.y,
        left: i.x,
        right: i.x,
        status: ag.TouchStatus.MOTION,
        hasPressure: n.is_valid,
        pressure: n.force
      });
  this.channel.sendInputMessage({
    touchEvent: {
      groupId: this.currentGroupId,
      touches: o,
      estimatedTimestamp: Cg(this.clientConnectionId)
    }
  });
}
function gc(A, e) {
  let t,
    i,
    n,
    o = [],
    r = {};
  for (
    A.changedTouches.length === A.targetTouches.length &&
      (this.currentGroupId = (this.currentGroupId % 128) + 1),
      t = 0;
    t < A.changedTouches.length;
    t++
  )
    (r[A.changedTouches[t].identifier] = !0),
      (i = Kg(this.clientConnectionId, A.changedTouches[t], e)),
      (n = Lg(A.changedTouches[t])),
      o.push({
        id: A.changedTouches[t].identifier + 1,
        x: i.x,
        y: i.y,
        top: i.y,
        bottom: i.y,
        left: i.x,
        right: i.x,
        status: ag.TouchStatus.DOWN,
        hasPressure: n.is_valid,
        pressure: n.force
      });
  for (t = 0; t < A.targetTouches.length; t++)
    Object.prototype.hasOwnProperty.call(r, A.targetTouches[t].identifier) ||
      ((i = Kg(this.clientConnectionId, A.targetTouches[t], e)),
      (n = Lg(A.targetTouches[t])),
      o.push({
        id: A.targetTouches[t].identifier + 1,
        x: i.x,
        y: i.y,
        top: i.y,
        bottom: i.y,
        left: i.x,
        right: i.x,
        status: ag.TouchStatus.MOTION,
        hasPressure: n.is_valid,
        pressure: n.force
      }));
  this.channel.sendInputMessage({ touchEvent: { groupId: this.currentGroupId, touches: o } });
}
function cc(A, e) {
  let t,
    i,
    n,
    o = [];
  for (t = 0; t < A.changedTouches.length; t++)
    (i = Kg(this.clientConnectionId, A.changedTouches[t], e)),
      (n = Lg(A.changedTouches[t])),
      o.push({
        id: A.changedTouches.item(t).identifier + 1,
        x: i.x,
        y: i.y,
        top: i.y,
        bottom: i.y,
        left: i.x,
        right: i.x,
        status: ag.TouchStatus.UP,
        hasPressure: n.is_valid,
        pressure: n.force
      });
  for (t = 0; t < A.targetTouches.length; t++)
    (i = Kg(this.clientConnectionId, A.targetTouches[t], e)),
      (n = Lg(A.targetTouches[t])),
      o.push({
        id: A.targetTouches.item(t).identifier + 1,
        x: i.x,
        y: i.y,
        top: i.y,
        bottom: i.y,
        left: i.x,
        right: i.x,
        status: ag.TouchStatus.MOTION,
        hasPressure: n.is_valid,
        pressure: n.force
      });
  this.channel.sendInputMessage({ touchEvent: { groupId: this.currentGroupId, touches: o } });
}
function Ic(A, e) {
  let t;
  1 === A.changedTouches.length &&
    ((t = Kg(this.clientConnectionId, A.changedTouches[0], e)),
    Pg.call(this),
    this.channel.sendInputMessage({ pointerMotionEvent: { x: t.x, y: t.y } }));
}
function lc(A, e) {
  let t;
  1 === A.targetTouches.length &&
    ((t = Kg(this.clientConnectionId, A.targetTouches[0], e)),
    Pg.call(this),
    this.channel.sendInputMessage({ pointerMotionEvent: { x: t.x, y: t.y } }),
    this.channel.sendInputMessage({
      pointerButtonPressEvent: { button: 1, estimatedTimestamp: Cg(this.clientConnectionId) }
    }));
}
function dc(A, e) {
  let t;
  1 === A.changedTouches.length &&
    ((t = Kg(this.clientConnectionId, A.changedTouches[0], e)),
    Pg.call(this),
    this.channel.sendInputMessage({ pointerMotionEvent: { x: t.x, y: t.y } }),
    this.channel.sendInputMessage({
      pointerButtonReleaseEvent: { button: 1, estimatedTimestamp: Cg(this.clientConnectionId) }
    }),
    (function (A, e, t, i, n) {
      let o, r, s;
      return (
        (o = 500),
        (r = Kg(i, n)),
        (s = Kg(i, A)),
        !!n.timestamp &&
          (e && t
            ? performance.now() - n.timestamp <= 500 &&
              s.x > r.x - ig &&
              s.x < r.x + ig &&
              s.y > r.y - ig &&
              s.y < r.y + ig
            : t
              ? performance.now() - n.timestamp <= 500
              : !!e && s.x > r.x - ig && s.x < r.x + ig && s.y > r.y - ig && s.y < r.y + ig)
      );
    })(A.changedTouches[0], !0, !0, this.clientConnectionId, this.lastTouchEnded) &&
      (function (A, e, t, i) {
        let n;
        (n = Kg(i, A, e)),
          t.sendInputMessage({ pointerMotionEvent: { x: n.x, y: n.y } }),
          t.sendInputMessage({
            pointerButtonPressEvent: { button: 1, estimatedTimestamp: Cg(i) + 10 }
          }),
          t.sendInputMessage({ pointerMotionEvent: { x: n.x, y: n.y } }),
          t.sendInputMessage({
            pointerButtonReleaseEvent: { button: 1, estimatedTimestamp: Cg(i) + 20 }
          });
      })(A.changedTouches[0], e, this.channel, this.clientConnectionId),
    (this.lastTouchEnded = A.changedTouches[0]),
    (this.lastTouchEnded.timestamp = performance.now()));
}
function uc(A, e) {
  this.pressedKeys.forEach((A) => {
    const e = new lg(this.macKeyboardQuirks.commandIsPressed);
    if (
      ("Alt" === A.key &&
        (e.set("Control", KeyboardEvent.DOM_KEY_LOCATION_LEFT),
        Bg.call(this, this.channel, this.clientConnectionId, e, !0),
        Bg.call(this, this.channel, this.clientConnectionId, e, !1)),
      ("OS" === A.key || "Meta" === A.key) && this.macKeyboardQuirks.commandToControl && Qr())
    )
      return (
        e.set("Control", A.location),
        void Bg.call(this, this.channel, this.clientConnectionId, e, !1)
      );
    Bg.call(this, this.channel, this.clientConnectionId, A, !1);
  }),
    (this.pressedKeys = []),
    this.resetDeadKeyFlags(),
    Qr() && !this.currentIMEMode && Ug.call(this, e),
    (this.sendLocksSync = !0);
}
function Cc() {
  this.log.info(`Pointer ${document.pointerLockElement ? "" : "not "}locked`);
}
function Bc() {
  this.log.warn(`Pointer lock error, pointer ${document.pointerLockElement ? "" : "not "}locked`);
}
function Qc() {
  return (
    window.PointerEvent || window.navigator.pointerEnabled || window.navigator.msPointerEnabled
  );
}
function Ec() {
  (this.onKeyDown = vg.bind(this)),
    (this.onKeyUp = Mg.bind(this)),
    (this.onKeyPress = Og.bind(this)),
    (this.onWheel = nc.bind(this)),
    (this.onBlur = uc.bind(this)),
    (this.onCompositionEnd = kg.bind(this)),
    (this.onInput = Ng.bind(this)),
    Qc() &&
      ((this.onPointerCancel = Hg.bind(this)),
      (this.onPointerDown = qg.bind(this)),
      (this.onPointerMove = Jg.bind(this)),
      (this.onPointerUp = jg.bind(this)),
      (this.onPointerLeave = Yg.bind(this))),
    (this.onMouseMove = Wg.bind(this)),
    (this.onMouseDown = Xg.bind(this)),
    (this.onMouseUp = ec.bind(this)),
    (this.onMouseEnter = Zg.bind(this)),
    (this.onMouseLeave = Ac.bind(this)),
    (this.onTouchStart = rc.bind(this)),
    (this.onTouchMove = oc.bind(this)),
    (this.onTouchEnd = sc.bind(this)),
    (this.onTouchCancel = dg.bind(this));
}
function hc() {
  const A = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  this.log.debug("Removing input event handlers"),
    document.removeEventListener("pointerlockchange", this.onPointerLockChange),
    document.removeEventListener("pointerlockerror", this.onPointerLockError),
    A && A.getDisplayManager().clearInputListeners();
}
function pc() {
  const A = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY),
    e = Ws(this.clientConnectionId);
  (this.relativeMouseMode.enabled =
    this.relativeMouseMode.displayIsSingleMonitor && this.relativeMouseMode.serverAvailable),
    A && A.getDisplayManager().enableRelativeMouseMode(this.relativeMouseMode.enabled),
    e.update("relative-mouse", { enabled: this.relativeMouseMode.enabled }),
    !this.relativeMouseMode.enabled && document.pointerLockElement && document.exitPointerLock();
}
function fc(A) {
  (this.relativeMouseMode.displayIsSingleMonitor = A.enabled), pc.call(this);
}
function mc() {
  (this.cursorCanvas = null), (this.cursorCanvasContext = null);
}
function yc(A, e) {
  this.cursorCanvas || (this.cursorCanvas = document.createElement("canvas")),
    this.cursorCanvasContext
      ? this.cursorCanvasContext.clearRect(0, 0, this.cursorCanvas.width, this.cursorCanvas.height)
      : (this.cursorCanvasContext = this.cursorCanvas.getContext("2d")),
    (this.cursorCanvas.width === A && this.cursorCanvas.height === e) ||
      ((this.cursorCanvas.width = A), (this.cursorCanvas.height = e));
}
gg.set("Alt", KeyboardEvent.DOM_KEY_LOCATION_LEFT),
  (Ig.prototype.registerChannel = function (A) {
    this.channel && this.log.warn("Channel registration overwriting previous channel"),
      (this.channel = A),
      clearInterval(this.wheelStatsInterval),
      (this.wheelStatsInterval = null),
      this.wheelStats.deltaMode.clear(),
      this.wheelStats.deltaY.clear(),
      this.wheelStats.wheelDeltaY.clear();
    this.wheelStatsInterval = setInterval(() => this.logWheelExperimentalStats(), 3e5);
  }),
  (Ig.prototype.unregisterChannel = function (A) {
    this.channel === A
      ? (hc.call(this),
        (this.channel = null),
        (this.macKeyboardQuirks.commandIsPressed = !1),
        (this.previousMouseButtonsState = 0),
        document.pointerLockElement && document.exitPointerLock(),
        clearInterval(this.wheelStatsInterval),
        (this.wheelStatsInterval = null),
        this.resetDeadKeyFlags())
      : this.log.warn("Skip unregister of wrong channel");
  }),
  (Ig.prototype.registerShortcuts = function (A) {
    this.shortcuts = A;
  }),
  (Ig.prototype.setPosition = function (A, e) {
    const t = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
    this.mouseOut
      ? (this.mouseOut = !1)
      : t &&
        (this.hiddenCursor ||
          ((this.hiddenCursor = !0),
          Tg.call(this, "none"),
          this.currentCursorStyle &&
            t
              .getDisplayManager()
              .setVirtualCursor({
                visible: !0,
                imgSrc: this.currentCursorStyle.url,
                hotspotX: this.currentCursorStyle.hotspotX,
                hotspotY: this.currentCursorStyle.hotspotY,
                width: this.currentCursorStyle.width,
                height: this.currentCursorStyle.height
              })),
        t.getDisplayManager().setVirtualCursorPosition(A, e));
  }),
  (Ig.prototype.setCurrentCursor = function (A) {
    const e = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
    if (!e)
      return (
        this.log.info(
          "setCurrentCursor called before the DisplayChannel is available - caching for draw when DisplayChannel is up"
        ),
        void (this.cachedCursorStyle = A)
      );
    (this.currentCursorStyle = A),
      this.hiddenCursor || Tg.call(this, this.currentCursorStyle),
      e
        .getDisplayManager()
        .setVirtualCursor({
          visible: this.hiddenCursor,
          imgSrc: this.currentCursorStyle.url,
          hotspotX: this.currentCursorStyle.hotspotX,
          hotspotY: this.currentCursorStyle.hotspotY,
          width: this.currentCursorStyle.width,
          height: this.currentCursorStyle.height
        });
  }),
  (Ig.prototype.enableRelativeMouseMode = function (A) {
    (this.relativeMouseMode.serverAvailable = A), pc.call(this);
  }),
  (Ig.prototype.latency = function () {
    return this.channel ? this.channel.latency() : 0;
  }),
  (Ig.prototype.sendKey = function (A, e, t) {
    this.log.debug(`Sending key: ${A} location:${e}, isDown: ${t}`),
      Bg.call(this, this.channel, this.clientConnectionId, { key: A, location: e }, t);
  }),
  (Ig.prototype.setTouchSupported = function (A) {
    A
      ? (this.log.debug("Touch input mode is native"),
        (this.touchCallbacks.move = ac.bind(this)),
        (this.touchCallbacks.start = gc.bind(this)),
        (this.touchCallbacks.end = cc.bind(this)))
      : (this.log.debug("Touch input mode is legacy"),
        (this.touchCallbacks.move = Ic.bind(this)),
        (this.touchCallbacks.start = lc.bind(this)),
        (this.touchCallbacks.end = dc.bind(this)));
  }),
  (Ig.prototype.setMacOptionToAlt = function (A) {
    this.macKeyboardQuirks.optionToAlt = A && Qr();
  }),
  (Ig.prototype.setMacCommandToControl = function (A) {
    this.macKeyboardQuirks.commandToControl = A && Qr();
  }),
  (Ig.prototype.setForceKeyboardCombinations = function (A) {
    (this.macKeyboardQuirks.controlOptionToControlAlt = A && Qr()),
      (this.winKeyboardQuirks.leftAltNoGraph = A && Br());
  }),
  (Ig.prototype.latchModifier = function (A, e, t) {
    return (function (A, e) {
      return sg.some((t) => t.key === A && t.location === e);
    })(A, e) && "boolean" == typeof t
      ? (this.log.debug(`Sending key modifier: ${A} location:${e}, isDown: ${t}`),
        Bg.call(this, this.channel, this.clientConnectionId, { key: A, location: e }, t),
        !0)
      : (this.log.debug("Invalid modifier injection request received ", A, e, t), !1);
  }),
  (Ig.prototype.sendKeyboardEvent = function (A) {
    if (!Ao(A.type)) {
      if ("keydown" === A.type) return this.onKeyDown(A), !0;
      if ("keypress" === A.type) return this.onKeyPress(A), !0;
      if ("keyup" === A.type) return this.onKeyUp(A), !0;
    }
    return !1;
  }),
  (Ig.prototype.addListeners = function () {
    let A,
      e,
      t = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
    t &&
      (hc.call(this),
      document.addEventListener("pointerlockchange", this.onPointerLockChange),
      document.addEventListener("pointerlockerror", this.onPointerLockError),
      Ec.call(this),
      (A = {
        keydown: this.onKeyDown,
        keyup: this.onKeyUp,
        keypress: this.onKeyPress,
        wheel: this.onWheel,
        blur: this.onBlur
      }),
      Qr() && ((A.compositionend = this.onCompositionEnd), (A.input = this.onInput)),
      (e = { relativeMouseAvailabilityCallback: fc.bind(this) }),
      Qc()
        ? (this.log.info("Pointer Events are supported"),
          (A.MSPointerCancel = A.pointercancel = this.onPointerCancel),
          (A.MSPointerDown = A.pointerdown = this.onPointerDown),
          (A.MSPointerMove = A.pointermove = this.onPointerMove),
          (A.MSPointerUp = A.pointerup = this.onPointerUp),
          (A.MSPointerLeave = A.pointerleave = this.onPointerLeave))
        : this.log.info("Pointer Events are not supported"),
      (A.mousemove = this.onMouseMove),
      (A.mousedown = this.onMouseDown),
      (A.mouseup = this.onMouseUp),
      (A.mouseenter = this.onMouseEnter),
      (A.mouseleave = this.onMouseLeave),
      (A.touchstart = this.onTouchStart),
      (A.touchmove = this.onTouchMove),
      (A.touchend = this.onTouchEnd),
      (A.touchcancel = this.stopEvent),
      t.getDisplayManager().addInputListeners(A, e.relativeMouseAvailabilityCallback));
  }),
  (Ig.prototype.applyCachedCursorForDisplay = function () {
    this.cachedCursorStyle &&
      (this.setCurrentCursor(this.cachedCursorStyle), (this.cachedCursorStyle = null));
  }),
  (Ig.prototype.setIMEModeBehavior = function (A) {
    this.IMEModeBehavior = A;
  }),
  (Ig.prototype.setCurrentIMEMode = function (A) {
    this.resetDeadKeyFlags(), (this.currentIMEMode = A);
  }),
  (Ig.prototype.resetDeadKeyFlags = function () {
    (this.deadKeyStatus = cg.NOT_COMPOSING),
      (this.ignoredOptionDeadKey = !1),
      (this.deadKeyCompEndedOnBackspace = !1),
      (this.repeating = !1);
  }),
  (Ig.prototype.logWheelExperimentalStats = function () {
    let A = "no usage recorded";
    this.wheelStats.deltaMode.size > 0 &&
      (A = `DeltaModes [${[...this.wheelStats.deltaMode]}], DeltaYs [${[...this.wheelStats.deltaY]}], WDeltaYs [${[...this.wheelStats.wheelDeltaY]}]`),
      this.log.info(`Wheel experimental stats: ${A}, Browser ${Ir().getBrowserName()} on ${nr}`),
      this.wheelStats.deltaMode.clear(),
      this.wheelStats.deltaY.clear(),
      this.wheelStats.wheelDeltaY.clear();
  }),
  (mc.prototype.createCursorDataURL = function (A, e, t) {
    let i,
      n = !0,
      o = null;
    yc.call(this, A, e), (i = this.cursorCanvasContext.createImageData(A, e));
    for (let o = 0; o < e * A; o++)
      0 !== t[4 * o] &&
        ((i.data[4 * o + 0] = t[4 * o + 1]),
        (i.data[4 * o + 1] = t[4 * o + 2]),
        (i.data[4 * o + 2] = t[4 * o + 3]),
        (i.data[4 * o + 3] = t[4 * o + 0]),
        (n = !1));
    return (
      n ||
        (this.cursorCanvasContext.putImageData(i, 0, 0),
        (o = this.cursorCanvas.toDataURL("image/png"))),
      o
    );
  }),
  (mc.prototype.createEmptyCursorDataURL = function (A, e) {
    yc.call(this, A, e);
    const t = this.cursorCanvasContext.createImageData(A, e),
      i = e * A;
    for (let A = 0; A < 4 * i; A += 1) t.data[A] = 0;
    return (
      (t.data[i - 4] = 10),
      (t.data[i - 3] = 10),
      (t.data[i - 2] = 10),
      (t.data[i - 1] = 10),
      this.cursorCanvasContext.putImageData(t, 0, 0),
      this.cursorCanvas.toDataURL("image/png")
    );
  });
const Dc = { major: 1, minor: 1 },
  wc = za.input;
function Fc(A, e) {
  const t = (e) => {
    this.log.debug(`Add cursor ${A.id} to cache (size: ${A.width}x${A.height})`),
      this.cursorCache.set(A.id, {
        url: e,
        hotspotX: A.hotspotX,
        hotspotY: A.hotspotY,
        width: A.width,
        height: A.height
      });
  };
  if (A.pixelFormat === this.cursorPixelFormat)
    if (A.pixelFormat === wc.CursorImagePixelFormat.RAW_ARGB_DATA) {
      const i = this.cursor.createCursorDataURL(A.width, A.height, e);
      i
        ? t(i)
        : (this.log.debug("Received empty cursor shape"),
          t(this.cursor.createEmptyCursorDataURL(A.width, A.height)));
    } else this.log.warn(`Unknown pixel format ${A.pixelFormat} for cursor ${A.id}`);
  else
    this.log.warn(
      `Unsupported pixel format ${A.pixelFormat} for cursor ${A.id}, must be ${this.cursorPixelFormat}`
    );
}
function bc(A, e) {
  let t,
    i,
    n,
    o,
    r = !1;
  this.log.debug(
    `Received pointer cursor message with currentCursorsId: ${A.pointerCursors.currentCursorId}`
  );
  const s = (A) => {
      o = { url: A, hotspotX: 0, hotspotY: 0, width: 32, height: 32 };
    },
    a = () => {
      o ||
        (0 !== this.currentPointerCursor &&
          (this.log.info(`Cursor ${this.currentPointerCursor} not cached`),
          this.sendInputMessage({
            pointerRequireCursorImages: { ids: [this.currentPointerCursor] }
          })));
    };
  if (
    this.cursorPixelFormat !== wc.CursorImagePixelFormat.NONE &&
    A.pointerCursors.cursorImages.length > 0
  ) {
    i = 0;
    for (let o = 0; o < A.pointerCursors.cursorImages.length; ++o)
      (t = A.pointerCursors.cursorImages[o]),
        (n = t.width * t.height * 4),
        Fc.call(this, t, new Uint8Array(e, i, n)),
        (i += n);
  }
  if (A.pointerCursors.hidden)
    this.log.info("Received empty cursor"),
      s(this.cursor.createEmptyCursorDataURL(32, 32)),
      this.input.setCurrentCursor(o);
  else if (
    (A.pointerCursors.currentCursorId > 0 &&
      (this.cursorPixelFormat === wc.CursorImagePixelFormat.NONE &&
        this.currentPointerCursor &&
        (this.log.info(`Cursor type: ${this.currentPointerCursor.getHighBitsUnsigned()}`),
        this.currentPointerCursor.getHighBitsUnsigned() >> 8 &&
          this.currentPointerCursor.getHighBitsUnsigned() >> 8 ==
            A.pointerCursors.currentCursorId.getHighBitsUnsigned() >> 8 &&
          (r = !0)),
      r || (this.currentPointerCursor = A.pointerCursors.currentCursorId)),
    this.log.debug(`currentPointerCursor is: ${this.currentPointerCursor}`),
    this.cursorPixelFormat !== wc.CursorImagePixelFormat.NONE)
  )
    (o = this.cursorCache.get(this.currentPointerCursor)), a(), o && this.input.setCurrentCursor(o);
  else {
    if (Ao(this.cursorResource))
      return void this.log.warn(
        `Received cursor ${this.currentPointerCursor}, but cursorResource is not available`
      );
    this.cursorResource
      .fetch({ id: this.currentPointerCursor, t: this.cursorTimestamp })
      .then((A) => {
        s(URL.createObjectURL(A)), this.input.setCurrentCursor(o);
      })
      .catch((A) => {
        this.log.warn(A), a();
      });
  }
}
function Uc(A) {
  const e = A.pointerInvalidateCursors.ids;
  for (const A of e) this.cursorCache.delete(A);
}
function Sc() {
  this.cursorPixelFormat !== wc.CursorImagePixelFormat.NONE
    ? (this.cursorCache = new Map())
    : (this.cursorTimestamp = Date.now());
}
function Rc(A) {
  const e = Ws(this.clientConnectionId);
  switch (
    (this.log.info(
      `Input service '${(function (A) {
        switch (A) {
          case wc.InputService.KEYBOARD:
            return "keyboard";
          case wc.InputService.MOUSE:
            return "mouse";
          case wc.InputService.TOUCH:
            return "touch";
          case wc.InputService.POINTER:
            return "pointer";
          case wc.InputService.STYLUS:
            return "stylus";
          case wc.InputService.GAMEPAD:
            return "gamepad";
          case wc.InputService.SAS:
            return "webauthn";
          case wc.InputService.WEBAUTHN:
            return "keyboard-sas";
          default:
            return `unknown (${A})`;
        }
      })(A.statusUpdate.inputService)}' changed status to '${(function (A) {
        switch (A) {
          case wc.Status.NOT_AVAILABLE:
            return "not available";
          case wc.Status.AVAILABLE:
            return "available";
          case wc.Status.ACTIVE:
            return "active";
          case wc.Status.BUSY:
            return "busy";
          default:
            return `unknown (${A})`;
        }
      })(A.statusUpdate.inputStatus)}'`
    ),
    A.statusUpdate.inputService)
  ) {
    case wc.InputService.KEYBOARD:
      (this.status.keyboard = A.statusUpdate.inputStatus),
        e.update("keyboard", { enabled: this.status.keyboard === wc.Status.ACTIVE });
      break;
    case wc.InputService.MOUSE:
      (this.status.mouse = A.statusUpdate.inputStatus),
        e.update("mouse", { enabled: this.status.mouse === wc.Status.ACTIVE });
      break;
    case wc.InputService.TOUCH:
      (this.status.touch = A.statusUpdate.inputStatus),
        this.input.setTouchSupported(this.status.touch === wc.Status.ACTIVE);
      break;
    case wc.InputService.POINTER:
      this.status.pointer = A.statusUpdate.inputStatus;
      break;
    case wc.InputService.STYLUS:
      this.status.stylus = A.statusUpdate.inputStatus;
      break;
    case wc.InputService.SAS:
      this.status.sas = A.statusUpdate.inputStatus;
  }
  (A.statusUpdate.inputService !== wc.InputService.KEYBOARD &&
    A.statusUpdate.inputService !== wc.InputService.SAS) ||
    e.update("keyboard-sas", {
      enabled: this.status.sas === wc.Status.ACTIVE && this.status.keyboard === wc.Status.ACTIVE
    }),
    (A.statusUpdate.inputService !== wc.InputService.MOUSE &&
      A.statusUpdate.inputService !== wc.InputService.POINTER) ||
      this.input.enableRelativeMouseMode(
        this.relativeMouseSupported &&
          this.status.mouse === wc.Status.ACTIVE &&
          this.status.pointer === wc.Status.ACTIVE
      );
}
function vc(A) {
  let e;
  this.log.debug("CursorImagePixelFormat: RAW_ARGB_DATA"),
    (this.cursorPixelFormat = wc.CursorImagePixelFormat.RAW_ARGB_DATA),
    this.input.registerChannel(this),
    this.input.addListeners(this),
    (this.relativeMouseSupported =
      A.capabilities.supportedPointerModes.indexOf(wc.Capabilities.PointerMode.SERVER) > -1),
    to(this.protocolVersion, { major: 1, minor: 1 }) ||
      this.input.enableRelativeMouseMode(this.relativeMouseSupported),
    this.log.info(
      `Supported pointer modes: ${JSON.stringify(A.capabilities.supportedPointerModes)}`
    ),
    this.log.info(`Suggested cursor cache size: ${A.capabilities.cursorCacheSize}`),
    this.log.info(
      `Supported cursor image formats: ${JSON.stringify(A.capabilities.supportedCursorImagePixelFormats)}`
    ),
    this.sendInputMessage({
      preferences: { preferredCursorImagePixelFormat: this.cursorPixelFormat }
    }),
    this.onKeyboardEnabledCb && this.onKeyboardEnabledCb(!0),
    to(this.protocolVersion, { major: 1, minor: 1 }) ||
      ((e = Ws(this.clientConnectionId)),
      e.update("mouse", { enabled: !0 }),
      e.update("keyboard", { enabled: !0 }));
}
function xc(A, e) {
  switch (A.msg) {
    case "capabilities":
      vc.call(this, A);
      break;
    case "pointerMotionAck":
      (this.motionMessagesFromLastAck = 0),
        this.lastDiscardedMotionMessage && this.sendInputMessage(this.lastDiscardedMotionMessage);
      break;
    case "pointerPosition":
      this.input.setPosition(A.pointerPosition.x, A.pointerPosition.y);
      break;
    case "pointerCursors":
      bc.call(this, A, e);
      break;
    case "pointerInvalidateCursors":
      Uc.call(this, A);
      break;
    case "pointerInvalidateCursorCache":
      Sc.call(this);
      break;
    case "statusUpdate":
      Rc.call(this, A);
      break;
    default:
      this.log.warn(`Unknown input message: ${A}`);
  }
}
const Mc = 32;
class Oc {
  constructor(A, e) {
    (this.width = (A + 31) >>> 5),
      (this.height = (e + 31) >>> 5),
      (this.size = this.width * this.height),
      (this.times = new Float64Array(this.size)),
      (this.layers = new Uint8Array(this.size));
  }
  set(A, e, t) {
    let { x: i, y: n, width: o, height: r } = A;
    if (0 === o || 0 === r) return;
    let s = (i + o + 31) >>> 5,
      a = (n + r + 31) >>> 5;
    (i >>>= 5),
      (n >>>= 5),
      (i = Math.min(i, this.width)),
      (n = Math.min(n, this.height)),
      (s = Math.min(s, this.width)),
      (a = Math.min(a, this.height)),
      (o = s - i),
      (r = a - n);
    let g = n * this.width + i,
      c = r;
    for (; 0 !== c; )
      this.times.fill(e, g, g + o), this.layers.fill(t, g, g + o), (g += this.width), c--;
  }
  getRects(A, e, t) {
    let i = [],
      n = 0;
    for (let o = 0; o < this.height; o++) {
      let r = null;
      for (let s = 0; s < this.width; s++) {
        const a = A - this.times[n];
        if (a <= e) {
          const A = Math.max(0, Math.min(1, a / e)),
            g = Math.max(0, A * A * A * -t + t),
            c = this.layers[n];
          null === r
            ? (r = [s * Mc, o * Mc, Mc, Mc, c, g])
            : r[4] === c && r[5] === g
              ? (r[2] += Mc)
              : (i.push(r), (r = [s * Mc, o * Mc, Mc, Mc, c, g]));
        } else null !== r && (i.push(r), (r = null));
        n++;
      }
      null !== r && i.push(r);
    }
    return i;
  }
}
const kc = 8,
  Nc = [4290478080, 4281905408, 4279836152],
  Kc = [4291731337, 4288922681, 4283860223];
function Lc(A, e, t) {
  if (((this.log = Q("display", e)), Ao(A)))
    return this.log.debug("Invalid config in che creation of the display"), null;
  if (
    ((this.config = A),
    (this.highPixelDensityEnabled = A.enableHighPixelDensity),
    (this.dpr = null),
    (this.isPending = Boolean(t)),
    (this.id = A.id),
    (this.displayCanvas = null),
    (this.debugPatterns = null),
    (this.debugRefreshTrigger = null),
    (this.debugMap = null),
    (this.displayInputDiv = null),
    (this.paused = !1),
    (this.firstFrameReady = !1),
    (this.focusEventHandler = null),
    (this.visibilityHandler = this.setVisible.bind(this)),
    (this.renderer = null),
    (this.mouseCaptured = !1),
    (this.IMEMode = A.IMEMode || !Qr()),
    (this.scaleRatio = null),
    (this.translateCoordinates = Pc.bind(this)),
    Object.defineProperties(this, {
      window: {
        get: function () {
          return this.isPending ? null : this.config.window;
        }
      },
      document: {
        get: function () {
          return this.isPending ? null : this.config.window.document;
        }
      },
      name: {
        get: function () {
          return this.config.name;
        }
      },
      head: {
        get: function () {
          return {
            name: this.config.name,
            rect: { x: this.xOffset, y: this.yOffset, width: this.layerW, height: this.layerH },
            primary: this.primary
          };
        },
        set: function (A) {
          zc.call(this, A);
        }
      }
    }),
    zc.call(this, A.head),
    this.isPending)
  )
    _c.call(this), this.log.info(`Pending Server Display ${A.name} has been created`);
  else {
    if (!Xc.call(this)) return null;
    this.log.info(`Display ${A.name} has been created`);
  }
  (this.renderer = (function (A, e, t, i) {
    const n = { preserveDrawingBuffer: !1, antialias: !1, depth: !1, stencil: !1 },
      o = Ns(),
      r = null !== o ? o.name : null;
    let s;
    return "webgl2" === r
      ? new gs(A, A.getContext(r, n), t, i)
      : Ao(r)
        ? ((s = A.getContext("2d")),
          (s.mozImageSmoothingEnabled = !1),
          (s.webkitImageSmoothingEnabled = !1),
          (s.msImageSmoothingEnabled = !1),
          (s.imageSmoothingEnabled = !1),
          dr()
            ? (A.style["image-rendering"] = "-moz-crisp-edges")
            : lr()
              ? (A.style["image-rendering"] = "pixelated")
              : (A.style["image-rendering"] = "crisp-edges"),
          new cs(A, s, t, i))
        : new Yr(A, A.getContext(r, n), t, i);
  })(this.displayCanvas, this.debugLayer, A, e)),
    this.renderer.size(this.layerW, this.layerH),
    this.isPending || this.renderer.setDisplayWindow?.(this.window);
}
function Tc(A) {
  A.stopPropagation(), A.preventDefault();
}
function Pc(A, e) {
  const t = this.displayDiv,
    i = this.highPixelDensityEnabled ? so(t) : 1;
  let { width: n, height: o } = t.getBoundingClientRect();
  (n *= i), (o *= i);
  const r = A < n / 2 ? 0 : n - 1,
    s = e < o / 2 ? 0 : o - 1,
    a = this.config.hotCornerThreshold,
    g = n / 2 - Math.abs(n / 2 - A) < a && o / 2 - Math.abs(o / 2 - e) < a;
  return {
    x: Math.floor(A * i + this.xOffset),
    y: Math.floor(e * i + this.yOffset),
    cornerX: Math.floor(r + this.xOffset),
    cornerY: Math.floor(s + this.yOffset),
    isHotCorner: g
  };
}
function Gc(A, e) {
  const t = this.displayDiv,
    i = this.highPixelDensityEnabled ? so(t) : 1;
  let n = t.parentElement.scrollTop + this.config.window.pageYOffset,
    o = A + (t.parentElement.scrollLeft + this.config.window.pageXOffset),
    r = e + n,
    s = t,
    a = 0,
    g = 0,
    { width: c, height: I } = t.getBoundingClientRect(),
    l = !1;
  for (c *= i, I *= i; s && !isNaN(s.offsetLeft) && !isNaN(s.offsetTop); )
    (o -= s.offsetLeft), (r -= s.offsetTop), (s = s.offsetParent);
  return (
    (o *= i),
    (r *= i),
    o < 0 && (o = 0),
    r < 0 && (r = 0),
    o >= c && (o = c - 1),
    r >= I && (r = I - 1),
    o > c / 2 && (a = c - 1),
    r > I / 2 && (g = I - 1),
    (l =
      Math.abs(a - o) < this.config.hotCornerThreshold &&
      Math.abs(g - r) < this.config.hotCornerThreshold),
    (o = Math.floor(o / this.scaleRatio)),
    (r = Math.floor(r / this.scaleRatio)),
    (o += this.xOffset),
    (r += this.yOffset),
    (a += this.xOffset),
    (g += this.yOffset),
    {
      x: Math.floor(o),
      y: Math.floor(r),
      cornerX: Math.floor(a),
      cornerY: Math.floor(g),
      isHotCorner: l
    }
  );
}
function Hc() {
  const A = this.displayDiv;
  (A.tabIndex = 0),
    (A.style.overflow = "hidden"),
    (A.style.display = "none"),
    (this.focusEventHandler = this.focusDisplayDiv.bind(this)),
    A.addEventListener("click", this.focusEventHandler),
    A.addEventListener("focus", this.focusEventHandler),
    A.addEventListener("contextmenu", Tc),
    Yc.call(this),
    (this.virtualCursor = this.document.createElement("img")),
    (this.virtualCursor.style.position = "absolute"),
    (this.virtualCursor.style.overflow = "hidden"),
    (this.virtualCursor.style.pointerEvents = "none"),
    (this.virtualCursor.style.display = "none"),
    (this.virtualCursor.style.zIndex = 100),
    A.appendChild(this.virtualCursor);
}
function Yc() {
  void 0 !== this.document.hidden
    ? ((this.hidden = "hidden"), (this.visibilityChange = "visibilitychange"))
    : void 0 !== this.document.msHidden
      ? ((this.hidden = "msHidden"), (this.visibilityChange = "msvisibilitychange"))
      : void 0 !== this.document.webkitHidden &&
        ((this.hidden = "webkitHidden"), (this.visibilityChange = "webkitvisibilitychange")),
    this.document.addEventListener(this.visibilityChange, this.visibilityHandler, !1);
}
function qc() {
  this.document.removeEventListener(this.visibilityChange, this.visibilityHandler, !1);
}
function Jc(A) {
  let e;
  (e = A ? document.createElement("canvas") : this.document.createElement("canvas")),
    (this.displayCanvas = e),
    (e.style.position = "absolute"),
    (e.style.display = "none"),
    (e.style.zIndex = 0),
    A || this.displayDiv.insertBefore(this.displayCanvas, this.displayInputDiv);
}
function jc() {
  (this.displayInputDiv = this.document.createElement("div")),
    (this.displayInputDiv.id = "dcv-input"),
    (this.displayInputDiv.tabIndex = 0),
    (this.displayInputDiv.style.opacity = "0"),
    (this.displayInputDiv.contentEditable = !this.IMEMode),
    (this.displayInputDiv.style.height = this.displayDiv.style.height),
    (this.displayInputDiv.style.width = this.displayDiv.style.width),
    this.displayDiv.appendChild(this.displayInputDiv);
}
function Wc(A) {
  this.displayDiv &&
    this.displayInputDiv &&
    this.displayInputDiv.parentElement === this.displayDiv &&
    (this.removeInputListeners(), A || this.displayDiv.removeChild(this.displayInputDiv));
}
function Vc(A) {
  qc.call(this),
    this.displayDiv &&
      (this.debugLayer &&
        this.debugLayer.parentElement === this.displayDiv &&
        (this.displayDiv.removeChild(this.debugLayer), (this.debugLayer = null)),
      this.virtualCursor &&
        this.virtualCursor.parentElement === this.displayDiv &&
        (this.displayDiv.removeChild(this.virtualCursor), (this.virtualCursor = null)),
      this.displayCanvas &&
        this.displayCanvas.parentElement === this.displayDiv &&
        this.displayDiv.removeChild(this.displayCanvas),
      this.displayInputDiv &&
        this.displayInputDiv.parentElement === this.displayDiv &&
        Wc.call(this),
      this.displayDiv.removeEventListener("contextmenu", Tc),
      this.displayDiv.removeEventListener("click", this.focusEventHandler),
      this.displayDiv.removeEventListener("focus", this.focusEventHandler),
      (this.focusEventHandler = null),
      (this.displayDiv.style.display = "none"),
      (this.displayDiv = null)),
    A
      ? (this.maintainedLayersDiv || (this.maintainedLayersDiv = document.createElement("div")),
        this.maintainedLayersDiv.appendChild(this.displayCanvas),
        this.displayManager.setDisplayAsActive())
      : (this.displayCanvas = null),
    this.log.info(
      `Tore down display element for Display ${this.name}${A ? ", but maintained layers" : ""}`
    );
}
function _c() {
  (this.inputListeners = null),
    (this.displayDiv = null),
    (this.debugLayer = null),
    Jc.call(this, !0);
}
function Xc(A) {
  if (
    ((this.displayDiv = this.config.window.document.getElementById(this.config.divId)),
    !this.displayDiv)
  )
    return (
      this.log.error(
        `Unable to find the element '${this.config.divId}'. Creation of Display ${this.name} failed`
      ),
      !1
    );
  if ((Hc.call(this), 0 !== this.config.debugLayerDuration)) {
    (this.debugLayer = this.config.window.document.createElement("canvas")),
      (this.debugLayerCtx = this.debugLayer.getContext("2d")),
      (this.debugLayerCtx.mozImageSmoothingEnabled = !1),
      (this.debugLayerCtx.webkitImageSmoothingEnabled = !1),
      (this.debugLayerCtx.msImageSmoothingEnabled = !1),
      (this.debugLayerCtx.imageSmoothingEnabled = !1),
      (this.debugLayer.style.position = "absolute"),
      (this.debugLayer.style.zIndex = 1),
      this.displayDiv.appendChild(this.debugLayer);
    const A = new OffscreenCanvas(kc, kc),
      e = A.getContext("2d"),
      t = e.createImageData(kc, kc),
      i = new Uint32Array(t.data.buffer);
    this.debugPatterns = [];
    for (let n = 0; n < 3; n++) {
      const o = Nc[n],
        r = Kc[n];
      i.forEach((A, e, t) => {
        t[e] = (((7 & e) + (e >>> 3)) & 7) < 4 ? o : r;
      }),
        e.putImageData(t, 0, 0);
      const s = A.transferToImageBitmap();
      this.debugPatterns.push(this.debugLayerCtx.createPattern(s, "repeat")), s.close();
    }
  }
  return (
    jc.call(this, !1),
    this.addInputListeners(this.config.inputListeners),
    this.config.latestCursorStyle && this.setCursorStyle(this.config.latestCursorStyle),
    Ao(A) || !1 === A
      ? Jc.call(this, !1)
      : this.displayCanvas
        ? (this.maintainedLayersDiv && this.maintainedLayersDiv.removeChild(this.displayCanvas),
          this.displayDiv.insertBefore(this.displayCanvas, this.displayInputDiv))
        : this.log.warn("Trying to append a null canvas"),
    this.config.boundingBox && this.setLayout(this.head, this.config.boundingBox),
    !0
  );
}
function zc(A) {
  (this.layerW = A.rect.width),
    (this.layerH = A.rect.height),
    (this.xOffset = A.rect.x),
    (this.yOffset = A.rect.y),
    (this.primary = A.primary),
    (this.config.name = A.name),
    (this.config.head = A);
}
(Lc.prototype.registerManager = function (A) {
  this.displayManager = A;
}),
  (Lc.prototype.hasOpenedWindow = function () {
    return null !== this.config.window && !this.config.window.closed;
  }),
  (Lc.prototype.hasFocus = function () {
    return this.hasOpenedWindow() && this.config.window.document.hasFocus();
  }),
  (Lc.prototype.close = function () {
    null !== this.debugRefreshTrigger &&
      (cancelAnimationFrame(this.debugRefreshTrigger), (this.debugRefreshTrigger = null)),
      this.isPending
        ? ((this.displayCanvas = null), this.log.info(`Closed pending server display ${this.name}`))
        : Vc.call(this),
      this.renderer && this.renderer.release(),
      (this.renderer = null);
  }),
  (Lc.prototype.setCursorStyle = function (A) {
    this.displayDiv && (this.displayDiv.style.cursor = A);
  }),
  (Lc.prototype.addInputListeners = function (A) {
    Ao(A) ||
      (this.displayInputDiv &&
        ((this.inputListeners = {}),
        Object.keys(A).forEach((e) => {
          (this.inputListeners[e] = (t) => A[e](t, this.id)),
            this.displayInputDiv.addEventListener(e, this.inputListeners[e]);
        })));
  }),
  (Lc.prototype.clearInputListeners = function () {
    !Ao(this.inputListeners) &&
      this.inputListeners &&
      this.displayInputDiv &&
      this.removeInputListeners();
  }),
  (Lc.prototype.removeInputListeners = function () {
    !Ao(this.inputListeners) &&
      this.inputListeners &&
      this.displayInputDiv &&
      (Object.keys(this.inputListeners).forEach((A) => {
        this.displayInputDiv.removeEventListener(A, this.inputListeners[A]);
      }),
      (this.inputListeners = {}));
  }),
  (Lc.prototype.isWebGLRendering = function () {
    return !Ao(this.renderer.webGL);
  }),
  (Lc.prototype.startRenderingLayer = function (A, e) {
    this.renderer &&
      (this.renderer.addRenderingLayer(A, e),
      this.log.info(`Started renderer for layer type: ${A}`));
  }),
  (Lc.prototype.stopRenderingLayer = function (A) {
    this.renderer &&
      (this.renderer.removeRenderingLayer(A), this.log.info(`Stopped renderer for layerType ${A}`));
  }),
  (Lc.prototype.enableHighPixelDensity = function (A) {
    (this.highPixelDensityEnabled = A), this.renderer && this.renderer.enableHighPixelDensity(A);
    const e = this.displayDiv,
      t = A ? so(e) : 1;
    this.dpr !== t &&
      ((this.dpr = t),
      this.displayDiv &&
        ((e.style.width = this.layerW / t + "px"), (e.style.height = this.layerH / t + "px")),
      this.displayInputDiv &&
        ((this.displayInputDiv.style.width = e.style.width),
        (this.displayInputDiv.style.height = e.style.height)),
      this.debugLayer &&
        ((this.debugLayer.style.width = e.style.width),
        (this.debugLayer.style.height = e.style.height)));
  }),
  (Lc.prototype.paintDebugLayer = function () {
    const A = performance.now() / 1e3,
      e = this.debugMap.getRects(A, this.config.debugLayerDuration, 0.3),
      t = e.length;
    this.debugLayerCtx.clearRect(0, 0, this.debugLayer.width, this.debugLayer.height);
    for (let A = 0; A < t; A++) {
      const [t, i, n, o, r, s] = e[A];
      (this.debugLayerCtx.globalAlpha = s),
        (this.debugLayerCtx.fillStyle = this.debugPatterns[r]),
        this.debugLayerCtx.beginPath(),
        this.debugLayerCtx.rect(t, i, n, o),
        this.debugLayerCtx.fill();
    }
    t > 0 && this.invalidateDebugLayer();
  }),
  (Lc.prototype.invalidateDebugLayer = function () {
    null === this.debugRefreshTrigger &&
      (this.debugRefreshTrigger = requestAnimationFrame((A) => {
        (this.debugRefreshTrigger = null), this.paintDebugLayer();
      }));
  }),
  (Lc.prototype.setLayout = function (A, e) {
    zc.call(this, A),
      this.log.debug(
        `[Secondary] Resizing display area to ${this.layerW}x${this.layerH} (${e.w}x${e.h})`
      ),
      (this.displayDiv.style.display = "block");
    const t = this.displayDiv,
      i = this.highPixelDensityEnabled ? so(t) : 1;
    (t.style.width = this.layerW / i + "px"),
      (t.style.height = this.layerH / i + "px"),
      this.debugLayer &&
        ((this.debugLayer.width = this.layerW),
        (this.debugLayer.height = this.layerH),
        (this.debugMap = new Oc(this.layerW, this.layerH)),
        this.invalidateDebugLayer()),
      this.displayInputDiv &&
        ((this.displayInputDiv.style.width = t.style.width),
        (this.displayInputDiv.style.height = t.style.height)),
      this.debugLayer &&
        ((this.debugLayer.style.width = t.style.width),
        (this.debugLayer.style.height = t.style.height)),
      this.renderer && this.renderer.size(this.layerW, this.layerH),
      this.log.info(`Notifying new server display layout (${this.layerW}, ${this.layerH})`);
  }),
  (Lc.prototype.paintTile = function (A) {
    let e;
    if (
      (this.firstFrameReady ||
        this.isPending ||
        (this.config.firstFrameCallback(
          this.config.clientResizeEnabled,
          this.config.relativeMouseModeEnabled,
          this.id
        ),
        (this.displayCanvas.style.display = "inline-block"),
        (this.firstFrameReady = !0),
        this.log.info(`First frame notified for display ${this.name} (id: ${this.id})`)),
      this.renderer.render(A),
      (e = A.clip && A.clip.length > 0 ? A.clip : [A.rect]),
      this.debugLayer)
    ) {
      const t = performance.now() / 1e3,
        i = A.layerType;
      e.forEach((A) => {
        this.debugMap.set(A, t, i);
      }),
        this.invalidateDebugLayer();
    }
  }),
  (Lc.prototype.focusDisplayDiv = function () {
    Ao(this.displayDiv) ||
      Ao(this.displayInputDiv) ||
      (this.displayInputDiv.focus(), this.displayManager.setDisplayAsActive(this));
  }),
  (Lc.prototype.resume = function () {
    this.paused = !1;
  }),
  (Lc.prototype.pause = function () {
    this.paused = !0;
  }),
  (Lc.prototype.setVisible = function () {
    const A = this.document;
    (this.isVisible = !A[this.hidden]),
      this.log.debug(`Visibility changed to ${this.isVisible}`),
      A[this.hidden] && !this.paused
        ? this.displayManager.pauseDisplay(this)
        : !A[this.hidden] && this.paused && this.displayManager.resumeDisplay(this);
  }),
  (Lc.prototype.captureMouse = function () {
    this.mouseCaptured = !0;
  }),
  (Lc.prototype.releaseMouse = function () {
    this.mouseCaptured &&
      Xn(this.document.releaseCapture) &&
      (this.document.releaseCapture(), (this.mouseCaptured = !1));
  }),
  (Lc.prototype.isMouseCaptured = function () {
    return this.mouseCaptured;
  }),
  (Lc.prototype.requestPointerLock = function () {
    Xn(this.displayInputDiv.requestPointerLock) &&
      (this.displayInputDiv.focus(), this.displayInputDiv.requestPointerLock()?.catch(() => {}));
  }),
  (Lc.prototype.setVirtualCursor = function (A) {
    this.virtualCursor &&
      (A.visible
        ? ((this.virtualCursor.src = A.imgSrc),
          (this.virtualCursor.style.display = "block"),
          (this.virtualCursor.width = A.width),
          (this.virtualCursor.height = A.height),
          (this.virtualCursor.dcvHotspot = { x: A.hotspotX || 0, y: A.hotspotY || 0 }))
        : (this.virtualCursor.style.display = "none"));
  }),
  (Lc.prototype.setVirtualCursorPosition = function (A, e) {
    if (this.virtualCursor && "none" !== this.virtualCursor.style.display) {
      const t = this.highPixelDensityEnabled ? so(this.virtualCursor) : 1;
      (this.virtualCursor.style.left = (A - this.virtualCursor.dcvHotspot.x) / t + "px"),
        (this.virtualCursor.style.top = (e - this.virtualCursor.dcvHotspot.y) / t + "px");
    }
  }),
  (Lc.prototype.fromPendingToFull = function (A) {
    const e = A;
    (e.primary = this.config.primary),
      (e.name = this.config.name),
      (e.head = this.config.head),
      (e.id = this.config.id),
      (this.config = e),
      (this.highPixelDensityEnabled = e.enableHighPixelDensity),
      (this.isPending = !1);
    const t = Xc.call(this, !0);
    return this.renderer.setDisplayWindow?.(this.window), t;
  }),
  (Lc.prototype.setScaleRatio = function (A) {
    A > 0
      ? ((this.scaleRatio = A),
        this.log.info(`Set scale ratio to ${this.scaleRatio} for mouse coordinates`),
        (this.translateCoordinates = Gc.bind(this)))
      : ((this.scaleRatio = null),
        this.log.info("Setting autoscaling for mouse coordinates"),
        (this.translateCoordinates = Pc.bind(this)));
  }),
  (Lc.prototype.getScaleRatio = function () {
    return this.scaleRatio;
  }),
  (Lc.prototype.fromFullToPending = function () {
    Vc.call(this, !0),
      (this.isPending = !0),
      this.log.info(`Reduced display ${this.name} from full to pending`);
  }),
  (Lc.prototype.sendFirstFrame = function () {
    this.config.firstFrameCallback(
      this.config.clientResizeEnabled,
      this.config.relativeMouseModeEnabled,
      this.id
    ),
      (this.displayCanvas.style.display = "inline-block"),
      (this.firstFrameReady = !0),
      this.log.info(`First frame notified for display ${this.name} (id: ${this.id})`);
  }),
  (Lc.prototype.setIMEMode = function (A) {
    const e = this.hasFocus();
    let t, i;
    Qr()
      ? this.IMEMode !== A
        ? ((this.IMEMode = A),
          (t = this.inputListeners),
          Wc.call(this, e),
          e && (i = this.displayInputDiv),
          jc.call(this),
          (this.inputListeners = t),
          this.addInputListeners(this.inputListeners),
          e && (this.displayInputDiv.focus(), this.displayDiv.removeChild(i)),
          this.log.debug(`IME Mode is now set to ${this.IMEMode} for display ${this.id}`))
        : this.log.info(`IME Mode is already ${A} for display ${this.id}`)
      : this.log.warn("IME Mode is only supported on MacOS");
  });
var Zc = { exports: {} };
!(function (A) {
  var e = (function (A) {
    Object.defineProperty(A, "__esModule", { value: !0 }), (A.default = void 0);
    /**
     * @license
     * Copyright 2009 The Closure Library Authors
     * Copyright 2020 Daniel Wirtz / The long.js Authors.
     *
     * Licensed under the Apache License, Version 2.0 (the "License");
     * you may not use this file except in compliance with the License.
     * You may obtain a copy of the License at
     *
     *     http://www.apache.org/licenses/LICENSE-2.0
     *
     * Unless required by applicable law or agreed to in writing, software
     * distributed under the License is distributed on an "AS IS" BASIS,
     * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     * See the License for the specific language governing permissions and
     * limitations under the License.
     *
     * SPDX-License-Identifier: Apache-2.0
     */
    var e = null;
    try {
      e = new WebAssembly.Instance(
        new WebAssembly.Module(
          new Uint8Array([
            0, 97, 115, 109, 1, 0, 0, 0, 1, 13, 2, 96, 0, 1, 127, 96, 4, 127, 127, 127, 127, 1, 127,
            3, 7, 6, 0, 1, 1, 1, 1, 1, 6, 6, 1, 127, 1, 65, 0, 11, 7, 50, 6, 3, 109, 117, 108, 0, 1,
            5, 100, 105, 118, 95, 115, 0, 2, 5, 100, 105, 118, 95, 117, 0, 3, 5, 114, 101, 109, 95,
            115, 0, 4, 5, 114, 101, 109, 95, 117, 0, 5, 8, 103, 101, 116, 95, 104, 105, 103, 104, 0,
            0, 10, 191, 1, 6, 4, 0, 35, 0, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134,
            132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 126, 34, 4, 66, 32, 135, 167, 36, 0, 32,
            4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3,
            173, 66, 32, 134, 132, 127, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1,
            126, 32, 0, 173, 32, 1, 173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132,
            128, 34, 4, 66, 32, 135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1,
            173, 66, 32, 134, 132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 129, 34, 4, 66, 32,
            135, 167, 36, 0, 32, 4, 167, 11, 36, 1, 1, 126, 32, 0, 173, 32, 1, 173, 66, 32, 134,
            132, 32, 2, 173, 32, 3, 173, 66, 32, 134, 132, 130, 34, 4, 66, 32, 135, 167, 36, 0, 32,
            4, 167, 11
          ])
        ),
        {}
      ).exports;
    } catch (A) {}
    function t(A, e, t) {
      (this.low = 0 | A), (this.high = 0 | e), (this.unsigned = !!t);
    }
    function i(A) {
      return !0 === (A && A.__isLong__);
    }
    function n(A) {
      var e = Math.clz32(A & -A);
      return A ? 31 - e : e;
    }
    t.prototype.__isLong__,
      Object.defineProperty(t.prototype, "__isLong__", { value: !0 }),
      (t.isLong = i);
    var o = {},
      r = {};
    function s(A, e) {
      var t, i, n;
      return e
        ? (n = 0 <= (A >>>= 0) && A < 256) && (i = r[A])
          ? i
          : ((t = g(A, 0, !0)), n && (r[A] = t), t)
        : (n = -128 <= (A |= 0) && A < 128) && (i = o[A])
          ? i
          : ((t = g(A, A < 0 ? -1 : 0, !1)), n && (o[A] = t), t);
    }
    function a(A, e) {
      if (isNaN(A)) return e ? E : Q;
      if (e) {
        if (A < 0) return E;
        if (A >= u) return y;
      } else {
        if (A <= -C) return D;
        if (A + 1 >= C) return m;
      }
      return A < 0 ? a(-A, e).neg() : g(A % d | 0, (A / d) | 0, e);
    }
    function g(A, e, i) {
      return new t(A, e, i);
    }
    (t.fromInt = s), (t.fromNumber = a), (t.fromBits = g);
    var c = Math.pow;
    function I(A, e, t) {
      if (0 === A.length) throw Error("empty string");
      if (
        ("number" == typeof e ? ((t = e), (e = !1)) : (e = !!e),
        "NaN" === A || "Infinity" === A || "+Infinity" === A || "-Infinity" === A)
      )
        return e ? E : Q;
      if ((t = t || 10) < 2 || 36 < t) throw RangeError("radix");
      var i;
      if ((i = A.indexOf("-")) > 0) throw Error("interior hyphen");
      if (0 === i) return I(A.substring(1), e, t).neg();
      for (var n = a(c(t, 8)), o = Q, r = 0; r < A.length; r += 8) {
        var s = Math.min(8, A.length - r),
          g = parseInt(A.substring(r, r + s), t);
        if (s < 8) {
          var l = a(c(t, s));
          o = o.mul(l).add(a(g));
        } else o = (o = o.mul(n)).add(a(g));
      }
      return (o.unsigned = e), o;
    }
    function l(A, e) {
      return "number" == typeof A
        ? a(A, e)
        : "string" == typeof A
          ? I(A, e)
          : g(A.low, A.high, "boolean" == typeof e ? e : A.unsigned);
    }
    (t.fromString = I), (t.fromValue = l);
    var d = 4294967296,
      u = d * d,
      C = u / 2,
      B = s(1 << 24),
      Q = s(0);
    t.ZERO = Q;
    var E = s(0, !0);
    t.UZERO = E;
    var h = s(1);
    t.ONE = h;
    var p = s(1, !0);
    t.UONE = p;
    var f = s(-1);
    t.NEG_ONE = f;
    var m = g(-1, 2147483647, !1);
    t.MAX_VALUE = m;
    var y = g(-1, -1, !0);
    t.MAX_UNSIGNED_VALUE = y;
    var D = g(0, -2147483648, !1);
    t.MIN_VALUE = D;
    var w = t.prototype;
    (w.toInt = function () {
      return this.unsigned ? this.low >>> 0 : this.low;
    }),
      (w.toNumber = function () {
        return this.unsigned
          ? (this.high >>> 0) * d + (this.low >>> 0)
          : this.high * d + (this.low >>> 0);
      }),
      (w.toString = function (A) {
        if ((A = A || 10) < 2 || 36 < A) throw RangeError("radix");
        if (this.isZero()) return "0";
        if (this.isNegative()) {
          if (this.eq(D)) {
            var e = a(A),
              t = this.div(e),
              i = t.mul(e).sub(this);
            return t.toString(A) + i.toInt().toString(A);
          }
          return "-" + this.neg().toString(A);
        }
        for (var n = a(c(A, 6), this.unsigned), o = this, r = ""; ; ) {
          var s = o.div(n),
            g = (o.sub(s.mul(n)).toInt() >>> 0).toString(A);
          if ((o = s).isZero()) return g + r;
          for (; g.length < 6; ) g = "0" + g;
          r = "" + g + r;
        }
      }),
      (w.getHighBits = function () {
        return this.high;
      }),
      (w.getHighBitsUnsigned = function () {
        return this.high >>> 0;
      }),
      (w.getLowBits = function () {
        return this.low;
      }),
      (w.getLowBitsUnsigned = function () {
        return this.low >>> 0;
      }),
      (w.getNumBitsAbs = function () {
        if (this.isNegative()) return this.eq(D) ? 64 : this.neg().getNumBitsAbs();
        for (var A = 0 != this.high ? this.high : this.low, e = 31; e > 0 && !(A & (1 << e)); e--);
        return 0 != this.high ? e + 33 : e + 1;
      }),
      (w.isZero = function () {
        return 0 === this.high && 0 === this.low;
      }),
      (w.eqz = w.isZero),
      (w.isNegative = function () {
        return !this.unsigned && this.high < 0;
      }),
      (w.isPositive = function () {
        return this.unsigned || this.high >= 0;
      }),
      (w.isOdd = function () {
        return !(1 & ~this.low);
      }),
      (w.isEven = function () {
        return !(1 & this.low);
      }),
      (w.equals = function (A) {
        return (
          i(A) || (A = l(A)),
          (this.unsigned === A.unsigned || this.high >>> 31 != 1 || A.high >>> 31 != 1) &&
            this.high === A.high &&
            this.low === A.low
        );
      }),
      (w.eq = w.equals),
      (w.notEquals = function (A) {
        return !this.eq(A);
      }),
      (w.neq = w.notEquals),
      (w.ne = w.notEquals),
      (w.lessThan = function (A) {
        return this.comp(A) < 0;
      }),
      (w.lt = w.lessThan),
      (w.lessThanOrEqual = function (A) {
        return this.comp(A) <= 0;
      }),
      (w.lte = w.lessThanOrEqual),
      (w.le = w.lessThanOrEqual),
      (w.greaterThan = function (A) {
        return this.comp(A) > 0;
      }),
      (w.gt = w.greaterThan),
      (w.greaterThanOrEqual = function (A) {
        return this.comp(A) >= 0;
      }),
      (w.gte = w.greaterThanOrEqual),
      (w.ge = w.greaterThanOrEqual),
      (w.compare = function (A) {
        if ((i(A) || (A = l(A)), this.eq(A))) return 0;
        var e = this.isNegative(),
          t = A.isNegative();
        return e && !t
          ? -1
          : !e && t
            ? 1
            : this.unsigned
              ? A.high >>> 0 > this.high >>> 0 ||
                (A.high === this.high && A.low >>> 0 > this.low >>> 0)
                ? -1
                : 1
              : this.sub(A).isNegative()
                ? -1
                : 1;
      }),
      (w.comp = w.compare),
      (w.negate = function () {
        return !this.unsigned && this.eq(D) ? D : this.not().add(h);
      }),
      (w.neg = w.negate),
      (w.add = function (A) {
        i(A) || (A = l(A));
        var e = this.high >>> 16,
          t = 65535 & this.high,
          n = this.low >>> 16,
          o = 65535 & this.low,
          r = A.high >>> 16,
          s = 65535 & A.high,
          a = A.low >>> 16,
          c = 0,
          I = 0,
          d = 0,
          u = 0;
        return (
          (d += (u += o + (65535 & A.low)) >>> 16),
          (I += (d += n + a) >>> 16),
          (c += (I += t + s) >>> 16),
          (c += e + r),
          g(((d &= 65535) << 16) | (u &= 65535), ((c &= 65535) << 16) | (I &= 65535), this.unsigned)
        );
      }),
      (w.subtract = function (A) {
        return i(A) || (A = l(A)), this.add(A.neg());
      }),
      (w.sub = w.subtract),
      (w.multiply = function (A) {
        if (this.isZero()) return this;
        if ((i(A) || (A = l(A)), e))
          return g(e.mul(this.low, this.high, A.low, A.high), e.get_high(), this.unsigned);
        if (A.isZero()) return this.unsigned ? E : Q;
        if (this.eq(D)) return A.isOdd() ? D : Q;
        if (A.eq(D)) return this.isOdd() ? D : Q;
        if (this.isNegative())
          return A.isNegative() ? this.neg().mul(A.neg()) : this.neg().mul(A).neg();
        if (A.isNegative()) return this.mul(A.neg()).neg();
        if (this.lt(B) && A.lt(B)) return a(this.toNumber() * A.toNumber(), this.unsigned);
        var t = this.high >>> 16,
          n = 65535 & this.high,
          o = this.low >>> 16,
          r = 65535 & this.low,
          s = A.high >>> 16,
          c = 65535 & A.high,
          I = A.low >>> 16,
          d = 65535 & A.low,
          u = 0,
          C = 0,
          h = 0,
          p = 0;
        return (
          (h += (p += r * d) >>> 16),
          (C += (h += o * d) >>> 16),
          (h &= 65535),
          (C += (h += r * I) >>> 16),
          (u += (C += n * d) >>> 16),
          (C &= 65535),
          (u += (C += o * I) >>> 16),
          (C &= 65535),
          (u += (C += r * c) >>> 16),
          (u += t * d + n * I + o * c + r * s),
          g(((h &= 65535) << 16) | (p &= 65535), ((u &= 65535) << 16) | (C &= 65535), this.unsigned)
        );
      }),
      (w.mul = w.multiply),
      (w.divide = function (A) {
        if ((i(A) || (A = l(A)), A.isZero())) throw Error("division by zero");
        var t, n, o;
        if (e)
          return this.unsigned || -2147483648 !== this.high || -1 !== A.low || -1 !== A.high
            ? g(
                (this.unsigned ? e.div_u : e.div_s)(this.low, this.high, A.low, A.high),
                e.get_high(),
                this.unsigned
              )
            : this;
        if (this.isZero()) return this.unsigned ? E : Q;
        if (this.unsigned) {
          if ((A.unsigned || (A = A.toUnsigned()), A.gt(this))) return E;
          if (A.gt(this.shru(1))) return p;
          o = E;
        } else {
          if (this.eq(D))
            return A.eq(h) || A.eq(f)
              ? D
              : A.eq(D)
                ? h
                : (t = this.shr(1).div(A).shl(1)).eq(Q)
                  ? A.isNegative()
                    ? h
                    : f
                  : ((n = this.sub(A.mul(t))), (o = t.add(n.div(A))));
          if (A.eq(D)) return this.unsigned ? E : Q;
          if (this.isNegative())
            return A.isNegative() ? this.neg().div(A.neg()) : this.neg().div(A).neg();
          if (A.isNegative()) return this.div(A.neg()).neg();
          o = Q;
        }
        for (n = this; n.gte(A); ) {
          t = Math.max(1, Math.floor(n.toNumber() / A.toNumber()));
          for (
            var r = Math.ceil(Math.log(t) / Math.LN2),
              s = r <= 48 ? 1 : c(2, r - 48),
              I = a(t),
              d = I.mul(A);
            d.isNegative() || d.gt(n);

          )
            d = (I = a((t -= s), this.unsigned)).mul(A);
          I.isZero() && (I = h), (o = o.add(I)), (n = n.sub(d));
        }
        return o;
      }),
      (w.div = w.divide),
      (w.modulo = function (A) {
        return (
          i(A) || (A = l(A)),
          e
            ? g(
                (this.unsigned ? e.rem_u : e.rem_s)(this.low, this.high, A.low, A.high),
                e.get_high(),
                this.unsigned
              )
            : this.sub(this.div(A).mul(A))
        );
      }),
      (w.mod = w.modulo),
      (w.rem = w.modulo),
      (w.not = function () {
        return g(~this.low, ~this.high, this.unsigned);
      }),
      (w.countLeadingZeros = function () {
        return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
      }),
      (w.clz = w.countLeadingZeros),
      (w.countTrailingZeros = function () {
        return this.low ? n(this.low) : n(this.high) + 32;
      }),
      (w.ctz = w.countTrailingZeros),
      (w.and = function (A) {
        return i(A) || (A = l(A)), g(this.low & A.low, this.high & A.high, this.unsigned);
      }),
      (w.or = function (A) {
        return i(A) || (A = l(A)), g(this.low | A.low, this.high | A.high, this.unsigned);
      }),
      (w.xor = function (A) {
        return i(A) || (A = l(A)), g(this.low ^ A.low, this.high ^ A.high, this.unsigned);
      }),
      (w.shiftLeft = function (A) {
        return (
          i(A) && (A = A.toInt()),
          0 == (A &= 63)
            ? this
            : A < 32
              ? g(this.low << A, (this.high << A) | (this.low >>> (32 - A)), this.unsigned)
              : g(0, this.low << (A - 32), this.unsigned)
        );
      }),
      (w.shl = w.shiftLeft),
      (w.shiftRight = function (A) {
        return (
          i(A) && (A = A.toInt()),
          0 == (A &= 63)
            ? this
            : A < 32
              ? g((this.low >>> A) | (this.high << (32 - A)), this.high >> A, this.unsigned)
              : g(this.high >> (A - 32), this.high >= 0 ? 0 : -1, this.unsigned)
        );
      }),
      (w.shr = w.shiftRight),
      (w.shiftRightUnsigned = function (A) {
        return (
          i(A) && (A = A.toInt()),
          0 == (A &= 63)
            ? this
            : A < 32
              ? g((this.low >>> A) | (this.high << (32 - A)), this.high >>> A, this.unsigned)
              : g(32 === A ? this.high : this.high >>> (A - 32), 0, this.unsigned)
        );
      }),
      (w.shru = w.shiftRightUnsigned),
      (w.shr_u = w.shiftRightUnsigned),
      (w.rotateLeft = function (A) {
        var e;
        return (
          i(A) && (A = A.toInt()),
          0 == (A &= 63)
            ? this
            : 32 === A
              ? g(this.high, this.low, this.unsigned)
              : A < 32
                ? ((e = 32 - A),
                  g(
                    (this.low << A) | (this.high >>> e),
                    (this.high << A) | (this.low >>> e),
                    this.unsigned
                  ))
                : ((e = 32 - (A -= 32)),
                  g(
                    (this.high << A) | (this.low >>> e),
                    (this.low << A) | (this.high >>> e),
                    this.unsigned
                  ))
        );
      }),
      (w.rotl = w.rotateLeft),
      (w.rotateRight = function (A) {
        var e;
        return (
          i(A) && (A = A.toInt()),
          0 == (A &= 63)
            ? this
            : 32 === A
              ? g(this.high, this.low, this.unsigned)
              : A < 32
                ? ((e = 32 - A),
                  g(
                    (this.high << e) | (this.low >>> A),
                    (this.low << e) | (this.high >>> A),
                    this.unsigned
                  ))
                : ((e = 32 - (A -= 32)),
                  g(
                    (this.low << e) | (this.high >>> A),
                    (this.high << e) | (this.low >>> A),
                    this.unsigned
                  ))
        );
      }),
      (w.rotr = w.rotateRight),
      (w.toSigned = function () {
        return this.unsigned ? g(this.low, this.high, !1) : this;
      }),
      (w.toUnsigned = function () {
        return this.unsigned ? this : g(this.low, this.high, !0);
      }),
      (w.toBytes = function (A) {
        return A ? this.toBytesLE() : this.toBytesBE();
      }),
      (w.toBytesLE = function () {
        var A = this.high,
          e = this.low;
        return [
          255 & e,
          (e >>> 8) & 255,
          (e >>> 16) & 255,
          e >>> 24,
          255 & A,
          (A >>> 8) & 255,
          (A >>> 16) & 255,
          A >>> 24
        ];
      }),
      (w.toBytesBE = function () {
        var A = this.high,
          e = this.low;
        return [
          A >>> 24,
          (A >>> 16) & 255,
          (A >>> 8) & 255,
          255 & A,
          e >>> 24,
          (e >>> 16) & 255,
          (e >>> 8) & 255,
          255 & e
        ];
      }),
      (t.fromBytes = function (A, e, i) {
        return i ? t.fromBytesLE(A, e) : t.fromBytesBE(A, e);
      }),
      (t.fromBytesLE = function (A, e) {
        return new t(
          A[0] | (A[1] << 8) | (A[2] << 16) | (A[3] << 24),
          A[4] | (A[5] << 8) | (A[6] << 16) | (A[7] << 24),
          e
        );
      }),
      (t.fromBytesBE = function (A, e) {
        return new t(
          (A[4] << 24) | (A[5] << 16) | (A[6] << 8) | A[7],
          (A[0] << 24) | (A[1] << 16) | (A[2] << 8) | A[3],
          e
        );
      });
    var F = t;
    return (A.default = F), "default" in A ? A.default : A;
  })({});
  A.exports = e;
})(Zc);
var $c = e(Zc.exports);
function AI(A, e) {
  const t = qs(e);
  (this.log = Q("displaymanager", e)),
    eI.call(this),
    (this.configuration = A),
    (this.highPixelDensityEnabled = this.configuration.enableHighPixelDensity),
    (this.clientConnectionId = e),
    Ao(t)
      ? (this.log.warn("Could not gather current IME mode while initializing display"),
        (this.currentIMEMode = !Qr()))
      : (this.currentIMEMode = t.getCurrentIMEMode());
}
function eI() {
  (this.activeDisplay = null),
    (this.boundingBox = {}),
    (this.channel = null),
    (this.configuration = null),
    (this.clientResizeEnabled = !0),
    (this.firstFrameArrived = !1),
    (this.currentFrameClientTime = 0),
    (this.currentFrameServerTime = 0),
    (this.firstFrameCallback = null),
    (this.isVisible = !0),
    (this.latestHeads = {}),
    (this.layerW = 0),
    (this.layerH = 0),
    (this.primaryDisplay = null),
    (this.displayToWindowMap = {}),
    (this.displayToDprListenerMap = new Map()),
    (this.latestLogicalHeads = []),
    (this.logicalLayerW = 0),
    (this.logicalLayerH = 0),
    (this.id = 0),
    (this.inputListeners = {}),
    (this.frames = {}),
    (this.swappedFrames = []),
    (this.relativeMouseModeEnabled = !1),
    (this.latestCursorStyle = null),
    (this.displays = []),
    (this.pendingDisplays = []),
    (this.pendingServerDisplays = []),
    (this.maxDisplayNumber = 1),
    (this.relativeMouseAvailabilityCallback = null),
    (this.statsEnabled = !1);
}
function tI() {
  let A, e;
  if (!this.firstFrameArrived) {
    let A;
    this.log.info("First frame to be painted, executing associated actions"),
      (this.firstFrameArrived = !0),
      setTimeout(() => {
        this.statsEnabled = !0;
      }, 5e3),
      (A = qs(this.clientConnectionId)),
      A?.onFirstFrame(),
      (e = js(this.clientConnectionId).getDataChannel(Ia.AUDIO)),
      e && e.audioOutput.displayReady(!0);
  }
  0 !== this.swappedFrames.length && 0 === this.swappedFrames[0].count
    ? ((A = this.swappedFrames.shift()),
      this.log.debugIf(() => `Paint frame ${A.frameId}`),
      A.tiles.forEach((e) => {
        const t =
          EI.call(this, e.displayId, this.displays) ||
          EI.call(this, e.displayId, this.pendingServerDisplays);
        let i = !1;
        $c.fromNumber(e.frameId).notEquals(A.frameId)
          ? this.log.info(`Discarding invalid tile for frame ${e.frameId} (expected ${A.frameId})`)
          : e.discard
            ? this.log.debug(`Discarding invalid tile for frame ${e.frameId} (decoder was closed)`)
            : Object.prototype.hasOwnProperty.call(e, "layerType")
              ? t
                ? ((i = !0), t.paintTile(e))
                : this.log.info(
                    `Discarding valid tile for frame ${e.frameId} since display owner do not exists anymore`
                  )
              : this.log.info(
                  `Discarding invalid tile for frame ${e.frameId} (decode was aborted)`
                ),
          !i && e.buffer && (e.buffer.release(), (e.buffer = null));
      }),
      A.serverTime > 0 && this.statsEnabled
        ? ((this.currentFrameClientTime = performance.now()),
          (this.currentFrameServerTime = A.serverTime),
          this.log.debugIf(
            () =>
              `Updated timestamps - currentFrameClientTime: ${this.currentFrameClientTime}, currentFrameServerTime: ${this.currentFrameServerTime}`
          ))
        : this.log.debugIf(
            () =>
              "Not considering current frame for stats update - server timestamp might be the one of previous transmission"
          ),
      A.sendAck &&
        this.channel &&
        (this.isVisible
          ? this.channel.sendAck(A.frameId, Date.now() - A.creationTime)
          : (this.log.debug(
              `Tab(s) is currently not visible: omitting client time in ack for frame ${A.frameId}`
            ),
            this.channel.sendAck(A.frameId, 0))),
      delete this.frames[A.frameId],
      tI.call(this))
    : this.log.debugIf(() => {
        let A = "";
        return (
          0 !== this.swappedFrames.length && (A = `, count ${this.swappedFrames[0].count}`),
          `Paint frames not ready (length ${this.swappedFrames.length}${A})`
        );
      });
}
function iI(A, e) {
  this.log.info(`Dpr changed for ${A}: ${e}`),
    Ao(this.channel)
      ? this.log.error(
          "Unable to synchronize high pixel density: display channel is null or undefined"
        )
      : this.channel.syncHighPixelDensity(this.latestLogicalHeads);
}
function nI() {
  this.displayToDprListenerMap.forEach((A, e, t) => {
    A();
  }),
    this.displayToDprListenerMap.clear();
}
function oI() {
  if ((nI.call(this), this.highPixelDensityEnabled))
    for (const [A, e] of Object.entries(this.displayToWindowMap))
      this.displayToDprListenerMap.set(
        A,
        ao(e, (e) => iI.call(this, A, e))
      );
}
function rI(A, e) {
  if (this.highPixelDensityEnabled) {
    const t = this.displayToDprListenerMap.get(A);
    Ao(t) || (t(), this.displayToDprListenerMap.delete(A)),
      this.displayToDprListenerMap.set(
        A,
        ao(e, (e) => iI.call(this, A, e))
      );
  }
}
function sI(A) {
  const e = this.displayToWindowMap[0];
  return A.primary ? e : Object.values(this.displayToWindowMap).find((A) => A !== e);
}
function aI(A) {
  let e = 0,
    t = 0,
    i = 0,
    n = [];
  return (
    A.forEach((A) => {
      let o = A.rect.width,
        r = A.rect.height;
      if (this.highPixelDensityEnabled) {
        const e = sI.call(this, A);
        if (e) {
          const t = e.devicePixelRatio;
          Ao(t) || t <= 0
            ? this.log.warn(
                `Failed to scale physical head ${A.name} ${o}x${r} because device pixel ratio is invalid (${t})`
              )
            : ((o = 0 | Math.floor(o / t)),
              (r = 0 | Math.floor(r / t)),
              this.log.info(
                `Scaled physical head ${A.name} to ${o}x${r} (divider: ${t}) because high pixel density is enabled`
              ));
        } else
          this.log.warn(
            `Failed to scale physical head ${A.name} ${o}x${r} because no ${A.primary ? "primary" : "secondary"} window is registered`
          );
      }
      A.primary && ((e = o), (t = r)),
        n.push({
          name: A.name,
          rect: { x: i, y: A.rect.y, width: o, height: r },
          primary: A.primary
        }),
        (i += o);
    }),
    [e, t, n]
  );
}
function gI() {
  return this.id++;
}
function cI(A) {
  let e, t, i, n, o, r, s, a, g;
  if (A) {
    if (
      ((r = A.length),
      (s = this.displays.length),
      (a = this.pendingDisplays.length),
      this.displays[0])
    ) {
      for (o = Math.min(s, r), i = 0; i < o; i++)
        this.displays[i].setLayout(A[i], this.boundingBox);
      if (s > r) {
        for (; i < s; i++) {
          const A = this.displays[i].id;
          this.displays[i].close(),
            delete this.displays[i],
            this.configuration.observers.displayAvailability(A, { enabled: !1, closed: !0 });
        }
        lI.call(this), dI.call(this);
      } else if (s === r && this.pendingServerDisplays.length > 0) dI.call(this);
      else if (i < r && a > 0)
        for (n = 0; i < r && !(n >= a); i++, n++)
          (e = new Lc(
            {
              window: this.pendingDisplays[n].window,
              primary: A[i].primary,
              id: this.pendingDisplays[n].displayId,
              debugLayerDuration: this.configuration.showDebugLayer,
              enableGraphicsDebugLayer: this.configuration.enableGraphicsDebugLayer,
              enableHighPixelDensity: this.highPixelDensityEnabled,
              clientHiDpiScaling: this.configuration.clientHiDpiScaling,
              supportsReconfigure: this.channel.getSupportsReconfigure(),
              enableTileGroupRendering: this.channel.getSupportsTileGroupProcessing(),
              divId: this.pendingDisplays[n].config.displayDivName,
              inputListeners: this.inputListeners,
              latestCursorStyle: this.latestCursorStyle,
              name: A[i].name,
              firstFrameCallback: this.firstFrameCallback,
              relativeMouseModeEnabled: this.relativeMouseModeEnabled,
              virtualCursor: this.virtualCursor,
              hotCornerThreshold: 30,
              clientResizeEnabled: this.clientResizeEnabled,
              head: A[i],
              boundingBox: this.boundingBox,
              IMEMode: this.currentIMEMode
            },
            this.clientConnectionId
          )),
            e && null !== e.displayCanvas && null !== e.displayInputDiv
              ? (e.registerManager(this),
                this.displays.push(e),
                this.configuration.observers.displayAvailability(e.id, { enabled: !0, closed: !1 }))
              : this.log.warn("Not adding display since display canvas or input div are null");
      lI.call(this, n);
    } else
      (e = new Lc(
        {
          window: window,
          primary: !0,
          id: 0,
          debugLayerDuration: this.configuration.showDebugLayer,
          enableGraphicsDebugLayer: this.configuration.enableGraphicsDebugLayer,
          enableHighPixelDensity: this.highPixelDensityEnabled,
          clientHiDpiScaling: this.configuration.clientHiDpiScaling,
          supportsReconfigure: this.channel.getSupportsReconfigure(),
          enableTileGroupRendering: this.channel.getSupportsTileGroupProcessing(),
          divId: this.configuration.divId,
          inputListeners: this.inputListeners,
          latestCursorStyle: this.latestCursorStyle,
          name: A[0].name,
          firstFrameCallback: this.firstFrameCallback,
          relativeMouseModeEnabled: this.relativeMouseModeEnabled,
          virtualCursor: this.virtualCursor,
          hotCornerThreshold: 30,
          clientResizeEnabled: this.clientResizeEnabled,
          head: A[0],
          boundingBox: this.boundingBox,
          IMEMode: this.currentIMEMode
        },
        this.clientConnectionId
      )),
        e.registerManager(this),
        (this.displays[0] = e),
        (this.primaryDisplay = e),
        (this.activeDisplay = e),
        this.configuration.observers.displayAvailability(0, { enabled: !0, closed: !1 });
    if (((s = this.displays.length), s < r)) {
      for (t = [], g = [], i = s; i < r; ++i)
        (e = II(this.pendingServerDisplays, A[i].name)),
          null === e
            ? ((e = new Lc(
                {
                  primary: A[i].primary,
                  name: A[i].name,
                  head: A[i],
                  id: gI.call(this),
                  debugLayerDuration: this.configuration.showDebugLayer,
                  enableHighPixelDensity: this.highPixelDensityEnabled,
                  clientHiDpiScaling: this.configuration.clientHiDpiScaling,
                  supportsReconfigure: this.channel.getSupportsReconfigure(),
                  enableTileGroupRendering: this.channel.getSupportsTileGroupProcessing(),
                  IMEMode: this.currentIMEMode
                },
                this.clientConnectionId,
                !0
              )),
              e.registerManager(this),
              g.push(e))
            : ((e.primary = e.primary || A[i].primary),
              (e.head = A[i]),
              this.log.info(
                `Updating display ${e.name} with id ${e.id} inside pending server displays`
              )),
          t.push(e);
      dI.call(this),
        (this.pendingServerDisplays = t),
        g.forEach((A) => {
          this.log.info(
            `Notifying display ${A.name} added to pending server displays with id ${A.id}`
          ),
            this.configuration.observers.displayAvailability(A.id, { enabled: !1, closed: !1 });
        });
    }
    this.log.info(
      `Notifying new server primary display layout (${this.layerW}, ${this.layerH}), logical: (${this.logicalLayerW}, ${this.logicalLayerH})`
    ),
      Xn(this.configuration.observers.displayLayout) &&
        this.configuration.observers.displayLayout(
          this.logicalLayerW,
          this.logicalLayerH,
          this.latestLogicalHeads
        );
  }
}
function II(A, e) {
  for (let t = 0; t < A.length; t++) if (A[t].name === e) return A.splice(t, 1)[0];
  return null;
}
function lI(A) {
  const e = Ao(A) ? 0 : A;
  this.pendingDisplays.forEach((A, t) => {
    t >= e &&
      this.configuration.observers.displayAvailability(A.displayId, { enabled: !1, closed: !0 });
  }),
    (this.pendingDisplays = []);
}
function dI() {
  this.pendingServerDisplays.forEach((A) => {
    A.close(), this.configuration.observers.displayAvailability(A.id, { enabled: !1, closed: !0 });
  }),
    (this.pendingServerDisplays = []);
}
function uI(A, e, t) {
  const i = this.pendingServerDisplays[A];
  return (
    !(
      !i ||
      (this.configuration.observers.displayAvailability(i.id, { enabled: !0, closed: !1 }),
      !i.fromPendingToFull({
        window: e,
        debugLayerDuration: this.configuration.showDebugLayer,
        enableGraphicsDebugLayer: this.configuration.enableGraphicsDebugLayer,
        enableHighPixelDensity: this.highPixelDensityEnabled,
        clientHiDpiScaling: this.configuration.clientHiDpiScaling,
        divId: t.displayDivName,
        inputListeners: this.inputListeners,
        latestCursorStyle: this.latestCursorStyle,
        firstFrameCallback: this.firstFrameCallback,
        relativeMouseModeEnabled: this.relativeMouseModeEnabled,
        virtualCursor: this.virtualCursor,
        hotCornerThreshold: 30,
        clientResizeEnabled: this.clientResizeEnabled,
        boundingBox: this.boundingBox
      }))
    ) &&
    (this.displays.push(i),
    this.pendingServerDisplays.splice(A, 1),
    e.dcvId || (e.dcvId = i.id),
    !0)
  );
}
function CI() {
  const A = [];
  return (
    this.displays.forEach((e) => {
      A.push(e.head);
    }),
    A
  );
}
function BI() {
  this.displays &&
    (this.displays.forEach((A) => {
      A.close(),
        this.configuration.observers.displayAvailability(A.id, { enabled: !1, closed: !0 });
    }),
    (this.displays = []));
}
function QI() {
  return this.displays.every((A) => A.paused);
}
function EI(A, e) {
  const t = e.find((e) => e.id === A);
  return (
    t || (this.log.debug(`The requested display id ${A} is not associated to a display`), null)
  );
}
function hI() {
  let A = 0;
  return (
    this.latestLogicalHeads.forEach((e) => {
      e.rect.x + e.rect.width > A && (A = e.rect.x + e.rect.width);
    }),
    {
      name: "NewDisplay",
      rect: {
        x: A,
        y: 0,
        width: this.latestLogicalHeads[0].rect.width,
        height: this.latestLogicalHeads[0].rect.height
      },
      primary: !1
    }
  );
}
function pI(A, e) {
  (this.log = Q("decoder")),
    (this.pool = A),
    (this.onFrameDecoded = (function (A) {
      return Xn(A) ? A : eo;
    })(e));
}
(AI.prototype.registerChannel = function (A) {
  (this.channel = A),
    Xn(this.configuration.observers.firstFrame) &&
      (this.firstFrameCallback = this.configuration.observers.firstFrame);
  const e = gI.call(this);
  (this.displayToWindowMap[e] = window),
    rI.call(this, e, window),
    window.dcvId || (window.dcvId = e);
}),
  (AI.prototype.unregisterChannel = function (A) {
    if (this.channel !== A) return void this.log.warn("Skip unregister of wrong channel");
    this.releaseMouse();
    const e = js(this.clientConnectionId).getDataChannel(Ia.AUDIO);
    e && e.audioOutput.displayReady(!1),
      nI.call(this),
      dI.call(this),
      lI.call(this),
      this.resetFrameQueue(),
      BI.call(this),
      eI.call(this);
  }),
  (AI.prototype.setLayout = function (A) {
    let e = 0;
    (this.boundingBox = { x1: 0, y1: 0, x2: 0, y2: 0, w: 0, h: 0 }),
      A.forEach((A, t) => {
        (this.boundingBox.x1 = Math.min(this.boundingBox.x1, A.rect.x)),
          (this.boundingBox.y1 = Math.min(this.boundingBox.y1, A.rect.y)),
          (this.boundingBox.x2 = Math.max(this.boundingBox.x2, A.rect.x + A.rect.width)),
          (this.boundingBox.y2 = Math.max(this.boundingBox.y2, A.rect.y + A.rect.height)),
          A.primary && (e = t);
      }),
      (this.boundingBox.w = this.boundingBox.x2 - this.boundingBox.x1),
      (this.boundingBox.h = this.boundingBox.y2 - this.boundingBox.y1),
      (this.layerW = A[e].rect.width),
      (this.layerH = A[e].rect.height),
      (this.latestHeads = A),
      ([this.logicalLayerW, this.logicalLayerH, this.latestLogicalHeads] = aI.call(this, A)),
      Xn(this.relativeMouseAvailabilityCallback) &&
        this.relativeMouseAvailabilityCallback({ enabled: 1 === A.length }),
      cI.call(this, A);
  }),
  (AI.prototype.convertHeadToPhysical = function (A, e, t) {
    if (this.highPixelDensityEnabled) {
      const i = sI.call(this, A);
      let n = e,
        o = t;
      if (i) {
        const e = i.devicePixelRatio;
        if (Ao(e) || e <= 0)
          this.log.warn(
            `Failed to scale logical head ${A.name} ${n}x${o} because device pixel ratio is invalid (${e})`
          );
        else {
          let [t, i] = (function (A) {
            let e = 1,
              t = 1,
              i = Math.abs(A - 1);
            for (let n = 1; i > 0 && n <= 16; n++) {
              let o = Math.round(A * n),
                r = Math.abs(A - o / n);
              r < i && ((e = o), (t = n), (i = r));
            }
            return [0 | e, t];
          })(e);
          1 & t && (i *= 2);
          const r = (0 | Math.floor(n / i)) * i,
            s = (0 | Math.floor(o / i)) * i;
          this.log.info(`Corrected logical head ${A.name} from ${n}x${o} to ${r}x${s}`),
            (n = r * e),
            (o = s * e),
            this.log.info(
              `Scaled logical head ${A.name} to ${n}x${o} (multiplier: ${e}) because high pixel density is enabled`
            );
        }
      } else
        this.log.warn(
          `Failed to scale logical head ${A.name} ${n}x${o} because no ${A.primary ? "primary" : "secondary"} window is registered`
        );
      return [n, o];
    }
    return [e, t];
  }),
  (AI.prototype.enableHighPixelDensity = function (A) {
    for (let e = 0; e < this.displays.length; e++) this.displays[e].enableHighPixelDensity(A);
    for (let e = 0; e < this.pendingServerDisplays.length; e++)
      this.pendingServerDisplays[e].enableHighPixelDensity(A);
    this.highPixelDensityEnabled !== A &&
      ((this.highPixelDensityEnabled = A),
      Ao(this.channel) || this.channel.syncHighPixelDensity(this.latestLogicalHeads),
      oI.call(this));
  }),
  (AI.prototype.enableResize = function (A) {
    this.clientResizeEnabled = A;
  }),
  (AI.prototype.isResizeEnabled = function () {
    return this.clientResizeEnabled;
  }),
  (AI.prototype.resetFrameQueue = function () {
    (this.swappedFrames = []), (this.frames = {});
  }),
  (AI.prototype.pushVoidTile = function (A) {
    A
      ? (this.log.debug(`Push void tile (frame ${A})`),
        this.frames[A] ||
          (this.frames[A] = {
            frameId: A,
            count: 1,
            tiles: [],
            sendAck: !1,
            countFrames: !1,
            creationTime: Date.now(),
            discard: !1
          }))
      : this.log.error("Cannot add tile for unspecified frame");
  }),
  (AI.prototype.pushPendingTile = function (A, e) {
    A
      ? (this.log.debugIf(() => `Push pending tile (frame ${A})`),
        this.frames[A]
          ? this.frames[A].count++
          : (this.frames[A] = {
              frameId: A,
              count: 2,
              tiles: [],
              sendAck: !1,
              countFrames: e,
              creationTime: Date.now(),
              discard: !1
            }))
      : this.log.error("Cannot add tile for unspecified frame");
  }),
  (AI.prototype.pushDecodedTile = function (A) {
    if (!A.frameId || !this.frames[A.frameId])
      return void this.log.error(`Received decoded tile for unknown frame ${A.frameId}`);
    const e = this.frames[A.frameId];
    e.tiles.push(A),
      e.count--,
      this.log.debugIf(() => `Push decoded tile (frame ${A.frameId}, ${e.count})`),
      0 === e.count && tI.call(this);
  }),
  (AI.prototype.swap = function (A, e) {
    if (!A || !this.frames[A])
      return void this.log.error(`Received swap tile for unknown frame ${A}`);
    const t = this.frames[A];
    (t.sendAck = !0),
      (t.serverTime = e),
      this.swappedFrames.push(t),
      t.countFrames && Vs(this.clientConnectionId).incrementSwaps(),
      t.count--,
      this.log.debugIf(() => `Swap frame ${A} (${t.count})`),
      0 === t.count && tI.call(this);
  }),
  (AI.prototype.captureMouse = function () {
    this.activeDisplay.captureMouse();
  }),
  (AI.prototype.releaseMouse = function () {
    this.activeDisplay && this.activeDisplay.releaseMouse();
  }),
  (AI.prototype.isMouseCaptured = function () {
    return this.activeDisplay.isMouseCaptured();
  }),
  (AI.prototype.requestPointerLock = function () {
    this.activeDisplay.requestPointerLock();
  }),
  (AI.prototype.setVirtualCursor = function (A) {
    (this.virtualCursor = A),
      this.displays &&
        this.displays.forEach((e) => {
          e.setVirtualCursor(A);
        });
  }),
  (AI.prototype.setVirtualCursorPosition = function (A, e) {
    this.activeDisplay && this.activeDisplay.setVirtualCursorPosition(A, e);
  }),
  (AI.prototype.enableRelativeMouseMode = function (A) {
    this.relativeMouseModeEnabled = A;
  }),
  (AI.prototype.translateCoordinates = function (A, e, t) {
    return this.activeDisplay
      ? Ao(t)
        ? this.activeDisplay.translateCoordinates(A, e)
        : EI.call(this, t, this.displays).translateCoordinates(A, e)
      : (this.log.debug("A coordinates translation was requested, but no display is active"), null);
  }),
  (AI.prototype.setCursorStyle = function (A) {
    (this.latestCursorStyle = A),
      this.displays.forEach((e) => {
        e.setCursorStyle(A);
      });
  }),
  (AI.prototype.currentServerTime = function () {
    return this.currentFrameClientTime <= 0 || this.currentFrameServerTime <= 0
      ? 0
      : this.currentFrameServerTime + performance.now() - this.currentFrameClientTime;
  }),
  (AI.prototype.addInputListeners = function (A, e) {
    this.log.debug("Adding input event handlers"),
      (this.inputListeners = A),
      (this.relativeMouseAvailabilityCallback = e),
      Xn(this.relativeMouseAvailabilityCallback) &&
        this.relativeMouseAvailabilityCallback({ enabled: 1 === this.latestHeads.length }),
      this.displays.forEach((A) => {
        A.addInputListeners(this.inputListeners);
      });
  }),
  (AI.prototype.clearInputListeners = function () {
    (this.inputListeners = {}),
      (this.relativeMouseAvailabilityCallback = null),
      this.displays.forEach((A) => {
        A.removeInputListeners();
      });
  }),
  (AI.prototype.focusDisplayDiv = function (A) {
    Ao(A) && !Ao(this.activeDisplay)
      ? this.activeDisplay.focusDisplayDiv()
      : Ao(A) || EI.call(this, A, this.displays).focusDisplayDiv();
  }),
  (AI.prototype.getActiveDisplay = function () {
    return this.activeDisplay;
  }),
  (AI.prototype.getActiveWindow = function () {
    return this.activeDisplay ? this.activeDisplay.window : window;
  }),
  (AI.prototype.getDisplayToWindowMap = function () {
    return this.displayToWindowMap;
  }),
  (AI.prototype.isDisplayReady = function () {
    return this.firstFrameArrived;
  }),
  (AI.prototype.forceFirstFrameCallback = function (A) {
    EI.call(this, A, this.displays).sendFirstFrame();
  }),
  (AI.prototype.attachDisplay = function (A, e) {
    const t = [],
      i = {
        success: !1,
        displayId: null,
        forceFirstFrameCallback: !1,
        errorCode: Io.MultiMonitor.NO_ERROR,
        errorMessage: ""
      },
      n = this.pendingServerDisplays.length;
    if (
      this.maxDisplayNumber &&
      this.displays.length + this.pendingDisplays.length >= this.maxDisplayNumber
    )
      (i.success = !1),
        (i.errorCode = Io.MultiMonitor.MAX_DISPLAY_NUMBER_REACHED),
        (i.errorMessage = "Maximum number of displays has already been reached");
    else if (n > 0) {
      for (let t = 0; t < n; ++t) {
        const n = this.pendingServerDisplays[t];
        if (n.id === e.displayId) {
          if (
            ((i.success = !0),
            (i.displayId = n.id),
            (i.forceFirstFrameCallback = !0),
            uI.call(this, t, A, e))
          )
            this.resumeDisplay(n),
              (this.displayToWindowMap[e.displayId] = A),
              rI.call(this, e.displayId, A);
          else {
            const A = "Failed to convert the pending display to a full display";
            this.log.error(A),
              (i.success = !1),
              (i.errorCode = Io.MultiMonitor.DISPLAY_NOT_OPENED_BY_SERVER),
              (i.errorMessage = A);
          }
          return i;
        }
      }
      (i.success = !1),
        (i.errorCode = Io.MultiMonitor.DISPLAY_NOT_OPENED_BY_SERVER),
        (i.errorMessage =
          "The server has already pending opened displays. You must request one of them.");
    } else
      (i.displayId = gI.call(this)),
        (i.success = !0),
        A.dcvId || (A.dcvId = i.displayId),
        (this.displayToWindowMap[i.displayId] = A),
        rI.call(i.displayId, A),
        this.pendingDisplays.push({ window: A, config: e, displayId: i.displayId }),
        this.latestLogicalHeads.forEach((A) => {
          t.push(A);
        }),
        t.push(hI.call(this)),
        this.channel.sendDisplayLayoutMulti(t);
    return i;
  }),
  (AI.prototype.detachDisplay = function (A) {
    let e,
      t = this.isResizeEnabled(),
      i = !1;
    this.log.debug(`Attempting to detach display ${A}`),
      (this.displays = this.displays.filter(
        (n) =>
          n.id !== A ||
          (Object.keys(this.channel.streamInfos).forEach((t) => {
            (e = this.channel.streamInfos[t]),
              e.associatedDisplay && e.associatedDisplay.id === A && (e.associatedDisplay = null);
          }),
          t
            ? (n.close(), (i = !0))
            : (this.pauseDisplay(n),
              n.fromFullToPending(),
              this.pendingServerDisplays.push(n),
              (i = !0)),
          !1)
      )),
      i
        ? (this.log.info(`Detached display ${A}`),
          t
            ? (this.channel.sendDisplayLayoutMulti(CI.call(this)),
              this.configuration.observers.displayAvailability(A, { enabled: !1, closed: !0 }))
            : (this.setLayout(this.latestHeads),
              this.configuration.observers.displayAvailability(A, { enabled: !1, closed: !1 })))
        : this.log.warn(`Display ${A} not found for detaching`);
  }),
  (AI.prototype.setMaxDisplayNumber = function (A) {
    (this.maxDisplayNumber = A),
      this.log.info(`Maximum number of displays set to ${this.maxDisplayNumber}`);
  }),
  (AI.prototype.setDisplayScaleRatio = function (A, e) {
    const t = EI.call(this, e, this.displays);
    return null === t
      ? (this.log.info(`Cannot find display to scale: ${e}`), !1)
      : (t.setScaleRatio(A), !0);
  }),
  (AI.prototype.getScaleRatio = function (A) {
    let e;
    return (
      (e = Ao(A) ? EI.call(this, 0, this.displays) : EI.call(this, A, this.displays)),
      null === e ? 1 : e.getScaleRatio()
    );
  }),
  (AI.prototype.pauseDisplay = function (A) {
    Ao(this.channel) ||
      (A.pause(),
      to(this.channel.protocolVersion, { major: 1, minor: 3 })
        ? (this.channel.sendPause(A.name),
          QI.call(this) &&
            ((this.isVisible = !1),
            (this.currentFrameClientTime = 0),
            (this.currentFrameServerTime = 0)))
        : QI.call(this) &&
          (this.channel.sendPause(),
          (this.isVisible = !1),
          (this.currentFrameClientTime = 0),
          (this.currentFrameServerTime = 0)));
  }),
  (AI.prototype.resumeDisplay = function (A) {
    Ao(this.channel) ||
      (A.resume(),
      to(this.channel.protocolVersion, { major: 1, minor: 3 })
        ? this.channel.sendResume(A.name)
        : this.channel.sendResume(),
      QI.call(this) || (this.isVisible = !0));
  }),
  (AI.prototype.setDisplayAsActive = function (A) {
    A && A.hasFocus() ? (this.activeDisplay = A) : (this.activeDisplay = this.primaryDisplay);
  }),
  (AI.prototype.getDisplayFromTile = function (A) {
    for (let e = 0; e < this.displays.length; e++)
      if (
        A.rect.x >= this.displays[e].head.rect.x &&
        A.rect.x < this.displays[e].head.rect.x + this.displays[e].head.rect.width &&
        A.rect.y >= this.displays[e].head.rect.y &&
        A.rect.y < this.displays[e].head.rect.y + this.displays[e].head.rect.height
      )
        return this.displays[e];
    for (let e = 0; e < this.pendingServerDisplays.length; e++)
      if (
        A.rect.x >= this.pendingServerDisplays[e].head.rect.x &&
        A.rect.x <
          this.pendingServerDisplays[e].head.rect.x +
            this.pendingServerDisplays[e].head.rect.width &&
        A.rect.y >= this.pendingServerDisplays[e].head.rect.y &&
        A.rect.y <
          this.pendingServerDisplays[e].head.rect.y + this.pendingServerDisplays[e].head.rect.height
      )
        return this.pendingServerDisplays[e];
    return null;
  }),
  (AI.prototype.getInputDiv = function (A) {
    const e = EI.call(this, A, this.displays);
    return e
      ? e.displayInputDiv
      : (this.log.warn(`Could not get input div for display ${A}`), null);
  }),
  (AI.prototype.setCurrentIMEMode = function (A) {
    (this.currentIMEMode = A),
      Ao(this.displays)
        ? this.log.warn("Displays not initialized when setting current IME mode")
        : this.displays.forEach((A) => A.setIMEMode(this.currentIMEMode));
  }),
  (AI.prototype.getCurrentDisplays = function () {
    return this.displays;
  }),
  (pI.prototype.decode = function (A) {
    this.log.error(`abstract 'decode' method not implemented by ${this.constructor.name}`);
  }),
  (pI.prototype.start = function (A) {
    this.log.error(`abstract 'start' method not implemented by ${this.constructor.name}`);
  }),
  (pI.prototype.stop = function () {
    this.log.error(`abstract 'stop' method not implemented by ${this.constructor.name}`);
  }),
  (pI.prototype.getMinimumPoolSize = function (A, e) {
    return this.log.debug(`'getMinimumPoolSize' will yield 0 by ${this.constructor.name}`), 0;
  });
const fI = (A) => (A + 16383) & -16384;
class mI {
  toBuffer() {
    return null;
  }
  fromBuffer(A) {}
  get data() {
    return null;
  }
  get length() {
    return 0;
  }
  detach() {}
  release() {}
}
class yI extends mI {
  constructor(A) {
    super(), (this.block = A);
  }
  get data() {
    return this.block;
  }
  get length() {
    return this.block.byteLength;
  }
  release() {
    this.block = null;
  }
}
class DI extends mI {
  constructor(A) {
    super(),
      (this.block = new Uint8Array(A)),
      (this.size = A),
      (this.flaggedForDeletion = !1),
      (this.inUse = !1),
      (this.currentLength = 0);
  }
  get data() {
    return this.block;
  }
  get length() {
    return this.currentLength;
  }
  toBuffer() {
    if (!this.block || !this.inUse) return null;
    const A = this.block.buffer;
    return (this.block = null), A;
  }
  fromBuffer(A) {
    A && !this.block && A.byteLength === this.size && (this.block = new Uint8Array(A));
  }
  detach() {
    this.inUse ? (this.flaggedForDeletion = !0) : (this.block = null);
  }
  release() {
    (this.inUse = !1), this.flaggedForDeletion && ((this.block = null), (this.size = 0));
  }
}
class wI {
  constructor(A) {
    (this.log = A), (this.bufferSize = 0), (this.buffers = []);
  }
  peek(A) {
    const e = fI(A);
    0 === e && this.log.warn(`Requested allocation (${e}) is invalid`),
      e > this.bufferSize &&
        this.log.warn(
          `Requested allocation (${e}) exceeds the maximum allowed (${this.bufferSize})`
        );
    let t = this.buffers.find((A) => !A.inUse);
    return (
      t ||
        (this.log.debug("No capacity, allocating new buffer"),
        (t = new DI(this.bufferSize)),
        this.buffers.push(t)),
      (t.inUse = !0),
      (t.currentLength = e),
      t
    );
  }
  resize(A) {
    const e = fI(A);
    e !== this.bufferSize &&
      (this.log.debug(`Resizing pool to ${e}`),
      this.buffers.forEach((A) => A.detach()),
      (this.buffers = []),
      (this.bufferSize = e));
  }
}
function FI(A, e, t, i, n, o, r) {
  pI.call(this, t, i), (this.log = Q(n, r));
  const s = URL.createObjectURL(
    new Blob([`var baseUrl = "${A}";`, `importScripts("${A + o}");`], { type: "text/javascript" })
  );
  (this.worker = new Worker(s, { name: "YUVDecoder" })),
    URL.revokeObjectURL(s),
    (this.negotiatedCapabilities = e),
    (this.tiles = []),
    (this.startFlag = !1),
    (this.layerType = -1),
    (this.pictureCount = 0),
    (this.isBt601 = e.indexOf("colorspace_yuv_rec601") > -1),
    (this.isFullRange = e.indexOf("colorrange_full") > -1),
    this.log.info(`Created YUV worker (${A}${o})`),
    (this.worker.onerror = (A) => {
      this.log.warn(`YUV worker error (${A.filename}:${A.lineno}): ${A.message}`);
    }),
    (this.worker.onmessageerror = (A) => {
      this.log.warn(`YUV worker message error: ${JSON.stringify(A)}`);
    }),
    (this.worker.onmessage = (A) => {
      if ("frame" === A.data.type) {
        const e = this.tiles.shift();
        if (!e) return void this.log.warn("No tile info found for decoded YUV frame");
        if (((e.data = null), (e.discard = !this.startFlag), e.discard))
          return (
            this.log.debug("Trying to push a tile when the decoder is stopped"),
            void this.onFrameDecoded(e)
          );
        (e.pixelFormat = xr.I420),
          (e.renderMethod = xr.CLIPMAP),
          (e.layerType = this.layerType),
          (e.buffer = new yI(A.data.buffer)),
          (e.isRgb = !1),
          (e.isBt601 = this.isBt601),
          (e.isFullRange = this.isFullRange),
          this.onFrameDecoded(e);
      } else
        "stats" === A.data.type
          ? this.log.debug(`Decoding worker statistics for ${n}: ${C(A.data)}`)
          : "info" === A.data.type && this.log.info(A.data.message);
    });
}
function bI(A, e, t, i, n) {
  return FI.call(this, A, e, t, i, "h264", "/dcv/broadwayh264decoder-worker.js", n);
}
(FI.prototype = Object.create(pI.prototype)),
  (FI.prototype.constructor = FI),
  (FI.prototype.getConfig = function () {
    const A = {};
    return (A.decoder = xr.YUV), (A.pixelFormat = xr.I420), (A.renderMethod = xr.CLIPMAP), A;
  }),
  (FI.prototype.decode = function (A) {
    this.log.debug(`Decoding YUV tile of frame ${A.frameId}`), this.tiles.push(A);
    const e = A.data;
    (A.data = null),
      this.worker.postMessage({ type: "frame", frame: e }, [e]),
      this.pictureCount++,
      this.pictureCount % 100 == 0 && this.worker.postMessage({ type: "stats" });
  }),
  (FI.prototype.start = function (A) {
    (this.startFlag = !0), this.log.debug("YUV decoder started");
  }),
  (FI.prototype.stop = function () {
    (this.startFlag = !1),
      this.worker.postMessage({ type: "close" }),
      (this.worker = null),
      this.log.debug("YUV decoder stopped");
  }),
  (bI.prototype = Object.create(FI.prototype)),
  (bI.prototype.constructor = bI),
  (bI.codecName = "h264"),
  (bI.capabilities = [
    "codec_quality_setting",
    "codec_profile_baseline",
    "subsamp_420",
    "colorspace_yuv_rec709",
    "colorspace_yuv_rec601",
    "colorrange_full"
  ]);
const UI = 6e3;
class SI extends mI {
  constructor(A) {
    super(), (this.frame = A);
  }
  get data() {
    return this.frame;
  }
  release() {
    this.frame && (this.frame.close(), (this.frame = null));
  }
}
function RI(A, e) {
  let t, i, n, o, r, s, a, g, c, I, l;
  if (
    ((i = A.data),
    (n = e.data),
    (r = i.byteLength),
    (s = n.byteLength),
    (g =
      null !== this.currentSps &&
      this.currentSps.byteLength === r &&
      this.currentSps.every((A, e) => i[e] === A)),
    (c =
      null !== this.currentPps &&
      this.currentPps.byteLength === s &&
      this.currentPps.every((A, e) => n[e] === A)),
    g && c)
  )
    return this.currentConfig;
  if ((c || (this.currentPps = n.slice()), g)) (o = this.patchedSps.data), (a = o.byteLength);
  else {
    if (
      ((this.currentSps = i.slice()),
      (this.patchedSps = A.patch(this.negotiatedCapabilities)),
      null === this.patchedSps)
    )
      return this.log.error("Failed to generate config description"), null;
    (o = this.patchedSps.data),
      (a = o.byteLength),
      (r !== a || i.some((A, e) => o[e] !== A)) &&
        (this.log.debug(`Input sps:   ${_n(i)}`), this.log.debug(`Patched sps: ${_n(o)}`));
  }
  return (
    (t = (function (A, e) {
      const t = A.data,
        i = t.byteLength,
        n = e.data,
        o = n.byteLength,
        r = new Uint8Array(11 + i + o);
      return (
        (r[0] = 1),
        r.set(t.subarray(1, 4), 1),
        (r[4] = 255),
        (r[5] = 225),
        Wo(r, 6, i),
        r.set(t, 8),
        (r[8 + i] = 1),
        Wo(r, 9 + i, o),
        r.set(n, 11 + i),
        r
      );
    })(this.patchedSps, e)),
    (l = { codec: `avc1.${_n(t.subarray(1, 4))}`, description: t, optimizeForLatency: !0 }),
    (I = o[1]),
    NI.profiles[I]
      ? (l.hardwareAcceleration = "prefer-hardware")
      : (l.hardwareAcceleration = "prefer-software"),
    l
  );
}
function vI(A) {
  return null !== A && "closed" !== A.state;
}
function xI() {
  if (vI(this.videoDecoder)) {
    const A = this.videoDecoder;
    (this.videoDecoder = null),
      "unconfigured" === A.state
        ? A.close()
        : A.flush().then((e) => {
            A.close();
          });
  }
}
function MI(A, e) {
  if (
    (this.frameCount++,
    (this.frameDecodeTime += e),
    (this.frameProcessTime += A + e),
    this.frameCount === UI)
  ) {
    const A = ((this.frameDecodeTime / this.frameCount) * 1e3) | 0,
      e = ((this.frameProcessTime / this.frameCount) * 1e3) | 0,
      t = (this.frameCount / (this.frameProcessTime / 1e3)).toFixed(2);
    this.log.info(
      `(Experimental) Decoder averages: [process-time: ${e}us, decode-time: ${A}us, decode-rate: ${t}]`
    ),
      (this.frameCount = 0),
      (this.frameDecodeTime = 0),
      (this.frameProcessTime = 0);
  }
}
function OI() {
  Object.keys(this.tiles).forEach((A) => {
    this.log.debug(`Discarding pending frame ${A}`);
    let e = this.tiles[A];
    e ? this.onFrameDecoded(e.tile) : this.log.warn("No tile info found for decoded frame");
  }),
    (this.tiles = {});
}
function kI() {
  if (null === this.currentConfig)
    return this.log.error("Decoder configuration failed: no config"), void xI.call(this);
  if (
    (vI(this.videoDecoder) ||
      (this.videoDecoder = new window.VideoDecoder({
        output: (A) => {
          let e,
            t,
            i,
            n = performance.now();
          if (((e = A.timestamp), this.log.debugIf(() => `Decoded: ${e}`), (t = this.tiles[e]), !t))
            return A.close(), void this.log.warn("No tile info found for decoded frame");
          if (
            (MI.call(this, t.prepareTime, n - t.decodeStart),
            (i = t.tile),
            delete this.tiles[e],
            (i.discard = !this.startFlag),
            i.discard)
          )
            return (
              A.close(),
              this.log.debug("Trying to push a tile when the decoder is stopped"),
              void this.onFrameDecoded(i)
            );
          if (
            ((this.lastDecodedFrameId = i.frameId),
            (i.pixelFormat = xr.FRAME),
            (i.renderMethod = xr.CLIPMAP),
            (i.layerType = this.layerType),
            dr())
          ) {
            i.isRgb = !0;
            const e = A.displayWidth,
              t = A.displayHeight,
              n = this.pool.peek(e * t * 4),
              o = { rect: { x: 0, y: 0, width: e, height: t }, format: "BGRX" };
            A.copyTo(n.data, o)
              .then((A) => {
                (i.buffer = n), (i.width = e), (i.height = t), this.onFrameDecoded(i);
              })
              .catch((A) => n.release())
              .finally(() => A.close());
          } else if (
            ((i.isRgb = "prefer-hardware" === this.currentConfig.hardwareAcceleration), i.isRgb)
          )
            (i.buffer = new SI(A)), this.onFrameDecoded(i);
          else {
            i.isI420 = this.format === xr.I420;
            const e = A.displayWidth,
              t = A.displayHeight,
              n = i.isI420 ? (t + 3) & -4 : t,
              o = i.isI420 ? 1 : 0,
              r = e,
              s = r * n,
              a = e >> o,
              g = n >> o,
              c = s + a * g,
              I = this.pool.peek(c + a * g),
              l = {
                rect: { x: 0, y: 0, width: e, height: t },
                layout: [
                  { offset: 0, stride: r },
                  { offset: s, stride: a },
                  { offset: c, stride: a }
                ]
              };
            A.copyTo(I.data, l)
              .then((A) => {
                (i.buffer = I),
                  (i.width = e),
                  (i.height = n),
                  (i.isBt601 = this.isBt601),
                  (i.isFullRange = this.isFullRange),
                  this.onFrameDecoded(i);
              })
              .catch((A) => I.release())
              .finally(() => A.close());
          }
        },
        error: (A) => {
          "QuotaExceededError" === A.name || "EncodingError" === A.name
            ? (this.log.debug(A),
              OI.call(this),
              this.isContextLive
                ? (this.log.debug(
                    `${A.name} occurred. Requesting initialization from ${this.lastDecodedFrameId}`
                  ),
                  this.onLostContext && this.onLostContext(this.lastDecodedFrameId),
                  (this.isContextLive = !1))
                : this.log.debug("An initialization is already in progress"))
            : (this.log.error(A), xI.call(this));
        }
      })),
    this.log.debug(`Requested config: ${C(this.currentConfig)}`),
    null !== this.videoDecoder)
  )
    try {
      this.videoDecoder.configure(this.currentConfig);
    } catch (A) {
      this.log.error(`Decoder configuration failed: ${A}`), (this.videoDecoder = null);
    }
}
function NI(A, e, t, i, n) {
  return (
    pI.call(this, t, i),
    (this.log = Q("webvideo", n)),
    (this.negotiatedCapabilities = e),
    (this.parser = new Zo(this.log)),
    (this.tiles = {}),
    (this.startFlag = !1),
    (this.layerType = -1),
    (this.currentConfig = null),
    (this.currentSps = null),
    (this.currentPps = null),
    (this.patchedSps = null),
    (this.frameCount = 0),
    (this.frameDecodeTime = 0),
    (this.frameProcessTime = 0),
    (this.isContextLive = !0),
    (this.lastDecodedFrameId = 0),
    (this.videoDecoder = null),
    (this.isBt601 = e.indexOf("colorspace_yuv_rec601") >= 0),
    (this.isFullRange = e.indexOf("colorrange_full") >= 0),
    (this.format = e.indexOf("subsamp_444") >= 0 ? xr.I444 : xr.I420),
    this
  );
}
function KI(A, e, t, i, n) {
  return FI.call(this, A, e, t, i, "jsmpeg", "/dcv/jsmpegdecoder-worker.js", n);
}
(NI.prototype = Object.create(pI.prototype)),
  (NI.prototype.constructor = NI),
  (NI.codecName = "h264"),
  (NI.capabilities = ["codec_quality_setting"]),
  (NI.profiles = {}),
  (NI.setup = function (A) {
    let e = 0;
    const t = new Set(NI.capabilities);
    A.forEach((A) => {
      const i = A.idc;
      if (i !== e) {
        const A = Ar(i);
        t.add(`codec_profile_${$o(A || i)}`), (e = e || A);
      }
      NI.profiles[i] = A.preferHardware;
    }),
      0 !== e && t.add("subsamp_444"),
      t.add("subsamp_420"),
      t.add("colorspace_yuv_rec709"),
      t.add("colorspace_yuv_rec601"),
      (NI.capabilities = Array.from(t));
  }),
  (NI.prototype.getConfig = function () {
    return { decoder: xr.YUV, pixelFormat: xr.FRAME, renderMethod: xr.CLIPMAP };
  }),
  (NI.prototype.getMinimumPoolSize = function (A, e) {
    if (dr()) return 4 * A * e;
    return (
      (3 * A * (this.format === xr.I420 ? (e + 3) & -4 : e)) >> (this.format === xr.I420 ? 1 : 0)
    );
  }),
  (NI.prototype.decode = function (A) {
    let e,
      t = !1;
    this.log.debug(`Processing frame ${A.frameId}`), (e = performance.now());
    const i = this.parser.parse(A.data);
    if (((A.data = null), null === i))
      return (
        this.log.error(`Discarding frame ${A.frameId}: unable to parse payload`),
        void this.onFrameDecoded(A)
      );
    const [n, o, r] = i,
      s = null !== n;
    if (!this.isContextLive) {
      if (!o)
        return (
          this.log.debug(`Discarding frame ${A.frameId} until context resume`),
          void this.onFrameDecoded(A)
        );
      this.log.debug(`Resuming context from frame ${A.frameId}`), (this.isContextLive = !0);
    }
    if (((t = !vI(this.videoDecoder)), s)) {
      const [A, e] = n,
        i = RI.call(this, A, e);
      i !== this.currentConfig && ((this.currentConfig = i), (t = !0));
    }
    if (t) {
      if (!o) return void this.log.error(`Discarding frame ${A.frameId}: key frame expected`);
      kI.call(this);
    }
    if (vI(this.videoDecoder)) {
      const t = new window.EncodedVideoChunk({
          timestamp: A.frameId,
          data: r,
          type: o ? "key" : "delta"
        }),
        i = performance.now();
      this.log.debugIf(() => `Queued: ${A.frameId}, type: ${t.type}`),
        (this.tiles[A.frameId] = { tile: A, prepareTime: i - e, decodeStart: i }),
        this.videoDecoder.decode(t);
    } else this.log.error(`Discarding frame ${A.frameId}: no decoder configured`);
  }),
  (NI.prototype.start = function (A) {
    (this.startFlag = !0), this.log.debug("Web video decoder started");
  }),
  (NI.prototype.stop = function () {
    (this.startFlag = !1),
      (this.avcc = null),
      xI.call(this),
      this.log.debug("Web video decoder stopped");
  }),
  (KI.prototype = Object.create(FI.prototype)),
  (KI.prototype.constructor = KI),
  (KI.codecName = "mpeg1video"),
  (KI.capabilities = [
    "codec_quality_setting",
    "subsamp_420",
    "colorspace_yuv_rec601",
    "colorspace_yuv_rec709"
  ]);
class LI extends mI {
  constructor(A) {
    super(), (this.img = A);
  }
  get data() {
    return this.img;
  }
  release() {
    this.img && (this.img = null);
  }
}
function TI(A, e, t, i, n) {
  pI.call(this, t, i),
    (this.log = Q("jpeg", n)),
    (this.negotiatedCapabilities = e),
    (this.startFlag = !1),
    (this.layerType = -1);
}
function PI(A, e, t, i, n) {
  pI.call(this, t, i),
    (this.log = Q("jpeg", n)),
    (this.format = e.indexOf("subsamp_444") >= 0 ? xr.I444 : xr.I420),
    (this.negotiatedCapabilities = e),
    (this.startFlag = !1),
    (this.layerType = -1);
}
function GI(A, e, t, i, n) {
  pI.call(this, t, i),
    (this.log = Q("lz4decoder", n)),
    (this.negotiatedCapabilities = e),
    (this.isRgb = e.indexOf("colorspace_rgb") >= 0),
    this.isRgb || (this.isBt601 = e.indexOf("colorspace_yuv_rec601") >= 0),
    (this.pictureCount = 0),
    (this.usingWebGLDecoder = !1),
    (this.startFlag = !1),
    (this.layerType = -1),
    (this.name = "lz4"),
    this.log.info("Using model " + (this.isRgb ? "rgb" : "yuv"));
  const o = "/dcv/lz4decoder-worker.js",
    r = URL.createObjectURL(
      new Blob([`var baseUrl = "${A}";`, `importScripts("${A + o}");`], { type: "text/javascript" })
    );
  (this.lz4Worker = new Worker(r, { name: "LZ4Decoder" })),
    URL.revokeObjectURL(r),
    (this.tiles = []),
    this.log.info(`Created Lz4 worker (${A}${o})`),
    (this.lz4Worker.onerror = (A) => {
      this.log.warn(`LZ4 worker error (${A.filename}:${A.lineno}): ${A.message}`);
    }),
    (this.lz4Worker.onmessageerror = (A) => {
      this.log.warn(`LZ4 worker message error: ${JSON.stringify(A)}`);
    }),
    (this.lz4Worker.onmessage = (A) => {
      let e;
      if ("frame" === A.data.type) {
        if (((e = this.tiles.shift()), !e))
          return void this.log.warn("No tile info found for decoded LZ4 frame");
        (e.data = null),
          e.buffer &&
            (e.buffer.fromBuffer(A.data.buffer),
            A.data.ok ||
              (this.log.warn(`Discarding ${e.frameId} because of failed decompression`),
              e.buffer.release(),
              (e.buffer = null),
              (A.data.buffer = null))),
          (e.discard = !this.startFlag),
          e.discard
            ? (this.log.debug("Trying to push a tile when the decoder is stopped"),
              e.buffer && (e.buffer.release(), (e.buffer = null)))
            : null !== A.data.buffer &&
              (this.isRgb ? (e.pixelFormat = xr.RGB) : (e.pixelFormat = xr.NV12),
              (e.renderMethod = xr.TILELIST),
              (e.layerType = this.layerType),
              e.buffer || (e.buffer = new yI(A.data.buffer)),
              null !== e.rect &&
                (e.rect = { x: A.data.x, y: A.data.y, width: A.data.width, height: A.data.height }),
              (e.isRgb = this.isRgb),
              this.isRgb || ((e.isBt601 = this.isBt601), (e.isFullRange = !1))),
          this.onFrameDecoded(e);
      } else
        "stats" === A.data.type
          ? this.log.debug(`Decoding worker statistics: ${C(A.data)}`)
          : "info" === A.data.type
            ? this.log.info(A.data.message)
            : "warn" === A.data.type
              ? this.log.warn(A.data.message)
              : "error" === A.data.type && this.log.error(A.data.message);
    });
}
let HI;
function YI(A, e, t) {
  const i = A.codecName;
  t.indexOf(i) >= 0
    ? ((e[i] = A), HI.info(`Decoder of type '${i}' registered in the factory`))
    : HI.info(`Decoder of type '${i}' is not enabled`);
}
function qI(A, e, t, i) {
  const n = null !== e;
  let o,
    r,
    s,
    a = { parked: {} };
  (HI = Q("decoderfactory")),
    (o =
      A.displayCodecs && A.displayCodecs.length > 0
        ? A.displayCodecs
        : ur() && !Cr()
          ? ["mpeg1video", "jpeg", "lz4"]
          : ["h264", "jpeg", "lz4"]),
    HI.info(`Enabled codecs are: ${o}`),
    (s = !1),
    i
      ? n
        ? (o.indexOf("h264") >= 0
            ? t.find((A) => 0 !== Ar(A.idc)) && (s = !0)
            : o.indexOf("mpeg1video") < 0 && (s = !0),
          s || HI.info("Disabling high color accuracy because no frame decoder is supporting it"))
        : HI.info("Disabling high color accuracy because WebGL is not available")
      : HI.info("Disabling high color accuracy because live codec negotiation is not available");
  const g = new Set(GI.capabilities);
  n
    ? (0 !== t.length ? (NI.setup(t), YI(NI, a, o)) : YI(bI, a, o),
      YI(KI, a, o),
      (r = (A.losslessColorspace || "rgb").toLowerCase()),
      "rgb" !== r &&
        "yuv_rec709" !== r &&
        "yuv_rec601" !== r &&
        (HI.error(`Invalid color space ${A.losslessColorspace}. Defaulting to rgb`), (r = "rgb")),
      g.add(`colorspace_${r}`))
    : (HI.warn(
        "WebGL support is not available or disabled. Cannot enable H.264 and MPEG1 decoders, nor use any yuv-based colorspace for Lz4 decoder (will use rgb)"
      ),
      window.WebGLRenderingContext &&
        (HI.warn("WebGL support looks available but is disabled."),
        dr()
          ? HI.warn("Try to reset the gfx.crash-guard.status.glcontext value in about:config")
          : lr() && HI.warn("Make sure 'Use hardware acceleration when available' is enabled")),
      g.add("colorspace_rgb")),
    (GI.capabilities = Array.from(g)),
    YI(GI, a, o);
  const c = A.enableWebCodecs && n && e.webImageRenderingSupported && bs;
  return (
    YI(c ? PI : TI, a, o),
    {
      decoders: a,
      highColorAccuracyAvailable: s,
      tileGroupProcessingSupported: c && e.tileGroupRenderingSupported
    }
  );
}
function JI(A, e) {
  const t = to(e, { major: 1, minor: 9 }),
    i = Ns();
  return (
    (HI = Q("decoderfactory")),
    Ao(i)
      ? (HI.info("Disabling WebVideoDecoder because WebGL is not available"),
        Promise.resolve(qI(A, null, [], t)))
      : A.enableWebCodecs
        ? to(e, { major: 1, minor: 8 })
          ? (null !== Fs
              ? Promise.resolve(Fs)
              : "VideoDecoder" in window
                ? Fr().then((A) => {
                    const e = [];
                    for (const t of A) {
                      const A = t.idc,
                        i = $o(A);
                      t.error
                        ? Bs.debug(`Unsupported h264 profile: '${i}'\n${t.error}`)
                        : e.push({ idc: A, preferHardware: t.preferHardware, format: t.format });
                    }
                    return (
                      e.length > 0
                        ? Bs.info(
                            [
                              "WebVideoDecoder is available. Supported profiles:\n",
                              "name     config          format",
                              "-------- --------------- ------",
                              e
                                .map((A) => {
                                  const e = A.preferHardware
                                    ? "prefer hardware"
                                    : "prefer software";
                                  return `${$o(A.idc).padEnd(8)} ${e.padEnd(15)} ${A.format}`;
                                })
                                .join("\n")
                            ].join("\n")
                          )
                        : Bs.info("WebVideoDecoder is not available. No suitable profile found"),
                      (Fs = e),
                      Fs
                    );
                  })
                : (Bs.info("WebVideoDecoder is not available. The browser does not support it"),
                  (Fs = []),
                  Promise.resolve(Fs))
            ).then(
              (e) => (
                0 === e.length && HI.info("Disabling WebVideoDecoder because it is not available"),
                Promise.resolve(qI(A, i, e, t))
              )
            )
          : (HI.info(
              "Disabling WebVideoDecoder because server does not handle context lost events"
            ),
            Promise.resolve(qI(A, i, [], t)))
        : (HI.info("Disabling WebVideoDecoder and WebImageDecoder by user settings"),
          Promise.resolve(qI(A, i, [], t)))
  );
}
(TI.prototype = Object.create(pI.prototype)),
  (TI.prototype.constructor = TI),
  (TI.codecName = "jpeg"),
  (TI.capabilities = [
    "codec_quality_setting",
    "codec_tiles",
    "codec_tiles_group",
    "subsamp_444",
    "subsamp_420"
  ]),
  (TI.prototype.getConfig = function () {
    const A = {};
    return (A.decoder = xr.JPEG), (A.pixelFormat = xr.RGB), (A.renderMethod = xr.TILELIST), A;
  }),
  (TI.prototype.decode = function (A) {
    let e;
    (e = new Image()),
      e.addEventListener(
        "error",
        () => {
          this.log.error.set("failed to decode JPEG"), e.dispose();
        },
        !1
      ),
      e.addEventListener(
        "load",
        () => {
          if (((A.data = null), (A.discard = !this.startFlag), A.discard))
            return (
              this.log.debug("Trying to push a tile when the decoder is stopped"),
              void this.onFrameDecoded(A)
            );
          (A.pixelFormat = xr.RGB),
            (A.renderMethod = xr.TILELIST),
            (A.layerType = this.layerType),
            (A.buffer = new LI(e)),
            (A.isRgb = !0),
            this.onFrameDecoded(A);
        },
        !1
      ),
      (e.src = `data: image/jpeg;base64,${(function (A) {
        return btoa(Vn(new Uint8Array(A)));
      })(A.data)}`);
  }),
  (TI.prototype.start = function (A) {
    (this.startFlag = !0), this.log.debug("JPEG decoder started");
  }),
  (TI.prototype.stop = function () {
    (this.startFlag = !1), this.log.debug("JPEG decoder stopped");
  }),
  (PI.prototype = Object.create(pI.prototype)),
  (PI.prototype.constructor = PI),
  (PI.codecName = "jpeg"),
  (PI.capabilities = [
    "codec_quality_setting",
    "codec_tiles",
    "codec_tiles_group",
    "subsamp_444",
    "subsamp_420"
  ]),
  (PI.prototype.getConfig = function () {
    const A = {};
    return (A.decoder = xr.JPEG), (A.pixelFormat = this.format), (A.renderMethod = xr.TILELIST), A;
  }),
  (PI.prototype.getMinimumPoolSize = function (A, e) {
    return (3 * A * e) >> (this.format === xr.I444 ? 0 : 1);
  }),
  (PI.prototype.decodeGroup = function (A) {
    const e = A.clip,
      t = e.length,
      i = A.units.length,
      n = new Uint8Array(A.data);
    if (t !== i)
      return (
        this.log.error(`Clip count: ${t} not equal to unit count: ${i}`),
        (A.data = null),
        void this.onFrameDecoded(A)
      );
    const o = [];
    let r = 0;
    e.forEach((A) => {
      const e = this.format === xr.I444 ? 0 : 1,
        t = (3 * A.width * A.height) >> e;
      o.push([r, t]), (r += t);
    });
    const s = this.pool.peek(r),
      a = s.data,
      g = o.map((e, t, i) => {
        const o = n.subarray(A.units[t].offset, A.units[t].offset + A.units[t].size),
          r = a.subarray(e[0], e[0] + e[1]),
          s = A.clip[t],
          g = new window.ImageDecoder({
            type: "image/jpeg",
            data: o,
            premultiplyAlpha: "none",
            colorSpaceConversion: "none"
          });
        return new Promise((A, t) => {
          g.decode()
            .then((i) => {
              if (!i.complete) return void t("Incomplete image");
              const n = i.image,
                o = n.displayWidth,
                a = n.displayHeight;
              if (o !== s.width || a !== s.height)
                return void t(`Size mismatch. Expected: ${s.width}x${s.height}, found: ${o}x${a}`);
              let g = null;
              if (
                ("I420" === n.format ? (g = xr.I420) : "I444" === n.format && (g = xr.I444),
                g !== this.format)
              )
                return void t(`Format mismatch. Expected: ${this.format}, found: ${n.format}`);
              const c = n.allocationSize();
              c === e[1]
                ? n
                    .copyTo(r)
                    .then((e) => A())
                    .catch((A) => t(A))
                    .finally(() => n.close())
                : t(`Allocation mismatch. Expected: ${e[1]}, found: ${c}`);
            })
            .catch((A) => t(A))
            .finally(() => g.close());
        });
      });
    Promise.all(g)
      .then((e) => {
        if (((A.discard = !this.startFlag), A.discard))
          throw new Error("Trying to push a tile when the decoder is stopped");
        (A.pixelFormat = this.format),
          (A.renderMethod = xr.TILELIST),
          (A.layerType = this.layerType),
          (A.buffer = s),
          (A.isRgb = !1),
          (A.isBt601 = !0),
          (A.isFullRange = !0);
      })
      .catch((A) => {
        this.log.debug(A), s.release();
      })
      .finally(() => {
        (A.data = null), this.onFrameDecoded(A);
      });
  }),
  (PI.prototype.decodeRect = function (A) {
    const e = new window.ImageDecoder({
      type: "image/jpeg",
      data: A.data,
      premultiplyAlpha: "none",
      colorSpaceConversion: "none"
    });
    new Promise((t, i) => {
      e.decode()
        .then((e) => {
          if (!e.complete) return void i("Incomplete image");
          const n = e.image,
            o = n.displayWidth,
            r = n.displayHeight;
          if (o !== A.rect.width || r !== A.rect.height)
            return void i(
              `Size mismatch. Expected: ${A.rect.width}x${A.rect.height}, found: ${o}x${r}`
            );
          let s = null;
          if (
            ("I420" === n.format ? (s = xr.I420) : "I444" === n.format && (s = xr.I444),
            s !== this.format)
          )
            return void i(`Format mismatch. Expected: ${this.format}, found: ${n.format}`);
          const a = n.allocationSize(),
            g = s === xr.I444 ? 0 : 1,
            c = (3 * A.rect.width * A.rect.height) >> g;
          if (a !== c) return void i(`Allocation mismatch. Expected: ${c}, found: ${a}`);
          const I = new Uint8Array(a);
          n.copyTo(I)
            .then((A) => t(I))
            .catch((A) => i(A))
            .finally(() => n.close());
        })
        .catch((A) => i(A))
        .finally(() => e.close());
    })
      .then((e) => {
        if (((A.discard = !this.startFlag), !this.startFlag))
          throw new Error("Trying to push a tile when the decoder is stopped");
        (A.pixelFormat = this.format),
          (A.renderMethod = xr.TILELIST),
          (A.layerType = this.layerType),
          (A.buffer = new yI(e)),
          (A.width = A.rect.width),
          (A.height = A.rect.height),
          (A.isRgb = !1),
          (A.isBt601 = !0),
          (A.isFullRange = !0);
      })
      .catch((A) => this.log.debug(A))
      .finally(() => {
        (A.data = null), this.onFrameDecoded(A);
      });
  }),
  (PI.prototype.decode = function (A) {
    null === A.rect ? this.decodeGroup(A) : this.decodeRect(A);
  }),
  (PI.prototype.start = function (A) {
    (this.startFlag = !0), this.log.debug("Web image decoder started");
  }),
  (PI.prototype.stop = function () {
    (this.startFlag = !1), this.log.debug("Web image decoder stopped");
  }),
  (GI.prototype = Object.create(pI.prototype)),
  (GI.prototype.constructor = GI),
  (GI.codecName = "lz4"),
  (GI.capabilities = ["codec_lossless", "codec_tiles_group", "codec_tiles"]),
  (GI.prototype.getConfig = function () {
    const A = {};
    return (
      (A.decoder = xr.LZ4),
      this.isRgb ? (A.pixelFormat = xr.RGB) : (A.pixelFormat = xr.NV12),
      (A.renderMethod = xr.TILELIST),
      A
    );
  }),
  (GI.prototype.getMinimumPoolSize = function (A, e) {
    if (!this.usingWebGLDecoder) return 0;
    return (3 * A * e) >> (this.isRgb ? 0 : 1);
  }),
  (GI.prototype.decode = function (A) {
    this.log.debug(`Decoding LZ4 tile of frame ${A.frameId}`);
    const e = A.data;
    if (((A.data = null), this.tiles.push(A), null === A.rect)) {
      const t = this.isRgb ? 0 : 1,
        i = A.clip.length,
        n = new Uint32Array(4 * i);
      let o = 0;
      A.clip.forEach((e, i, r) => {
        const s = A.units[i],
          a = (3 * e.width * e.height) >> t;
        n.set([s.offset, s.size, o, a], 4 * i), (o += a);
      }),
        (A.buffer = this.pool.peek(o));
      const r = n.buffer,
        s = A.buffer.toBuffer();
      this.lz4Worker.postMessage({ type: "frame", clips: r, output: s, frame: e, maxSize: o }, [
        r,
        s,
        e
      ]);
    } else
      this.lz4Worker.postMessage(
        {
          type: "frame",
          width: A.rect.width,
          height: A.rect.height,
          x: A.rect.x,
          y: A.rect.y,
          isRgb: this.isRgb,
          usingWebGLDecoder: this.usingWebGLDecoder,
          frame: e
        },
        [e]
      );
    this.pictureCount++,
      this.pictureCount % 100 == 0 && this.lz4Worker.postMessage({ type: "stats" });
  }),
  (GI.prototype.start = function (A) {
    (this.startFlag = !0),
      (this.usingWebGLDecoder = A.webGLEnable),
      this.log.debug("LZ4 decoder started");
  }),
  (GI.prototype.stop = function (A = !1) {
    (this.startFlag = !1),
      A && (this.lz4Worker.postMessage({ type: "close" }), (this.lz4Worker = null)),
      this.log.debug("LZ4 decoder stopped");
  });
const jI = { width: 4096, height: 2160 },
  WI = { major: 1, minor: 9 },
  VI = vr.display,
  _I = (A) => Do(VI.ClientMessage, A);
function XI() {
  const A = js(this.clientConnectionId).getDataChannel(Ia.INPUT);
  A && A.getInput().addListeners();
}
function zI() {
  let A = js(this.clientConnectionId).getDataChannel(Ia.INPUT);
  A && A.getInput().applyCachedCursorForDisplay();
}
function ZI(A) {
  return A.rect.width > jI.width || A.rect.height > jI.height;
}
function $I(A, e) {
  let t, i, n, o;
  switch (A.msg) {
    case "handshakeStart":
      this.log.info(`Start display negotiation (${A.handshakeStart.negotiationId})`),
        (this.negotiationId = A.handshakeStart.negotiationId),
        (this.applyLayoutPendingRequest = !0),
        il.call(this);
      break;
    case "displayLayout":
      this.log.info(`Display Layout: ${JSON.stringify(A.displayLayout.displayHeads)}`),
        (n = A.displayLayout.displayHeads.some(ZI)),
        (o =
          !this.pendingLayout ||
          (function (A, e) {
            let t,
              i,
              n = [],
              o = !0;
            return (
              A.length !== e.length
                ? (o = !1)
                : (e.forEach((A) => {
                    n.push(A);
                  }),
                  A.forEach((A) => {
                    (t = !1),
                      (i = 0),
                      o &&
                        n.forEach((e) => {
                          e &&
                            !t &&
                            A.width === e.width &&
                            A.height === e.height &&
                            ((t = !0), (n[i] = null)),
                            i++;
                        }),
                      t || (o = !1);
                  })),
              o
            );
          })(el.call(this, this.pendingLayout), A.displayLayout.displayHeads)),
        this.applyLayoutPendingRequest &&
          this.displaymanager.isResizeEnabled() &&
          !o &&
          (this.sendDisplayLayoutMulti(this.pendingLayout), (this.applyLayoutPendingRequest = !1)),
        o && (this.pendingLayout = null),
        n && !this.displaymanager.isResizeEnabled()
          ? this.log.warn(
              "Display resolution is larger than the maximum supported one and client resize is disabled. Please change either."
            )
          : (this.displaymanager.setLayout(A.displayLayout.displayHeads),
            (this.currentNumHeads = A.displayLayout.displayHeads.length),
            this.updateMaxDisplayNumber()),
        (this.currentLayout = A.displayLayout.displayHeads.map((A) => [
          A.rect.width,
          A.rect.height
        ])),
        (this.resizePool = !0);
      break;
    case "displayLayoutCapabilities":
      {
        const e = {
          maxHeadResolution: { width: 0, height: 0 },
          webClientMaxHeadResolution: { width: 0, height: 0 },
          minHeadResolution: { width: 1, height: 1 }
        };
        this.log.info(
          `Display Layout Capabilities: ${JSON.stringify(A.displayLayoutCapabilities)}`
        ),
          this.displaymanager.enableResize(A.displayLayoutCapabilities.supportClientResize),
          A.displayLayoutCapabilities.maxHeadResolution &&
            (e.maxHeadResolution = {
              width: A.displayLayoutCapabilities.maxHeadResolution.width || 0,
              height: A.displayLayoutCapabilities.maxHeadResolution.height || 0
            }),
          A.displayLayoutCapabilities.webClientMaxHeadResolution &&
            (e.webClientMaxHeadResolution = {
              width: A.displayLayoutCapabilities.webClientMaxHeadResolution.width || 0,
              height: A.displayLayoutCapabilities.webClientMaxHeadResolution.height || 0
            }),
          A.displayLayoutCapabilities.minHeadResolution &&
            (e.minHeadResolution = {
              width: A.displayLayoutCapabilities.minHeadResolution.width || 1,
              height: A.displayLayoutCapabilities.minHeadResolution.height || 1
            }),
          (this.serverLayoutLimits = {
            maxDisplayWidth: e.maxHeadResolution.width,
            maxDisplayHeight: e.maxHeadResolution.height,
            webMaxDisplayWidth:
              e.maxHeadResolution.width && e.webClientMaxHeadResolution.width
                ? Math.min(e.webClientMaxHeadResolution.width, e.maxHeadResolution.width)
                : Math.max(e.webClientMaxHeadResolution.width, e.maxHeadResolution.width),
            webMaxDisplayHeight:
              e.maxHeadResolution.height && e.webClientMaxHeadResolution.height
                ? Math.min(e.webClientMaxHeadResolution.height, e.maxHeadResolution.height)
                : Math.max(e.webClientMaxHeadResolution.height, e.maxHeadResolution.height),
            minDisplayWidth: e.minHeadResolution.width,
            minDisplayHeight: e.minHeadResolution.height,
            maxHeads: A.displayLayoutCapabilities.maxHeads || 2
          }),
          this.updateMaxDisplayNumber();
      }
      break;
    case "serverCodecs":
      if (
        (this.log.info(`Server Codecs: ${JSON.stringify(A.serverCodecs.codecs)}`),
        (this.requestedDisplayConfig = null),
        (this.highColorAccuracy = A.serverCodecs.codecs.every((A) =>
          A.capabilities.every((A) => !A.includes("subsamp_") || "subsamp_444" === A)
        )),
        (this.tileGroupProcessingSupported =
          this.tileGroupProcessingSupported &&
          A.serverCodecs.codecs.some((A) => A.capabilities.some((A) => A.includes("tiles_group")))),
        (i = Ws(this.clientConnectionId)),
        i.update("high-color-accuracy", {
          enabled: this.highColorAccuracy,
          available: this.highColorAccuracyAvailable
        }),
        this.ready || (this.decoderInfos = {}),
        A.serverCodecs.codecs.forEach(function (A, e) {
          this.decoderInfos[A.id] = { name: A.name, capabilities: A.capabilities };
        }, this),
        this.ready || nl.call(this),
        null !== this.pendingDisplayConfig)
      ) {
        const A = this.pendingDisplayConfig;
        (this.pendingDisplayConfig = null), ol.call(this, A);
      }
      break;
    case "streamStart":
      this.log.info(`Start stream ${A.streamStart.streamId} with codec ${A.streamStart.codecId}`),
        al.call(this, A.streamStart.streamId, A.streamStart.codecId, A.streamStart.layer);
      break;
    case "streamEnd":
      this.log.info(`End stream ${A.streamEnd.streamId}`), gl.call(this, A.streamEnd.streamId);
      break;
    case "swap":
      this.log.debugIf(() => `Server swap for frame ${A.swap.frameIndex}`),
        this.displaymanager.swap(
          $c.fromNumber(A.swap.frameIndex),
          $c.fromNumber(A.swap.sendTimestamp).toNumber() / 1e3
        );
      break;
    case "tileUpdate":
      if (
        (this.log.debugIf(
          () =>
            `Server Tile for stream ${A.tileUpdate.streamId}, frame ${A.tileUpdate.frameIndex} (${A.tileUpdate.rect.x}, ${A.tileUpdate.rect.y} ${A.tileUpdate.rect.width}x${A.tileUpdate.rect.height})`
        ),
        ZI(A.tileUpdate))
      )
        this.log.warn(
          `Ignoring tile update. Resolution ${JSON.stringify({ width: A.tileUpdate.rect.width, height: A.tileUpdate.rect.height })} larger than the supported one: ${JSON.stringify(jI)}. Please reduce resolution.`
        ),
          this.displaymanager.pushVoidTile(A.tileUpdate.frameIndex);
      else if (A.tileUpdate.streamId in this.streamInfos) {
        if (null === this.streamInfos[A.tileUpdate.streamId].associatedDisplay) {
          if (!sl.call(this, A.tileUpdate, this.streamInfos, this.decoders)) {
            this.log.debug(
              `No display available for tile update for known stream ${A.tileUpdate.streamId}`
            ),
              this.displaymanager.pushVoidTile(A.tileUpdate.frameIndex);
            break;
          }
          this.resizePool = !0;
        }
        if (this.resizePool) {
          const A = Object.values(this.decoders),
            e = this.currentLayout.reduce((e, t) => {
              const [i, n] = t,
                o = A.reduce((A, e) => Math.max(A, e.getMinimumPoolSize(i, n)), 0);
              return Math.max(e, o);
            }, 0);
          this.pool.resize(e), (this.resizePool = !1);
        }
        if (!Ao(A.tileUpdate.tileUnits) && A.tileUpdate.tileUnits.length > 0)
          if (A.tileUpdate.clipRegion.length === A.tileUpdate.tileUnits.length)
            if (this.tileGroupProcessingSupported)
              this.displaymanager.pushPendingTile(
                A.tileUpdate.frameIndex,
                !rl(this.streamInfos[A.tileUpdate.streamId])
              ),
                this.decoders[A.tileUpdate.streamId].decode({
                  frameId: A.tileUpdate.frameIndex,
                  rect: null,
                  clip: A.tileUpdate.clipRegion,
                  units: A.tileUpdate.tileUnits,
                  displayId: this.streamInfos[A.tileUpdate.streamId].associatedDisplay.id,
                  data: e
                });
            else
              for (let t = 0; t < A.tileUpdate.clipRegion.length; t++)
                this.displaymanager.pushPendingTile(
                  A.tileUpdate.frameIndex,
                  !rl(this.streamInfos[A.tileUpdate.streamId])
                ),
                  this.decoders[A.tileUpdate.streamId].decode({
                    frameId: A.tileUpdate.frameIndex,
                    rect: A.tileUpdate.clipRegion[t],
                    clip: [],
                    displayId: this.streamInfos[A.tileUpdate.streamId].associatedDisplay.id,
                    data: e.slice(
                      A.tileUpdate.tileUnits[t].offset,
                      A.tileUpdate.tileUnits[t].offset + A.tileUpdate.tileUnits[t].size
                    )
                  });
          else
            this.log.warn(
              `Ignoring tiles group update since clip regions and tile units do not match ${A.tileUpdate.frameIndex}`
            ),
              this.displaymanager.pushVoidTile(A.tileUpdate.frameIndex);
        else
          (t = A.tileUpdate.rect),
            (t.x -= this.streamInfos[A.tileUpdate.streamId].associatedDisplay.xOffset),
            (t.y -= this.streamInfos[A.tileUpdate.streamId].associatedDisplay.yOffset),
            this.displaymanager.pushPendingTile(
              A.tileUpdate.frameIndex,
              !rl(this.streamInfos[A.tileUpdate.streamId])
            ),
            this.decoders[A.tileUpdate.streamId].decode({
              frameId: A.tileUpdate.frameIndex,
              rect: t,
              clip: A.tileUpdate.clipRegion,
              displayId: this.streamInfos[A.tileUpdate.streamId].associatedDisplay.id,
              data: e
            });
      } else
        this.log.info(`Ignoring tile update for unknown stream ${A.tileUpdate.streamId}`),
          this.displaymanager.pushVoidTile(A.tileUpdate.frameIndex);
      break;
    case "tileMove":
      this.log.warn("Server Tile Move currently not supported");
      break;
    case "ping":
      dl.call(this, A);
      break;
    case "screenshotResult":
      if (
        (this.log.info(`Received screenshot result ${A.screenshotResult.status}`),
        null === this.screenshotCallback)
      ) {
        this.log.info("Received screenshot but screenshot observer is not provided");
        break;
      }
      A.screenshotResult.status !== VI.ScreenshotResult.StatusCode.OK
        ? (this.log.warn("Screenshot request failed"), this.screenshotCallback(null))
        : this.screenshotCallback(e),
        (this.screenshotRequested = !1);
      break;
    case "statusUpdate":
      switch (((i = Ws(this.clientConnectionId)), A.statusUpdate.displayService)) {
        case VI.DisplayService.SCREENSHOT:
          (this.screenshotActive = A.statusUpdate.displayStatus !== VI.Status.NOT_AVAILABLE),
            this.log.info(
              "Status for screenshot service received from server: " +
                (this.screenshotActive ? "active" : "unavailable")
            ),
            i.update("screenshot", { enabled: this.screenshotActive });
        case VI.DisplayService.WINDOW_TRACKING:
      }
      break;
    case "seamlessData":
    case "seamlessServerCommand":
      this.log.debug(`Ignored display message: ${A.msg}`);
      break;
    default:
      this.log.warn(`Unknown display message: ${A.msg}`);
  }
}
function Al(A, e) {
  this.transport.sendMessage(_I({ tileAck: { codecFrameId: e, streamId: A, negative: !0 } }));
}
function el(A) {
  let e = 0,
    t = [];
  return (
    A.forEach((A) => {
      if (A) {
        let i = A.rect.width || 0,
          n = A.rect.height || 0;
        [i, n] = this.displaymanager.convertHeadToPhysical(A, i, n);
        let o = Math.max(this.currentLayoutSettings.minDisplayWidth, i),
          r = Math.max(this.currentLayoutSettings.minDisplayHeight, n),
          s = this.getMaxHeadResolution();
        (o = s.maxWidth ? Math.min(o, s.maxWidth) : o),
          (r = s.maxHeight ? Math.min(r, s.maxHeight) : r),
          t.push({
            name: A.name,
            rect: { x: e, y: A.rect.y, width: o, height: r },
            primary: A.primary
          }),
          (i < this.currentLayoutSettings.minDisplayWidth ||
            n < this.currentLayoutSettings.minDisplayHeight) &&
            this.log.warn(
              `Display request (${i}x${n}) got capped since a larger minimum resolution is set`
            ),
          ((this.currentLayoutSettings.maxDisplayWidth &&
            i > this.currentLayoutSettings.maxDisplayWidth) ||
            (this.currentLayoutSettings.maxDisplayHeight &&
              n > this.currentLayoutSettings.maxDisplayHeight)) &&
            this.log.warn(
              `Display request is larger than maximum display resolution (${this.currentLayoutSettings.maxDisplayWidth}x${this.currentLayoutSettings.maxDisplayHeight}), it will be capped by the server`
            ),
          (e += o);
      }
    }),
    t
  );
}
function tl() {
  this.log.info("Resetting display channel"),
    this.decoders &&
      Object.keys(this.decoders).forEach((A) => {
        this.decoders[A].stop();
      }),
    this.streamInfos &&
      Object.keys(this.streamInfos).forEach((A) => {
        this.streamInfos[A].associatedDisplay &&
          this.streamInfos[A].associatedDisplay.stopRenderingLayer(this.streamInfos[A].layerType);
      }),
    (this.decoderInfos = {}),
    (this.decoders = {}),
    (this.streamInfos = {}),
    this.displaymanager.resetFrameQueue(),
    null === this.requestedDisplayConfig &&
      (this.requestedDisplayConfig = {
        highColorAccuracy:
          null !== this.highColorAccuracy ? this.highColorAccuracy : this.config.highColorAccuracy
      }),
    (this.ready = !1);
}
function il() {
  tl.call(this), this.log.info("Start"), Il.call(this);
}
function nl() {
  ll.call(this),
    (this.ready = !0),
    this.currentQualityUpdatesSetting &&
      this.enableQualityUpdates(1 === this.currentQualityUpdatesSetting),
    this.currentQuality && this.setQuality(this.currentQuality.min, this.currentQuality.max),
    this.currentLayoutSettings &&
      (this.setLayoutSettings(
        this.currentLayoutSettings.maxDisplayWidth,
        this.currentLayoutSettings.maxDisplayHeight,
        this.currentLayoutSettings.maxDisplayNumber
      ),
      this.updateMaxDisplayNumber()),
    this.pendingLayout && this.sendDisplayLayoutMulti(this.pendingLayout);
}
function ol(A) {
  return (
    !(!this.ready || !this.highColorAccuracyAvailable) &&
    (null !== this.requestedDisplayConfig
      ? (this.requestedDisplayConfig.highColorAccuracy === A.highColorAccuracy
          ? (this.pendingDisplayConfig = null)
          : (this.pendingDisplayConfig = A),
        !0)
      : (this.highColorAccuracy === A.highColorAccuracy ||
          ((this.requestedDisplayConfig = A), (this.sendCodecsRequested = !0), cl.call(this)),
        !0))
  );
}
function rl(A) {
  return A.layerType === VI.StreamStart.Layer.QUALITY_UPDATE;
}
function sl(A, e, t) {
  let i,
    n,
    o = A.streamId,
    r = e[o].layerType;
  return (
    (n = this.displaymanager.getDisplayFromTile(A)),
    null !== n &&
      (n.paused && to(this.protocolVersion, { major: 1, minor: 3 }) && this.sendPause(n.name),
      (e[o].associatedDisplay = n),
      (i = t[o]),
      (i.onFrameDecoded = this.displaymanager.pushDecodedTile.bind(this.displaymanager)),
      (i.onLostContext = function (A) {
        Al.call(this, o, A);
      }.bind(this)),
      (i.layerType = r),
      n.startRenderingLayer(r, i.getConfig()),
      i.start({ webGLEnable: n.isWebGLRendering() }),
      this.log.info(
        `Stream ${A.streamId} associated to display ${e[o].associatedDisplay.name}(id: ${e[o].associatedDisplay.id})`
      ),
      !0)
  );
}
function al(A, e, t) {
  let i;
  A in this.decoders
    ? this.log.warn(`Stream ${A} was already started`)
    : e in this.decoderInfos
      ? (this.log.info(
          `Creating decoder for codec ${this.decoderInfos[e].name} (id: ${e}, layer: ${t})`
        ),
        (i = (function (A, e, t, i, n, o, r) {
          if (A in e.parked) {
            const t = e.parked[A].pop();
            if ((0 === e.parked[A].length && delete e.parked[A], t))
              return HI.info(`Recycling previous decoder for codec ${A}`), t;
          }
          return A in e ? new e[A](t, i, n, o, r) : null;
        })(
          this.decoderInfos[e].name,
          this.decoderConstructors,
          this.baseUrl,
          this.decoderInfos[e].capabilities,
          this.pool,
          null,
          this.clientConnectionId
        )),
        i &&
          ((this.decoders[A] = i),
          (this.streamInfos[A] = { layerType: t, associatedDisplay: null }),
          this.log.info(
            `Created decoder for codec ${this.decoderInfos[e].name} (id: ${e}, layer: ${t})`
          )))
      : this.log.warn(`Stream ${A} is requesting the unknown codec ${e}`);
}
function gl(A, e = !1) {
  if (A in this.decoders) {
    if (
      (this.streamInfos[A].associatedDisplay &&
        this.streamInfos[A].associatedDisplay.stopRenderingLayer(this.streamInfos[A].layerType),
      this.decoders[A].stop(e),
      "lz4" === this.decoders[A].name)
    )
      if (e) {
        if (this.decoderConstructors.parked.lz4) {
          for (const A of this.decoderConstructors.parked.lz4) A.stop(e);
          delete this.decoderConstructors.parked.lz4;
        }
      } else
        this.decoderConstructors.parked.lz4 || (this.decoderConstructors.parked.lz4 = []),
          this.decoderConstructors.parked.lz4.push(this.decoders[A]);
    delete this.decoders[A], delete this.streamInfos[A];
  } else this.log.warn(`Cannot end unknown stream ${A}`);
}
function cl() {
  if (!this.codecsReady || !this.sendCodecsRequested) return;
  this.sendCodecsRequested = !1;
  const A = (function (A) {
      const e = [];
      return (
        Object.keys(A).forEach((t) => {
          "parked" !== t && e.push({ name: t, capabilities: A[t].capabilities });
        }),
        e
      );
    })(this.decoderConstructors),
    e = !this.highColorAccuracyAvailable || !this.requestedDisplayConfig.highColorAccuracy;
  to(this.protocolVersion, { major: 1, minor: 6 }) ||
    A.forEach((A) => {
      const e = A.capabilities;
      A.capabilities = e.filter((A) => "colorrange_full" !== A);
    }),
    e &&
      A.forEach((A) => {
        const e = A.capabilities;
        A.capabilities = e.filter((A) => "subsamp_444" !== A);
      }),
    this.negotiationId || this.log.warn("Sending client codecs without negotiation id"),
    this.log.info(`Sending client codecs: ${JSON.stringify(A)}`),
    this.transport.sendMessage(
      _I({ clientCodecs: { codecs: A, negotiationId: this.negotiationId } })
    );
}
function Il() {
  (this.sendCodecsRequested = !0), cl.call(this);
}
function ll() {
  this.negotiationId || this.log.warn("Sending client ready without negotiation id"),
    this.log.info("Sending client ready"),
    this.transport.sendMessage(_I({ ready: { negotiationId: this.negotiationId } }));
}
function dl(A) {
  this.transport.sendMessage(_I({ pong: { pingTimestamp: A.ping.pingTimestamp } }));
}
const ul = Fo.exports.Reader,
  Cl = Fo.exports.Writer,
  Bl = Fo.exports.util,
  Ql = Fo.exports.roots["dcv.clipboard"] || (Fo.exports.roots["dcv.clipboard"] = {}),
  El = (Ql.dcv = (() => {
    const A = {};
    return (
      (A.clipboard = (function () {
        const A = {};
        return (
          (A.HandshakeStart = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.negotiationId = Bl.Long ? Bl.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Cl.create()),
                  null != A.negotiationId &&
                    Object.hasOwnProperty.call(A, "negotiationId") &&
                    e.uint32(8).uint64(A.negotiationId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.HandshakeStart();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.negotiationId = A.uint64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.negotiationId &&
                      A.hasOwnProperty("negotiationId") &&
                      !(
                        Bl.isInteger(A.negotiationId) ||
                        (A.negotiationId &&
                          Bl.isInteger(A.negotiationId.low) &&
                          Bl.isInteger(A.negotiationId.high))
                      )
                    ? "negotiationId: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.HandshakeStart) return A;
                let e = new Ql.dcv.clipboard.HandshakeStart();
                return (
                  null != A.negotiationId &&
                    (Bl.Long
                      ? ((e.negotiationId = Bl.Long.fromValue(A.negotiationId)).unsigned = !0)
                      : "string" == typeof A.negotiationId
                        ? (e.negotiationId = parseInt(A.negotiationId, 10))
                        : "number" == typeof A.negotiationId
                          ? (e.negotiationId = A.negotiationId)
                          : "object" == typeof A.negotiationId &&
                            (e.negotiationId = new Bl.LongBits(
                              A.negotiationId.low >>> 0,
                              A.negotiationId.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (Bl.Long) {
                    let A = new Bl.Long(0, 0, !0);
                    t.negotiationId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.negotiationId = e.longs === String ? "0" : 0;
                return (
                  null != A.negotiationId &&
                    A.hasOwnProperty("negotiationId") &&
                    ("number" == typeof A.negotiationId
                      ? (t.negotiationId =
                          e.longs === String ? String(A.negotiationId) : A.negotiationId)
                      : (t.negotiationId =
                          e.longs === String
                            ? Bl.Long.prototype.toString.call(A.negotiationId)
                            : e.longs === Number
                              ? new Bl.LongBits(
                                  A.negotiationId.low >>> 0,
                                  A.negotiationId.high >>> 0
                                ).toNumber(!0)
                              : A.negotiationId)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.HandshakeStart"
                );
              }),
              A
            );
          })()),
          (A.SupportedTargets = (function () {
            function A(A) {
              if (((this.reading = []), (this.writing = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.reading = Bl.emptyArray),
              (A.prototype.writing = Bl.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Cl.create()), null != A.reading && A.reading.length))
                  for (let t = 0; t < A.reading.length; ++t) e.uint32(10).string(A.reading[t]);
                if (null != A.writing && A.writing.length)
                  for (let t = 0; t < A.writing.length; ++t) e.uint32(18).string(A.writing[t]);
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.SupportedTargets();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      (i.reading && i.reading.length) || (i.reading = []),
                        i.reading.push(A.string());
                      break;
                    case 2:
                      (i.writing && i.writing.length) || (i.writing = []),
                        i.writing.push(A.string());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.reading && A.hasOwnProperty("reading")) {
                  if (!Array.isArray(A.reading)) return "reading: array expected";
                  for (let e = 0; e < A.reading.length; ++e)
                    if (!Bl.isString(A.reading[e])) return "reading: string[] expected";
                }
                if (null != A.writing && A.hasOwnProperty("writing")) {
                  if (!Array.isArray(A.writing)) return "writing: array expected";
                  for (let e = 0; e < A.writing.length; ++e)
                    if (!Bl.isString(A.writing[e])) return "writing: string[] expected";
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.SupportedTargets) return A;
                let e = new Ql.dcv.clipboard.SupportedTargets();
                if (A.reading) {
                  if (!Array.isArray(A.reading))
                    throw TypeError(".dcv.clipboard.SupportedTargets.reading: array expected");
                  e.reading = [];
                  for (let t = 0; t < A.reading.length; ++t) e.reading[t] = String(A.reading[t]);
                }
                if (A.writing) {
                  if (!Array.isArray(A.writing))
                    throw TypeError(".dcv.clipboard.SupportedTargets.writing: array expected");
                  e.writing = [];
                  for (let t = 0; t < A.writing.length; ++t) e.writing[t] = String(A.writing[t]);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && ((t.reading = []), (t.writing = [])),
                  A.reading && A.reading.length)
                ) {
                  t.reading = [];
                  for (let e = 0; e < A.reading.length; ++e) t.reading[e] = A.reading[e];
                }
                if (A.writing && A.writing.length) {
                  t.writing = [];
                  for (let e = 0; e < A.writing.length; ++e) t.writing[e] = A.writing[e];
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.SupportedTargets"
                );
              }),
              A
            );
          })()),
          (A.UpdateEvent = (function () {
            function A(A) {
              if (((this.targets = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.targets = Bl.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Cl.create()), null != A.targets && A.targets.length))
                  for (let t = 0; t < A.targets.length; ++t) e.uint32(10).string(A.targets[t]);
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.UpdateEvent();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    (i.targets && i.targets.length) || (i.targets = []), i.targets.push(A.string());
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.targets && A.hasOwnProperty("targets")) {
                  if (!Array.isArray(A.targets)) return "targets: array expected";
                  for (let e = 0; e < A.targets.length; ++e)
                    if (!Bl.isString(A.targets[e])) return "targets: string[] expected";
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.UpdateEvent) return A;
                let e = new Ql.dcv.clipboard.UpdateEvent();
                if (A.targets) {
                  if (!Array.isArray(A.targets))
                    throw TypeError(".dcv.clipboard.UpdateEvent.targets: array expected");
                  e.targets = [];
                  for (let t = 0; t < A.targets.length; ++t) e.targets[t] = String(A.targets[t]);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.targets = []), A.targets && A.targets.length)) {
                  t.targets = [];
                  for (let e = 0; e < A.targets.length; ++e) t.targets[e] = A.targets[e];
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.UpdateEvent"
                );
              }),
              A
            );
          })()),
          (A.RequestData = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.target = ""),
              (A.prototype.id = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Cl.create()),
                  null != A.target &&
                    Object.hasOwnProperty.call(A, "target") &&
                    e.uint32(10).string(A.target),
                  null != A.id && Object.hasOwnProperty.call(A, "id") && e.uint32(16).uint32(A.id),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.RequestData();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.target = A.string();
                      break;
                    case 2:
                      i.id = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.target && A.hasOwnProperty("target") && !Bl.isString(A.target)
                    ? "target: string expected"
                    : null != A.id && A.hasOwnProperty("id") && !Bl.isInteger(A.id)
                      ? "id: integer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.RequestData) return A;
                let e = new Ql.dcv.clipboard.RequestData();
                return (
                  null != A.target && (e.target = String(A.target)),
                  null != A.id && (e.id = A.id >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.target = ""), (t.id = 0)),
                  null != A.target && A.hasOwnProperty("target") && (t.target = A.target),
                  null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.RequestData"
                );
              }),
              A
            );
          })()),
          (A.ClipboardData = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.target = ""),
              (A.prototype.id = 0),
              (A.prototype.error = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Cl.create()),
                  null != A.target &&
                    Object.hasOwnProperty.call(A, "target") &&
                    e.uint32(10).string(A.target),
                  null != A.id && Object.hasOwnProperty.call(A, "id") && e.uint32(16).uint32(A.id),
                  null != A.error &&
                    Object.hasOwnProperty.call(A, "error") &&
                    e.uint32(24).int32(A.error),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.ClipboardData();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.target = A.string();
                      break;
                    case 2:
                      i.id = A.uint32();
                      break;
                    case 3:
                      i.error = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.target && A.hasOwnProperty("target") && !Bl.isString(A.target))
                  return "target: string expected";
                if (null != A.id && A.hasOwnProperty("id") && !Bl.isInteger(A.id))
                  return "id: integer expected";
                if (null != A.error && A.hasOwnProperty("error"))
                  switch (A.error) {
                    default:
                      return "error: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.ClipboardData) return A;
                let e = new Ql.dcv.clipboard.ClipboardData();
                switch (
                  (null != A.target && (e.target = String(A.target)),
                  null != A.id && (e.id = A.id >>> 0),
                  A.error)
                ) {
                  default:
                    if ("number" == typeof A.error) {
                      e.error = A.error;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.error = 0;
                    break;
                  case "GENERIC":
                  case 1:
                    e.error = 1;
                    break;
                  case "EMPTY_CLIPBOARD":
                  case 2:
                    e.error = 2;
                    break;
                  case "CONVERSION_ERROR":
                  case 3:
                    e.error = 3;
                    break;
                  case "DATA_EXCEEDS_LIMIT":
                  case 4:
                    e.error = 4;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.target = ""), (t.id = 0), (t.error = e.enums === String ? "NONE" : 0)),
                  null != A.target && A.hasOwnProperty("target") && (t.target = A.target),
                  null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                  null != A.error &&
                    A.hasOwnProperty("error") &&
                    (t.error =
                      e.enums === String
                        ? void 0 === Ql.dcv.clipboard.ClipboardData.Error[A.error]
                          ? A.error
                          : Ql.dcv.clipboard.ClipboardData.Error[A.error]
                        : A.error),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.ClipboardData"
                );
              }),
              (A.Error = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "NONE")] = 0),
                  (e[(A[1] = "GENERIC")] = 1),
                  (e[(A[2] = "EMPTY_CLIPBOARD")] = 2),
                  (e[(A[3] = "CONVERSION_ERROR")] = 3),
                  (e[(A[4] = "DATA_EXCEEDS_LIMIT")] = 4),
                  e
                );
              })()),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.supportedTargets = null),
              (A.prototype.updateEvent = null),
              (A.prototype.requestData = null),
              (A.prototype.clipboardData = null),
              Object.defineProperty(A.prototype, "msg", {
                get: Bl.oneOfGetter(
                  (e = ["supportedTargets", "updateEvent", "requestData", "clipboardData"])
                ),
                set: Bl.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Cl.create()),
                  null != A.supportedTargets &&
                    Object.hasOwnProperty.call(A, "supportedTargets") &&
                    Ql.dcv.clipboard.SupportedTargets.encode(
                      A.supportedTargets,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.updateEvent &&
                    Object.hasOwnProperty.call(A, "updateEvent") &&
                    Ql.dcv.clipboard.UpdateEvent.encode(
                      A.updateEvent,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.requestData &&
                    Object.hasOwnProperty.call(A, "requestData") &&
                    Ql.dcv.clipboard.RequestData.encode(
                      A.requestData,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.clipboardData &&
                    Object.hasOwnProperty.call(A, "clipboardData") &&
                    Ql.dcv.clipboard.ClipboardData.encode(
                      A.clipboardData,
                      e.uint32(322).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.supportedTargets = Ql.dcv.clipboard.SupportedTargets.decode(A, A.uint32());
                      break;
                    case 20:
                      i.updateEvent = Ql.dcv.clipboard.UpdateEvent.decode(A, A.uint32());
                      break;
                    case 30:
                      i.requestData = Ql.dcv.clipboard.RequestData.decode(A, A.uint32());
                      break;
                    case 40:
                      i.clipboardData = Ql.dcv.clipboard.ClipboardData.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.supportedTargets && A.hasOwnProperty("supportedTargets")) {
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.SupportedTargets.verify(A.supportedTargets);
                    if (e) return "supportedTargets." + e;
                  }
                }
                if (null != A.updateEvent && A.hasOwnProperty("updateEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.UpdateEvent.verify(A.updateEvent);
                    if (e) return "updateEvent." + e;
                  }
                }
                if (null != A.requestData && A.hasOwnProperty("requestData")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.RequestData.verify(A.requestData);
                    if (e) return "requestData." + e;
                  }
                }
                if (null != A.clipboardData && A.hasOwnProperty("clipboardData")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.ClipboardData.verify(A.clipboardData);
                    if (e) return "clipboardData." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.ClientMessage) return A;
                let e = new Ql.dcv.clipboard.ClientMessage();
                if (null != A.supportedTargets) {
                  if ("object" != typeof A.supportedTargets)
                    throw TypeError(
                      ".dcv.clipboard.ClientMessage.supportedTargets: object expected"
                    );
                  e.supportedTargets = Ql.dcv.clipboard.SupportedTargets.fromObject(
                    A.supportedTargets
                  );
                }
                if (null != A.updateEvent) {
                  if ("object" != typeof A.updateEvent)
                    throw TypeError(".dcv.clipboard.ClientMessage.updateEvent: object expected");
                  e.updateEvent = Ql.dcv.clipboard.UpdateEvent.fromObject(A.updateEvent);
                }
                if (null != A.requestData) {
                  if ("object" != typeof A.requestData)
                    throw TypeError(".dcv.clipboard.ClientMessage.requestData: object expected");
                  e.requestData = Ql.dcv.clipboard.RequestData.fromObject(A.requestData);
                }
                if (null != A.clipboardData) {
                  if ("object" != typeof A.clipboardData)
                    throw TypeError(".dcv.clipboard.ClientMessage.clipboardData: object expected");
                  e.clipboardData = Ql.dcv.clipboard.ClipboardData.fromObject(A.clipboardData);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.supportedTargets &&
                    A.hasOwnProperty("supportedTargets") &&
                    ((t.supportedTargets = Ql.dcv.clipboard.SupportedTargets.toObject(
                      A.supportedTargets,
                      e
                    )),
                    e.oneofs && (t.msg = "supportedTargets")),
                  null != A.updateEvent &&
                    A.hasOwnProperty("updateEvent") &&
                    ((t.updateEvent = Ql.dcv.clipboard.UpdateEvent.toObject(A.updateEvent, e)),
                    e.oneofs && (t.msg = "updateEvent")),
                  null != A.requestData &&
                    A.hasOwnProperty("requestData") &&
                    ((t.requestData = Ql.dcv.clipboard.RequestData.toObject(A.requestData, e)),
                    e.oneofs && (t.msg = "requestData")),
                  null != A.clipboardData &&
                    A.hasOwnProperty("clipboardData") &&
                    ((t.clipboardData = Ql.dcv.clipboard.ClipboardData.toObject(
                      A.clipboardData,
                      e
                    )),
                    e.oneofs && (t.msg = "clipboardData")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.ClientMessage"
                );
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.handshakeStart = null),
              (A.prototype.supportedTargets = null),
              (A.prototype.updateEvent = null),
              (A.prototype.requestData = null),
              (A.prototype.clipboardData = null),
              Object.defineProperty(A.prototype, "msg", {
                get: Bl.oneOfGetter(
                  (e = [
                    "handshakeStart",
                    "supportedTargets",
                    "updateEvent",
                    "requestData",
                    "clipboardData"
                  ])
                ),
                set: Bl.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Cl.create()),
                  null != A.handshakeStart &&
                    Object.hasOwnProperty.call(A, "handshakeStart") &&
                    Ql.dcv.clipboard.HandshakeStart.encode(
                      A.handshakeStart,
                      e.uint32(10).fork()
                    ).ldelim(),
                  null != A.supportedTargets &&
                    Object.hasOwnProperty.call(A, "supportedTargets") &&
                    Ql.dcv.clipboard.SupportedTargets.encode(
                      A.supportedTargets,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.updateEvent &&
                    Object.hasOwnProperty.call(A, "updateEvent") &&
                    Ql.dcv.clipboard.UpdateEvent.encode(
                      A.updateEvent,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.requestData &&
                    Object.hasOwnProperty.call(A, "requestData") &&
                    Ql.dcv.clipboard.RequestData.encode(
                      A.requestData,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.clipboardData &&
                    Object.hasOwnProperty.call(A, "clipboardData") &&
                    Ql.dcv.clipboard.ClipboardData.encode(
                      A.clipboardData,
                      e.uint32(322).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof ul || (A = ul.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Ql.dcv.clipboard.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.handshakeStart = Ql.dcv.clipboard.HandshakeStart.decode(A, A.uint32());
                      break;
                    case 10:
                      i.supportedTargets = Ql.dcv.clipboard.SupportedTargets.decode(A, A.uint32());
                      break;
                    case 20:
                      i.updateEvent = Ql.dcv.clipboard.UpdateEvent.decode(A, A.uint32());
                      break;
                    case 30:
                      i.requestData = Ql.dcv.clipboard.RequestData.decode(A, A.uint32());
                      break;
                    case 40:
                      i.clipboardData = Ql.dcv.clipboard.ClipboardData.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof ul || (A = new ul(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.handshakeStart && A.hasOwnProperty("handshakeStart")) {
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.HandshakeStart.verify(A.handshakeStart);
                    if (e) return "handshakeStart." + e;
                  }
                }
                if (null != A.supportedTargets && A.hasOwnProperty("supportedTargets")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.SupportedTargets.verify(A.supportedTargets);
                    if (e) return "supportedTargets." + e;
                  }
                }
                if (null != A.updateEvent && A.hasOwnProperty("updateEvent")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.UpdateEvent.verify(A.updateEvent);
                    if (e) return "updateEvent." + e;
                  }
                }
                if (null != A.requestData && A.hasOwnProperty("requestData")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.RequestData.verify(A.requestData);
                    if (e) return "requestData." + e;
                  }
                }
                if (null != A.clipboardData && A.hasOwnProperty("clipboardData")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Ql.dcv.clipboard.ClipboardData.verify(A.clipboardData);
                    if (e) return "clipboardData." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Ql.dcv.clipboard.ServerMessage) return A;
                let e = new Ql.dcv.clipboard.ServerMessage();
                if (null != A.handshakeStart) {
                  if ("object" != typeof A.handshakeStart)
                    throw TypeError(".dcv.clipboard.ServerMessage.handshakeStart: object expected");
                  e.handshakeStart = Ql.dcv.clipboard.HandshakeStart.fromObject(A.handshakeStart);
                }
                if (null != A.supportedTargets) {
                  if ("object" != typeof A.supportedTargets)
                    throw TypeError(
                      ".dcv.clipboard.ServerMessage.supportedTargets: object expected"
                    );
                  e.supportedTargets = Ql.dcv.clipboard.SupportedTargets.fromObject(
                    A.supportedTargets
                  );
                }
                if (null != A.updateEvent) {
                  if ("object" != typeof A.updateEvent)
                    throw TypeError(".dcv.clipboard.ServerMessage.updateEvent: object expected");
                  e.updateEvent = Ql.dcv.clipboard.UpdateEvent.fromObject(A.updateEvent);
                }
                if (null != A.requestData) {
                  if ("object" != typeof A.requestData)
                    throw TypeError(".dcv.clipboard.ServerMessage.requestData: object expected");
                  e.requestData = Ql.dcv.clipboard.RequestData.fromObject(A.requestData);
                }
                if (null != A.clipboardData) {
                  if ("object" != typeof A.clipboardData)
                    throw TypeError(".dcv.clipboard.ServerMessage.clipboardData: object expected");
                  e.clipboardData = Ql.dcv.clipboard.ClipboardData.fromObject(A.clipboardData);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.handshakeStart &&
                    A.hasOwnProperty("handshakeStart") &&
                    ((t.handshakeStart = Ql.dcv.clipboard.HandshakeStart.toObject(
                      A.handshakeStart,
                      e
                    )),
                    e.oneofs && (t.msg = "handshakeStart")),
                  null != A.supportedTargets &&
                    A.hasOwnProperty("supportedTargets") &&
                    ((t.supportedTargets = Ql.dcv.clipboard.SupportedTargets.toObject(
                      A.supportedTargets,
                      e
                    )),
                    e.oneofs && (t.msg = "supportedTargets")),
                  null != A.updateEvent &&
                    A.hasOwnProperty("updateEvent") &&
                    ((t.updateEvent = Ql.dcv.clipboard.UpdateEvent.toObject(A.updateEvent, e)),
                    e.oneofs && (t.msg = "updateEvent")),
                  null != A.requestData &&
                    A.hasOwnProperty("requestData") &&
                    ((t.requestData = Ql.dcv.clipboard.RequestData.toObject(A.requestData, e)),
                    e.oneofs && (t.msg = "requestData")),
                  null != A.clipboardData &&
                    A.hasOwnProperty("clipboardData") &&
                    ((t.clipboardData = Ql.dcv.clipboard.ClipboardData.toObject(
                      A.clipboardData,
                      e
                    )),
                    e.oneofs && (t.msg = "clipboardData")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.clipboard.ServerMessage"
                );
              }),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  hl = 1048576,
  pl = 20;
function fl(A, e, t) {
  let i,
    n,
    o = Ol(t);
  if (((this.clientConnectionId = t), (this.log = Q("clipboard", this.clientConnectionId)), !o))
    throw new Error("No window to check");
  (i = o.document.queryCommandSupported("copy")),
    (n = o.dcvId),
    (this.remoteData = {}),
    (this.triggerEvent = null),
    (this.onNewLocalData = null),
    (this.isAutoCopyAvailable = !1),
    (this.pendingDataToSync = !1),
    (this.copyEnabled = !1),
    (this.pasteEnabled = !1),
    (this.syncListenersEnabled = !1),
    (this.asyncCopy = {}),
    (this.asyncPaste = {}),
    (this.hiddenInput = {}),
    (this.listeners = {}),
    (this.syncClipboardsHandler = Ml.bind(this)),
    (this.onInputSelectHiddenInput = yl.bind(this)),
    (this.keyBoardListener = Dl.bind(this)),
    (this.performAsyncPaste = Tl.bind(this)),
    (this.onCopy = wl.bind(this)),
    (this.onPaste = bl.bind(this)),
    Kl.call(this),
    this.log.info("Clibpoard copy autosync " + (i ? "available" : "not available")),
    this.log.debug(
      `Clibpoard autosync ${i ? "supported" : "not supported"} and client set it to ${e ? "enabled" : "disabled"}`
    ),
    (this.syncListenersEnabled = !1),
    (this.isAutoCopyAvailable = i && e),
    (this.triggerEvent = (e) => {
      this.log.info(`Notifying clipboard event (${e.name})`), Xn(A) && A(e);
    }),
    this.triggerEvent({
      name: "established",
      autoCopy: this.isAutoCopyAvailable || "granted" === this.asyncCopy[n],
      maxDataSize: pl
    }),
    (this.hiddenInput[n] = Gl(o.document));
}
function ml(A) {
  (this.hiddenInput[A].value = " "), this.hiddenInput[A].focus(), this.hiddenInput[A].select();
}
function yl() {
  const A = Ol(this.clientConnectionId);
  A && ml.call(this, A.dcvId);
}
function Dl(A) {
  if (A.ctrlKey)
    switch (A.keyCode) {
      case 67:
        Fl.call(this);
        break;
      case 86:
        Ul.call(this);
    }
}
function wl(A) {
  const e = A.clipboardData,
    t = Ol(this.clientConnectionId);
  t &&
    this.copyEnabled &&
    (this.getTargets().indexOf("text/plain") > -1 &&
      (this.log.info(`Clipboard onCopy event writing to clipboard: ${this.getTextData()}`),
      e.setData("text/plain", this.getTextData()),
      (this.pendingDataToSync = !1)),
    ml.call(this, t.dcvId),
    A.preventDefault(),
    this.triggerEvent({ name: "copy" }));
}
function Fl() {
  let A,
    e = Ol(this.clientConnectionId);
  e &&
    this.copyEnabled &&
    ((A = e.clipboardData),
    this.remoteData &&
      (this.getTargets().indexOf("text/plain") > -1 &&
        (A.setData("Text", this.getTextData()),
        ml.call(this, e.dcvId),
        (this.pendingDataToSync = !1)),
      this.triggerEvent({ name: "copy" })));
}
function bl(A) {
  let e,
    t = Ol(this.clientConnectionId);
  t &&
    this.pasteEnabled &&
    ((e = A.clipboardData.getData("text/plain")),
    Sl.call(this, e),
    ml.call(this, t.dcvId),
    A.preventDefault(),
    this.triggerEvent({ name: "paste" }));
}
function Ul() {
  let A, e;
  this.pasteEnabled &&
    ((A = window.clipboardData),
    (e = A.getData("Text")),
    Sl.call(this, e),
    this.triggerEvent({ name: "paste" }));
}
function Sl(A) {
  A && 0 !== A.length
    ? Rl.call(this, A) &&
      (this.log.info(`Clipboard onPaste event - data text of size ${A.length}`),
      this.addDataFromLocal({ "text/plain": A }))
    : (this.log.info("Clipboard onPaste event - clipboard empty"), this.clearFromLocal());
}
function Rl(A) {
  if (!A) return !0;
  const e = ro(A);
  return Ao(e)
    ? (this.log.debug(`Cannot get size of ${A} of type ${typeof A}`), !0)
    : (this.log.debug(`Checking clipboard data limits on data of size: ${e} and type: ${typeof A}`),
      !(e > pl * hl) ||
        (this.triggerEvent({ name: "dataSizeAlert" }),
        this.log.warn(
          "Warning: local data cannot be copied from remote because it exceeds clipboard data transfer limit."
        ),
        !1));
}
function vl() {
  let A,
    e = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  e &&
    ((A = e.getDisplayManager().getDisplayToWindowMap()),
    this.syncListenersEnabled && xl.call(this),
    this.pendingDataToSync &&
      (Object.values(A).forEach((A) => {
        A.document.addEventListener("keydown", this.syncClipboardsHandler),
          A.document.addEventListener("keyup", this.syncClipboardsHandler),
          A.document.addEventListener("mousedown", this.syncClipboardsHandler),
          A.document.addEventListener("mouseup", this.syncClipboardsHandler);
      }),
      (this.syncListenersEnabled = !0)));
}
function xl() {
  let A,
    e = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  this.syncListenersEnabled &&
    e &&
    ((A = e.getDisplayManager().getDisplayToWindowMap()),
    Object.values(A).forEach((A) => {
      A.document.removeEventListener("keydown", this.syncClipboardsHandler),
        A.document.removeEventListener("keyup", this.syncClipboardsHandler),
        A.document.removeEventListener("mousedown", this.syncClipboardsHandler),
        A.document.removeEventListener("mouseup", this.syncClipboardsHandler);
    }),
    (this.syncListenersEnabled = !1));
}
function Ml() {
  this.syncClipboards() &&
    (this.triggerEvent({ name: "autoCopyDone" }), (this.pendingDataToSync = !1)),
    xl.call(this);
}
function Ol(A, e) {
  if (Ao(e)) {
    const e = js(A).getDataChannel(Ia.DISPLAY);
    return e ? e.getDisplayManager().getActiveWindow() : window;
  }
  return e;
}
function kl(A) {
  const e = "clipboard-read";
  let t,
    i = Ol(this.clientConnectionId, A);
  i &&
    ((t = Ao(i.dcvId) ? 0 : i.dcvId),
    i.navigator.permissions
      .query({ name: e })
      .then((A) => {
        switch (
          (this.log.info(`Async API ${e} from ${this.asyncPaste[t]} to ${A.state}`), A.state)
        ) {
          case "granted":
          case "prompt":
            this.asyncPaste[t] ||
              (this.log.info(`Adding focus listener for ${e}`),
              i.document.addEventListener("focusin", this.performAsyncPaste),
              (A.onchange = () => kl.call(this, i))),
              (this.asyncPaste[t] = A.state);
            break;
          default:
            (this.asyncPaste[t] = null),
              i.document.removeEventListener("focusin", this.performAsyncPaste);
        }
      })
      .catch(() => {
        this.log.info(
          `This browser do not support Permission API for ${e}. Using classic clipboard.`
        );
      }));
}
function Nl(A) {
  const e = "clipboard-write";
  let t,
    i = Ol(this.clientConnectionId, A);
  i &&
    ((t = Ao(i.dcvId) ? 0 : i.dcvId),
    i.navigator.permissions
      .query({ name: e })
      .then((A) => {
        switch (
          (this.log.info(`Async API ${e} from ${this.asyncCopy[t]} to ${A.state}`), A.state)
        ) {
          case "granted":
          case "prompt":
            this.asyncCopy[t] ||
              (this.log.info(`Adding focus listener for ${e}`),
              (A.onchange = () => Nl.call(this, i))),
              (this.asyncCopy[t] = A.state);
            break;
          default:
            this.asyncCopy[t] = null;
        }
      })
      .catch(() => {
        this.log.info(
          `This browser does not support Permission API for ${e}. Using classic clipboard.`
        );
      }));
}
function Kl(A) {
  const e = Ol(this.clientConnectionId, A);
  e &&
    e.navigator.clipboard &&
    !Ao(e.navigator.permissions) &&
    Xn(e.navigator.permissions.query) &&
    (Nl.call(this, e), kl.call(this, e));
}
function Ll(A, e) {
  let t,
    i,
    n = this.getData(e),
    o = Ol(this.clientConnectionId);
  o &&
    ((t = o.dcvId),
    (i = new Blob([n], { type: e })),
    this.asyncCopy[t] &&
      this.pendingDataToSync &&
      o.navigator.clipboard
        .write([new window.ClipboardItem({ [e]: i })])
        .then(() => {
          (this.pendingDataToSync = !1),
            this.log.info("Async auto copy: DONE."),
            A ? this.triggerEvent({ name: "autoCopyDone" }) : this.triggerEvent({ name: "copy" });
        })
        .catch(() => {
          this.log.info("Async auto copy: DENIED.");
        }));
}
function Tl() {
  let A,
    e = Ol(this.clientConnectionId);
  e &&
    ((A = e.dcvId),
    this.asyncPaste[A]
      ? e.navigator.clipboard
          .read()
          .then((A) => {
            const e = ["image/png", "text/plain"],
              t = {};
            for (const i of A) {
              const A = i.types.filter((A) => e.includes(A));
              for (const e of A)
                i.getType(e).then((i) => {
                  (i && 0 !== i.size) || A.splice(A.indexOf(e), 1),
                    A.length
                      ? Pl.call(this, i, e, t, A.length)
                      : (this.log.info("Clearing data from local"), this.clearFromLocal());
                });
            }
          })
          .catch(() => {
            this.log.info(
              "Async multi-format paste when gaining tab focus: DENIED. Falling back to text-only paste."
            ),
              e.navigator.clipboard
                .readText()
                .then((A) => {
                  Pl.call(this, new Blob([A]), "text/plain", {}, 1);
                })
                .catch(() => {
                  this.log.info("Async text-only paste when gaining tab focus: DENIED.");
                });
          })
      : e.document.removeEventListener("focusin", this.performAsyncPaste));
}
function Pl(A, e, t, i) {
  const n = (A) => {
    (t[e] = A),
      Object.keys(t).length === i &&
        (this.addDataFromLocal(t), this.triggerEvent({ name: "autoPasteDone" }));
  };
  if (A && A.size > 0)
    switch (e) {
      case "image/png":
        A.arrayBuffer().then((t) => {
          !(function (A, e) {
            if (Ao(A) && Ao(e)) return !0;
            if (Ao(A) || Ao(e)) return !1;
            if (A.byteLength !== e.byteLength) return !1;
            const t = new DataView(A),
              i = new DataView(e);
            for (let e = 0; e < A.byteLength; e++) if (t.getUint8(e) !== i.getUint8(e)) return !1;
            return !0;
          })(t, this.getData(e)) &&
            Rl.call(this, A) &&
            (this.log.info("Async paste when gaining tab focus: DONE."), n(t));
        });
        break;
      case "text/plain":
        A.text().then((e) => {
          const t = this.getTextData();
          !this.pasteEnabled || (t && e === t) || !Rl.call(this, A)
            ? this.log.info("Async paste when gaining tab focus: NO NEW DATA TO SYNC.")
            : (this.log.info("Async paste when gaining tab focus: DONE."), n(e));
        });
    }
}
function Gl(A) {
  let e = A.getElementById("dcv-clipboard-hidden-input");
  return (
    null === e &&
      ((e = A.createElement("input")),
      (e.id = "dcv-clipboard-hidden-input"),
      (e.style.display = "none"),
      e.setAttribute("type", "text"),
      (e.value = ""),
      A.body.appendChild(e)),
    e
  );
}
(fl.prototype.remoteError = function (A) {
  this.triggerEvent({ name: "remoteError", error: A });
}),
  (fl.prototype.enableCopy = function (A) {
    (this.copyEnabled = A), this.log.debug(`Copy set to ${A}`);
  }),
  (fl.prototype.enablePaste = function (A) {
    (this.pasteEnabled = A),
      A || (document.removeEventListener("focusin", this.performAsyncPaste), this.clearData()),
      this.log.debug(`Paste set to ${A}`);
  }),
  (fl.prototype.addListeners = function (A) {
    const e = A.document,
      t = A.dcvId;
    this.listeners[t] ||
      (this.log.debug("adding listeners"),
      this.remoteData && e.addEventListener("copy", this.onCopy),
      e.addEventListener("paste", this.onPaste),
      e.addEventListener("input", this.onInputSelectHiddenInput)),
      ml.call(this, t),
      (this.listeners[t] = !0);
  }),
  (fl.prototype.removeListeners = function (A) {
    const e = A.document,
      t = A.dcvId;
    this.listeners[t] &&
      (this.log.debug("Removing listeners"),
      this.remoteData && e.removeEventListener("copy", this.onCopy),
      e.removeEventListener("paste", this.onPaste),
      e.removeEventListener("input", this.onInputSelectHiddenInput)),
      (this.listeners[t] = !1);
  }),
  (fl.prototype.clearData = function () {
    this.remoteData = {};
  }),
  (fl.prototype.getData = function (A) {
    return Object.prototype.hasOwnProperty.call(this.remoteData, A) && null !== this.remoteData[A]
      ? (this.log.debug(`Store has data of type ${A} of size ${ro(this.remoteData[A])}`),
        xl.call(this),
        this.remoteData[A])
      : (this.log.debug(`No data stored for type ${A}`), null);
  }),
  (fl.prototype.getTextData = function () {
    return this.getData("text/plain");
  }),
  (fl.prototype.getTargets = function () {
    return Object.keys(this.remoteData);
  }),
  (fl.prototype.getDataDictionary = function () {
    const A = {},
      e = this;
    return (
      e.getTargets().forEach((t) => {
        A[t] = e.getData(t);
      }),
      A
    );
  }),
  (fl.prototype.addData = function (A, e) {
    let t,
      i = Ol(this.clientConnectionId);
    return (
      !(!i || !Rl.call(this, A)) &&
      ((t = i.dcvId),
      (this.remoteData[e] = A),
      (this.pendingDataToSync = !0),
      this.triggerEvent({
        name: "newDataAvailable",
        clipboardData: this.getDataDictionary(),
        autoCopy: this.isAutoCopyAvailable || "granted" === this.asyncCopy[t]
      }),
      "granted" === this.asyncCopy[t]
        ? Ll.call(this, !0, e)
        : this.isAutoCopyAvailable && vl.call(this),
      this.log.info(`Received data of type ${e} of size ${ro(A)} from remote: ready to be copied.`),
      !0)
    );
  }),
  (fl.prototype.addDataFromLocal = function (A) {
    if (Object.values(A).some((A) => !Rl.call(this, A))) return !1;
    (this.remoteData = A), (this.pendingDataToSync = !1);
    for (const [e, t] of Object.entries(A))
      this.triggerEvent({ name: "pasteAvailableData", clipboardData: t }),
        this.log.info(
          `Received data of type ${e} of size ${ro(t)} from local: ready to be copied.`
        );
    return Xn(this.onNewLocalData) && this.onNewLocalData(), !0;
  }),
  (fl.prototype.clearFromLocal = function () {
    return (
      (this.remoteData = {}),
      (this.pendingDataToSync = !1),
      this.log.info("Received clear event from local."),
      Xn(this.onNewLocalData) && this.onNewLocalData(),
      !0
    );
  }),
  (fl.prototype.syncClipboards = function () {
    let A,
      e,
      t,
      i,
      n,
      o = this.getTextData(),
      r = Ol(this.clientConnectionId);
    return (
      !(!r || !this.copyEnabled) &&
      ((n = r.document),
      (t = "rtl" === n.documentElement.getAttribute("dir")),
      (i = n.activeElement),
      (A = n.createElement("textarea")),
      (A.style.fontSize = "12pt"),
      (A.style.background = "transparent"),
      (A.style.border = "0"),
      (A.style.padding = "0"),
      (A.style.margin = "0"),
      (A.style.position = "fixed"),
      (A.style.top = "-9999px"),
      (A.style[t ? "right" : "left"] = "-9999px"),
      A.setAttribute("readonly", ""),
      (A.value = o),
      n.body.appendChild(A),
      A.select(),
      A.setSelectionRange(0, A.value.length),
      (e = n.execCommand("copy")),
      this.log.debug(`Autosync of clipboard result: ${e}`),
      n.body.removeChild(A),
      i.focus(),
      e)
    );
  }),
  (fl.prototype.enableEventListeners = function (A, e) {
    (this.hiddenInput[e.dcvId] = Gl(e.document)),
      A ? this.addListeners(e) : this.removeListeners(e);
  }),
  (fl.prototype.enableDisplay = function (A) {
    Kl.call(this, A);
  }),
  (fl.prototype.hasDataToSync = function () {
    this.isAutoCopyAvailable && this.pendingDataToSync && Ml.call(this);
  });
const Hl = { major: 1, minor: 0 },
  Yl = El.clipboard,
  ql = (A) => Do(Yl.ClientMessage, A);
function Jl() {
  this.log.info("Resetting channel"),
    (this.idDataClipboard = 0),
    (this.lastClipboardDataReceived = null);
}
function jl() {
  Jl.call(this), this.log.info("Starting handshake"), Xl.call(this), zl.call(this);
}
function Wl(A, e) {
  let t,
    i,
    n,
    o,
    r = Yl.ClipboardData.Error.NONE,
    s = Ws(this.clientConnectionId);
  switch (A.msg) {
    case "handshakeStart":
      jl.call(this);
      break;
    case "supportedTargets":
      this.log.debug("Received supportedTargets message"),
        this.log.debug(
          `supportedTargets num-R: ${A.supportedTargets.reading.length} num-W: ${A.supportedTargets.writing.length}`
        ),
        A.supportedTargets.reading.length > 0 &&
          (this.remoteClipboard.enableCopy(!0),
          s.update("clipboard-copy", {
            enabled: !0,
            autoCopy: this.remoteClipboard.isAutoCopyAvailable
          })),
        A.supportedTargets.writing.length > 0 &&
          (this.remoteClipboard.enablePaste(!0),
          s.update("clipboard-paste", {
            enabled: !0,
            autoPaste: this.remoteClipboard.isAutoPasteAvailable
          }));
      break;
    case "updateEvent":
      this.log.debug("Received updateEvent message"),
        A.updateEvent.targets.length > 0
          ? ((o = A.updateEvent.targets.toString()),
            this.log.debug(`updateEvent: ${A} :${o}`),
            A.updateEvent.targets.find((A) => "dcv/text" === A)
              ? Vl.call(this, "dcv/text")
              : Vl.call(this, A.updateEvent.targets[0]))
          : (this.log.info("Received clear event from remote."),
            null !== this.lastClipboardDataReceived &&
              ((this.lastClipboardDataReceived = null),
              this.remoteClipboard.addData("", "text/plain"),
              this.remoteClipboard.clearData()));
      break;
    case "requestData":
      switch ((this.log.debug("Received requestData message"), A.requestData.target)) {
        case "dcv/text":
          (n = this.remoteClipboard.getData("text/plain")),
            n
              ? ((t = $n(n)), null === t && (r = Yl.ClipboardData.Error.CONVERSION_ERROR))
              : ((t = null), (r = Yl.ClipboardData.Error.EMPTY_CLIPBOARD));
          break;
        case "dcv/image":
          (n = this.remoteClipboard.getData("image/png")),
            n ? (t = n) : ((t = null), (r = Yl.clipboardData.Error.EMPTY_CLIPBOARD));
          break;
        default:
          (t = null), (r = Yl.ClipboardData.Error.GENERIC);
      }
      Zl.call(this, A.requestData.id, A.requestData.target, t, r);
      break;
    case "clipboardData":
      if (
        (this.log.debug("Received clipboardData message"),
        A.clipboardData.error !== Yl.ClipboardData.Error.NONE)
      )
        switch (A.clipboardData.error) {
          case Yl.ClipboardData.Error.EMPTY_CLIPBOARD:
            this.log.warn(
              "Error: the clipboard was empty on server when retrieving the data from clipboard."
            ),
              this.remoteClipboard.remoteError("emptyClipboard");
            break;
          case Yl.ClipboardData.Error.CONVERSION_ERROR:
            this.log.warn(
              "Error: there was a conversion error on server when retrieving the data from clipboard."
            ),
              this.remoteClipboard.remoteError("conversionError");
            break;
          case Yl.ClipboardData.Error.DATA_EXCEEDS_LIMIT:
            this.log.warn(
              "Error: remote data cannot be copied from remote because it exceeds clipboard data transfer limit."
            ),
              this.remoteClipboard.remoteError("dataSizeAlert");
            break;
          default:
            this.log.warn(
              "Error: there was a generic error on server when retrieving the data from clipboard."
            ),
              this.remoteClipboard.remoteError("generic");
        }
      else
        switch (A.clipboardData.target) {
          case "dcv/text":
            (this.lastClipboardDataReceived = new Uint8Array(e)),
              this.lastClipboardDataReceived
                ? ((i = (function (A) {
                    const e = Vn(A);
                    return decodeURIComponent(escape(e));
                  })(this.lastClipboardDataReceived)),
                  this.remoteClipboard.clearData(),
                  this.remoteClipboard.addData(
                    Br() ? i.replace(/\r?\n/g, "\r\n") : i,
                    "text/plain"
                  ))
                : this.log.warn("Received invalid data to copy");
            break;
          case "dcv/image":
            this.remoteClipboard.clearData(), this.remoteClipboard.addData(e, "image/png");
            break;
          default:
            this.remoteClipboard.remoteError("usupportedTarget"),
              this.log.warn(`Unable to set clipboard data with target="${A.clipboardData.target}`);
        }
      break;
    default:
      this.log.warn(`Unknown clipboard message: ${A}`);
  }
}
function Vl(A) {
  this.log.debug(`send RequestData message T:${A}`),
    (this.idDataClipboard += 1),
    this.transport.sendMessage(ql({ requestData: { target: A, id: this.idDataClipboard } }));
}
function _l() {
  let A,
    e = [];
  Ao(this.remoteClipboard) ||
    ((A = this.remoteClipboard.getTargets()),
    A.indexOf("text/plain") > -1 && e.push("dcv/text"),
    A.indexOf("image/png") > -1 && e.push("dcv/image"),
    this.log.debug("sending Clipboard Update to remote"),
    this.transport.sendMessage(ql({ updateEvent: { targets: e } })));
}
function Xl() {
  (this.supportedTargetsRead = ["dcv/text"]),
    (this.supportedTargetsWrite = ["dcv/text"]),
    pr() &&
      (this.supportedTargetsRead.push("dcv/image"), this.supportedTargetsWrite.push("dcv/image"));
}
function zl() {
  this.log.debug("sending supported targets by client"),
    this.transport.sendMessage(
      ql({
        supportedTargets: {
          reading: this.supportedTargetsRead,
          writing: this.supportedTargetsWrite
        }
      })
    );
}
function Zl(A, e, t, i) {
  let n;
  if (null !== t)
    this.log.info(`Sending data of type ${e} and size ${ro(t)} bytes to remote requestor.`);
  else {
    switch (i) {
      case Yl.ClipboardData.Error.EMPTY_CLIPBOARD:
        n = "empty clipboard";
        break;
      case Yl.ClipboardData.Error.CONVERSION_ERROR:
        n = "conversion";
        break;
      case Yl.ClipboardData.Error.DATA_EXCEEDS_LIMIT:
        n = "data exceeds limit";
        break;
      case Yl.ClipboardData.Error.GENERIC:
      default:
        n = "generic";
    }
    this.log.warn(
      `Unable to get clipboard data with target="${e}", sending ${n} error (${i}) to remote requestor.`
    );
  }
  this.transport.sendMessage(ql({ clipboardData: { target: e, id: A, error: i } }), t);
}
const $l = Fo.exports.Reader,
  Ad = Fo.exports.Writer,
  ed = Fo.exports.util,
  td = Fo.exports.roots["dcv.audio"] || (Fo.exports.roots["dcv.audio"] = {}),
  id = (td.dcv = (() => {
    const A = {};
    return (
      (A.audio = (function () {
        const A = {};
        return (
          (A.AudioType = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "NONE")] = 0),
              (e[(A[1] = "STEREO")] = 1),
              (e[(A[4] = "MULTI_CHANNEL_QUAD")] = 4),
              (e[(A[6] = "MULTI_CHANNEL_5_1")] = 6),
              (e[(A[8] = "MULTI_CHANNEL_7_1")] = 8),
              e
            );
          })()),
          (A.SampleRate = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "SR_48KHz")] = 0), e;
          })()),
          (A.AudioService = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "STREAM")] = 0),
              (e[(A[1] = "INJECTION")] = 1),
              (e[(A[2] = "SPECTRUM")] = 2),
              e
            );
          })()),
          (A.AudioStatus = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "ACTIVE")] = 0),
              (e[(A[1] = "AVAILABLE")] = 1),
              (e[(A[2] = "NOT_AVAILABLE")] = 2),
              (e[(A[3] = "BUSY")] = 3),
              e
            );
          })()),
          (A.AudioChannelPosition = (function () {
            const A = {},
              e = Object.create(A);
            return (
              (e[(A[0] = "CHANNEL_NONE")] = 0),
              (e[(A[1] = "CHANNEL_LEFT")] = 1),
              (e[(A[2] = "CHANNEL_RIGHT")] = 2),
              (e[(A[3] = "CHANNEL_CENTER")] = 3),
              (e[(A[4] = "CHANNEL_LFE")] = 4),
              (e[(A[5] = "CHANNEL_REAR_LEFT")] = 5),
              (e[(A[6] = "CHANNEL_REAR_RIGHT")] = 6),
              (e[(A[7] = "CHANNEL_SIDE_LEFT")] = 7),
              (e[(A[8] = "CHANNEL_SIDE_RIGHT")] = 8),
              e
            );
          })()),
          (A.HandshakeStart = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.negotiationId = ed.Long ? ed.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.negotiationId &&
                    Object.hasOwnProperty.call(A, "negotiationId") &&
                    e.uint32(8).uint64(A.negotiationId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.HandshakeStart();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.negotiationId = A.uint64();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.negotiationId &&
                      A.hasOwnProperty("negotiationId") &&
                      !(
                        ed.isInteger(A.negotiationId) ||
                        (A.negotiationId &&
                          ed.isInteger(A.negotiationId.low) &&
                          ed.isInteger(A.negotiationId.high))
                      )
                    ? "negotiationId: integer|Long expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.HandshakeStart) return A;
                let e = new td.dcv.audio.HandshakeStart();
                return (
                  null != A.negotiationId &&
                    (ed.Long
                      ? ((e.negotiationId = ed.Long.fromValue(A.negotiationId)).unsigned = !0)
                      : "string" == typeof A.negotiationId
                        ? (e.negotiationId = parseInt(A.negotiationId, 10))
                        : "number" == typeof A.negotiationId
                          ? (e.negotiationId = A.negotiationId)
                          : "object" == typeof A.negotiationId &&
                            (e.negotiationId = new ed.LongBits(
                              A.negotiationId.low >>> 0,
                              A.negotiationId.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (ed.Long) {
                    let A = new ed.Long(0, 0, !0);
                    t.negotiationId =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.negotiationId = e.longs === String ? "0" : 0;
                return (
                  null != A.negotiationId &&
                    A.hasOwnProperty("negotiationId") &&
                    ("number" == typeof A.negotiationId
                      ? (t.negotiationId =
                          e.longs === String ? String(A.negotiationId) : A.negotiationId)
                      : (t.negotiationId =
                          e.longs === String
                            ? ed.Long.prototype.toString.call(A.negotiationId)
                            : e.longs === Number
                              ? new ed.LongBits(
                                  A.negotiationId.low >>> 0,
                                  A.negotiationId.high >>> 0
                                ).toNumber(!0)
                              : A.negotiationId)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.HandshakeStart";
              }),
              A
            );
          })()),
          (A.Configuration = (function () {
            function A(A) {
              if (((this.channelMapping = []), (this.availableTypes = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.sampleRate = 0),
              (A.prototype.injectFrameLength = 0),
              (A.prototype.streamFrameLength = 0),
              (A.prototype.type = 0),
              (A.prototype.channelMapping = ed.emptyArray),
              (A.prototype.codec = null),
              (A.prototype.availableTypes = ed.emptyArray),
              (A.prototype.avSyncSupported = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Ad.create()),
                  null != A.sampleRate &&
                    Object.hasOwnProperty.call(A, "sampleRate") &&
                    e.uint32(8).int32(A.sampleRate),
                  null != A.injectFrameLength &&
                    Object.hasOwnProperty.call(A, "injectFrameLength") &&
                    e.uint32(16).uint32(A.injectFrameLength),
                  null != A.type &&
                    Object.hasOwnProperty.call(A, "type") &&
                    e.uint32(24).int32(A.type),
                  null != A.channelMapping && A.channelMapping.length)
                ) {
                  e.uint32(34).fork();
                  for (let t = 0; t < A.channelMapping.length; ++t) e.int32(A.channelMapping[t]);
                  e.ldelim();
                }
                if (
                  (null != A.streamFrameLength &&
                    Object.hasOwnProperty.call(A, "streamFrameLength") &&
                    e.uint32(40).uint32(A.streamFrameLength),
                  null != A.codec &&
                    Object.hasOwnProperty.call(A, "codec") &&
                    td.dcv.audio.Configuration.Codec.encode(A.codec, e.uint32(82).fork()).ldelim(),
                  null != A.availableTypes && A.availableTypes.length)
                ) {
                  e.uint32(162).fork();
                  for (let t = 0; t < A.availableTypes.length; ++t) e.int32(A.availableTypes[t]);
                  e.ldelim();
                }
                return (
                  null != A.avSyncSupported &&
                    Object.hasOwnProperty.call(A, "avSyncSupported") &&
                    e.uint32(240).bool(A.avSyncSupported),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.Configuration();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.sampleRate = A.int32();
                      break;
                    case 2:
                      i.injectFrameLength = A.uint32();
                      break;
                    case 5:
                      i.streamFrameLength = A.uint32();
                      break;
                    case 3:
                      i.type = A.int32();
                      break;
                    case 4:
                      if (
                        ((i.channelMapping && i.channelMapping.length) || (i.channelMapping = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.channelMapping.push(A.int32());
                      } else i.channelMapping.push(A.int32());
                      break;
                    case 10:
                      i.codec = td.dcv.audio.Configuration.Codec.decode(A, A.uint32());
                      break;
                    case 20:
                      if (
                        ((i.availableTypes && i.availableTypes.length) || (i.availableTypes = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.availableTypes.push(A.int32());
                      } else i.availableTypes.push(A.int32());
                      break;
                    case 30:
                      i.avSyncSupported = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.sampleRate && A.hasOwnProperty("sampleRate") && 0 !== A.sampleRate)
                  return "sampleRate: enum value expected";
                if (
                  null != A.injectFrameLength &&
                  A.hasOwnProperty("injectFrameLength") &&
                  !ed.isInteger(A.injectFrameLength)
                )
                  return "injectFrameLength: integer expected";
                if (
                  null != A.streamFrameLength &&
                  A.hasOwnProperty("streamFrameLength") &&
                  !ed.isInteger(A.streamFrameLength)
                )
                  return "streamFrameLength: integer expected";
                if (null != A.type && A.hasOwnProperty("type"))
                  switch (A.type) {
                    default:
                      return "type: enum value expected";
                    case 0:
                    case 1:
                    case 4:
                    case 6:
                    case 8:
                  }
                if (null != A.channelMapping && A.hasOwnProperty("channelMapping")) {
                  if (!Array.isArray(A.channelMapping)) return "channelMapping: array expected";
                  for (let e = 0; e < A.channelMapping.length; ++e)
                    switch (A.channelMapping[e]) {
                      default:
                        return "channelMapping: enum value[] expected";
                      case 0:
                      case 1:
                      case 2:
                      case 3:
                      case 4:
                      case 5:
                      case 6:
                      case 7:
                      case 8:
                    }
                }
                if (null != A.codec && A.hasOwnProperty("codec")) {
                  let e = td.dcv.audio.Configuration.Codec.verify(A.codec);
                  if (e) return "codec." + e;
                }
                if (null != A.availableTypes && A.hasOwnProperty("availableTypes")) {
                  if (!Array.isArray(A.availableTypes)) return "availableTypes: array expected";
                  for (let e = 0; e < A.availableTypes.length; ++e)
                    switch (A.availableTypes[e]) {
                      default:
                        return "availableTypes: enum value[] expected";
                      case 0:
                      case 1:
                      case 4:
                      case 6:
                      case 8:
                    }
                }
                return null != A.avSyncSupported &&
                  A.hasOwnProperty("avSyncSupported") &&
                  "boolean" != typeof A.avSyncSupported
                  ? "avSyncSupported: boolean expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.Configuration) return A;
                let e = new td.dcv.audio.Configuration();
                switch (A.sampleRate) {
                  default:
                    if ("number" == typeof A.sampleRate) {
                      e.sampleRate = A.sampleRate;
                      break;
                    }
                    break;
                  case "SR_48KHz":
                  case 0:
                    e.sampleRate = 0;
                }
                switch (
                  (null != A.injectFrameLength && (e.injectFrameLength = A.injectFrameLength >>> 0),
                  null != A.streamFrameLength && (e.streamFrameLength = A.streamFrameLength >>> 0),
                  A.type)
                ) {
                  default:
                    if ("number" == typeof A.type) {
                      e.type = A.type;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.type = 0;
                    break;
                  case "STEREO":
                  case 1:
                    e.type = 1;
                    break;
                  case "MULTI_CHANNEL_QUAD":
                  case 4:
                    e.type = 4;
                    break;
                  case "MULTI_CHANNEL_5_1":
                  case 6:
                    e.type = 6;
                    break;
                  case "MULTI_CHANNEL_7_1":
                  case 8:
                    e.type = 8;
                }
                if (A.channelMapping) {
                  if (!Array.isArray(A.channelMapping))
                    throw TypeError(".dcv.audio.Configuration.channelMapping: array expected");
                  e.channelMapping = [];
                  for (let t = 0; t < A.channelMapping.length; ++t)
                    switch (A.channelMapping[t]) {
                      default:
                        if ("number" == typeof A.channelMapping[t]) {
                          e.channelMapping[t] = A.channelMapping[t];
                          break;
                        }
                      case "CHANNEL_NONE":
                      case 0:
                        e.channelMapping[t] = 0;
                        break;
                      case "CHANNEL_LEFT":
                      case 1:
                        e.channelMapping[t] = 1;
                        break;
                      case "CHANNEL_RIGHT":
                      case 2:
                        e.channelMapping[t] = 2;
                        break;
                      case "CHANNEL_CENTER":
                      case 3:
                        e.channelMapping[t] = 3;
                        break;
                      case "CHANNEL_LFE":
                      case 4:
                        e.channelMapping[t] = 4;
                        break;
                      case "CHANNEL_REAR_LEFT":
                      case 5:
                        e.channelMapping[t] = 5;
                        break;
                      case "CHANNEL_REAR_RIGHT":
                      case 6:
                        e.channelMapping[t] = 6;
                        break;
                      case "CHANNEL_SIDE_LEFT":
                      case 7:
                        e.channelMapping[t] = 7;
                        break;
                      case "CHANNEL_SIDE_RIGHT":
                      case 8:
                        e.channelMapping[t] = 8;
                    }
                }
                if (null != A.codec) {
                  if ("object" != typeof A.codec)
                    throw TypeError(".dcv.audio.Configuration.codec: object expected");
                  e.codec = td.dcv.audio.Configuration.Codec.fromObject(A.codec);
                }
                if (A.availableTypes) {
                  if (!Array.isArray(A.availableTypes))
                    throw TypeError(".dcv.audio.Configuration.availableTypes: array expected");
                  e.availableTypes = [];
                  for (let t = 0; t < A.availableTypes.length; ++t)
                    switch (A.availableTypes[t]) {
                      default:
                        if ("number" == typeof A.availableTypes[t]) {
                          e.availableTypes[t] = A.availableTypes[t];
                          break;
                        }
                      case "NONE":
                      case 0:
                        e.availableTypes[t] = 0;
                        break;
                      case "STEREO":
                      case 1:
                        e.availableTypes[t] = 1;
                        break;
                      case "MULTI_CHANNEL_QUAD":
                      case 4:
                        e.availableTypes[t] = 4;
                        break;
                      case "MULTI_CHANNEL_5_1":
                      case 6:
                        e.availableTypes[t] = 6;
                        break;
                      case "MULTI_CHANNEL_7_1":
                      case 8:
                        e.availableTypes[t] = 8;
                    }
                }
                return (
                  null != A.avSyncSupported && (e.avSyncSupported = Boolean(A.avSyncSupported)), e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && ((t.channelMapping = []), (t.availableTypes = [])),
                  e.defaults &&
                    ((t.sampleRate = e.enums === String ? "SR_48KHz" : 0),
                    (t.injectFrameLength = 0),
                    (t.type = e.enums === String ? "NONE" : 0),
                    (t.streamFrameLength = 0),
                    (t.codec = null),
                    (t.avSyncSupported = !1)),
                  null != A.sampleRate &&
                    A.hasOwnProperty("sampleRate") &&
                    (t.sampleRate =
                      e.enums === String
                        ? void 0 === td.dcv.audio.SampleRate[A.sampleRate]
                          ? A.sampleRate
                          : td.dcv.audio.SampleRate[A.sampleRate]
                        : A.sampleRate),
                  null != A.injectFrameLength &&
                    A.hasOwnProperty("injectFrameLength") &&
                    (t.injectFrameLength = A.injectFrameLength),
                  null != A.type &&
                    A.hasOwnProperty("type") &&
                    (t.type =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioType[A.type]
                          ? A.type
                          : td.dcv.audio.AudioType[A.type]
                        : A.type),
                  A.channelMapping && A.channelMapping.length)
                ) {
                  t.channelMapping = [];
                  for (let i = 0; i < A.channelMapping.length; ++i)
                    t.channelMapping[i] =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioChannelPosition[A.channelMapping[i]]
                          ? A.channelMapping[i]
                          : td.dcv.audio.AudioChannelPosition[A.channelMapping[i]]
                        : A.channelMapping[i];
                }
                if (
                  (null != A.streamFrameLength &&
                    A.hasOwnProperty("streamFrameLength") &&
                    (t.streamFrameLength = A.streamFrameLength),
                  null != A.codec &&
                    A.hasOwnProperty("codec") &&
                    (t.codec = td.dcv.audio.Configuration.Codec.toObject(A.codec, e)),
                  A.availableTypes && A.availableTypes.length)
                ) {
                  t.availableTypes = [];
                  for (let i = 0; i < A.availableTypes.length; ++i)
                    t.availableTypes[i] =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioType[A.availableTypes[i]]
                          ? A.availableTypes[i]
                          : td.dcv.audio.AudioType[A.availableTypes[i]]
                        : A.availableTypes[i];
                }
                return (
                  null != A.avSyncSupported &&
                    A.hasOwnProperty("avSyncSupported") &&
                    (t.avSyncSupported = A.avSyncSupported),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.Configuration";
              }),
              (A.Codec = (function () {
                function A(A) {
                  if (((this.bitrates = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.audioProfile = ""),
                  (A.prototype.bitrates = ed.emptyArray),
                  (A.prototype.level = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ad.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.audioProfile &&
                        Object.hasOwnProperty.call(A, "audioProfile") &&
                        e.uint32(18).string(A.audioProfile),
                      null != A.bitrates && A.bitrates.length)
                    ) {
                      e.uint32(82).fork();
                      for (let t = 0; t < A.bitrates.length; ++t) e.uint32(A.bitrates[t]);
                      e.ldelim();
                    }
                    return (
                      null != A.level &&
                        Object.hasOwnProperty.call(A, "level") &&
                        e.uint32(88).uint32(A.level),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.Configuration.Codec();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 2:
                          i.audioProfile = A.string();
                          break;
                        case 10:
                          if (
                            ((i.bitrates && i.bitrates.length) || (i.bitrates = []), 2 == (7 & e))
                          ) {
                            let e = A.uint32() + A.pos;
                            for (; A.pos < e; ) i.bitrates.push(A.uint32());
                          } else i.bitrates.push(A.uint32());
                          break;
                        case 11:
                          i.level = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !ed.isString(A.name))
                      return "name: string expected";
                    if (
                      null != A.audioProfile &&
                      A.hasOwnProperty("audioProfile") &&
                      !ed.isString(A.audioProfile)
                    )
                      return "audioProfile: string expected";
                    if (null != A.bitrates && A.hasOwnProperty("bitrates")) {
                      if (!Array.isArray(A.bitrates)) return "bitrates: array expected";
                      for (let e = 0; e < A.bitrates.length; ++e)
                        if (!ed.isInteger(A.bitrates[e])) return "bitrates: integer[] expected";
                    }
                    return null != A.level && A.hasOwnProperty("level") && !ed.isInteger(A.level)
                      ? "level: integer expected"
                      : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.Configuration.Codec) return A;
                    let e = new td.dcv.audio.Configuration.Codec();
                    if (
                      (null != A.name && (e.name = String(A.name)),
                      null != A.audioProfile && (e.audioProfile = String(A.audioProfile)),
                      A.bitrates)
                    ) {
                      if (!Array.isArray(A.bitrates))
                        throw TypeError(".dcv.audio.Configuration.Codec.bitrates: array expected");
                      e.bitrates = [];
                      for (let t = 0; t < A.bitrates.length; ++t)
                        e.bitrates[t] = A.bitrates[t] >>> 0;
                    }
                    return null != A.level && (e.level = A.level >>> 0), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && (t.bitrates = []),
                      e.defaults && ((t.name = ""), (t.audioProfile = ""), (t.level = 0)),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      null != A.audioProfile &&
                        A.hasOwnProperty("audioProfile") &&
                        (t.audioProfile = A.audioProfile),
                      A.bitrates && A.bitrates.length)
                    ) {
                      t.bitrates = [];
                      for (let e = 0; e < A.bitrates.length; ++e) t.bitrates[e] = A.bitrates[e];
                    }
                    return null != A.level && A.hasOwnProperty("level") && (t.level = A.level), t;
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.Configuration.Codec"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.StatusUpdate = (function () {
            function A(A) {
              if (((this.status = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.status = ed.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ad.create()), null != A.status && A.status.length))
                  for (let t = 0; t < A.status.length; ++t)
                    td.dcv.audio.StatusUpdate.ServiceStatus.encode(
                      A.status[t],
                      e.uint32(10).fork()
                    ).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.StatusUpdate();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    (i.status && i.status.length) || (i.status = []),
                      i.status.push(td.dcv.audio.StatusUpdate.ServiceStatus.decode(A, A.uint32()));
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.status && A.hasOwnProperty("status")) {
                  if (!Array.isArray(A.status)) return "status: array expected";
                  for (let e = 0; e < A.status.length; ++e) {
                    let t = td.dcv.audio.StatusUpdate.ServiceStatus.verify(A.status[e]);
                    if (t) return "status." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.StatusUpdate) return A;
                let e = new td.dcv.audio.StatusUpdate();
                if (A.status) {
                  if (!Array.isArray(A.status))
                    throw TypeError(".dcv.audio.StatusUpdate.status: array expected");
                  e.status = [];
                  for (let t = 0; t < A.status.length; ++t) {
                    if ("object" != typeof A.status[t])
                      throw TypeError(".dcv.audio.StatusUpdate.status: object expected");
                    e.status[t] = td.dcv.audio.StatusUpdate.ServiceStatus.fromObject(A.status[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (((e.arrays || e.defaults) && (t.status = []), A.status && A.status.length)) {
                  t.status = [];
                  for (let i = 0; i < A.status.length; ++i)
                    t.status[i] = td.dcv.audio.StatusUpdate.ServiceStatus.toObject(A.status[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.StatusUpdate";
              }),
              (A.ServiceStatus = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.service = 0),
                  (A.prototype.status = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.service &&
                        Object.hasOwnProperty.call(A, "service") &&
                        e.uint32(8).int32(A.service),
                      null != A.status &&
                        Object.hasOwnProperty.call(A, "status") &&
                        e.uint32(16).int32(A.status),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.StatusUpdate.ServiceStatus();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.service = A.int32();
                          break;
                        case 2:
                          i.status = A.int32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.service && A.hasOwnProperty("service"))
                      switch (A.service) {
                        default:
                          return "service: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                      }
                    if (null != A.status && A.hasOwnProperty("status"))
                      switch (A.status) {
                        default:
                          return "status: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                      }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.StatusUpdate.ServiceStatus) return A;
                    let e = new td.dcv.audio.StatusUpdate.ServiceStatus();
                    switch (A.service) {
                      default:
                        if ("number" == typeof A.service) {
                          e.service = A.service;
                          break;
                        }
                        break;
                      case "STREAM":
                      case 0:
                        e.service = 0;
                        break;
                      case "INJECTION":
                      case 1:
                        e.service = 1;
                        break;
                      case "SPECTRUM":
                      case 2:
                        e.service = 2;
                    }
                    switch (A.status) {
                      default:
                        if ("number" == typeof A.status) {
                          e.status = A.status;
                          break;
                        }
                        break;
                      case "ACTIVE":
                      case 0:
                        e.status = 0;
                        break;
                      case "AVAILABLE":
                      case 1:
                        e.status = 1;
                        break;
                      case "NOT_AVAILABLE":
                      case 2:
                        e.status = 2;
                        break;
                      case "BUSY":
                      case 3:
                        e.status = 3;
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults &&
                        ((t.service = e.enums === String ? "STREAM" : 0),
                        (t.status = e.enums === String ? "ACTIVE" : 0)),
                      null != A.service &&
                        A.hasOwnProperty("service") &&
                        (t.service =
                          e.enums === String
                            ? void 0 === td.dcv.audio.AudioService[A.service]
                              ? A.service
                              : td.dcv.audio.AudioService[A.service]
                            : A.service),
                      null != A.status &&
                        A.hasOwnProperty("status") &&
                        (t.status =
                          e.enums === String
                            ? void 0 === td.dcv.audio.AudioStatus[A.status]
                              ? A.status
                              : td.dcv.audio.AudioStatus[A.status]
                            : A.status),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.StatusUpdate.ServiceStatus"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.StreamConfiguration = (function () {
            function A(A) {
              if (((this.channelMapping = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.encodingLevel = 0),
              (A.prototype.type = 0),
              (A.prototype.channelMapping = ed.emptyArray),
              (A.prototype.frameLength = 0),
              (A.prototype.avSync = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Ad.create()),
                  null != A.encodingLevel &&
                    Object.hasOwnProperty.call(A, "encodingLevel") &&
                    e.uint32(8).uint32(A.encodingLevel),
                  null != A.type &&
                    Object.hasOwnProperty.call(A, "type") &&
                    e.uint32(16).int32(A.type),
                  null != A.channelMapping && A.channelMapping.length)
                ) {
                  e.uint32(26).fork();
                  for (let t = 0; t < A.channelMapping.length; ++t) e.int32(A.channelMapping[t]);
                  e.ldelim();
                }
                return (
                  null != A.frameLength &&
                    Object.hasOwnProperty.call(A, "frameLength") &&
                    e.uint32(32).uint32(A.frameLength),
                  null != A.avSync &&
                    Object.hasOwnProperty.call(A, "avSync") &&
                    e.uint32(240).bool(A.avSync),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.StreamConfiguration();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.encodingLevel = A.uint32();
                      break;
                    case 2:
                      i.type = A.int32();
                      break;
                    case 3:
                      if (
                        ((i.channelMapping && i.channelMapping.length) || (i.channelMapping = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.channelMapping.push(A.int32());
                      } else i.channelMapping.push(A.int32());
                      break;
                    case 4:
                      i.frameLength = A.uint32();
                      break;
                    case 30:
                      i.avSync = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.encodingLevel &&
                  A.hasOwnProperty("encodingLevel") &&
                  !ed.isInteger(A.encodingLevel)
                )
                  return "encodingLevel: integer expected";
                if (null != A.type && A.hasOwnProperty("type"))
                  switch (A.type) {
                    default:
                      return "type: enum value expected";
                    case 0:
                    case 1:
                    case 4:
                    case 6:
                    case 8:
                  }
                if (null != A.channelMapping && A.hasOwnProperty("channelMapping")) {
                  if (!Array.isArray(A.channelMapping)) return "channelMapping: array expected";
                  for (let e = 0; e < A.channelMapping.length; ++e)
                    switch (A.channelMapping[e]) {
                      default:
                        return "channelMapping: enum value[] expected";
                      case 0:
                      case 1:
                      case 2:
                      case 3:
                      case 4:
                      case 5:
                      case 6:
                      case 7:
                      case 8:
                    }
                }
                return null != A.frameLength &&
                  A.hasOwnProperty("frameLength") &&
                  !ed.isInteger(A.frameLength)
                  ? "frameLength: integer expected"
                  : null != A.avSync && A.hasOwnProperty("avSync") && "boolean" != typeof A.avSync
                    ? "avSync: boolean expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.StreamConfiguration) return A;
                let e = new td.dcv.audio.StreamConfiguration();
                switch (
                  (null != A.encodingLevel && (e.encodingLevel = A.encodingLevel >>> 0), A.type)
                ) {
                  default:
                    if ("number" == typeof A.type) {
                      e.type = A.type;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.type = 0;
                    break;
                  case "STEREO":
                  case 1:
                    e.type = 1;
                    break;
                  case "MULTI_CHANNEL_QUAD":
                  case 4:
                    e.type = 4;
                    break;
                  case "MULTI_CHANNEL_5_1":
                  case 6:
                    e.type = 6;
                    break;
                  case "MULTI_CHANNEL_7_1":
                  case 8:
                    e.type = 8;
                }
                if (A.channelMapping) {
                  if (!Array.isArray(A.channelMapping))
                    throw TypeError(
                      ".dcv.audio.StreamConfiguration.channelMapping: array expected"
                    );
                  e.channelMapping = [];
                  for (let t = 0; t < A.channelMapping.length; ++t)
                    switch (A.channelMapping[t]) {
                      default:
                        if ("number" == typeof A.channelMapping[t]) {
                          e.channelMapping[t] = A.channelMapping[t];
                          break;
                        }
                      case "CHANNEL_NONE":
                      case 0:
                        e.channelMapping[t] = 0;
                        break;
                      case "CHANNEL_LEFT":
                      case 1:
                        e.channelMapping[t] = 1;
                        break;
                      case "CHANNEL_RIGHT":
                      case 2:
                        e.channelMapping[t] = 2;
                        break;
                      case "CHANNEL_CENTER":
                      case 3:
                        e.channelMapping[t] = 3;
                        break;
                      case "CHANNEL_LFE":
                      case 4:
                        e.channelMapping[t] = 4;
                        break;
                      case "CHANNEL_REAR_LEFT":
                      case 5:
                        e.channelMapping[t] = 5;
                        break;
                      case "CHANNEL_REAR_RIGHT":
                      case 6:
                        e.channelMapping[t] = 6;
                        break;
                      case "CHANNEL_SIDE_LEFT":
                      case 7:
                        e.channelMapping[t] = 7;
                        break;
                      case "CHANNEL_SIDE_RIGHT":
                      case 8:
                        e.channelMapping[t] = 8;
                    }
                }
                return (
                  null != A.frameLength && (e.frameLength = A.frameLength >>> 0),
                  null != A.avSync && (e.avSync = Boolean(A.avSync)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.channelMapping = []),
                  e.defaults &&
                    ((t.encodingLevel = 0),
                    (t.type = e.enums === String ? "NONE" : 0),
                    (t.frameLength = 0),
                    (t.avSync = !1)),
                  null != A.encodingLevel &&
                    A.hasOwnProperty("encodingLevel") &&
                    (t.encodingLevel = A.encodingLevel),
                  null != A.type &&
                    A.hasOwnProperty("type") &&
                    (t.type =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioType[A.type]
                          ? A.type
                          : td.dcv.audio.AudioType[A.type]
                        : A.type),
                  A.channelMapping && A.channelMapping.length)
                ) {
                  t.channelMapping = [];
                  for (let i = 0; i < A.channelMapping.length; ++i)
                    t.channelMapping[i] =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioChannelPosition[A.channelMapping[i]]
                          ? A.channelMapping[i]
                          : td.dcv.audio.AudioChannelPosition[A.channelMapping[i]]
                        : A.channelMapping[i];
                }
                return (
                  null != A.frameLength &&
                    A.hasOwnProperty("frameLength") &&
                    (t.frameLength = A.frameLength),
                  null != A.avSync && A.hasOwnProperty("avSync") && (t.avSync = A.avSync),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.StreamConfiguration"
                );
              }),
              A
            );
          })()),
          (A.AudioSpectrum = (function () {
            function A(A) {
              if (((this.spectrum = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.spectrum = ed.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ad.create()), null != A.spectrum && A.spectrum.length)) {
                  e.uint32(10).fork();
                  for (let t = 0; t < A.spectrum.length; ++t) e.int32(A.spectrum[t]);
                  e.ldelim();
                }
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.AudioSpectrum();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1)
                    if (((i.spectrum && i.spectrum.length) || (i.spectrum = []), 2 == (7 & e))) {
                      let e = A.uint32() + A.pos;
                      for (; A.pos < e; ) i.spectrum.push(A.int32());
                    } else i.spectrum.push(A.int32());
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.spectrum && A.hasOwnProperty("spectrum")) {
                  if (!Array.isArray(A.spectrum)) return "spectrum: array expected";
                  for (let e = 0; e < A.spectrum.length; ++e)
                    if (!ed.isInteger(A.spectrum[e])) return "spectrum: integer[] expected";
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.AudioSpectrum) return A;
                let e = new td.dcv.audio.AudioSpectrum();
                if (A.spectrum) {
                  if (!Array.isArray(A.spectrum))
                    throw TypeError(".dcv.audio.AudioSpectrum.spectrum: array expected");
                  e.spectrum = [];
                  for (let t = 0; t < A.spectrum.length; ++t) e.spectrum[t] = 0 | A.spectrum[t];
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.spectrum = []), A.spectrum && A.spectrum.length)
                ) {
                  t.spectrum = [];
                  for (let e = 0; e < A.spectrum.length; ++e) t.spectrum[e] = A.spectrum[e];
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.AudioSpectrum";
              }),
              A
            );
          })()),
          (A.Capabilities = (function () {
            function A(A) {
              if (((this.audioCodecs = []), (this.preferredTypes = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.audioCodecs = ed.emptyArray),
              (A.prototype.preferredTypes = ed.emptyArray),
              (A.prototype.streamFrameLength = 0),
              (A.prototype.injectFrameLength = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if ((e || (e = Ad.create()), null != A.audioCodecs && A.audioCodecs.length))
                  for (let t = 0; t < A.audioCodecs.length; ++t)
                    td.dcv.audio.Capabilities.Codec.encode(
                      A.audioCodecs[t],
                      e.uint32(10).fork()
                    ).ldelim();
                if (
                  (null != A.streamFrameLength &&
                    Object.hasOwnProperty.call(A, "streamFrameLength") &&
                    e.uint32(16).uint32(A.streamFrameLength),
                  null != A.injectFrameLength &&
                    Object.hasOwnProperty.call(A, "injectFrameLength") &&
                    e.uint32(24).uint32(A.injectFrameLength),
                  null != A.preferredTypes && A.preferredTypes.length)
                ) {
                  e.uint32(82).fork();
                  for (let t = 0; t < A.preferredTypes.length; ++t) e.int32(A.preferredTypes[t]);
                  e.ldelim();
                }
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.Capabilities();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      (i.audioCodecs && i.audioCodecs.length) || (i.audioCodecs = []),
                        i.audioCodecs.push(td.dcv.audio.Capabilities.Codec.decode(A, A.uint32()));
                      break;
                    case 10:
                      if (
                        ((i.preferredTypes && i.preferredTypes.length) || (i.preferredTypes = []),
                        2 == (7 & e))
                      ) {
                        let e = A.uint32() + A.pos;
                        for (; A.pos < e; ) i.preferredTypes.push(A.int32());
                      } else i.preferredTypes.push(A.int32());
                      break;
                    case 2:
                      i.streamFrameLength = A.uint32();
                      break;
                    case 3:
                      i.injectFrameLength = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.audioCodecs && A.hasOwnProperty("audioCodecs")) {
                  if (!Array.isArray(A.audioCodecs)) return "audioCodecs: array expected";
                  for (let e = 0; e < A.audioCodecs.length; ++e) {
                    let t = td.dcv.audio.Capabilities.Codec.verify(A.audioCodecs[e]);
                    if (t) return "audioCodecs." + t;
                  }
                }
                if (null != A.preferredTypes && A.hasOwnProperty("preferredTypes")) {
                  if (!Array.isArray(A.preferredTypes)) return "preferredTypes: array expected";
                  for (let e = 0; e < A.preferredTypes.length; ++e)
                    switch (A.preferredTypes[e]) {
                      default:
                        return "preferredTypes: enum value[] expected";
                      case 0:
                      case 1:
                      case 4:
                      case 6:
                      case 8:
                    }
                }
                return null != A.streamFrameLength &&
                  A.hasOwnProperty("streamFrameLength") &&
                  !ed.isInteger(A.streamFrameLength)
                  ? "streamFrameLength: integer expected"
                  : null != A.injectFrameLength &&
                      A.hasOwnProperty("injectFrameLength") &&
                      !ed.isInteger(A.injectFrameLength)
                    ? "injectFrameLength: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.Capabilities) return A;
                let e = new td.dcv.audio.Capabilities();
                if (A.audioCodecs) {
                  if (!Array.isArray(A.audioCodecs))
                    throw TypeError(".dcv.audio.Capabilities.audioCodecs: array expected");
                  e.audioCodecs = [];
                  for (let t = 0; t < A.audioCodecs.length; ++t) {
                    if ("object" != typeof A.audioCodecs[t])
                      throw TypeError(".dcv.audio.Capabilities.audioCodecs: object expected");
                    e.audioCodecs[t] = td.dcv.audio.Capabilities.Codec.fromObject(A.audioCodecs[t]);
                  }
                }
                if (A.preferredTypes) {
                  if (!Array.isArray(A.preferredTypes))
                    throw TypeError(".dcv.audio.Capabilities.preferredTypes: array expected");
                  e.preferredTypes = [];
                  for (let t = 0; t < A.preferredTypes.length; ++t)
                    switch (A.preferredTypes[t]) {
                      default:
                        if ("number" == typeof A.preferredTypes[t]) {
                          e.preferredTypes[t] = A.preferredTypes[t];
                          break;
                        }
                      case "NONE":
                      case 0:
                        e.preferredTypes[t] = 0;
                        break;
                      case "STEREO":
                      case 1:
                        e.preferredTypes[t] = 1;
                        break;
                      case "MULTI_CHANNEL_QUAD":
                      case 4:
                        e.preferredTypes[t] = 4;
                        break;
                      case "MULTI_CHANNEL_5_1":
                      case 6:
                        e.preferredTypes[t] = 6;
                        break;
                      case "MULTI_CHANNEL_7_1":
                      case 8:
                        e.preferredTypes[t] = 8;
                    }
                }
                return (
                  null != A.streamFrameLength && (e.streamFrameLength = A.streamFrameLength >>> 0),
                  null != A.injectFrameLength && (e.injectFrameLength = A.injectFrameLength >>> 0),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && ((t.audioCodecs = []), (t.preferredTypes = [])),
                  e.defaults && ((t.streamFrameLength = 0), (t.injectFrameLength = 0)),
                  A.audioCodecs && A.audioCodecs.length)
                ) {
                  t.audioCodecs = [];
                  for (let i = 0; i < A.audioCodecs.length; ++i)
                    t.audioCodecs[i] = td.dcv.audio.Capabilities.Codec.toObject(
                      A.audioCodecs[i],
                      e
                    );
                }
                if (
                  (null != A.streamFrameLength &&
                    A.hasOwnProperty("streamFrameLength") &&
                    (t.streamFrameLength = A.streamFrameLength),
                  null != A.injectFrameLength &&
                    A.hasOwnProperty("injectFrameLength") &&
                    (t.injectFrameLength = A.injectFrameLength),
                  A.preferredTypes && A.preferredTypes.length)
                ) {
                  t.preferredTypes = [];
                  for (let i = 0; i < A.preferredTypes.length; ++i)
                    t.preferredTypes[i] =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioType[A.preferredTypes[i]]
                          ? A.preferredTypes[i]
                          : td.dcv.audio.AudioType[A.preferredTypes[i]]
                        : A.preferredTypes[i];
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.Capabilities";
              }),
              (A.Codec = (function () {
                function A(A) {
                  if (((this.audioProfiles = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.audioProfiles = ed.emptyArray),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ad.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.audioProfiles && A.audioProfiles.length)
                    )
                      for (let t = 0; t < A.audioProfiles.length; ++t)
                        e.uint32(18).string(A.audioProfiles[t]);
                    return e;
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.Capabilities.Codec();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 2:
                          (i.audioProfiles && i.audioProfiles.length) || (i.audioProfiles = []),
                            i.audioProfiles.push(A.string());
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !ed.isString(A.name))
                      return "name: string expected";
                    if (null != A.audioProfiles && A.hasOwnProperty("audioProfiles")) {
                      if (!Array.isArray(A.audioProfiles)) return "audioProfiles: array expected";
                      for (let e = 0; e < A.audioProfiles.length; ++e)
                        if (!ed.isString(A.audioProfiles[e]))
                          return "audioProfiles: string[] expected";
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.Capabilities.Codec) return A;
                    let e = new td.dcv.audio.Capabilities.Codec();
                    if ((null != A.name && (e.name = String(A.name)), A.audioProfiles)) {
                      if (!Array.isArray(A.audioProfiles))
                        throw TypeError(
                          ".dcv.audio.Capabilities.Codec.audioProfiles: array expected"
                        );
                      e.audioProfiles = [];
                      for (let t = 0; t < A.audioProfiles.length; ++t)
                        e.audioProfiles[t] = String(A.audioProfiles[t]);
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && (t.audioProfiles = []),
                      e.defaults && (t.name = ""),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      A.audioProfiles && A.audioProfiles.length)
                    ) {
                      t.audioProfiles = [];
                      for (let e = 0; e < A.audioProfiles.length; ++e)
                        t.audioProfiles[e] = A.audioProfiles[e];
                    }
                    return t;
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.Capabilities.Codec"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.StartService = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.service = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.service &&
                    Object.hasOwnProperty.call(A, "service") &&
                    e.uint32(8).int32(A.service),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.StartService();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.service = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.service && A.hasOwnProperty("service"))
                  switch (A.service) {
                    default:
                      return "service: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.StartService) return A;
                let e = new td.dcv.audio.StartService();
                switch (A.service) {
                  default:
                    if ("number" == typeof A.service) {
                      e.service = A.service;
                      break;
                    }
                    break;
                  case "STREAM":
                  case 0:
                    e.service = 0;
                    break;
                  case "INJECTION":
                  case 1:
                    e.service = 1;
                    break;
                  case "SPECTRUM":
                  case 2:
                    e.service = 2;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.service = e.enums === String ? "STREAM" : 0),
                  null != A.service &&
                    A.hasOwnProperty("service") &&
                    (t.service =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioService[A.service]
                          ? A.service
                          : td.dcv.audio.AudioService[A.service]
                        : A.service),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.StartService";
              }),
              A
            );
          })()),
          (A.StopService = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.service = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.service &&
                    Object.hasOwnProperty.call(A, "service") &&
                    e.uint32(8).int32(A.service),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.StopService();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.service = A.int32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.service && A.hasOwnProperty("service"))
                  switch (A.service) {
                    default:
                      return "service: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.StopService) return A;
                let e = new td.dcv.audio.StopService();
                switch (A.service) {
                  default:
                    if ("number" == typeof A.service) {
                      e.service = A.service;
                      break;
                    }
                    break;
                  case "STREAM":
                  case 0:
                    e.service = 0;
                    break;
                  case "INJECTION":
                  case 1:
                    e.service = 1;
                    break;
                  case "SPECTRUM":
                  case 2:
                    e.service = 2;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.service = e.enums === String ? "STREAM" : 0),
                  null != A.service &&
                    A.hasOwnProperty("service") &&
                    (t.service =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioService[A.service]
                          ? A.service
                          : td.dcv.audio.AudioService[A.service]
                        : A.service),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.StopService";
              }),
              A
            );
          })()),
          (A.SetStreamConfiguration = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.encodingLevel = 0),
              (A.prototype.type = 0),
              (A.prototype.frameLength = 0),
              (A.prototype.avSync = !1),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.encodingLevel &&
                    Object.hasOwnProperty.call(A, "encodingLevel") &&
                    e.uint32(8).uint32(A.encodingLevel),
                  null != A.type &&
                    Object.hasOwnProperty.call(A, "type") &&
                    e.uint32(16).int32(A.type),
                  null != A.frameLength &&
                    Object.hasOwnProperty.call(A, "frameLength") &&
                    e.uint32(40).uint32(A.frameLength),
                  null != A.avSync &&
                    Object.hasOwnProperty.call(A, "avSync") &&
                    e.uint32(240).bool(A.avSync),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.SetStreamConfiguration();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.encodingLevel = A.uint32();
                      break;
                    case 2:
                      i.type = A.int32();
                      break;
                    case 5:
                      i.frameLength = A.uint32();
                      break;
                    case 30:
                      i.avSync = A.bool();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.encodingLevel &&
                  A.hasOwnProperty("encodingLevel") &&
                  !ed.isInteger(A.encodingLevel)
                )
                  return "encodingLevel: integer expected";
                if (null != A.type && A.hasOwnProperty("type"))
                  switch (A.type) {
                    default:
                      return "type: enum value expected";
                    case 0:
                    case 1:
                    case 4:
                    case 6:
                    case 8:
                  }
                return null != A.frameLength &&
                  A.hasOwnProperty("frameLength") &&
                  !ed.isInteger(A.frameLength)
                  ? "frameLength: integer expected"
                  : null != A.avSync && A.hasOwnProperty("avSync") && "boolean" != typeof A.avSync
                    ? "avSync: boolean expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.SetStreamConfiguration) return A;
                let e = new td.dcv.audio.SetStreamConfiguration();
                switch (
                  (null != A.encodingLevel && (e.encodingLevel = A.encodingLevel >>> 0), A.type)
                ) {
                  default:
                    if ("number" == typeof A.type) {
                      e.type = A.type;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.type = 0;
                    break;
                  case "STEREO":
                  case 1:
                    e.type = 1;
                    break;
                  case "MULTI_CHANNEL_QUAD":
                  case 4:
                    e.type = 4;
                    break;
                  case "MULTI_CHANNEL_5_1":
                  case 6:
                    e.type = 6;
                    break;
                  case "MULTI_CHANNEL_7_1":
                  case 8:
                    e.type = 8;
                }
                return (
                  null != A.frameLength && (e.frameLength = A.frameLength >>> 0),
                  null != A.avSync && (e.avSync = Boolean(A.avSync)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.encodingLevel = 0),
                    (t.type = e.enums === String ? "NONE" : 0),
                    (t.frameLength = 0),
                    (t.avSync = !1)),
                  null != A.encodingLevel &&
                    A.hasOwnProperty("encodingLevel") &&
                    (t.encodingLevel = A.encodingLevel),
                  null != A.type &&
                    A.hasOwnProperty("type") &&
                    (t.type =
                      e.enums === String
                        ? void 0 === td.dcv.audio.AudioType[A.type]
                          ? A.type
                          : td.dcv.audio.AudioType[A.type]
                        : A.type),
                  null != A.frameLength &&
                    A.hasOwnProperty("frameLength") &&
                    (t.frameLength = A.frameLength),
                  null != A.avSync && A.hasOwnProperty("avSync") && (t.avSync = A.avSync),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.audio.SetStreamConfiguration"
                );
              }),
              A
            );
          })()),
          (A.AudioPacket = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.timestamp = ed.Long ? ed.Long.fromBits(0, 0, !1) : 0),
              (A.prototype.strength = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.timestamp &&
                    Object.hasOwnProperty.call(A, "timestamp") &&
                    e.uint32(8).int64(A.timestamp),
                  null != A.strength &&
                    Object.hasOwnProperty.call(A, "strength") &&
                    e.uint32(85).float(A.strength),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.AudioPacket();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.timestamp = A.int64();
                      break;
                    case 10:
                      i.strength = A.float();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.timestamp &&
                      A.hasOwnProperty("timestamp") &&
                      !(
                        ed.isInteger(A.timestamp) ||
                        (A.timestamp &&
                          ed.isInteger(A.timestamp.low) &&
                          ed.isInteger(A.timestamp.high))
                      )
                    ? "timestamp: integer|Long expected"
                    : null != A.strength &&
                        A.hasOwnProperty("strength") &&
                        "number" != typeof A.strength
                      ? "strength: number expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.AudioPacket) return A;
                let e = new td.dcv.audio.AudioPacket();
                return (
                  null != A.timestamp &&
                    (ed.Long
                      ? ((e.timestamp = ed.Long.fromValue(A.timestamp)).unsigned = !1)
                      : "string" == typeof A.timestamp
                        ? (e.timestamp = parseInt(A.timestamp, 10))
                        : "number" == typeof A.timestamp
                          ? (e.timestamp = A.timestamp)
                          : "object" == typeof A.timestamp &&
                            (e.timestamp = new ed.LongBits(
                              A.timestamp.low >>> 0,
                              A.timestamp.high >>> 0
                            ).toNumber())),
                  null != A.strength && (e.strength = Number(A.strength)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (ed.Long) {
                    let A = new ed.Long(0, 0, !1);
                    t.timestamp =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.timestamp = e.longs === String ? "0" : 0;
                  t.strength = 0;
                }
                return (
                  null != A.timestamp &&
                    A.hasOwnProperty("timestamp") &&
                    ("number" == typeof A.timestamp
                      ? (t.timestamp = e.longs === String ? String(A.timestamp) : A.timestamp)
                      : (t.timestamp =
                          e.longs === String
                            ? ed.Long.prototype.toString.call(A.timestamp)
                            : e.longs === Number
                              ? new ed.LongBits(
                                  A.timestamp.low >>> 0,
                                  A.timestamp.high >>> 0
                                ).toNumber()
                              : A.timestamp)),
                  null != A.strength &&
                    A.hasOwnProperty("strength") &&
                    (t.strength =
                      e.json && !isFinite(A.strength) ? String(A.strength) : A.strength),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.AudioPacket";
              }),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.capabilities = null),
              (A.prototype.startService = null),
              (A.prototype.stopService = null),
              (A.prototype.setStreamConfiguration = null),
              (A.prototype.audioPacket = null),
              (A.prototype.webcamAttach = null),
              (A.prototype.webcamDetach = null),
              (A.prototype.webcamFrame = null),
              Object.defineProperty(A.prototype, "msg", {
                get: ed.oneOfGetter(
                  (e = [
                    "capabilities",
                    "startService",
                    "stopService",
                    "setStreamConfiguration",
                    "audioPacket",
                    "webcamAttach",
                    "webcamDetach",
                    "webcamFrame"
                  ])
                ),
                set: ed.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.capabilities &&
                    Object.hasOwnProperty.call(A, "capabilities") &&
                    td.dcv.audio.Capabilities.encode(A.capabilities, e.uint32(82).fork()).ldelim(),
                  null != A.startService &&
                    Object.hasOwnProperty.call(A, "startService") &&
                    td.dcv.audio.StartService.encode(A.startService, e.uint32(162).fork()).ldelim(),
                  null != A.stopService &&
                    Object.hasOwnProperty.call(A, "stopService") &&
                    td.dcv.audio.StopService.encode(A.stopService, e.uint32(170).fork()).ldelim(),
                  null != A.setStreamConfiguration &&
                    Object.hasOwnProperty.call(A, "setStreamConfiguration") &&
                    td.dcv.audio.SetStreamConfiguration.encode(
                      A.setStreamConfiguration,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.audioPacket &&
                    Object.hasOwnProperty.call(A, "audioPacket") &&
                    td.dcv.audio.AudioPacket.encode(A.audioPacket, e.uint32(322).fork()).ldelim(),
                  null != A.webcamAttach &&
                    Object.hasOwnProperty.call(A, "webcamAttach") &&
                    td.dcv.audio.webcam.Attach.encode(
                      A.webcamAttach,
                      e.uint32(482).fork()
                    ).ldelim(),
                  null != A.webcamDetach &&
                    Object.hasOwnProperty.call(A, "webcamDetach") &&
                    td.dcv.audio.webcam.Detach.encode(
                      A.webcamDetach,
                      e.uint32(490).fork()
                    ).ldelim(),
                  null != A.webcamFrame &&
                    Object.hasOwnProperty.call(A, "webcamFrame") &&
                    td.dcv.audio.webcam.Frame.encode(A.webcamFrame, e.uint32(498).fork()).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.capabilities = td.dcv.audio.Capabilities.decode(A, A.uint32());
                      break;
                    case 20:
                      i.startService = td.dcv.audio.StartService.decode(A, A.uint32());
                      break;
                    case 21:
                      i.stopService = td.dcv.audio.StopService.decode(A, A.uint32());
                      break;
                    case 30:
                      i.setStreamConfiguration = td.dcv.audio.SetStreamConfiguration.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 40:
                      i.audioPacket = td.dcv.audio.AudioPacket.decode(A, A.uint32());
                      break;
                    case 60:
                      i.webcamAttach = td.dcv.audio.webcam.Attach.decode(A, A.uint32());
                      break;
                    case 61:
                      i.webcamDetach = td.dcv.audio.webcam.Detach.decode(A, A.uint32());
                      break;
                    case 62:
                      i.webcamFrame = td.dcv.audio.webcam.Frame.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.capabilities && A.hasOwnProperty("capabilities")) {
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.Capabilities.verify(A.capabilities);
                    if (e) return "capabilities." + e;
                  }
                }
                if (null != A.startService && A.hasOwnProperty("startService")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.StartService.verify(A.startService);
                    if (e) return "startService." + e;
                  }
                }
                if (null != A.stopService && A.hasOwnProperty("stopService")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.StopService.verify(A.stopService);
                    if (e) return "stopService." + e;
                  }
                }
                if (
                  null != A.setStreamConfiguration &&
                  A.hasOwnProperty("setStreamConfiguration")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.SetStreamConfiguration.verify(A.setStreamConfiguration);
                    if (e) return "setStreamConfiguration." + e;
                  }
                }
                if (null != A.audioPacket && A.hasOwnProperty("audioPacket")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.AudioPacket.verify(A.audioPacket);
                    if (e) return "audioPacket." + e;
                  }
                }
                if (null != A.webcamAttach && A.hasOwnProperty("webcamAttach")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.Attach.verify(A.webcamAttach);
                    if (e) return "webcamAttach." + e;
                  }
                }
                if (null != A.webcamDetach && A.hasOwnProperty("webcamDetach")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.Detach.verify(A.webcamDetach);
                    if (e) return "webcamDetach." + e;
                  }
                }
                if (null != A.webcamFrame && A.hasOwnProperty("webcamFrame")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.Frame.verify(A.webcamFrame);
                    if (e) return "webcamFrame." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.ClientMessage) return A;
                let e = new td.dcv.audio.ClientMessage();
                if (null != A.capabilities) {
                  if ("object" != typeof A.capabilities)
                    throw TypeError(".dcv.audio.ClientMessage.capabilities: object expected");
                  e.capabilities = td.dcv.audio.Capabilities.fromObject(A.capabilities);
                }
                if (null != A.startService) {
                  if ("object" != typeof A.startService)
                    throw TypeError(".dcv.audio.ClientMessage.startService: object expected");
                  e.startService = td.dcv.audio.StartService.fromObject(A.startService);
                }
                if (null != A.stopService) {
                  if ("object" != typeof A.stopService)
                    throw TypeError(".dcv.audio.ClientMessage.stopService: object expected");
                  e.stopService = td.dcv.audio.StopService.fromObject(A.stopService);
                }
                if (null != A.setStreamConfiguration) {
                  if ("object" != typeof A.setStreamConfiguration)
                    throw TypeError(
                      ".dcv.audio.ClientMessage.setStreamConfiguration: object expected"
                    );
                  e.setStreamConfiguration = td.dcv.audio.SetStreamConfiguration.fromObject(
                    A.setStreamConfiguration
                  );
                }
                if (null != A.audioPacket) {
                  if ("object" != typeof A.audioPacket)
                    throw TypeError(".dcv.audio.ClientMessage.audioPacket: object expected");
                  e.audioPacket = td.dcv.audio.AudioPacket.fromObject(A.audioPacket);
                }
                if (null != A.webcamAttach) {
                  if ("object" != typeof A.webcamAttach)
                    throw TypeError(".dcv.audio.ClientMessage.webcamAttach: object expected");
                  e.webcamAttach = td.dcv.audio.webcam.Attach.fromObject(A.webcamAttach);
                }
                if (null != A.webcamDetach) {
                  if ("object" != typeof A.webcamDetach)
                    throw TypeError(".dcv.audio.ClientMessage.webcamDetach: object expected");
                  e.webcamDetach = td.dcv.audio.webcam.Detach.fromObject(A.webcamDetach);
                }
                if (null != A.webcamFrame) {
                  if ("object" != typeof A.webcamFrame)
                    throw TypeError(".dcv.audio.ClientMessage.webcamFrame: object expected");
                  e.webcamFrame = td.dcv.audio.webcam.Frame.fromObject(A.webcamFrame);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.capabilities &&
                    A.hasOwnProperty("capabilities") &&
                    ((t.capabilities = td.dcv.audio.Capabilities.toObject(A.capabilities, e)),
                    e.oneofs && (t.msg = "capabilities")),
                  null != A.startService &&
                    A.hasOwnProperty("startService") &&
                    ((t.startService = td.dcv.audio.StartService.toObject(A.startService, e)),
                    e.oneofs && (t.msg = "startService")),
                  null != A.stopService &&
                    A.hasOwnProperty("stopService") &&
                    ((t.stopService = td.dcv.audio.StopService.toObject(A.stopService, e)),
                    e.oneofs && (t.msg = "stopService")),
                  null != A.setStreamConfiguration &&
                    A.hasOwnProperty("setStreamConfiguration") &&
                    ((t.setStreamConfiguration = td.dcv.audio.SetStreamConfiguration.toObject(
                      A.setStreamConfiguration,
                      e
                    )),
                    e.oneofs && (t.msg = "setStreamConfiguration")),
                  null != A.audioPacket &&
                    A.hasOwnProperty("audioPacket") &&
                    ((t.audioPacket = td.dcv.audio.AudioPacket.toObject(A.audioPacket, e)),
                    e.oneofs && (t.msg = "audioPacket")),
                  null != A.webcamAttach &&
                    A.hasOwnProperty("webcamAttach") &&
                    ((t.webcamAttach = td.dcv.audio.webcam.Attach.toObject(A.webcamAttach, e)),
                    e.oneofs && (t.msg = "webcamAttach")),
                  null != A.webcamDetach &&
                    A.hasOwnProperty("webcamDetach") &&
                    ((t.webcamDetach = td.dcv.audio.webcam.Detach.toObject(A.webcamDetach, e)),
                    e.oneofs && (t.msg = "webcamDetach")),
                  null != A.webcamFrame &&
                    A.hasOwnProperty("webcamFrame") &&
                    ((t.webcamFrame = td.dcv.audio.webcam.Frame.toObject(A.webcamFrame, e)),
                    e.oneofs && (t.msg = "webcamFrame")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.ClientMessage";
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.handshakeStart = null),
              (A.prototype.configuration = null),
              (A.prototype.statusUpdate = null),
              (A.prototype.streamConfiguration = null),
              (A.prototype.audioSpectrum = null),
              (A.prototype.audioPacket = null),
              (A.prototype.webcamServerCapabilities = null),
              (A.prototype.webcamStatusUpdate = null),
              (A.prototype.webcamStreamingConfiguration = null),
              (A.prototype.webcamAck = null),
              (A.prototype.webcamErrorResponse = null),
              Object.defineProperty(A.prototype, "msg", {
                get: ed.oneOfGetter(
                  (e = [
                    "handshakeStart",
                    "configuration",
                    "statusUpdate",
                    "streamConfiguration",
                    "audioSpectrum",
                    "audioPacket",
                    "webcamServerCapabilities",
                    "webcamStatusUpdate",
                    "webcamStreamingConfiguration",
                    "webcamAck",
                    "webcamErrorResponse"
                  ])
                ),
                set: ed.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Ad.create()),
                  null != A.handshakeStart &&
                    Object.hasOwnProperty.call(A, "handshakeStart") &&
                    td.dcv.audio.HandshakeStart.encode(
                      A.handshakeStart,
                      e.uint32(10).fork()
                    ).ldelim(),
                  null != A.configuration &&
                    Object.hasOwnProperty.call(A, "configuration") &&
                    td.dcv.audio.Configuration.encode(
                      A.configuration,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.statusUpdate &&
                    Object.hasOwnProperty.call(A, "statusUpdate") &&
                    td.dcv.audio.StatusUpdate.encode(A.statusUpdate, e.uint32(162).fork()).ldelim(),
                  null != A.streamConfiguration &&
                    Object.hasOwnProperty.call(A, "streamConfiguration") &&
                    td.dcv.audio.StreamConfiguration.encode(
                      A.streamConfiguration,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.audioSpectrum &&
                    Object.hasOwnProperty.call(A, "audioSpectrum") &&
                    td.dcv.audio.AudioSpectrum.encode(
                      A.audioSpectrum,
                      e.uint32(322).fork()
                    ).ldelim(),
                  null != A.audioPacket &&
                    Object.hasOwnProperty.call(A, "audioPacket") &&
                    td.dcv.audio.AudioPacket.encode(A.audioPacket, e.uint32(402).fork()).ldelim(),
                  null != A.webcamServerCapabilities &&
                    Object.hasOwnProperty.call(A, "webcamServerCapabilities") &&
                    td.dcv.audio.webcam.ServerCapabilities.encode(
                      A.webcamServerCapabilities,
                      e.uint32(482).fork()
                    ).ldelim(),
                  null != A.webcamStatusUpdate &&
                    Object.hasOwnProperty.call(A, "webcamStatusUpdate") &&
                    td.dcv.audio.webcam.StatusUpdate.encode(
                      A.webcamStatusUpdate,
                      e.uint32(490).fork()
                    ).ldelim(),
                  null != A.webcamStreamingConfiguration &&
                    Object.hasOwnProperty.call(A, "webcamStreamingConfiguration") &&
                    td.dcv.audio.webcam.StreamConfiguration.encode(
                      A.webcamStreamingConfiguration,
                      e.uint32(498).fork()
                    ).ldelim(),
                  null != A.webcamAck &&
                    Object.hasOwnProperty.call(A, "webcamAck") &&
                    td.dcv.audio.webcam.Ack.encode(A.webcamAck, e.uint32(506).fork()).ldelim(),
                  null != A.webcamErrorResponse &&
                    Object.hasOwnProperty.call(A, "webcamErrorResponse") &&
                    td.dcv.audio.webcam.ErrorResponse.encode(
                      A.webcamErrorResponse,
                      e.uint32(514).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof $l || (A = $l.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new td.dcv.audio.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.handshakeStart = td.dcv.audio.HandshakeStart.decode(A, A.uint32());
                      break;
                    case 10:
                      i.configuration = td.dcv.audio.Configuration.decode(A, A.uint32());
                      break;
                    case 20:
                      i.statusUpdate = td.dcv.audio.StatusUpdate.decode(A, A.uint32());
                      break;
                    case 30:
                      i.streamConfiguration = td.dcv.audio.StreamConfiguration.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 40:
                      i.audioSpectrum = td.dcv.audio.AudioSpectrum.decode(A, A.uint32());
                      break;
                    case 50:
                      i.audioPacket = td.dcv.audio.AudioPacket.decode(A, A.uint32());
                      break;
                    case 60:
                      i.webcamServerCapabilities = td.dcv.audio.webcam.ServerCapabilities.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 61:
                      i.webcamStatusUpdate = td.dcv.audio.webcam.StatusUpdate.decode(A, A.uint32());
                      break;
                    case 62:
                      i.webcamStreamingConfiguration =
                        td.dcv.audio.webcam.StreamConfiguration.decode(A, A.uint32());
                      break;
                    case 63:
                      i.webcamAck = td.dcv.audio.webcam.Ack.decode(A, A.uint32());
                      break;
                    case 64:
                      i.webcamErrorResponse = td.dcv.audio.webcam.ErrorResponse.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.handshakeStart && A.hasOwnProperty("handshakeStart")) {
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.HandshakeStart.verify(A.handshakeStart);
                    if (e) return "handshakeStart." + e;
                  }
                }
                if (null != A.configuration && A.hasOwnProperty("configuration")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.Configuration.verify(A.configuration);
                    if (e) return "configuration." + e;
                  }
                }
                if (null != A.statusUpdate && A.hasOwnProperty("statusUpdate")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.StatusUpdate.verify(A.statusUpdate);
                    if (e) return "statusUpdate." + e;
                  }
                }
                if (null != A.streamConfiguration && A.hasOwnProperty("streamConfiguration")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.StreamConfiguration.verify(A.streamConfiguration);
                    if (e) return "streamConfiguration." + e;
                  }
                }
                if (null != A.audioSpectrum && A.hasOwnProperty("audioSpectrum")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.AudioSpectrum.verify(A.audioSpectrum);
                    if (e) return "audioSpectrum." + e;
                  }
                }
                if (null != A.audioPacket && A.hasOwnProperty("audioPacket")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.AudioPacket.verify(A.audioPacket);
                    if (e) return "audioPacket." + e;
                  }
                }
                if (
                  null != A.webcamServerCapabilities &&
                  A.hasOwnProperty("webcamServerCapabilities")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.ServerCapabilities.verify(
                      A.webcamServerCapabilities
                    );
                    if (e) return "webcamServerCapabilities." + e;
                  }
                }
                if (null != A.webcamStatusUpdate && A.hasOwnProperty("webcamStatusUpdate")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.StatusUpdate.verify(A.webcamStatusUpdate);
                    if (e) return "webcamStatusUpdate." + e;
                  }
                }
                if (
                  null != A.webcamStreamingConfiguration &&
                  A.hasOwnProperty("webcamStreamingConfiguration")
                ) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.StreamConfiguration.verify(
                      A.webcamStreamingConfiguration
                    );
                    if (e) return "webcamStreamingConfiguration." + e;
                  }
                }
                if (null != A.webcamAck && A.hasOwnProperty("webcamAck")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.Ack.verify(A.webcamAck);
                    if (e) return "webcamAck." + e;
                  }
                }
                if (null != A.webcamErrorResponse && A.hasOwnProperty("webcamErrorResponse")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = td.dcv.audio.webcam.ErrorResponse.verify(A.webcamErrorResponse);
                    if (e) return "webcamErrorResponse." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof td.dcv.audio.ServerMessage) return A;
                let e = new td.dcv.audio.ServerMessage();
                if (null != A.handshakeStart) {
                  if ("object" != typeof A.handshakeStart)
                    throw TypeError(".dcv.audio.ServerMessage.handshakeStart: object expected");
                  e.handshakeStart = td.dcv.audio.HandshakeStart.fromObject(A.handshakeStart);
                }
                if (null != A.configuration) {
                  if ("object" != typeof A.configuration)
                    throw TypeError(".dcv.audio.ServerMessage.configuration: object expected");
                  e.configuration = td.dcv.audio.Configuration.fromObject(A.configuration);
                }
                if (null != A.statusUpdate) {
                  if ("object" != typeof A.statusUpdate)
                    throw TypeError(".dcv.audio.ServerMessage.statusUpdate: object expected");
                  e.statusUpdate = td.dcv.audio.StatusUpdate.fromObject(A.statusUpdate);
                }
                if (null != A.streamConfiguration) {
                  if ("object" != typeof A.streamConfiguration)
                    throw TypeError(
                      ".dcv.audio.ServerMessage.streamConfiguration: object expected"
                    );
                  e.streamConfiguration = td.dcv.audio.StreamConfiguration.fromObject(
                    A.streamConfiguration
                  );
                }
                if (null != A.audioSpectrum) {
                  if ("object" != typeof A.audioSpectrum)
                    throw TypeError(".dcv.audio.ServerMessage.audioSpectrum: object expected");
                  e.audioSpectrum = td.dcv.audio.AudioSpectrum.fromObject(A.audioSpectrum);
                }
                if (null != A.audioPacket) {
                  if ("object" != typeof A.audioPacket)
                    throw TypeError(".dcv.audio.ServerMessage.audioPacket: object expected");
                  e.audioPacket = td.dcv.audio.AudioPacket.fromObject(A.audioPacket);
                }
                if (null != A.webcamServerCapabilities) {
                  if ("object" != typeof A.webcamServerCapabilities)
                    throw TypeError(
                      ".dcv.audio.ServerMessage.webcamServerCapabilities: object expected"
                    );
                  e.webcamServerCapabilities = td.dcv.audio.webcam.ServerCapabilities.fromObject(
                    A.webcamServerCapabilities
                  );
                }
                if (null != A.webcamStatusUpdate) {
                  if ("object" != typeof A.webcamStatusUpdate)
                    throw TypeError(".dcv.audio.ServerMessage.webcamStatusUpdate: object expected");
                  e.webcamStatusUpdate = td.dcv.audio.webcam.StatusUpdate.fromObject(
                    A.webcamStatusUpdate
                  );
                }
                if (null != A.webcamStreamingConfiguration) {
                  if ("object" != typeof A.webcamStreamingConfiguration)
                    throw TypeError(
                      ".dcv.audio.ServerMessage.webcamStreamingConfiguration: object expected"
                    );
                  e.webcamStreamingConfiguration =
                    td.dcv.audio.webcam.StreamConfiguration.fromObject(
                      A.webcamStreamingConfiguration
                    );
                }
                if (null != A.webcamAck) {
                  if ("object" != typeof A.webcamAck)
                    throw TypeError(".dcv.audio.ServerMessage.webcamAck: object expected");
                  e.webcamAck = td.dcv.audio.webcam.Ack.fromObject(A.webcamAck);
                }
                if (null != A.webcamErrorResponse) {
                  if ("object" != typeof A.webcamErrorResponse)
                    throw TypeError(
                      ".dcv.audio.ServerMessage.webcamErrorResponse: object expected"
                    );
                  e.webcamErrorResponse = td.dcv.audio.webcam.ErrorResponse.fromObject(
                    A.webcamErrorResponse
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.handshakeStart &&
                    A.hasOwnProperty("handshakeStart") &&
                    ((t.handshakeStart = td.dcv.audio.HandshakeStart.toObject(A.handshakeStart, e)),
                    e.oneofs && (t.msg = "handshakeStart")),
                  null != A.configuration &&
                    A.hasOwnProperty("configuration") &&
                    ((t.configuration = td.dcv.audio.Configuration.toObject(A.configuration, e)),
                    e.oneofs && (t.msg = "configuration")),
                  null != A.statusUpdate &&
                    A.hasOwnProperty("statusUpdate") &&
                    ((t.statusUpdate = td.dcv.audio.StatusUpdate.toObject(A.statusUpdate, e)),
                    e.oneofs && (t.msg = "statusUpdate")),
                  null != A.streamConfiguration &&
                    A.hasOwnProperty("streamConfiguration") &&
                    ((t.streamConfiguration = td.dcv.audio.StreamConfiguration.toObject(
                      A.streamConfiguration,
                      e
                    )),
                    e.oneofs && (t.msg = "streamConfiguration")),
                  null != A.audioSpectrum &&
                    A.hasOwnProperty("audioSpectrum") &&
                    ((t.audioSpectrum = td.dcv.audio.AudioSpectrum.toObject(A.audioSpectrum, e)),
                    e.oneofs && (t.msg = "audioSpectrum")),
                  null != A.audioPacket &&
                    A.hasOwnProperty("audioPacket") &&
                    ((t.audioPacket = td.dcv.audio.AudioPacket.toObject(A.audioPacket, e)),
                    e.oneofs && (t.msg = "audioPacket")),
                  null != A.webcamServerCapabilities &&
                    A.hasOwnProperty("webcamServerCapabilities") &&
                    ((t.webcamServerCapabilities = td.dcv.audio.webcam.ServerCapabilities.toObject(
                      A.webcamServerCapabilities,
                      e
                    )),
                    e.oneofs && (t.msg = "webcamServerCapabilities")),
                  null != A.webcamStatusUpdate &&
                    A.hasOwnProperty("webcamStatusUpdate") &&
                    ((t.webcamStatusUpdate = td.dcv.audio.webcam.StatusUpdate.toObject(
                      A.webcamStatusUpdate,
                      e
                    )),
                    e.oneofs && (t.msg = "webcamStatusUpdate")),
                  null != A.webcamStreamingConfiguration &&
                    A.hasOwnProperty("webcamStreamingConfiguration") &&
                    ((t.webcamStreamingConfiguration =
                      td.dcv.audio.webcam.StreamConfiguration.toObject(
                        A.webcamStreamingConfiguration,
                        e
                      )),
                    e.oneofs && (t.msg = "webcamStreamingConfiguration")),
                  null != A.webcamAck &&
                    A.hasOwnProperty("webcamAck") &&
                    ((t.webcamAck = td.dcv.audio.webcam.Ack.toObject(A.webcamAck, e)),
                    e.oneofs && (t.msg = "webcamAck")),
                  null != A.webcamErrorResponse &&
                    A.hasOwnProperty("webcamErrorResponse") &&
                    ((t.webcamErrorResponse = td.dcv.audio.webcam.ErrorResponse.toObject(
                      A.webcamErrorResponse,
                      e
                    )),
                    e.oneofs && (t.msg = "webcamErrorResponse")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.ServerMessage";
              }),
              A
            );
          })()),
          (A.webcam = (function () {
            const A = {};
            return (
              (A.Resolution = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.width = 0),
                  (A.prototype.height = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.width &&
                        Object.hasOwnProperty.call(A, "width") &&
                        e.uint32(8).uint32(A.width),
                      null != A.height &&
                        Object.hasOwnProperty.call(A, "height") &&
                        e.uint32(16).uint32(A.height),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.Resolution();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.width = A.uint32();
                          break;
                        case 2:
                          i.height = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.width && A.hasOwnProperty("width") && !ed.isInteger(A.width)
                        ? "width: integer expected"
                        : null != A.height && A.hasOwnProperty("height") && !ed.isInteger(A.height)
                          ? "height: integer expected"
                          : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.Resolution) return A;
                    let e = new td.dcv.audio.webcam.Resolution();
                    return (
                      null != A.width && (e.width = A.width >>> 0),
                      null != A.height && (e.height = A.height >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.width = 0), (t.height = 0)),
                      null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                      null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.Resolution"
                    );
                  }),
                  A
                );
              })()),
              (A.Codec = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.Codec();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.name = A.string();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.name && A.hasOwnProperty("name") && !ed.isString(A.name)
                        ? "name: string expected"
                        : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.Codec) return A;
                    let e = new td.dcv.audio.webcam.Codec();
                    return null != A.name && (e.name = String(A.name)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.name = ""),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Codec"
                    );
                  }),
                  A
                );
              })()),
              (A.ServerCapabilities = (function () {
                function A(A) {
                  if (((this.codecs = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.codecs = ed.emptyArray),
                  (A.prototype.maxResolution = null),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if ((e || (e = Ad.create()), null != A.codecs && A.codecs.length))
                      for (let t = 0; t < A.codecs.length; ++t)
                        td.dcv.audio.webcam.Codec.encode(A.codecs[t], e.uint32(10).fork()).ldelim();
                    return (
                      null != A.maxResolution &&
                        Object.hasOwnProperty.call(A, "maxResolution") &&
                        td.dcv.audio.webcam.Resolution.encode(
                          A.maxResolution,
                          e.uint32(18).fork()
                        ).ldelim(),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.ServerCapabilities();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          (i.codecs && i.codecs.length) || (i.codecs = []),
                            i.codecs.push(td.dcv.audio.webcam.Codec.decode(A, A.uint32()));
                          break;
                        case 2:
                          i.maxResolution = td.dcv.audio.webcam.Resolution.decode(A, A.uint32());
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.codecs && A.hasOwnProperty("codecs")) {
                      if (!Array.isArray(A.codecs)) return "codecs: array expected";
                      for (let e = 0; e < A.codecs.length; ++e) {
                        let t = td.dcv.audio.webcam.Codec.verify(A.codecs[e]);
                        if (t) return "codecs." + t;
                      }
                    }
                    if (null != A.maxResolution && A.hasOwnProperty("maxResolution")) {
                      let e = td.dcv.audio.webcam.Resolution.verify(A.maxResolution);
                      if (e) return "maxResolution." + e;
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.ServerCapabilities) return A;
                    let e = new td.dcv.audio.webcam.ServerCapabilities();
                    if (A.codecs) {
                      if (!Array.isArray(A.codecs))
                        throw TypeError(
                          ".dcv.audio.webcam.ServerCapabilities.codecs: array expected"
                        );
                      e.codecs = [];
                      for (let t = 0; t < A.codecs.length; ++t) {
                        if ("object" != typeof A.codecs[t])
                          throw TypeError(
                            ".dcv.audio.webcam.ServerCapabilities.codecs: object expected"
                          );
                        e.codecs[t] = td.dcv.audio.webcam.Codec.fromObject(A.codecs[t]);
                      }
                    }
                    if (null != A.maxResolution) {
                      if ("object" != typeof A.maxResolution)
                        throw TypeError(
                          ".dcv.audio.webcam.ServerCapabilities.maxResolution: object expected"
                        );
                      e.maxResolution = td.dcv.audio.webcam.Resolution.fromObject(A.maxResolution);
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && (t.codecs = []),
                      e.defaults && (t.maxResolution = null),
                      A.codecs && A.codecs.length)
                    ) {
                      t.codecs = [];
                      for (let i = 0; i < A.codecs.length; ++i)
                        t.codecs[i] = td.dcv.audio.webcam.Codec.toObject(A.codecs[i], e);
                    }
                    return (
                      null != A.maxResolution &&
                        A.hasOwnProperty("maxResolution") &&
                        (t.maxResolution = td.dcv.audio.webcam.Resolution.toObject(
                          A.maxResolution,
                          e
                        )),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.ServerCapabilities"
                    );
                  }),
                  A
                );
              })()),
              (A.ClientCapabilities = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.videoscale = !1),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.videoscale &&
                        Object.hasOwnProperty.call(A, "videoscale") &&
                        e.uint32(8).bool(A.videoscale),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.ClientCapabilities();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.videoscale = A.bool();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.videoscale &&
                          A.hasOwnProperty("videoscale") &&
                          "boolean" != typeof A.videoscale
                        ? "videoscale: boolean expected"
                        : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.ClientCapabilities) return A;
                    let e = new td.dcv.audio.webcam.ClientCapabilities();
                    return null != A.videoscale && (e.videoscale = Boolean(A.videoscale)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.videoscale = !1),
                      null != A.videoscale &&
                        A.hasOwnProperty("videoscale") &&
                        (t.videoscale = A.videoscale),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.ClientCapabilities"
                    );
                  }),
                  A
                );
              })()),
              (A.Attach = (function () {
                function A(A) {
                  if (((this.resolutions = []), (this.codecs = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.resolutions = ed.emptyArray),
                  (A.prototype.codecs = ed.emptyArray),
                  (A.prototype.capabilities = null),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ad.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.resolutions && A.resolutions.length)
                    )
                      for (let t = 0; t < A.resolutions.length; ++t)
                        td.dcv.audio.webcam.Resolution.encode(
                          A.resolutions[t],
                          e.uint32(18).fork()
                        ).ldelim();
                    if (null != A.codecs && A.codecs.length)
                      for (let t = 0; t < A.codecs.length; ++t)
                        td.dcv.audio.webcam.Codec.encode(A.codecs[t], e.uint32(26).fork()).ldelim();
                    return (
                      null != A.capabilities &&
                        Object.hasOwnProperty.call(A, "capabilities") &&
                        td.dcv.audio.webcam.ClientCapabilities.encode(
                          A.capabilities,
                          e.uint32(34).fork()
                        ).ldelim(),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.Attach();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 2:
                          (i.resolutions && i.resolutions.length) || (i.resolutions = []),
                            i.resolutions.push(
                              td.dcv.audio.webcam.Resolution.decode(A, A.uint32())
                            );
                          break;
                        case 3:
                          (i.codecs && i.codecs.length) || (i.codecs = []),
                            i.codecs.push(td.dcv.audio.webcam.Codec.decode(A, A.uint32()));
                          break;
                        case 4:
                          i.capabilities = td.dcv.audio.webcam.ClientCapabilities.decode(
                            A,
                            A.uint32()
                          );
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !ed.isString(A.name))
                      return "name: string expected";
                    if (null != A.resolutions && A.hasOwnProperty("resolutions")) {
                      if (!Array.isArray(A.resolutions)) return "resolutions: array expected";
                      for (let e = 0; e < A.resolutions.length; ++e) {
                        let t = td.dcv.audio.webcam.Resolution.verify(A.resolutions[e]);
                        if (t) return "resolutions." + t;
                      }
                    }
                    if (null != A.codecs && A.hasOwnProperty("codecs")) {
                      if (!Array.isArray(A.codecs)) return "codecs: array expected";
                      for (let e = 0; e < A.codecs.length; ++e) {
                        let t = td.dcv.audio.webcam.Codec.verify(A.codecs[e]);
                        if (t) return "codecs." + t;
                      }
                    }
                    if (null != A.capabilities && A.hasOwnProperty("capabilities")) {
                      let e = td.dcv.audio.webcam.ClientCapabilities.verify(A.capabilities);
                      if (e) return "capabilities." + e;
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.Attach) return A;
                    let e = new td.dcv.audio.webcam.Attach();
                    if ((null != A.name && (e.name = String(A.name)), A.resolutions)) {
                      if (!Array.isArray(A.resolutions))
                        throw TypeError(".dcv.audio.webcam.Attach.resolutions: array expected");
                      e.resolutions = [];
                      for (let t = 0; t < A.resolutions.length; ++t) {
                        if ("object" != typeof A.resolutions[t])
                          throw TypeError(".dcv.audio.webcam.Attach.resolutions: object expected");
                        e.resolutions[t] = td.dcv.audio.webcam.Resolution.fromObject(
                          A.resolutions[t]
                        );
                      }
                    }
                    if (A.codecs) {
                      if (!Array.isArray(A.codecs))
                        throw TypeError(".dcv.audio.webcam.Attach.codecs: array expected");
                      e.codecs = [];
                      for (let t = 0; t < A.codecs.length; ++t) {
                        if ("object" != typeof A.codecs[t])
                          throw TypeError(".dcv.audio.webcam.Attach.codecs: object expected");
                        e.codecs[t] = td.dcv.audio.webcam.Codec.fromObject(A.codecs[t]);
                      }
                    }
                    if (null != A.capabilities) {
                      if ("object" != typeof A.capabilities)
                        throw TypeError(".dcv.audio.webcam.Attach.capabilities: object expected");
                      e.capabilities = td.dcv.audio.webcam.ClientCapabilities.fromObject(
                        A.capabilities
                      );
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && ((t.resolutions = []), (t.codecs = [])),
                      e.defaults && ((t.name = ""), (t.capabilities = null)),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      A.resolutions && A.resolutions.length)
                    ) {
                      t.resolutions = [];
                      for (let i = 0; i < A.resolutions.length; ++i)
                        t.resolutions[i] = td.dcv.audio.webcam.Resolution.toObject(
                          A.resolutions[i],
                          e
                        );
                    }
                    if (A.codecs && A.codecs.length) {
                      t.codecs = [];
                      for (let i = 0; i < A.codecs.length; ++i)
                        t.codecs[i] = td.dcv.audio.webcam.Codec.toObject(A.codecs[i], e);
                    }
                    return (
                      null != A.capabilities &&
                        A.hasOwnProperty("capabilities") &&
                        (t.capabilities = td.dcv.audio.webcam.ClientCapabilities.toObject(
                          A.capabilities,
                          e
                        )),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Attach"
                    );
                  }),
                  A
                );
              })()),
              (A.Detach = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.reason = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.reason &&
                        Object.hasOwnProperty.call(A, "reason") &&
                        e.uint32(8).int32(A.reason),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.Detach();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.reason = A.int32();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.reason && A.hasOwnProperty("reason"))
                      switch (A.reason) {
                        default:
                          return "reason: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                      }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.Detach) return A;
                    let e = new td.dcv.audio.webcam.Detach();
                    switch (A.reason) {
                      default:
                        if ("number" == typeof A.reason) {
                          e.reason = A.reason;
                          break;
                        }
                        break;
                      case "NO_ERROR":
                      case 0:
                        e.reason = 0;
                        break;
                      case "GENERIC_ERROR":
                      case 1:
                        e.reason = 1;
                        break;
                      case "WEBCAM_ERROR":
                      case 2:
                        e.reason = 2;
                        break;
                      case "WEBCAM_BUSY":
                      case 3:
                        e.reason = 3;
                        break;
                      case "WEBCAM_NOT_FOUND":
                      case 4:
                        e.reason = 4;
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.reason = e.enums === String ? "NO_ERROR" : 0),
                      null != A.reason &&
                        A.hasOwnProperty("reason") &&
                        (t.reason =
                          e.enums === String
                            ? void 0 === td.dcv.audio.webcam.Detach.DetachReason[A.reason]
                              ? A.reason
                              : td.dcv.audio.webcam.Detach.DetachReason[A.reason]
                            : A.reason),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Detach"
                    );
                  }),
                  (A.DetachReason = (function () {
                    const A = {},
                      e = Object.create(A);
                    return (
                      (e[(A[0] = "NO_ERROR")] = 0),
                      (e[(A[1] = "GENERIC_ERROR")] = 1),
                      (e[(A[2] = "WEBCAM_ERROR")] = 2),
                      (e[(A[3] = "WEBCAM_BUSY")] = 3),
                      (e[(A[4] = "WEBCAM_NOT_FOUND")] = 4),
                      e
                    );
                  })()),
                  A
                );
              })()),
              (A.ErrorResponse = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.code = 0),
                  (A.prototype.details = ""),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.code &&
                        Object.hasOwnProperty.call(A, "code") &&
                        e.uint32(8).int32(A.code),
                      null != A.details &&
                        Object.hasOwnProperty.call(A, "details") &&
                        e.uint32(18).string(A.details),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.ErrorResponse();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.code = A.int32();
                          break;
                        case 2:
                          i.details = A.string();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.code && A.hasOwnProperty("code"))
                      switch (A.code) {
                        default:
                          return "code: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                      }
                    return null != A.details &&
                      A.hasOwnProperty("details") &&
                      !ed.isString(A.details)
                      ? "details: string expected"
                      : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.ErrorResponse) return A;
                    let e = new td.dcv.audio.webcam.ErrorResponse();
                    switch (A.code) {
                      default:
                        if ("number" == typeof A.code) {
                          e.code = A.code;
                          break;
                        }
                        break;
                      case "NONE":
                      case 0:
                        e.code = 0;
                        break;
                      case "ATTACH_FAILED":
                      case 1:
                        e.code = 1;
                        break;
                      case "ATTACH_FAILED_NOT_ALLOWED":
                      case 2:
                        e.code = 2;
                        break;
                      case "ATTACH_FAILED_NO_CODECS_SUPPORTED":
                      case 3:
                        e.code = 3;
                        break;
                      case "ATTACH_FAILED_NO_RESOLUTIONS_SUPPORTED":
                      case 4:
                        e.code = 4;
                        break;
                      case "ATTACH_FAILED_ALREADY_ATTACHED":
                      case 5:
                        e.code = 5;
                        break;
                      case "ATTACH_FAILED_DEVICE_IN_USE":
                      case 6:
                        e.code = 6;
                    }
                    return null != A.details && (e.details = String(A.details)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.code = e.enums === String ? "NONE" : 0), (t.details = "")),
                      null != A.code &&
                        A.hasOwnProperty("code") &&
                        (t.code =
                          e.enums === String
                            ? void 0 === td.dcv.audio.webcam.ErrorResponse.Code[A.code]
                              ? A.code
                              : td.dcv.audio.webcam.ErrorResponse.Code[A.code]
                            : A.code),
                      null != A.details && A.hasOwnProperty("details") && (t.details = A.details),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.ErrorResponse"
                    );
                  }),
                  (A.Code = (function () {
                    const A = {},
                      e = Object.create(A);
                    return (
                      (e[(A[0] = "NONE")] = 0),
                      (e[(A[1] = "ATTACH_FAILED")] = 1),
                      (e[(A[2] = "ATTACH_FAILED_NOT_ALLOWED")] = 2),
                      (e[(A[3] = "ATTACH_FAILED_NO_CODECS_SUPPORTED")] = 3),
                      (e[(A[4] = "ATTACH_FAILED_NO_RESOLUTIONS_SUPPORTED")] = 4),
                      (e[(A[5] = "ATTACH_FAILED_ALREADY_ATTACHED")] = 5),
                      (e[(A[6] = "ATTACH_FAILED_DEVICE_IN_USE")] = 6),
                      e
                    );
                  })()),
                  A
                );
              })()),
              (A.StatusUpdate = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.status = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.status &&
                        Object.hasOwnProperty.call(A, "status") &&
                        e.uint32(8).int32(A.status),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.StatusUpdate();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.status = A.int32();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.status && A.hasOwnProperty("status"))
                      switch (A.status) {
                        default:
                          return "status: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                      }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.StatusUpdate) return A;
                    let e = new td.dcv.audio.webcam.StatusUpdate();
                    switch (A.status) {
                      default:
                        if ("number" == typeof A.status) {
                          e.status = A.status;
                          break;
                        }
                        break;
                      case "NOT_AVAILABLE":
                      case 0:
                        e.status = 0;
                        break;
                      case "BUSY":
                      case 1:
                        e.status = 1;
                        break;
                      case "AVAILABLE":
                      case 2:
                        e.status = 2;
                        break;
                      case "ATTACHED":
                      case 3:
                        e.status = 3;
                        break;
                      case "STREAMING":
                      case 4:
                        e.status = 4;
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.status = e.enums === String ? "NOT_AVAILABLE" : 0),
                      null != A.status &&
                        A.hasOwnProperty("status") &&
                        (t.status =
                          e.enums === String
                            ? void 0 === td.dcv.audio.webcam.StatusUpdate.ServiceStatus[A.status]
                              ? A.status
                              : td.dcv.audio.webcam.StatusUpdate.ServiceStatus[A.status]
                            : A.status),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.StatusUpdate"
                    );
                  }),
                  (A.ServiceStatus = (function () {
                    const A = {},
                      e = Object.create(A);
                    return (
                      (e[(A[0] = "NOT_AVAILABLE")] = 0),
                      (e[(A[1] = "BUSY")] = 1),
                      (e[(A[2] = "AVAILABLE")] = 2),
                      (e[(A[3] = "ATTACHED")] = 3),
                      (e[(A[4] = "STREAMING")] = 4),
                      e
                    );
                  })()),
                  A
                );
              })()),
              (A.StreamConfiguration = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.id = 0),
                  (A.prototype.resolution = null),
                  (A.prototype.codec = null),
                  (A.prototype.bitrate = 0),
                  (A.prototype.fps = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.id &&
                        Object.hasOwnProperty.call(A, "id") &&
                        e.uint32(8).uint32(A.id),
                      null != A.resolution &&
                        Object.hasOwnProperty.call(A, "resolution") &&
                        td.dcv.audio.webcam.Resolution.encode(
                          A.resolution,
                          e.uint32(18).fork()
                        ).ldelim(),
                      null != A.codec &&
                        Object.hasOwnProperty.call(A, "codec") &&
                        td.dcv.audio.webcam.Codec.encode(A.codec, e.uint32(26).fork()).ldelim(),
                      null != A.bitrate &&
                        Object.hasOwnProperty.call(A, "bitrate") &&
                        e.uint32(32).uint32(A.bitrate),
                      null != A.fps &&
                        Object.hasOwnProperty.call(A, "fps") &&
                        e.uint32(40).uint32(A.fps),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.StreamConfiguration();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.id = A.uint32();
                          break;
                        case 2:
                          i.resolution = td.dcv.audio.webcam.Resolution.decode(A, A.uint32());
                          break;
                        case 3:
                          i.codec = td.dcv.audio.webcam.Codec.decode(A, A.uint32());
                          break;
                        case 4:
                          i.bitrate = A.uint32();
                          break;
                        case 5:
                          i.fps = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.id && A.hasOwnProperty("id") && !ed.isInteger(A.id))
                      return "id: integer expected";
                    if (null != A.resolution && A.hasOwnProperty("resolution")) {
                      let e = td.dcv.audio.webcam.Resolution.verify(A.resolution);
                      if (e) return "resolution." + e;
                    }
                    if (null != A.codec && A.hasOwnProperty("codec")) {
                      let e = td.dcv.audio.webcam.Codec.verify(A.codec);
                      if (e) return "codec." + e;
                    }
                    return null != A.bitrate &&
                      A.hasOwnProperty("bitrate") &&
                      !ed.isInteger(A.bitrate)
                      ? "bitrate: integer expected"
                      : null != A.fps && A.hasOwnProperty("fps") && !ed.isInteger(A.fps)
                        ? "fps: integer expected"
                        : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.StreamConfiguration) return A;
                    let e = new td.dcv.audio.webcam.StreamConfiguration();
                    if ((null != A.id && (e.id = A.id >>> 0), null != A.resolution)) {
                      if ("object" != typeof A.resolution)
                        throw TypeError(
                          ".dcv.audio.webcam.StreamConfiguration.resolution: object expected"
                        );
                      e.resolution = td.dcv.audio.webcam.Resolution.fromObject(A.resolution);
                    }
                    if (null != A.codec) {
                      if ("object" != typeof A.codec)
                        throw TypeError(
                          ".dcv.audio.webcam.StreamConfiguration.codec: object expected"
                        );
                      e.codec = td.dcv.audio.webcam.Codec.fromObject(A.codec);
                    }
                    return (
                      null != A.bitrate && (e.bitrate = A.bitrate >>> 0),
                      null != A.fps && (e.fps = A.fps >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults &&
                        ((t.id = 0),
                        (t.resolution = null),
                        (t.codec = null),
                        (t.bitrate = 0),
                        (t.fps = 0)),
                      null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                      null != A.resolution &&
                        A.hasOwnProperty("resolution") &&
                        (t.resolution = td.dcv.audio.webcam.Resolution.toObject(A.resolution, e)),
                      null != A.codec &&
                        A.hasOwnProperty("codec") &&
                        (t.codec = td.dcv.audio.webcam.Codec.toObject(A.codec, e)),
                      null != A.bitrate && A.hasOwnProperty("bitrate") && (t.bitrate = A.bitrate),
                      null != A.fps && A.hasOwnProperty("fps") && (t.fps = A.fps),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.StreamConfiguration"
                    );
                  }),
                  A
                );
              })()),
              (A.Frame = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.frameIndex = ed.Long ? ed.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.streamId = 0),
                  (A.prototype.timestamp = ed.Long ? ed.Long.fromBits(0, 0, !1) : 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.frameIndex &&
                        Object.hasOwnProperty.call(A, "frameIndex") &&
                        e.uint32(8).uint64(A.frameIndex),
                      null != A.streamId &&
                        Object.hasOwnProperty.call(A, "streamId") &&
                        e.uint32(16).uint32(A.streamId),
                      null != A.timestamp &&
                        Object.hasOwnProperty.call(A, "timestamp") &&
                        e.uint32(24).int64(A.timestamp),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.Frame();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.frameIndex = A.uint64();
                          break;
                        case 2:
                          i.streamId = A.uint32();
                          break;
                        case 3:
                          i.timestamp = A.int64();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.frameIndex &&
                          A.hasOwnProperty("frameIndex") &&
                          !(
                            ed.isInteger(A.frameIndex) ||
                            (A.frameIndex &&
                              ed.isInteger(A.frameIndex.low) &&
                              ed.isInteger(A.frameIndex.high))
                          )
                        ? "frameIndex: integer|Long expected"
                        : null != A.streamId &&
                            A.hasOwnProperty("streamId") &&
                            !ed.isInteger(A.streamId)
                          ? "streamId: integer expected"
                          : null != A.timestamp &&
                              A.hasOwnProperty("timestamp") &&
                              !(
                                ed.isInteger(A.timestamp) ||
                                (A.timestamp &&
                                  ed.isInteger(A.timestamp.low) &&
                                  ed.isInteger(A.timestamp.high))
                              )
                            ? "timestamp: integer|Long expected"
                            : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.Frame) return A;
                    let e = new td.dcv.audio.webcam.Frame();
                    return (
                      null != A.frameIndex &&
                        (ed.Long
                          ? ((e.frameIndex = ed.Long.fromValue(A.frameIndex)).unsigned = !0)
                          : "string" == typeof A.frameIndex
                            ? (e.frameIndex = parseInt(A.frameIndex, 10))
                            : "number" == typeof A.frameIndex
                              ? (e.frameIndex = A.frameIndex)
                              : "object" == typeof A.frameIndex &&
                                (e.frameIndex = new ed.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0))),
                      null != A.streamId && (e.streamId = A.streamId >>> 0),
                      null != A.timestamp &&
                        (ed.Long
                          ? ((e.timestamp = ed.Long.fromValue(A.timestamp)).unsigned = !1)
                          : "string" == typeof A.timestamp
                            ? (e.timestamp = parseInt(A.timestamp, 10))
                            : "number" == typeof A.timestamp
                              ? (e.timestamp = A.timestamp)
                              : "object" == typeof A.timestamp &&
                                (e.timestamp = new ed.LongBits(
                                  A.timestamp.low >>> 0,
                                  A.timestamp.high >>> 0
                                ).toNumber())),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults) {
                      if (ed.Long) {
                        let A = new ed.Long(0, 0, !0);
                        t.frameIndex =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.frameIndex = e.longs === String ? "0" : 0;
                      if (((t.streamId = 0), ed.Long)) {
                        let A = new ed.Long(0, 0, !1);
                        t.timestamp =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.timestamp = e.longs === String ? "0" : 0;
                    }
                    return (
                      null != A.frameIndex &&
                        A.hasOwnProperty("frameIndex") &&
                        ("number" == typeof A.frameIndex
                          ? (t.frameIndex =
                              e.longs === String ? String(A.frameIndex) : A.frameIndex)
                          : (t.frameIndex =
                              e.longs === String
                                ? ed.Long.prototype.toString.call(A.frameIndex)
                                : e.longs === Number
                                  ? new ed.LongBits(
                                      A.frameIndex.low >>> 0,
                                      A.frameIndex.high >>> 0
                                    ).toNumber(!0)
                                  : A.frameIndex)),
                      null != A.streamId &&
                        A.hasOwnProperty("streamId") &&
                        (t.streamId = A.streamId),
                      null != A.timestamp &&
                        A.hasOwnProperty("timestamp") &&
                        ("number" == typeof A.timestamp
                          ? (t.timestamp = e.longs === String ? String(A.timestamp) : A.timestamp)
                          : (t.timestamp =
                              e.longs === String
                                ? ed.Long.prototype.toString.call(A.timestamp)
                                : e.longs === Number
                                  ? new ed.LongBits(
                                      A.timestamp.low >>> 0,
                                      A.timestamp.high >>> 0
                                    ).toNumber()
                                  : A.timestamp)),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Frame"
                    );
                  }),
                  A
                );
              })()),
              (A.Ack = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.frameIndex = ed.Long ? ed.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.streamId = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ad.create()),
                      null != A.frameIndex &&
                        Object.hasOwnProperty.call(A, "frameIndex") &&
                        e.uint32(8).uint64(A.frameIndex),
                      null != A.streamId &&
                        Object.hasOwnProperty.call(A, "streamId") &&
                        e.uint32(16).uint32(A.streamId),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof $l || (A = $l.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new td.dcv.audio.webcam.Ack();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.frameIndex = A.uint64();
                          break;
                        case 2:
                          i.streamId = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof $l || (A = new $l(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.frameIndex &&
                          A.hasOwnProperty("frameIndex") &&
                          !(
                            ed.isInteger(A.frameIndex) ||
                            (A.frameIndex &&
                              ed.isInteger(A.frameIndex.low) &&
                              ed.isInteger(A.frameIndex.high))
                          )
                        ? "frameIndex: integer|Long expected"
                        : null != A.streamId &&
                            A.hasOwnProperty("streamId") &&
                            !ed.isInteger(A.streamId)
                          ? "streamId: integer expected"
                          : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof td.dcv.audio.webcam.Ack) return A;
                    let e = new td.dcv.audio.webcam.Ack();
                    return (
                      null != A.frameIndex &&
                        (ed.Long
                          ? ((e.frameIndex = ed.Long.fromValue(A.frameIndex)).unsigned = !0)
                          : "string" == typeof A.frameIndex
                            ? (e.frameIndex = parseInt(A.frameIndex, 10))
                            : "number" == typeof A.frameIndex
                              ? (e.frameIndex = A.frameIndex)
                              : "object" == typeof A.frameIndex &&
                                (e.frameIndex = new ed.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0))),
                      null != A.streamId && (e.streamId = A.streamId >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults) {
                      if (ed.Long) {
                        let A = new ed.Long(0, 0, !0);
                        t.frameIndex =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.frameIndex = e.longs === String ? "0" : 0;
                      t.streamId = 0;
                    }
                    return (
                      null != A.frameIndex &&
                        A.hasOwnProperty("frameIndex") &&
                        ("number" == typeof A.frameIndex
                          ? (t.frameIndex =
                              e.longs === String ? String(A.frameIndex) : A.frameIndex)
                          : (t.frameIndex =
                              e.longs === String
                                ? ed.Long.prototype.toString.call(A.frameIndex)
                                : e.longs === Number
                                  ? new ed.LongBits(
                                      A.frameIndex.low >>> 0,
                                      A.frameIndex.high >>> 0
                                    ).toNumber(!0)
                                  : A.frameIndex)),
                      null != A.streamId &&
                        A.hasOwnProperty("streamId") &&
                        (t.streamId = A.streamId),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Ack";
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  nd = {
    elements: 22,
    0: new Uint8Array([
      254, 2, 255, 254, 127, 217, 29, 239, 163, 98, 208, 123, 212, 109, 51, 23, 25, 34, 64, 17, 135,
      13, 62, 110, 107, 226, 42, 40, 164, 120, 96, 103, 254, 12, 36, 161, 133, 246, 204, 125, 106,
      103, 224, 165, 21, 154, 182, 182, 174, 150, 112, 248, 125, 135, 119, 24, 110, 76, 97, 147,
      247, 253, 1, 165, 105, 53, 179, 69, 252, 41, 10, 29, 99, 205, 191, 177, 120, 62, 61, 189, 255,
      249, 18, 46, 84, 152, 4, 98, 12, 243, 234, 114, 188, 154, 21, 179, 247, 176, 91, 7, 29, 139,
      15, 192, 72, 177, 230, 47, 235, 225, 206, 2, 180, 111, 91, 28, 27, 127, 204, 248, 29, 96, 176,
      131, 187, 115, 101, 63, 174, 233, 48, 235, 114, 11, 238, 29, 110, 70, 29, 110, 66, 65, 199,
      57, 224, 89, 42, 17, 97, 71, 144, 121, 145, 49, 212, 123, 114, 41, 144, 210, 129, 124, 57,
      250, 224, 121, 22, 237, 142, 145, 90, 158, 202, 43, 88, 219, 95, 223, 182, 69, 28, 41, 21, 95,
      52, 0, 247, 7, 186, 30, 88, 40, 6, 46, 219, 4, 174, 215, 97, 195, 29, 69, 32, 214, 172, 249,
      2, 224, 220, 140, 152, 174, 45, 111, 55, 21, 155, 36, 203, 71, 87, 245, 204, 85, 136, 229,
      109, 133, 28, 115, 74, 196, 199, 91, 235, 232, 242, 108, 216, 10, 96, 100, 128, 69, 180, 146,
      7, 13, 146, 160, 53, 161, 250, 90, 85
    ]),
    1: new Uint8Array([
      254, 229, 119, 222, 56, 112, 193, 165, 219, 35, 142, 105, 145, 185, 166, 161, 81, 150, 43, 20,
      32, 234, 63, 213, 172, 111, 138, 227, 173, 174, 8, 6, 140, 188, 206, 159, 177, 248, 248, 58,
      211, 38, 125, 121, 222, 101, 166, 80, 74, 151, 98, 118, 210, 35, 129, 128, 14, 11, 90, 14, 66,
      160, 20, 56, 230, 248, 68, 176, 177, 244, 65, 40, 72, 213, 106, 51, 132, 98, 118, 134, 11,
      119, 184, 46, 0, 79, 169, 2, 208, 182, 174, 196, 136, 45, 49, 228, 66, 198, 98, 99, 217, 74,
      5, 140, 113, 231, 136, 224, 20, 110, 2, 149, 68, 98, 33, 199, 73, 180, 195, 161, 162, 224, 47,
      0, 23, 167, 172, 21, 33, 176, 235, 114, 31, 191, 166, 113, 99, 56, 135, 67, 4, 1, 111, 26,
      204, 60, 40, 242, 5, 254, 230, 64, 73, 104, 220, 214, 129, 53, 234, 46, 136, 218, 241, 167,
      29, 138, 80, 233, 248, 151, 211, 78, 145, 199, 70, 101, 172, 78, 187, 216, 185, 147, 125, 63,
      20, 205, 146, 49, 59, 245, 175, 228, 214, 75, 48, 86, 58, 182, 91, 143, 77, 113, 126, 22, 240,
      0, 182, 215, 192, 13, 113, 255, 49, 114, 0, 1, 152, 214, 28, 117, 7, 215, 58, 243, 161, 57,
      190, 233, 85, 56, 49, 125, 179, 29, 8, 242, 179, 139, 173, 250, 215, 99, 65, 118, 28, 220,
      210, 20, 173, 249, 10, 229, 122, 217, 23, 21, 12, 145, 247, 188, 98, 172, 227, 170, 46, 66,
      120, 162, 244, 141, 177, 154, 61, 75, 134, 255, 146, 194, 106, 211, 40, 36, 133, 190, 247,
      154, 173, 249, 8, 247, 38, 89, 180, 100, 249, 7, 185, 204, 32, 199, 140, 23, 191, 7, 19, 202,
      26, 45, 134, 24, 117, 185, 15, 86, 164, 56, 251, 76, 80, 159, 146, 59, 117, 233, 172, 221,
      235, 127, 32, 2, 185, 120, 154, 22, 56, 172, 134, 48, 142, 120, 143, 43, 46, 82, 118, 131,
      207, 73, 137, 250, 113, 39, 143, 14, 169, 124, 216, 213, 98, 155, 117, 228, 90, 56, 32, 233,
      31, 184, 28, 167, 188, 75, 72, 242, 252, 23, 118, 97, 82, 157, 145, 46, 113, 54, 211, 28, 255,
      187, 186, 153, 29
    ]),
    2: new Uint8Array([
      253, 119, 221, 139, 14, 175, 59, 229, 123, 245, 244, 115, 60, 106, 160, 142, 101, 21, 193,
      104, 49, 193, 221, 10, 8, 65, 232, 37, 54, 113, 147, 132, 239, 30, 166, 1, 48, 195, 121, 116,
      87, 241, 86, 216, 21, 157, 72, 69, 206, 125, 252, 228, 35, 95, 125, 138, 114, 54, 85, 112,
      201, 39, 174, 170, 62, 173, 233, 7, 58, 14, 161, 149, 26, 125, 91, 96, 101, 232, 135, 249, 65,
      202, 51, 244, 214, 233, 64, 58, 134, 101, 83, 151, 223, 205, 139, 47, 105, 214, 61, 162, 94,
      254, 59, 179, 112, 136, 58, 235, 79, 58, 4, 22, 110, 152, 37, 216, 226, 82, 115, 29, 126, 192,
      218, 12, 216, 47, 77, 189, 181, 164, 59, 185, 26, 18, 227, 35, 213, 197, 24, 56, 56, 20, 128,
      193, 247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 238, 4, 241, 125, 179,
      29, 8, 242, 179, 1, 87, 94, 71, 182, 248, 246, 76, 147, 6, 19, 202, 222, 153, 230, 178, 118,
      197, 124, 203, 102, 207, 189, 194, 19, 49, 135, 22, 142, 207, 117, 124, 237, 255, 109, 55,
      131, 44, 226, 16, 177, 229, 235, 201, 84, 1, 129, 103, 202, 34, 83, 9, 4, 49, 168, 34, 205,
      13, 8, 9, 67, 87, 199, 113, 120, 164, 130, 147, 202, 26, 45, 134, 24, 117, 185, 15, 67, 141,
      106, 123, 76, 80, 159, 146, 59, 117, 233, 172, 221, 235, 127, 32, 2, 185, 120, 154, 22, 56,
      172, 134, 48, 135, 149, 156, 241, 46, 82, 119, 147, 199, 164, 196, 253, 56, 147, 199, 135, 84,
      190, 108, 106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252,
      23, 118, 97, 82, 157, 145, 46, 113, 52, 203, 79, 255, 187, 186, 139, 12
    ]),
    3: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 67, 155, 230, 70, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 155, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    4: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 238, 37, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 113, 55, 11, 79, 255, 187, 186, 143, 12
    ]),
    5: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 131, 155, 230, 6, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 156, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    6: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 83, 155, 174, 69, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 109, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    7: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 131, 155, 230, 6, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 156, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    8: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 174, 37, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 113, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    9: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 67, 155, 230, 70, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 155, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    10: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 174, 5, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 113, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    11: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 131, 155, 230, 6, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 156, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    12: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 83, 155, 174, 101, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 109, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    13: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 131, 155, 230, 6, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 156, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    14: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 174, 5, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 113, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    15: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 67, 155, 230, 70, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 155, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    16: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 174, 37, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 113, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    17: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 131, 155, 230, 6, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 156, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    18: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 83, 155, 174, 69, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 109, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    19: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 131, 155, 230, 6, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 156, 77, 83, 28, 255, 187, 250, 153, 29
    ]),
    20: new Uint8Array([
      253, 119, 221, 1, 132, 18, 241, 162, 163, 132, 90, 68, 0, 38, 243, 245, 178, 130, 249, 80, 38,
      10, 240, 40, 6, 230, 192, 93, 10, 202, 185, 65, 206, 48, 54, 107, 47, 39, 199, 212, 225, 8,
      58, 71, 240, 190, 187, 117, 206, 150, 223, 96, 131, 95, 75, 72, 201, 232, 246, 50, 248, 186,
      46, 102, 128, 171, 213, 63, 155, 213, 158, 14, 96, 30, 139, 215, 41, 60, 41, 148, 89, 202, 27,
      165, 12, 253, 52, 58, 134, 101, 83, 192, 152, 155, 22, 94, 32, 30, 74, 162, 101, 118, 152, 67,
      5, 253, 126, 90, 121, 208, 32, 179, 116, 193, 46, 199, 18, 147, 153, 120, 28, 5, 160, 205,
      130, 244, 219, 212, 167, 202, 247, 35, 66, 92, 100, 122, 184, 163, 5, 133, 16, 55, 240, 193,
      247, 254, 232, 72, 0, 1, 118, 92, 208, 125, 206, 179, 147, 155, 174, 37, 241, 125, 179, 29,
      116, 166, 237, 67, 240, 151, 31, 153, 240, 195, 108, 57, 147, 98, 42, 145, 247, 6, 13, 98,
      108, 152, 8, 175, 12, 154, 154, 54, 188, 67, 209, 218, 136, 246, 135, 62, 97, 166, 209, 174,
      21, 222, 204, 8, 0, 160, 215, 111, 79, 65, 55, 155, 136, 21, 149, 34, 209, 147, 141, 178, 112,
      163, 110, 222, 119, 206, 137, 63, 128, 162, 4, 242, 134, 139, 97, 134, 29, 110, 67, 208, 227,
      90, 148, 77, 48, 159, 144, 67, 139, 244, 214, 110, 245, 191, 144, 1, 92, 188, 77, 11, 28, 86,
      67, 24, 71, 60, 71, 149, 151, 41, 59, 65, 231, 164, 196, 253, 56, 147, 176, 153, 48, 190, 108,
      106, 177, 77, 186, 242, 45, 28, 16, 116, 143, 177, 252, 167, 188, 75, 72, 242, 252, 23, 118,
      97, 82, 157, 145, 46, 113, 55, 11, 79, 255, 187, 250, 143, 12
    ]),
    21: new Uint8Array([
      253, 119, 222, 56, 112, 213, 156, 20, 67, 253, 160, 72, 224, 198, 85, 25, 189, 66, 17, 186,
      219, 209, 199, 207, 81, 189, 66, 158, 204, 53, 157, 230, 122, 24, 35, 108, 7, 142, 44, 142,
      222, 212, 89, 8, 76, 116, 182, 109, 80, 25, 227, 140, 120, 214, 25, 83, 26, 13, 101, 214, 122,
      155, 149, 178, 24, 230, 97, 88, 82, 111, 118, 139, 133, 115, 125, 121, 231, 67, 252, 160, 26,
      126, 21, 123, 127, 204, 168, 68, 18, 245, 78, 95, 127, 121, 209, 222, 211, 172, 101, 81, 47,
      125, 166, 16, 193, 127, 95, 150, 158, 116, 18, 11, 55, 76, 18, 236, 113, 41, 57, 142, 191, 96,
      109, 6, 108, 23, 166, 222, 218, 210, 29, 220, 141, 9, 113, 145, 234, 226, 140, 28, 28, 13,
      252, 48, 125, 255, 186, 18, 0, 5, 217, 116, 65, 245, 206, 179, 67, 155, 230, 70, 49, 125, 179,
      29, 8, 242, 179, 139, 173, 250, 221, 159, 119, 186, 68, 149, 171, 100, 127, 45, 191, 52, 249,
      2, 55, 91, 14, 131, 107, 152, 61, 188, 88, 184, 116, 164, 201, 153, 135, 200, 224, 28, 133,
      43, 181, 3, 180, 82, 3, 23, 227, 233, 39, 18, 162, 153, 40, 250, 12, 227, 186, 161, 111, 154,
      165, 34, 116, 178, 229, 194, 205, 125, 187, 222, 79, 40, 104, 18, 6, 230, 29, 110, 67, 219,
      83, 8, 209, 52, 196, 144, 72, 237, 215, 166, 179, 36, 59, 51, 156, 10, 229, 226, 104, 88, 226,
      178, 24, 194, 30, 86, 115, 196, 185, 73, 218, 15, 61, 38, 39, 233, 196, 157, 146, 158, 181,
      243, 99, 85, 138, 109, 215, 145, 104, 249, 98, 158, 145, 246, 63, 148, 247, 244, 191, 160, 83,
      165, 221, 152, 84, 167, 100, 75, 155, 77, 83, 28, 255, 187, 250, 153, 29
    ])
  };
function od(A) {
  return A < 0 || A >= nd.elements ? null : nd[A];
}
const rd = Object.freeze({
    UNCONFIGURED: "unconfigured",
    CONFIGURED: "configured",
    CLOSED: "closed"
  }),
  sd = Object.freeze({ KEY: "key", DELTA: "delta" });
class ad {
  constructor(A) {}
  initializeResources() {
    return Promise.resolve();
  }
  get state() {
    gd();
  }
  get decodeQueueSize() {
    gd();
  }
  static isConfigSupported(A) {
    gd();
  }
  configure(A, e) {
    gd();
  }
  decode(A, e) {
    gd();
  }
  flush() {
    gd();
  }
  reset() {
    gd();
  }
  close() {
    gd();
  }
}
function gd() {
  throw new Error(`Unimplemented interface method ${gd.caller.name}`);
}
const cd = 1e3,
  Id = 6e5,
  ld = 2,
  dd = id.audio,
  ud = 11;
class Cd {
  constructor(A) {
    (this.log = Q("audioplayer", A.clientConnectionId)),
      (this.startFlag = !1),
      (this.currentConfig = null),
      (this.contextState = 0),
      (this.audioDecoder = null),
      (this.audioDecoderTsQueue = []),
      (this.lastBufferChecked = 1e3),
      (this.key = !0),
      (this.buffertime = 0),
      (this.samplesDecodedCount = 0),
      (this.startDecodingTimes = []),
      (this.settings = A),
      (this.playAudioFrame = this.playAudioFrameSimple.bind(this)),
      (this.minBufferTime = 0.1),
      (this.bufferTime = this.minBufferTime),
      (this.initPlayBufferTime = 2 * this.minBufferTime),
      (this.playTime = 0),
      (this.lastPlayedTime = 0),
      (this.lastArrivalPlayDiffTime = 0),
      (this.percentile90thDecodeTime = 0),
      (this.framesReceivedSinceStartTime = 0),
      (this.decodeTimes = []),
      (this.initArrivalTime = []),
      (this.firstPacketSinceSilenceTs = 0),
      (this.lastArrivalTime = 0),
      (this.lastPacketTs = 0),
      (this.lastPlayBufferTime = 0),
      (this.lastQueuedTime = 0),
      this.resetStats();
  }
  logStatePastPlayBufferTime(A, e) {
    return `Frame: ${this.framesReceivedSinceStartTime}. Arrival time ${A}s real play time ${this.playTime + e} theoretical play time at ${this.playTime}s buffer time ${e}s`;
  }
  logStateAfterPlayBufferTime(A, e) {
    return `Frame: ${this.framesReceivedSinceStartTime}. Arrival time ${A}s while play time was ${this.playTime + e}s will skip from play ${this.skipframe} audio frames`;
  }
  logStateBufferEvaluation(A) {
    return `Evaluate Buffer Callback called ${this.settings.audioContext.currentTime} lastArrivalPlayDiffTime ${this.lastArrivalPlayDiffTime} extra buffer ${A} dropValue ${this.dropFrames}`;
  }
  logStateDropFrame() {
    return `Dropping ${this.dropFrames} audio frames to reduce the "buffering". Buffer will reduce to ${this.bufferTime - this.dropFrames * this.settings.audioFrameTime}`;
  }
  init() {
    return (
      (this.initFunction = Fd.bind(this)),
      (this.decodeFunction = Fd.bind(this)),
      (this.chosenDecodingFunction = this.decode.bind(this)),
      this.log.info("Audio player initialized"),
      this.audioDecoder
        ? (this.log.warn("Audio decoder already initialized on player init"), Promise.resolve())
        : ((this.audioDecoder = new this.settings.DecoderType(this.settings.clientConnectionId)),
          this.audioDecoder.initializeResources())
    );
  }
  decode(A, e) {
    if (
      (this.log.debug(`Processing audio frame ${e}`),
      wd(this.audioDecoder) || bd.call(this),
      0 === this.contextState)
    )
      if (wd(this.audioDecoder)) {
        const t = this.key ? sd.KEY : sd.DELTA;
        (this.key = !1),
          this.log.debugIf(() => `Audio frame ${e} queued with type=${t}`),
          this.audioDecoderTsQueue.push(e),
          this.audioDecoder.decode(A, t);
      } else this.log.error(`Audio frame ${e} discarded: no decoder configured`);
    else
      this.contextState === ld
        ? (this.log.debug(
            `A context loss occurred. Requesting initialization from ${this.samplesDecodedCount}`
          ),
          this.reset(),
          (this.contextState = 1))
        : this.log.debug(`Discarding frame ${this.samplesDecodedCount} until context resume`);
  }
  remove() {
    (this.startFlag = !1), Ud.call(this), this.log.info("Audio player stopped");
  }
  reset() {
    return this.log.info("Resetting Audio Player"), Ud.call(this).then(this.init());
  }
  tune(A, e) {
    return 0 === arguments.length
      ? hd.call(this)
      : Xn(A) && Xn(e)
        ? pd.call(this, A, e)
        : Promise.reject();
  }
  setDecodeFunction() {
    (this.decodeFunction = this.decode.bind(this)),
      fd.call(this),
      (this.lastBufferCheck = this.settings.audioContext.currentTime),
      (this.evaluateBufferIntervalTimeout = cd),
      (this.evaluateBufferTimeoutCalled = setTimeout(
        md.bind(this),
        this.evaluateBufferIntervalTimeout
      ));
  }
  processAudioFrame(A, e, t, i) {
    if (this.lastArrivalPlayDiffTime < e)
      this.log.debugIf(
        () =>
          `Audio frame ${i}. Arrival time ${t}s real play time ${this.playTime + e} theoretical play time at ${this.playTime}s buffer time ${e}s`
      ),
        this.playAudioFrame(A, this.playTime + e + this.startTime);
    else {
      this.stats.dropped++;
      let A = Math.ceil(1e3 * (t - this.lastArrivalTime));
      if (i < this.firstPacketSinceSilenceTs || 0 === this.firstPacketSinceSilenceTs)
        return void this.log.debug(
          `Audio frame ${i} arrived after ${A} msec, dropped since decoded after silence from server`
        );
      A < 1e3
        ? (this.log.debugIf(
            () =>
              `Audio frame ${i} arrived after ${A} msec while play time was ${this.playTime + e}s, skip late samples`
          ),
          (this.bufferTime +=
            Math.ceil((t - this.playTime) / this.settings.audioFrameTime) *
            this.settings.audioFrameTime),
          this.bufferTime > 2 &&
            (this.log.warn(
              'The audio channel has a "buffering" greater than 2 seconds. Setting 2 seconds as limit.'
            ),
            (this.bufferTime = 2)))
        : (this.log.warn(`Audio frame ${i} arrived after ${A} msec, skip late samples`),
          (this.bufferTime = 2 * this.minBufferTime)),
        (this.skipPacketTs = i + 1e3 * A),
        (this.decodeFunction = yd.bind(this));
    }
  }
  playFromSilence(A, e) {
    (this.key = !0),
      (this.decodeFunction = this.initFunction.bind(this)),
      (this.framesReceivedSinceStartTime = 0),
      (this.startTime = this.settings.audioContext.currentTime),
      (this.firstPacketSinceSilenceTs = e),
      (this.lastArrivalTime = 0),
      (this.lastPacketTs = 0),
      (this.skipPacketTs = 0),
      this.decodeFunction(A, e),
      (this.evaluateBufferTimeoutCalled = setTimeout(
        md.bind(this),
        this.evaluateBufferIntervalTimeout
      ));
  }
  silence() {
    (this.firstPacketSinceSilenceTs = 0),
      this.initDone
        ? (this.evaluateBufferTimeoutCalled && clearTimeout(this.evaluateBufferTimeoutCalled),
          (this.decodeFunction = this.playFromSilence.bind(this)))
        : this.decodeFunction(null);
  }
  queueData(A, e) {
    this.decodeFunction(A, e);
  }
  setBufferTime() {
    (this.percentile90thDecodeTime = this.decodeTimes.sort((A, e) => A - e)[
      Math.floor(0.9 * this.decodeTimes.length) - 1
    ]),
      (this.bufferTime = Math.max(this.percentile90thDecodeTime, this.minBufferTime)),
      (this.decodeTimes = []),
      this.log.debug(
        `Tune decode time ${this.percentile90thDecodeTime} BufferTime ${this.bufferTime}`
      );
  }
  playAudioFrameSimple(A, e) {
    Sd.call(this, A, e);
  }
  logAudioDebug(A, e, t) {
    return `Audio frame ${A} raw playback: diff-time=${this.lastArrivalPlayDiffTime}, arrival-time=${e}, play-time=${this.playTime}, start-time=${this.startTime}, buffer-time=${t}`;
  }
  playBufferRaw(A, e) {
    const t = this.bufferTime ? this.bufferTime : this.initPlayBufferTime,
      i = this.settings.audioContext.currentTime,
      n = i - this.startTime,
      o = this.lastPlayedTime > i ? this.lastPlayedTime - i : 0;
    if (
      (this.initDone &&
        (this.framesReceivedSinceStartTime++,
        this.stats.count++,
        (this.stats.bufferTimeSum += t),
        (this.stats.bufferTimeMin = t < this.stats.bufferTimeMin ? t : this.stats.bufferTimeMin),
        (this.stats.bufferTimeMax = t > this.stats.bufferTimeMax ? t : this.stats.bufferTimeMax),
        (this.stats.queuedTimeSum += o),
        (this.stats.queuedTimeMin = o < this.stats.queuedTimeMin ? o : this.stats.queuedTimeMin),
        (this.stats.queuedTimeMax = o > this.stats.queuedTimeMax ? o : this.stats.queuedTimeMax)),
      (this.lastPlayBufferTime = t),
      (this.lastQueuedTime = o),
      (this.playTime = this.framesReceivedSinceStartTime * this.settings.audioFrameTime),
      (this.lastArrivalPlayDiffTime = n - this.playTime),
      e <= this.lastPacketTs)
    )
      return (
        this.log.warn(
          `Audio frame ${e} arrived, but last queued audio frame was ${this.lastPacketTs}. Skipping audio frame.`
        ),
        void this.stats.dropped++
      );
    null !== A &&
      (e < this.skipPacketTs
        ? (this.log.debugIf(() => `Audio frame ${e} skip late raw packet`), this.stats.dropped++)
        : this.initDone
          ? (Rd(A) && this.log.info(`Audio frame ${e} has clipping`),
            this.log.debugIf(() => this.logAudioDebug(e, n, t)),
            this.processAudioFrame(A, t, n, e))
          : (Rd(A) && this.log.info(`Audio frame ${e} has clipping`),
            this.log.debug(
              `Audio frame ${e}. Arrival time ${n}s real play time ${this.playTime + t}. Still initializing parameters.`
            ),
            this.playAudioFrame(A, this.playTime + t + this.startTime))),
      (this.lastArrivalTime = n),
      (this.lastPacketTs = e);
  }
  noDecode() {
    this.evaluateBufferTimeoutCalled && clearTimeout(this.evaluateBufferTimeoutCalled),
      this.settings.channel.sendStopService(dd.AudioService.STREAM);
  }
  getStats() {
    const A = {
      bufferTimeAvg:
        this.stats.count > 0 ? Math.round((1e3 * this.stats.bufferTimeSum) / this.stats.count) : 0,
      bufferTimeMin: this.stats.count > 0 ? Math.round(1e3 * this.stats.bufferTimeMin) : 0,
      bufferTimeMax: Math.round(1e3 * this.stats.bufferTimeMax),
      bufferTimeLast: Math.round(1e3 * this.lastPlayBufferTime),
      queuedTimeAvg:
        this.stats.count > 0 ? Math.round((1e3 * this.stats.queuedTimeSum) / this.stats.count) : 0,
      queuedTimeMin: this.stats.count > 0 ? Math.round(1e3 * this.stats.queuedTimeMin) : 0,
      queuedTimeMax: Math.round(1e3 * this.stats.queuedTimeMax),
      queuedTimeLast: Math.round(1e3 * this.lastQueuedTime),
      packets: this.stats.count + this.stats.dropped,
      dropped: this.stats.dropped
    };
    return this.resetStats(), A;
  }
  resetStats() {
    this.stats = {
      bufferTimeMin: Number.MAX_SAFE_INTEGER,
      bufferTimeSum: 0,
      bufferTimeMax: 0,
      queuedTimeMin: Number.MAX_SAFE_INTEGER,
      queuedTimeSum: 0,
      queuedTimeMax: 0,
      count: 0,
      dropped: 0
    };
  }
}
function Bd() {
  const A = {
    codec: "opus",
    sampleRate: this.settings.audioSamplerate,
    numberOfChannels: this.settings.audioChannels
  };
  return this.settings.DecoderType.isConfigSupported(A);
}
function Qd(A, e) {
  let t = "";
  e && clearTimeout(e), A && (t += A);
  try {
    this.audioDecoder.close();
  } catch (A) {
    t += `[control] ${A}`;
  }
  return t;
}
function Ed(A) {
  return {
    output: (e) => {
      const t = this.audioDecoderTsQueue.shift();
      this.log.debug(`Decoded: ${t}`),
        A && clearTimeout(A),
        this.decodeTimes.push((performance.now() - this.startDecodingTimes.shift()) / 1e3),
        this.decodeTimes.length > ud && this.setBufferTime();
    },
    error: (e) => {
      throw new Error(Qd.call(this, `[codec] ${e}`, A));
    }
  };
}
function hd() {
  return new Promise((A, e) => {
    try {
      Bd.call(this).then((t) => {
        if (t.supported) {
          const i = setTimeout(() => {
            e(Qd.call(this, "[codec] frame not decoded in time"));
          }, 1e3);
          this.audioDecoderTsQueue = [];
          const n = Ed.call(this, i);
          try {
            this.audioDecoder.configure(n, t.config);
          } catch (A) {
            return void e(Qd.call(this, A.message));
          }
          (this.startTime = this.settings.audioContext.currentTime), (this.lastArrivalTime = 0);
          for (let A = 0; null !== od(A) && A <= ud; A++)
            this.decode(od(A), 2e4 * A), this.startDecodingTimes.push(performance.now());
          A();
        } else e(Qd.call(this, "Decoder configuration not supported."));
      });
    } catch (A) {
      e(Qd.call(this, `[control] ${A}`));
    }
  });
}
function pd(A, e) {
  return new Promise((t, i) => {
    try {
      Bd.call(this).then((n) => {
        if (n.supported) {
          const o = setTimeout(() => {
            i(Qd.call(this, "[codec] frame not decoded in time"));
          }, 1e3);
          this.audioDecoderTsQueue = [];
          const r = Ed.call(this, o);
          try {
            this.audioDecoder.configure(r, n.config);
          } catch (A) {
            return void i(Qd.call(this, A.message));
          }
          (this.startTime = this.settings.audioContext.currentTime), (this.lastArrivalTime = 0);
          for (let t = 0; t <= ud; t++)
            this.decode(A(e())), this.startDecodingTimes.push(performance.now());
          t();
        } else i(Qd.call(this, "Decoder configuration not supported."));
      });
    } catch (A) {
      i(Qd.call(this, `[control] ${A}`));
    }
  });
}
function fd() {
  let A;
  (this.lastBufferCheck = this.settings.audioContext.currentTime),
    this.lastArrivalPlayDiffTime <= 0
      ? ((A = this.bufferTime - this.minBufferTime),
        (this.dropFrames = Math.floor(A / this.settings.audioFrameTime)),
        this.log.debugIf(() => this.logStateBufferEvaluation(A)),
        this.dropFrames > 0
          ? ((this.decodeFunction = Dd.bind(this)),
            this.log.debugIf(() => this.logStateDropFrame()),
            (this.lastBufferChecked = A - this.dropFrames * this.settings.audioFrameTime))
          : (this.lastBufferChecked = A))
      : ((A = this.bufferTime - this.minBufferTime - this.lastArrivalPlayDiffTime),
        A >= this.lastBufferChecked
          ? ((this.dropFrames = Math.floor(A / this.settings.audioFrameTime)),
            this.log.debugIf(() => this.logStateBufferEvaluation(A)),
            this.dropFrames > 0
              ? ((this.decodeFunction = Dd.bind(this)),
                this.log.debugIf(() => this.logStateDropFrame()),
                (this.lastBufferChecked = A - this.dropFrames * this.settings.audioFrameTime))
              : (this.lastBufferChecked = A))
          : (this.lastBufferChecked = A)),
    this.evaluateBufferTimeoutCalled && clearTimeout(this.evaluateBufferTimeoutCalled),
    (this.evaluateBufferIntervalTimeout = Math.min(this.evaluateBufferIntervalTimeout + cd, Id)),
    (this.evaluateBufferTimeoutCalled = setTimeout(
      md.bind(this),
      this.evaluateBufferIntervalTimeout
    ));
}
function md() {
  return this.decodeFunction === yd ||
    this.decodeFunction === this.playFromSilence ||
    this.decodeFunction === this.noDecode
    ? ((this.lastBufferCheck = this.settings.audioContext.currentTime),
      (this.evaluateBufferIntervalTimeout = Math.max(cd, this.evaluateBufferIntervalTimeout - cd)),
      (this.lastBufferChecked = 1e3),
      this.evaluateBufferTimeoutCalled && clearTimeout(this.evaluateBufferTimeoutCalled),
      void (this.evaluateBufferTimeoutCalled = setTimeout(
        md.bind(this),
        this.evaluateBufferIntervalTimeout
      )))
    : this.settings.audioContext.currentTime - this.lastBufferCheck < 2
      ? (this.evaluateBufferTimeoutCalled && clearTimeout(this.evaluateBufferTimeoutCalled),
        void (this.evaluateBufferTimeoutCalled = setTimeout(
          md.bind(this),
          this.evaluateBufferIntervalTimeout
        )))
      : void fd.call(this);
}
function yd(A, e) {
  if (0 === this.firstPacketSinceSilenceTs)
    return (
      this.log.info(
        `Audio frame ${e} received after silence, stop skipping frames up to ${this.skipPacketTs}`
      ),
      this.silence(),
      void this.decodeFunction(A, e)
    );
  (this.lastBufferCheck = this.settings.audioContext.currentTime),
    e < this.skipPacketTs
      ? (this.evaluateBufferTimeoutCalled && clearTimeout(this.evaluateBufferTimeoutCalled),
        this.log.debugIf(() => `Audio frame ${e} skipped`),
        this.framesReceivedSinceStartTime++,
        this.stats.dropped++)
      : (0 === this.audioDecoder.decodeQueueSize &&
          0 !== this.audioDecoderTsQueue.length &&
          (this.log.warn(
            `Remove ${this.audioDecoderTsQueue.length} pending elements from timestamps queue`
          ),
          (this.audioDecoderTsQueue = [])),
        this.log.info(`Audio frame ${e} stop skipping frames`),
        (this.skipPacketTs = 0),
        (this.decodeFunction = this.chosenDecodingFunction.bind(this)),
        this.decodeFunction(A, e),
        (this.evaluateBufferTimeoutCalled = setTimeout(
          md.bind(this),
          this.evaluateBufferIntervalTimeout
        )));
}
function Dd(A, e) {
  this.dropFrames
    ? (this.framesReceivedSinceStartTime++,
      this.dropFrames--,
      (this.bufferTime -= this.settings.audioFrameTime),
      this.stats.dropped++)
    : (0 === this.audioDecoder.decodeQueueSize &&
        0 !== this.audioDecoderTsQueue.length &&
        (this.log.warn(`Remove ${this.audioDecoderTsQueue.length} elements from timestamps queue`),
        (this.audioDecoderTsQueue = [])),
      this.log.debugIf(() => `Stopped dropping frames, buffer is ${this.bufferTime}`),
      (this.decodeFunction = this.chosenDecodingFunction.bind(this)),
      this.decodeFunction(A, e));
}
function wd(A) {
  return null !== A && A.state === rd.CONFIGURED;
}
function Fd() {
  this.log.debug("Decoder initialization"),
    (this.decodeFunction = bd.bind(this)),
    (this.startTime = this.settings.audioContext.currentTime),
    (this.lastArrivalTime = 0),
    (this.startFlag = !0),
    (this.key = !0),
    bd.call(this);
}
function bd() {
  if (
    ((this.currentConfig = {
      codec: "opus",
      sampleRate: this.settings.audioSamplerate,
      numberOfChannels: this.settings.audioChannels
    }),
    null === this.currentConfig)
  )
    return this.log.error("Decoder configuration failed: no config"), void Ud.call(this);
  if (
    this.settings.firstDisplayFrameReady &&
    "running" === this.settings.audioContext.state &&
    !wd(this.audioDecoder)
  ) {
    if (
      ((this.audioDecoderTsQueue = []),
      null !== this.audioDecoder && this.audioDecoder.state === rd.UNCONFIGURED)
    ) {
      this.log.debug(`Requested config: ${C(this.currentConfig)}`);
      try {
        this.settings.DecoderType.isConfigSupported(this.currentConfig).then((A) => {
          if (A.supported) {
            this.currentConfig = A.config;
            const e = {
              output: (A) => {
                const e = this.audioDecoderTsQueue.shift();
                this.log.debugIf(() => `Audio frame ${e} decoded`),
                  this.startFlag && this.playBufferRaw(A, e);
              },
              error: (A) => {
                A.code === DOMException.QUOTA_EXCEEDED_ERR
                  ? (this.log.debug(A), (this.contextState = ld))
                  : (this.log.error(A), Ud.call(this));
              }
            };
            if (
              (this.audioDecoder.configure(e, this.currentConfig),
              this.setDecodeFunction(),
              this.decodeTimes.length > 0)
            ) {
              const A = this.decodeTimes.sort((A, e) => A - e)[
                Math.floor(0.9 * this.decodeTimes.length) - 1
              ];
              A > this.bufferTime &&
                ((this.bufferTime = Math.max(A, this.bufferTime)),
                this.log.debug(`[Init] New buffer time ${this.bufferTime}`));
            }
            if (this.initArrivalTime.length > 1) {
              let A = 0,
                e = 0;
              for (let t = 0; t < this.initArrivalTime.length; t++)
                this.initArrivalTime[t + 1] - this.initArrivalTime[t] >
                  this.settings.audioFrameTime &&
                  ((A +=
                    this.initArrivalTime[t + 1] -
                    this.initArrivalTime[t] -
                    this.settings.audioFrameTime),
                  e++);
              e > 0 &&
                (this.log.debug("[Init] Adding to buffer a mean delay arrival time of " + A / e),
                (this.bufferTime += A / e));
            }
            (this.initDone = !0),
              (this.framesReceivedSinceStartTime = 0),
              (this.startTime = this.settings.audioContext.currentTime),
              (this.lastArrivalTime = 0),
              this.log.debug(
                `[Init] Frame received with time ${this.settings.audioContext.currentTime} Decode Times ${this.decodeTimes} (FirstFrameReady ${this.settings.firstDisplayFrameReady} AudioContext state ${this.settings.audioContext.state})`
              );
          } else
            this.log.error("Decoder configuration not supported."),
              this.audioDecoder.close(),
              (this.audioDecoder = null);
        });
      } catch (A) {
        this.log.error(`Decoder configuration failed: ${A}`),
          this.audioDecoder.close(),
          (this.audioDecoder = null);
      }
    }
  } else
    this.settings.firstDisplayFrameReady &&
      "running" === this.settings.audioContext.state &&
      wd(this.audioDecoder) &&
      this.setDecodeFunction();
}
function Ud() {
  return wd(this.audioDecoder)
    ? (this.settings.channel && this.settings.channel.sendStopService(dd.AudioService.STREAM),
      (this.initFunction = this.noDecode.bind(this)),
      (this.decodeFunction = this.noDecode.bind(this)),
      this.audioDecoder
        .flush()
        .then(() => {
          this.audioDecoder.close();
        })
        .catch((A) => {
          A.code === DOMException.ABORT_ERR && this.log.info("Closed Audio Decoder");
        }))
    : Promise.resolve();
}
function Sd(A, e) {
  if ("running" !== this.settings.audioContext.state) return;
  const t = this.settings.audioContext.createBuffer(
      this.settings.audioChannels,
      this.settings.audioFrameSamples,
      this.settings.audioSamplerate
    ),
    i = t.getChannelData(0),
    n = t.getChannelData(1),
    o = this.settings.audioContext.createBufferSource();
  for (let e = 0, t = 0; e < A.length; e += 2, t++) (i[t] = A[e]), (n[t] = A[e + 1]);
  this.settings.gainValueChanged &&
    (this.settings.gainNode.gain.setValueAtTime(
      this.settings.gainValue,
      this.settings.audioContext.currentTime
    ),
    (this.settings.gainValueChanged = !1)),
    o.connect(this.settings.gainNode),
    (o.buffer = t),
    o.start(e, 0, t.duration),
    (this.lastPlayedTime = e),
    this.log.debugIf(() => `lastPlayedTime ${this.lastPlayedTime}`);
}
function Rd(A) {
  for (let e = 0; e < A.length; e++) if (A[e] >= 1 || A[e] <= -1) return !0;
  return !1;
}
class vd extends ad {
  constructor(A) {
    super(A), (this.log = Q("webdecoder", A));
  }
  #A;
  #e;
  #t(A) {
    const e = { planeIndex: 0, format: "f32" };
    let t = new Float32Array(A.allocationSize(e));
    A.copyTo(t, e), A.close(), this.#e(t);
  }
  get state() {
    return this.#A ? this.#A.state : rd.UNCONFIGURED;
  }
  get decodeQueueSize() {
    return this.#A.decodeQueueSize;
  }
  static isConfigSupported(A) {
    return window.AudioDecoder.isConfigSupported(A);
  }
  configure(A, e) {
    if (!Xn(A.output)) throw new TypeError(`Invalid output callback type '${typeof A.output}'`);
    this.log.debug(`Configuring decoder (${this.#A ? "no " : ""}old decoder present)`),
      this.close(),
      (this.#e = A.output),
      (this.#A = new window.AudioDecoder({ output: this.#t.bind(this), error: A.error })),
      this.#A.configure(e);
  }
  decode(A, e) {
    if (!this.#A)
      throw new DOMException("Cannot decode: decoder not configured", "InvalidStateError");
    const t = new window.EncodedAudioChunk({ type: e, timestamp: 0, data: A });
    this.#A.decode(t);
  }
  flush() {
    if (!this.#A)
      throw new DOMException("Cannot flush: decoder not configured", "InvalidStateError");
    return (
      this.log.debug("Flushing decoder"),
      this.#A.flush().then(() => {
        this.log.debug("Decoder flushed");
      })
    );
  }
  reset() {
    this.#A && (this.log.debug("Resetting decoder"), this.#A.reset());
  }
  close() {
    this.log.debug("Closing decoder"), this.#A && this.#A.close(), (this.#A = null);
  }
}
var xd = { exports: {} };
!(function (A) {
  var e,
    t =
      ((e =
        "undefined" != typeof document && document.currentScript
          ? document.currentScript.src
          : void 0),
      function (A) {
        var t, i;
        (A = void 0 !== (A = A || {}) ? A : {}).ready = new Promise(function (A, e) {
          (t = A), (i = e);
        });
        var n,
          o = {};
        for (n in A) A.hasOwnProperty(n) && (o[n] = A[n]);
        var r,
          s = !0,
          a = "";
        "undefined" != typeof document &&
          document.currentScript &&
          (a = document.currentScript.src),
          e && (a = e),
          (a = 0 !== a.indexOf("blob:") ? a.substr(0, a.lastIndexOf("/") + 1) : "");
        var g,
          c,
          I = A.print || console.log.bind(console),
          l = A.printErr || console.warn.bind(console);
        for (n in o) o.hasOwnProperty(n) && (A[n] = o[n]);
        (o = null),
          A.arguments && A.arguments,
          A.thisProgram && A.thisProgram,
          A.quit && A.quit,
          A.wasmBinary && (g = A.wasmBinary),
          A.noExitRuntime,
          "object" != typeof WebAssembly && S("no native wasm support detected");
        var d,
          u,
          C,
          B,
          Q,
          E,
          h,
          p = !1,
          f = "undefined" != typeof TextDecoder ? new TextDecoder("utf8") : void 0;
        function m(A, e, t) {
          for (var i = e + t, n = e; A[n] && !(n >= i); ) ++n;
          if (n - e > 16 && A.subarray && f) return f.decode(A.subarray(e, n));
          for (var o = ""; e < n; ) {
            var r = A[e++];
            if (128 & r) {
              var s = 63 & A[e++];
              if (192 != (224 & r)) {
                var a = 63 & A[e++];
                if (
                  (r =
                    224 == (240 & r)
                      ? ((15 & r) << 12) | (s << 6) | a
                      : ((7 & r) << 18) | (s << 12) | (a << 6) | (63 & A[e++])) < 65536
                )
                  o += String.fromCharCode(r);
                else {
                  var g = r - 65536;
                  o += String.fromCharCode(55296 | (g >> 10), 56320 | (1023 & g));
                }
              } else o += String.fromCharCode(((31 & r) << 6) | s);
            } else o += String.fromCharCode(r);
          }
          return o;
        }
        A.INITIAL_MEMORY;
        var y = [],
          D = [],
          w = [],
          F = [],
          b = 0,
          U = null;
        function S(e) {
          A.onAbort && A.onAbort(e),
            l((e += "")),
            (p = !0),
            (e = "abort(" + e + "). Build with -s ASSERTIONS=1 for more info.");
          var t = new WebAssembly.RuntimeError(e);
          throw (i(t), t);
        }
        (A.preloadedImages = {}), (A.preloadedAudios = {});
        var R = "data:application/octet-stream;base64,";
        function v(A) {
          return (
            (e = A), (t = R), String.prototype.startsWith ? e.startsWith(t) : 0 === e.indexOf(t)
          );
          var e, t;
        }
        var x,
          M,
          O,
          k =
            "data:application/octet-stream;base64,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";
        function N(A) {
          try {
            if (A == k && g) return new Uint8Array(g);
            var e = (function (A) {
              if (v(A))
                return (function (A) {
                  try {
                    for (var e = P(A), t = new Uint8Array(e.length), i = 0; i < e.length; ++i)
                      t[i] = e.charCodeAt(i);
                    return t;
                  } catch (A) {
                    throw new Error("Converting base64 string to bytes failed.");
                  }
                })(A.slice(R.length));
            })(A);
            if (e) return e;
            if (!r) throw "both async and sync fetching of the wasm failed";
          } catch (A) {
            S(A);
          }
        }
        function K(e) {
          for (; e.length > 0; ) {
            var t = e.shift();
            if ("function" != typeof t) {
              var i = t.func;
              "number" == typeof i
                ? void 0 === t.arg
                  ? h.get(i)()
                  : h.get(i)(t.arg)
                : i(void 0 === t.arg ? null : t.arg);
            } else t(A);
          }
        }
        v(k) || ((x = k), (k = A.locateFile ? A.locateFile(x, a) : a + x));
        var L,
          T = {
            mappings: {},
            buffers: [null, [], []],
            printChar: function (A, e) {
              var t = T.buffers[A];
              0 === e || 10 === e ? ((1 === A ? I : l)(m(t, 0)), (t.length = 0)) : t.push(e);
            },
            varargs: void 0,
            get: function () {
              return (T.varargs += 4), B[(T.varargs - 4) >> 2];
            },
            getStr: function (A) {
              var e = (function (A, e) {
                return A ? m(u, A, e) : "";
              })(A);
              return e;
            },
            get64: function (A, e) {
              return A;
            }
          },
          P =
            "function" == typeof atob
              ? atob
              : function (A) {
                  var e,
                    t,
                    i,
                    n,
                    o,
                    r,
                    s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
                    a = "",
                    g = 0;
                  A = A.replace(/[^A-Za-z0-9\+\/\=]/g, "");
                  do {
                    (e = (s.indexOf(A.charAt(g++)) << 2) | ((n = s.indexOf(A.charAt(g++))) >> 4)),
                      (t = ((15 & n) << 4) | ((o = s.indexOf(A.charAt(g++))) >> 2)),
                      (i = ((3 & o) << 6) | (r = s.indexOf(A.charAt(g++)))),
                      (a += String.fromCharCode(e)),
                      64 !== o && (a += String.fromCharCode(t)),
                      64 !== r && (a += String.fromCharCode(i));
                  } while (g < A.length);
                  return a;
                },
          G = {
            a: function () {
              l("missing function: __stack_chk_fail"), S(-1);
            },
            e: function () {
              S();
            },
            f: function (A, e, t) {
              u.copyWithin(A, e, e + t);
            },
            d: function (A) {
              u.length, S("OOM");
            },
            g: function (A) {
              return 0;
            },
            c: function (A, e, t, i, n) {},
            b: function (A, e, t, i) {
              for (var n = 0, o = 0; o < t; o++) {
                for (var r = B[(e + 8 * o) >> 2], s = B[(e + (8 * o + 4)) >> 2], a = 0; a < s; a++)
                  T.printChar(A, u[r + a]);
                n += s;
              }
              return (B[i >> 2] = n), 0;
            }
          };
        function H(e) {
          function i() {
            L ||
              ((L = !0),
              (A.calledRun = !0),
              p ||
                (K(D),
                K(w),
                t(A),
                A.onRuntimeInitialized && A.onRuntimeInitialized(),
                (function () {
                  if (A.postRun)
                    for (
                      "function" == typeof A.postRun && (A.postRun = [A.postRun]);
                      A.postRun.length;

                    )
                      (e = A.postRun.shift()), F.unshift(e);
                  var e;
                  K(F);
                })()));
          }
          b > 0 ||
            ((function () {
              if (A.preRun)
                for ("function" == typeof A.preRun && (A.preRun = [A.preRun]); A.preRun.length; )
                  (e = A.preRun.shift()), y.unshift(e);
              var e;
              K(y);
            })(),
            b > 0 ||
              (A.setStatus
                ? (A.setStatus("Running..."),
                  setTimeout(function () {
                    setTimeout(function () {
                      A.setStatus("");
                    }, 1),
                      i();
                  }, 1))
                : i()));
        }
        if (
          ((function () {
            var e = { a: G };
            function t(e, t) {
              var i,
                n,
                o = e.exports;
              (A.asm = o),
                (c = A.asm.h),
                (i = c.buffer),
                (A.HEAP8 = d = new Int8Array(i)),
                (A.HEAP16 = C = new Int16Array(i)),
                (A.HEAP32 = B = new Int32Array(i)),
                (A.HEAPU8 = u = new Uint8Array(i)),
                (A.HEAPU16 = new Uint16Array(i)),
                (A.HEAPU32 = new Uint32Array(i)),
                (A.HEAPF32 = Q = new Float32Array(i)),
                (A.HEAPF64 = E = new Float64Array(i)),
                (h = A.asm.t),
                (n = A.asm.i),
                D.unshift(n),
                (function () {
                  if ((b--, A.monitorRunDependencies && A.monitorRunDependencies(b), 0 == b && U)) {
                    var e = U;
                    (U = null), e();
                  }
                })();
            }
            function n(A) {
              t(A.instance);
            }
            function o(A) {
              return (
                !g && s && "function" == typeof fetch
                  ? fetch(k, { credentials: "same-origin" })
                      .then(function (A) {
                        if (!A.ok) throw "failed to load wasm binary file at '" + k + "'";
                        return A.arrayBuffer();
                      })
                      .catch(function () {
                        return N(k);
                      })
                  : Promise.resolve().then(function () {
                      return N(k);
                    })
              )
                .then(function (A) {
                  return WebAssembly.instantiate(A, e);
                })
                .then(A, function (A) {
                  l("failed to asynchronously prepare wasm: " + A), S(A);
                });
            }
            if ((b++, A.monitorRunDependencies && A.monitorRunDependencies(b), A.instantiateWasm))
              try {
                return A.instantiateWasm(e, t);
              } catch (A) {
                return l("Module.instantiateWasm callback failed with error: " + A), !1;
              }
            (g ||
            "function" != typeof WebAssembly.instantiateStreaming ||
            v(k) ||
            "function" != typeof fetch
              ? o(n)
              : fetch(k, { credentials: "same-origin" }).then(function (A) {
                  return WebAssembly.instantiateStreaming(A, e).then(n, function (A) {
                    return (
                      l("wasm streaming compile failed: " + A),
                      l("falling back to ArrayBuffer instantiation"),
                      o(n)
                    );
                  });
                })
            ).catch(i);
          })(),
          (A.___wasm_call_ctors = function () {
            return (A.___wasm_call_ctors = A.asm.i).apply(null, arguments);
          }),
          (A._opus_decoder_create = function () {
            return (A._opus_decoder_create = A.asm.j).apply(null, arguments);
          }),
          (A._opus_decode_float = function () {
            return (A._opus_decode_float = A.asm.k).apply(null, arguments);
          }),
          (A._opus_decoder_ctl = function () {
            return (A._opus_decoder_ctl = A.asm.l).apply(null, arguments);
          }),
          (A._opus_encoder_create = function () {
            return (A._opus_encoder_create = A.asm.m).apply(null, arguments);
          }),
          (A._opus_encode_float = function () {
            return (A._opus_encode_float = A.asm.n).apply(null, arguments);
          }),
          (A._opus_encoder_ctl = function () {
            return (A._opus_encoder_ctl = A.asm.o).apply(null, arguments);
          }),
          (A._speex_resampler_init = function () {
            return (A._speex_resampler_init = A.asm.p).apply(null, arguments);
          }),
          (A._speex_resampler_process_interleaved_float = function () {
            return (A._speex_resampler_process_interleaved_float = A.asm.q).apply(null, arguments);
          }),
          (A._malloc = function () {
            return (A._malloc = A.asm.r).apply(null, arguments);
          }),
          (A._free = function () {
            return (A._free = A.asm.s).apply(null, arguments);
          }),
          (A.setValue = function (A, e, t, i) {
            switch (("*" === (t = t || "i8").charAt(t.length - 1) && (t = "i32"), t)) {
              case "i1":
              case "i8":
                d[0 | A] = e;
                break;
              case "i16":
                C[A >> 1] = e;
                break;
              case "i32":
                B[A >> 2] = e;
                break;
              case "i64":
                (O = [
                  e >>> 0,
                  ((M = e),
                  +Math.abs(M) >= 1
                    ? M > 0
                      ? (0 | Math.min(+Math.floor(M / 4294967296), 4294967295)) >>> 0
                      : ~~+Math.ceil((M - +(~~M >>> 0)) / 4294967296) >>> 0
                    : 0)
                ]),
                  (B[A >> 2] = O[0]),
                  (B[(A + 4) >> 2] = O[1]);
                break;
              case "float":
                Q[A >> 2] = e;
                break;
              case "double":
                E[A >> 3] = e;
                break;
              default:
                S("invalid type for setValue: " + t);
            }
          }),
          (A.getValue = function (A, e, t) {
            switch (("*" === (e = e || "i8").charAt(e.length - 1) && (e = "i32"), e)) {
              case "i1":
              case "i8":
                return d[0 | A];
              case "i16":
                return C[A >> 1];
              case "i32":
              case "i64":
                return B[A >> 2];
              case "float":
                return Q[A >> 2];
              case "double":
                return E[A >> 3];
              default:
                S("invalid type for getValue: " + e);
            }
            return null;
          }),
          (U = function A() {
            L || H(), L || (U = A);
          }),
          (A.run = H),
          A.preInit)
        )
          for ("function" == typeof A.preInit && (A.preInit = [A.preInit]); A.preInit.length > 0; )
            A.preInit.pop()();
        return H(), A.ready;
      });
  A.exports = t;
})(xd);
var Md = xd.exports;
class Od extends ad {
  constructor(A) {
    super(A), (this.log = Q("opusdecoder", A));
  }
  #i;
  #n;
  #o;
  #r;
  #s = rd.UNCONFIGURED;
  #a() {
    let A,
      e = this.#o._malloc(4);
    if (
      ((this.#r = this.#o._opus_decoder_create(this.sampleRate, this.numberOfChannels, e)),
      (A = this.#o.getValue(e, "i32")),
      this.#o._free(e),
      0 !== A)
    )
      throw new Error(`Error ${A} during decoder creation`);
    this.log.debug("Decoder created");
  }
  #g() {
    this.#r &&
      (this.#o._free(this.#r),
      (this.#r = null),
      this.log.debug(),
      this.log.debug("Decoder destroyed"));
  }
  initializeResources() {
    return this.#o
      ? Promise.resolve()
      : (this.log.debug("Initializing wasm module"),
        new Promise((A, e) => {
          Md()
            .then((e) => {
              (this.#o = e), this.log.debug("Wasm module initialized"), A();
            })
            .catch(e);
        }));
  }
  get state() {
    return this.#s;
  }
  get decodeQueueSize() {
    return 0;
  }
  static #c(A) {
    if (!zn(A)) throw new TypeError("No configuration provided");
    if (!Zn(A.sampleRate)) throw new TypeError("Invalid sample rate provided in configuration");
    if (!Zn(A.numberOfChannels))
      throw new TypeError("Invalid number of channels provided in configuration");
    return !0;
  }
  static isConfigSupported(A) {
    return Promise.resolve({
      supported: Od.#c(A),
      config: { sampleRate: A.sampleRate, numberOfChannels: A.numberOfChannels }
    });
  }
  configure(A, e) {
    if (!zn(A)) throw new TypeError(`Invalid init dictionary type '${typeof A}'`);
    if (!Xn(A.output)) throw new TypeError(`Invalid output callback type '${typeof A.output}'`);
    if (!Xn(A.error)) throw new TypeError(`Invalid error callback type '${typeof A.error}'`);
    this.log.debug(`Configuring decoder (${this.#r ? "no " : ""}old decoder present)`),
      this.#r && this.#g(),
      (this.#i = A.output),
      (this.#n = A.error),
      Od.#c(e),
      (this.sampleRate = e.sampleRate),
      (this.numberOfChannels = e.numberOfChannels),
      this.#a(),
      (this.#s = rd.CONFIGURED);
  }
  decode(A) {
    if (this.state !== rd.CONFIGURED)
      throw new DOMException("Cannot decode: decoder not configured", "InvalidStateError");
    new Promise((e, t) => {
      const i = 5760 * this.numberOfChannels;
      let n, o, r, s, a, g, c;
      A &&
        ((c = A.byteLength),
        (o = this.#o._malloc(c)),
        (a = this.#o._malloc(4 * i)),
        (n = this.#o.HEAPU8.subarray(o, o + c)),
        (s = this.#o.HEAPF32.subarray(a / 4, a / 4 + i)),
        n.set(new Uint8Array(A)),
        (g = this.#o._opus_decode_float(this.#r, o, A.byteLength, a, 5760, 0)),
        g <= 0
          ? t("Error on decoding the audio frame")
          : ((r = new Float32Array(s.subarray(0, g * this.numberOfChannels))), e(r)),
        this.#o._free(o),
        this.#o._free(a));
    })
      .then(this.#i)
      .catch(this.#n);
  }
  flush() {
    if (this.state !== rd.CONFIGURED)
      throw new DOMException("Cannot flush: decoder not configured", "InvalidStateError");
    return this.log.debug("Flushed decoder"), Promise.resolve();
  }
  reset() {
    if (this.#r) {
      this.log.debug("Resetting decoder");
      const A = this.#o._opus_decoder_ctl(this.#r, 4028);
      0 !== A &&
        (this.log.warn(`Error ${A} while resetting decoder, creating a new one`),
        this.#g(),
        this.#a());
    }
    this.#s = rd.UNCONFIGURED;
  }
  close() {
    this.log.debug("Closing decoder"), this.#g(), (this.#s = rd.UNCONFIGURED);
  }
}
class kd {
  constructor(A, e) {
    (this.clientConnectionId = A),
      (this.webCodecsEnabled = e),
      (this.log = Q("audiooutput", this.clientConnectionId)),
      (this.channel = null),
      (this.firstDisplayFrameReady = !1),
      (this.gainNode = null),
      (this.gainValue = 1),
      (this.gainValueChanged = !1),
      (this.audioChannels = -1),
      (this.audioSamplerate = -1),
      (this.audioFrameSamples = -1),
      (this.audioFrameTime = -1),
      (this.audioContext = Ts()),
      (this.gainNode = this.audioContext.createGain()),
      this.gainNode.connect(this.audioContext.destination);
  }
  registerChannel(A) {
    this.channel && this.log.warn("Channel registration overwriting previous channel"),
      (this.channel = A);
  }
  unregisterChannel(A) {
    this.channel === A ? (this.channel = null) : this.log.warn("Skip unregister of wrong channel");
  }
  setAudioChannels(A) {
    A <= 0 || (this.audioChannels = A);
  }
  setAudioSamplerate(A) {
    A <= 0 ||
      ((this.audioSamplerate = A),
      this.audioFrameSamples > 0 &&
        (this.audioFrameTime = this.audioFrameSamples / this.audioSamplerate));
  }
  setFrameSamples(A) {
    A <= 0 ||
      ((this.audioFrameSamples = A),
      this.audioSamplerate > 0 &&
        (this.audioFrameTime = this.audioFrameSamples / this.audioSamplerate));
  }
  setVolume(A) {
    oo(A, 0, 1) && ((this.gainValue = A), (this.gainValueChanged = !0));
  }
  getPlayer(A) {
    return this.audioSamplerate <= 0 || this.audioFrameSamples <= 0 || this.audioChannels <= 0
      ? (this.log.warn(
          `Not all the settings have valid values (${this.audioSamplerate}, ${this.audioFrameSamples}, ${this.audioChannels})`
        ),
        Promise.reject())
      : Nd.call(this, A);
  }
  reset() {
    this.log.info("Resetting audio output."),
      (this.channel = null),
      (this.firstDisplayFrameReady = !1),
      (this.gainNode = null),
      (this.gainValue = 1),
      (this.gainValueChanged = !1),
      (this.audioChannels = -1),
      (this.audioSamplerate = -1),
      (this.audioFrameSamples = -1),
      (this.audioFrameTime = -1);
  }
  displayReady(A) {
    this.firstDisplayFrameReady = A;
  }
}
async function Nd(A) {
  if (A !== da) return this.log.warn(`Invalid codec selected: ${A}`), null;
  const e = {
      codec: "opus",
      sampleRate: this.audioSamplerate,
      numberOfChannels: this.audioChannels
    },
    { supported: t } =
      "AudioDecoder" in window ? await window.AudioDecoder.isConfigSupported(e) : { supported: !1 };
  return (this.DecoderType = t && this.webCodecsEnabled ? vd : Od), new Cd(this);
}
const Kd = Fo.exports.Reader,
  Ld = Fo.exports.Writer,
  Td = Fo.exports.util,
  Pd = Fo.exports.roots["dcv.webcam"] || (Fo.exports.roots["dcv.webcam"] = {}),
  Gd = (Pd.dcv = (() => {
    const A = {};
    return (
      (A.audio = (function () {
        const A = {};
        return (
          (A.webcam = (function () {
            const A = {};
            return (
              (A.Resolution = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.width = 0),
                  (A.prototype.height = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.width &&
                        Object.hasOwnProperty.call(A, "width") &&
                        e.uint32(8).uint32(A.width),
                      null != A.height &&
                        Object.hasOwnProperty.call(A, "height") &&
                        e.uint32(16).uint32(A.height),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.Resolution();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.width = A.uint32();
                          break;
                        case 2:
                          i.height = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.width && A.hasOwnProperty("width") && !Td.isInteger(A.width)
                        ? "width: integer expected"
                        : null != A.height && A.hasOwnProperty("height") && !Td.isInteger(A.height)
                          ? "height: integer expected"
                          : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.Resolution) return A;
                    let e = new Pd.dcv.audio.webcam.Resolution();
                    return (
                      null != A.width && (e.width = A.width >>> 0),
                      null != A.height && (e.height = A.height >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.width = 0), (t.height = 0)),
                      null != A.width && A.hasOwnProperty("width") && (t.width = A.width),
                      null != A.height && A.hasOwnProperty("height") && (t.height = A.height),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.Resolution"
                    );
                  }),
                  A
                );
              })()),
              (A.Codec = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.Codec();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.name = A.string();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.name && A.hasOwnProperty("name") && !Td.isString(A.name)
                        ? "name: string expected"
                        : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.Codec) return A;
                    let e = new Pd.dcv.audio.webcam.Codec();
                    return null != A.name && (e.name = String(A.name)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.name = ""),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Codec"
                    );
                  }),
                  A
                );
              })()),
              (A.ServerCapabilities = (function () {
                function A(A) {
                  if (((this.codecs = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.codecs = Td.emptyArray),
                  (A.prototype.maxResolution = null),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if ((e || (e = Ld.create()), null != A.codecs && A.codecs.length))
                      for (let t = 0; t < A.codecs.length; ++t)
                        Pd.dcv.audio.webcam.Codec.encode(A.codecs[t], e.uint32(10).fork()).ldelim();
                    return (
                      null != A.maxResolution &&
                        Object.hasOwnProperty.call(A, "maxResolution") &&
                        Pd.dcv.audio.webcam.Resolution.encode(
                          A.maxResolution,
                          e.uint32(18).fork()
                        ).ldelim(),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.ServerCapabilities();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          (i.codecs && i.codecs.length) || (i.codecs = []),
                            i.codecs.push(Pd.dcv.audio.webcam.Codec.decode(A, A.uint32()));
                          break;
                        case 2:
                          i.maxResolution = Pd.dcv.audio.webcam.Resolution.decode(A, A.uint32());
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.codecs && A.hasOwnProperty("codecs")) {
                      if (!Array.isArray(A.codecs)) return "codecs: array expected";
                      for (let e = 0; e < A.codecs.length; ++e) {
                        let t = Pd.dcv.audio.webcam.Codec.verify(A.codecs[e]);
                        if (t) return "codecs." + t;
                      }
                    }
                    if (null != A.maxResolution && A.hasOwnProperty("maxResolution")) {
                      let e = Pd.dcv.audio.webcam.Resolution.verify(A.maxResolution);
                      if (e) return "maxResolution." + e;
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.ServerCapabilities) return A;
                    let e = new Pd.dcv.audio.webcam.ServerCapabilities();
                    if (A.codecs) {
                      if (!Array.isArray(A.codecs))
                        throw TypeError(
                          ".dcv.audio.webcam.ServerCapabilities.codecs: array expected"
                        );
                      e.codecs = [];
                      for (let t = 0; t < A.codecs.length; ++t) {
                        if ("object" != typeof A.codecs[t])
                          throw TypeError(
                            ".dcv.audio.webcam.ServerCapabilities.codecs: object expected"
                          );
                        e.codecs[t] = Pd.dcv.audio.webcam.Codec.fromObject(A.codecs[t]);
                      }
                    }
                    if (null != A.maxResolution) {
                      if ("object" != typeof A.maxResolution)
                        throw TypeError(
                          ".dcv.audio.webcam.ServerCapabilities.maxResolution: object expected"
                        );
                      e.maxResolution = Pd.dcv.audio.webcam.Resolution.fromObject(A.maxResolution);
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && (t.codecs = []),
                      e.defaults && (t.maxResolution = null),
                      A.codecs && A.codecs.length)
                    ) {
                      t.codecs = [];
                      for (let i = 0; i < A.codecs.length; ++i)
                        t.codecs[i] = Pd.dcv.audio.webcam.Codec.toObject(A.codecs[i], e);
                    }
                    return (
                      null != A.maxResolution &&
                        A.hasOwnProperty("maxResolution") &&
                        (t.maxResolution = Pd.dcv.audio.webcam.Resolution.toObject(
                          A.maxResolution,
                          e
                        )),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.ServerCapabilities"
                    );
                  }),
                  A
                );
              })()),
              (A.ClientCapabilities = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.videoscale = !1),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.videoscale &&
                        Object.hasOwnProperty.call(A, "videoscale") &&
                        e.uint32(8).bool(A.videoscale),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.ClientCapabilities();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.videoscale = A.bool();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.videoscale &&
                          A.hasOwnProperty("videoscale") &&
                          "boolean" != typeof A.videoscale
                        ? "videoscale: boolean expected"
                        : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.ClientCapabilities) return A;
                    let e = new Pd.dcv.audio.webcam.ClientCapabilities();
                    return null != A.videoscale && (e.videoscale = Boolean(A.videoscale)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.videoscale = !1),
                      null != A.videoscale &&
                        A.hasOwnProperty("videoscale") &&
                        (t.videoscale = A.videoscale),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.ClientCapabilities"
                    );
                  }),
                  A
                );
              })()),
              (A.Attach = (function () {
                function A(A) {
                  if (((this.resolutions = []), (this.codecs = []), A))
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.name = ""),
                  (A.prototype.resolutions = Td.emptyArray),
                  (A.prototype.codecs = Td.emptyArray),
                  (A.prototype.capabilities = null),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    if (
                      (e || (e = Ld.create()),
                      null != A.name &&
                        Object.hasOwnProperty.call(A, "name") &&
                        e.uint32(10).string(A.name),
                      null != A.resolutions && A.resolutions.length)
                    )
                      for (let t = 0; t < A.resolutions.length; ++t)
                        Pd.dcv.audio.webcam.Resolution.encode(
                          A.resolutions[t],
                          e.uint32(18).fork()
                        ).ldelim();
                    if (null != A.codecs && A.codecs.length)
                      for (let t = 0; t < A.codecs.length; ++t)
                        Pd.dcv.audio.webcam.Codec.encode(A.codecs[t], e.uint32(26).fork()).ldelim();
                    return (
                      null != A.capabilities &&
                        Object.hasOwnProperty.call(A, "capabilities") &&
                        Pd.dcv.audio.webcam.ClientCapabilities.encode(
                          A.capabilities,
                          e.uint32(34).fork()
                        ).ldelim(),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.Attach();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.name = A.string();
                          break;
                        case 2:
                          (i.resolutions && i.resolutions.length) || (i.resolutions = []),
                            i.resolutions.push(
                              Pd.dcv.audio.webcam.Resolution.decode(A, A.uint32())
                            );
                          break;
                        case 3:
                          (i.codecs && i.codecs.length) || (i.codecs = []),
                            i.codecs.push(Pd.dcv.audio.webcam.Codec.decode(A, A.uint32()));
                          break;
                        case 4:
                          i.capabilities = Pd.dcv.audio.webcam.ClientCapabilities.decode(
                            A,
                            A.uint32()
                          );
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.name && A.hasOwnProperty("name") && !Td.isString(A.name))
                      return "name: string expected";
                    if (null != A.resolutions && A.hasOwnProperty("resolutions")) {
                      if (!Array.isArray(A.resolutions)) return "resolutions: array expected";
                      for (let e = 0; e < A.resolutions.length; ++e) {
                        let t = Pd.dcv.audio.webcam.Resolution.verify(A.resolutions[e]);
                        if (t) return "resolutions." + t;
                      }
                    }
                    if (null != A.codecs && A.hasOwnProperty("codecs")) {
                      if (!Array.isArray(A.codecs)) return "codecs: array expected";
                      for (let e = 0; e < A.codecs.length; ++e) {
                        let t = Pd.dcv.audio.webcam.Codec.verify(A.codecs[e]);
                        if (t) return "codecs." + t;
                      }
                    }
                    if (null != A.capabilities && A.hasOwnProperty("capabilities")) {
                      let e = Pd.dcv.audio.webcam.ClientCapabilities.verify(A.capabilities);
                      if (e) return "capabilities." + e;
                    }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.Attach) return A;
                    let e = new Pd.dcv.audio.webcam.Attach();
                    if ((null != A.name && (e.name = String(A.name)), A.resolutions)) {
                      if (!Array.isArray(A.resolutions))
                        throw TypeError(".dcv.audio.webcam.Attach.resolutions: array expected");
                      e.resolutions = [];
                      for (let t = 0; t < A.resolutions.length; ++t) {
                        if ("object" != typeof A.resolutions[t])
                          throw TypeError(".dcv.audio.webcam.Attach.resolutions: object expected");
                        e.resolutions[t] = Pd.dcv.audio.webcam.Resolution.fromObject(
                          A.resolutions[t]
                        );
                      }
                    }
                    if (A.codecs) {
                      if (!Array.isArray(A.codecs))
                        throw TypeError(".dcv.audio.webcam.Attach.codecs: array expected");
                      e.codecs = [];
                      for (let t = 0; t < A.codecs.length; ++t) {
                        if ("object" != typeof A.codecs[t])
                          throw TypeError(".dcv.audio.webcam.Attach.codecs: object expected");
                        e.codecs[t] = Pd.dcv.audio.webcam.Codec.fromObject(A.codecs[t]);
                      }
                    }
                    if (null != A.capabilities) {
                      if ("object" != typeof A.capabilities)
                        throw TypeError(".dcv.audio.webcam.Attach.capabilities: object expected");
                      e.capabilities = Pd.dcv.audio.webcam.ClientCapabilities.fromObject(
                        A.capabilities
                      );
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (
                      ((e.arrays || e.defaults) && ((t.resolutions = []), (t.codecs = [])),
                      e.defaults && ((t.name = ""), (t.capabilities = null)),
                      null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                      A.resolutions && A.resolutions.length)
                    ) {
                      t.resolutions = [];
                      for (let i = 0; i < A.resolutions.length; ++i)
                        t.resolutions[i] = Pd.dcv.audio.webcam.Resolution.toObject(
                          A.resolutions[i],
                          e
                        );
                    }
                    if (A.codecs && A.codecs.length) {
                      t.codecs = [];
                      for (let i = 0; i < A.codecs.length; ++i)
                        t.codecs[i] = Pd.dcv.audio.webcam.Codec.toObject(A.codecs[i], e);
                    }
                    return (
                      null != A.capabilities &&
                        A.hasOwnProperty("capabilities") &&
                        (t.capabilities = Pd.dcv.audio.webcam.ClientCapabilities.toObject(
                          A.capabilities,
                          e
                        )),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Attach"
                    );
                  }),
                  A
                );
              })()),
              (A.Detach = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.reason = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.reason &&
                        Object.hasOwnProperty.call(A, "reason") &&
                        e.uint32(8).int32(A.reason),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.Detach();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.reason = A.int32();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.reason && A.hasOwnProperty("reason"))
                      switch (A.reason) {
                        default:
                          return "reason: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                      }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.Detach) return A;
                    let e = new Pd.dcv.audio.webcam.Detach();
                    switch (A.reason) {
                      default:
                        if ("number" == typeof A.reason) {
                          e.reason = A.reason;
                          break;
                        }
                        break;
                      case "NO_ERROR":
                      case 0:
                        e.reason = 0;
                        break;
                      case "GENERIC_ERROR":
                      case 1:
                        e.reason = 1;
                        break;
                      case "WEBCAM_ERROR":
                      case 2:
                        e.reason = 2;
                        break;
                      case "WEBCAM_BUSY":
                      case 3:
                        e.reason = 3;
                        break;
                      case "WEBCAM_NOT_FOUND":
                      case 4:
                        e.reason = 4;
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.reason = e.enums === String ? "NO_ERROR" : 0),
                      null != A.reason &&
                        A.hasOwnProperty("reason") &&
                        (t.reason =
                          e.enums === String
                            ? void 0 === Pd.dcv.audio.webcam.Detach.DetachReason[A.reason]
                              ? A.reason
                              : Pd.dcv.audio.webcam.Detach.DetachReason[A.reason]
                            : A.reason),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Detach"
                    );
                  }),
                  (A.DetachReason = (function () {
                    const A = {},
                      e = Object.create(A);
                    return (
                      (e[(A[0] = "NO_ERROR")] = 0),
                      (e[(A[1] = "GENERIC_ERROR")] = 1),
                      (e[(A[2] = "WEBCAM_ERROR")] = 2),
                      (e[(A[3] = "WEBCAM_BUSY")] = 3),
                      (e[(A[4] = "WEBCAM_NOT_FOUND")] = 4),
                      e
                    );
                  })()),
                  A
                );
              })()),
              (A.ErrorResponse = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.code = 0),
                  (A.prototype.details = ""),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.code &&
                        Object.hasOwnProperty.call(A, "code") &&
                        e.uint32(8).int32(A.code),
                      null != A.details &&
                        Object.hasOwnProperty.call(A, "details") &&
                        e.uint32(18).string(A.details),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.ErrorResponse();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.code = A.int32();
                          break;
                        case 2:
                          i.details = A.string();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.code && A.hasOwnProperty("code"))
                      switch (A.code) {
                        default:
                          return "code: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                      }
                    return null != A.details &&
                      A.hasOwnProperty("details") &&
                      !Td.isString(A.details)
                      ? "details: string expected"
                      : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.ErrorResponse) return A;
                    let e = new Pd.dcv.audio.webcam.ErrorResponse();
                    switch (A.code) {
                      default:
                        if ("number" == typeof A.code) {
                          e.code = A.code;
                          break;
                        }
                        break;
                      case "NONE":
                      case 0:
                        e.code = 0;
                        break;
                      case "ATTACH_FAILED":
                      case 1:
                        e.code = 1;
                        break;
                      case "ATTACH_FAILED_NOT_ALLOWED":
                      case 2:
                        e.code = 2;
                        break;
                      case "ATTACH_FAILED_NO_CODECS_SUPPORTED":
                      case 3:
                        e.code = 3;
                        break;
                      case "ATTACH_FAILED_NO_RESOLUTIONS_SUPPORTED":
                      case 4:
                        e.code = 4;
                        break;
                      case "ATTACH_FAILED_ALREADY_ATTACHED":
                      case 5:
                        e.code = 5;
                        break;
                      case "ATTACH_FAILED_DEVICE_IN_USE":
                      case 6:
                        e.code = 6;
                    }
                    return null != A.details && (e.details = String(A.details)), e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.code = e.enums === String ? "NONE" : 0), (t.details = "")),
                      null != A.code &&
                        A.hasOwnProperty("code") &&
                        (t.code =
                          e.enums === String
                            ? void 0 === Pd.dcv.audio.webcam.ErrorResponse.Code[A.code]
                              ? A.code
                              : Pd.dcv.audio.webcam.ErrorResponse.Code[A.code]
                            : A.code),
                      null != A.details && A.hasOwnProperty("details") && (t.details = A.details),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.ErrorResponse"
                    );
                  }),
                  (A.Code = (function () {
                    const A = {},
                      e = Object.create(A);
                    return (
                      (e[(A[0] = "NONE")] = 0),
                      (e[(A[1] = "ATTACH_FAILED")] = 1),
                      (e[(A[2] = "ATTACH_FAILED_NOT_ALLOWED")] = 2),
                      (e[(A[3] = "ATTACH_FAILED_NO_CODECS_SUPPORTED")] = 3),
                      (e[(A[4] = "ATTACH_FAILED_NO_RESOLUTIONS_SUPPORTED")] = 4),
                      (e[(A[5] = "ATTACH_FAILED_ALREADY_ATTACHED")] = 5),
                      (e[(A[6] = "ATTACH_FAILED_DEVICE_IN_USE")] = 6),
                      e
                    );
                  })()),
                  A
                );
              })()),
              (A.StatusUpdate = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.status = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.status &&
                        Object.hasOwnProperty.call(A, "status") &&
                        e.uint32(8).int32(A.status),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.StatusUpdate();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      if (e >>> 3 == 1) i.status = A.int32();
                      else A.skipType(7 & e);
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.status && A.hasOwnProperty("status"))
                      switch (A.status) {
                        default:
                          return "status: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                      }
                    return null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.StatusUpdate) return A;
                    let e = new Pd.dcv.audio.webcam.StatusUpdate();
                    switch (A.status) {
                      default:
                        if ("number" == typeof A.status) {
                          e.status = A.status;
                          break;
                        }
                        break;
                      case "NOT_AVAILABLE":
                      case 0:
                        e.status = 0;
                        break;
                      case "BUSY":
                      case 1:
                        e.status = 1;
                        break;
                      case "AVAILABLE":
                      case 2:
                        e.status = 2;
                        break;
                      case "ATTACHED":
                      case 3:
                        e.status = 3;
                        break;
                      case "STREAMING":
                      case 4:
                        e.status = 4;
                    }
                    return e;
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && (t.status = e.enums === String ? "NOT_AVAILABLE" : 0),
                      null != A.status &&
                        A.hasOwnProperty("status") &&
                        (t.status =
                          e.enums === String
                            ? void 0 === Pd.dcv.audio.webcam.StatusUpdate.ServiceStatus[A.status]
                              ? A.status
                              : Pd.dcv.audio.webcam.StatusUpdate.ServiceStatus[A.status]
                            : A.status),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.StatusUpdate"
                    );
                  }),
                  (A.ServiceStatus = (function () {
                    const A = {},
                      e = Object.create(A);
                    return (
                      (e[(A[0] = "NOT_AVAILABLE")] = 0),
                      (e[(A[1] = "BUSY")] = 1),
                      (e[(A[2] = "AVAILABLE")] = 2),
                      (e[(A[3] = "ATTACHED")] = 3),
                      (e[(A[4] = "STREAMING")] = 4),
                      e
                    );
                  })()),
                  A
                );
              })()),
              (A.StreamConfiguration = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.id = 0),
                  (A.prototype.resolution = null),
                  (A.prototype.codec = null),
                  (A.prototype.bitrate = 0),
                  (A.prototype.fps = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.id &&
                        Object.hasOwnProperty.call(A, "id") &&
                        e.uint32(8).uint32(A.id),
                      null != A.resolution &&
                        Object.hasOwnProperty.call(A, "resolution") &&
                        Pd.dcv.audio.webcam.Resolution.encode(
                          A.resolution,
                          e.uint32(18).fork()
                        ).ldelim(),
                      null != A.codec &&
                        Object.hasOwnProperty.call(A, "codec") &&
                        Pd.dcv.audio.webcam.Codec.encode(A.codec, e.uint32(26).fork()).ldelim(),
                      null != A.bitrate &&
                        Object.hasOwnProperty.call(A, "bitrate") &&
                        e.uint32(32).uint32(A.bitrate),
                      null != A.fps &&
                        Object.hasOwnProperty.call(A, "fps") &&
                        e.uint32(40).uint32(A.fps),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.StreamConfiguration();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.id = A.uint32();
                          break;
                        case 2:
                          i.resolution = Pd.dcv.audio.webcam.Resolution.decode(A, A.uint32());
                          break;
                        case 3:
                          i.codec = Pd.dcv.audio.webcam.Codec.decode(A, A.uint32());
                          break;
                        case 4:
                          i.bitrate = A.uint32();
                          break;
                        case 5:
                          i.fps = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    if ("object" != typeof A || null === A) return "object expected";
                    if (null != A.id && A.hasOwnProperty("id") && !Td.isInteger(A.id))
                      return "id: integer expected";
                    if (null != A.resolution && A.hasOwnProperty("resolution")) {
                      let e = Pd.dcv.audio.webcam.Resolution.verify(A.resolution);
                      if (e) return "resolution." + e;
                    }
                    if (null != A.codec && A.hasOwnProperty("codec")) {
                      let e = Pd.dcv.audio.webcam.Codec.verify(A.codec);
                      if (e) return "codec." + e;
                    }
                    return null != A.bitrate &&
                      A.hasOwnProperty("bitrate") &&
                      !Td.isInteger(A.bitrate)
                      ? "bitrate: integer expected"
                      : null != A.fps && A.hasOwnProperty("fps") && !Td.isInteger(A.fps)
                        ? "fps: integer expected"
                        : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.StreamConfiguration) return A;
                    let e = new Pd.dcv.audio.webcam.StreamConfiguration();
                    if ((null != A.id && (e.id = A.id >>> 0), null != A.resolution)) {
                      if ("object" != typeof A.resolution)
                        throw TypeError(
                          ".dcv.audio.webcam.StreamConfiguration.resolution: object expected"
                        );
                      e.resolution = Pd.dcv.audio.webcam.Resolution.fromObject(A.resolution);
                    }
                    if (null != A.codec) {
                      if ("object" != typeof A.codec)
                        throw TypeError(
                          ".dcv.audio.webcam.StreamConfiguration.codec: object expected"
                        );
                      e.codec = Pd.dcv.audio.webcam.Codec.fromObject(A.codec);
                    }
                    return (
                      null != A.bitrate && (e.bitrate = A.bitrate >>> 0),
                      null != A.fps && (e.fps = A.fps >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults &&
                        ((t.id = 0),
                        (t.resolution = null),
                        (t.codec = null),
                        (t.bitrate = 0),
                        (t.fps = 0)),
                      null != A.id && A.hasOwnProperty("id") && (t.id = A.id),
                      null != A.resolution &&
                        A.hasOwnProperty("resolution") &&
                        (t.resolution = Pd.dcv.audio.webcam.Resolution.toObject(A.resolution, e)),
                      null != A.codec &&
                        A.hasOwnProperty("codec") &&
                        (t.codec = Pd.dcv.audio.webcam.Codec.toObject(A.codec, e)),
                      null != A.bitrate && A.hasOwnProperty("bitrate") && (t.bitrate = A.bitrate),
                      null != A.fps && A.hasOwnProperty("fps") && (t.fps = A.fps),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.audio.webcam.StreamConfiguration"
                    );
                  }),
                  A
                );
              })()),
              (A.Frame = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.frameIndex = Td.Long ? Td.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.streamId = 0),
                  (A.prototype.timestamp = Td.Long ? Td.Long.fromBits(0, 0, !1) : 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.frameIndex &&
                        Object.hasOwnProperty.call(A, "frameIndex") &&
                        e.uint32(8).uint64(A.frameIndex),
                      null != A.streamId &&
                        Object.hasOwnProperty.call(A, "streamId") &&
                        e.uint32(16).uint32(A.streamId),
                      null != A.timestamp &&
                        Object.hasOwnProperty.call(A, "timestamp") &&
                        e.uint32(24).int64(A.timestamp),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.Frame();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.frameIndex = A.uint64();
                          break;
                        case 2:
                          i.streamId = A.uint32();
                          break;
                        case 3:
                          i.timestamp = A.int64();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.frameIndex &&
                          A.hasOwnProperty("frameIndex") &&
                          !(
                            Td.isInteger(A.frameIndex) ||
                            (A.frameIndex &&
                              Td.isInteger(A.frameIndex.low) &&
                              Td.isInteger(A.frameIndex.high))
                          )
                        ? "frameIndex: integer|Long expected"
                        : null != A.streamId &&
                            A.hasOwnProperty("streamId") &&
                            !Td.isInteger(A.streamId)
                          ? "streamId: integer expected"
                          : null != A.timestamp &&
                              A.hasOwnProperty("timestamp") &&
                              !(
                                Td.isInteger(A.timestamp) ||
                                (A.timestamp &&
                                  Td.isInteger(A.timestamp.low) &&
                                  Td.isInteger(A.timestamp.high))
                              )
                            ? "timestamp: integer|Long expected"
                            : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.Frame) return A;
                    let e = new Pd.dcv.audio.webcam.Frame();
                    return (
                      null != A.frameIndex &&
                        (Td.Long
                          ? ((e.frameIndex = Td.Long.fromValue(A.frameIndex)).unsigned = !0)
                          : "string" == typeof A.frameIndex
                            ? (e.frameIndex = parseInt(A.frameIndex, 10))
                            : "number" == typeof A.frameIndex
                              ? (e.frameIndex = A.frameIndex)
                              : "object" == typeof A.frameIndex &&
                                (e.frameIndex = new Td.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0))),
                      null != A.streamId && (e.streamId = A.streamId >>> 0),
                      null != A.timestamp &&
                        (Td.Long
                          ? ((e.timestamp = Td.Long.fromValue(A.timestamp)).unsigned = !1)
                          : "string" == typeof A.timestamp
                            ? (e.timestamp = parseInt(A.timestamp, 10))
                            : "number" == typeof A.timestamp
                              ? (e.timestamp = A.timestamp)
                              : "object" == typeof A.timestamp &&
                                (e.timestamp = new Td.LongBits(
                                  A.timestamp.low >>> 0,
                                  A.timestamp.high >>> 0
                                ).toNumber())),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults) {
                      if (Td.Long) {
                        let A = new Td.Long(0, 0, !0);
                        t.frameIndex =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.frameIndex = e.longs === String ? "0" : 0;
                      if (((t.streamId = 0), Td.Long)) {
                        let A = new Td.Long(0, 0, !1);
                        t.timestamp =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.timestamp = e.longs === String ? "0" : 0;
                    }
                    return (
                      null != A.frameIndex &&
                        A.hasOwnProperty("frameIndex") &&
                        ("number" == typeof A.frameIndex
                          ? (t.frameIndex =
                              e.longs === String ? String(A.frameIndex) : A.frameIndex)
                          : (t.frameIndex =
                              e.longs === String
                                ? Td.Long.prototype.toString.call(A.frameIndex)
                                : e.longs === Number
                                  ? new Td.LongBits(
                                      A.frameIndex.low >>> 0,
                                      A.frameIndex.high >>> 0
                                    ).toNumber(!0)
                                  : A.frameIndex)),
                      null != A.streamId &&
                        A.hasOwnProperty("streamId") &&
                        (t.streamId = A.streamId),
                      null != A.timestamp &&
                        A.hasOwnProperty("timestamp") &&
                        ("number" == typeof A.timestamp
                          ? (t.timestamp = e.longs === String ? String(A.timestamp) : A.timestamp)
                          : (t.timestamp =
                              e.longs === String
                                ? Td.Long.prototype.toString.call(A.timestamp)
                                : e.longs === Number
                                  ? new Td.LongBits(
                                      A.timestamp.low >>> 0,
                                      A.timestamp.high >>> 0
                                    ).toNumber()
                                  : A.timestamp)),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Frame"
                    );
                  }),
                  A
                );
              })()),
              (A.Ack = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.frameIndex = Td.Long ? Td.Long.fromBits(0, 0, !0) : 0),
                  (A.prototype.streamId = 0),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = Ld.create()),
                      null != A.frameIndex &&
                        Object.hasOwnProperty.call(A, "frameIndex") &&
                        e.uint32(8).uint64(A.frameIndex),
                      null != A.streamId &&
                        Object.hasOwnProperty.call(A, "streamId") &&
                        e.uint32(16).uint32(A.streamId),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof Kd || (A = Kd.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new Pd.dcv.audio.webcam.Ack();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.frameIndex = A.uint64();
                          break;
                        case 2:
                          i.streamId = A.uint32();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof Kd || (A = new Kd(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.frameIndex &&
                          A.hasOwnProperty("frameIndex") &&
                          !(
                            Td.isInteger(A.frameIndex) ||
                            (A.frameIndex &&
                              Td.isInteger(A.frameIndex.low) &&
                              Td.isInteger(A.frameIndex.high))
                          )
                        ? "frameIndex: integer|Long expected"
                        : null != A.streamId &&
                            A.hasOwnProperty("streamId") &&
                            !Td.isInteger(A.streamId)
                          ? "streamId: integer expected"
                          : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof Pd.dcv.audio.webcam.Ack) return A;
                    let e = new Pd.dcv.audio.webcam.Ack();
                    return (
                      null != A.frameIndex &&
                        (Td.Long
                          ? ((e.frameIndex = Td.Long.fromValue(A.frameIndex)).unsigned = !0)
                          : "string" == typeof A.frameIndex
                            ? (e.frameIndex = parseInt(A.frameIndex, 10))
                            : "number" == typeof A.frameIndex
                              ? (e.frameIndex = A.frameIndex)
                              : "object" == typeof A.frameIndex &&
                                (e.frameIndex = new Td.LongBits(
                                  A.frameIndex.low >>> 0,
                                  A.frameIndex.high >>> 0
                                ).toNumber(!0))),
                      null != A.streamId && (e.streamId = A.streamId >>> 0),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    if (e.defaults) {
                      if (Td.Long) {
                        let A = new Td.Long(0, 0, !0);
                        t.frameIndex =
                          e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                      } else t.frameIndex = e.longs === String ? "0" : 0;
                      t.streamId = 0;
                    }
                    return (
                      null != A.frameIndex &&
                        A.hasOwnProperty("frameIndex") &&
                        ("number" == typeof A.frameIndex
                          ? (t.frameIndex =
                              e.longs === String ? String(A.frameIndex) : A.frameIndex)
                          : (t.frameIndex =
                              e.longs === String
                                ? Td.Long.prototype.toString.call(A.frameIndex)
                                : e.longs === Number
                                  ? new Td.LongBits(
                                      A.frameIndex.low >>> 0,
                                      A.frameIndex.high >>> 0
                                    ).toNumber(!0)
                                  : A.frameIndex)),
                      null != A.streamId &&
                        A.hasOwnProperty("streamId") &&
                        (t.streamId = A.streamId),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.audio.webcam.Ack";
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  Hd = Q("settings");
let Yd = null;
try {
  Yd = window.localStorage;
} catch (A) {
  Hd.warn(`Settings persistence disabled. Error accessing local storage: ${A.message}`);
}
const qd = { webcamResolutionsDetected: {} };
const Jd = Gd.audio.webcam,
  jd = [
    { width: 424, height: 240 },
    { width: 640, height: 360 },
    { width: 960, height: 540 },
    { width: 1280, height: 720 },
    { width: 1600, height: 900 },
    { width: 1920, height: 1080 },
    { width: 320, height: 240 },
    { width: 640, height: 480 },
    { width: 800, height: 600 },
    { width: 1024, height: 768 },
    { width: 1440, height: 1080 },
    { width: 1920, height: 1440 }
  ];
class Wd {
  constructor(A) {
    (this.log = Q("webcam", A)),
      (this.clientConnectionId = A),
      (this.attached = !1),
      (this.streaming = !1),
      (this.setEnabledInProgressForDeviceId = null);
  }
  applyTrackResolutionConstraints() {
    return this.webcamStream
      .getVideoTracks()[0]
      .applyConstraints({
        width: this.streamingConfiguration.resolution.width,
        height: this.streamingConfiguration.resolution.height,
        frameRate: this.streamingConfiguration.fps
      });
  }
  registerManager(A) {
    this.webcamManager = A;
  }
  reset() {
    this.log.info("Resetting webcam..."), Vd.call(this);
  }
  setEnabled(A, e) {
    if (this.setEnabledInProgressForDeviceId)
      return this.setEnabledInProgressForDeviceId === e
        ? (this.log.debug(
            `Ignoring request to ${A ? "enable" : "disable"} webcam as there is still another one in progress`
          ),
          Promise.resolve(e))
        : (this.log.debug(
            `Ignoring request to ${A ? "enable" : "disable"} webcam with deviceId ${e} as an attach is still in progress for deviceId ${this.setEnabledInProgressForDeviceId}`
          ),
          Promise.reject(
            `Unable to ${A ? "enable" : "disable"} webcam as an attach is still in progress for another device`
          ));
    if (((this.setEnabledInProgressForDeviceId = e), this.attached === A))
      return (this.setEnabledInProgressForDeviceId = null), Promise.resolve(e);
    if (!this.attached && A) {
      const A = fr() ? 500 : 0,
        t = fr() ? 3 : 1;
      return co(() => navigator.mediaDevices.getUserMedia({ video: { deviceId: e } }), A, t)
        .then((A) => ((this.webcamStream = A), zd.call(this)))
        .then(
          (A) => (
            (this.attached = !0),
            (this.attachedDeviceId = A),
            _d.call(this),
            (this.setEnabledInProgressForDeviceId = null),
            Promise.resolve(A)
          )
        )
        .catch((A) => (Vd.call(this), Promise.reject(`${A.name}: ${A.message}`)));
    }
    return this.attached && !A
      ? (Vd.call(this),
        this.webcamManager.sendDetachWebcam(Jd.Detach.DetachReason.NO_ERROR),
        Promise.resolve(e))
      : ((this.setEnabledInProgressForDeviceId = null),
        Promise.reject(`Unable to ${A ? "enable" : "disable"} webcam`));
  }
  setMaxResolution(A) {
    this.log.debug(`Setting maximum resolution to ${C(A)}`), (this.maxResolution = A);
  }
  setStreamingConfiguration(A) {
    this.log.info(`Setting streaming configuration ${JSON.stringify(A)}`),
      (this.streamingConfiguration = A),
      0 === this.streamingConfiguration.fps && (this.streamingConfiguration.fps = 15),
      (this.streamingConfiguration.fps = Math.min(120, this.streamingConfiguration.fps));
  }
  async startStream() {
    return (
      (this.streaming = !0),
      (this.framesCounter = 0),
      navigator.mediaDevices.getUserMedia({ video: { deviceId: this.attachedDeviceId } })
    );
  }
  stopStream() {
    (this.streaming = !1), (this.setEnabledInProgressForDeviceId = null), _d.call(this);
  }
}
function Vd() {
  (this.attached = !1), (this.attachedDeviceId = null), this.stopStream();
}
function _d() {
  this.webcamStream &&
    (this.webcamStream.getVideoTracks().forEach((A) => {
      A.stop();
    }),
    (this.webcamStream = null));
}
async function Xd(A, e) {
  const t = A.getCapabilities(),
    i = [];
  async function n(e) {
    try {
      (function (A, e) {
        return (
          A.width > 1 &&
          A.height > 1 &&
          !e.some((e) => e.width === A.width && e.height === A.height)
        );
      })(e, i) &&
        (await A.applyConstraints({ width: { exact: e.width }, height: { exact: e.height } }),
        i.push(e));
    } catch (A) {
      this.log.debug(`Resolution ${C(e)} not supported. ${A}`);
    }
  }
  async function o(A, e) {
    await Promise.allSettled(
      ["min", "max"].map(async (t) => n.call(this, { width: A[t], height: e[t] }))
    );
  }
  return (
    await o(t.width, t.height),
    await o(e.imageWidth, e.imageHeight),
    await Promise.allSettled(jd.map(n.bind(this))),
    i
  );
}
function zd() {
  let A,
    e,
    t,
    i = this.webcamStream.getVideoTracks(),
    n = this.getClientSupportedCodecs();
  return new Promise((o, r) => {
    if (i && 0 !== i.length)
      if (ws && Ds) {
        (A = i[0]), (e = A.getCapabilities());
        const s = () => {
          (t = qd.webcamResolutionsDetected[e.deviceId].filter((A) =>
            (function (A, e) {
              return (
                !e || ((!e.width || e.width >= A.width) && (!e.height || e.height >= A.height))
              );
            })(A, this.maxResolution)
          )),
            this.webcamManager.sendAttachWebcam(e.deviceId, t, n),
            o(e.deviceId);
        };
        e.deviceId in qd.webcamResolutionsDetected
          ? s()
          : new ImageCapture(A).getPhotoCapabilities().then(async (i) => {
              (t = await Xd.call(this, A, i)),
                this.log.debug(`Supported resolutions: ${C(t)}`),
                0 === t.length
                  ? r(new Error("There are no viable supported resolutions on the client."))
                  : ((qd.webcamResolutionsDetected[e.deviceId] = t),
                    Yd?.setItem("dcv-settings", JSON.stringify(qd)),
                    s());
            });
      } else r(new Error("Cannot get the camera supported resolutions."));
    else r(new Error("There are no mediaStreamTracks of kind 'video' available."));
  });
}
const Zd = 20;
class $d extends Wd {
  constructor(A, e) {
    super(A), (this.log = Q("webcamJpeg", A)), (this.elapsedTime = 0), (this.divId = e);
    let t,
      i = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
    i &&
      ((t = i.getDisplayManager().getActiveWindow().document),
      (this.webcamVideoElement = (function (A, e) {
        let t = A.getElementById("dcv-webcam-video");
        null === t &&
          ((t = A.createElement("video")),
          (t.id = "dcv-webcam-video"),
          t.setAttribute("autoplay", ""),
          t.setAttribute("plays-inline", ""),
          t.setAttribute("muted", ""),
          Object.assign(t.style, {
            display: "block",
            width: "1px",
            height: "1px",
            "z-index": "-1",
            position: "absolute"
          }),
          A.getElementById(e).appendChild(t));
        return t;
      })(t, this.divId)),
      (this.webcamCanvasElement = (function (A, e) {
        let t = A.getElementById("dcv-webcam-canvas");
        null === t &&
          ((t = A.createElement("canvas")),
          (t.id = "dcv-webcam-canvas"),
          (t.style.display = "none"),
          A.getElementById(e).appendChild(t));
        return t;
      })(t, this.divId)),
      (this.webcamCanvasCtx = this.webcamCanvasElement.getContext("2d")));
  }
  getClientSupportedCodecs() {
    return [{ name: "jpeg" }];
  }
  startStream() {
    super
      .startStream()
      .then((A) => {
        (this.webcamStream = A),
          (this.webcamCanvasElement.width = this.streamingConfiguration.resolution.width),
          (this.webcamCanvasElement.height = this.streamingConfiguration.resolution.height),
          eu.call(this);
      })
      .catch((A) => {
        this.log.error(`Could not start streaming webcam. Error: ${A}`);
      });
  }
  stopStream() {
    super.stopStream(),
      window.cancelAnimationFrame(this.requestAnimationRef),
      this.webcamCanvasCtx.clearRect(
        0,
        0,
        this.webcamCanvasElement.width,
        this.webcamCanvasElement.height
      ),
      this.webcamVideoElement.pause(),
      (this.webcamVideoElement.srcObject = null),
      this.webcamVideoElement.load(),
      (this.elapsedTime = 0);
  }
}
function Au(A) {
  (this.elapsedTime + A - this.lastTimestamp) / 1e3 >=
    this.framesCounter / Math.min(this.streamingConfiguration.fps, Zd) &&
    (this.webcamCanvasCtx.drawImage(this.webcamVideoElement, 0, 0),
    this.webcamCanvasElement.toBlob(
      (A) =>
        A.arrayBuffer().then((A) =>
          this.webcamManager.sendWebcamFrame(new Uint8Array(A), this.streamingConfiguration.id)
        ),
      "image/jpeg"
    ),
    (this.elapsedTime += A - this.lastTimestamp),
    (this.lastTimestamp = A),
    ++this.framesCounter),
    this.streaming && (this.requestAnimationRef = window.requestAnimationFrame(Au.bind(this)));
}
function eu() {
  (this.webcamVideoElement.srcObject = this.webcamStream),
    this.webcamVideoElement.load(),
    (this.lastTimestamp = performance.now()),
    (this.requestAnimationRef = window.requestAnimationFrame(Au.bind(this)));
}
class tu extends Wd {
  constructor(A) {
    super(A), (this.log = Q("webcamVp8", A));
  }
  getClientSupportedCodecs() {
    return [{ name: "vp8" }];
  }
  startStream() {
    super
      .startStream()
      .then((A) => {
        (this.webcamStream = A),
          super.applyTrackResolutionConstraints
            .call(this)
            .then(nu.bind(this))
            .catch((A) => {
              this.log.error(A);
            });
      })
      .catch((A) => Promise.reject(`Could not start streaming webcam. Error: ${A}`));
  }
  stopStream() {
    super.stopStream(), this.encoder && "closed" !== this.encoder.state && this.encoder.close();
  }
}
async function iu() {
  let A,
    e = this.streamingConfiguration.resolution.width,
    t = this.streamingConfiguration.resolution.height;
  this.streamingConfiguration.bitrate > 0
    ? (A = this.streamingConfiguration.bitrate)
    : ((A = 60 * Math.floor(Math.sqrt(e * t * this.streamingConfiguration.fps) / 200)),
      (A = Math.min(Math.max(A, 10), 1e4)));
  const i = {
      codec: "vp8",
      width: e,
      height: t,
      framerate: this.streamingConfiguration.fps,
      bitrate: 1e3 * A,
      latencyMode: "realtime"
    },
    { supported: n } =
      "VideoEncoder" in window ? await window.VideoEncoder.isConfigSupported(i) : { supported: !1 };
  n &&
    (this.encoder.configure(i),
    this.log.info(
      `Webcam Vp8 encoder configured with resolution ${e}x${t}, framerate ${this.streamingConfiguration.fps} and bitrate: ${A} Kbps`
    ));
}
async function nu() {
  (this.encoder = new window.VideoEncoder({
    output: (A) => {
      const e = new Uint8Array(A.byteLength);
      A.copyTo(e), this.webcamManager.sendWebcamFrame(e, this.streamingConfiguration.id);
    },
    error: (A) => this.log.error(A)
  })),
    iu.call(this);
  const A = new window.MediaStreamTrackProcessor(
    this.webcamStream.getVideoTracks()[0]
  ).readable.getReader();
  let e = await A.read();
  for (; !e.done; ) {
    const t = e.value;
    if (this.encoder.encodeQueueSize > 2) t.close();
    else {
      const A = 0 === this.framesCounter;
      "unconfigured" === this.encoder.state
        ? iu.call(this)
        : "configured" === this.encoder.state
          ? (this.encoder.encode(t, { keyFrame: A }), this.framesCounter++, t.close())
          : t.close();
    }
    e = await A.read();
  }
}
class ou extends Wd {
  constructor(A) {
    super(A), (this.log = Q("webcamWebm", A));
  }
  getClientSupportedCodecs() {
    return [{ name: "webm" }];
  }
  startStream() {
    super
      .startStream()
      .then((A) => {
        (this.webcamStream = A),
          super.applyTrackResolutionConstraints
            .call(this)
            .then(au.bind(this))
            .catch((A) => {
              this.log.error(A);
            });
      })
      .catch((A) => Promise.reject(`Could not start streaming webcam. Error: ${A}`));
  }
  stopStream() {
    super.stopStream(),
      window.cancelAnimationFrame(this.requestAnimationRef),
      this.mediaRecorder && "inactive" !== this.mediaRecorder.state && this.mediaRecorder.stop();
  }
}
function ru(A) {
  A.arrayBuffer().then((A) =>
    this.webcamManager.sendWebcamFrame(new Uint8Array(A), this.streamingConfiguration.id)
  );
}
function su() {
  "recording" === this.mediaRecorder.state && this.mediaRecorder.requestData(),
    this.streaming && (this.requestAnimationRef = window.requestAnimationFrame(su.bind(this)));
}
function au() {
  (this.mediaRecorder = new MediaRecorder(this.webcamStream, {
    mimeType: "video/webm;codecs=vp8"
  })),
    (this.mediaRecorder.ondataavailable = (A) => {
      A.data.size > 0 && ru.call(this, A.data);
    }),
    this.mediaRecorder.start(),
    (this.requestAnimationRef = window.requestAnimationFrame(su.bind(this)));
}
async function gu(A, e, t, i) {
  const n = Q("webcamfactory"),
    o = A.map((A) => A.name),
    { supported: r } =
      "VideoEncoder" in window
        ? await window.VideoEncoder.isConfigSupported({
            codec: "vp8",
            width: 640,
            height: 480,
            bitrate: 92e4,
            latencyMode: "realtime"
          })
        : { supported: !1 };
  return e && -1 !== o.indexOf("vp8") && "MediaStreamTrackProcessor" in window && r
    ? (n.info("Created webcam Vp8 encoder."), new tu(t))
    : -1 !== o.indexOf("webm") &&
        ms &&
        MediaRecorder.isTypeSupported &&
        Xn(MediaRecorder.isTypeSupported) &&
        MediaRecorder.isTypeSupported("video/webm;codecs=vp8")
      ? (n.info("Created webcam Webm encoder."), new ou(t))
      : (n.info("Created webcam Jpeg encoder."), new $d(t, i));
}
const cu = Gd.audio.webcam,
  Iu = pr();
function lu(A, e, t) {
  if (
    ((this.log = Q("webcammanager", A)),
    (this.counter = 0),
    (this.clientConnectionId = A),
    (this.webCodecsEnabled = e),
    (this.divId = t),
    !Iu)
  )
    return null;
  Qu.call(this);
}
function du(A) {
  const e = Ws(this.clientConnectionId);
  switch (A.webcamStatusUpdate.status) {
    case cu.StatusUpdate.ServiceStatus.NOT_AVAILABLE:
      this.log.info("Webcam service not available."),
        this.webcam && this.webcam.reset(),
        e.update("webcam", { enabled: !1, serviceStatus: "not-available" });
      break;
    case cu.StatusUpdate.ServiceStatus.BUSY:
      this.log.info("Webcam service busy on another client."),
        e.update("webcam", { enabled: !0, serviceStatus: "busy" });
      break;
    case cu.StatusUpdate.ServiceStatus.AVAILABLE:
      e.update("webcam", { enabled: !0, serviceStatus: "available" });
      break;
    case cu.StatusUpdate.ServiceStatus.ATTACHED:
      this.webcam.stopStream(), e.update("webcam", { enabled: !0, serviceStatus: "attached" });
      break;
    case cu.StatusUpdate.ServiceStatus.STREAMING:
      this.webcam.startStream(), e.update("webcam", { enabled: !0, serviceStatus: "streaming" });
  }
}
function uu(A) {
  this.webcam.setStreamingConfiguration(A.webcamStreamingConfiguration);
}
function Cu({ code: A, details: e }) {
  this.log.warn(`Webcam error response received with code ${A}: ${e}`);
  const t = Ws(this.clientConnectionId);
  switch (A) {
    case cu.ErrorResponse.Code.NONE:
      t.update("webcam-error", { error: "none", message: e, code: A });
      break;
    case cu.ErrorResponse.Code.ATTACH_FAILED:
      t.update("webcam-error", { error: "attach-failed", message: e, code: A });
      break;
    case cu.ErrorResponse.Code.ATTACH_FAILED_NOT_ALLOWED:
      t.update("webcam-error", { error: "attach-failed-not-allowed", message: e, code: A });
      break;
    case cu.ErrorResponse.Code.ATTACH_FAILED_NO_CODECS_SUPPORTED:
      t.update("webcam-error", { error: "attach-failed-no-codecs-supported", message: e, code: A });
      break;
    case cu.ErrorResponse.Code.ATTACH_FAILED_NO_RESOLUTIONS_SUPPORTED:
      t.update("webcam-error", {
        error: "attach-failed-no-resolutions-supported",
        message: e,
        code: A
      });
      break;
    case cu.ErrorResponse.Code.ATTACH_FAILED_ALREADY_ATTACHED:
      t.update("webcam-error", { error: "attach-failed-already-attached", message: e, code: A });
      break;
    case cu.ErrorResponse.Code.ATTACH_FAILED_DEVICE_IN_USE:
      t.update("webcam-error", { error: "attach-failed-device-in-use", message: e, code: A });
  }
  this.webcam && ((this.webcam.setEnabledInProgressForDeviceId = null), this.webcam.setEnabled(!1));
}
function Bu(A) {
  gu(
    A.webcamServerCapabilities.codecs,
    this.webCodecsEnabled,
    this.clientConnectionId,
    this.divId
  ).then((e) => {
    (this.webcam = e),
      this.webcam.registerManager(this),
      this.webcam.setMaxResolution(A.webcamServerCapabilities.maxResolution);
  });
}
function Qu() {
  Os() &&
    navigator.permissions
      .query({ name: "camera" })
      .then((A) => {
        A.onchange = () => {
          this.log.info(`Camera permission state has changed to ${A.state}`),
            this.attachedWebcam &&
              "granted" !== A.state &&
              this.webcam.setEnabled(!1, this.attachedWebcam);
        };
      })
      .catch((A) => {
        A instanceof TypeError ? this.log.info(A.message) : this.log.warn(A.message);
      });
}
(lu.prototype.registerChannel = function (A) {
  this.audioChannel = Iu ? A : null;
}),
  (lu.prototype.unregisterChannel = function (A) {
    Iu &&
      (this.audioChannel === A
        ? ((this.audioChannel = null), this.webcam && this.webcam.reset())
        : this.log.warn("Skip unregister of wrong channel"));
  }),
  (lu.prototype.handleWebcamMessage = function (A) {
    if (Iu)
      switch (A.msg) {
        case "webcamServerCapabilities":
          Bu.call(this, A);
          break;
        case "webcamStatusUpdate":
          this.webcam && (this.webcam.setEnabledInProgressForDeviceId = null), du.call(this, A);
          break;
        case "webcamStreamingConfiguration":
          uu.call(this, A);
          break;
        case "webcamErrorResponse":
          Cu.call(this, A.webcamErrorResponse);
          break;
        case "webcamAck":
          break;
        default:
          this.log.warn(`Unknown audio message: ${A.msg}`);
      }
  }),
  (lu.prototype.setWebcam = function (A, e) {
    return Ao(this.webcam) && !A
      ? (this.log.info("Requested to disable webcam but webcam is not defined"), Promise.resolve())
      : !Ao(this.webcam) && (!A || (vs() && Iu))
        ? this.webcam.setEnabled(A, e)
        : Promise.reject("Webcam not supported from the browser");
  }),
  (lu.prototype.updateAttachedWebcam = function () {
    this.attachedWebcam &&
      Ks().then((A) => {
        0 ===
          A.filter((A) => A.deviceId === this.attachedWebcam && "videoinput" === A.kind).length &&
          this.webcam.setEnabled(!1, this.attachedWebcam);
      });
  }),
  (lu.prototype.sendAttachWebcam = function (A, e, t) {
    this.log.info("Sending Attach message"),
      this.audioChannel
        ? ((this.attachedWebcam = A),
          this.audioChannel.sendMessage({ webcamAttach: { name: A, resolutions: e, codecs: t } }))
        : this.log.info("Audio channel is not available");
  }),
  (lu.prototype.sendDetachWebcam = function (A) {
    this.log.info("Sending Detach message"),
      this.audioChannel
        ? ((this.attachedWebcam = null),
          this.audioChannel.sendMessage({ webcamDetach: { reason: A } }))
        : this.log.info("Audio channel is not available");
  }),
  (lu.prototype.sendWebcamFrame = function (A, e) {
    this.audioChannel.sendMessage(
      {
        webcamFrame: { frameIndex: this.counter++, streamId: e, timestamp: 1e3 * performance.now() }
      },
      A
    );
  });
const Eu = { major: 1, minor: 3 },
  hu = id.audio,
  pu = 3e3;
function fu(A, e) {
  e && "AudioEncoder" in window && "MediaStreamTrackProcessor" in window
    ? Promise.resolve()
        .then(function () {
          return IQ;
        })
        .then((A) => {
          this.microphone = new A.Microphone(this.clientConnectionId);
        })
    : "AudioWorklet" in window &&
        "function" == typeof AudioWorklet &&
        "audioWorklet" in AudioContext.prototype &&
        "function" == typeof Ts().audioWorklet.addModule &&
        "AudioWorkletNode" in window &&
        "function" == typeof AudioWorkletNode
      ? Promise.resolve()
          .then(function () {
            return CQ;
          })
          .then((e) => {
            this.microphone = new e.Microphone(this.clientConnectionId, A);
          })
      : Promise.resolve()
          .then(function () {
            return wQ;
          })
          .then((A) => {
            this.microphone = new A.Microphone(this.clientConnectionId);
          });
}
function mu() {
  let A = js(this.clientConnectionId).getDataChannel(Ia.DISPLAY);
  return A && A.getDisplayManager().isDisplayReady();
}
function yu() {
  (this.state = {
    audioOn: !1,
    encodingLevel: null,
    audioPacketStrength: null,
    audioSpectrum: null,
    audioBitrates: [],
    selectedCodec: null,
    selectedProfile: null
  }),
    this.player && this.player.remove(),
    this.encoder && this.encoder.remove(),
    (this.player = null),
    (this.encoder = null);
}
function Du() {
  this.audioOutput.registerChannel(this),
    Ku() && this.microphone.registerChannel(this),
    vs() && this.webcamManager && this.webcamManager.registerChannel(this),
    Ms()
      ? ((this.boundOnDeviceChange = wu.bind(this)),
        navigator.mediaDevices.addEventListener("devicechange", this.boundOnDeviceChange))
      : (this.deviceChangePollingIntervalId = setInterval(wu.bind(this), pu)),
    this.log.info("Starting handshake"),
    Nu.call(this);
}
function wu() {
  var A;
  fr() ? this.log.info("Checking for device change") : this.log.info("Device change detected"),
    this.webcamManager && this.webcamManager.updateAttachedWebcam(),
    this.microphone.microphoneMediaDeviceInfo
      ? ((A = this.microphone.microphoneMediaDeviceInfo.deviceId),
        Ks()
          .then((e) => {
            const t = e.filter((A) => "audioinput" === A.kind);
            return 0 !== t.length && t.map((A) => A.deviceId).includes(A);
          })
          .catch(() => !1)).then((A) => {
          !this.microphone.microphoneEnabled ||
            !this.encoder ||
            (A && "default" !== this.microphone.microphoneMediaDeviceInfo.deviceId) ||
            Fu.call(this).catch((A) => {
              const e = `${A.name}: ${A.message}`;
              this.log.error(`Failed to re-enable microphone after device change: ${e}`);
            });
        })
      : this.log.debug("Device change detected but microphone is not enabled."),
    Xn(this.deviceChangeEvent) && this.deviceChangeEvent();
}
function Fu() {
  return fr()
    ? Ks().then((A) => {
        const e = A.filter((A) => "audioinput" === A.kind && A.label === us).length > 0;
        return this.microphone.headsetAttachedOnNiva !== e
          ? this.microphone
              .setEnabled(this.encoder, !1)
              .then(() => this.microphone.setEnabled(this.encoder, !0))
          : Promise.resolve();
      })
    : Ls().then((A) => {
        return (
          (e = this.microphone.microphoneMediaDeviceInfo),
          (t = A),
          zn(e) &&
          zn(t) &&
          e.kind === t.kind &&
          e.deviceId === t.deviceId &&
          e.groupId === t.groupId &&
          e.label === t.label
            ? Promise.resolve()
            : this.microphone
                .setEnabled(this.encoder, !1)
                .then(() => this.microphone.setEnabled(this.encoder, !0))
        );
        var e, t;
      });
}
function bu() {
  let A;
  return null === this.player || (null === this.encoder && this.state.dynamicTuning)
    ? Promise.reject("Audio not configured. Unable to tune audio system.")
    : ((A =
        this.encoder && this.state.dynamicTuning
          ? this.player.tune(this.encoder.encodeSingleBuffer, Uu.bind(this))
          : this.player.tune()),
      A);
}
function Uu() {
  return new Float32Array(this.state.audioStreamFrameSamples * this.state.audioChannels).map(
    () => 2 * Math.random() - 1
  );
}
function Su() {
  if (this.player && this.state.audioOn) {
    const A = this.player.getStats();
    if (A.packets > 0 || this.channelStats.receivedPackets > 0) {
      const e = this.audioPacketsReceivedSinceSilence > 0 ? "active" : "silence",
        t =
          this.channelStats.receivedPackets > 0
            ? Math.round(this.channelStats.receiveIntervalSum / this.channelStats.receivedPackets)
            : 0,
        i = this.channelStats.receivedPackets > 0 ? this.channelStats.receiveIntervalMin : 0,
        n = this.channelStats.receiveIntervalMax;
      this.log.info(
        `Audio playback stats: current-state=${e}, received-packets=${this.channelStats.receivedPackets}, receive-interval={min=${i} msec, avg=${t} msec, max=${n} msec} dropped=${A.dropped}, skipped=${this.channelStats.receivedPacketsSkipped}, buffer-time={min=${A.bufferTimeMin} msec, avg=${A.bufferTimeAvg} msec, max=${A.bufferTimeMax} msec, last=${A.bufferTimeLast} msec}, queue-time={min=${A.queuedTimeMin} msec, avg=${A.queuedTimeAvg} msec, max=${A.queuedTimeMax} msec, last=${A.queuedTimeLast} msec}`
      );
    }
    this.channelStats = {
      receiveIntervalMin: Number.MAX_SAFE_INTEGER,
      receiveIntervalSum: 0,
      receiveIntervalMax: 0,
      receivedPacketsSkipped: 0,
      receivedPackets: 0
    };
  }
}
function Ru(A, e) {
  const t = performance.now();
  switch (A.msg) {
    case "handshakeStart":
      Du.call(this);
      break;
    case "configuration":
      xu.call(this, A);
      break;
    case "statusUpdate":
      ku.call(this, A);
      break;
    case "streamConfiguration":
      A.streamConfiguration.frameLength > 0 &&
        A.streamConfiguration.frameLength !== this.state.streamFrameLength &&
        ((this.state.streamFrameLength = A.streamConfiguration.frameLength),
        (this.state.audioStreamFrameSamples = Math.round(
          (this.state.streamFrameLength / 1e3) * this.state.sampleRate
        )),
        this.audioOutput.setFrameSamples(this.state.audioStreamFrameSamples)),
        vu.call(this, A.streamConfiguration.type),
        this.log.info(
          `Stream Configuration: audio type: ${A.streamConfiguration.type}, stream frame length: ${A.streamConfiguration.frameLength} ms`
        );
      break;
    case "audioSpectrum":
      if (A.audioSpectrum.spectrum.length > 0) {
        this.state.audioSpectrum = new Int32Array(A.audioSpectrum.spectrum.length);
        for (let e = 0; e < A.audioSpectrum.spectrum.length; e++)
          this.state.audioSpectrum[e] = A.audioSpectrum.spectrum[e];
      }
      break;
    case "audioPacket":
      {
        const i = A.audioPacket.timestamp;
        if (
          ((this.state.audioPacketStrength = A.audioPacket.strength),
          -1 === this.state.audioPacketStrength)
        )
          this.log.info(`Received SILENCE from server with timestamp=${i}.`),
            (this.firstAudioPacketSinceSilenceTs = 0),
            (this.audioPacketsReceivedSinceSilence = 0),
            (this.audioPacketLastReceiveTime = 0),
            this.player.silence();
        else if (this.state.audioOn) {
          if (
            (0 === this.firstAudioPacketSinceSilenceTs &&
              (this.log.info(`Receiving audio from server with timestamp=${i}.`),
              (this.firstAudioPacketSinceSilenceTs = i),
              (this.audioPacketLastReceiveTime = 0)),
            this.audioPacketLastReceiveTime > 0)
          ) {
            const A = t - this.audioPacketLastReceiveTime;
            (this.channelStats.receiveIntervalSum += A),
              (this.channelStats.receiveIntervalMin =
                A < this.channelStats.receiveIntervalMin
                  ? A
                  : this.channelStats.receiveIntervalMin),
              (this.channelStats.receiveIntervalMax =
                A > this.channelStats.receiveIntervalMax
                  ? A
                  : this.channelStats.receiveIntervalMax),
              this.channelStats.receivedPackets++;
          }
          this.audioPacketLastReceiveTime = t;
          const A = Math.round(
            (i - this.firstAudioPacketSinceSilenceTs) / (1e6 * this.player.settings.audioFrameTime)
          );
          if (this.audioPacketsReceivedSinceSilence - A > 5) {
            this.log.debug(
              `Skipping unexpected packet with timestamp '${i}' when first timestamp since silence was '${this.firstAudioPacketSinceSilenceTs}'. Received ${this.audioPacketsReceivedSinceSilence} packets while expecting ${A}`
            ),
              this.channelStats.receivedPacketsSkipped++;
            break;
          }
          if (A - this.audioPacketsReceivedSinceSilence > 3) {
            this.log.info(
              `Imposing player silence: received audio packet with timestamp '${i}' when first timestamp since silence was '${this.firstAudioPacketSinceSilenceTs}'. Received only ${this.audioPacketsReceivedSinceSilence} packets while expecting ${A}`
            ),
              (this.firstAudioPacketSinceSilenceTs = 0),
              (this.audioPacketsReceivedSinceSilence = 0),
              this.player.silence();
            break;
          }
          this.player.queueData(e, i), this.audioPacketsReceivedSinceSilence++;
        }
      }
      break;
    default:
      this.webcamManager && this.webcamManager.handleWebcamMessage(A);
  }
}
function vu(A) {
  switch (A) {
    case hu.AudioType.MONO:
      this.state.audioChannels = 1;
      break;
    case hu.AudioType.STEREO:
      this.state.audioChannels = 2;
      break;
    case hu.AudioType.MULTI_CHANNEL_5_1:
      this.state.audioChannels = 6;
      break;
    case hu.AudioType.MULTI_CHANNEL_7_1:
      this.state.audioChannels = 8;
      break;
    default:
      this.state.audioChannels = 2;
  }
  this.audioOutput.setAudioChannels(this.state.audioChannels);
}
function xu(A) {
  switch (A.configuration.sampleRate) {
    case hu.SampleRate.SR_8KHz:
      this.state.sampleRate = 8e3;
      break;
    case hu.SampleRate.SR_22KHz:
      this.state.sampleRate = 22e3;
      break;
    case hu.SampleRate.SR_44KHz:
      this.state.sampleRate = 44e3;
      break;
    case hu.SampleRate.SR_48KHz:
      this.state.sampleRate = 48e3;
      break;
    case hu.SampleRate.SR_96KHz:
      this.state.sampleRate = 96e3;
      break;
    default:
      this.state.sampleRate = 48e3;
  }
  A.configuration.streamFrameLength > 0
    ? (this.state.streamFrameLength = A.configuration.streamFrameLength)
    : (this.state.streamFrameLength = 40),
    A.configuration.injectFrameLength > 0
      ? (this.state.injectFrameLength = A.configuration.injectFrameLength)
      : (this.state.injectFrameLength = 40),
    vu.call(this, A.configuration.type),
    this.microphone.setAudioChannels(this.state.audioChannels),
    (this.state.audioStreamFrameSamples = Math.round(
      (this.state.streamFrameLength / 1e3) * this.state.sampleRate
    )),
    (this.state.audioInjectFrameSamples = Math.round(
      (this.state.injectFrameLength / 1e3) * this.state.sampleRate
    )),
    this.audioOutput.setAudioSamplerate(this.state.sampleRate),
    this.audioOutput.setFrameSamples(this.state.audioStreamFrameSamples),
    Ku() &&
      (this.microphone.setAudioSamplerate(this.state.sampleRate),
      this.microphone.setFrameSamples(this.state.audioInjectFrameSamples)),
    this.log.info(
      `Configuration: ${this.state.audioChannels} channels, ${this.state.sampleRate}Hz, stream frame length: ${this.state.streamFrameLength} ms, inject frame length: ${this.state.injectFrameLength} ms`
    ),
    null !== A.configuration.codec &&
      ((this.state.selectedCodec = A.configuration.codec.name),
      (this.state.selectedProfile = A.configuration.codec.audioProfile),
      (this.state.audioBitrates = A.configuration.codec.bitrates),
      (this.state.encodingLevel = A.configuration.codec.level),
      this.audioOutput
        .getPlayer(this.state.selectedCodec, this.state.selectedProfile)
        .then((A) => {
          (this.player = A),
            this.player
              .init()
              .then(() => {
                (this.player.initialized = !0),
                  this.log.info(
                    `Selected codec ${this.state.selectedCodec} and profile ${this.state.selectedProfile} with bitrates: ${this.state.audioBitrates} kbps (Default: ${this.state.audioBitrates[this.state.encodingLevel]} kbps)`
                  ),
                  Ws(this.clientConnectionId)
                    .query("audio-out")
                    .then((A) => {
                      A.enabled &&
                        !this.player.tuned &&
                        bu
                          .call(this)
                          .then(() => {
                            this.player
                              .reset()
                              .then(() => {
                                this.encoder && this.encoder.reset(),
                                  this.sendStartService(hu.AudioService.STREAM),
                                  (this.player.tuned = !0);
                              })
                              .catch((A) => {
                                this.log.warn(`Unable to reset the audio system. Error: ${A}`),
                                  Ws(this.clientConnectionId).update("audio-out", { enabled: !1 });
                              });
                          })
                          .catch((A) => {
                            this.log.warn(
                              `We were unable to tune the audio system on browser. Not starting audio. Error: ${A}`
                            ),
                              Ws(this.clientConnectionId).update("audio-out", { enabled: !1 });
                          });
                    })
                    .catch(() => {
                      this.log.warn("Initialization failed");
                    });
              })
              .catch((A) =>
                Promise.reject(`Impossible to set up a valid audio player. Error: ${A}`)
              );
        })
        .catch((A) => Promise.reject(`Impossible to create a valid audio player. Error: ${A}`)),
      Ku() &&
        this.microphone
          .initOpusModule()
          .then(() => {
            if (
              (this.microphone.setAudioBitrate(
                1e3 * this.state.audioBitrates[this.state.encodingLevel]
              ),
              this.log.info(
                "Selected audio bitrate " + 1e3 * this.state.audioBitrates[this.state.encodingLevel]
              ),
              this.encoder && this.encoder.remove(),
              (this.encoder = this.microphone.initEncoder(
                this.state.selectedCodec,
                this.state.selectedProfile
              )),
              "available" === this.lastAudioInStatus)
            ) {
              Ws(this.clientConnectionId).update("audio-in", { enabled: !0, remote: "available" }),
                (this.lastAudioInStatus = null);
            }
          })
          .catch((A) => Promise.reject("Impossible to set up a valid audio-in opus encoder.")));
}
function Mu(A) {
  const e = Ws(this.clientConnectionId);
  switch (A) {
    case hu.AudioStatus.AVAILABLE:
      this.log.debug("Audio service available."),
        e.update("audio-out", { enabled: !0, remote: "available" }),
        this.player &&
          !this.player.tuned &&
          this.player.initialized &&
          bu
            .call(this)
            .then(() => {
              this.player.reset(),
                this.encoder && this.encoder.reset(),
                this.sendStartService(hu.AudioService.STREAM),
                (this.player.tuned = !0);
            })
            .catch((A) => {
              this.log.warn(
                `We were unable to tune the audio system on browser. Not starting audio. Error: ${A}`
              ),
                e.update("audio-out", { enabled: !1 });
            });
      break;
    case hu.AudioStatus.ACTIVE:
      this.log.debug("Audio service active."),
        e.update("audio-out", { enabled: !0, remote: "active" }),
        (this.state.audioOn = !0),
        (this.audioPacketLastReceiveTime = 0);
      break;
    case hu.AudioStatus.BUSY:
      this.log.debug("Audio service busy on another client."),
        e.update("audio-out", { enabled: !0, remote: "busy" });
      break;
    case hu.AudioStatus.NOT_AVAILABLE:
      this.log.debug("Audio service not available."),
        e.update("audio-out", { enabled: !1, remote: "not-available" });
  }
}
function Ou(A) {
  const e = Ws(this.clientConnectionId);
  switch (A) {
    case hu.AudioStatus.AVAILABLE:
      this.log.debug("Microphone service available."),
        this.encoder
          ? e.update("audio-in", { enabled: !0, remote: "available" })
          : this.log.debug("Encoder not present, will update once ready."),
        (this.lastAudioInStatus = "available");
      break;
    case hu.AudioStatus.ACTIVE:
      this.log.debug("Microphone service active."),
        e.update("audio-in", { enabled: !0, remote: "active" }),
        (this.lastAudioInStatus = "active");
      break;
    case hu.AudioStatus.BUSY:
      this.log.debug("Microphone service busy on another client."),
        e.update("audio-in", { enabled: !0, remote: "busy" }),
        (this.lastAudioInStatus = "busy");
      break;
    case hu.AudioStatus.NOT_AVAILABLE:
      this.log.debug("Microphone service not available."),
        e.update("audio-in", { enabled: !1, remote: "not-available" }),
        "not-available" !== this.lastAudioInStatus &&
          this.setAudioInput(!1)
            .then(() => {
              this.log.info("Stopping audio input since audio status is not available");
            })
            .catch((A) => {
              this.log.warn(`Impossible to set audio input to false. Error: ${A}`);
            }),
        (this.lastAudioInStatus = "not-available");
  }
}
function ku(A) {
  let e = A.statusUpdate.status.length;
  for (; e; )
    switch ((e--, A.statusUpdate.status[e].service)) {
      case hu.AudioService.STREAM:
        Mu.call(this, A.statusUpdate.status[e].status);
        break;
      case hu.AudioService.INJECTION:
        Ou.call(this, A.statusUpdate.status[e].status);
      case hu.AudioService.SPECTRUM:
    }
}
function Nu() {
  const A = { audioCodecs: [{ name: da, audioProfiles: this.state.supportedProfiles }] };
  "microphone" === this.microphone.getName()
    ? ((A.streamFrameLength = 40), (A.injectFrameLength = 40))
    : ((A.streamFrameLength = 20), (A.injectFrameLength = 20)),
    this.log.info(
      `Sending to server supported configuration: frame-length=${A.streamFrameLength},${A.injectFrameLength} msec; codec=opus; profiles=${this.state.supportedProfiles}`
    ),
    this.sendMessage({ capabilities: A });
}
function Ku() {
  return "AudioContext" in window && vs();
}
const Lu = Fo.exports.Reader,
  Tu = Fo.exports.Writer,
  Pu = Fo.exports.util,
  Gu = Fo.exports.roots["dcv.filestorage"] || (Fo.exports.roots["dcv.filestorage"] = {}),
  Hu = (Gu.dcv = (() => {
    const A = {};
    return (
      (A.filestorage = (function () {
        const A = {};
        return (
          (A.CommandCancel = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.requestId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(80).uint32(A.requestId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.CommandCancel();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10) i.requestId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.requestId &&
                      A.hasOwnProperty("requestId") &&
                      !Pu.isInteger(A.requestId)
                    ? "requestId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.CommandCancel) return A;
                let e = new Gu.dcv.filestorage.CommandCancel();
                return null != A.requestId && (e.requestId = A.requestId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.requestId = 0),
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.CommandCancel"
                );
              }),
              A
            );
          })()),
          (A.TransferChunk = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.requestId = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(8).uint32(A.requestId),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.TransferChunk();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.requestId = A.uint32();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.requestId &&
                      A.hasOwnProperty("requestId") &&
                      !Pu.isInteger(A.requestId)
                    ? "requestId: integer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.TransferChunk) return A;
                let e = new Gu.dcv.filestorage.TransferChunk();
                return null != A.requestId && (e.requestId = A.requestId >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.requestId = 0),
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.TransferChunk"
                );
              }),
              A
            );
          })()),
          (A.TransferChunkAck = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.requestId = 0),
              (A.prototype.bytesTransfered = Pu.Long ? Pu.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(8).uint32(A.requestId),
                  null != A.bytesTransfered &&
                    Object.hasOwnProperty.call(A, "bytesTransfered") &&
                    e.uint32(16).uint64(A.bytesTransfered),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.TransferChunkAck();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.requestId = A.uint32();
                      break;
                    case 2:
                      i.bytesTransfered = A.uint64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.requestId &&
                      A.hasOwnProperty("requestId") &&
                      !Pu.isInteger(A.requestId)
                    ? "requestId: integer expected"
                    : null != A.bytesTransfered &&
                        A.hasOwnProperty("bytesTransfered") &&
                        !(
                          Pu.isInteger(A.bytesTransfered) ||
                          (A.bytesTransfered &&
                            Pu.isInteger(A.bytesTransfered.low) &&
                            Pu.isInteger(A.bytesTransfered.high))
                        )
                      ? "bytesTransfered: integer|Long expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.TransferChunkAck) return A;
                let e = new Gu.dcv.filestorage.TransferChunkAck();
                return (
                  null != A.requestId && (e.requestId = A.requestId >>> 0),
                  null != A.bytesTransfered &&
                    (Pu.Long
                      ? ((e.bytesTransfered = Pu.Long.fromValue(A.bytesTransfered)).unsigned = !0)
                      : "string" == typeof A.bytesTransfered
                        ? (e.bytesTransfered = parseInt(A.bytesTransfered, 10))
                        : "number" == typeof A.bytesTransfered
                          ? (e.bytesTransfered = A.bytesTransfered)
                          : "object" == typeof A.bytesTransfered &&
                            (e.bytesTransfered = new Pu.LongBits(
                              A.bytesTransfered.low >>> 0,
                              A.bytesTransfered.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (((t.requestId = 0), Pu.Long)) {
                    let A = new Pu.Long(0, 0, !0);
                    t.bytesTransfered =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.bytesTransfered = e.longs === String ? "0" : 0;
                return (
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  null != A.bytesTransfered &&
                    A.hasOwnProperty("bytesTransfered") &&
                    ("number" == typeof A.bytesTransfered
                      ? (t.bytesTransfered =
                          e.longs === String ? String(A.bytesTransfered) : A.bytesTransfered)
                      : (t.bytesTransfered =
                          e.longs === String
                            ? Pu.Long.prototype.toString.call(A.bytesTransfered)
                            : e.longs === Number
                              ? new Pu.LongBits(
                                  A.bytesTransfered.low >>> 0,
                                  A.bytesTransfered.high >>> 0
                                ).toNumber(!0)
                              : A.bytesTransfered)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.TransferChunkAck"
                );
              }),
              A
            );
          })()),
          (A.TransferEnd = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.requestId = 0),
              (A.prototype.reason = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(8).uint32(A.requestId),
                  null != A.reason &&
                    Object.hasOwnProperty.call(A, "reason") &&
                    e.uint32(16).int32(A.reason),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.TransferEnd();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.requestId = A.uint32();
                      break;
                    case 2:
                      i.reason = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.requestId &&
                  A.hasOwnProperty("requestId") &&
                  !Pu.isInteger(A.requestId)
                )
                  return "requestId: integer expected";
                if (null != A.reason && A.hasOwnProperty("reason"))
                  switch (A.reason) {
                    default:
                      return "reason: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.TransferEnd) return A;
                let e = new Gu.dcv.filestorage.TransferEnd();
                switch ((null != A.requestId && (e.requestId = A.requestId >>> 0), A.reason)) {
                  default:
                    if ("number" == typeof A.reason) {
                      e.reason = A.reason;
                      break;
                    }
                    break;
                  case "COMPLETED":
                  case 0:
                    e.reason = 0;
                    break;
                  case "ERROR":
                  case 1:
                    e.reason = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.requestId = 0), (t.reason = e.enums === String ? "COMPLETED" : 0)),
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  null != A.reason &&
                    A.hasOwnProperty("reason") &&
                    (t.reason =
                      e.enums === String
                        ? void 0 === Gu.dcv.filestorage.TransferEnd.TerminationReason[A.reason]
                          ? A.reason
                          : Gu.dcv.filestorage.TransferEnd.TerminationReason[A.reason]
                        : A.reason),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.TransferEnd"
                );
              }),
              (A.TerminationReason = (function () {
                const A = {},
                  e = Object.create(A);
                return (e[(A[0] = "COMPLETED")] = 0), (e[(A[1] = "ERROR")] = 1), e;
              })()),
              A
            );
          })()),
          (A.Status = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "NOT_ALLOWED")] = 0), (e[(A[1] = "ALLOWED")] = 1), e;
          })()),
          (A.Service = (function () {
            const A = {},
              e = Object.create(A);
            return (e[(A[0] = "UPLOAD")] = 0), (e[(A[1] = "DOWNLOAD")] = 1), e;
          })()),
          (A.StatusUpdate = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.service = 0),
              (A.prototype.status = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.service &&
                    Object.hasOwnProperty.call(A, "service") &&
                    e.uint32(8).int32(A.service),
                  null != A.status &&
                    Object.hasOwnProperty.call(A, "status") &&
                    e.uint32(16).int32(A.status),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.StatusUpdate();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.service = A.int32();
                      break;
                    case 2:
                      i.status = A.int32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.service && A.hasOwnProperty("service"))
                  switch (A.service) {
                    default:
                      return "service: enum value expected";
                    case 0:
                    case 1:
                  }
                if (null != A.status && A.hasOwnProperty("status"))
                  switch (A.status) {
                    default:
                      return "status: enum value expected";
                    case 0:
                    case 1:
                  }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.StatusUpdate) return A;
                let e = new Gu.dcv.filestorage.StatusUpdate();
                switch (A.service) {
                  default:
                    if ("number" == typeof A.service) {
                      e.service = A.service;
                      break;
                    }
                    break;
                  case "UPLOAD":
                  case 0:
                    e.service = 0;
                    break;
                  case "DOWNLOAD":
                  case 1:
                    e.service = 1;
                }
                switch (A.status) {
                  default:
                    if ("number" == typeof A.status) {
                      e.status = A.status;
                      break;
                    }
                    break;
                  case "NOT_ALLOWED":
                  case 0:
                    e.status = 0;
                    break;
                  case "ALLOWED":
                  case 1:
                    e.status = 1;
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.service = e.enums === String ? "UPLOAD" : 0),
                    (t.status = e.enums === String ? "NOT_ALLOWED" : 0)),
                  null != A.service &&
                    A.hasOwnProperty("service") &&
                    (t.service =
                      e.enums === String
                        ? void 0 === Gu.dcv.filestorage.Service[A.service]
                          ? A.service
                          : Gu.dcv.filestorage.Service[A.service]
                        : A.service),
                  null != A.status &&
                    A.hasOwnProperty("status") &&
                    (t.status =
                      e.enums === String
                        ? void 0 === Gu.dcv.filestorage.Status[A.status]
                          ? A.status
                          : Gu.dcv.filestorage.Status[A.status]
                        : A.status),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.StatusUpdate"
                );
              }),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.commandRequest = null),
              (A.prototype.commandCancel = null),
              (A.prototype.transferChunk = null),
              (A.prototype.transferEnd = null),
              Object.defineProperty(A.prototype, "msg", {
                get: Pu.oneOfGetter(
                  (e = ["commandRequest", "commandCancel", "transferChunk", "transferEnd"])
                ),
                set: Pu.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.commandRequest &&
                    Object.hasOwnProperty.call(A, "commandRequest") &&
                    Gu.dcv.filestorage.CommandRequest.encode(
                      A.commandRequest,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.commandCancel &&
                    Object.hasOwnProperty.call(A, "commandCancel") &&
                    Gu.dcv.filestorage.CommandCancel.encode(
                      A.commandCancel,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.transferChunk &&
                    Object.hasOwnProperty.call(A, "transferChunk") &&
                    Gu.dcv.filestorage.TransferChunk.encode(
                      A.transferChunk,
                      e.uint32(242).fork()
                    ).ldelim(),
                  null != A.transferEnd &&
                    Object.hasOwnProperty.call(A, "transferEnd") &&
                    Gu.dcv.filestorage.TransferEnd.encode(
                      A.transferEnd,
                      e.uint32(250).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.commandRequest = Gu.dcv.filestorage.CommandRequest.decode(A, A.uint32());
                      break;
                    case 20:
                      i.commandCancel = Gu.dcv.filestorage.CommandCancel.decode(A, A.uint32());
                      break;
                    case 30:
                      i.transferChunk = Gu.dcv.filestorage.TransferChunk.decode(A, A.uint32());
                      break;
                    case 31:
                      i.transferEnd = Gu.dcv.filestorage.TransferEnd.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.commandRequest && A.hasOwnProperty("commandRequest")) {
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.CommandRequest.verify(A.commandRequest);
                    if (e) return "commandRequest." + e;
                  }
                }
                if (null != A.commandCancel && A.hasOwnProperty("commandCancel")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.CommandCancel.verify(A.commandCancel);
                    if (e) return "commandCancel." + e;
                  }
                }
                if (null != A.transferChunk && A.hasOwnProperty("transferChunk")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.TransferChunk.verify(A.transferChunk);
                    if (e) return "transferChunk." + e;
                  }
                }
                if (null != A.transferEnd && A.hasOwnProperty("transferEnd")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.TransferEnd.verify(A.transferEnd);
                    if (e) return "transferEnd." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.ClientMessage) return A;
                let e = new Gu.dcv.filestorage.ClientMessage();
                if (null != A.commandRequest) {
                  if ("object" != typeof A.commandRequest)
                    throw TypeError(
                      ".dcv.filestorage.ClientMessage.commandRequest: object expected"
                    );
                  e.commandRequest = Gu.dcv.filestorage.CommandRequest.fromObject(A.commandRequest);
                }
                if (null != A.commandCancel) {
                  if ("object" != typeof A.commandCancel)
                    throw TypeError(
                      ".dcv.filestorage.ClientMessage.commandCancel: object expected"
                    );
                  e.commandCancel = Gu.dcv.filestorage.CommandCancel.fromObject(A.commandCancel);
                }
                if (null != A.transferChunk) {
                  if ("object" != typeof A.transferChunk)
                    throw TypeError(
                      ".dcv.filestorage.ClientMessage.transferChunk: object expected"
                    );
                  e.transferChunk = Gu.dcv.filestorage.TransferChunk.fromObject(A.transferChunk);
                }
                if (null != A.transferEnd) {
                  if ("object" != typeof A.transferEnd)
                    throw TypeError(".dcv.filestorage.ClientMessage.transferEnd: object expected");
                  e.transferEnd = Gu.dcv.filestorage.TransferEnd.fromObject(A.transferEnd);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.commandRequest &&
                    A.hasOwnProperty("commandRequest") &&
                    ((t.commandRequest = Gu.dcv.filestorage.CommandRequest.toObject(
                      A.commandRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "commandRequest")),
                  null != A.commandCancel &&
                    A.hasOwnProperty("commandCancel") &&
                    ((t.commandCancel = Gu.dcv.filestorage.CommandCancel.toObject(
                      A.commandCancel,
                      e
                    )),
                    e.oneofs && (t.msg = "commandCancel")),
                  null != A.transferChunk &&
                    A.hasOwnProperty("transferChunk") &&
                    ((t.transferChunk = Gu.dcv.filestorage.TransferChunk.toObject(
                      A.transferChunk,
                      e
                    )),
                    e.oneofs && (t.msg = "transferChunk")),
                  null != A.transferEnd &&
                    A.hasOwnProperty("transferEnd") &&
                    ((t.transferEnd = Gu.dcv.filestorage.TransferEnd.toObject(A.transferEnd, e)),
                    e.oneofs && (t.msg = "transferEnd")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.ClientMessage"
                );
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.statusUpdate = null),
              (A.prototype.commandResult = null),
              (A.prototype.listMessage = null),
              (A.prototype.transferChunkAck = null),
              Object.defineProperty(A.prototype, "msg", {
                get: Pu.oneOfGetter(
                  (e = ["statusUpdate", "commandResult", "listMessage", "transferChunkAck"])
                ),
                set: Pu.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.statusUpdate &&
                    Object.hasOwnProperty.call(A, "statusUpdate") &&
                    Gu.dcv.filestorage.StatusUpdate.encode(
                      A.statusUpdate,
                      e.uint32(10).fork()
                    ).ldelim(),
                  null != A.commandResult &&
                    Object.hasOwnProperty.call(A, "commandResult") &&
                    Gu.dcv.filestorage.CommandResult.encode(
                      A.commandResult,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.listMessage &&
                    Object.hasOwnProperty.call(A, "listMessage") &&
                    Gu.dcv.filestorage.List.encode(A.listMessage, e.uint32(162).fork()).ldelim(),
                  null != A.transferChunkAck &&
                    Object.hasOwnProperty.call(A, "transferChunkAck") &&
                    Gu.dcv.filestorage.TransferChunkAck.encode(
                      A.transferChunkAck,
                      e.uint32(242).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.statusUpdate = Gu.dcv.filestorage.StatusUpdate.decode(A, A.uint32());
                      break;
                    case 10:
                      i.commandResult = Gu.dcv.filestorage.CommandResult.decode(A, A.uint32());
                      break;
                    case 20:
                      i.listMessage = Gu.dcv.filestorage.List.decode(A, A.uint32());
                      break;
                    case 30:
                      i.transferChunkAck = Gu.dcv.filestorage.TransferChunkAck.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.statusUpdate && A.hasOwnProperty("statusUpdate")) {
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.StatusUpdate.verify(A.statusUpdate);
                    if (e) return "statusUpdate." + e;
                  }
                }
                if (null != A.commandResult && A.hasOwnProperty("commandResult")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.CommandResult.verify(A.commandResult);
                    if (e) return "commandResult." + e;
                  }
                }
                if (null != A.listMessage && A.hasOwnProperty("listMessage")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.List.verify(A.listMessage);
                    if (e) return "listMessage." + e;
                  }
                }
                if (null != A.transferChunkAck && A.hasOwnProperty("transferChunkAck")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = Gu.dcv.filestorage.TransferChunkAck.verify(A.transferChunkAck);
                    if (e) return "transferChunkAck." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.ServerMessage) return A;
                let e = new Gu.dcv.filestorage.ServerMessage();
                if (null != A.statusUpdate) {
                  if ("object" != typeof A.statusUpdate)
                    throw TypeError(".dcv.filestorage.ServerMessage.statusUpdate: object expected");
                  e.statusUpdate = Gu.dcv.filestorage.StatusUpdate.fromObject(A.statusUpdate);
                }
                if (null != A.commandResult) {
                  if ("object" != typeof A.commandResult)
                    throw TypeError(
                      ".dcv.filestorage.ServerMessage.commandResult: object expected"
                    );
                  e.commandResult = Gu.dcv.filestorage.CommandResult.fromObject(A.commandResult);
                }
                if (null != A.listMessage) {
                  if ("object" != typeof A.listMessage)
                    throw TypeError(".dcv.filestorage.ServerMessage.listMessage: object expected");
                  e.listMessage = Gu.dcv.filestorage.List.fromObject(A.listMessage);
                }
                if (null != A.transferChunkAck) {
                  if ("object" != typeof A.transferChunkAck)
                    throw TypeError(
                      ".dcv.filestorage.ServerMessage.transferChunkAck: object expected"
                    );
                  e.transferChunkAck = Gu.dcv.filestorage.TransferChunkAck.fromObject(
                    A.transferChunkAck
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.statusUpdate &&
                    A.hasOwnProperty("statusUpdate") &&
                    ((t.statusUpdate = Gu.dcv.filestorage.StatusUpdate.toObject(A.statusUpdate, e)),
                    e.oneofs && (t.msg = "statusUpdate")),
                  null != A.commandResult &&
                    A.hasOwnProperty("commandResult") &&
                    ((t.commandResult = Gu.dcv.filestorage.CommandResult.toObject(
                      A.commandResult,
                      e
                    )),
                    e.oneofs && (t.msg = "commandResult")),
                  null != A.listMessage &&
                    A.hasOwnProperty("listMessage") &&
                    ((t.listMessage = Gu.dcv.filestorage.List.toObject(A.listMessage, e)),
                    e.oneofs && (t.msg = "listMessage")),
                  null != A.transferChunkAck &&
                    A.hasOwnProperty("transferChunkAck") &&
                    ((t.transferChunkAck = Gu.dcv.filestorage.TransferChunkAck.toObject(
                      A.transferChunkAck,
                      e
                    )),
                    e.oneofs && (t.msg = "transferChunkAck")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.ServerMessage"
                );
              }),
              A
            );
          })()),
          (A.CreateDirectoryCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.pathname &&
                    Object.hasOwnProperty.call(A, "pathname") &&
                    e.uint32(82).string(A.pathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.CreateDirectoryCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10) i.pathname = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pathname && A.hasOwnProperty("pathname") && !Pu.isString(A.pathname)
                    ? "pathname: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.CreateDirectoryCommand) return A;
                let e = new Gu.dcv.filestorage.CreateDirectoryCommand();
                return null != A.pathname && (e.pathname = String(A.pathname)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.pathname = ""),
                  null != A.pathname && A.hasOwnProperty("pathname") && (t.pathname = A.pathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.CreateDirectoryCommand"
                );
              }),
              A
            );
          })()),
          (A.DeleteFileCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.pathname &&
                    Object.hasOwnProperty.call(A, "pathname") &&
                    e.uint32(82).string(A.pathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.DeleteFileCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10) i.pathname = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pathname && A.hasOwnProperty("pathname") && !Pu.isString(A.pathname)
                    ? "pathname: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.DeleteFileCommand) return A;
                let e = new Gu.dcv.filestorage.DeleteFileCommand();
                return null != A.pathname && (e.pathname = String(A.pathname)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.pathname = ""),
                  null != A.pathname && A.hasOwnProperty("pathname") && (t.pathname = A.pathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.DeleteFileCommand"
                );
              }),
              A
            );
          })()),
          (A.DeleteDirectoryCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.pathname &&
                    Object.hasOwnProperty.call(A, "pathname") &&
                    e.uint32(82).string(A.pathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.DeleteDirectoryCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10) i.pathname = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pathname && A.hasOwnProperty("pathname") && !Pu.isString(A.pathname)
                    ? "pathname: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.DeleteDirectoryCommand) return A;
                let e = new Gu.dcv.filestorage.DeleteDirectoryCommand();
                return null != A.pathname && (e.pathname = String(A.pathname)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.pathname = ""),
                  null != A.pathname && A.hasOwnProperty("pathname") && (t.pathname = A.pathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.DeleteDirectoryCommand"
                );
              }),
              A
            );
          })()),
          (A.MoveFileCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.oldPathname = ""),
              (A.prototype.newPathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.oldPathname &&
                    Object.hasOwnProperty.call(A, "oldPathname") &&
                    e.uint32(82).string(A.oldPathname),
                  null != A.newPathname &&
                    Object.hasOwnProperty.call(A, "newPathname") &&
                    e.uint32(162).string(A.newPathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.MoveFileCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.oldPathname = A.string();
                      break;
                    case 20:
                      i.newPathname = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.oldPathname &&
                      A.hasOwnProperty("oldPathname") &&
                      !Pu.isString(A.oldPathname)
                    ? "oldPathname: string expected"
                    : null != A.newPathname &&
                        A.hasOwnProperty("newPathname") &&
                        !Pu.isString(A.newPathname)
                      ? "newPathname: string expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.MoveFileCommand) return A;
                let e = new Gu.dcv.filestorage.MoveFileCommand();
                return (
                  null != A.oldPathname && (e.oldPathname = String(A.oldPathname)),
                  null != A.newPathname && (e.newPathname = String(A.newPathname)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.oldPathname = ""), (t.newPathname = "")),
                  null != A.oldPathname &&
                    A.hasOwnProperty("oldPathname") &&
                    (t.oldPathname = A.oldPathname),
                  null != A.newPathname &&
                    A.hasOwnProperty("newPathname") &&
                    (t.newPathname = A.newPathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.MoveFileCommand"
                );
              }),
              A
            );
          })()),
          (A.MoveDirectoryCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.oldPathname = ""),
              (A.prototype.newPathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.oldPathname &&
                    Object.hasOwnProperty.call(A, "oldPathname") &&
                    e.uint32(82).string(A.oldPathname),
                  null != A.newPathname &&
                    Object.hasOwnProperty.call(A, "newPathname") &&
                    e.uint32(162).string(A.newPathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.MoveDirectoryCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.oldPathname = A.string();
                      break;
                    case 20:
                      i.newPathname = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.oldPathname &&
                      A.hasOwnProperty("oldPathname") &&
                      !Pu.isString(A.oldPathname)
                    ? "oldPathname: string expected"
                    : null != A.newPathname &&
                        A.hasOwnProperty("newPathname") &&
                        !Pu.isString(A.newPathname)
                      ? "newPathname: string expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.MoveDirectoryCommand) return A;
                let e = new Gu.dcv.filestorage.MoveDirectoryCommand();
                return (
                  null != A.oldPathname && (e.oldPathname = String(A.oldPathname)),
                  null != A.newPathname && (e.newPathname = String(A.newPathname)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && ((t.oldPathname = ""), (t.newPathname = "")),
                  null != A.oldPathname &&
                    A.hasOwnProperty("oldPathname") &&
                    (t.oldPathname = A.oldPathname),
                  null != A.newPathname &&
                    A.hasOwnProperty("newPathname") &&
                    (t.newPathname = A.newPathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.MoveDirectoryCommand"
                );
              }),
              A
            );
          })()),
          (A.RetrieveFileCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.pathname &&
                    Object.hasOwnProperty.call(A, "pathname") &&
                    e.uint32(82).string(A.pathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.RetrieveFileCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10) i.pathname = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pathname && A.hasOwnProperty("pathname") && !Pu.isString(A.pathname)
                    ? "pathname: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.RetrieveFileCommand) return A;
                let e = new Gu.dcv.filestorage.RetrieveFileCommand();
                return null != A.pathname && (e.pathname = String(A.pathname)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.pathname = ""),
                  null != A.pathname && A.hasOwnProperty("pathname") && (t.pathname = A.pathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.RetrieveFileCommand"
                );
              }),
              A
            );
          })()),
          (A.StoreFileCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pathname = ""),
              (A.prototype.fileSize = Pu.Long ? Pu.Long.fromBits(0, 0, !0) : 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.pathname &&
                    Object.hasOwnProperty.call(A, "pathname") &&
                    e.uint32(82).string(A.pathname),
                  null != A.fileSize &&
                    Object.hasOwnProperty.call(A, "fileSize") &&
                    e.uint32(160).uint64(A.fileSize),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.StoreFileCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.pathname = A.string();
                      break;
                    case 20:
                      i.fileSize = A.uint64();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pathname && A.hasOwnProperty("pathname") && !Pu.isString(A.pathname)
                    ? "pathname: string expected"
                    : null != A.fileSize &&
                        A.hasOwnProperty("fileSize") &&
                        !(
                          Pu.isInteger(A.fileSize) ||
                          (A.fileSize &&
                            Pu.isInteger(A.fileSize.low) &&
                            Pu.isInteger(A.fileSize.high))
                        )
                      ? "fileSize: integer|Long expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.StoreFileCommand) return A;
                let e = new Gu.dcv.filestorage.StoreFileCommand();
                return (
                  null != A.pathname && (e.pathname = String(A.pathname)),
                  null != A.fileSize &&
                    (Pu.Long
                      ? ((e.fileSize = Pu.Long.fromValue(A.fileSize)).unsigned = !0)
                      : "string" == typeof A.fileSize
                        ? (e.fileSize = parseInt(A.fileSize, 10))
                        : "number" == typeof A.fileSize
                          ? (e.fileSize = A.fileSize)
                          : "object" == typeof A.fileSize &&
                            (e.fileSize = new Pu.LongBits(
                              A.fileSize.low >>> 0,
                              A.fileSize.high >>> 0
                            ).toNumber(!0))),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults)
                  if (((t.pathname = ""), Pu.Long)) {
                    let A = new Pu.Long(0, 0, !0);
                    t.fileSize =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.fileSize = e.longs === String ? "0" : 0;
                return (
                  null != A.pathname && A.hasOwnProperty("pathname") && (t.pathname = A.pathname),
                  null != A.fileSize &&
                    A.hasOwnProperty("fileSize") &&
                    ("number" == typeof A.fileSize
                      ? (t.fileSize = e.longs === String ? String(A.fileSize) : A.fileSize)
                      : (t.fileSize =
                          e.longs === String
                            ? Pu.Long.prototype.toString.call(A.fileSize)
                            : e.longs === Number
                              ? new Pu.LongBits(
                                  A.fileSize.low >>> 0,
                                  A.fileSize.high >>> 0
                                ).toNumber(!0)
                              : A.fileSize)),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"),
                  A + "/dcv.filestorage.StoreFileCommand"
                );
              }),
              A
            );
          })()),
          (A.ListCommand = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.pathname = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.pathname &&
                    Object.hasOwnProperty.call(A, "pathname") &&
                    e.uint32(82).string(A.pathname),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.ListCommand();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 10) i.pathname = A.string();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.pathname && A.hasOwnProperty("pathname") && !Pu.isString(A.pathname)
                    ? "pathname: string expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.ListCommand) return A;
                let e = new Gu.dcv.filestorage.ListCommand();
                return null != A.pathname && (e.pathname = String(A.pathname)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.pathname = ""),
                  null != A.pathname && A.hasOwnProperty("pathname") && (t.pathname = A.pathname),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.ListCommand"
                );
              }),
              A
            );
          })()),
          (A.FileInfo = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.type = 0),
              (A.prototype.name = ""),
              (A.prototype.displayName = ""),
              (A.prototype.lastModified = ""),
              (A.prototype.size = Pu.Long ? Pu.Long.fromBits(0, 0, !0) : 0),
              (A.prototype.mimeType = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.type &&
                    Object.hasOwnProperty.call(A, "type") &&
                    e.uint32(80).int32(A.type),
                  null != A.name &&
                    Object.hasOwnProperty.call(A, "name") &&
                    e.uint32(162).string(A.name),
                  null != A.displayName &&
                    Object.hasOwnProperty.call(A, "displayName") &&
                    e.uint32(170).string(A.displayName),
                  null != A.lastModified &&
                    Object.hasOwnProperty.call(A, "lastModified") &&
                    e.uint32(242).string(A.lastModified),
                  null != A.size &&
                    Object.hasOwnProperty.call(A, "size") &&
                    e.uint32(320).uint64(A.size),
                  null != A.mimeType &&
                    Object.hasOwnProperty.call(A, "mimeType") &&
                    e.uint32(402).string(A.mimeType),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.FileInfo();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.type = A.int32();
                      break;
                    case 20:
                      i.name = A.string();
                      break;
                    case 21:
                      i.displayName = A.string();
                      break;
                    case 30:
                      i.lastModified = A.string();
                      break;
                    case 40:
                      i.size = A.uint64();
                      break;
                    case 50:
                      i.mimeType = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.type && A.hasOwnProperty("type"))
                  switch (A.type) {
                    default:
                      return "type: enum value expected";
                    case 0:
                    case 1:
                  }
                return null != A.name && A.hasOwnProperty("name") && !Pu.isString(A.name)
                  ? "name: string expected"
                  : null != A.displayName &&
                      A.hasOwnProperty("displayName") &&
                      !Pu.isString(A.displayName)
                    ? "displayName: string expected"
                    : null != A.lastModified &&
                        A.hasOwnProperty("lastModified") &&
                        !Pu.isString(A.lastModified)
                      ? "lastModified: string expected"
                      : null != A.size &&
                          A.hasOwnProperty("size") &&
                          !(
                            Pu.isInteger(A.size) ||
                            (A.size && Pu.isInteger(A.size.low) && Pu.isInteger(A.size.high))
                          )
                        ? "size: integer|Long expected"
                        : null != A.mimeType &&
                            A.hasOwnProperty("mimeType") &&
                            !Pu.isString(A.mimeType)
                          ? "mimeType: string expected"
                          : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.FileInfo) return A;
                let e = new Gu.dcv.filestorage.FileInfo();
                switch (A.type) {
                  default:
                    if ("number" == typeof A.type) {
                      e.type = A.type;
                      break;
                    }
                    break;
                  case "FILE":
                  case 0:
                    e.type = 0;
                    break;
                  case "DIRECTORY":
                  case 1:
                    e.type = 1;
                }
                return (
                  null != A.name && (e.name = String(A.name)),
                  null != A.displayName && (e.displayName = String(A.displayName)),
                  null != A.lastModified && (e.lastModified = String(A.lastModified)),
                  null != A.size &&
                    (Pu.Long
                      ? ((e.size = Pu.Long.fromValue(A.size)).unsigned = !0)
                      : "string" == typeof A.size
                        ? (e.size = parseInt(A.size, 10))
                        : "number" == typeof A.size
                          ? (e.size = A.size)
                          : "object" == typeof A.size &&
                            (e.size = new Pu.LongBits(A.size.low >>> 0, A.size.high >>> 0).toNumber(
                              !0
                            ))),
                  null != A.mimeType && (e.mimeType = String(A.mimeType)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (e.defaults) {
                  if (
                    ((t.type = e.enums === String ? "FILE" : 0),
                    (t.name = ""),
                    (t.displayName = ""),
                    (t.lastModified = ""),
                    Pu.Long)
                  ) {
                    let A = new Pu.Long(0, 0, !0);
                    t.size =
                      e.longs === String ? A.toString() : e.longs === Number ? A.toNumber() : A;
                  } else t.size = e.longs === String ? "0" : 0;
                  t.mimeType = "";
                }
                return (
                  null != A.type &&
                    A.hasOwnProperty("type") &&
                    (t.type =
                      e.enums === String
                        ? void 0 === Gu.dcv.filestorage.FileInfo.Type[A.type]
                          ? A.type
                          : Gu.dcv.filestorage.FileInfo.Type[A.type]
                        : A.type),
                  null != A.name && A.hasOwnProperty("name") && (t.name = A.name),
                  null != A.displayName &&
                    A.hasOwnProperty("displayName") &&
                    (t.displayName = A.displayName),
                  null != A.lastModified &&
                    A.hasOwnProperty("lastModified") &&
                    (t.lastModified = A.lastModified),
                  null != A.size &&
                    A.hasOwnProperty("size") &&
                    ("number" == typeof A.size
                      ? (t.size = e.longs === String ? String(A.size) : A.size)
                      : (t.size =
                          e.longs === String
                            ? Pu.Long.prototype.toString.call(A.size)
                            : e.longs === Number
                              ? new Pu.LongBits(A.size.low >>> 0, A.size.high >>> 0).toNumber(!0)
                              : A.size)),
                  null != A.mimeType && A.hasOwnProperty("mimeType") && (t.mimeType = A.mimeType),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.FileInfo";
              }),
              (A.Type = (function () {
                const A = {},
                  e = Object.create(A);
                return (e[(A[0] = "FILE")] = 0), (e[(A[1] = "DIRECTORY")] = 1), e;
              })()),
              A
            );
          })()),
          (A.List = (function () {
            function A(A) {
              if (((this.item = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.requestId = 0),
              (A.prototype.item = Pu.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(80).uint32(A.requestId),
                  null != A.item && A.item.length)
                )
                  for (let t = 0; t < A.item.length; ++t)
                    Gu.dcv.filestorage.FileInfo.encode(A.item[t], e.uint32(162).fork()).ldelim();
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.List();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.requestId = A.uint32();
                      break;
                    case 20:
                      (i.item && i.item.length) || (i.item = []),
                        i.item.push(Gu.dcv.filestorage.FileInfo.decode(A, A.uint32()));
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.requestId &&
                  A.hasOwnProperty("requestId") &&
                  !Pu.isInteger(A.requestId)
                )
                  return "requestId: integer expected";
                if (null != A.item && A.hasOwnProperty("item")) {
                  if (!Array.isArray(A.item)) return "item: array expected";
                  for (let e = 0; e < A.item.length; ++e) {
                    let t = Gu.dcv.filestorage.FileInfo.verify(A.item[e]);
                    if (t) return "item." + t;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.List) return A;
                let e = new Gu.dcv.filestorage.List();
                if ((null != A.requestId && (e.requestId = A.requestId >>> 0), A.item)) {
                  if (!Array.isArray(A.item))
                    throw TypeError(".dcv.filestorage.List.item: array expected");
                  e.item = [];
                  for (let t = 0; t < A.item.length; ++t) {
                    if ("object" != typeof A.item[t])
                      throw TypeError(".dcv.filestorage.List.item: object expected");
                    e.item[t] = Gu.dcv.filestorage.FileInfo.fromObject(A.item[t]);
                  }
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.item = []),
                  e.defaults && (t.requestId = 0),
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  A.item && A.item.length)
                ) {
                  t.item = [];
                  for (let i = 0; i < A.item.length; ++i)
                    t.item[i] = Gu.dcv.filestorage.FileInfo.toObject(A.item[i], e);
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.List";
              }),
              A
            );
          })()),
          (A.CommandRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.requestId = 0),
              (A.prototype.createDirectory = null),
              (A.prototype.deleteFile = null),
              (A.prototype.deleteDirectory = null),
              (A.prototype.moveFile = null),
              (A.prototype.moveDirectory = null),
              (A.prototype.retrieveFile = null),
              (A.prototype.storeFile = null),
              (A.prototype.list = null),
              Object.defineProperty(A.prototype, "command", {
                get: Pu.oneOfGetter(
                  (e = [
                    "createDirectory",
                    "deleteFile",
                    "deleteDirectory",
                    "moveFile",
                    "moveDirectory",
                    "retrieveFile",
                    "storeFile",
                    "list"
                  ])
                ),
                set: Pu.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(80).uint32(A.requestId),
                  null != A.createDirectory &&
                    Object.hasOwnProperty.call(A, "createDirectory") &&
                    Gu.dcv.filestorage.CreateDirectoryCommand.encode(
                      A.createDirectory,
                      e.uint32(802).fork()
                    ).ldelim(),
                  null != A.deleteFile &&
                    Object.hasOwnProperty.call(A, "deleteFile") &&
                    Gu.dcv.filestorage.DeleteFileCommand.encode(
                      A.deleteFile,
                      e.uint32(882).fork()
                    ).ldelim(),
                  null != A.deleteDirectory &&
                    Object.hasOwnProperty.call(A, "deleteDirectory") &&
                    Gu.dcv.filestorage.DeleteDirectoryCommand.encode(
                      A.deleteDirectory,
                      e.uint32(962).fork()
                    ).ldelim(),
                  null != A.moveFile &&
                    Object.hasOwnProperty.call(A, "moveFile") &&
                    Gu.dcv.filestorage.MoveFileCommand.encode(
                      A.moveFile,
                      e.uint32(1042).fork()
                    ).ldelim(),
                  null != A.moveDirectory &&
                    Object.hasOwnProperty.call(A, "moveDirectory") &&
                    Gu.dcv.filestorage.MoveDirectoryCommand.encode(
                      A.moveDirectory,
                      e.uint32(1122).fork()
                    ).ldelim(),
                  null != A.retrieveFile &&
                    Object.hasOwnProperty.call(A, "retrieveFile") &&
                    Gu.dcv.filestorage.RetrieveFileCommand.encode(
                      A.retrieveFile,
                      e.uint32(1202).fork()
                    ).ldelim(),
                  null != A.storeFile &&
                    Object.hasOwnProperty.call(A, "storeFile") &&
                    Gu.dcv.filestorage.StoreFileCommand.encode(
                      A.storeFile,
                      e.uint32(1282).fork()
                    ).ldelim(),
                  null != A.list &&
                    Object.hasOwnProperty.call(A, "list") &&
                    Gu.dcv.filestorage.ListCommand.encode(A.list, e.uint32(1362).fork()).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.CommandRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.requestId = A.uint32();
                      break;
                    case 100:
                      i.createDirectory = Gu.dcv.filestorage.CreateDirectoryCommand.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 110:
                      i.deleteFile = Gu.dcv.filestorage.DeleteFileCommand.decode(A, A.uint32());
                      break;
                    case 120:
                      i.deleteDirectory = Gu.dcv.filestorage.DeleteDirectoryCommand.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 130:
                      i.moveFile = Gu.dcv.filestorage.MoveFileCommand.decode(A, A.uint32());
                      break;
                    case 140:
                      i.moveDirectory = Gu.dcv.filestorage.MoveDirectoryCommand.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 150:
                      i.retrieveFile = Gu.dcv.filestorage.RetrieveFileCommand.decode(A, A.uint32());
                      break;
                    case 160:
                      i.storeFile = Gu.dcv.filestorage.StoreFileCommand.decode(A, A.uint32());
                      break;
                    case 170:
                      i.list = Gu.dcv.filestorage.ListCommand.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (
                  null != A.requestId &&
                  A.hasOwnProperty("requestId") &&
                  !Pu.isInteger(A.requestId)
                )
                  return "requestId: integer expected";
                if (null != A.createDirectory && A.hasOwnProperty("createDirectory")) {
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.CreateDirectoryCommand.verify(A.createDirectory);
                    if (e) return "createDirectory." + e;
                  }
                }
                if (null != A.deleteFile && A.hasOwnProperty("deleteFile")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.DeleteFileCommand.verify(A.deleteFile);
                    if (e) return "deleteFile." + e;
                  }
                }
                if (null != A.deleteDirectory && A.hasOwnProperty("deleteDirectory")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.DeleteDirectoryCommand.verify(A.deleteDirectory);
                    if (e) return "deleteDirectory." + e;
                  }
                }
                if (null != A.moveFile && A.hasOwnProperty("moveFile")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.MoveFileCommand.verify(A.moveFile);
                    if (e) return "moveFile." + e;
                  }
                }
                if (null != A.moveDirectory && A.hasOwnProperty("moveDirectory")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.MoveDirectoryCommand.verify(A.moveDirectory);
                    if (e) return "moveDirectory." + e;
                  }
                }
                if (null != A.retrieveFile && A.hasOwnProperty("retrieveFile")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.RetrieveFileCommand.verify(A.retrieveFile);
                    if (e) return "retrieveFile." + e;
                  }
                }
                if (null != A.storeFile && A.hasOwnProperty("storeFile")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.StoreFileCommand.verify(A.storeFile);
                    if (e) return "storeFile." + e;
                  }
                }
                if (null != A.list && A.hasOwnProperty("list")) {
                  if (1 === e.command) return "command: multiple values";
                  e.command = 1;
                  {
                    let e = Gu.dcv.filestorage.ListCommand.verify(A.list);
                    if (e) return "list." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.CommandRequest) return A;
                let e = new Gu.dcv.filestorage.CommandRequest();
                if (
                  (null != A.requestId && (e.requestId = A.requestId >>> 0),
                  null != A.createDirectory)
                ) {
                  if ("object" != typeof A.createDirectory)
                    throw TypeError(
                      ".dcv.filestorage.CommandRequest.createDirectory: object expected"
                    );
                  e.createDirectory = Gu.dcv.filestorage.CreateDirectoryCommand.fromObject(
                    A.createDirectory
                  );
                }
                if (null != A.deleteFile) {
                  if ("object" != typeof A.deleteFile)
                    throw TypeError(".dcv.filestorage.CommandRequest.deleteFile: object expected");
                  e.deleteFile = Gu.dcv.filestorage.DeleteFileCommand.fromObject(A.deleteFile);
                }
                if (null != A.deleteDirectory) {
                  if ("object" != typeof A.deleteDirectory)
                    throw TypeError(
                      ".dcv.filestorage.CommandRequest.deleteDirectory: object expected"
                    );
                  e.deleteDirectory = Gu.dcv.filestorage.DeleteDirectoryCommand.fromObject(
                    A.deleteDirectory
                  );
                }
                if (null != A.moveFile) {
                  if ("object" != typeof A.moveFile)
                    throw TypeError(".dcv.filestorage.CommandRequest.moveFile: object expected");
                  e.moveFile = Gu.dcv.filestorage.MoveFileCommand.fromObject(A.moveFile);
                }
                if (null != A.moveDirectory) {
                  if ("object" != typeof A.moveDirectory)
                    throw TypeError(
                      ".dcv.filestorage.CommandRequest.moveDirectory: object expected"
                    );
                  e.moveDirectory = Gu.dcv.filestorage.MoveDirectoryCommand.fromObject(
                    A.moveDirectory
                  );
                }
                if (null != A.retrieveFile) {
                  if ("object" != typeof A.retrieveFile)
                    throw TypeError(
                      ".dcv.filestorage.CommandRequest.retrieveFile: object expected"
                    );
                  e.retrieveFile = Gu.dcv.filestorage.RetrieveFileCommand.fromObject(
                    A.retrieveFile
                  );
                }
                if (null != A.storeFile) {
                  if ("object" != typeof A.storeFile)
                    throw TypeError(".dcv.filestorage.CommandRequest.storeFile: object expected");
                  e.storeFile = Gu.dcv.filestorage.StoreFileCommand.fromObject(A.storeFile);
                }
                if (null != A.list) {
                  if ("object" != typeof A.list)
                    throw TypeError(".dcv.filestorage.CommandRequest.list: object expected");
                  e.list = Gu.dcv.filestorage.ListCommand.fromObject(A.list);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults && (t.requestId = 0),
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  null != A.createDirectory &&
                    A.hasOwnProperty("createDirectory") &&
                    ((t.createDirectory = Gu.dcv.filestorage.CreateDirectoryCommand.toObject(
                      A.createDirectory,
                      e
                    )),
                    e.oneofs && (t.command = "createDirectory")),
                  null != A.deleteFile &&
                    A.hasOwnProperty("deleteFile") &&
                    ((t.deleteFile = Gu.dcv.filestorage.DeleteFileCommand.toObject(
                      A.deleteFile,
                      e
                    )),
                    e.oneofs && (t.command = "deleteFile")),
                  null != A.deleteDirectory &&
                    A.hasOwnProperty("deleteDirectory") &&
                    ((t.deleteDirectory = Gu.dcv.filestorage.DeleteDirectoryCommand.toObject(
                      A.deleteDirectory,
                      e
                    )),
                    e.oneofs && (t.command = "deleteDirectory")),
                  null != A.moveFile &&
                    A.hasOwnProperty("moveFile") &&
                    ((t.moveFile = Gu.dcv.filestorage.MoveFileCommand.toObject(A.moveFile, e)),
                    e.oneofs && (t.command = "moveFile")),
                  null != A.moveDirectory &&
                    A.hasOwnProperty("moveDirectory") &&
                    ((t.moveDirectory = Gu.dcv.filestorage.MoveDirectoryCommand.toObject(
                      A.moveDirectory,
                      e
                    )),
                    e.oneofs && (t.command = "moveDirectory")),
                  null != A.retrieveFile &&
                    A.hasOwnProperty("retrieveFile") &&
                    ((t.retrieveFile = Gu.dcv.filestorage.RetrieveFileCommand.toObject(
                      A.retrieveFile,
                      e
                    )),
                    e.oneofs && (t.command = "retrieveFile")),
                  null != A.storeFile &&
                    A.hasOwnProperty("storeFile") &&
                    ((t.storeFile = Gu.dcv.filestorage.StoreFileCommand.toObject(A.storeFile, e)),
                    e.oneofs && (t.command = "storeFile")),
                  null != A.list &&
                    A.hasOwnProperty("list") &&
                    ((t.list = Gu.dcv.filestorage.ListCommand.toObject(A.list, e)),
                    e.oneofs && (t.command = "list")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.CommandRequest"
                );
              }),
              A
            );
          })()),
          (A.CommandResult = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.requestId = 0),
              (A.prototype.completionCode = 0),
              (A.prototype.message = ""),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = Tu.create()),
                  null != A.requestId &&
                    Object.hasOwnProperty.call(A, "requestId") &&
                    e.uint32(80).uint32(A.requestId),
                  null != A.completionCode &&
                    Object.hasOwnProperty.call(A, "completionCode") &&
                    e.uint32(160).int32(A.completionCode),
                  null != A.message &&
                    Object.hasOwnProperty.call(A, "message") &&
                    e.uint32(242).string(A.message),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof Lu || (A = Lu.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new Gu.dcv.filestorage.CommandResult();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.requestId = A.uint32();
                      break;
                    case 20:
                      i.completionCode = A.int32();
                      break;
                    case 30:
                      i.message = A.string();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof Lu || (A = new Lu(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.requestId &&
                  A.hasOwnProperty("requestId") &&
                  !Pu.isInteger(A.requestId)
                )
                  return "requestId: integer expected";
                if (null != A.completionCode && A.hasOwnProperty("completionCode"))
                  switch (A.completionCode) {
                    default:
                      return "completionCode: enum value expected";
                    case 0:
                    case 10:
                    case 15:
                    case 20:
                    case 25:
                    case 30:
                    case 40:
                    case 50:
                    case 51:
                    case 52:
                  }
                return null != A.message && A.hasOwnProperty("message") && !Pu.isString(A.message)
                  ? "message: string expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof Gu.dcv.filestorage.CommandResult) return A;
                let e = new Gu.dcv.filestorage.CommandResult();
                switch (
                  (null != A.requestId && (e.requestId = A.requestId >>> 0), A.completionCode)
                ) {
                  default:
                    if ("number" == typeof A.completionCode) {
                      e.completionCode = A.completionCode;
                      break;
                    }
                    break;
                  case "NONE":
                  case 0:
                    e.completionCode = 0;
                    break;
                  case "OK":
                  case 10:
                    e.completionCode = 10;
                    break;
                  case "READY":
                  case 15:
                    e.completionCode = 15;
                    break;
                  case "CANCELLED":
                  case 20:
                    e.completionCode = 20;
                    break;
                  case "ABORTED":
                  case 25:
                    e.completionCode = 25;
                    break;
                  case "INVALID_ARGUMENT":
                  case 30:
                    e.completionCode = 30;
                    break;
                  case "UNIMPLEMENTED_COMMAND":
                  case 40:
                    e.completionCode = 40;
                    break;
                  case "ERROR":
                  case 50:
                    e.completionCode = 50;
                    break;
                  case "ERROR_ALREADY_EXIST":
                  case 51:
                    e.completionCode = 51;
                    break;
                  case "ERROR_NOT_FOUND":
                  case 52:
                    e.completionCode = 52;
                }
                return null != A.message && (e.message = String(A.message)), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.requestId = 0),
                    (t.completionCode = e.enums === String ? "NONE" : 0),
                    (t.message = "")),
                  null != A.requestId &&
                    A.hasOwnProperty("requestId") &&
                    (t.requestId = A.requestId),
                  null != A.completionCode &&
                    A.hasOwnProperty("completionCode") &&
                    (t.completionCode =
                      e.enums === String
                        ? void 0 ===
                          Gu.dcv.filestorage.CommandResult.CompletionCode[A.completionCode]
                          ? A.completionCode
                          : Gu.dcv.filestorage.CommandResult.CompletionCode[A.completionCode]
                        : A.completionCode),
                  null != A.message && A.hasOwnProperty("message") && (t.message = A.message),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.filestorage.CommandResult"
                );
              }),
              (A.CompletionCode = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "NONE")] = 0),
                  (e[(A[10] = "OK")] = 10),
                  (e[(A[15] = "READY")] = 15),
                  (e[(A[20] = "CANCELLED")] = 20),
                  (e[(A[25] = "ABORTED")] = 25),
                  (e[(A[30] = "INVALID_ARGUMENT")] = 30),
                  (e[(A[40] = "UNIMPLEMENTED_COMMAND")] = 40),
                  (e[(A[50] = "ERROR")] = 50),
                  (e[(A[51] = "ERROR_ALREADY_EXIST")] = 51),
                  (e[(A[52] = "ERROR_NOT_FOUND")] = 52),
                  e
                );
              })()),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })());
class Yu {
  constructor(A) {
    (this.chunk_size = 65536),
      (this.chunk_step = 32768),
      (this.maxChunkSize = 245760),
      (this.maxByteRate = 655360),
      (this.currentByteRate = 131072),
      (this.minTimeout = 20),
      (this.timeout = Math.max(
        Math.ceil((1e3 * this.chunk_size) / this.currentByteRate),
        this.minTimeout
      )),
      (this.file_channel = A),
      (this.numUploads = 0),
      (this.updateFrequency = 250),
      (this.log = A.log);
  }
  updateByteRate() {
    let A;
    0 !== this.numUploads &&
      ((A = this.file_channel.getBufferedAmount()),
      0 === A
        ? this.chunk_size === this.maxChunkSize
          ? ((this.currentByteRate = Math.min(
              this.currentByteRate + this.maxChunkSize,
              this.maxByteRate
            )),
            (this.timeout = Math.max(
              Math.ceil((1e3 * this.chunk_size) / this.currentByteRate),
              this.minTimeout
            )))
          : (this.chunk_size = Math.min(this.chunk_size + this.chunk_step, this.maxChunkSize))
        : this.timeout === this.updateFrequency
          ? (this.chunk_size = Math.max(this.chunk_size - this.chunk_step, this.chunk_step))
          : ((this.currentByteRate = Math.max(this.currentByteRate - A, this.chunk_size)),
            (this.timeout = Math.max(
              Math.ceil((1e3 * this.chunk_size) / this.currentByteRate),
              this.minTimeout
            ))),
      this.log.debug(
        `Current upload frequency: ${this.timeout}(ms), Chunk size: ${this.chunk_size}Bytes, buffered queue on channel: ${A} Bytes`
      ),
      setTimeout(this.updateByteRate.bind(this), this.updateFrequency));
  }
  addUpload() {
    this.numUploads <= 0 && setTimeout(this.updateByteRate.bind(this), 500),
      this.numUploads++,
      this.numUploads > 1 &&
        (this.timeout = Math.ceil((this.timeout * this.numUploads) / (this.numUploads - 1)));
  }
  removeUpload() {
    this.numUploads--,
      this.numUploads < 1
        ? (this.numUploads = 0)
        : this.numUploads > 0 &&
          (this.timeout = Math.ceil((this.timeout * this.numUploads) / (this.numUploads + 1)));
  }
  getTimeout() {
    return this.timeout;
  }
}
class qu {
  constructor(A) {
    (this.channel = A), (this.callbacks = { success: null, error: null }), (this.log = A.log);
  }
  on(A, e) {
    return (
      "function" != typeof e
        ? this.log.warn("callback is not a function")
        : A in this.callbacks
          ? (this.log.debug(`registering callback for event ${A}`), (this.callbacks[A] = e))
          : this.log.warn(`event ${A}is not supported`),
      this
    );
  }
  off(A) {
    return (
      A in this.callbacks
        ? (this.callbacks[A] = null)
        : this.log.error(`event ${A}is not supported`),
      this
    );
  }
  run() {
    return this.log.error("Not implemented"), this;
  }
  cancel() {
    return this.id && this.channel.sendCommandCancel(this.id), this;
  }
  trigger(A) {
    const e = Array.prototype.slice.call(arguments, 1);
    this.log.debug(`Triggering event ${A} with parameters ${e}`),
      "function" == typeof this.callbacks[A] && this.callbacks[A].apply(this, e);
  }
}
class Ju extends qu {
  constructor(A, e) {
    if (
      (super(A),
      (this.log = A.log),
      (this.paramErrors = null),
      "string" != typeof e && !(e instanceof String))
    )
      return this.log.error(`Invalid path ${e}`), void (this.paramErrors = `Invalid path ${e}`);
    (this.path = e), (this.callbacks.newItems = null);
  }
  run() {
    return (
      null === this.paramErrors
        ? (this.channel.abortCurrentListRequest(),
          (this.id = this.channel.requestCommand(this)),
          (this.channel.currentListRequestId = this.id),
          this.log.debug(`Requesting list for folder ${this.path} with id ${this.id}`),
          this.channel.sendList(this.id, this.path))
        : this.trigger("error", { message: this.paramErrors }),
      this
    );
  }
}
class ju extends qu {
  constructor(A, e) {
    if (
      (super(A),
      (this.paramErrors = null),
      (this.log = A.log),
      "string" != typeof e && !(e instanceof String))
    )
      return this.log.error(`Invalid path ${e}`), void (this.paramErrors = `Invalid path ${e}`);
    this.path = e;
  }
  run() {
    return (
      null === this.paramErrors
        ? ((this.id = this.channel.requestCommand(this)),
          this.log.debug(`Requesting mkdir for folder ${this.path} with id ${this.id}`),
          this.channel.createFolder(this.id, this.path))
        : this.trigger("error", { message: this.paramErrors }),
      this
    );
  }
}
class Wu extends qu {
  constructor(A, e, t) {
    if (
      (super(A),
      (this.paramErrors = null),
      (this.log = A.log),
      "string" != typeof e && !(e instanceof String))
    )
      return this.log.error(`Invalid path ${e}`), void (this.paramErrors = `Invalid path ${e}`);
    (this.path = e), (this.folder = t);
  }
  run() {
    return (
      null === this.paramErrors
        ? ((this.id = this.channel.requestCommand(this)),
          this.log.debug(`Requesting rm for path ${this.path} with id ${this.id}`),
          this.folder
            ? this.channel.deleteDirectory(this.id, this.path)
            : this.channel.deleteFile(this.id, this.path))
        : this.trigger("error", { message: this.paramErrors }),
      this
    );
  }
}
class Vu extends qu {
  constructor(A, e, t, i) {
    return (
      super(A),
      (this.paramErrors = null),
      (this.log = A.log),
      "string" == typeof e || e instanceof String
        ? "string" == typeof t || t instanceof String
          ? e.indexOf("..") >= 0 || t.indexOf("..") >= 0
            ? (this.log.error('Rename command cannot contain ".."'),
              void (this.paramErrors = 'Rename command cannot contain ".."'))
            : ((this.src = e), (this.dest = t), void (this.folder = i))
          : (this.log.error(`Invalid destination path ${t}`),
            void (this.paramErrors = `Invalid destination path ${t}`))
        : (this.log.error(`Invalid source path ${e}`),
          void (this.paramErrors = `Invalid source path ${e}`))
    );
  }
  run() {
    return (
      null === this.paramErrors
        ? ((this.id = this.channel.requestCommand(this)),
          this.log.debug(
            `Requesting rename from path ${this.src} to ${this.dest} with id ${this.id}`
          ),
          this.folder
            ? this.channel.moveDirectory(this.id, this.src, this.dest)
            : this.channel.moveFile(this.id, this.src, this.dest))
        : this.trigger("error", { message: this.paramErrors }),
      this
    );
  }
}
class _u extends qu {
  constructor(A, e) {
    if (
      (super(A),
      (this.paramErrors = null),
      (this.log = A.log),
      "string" != typeof e && !(e instanceof String))
    )
      return this.log.error(`Invalid path ${e}`), void (this.paramErrors = `Invalid path ${e}`);
    this.path = e;
  }
  run() {
    return (
      null === this.paramErrors
        ? ((this.id = this.channel.requestCommand(this)),
          this.log.debug(`Requesting download of path ${this.path} with id ${this.id}`),
          this.channel.sendDownloadRequest(this.id, this.path))
        : this.trigger("error", { message: this.paramErrors }),
      this
    );
  }
}
const Xu = Hu.filestorage;
class zu {
  constructor(A, e, t, i, n) {
    (this.file = e),
      (this.fullpath = t),
      (this.requestId = A),
      (this.reader = new FileReader()),
      (this.cancelled = !1),
      (this.done = !1),
      (this.file_channel = i),
      (this.onprogress = n),
      (this.loadNextChunkTime = 0),
      (this.outstandingAck = 0),
      (this.log = i.log),
      (this.filename = e.name),
      (this.index = -1),
      (this.reader.onload = (A) => {
        let e, t, i;
        this.done
          ? this.log.warn("onload on an already done uploader")
          : this.cancelled
            ? this.handleCancel()
            : ((e = A.target.result),
              e && e.byteLength > 0
                ? ((t = this.file.size),
                  this.log.debug(
                    `Uploading chunk of ${this.file.name}(id: ${this.requestId}, sent: ${this.index}/${t} bytes, chunk: ${e.byteLength}, buffered amount: ${this.file_channel.getBufferedAmount()})`
                  ),
                  this.outstandingAck++,
                  this.file_channel.sendTransferChunk(this.requestId, e),
                  this.file_channel.isTransferAckSupported ||
                    "function" != typeof this.onprogress ||
                    this.onprogress(this.index, t),
                  (this.index += e.byteLength),
                  this.index >= t
                    ? this.handleEndOfFile()
                    : ((i = Math.floor(
                        this.file_channel.uploadTimer.getTimeout() -
                          performance.now() +
                          this.loadNextChunkTime
                      )),
                      (i = Math.max(0, i)),
                      this.log.debug(
                        `Calling load next chunk  with timeout of ${i} timer timeout is ${this.file_channel.uploadTimer.getTimeout()} and load chunk and send took ${performance.now() - this.loadNextChunkTime} ms`
                      ),
                      setTimeout(() => this.loadNextChunk(), i)))
                : 0 === this.index
                  ? ("function" == typeof this.onprogress && this.onprogress(0, 0),
                    this.handleEndOfFile())
                  : this.handleError("File deleted while reading"));
      }),
      (this.reader.onerror = (A) => {
        let e;
        switch (A.target.error.code) {
          case A.target.error.NOT_FOUND_ERR:
            e = "File not found";
            break;
          case A.target.error.NOT_READABLE_ERR:
            e = "File could not be read";
            break;
          case A.target.error.ABORT_ERR:
            e = "Read operation was cancelled";
            break;
          case A.target.error.SECURITY_ERR:
            e = "Security restrictions prevented the script from reading the file";
            break;
          default:
            e = "Unknown error";
        }
        this.handleError(e);
      });
  }
  handleError(A) {
    this.log.warn(`Error reading the file ${this.filename}: ${A}`),
      this.index >= 0 &&
        this.file_channel.sendTransferEnd(this.requestId, Xu.TransferEnd.TerminationReason.ERROR),
      this.file_channel.uploadTimer.removeUpload(),
      (this.done = !0);
  }
  handleCancel() {
    this.log.debug(`The upload of file ${this.filename} has been cancelled.`),
      this.file_channel.uploadTimer.removeUpload(),
      (this.done = !0);
  }
  handleEndOfFile() {
    this.log.debug("Sending transfer end message (reason: COMPLETED)"),
      this.file_channel.sendTransferEnd(this.requestId, Xu.TransferEnd.TerminationReason.COMPLETED),
      this.file_channel.uploadTimer.removeUpload(),
      (this.done = !0);
  }
  loadNextChunk() {
    let A, e, t;
    if (
      ((A = Math.min(this.index + this.file_channel.uploadTimer.chunk_size, this.file.size)),
      this.log.debug(`Load next chunk (start: ${this.index}, end: ${A})`),
      this.done)
    )
      this.log.warn("loadNextChunk on an already done uploader");
    else if (this.cancelled) this.handleCancel();
    else {
      if (((t = this.file_channel.getTotalOutstandingAcks()), t > 3))
        return (
          this.log.debug(`Load next chunk skipped: ${t} outstanding ack`),
          (e = Math.floor(this.file_channel.uploadTimer.getTimeout())),
          (e = Math.max(0, e)),
          void setTimeout(() => this.loadNextChunk(), e)
        );
      try {
        (this.loadNextChunkTime = performance.now()),
          this.reader.readAsArrayBuffer(this.file.slice(this.index, A));
      } catch (A) {
        this.handleError(A.message);
      }
    }
  }
  cancel() {
    this.done
      ? this.log.debug("Ignore cancel since the uploader is already done")
      : (this.file_channel.uploadTimer.removeUpload(), (this.cancelled = !0));
  }
  upload() {
    this.index < 0 &&
      !this.cancelled &&
      ((this.index = 0), this.file_channel.uploadTimer.addUpload(), this.loadNextChunk());
  }
}
class Zu extends qu {
  constructor(A, e, t) {
    super(A),
      (this.paramErrors = null),
      (this.file = e),
      (this.dir = t),
      (this.callbacks.progress = null),
      (this.chunkedUploader = null),
      (this.log = A.log);
  }
  run() {
    const A = `${this.dir}/${this.file.name}`;
    return (
      (this.id = this.channel.requestCommand(this)),
      this.log.debug(`Requesting upload of file ${this.file.name} into ${A} with id ${this.id}`),
      (this.chunkedUploader = new zu(this.id, this.file, A, this.channel, (A, e) => {
        this.trigger("progress", A, e);
      })),
      this.channel.sendUploadRequest(A, this.file.size, this.id),
      this
    );
  }
  cancel() {
    return (
      this.id &&
        this.chunkedUploader &&
        (this.log.debug(`Cancelling upload of file ${this.file.name} with id ${this.id}`),
        this.chunkedUploader.cancel(),
        this.channel.sendCommandCancel(this.id)),
      this
    );
  }
}
class $u extends qu {
  constructor(A, e, t) {
    super(A),
      (this.listFiles = [...e].map((A) => A.webkitGetAsEntry() || A.getAsEntry())),
      (this.destinationDir = t),
      (this.log = A.log),
      (this.notification = null),
      (this.paramErrors = null),
      (this.callbacks.progress = null),
      (this.uploadedFiles = 0),
      (this.uploadedDirectories = 0),
      (this.totalFiles = 0),
      (this.totalDirectories = 0),
      (this.bytesUploaded = 0),
      (this.totalBytes = 0),
      (this.totalHiddenFiles = 0),
      (this.commandsQueue = []),
      (this.commandsInExecution = new Set()),
      (this.partialUploadSizeForCommand = new Map()),
      (this.cancelled = !1);
  }
  run() {
    return this.cancelled
      ? (this.log.warn("UploadFilesCommand can't be run as it has been already cancelled"), this)
      : ((this.id = this.channel.requestCommand(this)),
        Promise.all(this.listFiles.map((A) => tC(A, this.log, this.channel.serverOS))).then((A) => {
          for (const e of A)
            (this.totalDirectories += e.directories),
              (this.totalFiles += e.files),
              (this.totalBytes += e.bytes);
          if (0 !== this.totalFiles || 0 !== this.totalDirectories) {
            this.log.debug(
              `Requesting upload of ${this.totalFiles} files, total size ${this.totalBytes} bytes. Into ${this.destinationDir} with id ${this.id}`
            );
            for (const A of this.listFiles)
              AC.call(this, A, this.destinationDir, this.channel.serverOS);
            this.log.info(
              `Uploaded ${this.totalFiles} files, (${this.totalHiddenFiles} skipped because hidden)`
            );
          } else this.trigger("error", { message: "0 files selected for upload" });
        }),
        this);
  }
  cancel() {
    if (this.id && !this.cancelled) {
      (this.cancelled = !0),
        this.log.debug(`Cancelling upload files with id ${this.id}`),
        this.channel.sendCommandCancel(this.id);
      for (const A of this.commandsInExecution)
        this.channel.sendCommandCancel(A), this.commandsInExecution.delete(A);
      this.commandsInExecution.commandsQueue = [];
    }
    return this;
  }
}
function AC(A, e) {
  if (this.cancelled)
    this.log.debug(`Ignoring ${A.name} upload as its UploadFilesCommand has been cancelled`);
  else {
    if (oC(A.name, this.channel.serverOS))
      return (
        this.log.debug(`File ${A.name} was not uploaded because it is hidden`),
        void this.totalHiddenFiles++
      );
    if (A.isDirectory) {
      const t = `${e}/${A.name}`,
        i = new ju(this.channel, t)
          .on("success", () => {
            if (this.cancelled)
              return void this.log.debug(
                `Ignoring ${A.name} upload success event as its UploadFilesCommand has been cancelled`
              );
            (this.uploadedDirectory += 1),
              this.commandsInExecution.delete(i.id),
              this.trigger(
                "progress",
                this.bytesUploaded,
                this.totalBytes,
                this.uploadedFiles,
                this.totalFiles,
                this.uploadedDirectories,
                this.totalDirectories,
                { destinationFolder: e, isDirectory: !0 }
              );
            const n = this;
            iC(A, this.log).then((A) => {
              for (const e of A) AC.call(n, e, t);
            }),
              eC.call(this);
          })
          .on("error", (e) => {
            this.cancelled
              ? this.log.debug(
                  `Ignoring ${A.name} directory upload error event as its UploadFilesCommand has been cancelled`
                )
              : (this.commandsInExecution.delete(i.id),
                this.trigger("error", e),
                this.log.debug(
                  `Cancelling upload files command as an error occurred while uploading "${A.name}" directory`
                ),
                this.cancel());
          });
      this.commandsQueue.push(i), eC.call(this);
    } else
      A.isFile
        ? A.file(
            (t) => {
              if (this.cancelled)
                return void this.log.debug(
                  `Ignoring ${A.name} directory upload error event as its UploadFilesCommand has been cancelled`
                );
              const i = this,
                n = new Zu(this.channel, t, e)
                  .on("success", () => {
                    if (i.cancelled)
                      return void i.log.debug(
                        `Ignoring ${A.name} file upload success event as its UploadFilesCommand has been cancelled`
                      );
                    i.uploadedFiles += 1;
                    const o = i.partialUploadSizeForCommand.get(n.id);
                    (i.bytesUploaded += t.size - o),
                      i.trigger(
                        "progress",
                        i.bytesUploaded,
                        i.totalBytes,
                        i.uploadedFiles,
                        i.totalFiles,
                        this.uploadedDirectories,
                        i.totalDirectories,
                        { destinationFolder: e, isDirectory: !1 }
                      ),
                      i.commandsInExecution.delete(n.id),
                      i.uploadedFiles === this.totalFiles ? i.trigger("success") : eC.call(this);
                  })
                  .on("error", (e) => {
                    this.cancelled
                      ? this.log.debug(
                          `Ignoring ${A.name} file upload error event as its UploadFilesCommand has been cancelled`
                        )
                      : (i.commandsInExecution.delete(n.id),
                        i.trigger("error", e),
                        this.log.debug(
                          `Cancelling upload files command as an error occurred while uploading "${A.name}" file`
                        ),
                        this.cancel());
                  })
                  .on("progress", (t, o) => {
                    if (this.cancelled)
                      return void this.log.debug(
                        `Ignoring ${A.name} file upload progress event as its UploadFilesCommand has been cancelled`
                      );
                    const r = i.partialUploadSizeForCommand.get(n.id);
                    (i.bytesUploaded += t - (void 0 !== r ? r : 0)),
                      i.partialUploadSizeForCommand.set(n.id, t),
                      i.trigger(
                        "progress",
                        i.bytesUploaded,
                        i.totalBytes,
                        i.uploadedFiles,
                        i.totalFiles,
                        i.uploadedDirectories,
                        i.totalDirectories,
                        { destinationFolder: e, isDirectory: !1 }
                      );
                  });
              this.commandsQueue.push(n), eC.call(this);
            },
            () => this.log.warn(`Failed to retrieve file: ${A.name}`)
          )
        : this.log.warn(`Unsupported file system entry ${A.name}`);
  }
}
function eC() {
  if (this.cancelled)
    return void this.log.debug(
      "Ignoring runCommands call as this UploadFilesCommand has been cancelled"
    );
  if (this.commandsInExecution.size >= 5 || 0 === this.commandsQueue.length) return;
  const A = this.commandsQueue.pop();
  A.run(), this.commandsInExecution.add(A.id);
}
async function tC(A, e, t) {
  const i = { directories: 0, files: 0, bytes: 0 };
  if (oC(A.name, t)) return i;
  if (A.isDirectory) {
    i.directories += 1;
    for (const n of await iC(A, e)) {
      const A = await tC(n, e, t);
      (i.directories += A.directories), (i.files += A.files), (i.bytes += A.bytes);
    }
  } else if (A.isFile) {
    let t = null;
    try {
      t = await ((n = A),
      new Promise((A, e) => {
        const t = (e) => {
            A(e);
          },
          i = (A) => {
            e(A);
          };
        n.file(t, i);
      }));
    } catch (A) {
      e.error(A);
    }
    t && ((i.bytes += t.size), i.files++);
  } else e.warn(`Unsupported file system entry ${A.name}`);
  var n;
  return i;
}
async function iC(A, e) {
  const t = A.createReader(),
    i = [];
  let n = await nC(t, e);
  for (; 0 !== n.length; ) i.push(...n), (n = await nC(t, e));
  return i;
}
function nC(A, e) {
  return new Promise((t, i) => {
    A.readEntries(
      (A) => {
        t(A);
      },
      (A) => {
        e.error(A), t([]);
      }
    );
  });
}
function oC(A, e) {
  return A.startsWith(".") && (!e.includes("Windows") || !Br());
}
const rC = { major: 1, minor: 2 },
  sC = Hu.filestorage,
  aC = (A) => Do(sC.ClientMessage, A);
var gC = { exports: {} };
!(function (e) {
  var t = {
      major: 0,
      minor: 4,
      patch: 4,
      buildNumber: 0,
      gitHash: "fe0b284ac3bf40c3533295a35085ba25a9832c38",
      versionStr: "0.4.4+build.0"
    },
    i =
      "undefined" != typeof globalThis
        ? globalThis
        : "undefined" != typeof window
          ? window
          : void 0 !== A
            ? A
            : "undefined" != typeof self
              ? self
              : {};
  function n(A) {
    return A && A.__esModule && Object.prototype.hasOwnProperty.call(A, "default") ? A.default : A;
  }
  var o = { exports: {} };
  !(function (A) {
    var e, t;
    (e = i),
      (t = function () {
        var A = function () {},
          e = "undefined",
          t =
            typeof window !== e &&
            typeof window.navigator !== e &&
            /Trident\/|MSIE /.test(window.navigator.userAgent),
          i = ["trace", "debug", "info", "warn", "error"],
          n = {},
          o = null;
        function r(A, e) {
          var t = A[e];
          if ("function" == typeof t.bind) return t.bind(A);
          try {
            return Function.prototype.bind.call(t, A);
          } catch (e) {
            return function () {
              return Function.prototype.apply.apply(t, [A, arguments]);
            };
          }
        }
        function s() {
          console.log &&
            (console.log.apply
              ? console.log.apply(console, arguments)
              : Function.prototype.apply.apply(console.log, [console, arguments])),
            console.trace && console.trace();
        }
        function a() {
          for (var t = this.getLevel(), n = 0; n < i.length; n++) {
            var o = i[n];
            this[o] = n < t ? A : this.methodFactory(o, t, this.name);
          }
          if (((this.log = this.debug), typeof console === e && t < this.levels.SILENT))
            return "No console available for logging";
        }
        function g(A) {
          return function () {
            typeof console !== e && (a.call(this), this[A].apply(this, arguments));
          };
        }
        function c(i, n, o) {
          return (
            (function (i) {
              return (
                "debug" === i && (i = "log"),
                typeof console !== e &&
                  ("trace" === i && t
                    ? s
                    : void 0 !== console[i]
                      ? r(console, i)
                      : void 0 !== console.log
                        ? r(console, "log")
                        : A)
              );
            })(i) || g.apply(this, arguments)
          );
        }
        function I(A, t) {
          var r,
            s,
            g,
            I = this,
            l = "loglevel";
          function d() {
            var A;
            if (typeof window !== e && l) {
              try {
                A = window.localStorage[l];
              } catch (A) {}
              if (typeof A === e)
                try {
                  var t = window.document.cookie,
                    i = encodeURIComponent(l),
                    n = t.indexOf(i + "=");
                  -1 !== n && (A = /^([^;]+)/.exec(t.slice(n + i.length + 1))[1]);
                } catch (A) {}
              return void 0 === I.levels[A] && (A = void 0), A;
            }
          }
          function u(A) {
            var e = A;
            if (
              ("string" == typeof e &&
                void 0 !== I.levels[e.toUpperCase()] &&
                (e = I.levels[e.toUpperCase()]),
              "number" == typeof e && e >= 0 && e <= I.levels.SILENT)
            )
              return e;
            throw new TypeError("log.setLevel() called with invalid level: " + A);
          }
          "string" == typeof A ? (l += ":" + A) : "symbol" == typeof A && (l = void 0),
            (I.name = A),
            (I.levels = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 5 }),
            (I.methodFactory = t || c),
            (I.getLevel = function () {
              return null != g ? g : null != s ? s : r;
            }),
            (I.setLevel = function (A, t) {
              return (
                (g = u(A)),
                !1 !== t &&
                  (function (A) {
                    var t = (i[A] || "silent").toUpperCase();
                    if (typeof window !== e && l) {
                      try {
                        return void (window.localStorage[l] = t);
                      } catch (A) {}
                      try {
                        window.document.cookie = encodeURIComponent(l) + "=" + t + ";";
                      } catch (A) {}
                    }
                  })(g),
                a.call(I)
              );
            }),
            (I.setDefaultLevel = function (A) {
              (s = u(A)), d() || I.setLevel(A, !1);
            }),
            (I.resetLevel = function () {
              (g = null),
                (function () {
                  if (typeof window !== e && l) {
                    try {
                      window.localStorage.removeItem(l);
                    } catch (A) {}
                    try {
                      window.document.cookie =
                        encodeURIComponent(l) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
                    } catch (A) {}
                  }
                })(),
                a.call(I);
            }),
            (I.enableAll = function (A) {
              I.setLevel(I.levels.TRACE, A);
            }),
            (I.disableAll = function (A) {
              I.setLevel(I.levels.SILENT, A);
            }),
            (I.rebuild = function () {
              if ((o !== I && (r = u(o.getLevel())), a.call(I), o === I))
                for (var A in n) n[A].rebuild();
            }),
            (r = u(o ? o.getLevel() : "WARN"));
          var C = d();
          null != C && (g = u(C)), a.call(I);
        }
        (o = new I()).getLogger = function (A) {
          if (("symbol" != typeof A && "string" != typeof A) || "" === A)
            throw new TypeError("You must supply a name when creating a logger.");
          var e = n[A];
          return e || (e = n[A] = new I(A, o.methodFactory)), e;
        };
        var l = typeof window !== e ? window.log : void 0;
        return (
          (o.noConflict = function () {
            return typeof window !== e && window.log === o && (window.log = l), o;
          }),
          (o.getLoggers = function () {
            return n;
          }),
          (o.default = o),
          o
        );
      }),
      A.exports ? (A.exports = t()) : (e.log = t());
  })(o);
  var r = n(o.exports);
  const s = Object.freeze({
      HELLO_API_NAME: "hello",
      GETUSERMEDIA_API_NAME: "navigator.mediaDevices.getUserMedia",
      ENUMERATEDEVICES_API_NAME: "navigator.mediaDevices.enumerateDevices",
      ADD_MEDIADEVICES_EVENT_LISTENER: "navigator.mediaDevices.addEventListener",
      GENERATE_CERTIFICATE_API_NAME: "RTCPeerConnection.generateCertificate",
      NEWRTCPEERCONNECTION_API_NAME: "new.RTCPeerConnection",
      PC_GET_CONFIGURATION: "pcs.getConfiguration",
      NEW_AUDIO_CONTEXT: "new.AudioContext",
      CREATE_WORKER: "new.Worker",
      WORKER_POST_MESSAGE: "workers.postMessage",
      WORKER_TERMINATE: "workers.terminate",
      AUDIO_CTX_CREATE_AUDIO_NODE: "audioContexts.createAudioNode",
      AUDIO_CTX_CLOSE: "audioContexts.close",
      AUDIO_NODE_CONNECT: "audioNodes.connect",
      AUDIO_NODE_DISCONNECT: "audioNodes.disconnect",
      AUDIO_PARAM_SET_VALUE_AT_TIME: "audioParams.setValueAtTime",
      AUDIO_PARAM_SET_RAMP_TO_VALUE_AT_TIME: "audioParams.linearRampToValueAtTime",
      AUDIO_NODE_SET_TYPE: "audioNodes.setType",
      AUDIO_NODE_START: "audioNodes.start",
      AUDIO_NODE_STOP: "audioNodes.stop",
      PC_CLOSE_API_NAME: "pcs.close",
      ADDSTREAM_API_NAME: "pcs.addStream",
      STREAM_REMOVE_TRACK: "streams.removeTrack",
      STREAM_ADD_TRACK: "streams.addTrack",
      GET_STATS_API_NAME: "pcs.getStats",
      CREATE_OFFER_API_NAME: "pcs.createOffer",
      SET_LOCAL_DESCRIPTION_API_NAME: "pcs.setLocalDescription",
      ADD_PC_EVENT_LISTENER: "pcs.addEventListener",
      ADD_TRACK_EVENT_LISTENER: "tracks.addEventListener",
      ADD_DTMF_EVENT_LISTENER: "dtmfs.addEventListener",
      ADD_WORKER_EVENT_LISTENER: "workers.addEventListener",
      SET_REMOTE_DESCRIPTION_API_NAME: "pcs.setRemoteDescription",
      ADD_ICE_CANDIDATE_API_NAME: "pcs.addIceCandidate",
      CREATE_MEDIA_ELEMENT_API_NAME: "document.createElement",
      MEDIA_ELEMENT_SET_SINK_ID_API_NAME: "mediaElements.setSinkId",
      MEDIA_ELEMENT_REMOVE: "mediaElements.remove",
      CREATE_ANSWER_API_NAME: "pcs.createAnswer",
      UNLOAD_EVENT_NAME: "unload",
      TOGGLE_TRACK_ENABLED_API_NAME: "tracks.enabled",
      TRACK_STOP_API_NAME: "tracks.stop",
      TRACK_GET_SETTINGS: "tracks.getSettings",
      GET_RECEIVERS_API_NAME: "pcs.getReceivers",
      ADD_TRACK_API_NAME: "pcs.addTrack",
      GET_SENDERS_API_NAME: "pcs.getSenders",
      GET_SENDER_STATS_API_NAME: "senders.getStats",
      GET_RECEIVER_STATS_API_NAME: "receivers.getStats",
      SET_MEDIA_SRC_OBJ_API_NAME: "mediaElements.srcObject",
      SET_MEDIA_HIDDEN_API_NAME: "mediaElements.hidden",
      SET_MEDIA_VOLUME_API_NAME: "mediaElements.volume",
      MEDIA_ELEMENT_PLAY_API_NAME: "mediaElements.play",
      MEDIA_ELEMENT_PAUSE_API_NAME: "mediaElements.pause",
      MEDIA_ELEMENT_MUTED: "mediaElements.muted",
      ADD_TRANSCEIVER_API_NAME: "pcs.addTransceiver",
      GET_TRANSCEIVERS_API_NAME: "pcs.getTransceivers",
      TRANSCEIVER_SET_CODEC_PREFS: "transceivers.setCodecPreferences",
      REPLACE_SENDER_TRACK_API_NAME: "senders.replaceTrack",
      PC_REMOVE_TRACK_API_NAME: "pcs.removeTrack",
      INSERT_DTMF_API_NAME: "dtmfSenders.insertDTMF",
      SENDER_CREATE_ENCODED_STREAMS: "senders.createEncodedStreams",
      RECEIVER_CREATE_ENCODED_STREAMS: "receivers.createEncodedStreams"
    }),
    a = Object.freeze({
      SIG_STATE_CHANGE: "signalingstatechange",
      TRACK: "track",
      CONN_STATE_CHANGE: "connectionstatechange",
      ICE_CONN_STATE_CHANGE: "iceconnectionstatechange",
      ICE_GATHER_STATE_CHANGE: "icegatheringstatechange",
      ICE_CANDIDATE: "icecandidate",
      NEGOTIATION_NEEDED: "negotiationneeded"
    }),
    g = Object.freeze({ ENDED: "ended", MUTE: "mute", UNMUTE: "unmute" }),
    c = Object.freeze({ TONECHANGE: "tonechange" }),
    I = Object.freeze({ ERROR: "error", MESSAGE: "message", MESSAGE_ERROR: "messageerror" }),
    l = Object.freeze({ DEVICECHANGE: "devicechange" }),
    d = Object.freeze({ NEW: "new", AVAILABLE: "available", UNAVAILABLE: "unavailable" }),
    u = Object.freeze({
      BETA_CHROME: "epghbidlkiikjcmmloiahljfmkgbjgjb",
      CHROME: "diilpfplcnhehakckkpmcmibmhbingnd",
      EDGE: "kjbbkjjiecchbcdoollhgffghfjnbhef"
    });
  for (
    var C = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
      B = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256),
      Q = 0;
    Q < 64;
    Q++
  )
    B[C.charCodeAt(Q)] = Q;
  var E = function (A) {
      var e,
        t = new Uint8Array(A),
        i = t.length,
        n = "";
      for (e = 0; e < i; e += 3)
        (n += C[t[e] >> 2]),
          (n += C[((3 & t[e]) << 4) | (t[e + 1] >> 4)]),
          (n += C[((15 & t[e + 1]) << 2) | (t[e + 2] >> 6)]),
          (n += C[63 & t[e + 2]]);
      return (
        i % 3 == 2
          ? (n = n.substring(0, n.length - 1) + "=")
          : i % 3 == 1 && (n = n.substring(0, n.length - 2) + "=="),
        n
      );
    },
    h = function (A) {
      var e,
        t,
        i,
        n,
        o,
        r = 0.75 * A.length,
        s = A.length,
        a = 0;
      "=" === A[A.length - 1] && (r--, "=" === A[A.length - 2] && r--);
      var g = new ArrayBuffer(r),
        c = new Uint8Array(g);
      for (e = 0; e < s; e += 4)
        (t = B[A.charCodeAt(e)]),
          (i = B[A.charCodeAt(e + 1)]),
          (n = B[A.charCodeAt(e + 2)]),
          (o = B[A.charCodeAt(e + 3)]),
          (c[a++] = (t << 2) | (i >> 4)),
          (c[a++] = ((15 & i) << 4) | (n >> 2)),
          (c[a++] = ((3 & n) << 6) | (63 & o));
      return g;
    },
    p = { exports: {} };
  /*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */ !(function (A, e) {
    !(function (A) {
      function e(A) {
        let e = A.length;
        for (; --e >= 0; ) A[e] = 0;
      }
      const t = 256,
        i = 286,
        n = 30,
        o = 15,
        r = new Uint8Array([
          0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0
        ]),
        s = new Uint8Array([
          0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12,
          13, 13
        ]),
        a = new Uint8Array([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]),
        g = new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
        c = new Array(576);
      e(c);
      const I = new Array(60);
      e(I);
      const l = new Array(512);
      e(l);
      const d = new Array(256);
      e(d);
      const u = new Array(29);
      e(u);
      const C = new Array(n);
      function B(A, e, t, i, n) {
        (this.static_tree = A),
          (this.extra_bits = e),
          (this.extra_base = t),
          (this.elems = i),
          (this.max_length = n),
          (this.has_stree = A && A.length);
      }
      let Q, E, h;
      function p(A, e) {
        (this.dyn_tree = A), (this.max_code = 0), (this.stat_desc = e);
      }
      e(C);
      const f = (A) => (A < 256 ? l[A] : l[256 + (A >>> 7)]),
        m = (A, e) => {
          (A.pending_buf[A.pending++] = 255 & e), (A.pending_buf[A.pending++] = (e >>> 8) & 255);
        },
        y = (A, e, t) => {
          A.bi_valid > 16 - t
            ? ((A.bi_buf |= (e << A.bi_valid) & 65535),
              m(A, A.bi_buf),
              (A.bi_buf = e >> (16 - A.bi_valid)),
              (A.bi_valid += t - 16))
            : ((A.bi_buf |= (e << A.bi_valid) & 65535), (A.bi_valid += t));
        },
        D = (A, e, t) => {
          y(A, t[2 * e], t[2 * e + 1]);
        },
        w = (A, e) => {
          let t = 0;
          do {
            (t |= 1 & A), (A >>>= 1), (t <<= 1);
          } while (--e > 0);
          return t >>> 1;
        },
        F = (A, e, t) => {
          const i = new Array(16);
          let n,
            r,
            s = 0;
          for (n = 1; n <= o; n++) (s = (s + t[n - 1]) << 1), (i[n] = s);
          for (r = 0; r <= e; r++) {
            let e = A[2 * r + 1];
            0 !== e && (A[2 * r] = w(i[e]++, e));
          }
        },
        b = (A) => {
          let e;
          for (e = 0; e < i; e++) A.dyn_ltree[2 * e] = 0;
          for (e = 0; e < n; e++) A.dyn_dtree[2 * e] = 0;
          for (e = 0; e < 19; e++) A.bl_tree[2 * e] = 0;
          (A.dyn_ltree[512] = 1), (A.opt_len = A.static_len = 0), (A.sym_next = A.matches = 0);
        },
        U = (A) => {
          A.bi_valid > 8
            ? m(A, A.bi_buf)
            : A.bi_valid > 0 && (A.pending_buf[A.pending++] = A.bi_buf),
            (A.bi_buf = 0),
            (A.bi_valid = 0);
        },
        S = (A, e, t, i) => {
          const n = 2 * e,
            o = 2 * t;
          return A[n] < A[o] || (A[n] === A[o] && i[e] <= i[t]);
        },
        R = (A, e, t) => {
          const i = A.heap[t];
          let n = t << 1;
          for (
            ;
            n <= A.heap_len &&
            (n < A.heap_len && S(e, A.heap[n + 1], A.heap[n], A.depth) && n++,
            !S(e, i, A.heap[n], A.depth));

          )
            (A.heap[t] = A.heap[n]), (t = n), (n <<= 1);
          A.heap[t] = i;
        },
        v = (A, e, i) => {
          let n,
            o,
            a,
            g,
            c = 0;
          if (0 !== A.sym_next)
            do {
              (n = 255 & A.pending_buf[A.sym_buf + c++]),
                (n += (255 & A.pending_buf[A.sym_buf + c++]) << 8),
                (o = A.pending_buf[A.sym_buf + c++]),
                0 === n
                  ? D(A, o, e)
                  : ((a = d[o]),
                    D(A, a + t + 1, e),
                    (g = r[a]),
                    0 !== g && ((o -= u[a]), y(A, o, g)),
                    n--,
                    (a = f(n)),
                    D(A, a, i),
                    (g = s[a]),
                    0 !== g && ((n -= C[a]), y(A, n, g)));
            } while (c < A.sym_next);
          D(A, 256, e);
        },
        x = (A, e) => {
          const t = e.dyn_tree,
            i = e.stat_desc.static_tree,
            n = e.stat_desc.has_stree,
            r = e.stat_desc.elems;
          let s,
            a,
            g,
            c = -1;
          for (A.heap_len = 0, A.heap_max = 573, s = 0; s < r; s++)
            0 !== t[2 * s]
              ? ((A.heap[++A.heap_len] = c = s), (A.depth[s] = 0))
              : (t[2 * s + 1] = 0);
          for (; A.heap_len < 2; )
            (g = A.heap[++A.heap_len] = c < 2 ? ++c : 0),
              (t[2 * g] = 1),
              (A.depth[g] = 0),
              A.opt_len--,
              n && (A.static_len -= i[2 * g + 1]);
          for (e.max_code = c, s = A.heap_len >> 1; s >= 1; s--) R(A, t, s);
          g = r;
          do {
            (s = A.heap[1]),
              (A.heap[1] = A.heap[A.heap_len--]),
              R(A, t, 1),
              (a = A.heap[1]),
              (A.heap[--A.heap_max] = s),
              (A.heap[--A.heap_max] = a),
              (t[2 * g] = t[2 * s] + t[2 * a]),
              (A.depth[g] = (A.depth[s] >= A.depth[a] ? A.depth[s] : A.depth[a]) + 1),
              (t[2 * s + 1] = t[2 * a + 1] = g),
              (A.heap[1] = g++),
              R(A, t, 1);
          } while (A.heap_len >= 2);
          (A.heap[--A.heap_max] = A.heap[1]),
            ((A, e) => {
              const t = e.dyn_tree,
                i = e.max_code,
                n = e.stat_desc.static_tree,
                r = e.stat_desc.has_stree,
                s = e.stat_desc.extra_bits,
                a = e.stat_desc.extra_base,
                g = e.stat_desc.max_length;
              let c,
                I,
                l,
                d,
                u,
                C,
                B = 0;
              for (d = 0; d <= o; d++) A.bl_count[d] = 0;
              for (t[2 * A.heap[A.heap_max] + 1] = 0, c = A.heap_max + 1; c < 573; c++)
                (I = A.heap[c]),
                  (d = t[2 * t[2 * I + 1] + 1] + 1),
                  d > g && ((d = g), B++),
                  (t[2 * I + 1] = d),
                  I > i ||
                    (A.bl_count[d]++,
                    (u = 0),
                    I >= a && (u = s[I - a]),
                    (C = t[2 * I]),
                    (A.opt_len += C * (d + u)),
                    r && (A.static_len += C * (n[2 * I + 1] + u)));
              if (0 !== B) {
                do {
                  for (d = g - 1; 0 === A.bl_count[d]; ) d--;
                  A.bl_count[d]--, (A.bl_count[d + 1] += 2), A.bl_count[g]--, (B -= 2);
                } while (B > 0);
                for (d = g; 0 !== d; d--)
                  for (I = A.bl_count[d]; 0 !== I; )
                    (l = A.heap[--c]),
                      l > i ||
                        (t[2 * l + 1] !== d &&
                          ((A.opt_len += (d - t[2 * l + 1]) * t[2 * l]), (t[2 * l + 1] = d)),
                        I--);
              }
            })(A, e),
            F(t, c, A.bl_count);
        },
        M = (A, e, t) => {
          let i,
            n,
            o = -1,
            r = e[1],
            s = 0,
            a = 7,
            g = 4;
          for (0 === r && ((a = 138), (g = 3)), e[2 * (t + 1) + 1] = 65535, i = 0; i <= t; i++)
            (n = r),
              (r = e[2 * (i + 1) + 1]),
              (++s < a && n === r) ||
                (s < g
                  ? (A.bl_tree[2 * n] += s)
                  : 0 !== n
                    ? (n !== o && A.bl_tree[2 * n]++, A.bl_tree[32]++)
                    : s <= 10
                      ? A.bl_tree[34]++
                      : A.bl_tree[36]++,
                (s = 0),
                (o = n),
                0 === r ? ((a = 138), (g = 3)) : n === r ? ((a = 6), (g = 3)) : ((a = 7), (g = 4)));
        },
        O = (A, e, t) => {
          let i,
            n,
            o = -1,
            r = e[1],
            s = 0,
            a = 7,
            g = 4;
          for (0 === r && ((a = 138), (g = 3)), i = 0; i <= t; i++)
            if (((n = r), (r = e[2 * (i + 1) + 1]), !(++s < a && n === r))) {
              if (s < g)
                do {
                  D(A, n, A.bl_tree);
                } while (0 != --s);
              else
                0 !== n
                  ? (n !== o && (D(A, n, A.bl_tree), s--), D(A, 16, A.bl_tree), y(A, s - 3, 2))
                  : s <= 10
                    ? (D(A, 17, A.bl_tree), y(A, s - 3, 3))
                    : (D(A, 18, A.bl_tree), y(A, s - 11, 7));
              (s = 0),
                (o = n),
                0 === r ? ((a = 138), (g = 3)) : n === r ? ((a = 6), (g = 3)) : ((a = 7), (g = 4));
            }
        };
      let k = !1;
      const N = (A, e, t, i) => {
        y(A, 0 + (i ? 1 : 0), 3),
          U(A),
          m(A, t),
          m(A, ~t),
          t && A.pending_buf.set(A.window.subarray(e, e + t), A.pending),
          (A.pending += t);
      };
      var K = (A, e, i, n) => {
          let o,
            r,
            s = 0;
          A.level > 0
            ? (2 === A.strm.data_type &&
                (A.strm.data_type = ((A) => {
                  let e,
                    i = 4093624447;
                  for (e = 0; e <= 31; e++, i >>>= 1)
                    if (1 & i && 0 !== A.dyn_ltree[2 * e]) return 0;
                  if (0 !== A.dyn_ltree[18] || 0 !== A.dyn_ltree[20] || 0 !== A.dyn_ltree[26])
                    return 1;
                  for (e = 32; e < t; e++) if (0 !== A.dyn_ltree[2 * e]) return 1;
                  return 0;
                })(A)),
              x(A, A.l_desc),
              x(A, A.d_desc),
              (s = ((A) => {
                let e;
                for (
                  M(A, A.dyn_ltree, A.l_desc.max_code),
                    M(A, A.dyn_dtree, A.d_desc.max_code),
                    x(A, A.bl_desc),
                    e = 18;
                  e >= 3 && 0 === A.bl_tree[2 * g[e] + 1];
                  e--
                );
                return (A.opt_len += 3 * (e + 1) + 5 + 5 + 4), e;
              })(A)),
              (o = (A.opt_len + 3 + 7) >>> 3),
              (r = (A.static_len + 3 + 7) >>> 3),
              r <= o && (o = r))
            : (o = r = i + 5),
            i + 4 <= o && -1 !== e
              ? N(A, e, i, n)
              : 4 === A.strategy || r === o
                ? (y(A, 2 + (n ? 1 : 0), 3), v(A, c, I))
                : (y(A, 4 + (n ? 1 : 0), 3),
                  ((A, e, t, i) => {
                    let n;
                    for (y(A, e - 257, 5), y(A, t - 1, 5), y(A, i - 4, 4), n = 0; n < i; n++)
                      y(A, A.bl_tree[2 * g[n] + 1], 3);
                    O(A, A.dyn_ltree, e - 1), O(A, A.dyn_dtree, t - 1);
                  })(A, A.l_desc.max_code + 1, A.d_desc.max_code + 1, s + 1),
                  v(A, A.dyn_ltree, A.dyn_dtree)),
            b(A),
            n && U(A);
        },
        L = {
          _tr_init: (A) => {
            k ||
              ((() => {
                let A, e, t, g, p;
                const f = new Array(16);
                for (t = 0, g = 0; g < 28; g++)
                  for (u[g] = t, A = 0; A < 1 << r[g]; A++) d[t++] = g;
                for (d[t - 1] = g, p = 0, g = 0; g < 16; g++)
                  for (C[g] = p, A = 0; A < 1 << s[g]; A++) l[p++] = g;
                for (p >>= 7; g < n; g++)
                  for (C[g] = p << 7, A = 0; A < 1 << (s[g] - 7); A++) l[256 + p++] = g;
                for (e = 0; e <= o; e++) f[e] = 0;
                for (A = 0; A <= 143; ) (c[2 * A + 1] = 8), A++, f[8]++;
                for (; A <= 255; ) (c[2 * A + 1] = 9), A++, f[9]++;
                for (; A <= 279; ) (c[2 * A + 1] = 7), A++, f[7]++;
                for (; A <= 287; ) (c[2 * A + 1] = 8), A++, f[8]++;
                for (F(c, 287, f), A = 0; A < n; A++) (I[2 * A + 1] = 5), (I[2 * A] = w(A, 5));
                (Q = new B(c, r, 257, i, o)),
                  (E = new B(I, s, 0, n, o)),
                  (h = new B(new Array(0), a, 0, 19, 7));
              })(),
              (k = !0)),
              (A.l_desc = new p(A.dyn_ltree, Q)),
              (A.d_desc = new p(A.dyn_dtree, E)),
              (A.bl_desc = new p(A.bl_tree, h)),
              (A.bi_buf = 0),
              (A.bi_valid = 0),
              b(A);
          },
          _tr_stored_block: N,
          _tr_flush_block: K,
          _tr_tally: (A, e, i) => (
            (A.pending_buf[A.sym_buf + A.sym_next++] = e),
            (A.pending_buf[A.sym_buf + A.sym_next++] = e >> 8),
            (A.pending_buf[A.sym_buf + A.sym_next++] = i),
            0 === e
              ? A.dyn_ltree[2 * i]++
              : (A.matches++, e--, A.dyn_ltree[2 * (d[i] + t + 1)]++, A.dyn_dtree[2 * f(e)]++),
            A.sym_next === A.sym_end
          ),
          _tr_align: (A) => {
            y(A, 2, 3),
              D(A, 256, c),
              ((A) => {
                16 === A.bi_valid
                  ? (m(A, A.bi_buf), (A.bi_buf = 0), (A.bi_valid = 0))
                  : A.bi_valid >= 8 &&
                    ((A.pending_buf[A.pending++] = 255 & A.bi_buf),
                    (A.bi_buf >>= 8),
                    (A.bi_valid -= 8));
              })(A);
          }
        },
        T = (A, e, t, i) => {
          let n = 65535 & A,
            o = (A >>> 16) & 65535,
            r = 0;
          for (; 0 !== t; ) {
            (r = t > 2e3 ? 2e3 : t), (t -= r);
            do {
              (n = (n + e[i++]) | 0), (o = (o + n) | 0);
            } while (--r);
            (n %= 65521), (o %= 65521);
          }
          return n | (o << 16);
        };
      const P = new Uint32Array(
        (() => {
          let A,
            e = [];
          for (var t = 0; t < 256; t++) {
            A = t;
            for (var i = 0; i < 8; i++) A = 1 & A ? 3988292384 ^ (A >>> 1) : A >>> 1;
            e[t] = A;
          }
          return e;
        })()
      );
      var G = (A, e, t, i) => {
          const n = P,
            o = i + t;
          A ^= -1;
          for (let t = i; t < o; t++) A = (A >>> 8) ^ n[255 & (A ^ e[t])];
          return ~A;
        },
        H = {
          2: "need dictionary",
          1: "stream end",
          0: "",
          "-1": "file error",
          "-2": "stream error",
          "-3": "data error",
          "-4": "insufficient memory",
          "-5": "buffer error",
          "-6": "incompatible version"
        },
        Y = {
          Z_NO_FLUSH: 0,
          Z_PARTIAL_FLUSH: 1,
          Z_SYNC_FLUSH: 2,
          Z_FULL_FLUSH: 3,
          Z_FINISH: 4,
          Z_BLOCK: 5,
          Z_TREES: 6,
          Z_OK: 0,
          Z_STREAM_END: 1,
          Z_NEED_DICT: 2,
          Z_ERRNO: -1,
          Z_STREAM_ERROR: -2,
          Z_DATA_ERROR: -3,
          Z_MEM_ERROR: -4,
          Z_BUF_ERROR: -5,
          Z_NO_COMPRESSION: 0,
          Z_BEST_SPEED: 1,
          Z_BEST_COMPRESSION: 9,
          Z_DEFAULT_COMPRESSION: -1,
          Z_FILTERED: 1,
          Z_HUFFMAN_ONLY: 2,
          Z_RLE: 3,
          Z_FIXED: 4,
          Z_DEFAULT_STRATEGY: 0,
          Z_BINARY: 0,
          Z_TEXT: 1,
          Z_UNKNOWN: 2,
          Z_DEFLATED: 8
        };
      const {
          _tr_init: q,
          _tr_stored_block: J,
          _tr_flush_block: j,
          _tr_tally: W,
          _tr_align: V
        } = L,
        {
          Z_NO_FLUSH: _,
          Z_PARTIAL_FLUSH: X,
          Z_FULL_FLUSH: z,
          Z_FINISH: Z,
          Z_BLOCK: $,
          Z_OK: AA,
          Z_STREAM_END: eA,
          Z_STREAM_ERROR: tA,
          Z_DATA_ERROR: iA,
          Z_BUF_ERROR: nA,
          Z_DEFAULT_COMPRESSION: oA,
          Z_FILTERED: rA,
          Z_HUFFMAN_ONLY: sA,
          Z_RLE: aA,
          Z_FIXED: gA,
          Z_DEFAULT_STRATEGY: cA,
          Z_UNKNOWN: IA,
          Z_DEFLATED: lA
        } = Y,
        dA = 258,
        uA = 262,
        CA = 42,
        BA = 113,
        QA = 666,
        EA = (A, e) => ((A.msg = H[e]), e),
        hA = (A) => 2 * A - (A > 4 ? 9 : 0),
        pA = (A) => {
          let e = A.length;
          for (; --e >= 0; ) A[e] = 0;
        },
        fA = (A) => {
          let e,
            t,
            i,
            n = A.w_size;
          (e = A.hash_size), (i = e);
          do {
            (t = A.head[--i]), (A.head[i] = t >= n ? t - n : 0);
          } while (--e);
          (e = n), (i = e);
          do {
            (t = A.prev[--i]), (A.prev[i] = t >= n ? t - n : 0);
          } while (--e);
        };
      let mA = (A, e, t) => ((e << A.hash_shift) ^ t) & A.hash_mask;
      const yA = (A) => {
          const e = A.state;
          let t = e.pending;
          t > A.avail_out && (t = A.avail_out),
            0 !== t &&
              (A.output.set(e.pending_buf.subarray(e.pending_out, e.pending_out + t), A.next_out),
              (A.next_out += t),
              (e.pending_out += t),
              (A.total_out += t),
              (A.avail_out -= t),
              (e.pending -= t),
              0 === e.pending && (e.pending_out = 0));
        },
        DA = (A, e) => {
          j(A, A.block_start >= 0 ? A.block_start : -1, A.strstart - A.block_start, e),
            (A.block_start = A.strstart),
            yA(A.strm);
        },
        wA = (A, e) => {
          A.pending_buf[A.pending++] = e;
        },
        FA = (A, e) => {
          (A.pending_buf[A.pending++] = (e >>> 8) & 255), (A.pending_buf[A.pending++] = 255 & e);
        },
        bA = (A, e, t, i) => {
          let n = A.avail_in;
          return (
            n > i && (n = i),
            0 === n
              ? 0
              : ((A.avail_in -= n),
                e.set(A.input.subarray(A.next_in, A.next_in + n), t),
                1 === A.state.wrap
                  ? (A.adler = T(A.adler, e, n, t))
                  : 2 === A.state.wrap && (A.adler = G(A.adler, e, n, t)),
                (A.next_in += n),
                (A.total_in += n),
                n)
          );
        },
        UA = (A, e) => {
          let t,
            i,
            n = A.max_chain_length,
            o = A.strstart,
            r = A.prev_length,
            s = A.nice_match;
          const a = A.strstart > A.w_size - uA ? A.strstart - (A.w_size - uA) : 0,
            g = A.window,
            c = A.w_mask,
            I = A.prev,
            l = A.strstart + dA;
          let d = g[o + r - 1],
            u = g[o + r];
          A.prev_length >= A.good_match && (n >>= 2), s > A.lookahead && (s = A.lookahead);
          do {
            if (
              ((t = e),
              g[t + r] === u && g[t + r - 1] === d && g[t] === g[o] && g[++t] === g[o + 1])
            ) {
              (o += 2), t++;
              do {} while (
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                g[++o] === g[++t] &&
                o < l
              );
              if (((i = dA - (l - o)), (o = l - dA), i > r)) {
                if (((A.match_start = e), (r = i), i >= s)) break;
                (d = g[o + r - 1]), (u = g[o + r]);
              }
            }
          } while ((e = I[e & c]) > a && 0 != --n);
          return r <= A.lookahead ? r : A.lookahead;
        },
        SA = (A) => {
          const e = A.w_size;
          let t, i, n;
          do {
            if (
              ((i = A.window_size - A.lookahead - A.strstart),
              A.strstart >= e + (e - uA) &&
                (A.window.set(A.window.subarray(e, e + e - i), 0),
                (A.match_start -= e),
                (A.strstart -= e),
                (A.block_start -= e),
                A.insert > A.strstart && (A.insert = A.strstart),
                fA(A),
                (i += e)),
              0 === A.strm.avail_in)
            )
              break;
            if (
              ((t = bA(A.strm, A.window, A.strstart + A.lookahead, i)),
              (A.lookahead += t),
              A.lookahead + A.insert >= 3)
            )
              for (
                n = A.strstart - A.insert,
                  A.ins_h = A.window[n],
                  A.ins_h = mA(A, A.ins_h, A.window[n + 1]);
                A.insert &&
                ((A.ins_h = mA(A, A.ins_h, A.window[n + 3 - 1])),
                (A.prev[n & A.w_mask] = A.head[A.ins_h]),
                (A.head[A.ins_h] = n),
                n++,
                A.insert--,
                !(A.lookahead + A.insert < 3));

              );
          } while (A.lookahead < uA && 0 !== A.strm.avail_in);
        },
        RA = (A, e) => {
          let t,
            i,
            n,
            o = A.pending_buf_size - 5 > A.w_size ? A.w_size : A.pending_buf_size - 5,
            r = 0,
            s = A.strm.avail_in;
          do {
            if (((t = 65535), (n = (A.bi_valid + 42) >> 3), A.strm.avail_out < n)) break;
            if (
              ((n = A.strm.avail_out - n),
              (i = A.strstart - A.block_start),
              t > i + A.strm.avail_in && (t = i + A.strm.avail_in),
              t > n && (t = n),
              t < o && ((0 === t && e !== Z) || e === _ || t !== i + A.strm.avail_in))
            )
              break;
            (r = e === Z && t === i + A.strm.avail_in ? 1 : 0),
              J(A, 0, 0, r),
              (A.pending_buf[A.pending - 4] = t),
              (A.pending_buf[A.pending - 3] = t >> 8),
              (A.pending_buf[A.pending - 2] = ~t),
              (A.pending_buf[A.pending - 1] = ~t >> 8),
              yA(A.strm),
              i &&
                (i > t && (i = t),
                A.strm.output.set(
                  A.window.subarray(A.block_start, A.block_start + i),
                  A.strm.next_out
                ),
                (A.strm.next_out += i),
                (A.strm.avail_out -= i),
                (A.strm.total_out += i),
                (A.block_start += i),
                (t -= i)),
              t &&
                (bA(A.strm, A.strm.output, A.strm.next_out, t),
                (A.strm.next_out += t),
                (A.strm.avail_out -= t),
                (A.strm.total_out += t));
          } while (0 === r);
          return (
            (s -= A.strm.avail_in),
            s &&
              (s >= A.w_size
                ? ((A.matches = 2),
                  A.window.set(A.strm.input.subarray(A.strm.next_in - A.w_size, A.strm.next_in), 0),
                  (A.strstart = A.w_size),
                  (A.insert = A.strstart))
                : (A.window_size - A.strstart <= s &&
                    ((A.strstart -= A.w_size),
                    A.window.set(A.window.subarray(A.w_size, A.w_size + A.strstart), 0),
                    A.matches < 2 && A.matches++,
                    A.insert > A.strstart && (A.insert = A.strstart)),
                  A.window.set(
                    A.strm.input.subarray(A.strm.next_in - s, A.strm.next_in),
                    A.strstart
                  ),
                  (A.strstart += s),
                  (A.insert += s > A.w_size - A.insert ? A.w_size - A.insert : s)),
              (A.block_start = A.strstart)),
            A.high_water < A.strstart && (A.high_water = A.strstart),
            r
              ? 4
              : e !== _ && e !== Z && 0 === A.strm.avail_in && A.strstart === A.block_start
                ? 2
                : ((n = A.window_size - A.strstart),
                  A.strm.avail_in > n &&
                    A.block_start >= A.w_size &&
                    ((A.block_start -= A.w_size),
                    (A.strstart -= A.w_size),
                    A.window.set(A.window.subarray(A.w_size, A.w_size + A.strstart), 0),
                    A.matches < 2 && A.matches++,
                    (n += A.w_size),
                    A.insert > A.strstart && (A.insert = A.strstart)),
                  n > A.strm.avail_in && (n = A.strm.avail_in),
                  n &&
                    (bA(A.strm, A.window, A.strstart, n),
                    (A.strstart += n),
                    (A.insert += n > A.w_size - A.insert ? A.w_size - A.insert : n)),
                  A.high_water < A.strstart && (A.high_water = A.strstart),
                  (n = (A.bi_valid + 42) >> 3),
                  (n = A.pending_buf_size - n > 65535 ? 65535 : A.pending_buf_size - n),
                  (o = n > A.w_size ? A.w_size : n),
                  (i = A.strstart - A.block_start),
                  (i >= o || ((i || e === Z) && e !== _ && 0 === A.strm.avail_in && i <= n)) &&
                    ((t = i > n ? n : i),
                    (r = e === Z && 0 === A.strm.avail_in && t === i ? 1 : 0),
                    J(A, A.block_start, t, r),
                    (A.block_start += t),
                    yA(A.strm)),
                  r ? 3 : 1)
          );
        },
        vA = (A, e) => {
          let t, i;
          for (;;) {
            if (A.lookahead < uA) {
              if ((SA(A), A.lookahead < uA && e === _)) return 1;
              if (0 === A.lookahead) break;
            }
            if (
              ((t = 0),
              A.lookahead >= 3 &&
                ((A.ins_h = mA(A, A.ins_h, A.window[A.strstart + 3 - 1])),
                (t = A.prev[A.strstart & A.w_mask] = A.head[A.ins_h]),
                (A.head[A.ins_h] = A.strstart)),
              0 !== t && A.strstart - t <= A.w_size - uA && (A.match_length = UA(A, t)),
              A.match_length >= 3)
            )
              if (
                ((i = W(A, A.strstart - A.match_start, A.match_length - 3)),
                (A.lookahead -= A.match_length),
                A.match_length <= A.max_lazy_match && A.lookahead >= 3)
              ) {
                A.match_length--;
                do {
                  A.strstart++,
                    (A.ins_h = mA(A, A.ins_h, A.window[A.strstart + 3 - 1])),
                    (t = A.prev[A.strstart & A.w_mask] = A.head[A.ins_h]),
                    (A.head[A.ins_h] = A.strstart);
                } while (0 != --A.match_length);
                A.strstart++;
              } else
                (A.strstart += A.match_length),
                  (A.match_length = 0),
                  (A.ins_h = A.window[A.strstart]),
                  (A.ins_h = mA(A, A.ins_h, A.window[A.strstart + 1]));
            else (i = W(A, 0, A.window[A.strstart])), A.lookahead--, A.strstart++;
            if (i && (DA(A, !1), 0 === A.strm.avail_out)) return 1;
          }
          return (
            (A.insert = A.strstart < 2 ? A.strstart : 2),
            e === Z
              ? (DA(A, !0), 0 === A.strm.avail_out ? 3 : 4)
              : A.sym_next && (DA(A, !1), 0 === A.strm.avail_out)
                ? 1
                : 2
          );
        },
        xA = (A, e) => {
          let t, i, n;
          for (;;) {
            if (A.lookahead < uA) {
              if ((SA(A), A.lookahead < uA && e === _)) return 1;
              if (0 === A.lookahead) break;
            }
            if (
              ((t = 0),
              A.lookahead >= 3 &&
                ((A.ins_h = mA(A, A.ins_h, A.window[A.strstart + 3 - 1])),
                (t = A.prev[A.strstart & A.w_mask] = A.head[A.ins_h]),
                (A.head[A.ins_h] = A.strstart)),
              (A.prev_length = A.match_length),
              (A.prev_match = A.match_start),
              (A.match_length = 2),
              0 !== t &&
                A.prev_length < A.max_lazy_match &&
                A.strstart - t <= A.w_size - uA &&
                ((A.match_length = UA(A, t)),
                A.match_length <= 5 &&
                  (A.strategy === rA ||
                    (3 === A.match_length && A.strstart - A.match_start > 4096)) &&
                  (A.match_length = 2)),
              A.prev_length >= 3 && A.match_length <= A.prev_length)
            ) {
              (n = A.strstart + A.lookahead - 3),
                (i = W(A, A.strstart - 1 - A.prev_match, A.prev_length - 3)),
                (A.lookahead -= A.prev_length - 1),
                (A.prev_length -= 2);
              do {
                ++A.strstart <= n &&
                  ((A.ins_h = mA(A, A.ins_h, A.window[A.strstart + 3 - 1])),
                  (t = A.prev[A.strstart & A.w_mask] = A.head[A.ins_h]),
                  (A.head[A.ins_h] = A.strstart));
              } while (0 != --A.prev_length);
              if (
                ((A.match_available = 0),
                (A.match_length = 2),
                A.strstart++,
                i && (DA(A, !1), 0 === A.strm.avail_out))
              )
                return 1;
            } else if (A.match_available) {
              if (
                ((i = W(A, 0, A.window[A.strstart - 1])),
                i && DA(A, !1),
                A.strstart++,
                A.lookahead--,
                0 === A.strm.avail_out)
              )
                return 1;
            } else (A.match_available = 1), A.strstart++, A.lookahead--;
          }
          return (
            A.match_available && ((i = W(A, 0, A.window[A.strstart - 1])), (A.match_available = 0)),
            (A.insert = A.strstart < 2 ? A.strstart : 2),
            e === Z
              ? (DA(A, !0), 0 === A.strm.avail_out ? 3 : 4)
              : A.sym_next && (DA(A, !1), 0 === A.strm.avail_out)
                ? 1
                : 2
          );
        };
      function MA(A, e, t, i, n) {
        (this.good_length = A),
          (this.max_lazy = e),
          (this.nice_length = t),
          (this.max_chain = i),
          (this.func = n);
      }
      const OA = [
        new MA(0, 0, 0, 0, RA),
        new MA(4, 4, 8, 4, vA),
        new MA(4, 5, 16, 8, vA),
        new MA(4, 6, 32, 32, vA),
        new MA(4, 4, 16, 16, xA),
        new MA(8, 16, 32, 32, xA),
        new MA(8, 16, 128, 128, xA),
        new MA(8, 32, 128, 256, xA),
        new MA(32, 128, 258, 1024, xA),
        new MA(32, 258, 258, 4096, xA)
      ];
      function kA() {
        (this.strm = null),
          (this.status = 0),
          (this.pending_buf = null),
          (this.pending_buf_size = 0),
          (this.pending_out = 0),
          (this.pending = 0),
          (this.wrap = 0),
          (this.gzhead = null),
          (this.gzindex = 0),
          (this.method = lA),
          (this.last_flush = -1),
          (this.w_size = 0),
          (this.w_bits = 0),
          (this.w_mask = 0),
          (this.window = null),
          (this.window_size = 0),
          (this.prev = null),
          (this.head = null),
          (this.ins_h = 0),
          (this.hash_size = 0),
          (this.hash_bits = 0),
          (this.hash_mask = 0),
          (this.hash_shift = 0),
          (this.block_start = 0),
          (this.match_length = 0),
          (this.prev_match = 0),
          (this.match_available = 0),
          (this.strstart = 0),
          (this.match_start = 0),
          (this.lookahead = 0),
          (this.prev_length = 0),
          (this.max_chain_length = 0),
          (this.max_lazy_match = 0),
          (this.level = 0),
          (this.strategy = 0),
          (this.good_match = 0),
          (this.nice_match = 0),
          (this.dyn_ltree = new Uint16Array(1146)),
          (this.dyn_dtree = new Uint16Array(122)),
          (this.bl_tree = new Uint16Array(78)),
          pA(this.dyn_ltree),
          pA(this.dyn_dtree),
          pA(this.bl_tree),
          (this.l_desc = null),
          (this.d_desc = null),
          (this.bl_desc = null),
          (this.bl_count = new Uint16Array(16)),
          (this.heap = new Uint16Array(573)),
          pA(this.heap),
          (this.heap_len = 0),
          (this.heap_max = 0),
          (this.depth = new Uint16Array(573)),
          pA(this.depth),
          (this.sym_buf = 0),
          (this.lit_bufsize = 0),
          (this.sym_next = 0),
          (this.sym_end = 0),
          (this.opt_len = 0),
          (this.static_len = 0),
          (this.matches = 0),
          (this.insert = 0),
          (this.bi_buf = 0),
          (this.bi_valid = 0);
      }
      const NA = (A) => {
          if (!A) return 1;
          const e = A.state;
          return !e ||
            e.strm !== A ||
            (e.status !== CA &&
              57 !== e.status &&
              69 !== e.status &&
              73 !== e.status &&
              91 !== e.status &&
              103 !== e.status &&
              e.status !== BA &&
              e.status !== QA)
            ? 1
            : 0;
        },
        KA = (A) => {
          if (NA(A)) return EA(A, tA);
          (A.total_in = A.total_out = 0), (A.data_type = IA);
          const e = A.state;
          return (
            (e.pending = 0),
            (e.pending_out = 0),
            e.wrap < 0 && (e.wrap = -e.wrap),
            (e.status = 2 === e.wrap ? 57 : e.wrap ? CA : BA),
            (A.adler = 2 === e.wrap ? 0 : 1),
            (e.last_flush = -2),
            q(e),
            AA
          );
        },
        LA = (A) => {
          const e = KA(A);
          var t;
          return (
            e === AA &&
              (((t = A.state).window_size = 2 * t.w_size),
              pA(t.head),
              (t.max_lazy_match = OA[t.level].max_lazy),
              (t.good_match = OA[t.level].good_length),
              (t.nice_match = OA[t.level].nice_length),
              (t.max_chain_length = OA[t.level].max_chain),
              (t.strstart = 0),
              (t.block_start = 0),
              (t.lookahead = 0),
              (t.insert = 0),
              (t.match_length = t.prev_length = 2),
              (t.match_available = 0),
              (t.ins_h = 0)),
            e
          );
        },
        TA = (A, e, t, i, n, o) => {
          if (!A) return tA;
          let r = 1;
          if (
            (e === oA && (e = 6),
            i < 0 ? ((r = 0), (i = -i)) : i > 15 && ((r = 2), (i -= 16)),
            n < 1 ||
              n > 9 ||
              t !== lA ||
              i < 8 ||
              i > 15 ||
              e < 0 ||
              e > 9 ||
              o < 0 ||
              o > gA ||
              (8 === i && 1 !== r))
          )
            return EA(A, tA);
          8 === i && (i = 9);
          const s = new kA();
          return (
            (A.state = s),
            (s.strm = A),
            (s.status = CA),
            (s.wrap = r),
            (s.gzhead = null),
            (s.w_bits = i),
            (s.w_size = 1 << s.w_bits),
            (s.w_mask = s.w_size - 1),
            (s.hash_bits = n + 7),
            (s.hash_size = 1 << s.hash_bits),
            (s.hash_mask = s.hash_size - 1),
            (s.hash_shift = ~~((s.hash_bits + 3 - 1) / 3)),
            (s.window = new Uint8Array(2 * s.w_size)),
            (s.head = new Uint16Array(s.hash_size)),
            (s.prev = new Uint16Array(s.w_size)),
            (s.lit_bufsize = 1 << (n + 6)),
            (s.pending_buf_size = 4 * s.lit_bufsize),
            (s.pending_buf = new Uint8Array(s.pending_buf_size)),
            (s.sym_buf = s.lit_bufsize),
            (s.sym_end = 3 * (s.lit_bufsize - 1)),
            (s.level = e),
            (s.strategy = o),
            (s.method = t),
            LA(A)
          );
        };
      var PA = {
        deflateInit: (A, e) => TA(A, e, lA, 15, 8, cA),
        deflateInit2: TA,
        deflateReset: LA,
        deflateResetKeep: KA,
        deflateSetHeader: (A, e) => (NA(A) || 2 !== A.state.wrap ? tA : ((A.state.gzhead = e), AA)),
        deflate: (A, e) => {
          if (NA(A) || e > $ || e < 0) return A ? EA(A, tA) : tA;
          const t = A.state;
          if (!A.output || (0 !== A.avail_in && !A.input) || (t.status === QA && e !== Z))
            return EA(A, 0 === A.avail_out ? nA : tA);
          const i = t.last_flush;
          if (((t.last_flush = e), 0 !== t.pending)) {
            if ((yA(A), 0 === A.avail_out)) return (t.last_flush = -1), AA;
          } else if (0 === A.avail_in && hA(e) <= hA(i) && e !== Z) return EA(A, nA);
          if (t.status === QA && 0 !== A.avail_in) return EA(A, nA);
          if ((t.status === CA && 0 === t.wrap && (t.status = BA), t.status === CA)) {
            let e = (lA + ((t.w_bits - 8) << 4)) << 8,
              i = -1;
            if (
              ((i = t.strategy >= sA || t.level < 2 ? 0 : t.level < 6 ? 1 : 6 === t.level ? 2 : 3),
              (e |= i << 6),
              0 !== t.strstart && (e |= 32),
              (e += 31 - (e % 31)),
              FA(t, e),
              0 !== t.strstart && (FA(t, A.adler >>> 16), FA(t, 65535 & A.adler)),
              (A.adler = 1),
              (t.status = BA),
              yA(A),
              0 !== t.pending)
            )
              return (t.last_flush = -1), AA;
          }
          if (57 === t.status)
            if (((A.adler = 0), wA(t, 31), wA(t, 139), wA(t, 8), t.gzhead))
              wA(
                t,
                (t.gzhead.text ? 1 : 0) +
                  (t.gzhead.hcrc ? 2 : 0) +
                  (t.gzhead.extra ? 4 : 0) +
                  (t.gzhead.name ? 8 : 0) +
                  (t.gzhead.comment ? 16 : 0)
              ),
                wA(t, 255 & t.gzhead.time),
                wA(t, (t.gzhead.time >> 8) & 255),
                wA(t, (t.gzhead.time >> 16) & 255),
                wA(t, (t.gzhead.time >> 24) & 255),
                wA(t, 9 === t.level ? 2 : t.strategy >= sA || t.level < 2 ? 4 : 0),
                wA(t, 255 & t.gzhead.os),
                t.gzhead.extra &&
                  t.gzhead.extra.length &&
                  (wA(t, 255 & t.gzhead.extra.length), wA(t, (t.gzhead.extra.length >> 8) & 255)),
                t.gzhead.hcrc && (A.adler = G(A.adler, t.pending_buf, t.pending, 0)),
                (t.gzindex = 0),
                (t.status = 69);
            else if (
              (wA(t, 0),
              wA(t, 0),
              wA(t, 0),
              wA(t, 0),
              wA(t, 0),
              wA(t, 9 === t.level ? 2 : t.strategy >= sA || t.level < 2 ? 4 : 0),
              wA(t, 3),
              (t.status = BA),
              yA(A),
              0 !== t.pending)
            )
              return (t.last_flush = -1), AA;
          if (69 === t.status) {
            if (t.gzhead.extra) {
              let e = t.pending,
                i = (65535 & t.gzhead.extra.length) - t.gzindex;
              for (; t.pending + i > t.pending_buf_size; ) {
                let n = t.pending_buf_size - t.pending;
                if (
                  (t.pending_buf.set(t.gzhead.extra.subarray(t.gzindex, t.gzindex + n), t.pending),
                  (t.pending = t.pending_buf_size),
                  t.gzhead.hcrc &&
                    t.pending > e &&
                    (A.adler = G(A.adler, t.pending_buf, t.pending - e, e)),
                  (t.gzindex += n),
                  yA(A),
                  0 !== t.pending)
                )
                  return (t.last_flush = -1), AA;
                (e = 0), (i -= n);
              }
              let n = new Uint8Array(t.gzhead.extra);
              t.pending_buf.set(n.subarray(t.gzindex, t.gzindex + i), t.pending),
                (t.pending += i),
                t.gzhead.hcrc &&
                  t.pending > e &&
                  (A.adler = G(A.adler, t.pending_buf, t.pending - e, e)),
                (t.gzindex = 0);
            }
            t.status = 73;
          }
          if (73 === t.status) {
            if (t.gzhead.name) {
              let e,
                i = t.pending;
              do {
                if (t.pending === t.pending_buf_size) {
                  if (
                    (t.gzhead.hcrc &&
                      t.pending > i &&
                      (A.adler = G(A.adler, t.pending_buf, t.pending - i, i)),
                    yA(A),
                    0 !== t.pending)
                  )
                    return (t.last_flush = -1), AA;
                  i = 0;
                }
                (e =
                  t.gzindex < t.gzhead.name.length
                    ? 255 & t.gzhead.name.charCodeAt(t.gzindex++)
                    : 0),
                  wA(t, e);
              } while (0 !== e);
              t.gzhead.hcrc &&
                t.pending > i &&
                (A.adler = G(A.adler, t.pending_buf, t.pending - i, i)),
                (t.gzindex = 0);
            }
            t.status = 91;
          }
          if (91 === t.status) {
            if (t.gzhead.comment) {
              let e,
                i = t.pending;
              do {
                if (t.pending === t.pending_buf_size) {
                  if (
                    (t.gzhead.hcrc &&
                      t.pending > i &&
                      (A.adler = G(A.adler, t.pending_buf, t.pending - i, i)),
                    yA(A),
                    0 !== t.pending)
                  )
                    return (t.last_flush = -1), AA;
                  i = 0;
                }
                (e =
                  t.gzindex < t.gzhead.comment.length
                    ? 255 & t.gzhead.comment.charCodeAt(t.gzindex++)
                    : 0),
                  wA(t, e);
              } while (0 !== e);
              t.gzhead.hcrc &&
                t.pending > i &&
                (A.adler = G(A.adler, t.pending_buf, t.pending - i, i));
            }
            t.status = 103;
          }
          if (103 === t.status) {
            if (t.gzhead.hcrc) {
              if (t.pending + 2 > t.pending_buf_size && (yA(A), 0 !== t.pending))
                return (t.last_flush = -1), AA;
              wA(t, 255 & A.adler), wA(t, (A.adler >> 8) & 255), (A.adler = 0);
            }
            if (((t.status = BA), yA(A), 0 !== t.pending)) return (t.last_flush = -1), AA;
          }
          if (0 !== A.avail_in || 0 !== t.lookahead || (e !== _ && t.status !== QA)) {
            let i =
              0 === t.level
                ? RA(t, e)
                : t.strategy === sA
                  ? ((A, e) => {
                      let t;
                      for (;;) {
                        if (0 === A.lookahead && (SA(A), 0 === A.lookahead)) {
                          if (e === _) return 1;
                          break;
                        }
                        if (
                          ((A.match_length = 0),
                          (t = W(A, 0, A.window[A.strstart])),
                          A.lookahead--,
                          A.strstart++,
                          t && (DA(A, !1), 0 === A.strm.avail_out))
                        )
                          return 1;
                      }
                      return (
                        (A.insert = 0),
                        e === Z
                          ? (DA(A, !0), 0 === A.strm.avail_out ? 3 : 4)
                          : A.sym_next && (DA(A, !1), 0 === A.strm.avail_out)
                            ? 1
                            : 2
                      );
                    })(t, e)
                  : t.strategy === aA
                    ? ((A, e) => {
                        let t, i, n, o;
                        const r = A.window;
                        for (;;) {
                          if (A.lookahead <= dA) {
                            if ((SA(A), A.lookahead <= dA && e === _)) return 1;
                            if (0 === A.lookahead) break;
                          }
                          if (
                            ((A.match_length = 0),
                            A.lookahead >= 3 &&
                              A.strstart > 0 &&
                              ((n = A.strstart - 1),
                              (i = r[n]),
                              i === r[++n] && i === r[++n] && i === r[++n]))
                          ) {
                            o = A.strstart + dA;
                            do {} while (
                              i === r[++n] &&
                              i === r[++n] &&
                              i === r[++n] &&
                              i === r[++n] &&
                              i === r[++n] &&
                              i === r[++n] &&
                              i === r[++n] &&
                              i === r[++n] &&
                              n < o
                            );
                            (A.match_length = dA - (o - n)),
                              A.match_length > A.lookahead && (A.match_length = A.lookahead);
                          }
                          if (
                            (A.match_length >= 3
                              ? ((t = W(A, 1, A.match_length - 3)),
                                (A.lookahead -= A.match_length),
                                (A.strstart += A.match_length),
                                (A.match_length = 0))
                              : ((t = W(A, 0, A.window[A.strstart])), A.lookahead--, A.strstart++),
                            t && (DA(A, !1), 0 === A.strm.avail_out))
                          )
                            return 1;
                        }
                        return (
                          (A.insert = 0),
                          e === Z
                            ? (DA(A, !0), 0 === A.strm.avail_out ? 3 : 4)
                            : A.sym_next && (DA(A, !1), 0 === A.strm.avail_out)
                              ? 1
                              : 2
                        );
                      })(t, e)
                    : OA[t.level].func(t, e);
            if (((3 !== i && 4 !== i) || (t.status = QA), 1 === i || 3 === i))
              return 0 === A.avail_out && (t.last_flush = -1), AA;
            if (
              2 === i &&
              (e === X
                ? V(t)
                : e !== $ &&
                  (J(t, 0, 0, !1),
                  e === z &&
                    (pA(t.head),
                    0 === t.lookahead && ((t.strstart = 0), (t.block_start = 0), (t.insert = 0)))),
              yA(A),
              0 === A.avail_out)
            )
              return (t.last_flush = -1), AA;
          }
          return e !== Z
            ? AA
            : t.wrap <= 0
              ? eA
              : (2 === t.wrap
                  ? (wA(t, 255 & A.adler),
                    wA(t, (A.adler >> 8) & 255),
                    wA(t, (A.adler >> 16) & 255),
                    wA(t, (A.adler >> 24) & 255),
                    wA(t, 255 & A.total_in),
                    wA(t, (A.total_in >> 8) & 255),
                    wA(t, (A.total_in >> 16) & 255),
                    wA(t, (A.total_in >> 24) & 255))
                  : (FA(t, A.adler >>> 16), FA(t, 65535 & A.adler)),
                yA(A),
                t.wrap > 0 && (t.wrap = -t.wrap),
                0 !== t.pending ? AA : eA);
        },
        deflateEnd: (A) => {
          if (NA(A)) return tA;
          const e = A.state.status;
          return (A.state = null), e === BA ? EA(A, iA) : AA;
        },
        deflateSetDictionary: (A, e) => {
          let t = e.length;
          if (NA(A)) return tA;
          const i = A.state,
            n = i.wrap;
          if (2 === n || (1 === n && i.status !== CA) || i.lookahead) return tA;
          if ((1 === n && (A.adler = T(A.adler, e, t, 0)), (i.wrap = 0), t >= i.w_size)) {
            0 === n && (pA(i.head), (i.strstart = 0), (i.block_start = 0), (i.insert = 0));
            let A = new Uint8Array(i.w_size);
            A.set(e.subarray(t - i.w_size, t), 0), (e = A), (t = i.w_size);
          }
          const o = A.avail_in,
            r = A.next_in,
            s = A.input;
          for (A.avail_in = t, A.next_in = 0, A.input = e, SA(i); i.lookahead >= 3; ) {
            let A = i.strstart,
              e = i.lookahead - 2;
            do {
              (i.ins_h = mA(i, i.ins_h, i.window[A + 3 - 1])),
                (i.prev[A & i.w_mask] = i.head[i.ins_h]),
                (i.head[i.ins_h] = A),
                A++;
            } while (--e);
            (i.strstart = A), (i.lookahead = 2), SA(i);
          }
          return (
            (i.strstart += i.lookahead),
            (i.block_start = i.strstart),
            (i.insert = i.lookahead),
            (i.lookahead = 0),
            (i.match_length = i.prev_length = 2),
            (i.match_available = 0),
            (A.next_in = r),
            (A.input = s),
            (A.avail_in = o),
            (i.wrap = n),
            AA
          );
        },
        deflateInfo: "pako deflate (from Nodeca project)"
      };
      const GA = (A, e) => Object.prototype.hasOwnProperty.call(A, e);
      var HA = function (A) {
          const e = Array.prototype.slice.call(arguments, 1);
          for (; e.length; ) {
            const t = e.shift();
            if (t) {
              if ("object" != typeof t) throw new TypeError(t + "must be non-object");
              for (const e in t) GA(t, e) && (A[e] = t[e]);
            }
          }
          return A;
        },
        YA = (A) => {
          let e = 0;
          for (let t = 0, i = A.length; t < i; t++) e += A[t].length;
          const t = new Uint8Array(e);
          for (let e = 0, i = 0, n = A.length; e < n; e++) {
            let n = A[e];
            t.set(n, i), (i += n.length);
          }
          return t;
        };
      let qA = !0;
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (A) {
        qA = !1;
      }
      const JA = new Uint8Array(256);
      for (let A = 0; A < 256; A++)
        JA[A] = A >= 252 ? 6 : A >= 248 ? 5 : A >= 240 ? 4 : A >= 224 ? 3 : A >= 192 ? 2 : 1;
      JA[254] = JA[254] = 1;
      var jA = (A) => {
          if ("function" == typeof TextEncoder && TextEncoder.prototype.encode)
            return new TextEncoder().encode(A);
          let e,
            t,
            i,
            n,
            o,
            r = A.length,
            s = 0;
          for (n = 0; n < r; n++)
            (t = A.charCodeAt(n)),
              55296 == (64512 & t) &&
                n + 1 < r &&
                ((i = A.charCodeAt(n + 1)),
                56320 == (64512 & i) && ((t = 65536 + ((t - 55296) << 10) + (i - 56320)), n++)),
              (s += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4);
          for (e = new Uint8Array(s), o = 0, n = 0; o < s; n++)
            (t = A.charCodeAt(n)),
              55296 == (64512 & t) &&
                n + 1 < r &&
                ((i = A.charCodeAt(n + 1)),
                56320 == (64512 & i) && ((t = 65536 + ((t - 55296) << 10) + (i - 56320)), n++)),
              t < 128
                ? (e[o++] = t)
                : t < 2048
                  ? ((e[o++] = 192 | (t >>> 6)), (e[o++] = 128 | (63 & t)))
                  : t < 65536
                    ? ((e[o++] = 224 | (t >>> 12)),
                      (e[o++] = 128 | ((t >>> 6) & 63)),
                      (e[o++] = 128 | (63 & t)))
                    : ((e[o++] = 240 | (t >>> 18)),
                      (e[o++] = 128 | ((t >>> 12) & 63)),
                      (e[o++] = 128 | ((t >>> 6) & 63)),
                      (e[o++] = 128 | (63 & t)));
          return e;
        },
        WA = (A, e) => {
          const t = e || A.length;
          if ("function" == typeof TextDecoder && TextDecoder.prototype.decode)
            return new TextDecoder().decode(A.subarray(0, e));
          let i, n;
          const o = new Array(2 * t);
          for (n = 0, i = 0; i < t; ) {
            let e = A[i++];
            if (e < 128) {
              o[n++] = e;
              continue;
            }
            let r = JA[e];
            if (r > 4) (o[n++] = 65533), (i += r - 1);
            else {
              for (e &= 2 === r ? 31 : 3 === r ? 15 : 7; r > 1 && i < t; )
                (e = (e << 6) | (63 & A[i++])), r--;
              r > 1
                ? (o[n++] = 65533)
                : e < 65536
                  ? (o[n++] = e)
                  : ((e -= 65536),
                    (o[n++] = 55296 | ((e >> 10) & 1023)),
                    (o[n++] = 56320 | (1023 & e)));
            }
          }
          return ((A, e) => {
            if (e < 65534 && A.subarray && qA)
              return String.fromCharCode.apply(null, A.length === e ? A : A.subarray(0, e));
            let t = "";
            for (let i = 0; i < e; i++) t += String.fromCharCode(A[i]);
            return t;
          })(o, n);
        },
        VA = (A, e) => {
          (e = e || A.length) > A.length && (e = A.length);
          let t = e - 1;
          for (; t >= 0 && 128 == (192 & A[t]); ) t--;
          return t < 0 || 0 === t ? e : t + JA[A[t]] > e ? t : e;
        },
        _A = function () {
          (this.input = null),
            (this.next_in = 0),
            (this.avail_in = 0),
            (this.total_in = 0),
            (this.output = null),
            (this.next_out = 0),
            (this.avail_out = 0),
            (this.total_out = 0),
            (this.msg = ""),
            (this.state = null),
            (this.data_type = 2),
            (this.adler = 0);
        };
      const XA = Object.prototype.toString,
        {
          Z_NO_FLUSH: zA,
          Z_SYNC_FLUSH: ZA,
          Z_FULL_FLUSH: $A,
          Z_FINISH: Ae,
          Z_OK: ee,
          Z_STREAM_END: te,
          Z_DEFAULT_COMPRESSION: ie,
          Z_DEFAULT_STRATEGY: ne,
          Z_DEFLATED: oe
        } = Y;
      function re(A) {
        this.options = HA(
          { level: ie, method: oe, chunkSize: 16384, windowBits: 15, memLevel: 8, strategy: ne },
          A || {}
        );
        let e = this.options;
        e.raw && e.windowBits > 0
          ? (e.windowBits = -e.windowBits)
          : e.gzip && e.windowBits > 0 && e.windowBits < 16 && (e.windowBits += 16),
          (this.err = 0),
          (this.msg = ""),
          (this.ended = !1),
          (this.chunks = []),
          (this.strm = new _A()),
          (this.strm.avail_out = 0);
        let t = PA.deflateInit2(this.strm, e.level, e.method, e.windowBits, e.memLevel, e.strategy);
        if (t !== ee) throw new Error(H[t]);
        if ((e.header && PA.deflateSetHeader(this.strm, e.header), e.dictionary)) {
          let A;
          if (
            ((A =
              "string" == typeof e.dictionary
                ? jA(e.dictionary)
                : "[object ArrayBuffer]" === XA.call(e.dictionary)
                  ? new Uint8Array(e.dictionary)
                  : e.dictionary),
            (t = PA.deflateSetDictionary(this.strm, A)),
            t !== ee)
          )
            throw new Error(H[t]);
          this._dict_set = !0;
        }
      }
      function se(A, e) {
        const t = new re(e);
        if ((t.push(A, !0), t.err)) throw t.msg || H[t.err];
        return t.result;
      }
      (re.prototype.push = function (A, e) {
        const t = this.strm,
          i = this.options.chunkSize;
        let n, o;
        if (this.ended) return !1;
        for (
          o = e === ~~e ? e : !0 === e ? Ae : zA,
            "string" == typeof A
              ? (t.input = jA(A))
              : "[object ArrayBuffer]" === XA.call(A)
                ? (t.input = new Uint8Array(A))
                : (t.input = A),
            t.next_in = 0,
            t.avail_in = t.input.length;
          ;

        )
          if (
            (0 === t.avail_out &&
              ((t.output = new Uint8Array(i)), (t.next_out = 0), (t.avail_out = i)),
            (o === ZA || o === $A) && t.avail_out <= 6)
          )
            this.onData(t.output.subarray(0, t.next_out)), (t.avail_out = 0);
          else {
            if (((n = PA.deflate(t, o)), n === te))
              return (
                t.next_out > 0 && this.onData(t.output.subarray(0, t.next_out)),
                (n = PA.deflateEnd(this.strm)),
                this.onEnd(n),
                (this.ended = !0),
                n === ee
              );
            if (0 !== t.avail_out) {
              if (o > 0 && t.next_out > 0)
                this.onData(t.output.subarray(0, t.next_out)), (t.avail_out = 0);
              else if (0 === t.avail_in) break;
            } else this.onData(t.output);
          }
        return !0;
      }),
        (re.prototype.onData = function (A) {
          this.chunks.push(A);
        }),
        (re.prototype.onEnd = function (A) {
          A === ee && (this.result = YA(this.chunks)),
            (this.chunks = []),
            (this.err = A),
            (this.msg = this.strm.msg);
        });
      var ae = {
        Deflate: re,
        deflate: se,
        deflateRaw: function (A, e) {
          return ((e = e || {}).raw = !0), se(A, e);
        },
        gzip: function (A, e) {
          return ((e = e || {}).gzip = !0), se(A, e);
        },
        constants: Y
      };
      const ge = 16209;
      var ce = function (A, e) {
        let t, i, n, o, r, s, a, g, c, I, l, d, u, C, B, Q, E, h, p, f, m, y, D, w;
        const F = A.state;
        (t = A.next_in),
          (D = A.input),
          (i = t + (A.avail_in - 5)),
          (n = A.next_out),
          (w = A.output),
          (o = n - (e - A.avail_out)),
          (r = n + (A.avail_out - 257)),
          (s = F.dmax),
          (a = F.wsize),
          (g = F.whave),
          (c = F.wnext),
          (I = F.window),
          (l = F.hold),
          (d = F.bits),
          (u = F.lencode),
          (C = F.distcode),
          (B = (1 << F.lenbits) - 1),
          (Q = (1 << F.distbits) - 1);
        A: do {
          d < 15 && ((l += D[t++] << d), (d += 8), (l += D[t++] << d), (d += 8)), (E = u[l & B]);
          e: for (;;) {
            if (((h = E >>> 24), (l >>>= h), (d -= h), (h = (E >>> 16) & 255), 0 === h))
              w[n++] = 65535 & E;
            else {
              if (!(16 & h)) {
                if (!(64 & h)) {
                  E = u[(65535 & E) + (l & ((1 << h) - 1))];
                  continue e;
                }
                if (32 & h) {
                  F.mode = 16191;
                  break A;
                }
                (A.msg = "invalid literal/length code"), (F.mode = ge);
                break A;
              }
              (p = 65535 & E),
                (h &= 15),
                h &&
                  (d < h && ((l += D[t++] << d), (d += 8)),
                  (p += l & ((1 << h) - 1)),
                  (l >>>= h),
                  (d -= h)),
                d < 15 && ((l += D[t++] << d), (d += 8), (l += D[t++] << d), (d += 8)),
                (E = C[l & Q]);
              t: for (;;) {
                if (((h = E >>> 24), (l >>>= h), (d -= h), (h = (E >>> 16) & 255), !(16 & h))) {
                  if (!(64 & h)) {
                    E = C[(65535 & E) + (l & ((1 << h) - 1))];
                    continue t;
                  }
                  (A.msg = "invalid distance code"), (F.mode = ge);
                  break A;
                }
                if (
                  ((f = 65535 & E),
                  (h &= 15),
                  d < h && ((l += D[t++] << d), (d += 8), d < h && ((l += D[t++] << d), (d += 8))),
                  (f += l & ((1 << h) - 1)),
                  f > s)
                ) {
                  (A.msg = "invalid distance too far back"), (F.mode = ge);
                  break A;
                }
                if (((l >>>= h), (d -= h), (h = n - o), f > h)) {
                  if (((h = f - h), h > g && F.sane)) {
                    (A.msg = "invalid distance too far back"), (F.mode = ge);
                    break A;
                  }
                  if (((m = 0), (y = I), 0 === c)) {
                    if (((m += a - h), h < p)) {
                      p -= h;
                      do {
                        w[n++] = I[m++];
                      } while (--h);
                      (m = n - f), (y = w);
                    }
                  } else if (c < h) {
                    if (((m += a + c - h), (h -= c), h < p)) {
                      p -= h;
                      do {
                        w[n++] = I[m++];
                      } while (--h);
                      if (((m = 0), c < p)) {
                        (h = c), (p -= h);
                        do {
                          w[n++] = I[m++];
                        } while (--h);
                        (m = n - f), (y = w);
                      }
                    }
                  } else if (((m += c - h), h < p)) {
                    p -= h;
                    do {
                      w[n++] = I[m++];
                    } while (--h);
                    (m = n - f), (y = w);
                  }
                  for (; p > 2; ) (w[n++] = y[m++]), (w[n++] = y[m++]), (w[n++] = y[m++]), (p -= 3);
                  p && ((w[n++] = y[m++]), p > 1 && (w[n++] = y[m++]));
                } else {
                  m = n - f;
                  do {
                    (w[n++] = w[m++]), (w[n++] = w[m++]), (w[n++] = w[m++]), (p -= 3);
                  } while (p > 2);
                  p && ((w[n++] = w[m++]), p > 1 && (w[n++] = w[m++]));
                }
                break;
              }
            }
            break;
          }
        } while (t < i && n < r);
        (p = d >> 3),
          (t -= p),
          (d -= p << 3),
          (l &= (1 << d) - 1),
          (A.next_in = t),
          (A.next_out = n),
          (A.avail_in = t < i ? i - t + 5 : 5 - (t - i)),
          (A.avail_out = n < r ? r - n + 257 : 257 - (n - r)),
          (F.hold = l),
          (F.bits = d);
      };
      const Ie = 15,
        le = new Uint16Array([
          3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115,
          131, 163, 195, 227, 258, 0, 0
        ]),
        de = new Uint8Array([
          16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20,
          20, 20, 21, 21, 21, 21, 16, 72, 78
        ]),
        ue = new Uint16Array([
          1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537,
          2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0
        ]),
        Ce = new Uint8Array([
          16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25,
          26, 26, 27, 27, 28, 28, 29, 29, 64, 64
        ]);
      var Be = (A, e, t, i, n, o, r, s) => {
        const a = s.bits;
        let g,
          c,
          I,
          l,
          d,
          u,
          C = 0,
          B = 0,
          Q = 0,
          E = 0,
          h = 0,
          p = 0,
          f = 0,
          m = 0,
          y = 0,
          D = 0,
          w = null;
        const F = new Uint16Array(16),
          b = new Uint16Array(16);
        let U,
          S,
          R,
          v = null;
        for (C = 0; C <= Ie; C++) F[C] = 0;
        for (B = 0; B < i; B++) F[e[t + B]]++;
        for (h = a, E = Ie; E >= 1 && 0 === F[E]; E--);
        if ((h > E && (h = E), 0 === E))
          return (n[o++] = 20971520), (n[o++] = 20971520), (s.bits = 1), 0;
        for (Q = 1; Q < E && 0 === F[Q]; Q++);
        for (h < Q && (h = Q), m = 1, C = 1; C <= Ie; C++)
          if (((m <<= 1), (m -= F[C]), m < 0)) return -1;
        if (m > 0 && (0 === A || 1 !== E)) return -1;
        for (b[1] = 0, C = 1; C < Ie; C++) b[C + 1] = b[C] + F[C];
        for (B = 0; B < i; B++) 0 !== e[t + B] && (r[b[e[t + B]]++] = B);
        if (
          (0 === A
            ? ((w = v = r), (u = 20))
            : 1 === A
              ? ((w = le), (v = de), (u = 257))
              : ((w = ue), (v = Ce), (u = 0)),
          (D = 0),
          (B = 0),
          (C = Q),
          (d = o),
          (p = h),
          (f = 0),
          (I = -1),
          (y = 1 << h),
          (l = y - 1),
          (1 === A && y > 852) || (2 === A && y > 592))
        )
          return 1;
        for (;;) {
          (U = C - f),
            r[B] + 1 < u
              ? ((S = 0), (R = r[B]))
              : r[B] >= u
                ? ((S = v[r[B] - u]), (R = w[r[B] - u]))
                : ((S = 96), (R = 0)),
            (g = 1 << (C - f)),
            (c = 1 << p),
            (Q = c);
          do {
            (c -= g), (n[d + (D >> f) + c] = (U << 24) | (S << 16) | R);
          } while (0 !== c);
          for (g = 1 << (C - 1); D & g; ) g >>= 1;
          if ((0 !== g ? ((D &= g - 1), (D += g)) : (D = 0), B++, 0 == --F[C])) {
            if (C === E) break;
            C = e[t + r[B]];
          }
          if (C > h && (D & l) !== I) {
            for (
              0 === f && (f = h), d += Q, p = C - f, m = 1 << p;
              p + f < E && ((m -= F[p + f]), !(m <= 0));

            )
              p++, (m <<= 1);
            if (((y += 1 << p), (1 === A && y > 852) || (2 === A && y > 592))) return 1;
            (I = D & l), (n[I] = (h << 24) | (p << 16) | (d - o));
          }
        }
        return 0 !== D && (n[d + D] = ((C - f) << 24) | (64 << 16)), (s.bits = h), 0;
      };
      const {
          Z_FINISH: Qe,
          Z_BLOCK: Ee,
          Z_TREES: he,
          Z_OK: pe,
          Z_STREAM_END: fe,
          Z_NEED_DICT: me,
          Z_STREAM_ERROR: ye,
          Z_DATA_ERROR: De,
          Z_MEM_ERROR: we,
          Z_BUF_ERROR: Fe,
          Z_DEFLATED: be
        } = Y,
        Ue = 16180,
        Se = 16190,
        Re = 16191,
        ve = 16192,
        xe = 16194,
        Me = 16199,
        Oe = 16200,
        ke = 16206,
        Ne = 16209,
        Ke = (A) =>
          ((A >>> 24) & 255) + ((A >>> 8) & 65280) + ((65280 & A) << 8) + ((255 & A) << 24);
      function Le() {
        (this.strm = null),
          (this.mode = 0),
          (this.last = !1),
          (this.wrap = 0),
          (this.havedict = !1),
          (this.flags = 0),
          (this.dmax = 0),
          (this.check = 0),
          (this.total = 0),
          (this.head = null),
          (this.wbits = 0),
          (this.wsize = 0),
          (this.whave = 0),
          (this.wnext = 0),
          (this.window = null),
          (this.hold = 0),
          (this.bits = 0),
          (this.length = 0),
          (this.offset = 0),
          (this.extra = 0),
          (this.lencode = null),
          (this.distcode = null),
          (this.lenbits = 0),
          (this.distbits = 0),
          (this.ncode = 0),
          (this.nlen = 0),
          (this.ndist = 0),
          (this.have = 0),
          (this.next = null),
          (this.lens = new Uint16Array(320)),
          (this.work = new Uint16Array(288)),
          (this.lendyn = null),
          (this.distdyn = null),
          (this.sane = 0),
          (this.back = 0),
          (this.was = 0);
      }
      const Te = (A) => {
          if (!A) return 1;
          const e = A.state;
          return !e || e.strm !== A || e.mode < Ue || e.mode > 16211 ? 1 : 0;
        },
        Pe = (A) => {
          if (Te(A)) return ye;
          const e = A.state;
          return (
            (A.total_in = A.total_out = e.total = 0),
            (A.msg = ""),
            e.wrap && (A.adler = 1 & e.wrap),
            (e.mode = Ue),
            (e.last = 0),
            (e.havedict = 0),
            (e.flags = -1),
            (e.dmax = 32768),
            (e.head = null),
            (e.hold = 0),
            (e.bits = 0),
            (e.lencode = e.lendyn = new Int32Array(852)),
            (e.distcode = e.distdyn = new Int32Array(592)),
            (e.sane = 1),
            (e.back = -1),
            pe
          );
        },
        Ge = (A) => {
          if (Te(A)) return ye;
          const e = A.state;
          return (e.wsize = 0), (e.whave = 0), (e.wnext = 0), Pe(A);
        },
        He = (A, e) => {
          let t;
          if (Te(A)) return ye;
          const i = A.state;
          return (
            e < 0 ? ((t = 0), (e = -e)) : ((t = 5 + (e >> 4)), e < 48 && (e &= 15)),
            e && (e < 8 || e > 15)
              ? ye
              : (null !== i.window && i.wbits !== e && (i.window = null),
                (i.wrap = t),
                (i.wbits = e),
                Ge(A))
          );
        },
        Ye = (A, e) => {
          if (!A) return ye;
          const t = new Le();
          (A.state = t), (t.strm = A), (t.window = null), (t.mode = Ue);
          const i = He(A, e);
          return i !== pe && (A.state = null), i;
        };
      let qe,
        Je,
        je = !0;
      const We = (A) => {
          if (je) {
            (qe = new Int32Array(512)), (Je = new Int32Array(32));
            let e = 0;
            for (; e < 144; ) A.lens[e++] = 8;
            for (; e < 256; ) A.lens[e++] = 9;
            for (; e < 280; ) A.lens[e++] = 7;
            for (; e < 288; ) A.lens[e++] = 8;
            for (Be(1, A.lens, 0, 288, qe, 0, A.work, { bits: 9 }), e = 0; e < 32; )
              A.lens[e++] = 5;
            Be(2, A.lens, 0, 32, Je, 0, A.work, { bits: 5 }), (je = !1);
          }
          (A.lencode = qe), (A.lenbits = 9), (A.distcode = Je), (A.distbits = 5);
        },
        Ve = (A, e, t, i) => {
          let n;
          const o = A.state;
          return (
            null === o.window &&
              ((o.wsize = 1 << o.wbits),
              (o.wnext = 0),
              (o.whave = 0),
              (o.window = new Uint8Array(o.wsize))),
            i >= o.wsize
              ? (o.window.set(e.subarray(t - o.wsize, t), 0), (o.wnext = 0), (o.whave = o.wsize))
              : ((n = o.wsize - o.wnext),
                n > i && (n = i),
                o.window.set(e.subarray(t - i, t - i + n), o.wnext),
                (i -= n)
                  ? (o.window.set(e.subarray(t - i, t), 0), (o.wnext = i), (o.whave = o.wsize))
                  : ((o.wnext += n),
                    o.wnext === o.wsize && (o.wnext = 0),
                    o.whave < o.wsize && (o.whave += n))),
            0
          );
        };
      var _e = {
          inflateReset: Ge,
          inflateReset2: He,
          inflateResetKeep: Pe,
          inflateInit: (A) => Ye(A, 15),
          inflateInit2: Ye,
          inflate: (A, e) => {
            let t,
              i,
              n,
              o,
              r,
              s,
              a,
              g,
              c,
              I,
              l,
              d,
              u,
              C,
              B,
              Q,
              E,
              h,
              p,
              f,
              m,
              y,
              D = 0;
            const w = new Uint8Array(4);
            let F, b;
            const U = new Uint8Array([
              16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15
            ]);
            if (Te(A) || !A.output || (!A.input && 0 !== A.avail_in)) return ye;
            (t = A.state),
              t.mode === Re && (t.mode = ve),
              (r = A.next_out),
              (n = A.output),
              (a = A.avail_out),
              (o = A.next_in),
              (i = A.input),
              (s = A.avail_in),
              (g = t.hold),
              (c = t.bits),
              (I = s),
              (l = a),
              (y = pe);
            A: for (;;)
              switch (t.mode) {
                case Ue:
                  if (0 === t.wrap) {
                    t.mode = ve;
                    break;
                  }
                  for (; c < 16; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  if (2 & t.wrap && 35615 === g) {
                    0 === t.wbits && (t.wbits = 15),
                      (t.check = 0),
                      (w[0] = 255 & g),
                      (w[1] = (g >>> 8) & 255),
                      (t.check = G(t.check, w, 2, 0)),
                      (g = 0),
                      (c = 0),
                      (t.mode = 16181);
                    break;
                  }
                  if (
                    (t.head && (t.head.done = !1),
                    !(1 & t.wrap) || (((255 & g) << 8) + (g >> 8)) % 31)
                  ) {
                    (A.msg = "incorrect header check"), (t.mode = Ne);
                    break;
                  }
                  if ((15 & g) !== be) {
                    (A.msg = "unknown compression method"), (t.mode = Ne);
                    break;
                  }
                  if (
                    ((g >>>= 4),
                    (c -= 4),
                    (m = 8 + (15 & g)),
                    0 === t.wbits && (t.wbits = m),
                    m > 15 || m > t.wbits)
                  ) {
                    (A.msg = "invalid window size"), (t.mode = Ne);
                    break;
                  }
                  (t.dmax = 1 << t.wbits),
                    (t.flags = 0),
                    (A.adler = t.check = 1),
                    (t.mode = 512 & g ? 16189 : Re),
                    (g = 0),
                    (c = 0);
                  break;
                case 16181:
                  for (; c < 16; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  if (((t.flags = g), (255 & t.flags) !== be)) {
                    (A.msg = "unknown compression method"), (t.mode = Ne);
                    break;
                  }
                  if (57344 & t.flags) {
                    (A.msg = "unknown header flags set"), (t.mode = Ne);
                    break;
                  }
                  t.head && (t.head.text = (g >> 8) & 1),
                    512 & t.flags &&
                      4 & t.wrap &&
                      ((w[0] = 255 & g), (w[1] = (g >>> 8) & 255), (t.check = G(t.check, w, 2, 0))),
                    (g = 0),
                    (c = 0),
                    (t.mode = 16182);
                case 16182:
                  for (; c < 32; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  t.head && (t.head.time = g),
                    512 & t.flags &&
                      4 & t.wrap &&
                      ((w[0] = 255 & g),
                      (w[1] = (g >>> 8) & 255),
                      (w[2] = (g >>> 16) & 255),
                      (w[3] = (g >>> 24) & 255),
                      (t.check = G(t.check, w, 4, 0))),
                    (g = 0),
                    (c = 0),
                    (t.mode = 16183);
                case 16183:
                  for (; c < 16; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  t.head && ((t.head.xflags = 255 & g), (t.head.os = g >> 8)),
                    512 & t.flags &&
                      4 & t.wrap &&
                      ((w[0] = 255 & g), (w[1] = (g >>> 8) & 255), (t.check = G(t.check, w, 2, 0))),
                    (g = 0),
                    (c = 0),
                    (t.mode = 16184);
                case 16184:
                  if (1024 & t.flags) {
                    for (; c < 16; ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    (t.length = g),
                      t.head && (t.head.extra_len = g),
                      512 & t.flags &&
                        4 & t.wrap &&
                        ((w[0] = 255 & g),
                        (w[1] = (g >>> 8) & 255),
                        (t.check = G(t.check, w, 2, 0))),
                      (g = 0),
                      (c = 0);
                  } else t.head && (t.head.extra = null);
                  t.mode = 16185;
                case 16185:
                  if (
                    1024 & t.flags &&
                    ((d = t.length),
                    d > s && (d = s),
                    d &&
                      (t.head &&
                        ((m = t.head.extra_len - t.length),
                        t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)),
                        t.head.extra.set(i.subarray(o, o + d), m)),
                      512 & t.flags && 4 & t.wrap && (t.check = G(t.check, i, d, o)),
                      (s -= d),
                      (o += d),
                      (t.length -= d)),
                    t.length)
                  )
                    break A;
                  (t.length = 0), (t.mode = 16186);
                case 16186:
                  if (2048 & t.flags) {
                    if (0 === s) break A;
                    d = 0;
                    do {
                      (m = i[o + d++]),
                        t.head && m && t.length < 65536 && (t.head.name += String.fromCharCode(m));
                    } while (m && d < s);
                    if (
                      (512 & t.flags && 4 & t.wrap && (t.check = G(t.check, i, d, o)),
                      (s -= d),
                      (o += d),
                      m)
                    )
                      break A;
                  } else t.head && (t.head.name = null);
                  (t.length = 0), (t.mode = 16187);
                case 16187:
                  if (4096 & t.flags) {
                    if (0 === s) break A;
                    d = 0;
                    do {
                      (m = i[o + d++]),
                        t.head &&
                          m &&
                          t.length < 65536 &&
                          (t.head.comment += String.fromCharCode(m));
                    } while (m && d < s);
                    if (
                      (512 & t.flags && 4 & t.wrap && (t.check = G(t.check, i, d, o)),
                      (s -= d),
                      (o += d),
                      m)
                    )
                      break A;
                  } else t.head && (t.head.comment = null);
                  t.mode = 16188;
                case 16188:
                  if (512 & t.flags) {
                    for (; c < 16; ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    if (4 & t.wrap && g !== (65535 & t.check)) {
                      (A.msg = "header crc mismatch"), (t.mode = Ne);
                      break;
                    }
                    (g = 0), (c = 0);
                  }
                  t.head && ((t.head.hcrc = (t.flags >> 9) & 1), (t.head.done = !0)),
                    (A.adler = t.check = 0),
                    (t.mode = Re);
                  break;
                case 16189:
                  for (; c < 32; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  (A.adler = t.check = Ke(g)), (g = 0), (c = 0), (t.mode = Se);
                case Se:
                  if (0 === t.havedict)
                    return (
                      (A.next_out = r),
                      (A.avail_out = a),
                      (A.next_in = o),
                      (A.avail_in = s),
                      (t.hold = g),
                      (t.bits = c),
                      me
                    );
                  (A.adler = t.check = 1), (t.mode = Re);
                case Re:
                  if (e === Ee || e === he) break A;
                case ve:
                  if (t.last) {
                    (g >>>= 7 & c), (c -= 7 & c), (t.mode = ke);
                    break;
                  }
                  for (; c < 3; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  switch (((t.last = 1 & g), (g >>>= 1), (c -= 1), 3 & g)) {
                    case 0:
                      t.mode = 16193;
                      break;
                    case 1:
                      if ((We(t), (t.mode = Me), e === he)) {
                        (g >>>= 2), (c -= 2);
                        break A;
                      }
                      break;
                    case 2:
                      t.mode = 16196;
                      break;
                    case 3:
                      (A.msg = "invalid block type"), (t.mode = Ne);
                  }
                  (g >>>= 2), (c -= 2);
                  break;
                case 16193:
                  for (g >>>= 7 & c, c -= 7 & c; c < 32; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  if ((65535 & g) != ((g >>> 16) ^ 65535)) {
                    (A.msg = "invalid stored block lengths"), (t.mode = Ne);
                    break;
                  }
                  if (((t.length = 65535 & g), (g = 0), (c = 0), (t.mode = xe), e === he)) break A;
                case xe:
                  t.mode = 16195;
                case 16195:
                  if (((d = t.length), d)) {
                    if ((d > s && (d = s), d > a && (d = a), 0 === d)) break A;
                    n.set(i.subarray(o, o + d), r),
                      (s -= d),
                      (o += d),
                      (a -= d),
                      (r += d),
                      (t.length -= d);
                    break;
                  }
                  t.mode = Re;
                  break;
                case 16196:
                  for (; c < 14; ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  if (
                    ((t.nlen = 257 + (31 & g)),
                    (g >>>= 5),
                    (c -= 5),
                    (t.ndist = 1 + (31 & g)),
                    (g >>>= 5),
                    (c -= 5),
                    (t.ncode = 4 + (15 & g)),
                    (g >>>= 4),
                    (c -= 4),
                    t.nlen > 286 || t.ndist > 30)
                  ) {
                    (A.msg = "too many length or distance symbols"), (t.mode = Ne);
                    break;
                  }
                  (t.have = 0), (t.mode = 16197);
                case 16197:
                  for (; t.have < t.ncode; ) {
                    for (; c < 3; ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    (t.lens[U[t.have++]] = 7 & g), (g >>>= 3), (c -= 3);
                  }
                  for (; t.have < 19; ) t.lens[U[t.have++]] = 0;
                  if (
                    ((t.lencode = t.lendyn),
                    (t.lenbits = 7),
                    (F = { bits: t.lenbits }),
                    (y = Be(0, t.lens, 0, 19, t.lencode, 0, t.work, F)),
                    (t.lenbits = F.bits),
                    y)
                  ) {
                    (A.msg = "invalid code lengths set"), (t.mode = Ne);
                    break;
                  }
                  (t.have = 0), (t.mode = 16198);
                case 16198:
                  for (; t.have < t.nlen + t.ndist; ) {
                    for (
                      ;
                      (D = t.lencode[g & ((1 << t.lenbits) - 1)]),
                        (B = D >>> 24),
                        (Q = (D >>> 16) & 255),
                        (E = 65535 & D),
                        !(B <= c);

                    ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    if (E < 16) (g >>>= B), (c -= B), (t.lens[t.have++] = E);
                    else {
                      if (16 === E) {
                        for (b = B + 2; c < b; ) {
                          if (0 === s) break A;
                          s--, (g += i[o++] << c), (c += 8);
                        }
                        if (((g >>>= B), (c -= B), 0 === t.have)) {
                          (A.msg = "invalid bit length repeat"), (t.mode = Ne);
                          break;
                        }
                        (m = t.lens[t.have - 1]), (d = 3 + (3 & g)), (g >>>= 2), (c -= 2);
                      } else if (17 === E) {
                        for (b = B + 3; c < b; ) {
                          if (0 === s) break A;
                          s--, (g += i[o++] << c), (c += 8);
                        }
                        (g >>>= B), (c -= B), (m = 0), (d = 3 + (7 & g)), (g >>>= 3), (c -= 3);
                      } else {
                        for (b = B + 7; c < b; ) {
                          if (0 === s) break A;
                          s--, (g += i[o++] << c), (c += 8);
                        }
                        (g >>>= B), (c -= B), (m = 0), (d = 11 + (127 & g)), (g >>>= 7), (c -= 7);
                      }
                      if (t.have + d > t.nlen + t.ndist) {
                        (A.msg = "invalid bit length repeat"), (t.mode = Ne);
                        break;
                      }
                      for (; d--; ) t.lens[t.have++] = m;
                    }
                  }
                  if (t.mode === Ne) break;
                  if (0 === t.lens[256]) {
                    (A.msg = "invalid code -- missing end-of-block"), (t.mode = Ne);
                    break;
                  }
                  if (
                    ((t.lenbits = 9),
                    (F = { bits: t.lenbits }),
                    (y = Be(1, t.lens, 0, t.nlen, t.lencode, 0, t.work, F)),
                    (t.lenbits = F.bits),
                    y)
                  ) {
                    (A.msg = "invalid literal/lengths set"), (t.mode = Ne);
                    break;
                  }
                  if (
                    ((t.distbits = 6),
                    (t.distcode = t.distdyn),
                    (F = { bits: t.distbits }),
                    (y = Be(2, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, F)),
                    (t.distbits = F.bits),
                    y)
                  ) {
                    (A.msg = "invalid distances set"), (t.mode = Ne);
                    break;
                  }
                  if (((t.mode = Me), e === he)) break A;
                case Me:
                  t.mode = Oe;
                case Oe:
                  if (s >= 6 && a >= 258) {
                    (A.next_out = r),
                      (A.avail_out = a),
                      (A.next_in = o),
                      (A.avail_in = s),
                      (t.hold = g),
                      (t.bits = c),
                      ce(A, l),
                      (r = A.next_out),
                      (n = A.output),
                      (a = A.avail_out),
                      (o = A.next_in),
                      (i = A.input),
                      (s = A.avail_in),
                      (g = t.hold),
                      (c = t.bits),
                      t.mode === Re && (t.back = -1);
                    break;
                  }
                  for (
                    t.back = 0;
                    (D = t.lencode[g & ((1 << t.lenbits) - 1)]),
                      (B = D >>> 24),
                      (Q = (D >>> 16) & 255),
                      (E = 65535 & D),
                      !(B <= c);

                  ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  if (Q && !(240 & Q)) {
                    for (
                      h = B, p = Q, f = E;
                      (D = t.lencode[f + ((g & ((1 << (h + p)) - 1)) >> h)]),
                        (B = D >>> 24),
                        (Q = (D >>> 16) & 255),
                        (E = 65535 & D),
                        !(h + B <= c);

                    ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    (g >>>= h), (c -= h), (t.back += h);
                  }
                  if (((g >>>= B), (c -= B), (t.back += B), (t.length = E), 0 === Q)) {
                    t.mode = 16205;
                    break;
                  }
                  if (32 & Q) {
                    (t.back = -1), (t.mode = Re);
                    break;
                  }
                  if (64 & Q) {
                    (A.msg = "invalid literal/length code"), (t.mode = Ne);
                    break;
                  }
                  (t.extra = 15 & Q), (t.mode = 16201);
                case 16201:
                  if (t.extra) {
                    for (b = t.extra; c < b; ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    (t.length += g & ((1 << t.extra) - 1)),
                      (g >>>= t.extra),
                      (c -= t.extra),
                      (t.back += t.extra);
                  }
                  (t.was = t.length), (t.mode = 16202);
                case 16202:
                  for (
                    ;
                    (D = t.distcode[g & ((1 << t.distbits) - 1)]),
                      (B = D >>> 24),
                      (Q = (D >>> 16) & 255),
                      (E = 65535 & D),
                      !(B <= c);

                  ) {
                    if (0 === s) break A;
                    s--, (g += i[o++] << c), (c += 8);
                  }
                  if (!(240 & Q)) {
                    for (
                      h = B, p = Q, f = E;
                      (D = t.distcode[f + ((g & ((1 << (h + p)) - 1)) >> h)]),
                        (B = D >>> 24),
                        (Q = (D >>> 16) & 255),
                        (E = 65535 & D),
                        !(h + B <= c);

                    ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    (g >>>= h), (c -= h), (t.back += h);
                  }
                  if (((g >>>= B), (c -= B), (t.back += B), 64 & Q)) {
                    (A.msg = "invalid distance code"), (t.mode = Ne);
                    break;
                  }
                  (t.offset = E), (t.extra = 15 & Q), (t.mode = 16203);
                case 16203:
                  if (t.extra) {
                    for (b = t.extra; c < b; ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    (t.offset += g & ((1 << t.extra) - 1)),
                      (g >>>= t.extra),
                      (c -= t.extra),
                      (t.back += t.extra);
                  }
                  if (t.offset > t.dmax) {
                    (A.msg = "invalid distance too far back"), (t.mode = Ne);
                    break;
                  }
                  t.mode = 16204;
                case 16204:
                  if (0 === a) break A;
                  if (((d = l - a), t.offset > d)) {
                    if (((d = t.offset - d), d > t.whave && t.sane)) {
                      (A.msg = "invalid distance too far back"), (t.mode = Ne);
                      break;
                    }
                    d > t.wnext ? ((d -= t.wnext), (u = t.wsize - d)) : (u = t.wnext - d),
                      d > t.length && (d = t.length),
                      (C = t.window);
                  } else (C = n), (u = r - t.offset), (d = t.length);
                  d > a && (d = a), (a -= d), (t.length -= d);
                  do {
                    n[r++] = C[u++];
                  } while (--d);
                  0 === t.length && (t.mode = Oe);
                  break;
                case 16205:
                  if (0 === a) break A;
                  (n[r++] = t.length), a--, (t.mode = Oe);
                  break;
                case ke:
                  if (t.wrap) {
                    for (; c < 32; ) {
                      if (0 === s) break A;
                      s--, (g |= i[o++] << c), (c += 8);
                    }
                    if (
                      ((l -= a),
                      (A.total_out += l),
                      (t.total += l),
                      4 & t.wrap &&
                        l &&
                        (A.adler = t.check =
                          t.flags ? G(t.check, n, l, r - l) : T(t.check, n, l, r - l)),
                      (l = a),
                      4 & t.wrap && (t.flags ? g : Ke(g)) !== t.check)
                    ) {
                      (A.msg = "incorrect data check"), (t.mode = Ne);
                      break;
                    }
                    (g = 0), (c = 0);
                  }
                  t.mode = 16207;
                case 16207:
                  if (t.wrap && t.flags) {
                    for (; c < 32; ) {
                      if (0 === s) break A;
                      s--, (g += i[o++] << c), (c += 8);
                    }
                    if (4 & t.wrap && g !== (4294967295 & t.total)) {
                      (A.msg = "incorrect length check"), (t.mode = Ne);
                      break;
                    }
                    (g = 0), (c = 0);
                  }
                  t.mode = 16208;
                case 16208:
                  y = fe;
                  break A;
                case Ne:
                  y = De;
                  break A;
                case 16210:
                  return we;
                default:
                  return ye;
              }
            return (
              (A.next_out = r),
              (A.avail_out = a),
              (A.next_in = o),
              (A.avail_in = s),
              (t.hold = g),
              (t.bits = c),
              (t.wsize || (l !== A.avail_out && t.mode < Ne && (t.mode < ke || e !== Qe))) &&
                Ve(A, A.output, A.next_out, l - A.avail_out),
              (I -= A.avail_in),
              (l -= A.avail_out),
              (A.total_in += I),
              (A.total_out += l),
              (t.total += l),
              4 & t.wrap &&
                l &&
                (A.adler = t.check =
                  t.flags ? G(t.check, n, l, A.next_out - l) : T(t.check, n, l, A.next_out - l)),
              (A.data_type =
                t.bits +
                (t.last ? 64 : 0) +
                (t.mode === Re ? 128 : 0) +
                (t.mode === Me || t.mode === xe ? 256 : 0)),
              ((0 === I && 0 === l) || e === Qe) && y === pe && (y = Fe),
              y
            );
          },
          inflateEnd: (A) => {
            if (Te(A)) return ye;
            let e = A.state;
            return e.window && (e.window = null), (A.state = null), pe;
          },
          inflateGetHeader: (A, e) => {
            if (Te(A)) return ye;
            const t = A.state;
            return 2 & t.wrap ? ((t.head = e), (e.done = !1), pe) : ye;
          },
          inflateSetDictionary: (A, e) => {
            const t = e.length;
            let i, n, o;
            return Te(A)
              ? ye
              : ((i = A.state),
                0 !== i.wrap && i.mode !== Se
                  ? ye
                  : i.mode === Se && ((n = 1), (n = T(n, e, t, 0)), n !== i.check)
                    ? De
                    : ((o = Ve(A, e, t, t)), o ? ((i.mode = 16210), we) : ((i.havedict = 1), pe)));
          },
          inflateInfo: "pako inflate (from Nodeca project)"
        },
        Xe = function () {
          (this.text = 0),
            (this.time = 0),
            (this.xflags = 0),
            (this.os = 0),
            (this.extra = null),
            (this.extra_len = 0),
            (this.name = ""),
            (this.comment = ""),
            (this.hcrc = 0),
            (this.done = !1);
        };
      const ze = Object.prototype.toString,
        {
          Z_NO_FLUSH: Ze,
          Z_FINISH: $e,
          Z_OK: At,
          Z_STREAM_END: et,
          Z_NEED_DICT: tt,
          Z_STREAM_ERROR: it,
          Z_DATA_ERROR: nt,
          Z_MEM_ERROR: ot
        } = Y;
      function rt(A) {
        this.options = HA({ chunkSize: 65536, windowBits: 15, to: "" }, A || {});
        const e = this.options;
        e.raw &&
          e.windowBits >= 0 &&
          e.windowBits < 16 &&
          ((e.windowBits = -e.windowBits), 0 === e.windowBits && (e.windowBits = -15)),
          !(e.windowBits >= 0 && e.windowBits < 16) || (A && A.windowBits) || (e.windowBits += 32),
          e.windowBits > 15 && e.windowBits < 48 && !(15 & e.windowBits) && (e.windowBits |= 15),
          (this.err = 0),
          (this.msg = ""),
          (this.ended = !1),
          (this.chunks = []),
          (this.strm = new _A()),
          (this.strm.avail_out = 0);
        let t = _e.inflateInit2(this.strm, e.windowBits);
        if (t !== At) throw new Error(H[t]);
        if (
          ((this.header = new Xe()),
          _e.inflateGetHeader(this.strm, this.header),
          e.dictionary &&
            ("string" == typeof e.dictionary
              ? (e.dictionary = jA(e.dictionary))
              : "[object ArrayBuffer]" === ze.call(e.dictionary) &&
                (e.dictionary = new Uint8Array(e.dictionary)),
            e.raw && ((t = _e.inflateSetDictionary(this.strm, e.dictionary)), t !== At)))
        )
          throw new Error(H[t]);
      }
      function st(A, e) {
        const t = new rt(e);
        if ((t.push(A), t.err)) throw t.msg || H[t.err];
        return t.result;
      }
      (rt.prototype.push = function (A, e) {
        const t = this.strm,
          i = this.options.chunkSize,
          n = this.options.dictionary;
        let o, r, s;
        if (this.ended) return !1;
        for (
          r = e === ~~e ? e : !0 === e ? $e : Ze,
            "[object ArrayBuffer]" === ze.call(A) ? (t.input = new Uint8Array(A)) : (t.input = A),
            t.next_in = 0,
            t.avail_in = t.input.length;
          ;

        ) {
          for (
            0 === t.avail_out &&
              ((t.output = new Uint8Array(i)), (t.next_out = 0), (t.avail_out = i)),
              o = _e.inflate(t, r),
              o === tt &&
                n &&
                ((o = _e.inflateSetDictionary(t, n)),
                o === At ? (o = _e.inflate(t, r)) : o === nt && (o = tt));
            t.avail_in > 0 && o === et && t.state.wrap > 0 && 0 !== A[t.next_in];

          )
            _e.inflateReset(t), (o = _e.inflate(t, r));
          switch (o) {
            case it:
            case nt:
            case tt:
            case ot:
              return this.onEnd(o), (this.ended = !0), !1;
          }
          if (((s = t.avail_out), t.next_out && (0 === t.avail_out || o === et)))
            if ("string" === this.options.to) {
              let A = VA(t.output, t.next_out),
                e = t.next_out - A,
                n = WA(t.output, A);
              (t.next_out = e),
                (t.avail_out = i - e),
                e && t.output.set(t.output.subarray(A, A + e), 0),
                this.onData(n);
            } else
              this.onData(
                t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out)
              );
          if (o !== At || 0 !== s) {
            if (o === et)
              return (o = _e.inflateEnd(this.strm)), this.onEnd(o), (this.ended = !0), !0;
            if (0 === t.avail_in) break;
          }
        }
        return !0;
      }),
        (rt.prototype.onData = function (A) {
          this.chunks.push(A);
        }),
        (rt.prototype.onEnd = function (A) {
          A === At &&
            ("string" === this.options.to
              ? (this.result = this.chunks.join(""))
              : (this.result = YA(this.chunks))),
            (this.chunks = []),
            (this.err = A),
            (this.msg = this.strm.msg);
        });
      var at = {
        Inflate: rt,
        inflate: st,
        inflateRaw: function (A, e) {
          return ((e = e || {}).raw = !0), st(A, e);
        },
        ungzip: st,
        constants: Y
      };
      const { Deflate: gt, deflate: ct, deflateRaw: It, gzip: lt } = ae,
        { Inflate: dt, inflate: ut, inflateRaw: Ct, ungzip: Bt } = at;
      var Qt = gt,
        Et = ct,
        ht = It,
        pt = lt,
        ft = dt,
        mt = ut,
        yt = Ct,
        Dt = Bt,
        wt = Y,
        Ft = {
          Deflate: Qt,
          deflate: Et,
          deflateRaw: ht,
          gzip: pt,
          Inflate: ft,
          inflate: mt,
          inflateRaw: yt,
          ungzip: Dt,
          constants: wt
        };
      (A.Deflate = Qt),
        (A.Inflate = ft),
        (A.constants = wt),
        (A.default = Ft),
        (A.deflate = Et),
        (A.deflateRaw = ht),
        (A.gzip = pt),
        (A.inflate = mt),
        (A.inflateRaw = yt),
        (A.ungzip = Dt),
        Object.defineProperty(A, "__esModule", { value: !0 });
    })(e);
  })(0, p.exports);
  var f = n(p.exports);
  function m() {
    return -1 !== document.location.search.indexOf("USE_DCV_WEBRTC_BETA_EXTENSION")
      ? u.BETA_CHROME
      : (function () {
            const A = window.navigator.userAgent.toLowerCase();
            return A.indexOf("edg/") > -1 || A.indexOf("edge") > -1;
          })()
        ? u.EDGE
        : u.CHROME;
  }
  class y {
    constructor(A) {
      if (
        ((this.version = t),
        (this.config = A),
        (this.logger = A.logger),
        (this.clientInfo = null),
        (this.certParams = { name: "ECDSA", namedCurve: "P-256" }),
        (this.extensionId = m()),
        console.debug(`Using extensionId: ${this.extensionId}`),
        (this.pcProxies = new Map()),
        (this.audioContextProxies = new Map()),
        (this.audioNodeProxies = new Map()),
        (this.workerProxies = new Map()),
        (this.streamProxies = new Map()),
        (this.eventListeners = new Map()),
        (this.mediaElementProxies = new Map()),
        (this.transceiverProxies = new Map()),
        (this.senderProxies = new Map()),
        (this.dtmfProxies = new Map()),
        (this.receiverProxies = new Map()),
        (this.trackProxies = new Map()),
        (this.overridenApis = new Map()),
        (this.decoder = new TextDecoder("utf-8")),
        (this.firedEvents = new Set()),
        (this.md = null),
        (this.devices = []),
        this.logger.debug(`Checking for chrome extension.  Chrome runtime: ${chrome.runtime}`),
        void 0 === chrome.runtime)
      )
        throw new Error(
          "Chrome runtime not available.  DCV WebRTC chrome extension may not be active."
        );
      this.overridenApis.set(
        "navigator.mediaDevices.getUserMedia",
        navigator.mediaDevices.getUserMedia
      ),
        this.overridenApis.set(
          "navigator.mediaDevices.addEventListener",
          navigator.mediaDevices.addEventListener
        ),
        this.overridenApis.set(
          "navigator.mediaDevices.removeEventListener",
          navigator.mediaDevices.removeEventListener
        ),
        this.overridenApis.set(
          "navigator.mediaDevices.enumerateDevices",
          navigator.mediaDevices.enumerateDevices
        ),
        this.overridenApis.set("window.RTCPeerConnection", window.RTCPeerConnection),
        this.overridenApis.set(
          "window.RTCPeerConnection.generateCertificate",
          window.RTCPeerConnection.generateCertificate
        ),
        this.overridenApis.set("window.AudioContext", window.AudioContext),
        this.overridenApis.set("window.Worker", window.Worker),
        (this.status = d.NEW),
        (this.statusChangeEventListeners = []),
        (this.lastHeartbeat = Date.now()),
        (this.heartbeatTimeout = null),
        (this.heartbeatTimeoutMs = 1e4),
        (this.heartbeatIntervalPeriodMs = 1e3),
        (this.heartbeatInterval = null),
        (this.enumerateDevicesInterval = null),
        (this.enumerateDevicesPeriodMs = 3e3);
    }
    clearHeartbeatInterval() {
      this.heartbeatTimeout &&
        (clearTimeout(this.heartbeatTimeout), (this.heartbeatTimeout = null)),
        this.hearbeatInterval &&
          (clearInterval(this.hearbeatInterval), (this.hearbeatInterval = null));
    }
    resetHeartbeat(A) {
      var e = this;
      this.clearHeartbeatInterval(),
        (this.heartbeatTimeoutMs =
          A && A.heartbeatTimeoutMs ? A.heartbeatTimeoutMs : this.heartbeatTimeoutMs),
        (this.heartbeatIntervalPeriodMs =
          A && A.heartbeatIntervalPeriodMs
            ? A.heartbeatIntervalPeriodMs
            : this.heartbeatIntervalPeriodMs),
        (this.hearbeatInterval = setInterval(async function () {
          e.heartbeatTimeout ||
            (e.heartbeatTimeout = setTimeout(function () {
              e.logger.debug(
                `heartbeatTimeout reached, current status: ${e.status}, last hb: ${Date.now() - e.lastHeartbeat}ms ago.`
              ),
                e.status !== d.UNAVAILABLE &&
                  ((e.status = d.UNAVAILABLE),
                  e.statusChangeEventListeners.forEach(function (A) {
                    A({ status: e.status, data: e.clientInfo, lastHeartbeat: e.lastHeartbeat });
                  }));
            }, e.heartbeatTimeoutMs));
          try {
            if (((e.clientInfo = await e.sendApiRequest(s.HELLO_API_NAME, [])), !e.clientInfo))
              throw new Error("Failed to get clientInfo.");
            e.heartbeatTimeout && (clearTimeout(e.heartbeatTimeout), (e.heartbeatTimeout = null)),
              e.status !== d.AVAILABLE &&
                ((e.status = d.AVAILABLE),
                e.statusChangeEventListeners.forEach(function (A) {
                  A({ status: e.status, data: e.clientInfo });
                })),
              (e.lastHeartbeat = Date.now());
          } catch (A) {
            e.logger.debug(
              `Heartbeat ping failed.  Last heartbeat received ${Date.now() - e.lastHeartbeat}ms ago.`
            );
          }
        }, this.heartbeatIntervalPeriodMs));
    }
    makeMediaDeviceInfoProxies(A) {
      return (
        A.forEach(function (A) {
          A.toJSON = function () {
            return A;
          };
        }),
        A
      );
    }
    makeTrackProxy(A) {
      var e = this;
      if (this.trackProxies.has(A.id)) {
        let e = this.trackProxies.get(A.id);
        return Object.assign(e, A), e;
      }
      return (
        this.trackProxies.set(A.id, A),
        (A.pendingEvents = new Map()),
        (A.stop = function () {
          e.sendApiRequest(s.TRACK_STOP_API_NAME, [A.id]);
        }),
        (A.getSettings = function () {
          return (
            e.sendApiRequest(s.TRACK_GET_SETTINGS, [A.id]).then(function (e) {
              e && (A.settings = e);
            }),
            A.settings
          );
        }),
        (A.addEventListener = function (t, i, n) {
          e.logger.debug("Setting ended event listener via addEventListener."),
            e.addTrackEventListener(A.id, t, i, n);
        }),
        (A.removeEventListener = function (t, i) {
          e.removeEventListener(A.id, t, i);
        }),
        Object.defineProperty(A, "onended", {
          set: function (t) {
            e.addTrackEventListener(A.id, g.ENDED, t);
          },
          get: function () {
            return null;
          }
        }),
        Object.defineProperty(A, "onmute", {
          set: function (t) {
            e.addTrackEventListener(A.id, g.MUTE, t);
          },
          get: function () {
            return null;
          }
        }),
        Object.defineProperty(A, "onunmute", {
          set: function (t) {
            e.addTrackEventListener(A.id, g.UNMUTE, t);
          },
          get: function () {
            return null;
          }
        }),
        (A.trackEnabled = A.enabled),
        Object.defineProperty(A, "enabled", {
          set: function (t) {
            (A.trackEnabled = t),
              e.sendApiRequest(s.TOGGLE_TRACK_ENABLED_API_NAME, [A.id, t]).then(function (t) {
                t && (e.trackProxies.get(A.id).trackEnabled = t.enabled);
              });
          },
          get: function () {
            return A.trackEnabled;
          }
        }),
        this.preRegisterEvents(g, A, this.addTrackEventListener),
        A
      );
    }
    makeStreamProxy(A) {
      var e = this;
      this.streamProxies.set(A.id, A);
      let t = new MediaStream();
      (t.type = "proxy"), (t.proxy = A);
      let i = A.tracks
        ? A.tracks.map(function (A) {
            return e.makeTrackProxy(A);
          })
        : [];
      return (
        (A.tracks = i),
        (t.getTracks = function () {
          return i;
        }),
        (t.getAudioTracks = function () {
          return i.filter(function (A) {
            return "audio" === A.kind;
          });
        }),
        (t.getVideoTracks = function () {
          return i.filter(function (A) {
            return "video" === A.kind;
          });
        }),
        (t.getTrackById = function (A) {
          return i.find(function (e) {
            return e.id === A;
          });
        }),
        (t.createMediaElement = function (A) {
          return e.createMediaElement(A);
        }),
        (t.addTrack = function (t) {
          e.sendApiRequest(s.STREAM_ADD_TRACK, [A.id, t.id]);
        }),
        (t.removeTrack = function (t) {
          e.sendApiRequest(s.STREAM_REMOVE_TRACK, [A.id, t.id]);
        }),
        t
      );
    }
    updateTransceiverProxy(A) {
      let e = this.transceiverProxies.get(A.id);
      return (
        e || (e = {}),
        Object.assign(e, A),
        A.receiver &&
          "proxy" === A.receiver.type &&
          (e.receiver = this.updateReceiverProxy(A.receiver)),
        A.sender && "proxy" === A.sender.type && (e.sender = this.updateSenderProxy(A.sender)),
        this.transceiverProxies.set(A.id, e),
        e
      );
    }
    updatePCSenders(A, e) {
      var t = this;
      let i = e.map(function (A) {
        return t.updateSenderProxy(A);
      });
      this.pcProxies.get(A).senders = i;
    }
    updatePCReceivers(A, e) {
      var t = this;
      let i = e.map(function (A) {
        return t.updateReceiverProxy(A);
      });
      this.pcProxies.get(A).receivers = i;
    }
    updatePCTransceivers(A, e) {
      var t = this;
      let i = e;
      i.forEach(function (A) {
        t.updateTransceiverProxy(A);
      }),
        (this.pcProxies.get(A).transceivers = i);
    }
    isValidApi(A) {
      let e = !1;
      for (const t in s)
        if (s[t] === A) {
          e = !0;
          break;
        }
      return e;
    }
    async sendApiRequest(A, e, t = crypto.randomUUID()) {
      this.logger.debug(A, e, t);
      try {
        const i = { api: A, args: e };
        let n = f.deflateRaw(JSON.stringify(i));
        const o = { requestId: t, message: n, type: "request" };
        this.logger.debug("Sending request:", JSON.stringify(o));
        let r = await chrome.runtime.sendMessage(this.extensionId, o);
        n = r.message;
        const s = f.inflateRaw(n),
          a = this.decoder.decode(s);
        if (
          ((r.message = JSON.parse(a)),
          this.logger.debug("Received response: ", JSON.stringify(r)),
          !r || !r.message || !r.type)
        ) {
          let A = `Received empty message or type, extensionResponse: ${JSON.stringify(r)}, request: ${JSON.stringify(o)}, message: ${JSON.stringify(i)}`;
          return this.logger.warn(A), null;
        }
        if ("error" === r.type) {
          let A = `Received error: ${JSON.stringify(r)}, for request: ${JSON.stringify(o)}, message: ${JSON.stringify(i)}`,
            e = null;
          if (
            (this.logger.debug(A),
            r.message.error && r.message.error.message && r.message.error && r.message.error.name)
          )
            throw (
              ((A = r.message.error.message), (e = r.message.error.name), new DOMException(A, e))
            );
          return null;
        }
        if ("response" !== r.type && "event" !== r.type && "error" !== r.type) {
          let A = `Received invalid message type, type: ${JSON.stringify(r.type)}, event: ${JSON.stringify(r)}, request: ${JSON.stringify(o)}, message: ${JSON.stringify(i)}`;
          return this.logger.warn(A), null;
        }
        if (r.message.api && !this.isValidApi(r.message.api)) {
          let A = `Received invalid message api, event: ${JSON.stringify(r)}, request: ${JSON.stringify(o)}, message: ${JSON.stringify(i)}`;
          return this.logger.warn(A), null;
        }
        return "event" === r.type ? r.message.event : r.message.response;
      } catch (i) {
        return (
          this.logger.warn(`Failed to send api request: api: ${A}, args: ${e}, requestId: ${t}`, i),
          null
        );
      }
    }
    async getUserMediaInternal(A) {
      let e = await this.sendApiRequest(s.GETUSERMEDIA_API_NAME, [A]);
      return e ? this.makeStreamProxy(e) : null;
    }
    getOverridenApi(A) {
      return this.overridenApis.get(A);
    }
    async getUserMedia(A) {
      const e = Object.freeze(A);
      if (e.audio && e.video) {
        let A = await navigator.permissions.query({ name: "microphone" }),
          t = await navigator.permissions.query({ name: "camera" });
        if (A && "granted" === A.state && t && "granted" === t.state)
          return await this.getUserMediaInternal(e);
      } else if (e.audio) {
        let A = await navigator.permissions.query({ name: "microphone" });
        if (A && "granted" === A.state) return await this.getUserMediaInternal(e);
      } else if (e.video) {
        let A = await navigator.permissions.query({ name: "camera" });
        if (A && "granted" === A.state) return await this.getUserMediaInternal(e);
      }
      let t = [];
      if (
        (e.video &&
          ((t = await this.getOverridenApi("navigator.mediaDevices.enumerateDevices").apply(
            navigator.mediaDevices
          )),
          (t = t.filter(function (A) {
            return A.kind && A.kind.indexOf("video") > -1;
          }))),
        (e.audio && !e.video) || (e.video && t.length > 0))
      ) {
        let A = await this.getOverridenApi("navigator.mediaDevices.getUserMedia").apply(
          navigator.mediaDevices,
          [e]
        );
        this.disposeStream(A);
      }
      return await this.getUserMediaInternal(e);
    }
    async enumerateDevices() {
      let A = await this.sendApiRequest(s.ENUMERATEDEVICES_API_NAME, []);
      return A ? this.makeMediaDeviceInfoProxies(A) : [];
    }
    getVersion() {
      return t;
    }
    makeReceiverProxy(A) {
      var e = this;
      return (
        A.track && (A.track = this.makeTrackProxy(A.track)),
        (A.getSynchronizationSources = function () {
          return A.synchronizationSources;
        }),
        (A.getStats = async function () {
          const t = await e.sendApiRequest(s.GET_RECEIVER_STATS_API_NAME, [A.id]);
          let i = new Map();
          return (
            t &&
              t.forEach(function (A) {
                i.set(A.id, A);
              }),
            i
          );
        }),
        (A.createEncodedStreams = function () {
          let t = {
            id: crypto.randomUUID(),
            type: "proxy",
            readable: { id: crypto.randomUUID(), type: "proxy" },
            writable: { id: crypto.randomUUID(), type: "proxy" }
          };
          return (
            e.streamProxies.set(t.id, t),
            e.sendApiRequest(s.RECEIVER_CREATE_ENCODED_STREAMS, [A.id, t]),
            t
          );
        }),
        this.receiverProxies.set(A.id, A),
        A
      );
    }
    makeDTMFProxy(A) {
      var e = this;
      let t = A;
      return (
        this.dtmfProxies.has(t.id)
          ? ((t = this.dtmfProxies.get(t.id)), Object.assign(t, A))
          : (this.dtmfProxies.set(t.id, t),
            (t.pendingEvents = new Map()),
            (t.insertDTMF = function (A, i, n) {
              e.sendApiRequest(s.INSERT_DTMF_API_NAME, [t.id, A, i, n]);
            }),
            (t.addEventListener = function (A, i, n) {
              e.addDtmfEventListener(t.id, A, i, n);
            }),
            (t.removeEventListener = function (A, i) {
              e.removeEventListener(t.id, A, i);
            }),
            Object.defineProperty(t, "ontonechange", {
              set: function (A) {
                e.addDtmfEventListener(t.id, c.TONECHANGE, A);
              },
              get: function () {
                return null;
              }
            }),
            this.preRegisterEvents(c, t, this.addDtmfEventListener)),
        t
      );
    }
    makeSenderProxy(A) {
      var e = this;
      return (
        A.track && (A.track = this.makeTrackProxy(A.track)),
        A.dtmf && (A.dtmf = this.makeDTMFProxy(A.dtmf)),
        (A.getStats = async function () {
          let t = await e.sendApiRequest(s.GET_SENDER_STATS_API_NAME, [A.id]);
          return (
            t &&
              ((t.has = function (A) {
                return (
                  void 0 !==
                  t.find(function (e) {
                    return e.id === A;
                  })
                );
              }),
              (t.get = function (A) {
                return t.find(function (e) {
                  return e.id === A;
                });
              })),
            t
          );
        }),
        (A.replaceTrack = function (t) {
          return (A.track = t), e.sendApiRequest(s.REPLACE_SENDER_TRACK_API_NAME, [A.id, t]);
        }),
        (A.createEncodedStreams = function () {
          let t = {
            id: crypto.randomUUID(),
            type: "proxy",
            readable: { type: "proxy", id: crypto.randomUUID() },
            writable: { type: "proxy", id: crypto.randomUUID() }
          };
          return (
            e.streamProxies.set(t.id, t),
            e.sendApiRequest(s.SENDER_CREATE_ENCODED_STREAMS, [A.id, t]),
            t
          );
        }),
        A
      );
    }
    updateSenderProxy(A) {
      let e = this.senderProxies.get(A.id);
      return (
        e ? Object.assign(e, A) : ((e = A), this.senderProxies.set(A.id, e)),
        this.makeSenderProxy(e)
      );
    }
    updateReceiverProxy(A) {
      let e = this.receiverProxies.get(A.id);
      return (
        e ? Object.assign(e, A) : ((e = A), this.receiverProxies.set(A.id, e)),
        this.makeReceiverProxy(e)
      );
    }
    addTrack(A, e) {
      var t = this;
      let i = crypto.randomUUID();
      this.sendApiRequest(s.ADD_TRACK_API_NAME, [i, ...arguments]).then(function (A) {
        A &&
          (t.updateSenderProxy(A),
          t.updatePCSenders(A.pcId, A.senders),
          t.updatePCReceivers(A.pcId, A.receivers),
          t.updatePCTransceivers(A.pcId, A.transceivers));
      });
      let n = this.updateSenderProxy({ id: i });
      return this.pcProxies.get(A).senders.push(n), n;
    }
    updatePeerConnectionProxy(A) {
      let e = this.pcProxies.get(A.pcId);
      Object.assign(e, A),
        this.updatePCSenders(A.pcId, A.senders),
        this.updatePCReceivers(A.pcId, A.receivers),
        this.updatePCTransceivers(A.pcId, A.transceivers);
    }
    createPeerConnection(A, e) {
      var t = this;
      let i = crypto.randomUUID(),
        n = this;
      this.logger.debug(`Creating RTCPeerConnection with id: ${i}`);
      let o = {
        type: "proxy",
        id: i,
        signalingState: "new",
        connectionState: "new",
        iceConnectionState: "new",
        iceGatheringState: "new",
        receivers: [],
        senders: [],
        transceivers: [],
        pendingEvents: new Map(),
        configuration: A,
        close: function () {
          t.close(i);
        },
        addStream: function (A) {
          t.addStream(i, A);
        },
        getConfiguration: function () {
          return (
            t.sendApiRequest(s.PC_GET_CONFIGURATION, [i]).then(function (A) {
              A && (o.configuration = A);
            }),
            o.configuration
          );
        },
        getStats: function (A) {
          return t.getStats(i, A);
        },
        createOffer: function (A) {
          return t.createOffer(i, A);
        },
        createAnswer: function (A) {
          return t.createAnswer(i, A);
        },
        setLocalDescription: function (A) {
          return t.setLocalDescription(i, A);
        },
        addEventListener: function (A, e) {
          t.addPeerConnectionEventListener(i, A, e);
        },
        removeEventListener: function (A, e) {
          t.removeEventListener(i, A, e);
        },
        getEventListener: function (A) {
          return t.eventListeners.get(i).get(A);
        },
        set onicecandidate(A) {
          this.addEventListener(a.ICE_CANDIDATE, A);
        },
        get onicecandidate() {
          return this.getEventListener(a.ICE_CANDIDATE);
        },
        set ontrack(A) {
          this.addEventListener(a.TRACK, A);
        },
        get ontrack() {
          return this.getEventListener(a.TRACK);
        },
        get onsignalingstatechange() {
          return this.getEventListener(a.SIG_STATE_CHANGE);
        },
        set onsignalingstatechange(A) {
          this.addEventListener(a.SIG_STATE_CHANGE, A);
        },
        get onconnectionstatechange() {
          return this.getEventListener(a.CONN_STATE_CHANGE);
        },
        set onconnectionstatechange(A) {
          this.addEventListener(a.CONN_STATE_CHANGE, A);
        },
        get oniceconnectionstatechange() {
          return this.getEventListener(a.ICE_CONN_STATE_CHANGE);
        },
        set oniceconnectionstatechange(A) {
          this.addEventListener(a.ICE_CONN_STATE_CHANGE, A);
        },
        get onicegatheringstatechange() {
          return this.getEventListener(a.ICE_GATHER_STATE_CHANGE);
        },
        set onicegatheringstatechange(A) {
          this.addEventListener(a.ICE_GATHER_STATE_CHANGE, A);
        },
        get onnegotiationneeded() {
          return this.getEventListener(a.NEGOTIATION_NEEDED);
        },
        set onnegotiationneeded(A) {
          this.addEventListener(a.NEGOTIATION_NEEDED, A);
        },
        setRemoteDescription: function (A) {
          return t.setRemoteDescription(i, A);
        },
        addIceCandidate: function (A) {
          return t.addIceCandidate(i, A);
        },
        getRemoteStreams: function () {
          return t.logger.warn("getRemoteStreams not implemented on proxy."), [];
        },
        getReceivers: function () {
          return t.getReceivers(i);
        },
        getSenders: function () {
          return t.getSenders(i);
        },
        addTrack: function (A) {
          let e = [i, ...arguments];
          return n.addTrack.apply(n, e);
        },
        addTransceiver: function (A, e) {
          return t.addTransceiver(i, A, e);
        },
        getTransceivers: function () {
          return t.getTransceivers(i);
        },
        removeTrack: function (A) {
          t.removeTrack(i, A);
        }
      };
      return (
        this.pcProxies.set(i, o),
        this.sendApiRequest(s.NEWRTCPEERCONNECTION_API_NAME, [i, A, e], i).then(
          function (A) {
            A && t.updatePeerConnectionProxy(A);
          },
          function (A) {
            t.logger.error(`Error creating proxied RTCPeerConnection: ${A}`);
          }
        ),
        this.preRegisterEvents(a, this.pcProxies.get(i), this.addPeerConnectionEventListener),
        this.pcProxies.get(i)
      );
    }
    preRegisterEvents(A, e, t) {
      for (const i in A)
        "string" == typeof A[i] &&
          t.apply(this, [
            e.id,
            A[i],
            function (A) {
              e.pendingEvents.has(A.eventName) || e.pendingEvents.set(A.eventName, []),
                e.pendingEvents.get(A.eventName).push(A);
            }
          ]);
    }
    updateAudioContextProxy(A) {
      let e = this.audioContextProxies.get(A.id);
      Object.assign(e, A);
    }
    updateAudioNodeProxy(A) {
      let e = this.audioNodeProxies.get(A.id);
      Object.assign(e, A), A.stream && this.makeStreamProxy(A.stream);
    }
    makeAudioNodeProxy(A, e) {
      var t = this;
      return {
        type: "proxy",
        id: e,
        context: this.audioContextProxies.get(A),
        connect: function (A, i, n) {
          return t.sendApiRequest(s.AUDIO_NODE_CONNECT, [e, A, i, n]), A;
        },
        disconnect: function (A, i, n) {
          t.sendApiRequest(s.AUDIO_NODE_DISCONNECT, [e, A, i, n]);
        }
      };
    }
    createAudioNode(A, e, t) {
      var i = this;
      let n = crypto.randomUUID();
      return (
        this.audioNodeProxies.set(n, this.makeAudioNodeProxy(A, n)),
        this.sendApiRequest(s.AUDIO_CTX_CREATE_AUDIO_NODE, [A, n, e, t], n).then(
          function (A) {
            A && i.updateAudioNodeProxy(A);
          },
          function (A) {
            i.logger.error(`Error creating proxied ${e}: ${A}`);
          }
        ),
        this.audioNodeProxies.get(n)
      );
    }
    makeWorkerProxy(A) {
      var e = this;
      let t = {
        id: A,
        pendingEvents: new Map(),
        type: "proxy",
        postMessage: function (t, i) {
          e.sendApiRequest(s.WORKER_POST_MESSAGE, [A, t, i]);
        },
        terminate: function () {
          e.sendApiRequest(s.WORKER_TERMINATE, [A]);
        },
        addEventListener: function (A, i, n) {
          e.addWorkerEventListener(t.id, A, i, n);
        },
        removeEventListener: function (A, i) {
          e.removeEventListener(t.id, A, i);
        }
      };
      return (
        Object.defineProperty(t, "onerror", {
          set: function (A) {
            e.addWorkerEventListener(t.id, I.ERROR, A);
          },
          get: function () {
            return null;
          }
        }),
        Object.defineProperty(t, "onmessage", {
          set: function (A) {
            e.addWorkerEventListener(t.id, I.MESSAGE, A);
          },
          get: function () {
            return null;
          }
        }),
        Object.defineProperty(t, "onmessageerror", {
          set: function (A) {
            e.addWorkerEventListener(t.id, I.MESSAGE_ERROR, A);
          },
          get: function () {
            return null;
          }
        }),
        t
      );
    }
    createWorker(A, e) {
      var t = this;
      let i = crypto.randomUUID(),
        n = this.makeWorkerProxy(i);
      return (
        this.workerProxies.set(i, n),
        fetch(A).then(function (A) {
          A.blob().then(function (A) {
            A.arrayBuffer().then(function (n) {
              let o = E(n);
              t.sendApiRequest(s.CREATE_WORKER, [i, A.type, o, e]).then(function (A) {
                t.logger.debug(`Created worker: ${JSON.stringify(A)}`);
              });
            });
          });
        }),
        this.logger.debug(`Preregistering events for worker: ${JSON.stringify(n)}`),
        this.preRegisterEvents(I, n, this.addWorkerEventListener),
        n
      );
    }
    createAudioContext() {
      var A = this;
      let e = crypto.randomUUID(),
        t = crypto.randomUUID();
      return (
        this.audioContextProxies.set(e, {
          type: "proxy",
          id: e,
          destination: this.makeAudioNodeProxy(e, t),
          createGain: function () {
            let t = A.createAudioNode(e, "Gain", []),
              i = {
                setValueAtTime: function (e, n) {
                  return (
                    (i.currentValue = e),
                    A.sendApiRequest(s.AUDIO_PARAM_SET_VALUE_AT_TIME, [t.id, e, n]),
                    i
                  );
                },
                linearRampToValueAtTime: function (e, n) {
                  return A.sendApiRequest(s.AUDIO_PARAM_SET_RAMP_TO_VALUE_AT_TIME, [t.id, e, n]), i;
                }
              };
            return (
              Object.defineProperty(i, "value", {
                set: function (A) {
                  return i.setValueAtTime(A, 0);
                },
                get: function () {
                  return i.currentValue;
                }
              }),
              (t.gain = i),
              t
            );
          },
          createOscillator: function () {
            let t = A.createAudioNode(e, "Oscillator", []);
            (t.start = function (e = 0) {
              A.sendApiRequest(s.AUDIO_NODE_START, [t.id, e]);
            }),
              (t.stop = function (e = 0) {
                A.sendApiRequest(s.AUDIO_NODE_STOP, [t.id, e]);
              }),
              Object.defineProperty(t, "type", {
                set: function (e) {
                  (t.currentType = e), A.sendApiRequest(s.AUDIO_NODE_SET_TYPE, [t.id, e]);
                },
                get: function () {
                  return t.currentType;
                }
              });
            let i = {
              setValueAtTime: function (e, n) {
                return A.sendApiRequest(s.AUDIO_PARAM_SET_VALUE_AT_TIME, [t.id, e, n]), i;
              }
            };
            return (
              Object.defineProperty(i, "value", {
                set: function (A) {
                  return i.setValueAtTime(A, 0);
                },
                get: function () {
                  return i.currentValue;
                }
              }),
              (t.frequency = i),
              t
            );
          },
          createMediaStreamSource: function (t) {
            return A.createAudioNode(e, "MediaStreamSource", [t.proxy]);
          },
          createAnalyser: function () {
            return A.createAudioNode(e, "Analyser", []);
          },
          createMediaStreamDestination: function () {
            let t = A.createAudioNode(e, "MediaStreamDestination", []);
            return (
              (t.stream = A.makeStreamProxy({ id: t.id, tracks: [{ id: t.id, kind: "audio" }] })), t
            );
          },
          close: function () {
            return A.sendApiRequest(s.AUDIO_CTX_CLOSE, [e]);
          }
        }),
        this.sendApiRequest(s.NEW_AUDIO_CONTEXT, [e, t], e).then(
          function (e) {
            e && A.updateAudioContextProxy(e);
          },
          function (e) {
            A.logger.error(`Error creating proxied AudioContext: ${e}`);
          }
        ),
        this.audioContextProxies.get(e)
      );
    }
    close(A) {
      this.eventListeners.get(A).clear(), this.sendApiRequest(s.PC_CLOSE_API_NAME, [A]);
    }
    addStream(A, e) {
      this.sendApiRequest(s.ADDSTREAM_API_NAME, [A, e.proxy]);
    }
    getStats(A, e) {
      return "function" == typeof e
        ? Promise.reject(new Error("callback based getStats is obsolete."))
        : this.sendApiRequest(s.GET_STATS_API_NAME, [A, e]);
    }
    createOffer(A, e) {
      return this.sendApiRequest(s.CREATE_OFFER_API_NAME, [A, e]);
    }
    createAnswer(A, e) {
      return this.sendApiRequest(s.CREATE_ANSWER_API_NAME, [A, e]);
    }
    setLocalDescription(A, e) {
      return (
        (this.pcProxies.get(A).localDescription = e),
        this.sendApiRequest(s.SET_LOCAL_DESCRIPTION_API_NAME, [A, e])
      );
    }
    setRemoteDescription(A, e) {
      return this.sendApiRequest(s.SET_REMOTE_DESCRIPTION_API_NAME, [A, e]);
    }
    handleAddEventListenerResponse(A) {
      var e = this;
      A.eventName === a.SIG_STATE_CHANGE
        ? this.updatePeerConnectionProxy(A)
        : A.eventName === a.TRACK
          ? ((A.streams = A.streams.map(function (A) {
              return e.makeStreamProxy(A);
            })),
            (A.track = this.makeTrackProxy(A.track)),
            this.updatePeerConnectionProxy(A))
          : (A.eventName === a.CONN_STATE_CHANGE ||
              A.eventName === a.ICE_CONN_STATE_CHANGE ||
              A.eventName === a.ICE_GATHER_STATE_CHANGE ||
              A.eventName === a.ICE_CANDIDATE ||
              A.eventName === a.NEGOTIATION_NEEDED) &&
            this.updatePeerConnectionProxy(A),
        this.fireUpEventHandlers(this.pcProxies.get(A.pcId), A),
        this.sendApiRequest(s.ADD_PC_EVENT_LISTENER, [A.pcId, A.eventName]).then(function (A) {
          A && e.handleAddEventListenerResponse(A);
        });
    }
    fireUpEventHandlers(A, e) {
      if (A && this.eventListeners.get(A.id).has(e.eventName)) {
        let t = A.pendingEvents;
        this.eventListeners
          .get(A.id)
          .get(e.eventName)
          .forEach(function (A, i) {
            0 === i
              ? A(e)
              : t.get(e.eventName).forEach(function (e) {
                  A(e);
                });
          }),
          t.set(e.eventName, []);
      }
    }
    handleAddTrackEventListenerResponse(A) {
      var e = this;
      ("mute" !== A.eventName && "unmute" !== A.eventName) ||
        (this.trackProxies.get(A.trackId).muted = A.muted),
        this.fireUpEventHandlers(this.trackProxies.get(A.trackId), A),
        this.sendApiRequest(s.ADD_TRACK_EVENT_LISTENER, [A.trackId, A.eventName]).then(
          function (A) {
            A && e.handleAddTrackEventListenerResponse(A);
          }
        );
    }
    handleAddDtmfEventListenerResponse(A) {
      var e = this;
      this.fireUpEventHandlers(this.dtmfProxies.get(A.dtmfId), A),
        this.sendApiRequest(s.ADD_DTMF_EVENT_LISTENER, [A.dtmfId, A.eventName]).then(function (A) {
          A && e.handleAddDtmfEventListenerResponse(A);
        });
    }
    handleAddWorkerEventListenerResponse(A) {
      var e = this;
      this.fireUpEventHandlers(this.workerProxies.get(A.wId), A),
        this.sendApiRequest(s.ADD_WORKER_EVENT_LISTENER, [A.wId, A.eventName]).then(function (A) {
          A && e.handleAddWorkerEventListenerResponse(A);
        });
    }
    handleAddMediaDevicesEventListenerResponse(A) {
      var e = this;
      let t = this.md;
      this.firedEvents.has(A.id) || (this.fireUpEventHandlers(t, A), this.firedEvents.add(A.id)),
        this.sendApiRequest(s.ADD_MEDIADEVICES_EVENT_LISTENER, [A.mdId, A.eventName]).then(
          function (A) {
            A && e.handleAddMediaDevicesEventListenerResponse(A);
          }
        );
    }
    addEventListener(A, e, t) {
      this.eventListeners.has(A) || this.eventListeners.set(A, new Map()),
        this.eventListeners.get(A).has(e) || this.eventListeners.get(A).set(e, []),
        this.eventListeners.get(A).get(e).push(t);
    }
    addPeerConnectionEventListener(A, e, t) {
      var i = this;
      this.addEventListener(A, e, t),
        this.sendApiRequest(s.ADD_PC_EVENT_LISTENER, [A, e]).then(function (A) {
          A && i.handleAddEventListenerResponse(A);
        });
    }
    addTrackEventListener(A, e, t, i) {
      var n = this;
      this.addEventListener(A, e, t),
        this.sendApiRequest(s.ADD_TRACK_EVENT_LISTENER, [A, e, i]).then(function (A) {
          A && n.handleAddTrackEventListenerResponse(A);
        });
    }
    addDtmfEventListener(A, e, t, i) {
      var n = this;
      this.addEventListener(A, e, t),
        this.sendApiRequest(s.ADD_DTMF_EVENT_LISTENER, [A, e, i]).then(function (A) {
          A && n.handleAddDtmfEventListenerResponse(A);
        });
    }
    addWorkerEventListener(A, e, t) {
      var i = this;
      this.addEventListener(A, e, t),
        this.sendApiRequest(s.ADD_WORKER_EVENT_LISTENER, [A, e]).then(function (A) {
          A && i.handleAddWorkerEventListenerResponse(A);
        });
    }
    fireSingleEvent(A, e) {
      A &&
        this.eventListeners.get(A.id).has(e.eventName) &&
        this.eventListeners
          .get(A.id)
          .get(e.eventName)
          .forEach(function (A) {
            A(e);
          });
    }
    fireDeviceChangeEvent(A) {
      const e = {
        id: crypto.randomUUID(),
        mdId: A.id,
        eventName: l.DEVICECHANGE,
        type: l.DEVICECHANGE
      };
      this.fireSingleEvent(A, e);
    }
    isUndefinedOrNull(A) {
      return null == A;
    }
    isObject(A) {
      return !this.isUndefinedOrNull(A) && "object" == typeof A && !Array.isArray(A);
    }
    mediaDeviceInfoAreEqual(A, e) {
      return (
        !(!this.isObject(A) || !this.isObject(e)) &&
        A.kind === e.kind &&
        A.deviceId === e.deviceId &&
        A.groupId === e.groupId &&
        A.label === e.label
      );
    }
    defaultDeviceChanged(A, e) {
      return A.length > 0 && e.length > 0 && !this.mediaDeviceInfoAreEqual(A[0], e[0]);
    }
    addMediaDevicesEventListener(A, e, t) {
      var i = this;
      this.addEventListener(A, e, t),
        this.isClientNiva()
          ? this.enumerateDevicesInterval ||
            (this.enumerateDevicesInterval = setInterval(async function () {
              const A = await i.enumerateDevices(),
                e = Math.abs(i.devices.length - A.length);
              if (e > 0) for (let A = 0; A < e; A++) i.fireDeviceChangeEvent(i.md);
              else {
                const e = i.devices.filter(function (A) {
                    return "audioinput" === A.kind;
                  }),
                  t = A.filter(function (A) {
                    return "audioinput" === A.kind;
                  });
                i.defaultDeviceChanged(e, t) && i.fireDeviceChangeEvent(i.md);
                const n = i.devices.filter(function (A) {
                    return "audiooutput" === A.kind;
                  }),
                  o = A.filter(function (A) {
                    return "audiooutput" === A.kind;
                  });
                i.defaultDeviceChanged(n, o) && i.fireDeviceChangeEvent(i.md);
              }
              i.devices = A;
            }, this.enumerateDevicesPeriodMs))
          : this.sendApiRequest(s.ADD_MEDIADEVICES_EVENT_LISTENER, [A, e]).then(function (A) {
              A && i.handleAddMediaDevicesEventListenerResponse(A);
            });
    }
    removeEventListener(A, e, t) {
      let i = this.eventListeners.get(A).get(e);
      const n = i.indexOf(t);
      n > -1 && i.splice(n, 1);
    }
    addIceCandidate(A, e) {
      let t = e
        ? { sdpMLineIndex: e.sdpMLineIndex, sdpMid: e.sdpMid, candidate: e.candidate }
        : null;
      return this.sendApiRequest(s.ADD_ICE_CANDIDATE_API_NAME, [A, t]);
    }
    createMediaElement(A) {
      var e = this;
      let t = crypto.randomUUID();
      this.sendApiRequest(s.CREATE_MEDIA_ELEMENT_API_NAME, [t, A], t).then(function (A) {
        A && (e.mediaElementProxies.get(A.id).sinkId = A.sinkId);
      });
      let i = {
        id: t,
        type: "proxy",
        classList: new Set(),
        isMuted: !1,
        play: function () {
          e.sendApiRequest(s.MEDIA_ELEMENT_PLAY_API_NAME, [t]);
        },
        pause: function () {
          e.sendApiRequest(s.MEDIA_ELEMENT_PAUSE_API_NAME, [t]);
        },
        setSinkId: function (A) {
          return e.sendApiRequest(s.MEDIA_ELEMENT_SET_SINK_ID_API_NAME, [t, A]);
        },
        remove: function () {
          return e.sendApiRequest(s.MEDIA_ELEMENT_REMOVE, [t]);
        }
      };
      return (
        this.mediaElementProxies.set(t, i),
        (i.classList.remove = function (A) {
          i.classList.delete(A);
        }),
        Object.assign(i, A),
        Object.defineProperty(i, "srcObject", {
          set: function (A) {
            (i.stream = A),
              e.sendApiRequest(s.SET_MEDIA_SRC_OBJ_API_NAME, [i.id, A && A.proxy ? A.proxy : A]);
          },
          get: function () {
            return i.stream;
          }
        }),
        Object.defineProperty(i, "hidden", {
          set: function (A) {
            e.sendApiRequest(s.SET_MEDIA_HIDDEN_API_NAME, [i.id, A]);
          },
          get: function () {
            return i.hidden;
          }
        }),
        Object.defineProperty(i, "volume", {
          set: function (A) {
            e.sendApiRequest(s.SET_MEDIA_VOLUME_API_NAME, [i.id, A]);
          },
          get: function () {
            return i.volume;
          }
        }),
        Object.defineProperty(i, "muted", {
          set: function (A) {
            (i.isMuted = A),
              e.sendApiRequest(s.MEDIA_ELEMENT_MUTED, [i.id, A]).then(function (A) {
                A && (i.isMuted = A.muted);
              });
          },
          get: function () {
            return i.isMuted;
          }
        }),
        i
      );
    }
    generateCertificate(A) {
      return this.sendApiRequest(s.GENERATE_CERTIFICATE_API_NAME, [A]);
    }
    getReceivers(A) {
      var e = this;
      return (
        this.sendApiRequest(s.GET_RECEIVERS_API_NAME, [A]).then(function (A) {
          A && e.updatePCReceivers(A.pcId, A.receivers);
        }),
        this.pcProxies.get(A).receivers
      );
    }
    getSenders(A) {
      var e = this;
      return (
        this.sendApiRequest(s.GET_SENDERS_API_NAME, [A]).then(function (A) {
          A && e.updatePCSenders(A.pcId, A.senders);
        }),
        this.pcProxies.get(A).senders
      );
    }
    removeTrack(A, e) {
      this.sendApiRequest(s.PC_REMOVE_TRACK_API_NAME, [A, e]);
    }
    getTransceivers(A) {
      var e = this;
      return (
        this.sendApiRequest(s.GET_TRANSCEIVERS_API_NAME, [A]).then(function (A) {
          A && e.updatePCTransceivers(A.pcId, A.transceivers);
        }),
        this.pcProxies.get(A).transceivers
      );
    }
    addTransceiver(A, e, t) {
      var i = this;
      let n = crypto.randomUUID(),
        o = {
          type: "proxy",
          id: n,
          sender: this.makeSenderProxy({ id: crypto.randomUUID() }),
          receiver: this.makeReceiverProxy({ id: crypto.randomUUID() }),
          setCodecPreferences: function (A) {
            i.sendApiRequest(s.TRANSCEIVER_SET_CODEC_PREFS, [n, A]);
          }
        };
      return (
        this.transceiverProxies.set(o.id, o),
        this.pcProxies.get(A).transceivers.push(o),
        this.pcProxies.get(A).receivers.push(o.receiver),
        this.pcProxies.get(A).senders.push(o.sender),
        this.sendApiRequest(s.ADD_TRANSCEIVER_API_NAME, [
          A,
          o,
          "string" == typeof e ? e : this.makeTrackProxy(e),
          t
        ]).then(function (A) {
          A &&
            (i.updateTransceiverProxy(A),
            i.updatePCSenders(A.pcId, A.senders),
            i.updatePCReceivers(A.pcId, A.receivers),
            i.updatePCTransceivers(A.pcId, A.transceivers));
        }),
        o
      );
    }
    setLogger(A) {
      this.logger = A;
    }
    addMediaDevicesProxyMethods(A) {
      var e = this;
      (A.getUserMedia = function (A) {
        return e.getUserMedia(A);
      }),
        (A.enumerateDevices = function () {
          return e.enumerateDevices();
        }),
        (A.addEventListener = function (t, i, n) {
          e.logger.debug(`Setting mediaDevices ${t} event listener via addEventListener.`),
            e.addMediaDevicesEventListener(A.id, t, i, n);
        }),
        (A.removeEventListener = function (t, i) {
          e.removeEventListener(A.id, t, i);
        }),
        Object.defineProperty(A, "ondevicechange", {
          set: function (t) {
            e.addMediaDevicesEventListener(A.id, l.DEVICECHANGE, t);
          },
          get: function () {
            return null;
          },
          configurable: !0
        });
    }
    isClientNiva() {
      if (this.clientInfo && this.clientInfo.userAgent) {
        const A = new RegExp("AFTGAZLTC;"),
          e = this.clientInfo.userAgent.match(A);
        return null !== e && e.length > 0;
      }
      return !1;
    }
    disposeStream(A) {
      A.getTracks().forEach(function (e) {
        e.stop(), A.removeTrack(e);
      });
    }
    makeMediaDevicesProxy() {
      var A = this;
      return (
        this.md ||
          ((this.md = { type: "proxy", id: crypto.randomUUID(), pendingEvents: new Map() }),
          this.addMediaDevicesProxyMethods(this.md),
          this.isClientNiva()
            ? this.getUserMedia({ audio: !0 }).then(function (e) {
                A.enumerateDevices().then(function (e) {
                  A.devices = e;
                }),
                  A.disposeStream(e);
              })
            : this.preRegisterEvents(l, this.md, this.addMediaDevicesEventListener)),
        this.md
      );
    }
    overrideWebRTC() {
      this.logger.info("Overriding WebRTC interfaces for the current webapp.");
      let A = this;
      Object.assign(navigator.mediaDevices, this.makeMediaDevicesProxy()),
        this.addMediaDevicesProxyMethods(navigator.mediaDevices),
        (window.RTCPeerConnection = function (e, t) {
          return A.createPeerConnection(e, t);
        }),
        (window.RTCPeerConnection.generateCertificate = function (e) {
          return A.generateCertificate(e);
        }),
        (window.AudioContext = function () {
          return A.createAudioContext();
        }),
        (window.Worker = function (e, t) {
          return A.createWorker(e, t);
        });
    }
    removeStatusChangeEventListener(A) {
      this.statusChangeEventListeners = this.statusChangeEventListeners.filter(function (e) {
        return e !== A;
      });
    }
    addStatusChangeEventListener(A) {
      this.statusChangeEventListeners.push(A);
    }
    async sendHelloRequest() {
      var A = this;
      let e = await this.sendApiRequest(s.HELLO_API_NAME, []);
      return (
        e &&
          !globalThis.DCVWebRTCRedirProxy &&
          ((this.status = d.AVAILABLE),
          this.logger.info(
            `Running in a DCV WebRTC redirection env, proxy version: ${t.versionStr} - ${t.gitHash}`
          ),
          this.logger.info(`Client info: ${JSON.stringify(e)}`),
          window.addEventListener("beforeunload", function (e) {
            let t = {
              pcIds: [],
              streamIds: [],
              mediaElementIds: [],
              transceiverIds: [],
              senderIds: [],
              receiverIds: [],
              trackIds: [],
              workerIds: []
            };
            A.pcProxies.forEach(function (A, e) {
              t.pcIds.push(e);
            }),
              A.streamProxies.forEach(function (A, e) {
                t.streamIds.push(e);
              }),
              A.trackProxies.forEach(function (A, e) {
                t.trackIds.push(e);
              }),
              A.workerProxies.forEach(function (A, e) {
                t.workerIds.push(e);
              }),
              A.mediaElementProxies.forEach(function (A, e) {
                t.mediaElementIds.push(e);
              }),
              A.transceiverProxies.forEach(function (A, e) {
                t.transceiverIds.push(e);
              }),
              A.senderProxies.forEach(function (A, e) {
                t.senderIds.push(e);
              }),
              A.receiverProxies.forEach(function (A, e) {
                t.receiverIds.push(e);
              }),
              A.sendApiRequest(s.UNLOAD_EVENT_NAME, [t]);
          })),
        e
      );
    }
    static setInitCallback(A, e) {
      const t = globalThis.DCVWebRTCRedirProxy;
      if (t) A({ success: !0, proxy: t });
      else {
        y.initCallbacks || (y.initCallbacks = new Map());
        const t = setTimeout(function () {
          A({ success: !1, error: `Failed to initialize DCVWebRTCPeerConnectionProxy in ${e}ms` }),
            y.initCallbacks.delete(A);
        }, e);
        y.initCallbacks.set(A, t);
      }
    }
  }
  function D(A, e, t) {
    (globalThis.DCVWebRTCRedirProxy = e),
      y.initCallbacks
        ? (y.initCallbacks.forEach(function (i, n) {
            clearTimeout(i), n({ success: A, proxy: e, error: t });
          }),
          y.initCallbacks.clear())
        : r.debug("No DCVWebRTCPeerConnectionProxy.initCallback was specified.");
  }
  try {
    window.DCVWebRTCPeerConnectionProxy = y;
    let A = new y({ logger: r });
    A.sendHelloRequest()
      .then(function (e) {
        if (e)
          r.debug(`Successfully received hello response from client: ${JSON.stringify(e)}`),
            (A.clientInfo = e),
            A.resetHeartbeat(null),
            D(!0, A);
        else {
          const A =
            "Running in an invalid dcv webrtc env, skipping setting up proxy (empty result).";
          r.debug(A), D(!1, null, A);
        }
      })
      .catch(function (A) {
        const e = `Running in an invalid dcv webrtc env, skipping setting up proxy: ${JSON.stringify(A)}`;
        r.debug(e), D(!1, null, e);
      });
  } catch (e) {
    const A = e.message;
    D(!1, null, A), r.debug(`Skipping setting up proxy in client env: ${A}`);
  }
  e.DCVWebRTCRedirClient = class {
    constructor(A) {
      (this.version = t),
        (this.config = A),
        (this.logger = A.logger ? A.logger : r),
        (this.channel = A.channel),
        (this.decoder = new TextDecoder("utf-8")),
        (this.messageBuffer = null),
        (this.pcs = new Map()),
        (this.pcPromises = new Map()),
        (this.audioContexts = new Map()),
        (this.audioNodes = new Map()),
        (this.workers = new Map()),
        (this.workerPromises = new Map()),
        (this.certs = new Map()),
        (this.streams = new Map()),
        (this.tracks = new Map()),
        (this.offers = new Map()),
        (this.answers = new Map()),
        (this.remoteDescriptions = new Map()),
        (this.mediaElements = new Map()),
        (this.senders = new Map()),
        (this.dtmfSenders = new Map()),
        (this.receivers = new Map()),
        (this.transceivers = new Map()),
        this.logger.info(
          `Created WebRTC Redirection Client version: ${t.versionStr} - ${t.gitHash}`
        );
    }
    encodeBase64(A) {
      return E(A);
    }
    decodeBase64(A) {
      return h(A);
    }
    getVersion() {
      return this.version;
    }
    concatUint8Arrays(A) {
      const e = A.reduce(function (A, e) {
          return A + e.byteLength;
        }, 0),
        t = new Uint8Array(e);
      let i = 0;
      return (
        A.forEach(function (A) {
          t.set(A, i), (i += A.byteLength);
        }),
        t
      );
    }
    parseHeader(A) {
      return (A[3] << 24) | (A[2] << 16) | (A[1] << 8) | A[0];
    }
    onMessageReceived(A) {
      this.logger.debug(`onMessageReceived, binaryPayload.byteLength: ${A.byteLength}`);
      try {
        let e = 0;
        for (
          null === this.messageBuffer
            ? (this.messageBuffer = new Uint8Array(A))
            : (this.messageBuffer = this.concatUint8Arrays([
                this.messageBuffer,
                new Uint8Array(A)
              ])),
            this.messageBuffer.byteLength >= 4 && (e = this.parseHeader(this.messageBuffer));
          e > 0 && this.messageBuffer.byteLength >= e + 4;

        ) {
          let A = 4,
            t = 4 + e,
            i = this.messageBuffer.slice(A, t);
          this.logger.debug("Decoding payload: ", i);
          let n = this.decoder.decode(i);
          this.logger.debug(`Received message: ${n}`);
          let o = JSON.parse(n);
          this.logger.debug("Received json: ", o),
            this.handleMessage(o),
            (this.messageBuffer = this.messageBuffer.slice(t)),
            (e = this.messageBuffer.byteLength >= 4 ? this.parseHeader(this.messageBuffer) : 0);
        }
      } catch (A) {
        this.logger.error(`Failed to parse JSON from binaryPayload: ${A}`),
          (this.messageBuffer = null);
      }
    }
    getPeerConnection(A) {
      var e = this;
      return this.pcs.has(A)
        ? this.pcs.get(A)
        : (this.pcPromises.has(A) || this.pcPromises.set(A, []),
          new Promise(function (t, i) {
            e.pcPromises.get(A).push({ resolve: t, reject: i });
          }));
    }
    closePeerConnection(A) {
      var e = this;
      if (this.pcs.has(A)) {
        let t = this.pcs.get(A);
        t.getTransceivers().forEach(function (A) {
          A.sender &&
            (A.sender.dtmf &&
              e.dtmfSenders.forEach(function (t, i) {
                t === A.sender.dtmf && e.dtmfSenders.delete(i);
              }),
            e.senders.forEach(function (t, i) {
              t === A.sender && e.senders.delete(i);
            })),
            A.receiver &&
              e.receivers.forEach(function (t, i) {
                t === A.receiver && e.receivers.delete(i);
              }),
            e.transceivers.forEach(function (t, i) {
              t === A && e.transceivers.delete(i);
            });
        }),
          t.getSenders().forEach(function (A) {
            e.senders.forEach(function (t, i) {
              t === A && e.senders.delete(i);
            });
          }),
          t.getReceivers(function (A) {
            e.receivers.forEach(function (t, i) {
              t === A && e.receivers.delete(i);
            });
          }),
          t.localDescription &&
            (this.offers.forEach(function (A, i) {
              t.localDescription.type === A.type &&
                t.localDescription.sdp === A.sdp &&
                e.offers.delete(i);
            }),
            this.answers.forEach(function (A, i) {
              t.localDescription.type === A.type &&
                t.localDescription.sdp === A.sdp &&
                e.offers.delete(i);
            })),
          t.remoteDescription &&
            this.remoteDescriptions.forEach(function (A, i) {
              t.remoteDescription.type === A.type &&
                t.remoteDescription.sdp === A.sdp &&
                e.remoteDescriptions.delete(i);
            }),
          this.pcPromises.has(A) &&
            (this.pcPromises.get(A).forEach(function (A) {
              A.reject(null);
            }),
            this.pcPromises.delete(A)),
          t.close(),
          this.pcs.delete(A);
      }
    }
    getPendingEvent(A, e) {
      return A.pendingEvents.has(e) && A.pendingEvents.get(e).length > 0
        ? A.pendingEvents.get(e).shift()
        : (A.eventPromises.has(e) || A.eventPromises.set(e, []),
          new Promise(function (t, i) {
            A.eventPromises.get(e).push({ resolve: t, reject: i });
          }));
    }
    getStream(A) {
      return this.streams.get(A);
    }
    makeTrackTO(A, e = A.id ? A.id : crypto.randomUUID()) {
      return (
        this.tracks.set(e, A),
        {
          type: "proxy",
          contentHint: A.contentHint,
          enabled: A.enabled,
          id: e,
          kind: A.kind,
          label: A.label,
          muted: A.muted,
          readyState: A.readyState,
          settings: A.getSettings()
        }
      );
    }
    makeStreamTO(A, e = A.id ? A.id : crypto.randomUUID()) {
      var t = this;
      this.streams.set(e, A);
      let i = A.getTracks().map(function (A) {
        return t.makeTrackTO(A);
      });
      return { type: "proxy", id: e, active: A.active, tracks: i };
    }
    makeSyncronizationSourceTO(A) {
      return {
        audioLevel: A.audioLevel,
        rtpTimestamp: A.rtpTimestamp,
        source: A.source,
        timestamp: A.timestamp
      };
    }
    makeReceiverTO(A) {
      var e = this;
      let t = A.getSynchronizationSources();
      t = t.map(function (A) {
        return e.makeSyncronizationSourceTO(A);
      });
      let i = {
        id: A.id ? A.id : crypto.randomUUID(),
        type: "proxy",
        track: A.track ? this.makeTrackTO(A.track) : null,
        synchronizationSources: t,
        stats: []
      };
      return (A.id = i.id), this.receivers.set(i.id, A), i;
    }
    makeDTMFSenderTO(A) {
      let e = { id: A.id ? A.id : crypto.randomUUID(), type: "proxy", toneBuffer: A.toneBuffer };
      return (A.id = e.id), this.dtmfSenders.set(e.id, A), e;
    }
    makeSenderTO(A) {
      let e = {
        id: A.id ? A.id : crypto.randomUUID(),
        type: "proxy",
        track: A.track ? this.makeTrackTO(A.track) : null,
        dtmf: A.dtmf ? this.makeDTMFSenderTO(A.dtmf) : null
      };
      return (A.id = e.id), this.senders.set(e.id, A), e;
    }
    makeTransceiverTO(A) {
      return {
        id: A.id,
        type: "proxy",
        currentDirection: A.currentDirection,
        direction: A.direction,
        mid: A.mid,
        receiver: A.receiver ? this.makeReceiverTO(A.receiver) : null,
        sender: A.sender ? this.makeSenderTO(A.sender) : null,
        stopped: A.stopped
      };
    }
    findProxySubject(A) {
      return this.pcs.has(A)
        ? this.pcs.get(A)
        : this.audioContexts.has(A)
          ? this.audioContexts.get(A)
          : this.audioNodes.has(A)
            ? this.audioNodes.get(A)
            : this.workers.has(A)
              ? this.workers.get(A)
              : this.certs.has(A)
                ? this.certs.get(A)
                : this.streams.has(A)
                  ? this.streams.get(A)
                  : this.offers.has(A)
                    ? this.offers.get(A)
                    : this.answers.has(A)
                      ? this.answers.get(A)
                      : this.remoteDescriptions.has(A)
                        ? this.remoteDescriptions.get(A)
                        : this.mediaElements.has(A)
                          ? this.mediaElements.get(A)
                          : this.senders.has(A)
                            ? this.senders.get(A)
                            : this.dtmfSenders.has(A)
                              ? this.dtmfSenders.get(A)
                              : this.receivers.has(A)
                                ? this.receivers.get(A)
                                : this.transceivers.has(A)
                                  ? this.transceivers.get(A)
                                  : this.tracks.has(A)
                                    ? this.tracks.get(A)
                                    : null;
    }
    traverse(A, e) {
      if ("object" == typeof A)
        for (const t in A)
          Object.prototype.hasOwnProperty.call(A, t) &&
            (e.apply(this, [A, t, A[t]]),
            null !== A[t] && "object" == typeof A[t] && this.traverse(A[t], e));
    }
    getWorker(A) {
      var e = this;
      return this.workers.has(A)
        ? this.workers.get(A)
        : (this.workerPromises.has(A) || this.workerPromises.set(A, []),
          new Promise(function (t, i) {
            e.workerPromises.get(A).push({ resolve: t, reject: i });
          }));
    }
    gatherPeerConnectionState(A, e) {
      var t = this;
      (A.canTrickleIceCandidates = e.canTrickleIceCandidates),
        (A.connectionState = e.connectionState),
        (A.currentLocalDescription = e.currentLocalDescription),
        (A.currentRemoteDescription = e.currentRemoteDescription),
        (A.iceConnectionState = e.iceConnectionState),
        (A.iceGatheringState = e.iceGatheringState),
        (A.iceGatheringState = e.iceGatheringState),
        (A.localDescription = e.localDescription),
        (A.peerIdentity = e.peerIdentity),
        (A.pendingLocalDescription = e.pendingLocalDescription),
        (A.pendingRemoteDescription = e.pendingRemoteDescription),
        (A.remoteDescription = e.remoteDescription),
        (A.sctp = e.sctp),
        (A.signalingState = e.signalingState),
        (A.configuration = e.getConfiguration()),
        (A.transceivers = e.getTransceivers().map(function (A) {
          return t.makeTransceiverTO(A);
        })),
        (A.senders = e.getSenders().map(function (A) {
          return t.makeSenderTO(A);
        })),
        (A.receivers = e.getReceivers().map(function (A) {
          return t.makeReceiverTO(A);
        }));
    }
    getBrowserName(A) {
      const e = A.toLowerCase();
      switch (!0) {
        case e.indexOf("edge") > -1:
          return "edge";
        case e.indexOf("edg/") > -1:
          return "edg";
        case e.indexOf("opr") > -1 && !!window.opr:
          return "opera";
        case e.indexOf("chrome") > -1 && !!window.chrome:
          return "chrome";
        case e.indexOf("trident") > -1:
          return "ie";
        case e.indexOf("firefox") > -1:
          return "firefox";
        case e.indexOf("safari") > -1:
          return "safari";
        default:
          return "other";
      }
    }
    getBrowserVersion(A) {
      let e = this.getBrowserName(A),
        t = new RegExp(`(?<=${e}\\/)\\d+(?:\\.\\d+)+`, "i").exec(A);
      return t && t.length > 0 ? t[0] : null;
    }
    async callWebRTCApi(A, e, t) {
      var i = this;
      switch (A) {
        case s.HELLO_API_NAME:
          return {
            version: this.version,
            platform: "web",
            userAgent: navigator.userAgent,
            browserDetails: {
              browser: this.getBrowserName(navigator.userAgent),
              version: this.getBrowserVersion(navigator.userAgent)
            }
          };
        case s.GETUSERMEDIA_API_NAME: {
          let [A] = t,
            e = await navigator.mediaDevices.getUserMedia(A);
          return this.makeStreamTO(e);
        }
        case s.ENUMERATEDEVICES_API_NAME:
          return (await navigator.mediaDevices.enumerateDevices()).map(function (A) {
            return A.toJSON();
          });
        case s.STREAM_ADD_TRACK: {
          let [A, e] = t,
            i = this.streams.get(A),
            n = this.tracks.get(e);
          return i && n && i.addTrack(n), {};
        }
        case s.STREAM_REMOVE_TRACK: {
          let [A, e] = t,
            i = this.streams.get(A),
            n = this.tracks.get(e);
          return i && n && i.removeTrack(n), {};
        }
        case s.GENERATE_CERTIFICATE_API_NAME: {
          let [A] = t,
            i = await RTCPeerConnection.generateCertificate(A);
          return (
            this.certs.set(e, i),
            { type: "proxy", id: e, expires: i.expires, fingerprints: i.getFingerprints() }
          );
        }
        case s.NEWRTCPEERCONNECTION_API_NAME: {
          let [A, e, n] = t;
          if (e && e.certificates) {
            let A = e.certificates.map(function (A) {
              return i.certs.get(A.id);
            });
            e.certificates = A;
          }
          let o = new RTCPeerConnection(e, n);
          this.pcs.set(A, o),
            this.pcPromises.has(A) &&
              (this.pcPromises.get(A).forEach(function (A) {
                A.resolve(A);
              }),
              this.pcPromises.set(A, []));
          let r = { type: "proxy", pcId: A };
          return this.gatherPeerConnectionState(r, o), r;
        }
        case s.PC_GET_CONFIGURATION: {
          let [A] = t;
          return (await this.getPeerConnection(A)).getConfiguration();
        }
        case s.CREATE_WORKER: {
          let [A, e, i, n] = t,
            o = h(i),
            r = new Blob([o], { type: e }),
            s = URL.createObjectURL(r),
            a = new Worker(s, n);
          return (
            this.workers.set(A, a),
            this.workerPromises.has(A) &&
              (this.workerPromises.get(A).forEach(function (A) {
                A.resolve(a);
              }),
              this.workerPromises.set(A, [])),
            { type: "proxy", id: A }
          );
        }
        case s.WORKER_TERMINATE: {
          let [A] = t;
          return (
            this.workers.has(A) &&
              (this.workers.get(A).terminate(),
              this.workerPromises.has(A) &&
                this.workerPromises.get(A).forEach(function (A) {
                  A.reject(null);
                }),
              this.workerPromises.delete(A),
              this.workers.delete(A)),
            {}
          );
        }
        case s.WORKER_POST_MESSAGE: {
          let [A, e, n] = t,
            o = await this.getWorker(A);
          return (
            this.logger.debug("Message before traversing: ", JSON.stringify(e)),
            this.traverse(e, function (A, e, t) {
              "proxy" === t.type && t.id && (A[e] = i.findProxySubject(t.id));
            }),
            this.logger.debug("Message after traversing: ", e),
            this.logger.debug("Options before traversing: ", JSON.stringify(n)),
            this.traverse(n, function (A, e, t) {
              "proxy" === t.type && t.id && (A[e] = i.findProxySubject(t.id));
            }),
            this.logger.debug("Options after traversing: ", n),
            o.postMessage(e, n),
            { type: "proxy", id: A }
          );
        }
        case s.NEW_AUDIO_CONTEXT: {
          let [A, e] = t,
            i = new AudioContext();
          return (
            this.audioContexts.set(A, i),
            this.audioNodes.set(e, i.destination),
            {
              type: "proxy",
              id: A,
              baseLatency: i.baseLatency,
              currentTime: i.currentTime,
              outputLatency: i.outputLatency,
              sampleRate: i.sampleRate,
              sinkId: i.sinkId,
              state: i.state
            }
          );
        }
        case s.AUDIO_CTX_CREATE_AUDIO_NODE: {
          let [A, e, n, o] = t;
          if (this.audioContexts.has(A)) {
            let t = this.audioContexts.get(A),
              r = t["create" + n];
            o = o.map(function (A) {
              return "proxy" === A.type ? i.findProxySubject(A.id) : A;
            });
            let s = r.apply(t, o);
            this.audioNodes.set(e, s);
            let a = null;
            if (s.stream) {
              let A = s.stream.getTracks().map(function (A) {
                return i.makeTrackTO(A, e);
              });
              (a = this.makeStreamTO(s.stream, e)), (a.tracks = A);
            }
            return {
              id: e,
              channelCount: s.channelCount,
              channelCountMode: s.channelCountMode,
              channelInterpretation: s.channelInterpretation,
              numberOfInputs: s.numberOfInputs,
              numberOfOutputs: s.numberOfOutputs,
              fftSize: s.fftSize,
              frequencyBinCount: s.frequencyBinCount,
              maxDecibels: s.maxDecibels,
              minDecibels: s.minDecibels,
              smoothingTimeConstant: s.smoothingTimeConstant,
              stream: a
            };
          }
          return {};
        }
        case s.AUDIO_CTX_CLOSE: {
          let [A] = t;
          return (
            this.audioContexts.has(A) &&
              (this.audioContexts.get(A).close(), this.audioContexts.delete(A)),
            {}
          );
        }
        case s.AUDIO_NODE_CONNECT: {
          let [A, e, i, n] = t,
            o = this.audioNodes.get(A),
            r = this.findProxySubject(e.id);
          return o && r && o.connect(r, i || 0, n || 0), {};
        }
        case s.AUDIO_NODE_DISCONNECT: {
          let [A, e, i, n] = t,
            o = this.audioNodes.get(A),
            r = this.findProxySubject(e.id);
          return o && r && o.disconnect(r, i || 0, n || 0), {};
        }
        case s.AUDIO_NODE_SET_TYPE: {
          let [A, e] = t;
          return this.audioNodes.has(A) && (this.audioNodes.get(A).type = e), {};
        }
        case s.AUDIO_NODE_START: {
          let [A, e] = t;
          return this.audioNodes.has(A) && this.audioNodes.get(A).start(e), {};
        }
        case s.AUDIO_NODE_STOP: {
          let [A, e] = t;
          return this.audioNodes.has(A) && this.audioNodes.get(A).stop(e), {};
        }
        case s.AUDIO_PARAM_SET_VALUE_AT_TIME: {
          let [A, e, i] = t;
          if (this.audioNodes.has(A)) {
            let t = this.audioNodes.get(A);
            t.gain
              ? t.gain.setValueAtTime(e, i || t.context.currentTime)
              : t.frequency && t.frequency.setValueAtTime(e, i || t.context.currentTime);
          }
          return {};
        }
        case s.AUDIO_PARAM_SET_RAMP_TO_VALUE_AT_TIME: {
          let [A, e, i] = t;
          if (this.audioNodes.has(A)) {
            let t = this.audioNodes.get(A);
            t.frequency && t.frequency.linearRampToValueAtTime(e, i || t.context.currentTime);
          }
          return {};
        }
        case s.GET_RECEIVERS_API_NAME: {
          let [A] = t;
          return {
            pcId: A,
            receivers: (await this.getPeerConnection(A)).getReceivers().map(function (A) {
              return i.makeReceiverTO(A);
            })
          };
        }
        case s.GET_SENDERS_API_NAME: {
          let [A] = t;
          return {
            pcId: A,
            senders: (await this.getPeerConnection(A)).getSenders().map(function (A) {
              return i.makeSenderTO(A);
            })
          };
        }
        case s.INSERT_DTMF_API_NAME: {
          let [A, e, i, n] = t,
            o = this.dtmfSenders.get(A);
          return o && o.insertDTMF(e, i, n), {};
        }
        case s.GET_TRANSCEIVERS_API_NAME: {
          let [A] = t,
            e = (await this.getPeerConnection(A)).getTransceivers();
          return (
            (e = e.map(function (A) {
              return (A.id = A.id ? A.id : crypto.randomUUID()), i.makeTransceiverTO(A);
            })),
            { pcId: A, transceivers: e }
          );
        }
        case s.TRANSCEIVER_SET_CODEC_PREFS:
          return {};
        case s.ADD_TRACK_API_NAME: {
          let [A, e, n, ...o] = t,
            r = await this.getPeerConnection(e),
            s = [];
          o.forEach(function (A) {
            const e = i.streams.get(A.proxy.id);
            e && s.push(e);
          });
          let a = this.tracks.get(n.id);
          if (a) {
            let t = [a, ...s],
              n = r.addTrack.apply(r, t);
            n.id = A;
            let o = this.makeSenderTO(n);
            return (
              (o.pcId = e),
              (o.senders = r.getSenders().map(function (A) {
                return i.makeSenderTO(A);
              })),
              (o.receivers = r.getReceivers().map(function (A) {
                return i.makeReceiverTO(A);
              })),
              (o.transceivers = r.getTransceivers().map(function (A) {
                return i.makeTransceiverTO(A);
              })),
              o
            );
          }
          return {};
        }
        case s.ADD_TRANSCEIVER_API_NAME: {
          let [A, e, n, o] = t,
            r = await this.getPeerConnection(A);
          if (("string" != typeof n && (n = this.tracks.get(n.id)), o && o.streams)) {
            let A = [];
            o.streams.forEach(function (e) {
              if (e.proxy) {
                let t = i.streams.get(e.proxy.id);
                A.push(t);
              }
            }),
              (o.streams = A);
          }
          let s = r.addTransceiver(n, o);
          (s.id = e.id),
            this.transceivers.set(e.id, s),
            s.sender && ((s.sender.id = e.sender.id), this.senders.set(e.sender.id, s.sender)),
            s.receiver &&
              ((s.receiver.id = e.receiver.id), this.receivers.set(e.receiver.id, s.receiver));
          let a = this.makeTransceiverTO(s);
          return (
            (a.pcId = A),
            (a.senders = r.getSenders().map(function (A) {
              return i.makeSenderTO(A);
            })),
            (a.receivers = r.getReceivers().map(function (A) {
              return i.makeReceiverTO(A);
            })),
            (a.transceivers = r.getTransceivers().map(function (A) {
              return i.makeTransceiverTO(A);
            })),
            a
          );
        }
        case s.PC_CLOSE_API_NAME: {
          let [A] = t;
          return this.closePeerConnection(A), {};
        }
        case s.ADDSTREAM_API_NAME: {
          let [A, e] = t,
            i = this.streams.get(e.id);
          return (await this.getPeerConnection(A)).addStream(i), e;
        }
        case s.GET_STATS_API_NAME: {
          let [A, e] = t,
            i = await this.getPeerConnection(A),
            n = await i.getStats(e),
            o = [];
          return (
            n.forEach(function (A) {
              let e = Object.assign({}, A);
              o.push(e);
            }),
            o
          );
        }
        case s.GET_SENDER_STATS_API_NAME: {
          let [A] = t;
          if (this.senders.has(A)) {
            let e = await this.senders.get(A).getStats(),
              t = [];
            return (
              e.forEach(function (A) {
                let e = Object.assign({}, A);
                t.push(e);
              }),
              t
            );
          }
          return [];
        }
        case s.GET_RECEIVER_STATS_API_NAME: {
          let [A] = t;
          if (this.receivers.has(A)) {
            let e = await this.receivers.get(A).getStats(),
              t = [];
            return (
              e.forEach(function (A) {
                let e = {
                  id: A.id ? A.id : crypto.randomUUID(),
                  type: A.type,
                  concealedSamples: A.concealedSamples
                };
                t.push(e);
              }),
              t
            );
          }
          return {};
        }
        case s.REPLACE_SENDER_TRACK_API_NAME: {
          let [A, e] = t,
            i = this.senders.get(A),
            n = e ? this.tracks.get(e.id) : null;
          return n && i && (await i.replaceTrack(n)), {};
        }
        case s.PC_REMOVE_TRACK_API_NAME: {
          let [A, e] = t,
            i = await this.getPeerConnection(A),
            n = this.senders.get(e.id);
          return n && i.removeTrack(n), {};
        }
        case s.CREATE_OFFER_API_NAME: {
          let [A, i] = t,
            n = await this.getPeerConnection(A),
            o = await n.createOffer(i);
          return this.offers.set(e, o), { id: e, type: o.type, sdp: o.sdp };
        }
        case s.CREATE_ANSWER_API_NAME: {
          let [A, i] = t,
            n = await this.getPeerConnection(A),
            o = await n.createAnswer(i);
          return this.answers.set(e, o), { id: e, type: o.type, sdp: o.sdp };
        }
        case s.SET_LOCAL_DESCRIPTION_API_NAME: {
          let [A, e] = t,
            i = "offer" === e.type ? this.offers : this.answers,
            n = e.id ? i.get(e.id) : e;
          if (n) {
            n.sdp = e.sdp;
            let t = await this.getPeerConnection(A);
            return await t.setLocalDescription(n), e;
          }
          return {};
        }
        case s.SET_REMOTE_DESCRIPTION_API_NAME: {
          let [A, e] = t,
            i = await this.getPeerConnection(A);
          return await i.setRemoteDescription(e), e;
        }
        case s.ADD_ICE_CANDIDATE_API_NAME: {
          let [A, e] = t,
            i = e
              ? new RTCIceCandidate({ sdpMLineIndex: e.sdpMLineIndex, candidate: e.candidate })
              : null;
          return (await this.getPeerConnection(A)).addIceCandidate(i), e;
        }
        case s.ADD_PC_EVENT_LISTENER: {
          let [A, n] = t,
            o = await this.getPeerConnection(A);
          if (
            (o.pendingEvents || (o.pendingEvents = new Map()),
            o.eventPromises || (o.eventPromises = new Map()),
            o.pendingEvents.has(n))
          ) {
            let A = await this.getPendingEvent(o, n);
            this.sendEvent(s.ADD_PC_EVENT_LISTENER, e, A);
          } else if (!o[n]) {
            const t = function (t) {
              let n = null;
              if (t.type === a.ICE_CANDIDATE) {
                i.logger.debug("event: ", t);
                let e = t.candidate,
                  r = null;
                e &&
                  (r = {
                    sdpMLineIndex: e.sdpMLineIndex,
                    sdpMid: e.sdpMid,
                    candidate: e.candidate,
                    type: e.type,
                    foundation: e.foundation,
                    protocol: e.protocol,
                    address: e.address,
                    port: e.port,
                    priority: e.priority,
                    url: e.url,
                    relayProtocol: e.relayProtocol,
                    component: e.compoonent,
                    relatedAddress: e.relatedAddress,
                    relatedPort: e.relatedPort,
                    tcpType: e.tcpType,
                    usernameFragment: e.usernameFragment
                  }),
                  (n = { pcId: A, eventName: t.type, type: "proxy", candidate: r }),
                  i.gatherPeerConnectionState(n, o);
              } else
                t.type === a.SIG_STATE_CHANGE
                  ? ((n = { pcId: A, eventName: t.type, type: "proxy" }),
                    i.gatherPeerConnectionState(n, o))
                  : t.type === a.TRACK
                    ? ((n = {
                        pcId: A,
                        eventName: t.type,
                        type: "proxy",
                        streams: [],
                        senders: [],
                        receivers: [],
                        track: i.makeTrackTO(t.track)
                      }),
                      (n.streams = t.streams.map(function (A) {
                        return i.makeStreamTO(A);
                      })),
                      i.gatherPeerConnectionState(n, o))
                    : t.type === a.CONN_STATE_CHANGE ||
                        t.type === a.ICE_CONN_STATE_CHANGE ||
                        t.type === a.ICE_GATHER_STATE_CHANGE ||
                        t.type === a.NEGOTIATION_NEEDED
                      ? ((n = { pcId: A, eventName: t.type, type: "proxy" }),
                        i.gatherPeerConnectionState(n, o))
                      : i.logger.warn(
                          `Ignored event, type: ${t.type}, event: ${JSON.stringify(t)}`
                        );
              n && i.processPendingEvents(o, t, n, s.ADD_PC_EVENT_LISTENER, e);
            };
            (o[n] = t), o.addEventListener(n, t);
          }
          return null;
        }
        case s.ADD_TRACK_EVENT_LISTENER: {
          let [A, n, o] = t,
            r = this.tracks.get(A);
          if (r) {
            if (
              (r.pendingEvents || (r.pendingEvents = new Map()),
              r.eventPromises || (r.eventPromises = new Map()),
              r.pendingEvents.has(n))
            ) {
              let A = await this.getPendingEvent(r, n);
              this.sendEvent(s.ADD_TRACK_EVENT_LISTENER, e, A);
            } else if (!r[n]) {
              const t = function (t) {
                if (Object.values(g).includes(n)) {
                  let n = { trackId: A, eventName: t.type, type: "proxy" };
                  n && i.processPendingEvents(r, t, n, s.ADD_TRACK_EVENT_LISTENER, e);
                } else i.logger.warn(`Ignored event: ${JSON.stringify(t)}`);
              };
              (r[n] = t), r.addEventListener(n, t, o);
            }
            return null;
          }
          return {};
        }
        case s.ADD_WORKER_EVENT_LISTENER: {
          let [A, n] = t,
            o = await this.getWorker(A);
          if (
            (o.pendingEvents || (o.pendingEvents = new Map()),
            o.eventPromises || (o.eventPromises = new Map()),
            o.pendingEvents.has(n))
          ) {
            let A = await this.getPendingEvent(o, n);
            this.sendEvent(s.ADD_WORKER_EVENT_LISTENER, e, A);
          } else if (!o[n]) {
            const t = function (t) {
              if ((i.logger.debug("Received event: ", t), Object.values(I).includes(n))) {
                let n = { wId: A, eventName: t.type, type: "proxy", data: t.data };
                n && i.processPendingEvents(o, t, n, s.ADD_WORKER_EVENT_LISTENER, e);
              } else i.logger.warn(`Ignored event: ${JSON.stringify(t)}`, t);
            };
            (o[n] = t), o.addEventListener(n, t);
          }
          return null;
        }
        case s.ADD_DTMF_EVENT_LISTENER: {
          let [A, n, o] = t,
            r = this.dtmfSenders.get(A);
          if (
            (r.pendingEvents || (r.pendingEvents = new Map()),
            r.eventPromises || (r.eventPromises = new Map()),
            r.pendingEvents.has(n))
          ) {
            let A = await this.getPendingEvent(r, n);
            this.sendEvent(s.ADD_DTMF_EVENT_LISTENER, e, A);
          } else if (!r[n]) {
            const t = function (t) {
              if (Object.values(c).includes(n)) {
                let n = { dtmfId: A, eventName: t.type, type: t.type, tone: t.tone };
                i.processPendingEvents(r, t, n, s.ADD_DTMF_EVENT_LISTENER, e);
              } else i.logger.warn(`Ignored event: ${JSON.stringify(t)}`);
            };
            (r[n] = t), r.addEventListener(n, t, o);
          }
          return null;
        }
        case s.ADD_MEDIADEVICES_EVENT_LISTENER: {
          let [A, n, o] = t,
            r = navigator.mediaDevices;
          if (
            (r.pendingEvents || (r.pendingEvents = new Map()),
            r.eventPromises || (r.eventPromises = new Map()),
            r.pendingEvents.has(n))
          ) {
            let A = await this.getPendingEvent(r, n);
            this.sendEvent(s.ADD_MEDIADEVICES_EVENT_LISTENER, e, A);
          } else if (!r[n]) {
            const t = function (t) {
              if (Object.values(l).includes(n)) {
                let n = { id: crypto.randomUUID(), mdId: A, eventName: t.type, type: t.type };
                i.processPendingEvents(r, t, n, s.ADD_MEDIADEVICES_EVENT_LISTENER, e);
              } else i.logger.warn(`Ignored event: ${JSON.stringify(t)}`);
            };
            (r[n] = t), r.addEventListener(n, t, o);
          }
          return null;
        }
        case s.CREATE_MEDIA_ELEMENT_API_NAME: {
          let [A, e] = t;
          if ("audio" !== e.kind && "video" !== e.kind)
            return this.logger.warn(`Invalid media type: ${JSON.stringify(e)}`), null;
          let i = document.createElement(e.kind);
          return (
            Object.assign(i, e),
            document.body.appendChild(i),
            this.mediaElements.set(A, i),
            { id: A, sinkId: i.sinkId }
          );
        }
        case s.MEDIA_ELEMENT_SET_SINK_ID_API_NAME: {
          let [A, e] = t,
            i = this.mediaElements.get(A);
          return i ? (await i.setSinkId(e), { id: A, sinkId: i.sinkId }) : {};
        }
        case s.SET_MEDIA_SRC_OBJ_API_NAME: {
          let [A, e] = t,
            i = e ? this.getStream(e.id) : null;
          return this.mediaElements.has(A) && (this.mediaElements.get(A).srcObject = i), {};
        }
        case s.MEDIA_ELEMENT_MUTED: {
          let [A, e] = t;
          return (
            this.mediaElements.has(A) && (this.mediaElements.get(A).muted = e), { id: A, muted: e }
          );
        }
        case s.SET_MEDIA_HIDDEN_API_NAME: {
          let [A, e] = t,
            i = this.mediaElements.get(A);
          return i && (i.hidden = e), {};
        }
        case s.SET_MEDIA_VOLUME_API_NAME: {
          let [A, e] = t;
          return this.mediaElements.has(A) && (this.mediaElements.get(A).volume = e), {};
        }
        case s.MEDIA_ELEMENT_PLAY_API_NAME: {
          let [A] = t;
          return this.mediaElements.has(A) && this.mediaElements.get(A).play(), {};
        }
        case s.MEDIA_ELEMENT_PAUSE_API_NAME: {
          let [A] = t;
          return this.mediaElements.has(A) && this.mediaElements.get(A).pause(), {};
        }
        case s.MEDIA_ELEMENT_REMOVE: {
          let [A] = t;
          return (
            this.mediaElements.has(A) &&
              (this.mediaElements.get(A).remove(), this.mediaElements.delete(A)),
            {}
          );
        }
        case s.TOGGLE_TRACK_ENABLED_API_NAME: {
          let [A, e] = t,
            i = this.tracks.get(A);
          return i ? ((i.enabled = e), this.makeTrackTO(i)) : {};
        }
        case s.TRACK_STOP_API_NAME: {
          let [A] = t,
            e = this.tracks.get(A);
          return e && (e.stop(), this.tracks.delete(A)), {};
        }
        case s.TRACK_GET_SETTINGS: {
          let [A] = t,
            e = this.tracks.get(A);
          return e ? e.getSettings() : {};
        }
        case s.SENDER_CREATE_ENCODED_STREAMS: {
          let [A, e] = t;
          if (this.senders.has(A)) {
            let t = this.senders.get(A).createEncodedStreams();
            return (
              this.streams.set(e.id, t),
              this.streams.set(e.readable.id, t.readable),
              this.streams.set(e.writable.id, t.writable),
              e
            );
          }
          return {};
        }
        case s.RECEIVER_CREATE_ENCODED_STREAMS: {
          let [A, e] = t;
          if (this.receivers.has(A)) {
            let t = this.receivers.get(A).createEncodedStreams();
            return (
              this.streams.set(e.id, t),
              this.streams.set(e.readable.id, t.readable),
              this.streams.set(e.writable.id, t.writable),
              e
            );
          }
          return {};
        }
        case s.UNLOAD_EVENT_NAME: {
          let [A] = t;
          return (
            A.pcIds.forEach(function (A) {
              i.closePeerConnection(A);
            }),
            A.streamIds.forEach(function (A) {
              let e = i.streams.get(A);
              e &&
                ("function" == typeof e.getTracks &&
                  e.getTracks().forEach(function (A) {
                    A.stop();
                  }),
                i.streams.delete(A));
            }),
            A.trackIds.forEach(function (A) {
              i.tracks.delete(A);
            }),
            A.workerIds.forEach(function (A) {
              let e = i.workers.get(A);
              e && e.terminate(), i.workers.delete(A);
            }),
            A.mediaElementIds.forEach(function (A) {
              let e = i.mediaElements.get(A);
              e && (e.remove(), i.mediaElements.delete(A));
            }),
            A.transceiverIds.forEach(function (A) {
              i.transceivers.delete(A);
            }),
            A.senderIds.forEach(function (A) {
              i.senders.delete(A);
            }),
            A.receiverIds.forEach(function (A) {
              i.receivers.delete(A);
            }),
            {}
          );
        }
        default: {
          const e = new Error(`Invalid api: ${A}`);
          throw ((e.name = "InvalidApi"), e);
        }
      }
    }
    sendMessage(A) {
      this.logger.debug(`Sending message: ${JSON.stringify(A)}`);
      let e = A.message,
        t = f.deflateRaw(JSON.stringify(e));
      A.message = t;
      let i = new TextEncoder().encode(JSON.stringify(A)),
        n = i.byteLength,
        o = new Uint8Array([n, n >> 8, n >> 16, n >> 24]);
      this.channel.sendMessage(o), this.channel.sendMessage(i);
    }
    sendEvent(A, e, t) {
      let i = { requestId: e, type: "event", message: { api: A, event: t } };
      this.sendMessage(i);
    }
    sendResponse(A, e, t) {
      let i = { requestId: e, type: "response", message: { api: A, response: t } };
      this.sendMessage(i);
    }
    sendError(A, e, t) {
      let i = { requestId: e, type: "error", message: { api: A, error: t } };
      this.sendMessage(i);
    }
    async handleWebRTCApi(A) {
      try {
        let e = await this.callWebRTCApi(A.message.api, A.requestId, A.message.args);
        e && this.sendResponse(A.message.api, A.requestId, e);
      } catch (e) {
        this.logger.error(
          `Error handling WebRTC API: ${JSON.stringify(A)}, message: ${e.message ? e.message : "(no message)"}, error: ${JSON.stringify(e)}`
        ),
          this.logger.trace(e),
          this.sendError(A.message.api, A.requestId, { name: e.name, message: e.message });
      }
    }
    processPendingEvents(A, e, t, i, n) {
      if (A.pendingEvents.has(e.type)) {
        A.pendingEvents.get(e.type).push(t);
        let i = A.eventPromises.get(e.type);
        i &&
          i.forEach(function (A) {
            A.resolve(t);
          });
      } else this.sendEvent(i, n, t), A.pendingEvents.set(e.type, []);
    }
    handleMessage(A) {
      let e = A.message,
        t = f.inflateRaw(e),
        i = this.decoder.decode(t);
      (A.message = JSON.parse(i)),
        A.message.api && A.requestId && A.message.args
          ? this.handleWebRTCApi(A)
          : (this.logger.error(`Invalid message format: ${JSON.stringify(A)}`),
            this.logger.trace(A));
    }
    onClose(A) {
      this.logger.info(`WebRTC redir custom channel closed: ${JSON.stringify(A)}"`), this.release();
    }
    release() {
      var A = this;
      this.streams.forEach(function (A) {
        A.getTracks().forEach(function (A) {
          A.stop();
        });
      }),
        this.mediaElements.forEach(function (A) {
          A.remove();
        }),
        this.pcs.forEach(function (e, t) {
          A.closePeerConnection(t);
        }),
        this.certs.clear();
    }
  };
})(gC.exports);
var cC = e(gC.exports);
class IC extends ja {
  constructor(A, e, t, i, n, o, r) {
    super(A, e, t, i, n, o, r),
      (this.log = Q("webrtcredirchannel", e)),
      (this.webrtcredirclient = new cC.DCVWebRTCRedirClient({
        logger: Q("webrtcredirclient"),
        channel: this
      }));
  }
  run() {
    this.log.info("Starting webrtc redirection channel"),
      (this.onMessageReceived = (A, e) => {
        this.webrtcredirclient.onMessageReceived(e);
      });
  }
  onClose(A) {
    this.log.info(`Webrtc redir channel ${this.channelName} closed (${JSON.stringify(A)})`),
      this.webrtcredirclient.onClose(A),
      js(this.clientConnectionId).removeCustomChannel(this.channelName, this);
  }
  onError() {
    this.log.error(`Error on webrtc redir channel ${this.channelName}`);
  }
}
const lC = {
  [Ia.DISPLAY]: class extends qa {
    constructor(A, e, t, i, n, o, r) {
      super(A, e, t, i, n, o, WI, r);
      const s = Ws(this.clientConnectionId);
      (this.displaymanager = new AI(A, this.clientConnectionId)),
        (this.pool = new wI(this.log)),
        (this.currentLayout = [[jI.width, jI.height]]),
        (this.resizePool = !1),
        (this.displayAvailabilityObserverDefined = !1),
        (this.codecsReady = !1),
        (this.sendCodecsRequested = !1),
        (this.applyLayoutPendingRequest = !1),
        (this.currentLayoutSettings = {
          minDisplayWidth: 1,
          minDisplayHeight: 1,
          maxDisplayWidth: 0,
          maxDisplayHeight: 0,
          maxDisplayNumber: 0
        }),
        (this.serverLayoutLimits = {
          minDisplayWidth: 1,
          minDisplayHeight: 1,
          maxDisplayWidth: 0,
          maxDisplayHeight: 0,
          webMaxDisplayWidth: 0,
          webMaxDisplayHeight: 0,
          maxHeads: 0
        }),
        (Xn(A.observers.displayLayout) &&
          Xn(A.observers.firstFrame) &&
          Xn(A.observers.screenshot)) ||
          this.log.warn(
            "One of the following observers are not defined: displayLayout, firstFrame or screenshot"
          ),
        s.update("display", { enabled: !0 }),
        (this.screenshotActive = !1),
        s.update("screenshot", { enabled: this.screenshotActive }),
        (this.screenshotCallback = Xn(A.observers.screenshot) ? A.observers.screenshot : null),
        (this.screenshotRequested = !1),
        Xn(A.observers.displayAvailability)
          ? (this.displayAvailabilityObserverDefined = !0)
          : (this.log.warn("The following observer is not defined: displayAvailability"),
            (A.observers.displayAvailability = eo)),
        (this.requestedDisplayConfig = { highColorAccuracy: A.highColorAccuracy }),
        (this.pendingDisplayConfig = null),
        (this.highColorAccuracy = null),
        (this.baseUrl = A.baseUrl),
        (this.config = A),
        this.updateMaxDisplayNumber(),
        this.displaymanager.registerChannel(this);
    }
    run() {
      this.log.info(`Started display protocol on channel ${this.clientConnectionId}`),
        JI(this.config, this.protocolVersion).then((A) => {
          (this.codecsReady = !0),
            (this.decoderConstructors = A.decoders),
            (this.highColorAccuracyAvailable = A.highColorAccuracyAvailable),
            (this.tileGroupProcessingSupported = A.tileGroupProcessingSupported),
            cl.call(this);
        }),
        (this.onMessageReceived = (A, e) => {
          return $I.call(this, ((t = A), wo(VI.ServerMessage, t)), e);
          var t;
        }),
        XI.call(this),
        zI.call(this);
    }
    onClose(A) {
      const e = Ws(this.clientConnectionId);
      if (
        (e.update("display", { enabled: !1 }),
        e.update("display-multi", { enabled: !1 }),
        e.update("screenshot", { enabled: !1 }),
        this.screenshotRequested &&
          (this.screenshotCallback
            ? (this.screenshotCallback(null), (this.screenshotRequested = !1))
            : this.log.warn("Missing screenshot callback with screenshot request")),
        this.displaymanager.unregisterChannel(this),
        this.streamInfos)
      ) {
        this.log.debug("Ending all streams");
        for (const A of Object.keys(this.streamInfos)) gl.call(this, A, !0);
      }
      super.onClose(A);
    }
    setRequestedSettings(A) {
      to(this.protocolVersion, { major: 1, minor: 5 }) ||
        (A.maxDisplayWidth || (A.maxDisplayWidth = 1920),
        A.maxDisplayHeight || (A.maxDisplayHeight = 1080)),
        this.enableHighPixelDensity(A.highPixelDensityEnabled),
        this.setQuality(A.minDisplayQuality, A.maxDisplayQuality),
        this.setLayoutSettings(A.maxDisplayWidth, A.maxDisplayHeight, A.maxDisplayNumber),
        this.setMinLayoutSettings(A.minDisplayWidth, A.minDisplayHeight),
        this.enableQualityUpdates(A.qualityUpdatesEnabled);
    }
    enableHighPixelDensity(A) {
      this.displaymanager.enableHighPixelDensity(A);
    }
    sendAck(A, e) {
      this.transport.sendMessage(_I({ ack: { index: A, processingTime: e } }));
    }
    getScreenshot() {
      return this.screenshotActive
        ? this.ready
          ? this.screenshotCallback
            ? this.screenshotRequested
              ? (this.log.warn("Pending screenshot task already set"), !1)
              : (this.log.info("Sending screenshot request"),
                (this.screenshotRequested = !0),
                this.transport.sendMessage(
                  _I({ screenshotRequest: { format: VI.ScreenshotRequest.FormatType.PNG } })
                ),
                !0)
            : (this.log.warn("Screenshot observer not provided"), !1)
          : (this.log.warn("Cannot send screenshot request, display channel not established"), !1)
        : (this.log.warn("Requested screenshot, but service is not available"), !1);
    }
    getMaxHeadResolution() {
      let A, e;
      return (
        (A = this.currentLayoutSettings.maxDisplayWidth
          ? this.serverLayoutLimits.maxDisplayWidth
            ? Math.min(
                this.currentLayoutSettings.maxDisplayWidth,
                this.serverLayoutLimits.maxDisplayWidth
              )
            : this.currentLayoutSettings.maxDisplayWidth
          : this.serverLayoutLimits.webMaxDisplayWidth),
        (e = this.currentLayoutSettings.maxDisplayHeight
          ? this.serverLayoutLimits.maxDisplayHeight
            ? Math.min(
                this.currentLayoutSettings.maxDisplayHeight,
                this.serverLayoutLimits.maxDisplayHeight
              )
            : this.currentLayoutSettings.maxDisplayHeight
          : this.serverLayoutLimits.webMaxDisplayHeight),
        { maxWidth: A, maxHeight: e }
      );
    }
    getMinHeadResolution() {
      return {
        minWidth: Math.max(
          this.currentLayoutSettings.minDisplayWidth,
          this.serverLayoutLimits.minDisplayWidth
        ),
        minHeight: Math.max(
          this.currentLayoutSettings.minDisplayHeight,
          this.serverLayoutLimits.minDisplayHeight
        )
      };
    }
    getMaxHeadsNumber() {
      return this.displaymanager.isResizeEnabled() || 1 !== this.currentNumHeads
        ? this.currentLayoutSettings.maxDisplayNumber
          ? this.serverLayoutLimits.maxHeads
            ? Math.min(
                this.currentLayoutSettings.maxDisplayNumber,
                this.serverLayoutLimits.maxHeads
              )
            : this.currentLayoutSettings.maxDisplayNumber
          : this.serverLayoutLimits.maxHeads
        : 1;
    }
    getSupportsReconfigure() {
      return this.highColorAccuracyAvailable;
    }
    getSupportsTileGroupProcessing() {
      return this.tileGroupProcessingSupported;
    }
    updateMaxDisplayNumber() {
      let A = this.getMaxHeadsNumber(),
        e = !0,
        t = Ws(this.clientConnectionId);
      this.displayAvailabilityObserverDefined ? A < 2 && (e = !1) : (e = !1),
        e ? this.displaymanager.setMaxDisplayNumber(A) : this.displaymanager.setMaxDisplayNumber(1),
        t.update("display-multi", { enabled: e });
    }
    sendDisplayLayout(A, e) {
      if (this.displaymanager.isResizeEnabled()) {
        if (
          ((this.pendingLayout = [
            { name: "WebViewer", primary: !0, rect: { x: 0, y: 0, width: A, height: e } }
          ]),
          this.ready)
        ) {
          const A = el.call(this, this.pendingLayout),
            e = A.map(
              (A) =>
                `{${A.name}: ${A.rect.x},${A.rect.y}, ${A.rect.width}x${A.rect.height}, primary: ${A.primary}}`
            ).join();
          this.log.info(`Request display layout: [${e}]`),
            this.transport.sendMessage(_I({ displayLayoutRequest: { displayHeads: A } }));
        }
      } else this.log.warn("Display resize disabled");
    }
    sendDisplayConfig(A) {
      return ol.call(this, A);
    }
    setQuality(A, e) {
      this.ready &&
        this.transport.sendMessage(_I({ settings: { minQuality: A || 0, maxQuality: e || 0 } })),
        (this.currentQuality = { min: A, max: e });
    }
    setLayoutSettings(A, e, t) {
      let i = A || jI.width,
        n = e || jI.height,
        o = t || 0;
      (i > jI.width || n > jI.height) &&
        ((i = Math.min(i, jI.width)),
        (n = Math.min(n, jI.height)),
        this.log.warn(`Maximum display layout is being capped at: ${i}x${n}`)),
        this.ready &&
          this.transport.sendMessage(
            _I({ settings: { maxDisplayWidth: i, maxDisplayHeight: n, maxDisplayNumber: o } })
          ),
        (this.currentLayoutSettings = {
          ...this.currentLayoutSettings,
          maxDisplayWidth: i,
          maxDisplayHeight: n,
          maxDisplayNumber: o || this.currentLayoutSettings.maxDisplayNumber
        }),
        this.updateMaxDisplayNumber(),
        this.log.debug(`Current layout Settings: ${C(this.currentLayoutSettings)}`);
    }
    syncHighPixelDensity(A) {
      const e = this.pendingLayout || A;
      Ao(e) || this.sendDisplayLayoutMulti(e);
    }
    sendDisplayLayoutMulti(A) {
      if (this.displaymanager.isResizeEnabled()) {
        if (((this.pendingLayout = A), this.ready)) {
          const A = el.call(this, this.pendingLayout),
            e = A.map(
              (A) =>
                `{${A.name}: ${A.rect.x},${A.rect.y}, ${A.rect.width}x${A.rect.height}, primary: ${A.primary}}`
            ).join();
          this.log.info(`Request display layout: [${e}]`),
            this.transport.sendMessage(_I({ displayLayoutRequest: { displayHeads: A } }));
        }
      } else this.log.warn("Display resize disabled");
    }
    setMinLayoutSettings(A, e) {
      (this.currentLayoutSettings = {
        ...this.currentLayoutSettings,
        minDisplayWidth: A || this.currentLayoutSettings.minDisplayWidth,
        minDisplayHeight: e || this.currentLayoutSettings.minDisplayHeight
      }),
        this.log.debug(`Current layout Settings: ${C(this.currentLayoutSettings)}`);
    }
    enableQualityUpdates(A) {
      const e = A ? 1 : 2;
      this.ready && this.transport.sendMessage(_I({ settings: { enableQu: e } })),
        (this.currentQualityUpdatesSetting = e);
    }
    sendPause(A) {
      const e = { pause: {} };
      A && (e.pause.headName = A),
        this.log.info(`Sending pause message: ${JSON.stringify(e)}`),
        this.transport.sendMessage(_I(e));
    }
    sendResume(A) {
      const e = { resume: {} };
      A && (e.resume.headName = A),
        this.log.info(`Sending resume message: ${JSON.stringify(e)}`),
        this.transport.sendMessage(_I(e));
    }
    getDisplayManager() {
      return this.displaymanager;
    }
  },
  [Ia.AUDIO]: class extends qa {
    constructor(A, e, t, i, n, o, r) {
      if ((super(A, e, t, i, n, o, Eu, r), !ks())) throw Error("audio is not available");
      Ps(),
        (this.firstAudioPacketSinceSilenceTs = 0),
        (this.audioPacketsReceivedSinceSilence = 0),
        (this.audioPacketLastReceiveTime = 0),
        (this.boundOnDeviceChange = null),
        (this.onDeviceChangeEvent = A.observers.deviceChangeEvent),
        (this.state = {
          audioOn: !1,
          audioConfigBitrate: A.audioBitrate,
          supportedProfiles: ua,
          dynamicTuning: A.dynamicAudioTuning
        }),
        (this.channelStats = {
          receiveIntervalMin: Number.MAX_SAFE_INTEGER,
          receiveIntervalSum: 0,
          receiveIntervalMax: 0,
          receivedPacketsSkipped: 0,
          receivedPackets: 0
        }),
        (this.audioOutput = new kd(this.clientConnectionId, A.enableWebCodecs)),
        this.audioOutput.displayReady(mu.call(this)),
        this.audioOutput.setVolume(A.volumeLevel / 100),
        (this.webcamManager = new lu(this.clientConnectionId, A.enableWebCodecs, A.divId)),
        (this.reportStatsIntervalID = null),
        (this.deviceChangePollingIntervalId = null),
        fu.call(this, A.baseUrl, A.enableWebCodecs);
    }
    run() {
      this.log.info(`Started audio protocol on channel ${this.clientConnectionId}`),
        (this.reportStatsIntervalID = setInterval(Su.bind(this), 1e4)),
        (this.onMessageReceived = (A, e) => {
          return Ru.call(this, ((t = A), wo(hu.ServerMessage, t)), e);
          var t;
        });
    }
    onClose(A) {
      const e = Ws(this.clientConnectionId);
      clearInterval(this.reportStatsIntervalID),
        clearInterval(this.deviceChangePollingIntervalId),
        (this.reportStatsIntervalID = null),
        (this.deviceChangePollingIntervalId = null),
        (this.firstAudioPacketSinceSilenceTs = 0),
        (this.audioPacketsReceivedSinceSilence = 0),
        this.player && this.player.remove(),
        this.encoder && (this.encoder.remove(), (this.encoder = null)),
        ks() && (this.audioOutput.unregisterChannel(this), this.audioOutput.reset()),
        Ku() && (this.microphone.unregisterChannel(this), this.microphone.reset()),
        vs() && this.webcamManager && this.webcamManager.unregisterChannel(this),
        Ms() &&
          this.boundOnDeviceChange &&
          navigator.mediaDevices.removeEventListener("devicechange", this.boundOnDeviceChange),
        yu.call(this),
        e.update("audio-in", { enabled: !1 }),
        e.update("audio-out", { enabled: !1 }),
        e.update("webcam", { enabled: !1 }),
        super.onClose(A);
    }
    setRequestedSettings(A) {
      this.setVolumeLevel(A.audioVolume),
        this.setAudioInput(A.audioMicEnabled)
          .then(() => {
            this.log.debug(`Set audio input to ${A.audioMicEnabled}`);
          })
          .catch((e) => {
            this.log.warn(`Impossible to set audio input to ${A.audioMicEnabled}. Error: ${e}`);
          }),
        this.webcamManager &&
          this.webcamManager
            .setWebcam(A.webcamEnabled)
            .then(() => {
              this.log.debug(`Set webcam to ${A.webcamEnabled}`);
            })
            .catch((e) => {
              this.log.warn(`Impossible to set webcam to ${A.webcamEnabled}. Error: ${e}`);
            });
    }
    sendMessage(A, e) {
      var t;
      this.transport.sendMessage(((t = A), Do(hu.ClientMessage, t)), e);
    }
    sendStartService(A) {
      this.sendMessage({ startService: { service: A } });
    }
    sendStopService(A) {
      A === hu.AudioService.STREAM
        ? ((this.state.audioOn = !1), this.log.info("Stopping audio streaming."))
        : A === hu.AudioService.INJECTION && this.log.info("Stopping microphone streaming."),
        this.sendMessage({ stopService: { service: A } });
    }
    setVolumeLevel(A) {
      this.audioOutput.setVolume(A / 100);
    }
    setAudioInput(A, e) {
      const t = this.microphone.microphoneMediaDeviceInfo;
      return Ku()
        ? e && t && t.deviceId !== e && A
          ? this.microphone
              .setEnabled(this.encoder, !1)
              .then(() => this.microphone.setEnabled(this.encoder, !0, e))
          : this.microphone.setEnabled(this.encoder, A, e)
        : Promise.reject("Audio input not supported from the browser");
    }
    sendAudioPacket(A, e, t) {
      this.log.debug(
        `Sending audio packet of ${A.byteLength}bytes with timestamp ${e} and audio strength ${t}`
      ),
        this.sendMessage({ audioPacket: { timestamp: e, strength: t } }, A);
    }
    setWebcam(A, e) {
      return this.webcamManager
        ? this.webcamManager.setWebcam(A, e)
        : Promise.reject("Webcam not supported from the browser");
    }
  },
  [Ia.CLIPBOARD]: class extends qa {
    constructor(A, e, t, i, n, o, r) {
      super(A, e, t, i, n, o, Hl, r),
        (this.onClipboardEvent = A.observers.clipboardEvent),
        (this.clipboardAutoSyncAvailable = A.clipboardAutoSync);
      try {
        this.remoteClipboard = new fl(
          this.onClipboardEvent,
          this.clipboardAutoSyncAvailable,
          this.clientConnectionId
        );
      } catch (A) {
        throw (
          (this.log.warn(`Could not create Clipboard: ${A.message}`),
          (this.remoteClipboard = null),
          A)
        );
      }
      this.remoteClipboard.onNewLocalData = _l.bind(this);
    }
    run() {
      this.log.info(`Started clipboard protocol on channel ${this.clientConnectionId}`),
        (this.onMessageReceived = (A, e) => {
          return Wl.call(this, ((t = A), wo(Yl.ServerMessage, t)), e);
          var t;
        });
    }
    onClose(A) {
      const e = Ws(this.clientConnectionId);
      e.update("clipboard-copy", { enabled: !1 }),
        e.update("clipboard-paste", { enabled: !1 }),
        this.remoteClipboard.enableCopy(!1),
        this.remoteClipboard.enablePaste(!1),
        (this.idDataClipboard = null),
        (this.lastClipboardDataReceived = null),
        (this.remoteClipboard = null),
        super.onClose(A);
    }
    getRemoteClipboard() {
      return this.remoteClipboard;
    }
  },
  [Ia.INPUT]: class extends qa {
    constructor(A, e, t, i, n, o, r) {
      super(A, e, t, i, n, o, Dc, r),
        (this.status = {}),
        (this.onKeyboardEnabledCb = (e) => {
          this.log.info("Notifying keyboard status " + (e ? "enabled" : "disabled")),
            Xn(A.observers.keyboardEnabled) && A.observers.keyboardEnabled(e);
        }),
        (this.motionMessagesFromLastAck = 0),
        (this.motionMessageAckRequestPeriod = 5),
        (this.motionMessagesFromLastAckRequest = this.motionMessageAckRequestPeriod),
        (this.lastDiscardedMotionMessage = null),
        (this.relativeMouseSupported = !1),
        (this.cursor = new mc()),
        (this.currentPointerCursor = 0),
        (this.cursorCache = new Map()),
        (this.outstandingAcks = []),
        (this.cursorTimestamp = Date.now()),
        (this.input = new Ig(e));
    }
    run() {
      const A = Ws(this.clientConnectionId);
      this.log.info(`Started input protocol on channel ${this.clientConnectionId}`),
        (this.onMessageReceived = (A, e) => {
          return xc.call(this, ((t = A), wo(wc.ServerMessage, t)), e);
          var t;
        }),
        to(this.protocolVersion, { major: 1, minor: 1 })
          ? (this.log.info("Server handles status updates"),
            (this.status.keyboard = wc.Status.NOT_AVAILABLE),
            (this.status.mouse = wc.Status.NOT_AVAILABLE),
            (this.status.touch = wc.Status.NOT_AVAILABLE),
            (this.status.pointer = wc.Status.NOT_AVAILABLE),
            (this.status.sas = wc.Status.NOT_AVAILABLE))
          : (this.log.warn("Server does not handle status updates, status updates are disabled"),
            (this.status.keyboard = wc.Status.ACTIVE),
            (this.status.mouse = wc.Status.ACTIVE),
            (this.status.touch = wc.Status.ACTIVE),
            (this.status.pointer = wc.Status.ACTIVE),
            (this.status.sas = wc.Status.ACTIVE)),
        (this.status.stylus = wc.Status.NOT_AVAILABLE),
        this.input.setTouchSupported(!1),
        this.input.enableRelativeMouseMode(this.relativeMouseSupported),
        A.update("keyboard-sas", { enabled: this.status.sas === wc.Status.ACTIVE });
    }
    onClose(A) {
      const e = Ws(this.clientConnectionId);
      this.onKeyboardEnabledCb && this.onKeyboardEnabledCb(!1),
        e.update("mouse", { enabled: !1 }),
        e.update("keyboard", { enabled: !1 }),
        e.update("keyboard-sas", { enabled: !1 }),
        this.input.enableRelativeMouseMode(!1),
        this.input.unregisterChannel(this),
        super.onClose(A);
    }
    sendInputMessage(A) {
      if (this.setupCompleted)
        if (
          this.status.mouse !== wc.Status.ACTIVE &&
          (A.pointerMotionEvent ||
            A.pointerRelativeMotionEvent ||
            A.pointerButtonPressEvent ||
            A.pointerButtonReleaseEvent ||
            A.pointerAxisEvent)
        )
          this.log.debug(`Discard mouse message ${A.msg}, mouse service is not active`);
        else if (
          this.status.keyboard !== wc.Status.ACTIVE &&
          (A.specialKeyDownEvent || A.specialKeyUpEvent || A.keyDownEvent || A.keyUpEvent)
        )
          this.log.debug(`Discard keyboard message ${A.msg}, keyboard service is not active`);
        else if (this.status.touch !== wc.Status.ACTIVE && A.touchEvent)
          this.log.debug(`Discard touch message ${A.msg}, touch service is not active`);
        else if (this.status.pointer !== wc.Status.ACTIVE && A.pointerRequireCursorImages)
          this.log.debug(`Discard pointer message ${A.msg}, pointer service is not active`);
        else if (this.status.stylus !== wc.Status.ACTIVE && A.stylusEvent)
          this.log.debug(`Discard stylus message ${A.msg}, stylus service is not active`);
        else {
          if (A.pointerMotionEvent) {
            if (this.motionMessagesFromLastAck >= 2 * this.motionMessageAckRequestPeriod)
              return (
                this.log.debug("Discard pointerMotionEvent message"),
                void (this.lastDiscardedMotionMessage = A)
              );
            (this.lastDiscardedMotionMessage = null),
              this.motionMessagesFromLastAck++,
              this.motionMessagesFromLastAckRequest >= this.motionMessageAckRequestPeriod &&
                ((A.pointerMotionEvent.requestAck = !0),
                this.outstandingAcks.push({ sendtime: Date.now() }),
                (this.motionMessagesFromLastAckRequest = 0)),
              this.motionMessagesFromLastAckRequest++;
          }
          var e;
          this.transport.sendMessage(((e = A), Do(wc.ClientMessage, e)));
        }
      else this.log.warn("Blocked input message, channel setup not complete");
    }
    setCursorResource(A) {
      !Ao(A) && A.url
        ? (this.log.info("Registered cursor resource"), (this.cursorResource = A))
        : this.log.warn("Invalid cursor resource url");
    }
    getCursorResource() {
      return this.cursorResource;
    }
    isStylusSupportedByServer() {
      return this.status.stylus === wc.Status.ACTIVE;
    }
    getInput() {
      return this.input;
    }
  },
  [Ia.FILESTORAGE]: class extends qa {
    constructor(A, e, t, i, n, o, r) {
      super(A, e, t, i, n, o, rC, r);
      const s = Ws(this.clientConnectionId);
      (this.onFileStorageEnabledCb = function (e) {
        this.log.info("Notifying filestorage status " + (e ? "enabled" : "disabled")),
          Xn(A.observers.filestorageEnabled) && A.observers.filestorageEnabled(e);
      }),
        (this.requestedCommands = {}),
        (this.currentListRequestId = 0),
        (this.lastRequestId = 0),
        (this.uploadTimer = new Yu(this)),
        (this.fileExplorer = {
          list: (A) => new Ju(this, A),
          createDirectory: (A) => new ju(this, A),
          deleteFile: (A) => new Wu(this, A, !1),
          renameFile: (A, e) => new Vu(this, A, e, !1),
          renameDirectory: (A, e) => new Vu(this, A, e, !0),
          retrieveFile: (A) => new _u(this, A),
          storeFile: (A, e) => new Zu(this, A, e),
          uploadFiles: (A, e) => new $u(this, A, e)
        }),
        this.onFileStorageEnabledCb(!0),
        this.isStatusUpdateSupported ||
          (s.update("file-download", { enabled: !0 }), s.update("file-upload", { enabled: !0 }));
    }
    run() {
      this.log.info(
        `Starting file session storage protocol (Protocol version {${this.protocolVersion.major}.${this.protocolVersion.minor}})`
      ),
        (this.isTransferAckSupported = to(this.protocolVersion, { major: 1, minor: 1 })),
        (this.isStatusUpdateSupported = to(this.protocolVersion, { major: 1, minor: 2 })),
        (this.onMessageReceived = (A, e) => {
          return this.handleFilestorageMessage(((t = A), wo(sC.ServerMessage, t)));
          var t;
        });
    }
    onClose(A) {
      let e,
        t = Ws(this.clientConnectionId);
      for (e in this.requestedCommands)
        this.requestedCommands[e] instanceof Zu &&
          null !== this.requestedCommands[e].chunkedUploader &&
          (this.requestedCommands[e].chunkedUploader.cancel(),
          (this.requestedCommands[e].chunkedUploader = null),
          this.requestedCommands[e].trigger("error", {
            code: Io.FileStorage.ABORTED,
            message: "The operation was aborted"
          }));
      this.onFileStorageEnabledCb(!1),
        t.update("file-download", { enabled: !1 }),
        t.update("file-upload", { enabled: !1 }),
        super.onClose(A);
    }
    getFileExplorer() {
      return this.fileExplorer;
    }
    requestCommand(A) {
      return (
        this.lastRequestId++,
        this.lastRequestId === Number.MAX_VALUE && (this.lastRequestId = 1),
        (this.requestedCommands[this.lastRequestId] = A),
        this.lastRequestId
      );
    }
    sendTransferChunk(A, e) {
      this.log.debug(`Sending the TRANSFER CHUNK message to server for id ${A}`),
        this.transport.sendMessage(aC({ transferChunk: { requestId: A } }), e);
    }
    sendTransferEnd(A, e) {
      this.log.debug(`Sending the TRANSFER END message to server for id ${A}`),
        this.transport.sendMessage(aC({ transferEnd: { requestId: A, reason: e } }));
    }
    setUploadBandwidth(A) {
      this.log.debug(`Upload speed set to ${A}kbps`),
        (this.uploadTimer.maxByteRate = (1024 * A) / 8),
        (this.uploadTimer.currentByteRate = Math.min(
          this.uploadTimer.currentByteRate,
          this.uploadTimer.maxByteRate
        ));
    }
    getTotalOutstandingAcks() {
      let A,
        e = 0;
      if (!this.isTransferAckSupported) return 0;
      for (A in this.requestedCommands)
        this.requestedCommands[A] instanceof Zu &&
          null !== this.requestedCommands[A].chunkedUploader &&
          !this.requestedCommands[A].chunkedUploader.done &&
          (e += this.requestedCommands[A].chunkedUploader.outstandingAck);
      return e;
    }
    handleFilestorageMessage(A) {
      let e;
      if (((e = A.commandResult || A.listMessage || A.transferChunkAck || A.statusUpdate), e)) {
        if ("statusUpdate" === A.msg)
          return this.isStatusUpdateSupported
            ? void this.handleStatusUpdate(A)
            : void this.log.warn("Received status update message when not supported by protocol");
        if (e.requestId)
          if (this.requestedCommands[e.requestId])
            switch (A.msg) {
              case "commandResult":
                this.handleCommandResult(e);
                break;
              case "listMessage":
                this.handleFolderListing(e);
                break;
              case "transferChunkAck":
                this.handleTransferChunkAck(e);
                break;
              default:
                this.log.debug(`Unknown file session storage message: ${A}`);
            }
          else this.log.debug("Received a file storage message referring to unknown request.");
        else this.log.warn("Received invalid message from the server: no request id");
      } else this.log.warn("Received invalid message from the server.");
    }
    handleStatusUpdate(A) {
      const e = Ws(this.clientConnectionId);
      let t, i;
      switch (A.statusUpdate.status) {
        case sC.Status.ALLOWED:
          t = !0;
          break;
        case sC.Status.NOT_ALLOWED:
          t = !1;
          break;
        default:
          this.log.warn("Received a file storage message referring to unknown status");
      }
      switch (A.statusUpdate.service) {
        case sC.Service.UPLOAD:
          i = "file-upload";
          break;
        case sC.Service.DOWNLOAD:
          i = "file-download";
          break;
        default:
          this.log.warn("Received a file storage message referring to unknown service");
      }
      this.log.info(
        `Received filestorage status update for service ${i}: ${t ? "Allowed" : "Not Allowed"}`
      ),
        e.update(i, { enabled: t });
    }
    handleTransferChunkAck(A) {
      let e,
        t = A.requestId;
      this.requestedCommands[t] && this.requestedCommands[t].chunkedUploader
        ? ((e = this.requestedCommands[t].chunkedUploader),
          e.outstandingAck--,
          this.log.info(
            `Uploaded chunk of file ${e.file.name}(id: ${t}, transferred: ${A.bytesTransfered}/${e.file.size} bytes)`
          ),
          Xn(e.onprogress) &&
            e.onprogress($c.fromNumber(A.bytesTransfered).toNumber(), e.file.size))
        : this.log.warn(`Unknown chunked uploader ${t}`);
    }
    handleFolderListing(A) {
      let e,
        t = [];
      (e = this.requestedCommands[A.requestId]),
        e instanceof Ju && A.requestId === this.currentListRequestId
          ? (this.log.debug(`Received List for path ${e.path} of ${A.item.length} items.`),
            A.item.forEach((A) => {
              const e = this.handleFileInfo(A);
              e && t.push(e);
            }),
            t.length > 0 && e.trigger("newItems", t))
          : this.log.debug(`Received unexpected list object for request ${A.requestId}`);
    }
    handleFileInfo(A) {
      let e, t, i;
      if (A.type === sC.FileInfo.Type.FILE) e = "file";
      else {
        if (A.type !== sC.FileInfo.Type.DIRECTORY) return null;
        e = "folder";
      }
      return (
        (t = "" !== A.displayName ? A.displayName : A.name),
        (i = "" !== A.mimeType ? A.mimeType : null),
        this.log.debug(`${e} ${A.name} ${A.lastModified} ${t} ${A.size} ${i}`),
        {
          type: e,
          path: A.name,
          lastModified: A.lastModified,
          displayName: t,
          size: A.size,
          mimeType: i
        }
      );
    }
    handleUploadConfirmed(A) {
      this.log.debug(`The server is ready to accept data with id ${A}`),
        this.requestedCommands[A] && this.requestedCommands[A].chunkedUploader
          ? this.requestedCommands[A].chunkedUploader.upload()
          : this.log.warn(`Unknown chunked uploader ${A}`);
    }
    handleCommandResultFail(A, e, t) {
      this.log.warn(`The requested command with id ${A} has not been completed: ${t}`),
        this.requestedCommands[A] instanceof Zu &&
          null !== this.requestedCommands[A].chunkedUploader &&
          (this.requestedCommands[A].chunkedUploader.cancel(),
          (this.requestedCommands[A].chunkedUploader = null)),
        this.requestedCommands[A].trigger("error", { code: e, message: t }),
        delete this.requestedCommands[A];
    }
    handleCommandResult(A) {
      switch (A.completionCode) {
        case sC.CommandResult.CompletionCode.OK:
          this.log.debug(
            `The requested command with id ${A.requestId} has been successfully completed`
          ),
            this.requestedCommands[A.requestId].trigger("success"),
            delete this.requestedCommands[A.requestId];
          break;
        case sC.CommandResult.CompletionCode.READY:
          this.handleUploadConfirmed(A.requestId);
          break;
        case sC.CommandResult.CompletionCode.CANCELLED:
          this.handleCommandResultFail(
            A.requestId,
            Io.FileStorage.CANCELLED,
            "The operation was cancelled"
          );
          break;
        case sC.CommandResult.CompletionCode.ABORTED:
          this.handleCommandResultFail(
            A.requestId,
            Io.FileStorage.ABORTED,
            "The operation was aborted"
          );
          break;
        case sC.CommandResult.CompletionCode.ERROR_NOT_FOUND:
          this.handleCommandResultFail(A.requestId, Io.FileStorage.NOT_FOUND, "Path not found");
          break;
        case sC.CommandResult.CompletionCode.ERROR_ALREADY_EXIST:
          this.handleCommandResultFail(
            A.requestId,
            Io.FileStorage.ALREADY_EXISTS,
            "The file already exists"
          );
          break;
        case sC.CommandResult.CompletionCode.ERROR:
          this.handleCommandResultFail(A.requestId, Io.FileStorage.ERROR, "The operation failed");
          break;
        case sC.CommandResult.CompletionCode.INVALID_ARGUMENT:
          this.handleCommandResultFail(
            A.requestId,
            Io.FileStorage.INVALID_ARGUMENT,
            "Invalid argument"
          );
          break;
        case sC.CommandResult.CompletionCode.UNINPLEMENTED_COMMAND:
          this.handleCommandResultFail(
            A.requestId,
            Io.FileStorage.NOT_IMPLEMENTED,
            "The operation is not supported"
          );
          break;
        default:
          this.handleCommandResultFail(A.requestId, Io.FileStorage.UNKNOWN, "Unknown command");
      }
    }
    abortCurrentListRequest() {
      let A;
      (A = this.requestedCommands[this.currentListRequestId]),
        A instanceof Ju &&
          (A.trigger("error", {
            code: Io.FileStorage.ABORTED,
            message: "The operation was aborted"
          }),
          delete this.requestedCommands[this.currentListRequestId]);
    }
    sendCommandCancel(A) {
      this.transport.sendMessage(aC({ commandCancel: { requestId: A } }));
    }
    sendList(A, e) {
      this.transport.sendMessage(aC({ commandRequest: { requestId: A, list: { pathname: e } } }));
    }
    createFolder(A, e) {
      this.log.debug(`Requesting creation of folder ${e}`),
        this.transport.sendMessage(
          aC({ commandRequest: { requestId: A, createDirectory: { pathname: e } } })
        );
    }
    deleteFile(A, e) {
      this.log.debug(`Requesting remove of file ${e}`),
        this.transport.sendMessage(
          aC({ commandRequest: { requestId: A, deleteFile: { pathname: e } } })
        );
    }
    deleteDirectory(A, e) {
      this.log.debug(`Requesting remove of directory ${e}`),
        this.transport.sendMessage(
          aC({ commandRequest: { requestId: A, deleteDirectory: { pathname: e } } })
        );
    }
    moveFile(A, e, t) {
      this.log.debug(`Requesting move/rename of ${e} to ${t}`),
        this.transport.sendMessage(
          aC({ commandRequest: { requestId: A, moveFile: { oldPathname: e, newPathname: t } } })
        );
    }
    moveDirectory(A, e, t) {
      this.log.debug(`Requesting move/rename of ${e} to ${t}`),
        this.transport.sendMessage(
          aC({
            commandRequest: { requestId: A, moveDirectory: { oldPathname: e, newPathname: t } }
          })
        );
    }
    sendDownloadRequest(A, e) {
      this.log.debug(`Requesting download for ${e} with id ${A}`),
        this.transport.sendMessage(
          aC({ commandRequest: { requestId: A, retrieveFile: { pathname: e } } })
        );
    }
    sendUploadRequest(A, e, t) {
      this.log.debug(`Requesting upload in path ${A} of size ${e} with id ${t}`),
        this.transport.sendMessage(
          aC({ commandRequest: { requestId: t, storeFile: { pathname: A, fileSize: e } } })
        );
    }
  },
  [Ia.SMARTCARD]: null,
  [Ia.USB]: null,
  [Ia.REDIRECTION]: null
};
let dC;
function uC(A) {
  return !Object.prototype.hasOwnProperty.call(lC, A) && -1 === Object.values(ca).indexOf(A);
}
function CC(A) {
  return A === la.WEBRTC_REDIRECTION;
}
function BC(A) {
  this.log = Q("resource");
  (this.sessionId = A.sessionId),
    (this.resourceBaseUrl = (function (A, e) {
      let t,
        i = (function (A) {
          const e = document.createElement("a");
          let t;
          return (
            e.setAttribute("href", A),
            (t = { host: e.host, protocol: e.protocol, pathname: e.pathname, origin: e.origin }),
            t
          );
        })(A),
        n = i.origin ? i.origin : `${i.protocol}//${i.host}`;
      (n = n.replace(/\/+$/g, "")),
        (t = e ? ("/" === e.charAt(0) ? n + e : e) : n + i.pathname.replace(/\/[^/]*$/, ""));
      return t;
    })(A.url, A.resourceBaseUrl)),
    (this.extensionData = A.extensionData),
    (this.connectionFailureRetryAttempts = Ao(A.connectionFailureRetryAttempts)
      ? 10
      : A.connectionFailureRetryAttempts),
    (this.connectionBlockRetryAttempts = Ao(A.connectionBlockRetryAttempts)
      ? 0
      : A.connectionBlockRetryAttempts),
    (this.httpExtraHeaders = A.observers?.httpExtraHeaders),
    this.log.debug(`Resource created. Base URL: ${this.resourceBaseUrl}`);
}
function QC(A, e, t, i) {
  const n = hC.call(this, A);
  fetch(n)
    .then((n) => {
      if ((EC.call(this, n), n.ok)) e(n.blob());
      else {
        let o = 1;
        Ao(i) || (o = i + 1);
        const r = this.connectionBlockRetryAttempts;
        if (!(429 === n.status && o <= r))
          throw new Error(`Failed fetch: ${n.statusText} (${n.status} - ${n.type})`);
        this.log.info(
          `Failed to fetch resource ${this.id} in attempt ${o} (${n.status}), retrying to connect`
        ),
          setTimeout(() => {
            QC.call(this, A, e, t, o);
          }, 1);
      }
    })
    .catch((n) => {
      let o = 1;
      Ao(i) || (o = i + 1);
      const r = this.connectionFailureRetryAttempts;
      if (n instanceof TypeError && o <= r) {
        const i = Math.min(2560, 20 * Math.pow(2, o));
        this.log.info(
          `Failed to fetch resource ${this.id} in attempt ${o}, retrying to connect in ${i} ms`
        ),
          setTimeout(() => {
            QC.call(this, A, e, t, o);
          }, i);
      } else t(n);
    });
}
function EC(A) {
  this.log.debug(
    `Received response. Status code: ${A.status}, Status Text: ${A.statusText}, type: ${A.type}`
  ),
    [...A.headers.entries()].forEach((A) => this.log.debug(`Header: ${A[0]} with value: ${A[1]}`));
}
function hC(A) {
  const e = new Headers({ "Content-Type": "application/x-www-form-urlencoded" }),
    t = new URL(this.url.replace(/\?token=.*?(&|$)/, "?").replace(/\?$/, "")),
    i = new URLSearchParams({ token: encodeURIComponent(this.token) });
  zn(A) &&
    Object.entries(A).forEach(([A, e]) => {
      i.append(A, e);
    }),
    this.extensionData && e.append("DCV-Extension-Data", this.extensionData);
  let n = new Request(t, { method: "POST", body: i, headers: e });
  if (Xn(this.httpExtraHeaders)) {
    let A = this.httpExtraHeaders("POST", t, n.body);
    A instanceof Headers
      ? A.forEach((A, e) => {
          n.headers.append(e, A);
        })
      : this.log.warn("httpExtraHeaders callback returned invalid type " + typeof A);
  }
  return n;
}
function pC(A) {
  (this.log = Q("featuremanager")), (this.featuresUpdate = A), (this.features = {});
}
function fC() {
  this.channels = { mainChannel: null, dataChannels: {}, customChannels: {}, lazyChannels: {} };
}
function mC() {
  (this.bytesReceived = 0),
    (this.swaps = 0),
    (this.latencySamples = []),
    (this.statsSample = { timestamp: 0, bytesReceived: 0, swaps: 0 }),
    (this.stats = {
      fps: 0,
      traffic: 0,
      peakTraffic: 0,
      latency: 0,
      currentChannels: 0,
      openedChannels: 0,
      channelErrors: 0
    }),
    this.statsTimer();
}
(BC.prototype.decline = function () {
  let A,
    e = new Headers();
  this.extensionData && e.append("DCV-Extension-Data", this.extensionData);
  const t = new URL(this.url);
  if (Xn(this.httpExtraHeaders)) {
    let A = this.httpExtraHeaders("DELETE", t, null);
    A instanceof Headers
      ? A.forEach((A, t) => {
          e.has(t)
            ? this.log.warn(`httpExtraHeaders callback returned duplicate header ${t}`)
            : e.append(t, A);
        })
      : this.log.warn("httpExtraHeaders callback returned invalid type " + typeof A);
  }
  (A = new Request(t, { method: "DELETE", keepalive: !1, headers: e })),
    this.log.info(`Declining resource ${this.id}`),
    fetch(A)
      .then((A) => {
        EC.call(this, A),
          this.log.info(`HTTP DELETE sent for resource ${this.id} at domain ${this.domain}`);
      })
      .catch((A) =>
        this.log.warn(`Failed to send DELETE request to refuse resource ${this.id}. Error: ${A})`)
      );
}),
  (BC.prototype.accept = function (A) {
    const e = this.id;
    this.log.info(`Accepting resource with id "${e}"`),
      this.fetch(A)
        .then((A) => {
          this.log.info(`Successfully fetched resource with id "${e}"`);
          const t = document.createElement("a");
          (t.href = URL.createObjectURL(A)),
            "download" in t && (t.download = e.split("/").slice(-1)),
            (t.target = "_blank"),
            t.click();
        })
        .catch((A) => this.log.warn(`Failed to accept resource with id "${e}": ${A}`));
  }),
  (BC.prototype.fetch = function (A) {
    return new Promise((e, t) => {
      this.log.debug(`Fetching resource ${this.id}`), QC.call(this, A, e, t);
    });
  }),
  (BC.prototype.setup = function (A, e, t, i) {
    (this.serverConnectionId = A),
      (this.domain = e),
      (this.token = i),
      (this.id = t),
      (this.url =
        this.resourceBaseUrl +
        (function (A, e, t, i, n, o) {
          let r = null;
          return (
            (r = `/resource/${encodeURIComponent(t)}/${btoa(A)}/${e}/${encodeURIComponent(i)}?token=${encodeURIComponent(n)}`),
            o.debug(`URL for resource [${i}]: ${r}`),
            r
          );
        })(this.sessionId, this.serverConnectionId, e, t, i, this.log)),
      Object.getOwnPropertyDescriptor(this, "URL") ||
        Object.defineProperty(this, "URL", {
          get() {
            return this.url;
          },
          set(A) {
            this.url = A;
          }
        }),
      this.log.debug(
        `New resource created:\n\tURL: ${this.url}\n\tDomain: ${e}\n\tId: ${t}\n\tToken: ${i}`
      );
  }),
  (BC.prototype.addPrinterResourceURLFormats = function () {
    gr() && !mr()
      ? (this.log.debug(`Printed formats for resource ${this.id} are XPS and PDF`),
        (this.url += "&formats=xps,pdf"))
      : (this.log.debug(`Printed format for resource ${this.id} is PDF`),
        (this.url += "&formats=pdf"));
  }),
  (BC.prototype.setConnectionId = function (A) {
    this.log = Q("resource", A);
  }),
  (BC.prototype.setExtensionData = function (A) {
    this.extensionData = A;
  }),
  (pC.prototype.query = function (A) {
    return new Promise((e, t) => {
      "string" != typeof A
        ? t({
            message: `Invalid argument for querying a feature's status: ${A}. It should be a string.`
          })
        : -1 !== Object.keys(this.features).indexOf(A) && this.features[A].notified
          ? (this.log.info(
              `Sending feature query result for feature '${A}'. Status is ${JSON.stringify(this.features[A].status)}`
            ),
            e(this.features[A].status))
          : (this.log.info(
              `Sending feature query result for feature '${A}': feature not present or notified`
            ),
            t({ message: "Feature not present or notified" }));
    });
  }),
  (pC.prototype.update = function (A, e) {
    Ao(A) || Ao(e) || this.updateList([A], [e]);
  }),
  (pC.prototype.updateList = function (A, e) {
    Array.isArray(A) &&
      Array.isArray(e) &&
      A.length === e.length &&
      (A.forEach((A, t) => {
        this.features[A] = { status: e[t], notified: !0 };
      }),
      this.log.info(`Notifying features update for ${JSON.stringify(A)}`),
      this.featuresUpdate(A));
  }),
  (pC.prototype.setConnectionId = function (A) {
    (this.clientConnectionId = A), (this.log = Q("featuremanager", A));
  }),
  (fC.prototype.getChannels = function () {
    return this.channels;
  }),
  (fC.prototype.getMainChannel = function () {
    return this.channels.mainChannel;
  }),
  (fC.prototype.getDataChannels = function () {
    return this.channels.dataChannels;
  }),
  (fC.prototype.getDataChannel = function (A) {
    return this.channels.dataChannels[A];
  }),
  (fC.prototype.getCustomChannels = function () {
    return this.channels.customChannels;
  }),
  (fC.prototype.getCustomChannel = function (A) {
    return this.channels.customChannels[A];
  }),
  (fC.prototype.getLazyChannels = function () {
    return this.channels.lazyChannels;
  }),
  (fC.prototype.getLazyChannel = function (A) {
    return this.channels.lazyChannels[A];
  }),
  (fC.prototype.setChannels = function (A) {
    this.channels = A;
  }),
  (fC.prototype.setMainChannel = function (A) {
    this.channels.mainChannel = A;
  }),
  (fC.prototype.setDataChannel = function (A, e) {
    this.channels.dataChannels[A] = e;
  }),
  (fC.prototype.setCustomChannel = function (A, e) {
    this.channels.customChannels[A] = e;
  }),
  (fC.prototype.setLazyChannel = function (A, e) {
    this.channels.lazyChannels[A] = e;
  }),
  (fC.prototype.removeDataChannel = function (A, e) {
    A in this.channels.dataChannels &&
      this.channels.dataChannels[A] === e &&
      delete this.channels.dataChannels[A];
  }),
  (fC.prototype.removeCustomChannel = function (A, e) {
    A in this.channels.customChannels &&
      this.channels.customChannels[A] === e &&
      delete this.channels.customChannels[A];
  }),
  (fC.prototype.removeLazyChannel = function (A) {
    A in this.channels.lazyChannels && delete this.channels.lazyChannels[A];
  }),
  (fC.prototype.hasNoOpenChannels = function () {
    return (
      Ao(this.channels.mainChannel) &&
      !Object.keys(this.channels.dataChannels).length &&
      !Object.keys(this.channels.customChannels).length &&
      !Object.keys(this.channels.lazyChannels).length
    );
  }),
  (mC.prototype.statsTimer = function () {
    let A = Date.now(),
      e = A - 6e4,
      t = 0,
      i = 0,
      n = 0;
    A > this.statsSample.timestamp &&
      this.statsSample.timestamp > 0 &&
      (this.swaps > this.statsSample.swaps &&
        (t = Math.round(
          (1e3 * (this.swaps - this.statsSample.swaps)) / (A - this.statsSample.timestamp)
        )),
      this.bytesReceived > this.statsSample.bytesReceived &&
        (i =
          ((1e3 * (this.bytesReceived - this.statsSample.bytesReceived)) /
            (A - this.statsSample.timestamp)) *
          8)),
      (this.latencySamples = this.latencySamples.filter((A) => A.sendtime > e)),
      (n = 0),
      this.latencySamples.forEach((A, e) => {
        n += (A.recvtime - A.sendtime - n) / (1 + e);
      }),
      (this.statsSample.timestamp = A),
      (this.statsSample.bytesReceived = this.bytesReceived),
      (this.statsSample.swaps = this.swaps),
      (this.stats.fps = t),
      (this.stats.traffic = i),
      (this.stats.latency = n),
      i > this.stats.peakTraffic && (this.stats.peakTraffic = i),
      setTimeout(this.statsTimer.bind(this), 1e3);
  }),
  (mC.prototype.getStats = function () {
    return this.stats;
  }),
  (mC.prototype.addBytesReceived = function (A) {
    this.bytesReceived += A;
  }),
  (mC.prototype.addLatencySample = function (A) {
    this.latencySamples.push(A);
  }),
  (mC.prototype.incrementSwaps = function () {
    this.swaps++;
  }),
  (mC.prototype.channelOpened = function () {
    this.stats.openedChannels++, this.stats.currentChannels++;
  }),
  (mC.prototype.channelClosed = function () {
    this.stats.currentChannels--;
  }),
  (mC.prototype.channelError = function () {
    this.stats.channelErrors++;
  });
const yC = 10;
function DC() {
  this.log.info("Disconnecting DCV since the page has been unloaded"), this.disconnect();
}
function wC(A) {
  (this.log = Q("connection")),
    (this.configuration = A),
    (this.authToken = A.authToken),
    (this.extensionData = A.extensionData),
    FC.call(this),
    (this.channelManager = new fC()),
    (this.featureManager = new pC(A.observers.featuresUpdate)),
    (this.statsManager = new mC()),
    (this.pendingChannelNotifications = new Map()),
    (this.disconnectionRequested = !1),
    (this.requestedSettings = {
      qualityUpdatesEnabled: !0,
      highPixelDensityEnabled: A.enableHighPixelDensity,
      audioMicEnabled: !1,
      webcamEnabled: !1,
      minDisplayWidth: 640,
      minDisplayHeight: 480,
      maxDisplayNumber: 2,
      audioVolume: A.volumeLevel
    }),
    (this.onPageHide = DC.bind(this)),
    (this.IMEModeBehavior = "auto"),
    (this.currentIMEMode = !Qr()),
    (this.setCurrentIMEMode = LC.bind(this)),
    (this.getCurrentIMEMode = PC.bind(this)),
    (this.getIMEModeBehavior = TC.bind(this)),
    (this.firstFrameReceived = !1),
    (this.onFirstFrame = function () {
      this.firstFrameReceived ||
        ((this.firstFrameReceived = !0),
        this.log.info(
          `First frame received for the connection (version: ${h.version}, session: ${this.configuration.sessionId})`
        ));
    });
}
function FC() {
  (this.configuration.observers = this.configuration.observers || {}),
    this.configuration.callbacks &&
      Object.entries(this.configuration.callbacks).forEach(([A, e]) => {
        this.configuration.observers[A] = (...A) => e(this, ...A);
      }),
    [
      { name: "disconnect", deprecated: !1 },
      { name: "displayLayout", deprecated: !1 },
      { name: "firstFrame", deprecated: !1 },
      { name: "filePrinted", deprecated: !1 },
      { name: "fileDownload", deprecated: !1 },
      { name: "dataChannel", deprecated: !1 },
      { name: "licenseNotification", deprecated: !1 },
      { name: "idleWarningNotification", deprecated: !1 },
      { name: "qualityIndicatorState", deprecated: !1 },
      { name: "filestorageEnabled", deprecated: !1 },
      { name: "featuresUpdate", deprecated: !1 },
      { name: "clipboardEvent", deprecated: !1 },
      { name: "deviceChangeEvent", deprecated: !1 },
      { name: "screenshot", deprecated: !1 },
      { name: "collaboratorList", deprecated: !1 },
      { name: "networkQualityChange", deprecated: !1 }
    ].forEach((A) => {
      A.deprecated ||
        Xn(this.configuration.observers[A.name]) ||
        (this.log.warn(`Connection callback ${A.name} is undefined`),
        (this.configuration.observers[A.name] = () => {
          this.log.info(`Unhandled event for callback ${A.name} triggered`);
        })),
        A.deprecated &&
          Xn(this.configuration.observers[A.name]) &&
          this.log.warn(`Connection callback ${A.name} is deprecated`);
    });
}
function bC(A, e, t) {
  if (this.channelManager.getMainChannel())
    return (
      this.log.error("Main channel already opened"),
      void e({
        code: Io.Connection.MAIN_CHANNEL_ALREADY_OPEN,
        message: "Main channel already opened"
      })
    );
  const i = performance.now(),
    n =
      ((o = this.configuration),
      (r = this.authToken),
      (s = this.extensionData),
      (a = {
        onSetupCompleted: (e) => {
          var t, i;
          (this.clientConnectionId =
            ((t = this), (Gs[Hs] = t), Ys.info(`Added connection ${Hs} to connections`), Hs++)),
            (this.id = this.serverConnectionId = e.serverConnectionId),
            (e.clientConnectionId = this.clientConnectionId),
            (i = this.clientConnectionId) in l || (l[i] = {}),
            (this.log = Q("connection", this.clientConnectionId)),
            this.log.info(
              `Main channel setup completed for connection with ClientConnectionId ${this.clientConnectionId} and ServerConnectionId ${this.serverConnectionId}`
            ),
            this.featureManager.setConnectionId(this.clientConnectionId),
            this.fileResource.setConnectionId(this.clientConnectionId),
            this.cursorResource.setConnectionId(this.clientConnectionId),
            this.printerResource.setConnectionId(this.clientConnectionId),
            this.log.info("Adding disconnect callback to window pagehide"),
            window.addEventListener("pagehide", this.onPageHide),
            A();
        },
        onSetupFailed: (n) => {
          let o = 1;
          const r = performance.now() - i;
          let s = Ao(this.configuration.connectionFailureRetryAttempts)
            ? yC
            : this.configuration.connectionFailureRetryAttempts;
          if (
            (Ao(n) ||
              n.code !== Io.Connection.GATEWAY_BUSY ||
              (s = this.configuration.connectionBlockRetryAttempts || 0),
            Ao(t) || (o = t + 1),
            this.channelManager.setMainChannel(null),
            !Ao(n) && n.code === Io.Connection.GATEWAY_BUSY && o <= s)
          )
            this.log.info(
              `Failed to establish main channel in attempt ${o} (${n.message} - ${n.code}), retrying to connect`
            ),
              setTimeout(() => {
                bC.call(this, A, e, o);
              }, 1);
          else if (o <= s && Ao(n) && r < 3e3) {
            const t = Math.min(2560, 20 * Math.pow(2, o));
            this.log.info(
              `Failed to establish main channel in attempt ${o}, retrying to connect in ${t} ms`
            ),
              setTimeout(() => {
                bC.call(this, A, e, o);
              }, t);
          } else
            Xn(e) && e(n || { code: Io.Connection.TRANSPORT_ERROR, message: "Connection failed" });
        },
        onOpen: () => this.statsManager.channelOpened(),
        onClose: () => this.statsManager.channelClosed(),
        onError: () => this.statsManager.channelError(),
        onChannelNotification: RC.bind(this),
        onResourceNotification: vC.bind(this),
        onLicenseNotification: xC.bind(this),
        onIdleWarningNotification: MC.bind(this),
        onMainChannelClose: kC.bind(this),
        onQualityIndicatorNotification: NC.bind(this),
        onCollaboratorListReceived: OC.bind(this),
        onNetworkQualityChange: KC.bind(this),
        httpExtraHeaders: this.configuration.observers?.httpExtraHeaders,
        httpExtraSearchParams: this.configuration.observers?.httpExtraSearchParams
      }),
      new Fa(o, r, s, a));
  var o, r, s, a;
  n
    ? this.channelManager.setMainChannel(n)
    : Xn(e) &&
      e({
        code: Io.Connection.INITIALIZATION_FAILED,
        message: "Failed to initialize channel object."
      });
}
function UC(A, e, t, i, n) {
  A in this.channelManager.getDataChannels() &&
    (this.log.warn(
      `${A} channel already open, forcing close of previous channel (${this.channelManager.getDataChannel(A).clientConnectionId})`
    ),
    this.channelManager.getDataChannel(A).close());
  const o = (function (A, e, t, i, n, o, r, s) {
    let a;
    if (!Object.prototype.hasOwnProperty.call(lC, i))
      return dC.info(`Channel of type '${i}' is not supported`), null;
    if (r.indexOf(i.toString()) < 0) return dC.info(`Channel of type '${i}' is not enabled`), null;
    if (fr() && i.toString() === Ia.CLIPBOARD)
      return dC.info("Disabling Clipboard support for Amazon WorkSpaces Thin Client"), null;
    try {
      a = new lC[i](A, e, t, i, n, o, s);
    } catch (A) {
      return dC.warn(`Unable to create channel of type '${i}' (${A.message})`), null;
    }
    return dC.info(`Created channel of type '${i}'`), a;
  })(
    this.configuration,
    this.clientConnectionId,
    this.serverConnectionId,
    A,
    e,
    this.extensionData,
    this.enabledChannels,
    {
      onSetupCompleted: (A) => {
        A.setRequestedSettings(this.requestedSettings), Xn(t) && t(A);
      },
      onSetupFailed: (o) => {
        let r = 1;
        Ao(n) || (r = n + 1);
        let s = Ao(this.configuration.connectionFailureRetryAttempts)
          ? yC
          : this.configuration.connectionFailureRetryAttempts;
        if (
          (Ao(o) ||
            o.code !== Io.Connection.GATEWAY_BUSY ||
            (s = this.configuration.connectionBlockRetryAttempts || 0),
          !Ao(o) && o.code === Io.Connection.GATEWAY_BUSY && r <= s)
        )
          this.log.info(
            `Failed to establish data channel ${A} in attempt ${r} (${o.message} - ${o.code}), retrying to connect`
          ),
            setTimeout(() => {
              UC.call(this, t, i, r);
            }, 1);
        else if (r <= s && Ao(o)) {
          const n = Math.min(2560, 20 * Math.pow(2, r));
          this.log.info(
            `Failed to establish data channel ${A} in attempt ${r}, retrying to connect in ${n} ms`
          ),
            setTimeout(() => {
              UC.call(this, A, e, t, i, r);
            }, n);
        } else Xn(i) && i(o);
      },
      onOpen: () => this.statsManager.channelOpened(),
      onClose: () => {
        this.statsManager.channelClosed(),
          this.channelManager.hasNoOpenChannels() &&
            Xn(this.onConnectionCloseCb) &&
            this.onConnectionCloseCb();
      },
      onError: () => this.statsManager.channelError(),
      httpExtraHeaders: this.configuration.observers?.httpExtraHeaders,
      httpExtraSearchParams: this.configuration.observers?.httpExtraSearchParams
    }
  );
  return (
    o
      ? this.channelManager.setDataChannel(A, o)
      : Xn(i) &&
        i({
          code: Io.Channel.INITIALIZATION_FAILED,
          message: "Failed to initialize channel object."
        }),
    o
  );
}
function SC(A, e, t, i, n, o) {
  if (this.channelManager.getCustomChannel())
    return (
      this.log.error(`Custom channel ${A} already opened`),
      void n({ code: Io.Channel.ALREADY_OPEN, message: `Channel ${A} already opened` })
    );
  const r = (function (A, e, t, i, n, o, r) {
    return (
      dC.info(`Created custom channel with name '${i}'`),
      CC(i.toString()) ? new IC(A, e, t, i, n, o, r) : new ja(A, e, t, i, n, o, r)
    );
  })(
    this.configuration,
    this.clientConnectionId,
    this.serverConnectionId,
    A,
    e,
    this.extensionData,
    {
      onSetupCompleted: i,
      onSetupFailed: (r) => {
        let s = 1;
        Ao(o) || (s = o + 1);
        let a = Ao(this.configuration.connectionFailureRetryAttempts)
          ? yC
          : this.configuration.connectionFailureRetryAttempts;
        if (
          (Ao(r) ||
            r.code !== Io.Connection.GATEWAY_BUSY ||
            (a = this.configuration.connectionBlockRetryAttempts || 0),
          !Ao(r) && r.code === Io.Connection.GATEWAY_BUSY && s <= a)
        )
          this.log.info(
            `Failed to establish custom channel ${A} in attempt ${s} (${r.message} - ${r.code}), retrying to connect`
          ),
            setTimeout(() => {
              SC.call(this, i, n, s);
            }, 1);
        else if (s <= a && Ao(r)) {
          const o = Math.min(2560, 20 * Math.pow(2, s));
          this.log.info(
            `Failed to establish custom channel ${A} in attempt ${s}, retrying to connect in ${o} ms`
          ),
            setTimeout(() => {
              SC.call(this, A, e, t, i, n, s);
            }, o);
        } else
          Xn(n) && n(r || { code: Io.Connection.TRANSPORT_ERROR, message: "Connection failed" });
      },
      onMessageReceived: t.onMessageReceived,
      onOpen: () => this.statsManager.channelOpened(),
      onClose: (e) => {
        this.statsManager.channelClosed(),
          t.onClose(e),
          this.channelManager.hasNoOpenChannels() && Xn(this.onConnectionCloseCb)
            ? this.onConnectionCloseCb()
            : this.pendingChannelNotifications.has(A.toString()) &&
              (this.log.info(`Notifying custom data channel '${A}' from pending notification`),
              Xn(this.configuration.observers.dataChannel) &&
                this.configuration.observers.dataChannel(
                  this.pendingChannelNotifications.get(A.toString())
                ),
              this.pendingChannelNotifications.delete(A.toString()));
      },
      onError: () => this.statsManager.channelError(),
      httpExtraHeaders: this.configuration.observers?.httpExtraHeaders,
      httpExtraSearchParams: this.configuration.observers?.httpExtraSearchParams
    }
  );
  r && this.channelManager.setCustomChannel(A, r),
    !this.channelManager.getCustomChannel(A) &&
      Xn(n) &&
      n({
        code: Io.Channel.INITIALIZATION_FAILED,
        message: "Failed to initialize channel object."
      });
}
function RC(A, e, t) {
  let i,
    n = this.channelManager.getLazyChannels(),
    o = A;
  Ao(A) && !uC(e) && (o = ga),
    (i = new Ya(o, e)),
    "" === t
      ? (this.log.info(`Received revoke notification for channel '${i}'`),
        i in n
          ? ((n[i].token = ""), (n[i].enabled = !1), Xn(n[i].observer) && n[i].observer(!1))
          : i in this.channelManager.getDataChannels() &&
            this.channelManager.getDataChannel(i).close())
      : CC(i.toString())
        ? (this.log.info(`Received notification for webrtcredir custom channel '${i}'`),
          SC.call(
            this,
            i,
            t,
            {
              onClose: (A) => {
                this.log.info(`Webrtc custom channel closed: ${A.message}`);
              }
            },
            (A) => {
              this.log.info(`Opened webrtc custom channel ${A.channelName}`);
            },
            (A) => {
              this.log.error(`Failed to open webrtc custom channel: ${A.message}`);
            }
          ))
        : uC(i.toString())
          ? (this.log.info(`Received notification for custom channel '${i}'`),
            i in this.channelManager.getCustomChannels()
              ? (this.log.info(
                  `Custom data channel '${i}' already present, closing the existing channel before notifying it again`
                ),
                this.pendingChannelNotifications.set(i.toString(), {
                  name: i.name,
                  authToken: t,
                  namespace: i.namespace
                }),
                this.channelManager.getCustomChannel(i).close())
              : (this.log.info(`Notifying custom data channel '${i}'`),
                Xn(this.configuration.observers.dataChannel) &&
                  this.configuration.observers.dataChannel({
                    name: i.name,
                    authToken: t,
                    namespace: i.namespace
                  })))
          : (this.log.info(`Received notification for channel '${i}'`),
            i in n
              ? ((n[i].token = t), (n[i].enabled = !0), Xn(n[i].observer) && n[i].observer(!0))
              : UC.call(this, i, t));
}
function vC(A, e, t, i) {
  switch (e) {
    case "cursors":
      this.cursorResource.setup(A, e, t, i),
        this.channelManager.getDataChannel(Ia.INPUT) &&
          this.channelManager.getDataChannel(Ia.INPUT).setCursorResource(this.cursorResource);
      break;
    case "printer":
      this.printerResource.setup(A, e, t, i),
        this.printerResource.addPrinterResourceURLFormats(),
        this.log.info("Notifying new file printed resource"),
        Xn(this.configuration.observers.filePrinted) &&
          this.configuration.observers.filePrinted(this.printerResource);
      break;
    case "file":
      this.fileResource.setup(A, e, t, i),
        this.log.info(`Notifying new file download for resource with id "${t}"`),
        Xn(this.configuration.observers.fileDownload) &&
          this.configuration.observers.fileDownload(this.fileResource);
      break;
    default:
      this.log.debug(`Unknown domain ${e} in resource notification.`);
  }
}
function xC(A) {
  this.log.info("Notifying license notification status"),
    Xn(this.configuration.observers.licenseNotification) &&
      this.configuration.observers.licenseNotification(A);
}
function MC(A) {
  const e = new Date(A);
  this.log.info(
    A
      ? `Notifying idle warning timeout. Disconnection will happen at ${e.toString()} (ISO date ${A})`
      : "Revoking idle warning timeout."
  ),
    Xn(this.configuration.observers.idleWarningNotification) &&
      this.configuration.observers.idleWarningNotification(A ? e : null);
}
function OC(A) {
  Xn(this.configuration.observers.collaboratorList) &&
    this.configuration.observers.collaboratorList(A || []);
}
function kC(A) {
  if (Ao(this.serverConnectionId) || 0 === this.serverConnectionId) return;
  const e = this.channelManager.getMainChannel().pingTimeoutHasExpired();
  this.channelManager.setMainChannel(null),
    (this.onConnectionCloseCb = () => {
      let e = A;
      Js(this.clientConnectionId),
        this.disconnectionRequested &&
          (e = {
            code: Io.ClosingReason.DISCONNECTION_REQUESTED,
            reason: "Disconnection requested"
          }),
        this.log.info(
          `Notifying disconnect (code: ${e.code} message: ${e.message}, version: ${h.version}, session: ${this.configuration.sessionId})`
        ),
        Xn(this.configuration.observers.disconnect) && this.configuration.observers.disconnect(e);
    }),
    Object.keys(this.channelManager.getLazyChannels()).forEach((A) =>
      this.channelManager.removeLazyChannel(A)
    ),
    this.log.debug("Closed all lazy channels"),
    Object.keys(this.channelManager.getDataChannels()).forEach((A) =>
      this.channelManager.getDataChannel(A).close(e)
    ),
    this.log.debug("Closed all data channels"),
    Object.keys(this.channelManager.getCustomChannels()).forEach((A) =>
      this.channelManager.getCustomChannel(A).close(e)
    ),
    this.log.debug("Closed all custom channels"),
    this.channelManager.hasNoOpenChannels() && this.onConnectionCloseCb();
}
function NC(A) {
  this.log.info("Notifying quality indicators state"),
    Xn(this.configuration.observers.qualityIndicatorState) &&
      this.configuration.observers.qualityIndicatorState(A);
}
function KC(A) {
  this.log.info("Notifying network quality change."),
    Xn(this.configuration.observers.networkQualityChange) &&
      this.configuration.observers.networkQualityChange(A);
}
function LC(A) {
  if (!Qr()) return void this.log.warn("IME mode is only supported on MacOS");
  let e;
  switch (this.IMEModeBehavior) {
    case "on":
      e = !0;
      break;
    case "off":
      e = !1;
      break;
    case "auto":
      e = A;
      break;
    default:
      this.log.warn(
        `Unrecognized IME mode behavior "${this.IMEModeBehavior}", resetting to "auto"`
      ),
        (e = A),
        (this.IMEModeBehavior = "auto");
  }
  e !== A &&
    this.log.warn(
      `Could not set IME mode to ${A} because the behavior is set to "${this.IMEModeBehavior}", using ${e}`
    ),
    this.clientConnectionId || this.log.warn("Connection not established while setting IME Mode");
  const t = this.clientConnectionId,
    i = this.channelManager.getDataChannel(Ia.DISPLAY);
  i ||
    this.log.info(
      `Missing display channel (connection ${t}) while setting IME Mode, caching value`
    );
  const n = i?.getDisplayManager();
  !n &&
    i &&
    this.log.warn(`Could not get display manager for connection ${t} while setting IME Mode`);
  const o = this.channelManager.getDataChannel(Ia.INPUT);
  o ||
    this.log.info(`Missing input channel (connection ${t}) while setting IME Mode, caching value`);
  const r = o?.getInput();
  !r &&
    o &&
    this.log.warn(`Could not get input manager for connection ${t} while setting IME Mode`),
    this.log.info(`Setting IME mode to ${e} ("${this.IMEModeBehavior}" behavior)`),
    (this.currentIMEMode = e),
    n?.setCurrentIMEMode(this.currentIMEMode),
    r?.setCurrentIMEMode(this.currentIMEMode);
}
function TC() {
  return this.IMEModeBehavior;
}
function PC() {
  return this.currentIMEMode;
}
(wC.prototype.connect = function () {
  return new Promise((A, e) => {
    this.channelManager.getMainChannel()
      ? e({
          error: Io.Connection.MAIN_CHANNEL_ALREADY_OPEN,
          message: "mainchannel was already opened"
        })
      : (this.log.info("Setting up channel factory"),
        (this.enabledChannels = (function (A) {
          let e = Object.values(Ia);
          return (
            A && A.length > 0 && (e = A.map((A) => `${ga}${aa}${A}`)),
            (dC = Q("channelfactory")),
            e.filter((A) => !Ao(lC[A]))
          );
        })(this.configuration.enabledChannels)),
        this.log.info(`Setting up resources (${this.configuration.sessionId})`),
        (this.fileResource = new BC(this.configuration)),
        (this.cursorResource = new BC(this.configuration)),
        (this.printerResource = new BC(this.configuration)),
        this.log.info("Creating mainchannel"),
        bC.call(this, A, e));
  });
}),
  (wC.prototype.disconnect = function () {
    this.log.info("Disconnection requested"),
      this.disconnectionRequested
        ? this.log.warn("Disconnection already requested")
        : this.channelManager.getMainChannel() &&
          (this.channelManager.getMainChannel().close(),
          (this.disconnectionRequested = !0),
          this.log.info("Removing disconnect callback to window pagehide"),
          window.removeEventListener("pagehide", this.onPageHide));
  }),
  (wC.prototype.reconnect = function (A) {
    return (
      this.log.info("Reconnection requested"),
      new Promise((e, t) => {
        Ao(qs(this.clientConnectionId)) ||
          t({
            code: Io.Connection.ALREADY_OPEN,
            message:
              "Connection is open. Please reconnect only once the connection has been closed."
          }),
          (this.authToken = A),
          this.connect()
            .then(() => {
              this.log.info("Connection has been established"), e(this);
            })
            .catch((A) => {
              this.log.error(`Connection failed with error: ${JSON.stringify(A)}`), t(A);
            });
      })
    );
  }),
  (wC.prototype.setDisplayQuality = function (A, e) {
    if (
      (this.log.info("Received display quality change request"),
      !oo(A, 0, 100) || (e && (!oo(e, 0, 100) || A > e)))
    )
      return void this.log.warn(
        `Invalid image quality setting: {min: ${A}, max: ${e}}. The minimum and maximum display quality values should be numbers in the range [0, 100].`
      );
    this.log.info(
      "Received display quality change request. Setting " +
        (Ao(e) ? `minimum display quality to ${A}` : `display quality to [${A}-${e}]`)
    ),
      (this.requestedSettings.minDisplayQuality = A),
      (this.requestedSettings.maxDisplayQuality = e);
    const t = this.channelManager.getDataChannel(Ia.DISPLAY);
    t && t.setQuality(A, e);
  }),
  (wC.prototype.enableHighPixelDensity = function (A) {
    if ("boolean" != typeof A)
      return void this.log.warn(
        `Invalid argument for enabling high pixel density: ${A}. It should be a boolean.`
      );
    this.log.info(`Received request to ${A ? "enable" : "disable"} high pixel density`),
      (this.requestedSettings.highPixelDensityEnabled = A);
    const e = this.channelManager.getDataChannel(Ia.DISPLAY);
    e && e.enableHighPixelDensity(A);
  }),
  (wC.prototype.setMaxDisplayResolution = function (A, e) {
    if (!oo(A, 0, 1 / 0) || !oo(e, 0, 1 / 0))
      return void this.log.warn(
        `Invalid maximum display resolution setting: ${A}x${e}. The display resolution values should be numbers in the range [0, Inf).`
      );
    this.log.info(`Setting maximum display resolution to ${A}x${e}`),
      (this.requestedSettings.maxDisplayWidth = A),
      (this.requestedSettings.maxDisplayHeight = e);
    const t = this.channelManager.getDataChannel(Ia.DISPLAY);
    t && t.setLayoutSettings(A, e, this.requestedSettings.maxDisplayNumber);
  }),
  (wC.prototype.setMinDisplayResolution = function (A, e) {
    if (!oo(A, 0, 1 / 0) || !oo(e, 0, 1 / 0))
      return void this.log.warn(
        `Invalid minumum display resolution setting: ${A}x${e}. The display resolution values should be numbers in the range [0, Inf).`
      );
    this.log.info(`Setting minumum display resolution to ${A}x${e}`),
      (this.requestedSettings.minDisplayWidth = A),
      (this.requestedSettings.minDisplayHeight = e);
    const t = this.channelManager.getDataChannel(Ia.DISPLAY);
    t && t.setMinLayoutSettings(A, e);
  }),
  (wC.prototype.enableDisplayQualityUpdates = function (A) {
    if ("boolean" != typeof A)
      return void this.log.warn(
        `Invalid argument for enabling quality updates: ${A}. It should be a boolean.`
      );
    this.log.info(`Received request to ${A ? "enable" : "disable"} display quality updates`),
      (this.requestedSettings.qualityUpdatesEnabled = A);
    const e = this.channelManager.getDataChannel(Ia.DISPLAY);
    e && e.enableQualityUpdates(A);
  }),
  (wC.prototype.queryFeature = function (A) {
    return this.featureManager.query(A);
  }),
  (wC.prototype.setVolume = function (A) {
    if (!oo(A, 0, 100))
      return void this.log.warn(
        `Invalid audio volume: ${A}. The specified volume should be a number in the range [0, 100].`
      );
    this.log.info(`Setting audio volume to ${A}`), (this.requestedSettings.audioVolume = A);
    const e = this.channelManager.getDataChannel(Ia.AUDIO);
    e && e.setVolumeLevel(A);
  }),
  (wC.prototype.setMicrophone = function (A, e) {
    if ("boolean" != typeof A)
      return Promise.reject({
        code: Io.Audio.INVALID_ARGUMENT,
        message: `Invalid argument for setting the microphone: ${A}. It should be a boolean.`
      });
    if (e && "string" != typeof e)
      return Promise.reject({
        code: Io.Audio.INVALID_ARGUMENT,
        message: `Invalid argument for setting the microphone: ${e}. It should be a string.`
      });
    A &&
      Ks()
        .then((A) => {
          const e = A.filter((A) => "audioinput" === A.kind);
          0 === e.length && Bs.info("No audio input devices found");
          const t = e.map((A) => ({ label: A.label, deviceId: A.deviceId }));
          Bs.debug(`Available microphones: ${JSON.stringify(t)}`);
        })
        .catch(() => Bs.debug("No audio input devices found"))
        .catch(() => this.log.debug("No microphones found"));
    const t = this.channelManager.getDataChannel(Ia.AUDIO);
    return Ao(t)
      ? A
        ? Promise.reject({
            code: Io.Audio.CHANNEL_NOT_AVAILABLE,
            message: "Audio channel is not available"
          })
        : ((this.requestedSettings.audioMicEnabled = !1), Promise.resolve())
      : t
          .setAudioInput(A, e)
          .then((e) => ((this.requestedSettings.audioMicEnabled = A), Promise.resolve(e)))
          .catch(
            (A) => (
              (this.requestedSettings.audioMicEnabled = !1),
              Promise.reject({ code: Io.Audio.SETTING_AUDIO_FAILED, message: A })
            )
          );
  }),
  (wC.prototype.setWebcam = function (A, e) {
    if ("boolean" != typeof A)
      return Promise.reject({
        code: Io.Webcam.INVALID_ARGUMENT,
        message: `Invalid argument for enabling the webcam: ${A}. It should be a boolean.`
      });
    const t = this.channelManager.getDataChannel(Ia.AUDIO);
    return Ao(t)
      ? A
        ? Promise.reject({
            code: Io.Webcam.CHANNEL_NOT_AVAILABLE,
            message: "Channel for webcam is not available"
          })
        : ((this.requestedSettings.webcamEnabled = !1), Promise.resolve(e))
      : t
          .setWebcam(A, e)
          .then((e) => ((this.requestedSettings.webcamEnabled = A), Promise.resolve(e)))
          .catch(
            (A) => (
              (this.requestedSettings.webcamEnabled = !1),
              Promise.reject({ code: Io.Webcam.SETTING_WEBCAM_FAILED, message: A })
            )
          );
  }),
  (wC.prototype.setKeyboardQuirks = function (A) {
    if (zn(A))
      if (
        Object.keys(A).some(
          (A) =>
            -1 === ["macOptionToAlt", "macCommandToControl", "forceKeyboardCombinations"].indexOf(A)
        )
      )
        this.log.warn(
          "Possible values for keyboard quirks are macOptionToAlt and macCommandToControl."
        );
      else if (Object.values(A).some((A) => "boolean" != typeof A))
        this.log.warn("Keyboard quirks values should be of type boolean.");
      else {
        const e = this.channelManager.getDataChannel(Ia.INPUT);
        e &&
          (Object.prototype.hasOwnProperty.call(A, "macOptionToAlt") &&
            e.getInput().setMacOptionToAlt(A.macOptionToAlt),
          Object.prototype.hasOwnProperty.call(A, "macCommandToControl") &&
            e.getInput().setMacCommandToControl(A.macCommandToControl),
          Object.prototype.hasOwnProperty.call(A, "forceKeyboardCombinations") &&
            e.getInput().setForceKeyboardCombinations(A.forceKeyboardCombinations));
      }
    else
      this.log.warn(
        `Invalid argument for setting the keyboard quirks: ${A}. It should be an object.`
      );
  }),
  (wC.prototype.setUploadBandwidth = function (A) {
    if (!oo(A, 1024, 1024e3))
      return void this.log.warn(
        "Invalid argument for setting the upload bandwidth. It should be a number in the range [1024, 1000 * 1024]."
      );
    const e = this.channelManager.getDataChannel(Ia.FILESTORAGE);
    e && ((e.serverOS = this.getServerInfo().os), e.setUploadBandwidth(A));
  }),
  (wC.prototype.requestResolution = function (A, e) {
    const t = this.channelManager.getDataChannel(Ia.DISPLAY),
      i = Math.floor(A),
      n = Math.floor(e);
    return (
      this.log.info("Received resolution change request"),
      new Promise((A, e) => {
        oo(i, 0, 1 / 0) && oo(n, 0, 1 / 0)
          ? t
            ? (this.log.info(`Requesting resolution ${i}x${n}`), t.sendDisplayLayout(i, n), A())
            : e({ code: Io.Resolution.NO_CHANNEL, message: "Display channel is not available." })
          : e({
              code: Io.Resolution.INVALID_ARGUMENT,
              message:
                "Invalid display layout. The width and height values should be numbers in the range [0, Inf)."
            });
      })
    );
  }),
  (wC.prototype.requestDisplayConfig = function (A) {
    const e = this.channelManager.getDataChannel(Ia.DISPLAY),
      t = { highColorAccuracy: A };
    return (
      this.log.info(`Received a config change request: ${JSON.stringify(t)}`),
      new Promise((i, n) => {
        "boolean" != typeof A
          ? n({
              code: Io.DisplayConfig.INVALID_ARGUMENT,
              message: `Invalid argument for requesting display config: ${A}. It should be a boolean.`
            })
          : e
            ? e.sendDisplayConfig(t)
              ? i()
              : n({
                  code: Io.DisplayConfig.UNSUPPORTED_OPERATION,
                  message: "The operation is not supported."
                })
            : n({
                code: Io.DisplayConfig.NO_CHANNEL,
                message: "Display channel is not available."
              });
      })
    );
  }),
  (wC.prototype.requestDisplayLayout = function (A) {
    const e = this.channelManager.getDataChannel(Ia.DISPLAY);
    return (
      this.log.info(`Received a layout change request: ${JSON.stringify(A)}`),
      new Promise((t, i) => {
        !A || !Array.isArray(A) || A.length < 1 || A.some((A) => !zn(A))
          ? i({
              code: Io.Resolution.INVALID_ARGUMENT,
              message:
                "Invalid display layout. The layout parameter should be an array of objects of this kind: { name: String, rect: { x: Number, y: Number, width: Number, height: Number }, primary: boolean }"
            })
          : e
            ? (e.sendDisplayLayoutMulti(A), t())
            : i({ code: Io.Resolution.NO_CHANNEL, message: "Display channel is not available." });
      })
    );
  }),
  (wC.prototype.setDisplayScale = function (A, e) {
    const t = this.channelManager.getDataChannel(Ia.DISPLAY);
    return (
      this.log.warn(
        "Using custom mouse coordinates scaling factor. Please note that setDisplayScale API has been deprecated since version 1.3.0 since the mouse coordinates can be scaled automatically if a custom scaling factor is not provided."
      ),
      new Promise((i, n) => {
        if (null !== A && (A <= 0 || !oo(A, 0, 1 / 0)))
          return void n({
            code: Io.Resolution.INVALID_ARGUMENT,
            message:
              "Invalid display scaling factor. The scale ratio must be a strictly positive number."
          });
        if (!t)
          return void n({
            code: Io.Resolution.NO_CHANNEL,
            message: "Display channel is not available."
          });
        let o = e;
        (!Ao(e) && Number.isFinite(e)) || (o = 0),
          t.getDisplayManager().setDisplayScaleRatio(A, o)
            ? i()
            : n({ code: Io.Resolution.INVALID_ARGUMENT, message: "Error setting scaling factor." });
      })
    );
  }),
  (wC.prototype.registerKeyboardShortcuts = function (A) {
    if (
      Ao(A) ||
      !Array.isArray(A) ||
      0 === A.length ||
      A.some(
        (A) =>
          !zn(A) ||
          ["sequence", "output"].some(
            (e) =>
              !Object.prototype.hasOwnProperty.call(A, e) ||
              !Array.isArray(A[e]) ||
              A[e].some(
                (A) =>
                  !zn(A) ||
                  !Object.prototype.hasOwnProperty.call(A, "key") ||
                  !Object.prototype.hasOwnProperty.call(A, "location") ||
                  "string" != typeof A.key ||
                  "number" != typeof A.location
              )
          )
      )
    )
      this.log.warn(
        `Invalid shortcuts argument for registration: ${A}. It should be an array of objects of this kind: { sequence: [{ key: string, location: number }], output: [{ key: string, location: number }] }`
      );
    else {
      const e = this.channelManager.getDataChannel(Ia.INPUT);
      e && e.getInput().registerShortcuts(A);
    }
  }),
  (wC.prototype.sendKeyboardShortcut = function (A) {
    if (
      Array.isArray(A) &&
      0 !== A.length &&
      !A.some(
        (A) =>
          !zn(A) ||
          !Object.prototype.hasOwnProperty.call(A, "key") ||
          !Object.prototype.hasOwnProperty.call(A, "location") ||
          "string" != typeof A.key ||
          "number" != typeof A.location
      )
    )
      if (A && A.length > 0) {
        this.log.info(`Sending Keyboard shortcut: ${JSON.stringify(A)}`);
        const e = this.channelManager.getDataChannel(Ia.INPUT);
        if (e) {
          for (let t = 0; t < A.length; t++) e.getInput().sendKey(A[t].key, A[t].location, !0);
          for (let t = A.length - 1; t >= 0; t--) e.getInput().sendKey(A[t].key, A[t].location, !1);
        }
      } else this.log.error("Attempted to send an empty keyboard shortcut.");
    else
      this.log.warn(
        `Invalid keyboard shortcut to be sent ${A}. It should be an array of objects of this kind: { key: string, location: number }`
      );
  }),
  (wC.prototype.latchModifierKey = function (A, e, t) {
    if ("string" != typeof A || "number" != typeof e || "boolean" != typeof t)
      return (
        this.log.warn(
          "Invalid arguments passed as latch modifier. Key should be a string, location a number and isDown a boolean."
        ),
        !1
      );
    const i = this.channelManager.getDataChannel(Ia.INPUT);
    return !!i && i.getInput().latchModifier(A, e, t);
  }),
  (wC.prototype.enterRelativeMouseMode = function () {
    const A = this.channelManager.getDataChannel(Ia.DISPLAY);
    A && A.getDisplayManager().requestPointerLock();
  }),
  (wC.prototype.getStats = function () {
    return this.statsManager.getStats();
  }),
  (wC.prototype.getServerInfo = function () {
    return this.channelManager &&
      this.channelManager.getMainChannel() &&
      this.channelManager.getMainChannel().serverInfo
      ? this.channelManager.getMainChannel().serverInfo
      : null;
  }),
  (wC.prototype.setIMEModeBehavior = function (A, e) {
    if (Qr())
      if ("auto" === A || "on" === A || "off" === A) {
        if (this.IMEModeBehavior === A) {
          if ("auto" !== A || this.currentIMEMode === e)
            return void this.log.info(`IME mode behavior is already set to ${A}`);
          if ("boolean" != typeof e)
            return void this.log.warn(
              `Invalid IME compatibility mode "${e}" with "auto" behavior (expected boolean)`
            );
        } else {
          this.clientConnectionId ||
            this.log.warn("Connection not established while setting IME Mode behavior");
          const e = this.clientConnectionId,
            t = this.channelManager.getDataChannel(Ia.INPUT);
          t ||
            this.log.info(
              `Missing input channel (connection ${e}) while setting IME mode behavior, caching value`
            );
          const i = t?.getInput();
          i ||
            this.log.warn(
              `Could not get input manager for connection ${e} while setting IME mode behavior`
            ),
            this.log.info(`Setting IME mode behavior to ${A} for connection ${e}`),
            (this.IMEModeBehavior = A),
            i?.setIMEModeBehavior(this.IMEModeBehavior);
        }
        switch (this.IMEModeBehavior) {
          case "on":
            this.setCurrentIMEMode(!0);
            break;
          case "off":
            this.setCurrentIMEMode(!1);
            break;
          case "auto":
            Ao(e) || this.setCurrentIMEMode(e);
            break;
          default:
            this.log.warn(`Bad IME mode behavior "${this.IMEModeBehavior}", resetting to "auto"`),
              (this.IMEModeBehavior = "auto");
        }
      } else this.log.warn(`Invalid value "${A}" for IME mode behavior`);
    else this.log.warn("IME Mode behavior setting is only supported on MacOS");
  }),
  (wC.prototype.getServerExtensionData = function () {
    return this.channelManager &&
      this.channelManager.getMainChannel() &&
      this.channelManager.getMainChannel().serverExtensionData
      ? this.channelManager.getMainChannel().serverExtensionData
      : null;
  }),
  (wC.prototype.getFileExplorer = function () {
    return (
      this.log.info("requested file explorer"),
      new Promise((A, e) => {
        if (this.channelManager.getDataChannel(Ia.FILESTORAGE))
          this.log.info("Filestorage channel already open, return its file explorer"),
            A(this.channelManager.getDataChannel(Ia.FILESTORAGE).getFileExplorer());
        else if (this.channelManager.getLazyChannel(Ia.FILESTORAGE))
          if (this.channelManager.getLazyChannel(Ia.FILESTORAGE).enabled) {
            this.log.info("Opening a new filestorage channel");
            UC.call(
              this,
              new Ya(ga, ca.FILESTORAGE),
              this.channelManager.getLazyChannel(Ia.FILESTORAGE).token,
              (e) => {
                A(e.getFileExplorer());
              },
              (A) => {
                e({
                  code: Io.Channel.REJECTED,
                  message: `Connection setup failed: ${JSON.stringify(A)}`
                });
              }
            ) || e({ code: Io.Channel.REJECTED, message: "Failed to create filestorage channel" });
          } else
            e({
              code: Io.Channel.REJECTED,
              message: "Filestorage channel not notified by the server"
            });
        else
          e({
            code: Io.Channel.REJECTED,
            message: "Filestorage channel not found in neither open nor lazy channels lists"
          });
      })
    );
  }),
  (wC.prototype.disconnectCollaborator = function (A) {
    this.log.info(`Requested disconnect for collaborator with connection id: ${A}`);
    const e = this.channelManager.getMainChannel();
    e && e.disconnectCollaborator(A);
  }),
  (wC.prototype.enableTimezoneRedirection = function (A) {
    if ("boolean" != typeof A)
      return Promise.reject({
        code: Io.TimezoneRedirection.INVALID_ARGUMENT,
        message: `Invalid argument for setting the timezone redirection: ${A}. It should be a boolean.`
      });
    this.log.info(`Received request to ${A ? "enable" : "disable"} timezone redirection`);
    let e,
      t,
      i = this.channelManager.getMainChannel();
    return i
      ? to(i.protocolVersion, { major: 1, minor: 7 })
        ? ((e = i.timezoneRedirection.enabled),
          e === Ca.ALWAYS_OFF || e === Ca.ALWAYS_ON
            ? Promise.reject({
                code: Io.TimezoneRedirection.USER_CANNOT_CHANGE,
                message: "User is not allowed to change the Timezone Redirection setting."
              })
            : ((t = i.isTimezoneRedirectionEnabled()),
              A && t
                ? (this.log.debug(
                    "Ignored user trying to enable the Timezone Redirection setting as it was already enabled."
                  ),
                  Promise.resolve())
                : A || t
                  ? (i.enableTimezoneRedirection(A), Promise.resolve())
                  : (this.log.debug(
                      "Ignored user trying to disable the Timezone Redirection setting as it was already disabled."
                    ),
                    Promise.resolve())))
        : Promise.reject({
            code: Io.TimezoneRedirection.USER_CANNOT_CHANGE,
            message: "User is not allowed to change the Timezone Redirection setting."
          })
      : Promise.reject({
          code: Io.TimezoneRedirection.NO_CHANNEL,
          message: "Main channel is not available."
        });
  }),
  (wC.prototype.openChannel = function (A, e, t, i) {
    const n = this.channelManager.getMainChannel(),
      o = new Ya(i, A);
    return new Promise((A, i) => {
      n
        ? "string" != typeof o.getName() || "string" != typeof e
          ? i({
              code: Io.Channel.REJECTED,
              message:
                "Invalid arguments for opening a channel. Parameters name and authToken should be strings."
            })
          : to(n.protocolVersion, { major: 1, minor: 6 }) && "string" != typeof o.getNamespace()
            ? i({
                code: Io.Channel.REJECTED,
                message:
                  "Invalid arguments for opening a channel. Parameter namespace should be a string."
              })
            : o.getNamespace() === ga
              ? i({
                  code: Io.Channel.REJECTED,
                  message:
                    'Invalid arguments for opening a channel. Parameters namespace cannot be equal to "dcv".'
                })
              : !zn(t) ||
                  ["onMessageReceived", "onClose"].some(
                    (A) => !Object.prototype.hasOwnProperty.call(t, A) || !Xn(t[A])
                  )
                ? i({
                    code: Io.Channel.REJECTED,
                    message:
                      "Invalid callbacks argument for opening a channel. Callbacks should be an object with the onMessageReceived and the onClose callback functions defined."
                  })
                : CC(o.toString())
                  ? i({ code: Io.Channel.REJECTED, message: "Reserved custom channel." })
                  : o in this.channelManager.getCustomChannels()
                    ? i({
                        code: Io.Channel.ALREADY_OPEN,
                        message: `Channel ${o} was already open.`
                      })
                    : (this.log.info(`Creating a new custom channel: ${o}`),
                      SC.call(this, o, e, t, A, i))
        : i({ code: Io.Channel.REJECTED, message: "Main channel is not open." });
    });
  }),
  (wC.prototype.syncClipboards = function () {
    const A = this.channelManager.getDataChannel(Ia.CLIPBOARD);
    return A
      ? A.getRemoteClipboard().syncClipboards()
      : (this.log.warn("Clipboard channel is not opened."), !1);
  }),
  (wC.prototype.captureClipboardEvents = function (A, e, t) {
    let i,
      n = this.channelManager.getDataChannel(Ia.CLIPBOARD);
    if ("boolean" != typeof A || (!zn(e) && void 0 !== e) || (!Number.isFinite(t) && void 0 !== t))
      this.log.warn("Invalid arguments passed to captureClipboardEvents.");
    else if (n) {
      if (!Ao(t)) {
        const A = this.channelManager.getDataChannel(Ia.DISPLAY);
        A && (i = A.getDisplayManager().getDisplayToWindowMap()[t]);
      }
      i || (i = Ao(e) ? window : e), n.getRemoteClipboard().enableEventListeners(A, i);
    } else this.log.warn("Clipboard channel is not opened.");
  }),
  (wC.prototype.getScreenshot = function () {
    const A = this.channelManager.getDataChannel(Ia.DISPLAY);
    return (
      this.log.info("Requesting current screenshot"),
      new Promise((e, t) => {
        A
          ? A.getScreenshot()
            ? e()
            : t({
                code: Io.Screenshot.GENERIC_ERROR,
                message: "Cannot process screenshot request."
              })
          : t({ code: Io.Screenshot.NO_CHANNEL, message: "Display channel is not available." });
      })
    );
  }),
  (wC.prototype.sendKeyboardEvent = function (A) {
    if (!zn(A))
      return (
        this.log.warn(
          "Invalid argument passed to sendKeyboardEvent. It should be a https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent."
        ),
        !1
      );
    const e = this.channelManager.getDataChannel(Ia.INPUT);
    return !!e && e.getInput().sendKeyboardEvent(A);
  }),
  (wC.prototype.attachDisplay = function (A, e) {
    const t = this.channelManager.getDataChannel(Ia.DISPLAY);
    return new Promise((i, n) => {
      let o;
      if (t)
        if (zn(A) && zn(e))
          if (
            !Object.prototype.hasOwnProperty.call(e, "displayDivName") ||
            "string" != typeof e.displayDivName ||
            (Object.prototype.hasOwnProperty.call(e, "displayId") && !Number.isFinite(e.displayId))
          )
            n({
              code: Io.MultiMonitor.INVALID_ARGUMENT,
              message:
                "Invalid argument for attaching a display. DisplayConf should be an object and its properties displayDivName and displayId should be of type string and number respectively."
            });
          else if (
            ((o = t.getDisplayManager().attachDisplay(A, e)),
            this.log.info("Attach display request received"),
            o.success)
          ) {
            const e = this.channelManager.getDataChannel(Ia.CLIPBOARD);
            e && e.getRemoteClipboard().enableDisplay(A),
              this.log.info(`Attach request for display ${o.displayId} succeeded`),
              i(o.displayId),
              o.forceFirstFrameCallback &&
                setTimeout(t.getDisplayManager().forceFirstFrameCallback(o.displayId), 100);
          } else n({ code: o.errorCode, message: o.errorMessage });
        else
          n({
            code: Io.MultiMonitor.INVALID_ARGUMENT,
            message:
              "Invalid arguments for attaching a display. Both window and displayConf should be objects."
          });
      else
        n({ code: Io.MultiMonitor.NO_DISPLAY_CHANNEL, message: "Display channel is not opened" });
    });
  }),
  (wC.prototype.detachDisplay = function (A) {
    if (!Number.isFinite(A))
      return void this.log.warn(
        `Invalid argument for detaching a display: ${A}. It should be a number.`
      );
    this.log.info("Detach display request received");
    const e = this.channelManager.getDataChannel(Ia.DISPLAY);
    e && A && e.getDisplayManager().detachDisplay(A);
  }),
  (wC.prototype.getConnectedDevices = function () {
    return this.log.info("Enumerating connected devices"), Ks();
  }),
  (wC.prototype.setExtensionData = function (A) {
    "string" == typeof A
      ? (this.log.info("Setting extension data"),
        (this.extensionData = A),
        this.fileResource.setExtensionData(A),
        this.cursorResource.setExtensionData(A),
        this.printerResource.setExtensionData(A))
      : this.log.warn(`Invalid argument extensionData: ${A}. It should be a string.`);
  });
var GC = { exports: {} };
!(function (e) {
  /**
   * @license bytebuffer.js (c) 2015 Daniel Wirtz <dcode@dcode.io>
   * Backing buffer: ArrayBuffer, Accessor: Uint8Array
   * Released under the Apache License, Version 2.0
   * see: https://github.com/dcodeIO/bytebuffer.js for details
   */
  !(function (A, t) {
    e && e.exports
      ? (e.exports = (function () {
          var A;
          try {
            A = Zc.exports;
          } catch (A) {}
          return t(A);
        })())
      : ((A.dcodeIO = A.dcodeIO || {}).ByteBuffer = t(A.dcodeIO.Long));
  })(A, function (A) {
    var e = function (A, t, n) {
      if (
        (void 0 === A && (A = e.DEFAULT_CAPACITY),
        void 0 === t && (t = e.DEFAULT_ENDIAN),
        void 0 === n && (n = e.DEFAULT_NOASSERT),
        !n)
      ) {
        if ((A |= 0) < 0) throw RangeError("Illegal capacity");
        (t = !!t), (n = !!n);
      }
      (this.buffer = 0 === A ? i : new ArrayBuffer(A)),
        (this.view = 0 === A ? null : new Uint8Array(this.buffer)),
        (this.offset = 0),
        (this.markedOffset = -1),
        (this.limit = A),
        (this.littleEndian = t),
        (this.noAssert = n);
    };
    (e.VERSION = "5.0.1"),
      (e.LITTLE_ENDIAN = !0),
      (e.BIG_ENDIAN = !1),
      (e.DEFAULT_CAPACITY = 16),
      (e.DEFAULT_ENDIAN = e.BIG_ENDIAN),
      (e.DEFAULT_NOASSERT = !1),
      (e.Long = A || null);
    var t = e.prototype;
    t.__isByteBuffer__,
      Object.defineProperty(t, "__isByteBuffer__", { value: !0, enumerable: !1, configurable: !1 });
    var i = new ArrayBuffer(0),
      n = String.fromCharCode;
    function o(A) {
      var e = 0;
      return function () {
        return e < A.length ? A.charCodeAt(e++) : null;
      };
    }
    function r() {
      var A = [],
        e = [];
      return function () {
        if (0 === arguments.length) return e.join("") + n.apply(String, A);
        A.length + arguments.length > 1024 && (e.push(n.apply(String, A)), (A.length = 0)),
          Array.prototype.push.apply(A, arguments);
      };
    }
    function s(A, e, t, i, n) {
      var o,
        r,
        s = 8 * n - i - 1,
        a = (1 << s) - 1,
        g = a >> 1,
        c = -7,
        I = t ? n - 1 : 0,
        l = t ? -1 : 1,
        d = A[e + I];
      for (
        I += l, o = d & ((1 << -c) - 1), d >>= -c, c += s;
        c > 0;
        o = 256 * o + A[e + I], I += l, c -= 8
      );
      for (
        r = o & ((1 << -c) - 1), o >>= -c, c += i;
        c > 0;
        r = 256 * r + A[e + I], I += l, c -= 8
      );
      if (0 === o) o = 1 - g;
      else {
        if (o === a) return r ? NaN : (1 / 0) * (d ? -1 : 1);
        (r += Math.pow(2, i)), (o -= g);
      }
      return (d ? -1 : 1) * r * Math.pow(2, o - i);
    }
    function a(A, e, t, i, n, o) {
      var r,
        s,
        a,
        g = 8 * o - n - 1,
        c = (1 << g) - 1,
        I = c >> 1,
        l = 23 === n ? Math.pow(2, -24) - Math.pow(2, -77) : 0,
        d = i ? 0 : o - 1,
        u = i ? 1 : -1,
        C = e < 0 || (0 === e && 1 / e < 0) ? 1 : 0;
      for (
        e = Math.abs(e),
          isNaN(e) || e === 1 / 0
            ? ((s = isNaN(e) ? 1 : 0), (r = c))
            : ((r = Math.floor(Math.log(e) / Math.LN2)),
              e * (a = Math.pow(2, -r)) < 1 && (r--, (a *= 2)),
              (e += r + I >= 1 ? l / a : l * Math.pow(2, 1 - I)) * a >= 2 && (r++, (a /= 2)),
              r + I >= c
                ? ((s = 0), (r = c))
                : r + I >= 1
                  ? ((s = (e * a - 1) * Math.pow(2, n)), (r += I))
                  : ((s = e * Math.pow(2, I - 1) * Math.pow(2, n)), (r = 0)));
        n >= 8;
        A[t + d] = 255 & s, d += u, s /= 256, n -= 8
      );
      for (r = (r << n) | s, g += n; g > 0; A[t + d] = 255 & r, d += u, r /= 256, g -= 8);
      A[t + d - u] |= 128 * C;
    }
    (e.accessor = function () {
      return Uint8Array;
    }),
      (e.allocate = function (A, t, i) {
        return new e(A, t, i);
      }),
      (e.concat = function (A, t, i, n) {
        ("boolean" != typeof t && "string" == typeof t) || ((n = i), (i = t), (t = void 0));
        for (var o, r = 0, s = 0, a = A.length; s < a; ++s)
          e.isByteBuffer(A[s]) || (A[s] = e.wrap(A[s], t)),
            (o = A[s].limit - A[s].offset) > 0 && (r += o);
        if (0 === r) return new e(0, i, n);
        var g,
          c = new e(r, i, n);
        for (s = 0; s < a; )
          (o = (g = A[s++]).limit - g.offset) <= 0 ||
            (c.view.set(g.view.subarray(g.offset, g.limit), c.offset), (c.offset += o));
        return (c.limit = c.offset), (c.offset = 0), c;
      }),
      (e.isByteBuffer = function (A) {
        return !0 === (A && A.__isByteBuffer__);
      }),
      (e.type = function () {
        return ArrayBuffer;
      }),
      (e.wrap = function (A, i, n, o) {
        if (("string" != typeof i && ((o = n), (n = i), (i = void 0)), "string" == typeof A))
          switch ((void 0 === i && (i = "utf8"), i)) {
            case "base64":
              return e.fromBase64(A, n);
            case "hex":
              return e.fromHex(A, n);
            case "binary":
              return e.fromBinary(A, n);
            case "utf8":
              return e.fromUTF8(A, n);
            case "debug":
              return e.fromDebug(A, n);
            default:
              throw Error("Unsupported encoding: " + i);
          }
        if (null === A || "object" != typeof A) throw TypeError("Illegal buffer");
        var r;
        if (e.isByteBuffer(A)) return ((r = t.clone.call(A)).markedOffset = -1), r;
        if (A instanceof Uint8Array)
          (r = new e(0, n, o)),
            A.length > 0 &&
              ((r.buffer = A.buffer),
              (r.offset = A.byteOffset),
              (r.limit = A.byteOffset + A.byteLength),
              (r.view = new Uint8Array(A.buffer)));
        else if (A instanceof ArrayBuffer)
          (r = new e(0, n, o)),
            A.byteLength > 0 &&
              ((r.buffer = A),
              (r.offset = 0),
              (r.limit = A.byteLength),
              (r.view = A.byteLength > 0 ? new Uint8Array(A) : null));
        else {
          if ("[object Array]" !== Object.prototype.toString.call(A))
            throw TypeError("Illegal buffer");
          (r = new e(A.length, n, o)).limit = A.length;
          for (var s = 0; s < A.length; ++s) r.view[s] = A[s];
        }
        return r;
      }),
      (t.writeBitSet = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if (!(A instanceof Array)) throw TypeError("Illegal BitSet: Not an array");
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        var i,
          n = e,
          o = A.length,
          r = o >> 3,
          s = 0;
        for (e += this.writeVarint32(o, e); r--; )
          (i =
            (1 & !!A[s++]) |
            ((1 & !!A[s++]) << 1) |
            ((1 & !!A[s++]) << 2) |
            ((1 & !!A[s++]) << 3) |
            ((1 & !!A[s++]) << 4) |
            ((1 & !!A[s++]) << 5) |
            ((1 & !!A[s++]) << 6) |
            ((1 & !!A[s++]) << 7)),
            this.writeByte(i, e++);
        if (s < o) {
          var a = 0;
          for (i = 0; s < o; ) i |= (1 & !!A[s++]) << a++;
          this.writeByte(i, e++);
        }
        return t ? ((this.offset = e), this) : e - n;
      }),
      (t.readBitSet = function (A) {
        var e = void 0 === A;
        e && (A = this.offset);
        var t,
          i = this.readVarint32(A),
          n = i.value,
          o = n >> 3,
          r = 0,
          s = [];
        for (A += i.length; o--; )
          (t = this.readByte(A++)),
            (s[r++] = !!(1 & t)),
            (s[r++] = !!(2 & t)),
            (s[r++] = !!(4 & t)),
            (s[r++] = !!(8 & t)),
            (s[r++] = !!(16 & t)),
            (s[r++] = !!(32 & t)),
            (s[r++] = !!(64 & t)),
            (s[r++] = !!(128 & t));
        if (r < n) {
          var a = 0;
          for (t = this.readByte(A++); r < n; ) s[r++] = !!((t >> a++) & 1);
        }
        return e && (this.offset = A), s;
      }),
      (t.readBytes = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + A > this.buffer.byteLength)
            throw RangeError(
              "Illegal offset: 0 <= " + e + " (+" + A + ") <= " + this.buffer.byteLength
            );
        }
        var i = this.slice(e, e + A);
        return t && (this.offset += A), i;
      }),
      (t.writeBytes = t.append),
      (t.writeInt8 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A |= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 1;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 1),
          (this.view[e] = A),
          t && (this.offset += 1),
          this
        );
      }),
      (t.writeByte = t.writeInt8),
      (t.readInt8 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 1 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+1) <= " + this.buffer.byteLength);
        }
        var t = this.view[A];
        return 128 & ~t || (t = -(255 - t + 1)), e && (this.offset += 1), t;
      }),
      (t.readByte = t.readInt8),
      (t.writeUint8 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 1;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 1),
          (this.view[e] = A),
          t && (this.offset += 1),
          this
        );
      }),
      (t.writeUInt8 = t.writeUint8),
      (t.readUint8 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 1 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+1) <= " + this.buffer.byteLength);
        }
        var t = this.view[A];
        return e && (this.offset += 1), t;
      }),
      (t.readUInt8 = t.readUint8),
      (t.writeInt16 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A |= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 2;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 2),
          this.littleEndian
            ? ((this.view[e + 1] = (65280 & A) >>> 8), (this.view[e] = 255 & A))
            : ((this.view[e] = (65280 & A) >>> 8), (this.view[e + 1] = 255 & A)),
          t && (this.offset += 2),
          this
        );
      }),
      (t.writeShort = t.writeInt16),
      (t.readInt16 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 2 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+2) <= " + this.buffer.byteLength);
        }
        var t = 0;
        return (
          this.littleEndian
            ? ((t = this.view[A]), (t |= this.view[A + 1] << 8))
            : ((t = this.view[A] << 8), (t |= this.view[A + 1])),
          32768 & ~t || (t = -(65535 - t + 1)),
          e && (this.offset += 2),
          t
        );
      }),
      (t.readShort = t.readInt16),
      (t.writeUint16 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 2;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 2),
          this.littleEndian
            ? ((this.view[e + 1] = (65280 & A) >>> 8), (this.view[e] = 255 & A))
            : ((this.view[e] = (65280 & A) >>> 8), (this.view[e + 1] = 255 & A)),
          t && (this.offset += 2),
          this
        );
      }),
      (t.writeUInt16 = t.writeUint16),
      (t.readUint16 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 2 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+2) <= " + this.buffer.byteLength);
        }
        var t = 0;
        return (
          this.littleEndian
            ? ((t = this.view[A]), (t |= this.view[A + 1] << 8))
            : ((t = this.view[A] << 8), (t |= this.view[A + 1])),
          e && (this.offset += 2),
          t
        );
      }),
      (t.readUInt16 = t.readUint16),
      (t.writeInt32 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A |= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 4;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 4),
          this.littleEndian
            ? ((this.view[e + 3] = (A >>> 24) & 255),
              (this.view[e + 2] = (A >>> 16) & 255),
              (this.view[e + 1] = (A >>> 8) & 255),
              (this.view[e] = 255 & A))
            : ((this.view[e] = (A >>> 24) & 255),
              (this.view[e + 1] = (A >>> 16) & 255),
              (this.view[e + 2] = (A >>> 8) & 255),
              (this.view[e + 3] = 255 & A)),
          t && (this.offset += 4),
          this
        );
      }),
      (t.writeInt = t.writeInt32),
      (t.readInt32 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 4 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+4) <= " + this.buffer.byteLength);
        }
        var t = 0;
        return (
          this.littleEndian
            ? ((t = this.view[A + 2] << 16),
              (t |= this.view[A + 1] << 8),
              (t |= this.view[A]),
              (t += (this.view[A + 3] << 24) >>> 0))
            : ((t = this.view[A + 1] << 16),
              (t |= this.view[A + 2] << 8),
              (t |= this.view[A + 3]),
              (t += (this.view[A] << 24) >>> 0)),
          (t |= 0),
          e && (this.offset += 4),
          t
        );
      }),
      (t.readInt = t.readInt32),
      (t.writeUint32 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 4;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 4),
          this.littleEndian
            ? ((this.view[e + 3] = (A >>> 24) & 255),
              (this.view[e + 2] = (A >>> 16) & 255),
              (this.view[e + 1] = (A >>> 8) & 255),
              (this.view[e] = 255 & A))
            : ((this.view[e] = (A >>> 24) & 255),
              (this.view[e + 1] = (A >>> 16) & 255),
              (this.view[e + 2] = (A >>> 8) & 255),
              (this.view[e + 3] = 255 & A)),
          t && (this.offset += 4),
          this
        );
      }),
      (t.writeUInt32 = t.writeUint32),
      (t.readUint32 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 4 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+4) <= " + this.buffer.byteLength);
        }
        var t = 0;
        return (
          this.littleEndian
            ? ((t = this.view[A + 2] << 16),
              (t |= this.view[A + 1] << 8),
              (t |= this.view[A]),
              (t += (this.view[A + 3] << 24) >>> 0))
            : ((t = this.view[A + 1] << 16),
              (t |= this.view[A + 2] << 8),
              (t |= this.view[A + 3]),
              (t += (this.view[A] << 24) >>> 0)),
          e && (this.offset += 4),
          t
        );
      }),
      (t.readUInt32 = t.readUint32),
      A &&
        ((t.writeInt64 = function (e, t) {
          var i = void 0 === t;
          if ((i && (t = this.offset), !this.noAssert)) {
            if ("number" == typeof e) e = A.fromNumber(e);
            else if ("string" == typeof e) e = A.fromString(e);
            else if (!(e && e instanceof A))
              throw TypeError("Illegal value: " + e + " (not an integer or Long)");
            if ("number" != typeof t || t % 1 != 0)
              throw TypeError("Illegal offset: " + t + " (not an integer)");
            if ((t >>>= 0) < 0 || t + 0 > this.buffer.byteLength)
              throw RangeError("Illegal offset: 0 <= " + t + " (+0) <= " + this.buffer.byteLength);
          }
          "number" == typeof e
            ? (e = A.fromNumber(e))
            : "string" == typeof e && (e = A.fromString(e)),
            (t += 8);
          var n = this.buffer.byteLength;
          t > n && this.resize((n *= 2) > t ? n : t), (t -= 8);
          var o = e.low,
            r = e.high;
          return (
            this.littleEndian
              ? ((this.view[t + 3] = (o >>> 24) & 255),
                (this.view[t + 2] = (o >>> 16) & 255),
                (this.view[t + 1] = (o >>> 8) & 255),
                (this.view[t] = 255 & o),
                (t += 4),
                (this.view[t + 3] = (r >>> 24) & 255),
                (this.view[t + 2] = (r >>> 16) & 255),
                (this.view[t + 1] = (r >>> 8) & 255),
                (this.view[t] = 255 & r))
              : ((this.view[t] = (r >>> 24) & 255),
                (this.view[t + 1] = (r >>> 16) & 255),
                (this.view[t + 2] = (r >>> 8) & 255),
                (this.view[t + 3] = 255 & r),
                (t += 4),
                (this.view[t] = (o >>> 24) & 255),
                (this.view[t + 1] = (o >>> 16) & 255),
                (this.view[t + 2] = (o >>> 8) & 255),
                (this.view[t + 3] = 255 & o)),
            i && (this.offset += 8),
            this
          );
        }),
        (t.writeLong = t.writeInt64),
        (t.readInt64 = function (e) {
          var t = void 0 === e;
          if ((t && (e = this.offset), !this.noAssert)) {
            if ("number" != typeof e || e % 1 != 0)
              throw TypeError("Illegal offset: " + e + " (not an integer)");
            if ((e >>>= 0) < 0 || e + 8 > this.buffer.byteLength)
              throw RangeError("Illegal offset: 0 <= " + e + " (+8) <= " + this.buffer.byteLength);
          }
          var i = 0,
            n = 0;
          this.littleEndian
            ? ((i = this.view[e + 2] << 16),
              (i |= this.view[e + 1] << 8),
              (i |= this.view[e]),
              (i += (this.view[e + 3] << 24) >>> 0),
              (e += 4),
              (n = this.view[e + 2] << 16),
              (n |= this.view[e + 1] << 8),
              (n |= this.view[e]),
              (n += (this.view[e + 3] << 24) >>> 0))
            : ((n = this.view[e + 1] << 16),
              (n |= this.view[e + 2] << 8),
              (n |= this.view[e + 3]),
              (n += (this.view[e] << 24) >>> 0),
              (e += 4),
              (i = this.view[e + 1] << 16),
              (i |= this.view[e + 2] << 8),
              (i |= this.view[e + 3]),
              (i += (this.view[e] << 24) >>> 0));
          var o = new A(i, n, !1);
          return t && (this.offset += 8), o;
        }),
        (t.readLong = t.readInt64),
        (t.writeUint64 = function (e, t) {
          var i = void 0 === t;
          if ((i && (t = this.offset), !this.noAssert)) {
            if ("number" == typeof e) e = A.fromNumber(e);
            else if ("string" == typeof e) e = A.fromString(e);
            else if (!(e && e instanceof A))
              throw TypeError("Illegal value: " + e + " (not an integer or Long)");
            if ("number" != typeof t || t % 1 != 0)
              throw TypeError("Illegal offset: " + t + " (not an integer)");
            if ((t >>>= 0) < 0 || t + 0 > this.buffer.byteLength)
              throw RangeError("Illegal offset: 0 <= " + t + " (+0) <= " + this.buffer.byteLength);
          }
          "number" == typeof e
            ? (e = A.fromNumber(e))
            : "string" == typeof e && (e = A.fromString(e)),
            (t += 8);
          var n = this.buffer.byteLength;
          t > n && this.resize((n *= 2) > t ? n : t), (t -= 8);
          var o = e.low,
            r = e.high;
          return (
            this.littleEndian
              ? ((this.view[t + 3] = (o >>> 24) & 255),
                (this.view[t + 2] = (o >>> 16) & 255),
                (this.view[t + 1] = (o >>> 8) & 255),
                (this.view[t] = 255 & o),
                (t += 4),
                (this.view[t + 3] = (r >>> 24) & 255),
                (this.view[t + 2] = (r >>> 16) & 255),
                (this.view[t + 1] = (r >>> 8) & 255),
                (this.view[t] = 255 & r))
              : ((this.view[t] = (r >>> 24) & 255),
                (this.view[t + 1] = (r >>> 16) & 255),
                (this.view[t + 2] = (r >>> 8) & 255),
                (this.view[t + 3] = 255 & r),
                (t += 4),
                (this.view[t] = (o >>> 24) & 255),
                (this.view[t + 1] = (o >>> 16) & 255),
                (this.view[t + 2] = (o >>> 8) & 255),
                (this.view[t + 3] = 255 & o)),
            i && (this.offset += 8),
            this
          );
        }),
        (t.writeUInt64 = t.writeUint64),
        (t.readUint64 = function (e) {
          var t = void 0 === e;
          if ((t && (e = this.offset), !this.noAssert)) {
            if ("number" != typeof e || e % 1 != 0)
              throw TypeError("Illegal offset: " + e + " (not an integer)");
            if ((e >>>= 0) < 0 || e + 8 > this.buffer.byteLength)
              throw RangeError("Illegal offset: 0 <= " + e + " (+8) <= " + this.buffer.byteLength);
          }
          var i = 0,
            n = 0;
          this.littleEndian
            ? ((i = this.view[e + 2] << 16),
              (i |= this.view[e + 1] << 8),
              (i |= this.view[e]),
              (i += (this.view[e + 3] << 24) >>> 0),
              (e += 4),
              (n = this.view[e + 2] << 16),
              (n |= this.view[e + 1] << 8),
              (n |= this.view[e]),
              (n += (this.view[e + 3] << 24) >>> 0))
            : ((n = this.view[e + 1] << 16),
              (n |= this.view[e + 2] << 8),
              (n |= this.view[e + 3]),
              (n += (this.view[e] << 24) >>> 0),
              (e += 4),
              (i = this.view[e + 1] << 16),
              (i |= this.view[e + 2] << 8),
              (i |= this.view[e + 3]),
              (i += (this.view[e] << 24) >>> 0));
          var o = new A(i, n, !0);
          return t && (this.offset += 8), o;
        }),
        (t.readUInt64 = t.readUint64)),
      (t.writeFloat32 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A) throw TypeError("Illegal value: " + A + " (not a number)");
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 4;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 4),
          a(this.view, A, e, this.littleEndian, 23, 4),
          t && (this.offset += 4),
          this
        );
      }),
      (t.writeFloat = t.writeFloat32),
      (t.readFloat32 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 4 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+4) <= " + this.buffer.byteLength);
        }
        var t = s(this.view, A, this.littleEndian, 23, 4);
        return e && (this.offset += 4), t;
      }),
      (t.readFloat = t.readFloat32),
      (t.writeFloat64 = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof A) throw TypeError("Illegal value: " + A + " (not a number)");
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        e += 8;
        var i = this.buffer.byteLength;
        return (
          e > i && this.resize((i *= 2) > e ? i : e),
          (e -= 8),
          a(this.view, A, e, this.littleEndian, 52, 8),
          t && (this.offset += 8),
          this
        );
      }),
      (t.writeDouble = t.writeFloat64),
      (t.readFloat64 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 8 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+8) <= " + this.buffer.byteLength);
        }
        var t = s(this.view, A, this.littleEndian, 52, 8);
        return e && (this.offset += 8), t;
      }),
      (t.readDouble = t.readFloat64),
      (e.MAX_VARINT32_BYTES = 5),
      (e.calculateVarint32 = function (A) {
        return (A >>>= 0) < 128 ? 1 : A < 16384 ? 2 : A < 1 << 21 ? 3 : A < 1 << 28 ? 4 : 5;
      }),
      (e.zigZagEncode32 = function (A) {
        return (((A |= 0) << 1) ^ (A >> 31)) >>> 0;
      }),
      (e.zigZagDecode32 = function (A) {
        return (A >>> 1) ^ -(1 & A);
      }),
      (t.writeVarint32 = function (A, t) {
        var i = void 0 === t;
        if ((i && (t = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A |= 0), "number" != typeof t || t % 1 != 0))
            throw TypeError("Illegal offset: " + t + " (not an integer)");
          if ((t >>>= 0) < 0 || t + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + t + " (+0) <= " + this.buffer.byteLength);
        }
        var n,
          o = e.calculateVarint32(A);
        t += o;
        var r = this.buffer.byteLength;
        for (t > r && this.resize((r *= 2) > t ? r : t), t -= o, A >>>= 0; A >= 128; )
          (n = (127 & A) | 128), (this.view[t++] = n), (A >>>= 7);
        return (this.view[t++] = A), i ? ((this.offset = t), this) : o;
      }),
      (t.writeVarint32ZigZag = function (A, t) {
        return this.writeVarint32(e.zigZagEncode32(A), t);
      }),
      (t.readVarint32 = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 1 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+1) <= " + this.buffer.byteLength);
        }
        var t,
          i = 0,
          n = 0;
        do {
          if (!this.noAssert && A > this.limit) {
            var o = Error("Truncated");
            throw ((o.truncated = !0), o);
          }
          (t = this.view[A++]), i < 5 && (n |= (127 & t) << (7 * i)), ++i;
        } while (128 & t);
        return (n |= 0), e ? ((this.offset = A), n) : { value: n, length: i };
      }),
      (t.readVarint32ZigZag = function (A) {
        var t = this.readVarint32(A);
        return (
          "object" == typeof t ? (t.value = e.zigZagDecode32(t.value)) : (t = e.zigZagDecode32(t)),
          t
        );
      }),
      A &&
        ((e.MAX_VARINT64_BYTES = 10),
        (e.calculateVarint64 = function (e) {
          "number" == typeof e
            ? (e = A.fromNumber(e))
            : "string" == typeof e && (e = A.fromString(e));
          var t = e.toInt() >>> 0,
            i = e.shiftRightUnsigned(28).toInt() >>> 0,
            n = e.shiftRightUnsigned(56).toInt() >>> 0;
          return 0 == n
            ? 0 == i
              ? t < 16384
                ? t < 128
                  ? 1
                  : 2
                : t < 1 << 21
                  ? 3
                  : 4
              : i < 16384
                ? i < 128
                  ? 5
                  : 6
                : i < 1 << 21
                  ? 7
                  : 8
            : n < 128
              ? 9
              : 10;
        }),
        (e.zigZagEncode64 = function (e) {
          return (
            "number" == typeof e
              ? (e = A.fromNumber(e, !1))
              : "string" == typeof e
                ? (e = A.fromString(e, !1))
                : !1 !== e.unsigned && (e = e.toSigned()),
            e.shiftLeft(1).xor(e.shiftRight(63)).toUnsigned()
          );
        }),
        (e.zigZagDecode64 = function (e) {
          return (
            "number" == typeof e
              ? (e = A.fromNumber(e, !1))
              : "string" == typeof e
                ? (e = A.fromString(e, !1))
                : !1 !== e.unsigned && (e = e.toSigned()),
            e.shiftRightUnsigned(1).xor(e.and(A.ONE).toSigned().negate()).toSigned()
          );
        }),
        (t.writeVarint64 = function (t, i) {
          var n = void 0 === i;
          if ((n && (i = this.offset), !this.noAssert)) {
            if ("number" == typeof t) t = A.fromNumber(t);
            else if ("string" == typeof t) t = A.fromString(t);
            else if (!(t && t instanceof A))
              throw TypeError("Illegal value: " + t + " (not an integer or Long)");
            if ("number" != typeof i || i % 1 != 0)
              throw TypeError("Illegal offset: " + i + " (not an integer)");
            if ((i >>>= 0) < 0 || i + 0 > this.buffer.byteLength)
              throw RangeError("Illegal offset: 0 <= " + i + " (+0) <= " + this.buffer.byteLength);
          }
          "number" == typeof t
            ? (t = A.fromNumber(t, !1))
            : "string" == typeof t
              ? (t = A.fromString(t, !1))
              : !1 !== t.unsigned && (t = t.toSigned());
          var o = e.calculateVarint64(t),
            r = t.toInt() >>> 0,
            s = t.shiftRightUnsigned(28).toInt() >>> 0,
            a = t.shiftRightUnsigned(56).toInt() >>> 0;
          i += o;
          var g = this.buffer.byteLength;
          switch ((i > g && this.resize((g *= 2) > i ? g : i), (i -= o), o)) {
            case 10:
              this.view[i + 9] = (a >>> 7) & 1;
            case 9:
              this.view[i + 8] = 9 !== o ? 128 | a : 127 & a;
            case 8:
              this.view[i + 7] = 8 !== o ? (s >>> 21) | 128 : (s >>> 21) & 127;
            case 7:
              this.view[i + 6] = 7 !== o ? (s >>> 14) | 128 : (s >>> 14) & 127;
            case 6:
              this.view[i + 5] = 6 !== o ? (s >>> 7) | 128 : (s >>> 7) & 127;
            case 5:
              this.view[i + 4] = 5 !== o ? 128 | s : 127 & s;
            case 4:
              this.view[i + 3] = 4 !== o ? (r >>> 21) | 128 : (r >>> 21) & 127;
            case 3:
              this.view[i + 2] = 3 !== o ? (r >>> 14) | 128 : (r >>> 14) & 127;
            case 2:
              this.view[i + 1] = 2 !== o ? (r >>> 7) | 128 : (r >>> 7) & 127;
            case 1:
              this.view[i] = 1 !== o ? 128 | r : 127 & r;
          }
          return n ? ((this.offset += o), this) : o;
        }),
        (t.writeVarint64ZigZag = function (A, t) {
          return this.writeVarint64(e.zigZagEncode64(A), t);
        }),
        (t.readVarint64 = function (e) {
          var t = void 0 === e;
          if ((t && (e = this.offset), !this.noAssert)) {
            if ("number" != typeof e || e % 1 != 0)
              throw TypeError("Illegal offset: " + e + " (not an integer)");
            if ((e >>>= 0) < 0 || e + 1 > this.buffer.byteLength)
              throw RangeError("Illegal offset: 0 <= " + e + " (+1) <= " + this.buffer.byteLength);
          }
          var i = e,
            n = 0,
            o = 0,
            r = 0,
            s = 0;
          if (
            ((n = 127 & (s = this.view[e++])),
            128 & s &&
              ((n |= (127 & (s = this.view[e++])) << 7),
              (128 & s || (this.noAssert && void 0 === s)) &&
                ((n |= (127 & (s = this.view[e++])) << 14),
                (128 & s || (this.noAssert && void 0 === s)) &&
                  ((n |= (127 & (s = this.view[e++])) << 21),
                  (128 & s || (this.noAssert && void 0 === s)) &&
                    ((o = 127 & (s = this.view[e++])),
                    (128 & s || (this.noAssert && void 0 === s)) &&
                      ((o |= (127 & (s = this.view[e++])) << 7),
                      (128 & s || (this.noAssert && void 0 === s)) &&
                        ((o |= (127 & (s = this.view[e++])) << 14),
                        (128 & s || (this.noAssert && void 0 === s)) &&
                          ((o |= (127 & (s = this.view[e++])) << 21),
                          (128 & s || (this.noAssert && void 0 === s)) &&
                            ((r = 127 & (s = this.view[e++])),
                            (128 & s || (this.noAssert && void 0 === s)) &&
                              ((r |= (127 & (s = this.view[e++])) << 7),
                              128 & s || (this.noAssert && void 0 === s)))))))))))
          )
            throw Error("Buffer overrun");
          var a = A.fromBits(n | (o << 28), (o >>> 4) | (r << 24), !1);
          return t ? ((this.offset = e), a) : { value: a, length: e - i };
        }),
        (t.readVarint64ZigZag = function (t) {
          var i = this.readVarint64(t);
          return (
            i && i.value instanceof A
              ? (i.value = e.zigZagDecode64(i.value))
              : (i = e.zigZagDecode64(i)),
            i
          );
        })),
      (t.writeCString = function (A, e) {
        var t = void 0 === e;
        t && (e = this.offset);
        var i,
          n = A.length;
        if (!this.noAssert) {
          if ("string" != typeof A) throw TypeError("Illegal str: Not a string");
          for (i = 0; i < n; ++i)
            if (0 === A.charCodeAt(i)) throw RangeError("Illegal str: Contains NULL-characters");
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        (n = c.calculateUTF16asUTF8(o(A))[1]), (e += n + 1);
        var r = this.buffer.byteLength;
        return (
          e > r && this.resize((r *= 2) > e ? r : e),
          (e -= n + 1),
          c.encodeUTF16toUTF8(
            o(A),
            function (A) {
              this.view[e++] = A;
            }.bind(this)
          ),
          (this.view[e++] = 0),
          t ? ((this.offset = e), this) : n
        );
      }),
      (t.readCString = function (A) {
        var e = void 0 === A;
        if ((e && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 1 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+1) <= " + this.buffer.byteLength);
        }
        var t,
          i = A,
          n = -1;
        return (
          c.decodeUTF8toUTF16(
            function () {
              if (0 === n) return null;
              if (A >= this.limit)
                throw RangeError("Illegal range: Truncated data, " + A + " < " + this.limit);
              return 0 === (n = this.view[A++]) ? null : n;
            }.bind(this),
            (t = r()),
            !0
          ),
          e ? ((this.offset = A), t()) : { string: t(), length: A - i }
        );
      }),
      (t.writeIString = function (A, e) {
        var t = void 0 === e;
        if ((t && (e = this.offset), !this.noAssert)) {
          if ("string" != typeof A) throw TypeError("Illegal str: Not a string");
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        var i,
          n = e;
        (i = c.calculateUTF16asUTF8(o(A), this.noAssert)[1]), (e += 4 + i);
        var r = this.buffer.byteLength;
        if (
          (e > r && this.resize((r *= 2) > e ? r : e),
          (e -= 4 + i),
          this.littleEndian
            ? ((this.view[e + 3] = (i >>> 24) & 255),
              (this.view[e + 2] = (i >>> 16) & 255),
              (this.view[e + 1] = (i >>> 8) & 255),
              (this.view[e] = 255 & i))
            : ((this.view[e] = (i >>> 24) & 255),
              (this.view[e + 1] = (i >>> 16) & 255),
              (this.view[e + 2] = (i >>> 8) & 255),
              (this.view[e + 3] = 255 & i)),
          (e += 4),
          c.encodeUTF16toUTF8(
            o(A),
            function (A) {
              this.view[e++] = A;
            }.bind(this)
          ),
          e !== n + 4 + i)
        )
          throw RangeError("Illegal range: Truncated data, " + e + " == " + (e + 4 + i));
        return t ? ((this.offset = e), this) : e - n;
      }),
      (t.readIString = function (A) {
        var t = void 0 === A;
        if ((t && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 4 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+4) <= " + this.buffer.byteLength);
        }
        var i = A,
          n = this.readUint32(A),
          o = this.readUTF8String(n, e.METRICS_BYTES, (A += 4));
        return (
          (A += o.length), t ? ((this.offset = A), o.string) : { string: o.string, length: A - i }
        );
      }),
      (e.METRICS_CHARS = "c"),
      (e.METRICS_BYTES = "b"),
      (t.writeUTF8String = function (A, e) {
        var t,
          i = void 0 === e;
        if ((i && (e = this.offset), !this.noAssert)) {
          if ("number" != typeof e || e % 1 != 0)
            throw TypeError("Illegal offset: " + e + " (not an integer)");
          if ((e >>>= 0) < 0 || e + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + e + " (+0) <= " + this.buffer.byteLength);
        }
        var n = e;
        (t = c.calculateUTF16asUTF8(o(A))[1]), (e += t);
        var r = this.buffer.byteLength;
        return (
          e > r && this.resize((r *= 2) > e ? r : e),
          (e -= t),
          c.encodeUTF16toUTF8(
            o(A),
            function (A) {
              this.view[e++] = A;
            }.bind(this)
          ),
          i ? ((this.offset = e), this) : e - n
        );
      }),
      (t.writeString = t.writeUTF8String),
      (e.calculateUTF8Chars = function (A) {
        return c.calculateUTF16asUTF8(o(A))[0];
      }),
      (e.calculateUTF8Bytes = function (A) {
        return c.calculateUTF16asUTF8(o(A))[1];
      }),
      (e.calculateString = e.calculateUTF8Bytes),
      (t.readUTF8String = function (A, t, i) {
        "number" == typeof t && ((i = t), (t = void 0));
        var n = void 0 === i;
        if ((n && (i = this.offset), void 0 === t && (t = e.METRICS_CHARS), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal length: " + A + " (not an integer)");
          if (((A |= 0), "number" != typeof i || i % 1 != 0))
            throw TypeError("Illegal offset: " + i + " (not an integer)");
          if ((i >>>= 0) < 0 || i + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + i + " (+0) <= " + this.buffer.byteLength);
        }
        var o,
          s = 0,
          a = i;
        if (t === e.METRICS_CHARS) {
          if (
            ((o = r()),
            c.decodeUTF8(
              function () {
                return s < A && i < this.limit ? this.view[i++] : null;
              }.bind(this),
              function (A) {
                ++s, c.UTF8toUTF16(A, o);
              }
            ),
            s !== A)
          )
            throw RangeError("Illegal range: Truncated data, " + s + " == " + A);
          return n ? ((this.offset = i), o()) : { string: o(), length: i - a };
        }
        if (t === e.METRICS_BYTES) {
          if (!this.noAssert) {
            if ("number" != typeof i || i % 1 != 0)
              throw TypeError("Illegal offset: " + i + " (not an integer)");
            if ((i >>>= 0) < 0 || i + A > this.buffer.byteLength)
              throw RangeError(
                "Illegal offset: 0 <= " + i + " (+" + A + ") <= " + this.buffer.byteLength
              );
          }
          var g = i + A;
          if (
            (c.decodeUTF8toUTF16(
              function () {
                return i < g ? this.view[i++] : null;
              }.bind(this),
              (o = r()),
              this.noAssert
            ),
            i !== g)
          )
            throw RangeError("Illegal range: Truncated data, " + i + " == " + g);
          return n ? ((this.offset = i), o()) : { string: o(), length: i - a };
        }
        throw TypeError("Unsupported metrics: " + t);
      }),
      (t.readString = t.readUTF8String),
      (t.writeVString = function (A, t) {
        var i = void 0 === t;
        if ((i && (t = this.offset), !this.noAssert)) {
          if ("string" != typeof A) throw TypeError("Illegal str: Not a string");
          if ("number" != typeof t || t % 1 != 0)
            throw TypeError("Illegal offset: " + t + " (not an integer)");
          if ((t >>>= 0) < 0 || t + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + t + " (+0) <= " + this.buffer.byteLength);
        }
        var n,
          r,
          s = t;
        (n = c.calculateUTF16asUTF8(o(A), this.noAssert)[1]),
          (r = e.calculateVarint32(n)),
          (t += r + n);
        var a = this.buffer.byteLength;
        if (
          (t > a && this.resize((a *= 2) > t ? a : t),
          (t -= r + n),
          (t += this.writeVarint32(n, t)),
          c.encodeUTF16toUTF8(
            o(A),
            function (A) {
              this.view[t++] = A;
            }.bind(this)
          ),
          t !== s + n + r)
        )
          throw RangeError("Illegal range: Truncated data, " + t + " == " + (t + n + r));
        return i ? ((this.offset = t), this) : t - s;
      }),
      (t.readVString = function (A) {
        var t = void 0 === A;
        if ((t && (A = this.offset), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 1 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+1) <= " + this.buffer.byteLength);
        }
        var i = A,
          n = this.readVarint32(A),
          o = this.readUTF8String(n.value, e.METRICS_BYTES, (A += n.length));
        return (
          (A += o.length), t ? ((this.offset = A), o.string) : { string: o.string, length: A - i }
        );
      }),
      (t.append = function (A, t, i) {
        ("number" != typeof t && "string" == typeof t) || ((i = t), (t = void 0));
        var n = void 0 === i;
        if ((n && (i = this.offset), !this.noAssert)) {
          if ("number" != typeof i || i % 1 != 0)
            throw TypeError("Illegal offset: " + i + " (not an integer)");
          if ((i >>>= 0) < 0 || i + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + i + " (+0) <= " + this.buffer.byteLength);
        }
        A instanceof e || (A = e.wrap(A, t));
        var o = A.limit - A.offset;
        if (o <= 0) return this;
        i += o;
        var r = this.buffer.byteLength;
        return (
          i > r && this.resize((r *= 2) > i ? r : i),
          (i -= o),
          this.view.set(A.view.subarray(A.offset, A.limit), i),
          (A.offset += o),
          n && (this.offset += o),
          this
        );
      }),
      (t.appendTo = function (A, e) {
        return A.append(this, e), this;
      }),
      (t.assert = function (A) {
        return (this.noAssert = !A), this;
      }),
      (t.capacity = function () {
        return this.buffer.byteLength;
      }),
      (t.clear = function () {
        return (
          (this.offset = 0), (this.limit = this.buffer.byteLength), (this.markedOffset = -1), this
        );
      }),
      (t.clone = function (A) {
        var t = new e(0, this.littleEndian, this.noAssert);
        return (
          A
            ? ((t.buffer = new ArrayBuffer(this.buffer.byteLength)),
              (t.view = new Uint8Array(t.buffer)))
            : ((t.buffer = this.buffer), (t.view = this.view)),
          (t.offset = this.offset),
          (t.markedOffset = this.markedOffset),
          (t.limit = this.limit),
          t
        );
      }),
      (t.compact = function (A, e) {
        if ((void 0 === A && (A = this.offset), void 0 === e && (e = this.limit), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0) throw TypeError("Illegal begin: Not an integer");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((e >>>= 0), A < 0 || A > e || e > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + A + " <= " + e + " <= " + this.buffer.byteLength
            );
        }
        if (0 === A && e === this.buffer.byteLength) return this;
        var t = e - A;
        if (0 === t)
          return (
            (this.buffer = i),
            (this.view = null),
            this.markedOffset >= 0 && (this.markedOffset -= A),
            (this.offset = 0),
            (this.limit = 0),
            this
          );
        var n = new ArrayBuffer(t),
          o = new Uint8Array(n);
        return (
          o.set(this.view.subarray(A, e)),
          (this.buffer = n),
          (this.view = o),
          this.markedOffset >= 0 && (this.markedOffset -= A),
          (this.offset = 0),
          (this.limit = t),
          this
        );
      }),
      (t.copy = function (A, t) {
        if ((void 0 === A && (A = this.offset), void 0 === t && (t = this.limit), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0) throw TypeError("Illegal begin: Not an integer");
          if (((A >>>= 0), "number" != typeof t || t % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((t >>>= 0), A < 0 || A > t || t > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + A + " <= " + t + " <= " + this.buffer.byteLength
            );
        }
        if (A === t) return new e(0, this.littleEndian, this.noAssert);
        var i = t - A,
          n = new e(i, this.littleEndian, this.noAssert);
        return (
          (n.offset = 0),
          (n.limit = i),
          n.markedOffset >= 0 && (n.markedOffset -= A),
          this.copyTo(n, 0, A, t),
          n
        );
      }),
      (t.copyTo = function (A, t, i, n) {
        var o, r;
        if (!this.noAssert && !e.isByteBuffer(A))
          throw TypeError("Illegal target: Not a ByteBuffer");
        if (
          ((t = (r = void 0 === t) ? A.offset : 0 | t),
          (i = (o = void 0 === i) ? this.offset : 0 | i),
          (n = void 0 === n ? this.limit : 0 | n),
          t < 0 || t > A.buffer.byteLength)
        )
          throw RangeError("Illegal target range: 0 <= " + t + " <= " + A.buffer.byteLength);
        if (i < 0 || n > this.buffer.byteLength)
          throw RangeError("Illegal source range: 0 <= " + i + " <= " + this.buffer.byteLength);
        var s = n - i;
        return 0 === s
          ? A
          : (A.ensureCapacity(t + s),
            A.view.set(this.view.subarray(i, n), t),
            o && (this.offset += s),
            r && (A.offset += s),
            this);
      }),
      (t.ensureCapacity = function (A) {
        var e = this.buffer.byteLength;
        return e < A ? this.resize((e *= 2) > A ? e : A) : this;
      }),
      (t.fill = function (A, e, t) {
        var i = void 0 === e;
        if (
          (i && (e = this.offset),
          "string" == typeof A && A.length > 0 && (A = A.charCodeAt(0)),
          void 0 === e && (e = this.offset),
          void 0 === t && (t = this.limit),
          !this.noAssert)
        ) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal value: " + A + " (not an integer)");
          if (((A |= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal begin: Not an integer");
          if (((e >>>= 0), "number" != typeof t || t % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((t >>>= 0), e < 0 || e > t || t > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + e + " <= " + t + " <= " + this.buffer.byteLength
            );
        }
        if (e >= t) return this;
        for (; e < t; ) this.view[e++] = A;
        return i && (this.offset = e), this;
      }),
      (t.flip = function () {
        return (this.limit = this.offset), (this.offset = 0), this;
      }),
      (t.mark = function (A) {
        if (((A = void 0 === A ? this.offset : A), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal offset: " + A + " (not an integer)");
          if ((A >>>= 0) < 0 || A + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + A + " (+0) <= " + this.buffer.byteLength);
        }
        return (this.markedOffset = A), this;
      }),
      (t.order = function (A) {
        if (!this.noAssert && "boolean" != typeof A)
          throw TypeError("Illegal littleEndian: Not a boolean");
        return (this.littleEndian = !!A), this;
      }),
      (t.LE = function (A) {
        return (this.littleEndian = void 0 === A || !!A), this;
      }),
      (t.BE = function (A) {
        return (this.littleEndian = void 0 !== A && !A), this;
      }),
      (t.prepend = function (A, t, i) {
        ("number" != typeof t && "string" == typeof t) || ((i = t), (t = void 0));
        var n = void 0 === i;
        if ((n && (i = this.offset), !this.noAssert)) {
          if ("number" != typeof i || i % 1 != 0)
            throw TypeError("Illegal offset: " + i + " (not an integer)");
          if ((i >>>= 0) < 0 || i + 0 > this.buffer.byteLength)
            throw RangeError("Illegal offset: 0 <= " + i + " (+0) <= " + this.buffer.byteLength);
        }
        A instanceof e || (A = e.wrap(A, t));
        var o = A.limit - A.offset;
        if (o <= 0) return this;
        var r = o - i;
        if (r > 0) {
          var s = new ArrayBuffer(this.buffer.byteLength + r),
            a = new Uint8Array(s);
          a.set(this.view.subarray(i, this.buffer.byteLength), o),
            (this.buffer = s),
            (this.view = a),
            (this.offset += r),
            this.markedOffset >= 0 && (this.markedOffset += r),
            (this.limit += r),
            (i += r);
        } else new Uint8Array(this.buffer);
        return (
          this.view.set(A.view.subarray(A.offset, A.limit), i - o),
          (A.offset = A.limit),
          n && (this.offset -= o),
          this
        );
      }),
      (t.prependTo = function (A, e) {
        return A.prepend(this, e), this;
      }),
      (t.printDebug = function (A) {
        "function" != typeof A && (A = console.log.bind(console)),
          A(
            this.toString() +
              "\n-------------------------------------------------------------------\n" +
              this.toDebug(!0)
          );
      }),
      (t.remaining = function () {
        return this.limit - this.offset;
      }),
      (t.reset = function () {
        return (
          this.markedOffset >= 0
            ? ((this.offset = this.markedOffset), (this.markedOffset = -1))
            : (this.offset = 0),
          this
        );
      }),
      (t.resize = function (A) {
        if (!this.noAssert) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal capacity: " + A + " (not an integer)");
          if ((A |= 0) < 0) throw RangeError("Illegal capacity: 0 <= " + A);
        }
        if (this.buffer.byteLength < A) {
          var e = new ArrayBuffer(A),
            t = new Uint8Array(e);
          t.set(this.view), (this.buffer = e), (this.view = t);
        }
        return this;
      }),
      (t.reverse = function (A, e) {
        if ((void 0 === A && (A = this.offset), void 0 === e && (e = this.limit), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0) throw TypeError("Illegal begin: Not an integer");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((e >>>= 0), A < 0 || A > e || e > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + A + " <= " + e + " <= " + this.buffer.byteLength
            );
        }
        return A === e || Array.prototype.reverse.call(this.view.subarray(A, e)), this;
      }),
      (t.skip = function (A) {
        if (!this.noAssert) {
          if ("number" != typeof A || A % 1 != 0)
            throw TypeError("Illegal length: " + A + " (not an integer)");
          A |= 0;
        }
        var e = this.offset + A;
        if (!this.noAssert && (e < 0 || e > this.buffer.byteLength))
          throw RangeError(
            "Illegal length: 0 <= " + this.offset + " + " + A + " <= " + this.buffer.byteLength
          );
        return (this.offset = e), this;
      }),
      (t.slice = function (A, e) {
        if ((void 0 === A && (A = this.offset), void 0 === e && (e = this.limit), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0) throw TypeError("Illegal begin: Not an integer");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((e >>>= 0), A < 0 || A > e || e > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + A + " <= " + e + " <= " + this.buffer.byteLength
            );
        }
        var t = this.clone();
        return (t.offset = A), (t.limit = e), t;
      }),
      (t.toBuffer = function (A) {
        var e = this.offset,
          t = this.limit;
        if (!this.noAssert) {
          if ("number" != typeof e || e % 1 != 0) throw TypeError("Illegal offset: Not an integer");
          if (((e >>>= 0), "number" != typeof t || t % 1 != 0))
            throw TypeError("Illegal limit: Not an integer");
          if (((t >>>= 0), e < 0 || e > t || t > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + e + " <= " + t + " <= " + this.buffer.byteLength
            );
        }
        if (!A && 0 === e && t === this.buffer.byteLength) return this.buffer;
        if (e === t) return i;
        var n = new ArrayBuffer(t - e);
        return new Uint8Array(n).set(new Uint8Array(this.buffer).subarray(e, t), 0), n;
      }),
      (t.toArrayBuffer = t.toBuffer),
      (t.toString = function (A, e, t) {
        if (void 0 === A)
          return (
            "ByteBufferAB(offset=" +
            this.offset +
            ",markedOffset=" +
            this.markedOffset +
            ",limit=" +
            this.limit +
            ",capacity=" +
            this.capacity() +
            ")"
          );
        switch (("number" == typeof A && (t = e = A = "utf8"), A)) {
          case "utf8":
            return this.toUTF8(e, t);
          case "base64":
            return this.toBase64(e, t);
          case "hex":
            return this.toHex(e, t);
          case "binary":
            return this.toBinary(e, t);
          case "debug":
            return this.toDebug();
          case "columns":
            return this.toColumns();
          default:
            throw Error("Unsupported encoding: " + A);
        }
      });
    var g = (function () {
      for (
        var A = {},
          e = [
            65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86,
            87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111,
            112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55,
            56, 57, 43, 47
          ],
          t = [],
          i = 0,
          n = e.length;
        i < n;
        ++i
      )
        t[e[i]] = i;
      return (
        (A.encode = function (A, t) {
          for (var i, n; null !== (i = A()); )
            t(e[(i >> 2) & 63]),
              (n = (3 & i) << 4),
              null !== (i = A())
                ? (t(e[63 & ((n |= (i >> 4) & 15) | ((i >> 4) & 15))]),
                  (n = (15 & i) << 2),
                  null !== (i = A())
                    ? (t(e[63 & (n | ((i >> 6) & 3))]), t(e[63 & i]))
                    : (t(e[63 & n]), t(61)))
                : (t(e[63 & n]), t(61), t(61));
        }),
        (A.decode = function (A, e) {
          var i, n, o;
          function r(A) {
            throw Error("Illegal character code: " + A);
          }
          for (; null !== (i = A()); )
            if (
              (void 0 === (n = t[i]) && r(i),
              null !== (i = A()) &&
                (void 0 === (o = t[i]) && r(i),
                e(((n << 2) >>> 0) | ((48 & o) >> 4)),
                null !== (i = A())))
            ) {
              if (void 0 === (n = t[i])) {
                if (61 === i) break;
                r(i);
              }
              if ((e((((15 & o) << 4) >>> 0) | ((60 & n) >> 2)), null !== (i = A()))) {
                if (void 0 === (o = t[i])) {
                  if (61 === i) break;
                  r(i);
                }
                e((((3 & n) << 6) >>> 0) | o);
              }
            }
        }),
        (A.test = function (A) {
          return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(A);
        }),
        A
      );
    })();
    (t.toBase64 = function (A, e) {
      if (
        (void 0 === A && (A = this.offset),
        void 0 === e && (e = this.limit),
        (e |= 0),
        (A |= 0) < 0 || e > this.capacity || A > e)
      )
        throw RangeError("begin, end");
      var t;
      return (
        g.encode(
          function () {
            return A < e ? this.view[A++] : null;
          }.bind(this),
          (t = r())
        ),
        t()
      );
    }),
      (e.fromBase64 = function (A, t) {
        if ("string" != typeof A) throw TypeError("str");
        var i = new e((A.length / 4) * 3, t),
          n = 0;
        return (
          g.decode(o(A), function (A) {
            i.view[n++] = A;
          }),
          (i.limit = n),
          i
        );
      }),
      (e.btoa = function (A) {
        return e.fromBinary(A).toBase64();
      }),
      (e.atob = function (A) {
        return e.fromBase64(A).toBinary();
      }),
      (t.toBinary = function (A, e) {
        if (
          (void 0 === A && (A = this.offset),
          void 0 === e && (e = this.limit),
          (e |= 0),
          (A |= 0) < 0 || e > this.capacity() || A > e)
        )
          throw RangeError("begin, end");
        if (A === e) return "";
        for (var t = [], i = []; A < e; )
          t.push(this.view[A++]),
            t.length >= 1024 && (i.push(String.fromCharCode.apply(String, t)), (t = []));
        return i.join("") + String.fromCharCode.apply(String, t);
      }),
      (e.fromBinary = function (A, t) {
        if ("string" != typeof A) throw TypeError("str");
        for (var i, n = 0, o = A.length, r = new e(o, t); n < o; ) {
          if ((i = A.charCodeAt(n)) > 255) throw RangeError("illegal char code: " + i);
          r.view[n++] = i;
        }
        return (r.limit = o), r;
      }),
      (t.toDebug = function (A) {
        for (var e, t = -1, i = this.buffer.byteLength, n = "", o = "", r = ""; t < i; ) {
          if (
            (-1 !== t &&
              ((n +=
                (e = this.view[t]) < 16
                  ? "0" + e.toString(16).toUpperCase()
                  : e.toString(16).toUpperCase()),
              A && (o += e > 32 && e < 127 ? String.fromCharCode(e) : ".")),
            ++t,
            A && t > 0 && t % 16 == 0 && t !== i)
          ) {
            for (; n.length < 51; ) n += " ";
            (r += n + o + "\n"), (n = o = "");
          }
          t === this.offset && t === this.limit
            ? (n += t === this.markedOffset ? "!" : "|")
            : t === this.offset
              ? (n += t === this.markedOffset ? "[" : "<")
              : t === this.limit
                ? (n += t === this.markedOffset ? "]" : ">")
                : (n += t === this.markedOffset ? "'" : A || (0 !== t && t !== i) ? " " : "");
        }
        if (A && " " !== n) {
          for (; n.length < 51; ) n += " ";
          r += n + o + "\n";
        }
        return A ? r : n;
      }),
      (e.fromDebug = function (A, t, i) {
        for (
          var n,
            o,
            r = A.length,
            s = new e(((r + 1) / 3) | 0, t, i),
            a = 0,
            g = 0,
            c = !1,
            I = !1,
            l = !1,
            d = !1,
            u = !1;
          a < r;

        ) {
          switch ((n = A.charAt(a++))) {
            case "!":
              if (!i) {
                if (I || l || d) {
                  u = !0;
                  break;
                }
                I = l = d = !0;
              }
              (s.offset = s.markedOffset = s.limit = g), (c = !1);
              break;
            case "|":
              if (!i) {
                if (I || d) {
                  u = !0;
                  break;
                }
                I = d = !0;
              }
              (s.offset = s.limit = g), (c = !1);
              break;
            case "[":
              if (!i) {
                if (I || l) {
                  u = !0;
                  break;
                }
                I = l = !0;
              }
              (s.offset = s.markedOffset = g), (c = !1);
              break;
            case "<":
              if (!i) {
                if (I) {
                  u = !0;
                  break;
                }
                I = !0;
              }
              (s.offset = g), (c = !1);
              break;
            case "]":
              if (!i) {
                if (d || l) {
                  u = !0;
                  break;
                }
                d = l = !0;
              }
              (s.limit = s.markedOffset = g), (c = !1);
              break;
            case ">":
              if (!i) {
                if (d) {
                  u = !0;
                  break;
                }
                d = !0;
              }
              (s.limit = g), (c = !1);
              break;
            case "'":
              if (!i) {
                if (l) {
                  u = !0;
                  break;
                }
                l = !0;
              }
              (s.markedOffset = g), (c = !1);
              break;
            case " ":
              c = !1;
              break;
            default:
              if (!i && c) {
                u = !0;
                break;
              }
              if (((o = parseInt(n + A.charAt(a++), 16)), !i && (isNaN(o) || o < 0 || o > 255)))
                throw TypeError("Illegal str: Not a debug encoded string");
              (s.view[g++] = o), (c = !0);
          }
          if (u) throw TypeError("Illegal str: Invalid symbol at " + a);
        }
        if (!i) {
          if (!I || !d) throw TypeError("Illegal str: Missing offset or limit");
          if (g < s.buffer.byteLength)
            throw TypeError(
              "Illegal str: Not a debug encoded string (is it hex?) " + g + " < " + r
            );
        }
        return s;
      }),
      (t.toHex = function (A, e) {
        if (
          ((A = void 0 === A ? this.offset : A),
          (e = void 0 === e ? this.limit : e),
          !this.noAssert)
        ) {
          if ("number" != typeof A || A % 1 != 0) throw TypeError("Illegal begin: Not an integer");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((e >>>= 0), A < 0 || A > e || e > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + A + " <= " + e + " <= " + this.buffer.byteLength
            );
        }
        for (var t, i = new Array(e - A); A < e; )
          (t = this.view[A++]) < 16 ? i.push("0", t.toString(16)) : i.push(t.toString(16));
        return i.join("");
      }),
      (e.fromHex = function (A, t, i) {
        if (!i) {
          if ("string" != typeof A) throw TypeError("Illegal str: Not a string");
          if (A.length % 2 != 0) throw TypeError("Illegal str: Length not a multiple of 2");
        }
        for (var n, o = A.length, r = new e((o / 2) | 0, t), s = 0, a = 0; s < o; s += 2) {
          if (((n = parseInt(A.substring(s, s + 2), 16)), !i && (!isFinite(n) || n < 0 || n > 255)))
            throw TypeError("Illegal str: Contains non-hex characters");
          r.view[a++] = n;
        }
        return (r.limit = a), r;
      });
    var c = (function () {
      var A = {
        MAX_CODEPOINT: 1114111,
        encodeUTF8: function (A, e) {
          var t = null;
          for (
            "number" == typeof A &&
            ((t = A),
            (A = function () {
              return null;
            }));
            null !== t || null !== (t = A());

          )
            t < 128
              ? e(127 & t)
              : t < 2048
                ? (e(((t >> 6) & 31) | 192), e((63 & t) | 128))
                : t < 65536
                  ? (e(((t >> 12) & 15) | 224), e(((t >> 6) & 63) | 128), e((63 & t) | 128))
                  : (e(((t >> 18) & 7) | 240),
                    e(((t >> 12) & 63) | 128),
                    e(((t >> 6) & 63) | 128),
                    e((63 & t) | 128)),
              (t = null);
        },
        decodeUTF8: function (A, e) {
          for (
            var t,
              i,
              n,
              o,
              r = function (A) {
                A = A.slice(0, A.indexOf(null));
                var e = Error(A.toString());
                throw ((e.name = "TruncatedError"), (e.bytes = A), e);
              };
            null !== (t = A());

          )
            if (128 & t)
              if (192 == (224 & t)) null === (i = A()) && r([t, i]), e(((31 & t) << 6) | (63 & i));
              else if (224 == (240 & t))
                (null === (i = A()) || null === (n = A())) && r([t, i, n]),
                  e(((15 & t) << 12) | ((63 & i) << 6) | (63 & n));
              else {
                if (240 != (248 & t)) throw RangeError("Illegal starting byte: " + t);
                (null === (i = A()) || null === (n = A()) || null === (o = A())) && r([t, i, n, o]),
                  e(((7 & t) << 18) | ((63 & i) << 12) | ((63 & n) << 6) | (63 & o));
              }
            else e(t);
        },
        UTF16toUTF8: function (A, e) {
          for (var t, i = null; null !== (t = null !== i ? i : A()); )
            t >= 55296 && t <= 57343 && null !== (i = A()) && i >= 56320 && i <= 57343
              ? (e(1024 * (t - 55296) + i - 56320 + 65536), (i = null))
              : e(t);
          null !== i && e(i);
        },
        UTF8toUTF16: function (A, e) {
          var t = null;
          for (
            "number" == typeof A &&
            ((t = A),
            (A = function () {
              return null;
            }));
            null !== t || null !== (t = A());

          )
            t <= 65535 ? e(t) : (e(55296 + ((t -= 65536) >> 10)), e((t % 1024) + 56320)),
              (t = null);
        },
        encodeUTF16toUTF8: function (e, t) {
          A.UTF16toUTF8(e, function (e) {
            A.encodeUTF8(e, t);
          });
        },
        decodeUTF8toUTF16: function (e, t) {
          A.decodeUTF8(e, function (e) {
            A.UTF8toUTF16(e, t);
          });
        },
        calculateCodePoint: function (A) {
          return A < 128 ? 1 : A < 2048 ? 2 : A < 65536 ? 3 : 4;
        },
        calculateUTF8: function (A) {
          for (var e, t = 0; null !== (e = A()); )
            t += e < 128 ? 1 : e < 2048 ? 2 : e < 65536 ? 3 : 4;
          return t;
        },
        calculateUTF16asUTF8: function (e) {
          var t = 0,
            i = 0;
          return (
            A.UTF16toUTF8(e, function (A) {
              ++t, (i += A < 128 ? 1 : A < 2048 ? 2 : A < 65536 ? 3 : 4);
            }),
            [t, i]
          );
        }
      };
      return A;
    })();
    return (
      (t.toUTF8 = function (A, e) {
        if ((void 0 === A && (A = this.offset), void 0 === e && (e = this.limit), !this.noAssert)) {
          if ("number" != typeof A || A % 1 != 0) throw TypeError("Illegal begin: Not an integer");
          if (((A >>>= 0), "number" != typeof e || e % 1 != 0))
            throw TypeError("Illegal end: Not an integer");
          if (((e >>>= 0), A < 0 || A > e || e > this.buffer.byteLength))
            throw RangeError(
              "Illegal range: 0 <= " + A + " <= " + e + " <= " + this.buffer.byteLength
            );
        }
        var t;
        try {
          c.decodeUTF8toUTF16(
            function () {
              return A < e ? this.view[A++] : null;
            }.bind(this),
            (t = r())
          );
        } catch (t) {
          if (A !== e) throw RangeError("Illegal range: Truncated data, " + A + " != " + e);
        }
        return t();
      }),
      (e.fromUTF8 = function (A, t, i) {
        if (!i && "string" != typeof A) throw TypeError("Illegal str: Not a string");
        var n = new e(c.calculateUTF16asUTF8(o(A), !0)[1], t, i),
          r = 0;
        return (
          c.encodeUTF16toUTF8(o(A), function (A) {
            n.view[r++] = A;
          }),
          (n.limit = r),
          n
        );
      }),
      e
    );
  });
})(GC);
var HC = GC.exports;
function YC() {
  this.mechs = [];
}
function qC() {
  this.completed = !1;
}
(YC.prototype.use = function (A, e) {
  var t = {};
  return (
    e ? ((t.Mech = e), (t.name = A)) : ((t.Mech = A), (t.name = t.Mech.prototype.name)),
    this.mechs.push(t),
    this
  );
}),
  (YC.prototype.create = function (A) {
    var e, t, i, n, o;
    for (e = 0, n = this.mechs.length; e < n; e++)
      for (t = 0, o = A.length; t < o; t++)
        if ((i = this.mechs[e]).name === A[t]) return new i.Mech();
    return null;
  }),
  (qC.prototype.name = "PLAIN"),
  (qC.prototype.clientFirst = !0),
  (qC.prototype.response = function (A) {
    var e = "";
    if (!A.username) throw new Error("No username specified.");
    return (
      (e += A.authzid || ""),
      (e += "\0"),
      (e += A.username),
      (e += "\0"),
      (e += A.password),
      (this.completed = !0),
      e
    );
  }),
  (qC.prototype.challenge = function (A) {
    return !0;
  });
var JC = { exports: {} };
!(function (A) {
  !(function () {
    function e(A, e, t) {
      var i,
        n,
        c,
        I,
        l,
        B,
        Q,
        E,
        h = 0,
        p = [],
        f = 0,
        m = !1,
        y = !1,
        D = [],
        w = [],
        F = !1;
      if (
        ((i = (t = t || {}).encoding || "UTF8"),
        (E = t.numRounds || 1),
        (c = g(e, i)),
        E !== parseInt(E, 10) || 1 > E)
      )
        throw Error("numRounds must a integer >= 1");
      if ("SHA-1" !== A) throw Error("Chosen SHA variant is not supported");
      (l = 512),
        (B = u),
        (Q = C),
        (I = 160),
        (n = d(A)),
        (this.setHMACKey = function (e, t, o) {
          var r;
          if (!0 === y) throw Error("HMAC key already set");
          if (!0 === m) throw Error("Cannot set HMAC key after finalizing hash");
          if (!0 === F) throw Error("Cannot set HMAC key after calling update");
          if (
            ((e = (t = g(t, (i = (o || {}).encoding || "UTF8"))(e)).binLen),
            (t = t.value),
            (o = (r = l >>> 3) / 4 - 1),
            r < e / 8)
          ) {
            for (t = Q(t, e, 0, d(A)); t.length <= o; ) t.push(0);
            t[o] &= 4294967040;
          } else if (r > e / 8) {
            for (; t.length <= o; ) t.push(0);
            t[o] &= 4294967040;
          }
          for (e = 0; e <= o; e += 1) (D[e] = 909522486 ^ t[e]), (w[e] = 1549556828 ^ t[e]);
          (n = B(D, n)), (h = l), (y = !0);
        }),
        (this.update = function (A) {
          var e,
            t,
            i,
            o = 0,
            r = l >>> 5;
          for (A = (e = c(A, p, f)).binLen, t = e.value, e = A >>> 5, i = 0; i < e; i += r)
            o + l <= A && ((n = B(t.slice(i, i + r), n)), (o += l));
          (h += o), (p = t.slice(o >>> 5)), (f = A % l), (F = !0);
        }),
        (this.getHash = function (e, t) {
          var i, g, c;
          if (!0 === y) throw Error("Cannot call getHash after setting HMAC key");
          switch (((c = a(t)), e)) {
            case "HEX":
              i = function (A) {
                return o(A, c);
              };
              break;
            case "B64":
              i = function (A) {
                return r(A, c);
              };
              break;
            case "BYTES":
              i = s;
              break;
            default:
              throw Error("format must be HEX, B64, or BYTES");
          }
          if (!1 === m) for (n = Q(p, f, h, n), g = 1; g < E; g += 1) n = Q(n, I, 0, d(A));
          return (m = !0), i(n);
        }),
        (this.getHMAC = function (e, t) {
          var i, g, c;
          if (!1 === y) throw Error("Cannot call getHMAC without first setting HMAC key");
          switch (((c = a(t)), e)) {
            case "HEX":
              i = function (A) {
                return o(A, c);
              };
              break;
            case "B64":
              i = function (A) {
                return r(A, c);
              };
              break;
            case "BYTES":
              i = s;
              break;
            default:
              throw Error("outputFormat must be HEX, B64, or BYTES");
          }
          return (
            !1 === m && ((g = Q(p, f, h, n)), (n = B(w, d(A))), (n = Q(g, I, l, n))), (m = !0), i(n)
          );
        });
    }
    function t(A, e, t) {
      var i,
        n,
        o,
        r,
        s,
        a = A.length;
      if (((e = e || [0]), (s = (t = t || 0) >>> 3), 0 != a % 2))
        throw Error("String of HEX type must be in byte increments");
      for (i = 0; i < a; i += 2) {
        if (((n = parseInt(A.substr(i, 2), 16)), isNaN(n)))
          throw Error("String of HEX type contains invalid characters");
        for (o = (r = (i >>> 1) + s) >>> 2; e.length <= o; ) e.push(0);
        e[o] |= n << (8 * (3 - (r % 4)));
      }
      return { value: e, binLen: 4 * a + t };
    }
    function i(A, e, t) {
      var i,
        n,
        o,
        r,
        s = [];
      s = e || [0];
      for (n = (t = t || 0) >>> 3, i = 0; i < A.length; i += 1)
        (e = A.charCodeAt(i)),
          (o = (r = i + n) >>> 2),
          s.length <= o && s.push(0),
          (s[o] |= e << (8 * (3 - (r % 4))));
      return { value: s, binLen: 8 * A.length + t };
    }
    function n(A, e, t) {
      var i,
        n,
        o,
        r,
        s,
        a,
        g = [],
        c = 0;
      g = e || [0];
      if (((e = (t = t || 0) >>> 3), -1 === A.search(/^[a-zA-Z0-9=+\/]+$/)))
        throw Error("Invalid character in base-64 string");
      if (((n = A.indexOf("=")), (A = A.replace(/\=/g, "")), -1 !== n && n < A.length))
        throw Error("Invalid '=' found in base-64 string");
      for (n = 0; n < A.length; n += 4) {
        for (s = A.substr(n, 4), o = r = 0; o < s.length; o += 1)
          r |=
            (i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(
              s[o]
            )) <<
            (18 - 6 * o);
        for (o = 0; o < s.length - 1; o += 1) {
          for (i = (a = c + e) >>> 2; g.length <= i; ) g.push(0);
          (g[i] |= ((r >>> (16 - 8 * o)) & 255) << (8 * (3 - (a % 4)))), (c += 1);
        }
      }
      return { value: g, binLen: 8 * c + t };
    }
    function o(A, e) {
      var t,
        i,
        n = "",
        o = 4 * A.length;
      for (t = 0; t < o; t += 1)
        (i = A[t >>> 2] >>> (8 * (3 - (t % 4)))),
          (n += "0123456789abcdef".charAt((i >>> 4) & 15) + "0123456789abcdef".charAt(15 & i));
      return e.outputUpper ? n.toUpperCase() : n;
    }
    function r(A, e) {
      var t,
        i,
        n,
        o = "",
        r = 4 * A.length;
      for (t = 0; t < r; t += 3)
        for (
          n = (t + 1) >>> 2,
            i = A.length <= n ? 0 : A[n],
            n = (t + 2) >>> 2,
            n = A.length <= n ? 0 : A[n],
            n =
              (((A[t >>> 2] >>> (8 * (3 - (t % 4)))) & 255) << 16) |
              (((i >>> (8 * (3 - ((t + 1) % 4)))) & 255) << 8) |
              ((n >>> (8 * (3 - ((t + 2) % 4)))) & 255),
            i = 0;
          4 > i;
          i += 1
        )
          8 * t + 6 * i <= 32 * A.length
            ? (o += "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(
                (n >>> (6 * (3 - i))) & 63
              ))
            : (o += e.b64Pad);
      return o;
    }
    function s(A) {
      var e,
        t,
        i = "",
        n = 4 * A.length;
      for (e = 0; e < n; e += 1)
        (t = (A[e >>> 2] >>> (8 * (3 - (e % 4)))) & 255), (i += String.fromCharCode(t));
      return i;
    }
    function a(A) {
      var e = { outputUpper: !1, b64Pad: "=" };
      if (
        ((A = A || {}),
        (e.outputUpper = A.outputUpper || !1),
        (e.b64Pad = A.b64Pad || "="),
        "boolean" != typeof e.outputUpper)
      )
        throw Error("Invalid outputUpper formatting option");
      if ("string" != typeof e.b64Pad) throw Error("Invalid b64Pad formatting option");
      return e;
    }
    function g(A, e) {
      var o;
      switch (e) {
        case "UTF8":
        case "UTF16BE":
        case "UTF16LE":
          break;
        default:
          throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");
      }
      switch (A) {
        case "HEX":
          o = t;
          break;
        case "TEXT":
          o = function (A, t, i) {
            var n,
              o,
              r,
              s,
              a,
              g = [],
              c = [],
              I = 0;
            g = t || [0];
            if (((r = (t = i || 0) >>> 3), "UTF8" === e))
              for (n = 0; n < A.length; n += 1)
                for (
                  c = [],
                    128 > (i = A.charCodeAt(n))
                      ? c.push(i)
                      : 2048 > i
                        ? (c.push(192 | (i >>> 6)), c.push(128 | (63 & i)))
                        : 55296 > i || 57344 <= i
                          ? c.push(224 | (i >>> 12), 128 | ((i >>> 6) & 63), 128 | (63 & i))
                          : ((n += 1),
                            (i = 65536 + (((1023 & i) << 10) | (1023 & A.charCodeAt(n)))),
                            c.push(
                              240 | (i >>> 18),
                              128 | ((i >>> 12) & 63),
                              128 | ((i >>> 6) & 63),
                              128 | (63 & i)
                            )),
                    o = 0;
                  o < c.length;
                  o += 1
                ) {
                  for (s = (a = I + r) >>> 2; g.length <= s; ) g.push(0);
                  (g[s] |= c[o] << (8 * (3 - (a % 4)))), (I += 1);
                }
            else if ("UTF16BE" === e || "UTF16LE" === e)
              for (n = 0; n < A.length; n += 1) {
                for (
                  i = A.charCodeAt(n),
                    "UTF16LE" === e && (i = ((o = 255 & i) << 8) | (i >>> 8)),
                    s = (a = I + r) >>> 2;
                  g.length <= s;

                )
                  g.push(0);
                (g[s] |= i << (8 * (2 - (a % 4)))), (I += 2);
              }
            return { value: g, binLen: 8 * I + t };
          };
          break;
        case "B64":
          o = n;
          break;
        case "BYTES":
          o = i;
          break;
        default:
          throw Error("format must be HEX, TEXT, B64, or BYTES");
      }
      return o;
    }
    function c(A, e) {
      return (A << e) | (A >>> (32 - e));
    }
    function I(A, e) {
      var t = (65535 & A) + (65535 & e);
      return ((((A >>> 16) + (e >>> 16) + (t >>> 16)) & 65535) << 16) | (65535 & t);
    }
    function l(A, e, t, i, n) {
      var o = (65535 & A) + (65535 & e) + (65535 & t) + (65535 & i) + (65535 & n);
      return (
        ((((A >>> 16) + (e >>> 16) + (t >>> 16) + (i >>> 16) + (n >>> 16) + (o >>> 16)) & 65535) <<
          16) |
        (65535 & o)
      );
    }
    function d(A) {
      if ("SHA-1" !== A) throw Error("No SHA variants supported");
      return (A = [1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
    }
    function u(A, e) {
      var t,
        i,
        n,
        o,
        r,
        s,
        a,
        g = [];
      for (t = e[0], i = e[1], n = e[2], o = e[3], r = e[4], a = 0; 80 > a; a += 1)
        (g[a] = 16 > a ? A[a] : c(g[a - 3] ^ g[a - 8] ^ g[a - 14] ^ g[a - 16], 1)),
          (s =
            20 > a
              ? l(c(t, 5), (i & n) ^ (~i & o), r, 1518500249, g[a])
              : 40 > a
                ? l(c(t, 5), i ^ n ^ o, r, 1859775393, g[a])
                : 60 > a
                  ? l(c(t, 5), (i & n) ^ (i & o) ^ (n & o), r, 2400959708, g[a])
                  : l(c(t, 5), i ^ n ^ o, r, 3395469782, g[a])),
          (r = o),
          (o = n),
          (n = c(i, 30)),
          (i = t),
          (t = s);
      return (
        (e[0] = I(t, e[0])),
        (e[1] = I(i, e[1])),
        (e[2] = I(n, e[2])),
        (e[3] = I(o, e[3])),
        (e[4] = I(r, e[4])),
        e
      );
    }
    function C(A, e, t, i) {
      var n;
      for (n = 15 + (((e + 65) >>> 9) << 4); A.length <= n; ) A.push(0);
      for (A[e >>> 5] |= 128 << (24 - (e % 32)), A[n] = e + t, t = A.length, e = 0; e < t; e += 16)
        i = u(A.slice(e, e + 16), i);
      return i;
    }
    A.exports && (A.exports = e);
  })();
})(JC);
var jC,
  WC = JC.exports;
function VC(A) {
  var e, t;
  for (t = new Uint8Array(A.length), e = 0; e < A.length; e++) t[e] = A.charCodeAt(e);
  return t;
}
function _C(A) {
  return String.fromCharCode.apply(null, A);
}
function XC(A, e) {
  var t, i;
  for (i = "", t = 0; t < Math.min(A.length, e.length); t++)
    i += String.fromCharCode(A.charCodeAt(t) ^ e.charCodeAt(t));
  return i;
}
jC = {
  NONCE: function (A) {
    var e, t;
    if ((t = window.crypto || window.msCrypto) && t.getRandomValues)
      return (e = new Uint8Array(A)), t.getRandomValues(e), e;
    throw new Error(
      "Secure random number generation not supported by this browser use chrome, FireFox or Internet Explorer 11"
    );
  },
  XOR: function (A, e) {
    var t,
      i = [];
    for (t = 0; t < Math.min(A.length, e.length); t++) i.push(A[t] ^ e[t]);
    return new Uint8Array(i);
  },
  H: function (A) {
    var e;
    return (e = new WC("SHA-1", "BYTES")).update(_C(A)), VC(e.getHash("BYTES"));
  },
  HMAC: function (A, e) {
    var t;
    return (
      (t = new WC("SHA-1", "TEXT")).setHMACKey(_C(A), "BYTES"), t.update(e), VC(t.getHMAC("BYTES"))
    );
  },
  Hi: function (A, e, t) {
    var i, n, o, r, s, a, g, c;
    for (
      (r = new WC("SHA-1", "BYTES")).setHMACKey(A, "TEXT"),
        a = e,
        g = new Uint8Array([0, 0, 0, 1]),
        (c = new Uint8Array(a.byteLength + g.byteLength)).set(new Uint8Array(a), 0),
        c.set(new Uint8Array(g), a.byteLength),
        s = c,
        r.update(String.fromCharCode.apply(null, s)),
        i = n = r.getHMAC("BYTES"),
        o = 0;
      o < t - 1;
      o++
    )
      (r = new WC("SHA-1", "BYTES")).setHMACKey(A, "TEXT"),
        r.update(n),
        (i = XC(i, (n = r.getHMAC("BYTES"))));
    return VC(i);
  }
};
var zC = jC,
  ZC = {};
function $C(A) {
  var e, t, i, n;
  for (e = zC.NONCE((A || 32) / 2), t = "", i = 0; i < e.length; i++)
    t += (n = e[i]) < 16 ? "0" + n.toString(16) : n.toString(16);
  return t;
}
function AB(A) {
  var e, t, i;
  for (e = [], t = "", i = 0; i < A.length; i++)
    "," === (t = A[i]) ? e.push("=2C") : "=" === t ? e.push("=3D") : e.push(t);
  return e.join("");
}
function eB(A) {
  var e = A || {};
  (this.genNonce = e.genNonce || $C), (this.stage = "initial"), (this.completed = !1);
}
(eB.prototype.name = "SCRAM-SHA-1"),
  (eB.prototype.clientFirst = !0),
  (eB.prototype.response = function (A) {
    return ZC[this.stage](this, A);
  }),
  (eB.prototype.challenge = function (A) {
    var e;
    switch (
      ((e = (function (A) {
        var e, t, i, n, o;
        for (e = {}, n = 0, o = (t = A.split(/,(?=(?:[^"]|"[^"]*")*$)/)).length; n < o; n++)
          (i = /(\w+)=["]?([^"]+)["]?$/.exec(t[n])) && (e[i[1]] = i[2]);
        return e;
      })(A)),
      this.stage)
    ) {
      case "challenge":
        if (!e.r || !e.s || !e.i)
          return (
            (this.error =
              "An error occurred during the athentication exchange (invalid server-first-message)"),
            !1
          );
        if (
          ((this.salt = new Uint8Array(
            atob(e.s)
              .split("")
              .map(function (A) {
                return A.charCodeAt(0);
              })
          )),
          (this.iterationCount = parseInt(e.i || "0", 10)),
          (this.serverNonce = e.r),
          this.serverNonce.slice(0, this.clientNonce.length) !== this.clientNonce)
        )
          return (
            (this.error = "An error occurred during the athentication exchange (invalid nonce)"), !1
          );
        this.firstChallenge = A;
        break;
      case "final":
        if (!e.v && !e.e)
          return (
            (this.error =
              "An error occurred during the athentication exchange (invalid server-final-message)"),
            !1
          );
        if (e.e)
          return (
            (this.error = "An error occurred during the athentication exchange (" + e.e + ")"), !1
          );
        if (
          ((this.error = e.e),
          !(function (A, e) {
            var t;
            if (!A && !e) return !0;
            if (!A || !e) return !1;
            if (A.length !== e.length) return !1;
            for (t = 0; t < A.length; ++t) if (A[t] !== e[t]) return !1;
            return !0;
          })(
            new Uint8Array(
              atob(e.v)
                .split("")
                .map(function (A) {
                  return A.charCodeAt(0);
                })
            ),
            this.serverSignature
          ))
        )
          return (
            (this.error =
              "An error occurred during the athentication exchange (invalid server signature)"),
            !1
          );
        this.completed = !0;
        break;
      default:
        return !1;
    }
    return !0;
  }),
  (ZC.initial = function (A, e) {
    var t, i, n, o;
    if (!e.username) throw new Error("No username specified.");
    return (
      (A.clientNonce = A.genNonce()),
      (t = ""),
      e.authzid && (t = "a=" + AB(e.authzid)),
      (A.gs2Header = "n," + t + ","),
      (i = "r=" + A.clientNonce),
      (n = "n=" + AB(e.username)),
      (A.clientFirstMessageBare = n + "," + i),
      (o = A.gs2Header + A.clientFirstMessageBare),
      (A.stage = "challenge"),
      o
    );
  }),
  (ZC.challenge = function (A, e) {
    var t, i, n, o, r, s, a, g, c, I;
    return (
      (I = A.gs2Header),
      (t = window.btoa(unescape(encodeURIComponent(I)))),
      (A.clientFinalMessageWithoutProof = "c=" + t + ",r=" + A.serverNonce),
      (i = zC.Hi(e.password || "", A.salt, A.iterationCount)),
      (n = zC.HMAC(i, "Client Key")),
      (o = zC.HMAC(i, "Server Key")),
      (r = zC.H(n)),
      (s =
        A.clientFirstMessageBare + "," + A.firstChallenge + "," + A.clientFinalMessageWithoutProof),
      (a = zC.HMAC(r, s)),
      (g = zC.XOR(n, a)),
      (A.serverSignature = zC.HMAC(o, s)),
      (c = A.clientFinalMessageWithoutProof + ",p=" + btoa(String.fromCharCode.apply(null, g))),
      (A.stage = "final"),
      c
    );
  });
var tB = new YC();
tB.use(qC), tB.use(eB);
const iB = Fo.exports.Reader,
  nB = Fo.exports.Writer,
  oB = Fo.exports.util,
  rB = Fo.exports.roots["dcv.auth"] || (Fo.exports.roots["dcv.auth"] = {}),
  sB = (rB.dcv = (() => {
    const A = {};
    return (
      (A.auth = (function () {
        const A = {};
        return (
          (A.AuthenticationRequest = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return e || (e = nB.create()), e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.AuthenticationRequest();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A ? "object expected" : null;
              }),
              (A.fromObject = function (A) {
                return A instanceof rB.dcv.auth.AuthenticationRequest
                  ? A
                  : new rB.dcv.auth.AuthenticationRequest();
              }),
              (A.toObject = function () {
                return {};
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.AuthenticationRequest"
                );
              }),
              A
            );
          })()),
          (A.AuthenticationInit = (function () {
            function A(A) {
              if (((this.mechanisms = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.authenticationMode = ""),
              (A.prototype.mechanisms = oB.emptyArray),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = nB.create()),
                  null != A.authenticationMode &&
                    Object.hasOwnProperty.call(A, "authenticationMode") &&
                    e.uint32(10).string(A.authenticationMode),
                  null != A.mechanisms && A.mechanisms.length)
                )
                  for (let t = 0; t < A.mechanisms.length; ++t)
                    e.uint32(82).string(A.mechanisms[t]);
                return e;
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.AuthenticationInit();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.authenticationMode = A.string();
                      break;
                    case 10:
                      (i.mechanisms && i.mechanisms.length) || (i.mechanisms = []),
                        i.mechanisms.push(A.string());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (
                  null != A.authenticationMode &&
                  A.hasOwnProperty("authenticationMode") &&
                  !oB.isString(A.authenticationMode)
                )
                  return "authenticationMode: string expected";
                if (null != A.mechanisms && A.hasOwnProperty("mechanisms")) {
                  if (!Array.isArray(A.mechanisms)) return "mechanisms: array expected";
                  for (let e = 0; e < A.mechanisms.length; ++e)
                    if (!oB.isString(A.mechanisms[e])) return "mechanisms: string[] expected";
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.AuthenticationInit) return A;
                let e = new rB.dcv.auth.AuthenticationInit();
                if (
                  (null != A.authenticationMode &&
                    (e.authenticationMode = String(A.authenticationMode)),
                  A.mechanisms)
                ) {
                  if (!Array.isArray(A.mechanisms))
                    throw TypeError(".dcv.auth.AuthenticationInit.mechanisms: array expected");
                  e.mechanisms = [];
                  for (let t = 0; t < A.mechanisms.length; ++t)
                    e.mechanisms[t] = String(A.mechanisms[t]);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.mechanisms = []),
                  e.defaults && (t.authenticationMode = ""),
                  null != A.authenticationMode &&
                    A.hasOwnProperty("authenticationMode") &&
                    (t.authenticationMode = A.authenticationMode),
                  A.mechanisms && A.mechanisms.length)
                ) {
                  t.mechanisms = [];
                  for (let e = 0; e < A.mechanisms.length; ++e) t.mechanisms[e] = A.mechanisms[e];
                }
                return t;
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.AuthenticationInit"
                );
              }),
              A
            );
          })()),
          (A.SaslStart = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.mechanism = ""),
              (A.prototype.authData = oB.newBuffer([])),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = nB.create()),
                  null != A.mechanism &&
                    Object.hasOwnProperty.call(A, "mechanism") &&
                    e.uint32(10).string(A.mechanism),
                  null != A.authData &&
                    Object.hasOwnProperty.call(A, "authData") &&
                    e.uint32(82).bytes(A.authData),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.SaslStart();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.mechanism = A.string();
                      break;
                    case 10:
                      i.authData = A.bytes();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.mechanism &&
                      A.hasOwnProperty("mechanism") &&
                      !oB.isString(A.mechanism)
                    ? "mechanism: string expected"
                    : null != A.authData &&
                        A.hasOwnProperty("authData") &&
                        !(
                          (A.authData && "number" == typeof A.authData.length) ||
                          oB.isString(A.authData)
                        )
                      ? "authData: buffer expected"
                      : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.SaslStart) return A;
                let e = new rB.dcv.auth.SaslStart();
                return (
                  null != A.mechanism && (e.mechanism = String(A.mechanism)),
                  null != A.authData &&
                    ("string" == typeof A.authData
                      ? oB.base64.decode(
                          A.authData,
                          (e.authData = oB.newBuffer(oB.base64.length(A.authData))),
                          0
                        )
                      : A.authData.length >= 0 && (e.authData = A.authData)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    ((t.mechanism = ""),
                    e.bytes === String
                      ? (t.authData = "")
                      : ((t.authData = []),
                        e.bytes !== Array && (t.authData = oB.newBuffer(t.authData)))),
                  null != A.mechanism &&
                    A.hasOwnProperty("mechanism") &&
                    (t.mechanism = A.mechanism),
                  null != A.authData &&
                    A.hasOwnProperty("authData") &&
                    (t.authData =
                      e.bytes === String
                        ? oB.base64.encode(A.authData, 0, A.authData.length)
                        : e.bytes === Array
                          ? Array.prototype.slice.call(A.authData)
                          : A.authData),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.SaslStart";
              }),
              A
            );
          })()),
          (A.SaslChallenge = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.authData = oB.newBuffer([])),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = nB.create()),
                  null != A.authData &&
                    Object.hasOwnProperty.call(A, "authData") &&
                    e.uint32(10).bytes(A.authData),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.SaslChallenge();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.authData = A.bytes();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.authData &&
                      A.hasOwnProperty("authData") &&
                      !(
                        (A.authData && "number" == typeof A.authData.length) ||
                        oB.isString(A.authData)
                      )
                    ? "authData: buffer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.SaslChallenge) return A;
                let e = new rB.dcv.auth.SaslChallenge();
                return (
                  null != A.authData &&
                    ("string" == typeof A.authData
                      ? oB.base64.decode(
                          A.authData,
                          (e.authData = oB.newBuffer(oB.base64.length(A.authData))),
                          0
                        )
                      : A.authData.length >= 0 && (e.authData = A.authData)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    (e.bytes === String
                      ? (t.authData = "")
                      : ((t.authData = []),
                        e.bytes !== Array && (t.authData = oB.newBuffer(t.authData)))),
                  null != A.authData &&
                    A.hasOwnProperty("authData") &&
                    (t.authData =
                      e.bytes === String
                        ? oB.base64.encode(A.authData, 0, A.authData.length)
                        : e.bytes === Array
                          ? Array.prototype.slice.call(A.authData)
                          : A.authData),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.SaslChallenge";
              }),
              A
            );
          })()),
          (A.SaslStep = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.authData = oB.newBuffer([])),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = nB.create()),
                  null != A.authData &&
                    Object.hasOwnProperty.call(A, "authData") &&
                    e.uint32(10).bytes(A.authData),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.SaslStep();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  if (e >>> 3 == 1) i.authData = A.bytes();
                  else A.skipType(7 & e);
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                return "object" != typeof A || null === A
                  ? "object expected"
                  : null != A.authData &&
                      A.hasOwnProperty("authData") &&
                      !(
                        (A.authData && "number" == typeof A.authData.length) ||
                        oB.isString(A.authData)
                      )
                    ? "authData: buffer expected"
                    : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.SaslStep) return A;
                let e = new rB.dcv.auth.SaslStep();
                return (
                  null != A.authData &&
                    ("string" == typeof A.authData
                      ? oB.base64.decode(
                          A.authData,
                          (e.authData = oB.newBuffer(oB.base64.length(A.authData))),
                          0
                        )
                      : A.authData.length >= 0 && (e.authData = A.authData)),
                  e
                );
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  e.defaults &&
                    (e.bytes === String
                      ? (t.authData = "")
                      : ((t.authData = []),
                        e.bytes !== Array && (t.authData = oB.newBuffer(t.authData)))),
                  null != A.authData &&
                    A.hasOwnProperty("authData") &&
                    (t.authData =
                      e.bytes === String
                        ? oB.base64.encode(A.authData, 0, A.authData.length)
                        : e.bytes === Array
                          ? Array.prototype.slice.call(A.authData)
                          : A.authData),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.SaslStep";
              }),
              A
            );
          })()),
          (A.AuthenticationResult = (function () {
            function A(A) {
              if (((this.sessionTargets = []), A))
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            return (
              (A.prototype.resultValue = 0),
              (A.prototype.sessionTargets = oB.emptyArray),
              (A.prototype.retriesLeft = 0),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                if (
                  (e || (e = nB.create()),
                  null != A.resultValue &&
                    Object.hasOwnProperty.call(A, "resultValue") &&
                    e.uint32(8).int32(A.resultValue),
                  null != A.sessionTargets && A.sessionTargets.length)
                )
                  for (let t = 0; t < A.sessionTargets.length; ++t)
                    rB.dcv.auth.AuthenticationResult.SessionTarget.encode(
                      A.sessionTargets[t],
                      e.uint32(82).fork()
                    ).ldelim();
                return (
                  null != A.retriesLeft &&
                    Object.hasOwnProperty.call(A, "retriesLeft") &&
                    e.uint32(160).uint32(A.retriesLeft),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.AuthenticationResult();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 1:
                      i.resultValue = A.int32();
                      break;
                    case 10:
                      (i.sessionTargets && i.sessionTargets.length) || (i.sessionTargets = []),
                        i.sessionTargets.push(
                          rB.dcv.auth.AuthenticationResult.SessionTarget.decode(A, A.uint32())
                        );
                      break;
                    case 20:
                      i.retriesLeft = A.uint32();
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                if (null != A.resultValue && A.hasOwnProperty("resultValue"))
                  switch (A.resultValue) {
                    default:
                      return "resultValue: enum value expected";
                    case 0:
                    case 1:
                    case 2:
                  }
                if (null != A.sessionTargets && A.hasOwnProperty("sessionTargets")) {
                  if (!Array.isArray(A.sessionTargets)) return "sessionTargets: array expected";
                  for (let e = 0; e < A.sessionTargets.length; ++e) {
                    let t = rB.dcv.auth.AuthenticationResult.SessionTarget.verify(
                      A.sessionTargets[e]
                    );
                    if (t) return "sessionTargets." + t;
                  }
                }
                return null != A.retriesLeft &&
                  A.hasOwnProperty("retriesLeft") &&
                  !oB.isInteger(A.retriesLeft)
                  ? "retriesLeft: integer expected"
                  : null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.AuthenticationResult) return A;
                let e = new rB.dcv.auth.AuthenticationResult();
                switch (A.resultValue) {
                  default:
                    if ("number" == typeof A.resultValue) {
                      e.resultValue = A.resultValue;
                      break;
                    }
                    break;
                  case "FAIL":
                  case 0:
                    e.resultValue = 0;
                    break;
                  case "OK":
                  case 1:
                    e.resultValue = 1;
                    break;
                  case "REJECT":
                  case 2:
                    e.resultValue = 2;
                }
                if (A.sessionTargets) {
                  if (!Array.isArray(A.sessionTargets))
                    throw TypeError(
                      ".dcv.auth.AuthenticationResult.sessionTargets: array expected"
                    );
                  e.sessionTargets = [];
                  for (let t = 0; t < A.sessionTargets.length; ++t) {
                    if ("object" != typeof A.sessionTargets[t])
                      throw TypeError(
                        ".dcv.auth.AuthenticationResult.sessionTargets: object expected"
                      );
                    e.sessionTargets[t] = rB.dcv.auth.AuthenticationResult.SessionTarget.fromObject(
                      A.sessionTargets[t]
                    );
                  }
                }
                return null != A.retriesLeft && (e.retriesLeft = A.retriesLeft >>> 0), e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                if (
                  ((e.arrays || e.defaults) && (t.sessionTargets = []),
                  e.defaults &&
                    ((t.resultValue = e.enums === String ? "FAIL" : 0), (t.retriesLeft = 0)),
                  null != A.resultValue &&
                    A.hasOwnProperty("resultValue") &&
                    (t.resultValue =
                      e.enums === String
                        ? void 0 === rB.dcv.auth.AuthenticationResult.Result[A.resultValue]
                          ? A.resultValue
                          : rB.dcv.auth.AuthenticationResult.Result[A.resultValue]
                        : A.resultValue),
                  A.sessionTargets && A.sessionTargets.length)
                ) {
                  t.sessionTargets = [];
                  for (let i = 0; i < A.sessionTargets.length; ++i)
                    t.sessionTargets[i] = rB.dcv.auth.AuthenticationResult.SessionTarget.toObject(
                      A.sessionTargets[i],
                      e
                    );
                }
                return (
                  null != A.retriesLeft &&
                    A.hasOwnProperty("retriesLeft") &&
                    (t.retriesLeft = A.retriesLeft),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return (
                  void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.AuthenticationResult"
                );
              }),
              (A.Result = (function () {
                const A = {},
                  e = Object.create(A);
                return (
                  (e[(A[0] = "FAIL")] = 0), (e[(A[1] = "OK")] = 1), (e[(A[2] = "REJECT")] = 2), e
                );
              })()),
              (A.SessionTarget = (function () {
                function A(A) {
                  if (A)
                    for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                      null != A[e[t]] && (this[e[t]] = A[e[t]]);
                }
                return (
                  (A.prototype.sessionId = ""),
                  (A.prototype.authenticationToken = ""),
                  (A.create = function (e) {
                    return new A(e);
                  }),
                  (A.encode = function (A, e) {
                    return (
                      e || (e = nB.create()),
                      null != A.sessionId &&
                        Object.hasOwnProperty.call(A, "sessionId") &&
                        e.uint32(10).string(A.sessionId),
                      null != A.authenticationToken &&
                        Object.hasOwnProperty.call(A, "authenticationToken") &&
                        e.uint32(82).string(A.authenticationToken),
                      e
                    );
                  }),
                  (A.encodeDelimited = function (A, e) {
                    return this.encode(A, e).ldelim();
                  }),
                  (A.decode = function (A, e) {
                    A instanceof iB || (A = iB.create(A));
                    let t = void 0 === e ? A.len : A.pos + e,
                      i = new rB.dcv.auth.AuthenticationResult.SessionTarget();
                    for (; A.pos < t; ) {
                      let e = A.uint32();
                      switch (e >>> 3) {
                        case 1:
                          i.sessionId = A.string();
                          break;
                        case 10:
                          i.authenticationToken = A.string();
                          break;
                        default:
                          A.skipType(7 & e);
                      }
                    }
                    return i;
                  }),
                  (A.decodeDelimited = function (A) {
                    return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
                  }),
                  (A.verify = function (A) {
                    return "object" != typeof A || null === A
                      ? "object expected"
                      : null != A.sessionId &&
                          A.hasOwnProperty("sessionId") &&
                          !oB.isString(A.sessionId)
                        ? "sessionId: string expected"
                        : null != A.authenticationToken &&
                            A.hasOwnProperty("authenticationToken") &&
                            !oB.isString(A.authenticationToken)
                          ? "authenticationToken: string expected"
                          : null;
                  }),
                  (A.fromObject = function (A) {
                    if (A instanceof rB.dcv.auth.AuthenticationResult.SessionTarget) return A;
                    let e = new rB.dcv.auth.AuthenticationResult.SessionTarget();
                    return (
                      null != A.sessionId && (e.sessionId = String(A.sessionId)),
                      null != A.authenticationToken &&
                        (e.authenticationToken = String(A.authenticationToken)),
                      e
                    );
                  }),
                  (A.toObject = function (A, e) {
                    e || (e = {});
                    let t = {};
                    return (
                      e.defaults && ((t.sessionId = ""), (t.authenticationToken = "")),
                      null != A.sessionId &&
                        A.hasOwnProperty("sessionId") &&
                        (t.sessionId = A.sessionId),
                      null != A.authenticationToken &&
                        A.hasOwnProperty("authenticationToken") &&
                        (t.authenticationToken = A.authenticationToken),
                      t
                    );
                  }),
                  (A.prototype.toJSON = function () {
                    return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
                  }),
                  (A.getTypeUrl = function (A) {
                    return (
                      void 0 === A && (A = "type.googleapis.com"),
                      A + "/dcv.auth.AuthenticationResult.SessionTarget"
                    );
                  }),
                  A
                );
              })()),
              A
            );
          })()),
          (A.ClientMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.authenticationRequest = null),
              (A.prototype.saslStart = null),
              (A.prototype.saslStep = null),
              Object.defineProperty(A.prototype, "msg", {
                get: oB.oneOfGetter((e = ["authenticationRequest", "saslStart", "saslStep"])),
                set: oB.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = nB.create()),
                  null != A.authenticationRequest &&
                    Object.hasOwnProperty.call(A, "authenticationRequest") &&
                    rB.dcv.auth.AuthenticationRequest.encode(
                      A.authenticationRequest,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.saslStart &&
                    Object.hasOwnProperty.call(A, "saslStart") &&
                    rB.dcv.auth.SaslStart.encode(A.saslStart, e.uint32(162).fork()).ldelim(),
                  null != A.saslStep &&
                    Object.hasOwnProperty.call(A, "saslStep") &&
                    rB.dcv.auth.SaslStep.encode(A.saslStep, e.uint32(242).fork()).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.ClientMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.authenticationRequest = rB.dcv.auth.AuthenticationRequest.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    case 20:
                      i.saslStart = rB.dcv.auth.SaslStart.decode(A, A.uint32());
                      break;
                    case 30:
                      i.saslStep = rB.dcv.auth.SaslStep.decode(A, A.uint32());
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.authenticationRequest && A.hasOwnProperty("authenticationRequest")) {
                  e.msg = 1;
                  {
                    let e = rB.dcv.auth.AuthenticationRequest.verify(A.authenticationRequest);
                    if (e) return "authenticationRequest." + e;
                  }
                }
                if (null != A.saslStart && A.hasOwnProperty("saslStart")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = rB.dcv.auth.SaslStart.verify(A.saslStart);
                    if (e) return "saslStart." + e;
                  }
                }
                if (null != A.saslStep && A.hasOwnProperty("saslStep")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = rB.dcv.auth.SaslStep.verify(A.saslStep);
                    if (e) return "saslStep." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.ClientMessage) return A;
                let e = new rB.dcv.auth.ClientMessage();
                if (null != A.authenticationRequest) {
                  if ("object" != typeof A.authenticationRequest)
                    throw TypeError(
                      ".dcv.auth.ClientMessage.authenticationRequest: object expected"
                    );
                  e.authenticationRequest = rB.dcv.auth.AuthenticationRequest.fromObject(
                    A.authenticationRequest
                  );
                }
                if (null != A.saslStart) {
                  if ("object" != typeof A.saslStart)
                    throw TypeError(".dcv.auth.ClientMessage.saslStart: object expected");
                  e.saslStart = rB.dcv.auth.SaslStart.fromObject(A.saslStart);
                }
                if (null != A.saslStep) {
                  if ("object" != typeof A.saslStep)
                    throw TypeError(".dcv.auth.ClientMessage.saslStep: object expected");
                  e.saslStep = rB.dcv.auth.SaslStep.fromObject(A.saslStep);
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.authenticationRequest &&
                    A.hasOwnProperty("authenticationRequest") &&
                    ((t.authenticationRequest = rB.dcv.auth.AuthenticationRequest.toObject(
                      A.authenticationRequest,
                      e
                    )),
                    e.oneofs && (t.msg = "authenticationRequest")),
                  null != A.saslStart &&
                    A.hasOwnProperty("saslStart") &&
                    ((t.saslStart = rB.dcv.auth.SaslStart.toObject(A.saslStart, e)),
                    e.oneofs && (t.msg = "saslStart")),
                  null != A.saslStep &&
                    A.hasOwnProperty("saslStep") &&
                    ((t.saslStep = rB.dcv.auth.SaslStep.toObject(A.saslStep, e)),
                    e.oneofs && (t.msg = "saslStep")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.ClientMessage";
              }),
              A
            );
          })()),
          (A.ServerMessage = (function () {
            function A(A) {
              if (A)
                for (let e = Object.keys(A), t = 0; t < e.length; ++t)
                  null != A[e[t]] && (this[e[t]] = A[e[t]]);
            }
            let e;
            return (
              (A.prototype.authenticationInit = null),
              (A.prototype.saslChallenge = null),
              (A.prototype.authenticationResult = null),
              Object.defineProperty(A.prototype, "msg", {
                get: oB.oneOfGetter(
                  (e = ["authenticationInit", "saslChallenge", "authenticationResult"])
                ),
                set: oB.oneOfSetter(e)
              }),
              (A.create = function (e) {
                return new A(e);
              }),
              (A.encode = function (A, e) {
                return (
                  e || (e = nB.create()),
                  null != A.authenticationInit &&
                    Object.hasOwnProperty.call(A, "authenticationInit") &&
                    rB.dcv.auth.AuthenticationInit.encode(
                      A.authenticationInit,
                      e.uint32(82).fork()
                    ).ldelim(),
                  null != A.saslChallenge &&
                    Object.hasOwnProperty.call(A, "saslChallenge") &&
                    rB.dcv.auth.SaslChallenge.encode(
                      A.saslChallenge,
                      e.uint32(162).fork()
                    ).ldelim(),
                  null != A.authenticationResult &&
                    Object.hasOwnProperty.call(A, "authenticationResult") &&
                    rB.dcv.auth.AuthenticationResult.encode(
                      A.authenticationResult,
                      e.uint32(242).fork()
                    ).ldelim(),
                  e
                );
              }),
              (A.encodeDelimited = function (A, e) {
                return this.encode(A, e).ldelim();
              }),
              (A.decode = function (A, e) {
                A instanceof iB || (A = iB.create(A));
                let t = void 0 === e ? A.len : A.pos + e,
                  i = new rB.dcv.auth.ServerMessage();
                for (; A.pos < t; ) {
                  let e = A.uint32();
                  switch (e >>> 3) {
                    case 10:
                      i.authenticationInit = rB.dcv.auth.AuthenticationInit.decode(A, A.uint32());
                      break;
                    case 20:
                      i.saslChallenge = rB.dcv.auth.SaslChallenge.decode(A, A.uint32());
                      break;
                    case 30:
                      i.authenticationResult = rB.dcv.auth.AuthenticationResult.decode(
                        A,
                        A.uint32()
                      );
                      break;
                    default:
                      A.skipType(7 & e);
                  }
                }
                return i;
              }),
              (A.decodeDelimited = function (A) {
                return A instanceof iB || (A = new iB(A)), this.decode(A, A.uint32());
              }),
              (A.verify = function (A) {
                if ("object" != typeof A || null === A) return "object expected";
                let e = {};
                if (null != A.authenticationInit && A.hasOwnProperty("authenticationInit")) {
                  e.msg = 1;
                  {
                    let e = rB.dcv.auth.AuthenticationInit.verify(A.authenticationInit);
                    if (e) return "authenticationInit." + e;
                  }
                }
                if (null != A.saslChallenge && A.hasOwnProperty("saslChallenge")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = rB.dcv.auth.SaslChallenge.verify(A.saslChallenge);
                    if (e) return "saslChallenge." + e;
                  }
                }
                if (null != A.authenticationResult && A.hasOwnProperty("authenticationResult")) {
                  if (1 === e.msg) return "msg: multiple values";
                  e.msg = 1;
                  {
                    let e = rB.dcv.auth.AuthenticationResult.verify(A.authenticationResult);
                    if (e) return "authenticationResult." + e;
                  }
                }
                return null;
              }),
              (A.fromObject = function (A) {
                if (A instanceof rB.dcv.auth.ServerMessage) return A;
                let e = new rB.dcv.auth.ServerMessage();
                if (null != A.authenticationInit) {
                  if ("object" != typeof A.authenticationInit)
                    throw TypeError(".dcv.auth.ServerMessage.authenticationInit: object expected");
                  e.authenticationInit = rB.dcv.auth.AuthenticationInit.fromObject(
                    A.authenticationInit
                  );
                }
                if (null != A.saslChallenge) {
                  if ("object" != typeof A.saslChallenge)
                    throw TypeError(".dcv.auth.ServerMessage.saslChallenge: object expected");
                  e.saslChallenge = rB.dcv.auth.SaslChallenge.fromObject(A.saslChallenge);
                }
                if (null != A.authenticationResult) {
                  if ("object" != typeof A.authenticationResult)
                    throw TypeError(
                      ".dcv.auth.ServerMessage.authenticationResult: object expected"
                    );
                  e.authenticationResult = rB.dcv.auth.AuthenticationResult.fromObject(
                    A.authenticationResult
                  );
                }
                return e;
              }),
              (A.toObject = function (A, e) {
                e || (e = {});
                let t = {};
                return (
                  null != A.authenticationInit &&
                    A.hasOwnProperty("authenticationInit") &&
                    ((t.authenticationInit = rB.dcv.auth.AuthenticationInit.toObject(
                      A.authenticationInit,
                      e
                    )),
                    e.oneofs && (t.msg = "authenticationInit")),
                  null != A.saslChallenge &&
                    A.hasOwnProperty("saslChallenge") &&
                    ((t.saslChallenge = rB.dcv.auth.SaslChallenge.toObject(A.saslChallenge, e)),
                    e.oneofs && (t.msg = "saslChallenge")),
                  null != A.authenticationResult &&
                    A.hasOwnProperty("authenticationResult") &&
                    ((t.authenticationResult = rB.dcv.auth.AuthenticationResult.toObject(
                      A.authenticationResult,
                      e
                    )),
                    e.oneofs && (t.msg = "authenticationResult")),
                  t
                );
              }),
              (A.prototype.toJSON = function () {
                return this.constructor.toObject(this, Fo.exports.util.toJSONOptions);
              }),
              (A.getTypeUrl = function (A) {
                return void 0 === A && (A = "type.googleapis.com"), A + "/dcv.auth.ServerMessage";
              }),
              A
            );
          })()),
          A
        );
      })()),
      A
    );
  })()),
  aB = "dcv",
  gB = "system",
  cB = "otp",
  IB = "none",
  lB = "certificate",
  dB = [aB, gB, cB, IB, lB];
function uB(A, e) {
  (this.log = Q("authentication")),
    (this.callbacks = e),
    (this.url = A),
    (this.successfulAuthentication = !1),
    (this.permanentError = !1),
    (this.wsReopenedAfterInactivity = !1),
    EB.call(this);
}
function CB() {
  this.log.info("Auth WebSocket connection opened"), yB.call(this, { authenticationRequest: {} });
}
function BB(A) {
  this.log.info(
    `Auth WebSocket connection closed. Code ${A.code}${A.reason ? `. Reason: ${A.reason}` : ""}`
  ),
    !this.permanentError && !this.successfulAuthentication && A.code >= 1e3 && A.code <= 1005
      ? (EB.call(this), (this.wsReopenedAfterInactivity = !0))
      : (this.wsReopenedAfterInactivity = !1);
}
function QB() {
  pB.call(
    this,
    { code: Io.Authentication.GENERIC_ERROR, message: "Failed to communicate with server." },
    !0
  );
}
function EB() {
  let A = new URL(no(this.url, "/auth"));
  if (Xn(this.callbacks.httpExtraSearchParams)) {
    let e = this.callbacks.httpExtraSearchParams("GET", A, null);
    e instanceof URLSearchParams
      ? e.forEach((e, t) => {
          A.searchParams.set(t, e);
        })
      : this.log.warn("httpExtraSearchParams callback returned invalid type " + typeof e);
  }
  (this.websocket = new WebSocket(A, "dcv")),
    (this.websocket.binaryType = "arraybuffer"),
    (this.websocket.onopen = CB.bind(this)),
    (this.websocket.onclose = BB.bind(this)),
    (this.websocket.onmessage = DB.bind(this)),
    (this.websocket.onerror = QB.bind(this));
}
function hB(A) {
  if (!zn(A))
    return (
      pB.call(
        this,
        {
          code: Io.Authentication.WRONG_CREDENTIALS_FORMAT,
          message: "The provided credentials are not in the correct format."
        },
        !0
      ),
      !1
    );
  if (!this.requiredCredentials)
    return (
      pB.call(
        this,
        {
          code: Io.Authentication.UNREQUESTED_CREDENTIALS,
          message: "sendCredentials was called but no credentials have been requested."
        },
        !0
      ),
      !1
    );
  for (const e of this.requiredCredentials) {
    if (!(e.name in A))
      return (
        pB.call(
          this,
          {
            code: Io.Authentication.MISSING_CREDENTIAL,
            message: `The credential ${e.name} was not provided.`
          },
          !0
        ),
        !1
      );
    if (typeof A[e.name] !== e.type)
      return (
        pB.call(
          this,
          {
            code: Io.Authentication.WRONG_CREDENTIALS_TYPE,
            message: `The credential ${e.name}has type ${typeof A[e.name]} while type ${e.type} was requested.`
          },
          !0
        ),
        !1
      );
  }
  for (const e in A)
    if (-1 === this.requiredCredentials.map((A) => A.name).indexOf(e))
      return (
        pB.call(
          this,
          {
            code: Io.Authentication.UNREQUESTED_CREDENTIALS,
            message: `The credential ${e} was not requested.`
          },
          !0
        ),
        !1
      );
  return !0;
}
function pB(A, e) {
  this.callbacks.error(this, A), e && ((this.permanentError = !0), this.websocket.close());
}
function fB(A) {
  (this.requiredCredentials = A),
    this.callbacks.promptCredentials(this, { requiredCredentials: A });
}
function mB(A) {
  (this.requiredCredentials = null),
    (this.successfulAuthentication = !0),
    this.callbacks.success(this, A),
    this.websocket.close();
}
function yB(A) {
  const e = new sB.auth.ClientMessage(A),
    t = sB.auth.ClientMessage.encode(e).finish(),
    i = t.byteLength,
    n = new Uint8Array(8 + ((i + 7) & -8)),
    o = new DataView(n.buffer);
  o.setUint32(0, i, !0), o.setUint32(4, 0, !0), n.set(new Uint8Array(t), 8);
  try {
    this.websocket.send(n.buffer);
  } catch (A) {
    this.log.warn(`Auth Websocket failed to send: ${A.message}`);
  }
}
function DB(A) {
  let e,
    t = new DataView(A.data),
    i = t.getUint32(0, !0),
    n = t.getUint32(4, !0);
  if (0 === n)
    switch (((e = sB.auth.ServerMessage.decode(new Uint8Array(A.data.slice(8, 8 + i)))), e.msg)) {
      case "authenticationInit":
        wB.call(this, e.authenticationInit);
        break;
      case "authenticationResult":
        FB.call(this, e.authenticationResult);
        break;
      case "saslChallenge":
        bB.call(this, e.saslChallenge);
        break;
      default:
        pB.call(
          this,
          {
            code: Io.Authentication.INVALID_MESSAGE,
            message: `Unexpected Auth Websocket message:${e.msg}`
          },
          !0
        );
    }
  else
    pB.call(
      this,
      {
        code: Io.Authentication.INVALID_MESSAGE,
        message: `Invalid Auth Websocket message (bin size: ${n})`
      },
      !0
    );
}
function wB(A) {
  -1 === dB.indexOf(A.authenticationMode)
    ? pB.call(
        this,
        {
          code: Io.Authentication.UNKNOWN_AUTH_MODE,
          message: `Authentication failed. Unknown authentication mode ${A.mode}`
        },
        !0
      )
    : ((this.authenticationMode = A.authenticationMode),
      (this.serverMechanisms = A.mechanisms),
      SB.call(this));
}
function FB(A) {
  A.resultValue === sB.auth.AuthenticationResult.Result.REJECT
    ? pB.call(
        this,
        {
          code: Io.Authentication.AUTHENTICATION_REJECTED,
          message:
            "Your account is temporarily locked due to too many failed login attempts. Please retry in a few minutes."
        },
        !0
      )
    : A.resultValue === sB.auth.AuthenticationResult.Result.OK
      ? A.sessionTargets.length > 0
        ? mB.call(
            this,
            A.sessionTargets.map((A) => ({
              sessionId: A.sessionId,
              authToken: A.authenticationToken
            }))
          )
        : pB.call(
            this,
            {
              code: Io.Authentication.NO_SESSIONS,
              message:
                "No session is available or you are not authorised to join the session. Please contact the owner of the session or the host administrator."
            },
            !0
          )
      : A.retriesLeft > 0
        ? pB.call(
            this,
            { code: Io.Authentication.WRONG_CREDENTIALS, message: "Wrong username or password." },
            !1
          )
        : pB.call(
            this,
            { code: Io.Authentication.FAILED_COMMUNICATION, message: "Authentication failed." },
            !0
          );
}
function bB(A) {
  if (this.mechanism.completed)
    pB.call(
      this,
      { code: Io.Authentication.SASL_CHALLENGE, message: "Unexpected SASL protocol state." },
      !0
    );
  else if (A.authData.length > 0) {
    const e = String.fromCharCode.apply(null, A.authData);
    if ((this.log.debug(`SASL challenge: ${e}`), !this.mechanism.challenge(e)))
      return void pB.call(
        this,
        {
          code: Io.Authentication.SASL_CHALLENGE,
          message: `Authentication failed. Error: ${this.mechanism.error}`
        },
        !0
      );
    this.authenticationMode === aB && fB.call(this, [{ name: "password", type: "string" }]);
  } else {
    if (this.wsReopenedAfterInactivity)
      return void this.log.debug(
        "Not prompting credentials challenge after ws is reopened due to inactivity."
      );
    switch (this.authenticationMode) {
      case aB:
        fB.call(this, [{ name: "username", type: "string" }]);
        break;
      case gB:
        fB.call(this, [
          { name: "username", type: "string" },
          { name: "password", type: "string" }
        ]);
        break;
      case cB:
        fB.call(this, [{ name: "password", type: "string" }]);
        break;
      case IB:
      case lB:
        RB.call(this, { username: "dcvuser", password: "" });
    }
  }
}
function UB(A) {
  let e,
    t = new HC();
  try {
    e = this.mechanism.response(A);
  } catch (A) {
    return pB.call(this, { code: Io.Authentication.SASL_CHALLENGE, message: A.message }, !0), null;
  }
  return t.writeUTF8String(e), t.flip(), new Uint8Array(t.toBuffer(!0));
}
function SB() {
  (this.mechanism = tB.create(this.serverMechanisms)),
    this.mechanism
      ? (this.log.debug(`Using SASL mechanism: ${this.mechanism.name}`),
        this.mechanism.clientFirst
          ? yB.call(this, { saslStart: { mechanism: this.mechanism.name } })
          : pB.call(
              this,
              {
                code: Io.Authentication.SASL_AUTH_MECHANISM,
                message: `Unable to set data for SASL mechanism ${this.mechanism.name}`
              },
              !0
            ))
      : pB.call(
          this,
          {
            code: Io.Authentication.SASL_AUTH_MECHANISM,
            message: `Impossible to find a suitable SASL authentication mechanism in: ${this.serverMechanisms}`
          },
          !0
        );
}
function RB(A) {
  yB.call(this, { saslStep: { authData: UB.call(this, A) } });
}
let vB;
function xB() {
  const A = window.navigator?.connection;
  if (A) {
    let e = "(Experimental) Connection stats:\n\nname          value\n------------- -------\n";
    for (const t in A) Xn(A[t]) || null === A[t] || (e += `${t.padEnd(13)} ${A[t]}\n`);
    vB.info(e);
  } else vB.info("(Experimental) Browser do not support Network Information API.");
}
(uB.prototype.sendCredentials = function (A) {
  hB.call(this, A) && RB.call(this, A);
}),
  (uB.prototype.retry = function () {
    SB.call(this);
  });
const MB = 3;
let OB;
!(function () {
  if (!String.prototype.codePointAt) {
    let A = function (A) {
      if (null == this) throw TypeError();
      let e = String(this),
        t = e.length,
        i = A ? Number(A) : 0;
      if ((i != i && (i = 0), i < 0 || i >= t)) return;
      let n,
        o = e.charCodeAt(i);
      return o >= 55296 &&
        o <= 56319 &&
        t > i + 1 &&
        ((n = e.charCodeAt(i + 1)), n >= 56320 && n <= 57343)
        ? 1024 * (o - 55296) + n - 56320 + 65536
        : o;
    };
    Object.defineProperty
      ? Object.defineProperty(String.prototype, "codePointAt", {
          value: A,
          configurable: !0,
          writable: !0
        })
      : (String.prototype.codePointAt = A);
  }
})(),
  E.exports.polyfill(),
  (Number.isInteger =
    Number.isInteger ||
    function (A) {
      return "number" == typeof A && isFinite(A) && Math.floor(A) === A;
    }),
  (function () {
    const A = JSON.parse(Yd?.getItem("dcv-settings") || null);
    var e;
    A &&
      ((e = ["webcamResolutionsDetected"]),
      null !== A &&
        e.forEach((e) => {
          e in A && (qd[e] = A[e]);
        }));
  })();
const kB = {
    major: h.major,
    minor: h.minor,
    patch: h.patch,
    revision: h.revision,
    extended: h.extended,
    versionStr: h.version
  },
  NB = s;
const KB = Io.Connection,
  LB = Io.Channel,
  TB = Io.CustomChannel,
  PB = Io.Resolution,
  GB = Io.DisplayConfig,
  HB = Io.FileStorage,
  YB = Io.ClosingReason,
  qB = Io.MultiMonitor,
  JB = Io.Audio,
  jB = Io.Screenshot,
  WB = Io.Webcam,
  VB = Io.Authentication,
  _B = Ca,
  XB = Ba,
  zB = Io.TimezoneRedirection;
var ZB = Object.freeze({
  __proto__: null,
  version: kB,
  LogLevel: NB,
  browser: yr,
  setLogLevel: function (A) {
    u(A);
  },
  setLogHandler: function (A) {
    !(function (A) {
      const e = r.methodFactory;
      var t;
      (t = (t, i, n) => {
        const o = e(t, i, n);
        return function (e) {
          try {
            A({ level: s[t.toUpperCase()], levelName: t.toUpperCase(), domain: n, message: e });
          } catch (A) {
            o(`Error calling log handler: ${A.message}`);
          }
        };
      }),
        (r.methodFactory = t);
    })(A);
  },
  ConnectionError: KB,
  ChannelError: LB,
  CustomChannelError: TB,
  ResolutionError: PB,
  DisplayConfigError: GB,
  FileStorageError: HB,
  ClosingReasonError: YB,
  MultiMonitorError: qB,
  AudioError: JB,
  ScreenshotError: jB,
  WebcamError: WB,
  AuthenticationError: VB,
  TimezoneRedirectionSetting: _B,
  TimezoneRedirectionStatus: XB,
  TimezoneRedirectionError: zB,
  authenticate: function (A, e) {
    if ("string" != typeof A) throw new TypeError("Authentication url should be a string.");
    if (Object.values(e).some((A) => !Xn(A)))
      throw new TypeError(
        "Every callback for the authentication process should be a valid function."
      );
    if (go(e, "error") && go(e, "success") && go(e, "promptCredentials")) return new uB(A, e);
    throw new Error("One or more authentication callback is missing.");
  },
  connect: function (A) {
    return new Promise((e, t) => {
      if (
        ((OB = Q("client")),
        (Bs = Bs || Q("media")),
        OB.info(`Start DCV connection using SDK version ${h.version}`),
        OB.info(`userAgent is ${navigator.userAgent}`),
        fr() && OB.info("Client is an Amazon WorkSpaces Thin Client"),
        (vB = Q("network")),
        window.addEventListener("offline", (A) => {
          vB.info("(Experimental) Browser is offline.");
        }),
        window.addEventListener("online", (A) => {
          vB.info("(Experimental) Browser should be online.");
        }),
        navigator.connection && navigator.connection.addEventListener("change", (A) => xB()),
        xB(),
        (function (A) {
          for (const e of ["url", "sessionId", "authToken"])
            if (!go(A, e))
              return OB.error(`Connection configuration property ${e} is undefined`), !1;
          if (
            (go(A, "enableWebCodecs") ||
              (OB.info(
                "Connection configuration property enableWebCodecs is undefined. Defaulting to false."
              ),
              (A.enableWebCodecs = !1)),
            go(A, "highColorAccuracy") ||
              (OB.info(
                "Connection configuration property highColorAccuracy is undefined. Defaulting to false."
              ),
              (A.highColorAccuracy = !1)),
            Object.prototype.hasOwnProperty.call(A, "showDebugLayer")
              ? (!0 === A.showDebugLayer
                  ? (OB.info(
                      `Connection configuration property showDebugLayer is true. Defaulting to ${MB}.`
                    ),
                    (A.showDebugLayer = MB))
                  : !1 === A.showDebugLayer && (A.showDebugLayer = 0),
                (A.showDebugLayer |= 0))
              : (A.showDebugLayer = 0),
            (A.baseUrl = A.baseUrl ? A.baseUrl.replace(/^\/+|\/+$/g, "") : "dcvjs"),
            !new RegExp("^http", "i").test(A.baseUrl))
          ) {
            const e = window.location.origin.replace(/\/+$/g, ""),
              t = window.location.pathname.replace(/^\/|[^/]+?\.[^/]+?$/g, "");
            A.baseUrl = `${e}/${t}${t && !t.endsWith("/") ? "/" : ""}${A.baseUrl}`;
          }
          return (
            !go(A, "observers") ||
            !go(A, "callbacks") ||
            (OB.error(
              "Either observers or callbacks can be defined in the connection configuration, not both."
            ),
            !1)
          );
        })(A))
      ) {
        try {
          !(function (A) {
            if (
              (Object.entries({
                string: [
                  "url",
                  "sessionId",
                  "authToken",
                  "baseUrl",
                  "resourceBaseUrl",
                  "divId",
                  "losslessColorspace",
                  "extensionData"
                ],
                boolean: [
                  "clipboardAutoSync",
                  "dynamicAudioTuning",
                  "clientHiDpiScaling",
                  "enableHighPixelDensity",
                  "enableWebCodecs",
                  "highColorAccuracy",
                  "enableGraphicsDebugLayer"
                ],
                object: ["observers", "callbacks"]
              }).forEach(([e, t]) => {
                t.forEach((t) => {
                  if (go(A, t) && typeof A[t] !== e)
                    throw new TypeError(
                      `Connection configuration value for ${t} should have type ${e}.`
                    );
                });
              }),
              go(A, "authToken") && A.authToken.length > 15e3)
            )
              throw new TypeError(
                "Connection configuration property authToken should be a valid string shorter than 15000 bytes."
              );
            if (go(A, "volumeLevel") && !oo(A.volumeLevel, 0, 100))
              throw new TypeError(
                "Connection configuration property volumeLevel should be a valid number in the range [0, 100]."
              );
            if (
              go(A, "connectionFailureRetryAttempts") &&
              !oo(A.connectionFailureRetryAttempts, 0, 100)
            )
              throw new TypeError(
                "Connection configuration property connectionFailureRetryAttempts should be a valid number in the range [0, 100]."
              );
            if (
              go(A, "connectionBlockRetryAttempts") &&
              !oo(A.connectionBlockRetryAttempts, 0, 100)
            )
              throw new TypeError(
                "Connection configuration property connectionBlockRetryAttempts should be a valid number in the range [0, 100]."
              );
            if (
              Object.prototype.hasOwnProperty.call(A, "showDebugLayer") &&
              "boolean" != typeof A.showDebugLayer &&
              A.showDebugLayer < 0
            )
              throw new TypeError(
                "Connection configuration property showDebugLayer should be true, false, or a non-negative number."
              );
            ["displayCodecs", "enabledChannels"].forEach((e) => {
              if (go(A, e) && !Array.isArray(A[e]))
                throw new TypeError(`Connection configuration property ${e} should be an array.`);
            }),
              ["observers", "callbacks"].forEach((e) => {
                const t = A[e];
                if (t && !zn(t))
                  throw new TypeError(
                    `The Connection configuration property ${e} should be an object.`
                  );
                if (t && Object.values(t).some((A) => !Xn(A)))
                  throw new TypeError(
                    "Every callback defined in the Connection configuration should be a valid function."
                  );
              });
          })(A);
        } catch (A) {
          return void t({ code: Io.Connection.INVALID_CONFIG, message: A.message });
        }
        const i = new wC(A);
        i
          ? (OB.info(
              `Requested DCV ${h.version} connection for ${A.url} with WebSocket transport, session id ${A.sessionId}${A.extensionData ? " (with extension data)" : ""}`
            ),
            i
              .connect()
              .then(() => {
                OB.info("Connection has been established"), e(i);
              })
              .catch((e) => {
                OB.error(
                  `Connection failed: ${JSON.stringify(e)} (version: ${h.version}, session: ${A.sessionId})`
                ),
                  t(e);
              }))
          : t({
              code: Io.Connection.INITIALIZATION_FAILED,
              message: "Failed to initialize the Connection object."
            });
      } else t({ code: Io.Connection.INVALID_CONFIG, message: "Invalid configuration." });
    });
  }
});
function $B(A, e, t, i, n, o) {
  function r() {
    let n,
      r,
      s = A._malloc(4),
      a = A._malloc(4);
    return (
      (r = A._opus_encoder_create(e, t, 2049, s)),
      (n = A.getValue(s, "i32")),
      A._free(s),
      0 !== n
        ? (o("warn", `Can't create opus encoder. Error: ${n}`), A._free(a), null)
        : ((A.HEAP32[a >> 2] = i),
          (n = A._opus_encoder_ctl(r, 4002, a)),
          0 !== n
            ? (o("warn", `Unable to set bitrate to ${i}. Error: ${n}`), A._free(a), null)
            : ((A.HEAP32[a >> 2] = 10),
              (n = A._opus_encoder_ctl(r, 4010, a)),
              0 !== n && o("warn", `Unable to set complexity. Error: ${n}`),
              o(
                "info",
                `Opus Encoder with profile "generic" created: sample rate ${e}, ${t} channels, bitrate ${i}`
              ),
              A._free(a),
              r))
    );
  }
  switch (n) {
    case "generic":
      return r();
    case "voice":
      return (function () {
        let n,
          r,
          s = A._malloc(4),
          a = A._malloc(4);
        return (
          (r = A._opus_encoder_create(e, t, 2048, s)),
          (n = A.getValue(s, "i32")),
          A._free(s),
          0 !== n
            ? (o("warn", `Can't create opus encoder. Error: ${n}`), A._free(a), null)
            : ((A.HEAP32[a >> 2] = i),
              (n = A._opus_encoder_ctl(r, 4002, a)),
              0 !== n
                ? (o("warn", `Unable to set bitrate to ${i}. Error: ${n}`), A._free(a), null)
                : ((A.HEAP32[a >> 2] = 10),
                  (n = A._opus_encoder_ctl(r, 4010, a)),
                  0 !== n && o("warn", `Unable to set complexity. Error: ${n}`),
                  (A.HEAP32[a >> 2] = 3001),
                  (n = A._opus_encoder_ctl(r, 4024, a)),
                  0 !== n && o("warn", `Unable to set signal type to voice. Error: ${n}`),
                  (A.HEAP32[a >> 2] = 1104),
                  (n = A._opus_encoder_ctl(r, 4004, a)),
                  0 !== n && o("warn", `Unable to set signal type to voice. Error: ${n}`),
                  o(
                    "info",
                    `Opus Encoder with profile "voice" created: sample rate ${e}, ${t} channels, bitrate ${i}`
                  ),
                  A._free(a),
                  r))
        );
      })();
    default:
      return o("warn", 'Invalid audio profile selected for microphone, selecting "generic".'), r();
  }
}
class AQ {
  constructor(A, e, t, i, n) {
    if (
      ((this.log = Q("audioEncoder", n)),
      t.sampleRate <= 0 || t.frameSamples <= 0 || t.channels <= 0 || t.bitrate <= 0)
    )
      throw new Error(
        `Not all the settings have valid values (${t.sampleRate}, ${t.frameSamples}, ${t.channels}, ${t.bitrate})`
      );
    if (A !== da) throw new Error("Audio codec unavailable");
    if (-1 === ua.indexOf(e)) throw new Error(`Unsupported audio profile: ${e}`);
    (this.audioProfile = e),
      (this.audioChannels = t.channels),
      (this.audioSamplerate = t.sampleRate),
      (this.audioFrameSamples = t.frameSamples),
      (this.audioBitrate = t.bitrate),
      (this.clientConnectionId = n),
      (this.opusEncoder = null),
      (this.OpusModule = i),
      (this.encodeSingleBuffer = eQ.bind(this));
  }
  logCallback(A, e) {
    this.log[A](e);
  }
  createOpusEncoder() {
    return (
      this.audioChannels > -1 &&
        this.audioSamplerate > -1 &&
        this.audioFrameSamples > -1 &&
        this.audioBitrate > -1 &&
        "" !== this.audioProfile &&
        (this.opusEncoder = $B(
          this.OpusModule,
          this.audioSamplerate,
          this.audioChannels,
          this.audioBitrate,
          this.audioProfile,
          this.logCallback.bind(this)
        )),
      this.opusEncoder
    );
  }
  remove() {
    this.opusEncoder &&
      (this.log.debug("Deleting the Opus Encoder"),
      this.OpusModule._free(this.opusEncoder),
      (this.opusEncoder = null));
  }
  reset() {
    let A;
    this.opusEncoder &&
      ((A = this.OpusModule._opus_encoder_ctl(this.opusEncoder, 4028)),
      this.log.debug("Resetting Opus Encoder"),
      0 !== A &&
        (this.log.warn(`Unable to reset Opus Encoder. Error: ${A}\nCreating a new one.`),
        this.OpusModule._free(this.opusEncoder),
        (this.opusEncoder = $B(
          this.OpusModule,
          this.audioSamplerate,
          this.audioChannels,
          this.audioBitrate,
          this.audioProfile,
          this.logCallback.bind(this)
        ))));
  }
}
function eQ(A) {
  let e,
    t,
    i = this.audioFrameSamples * this.audioChannels,
    n = this.OpusModule._malloc(512),
    o = this.OpusModule.HEAPU8.subarray(n, n + 512),
    r = null;
  return A && A.length === i
    ? ((t = "object" == typeof A && A.constructor === Float32Array ? A : new Float32Array(A)),
      (e = this.OpusModule._opus_encode_float(this.opusEncoder, t, this.audioFrameSamples, n, 512)),
      e > 0 && ((r = new Uint8Array(e)), r.set(o.subarray(0, e))),
      this.OpusModule._free(n),
      r)
    : null;
}
const tQ = id.audio;
class iQ {
  constructor(A) {
    (this.clientConnectionId = A),
      (this.log = Q("audioinput", this.clientConnectionId)),
      (this.state = { bitrate: -1, channels: -1, sampleRate: -1, frameSamples: -1 }),
      (this.audioCtx = Ts()),
      (this.inputStream = null),
      (this.mediaStream = null),
      (this.grabbing = !1),
      (this.microphoneEnabled = !1),
      (this.microphoneMediaDeviceInfo = null),
      (this.headsetAttachedOnNiva = !1),
      (this.wrongSelectedCodec = !1),
      (this.audioProfile = ""),
      (this.processor = null),
      (this.OpusModule = null),
      rQ.call(this);
  }
  initOpusModule() {
    return this.OpusModule
      ? (this.log.warn("Opus Module already initialized"), Promise.resolve())
      : new Promise((A, e) => {
          Md()
            .then((e) => {
              (this.OpusModule = e), A();
            })
            .catch(e);
        });
  }
  registerChannel(A) {
    this.channel && this.log.warn("Channel registration overwriting previous channel"),
      (this.channel = A);
  }
  unregisterChannel(A) {
    this.channel === A ? (this.channel = null) : this.log.warn("Skip unregister of wrong channel");
  }
  setAudioChannels(A) {
    this.state.channels = A;
  }
  setAudioSamplerate(A) {
    this.state.sampleRate = A;
  }
  setFrameSamples(A) {
    this.state.frameSamples = A;
  }
  setAudioBitrate(A) {
    this.state.bitrate = A;
  }
  initEncoder(A, e) {
    let t;
    this.audioProfile = e;
    try {
      t = new AQ(A, e, this.state, this.OpusModule, this.clientConnectionId);
    } catch (A) {
      return (
        this.log.warn(`Could not create audio encoder: ${A.message}`),
        this.log.debug("Deleting the Opus Encoder"),
        this.OpusModule._free(this.opusEncoder),
        null
      );
    } finally {
      this.OpusModule = null;
    }
    return (
      null === t.createOpusEncoder() &&
        (this.log.info("Impossible to set up a valid opus encoder."),
        this.channel.sendStopService(tQ.AudioService.INJECTION),
        t.remove()),
      t
    );
  }
  setEnabled(A, e, t) {
    return this.microphoneEnabled === e
      ? Promise.resolve(t)
      : !A && e
        ? ((this.microphoneEnabled = !1),
          (this.microphoneMediaDeviceInfo = null),
          Promise.reject("Audio encoder initialization failed"))
        : this.audioCtx
          ? !this.grabbing && e
            ? nQ
                .call(this, t)
                .then(() => Promise.resolve(t))
                .catch((A) => {
                  const e = `${A.name}: ${A.message}`;
                  return (
                    (this.microphoneEnabled = !1),
                    (this.microphoneMediaDeviceInfo = null),
                    this.log.debug(`Could not set the audio input: ${e}`),
                    Promise.reject(e)
                  );
                })
            : !e && this.mediaStream
              ? ((this.microphoneEnabled = !1),
                (this.microphoneMediaDeviceInfo = null),
                (this.grabbing = !1),
                this.inputStream && (this.inputStream.disconnect(), (this.inputStream = null)),
                this.processor && (this.processor.disconnect(), (this.processor = null)),
                this.mediaStream.getAudioTracks().forEach((A) => {
                  A.stop();
                }),
                (this.mediaStream = null),
                this.channel.sendStopService(tQ.AudioService.INJECTION),
                Promise.resolve(t))
              : Promise.reject(`Unable to ${e ? "enable" : "disable"} microphone`)
          : ((this.microphoneEnabled = !1),
            (this.microphoneMediaDeviceInfo = null),
            Promise.reject("Microphone initialization failed"));
  }
  reset() {
    this.log.info("Resetting audio input..."),
      this.mediaStream &&
        (this.inputStream &&
          (this.inputStream.disconnect(), this.log.debug("audioInputStream disconnected")),
        this.processor &&
          (this.processor.disconnect(),
          (this.processor = null),
          this.log.debug("audio input processor disconnected")),
        this.mediaStream.getAudioTracks().forEach((A) => {
          A.stop(), this.log.debug("Stopping audio track");
        })),
      (this.state = { bitrate: -1, channels: -1, sampleRate: -1, frameSamples: -1 }),
      (this.inputStream = null),
      (this.audioFrameLengthUSec = -1),
      (this.mediaStream = null),
      (this.bufferToEncode = []),
      (this.bufferToEncodeSize = 0),
      (this.grabbing = !1),
      (this.grabbingSampleRate = 0),
      (this.microphoneEnabled = !1),
      (this.microphoneMediaDeviceInfo = null),
      (this.wrongSelectedCodec = !1),
      (this.encodeBuffer = null),
      (this.audioProfile = ""),
      (this.processor = null),
      (this.initTimestamp = 0);
  }
}
function nQ(A) {
  return fr()
    ? co(
        () => navigator.mediaDevices.getUserMedia({ audio: sQ("", this.state.sampleRate) }),
        500,
        3
      ).then(
        (A) => (
          Ks().then((A) => {
            this.headsetAttachedOnNiva =
              A.filter((A) => "audioinput" === A.kind && A.label === us).length > 0;
          }),
          oQ.call(this, A)
        )
      )
    : navigator.mediaDevices
        .getUserMedia({ audio: !0 })
        .then(() =>
          Ls(A).then(
            (A) => (
              (this.microphoneMediaDeviceInfo = A),
              this.log.info(
                `Setting microphone to device: ${JSON.stringify(this.microphoneMediaDeviceInfo.toJSON())}`
              ),
              navigator.mediaDevices
                .getUserMedia({
                  audio: sQ(this.microphoneMediaDeviceInfo.deviceId, this.state.sampleRate)
                })
                .then((A) => oQ.call(this, A))
            )
          )
        );
}
function oQ(A) {
  return (
    (this.microphoneEnabled = !0),
    (this.audioFrameLengthUSec = (1e6 * this.state.frameSamples) / this.state.sampleRate),
    this.channel.sendStartService(tQ.AudioService.INJECTION),
    (this.mediaStream = A),
    (this.grabbing = !0),
    (this.grabbingSampleRate = this.audioCtx.sampleRate),
    this.gotStream(),
    Promise.resolve()
  );
}
function rQ() {
  Os() &&
    navigator.permissions
      .query({ name: "microphone" })
      .then((A) => {
        A.onchange = () => {
          this.log.info(`Microphone permission state has changed to ${A.state}`),
            this.grabbing && "granted" !== A.state && this.setEnabled(!1);
        };
      })
      .catch((A) => {
        A instanceof TypeError ? this.log.info(A.message) : this.log.warn(A.message);
      });
}
function sQ(A, e) {
  let t = {};
  return (
    A && (t.deviceId = { exact: A }),
    -1 !== e && (t.sampleRate = e),
    !!(function (A) {
      if (!zn(A)) return !1;
      for (const e in A) if (go(A, e)) return !1;
      return !0;
    })(t) || t
  );
}
const aQ = "webaudioencoder";
function gQ(A, e) {
  const t = [],
    i = Math.trunc(A.length / e);
  for (let n = 0; n < e; n++) for (let o = 0; o < i; o++) t[o * e + n] = A[n * i + o];
  return new Float32Array(t);
}
async function cQ() {
  const A = {
      codec: "opus",
      sampleRate: this.state.sampleRate,
      numberOfChannels: this.state.channels,
      bitrate: this.state.bitrate
    },
    { supported: e } =
      "AudioEncoder" in window ? await window.AudioEncoder.isConfigSupported(A) : { supported: !1 };
  e &&
    (this.encoder.reset(),
    this.encoder.configure(A),
    this.log.info(
      `Audio encoder configured with sample rate ${this.state.sampleRate}, ${this.state.channels} channels and bitrate: ${this.state.bitrate} bps`
    ));
}
var IQ = Object.freeze({
  __proto__: null,
  Microphone: class extends iQ {
    constructor(A) {
      super(A), (this.log = Q(aQ, A)), (this.encoder = null), (this.latestStreamId = 0);
    }
    getName() {
      return aQ;
    }
    registerChannel(A) {
      super.registerChannel(A),
        (this.encoder = new window.AudioEncoder({
          output: (A) => {
            const e = new Uint8Array(A.byteLength);
            A.copyTo(e),
              this.initTimestamp &&
                ((this.encodeTime = performance.now() - this.initTimestamp),
                (this.initTimestamp = 0)),
              this.channel.sendAudioPacket(
                e,
                1e3 * (performance.now() - this.encodeTime) - this.audioFrameLengthUSec
              );
          },
          error: (A) => this.log.error(A)
        }));
    }
    unregisterChannel(A) {
      super.unregisterChannel(A), this.encoder?.close();
    }
    async gotStream() {
      cQ.call(this);
      const A = new window.MediaStreamTrackProcessor(
        this.mediaStream.getAudioTracks()[0]
      ).readable.getReader();
      let e = await A.read(),
        t = ++this.latestStreamId;
      for (
        this.initTimestamp = performance.now(),
          this.log.info(`Starting audio encoder on stream with id ${t}`);
        !e.done && t === this.latestStreamId;

      ) {
        const t = e.value;
        if ("unconfigured" === this.encoder.state) cQ.call(this);
        else if ("configured" === this.encoder.state) {
          let A = t;
          if ("f32-planar" === t.format && 1 === t.numberOfChannels && 1 !== this.state.channels) {
            const e = { planeIndex: 0 },
              i = new Float32Array(t.allocationSize(e));
            t.copyTo(i, e);
            const n = gQ(i.slice(0, t.numberOfFrames * this.state.channels), this.state.channels);
            A = new window.AudioData({
              format: "f32",
              sampleRate: t.sampleRate,
              numberOfFrames: t.numberOfFrames,
              numberOfChannels: this.state.channels,
              timestamp: t.timestamp,
              data: n
            });
          }
          this.encoder.encode(A), t.close();
        } else t.close();
        e = await A.read();
      }
      this.log.info(`Terminated audio encoder on stream with id ${t}`);
    }
  }
});
const lQ = "microphoneworklet";
("function" == typeof AudioWorkletNode && "audioWorklet" in AudioContext.prototype) ||
  (self.AudioWorkletNode = function () {});
class dQ extends AudioWorkletNode {
  constructor(A, e, t, i) {
    super(A, "microphoneProcessor", e),
      (this.log = Q(lQ, i)),
      (this.port.onmessage = t),
      this.log.debug("Initialized microphone worklet node.");
  }
}
function uQ(A) {
  switch (A.data.type) {
    case "audio":
      this.initTimestamp &&
        ((this.encodeTime = performance.now() - this.initTimestamp), (this.initTimestamp = 0)),
        this.channel.sendAudioPacket(
          A.data.buffer,
          1e3 * (performance.now() - this.encodeTime) - this.audioFrameLengthUSec,
          A.data.audioPacketStrength
        );
      break;
    case "log":
      this.log[A.data.level](A.data.message);
      break;
    case "init":
      this.initTimestamp = performance.now();
  }
}
var CQ = Object.freeze({
  __proto__: null,
  Microphone: class extends iQ {
    constructor(A, e) {
      super(A), (this.baseUrl = e), (this.log = Q(lQ, A));
    }
    getName() {
      return lQ;
    }
    gotStream() {
      (this.inputStream = this.audioCtx.createMediaStreamSource(this.mediaStream)),
        this.log.info(`Audio grabbing started. Audio context state: ${this.audioCtx.state}`),
        this.grabbingSampleRate === this.state.sampleRate
          ? ((this.resampling = !1),
            this.log.info(`Audio input sample rate ${this.grabbingSampleRate}Hz.`))
          : ((this.resampling = !0),
            this.log.info(
              `Audio input at sample rate ${this.grabbingSampleRate}Hz will be resampled to ${this.state.sampleRate}Hz`
            )),
        (function (A, e) {
          function t() {
            return Boolean(A.audioWorklet && "function" == typeof A.audioWorklet.addModule);
          }
          if (t()) return A.audioWorklet.addModule(`${e}/dcv/microphoneprocessor.js`);
          return Promise.reject("Audio Worklet Node not supported");
        })(this.audioCtx, this.baseUrl)
          .then(() => {
            const A = {
              processorOptions: {
                resampling: this.resampling,
                grabbingSampleRate: this.grabbingSampleRate,
                audioFrameSamples: this.state.frameSamples,
                audioSampleRate: this.state.sampleRate,
                audioBitrate: this.state.bitrate,
                audioProfile: this.audioProfile,
                audioChannels: this.state.channels,
                audioFrameLengthUSec: this.audioFrameLengthUSec,
                clientConnectionId: this.clientConnectionId
              }
            };
            (this.microphoneProcessor = new dQ(
              this.audioCtx,
              A,
              uQ.bind(this),
              this.clientConnectionId
            )),
              this.inputStream.connect(this.microphoneProcessor).connect(this.audioCtx.destination);
          })
          .catch((A) => {
            this.log.warn(`Impossible to set up microphone. Error: ${A}`);
          });
    }
  }
});
const BQ = 512,
  QQ = "microphone";
function EQ(A) {
  this.microphoneEnabled
    ? (Array.prototype.push.apply(
        this.bufferToEncode,
        (function (A, e) {
          let t,
            i,
            n = [];
          for (let o = 0; o < e; o++) {
            (t = o % A.numberOfChannels), (i = A.getChannelData(t));
            for (let A = 0; A < i.length; A++) n[A * e + o] = i[A];
          }
          return new Float32Array(n);
        })(A.inputBuffer, this.state.channels)
      ),
      this.encodeBuffer())
    : mQ.call(this);
}
function hQ() {
  let A, e, t;
  this.bufferToEncode.length >= this.encoderBufferLength &&
    ((A = this.bufferToEncode.slice(0, this.encoderBufferLength)),
    (this.bufferToEncode = this.bufferToEncode.slice(this.encoderBufferLength + 1)),
    this.encoderInputBuffer.set(A),
    (t = Math.max.apply(null, A)),
    (e = this.OpusModule._opus_encode_float(
      this.opusEncoder,
      this.encoderInputPointer,
      this.state.frameSamples,
      this.encoderOutputPointer,
      BQ
    )),
    e > 0 && fQ.call(this, e, t));
}
function pQ() {
  let A, e, t, i;
  this.bufferToEncode.length >= this.resampleBufferLength &&
    ((A = this.bufferToEncode.slice(0, this.resampleBufferLength)),
    (this.bufferToEncode = this.bufferToEncode.slice(this.resampleBufferLength + 1)),
    this.resampleBuffer.set(A),
    (i = Math.max.apply(null, A)),
    (t = this.OpusModule._speex_resampler_process_interleaved_float(
      this.resampler,
      this.resampleBufferPointer,
      this.resampleSamplesPerChannelPointer,
      this.encoderInputPointer,
      this.encoderInputPerChannelPointer
    )),
    0 !== t && this.log.warn(`Error during resampling: ${t}`),
    (e = this.OpusModule._opus_encode_float(
      this.opusEncoder,
      this.encoderInputPointer,
      this.state.frameSamples,
      this.encoderOutputPointer,
      BQ
    )),
    e > 0 && fQ.call(this, e, i));
}
function fQ(A, e) {
  const t = new Uint8Array(A);
  t.set(this.encoderOutputBuffer.subarray(0, A)),
    this.initTimestamp &&
      ((this.encodeTime = performance.now() - this.initTimestamp), (this.initTimestamp = 0)),
    this.channel.sendAudioPacket(
      t,
      1e3 * (performance.now() - this.initTimestamp) - this.audioFrameLengthUSec,
      e
    );
}
function mQ() {
  this.resampler &&
    (this.OpusModule._free(this.encoderInputPerChannelPointer),
    this.OpusModule._free(this.resampleSamplesPerChannelPointer),
    this.OpusModule._free(this.resampleBufferPointer),
    this.OpusModule._free(this.resampler)),
    this.OpusModule._free(this.encoderOutputPointer),
    this.OpusModule._free(this.encoderInputPointer);
}
function yQ() {
  (this.encoderInputPointer = this.OpusModule._malloc(4 * this.encoderBufferLength)),
    (this.encoderInputBuffer = this.OpusModule.HEAPF32.subarray(
      this.encoderInputPointer >> 2,
      (this.encoderInputPointer >> 2) + this.encoderBufferLength
    )),
    (this.encoderOutputPointer = this.OpusModule._malloc(BQ)),
    (this.encoderOutputBuffer = this.OpusModule.HEAPU8.subarray(
      this.encoderOutputPointer,
      this.encoderOutputPointer + BQ
    ));
}
function DQ() {
  const A = this.OpusModule._malloc(4);
  (this.resampler = this.OpusModule._speex_resampler_init(
    this.state.channels,
    this.grabbingSampleRate,
    this.state.sampleRate,
    10,
    A
  )),
    this.OpusModule._free(A),
    (this.encoderInputPerChannelPointer = this.OpusModule._malloc(4)),
    (this.resampleSamplesPerChannelPointer = this.OpusModule._malloc(4)),
    (this.resampleSamplesPerChannel = this.grabbingSampleRate * this.audioFrameLengthUSec * 1e-6),
    (this.resampleBufferLength = this.resampleSamplesPerChannel * this.state.channels),
    (this.resampleBufferPointer = this.OpusModule._malloc(4 * this.resampleBufferLength)),
    (this.resampleBuffer = this.OpusModule.HEAPF32.subarray(
      this.resampleBufferPointer >> 2,
      (this.resampleBufferPointer >> 2) + this.resampleBufferLength
    )),
    (this.OpusModule.HEAP32[this.resampleSamplesPerChannelPointer >> 2] =
      this.resampleSamplesPerChannel),
    (this.OpusModule.HEAP32[this.encoderInputPerChannelPointer >> 2] = this.state.frameSamples),
    yQ.call(this);
}
var wQ = Object.freeze({
  __proto__: null,
  Microphone: class extends iQ {
    constructor(A) {
      super(A), (this.log = Q(QQ, A));
    }
    getName() {
      return QQ;
    }
    gotStream() {
      (this.inputStream = this.audioCtx.createMediaStreamSource(this.mediaStream)),
        this.log.info(`Audio grabbing started. Audio context state: ${this.audioCtx.state}`),
        (this.bufferToEncode = []),
        (this.encoderBufferLength = this.state.frameSamples * this.state.channels),
        this.grabbingSampleRate === this.state.sampleRate
          ? ((this.encodeBuffer = hQ.bind(this)),
            yQ.call(this),
            this.log.info(`Audio input sample rate ${this.grabbingSampleRate}Hz.`))
          : ((this.encodeBuffer = pQ.bind(this)),
            DQ.call(this),
            this.log.info(
              `Audio input at sample rate ${this.grabbingSampleRate}Hz will be resampled to ${this.state.sampleRate}Hz`
            )),
        this.audioCtx.createScriptProcessor
          ? (this.processor = this.audioCtx.createScriptProcessor(
              1024,
              this.state.channels,
              this.state.channels
            ))
          : (this.processor = this.audioCtx.createJavaScriptNode(
              1024,
              this.state.channels,
              this.state.channels
            )),
        (this.initTimestamp = performance.now()),
        (this.processor.onaudioprocess = EQ.bind(this)),
        this.inputStream.connect(this.processor),
        this.processor.connect(this.audioCtx.destination);
    }
  }
});
export { ZB as default };
